// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*@import url("https://fonts.googleapis.com/css2?family=Inter:wght@200;300;400;500;600;700;800;900&display=swap");*/
:host ::ng-deep {
  /*!
  * Quill Editor v1.3.7
  * https://quilljs.com/
  * Copyright (c) 2014, Jason Chen
  * Copyright (c) 2013, salesforce.com
  */
}
:host ::ng-deep .p-overflow-hidden {
  overflow: hidden;
  padding-right: var(--scrollbar-width);
}
@layer primeng {
  :host ::ng-deep .p-component, :host ::ng-deep .p-component * {
    box-sizing: border-box;
  }
  :host ::ng-deep .p-hidden {
    display: none;
  }
  :host ::ng-deep .p-hidden-space {
    visibility: hidden;
  }
  :host ::ng-deep .p-hidden-accessible {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
  :host ::ng-deep .p-hidden-accessible input, :host ::ng-deep .p-hidden-accessible select {
    transform: scale(0);
  }
  :host ::ng-deep .p-reset {
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    text-decoration: none;
    font-size: 100%;
    list-style: none;
  }
  :host ::ng-deep .p-disabled, :host ::ng-deep .p-disabled * {
    cursor: default !important;
    pointer-events: none;
  }
  :host ::ng-deep .p-component-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  :host ::ng-deep .p-unselectable-text {
    -webkit-user-select: none;
    user-select: none;
  }
  :host ::ng-deep .p-scrollbar-measure {
    width: 100px;
    height: 100px;
    overflow: scroll;
    position: absolute;
    top: -9999px;
  }
  @keyframes p-fadein {
    0% {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  :host ::ng-deep .p-link {
    text-align: left;
    background-color: transparent;
    margin: 0;
    padding: 0;
    border: 0;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
  }
  :host ::ng-deep .p-link:disabled {
    cursor: default;
  }
  :host ::ng-deep .p-sr-only {
    border: 0;
    clip: rect(1px, 1px, 1px, 1px);
    clip-path: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
    word-wrap: normal !important;
  }
  :host ::ng-deep .p-connected-overlay {
    opacity: 0;
    transform: scaleY(0.8);
    transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1), opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
  }
  :host ::ng-deep .p-connected-overlay-visible {
    opacity: 1;
    transform: scaleY(1);
  }
  :host ::ng-deep .p-connected-overlay-hidden {
    opacity: 0;
    transform: scaleY(1);
    transition: opacity 0.1s linear;
  }
  :host ::ng-deep .p-toggleable-content.ng-animating {
    overflow: hidden;
  }
  :host ::ng-deep .p-icon-wrapper {
    display: inline-flex;
  }
  :host ::ng-deep .p-icon {
    display: inline-block;
  }
  :host ::ng-deep .p-icon-spin {
    animation: p-icon-spin 2s infinite linear;
  }
}
@keyframes p-icon-spin {
  0% {
    transform: rotate(0);
  }
  to {
    transform: rotate(359deg);
  }
}
@layer primeng {
  :host ::ng-deep .p-badge {
    display: inline-block;
    border-radius: 10px;
    text-align: center;
    padding: 0 0.5rem;
  }
  :host ::ng-deep .p-overlay-badge {
    position: relative;
  }
  :host ::ng-deep .p-overlay-badge .p-badge {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    transform-origin: 100% 0;
    margin: 0;
  }
  :host ::ng-deep .p-badge-dot {
    width: 0.5rem;
    min-width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    padding: 0;
  }
  :host ::ng-deep .p-badge-no-gutter {
    padding: 0;
    border-radius: 50%;
  }
}
@layer primeng {
  :host ::ng-deep .p-button {
    margin: 0;
    display: inline-flex;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    align-items: center;
    vertical-align: bottom;
    text-align: center;
    overflow: hidden;
    position: relative;
  }
  :host ::ng-deep .p-button-label {
    flex: 1 1 auto;
  }
  :host ::ng-deep .p-button-icon-right {
    order: 1;
  }
  :host ::ng-deep .p-button:disabled {
    cursor: default;
    pointer-events: none;
  }
  :host ::ng-deep .p-button-icon-only {
    justify-content: center;
  }
  :host ::ng-deep .p-button-icon-only:after {
    content: "p";
    visibility: hidden;
    clip: rect(0 0 0 0);
    width: 0;
  }
  :host ::ng-deep .p-button-vertical {
    flex-direction: column;
  }
  :host ::ng-deep .p-button-icon-bottom {
    order: 2;
  }
  :host ::ng-deep .p-buttonset .p-button {
    margin: 0;
  }
  :host ::ng-deep .p-buttonset .p-button:not(:last-child) {
    border-right: 0 none;
  }
  :host ::ng-deep .p-buttonset .p-button:not(:first-of-type):not(:last-of-type) {
    border-radius: 0;
  }
  :host ::ng-deep .p-buttonset .p-button:first-of-type {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  :host ::ng-deep .p-buttonset .p-button:last-of-type {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  :host ::ng-deep .p-buttonset .p-button:focus {
    position: relative;
    z-index: 1;
  }
  :host ::ng-deep p-button[iconpos=right] spinnericon {
    order: 1;
  }
}
@layer primeng {
  :host ::ng-deep .p-checkbox {
    display: inline-flex;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    vertical-align: bottom;
    position: relative;
  }
  :host ::ng-deep .p-checkbox-disabled {
    cursor: default !important;
    pointer-events: none;
  }
  :host ::ng-deep .p-checkbox-box {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  :host ::ng-deep p-checkbox {
    display: inline-flex;
    vertical-align: bottom;
    align-items: center;
  }
  :host ::ng-deep .p-checkbox-label {
    line-height: 1;
  }
}
:host ::ng-deep .p-colorpicker-panel .p-colorpicker-color {
  background: transparent no-repeat left top;
}
:host ::ng-deep .p-colorpicker-panel .p-colorpicker-hue {
  background: transparent no-repeat left top;
}
@layer primeng {
  :host ::ng-deep .p-inputtext {
    margin: 0;
  }
  :host ::ng-deep .p-fluid .p-inputtext {
    width: 100%;
  }
  :host ::ng-deep .p-inputgroup {
    display: flex;
    align-items: stretch;
    width: 100%;
  }
  :host ::ng-deep .p-inputgroup-addon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  :host ::ng-deep .p-inputgroup .p-float-label {
    display: flex;
    align-items: stretch;
    width: 100%;
  }
  :host ::ng-deep .p-inputgroup .p-inputtext, :host ::ng-deep .p-fluid .p-inputgroup .p-inputtext, :host ::ng-deep .p-inputgroup .p-inputwrapper, :host ::ng-deep .p-inputgroup .p-inputwrapper > .p-component {
    flex: 1 1 auto;
    width: 1%;
  }
  :host ::ng-deep .p-float-label {
    display: block;
    position: relative;
  }
  :host ::ng-deep .p-float-label label {
    position: absolute;
    pointer-events: none;
    top: 50%;
    margin-top: -0.5rem;
    transition-property: all;
    transition-timing-function: ease;
    line-height: 1;
  }
  :host ::ng-deep .p-float-label textarea ~ label {
    top: 1rem;
  }
  :host ::ng-deep .p-float-label input:focus ~ label, :host ::ng-deep .p-float-label input.p-filled ~ label, :host ::ng-deep .p-float-label textarea:focus ~ label, :host ::ng-deep .p-float-label textarea.p-filled ~ label, :host ::ng-deep .p-float-label .p-inputwrapper-focus ~ label, :host ::ng-deep .p-float-label .p-inputwrapper-filled ~ label {
    top: -0.75rem;
    font-size: 12px;
  }
  :host ::ng-deep .p-float-label .input:-webkit-autofill ~ label {
    top: -20px;
    font-size: 12px;
  }
  :host ::ng-deep .p-float-label .p-placeholder, :host ::ng-deep .p-float-label input::placeholder, :host ::ng-deep .p-float-label .p-inputtext::placeholder {
    opacity: 0;
    transition-property: all;
    transition-timing-function: ease;
  }
  :host ::ng-deep .p-float-label .p-focus .p-placeholder, :host ::ng-deep .p-float-label input:focus::placeholder, :host ::ng-deep .p-float-label .p-inputtext:focus::placeholder {
    opacity: 1;
    transition-property: all;
    transition-timing-function: ease;
  }
  :host ::ng-deep .p-input-icon-left, :host ::ng-deep .p-input-icon-right {
    position: relative;
    display: inline-block;
  }
  :host ::ng-deep .p-input-icon-left > i, :host ::ng-deep .p-input-icon-left > .p-icon-wrapper, :host ::ng-deep .p-input-icon-right > i, :host ::ng-deep .p-input-icon-right > .p-icon-wrapper {
    position: absolute;
    top: 50%;
    margin-top: -0.5rem;
  }
  :host ::ng-deep .p-fluid .p-input-icon-left, :host ::ng-deep .p-fluid .p-input-icon-right {
    display: block;
    width: 100%;
  }
}
@layer primeng {
  :host ::ng-deep .p-inputtextarea-resizable {
    overflow: hidden;
    resize: none;
  }
  :host ::ng-deep .p-fluid .p-inputtextarea {
    width: 100%;
  }
}
@layer primeng {
  :host ::ng-deep .p-password {
    position: relative;
    display: inline-flex;
  }
  :host ::ng-deep .p-password-panel {
    position: absolute;
    top: 0;
    left: 0;
  }
  :host ::ng-deep .p-password .p-password-panel {
    min-width: 100%;
  }
  :host ::ng-deep .p-password-meter {
    height: 10px;
  }
  :host ::ng-deep .p-password-strength {
    height: 100%;
    width: 0;
    transition: width 1s ease-in-out;
  }
  :host ::ng-deep .p-fluid .p-password {
    display: flex;
  }
  :host ::ng-deep .p-password-input::-ms-reveal, :host ::ng-deep .p-password-input::-ms-clear {
    display: none;
  }
  :host ::ng-deep .p-password-clear-icon {
    position: absolute;
    top: 50%;
    margin-top: -0.5rem;
    cursor: pointer;
  }
  :host ::ng-deep .p-password-clearable.p-password-mask .p-password-clear-icon {
    margin-top: unset;
  }
  :host ::ng-deep .p-password-clearable {
    position: relative;
  }
}
@layer primeng {
  :host ::ng-deep .p-radiobutton {
    display: inline-flex;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    vertical-align: bottom;
    position: relative;
  }
  :host ::ng-deep .p-radiobutton-box {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  :host ::ng-deep .p-radiobutton-icon {
    backface-visibility: hidden;
    transform: translateZ(0) scale(0.1);
    border-radius: 50%;
    visibility: hidden;
  }
  :host ::ng-deep .p-radiobutton-box.p-highlight .p-radiobutton-icon {
    transform: translateZ(0) scale(1);
    visibility: visible;
  }
  :host ::ng-deep p-radiobutton {
    display: inline-flex;
    vertical-align: bottom;
    align-items: center;
  }
  :host ::ng-deep .p-radiobutton-label {
    line-height: 1;
  }
}
@layer primeng {
  :host ::ng-deep .p-ripple {
    overflow: hidden;
    position: relative;
  }
  :host ::ng-deep .p-ink {
    display: block;
    position: absolute;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 100%;
    transform: scale(0);
  }
  :host ::ng-deep .p-ink-active {
    animation: ripple 0.4s linear;
  }
  :host ::ng-deep .p-ripple-disabled .p-ink {
    display: none !important;
  }
}
@keyframes ripple {
  to {
    opacity: 0;
    transform: scale(2.5);
  }
}
@layer primeng {
  :host ::ng-deep .p-tooltip {
    position: absolute;
    display: none;
    padding: 0.25em 0.5rem;
    max-width: 12.5rem;
    pointer-events: none;
  }
  :host ::ng-deep .p-tooltip.p-tooltip-right, :host ::ng-deep .p-tooltip.p-tooltip-left {
    padding: 0 0.25rem;
  }
  :host ::ng-deep .p-tooltip.p-tooltip-top, :host ::ng-deep .p-tooltip.p-tooltip-bottom {
    padding: 0.25em 0;
  }
  :host ::ng-deep .p-tooltip .p-tooltip-text {
    white-space: pre-line;
    word-break: break-word;
  }
  :host ::ng-deep .p-tooltip-arrow {
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
  }
  :host ::ng-deep .p-tooltip-right .p-tooltip-arrow {
    top: 50%;
    left: 0;
    margin-top: -0.25rem;
    border-width: 0.25em 0.25em 0.25em 0;
  }
  :host ::ng-deep .p-tooltip-left .p-tooltip-arrow {
    top: 50%;
    right: 0;
    margin-top: -0.25rem;
    border-width: 0.25em 0 0.25em 0.25rem;
  }
  :host ::ng-deep .p-tooltip.p-tooltip-top {
    padding: 0.25em 0;
  }
  :host ::ng-deep .p-tooltip-top .p-tooltip-arrow {
    bottom: 0;
    left: 50%;
    margin-left: -0.25rem;
    border-width: 0.25em 0.25em 0;
  }
  :host ::ng-deep .p-tooltip-bottom .p-tooltip-arrow {
    top: 0;
    left: 50%;
    margin-left: -0.25rem;
    border-width: 0 0.25em 0.25rem;
  }
}
@font-face {
  font-family: primeicons;
  font-display: block;
  font-weight: 400;
  font-style: normal;
}
:host ::ng-deep .pi {
  font-family: primeicons;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
:host ::ng-deep .pi:before {
  --webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
:host ::ng-deep .pi-fw {
  width: 1.28571429em;
  text-align: center;
}
:host ::ng-deep .pi-spin {
  animation: fa-spin 2s infinite linear;
}
@keyframes fa-spin {
  0% {
    transform: rotate(0);
  }
  to {
    transform: rotate(359deg);
  }
}
:host ::ng-deep .pi-eraser:before {
  content: "\\ea04";
}
:host ::ng-deep .pi-stopwatch:before {
  content: "\\ea01";
}
:host ::ng-deep .pi-verified:before {
  content: "\\ea02";
}
:host ::ng-deep .pi-delete-left:before {
  content: "\\ea03";
}
:host ::ng-deep .pi-hourglass:before {
  content: "\\e9fe";
}
:host ::ng-deep .pi-truck:before {
  content: "\\ea00";
}
:host ::ng-deep .pi-wrench:before {
  content: "\\e9ff";
}
:host ::ng-deep .pi-microphone:before {
  content: "\\e9fa";
}
:host ::ng-deep .pi-megaphone:before {
  content: "\\e9fb";
}
:host ::ng-deep .pi-arrow-right-arrow-left:before {
  content: "\\e9fc";
}
:host ::ng-deep .pi-bitcoin:before {
  content: "\\e9fd";
}
:host ::ng-deep .pi-file-edit:before {
  content: "\\e9f6";
}
:host ::ng-deep .pi-language:before {
  content: "\\e9f7";
}
:host ::ng-deep .pi-file-export:before {
  content: "\\e9f8";
}
:host ::ng-deep .pi-file-import:before {
  content: "\\e9f9";
}
:host ::ng-deep .pi-file-word:before {
  content: "\\e9f1";
}
:host ::ng-deep .pi-gift:before {
  content: "\\e9f2";
}
:host ::ng-deep .pi-cart-plus:before {
  content: "\\e9f3";
}
:host ::ng-deep .pi-thumbs-down-fill:before {
  content: "\\e9f4";
}
:host ::ng-deep .pi-thumbs-up-fill:before {
  content: "\\e9f5";
}
:host ::ng-deep .pi-arrows-alt:before {
  content: "\\e9f0";
}
:host ::ng-deep .pi-calculator:before {
  content: "\\e9ef";
}
:host ::ng-deep .pi-sort-alt-slash:before {
  content: "\\e9ee";
}
:host ::ng-deep .pi-arrows-h:before {
  content: "\\e9ec";
}
:host ::ng-deep .pi-arrows-v:before {
  content: "\\e9ed";
}
:host ::ng-deep .pi-pound:before {
  content: "\\e9eb";
}
:host ::ng-deep .pi-prime:before {
  content: "\\e9ea";
}
:host ::ng-deep .pi-chart-pie:before {
  content: "\\e9e9";
}
:host ::ng-deep .pi-reddit:before {
  content: "\\e9e8";
}
:host ::ng-deep .pi-code:before {
  content: "\\e9e7";
}
:host ::ng-deep .pi-sync:before {
  content: "\\e9e6";
}
:host ::ng-deep .pi-shopping-bag:before {
  content: "\\e9e5";
}
:host ::ng-deep .pi-server:before {
  content: "\\e9e4";
}
:host ::ng-deep .pi-database:before {
  content: "\\e9e3";
}
:host ::ng-deep .pi-hashtag:before {
  content: "\\e9e2";
}
:host ::ng-deep .pi-bookmark-fill:before {
  content: "\\e9df";
}
:host ::ng-deep .pi-filter-fill:before {
  content: "\\e9e0";
}
:host ::ng-deep .pi-heart-fill:before {
  content: "\\e9e1";
}
:host ::ng-deep .pi-flag-fill:before {
  content: "\\e9de";
}
:host ::ng-deep .pi-circle:before {
  content: "\\e9dc";
}
:host ::ng-deep .pi-circle-fill:before {
  content: "\\e9dd";
}
:host ::ng-deep .pi-bolt:before {
  content: "\\e9db";
}
:host ::ng-deep .pi-history:before {
  content: "\\e9da";
}
:host ::ng-deep .pi-box:before {
  content: "\\e9d9";
}
:host ::ng-deep .pi-at:before {
  content: "\\e9d8";
}
:host ::ng-deep .pi-arrow-up-right:before {
  content: "\\e9d4";
}
:host ::ng-deep .pi-arrow-up-left:before {
  content: "\\e9d5";
}
:host ::ng-deep .pi-arrow-down-left:before {
  content: "\\e9d6";
}
:host ::ng-deep .pi-arrow-down-right:before {
  content: "\\e9d7";
}
:host ::ng-deep .pi-telegram:before {
  content: "\\e9d3";
}
:host ::ng-deep .pi-stop-circle:before {
  content: "\\e9d2";
}
:host ::ng-deep .pi-stop:before {
  content: "\\e9d1";
}
:host ::ng-deep .pi-whatsapp:before {
  content: "\\e9d0";
}
:host ::ng-deep .pi-building:before {
  content: "\\e9cf";
}
:host ::ng-deep .pi-qrcode:before {
  content: "\\e9ce";
}
:host ::ng-deep .pi-car:before {
  content: "\\e9cd";
}
:host ::ng-deep .pi-instagram:before {
  content: "\\e9cc";
}
:host ::ng-deep .pi-linkedin:before {
  content: "\\e9cb";
}
:host ::ng-deep .pi-send:before {
  content: "\\e9ca";
}
:host ::ng-deep .pi-slack:before {
  content: "\\e9c9";
}
:host ::ng-deep .pi-sun:before {
  content: "\\e9c8";
}
:host ::ng-deep .pi-moon:before {
  content: "\\e9c7";
}
:host ::ng-deep .pi-vimeo:before {
  content: "\\e9c6";
}
:host ::ng-deep .pi-youtube:before {
  content: "\\e9c5";
}
:host ::ng-deep .pi-flag:before {
  content: "\\e9c4";
}
:host ::ng-deep .pi-wallet:before {
  content: "\\e9c3";
}
:host ::ng-deep .pi-map:before {
  content: "\\e9c2";
}
:host ::ng-deep .pi-link:before {
  content: "\\e9c1";
}
:host ::ng-deep .pi-credit-card:before {
  content: "\\e9bf";
}
:host ::ng-deep .pi-discord:before {
  content: "\\e9c0";
}
:host ::ng-deep .pi-percentage:before {
  content: "\\e9be";
}
:host ::ng-deep .pi-euro:before {
  content: "\\e9bd";
}
:host ::ng-deep .pi-book:before {
  content: "\\e9ba";
}
:host ::ng-deep .pi-shield:before {
  content: "\\e9b9";
}
:host ::ng-deep .pi-paypal:before {
  content: "\\e9bb";
}
:host ::ng-deep .pi-amazon:before {
  content: "\\e9bc";
}
:host ::ng-deep .pi-phone:before {
  content: "\\e9b8";
}
:host ::ng-deep .pi-filter-slash:before {
  content: "\\e9b7";
}
:host ::ng-deep .pi-facebook:before {
  content: "\\e9b4";
}
:host ::ng-deep .pi-github:before {
  content: "\\e9b5";
}
:host ::ng-deep .pi-twitter:before {
  content: "\\e9b6";
}
:host ::ng-deep .pi-step-backward-alt:before {
  content: "\\e9ac";
}
:host ::ng-deep .pi-step-forward-alt:before {
  content: "\\e9ad";
}
:host ::ng-deep .pi-forward:before {
  content: "\\e9ae";
}
:host ::ng-deep .pi-backward:before {
  content: "\\e9af";
}
:host ::ng-deep .pi-fast-backward:before {
  content: "\\e9b0";
}
:host ::ng-deep .pi-fast-forward:before {
  content: "\\e9b1";
}
:host ::ng-deep .pi-pause:before {
  content: "\\e9b2";
}
:host ::ng-deep .pi-play:before {
  content: "\\e9b3";
}
:host ::ng-deep .pi-compass:before {
  content: "\\e9ab";
}
:host ::ng-deep .pi-id-card:before {
  content: "\\e9aa";
}
:host ::ng-deep .pi-ticket:before {
  content: "\\e9a9";
}
:host ::ng-deep .pi-file-o:before {
  content: "\\e9a8";
}
:host ::ng-deep .pi-reply:before {
  content: "\\e9a7";
}
:host ::ng-deep .pi-directions-alt:before {
  content: "\\e9a5";
}
:host ::ng-deep .pi-directions:before {
  content: "\\e9a6";
}
:host ::ng-deep .pi-thumbs-up:before {
  content: "\\e9a3";
}
:host ::ng-deep .pi-thumbs-down:before {
  content: "\\e9a4";
}
:host ::ng-deep .pi-sort-numeric-down-alt:before {
  content: "\\e996";
}
:host ::ng-deep .pi-sort-numeric-up-alt:before {
  content: "\\e997";
}
:host ::ng-deep .pi-sort-alpha-down-alt:before {
  content: "\\e998";
}
:host ::ng-deep .pi-sort-alpha-up-alt:before {
  content: "\\e999";
}
:host ::ng-deep .pi-sort-numeric-down:before {
  content: "\\e99a";
}
:host ::ng-deep .pi-sort-numeric-up:before {
  content: "\\e99b";
}
:host ::ng-deep .pi-sort-alpha-down:before {
  content: "\\e99c";
}
:host ::ng-deep .pi-sort-alpha-up:before {
  content: "\\e99d";
}
:host ::ng-deep .pi-sort-alt:before {
  content: "\\e99e";
}
:host ::ng-deep .pi-sort-amount-up:before {
  content: "\\e99f";
}
:host ::ng-deep .pi-sort-amount-down:before {
  content: "\\e9a0";
}
:host ::ng-deep .pi-sort-amount-down-alt:before {
  content: "\\e9a1";
}
:host ::ng-deep .pi-sort-amount-up-alt:before {
  content: "\\e9a2";
}
:host ::ng-deep .pi-palette:before {
  content: "\\e995";
}
:host ::ng-deep .pi-undo:before {
  content: "\\e994";
}
:host ::ng-deep .pi-desktop:before {
  content: "\\e993";
}
:host ::ng-deep .pi-sliders-v:before {
  content: "\\e991";
}
:host ::ng-deep .pi-sliders-h:before {
  content: "\\e992";
}
:host ::ng-deep .pi-search-plus:before {
  content: "\\e98f";
}
:host ::ng-deep .pi-search-minus:before {
  content: "\\e990";
}
:host ::ng-deep .pi-file-excel:before {
  content: "\\e98e";
}
:host ::ng-deep .pi-file-pdf:before {
  content: "\\e98d";
}
:host ::ng-deep .pi-check-square:before {
  content: "\\e98c";
}
:host ::ng-deep .pi-chart-line:before {
  content: "\\e98b";
}
:host ::ng-deep .pi-user-edit:before {
  content: "\\e98a";
}
:host ::ng-deep .pi-exclamation-circle:before {
  content: "\\e989";
}
:host ::ng-deep .pi-android:before {
  content: "\\e985";
}
:host ::ng-deep .pi-google:before {
  content: "\\e986";
}
:host ::ng-deep .pi-apple:before {
  content: "\\e987";
}
:host ::ng-deep .pi-microsoft:before {
  content: "\\e988";
}
:host ::ng-deep .pi-heart:before {
  content: "\\e984";
}
:host ::ng-deep .pi-mobile:before {
  content: "\\e982";
}
:host ::ng-deep .pi-tablet:before {
  content: "\\e983";
}
:host ::ng-deep .pi-key:before {
  content: "\\e981";
}
:host ::ng-deep .pi-shopping-cart:before {
  content: "\\e980";
}
:host ::ng-deep .pi-comments:before {
  content: "\\e97e";
}
:host ::ng-deep .pi-comment:before {
  content: "\\e97f";
}
:host ::ng-deep .pi-briefcase:before {
  content: "\\e97d";
}
:host ::ng-deep .pi-bell:before {
  content: "\\e97c";
}
:host ::ng-deep .pi-paperclip:before {
  content: "\\e97b";
}
:host ::ng-deep .pi-share-alt:before {
  content: "\\e97a";
}
:host ::ng-deep .pi-envelope:before {
  content: "\\e979";
}
:host ::ng-deep .pi-volume-down:before {
  content: "\\e976";
}
:host ::ng-deep .pi-volume-up:before {
  content: "\\e977";
}
:host ::ng-deep .pi-volume-off:before {
  content: "\\e978";
}
:host ::ng-deep .pi-eject:before {
  content: "\\e975";
}
:host ::ng-deep .pi-money-bill:before {
  content: "\\e974";
}
:host ::ng-deep .pi-images:before {
  content: "\\e973";
}
:host ::ng-deep .pi-image:before {
  content: "\\e972";
}
:host ::ng-deep .pi-sign-in:before {
  content: "\\e970";
}
:host ::ng-deep .pi-sign-out:before {
  content: "\\e971";
}
:host ::ng-deep .pi-wifi:before {
  content: "\\e96f";
}
:host ::ng-deep .pi-sitemap:before {
  content: "\\e96e";
}
:host ::ng-deep .pi-chart-bar:before {
  content: "\\e96d";
}
:host ::ng-deep .pi-camera:before {
  content: "\\e96c";
}
:host ::ng-deep .pi-dollar:before {
  content: "\\e96b";
}
:host ::ng-deep .pi-lock-open:before {
  content: "\\e96a";
}
:host ::ng-deep .pi-table:before {
  content: "\\e969";
}
:host ::ng-deep .pi-map-marker:before {
  content: "\\e968";
}
:host ::ng-deep .pi-list:before {
  content: "\\e967";
}
:host ::ng-deep .pi-eye-slash:before {
  content: "\\e965";
}
:host ::ng-deep .pi-eye:before {
  content: "\\e966";
}
:host ::ng-deep .pi-folder-open:before {
  content: "\\e964";
}
:host ::ng-deep .pi-folder:before {
  content: "\\e963";
}
:host ::ng-deep .pi-video:before {
  content: "\\e962";
}
:host ::ng-deep .pi-inbox:before {
  content: "\\e961";
}
:host ::ng-deep .pi-lock:before {
  content: "\\e95f";
}
:host ::ng-deep .pi-unlock:before {
  content: "\\e960";
}
:host ::ng-deep .pi-tags:before {
  content: "\\e95d";
}
:host ::ng-deep .pi-tag:before {
  content: "\\e95e";
}
:host ::ng-deep .pi-power-off:before {
  content: "\\e95c";
}
:host ::ng-deep .pi-save:before {
  content: "\\e95b";
}
:host ::ng-deep .pi-question-circle:before {
  content: "\\e959";
}
:host ::ng-deep .pi-question:before {
  content: "\\e95a";
}
:host ::ng-deep .pi-copy:before {
  content: "\\e957";
}
:host ::ng-deep .pi-file:before {
  content: "\\e958";
}
:host ::ng-deep .pi-clone:before {
  content: "\\e955";
}
:host ::ng-deep .pi-calendar-times:before {
  content: "\\e952";
}
:host ::ng-deep .pi-calendar-minus:before {
  content: "\\e953";
}
:host ::ng-deep .pi-calendar-plus:before {
  content: "\\e954";
}
:host ::ng-deep .pi-ellipsis-v:before {
  content: "\\e950";
}
:host ::ng-deep .pi-ellipsis-h:before {
  content: "\\e951";
}
:host ::ng-deep .pi-bookmark:before {
  content: "\\e94e";
}
:host ::ng-deep .pi-globe:before {
  content: "\\e94f";
}
:host ::ng-deep .pi-replay:before {
  content: "\\e94d";
}
:host ::ng-deep .pi-filter:before {
  content: "\\e94c";
}
:host ::ng-deep .pi-print:before {
  content: "\\e94b";
}
:host ::ng-deep .pi-align-right:before {
  content: "\\e946";
}
:host ::ng-deep .pi-align-left:before {
  content: "\\e947";
}
:host ::ng-deep .pi-align-center:before {
  content: "\\e948";
}
:host ::ng-deep .pi-align-justify:before {
  content: "\\e949";
}
:host ::ng-deep .pi-cog:before {
  content: "\\e94a";
}
:host ::ng-deep .pi-cloud-download:before {
  content: "\\e943";
}
:host ::ng-deep .pi-cloud-upload:before {
  content: "\\e944";
}
:host ::ng-deep .pi-cloud:before {
  content: "\\e945";
}
:host ::ng-deep .pi-pencil:before {
  content: "\\e942";
}
:host ::ng-deep .pi-users:before {
  content: "\\e941";
}
:host ::ng-deep .pi-clock:before {
  content: "\\e940";
}
:host ::ng-deep .pi-user-minus:before {
  content: "\\e93e";
}
:host ::ng-deep .pi-user-plus:before {
  content: "\\e93f";
}
:host ::ng-deep .pi-trash:before {
  content: "\\e93d";
}
:host ::ng-deep .pi-external-link:before {
  content: "\\e93c";
}
:host ::ng-deep .pi-window-maximize:before {
  content: "\\e93b";
}
:host ::ng-deep .pi-window-minimize:before {
  content: "\\e93a";
}
:host ::ng-deep .pi-refresh:before {
  content: "\\e938";
}
:host ::ng-deep .pi-user:before {
  content: "\\e939";
}
:host ::ng-deep .pi-exclamation-triangle:before {
  content: "\\e922";
}
:host ::ng-deep .pi-calendar:before {
  content: "\\e927";
}
:host ::ng-deep .pi-chevron-circle-left:before {
  content: "\\e928";
}
:host ::ng-deep .pi-chevron-circle-down:before {
  content: "\\e929";
}
:host ::ng-deep .pi-chevron-circle-right:before {
  content: "\\e92a";
}
:host ::ng-deep .pi-chevron-circle-up:before {
  content: "\\e92b";
}
:host ::ng-deep .pi-angle-double-down:before {
  content: "\\e92c";
}
:host ::ng-deep .pi-angle-double-left:before {
  content: "\\e92d";
}
:host ::ng-deep .pi-angle-double-right:before {
  content: "\\e92e";
}
:host ::ng-deep .pi-angle-double-up:before {
  content: "\\e92f";
}
:host ::ng-deep .pi-angle-down:before {
  content: "\\e930";
}
:host ::ng-deep .pi-angle-left:before {
  content: "\\e931";
}
:host ::ng-deep .pi-angle-right:before {
  content: "\\e932";
}
:host ::ng-deep .pi-angle-up:before {
  content: "\\e933";
}
:host ::ng-deep .pi-upload:before {
  content: "\\e934";
}
:host ::ng-deep .pi-download:before {
  content: "\\e956";
}
:host ::ng-deep .pi-ban:before {
  content: "\\e935";
}
:host ::ng-deep .pi-star-fill:before {
  content: "\\e936";
}
:host ::ng-deep .pi-star:before {
  content: "\\e937";
}
:host ::ng-deep .pi-chevron-left:before {
  content: "\\e900";
}
:host ::ng-deep .pi-chevron-right:before {
  content: "\\e901";
}
:host ::ng-deep .pi-chevron-down:before {
  content: "\\e902";
}
:host ::ng-deep .pi-chevron-up:before {
  content: "\\e903";
}
:host ::ng-deep .pi-caret-left:before {
  content: "\\e904";
}
:host ::ng-deep .pi-caret-right:before {
  content: "\\e905";
}
:host ::ng-deep .pi-caret-down:before {
  content: "\\e906";
}
:host ::ng-deep .pi-caret-up:before {
  content: "\\e907";
}
:host ::ng-deep .pi-search:before {
  content: "\\e908";
}
:host ::ng-deep .pi-check:before {
  content: "\\e909";
}
:host ::ng-deep .pi-check-circle:before {
  content: "\\e90a";
}
:host ::ng-deep .pi-times:before {
  content: "\\e90b";
}
:host ::ng-deep .pi-times-circle:before {
  content: "\\e90c";
}
:host ::ng-deep .pi-plus:before {
  content: "\\e90d";
}
:host ::ng-deep .pi-plus-circle:before {
  content: "\\e90e";
}
:host ::ng-deep .pi-minus:before {
  content: "\\e90f";
}
:host ::ng-deep .pi-minus-circle:before {
  content: "\\e910";
}
:host ::ng-deep .pi-circle-on:before {
  content: "\\e911";
}
:host ::ng-deep .pi-circle-off:before {
  content: "\\e912";
}
:host ::ng-deep .pi-sort-down:before {
  content: "\\e913";
}
:host ::ng-deep .pi-sort-up:before {
  content: "\\e914";
}
:host ::ng-deep .pi-sort:before {
  content: "\\e915";
}
:host ::ng-deep .pi-step-backward:before {
  content: "\\e916";
}
:host ::ng-deep .pi-step-forward:before {
  content: "\\e917";
}
:host ::ng-deep .pi-th-large:before {
  content: "\\e918";
}
:host ::ng-deep .pi-arrow-down:before {
  content: "\\e919";
}
:host ::ng-deep .pi-arrow-left:before {
  content: "\\e91a";
}
:host ::ng-deep .pi-arrow-right:before {
  content: "\\e91b";
}
:host ::ng-deep .pi-arrow-up:before {
  content: "\\e91c";
}
:host ::ng-deep .pi-bars:before {
  content: "\\e91d";
}
:host ::ng-deep .pi-arrow-circle-down:before {
  content: "\\e91e";
}
:host ::ng-deep .pi-arrow-circle-left:before {
  content: "\\e91f";
}
:host ::ng-deep .pi-arrow-circle-right:before {
  content: "\\e920";
}
:host ::ng-deep .pi-arrow-circle-up:before {
  content: "\\e921";
}
:host ::ng-deep .pi-info:before {
  content: "\\e923";
}
:host ::ng-deep .pi-info-circle:before {
  content: "\\e924";
}
:host ::ng-deep .pi-home:before {
  content: "\\e925";
}
:host ::ng-deep .pi-spinner:before {
  content: "\\e926";
}
:host ::ng-deep .ql-container {
  box-sizing: border-box;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 13px;
  height: 100%;
  margin: 0;
  position: relative;
}
:host ::ng-deep .ql-container.ql-disabled .ql-tooltip {
  visibility: hidden;
}
:host ::ng-deep .ql-container.ql-disabled .ql-editor ul[data-checked] > li:before {
  pointer-events: none;
}
:host ::ng-deep .ql-clipboard {
  left: -100000px;
  height: 1px;
  overflow-y: hidden;
  position: absolute;
  top: 50%;
}
:host ::ng-deep .ql-clipboard p {
  margin: 0;
  padding: 0;
}
:host ::ng-deep .ql-editor {
  box-sizing: border-box;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  padding: 12px 15px;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
}
:host ::ng-deep .ql-editor > * {
  cursor: text;
}
:host ::ng-deep .ql-editor p, :host ::ng-deep .ql-editor ol, :host ::ng-deep .ql-editor ul, :host ::ng-deep .ql-editor pre, :host ::ng-deep .ql-editor blockquote, :host ::ng-deep .ql-editor h1, :host ::ng-deep .ql-editor h2, :host ::ng-deep .ql-editor h3, :host ::ng-deep .ql-editor h4, :host ::ng-deep .ql-editor h5, :host ::ng-deep .ql-editor h6 {
  margin: 0;
  padding: 0;
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
:host ::ng-deep .ql-editor ol, :host ::ng-deep .ql-editor ul {
  padding-left: 1.5em;
}
:host ::ng-deep .ql-editor ol > li, :host ::ng-deep .ql-editor ul > li {
  list-style-type: none;
}
:host ::ng-deep .ql-editor ul > li:before {
  content: "•";
}
:host ::ng-deep .ql-editor ul[data-checked=true], :host ::ng-deep .ql-editor ul[data-checked=false] {
  pointer-events: none;
}
:host ::ng-deep .ql-editor ul[data-checked=true] > li *, :host ::ng-deep .ql-editor ul[data-checked=false] > li * {
  pointer-events: all;
}
:host ::ng-deep .ql-editor ul[data-checked=true] > li:before, :host ::ng-deep .ql-editor ul[data-checked=false] > li:before {
  color: #777;
  cursor: pointer;
  pointer-events: all;
}
:host ::ng-deep .ql-editor ul[data-checked=true] > li:before {
  content: "☑";
}
:host ::ng-deep .ql-editor ul[data-checked=false] > li:before {
  content: "☐";
}
:host ::ng-deep .ql-editor li:before {
  display: inline-block;
  white-space: nowrap;
  width: 1.2em;
}
:host ::ng-deep .ql-editor li:not(.ql-direction-rtl):before {
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right;
}
:host ::ng-deep .ql-editor li.ql-direction-rtl:before {
  margin-left: 0.3em;
  margin-right: -1.5em;
}
:host ::ng-deep .ql-editor ol li:not(.ql-direction-rtl), :host ::ng-deep .ql-editor ul li:not(.ql-direction-rtl) {
  padding-left: 1.5em;
}
:host ::ng-deep .ql-editor ol li.ql-direction-rtl, :host ::ng-deep .ql-editor ul li.ql-direction-rtl {
  padding-right: 1.5em;
}
:host ::ng-deep .ql-editor ol li {
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  counter-increment: list-0;
}
:host ::ng-deep .ql-editor ol li:before {
  content: counter(list-0, decimal) ". ";
}
:host ::ng-deep .ql-editor ol li.ql-indent-1 {
  counter-increment: list-1;
}
:host ::ng-deep .ql-editor ol li.ql-indent-1:before {
  content: counter(list-1, lower-alpha) ". ";
}
:host ::ng-deep .ql-editor ol li.ql-indent-1 {
  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
:host ::ng-deep .ql-editor ol li.ql-indent-2 {
  counter-increment: list-2;
}
:host ::ng-deep .ql-editor ol li.ql-indent-2:before {
  content: counter(list-2, lower-roman) ". ";
}
:host ::ng-deep .ql-editor ol li.ql-indent-2 {
  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
:host ::ng-deep .ql-editor ol li.ql-indent-3 {
  counter-increment: list-3;
}
:host ::ng-deep .ql-editor ol li.ql-indent-3:before {
  content: counter(list-3, decimal) ". ";
}
:host ::ng-deep .ql-editor ol li.ql-indent-3 {
  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
}
:host ::ng-deep .ql-editor ol li.ql-indent-4 {
  counter-increment: list-4;
}
:host ::ng-deep .ql-editor ol li.ql-indent-4:before {
  content: counter(list-4, lower-alpha) ". ";
}
:host ::ng-deep .ql-editor ol li.ql-indent-4 {
  counter-reset: list-5 list-6 list-7 list-8 list-9;
}
:host ::ng-deep .ql-editor ol li.ql-indent-5 {
  counter-increment: list-5;
}
:host ::ng-deep .ql-editor ol li.ql-indent-5:before {
  content: counter(list-5, lower-roman) ". ";
}
:host ::ng-deep .ql-editor ol li.ql-indent-5 {
  counter-reset: list-6 list-7 list-8 list-9;
}
:host ::ng-deep .ql-editor ol li.ql-indent-6 {
  counter-increment: list-6;
}
:host ::ng-deep .ql-editor ol li.ql-indent-6:before {
  content: counter(list-6, decimal) ". ";
}
:host ::ng-deep .ql-editor ol li.ql-indent-6 {
  counter-reset: list-7 list-8 list-9;
}
:host ::ng-deep .ql-editor ol li.ql-indent-7 {
  counter-increment: list-7;
}
:host ::ng-deep .ql-editor ol li.ql-indent-7:before {
  content: counter(list-7, lower-alpha) ". ";
}
:host ::ng-deep .ql-editor ol li.ql-indent-7 {
  counter-reset: list-8 list-9;
}
:host ::ng-deep .ql-editor ol li.ql-indent-8 {
  counter-increment: list-8;
}
:host ::ng-deep .ql-editor ol li.ql-indent-8:before {
  content: counter(list-8, lower-roman) ". ";
}
:host ::ng-deep .ql-editor ol li.ql-indent-8 {
  counter-reset: list-9;
}
:host ::ng-deep .ql-editor ol li.ql-indent-9 {
  counter-increment: list-9;
}
:host ::ng-deep .ql-editor ol li.ql-indent-9:before {
  content: counter(list-9, decimal) ". ";
}
:host ::ng-deep .ql-editor .ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 3em;
}
:host ::ng-deep .ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 4.5em;
}
:host ::ng-deep .ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 3em;
}
:host ::ng-deep .ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 4.5em;
}
:host ::ng-deep .ql-editor .ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 6em;
}
:host ::ng-deep .ql-editor li.ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 7.5em;
}
:host ::ng-deep .ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 6em;
}
:host ::ng-deep .ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 7.5em;
}
:host ::ng-deep .ql-editor .ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 9em;
}
:host ::ng-deep .ql-editor li.ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 10.5em;
}
:host ::ng-deep .ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 9em;
}
:host ::ng-deep .ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 10.5em;
}
:host ::ng-deep .ql-editor .ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 12em;
}
:host ::ng-deep .ql-editor li.ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 13.5em;
}
:host ::ng-deep .ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 12em;
}
:host ::ng-deep .ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 13.5em;
}
:host ::ng-deep .ql-editor .ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 15em;
}
:host ::ng-deep .ql-editor li.ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 16.5em;
}
:host ::ng-deep .ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 15em;
}
:host ::ng-deep .ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 16.5em;
}
:host ::ng-deep .ql-editor .ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 18em;
}
:host ::ng-deep .ql-editor li.ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 19.5em;
}
:host ::ng-deep .ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 18em;
}
:host ::ng-deep .ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 19.5em;
}
:host ::ng-deep .ql-editor .ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 21em;
}
:host ::ng-deep .ql-editor li.ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 22.5em;
}
:host ::ng-deep .ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 21em;
}
:host ::ng-deep .ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 22.5em;
}
:host ::ng-deep .ql-editor .ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 24em;
}
:host ::ng-deep .ql-editor li.ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 25.5em;
}
:host ::ng-deep .ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 24em;
}
:host ::ng-deep .ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 25.5em;
}
:host ::ng-deep .ql-editor .ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 27em;
}
:host ::ng-deep .ql-editor li.ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 28.5em;
}
:host ::ng-deep .ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 27em;
}
:host ::ng-deep .ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 28.5em;
}
:host ::ng-deep .ql-editor .ql-video {
  display: block;
  max-width: 100%;
}
:host ::ng-deep .ql-editor .ql-video.ql-align-center {
  margin: 0 auto;
}
:host ::ng-deep .ql-editor .ql-video.ql-align-right {
  margin: 0 0 0 auto;
}
:host ::ng-deep .ql-editor .ql-bg-black {
  background-color: #000;
}
:host ::ng-deep .ql-editor .ql-bg-red {
  background-color: #e60000;
}
:host ::ng-deep .ql-editor .ql-bg-orange {
  background-color: #f90;
}
:host ::ng-deep .ql-editor .ql-bg-yellow {
  background-color: #ff0;
}
:host ::ng-deep .ql-editor .ql-bg-green {
  background-color: #008a00;
}
:host ::ng-deep .ql-editor .ql-bg-blue {
  background-color: #06c;
}
:host ::ng-deep .ql-editor .ql-bg-purple {
  background-color: #93f;
}
:host ::ng-deep .ql-editor .ql-color-white {
  color: #fff;
}
:host ::ng-deep .ql-editor .ql-color-red {
  color: #e60000;
}
:host ::ng-deep .ql-editor .ql-color-orange {
  color: #f90;
}
:host ::ng-deep .ql-editor .ql-color-yellow {
  color: #ff0;
}
:host ::ng-deep .ql-editor .ql-color-green {
  color: #008a00;
}
:host ::ng-deep .ql-editor .ql-color-blue {
  color: #06c;
}
:host ::ng-deep .ql-editor .ql-color-purple {
  color: #93f;
}
:host ::ng-deep .ql-editor .ql-font-serif {
  font-family: Georgia, Times New Roman, serif;
}
:host ::ng-deep .ql-editor .ql-font-monospace {
  font-family: Monaco, Courier New, monospace;
}
:host ::ng-deep .ql-editor .ql-size-small {
  font-size: 0.75em;
}
:host ::ng-deep .ql-editor .ql-size-large {
  font-size: 1.5em;
}
:host ::ng-deep .ql-editor .ql-size-huge {
  font-size: 2.5em;
}
:host ::ng-deep .ql-editor .ql-direction-rtl {
  direction: rtl;
  text-align: inherit;
}
:host ::ng-deep .ql-editor .ql-align-center {
  text-align: center;
}
:host ::ng-deep .ql-editor .ql-align-justify {
  text-align: justify;
}
:host ::ng-deep .ql-editor .ql-align-right {
  text-align: right;
}
:host ::ng-deep .ql-editor.ql-blank:before {
  color: rgba(0, 0, 0, 0.6);
  content: attr(data-placeholder);
  font-style: italic;
  left: 15px;
  pointer-events: none;
  position: absolute;
  right: 15px;
}
:host ::ng-deep .ql-snow.ql-toolbar:after, :host ::ng-deep .ql-snow .ql-toolbar:after {
  clear: both;
  content: "";
  display: table;
}
:host ::ng-deep .ql-snow.ql-toolbar button, :host ::ng-deep .ql-snow .ql-toolbar button {
  background: none;
  border: none;
  cursor: pointer;
  display: inline-block;
  float: left;
  height: 24px;
  padding: 3px 5px;
  width: 28px;
}
:host ::ng-deep .ql-snow.ql-toolbar button svg, :host ::ng-deep .ql-snow .ql-toolbar button svg {
  float: left;
  height: 100%;
}
:host ::ng-deep .ql-snow.ql-toolbar button:active:hover, :host ::ng-deep .ql-snow .ql-toolbar button:active:hover {
  outline: none;
}
:host ::ng-deep .ql-snow.ql-toolbar input.ql-image[type=file], :host ::ng-deep .ql-snow .ql-toolbar input.ql-image[type=file] {
  display: none;
}
:host ::ng-deep .ql-snow.ql-toolbar button:hover, :host ::ng-deep .ql-snow .ql-toolbar button:hover, :host ::ng-deep .ql-snow.ql-toolbar button:focus, :host ::ng-deep .ql-snow .ql-toolbar button:focus, :host ::ng-deep .ql-snow.ql-toolbar button.ql-active, :host ::ng-deep .ql-snow .ql-toolbar button.ql-active, :host ::ng-deep .ql-snow.ql-toolbar .ql-picker-label:hover, :host ::ng-deep .ql-snow .ql-toolbar .ql-picker-label:hover, :host ::ng-deep .ql-snow.ql-toolbar .ql-picker-label.ql-active, :host ::ng-deep .ql-snow .ql-toolbar .ql-picker-label.ql-active, :host ::ng-deep .ql-snow.ql-toolbar .ql-picker-item:hover, :host ::ng-deep .ql-snow .ql-toolbar .ql-picker-item:hover, :host ::ng-deep .ql-snow.ql-toolbar .ql-picker-item.ql-selected, :host ::ng-deep .ql-snow .ql-toolbar .ql-picker-item.ql-selected {
  color: #06c;
}
:host ::ng-deep .ql-snow.ql-toolbar button:hover .ql-fill, :host ::ng-deep .ql-snow .ql-toolbar button:hover .ql-fill, :host ::ng-deep .ql-snow.ql-toolbar button:focus .ql-fill, :host ::ng-deep .ql-snow .ql-toolbar button:focus .ql-fill, :host ::ng-deep .ql-snow.ql-toolbar button.ql-active .ql-fill, :host ::ng-deep .ql-snow .ql-toolbar button.ql-active .ql-fill, :host ::ng-deep .ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill, :host ::ng-deep .ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill, :host ::ng-deep .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill, :host ::ng-deep .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill, :host ::ng-deep .ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill, :host ::ng-deep .ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill, :host ::ng-deep .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill, :host ::ng-deep .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill, :host ::ng-deep .ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill, :host ::ng-deep .ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill, :host ::ng-deep .ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill, :host ::ng-deep .ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill, :host ::ng-deep .ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill, :host ::ng-deep .ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill, :host ::ng-deep .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill, :host ::ng-deep .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill, :host ::ng-deep .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill, :host ::ng-deep .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill, :host ::ng-deep .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill, :host ::ng-deep .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill, :host ::ng-deep .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill, :host ::ng-deep .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {
  fill: #06c;
}
:host ::ng-deep .ql-snow.ql-toolbar button:hover .ql-stroke, :host ::ng-deep .ql-snow .ql-toolbar button:hover .ql-stroke, :host ::ng-deep .ql-snow.ql-toolbar button:focus .ql-stroke, :host ::ng-deep .ql-snow .ql-toolbar button:focus .ql-stroke, :host ::ng-deep .ql-snow.ql-toolbar button.ql-active .ql-stroke, :host ::ng-deep .ql-snow .ql-toolbar button.ql-active .ql-stroke, :host ::ng-deep .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke, :host ::ng-deep .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke, :host ::ng-deep .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke, :host ::ng-deep .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke, :host ::ng-deep .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke, :host ::ng-deep .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke, :host ::ng-deep .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke, :host ::ng-deep .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke, :host ::ng-deep .ql-snow.ql-toolbar button:hover .ql-stroke-miter, :host ::ng-deep .ql-snow .ql-toolbar button:hover .ql-stroke-miter, :host ::ng-deep .ql-snow.ql-toolbar button:focus .ql-stroke-miter, :host ::ng-deep .ql-snow .ql-toolbar button:focus .ql-stroke-miter, :host ::ng-deep .ql-snow.ql-toolbar button.ql-active .ql-stroke-miter, :host ::ng-deep .ql-snow .ql-toolbar button.ql-active .ql-stroke-miter, :host ::ng-deep .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter, :host ::ng-deep .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter, :host ::ng-deep .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter, :host ::ng-deep .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter, :host ::ng-deep .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter, :host ::ng-deep .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter, :host ::ng-deep .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter, :host ::ng-deep .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {
  stroke: #06c;
}
@media (pointer: coarse) {
  :host ::ng-deep .ql-snow.ql-toolbar button:hover:not(.ql-active), :host ::ng-deep .ql-snow .ql-toolbar button:hover:not(.ql-active) {
    color: #444;
  }
  :host ::ng-deep .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill, :host ::ng-deep .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill, :host ::ng-deep .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill, :host ::ng-deep .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {
    fill: #444;
  }
  :host ::ng-deep .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke, :host ::ng-deep .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke, :host ::ng-deep .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter, :host ::ng-deep .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {
    stroke: #444;
  }
}
:host ::ng-deep .ql-snow, :host ::ng-deep .ql-snow * {
  box-sizing: border-box;
}
:host ::ng-deep .ql-snow .ql-hidden {
  display: none;
}
:host ::ng-deep .ql-snow .ql-out-bottom, :host ::ng-deep .ql-snow .ql-out-top {
  visibility: hidden;
}
:host ::ng-deep .ql-snow .ql-tooltip {
  position: absolute;
  transform: translateY(10px);
}
:host ::ng-deep .ql-snow .ql-tooltip a {
  cursor: pointer;
  text-decoration: none;
}
:host ::ng-deep .ql-snow .ql-tooltip.ql-flip {
  transform: translateY(-10px);
}
:host ::ng-deep .ql-snow .ql-formats {
  display: inline-block;
  vertical-align: middle;
}
:host ::ng-deep .ql-snow .ql-formats:after {
  clear: both;
  content: "";
  display: table;
}
:host ::ng-deep .ql-snow .ql-stroke {
  fill: none;
  stroke: #444;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
}
:host ::ng-deep .ql-snow .ql-stroke-miter {
  fill: none;
  stroke: #444;
  stroke-miterlimit: 10;
  stroke-width: 2;
}
:host ::ng-deep .ql-snow .ql-fill, :host ::ng-deep .ql-snow .ql-stroke.ql-fill {
  fill: #444;
}
:host ::ng-deep .ql-snow .ql-empty {
  fill: none;
}
:host ::ng-deep .ql-snow .ql-even {
  fill-rule: evenodd;
}
:host ::ng-deep .ql-snow .ql-thin, :host ::ng-deep .ql-snow .ql-stroke.ql-thin {
  stroke-width: 1;
}
:host ::ng-deep .ql-snow .ql-transparent {
  opacity: 0.4;
}
:host ::ng-deep .ql-snow .ql-direction svg:last-child {
  display: none;
}
:host ::ng-deep .ql-snow .ql-direction.ql-active svg:last-child {
  display: inline;
}
:host ::ng-deep .ql-snow .ql-direction.ql-active svg:first-child {
  display: none;
}
:host ::ng-deep .ql-snow .ql-editor h1 {
  font-size: 2em;
}
:host ::ng-deep .ql-snow .ql-editor h2 {
  font-size: 1.5em;
}
:host ::ng-deep .ql-snow .ql-editor h3 {
  font-size: 1.17em;
}
:host ::ng-deep .ql-snow .ql-editor h4 {
  font-size: 1em;
}
:host ::ng-deep .ql-snow .ql-editor h5 {
  font-size: 0.83em;
}
:host ::ng-deep .ql-snow .ql-editor h6 {
  font-size: 0.67em;
}
:host ::ng-deep .ql-snow .ql-editor a {
  text-decoration: underline;
}
:host ::ng-deep .ql-snow .ql-editor blockquote {
  border-left: 4px solid #ccc;
  margin-bottom: 5px;
  margin-top: 5px;
  padding-left: 16px;
}
:host ::ng-deep .ql-snow .ql-editor code, :host ::ng-deep .ql-snow .ql-editor pre {
  background-color: #f0f0f0;
  border-radius: 3px;
}
:host ::ng-deep .ql-snow .ql-editor pre {
  white-space: pre-wrap;
  margin-bottom: 5px;
  margin-top: 5px;
  padding: 5px 10px;
}
:host ::ng-deep .ql-snow .ql-editor code {
  font-size: 85%;
  padding: 2px 4px;
}
:host ::ng-deep .ql-snow .ql-editor pre.ql-syntax {
  background-color: #23241f;
  color: #f8f8f2;
  overflow: visible;
}
:host ::ng-deep .ql-snow .ql-editor img {
  max-width: 100%;
}
:host ::ng-deep .ql-snow .ql-picker {
  color: #444;
  display: inline-block;
  float: left;
  font-size: 14px;
  font-weight: 500;
  height: 24px;
  position: relative;
  vertical-align: middle;
}
:host ::ng-deep .ql-snow .ql-picker-label {
  cursor: pointer;
  display: inline-block;
  height: 100%;
  padding-left: 8px;
  padding-right: 2px;
  position: relative;
  width: 100%;
}
:host ::ng-deep .ql-snow .ql-picker-label:before {
  display: inline-block;
  line-height: 22px;
}
:host ::ng-deep .ql-snow .ql-picker-options {
  background-color: #fff;
  display: none;
  min-width: 100%;
  padding: 4px 8px;
  position: absolute;
  white-space: nowrap;
}
:host ::ng-deep .ql-snow .ql-picker-options .ql-picker-item {
  cursor: pointer;
  display: block;
  padding-bottom: 5px;
  padding-top: 5px;
}
:host ::ng-deep .ql-snow .ql-picker.ql-expanded .ql-picker-label {
  color: #ccc;
  z-index: 2;
}
:host ::ng-deep .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {
  fill: #ccc;
}
:host ::ng-deep .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {
  stroke: #ccc;
}
:host ::ng-deep .ql-snow .ql-picker.ql-expanded .ql-picker-options {
  display: block;
  margin-top: -1px;
  top: 100%;
  z-index: 1;
}
:host ::ng-deep .ql-snow .ql-color-picker, :host ::ng-deep .ql-snow .ql-icon-picker {
  width: 28px;
}
:host ::ng-deep .ql-snow .ql-color-picker .ql-picker-label, :host ::ng-deep .ql-snow .ql-icon-picker .ql-picker-label {
  padding: 2px 4px;
}
:host ::ng-deep .ql-snow .ql-color-picker .ql-picker-label svg, :host ::ng-deep .ql-snow .ql-icon-picker .ql-picker-label svg {
  right: 4px;
}
:host ::ng-deep .ql-snow .ql-icon-picker .ql-picker-options {
  padding: 4px 0;
}
:host ::ng-deep .ql-snow .ql-icon-picker .ql-picker-item {
  height: 24px;
  width: 24px;
  padding: 2px 4px;
}
:host ::ng-deep .ql-snow .ql-color-picker .ql-picker-options {
  padding: 3px 5px;
  width: 152px;
}
:host ::ng-deep .ql-snow .ql-color-picker .ql-picker-item {
  border: 1px solid transparent;
  float: left;
  height: 16px;
  margin: 2px;
  padding: 0;
  width: 16px;
}
:host ::ng-deep .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
  position: absolute;
  margin-top: -9px;
  right: 0;
  top: 50%;
  width: 18px;
}
:host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=""]):before, :host ::ng-deep .ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=""]):before, :host ::ng-deep .ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=""]):before, :host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=""]):before, :host ::ng-deep .ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=""]):before, :host ::ng-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=""]):before {
  content: attr(data-label);
}
:host ::ng-deep .ql-snow .ql-picker.ql-header {
  width: 98px;
}
:host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-label:before, :host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-item:before {
  content: "Normal";
}
:host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]:before, :host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]:before {
  content: "Heading 1";
}
:host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]:before, :host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]:before {
  content: "Heading 2";
}
:host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]:before, :host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]:before {
  content: "Heading 3";
}
:host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]:before, :host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]:before {
  content: "Heading 4";
}
:host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]:before, :host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]:before {
  content: "Heading 5";
}
:host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]:before, :host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]:before {
  content: "Heading 6";
}
:host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]:before {
  font-size: 2em;
}
:host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]:before {
  font-size: 1.5em;
}
:host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]:before {
  font-size: 1.17em;
}
:host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]:before {
  font-size: 1em;
}
:host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]:before {
  font-size: 0.83em;
}
:host ::ng-deep .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]:before {
  font-size: 0.67em;
}
:host ::ng-deep .ql-snow .ql-picker.ql-font {
  width: 108px;
}
:host ::ng-deep .ql-snow .ql-picker.ql-font .ql-picker-label:before, :host ::ng-deep .ql-snow .ql-picker.ql-font .ql-picker-item:before {
  content: "Sans Serif";
}
:host ::ng-deep .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]:before, :host ::ng-deep .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]:before {
  content: "Serif";
}
:host ::ng-deep .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]:before, :host ::ng-deep .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before {
  content: "Monospace";
}
:host ::ng-deep .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]:before {
  font-family: Georgia, Times New Roman, serif;
}
:host ::ng-deep .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before {
  font-family: Monaco, Courier New, monospace;
}
:host ::ng-deep .ql-snow .ql-picker.ql-size {
  width: 98px;
}
:host ::ng-deep .ql-snow .ql-picker.ql-size .ql-picker-label:before, :host ::ng-deep .ql-snow .ql-picker.ql-size .ql-picker-item:before {
  content: "Normal";
}
:host ::ng-deep .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]:before, :host ::ng-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]:before {
  content: "Small";
}
:host ::ng-deep .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]:before, :host ::ng-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]:before {
  content: "Large";
}
:host ::ng-deep .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]:before, :host ::ng-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]:before {
  content: "Huge";
}
:host ::ng-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]:before {
  font-size: 10px;
}
:host ::ng-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]:before {
  font-size: 18px;
}
:host ::ng-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]:before {
  font-size: 32px;
}
:host ::ng-deep .ql-snow .ql-color-picker.ql-background .ql-picker-item {
  background-color: #fff;
}
:host ::ng-deep .ql-snow .ql-color-picker.ql-color .ql-picker-item {
  background-color: #000;
}
:host ::ng-deep .ql-toolbar.ql-snow {
  border: 1px solid #ccc;
  box-sizing: border-box;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  padding: 8px;
}
:host ::ng-deep .ql-toolbar.ql-snow .ql-formats {
  margin-right: 15px;
}
:host ::ng-deep .ql-toolbar.ql-snow .ql-picker-label {
  border: 1px solid transparent;
}
:host ::ng-deep .ql-toolbar.ql-snow .ql-picker-options {
  border: 1px solid transparent;
  box-shadow: rgba(0, 0, 0, 0.2) 0 2px 8px;
}
:host ::ng-deep .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label, :host ::ng-deep .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
  border-color: #ccc;
}
:host ::ng-deep .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected, :host ::ng-deep .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {
  border-color: #000;
}
:host ::ng-deep .ql-toolbar.ql-snow + .ql-container.ql-snow {
  border-top: 0px;
}
:host ::ng-deep .ql-snow .ql-tooltip {
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 0 5px #ddd;
  color: #444;
  padding: 5px 12px;
  white-space: nowrap;
}
:host ::ng-deep .ql-snow .ql-tooltip:before {
  content: "Visit URL:";
  line-height: 26px;
  margin-right: 8px;
}
:host ::ng-deep .ql-snow .ql-tooltip input[type=text] {
  display: none;
  border: 1px solid #ccc;
  font-size: 13px;
  height: 26px;
  margin: 0;
  padding: 3px 5px;
  width: 170px;
}
:host ::ng-deep .ql-snow .ql-tooltip a.ql-preview {
  display: inline-block;
  max-width: 200px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
}
:host ::ng-deep .ql-snow .ql-tooltip a.ql-action:after {
  border-right: 1px solid #ccc;
  content: "Edit";
  margin-left: 16px;
  padding-right: 8px;
}
:host ::ng-deep .ql-snow .ql-tooltip a.ql-remove:before {
  content: "Remove";
  margin-left: 8px;
}
:host ::ng-deep .ql-snow .ql-tooltip a {
  line-height: 26px;
}
:host ::ng-deep .ql-snow .ql-tooltip.ql-editing a.ql-preview, :host ::ng-deep .ql-snow .ql-tooltip.ql-editing a.ql-remove {
  display: none;
}
:host ::ng-deep .ql-snow .ql-tooltip.ql-editing input[type=text] {
  display: inline-block;
}
:host ::ng-deep .ql-snow .ql-tooltip.ql-editing a.ql-action:after {
  border-right: 0px;
  content: "Save";
  padding-right: 0;
}
:host ::ng-deep .ql-snow .ql-tooltip[data-mode=link]:before {
  content: "Enter link:";
}
:host ::ng-deep .ql-snow .ql-tooltip[data-mode=formula]:before {
  content: "Enter formula:";
}
:host ::ng-deep .ql-snow .ql-tooltip[data-mode=video]:before {
  content: "Enter video:";
}
:host ::ng-deep .ql-snow a {
  color: #06c;
}
:host ::ng-deep .ql-container.ql-snow {
  border: 1px solid #ccc;
}
:host ::ng-deep span.flag {
  width: 44px;
  height: 30px;
  display: inline-block;
}
:host ::ng-deep img.flag {
  width: 30px;
}
:host ::ng-deep .flag {
  background-size: 100%;
  vertical-align: middle;
}
:host ::ng-deep .flag-ad {
  background-position: 0 0.413223%;
}
:host ::ng-deep .flag-ae {
  background-position: 0 0.826446%;
}
:host ::ng-deep .flag-af {
  background-position: 0 1.239669%;
}
:host ::ng-deep .flag-ag {
  background-position: 0 1.652893%;
}
:host ::ng-deep .flag-ai {
  background-position: 0 2.066116%;
}
:host ::ng-deep .flag-al {
  background-position: 0 2.479339%;
}
:host ::ng-deep .flag-am {
  background-position: 0 2.892562%;
}
:host ::ng-deep .flag-an {
  background-position: 0 3.305785%;
}
:host ::ng-deep .flag-ao {
  background-position: 0 3.719008%;
}
:host ::ng-deep .flag-aq {
  background-position: 0 4.132231%;
}
:host ::ng-deep .flag-ar {
  background-position: 0 4.545455%;
}
:host ::ng-deep .flag-as {
  background-position: 0 4.958678%;
}
:host ::ng-deep .flag-at {
  background-position: 0 5.371901%;
}
:host ::ng-deep .flag-au {
  background-position: 0 5.785124%;
}
:host ::ng-deep .flag-aw {
  background-position: 0 6.198347%;
}
:host ::ng-deep .flag-az {
  background-position: 0 6.61157%;
}
:host ::ng-deep .flag-ba {
  background-position: 0 7.024793%;
}
:host ::ng-deep .flag-bb {
  background-position: 0 7.438017%;
}
:host ::ng-deep .flag-bd {
  background-position: 0 7.85124%;
}
:host ::ng-deep .flag-be {
  background-position: 0 8.264463%;
}
:host ::ng-deep .flag-bf {
  background-position: 0 8.677686%;
}
:host ::ng-deep .flag-bg {
  background-position: 0 9.090909%;
}
:host ::ng-deep .flag-bh {
  background-position: 0 9.504132%;
}
:host ::ng-deep .flag-bi {
  background-position: 0 9.917355%;
}
:host ::ng-deep .flag-bj {
  background-position: 0 10.330579%;
}
:host ::ng-deep .flag-bm {
  background-position: 0 10.743802%;
}
:host ::ng-deep .flag-bn {
  background-position: 0 11.157025%;
}
:host ::ng-deep .flag-bo {
  background-position: 0 11.570248%;
}
:host ::ng-deep .flag-br {
  background-position: 0 11.983471%;
}
:host ::ng-deep .flag-bs {
  background-position: 0 12.396694%;
}
:host ::ng-deep .flag-bt {
  background-position: 0 12.809917%;
}
:host ::ng-deep .flag-bv {
  background-position: 0 13.22314%;
}
:host ::ng-deep .flag-bw {
  background-position: 0 13.636364%;
}
:host ::ng-deep .flag-by {
  background-position: 0 14.049587%;
}
:host ::ng-deep .flag-bz {
  background-position: 0 14.46281%;
}
:host ::ng-deep .flag-ca {
  background-position: 0 14.876033%;
}
:host ::ng-deep .flag-cc {
  background-position: 0 15.289256%;
}
:host ::ng-deep .flag-cd {
  background-position: 0 15.702479%;
}
:host ::ng-deep .flag-cf {
  background-position: 0 16.115702%;
}
:host ::ng-deep .flag-cg {
  background-position: 0 16.528926%;
}
:host ::ng-deep .flag-ch {
  background-position: 0 16.942149%;
}
:host ::ng-deep .flag-ci {
  background-position: 0 17.355372%;
}
:host ::ng-deep .flag-ck {
  background-position: 0 17.768595%;
}
:host ::ng-deep .flag-cl {
  background-position: 0 18.181818%;
}
:host ::ng-deep .flag-cm {
  background-position: 0 18.595041%;
}
:host ::ng-deep .flag-cn {
  background-position: 0 19.008264%;
}
:host ::ng-deep .flag-co {
  background-position: 0 19.421488%;
}
:host ::ng-deep .flag-cr {
  background-position: 0 19.834711%;
}
:host ::ng-deep .flag-cu {
  background-position: 0 20.247934%;
}
:host ::ng-deep .flag-cv {
  background-position: 0 20.661157%;
}
:host ::ng-deep .flag-cx {
  background-position: 0 21.07438%;
}
:host ::ng-deep .flag-cy {
  background-position: 0 21.487603%;
}
:host ::ng-deep .flag-cz {
  background-position: 0 21.900826%;
}
:host ::ng-deep .flag-de {
  background-position: 0 22.31405%;
}
:host ::ng-deep .flag-dj {
  background-position: 0 22.727273%;
}
:host ::ng-deep .flag-dk {
  background-position: 0 23.140496%;
}
:host ::ng-deep .flag-dm {
  background-position: 0 23.553719%;
}
:host ::ng-deep .flag-do {
  background-position: 0 23.966942%;
}
:host ::ng-deep .flag-dz {
  background-position: 0 24.380165%;
}
:host ::ng-deep .flag-ec {
  background-position: 0 24.793388%;
}
:host ::ng-deep .flag-ee {
  background-position: 0 25.206612%;
}
:host ::ng-deep .flag-eg {
  background-position: 0 25.619835%;
}
:host ::ng-deep .flag-eh {
  background-position: 0 26.033058%;
}
:host ::ng-deep .flag-er {
  background-position: 0 26.446281%;
}
:host ::ng-deep .flag-es {
  background-position: 0 26.859504%;
}
:host ::ng-deep .flag-et {
  background-position: 0 27.272727%;
}
:host ::ng-deep .flag-fi {
  background-position: 0 27.68595%;
}
:host ::ng-deep .flag-fj {
  background-position: 0 28.099174%;
}
:host ::ng-deep .flag-fk {
  background-position: 0 28.512397%;
}
:host ::ng-deep .flag-fm {
  background-position: 0 28.92562%;
}
:host ::ng-deep .flag-fo {
  background-position: 0 29.338843%;
}
:host ::ng-deep .flag-fr {
  background-position: 0 29.752066%;
}
:host ::ng-deep .flag-ga {
  background-position: 0 30.165289%;
}
:host ::ng-deep .flag-gd {
  background-position: 0 30.578512%;
}
:host ::ng-deep .flag-ge {
  background-position: 0 30.991736%;
}
:host ::ng-deep .flag-gf {
  background-position: 0 31.404959%;
}
:host ::ng-deep .flag-gh {
  background-position: 0 31.818182%;
}
:host ::ng-deep .flag-gi {
  background-position: 0 32.231405%;
}
:host ::ng-deep .flag-gl {
  background-position: 0 32.644628%;
}
:host ::ng-deep .flag-gm {
  background-position: 0 33.057851%;
}
:host ::ng-deep .flag-gn {
  background-position: 0 33.471074%;
}
:host ::ng-deep .flag-gp {
  background-position: 0 33.884298%;
}
:host ::ng-deep .flag-gq {
  background-position: 0 34.297521%;
}
:host ::ng-deep .flag-gr {
  background-position: 0 34.710744%;
}
:host ::ng-deep .flag-gs {
  background-position: 0 35.123967%;
}
:host ::ng-deep .flag-gt {
  background-position: 0 35.53719%;
}
:host ::ng-deep .flag-gu {
  background-position: 0 35.950413%;
}
:host ::ng-deep .flag-gw {
  background-position: 0 36.363636%;
}
:host ::ng-deep .flag-gy {
  background-position: 0 36.77686%;
}
:host ::ng-deep .flag-hk {
  background-position: 0 37.190083%;
}
:host ::ng-deep .flag-hm {
  background-position: 0 37.603306%;
}
:host ::ng-deep .flag-hn {
  background-position: 0 38.016529%;
}
:host ::ng-deep .flag-hr {
  background-position: 0 38.429752%;
}
:host ::ng-deep .flag-ht {
  background-position: 0 38.842975%;
}
:host ::ng-deep .flag-hu {
  background-position: 0 39.256198%;
}
:host ::ng-deep .flag-id {
  background-position: 0 39.669421%;
}
:host ::ng-deep .flag-ie {
  background-position: 0 40.082645%;
}
:host ::ng-deep .flag-il {
  background-position: 0 40.495868%;
}
:host ::ng-deep .flag-in {
  background-position: 0 40.909091%;
}
:host ::ng-deep .flag-io {
  background-position: 0 41.322314%;
}
:host ::ng-deep .flag-iq {
  background-position: 0 41.735537%;
}
:host ::ng-deep .flag-ir {
  background-position: 0 42.14876%;
}
:host ::ng-deep .flag-is {
  background-position: 0 42.561983%;
}
:host ::ng-deep .flag-it {
  background-position: 0 42.975207%;
}
:host ::ng-deep .flag-jm {
  background-position: 0 43.38843%;
}
:host ::ng-deep .flag-jo {
  background-position: 0 43.801653%;
}
:host ::ng-deep .flag-jp {
  background-position: 0 44.214876%;
}
:host ::ng-deep .flag-ke {
  background-position: 0 44.628099%;
}
:host ::ng-deep .flag-kg {
  background-position: 0 45.041322%;
}
:host ::ng-deep .flag-kh {
  background-position: 0 45.454545%;
}
:host ::ng-deep .flag-ki {
  background-position: 0 45.867769%;
}
:host ::ng-deep .flag-km {
  background-position: 0 46.280992%;
}
:host ::ng-deep .flag-kn {
  background-position: 0 46.694215%;
}
:host ::ng-deep .flag-kp {
  background-position: 0 47.107438%;
}
:host ::ng-deep .flag-kr {
  background-position: 0 47.520661%;
}
:host ::ng-deep .flag-kw {
  background-position: 0 47.933884%;
}
:host ::ng-deep .flag-ky {
  background-position: 0 48.347107%;
}
:host ::ng-deep .flag-kz {
  background-position: 0 48.760331%;
}
:host ::ng-deep .flag-la {
  background-position: 0 49.173554%;
}
:host ::ng-deep .flag-lb {
  background-position: 0 49.586777%;
}
:host ::ng-deep .flag-lc {
  background-position: 0 50%;
}
:host ::ng-deep .flag-li {
  background-position: 0 50.413223%;
}
:host ::ng-deep .flag-lk {
  background-position: 0 50.826446%;
}
:host ::ng-deep .flag-lr {
  background-position: 0 51.239669%;
}
:host ::ng-deep .flag-ls {
  background-position: 0 51.652893%;
}
:host ::ng-deep .flag-lt {
  background-position: 0 52.066116%;
}
:host ::ng-deep .flag-lu {
  background-position: 0 52.479339%;
}
:host ::ng-deep .flag-lv {
  background-position: 0 52.892562%;
}
:host ::ng-deep .flag-ly {
  background-position: 0 53.305785%;
}
:host ::ng-deep .flag-ma {
  background-position: 0 53.719008%;
}
:host ::ng-deep .flag-mc {
  background-position: 0 54.132231%;
}
:host ::ng-deep .flag-md {
  background-position: 0 54.545455%;
}
:host ::ng-deep .flag-me {
  background-position: 0 54.958678%;
}
:host ::ng-deep .flag-mg {
  background-position: 0 55.371901%;
}
:host ::ng-deep .flag-mh {
  background-position: 0 55.785124%;
}
:host ::ng-deep .flag-mk {
  background-position: 0 56.198347%;
}
:host ::ng-deep .flag-ml {
  background-position: 0 56.61157%;
}
:host ::ng-deep .flag-mm {
  background-position: 0 57.024793%;
}
:host ::ng-deep .flag-mn {
  background-position: 0 57.438017%;
}
:host ::ng-deep .flag-mo {
  background-position: 0 57.85124%;
}
:host ::ng-deep .flag-mp {
  background-position: 0 58.264463%;
}
:host ::ng-deep .flag-mq {
  background-position: 0 58.677686%;
}
:host ::ng-deep .flag-mr {
  background-position: 0 59.090909%;
}
:host ::ng-deep .flag-ms {
  background-position: 0 59.504132%;
}
:host ::ng-deep .flag-mt {
  background-position: 0 59.917355%;
}
:host ::ng-deep .flag-mu {
  background-position: 0 60.330579%;
}
:host ::ng-deep .flag-mv {
  background-position: 0 60.743802%;
}
:host ::ng-deep .flag-mw {
  background-position: 0 61.157025%;
}
:host ::ng-deep .flag-mx {
  background-position: 0 61.570248%;
}
:host ::ng-deep .flag-my {
  background-position: 0 61.983471%;
}
:host ::ng-deep .flag-mz {
  background-position: 0 62.396694%;
}
:host ::ng-deep .flag-na {
  background-position: 0 62.809917%;
}
:host ::ng-deep .flag-nc {
  background-position: 0 63.22314%;
}
:host ::ng-deep .flag-ne {
  background-position: 0 63.636364%;
}
:host ::ng-deep .flag-nf {
  background-position: 0 64.049587%;
}
:host ::ng-deep .flag-ng {
  background-position: 0 64.46281%;
}
:host ::ng-deep .flag-ni {
  background-position: 0 64.876033%;
}
:host ::ng-deep .flag-nl {
  background-position: 0 65.289256%;
}
:host ::ng-deep .flag-no {
  background-position: 0 65.702479%;
}
:host ::ng-deep .flag-np {
  background-position: 0 66.115702%;
}
:host ::ng-deep .flag-nr {
  background-position: 0 66.528926%;
}
:host ::ng-deep .flag-nu {
  background-position: 0 66.942149%;
}
:host ::ng-deep .flag-nz {
  background-position: 0 67.355372%;
}
:host ::ng-deep .flag-om {
  background-position: 0 67.768595%;
}
:host ::ng-deep .flag-pa {
  background-position: 0 68.181818%;
}
:host ::ng-deep .flag-pe {
  background-position: 0 68.595041%;
}
:host ::ng-deep .flag-pf {
  background-position: 0 69.008264%;
}
:host ::ng-deep .flag-pg {
  background-position: 0 69.421488%;
}
:host ::ng-deep .flag-ph {
  background-position: 0 69.834711%;
}
:host ::ng-deep .flag-pk {
  background-position: 0 70.247934%;
}
:host ::ng-deep .flag-pl {
  background-position: 0 70.661157%;
}
:host ::ng-deep .flag-pm {
  background-position: 0 71.07438%;
}
:host ::ng-deep .flag-pn {
  background-position: 0 71.487603%;
}
:host ::ng-deep .flag-pr {
  background-position: 0 71.900826%;
}
:host ::ng-deep .flag-pt {
  background-position: 0 72.31405%;
}
:host ::ng-deep .flag-pw {
  background-position: 0 72.727273%;
}
:host ::ng-deep .flag-py {
  background-position: 0 73.140496%;
}
:host ::ng-deep .flag-qa {
  background-position: 0 73.553719%;
}
:host ::ng-deep .flag-re {
  background-position: 0 73.966942%;
}
:host ::ng-deep .flag-ro {
  background-position: 0 74.380165%;
}
:host ::ng-deep .flag-rs {
  background-position: 0 74.793388%;
}
:host ::ng-deep .flag-ru {
  background-position: 0 75.206612%;
}
:host ::ng-deep .flag-rw {
  background-position: 0 75.619835%;
}
:host ::ng-deep .flag-sa {
  background-position: 0 76.033058%;
}
:host ::ng-deep .flag-sb {
  background-position: 0 76.446281%;
}
:host ::ng-deep .flag-sc {
  background-position: 0 76.859504%;
}
:host ::ng-deep .flag-sd {
  background-position: 0 77.272727%;
}
:host ::ng-deep .flag-se {
  background-position: 0 77.68595%;
}
:host ::ng-deep .flag-sg {
  background-position: 0 78.099174%;
}
:host ::ng-deep .flag-sh {
  background-position: 0 78.512397%;
}
:host ::ng-deep .flag-si {
  background-position: 0 78.92562%;
}
:host ::ng-deep .flag-sj {
  background-position: 0 79.338843%;
}
:host ::ng-deep .flag-sk {
  background-position: 0 79.752066%;
}
:host ::ng-deep .flag-sl {
  background-position: 0 80.165289%;
}
:host ::ng-deep .flag-sm {
  background-position: 0 80.578512%;
}
:host ::ng-deep .flag-sn {
  background-position: 0 80.991736%;
}
:host ::ng-deep .flag-so {
  background-position: 0 81.404959%;
}
:host ::ng-deep .flag-sr {
  background-position: 0 81.818182%;
}
:host ::ng-deep .flag-ss {
  background-position: 0 82.231405%;
}
:host ::ng-deep .flag-st {
  background-position: 0 82.644628%;
}
:host ::ng-deep .flag-sv {
  background-position: 0 83.057851%;
}
:host ::ng-deep .flag-sy {
  background-position: 0 83.471074%;
}
:host ::ng-deep .flag-sz {
  background-position: 0 83.884298%;
}
:host ::ng-deep .flag-tc {
  background-position: 0 84.297521%;
}
:host ::ng-deep .flag-td {
  background-position: 0 84.710744%;
}
:host ::ng-deep .flag-tf {
  background-position: 0 85.123967%;
}
:host ::ng-deep .flag-tg {
  background-position: 0 85.53719%;
}
:host ::ng-deep .flag-th {
  background-position: 0 85.950413%;
}
:host ::ng-deep .flag-tj {
  background-position: 0 86.363636%;
}
:host ::ng-deep .flag-tk {
  background-position: 0 86.77686%;
}
:host ::ng-deep .flag-tl {
  background-position: 0 87.190083%;
}
:host ::ng-deep .flag-tm {
  background-position: 0 87.603306%;
}
:host ::ng-deep .flag-tn {
  background-position: 0 88.016529%;
}
:host ::ng-deep .flag-to {
  background-position: 0 88.429752%;
}
:host ::ng-deep .flag-tp {
  background-position: 0 88.842975%;
}
:host ::ng-deep .flag-tr {
  background-position: 0 89.256198%;
}
:host ::ng-deep .flag-tt {
  background-position: 0 89.669421%;
}
:host ::ng-deep .flag-tv {
  background-position: 0 90.082645%;
}
:host ::ng-deep .flag-tw {
  background-position: 0 90.495868%;
}
:host ::ng-deep .flag-ty {
  background-position: 0 90.909091%;
}
:host ::ng-deep .flag-tz {
  background-position: 0 91.322314%;
}
:host ::ng-deep .flag-ua {
  background-position: 0 91.735537%;
}
:host ::ng-deep .flag-ug {
  background-position: 0 92.14876%;
}
:host ::ng-deep .flag-gb, :host ::ng-deep .flag-uk {
  background-position: 0 92.561983%;
}
:host ::ng-deep .flag-um {
  background-position: 0 92.975207%;
}
:host ::ng-deep .flag-us {
  background-position: 0 93.38843%;
}
:host ::ng-deep .flag-uy {
  background-position: 0 93.801653%;
}
:host ::ng-deep .flag-uz {
  background-position: 0 94.214876%;
}
:host ::ng-deep .flag-va {
  background-position: 0 94.628099%;
}
:host ::ng-deep .flag-vc {
  background-position: 0 95.041322%;
}
:host ::ng-deep .flag-ve {
  background-position: 0 95.454545%;
}
:host ::ng-deep .flag-vg {
  background-position: 0 95.867769%;
}
:host ::ng-deep .flag-vi {
  background-position: 0 96.280992%;
}
:host ::ng-deep .flag-vn {
  background-position: 0 96.694215%;
}
:host ::ng-deep .flag-vu {
  background-position: 0 97.107438%;
}
:host ::ng-deep .flag-wf {
  background-position: 0 97.520661%;
}
:host ::ng-deep .flag-ws {
  background-position: 0 97.933884%;
}
:host ::ng-deep .flag-ye {
  background-position: 0 98.347107%;
}
:host ::ng-deep .flag-za {
  background-position: 0 98.760331%;
}
:host ::ng-deep .flag-zm {
  background-position: 0 99.173554%;
}
:host ::ng-deep .flag-zr {
  background-position: 0 99.586777%;
}
:host ::ng-deep .flag-zw {
  background-position: 0 100%;
}
@font-face {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: Roboto;
  font-style: normal;
  font-weight: 700;
}
:host ::ng-deep .card {
  background-color: var(--surface-card);
  margin-bottom: 2rem;
  border: 1px solid var(--surface-border);
  border-radius: var(--border-radius);
}
:host ::ng-deep .card:last-child {
  margin-bottom: 0;
}
:host ::ng-deep .ng-hidden {
  display: none !important;
}
:host ::ng-deep h1,
:host ::ng-deep h2,
:host ::ng-deep h3,
:host ::ng-deep h4,
:host ::ng-deep h5,
:host ::ng-deep h6 {
  font-weight: 400;
  color: var(--accent);
  margin: 0 0 8px;
}
:host ::ng-deep h1, :host ::ng-deep .h1 {
  font-size: 2.55em;
  line-height: 1.2;
  color: var(--accent);
  font-weight: 700;
  text-shadow: 0 3px 8px rgba(0, 0, 0, 0.0901960784);
}
:host ::ng-deep h2, :host ::ng-deep .h2 {
  font-size: 2em;
  line-height: 1.2;
  color: var(--accent);
}
:host ::ng-deep h3, :host ::ng-deep .h3 {
  font-size: 1.5em;
  line-height: 1.2;
}
:host ::ng-deep h5, :host ::ng-deep .h5 {
  font-size: 1em;
  line-height: 1.2;
}
:host ::ng-deep h6, :host ::ng-deep .h6 {
  font-size: 0.825em;
  line-height: 1.2;
}
:host ::ng-deep h1:first-child, :host ::ng-deep h2:first-child, :host ::ng-deep h3:first-child, :host ::ng-deep h4:first-child, :host ::ng-deep h5:first-child, :host ::ng-deep h6:first-child {
  margin-top: 0;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep h1, :host ::ng-deep .h1 {
    font-size: 2.4em;
    line-height: 1.22;
    color: var(--accent);
    font-weight: 700;
    text-shadow: 0 3px 8px rgba(0, 0, 0, 0.0901960784);
  }
  :host ::ng-deep h2, :host ::ng-deep .h2 {
    font-size: 1.95em;
    line-height: 1.22;
    color: var(--accent);
  }
  :host ::ng-deep h3, :host ::ng-deep .h3 {
    font-size: 1.4em;
    line-height: 1.22;
  }
  :host ::ng-deep h4, :host ::ng-deep .h4 {
    font-size: 1.35em;
    line-height: 1.22;
  }
  :host ::ng-deep h5, :host ::ng-deep .h5 {
    font-size: 1.1em;
    line-height: 1.22;
  }
  :host ::ng-deep h6, :host ::ng-deep .h6 {
    font-size: 0.825em;
    line-height: 1.22;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep h1, :host ::ng-deep .h1 {
    font-size: 2.65em;
    line-height: 1.23;
    color: var(--accent);
    font-weight: 700;
    text-shadow: 0 3px 8px rgba(0, 0, 0, 0.0901960784);
  }
  :host ::ng-deep h2, :host ::ng-deep .h2 {
    font-size: 2.15em;
    line-height: 1.3;
    color: var(--accent);
  }
  :host ::ng-deep h3, :host ::ng-deep .h3 {
    font-size: 1.65em;
    line-height: 1.23;
  }
  :host ::ng-deep h4, :host ::ng-deep .h4 {
    font-size: 1.4em;
    line-height: 1.23;
  }
  :host ::ng-deep h5, :host ::ng-deep .h5 {
    font-size: 1.15em;
    line-height: 1.23;
  }
  :host ::ng-deep h6, :host ::ng-deep .h6 {
    font-size: 0.825em;
    line-height: 1.23;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep h1, :host ::ng-deep .h1 {
    font-size: 2.7em;
    line-height: 1.24;
    color: var(--accent);
    font-weight: 700;
    text-shadow: 0 3px 8px rgba(0, 0, 0, 0.0901960784);
  }
  :host ::ng-deep h2, :host ::ng-deep .h2 {
    font-size: 2.2em;
    line-height: 1.24;
    color: var(--accent);
  }
  :host ::ng-deep h3, :host ::ng-deep .h3 {
    font-size: 1.7em;
    line-height: 1.24;
  }
  :host ::ng-deep h4, :host ::ng-deep .h4 {
    font-size: 1.45em;
    line-height: 1.24;
  }
  :host ::ng-deep h5, :host ::ng-deep .h5 {
    font-size: 1.2em;
    line-height: 1.24;
  }
  :host ::ng-deep h6, :host ::ng-deep .h6 {
    font-size: 0.85em;
    line-height: 1.24;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep h1, :host ::ng-deep .h1 {
    font-size: 2.75em;
    line-height: 1.25;
    color: var(--accent);
    font-weight: 700;
    text-shadow: 0 3px 8px rgba(0, 0, 0, 0.0901960784);
  }
  :host ::ng-deep h2, :host ::ng-deep .h2 {
    font-size: 2.25em;
    line-height: 1.25;
    color: var(--accent);
  }
  :host ::ng-deep h3, :host ::ng-deep .h3 {
    font-size: 1.75em;
    line-height: 1.25;
  }
  :host ::ng-deep h4, :host ::ng-deep .h4 {
    font-size: 1.5em;
    line-height: 1.25;
  }
  :host ::ng-deep h5, :host ::ng-deep .h5 {
    font-size: 1.25em;
    line-height: 1.25;
  }
  :host ::ng-deep h6, :host ::ng-deep .h6 {
    font-size: 0.875em;
    line-height: 1.25;
  }
}
:host ::ng-deep mark {
  background: #FFF8E1;
  padding: 0.25rem 0.4rem;
  border-radius: var(--border-radius);
  font-family: monospace;
}
:host ::ng-deep blockquote {
  margin: 1rem 0;
  padding: 0 2rem;
  border-left: 4px solid #90A4AE;
}
:host ::ng-deep hr {
  border-top: solid var(--surface-border);
  border-width: 1px 0 0 0;
  margin: 1rem 0;
}
:host ::ng-deep p {
  margin: 0 0 1rem;
  line-height: 1.5;
}
:host ::ng-deep p:last-child {
  margin-bottom: 0;
}
@keyframes px-mask-in {
  0% {
    background-color: transparent;
  }
  to {
    background-color: var(--maskbg);
  }
}
@keyframes px-scalein {
  0% {
    opacity: 0;
    transform: scaleY(0.8);
  }
  to {
    opacity: 1;
    transform: scaleY(1);
  }
}
@keyframes px-fadein {
  0% {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes px-fadeout {
  0% {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
:host ::ng-deep .px-scalein {
  animation: px-scalein 0.12s cubic-bezier(0, 0, 0.2, 1);
}
:host ::ng-deep .px-fadein {
  animation: px-fadein 0.15s linear;
}
:host ::ng-deep .px-fadeout {
  animation: px-fadeout 0.15s linear;
}
:host ::ng-deep .layout-topbar-dark {
  --topbar-bg: #2a323d;
  --topbar-menu-button-bg: #ffffff;
  --topbar-menu-button-text-color: #212529;
  --topbar-item-text-color: #ffffff ;
}
:host ::ng-deep .layout-topbar-light {
  --topbar-bg: #ffffff;
  --topbar-menu-button-bg: var(--primary-color);
  --topbar-menu-button-text-color: #ffffff;
  --topbar-item-text-color: #212529 ;
}
:host ::ng-deep .layout-topbar-blue {
  --topbar-bg: #0d6efd;
  --topbar-menu-button-bg: #ffffff;
  --topbar-menu-button-text-color: #0d6efd;
  --topbar-item-text-color: #ffffff ;
}
:host ::ng-deep .layout-topbar-purple {
  --topbar-bg: #6f42c1;
  --topbar-menu-button-bg: #ffffff;
  --topbar-menu-button-text-color: #6f42c1;
  --topbar-item-text-color: #ffffff ;
}
:host ::ng-deep .layout-topbar-pink {
  --topbar-bg: #d63384;
  --topbar-menu-button-bg: #ffffff;
  --topbar-menu-button-text-color: #d63384;
  --topbar-item-text-color: #ffffff ;
}
:host ::ng-deep .layout-topbar-cyan {
  --topbar-bg: #0dcaf0;
  --topbar-menu-button-bg: #ffffff;
  --topbar-menu-button-text-color: #0dcaf0;
  --topbar-item-text-color: #ffffff ;
}
:host ::ng-deep .layout-topbar-teal {
  --topbar-bg: #20c997;
  --topbar-menu-button-bg: #212529;
  --topbar-menu-button-text-color: #20c997;
  --topbar-item-text-color: #212529 ;
}
:host ::ng-deep .layout-topbar-green {
  --topbar-bg: #198754;
  --topbar-menu-button-bg: #ffffff;
  --topbar-menu-button-text-color: #198754;
  --topbar-item-text-color: #ffffff ;
}
:host ::ng-deep .layout-topbar-yellow {
  --topbar-bg: #ffc107;
  --topbar-menu-button-bg: #212529;
  --topbar-menu-button-text-color: #ffc107;
  --topbar-item-text-color: #212529 ;
}
:host ::ng-deep .layout-topbar-orange {
  --topbar-bg: #fd7e14;
  --topbar-menu-button-bg: #212529;
  --topbar-menu-button-text-color: #fd7e14;
  --topbar-item-text-color: #212529 ;
}
:host ::ng-deep .layout-topbar-indigo {
  --topbar-bg: #6610f2;
  --topbar-menu-button-bg: #ffffff;
  --topbar-menu-button-text-color: #6610f2;
  --topbar-item-text-color: #ffffff ;
}
:host ::ng-deep .layout-topbar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 4rem;
  transition: width var(--transition-duration);
  display: flex;
  color: var(--topbar-item-text-color);
  background-color: var(--topbar-bg);
  border-bottom: 1px solid var(--surface-border);
}
:host ::ng-deep .layout-topbar ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
:host ::ng-deep .layout-topbar .layout-topbar-start {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 1rem;
  position: relative;
  width: 17rem;
}
:host ::ng-deep .layout-topbar .layout-topbar-start .layout-topbar-logo {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
:host ::ng-deep .layout-topbar .layout-topbar-start .layout-topbar-logo img {
  height: 2.5rem;
}
:host ::ng-deep .layout-topbar .layout-topbar-start .layout-topbar-logo .layout-topbar-logo-slim {
  display: none;
}
:host ::ng-deep .layout-topbar .layout-topbar-start .layout-menu-button {
  position: absolute;
  top: 50%;
  margin-top: -1.25rem;
  right: -1.25rem;
  width: 2.5rem;
  height: 2.5rem;
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: var(--border-radius);
  color: var(--topbar-menu-button-text-color);
  background-color: var(--topbar-menu-button-bg);
  transition: background-color var(--transition-duration);
  cursor: pointer;
}
:host ::ng-deep .layout-topbar .layout-topbar-start .layout-menu-button i {
  font-size: 2rem;
  transition: transform var(--transition-duration);
}
:host ::ng-deep .layout-topbar .layout-topbar-start .layout-topbar-mobile-button {
  display: none;
  border-radius: 50%;
  width: 2.5rem;
  height: 2.5rem;
  cursor: pointer;
}
:host ::ng-deep .layout-topbar .layout-topbar-end {
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: flex-end;
  padding: 0 2rem;
}
:host ::ng-deep .layout-topbar .layout-topbar-end .layout-megamenu {
  background: none;
}
:host ::ng-deep .layout-topbar .layout-topbar-end .layout-megamenu.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link .p-menuitem-text, :host ::ng-deep .layout-topbar .layout-topbar-end .layout-megamenu.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link .p-menuitem-icon, :host ::ng-deep .layout-topbar .layout-topbar-end .layout-megamenu.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link .p-submenu-icon {
  color: var(--topbar-item-text-color);
}
:host ::ng-deep .layout-topbar .layout-topbar-end .layout-megamenu.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover {
  background: var(--topbar-item-hover-bg);
  transition: background-color var(--transition-duration);
}
:host ::ng-deep .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}
:host ::ng-deep .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li {
  position: relative;
}
:host ::ng-deep .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li > a {
  width: 2.5rem;
  height: 2.5rem;
  -webkit-user-select: none;
  user-select: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--topbar-item-text-color);
}
:host ::ng-deep .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li > a i {
  font-size: 1.25rem;
}
:host ::ng-deep .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li > a:hover {
  background-color: var(--topbar-item-hover-bg);
  transition: background-color var(--transition-duration);
}
:host ::ng-deep .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li > div {
  position: absolute;
  top: 3.5rem;
  right: 0;
  min-width: 18rem;
  padding: 0.5rem 0;
  transform-origin: top;
  background: var(--surface-overlay);
  color: var(--text-color);
  border-top: 4px solid var(--topbar-bg);
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.1411764706), 0 3px 14px 2px rgba(0, 0, 0, 0.1215686275);
}
:host ::ng-deep .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search {
  position: relative;
  display: flex;
  align-items: center;
}
:host ::ng-deep .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search input {
  padding: 0.65rem 2.5rem 0.65rem 1rem;
  color: var(--topbar-item-text-color);
  background-color: rgba(255, 255, 255, 0.2);
  border: 1px solid var(--topbar-item-text-color);
  border-radius: 1.5rem;
  width: 14rem;
  font-size: 1rem;
  transition: var(--transition-duration);
}
:host ::ng-deep .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search input::placeholder {
  color: var(--topbar-item-text-color);
}
:host ::ng-deep .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search input:focus {
  outline: 0 none;
  border: 1px solid var(--topbar-item-text-color);
}
:host ::ng-deep .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search > i {
  color: var(--topbar-item-text-color);
  position: absolute;
  right: 0.75rem;
  font-size: 1.25rem;
}
:host ::ng-deep .layout-menu-light {
  --menu-bg: #ffffff;
  --root-menuitem-text-color: #657380;
  --menuitem-text-color: #515C66;
  --menuitem-hover-bg: rgba(0,0,0,.04);
  --active-menuitem-text-color: var(--primary-500);
  --active-menuitem-bg: var(--primary-50);
  --inline-menu-border-color: #e4e4e4 ;
}
:host ::ng-deep .layout-menu-dark {
  --menu-bg: #2a323d;
  --root-menuitem-text-color: rgba(255,255,255,.6);
  --menuitem-text-color: rgba(255,255,255,.87);
  --menuitem-hover-bg: hsla(0,0%,100%,.04);
  --active-menuitem-text-color: rgba(255,255,255,.87);
  --active-menuitem-bg: hsla(0,0%,100%,.04);
  --inline-menu-border-color: hsla(0,0%,100%,.12) ;
}
:host ::ng-deep .layout-sidebar {
  position: fixed;
  height: calc(100% - 4rem);
  top: 4rem;
  left: 0;
  width: 17rem;
  background: var(--menu-bg);
  border-right: 1px solid var(--surface-border);
  display: flex;
  flex-direction: column;
}
:host ::ng-deep .layout-sidebar .layout-sidebar-top {
  display: none;
}
:host ::ng-deep .layout-sidebar .layout-menu-container {
  flex: 1;
  padding-bottom: 2rem;
  overflow: auto;
}
:host ::ng-deep .layout-sidebar .layout-menu {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
:host ::ng-deep .layout-sidebar .layout-menu .layout-root-menuitem > .layout-menuitem-root-text {
  display: flex;
  align-items: center;
  font-size: 0.857rem;
  text-transform: uppercase;
  font-weight: 700;
  color: var(--root-menuitem-text-color);
  padding: 1rem 1.5rem 1rem 1rem;
}
:host ::ng-deep .layout-sidebar .layout-menu .layout-root-menuitem > .layout-menuitem-root-text > .layout-menuitem-root-icon {
  display: none;
}
:host ::ng-deep .layout-sidebar .layout-menu .layout-root-menuitem > a {
  display: none;
}
:host ::ng-deep .layout-sidebar .layout-menu a {
  -webkit-user-select: none;
  user-select: none;
}
:host ::ng-deep .layout-sidebar .layout-menu li.active-menuitem > a {
  color: var(--active-menuitem-text-color);
  background-color: var(--active-menuitem-bg);
}
:host ::ng-deep .layout-sidebar .layout-menu li.active-menuitem > a .layout-menuitem-icon {
  margin-right: 0.5rem;
  color: var(--active-menuitem-text-color);
}
:host ::ng-deep .layout-sidebar .layout-menu li.active-menuitem > a .layout-submenu-toggler {
  transform: rotate(-180deg);
}
:host ::ng-deep .layout-sidebar .layout-menu ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
:host ::ng-deep .layout-sidebar .layout-menu ul a {
  display: flex;
  align-items: center;
  position: relative;
  outline: 0 none;
  color: var(--menuitem-text-color);
  cursor: pointer;
  padding: 0.75rem 1.5rem;
  transition: background-color var(--transition-duration), box-shadow var(--transition-duration);
}
:host ::ng-deep .layout-sidebar .layout-menu ul a .layout-menuitem-icon {
  margin-right: 0.5rem;
  color: var(--menuitem-text-color);
}
:host ::ng-deep .layout-sidebar .layout-menu ul a .layout-submenu-toggler {
  font-size: 75%;
  margin-left: auto;
  transition: transform var(--transition-duration);
}
:host ::ng-deep .layout-sidebar .layout-menu ul a.active-route {
  font-weight: 700;
}
:host ::ng-deep .layout-sidebar .layout-menu ul a:hover {
  background-color: var(--menuitem-hover-bg);
}
:host ::ng-deep .layout-sidebar .layout-menu ul ul {
  overflow: hidden;
  border-radius: var(--border-radius);
}
:host ::ng-deep .layout-sidebar .layout-menu ul ul li a {
  padding-left: 2.5rem;
}
:host ::ng-deep .layout-sidebar .layout-menu ul ul li li a {
  padding-left: 3rem;
}
:host ::ng-deep .layout-sidebar .layout-menu ul ul li li li a {
  padding-left: 3.5rem;
}
:host ::ng-deep .layout-sidebar .layout-menu ul ul li li li li a {
  padding-left: 4rem;
}
:host ::ng-deep .layout-sidebar .layout-menu ul ul li li li li li a {
  padding-left: 5.5rem;
}
:host ::ng-deep .layout-sidebar .layout-menu ul ul li li li li li li a {
  padding-left: 5rem;
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .layout-container.layout-slim .layout-sidebar {
    width: 5rem;
    overflow: visible;
    z-index: 998;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-sidebar .layout-menu-container {
    overflow: auto;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-sidebar .layout-menu-container::-webkit-scrollbar {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-topbar .layout-topbar-start {
    width: 5rem;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-topbar .layout-topbar-start .layout-topbar-logo .layout-topbar-logo-full {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-topbar .layout-topbar-start .layout-topbar-logo .layout-topbar-logo-slim {
    display: block;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-topbar .layout-topbar-start .layout-menu-button {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-content-wrapper {
    margin-left: 5rem;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu {
    padding: 1rem 0;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu .layout-root-menuitem {
    margin: 0.75rem 0;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu .layout-root-menuitem:first-child {
    margin-top: 0;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu .layout-root-menuitem:last-child {
    margin-top: 0;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu .layout-root-menuitem > .layout-menuitem-root-text {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu .layout-root-menuitem > a {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;
    outline: none;
    transition: background-color var(--transition-duration);
    width: 3rem;
    height: 3rem;
    margin: 0 auto;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu .layout-root-menuitem > a .layout-submenu-toggler {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu .layout-root-menuitem > a .layout-menuitem-icon {
    font-size: 1.5rem;
    color: var(--menuitem-text-color);
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu .layout-root-menuitem > a .layout-menuitem-text {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu .layout-root-menuitem > a:hover {
    background-color: var(--menuitem-hover-bg);
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul {
    position: absolute;
    left: 5rem;
    top: 0;
    min-width: 15rem;
    background-color: var(--menu-bg);
    border-radius: var(--border-radius);
    padding: 0.5rem 0;
    max-height: 20rem;
    overflow: auto;
    z-index: 999;
    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.1411764706), 0 3px 14px 2px rgba(0, 0, 0, 0.1215686275);
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul::-webkit-scrollbar {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul a {
    padding-right: 0.5rem;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul li a {
    padding-left: 0.5rem;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul li li a {
    padding-left: 1rem;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul li li li a {
    padding-left: 1.5rem;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul li li li li a {
    padding-left: 2rem;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul li li li li li a {
    padding-left: 2.5rem;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul li li li li li li a {
    padding-left: 3rem;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu-profile {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu-profile > button {
    width: 3rem;
    height: 3rem;
    padding: 0;
    border-radius: 50%;
    justify-content: center;
    margin: 0.75rem 0;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu-profile > button span, :host ::ng-deep .layout-container.layout-slim .layout-menu-profile > button i {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu-profile > ul > li {
    margin: 0.75rem 0;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu-profile > ul > li:first-child {
    margin-top: 0;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu-profile > ul > li > button {
    width: 3rem;
    height: 3rem;
    padding: 0;
    justify-content: center;
    border-radius: 50%;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu-profile > ul > li > button > i {
    font-size: 1.5rem;
    margin-right: 0;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu-profile > ul > li > button > span {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-slim .layout-menu-profile > ul > li:last-child {
    margin-bottom: 1rem;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .layout-container.layout-slim-plus .layout-sidebar {
    width: 7rem;
    overflow: visible;
    z-index: 998;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-sidebar .layout-menu-container {
    overflow: auto;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-sidebar .layout-menu-container::-webkit-scrollbar {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-topbar .layout-topbar-start {
    width: 7rem;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-topbar .layout-topbar-start .layout-topbar-logo .layout-topbar-logo-full {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-topbar .layout-topbar-start .layout-topbar-logo .layout-topbar-logo-slim {
    display: block;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-topbar .layout-topbar-start .layout-menu-button {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-content-wrapper {
    margin-left: 7rem;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu {
    padding: 1rem 0;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu ul {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu li.active-menuitem > ul {
    display: block;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem {
    margin: 0.75rem 0;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem:first-child {
    margin-top: 0;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem:last-child {
    margin-top: 0;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > .layout-menuitem-root-text {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > a {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: var(--border-radius);
    cursor: pointer;
    outline: none;
    transition: background-color var(--transition-duration);
    width: auto;
    height: auto;
    margin: 0 auto 1rem;
    padding: 0.75rem 0;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > a .layout-submenu-toggler {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > a .layout-menuitem-icon {
    font-size: 1.5rem;
    color: var(--menuitem-text-color);
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > a .layout-menuitem-text {
    font-size: 0.875rem;
    display: block;
    margin-top: 0.25rem;
    color: var(--menuitem-text-color);
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > a:hover {
    background-color: var(--menuitem-hover-bg);
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul {
    position: absolute;
    left: 7rem;
    top: 0;
    min-width: 15rem;
    background-color: var(--menu-bg);
    border-radius: var(--border-radius);
    padding: 0.5rem 0;
    max-height: 20rem;
    overflow: auto;
    z-index: 999;
    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.1411764706), 0 3px 14px 2px rgba(0, 0, 0, 0.1215686275);
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul::-webkit-scrollbar {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul a {
    padding-right: 0.5rem;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul li a {
    padding-left: 0.5rem;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul li li a {
    padding-left: 1rem;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul li li li a {
    padding-left: 1.5rem;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul li li li li a {
    padding-left: 2rem;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul li li li li li a {
    padding-left: 2.5rem;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul li li li li li li a {
    padding-left: 3rem;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu-profile {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu-profile > button {
    width: 3rem;
    height: 3rem;
    padding: 0;
    border-radius: 50%;
    justify-content: center;
    margin: 0.75rem 0;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu-profile > button span, :host ::ng-deep .layout-container.layout-slim-plus .layout-menu-profile > button i {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu-profile > ul > li {
    margin: 0.75rem 0;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu-profile > ul > li:first-child {
    margin-top: 0;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu-profile > ul > li > button {
    width: 3rem;
    height: 3rem;
    padding: 0;
    justify-content: center;
    border-radius: 50%;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu-profile > ul > li > button > i {
    font-size: 1.5rem;
    margin-right: 0;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu-profile > ul > li > button > span {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-slim-plus .layout-menu-profile > ul > li:last-child {
    margin-bottom: 1rem;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .layout-container.layout-horizontal .layout-sidebar {
    width: 100%;
    height: 3rem;
    top: 4rem;
    position: fixed;
    z-index: 998;
    overflow: visible;
    flex-direction: row;
    padding: 0 2rem;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-sidebar .layout-menu-container {
    overflow: auto;
    padding-bottom: 0;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-sidebar .layout-menu-container::-webkit-scrollbar {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-topbar .layout-topbar-start .layout-menu-button {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-content-wrapper {
    padding-top: 7rem;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: center;
    height: 100%;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu ul {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu .layout-root-menuitem {
    border-radius: var(--border-radius);
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > .layout-menuitem-root-text {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > a {
    display: flex;
    align-items: center;
    padding: 0.75rem;
    border-radius: 0;
    cursor: pointer;
    outline: none;
    color: var(--menuitem-text-color);
    transition: background-color var(--transition-duration);
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > a .layout-submenu-toggler {
    display: block;
    margin-left: auto;
    transition: transform 0.2s;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > a .layout-menuitem-icon {
    font-size: 1.25rem;
    color: var(--menuitem-text-color);
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > a .layout-menuitem-text {
    font-size: 0.875rem;
    display: block;
    margin-left: 0.75rem;
    margin-right: 0.75rem;
    white-space: nowrap;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > a:hover {
    background-color: var(--menuitem-hover-bg);
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul {
    position: absolute;
    left: auto;
    top: 3rem;
    min-width: 15rem;
    background-color: var(--menu-bg);
    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.1411764706), 0 3px 14px 2px rgba(0, 0, 0, 0.1215686275);
    padding: 0.5rem 0;
    border-radius: var(--border-radius);
    max-height: 20rem;
    overflow: auto;
    z-index: 999;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul::-webkit-scrollbar {
    display: none;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul a {
    padding-right: 0.5rem;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul li a {
    padding-left: 0.5rem;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul li li a {
    padding-left: 1rem;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul li li li a {
    padding-left: 1.5rem;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul li li li li a {
    padding-left: 2rem;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul li li li li li a {
    padding-left: 2.5rem;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul li li li li li li a {
    padding-left: 3rem;
  }
  :host ::ng-deep .layout-container.layout-horizontal.layout-menu-profile-start .layout-menu-profile {
    border-bottom: 0 none;
  }
  :host ::ng-deep .layout-container.layout-horizontal.layout-menu-profile-start .layout-menu-profile > ul {
    left: 0;
  }
  :host ::ng-deep .layout-container.layout-horizontal.layout-menu-profile-end .layout-menu-profile {
    border-top: 0 none;
  }
  :host ::ng-deep .layout-container.layout-horizontal.layout-menu-profile-end .layout-menu-profile > ul {
    right: 0;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu-profile {
    position: relative;
    overflow: visible;
    width: auto;
    height: 100%;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu-profile > button {
    padding: 0 0.75rem;
    width: auto;
    height: 100%;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu-profile > button .layout-menu-profile-toggler {
    margin-left: 0.5rem;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu-profile > ul {
    position: absolute;
    top: 3rem;
    min-width: 15rem;
    background-color: var(--menu-bg);
    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.1411764706), 0 3px 14px 2px rgba(0, 0, 0, 0.1215686275);
    padding: 1rem;
    border-radius: var(--border-radius);
    max-height: 20rem;
    overflow: auto;
    z-index: 999;
    transform-origin: center top;
  }
  :host ::ng-deep .layout-container.layout-horizontal .layout-menu-profile > ul > li > button {
    padding: 0.75rem 0.5rem;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .layout-reveal .layout-sidebar {
    height: 100%;
    top: 0;
    transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1);
    transform: translate(-12.75rem);
    z-index: 999;
  }
  :host ::ng-deep .layout-reveal .layout-sidebar .layout-sidebar-top {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 0.75rem;
    height: 4rem;
    background-color: var(--topbar-bg);
    color: var(--topbar-item-text-color);
  }
  :host ::ng-deep .layout-reveal .layout-sidebar .layout-sidebar-top .layout-sidebar-logo {
    display: none;
  }
  :host ::ng-deep .layout-reveal .layout-sidebar .layout-sidebar-top .layout-sidebar-logo-slim {
    display: inline;
  }
  :host ::ng-deep .layout-reveal .layout-sidebar .layout-sidebar-top .layout-sidebar-anchor {
    display: none;
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 50%;
    border: 2px solid var(--topbar-menu-button-bg);
    background-color: transparent;
    transition: background-color var(--transition-duration), transform 0.3s;
  }
  :host ::ng-deep .layout-reveal .layout-sidebar .layout-menu-container {
    overflow: hidden;
  }
  :host ::ng-deep .layout-reveal .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem > .layout-menuitem-root-text > span {
    margin-right: auto;
  }
  :host ::ng-deep .layout-reveal .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem > .layout-menuitem-root-text > .layout-menuitem-root-icon {
    display: block;
    margin-right: 0.125rem;
  }
  :host ::ng-deep .layout-reveal .layout-sidebar .layout-menu-container .layout-menu ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
  :host ::ng-deep .layout-reveal .layout-sidebar .layout-menu-container .layout-menu ul a .layout-menuitem-text {
    order: 1;
    margin-right: auto;
  }
  :host ::ng-deep .layout-reveal .layout-sidebar .layout-menu-container .layout-menu ul a .layout-submenu-toggler {
    order: 2;
    display: none;
    margin-right: 0.5rem;
  }
  :host ::ng-deep .layout-reveal .layout-sidebar .layout-menu-container .layout-menu ul a .layout-menuitem-icon {
    order: 3;
    margin-right: 0;
    font-size: 1.25rem;
    width: auto;
  }
  :host ::ng-deep .layout-reveal .layout-sidebar .layout-menu-profile > ul > li > button {
    flex-direction: row-reverse;
  }
  :host ::ng-deep .layout-reveal .layout-sidebar .layout-menu-profile > ul > li > button > i {
    margin-right: 0;
    margin-left: auto;
    font-size: 1.25rem;
    width: auto;
  }
  :host ::ng-deep .layout-reveal .layout-topbar {
    padding-left: 4.25rem;
  }
  :host ::ng-deep .layout-reveal .layout-topbar .layout-topbar-start {
    display: none;
  }
  :host ::ng-deep .layout-reveal.layout-reveal .layout-content-wrapper {
    margin-left: 4.25rem;
    transition: margin-left 0.3s cubic-bezier(0, 0, 0.2, 1);
  }
  :host ::ng-deep .layout-reveal.layout-sidebar-active .layout-sidebar {
    transform: translate(0);
  }
  :host ::ng-deep .layout-reveal.layout-sidebar-active .layout-sidebar .layout-sidebar-top {
    padding: 0 1.5rem;
    justify-content: space-between;
  }
  :host ::ng-deep .layout-reveal.layout-sidebar-active .layout-sidebar .layout-sidebar-top .layout-sidebar-logo {
    display: inline;
  }
  :host ::ng-deep .layout-reveal.layout-sidebar-active .layout-sidebar .layout-sidebar-top .layout-sidebar-logo-slim {
    display: none;
  }
  :host ::ng-deep .layout-reveal.layout-sidebar-active .layout-sidebar .layout-sidebar-top .layout-sidebar-anchor {
    display: block;
    animation: px-fadein 0.15s linear;
  }
  :host ::ng-deep .layout-reveal.layout-sidebar-active .layout-sidebar .layout-menu-container {
    overflow: auto;
  }
  :host ::ng-deep .layout-reveal.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem > .layout-menuitem-root-text > .layout-menuitem-root-icon {
    display: none;
  }
  :host ::ng-deep .layout-reveal.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul a .layout-submenu-toggler {
    display: block;
  }
  :host ::ng-deep .layout-reveal.layout-sidebar-anchored .layout-topbar {
    padding-left: 17rem;
  }
  :host ::ng-deep .layout-reveal.layout-sidebar-anchored .layout-sidebar-top .layout-sidebar-anchor {
    background-color: var(--topbar-menu-button-bg);
  }
  :host ::ng-deep .layout-reveal.layout-sidebar-anchored .layout-content-wrapper {
    margin-left: 17rem;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .layout-drawer .layout-sidebar {
    height: 100%;
    top: 0;
    transition: width 0.3s cubic-bezier(0, 0, 0.2, 1);
    width: 4.25rem;
    z-index: 999;
  }
  :host ::ng-deep .layout-drawer .layout-sidebar .layout-sidebar-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.75rem;
    height: 4rem;
    background-color: var(--topbar-bg);
    color: var(--topbar-item-text-color);
  }
  :host ::ng-deep .layout-drawer .layout-sidebar .layout-sidebar-top .layout-sidebar-logo {
    display: none;
    width: 0;
    transition: width 0.2s cubic-bezier(0, 0, 0.2, 1);
    transition-delay: 0.3s;
  }
  :host ::ng-deep .layout-drawer .layout-sidebar .layout-sidebar-top .layout-sidebar-logo-slim {
    display: inline;
    order: 1;
  }
  :host ::ng-deep .layout-drawer .layout-sidebar .layout-sidebar-top .layout-sidebar-anchor {
    display: none;
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 50%;
    border: 2px solid var(--topbar-menu-button-bg);
    background-color: transparent;
    transition: background-color var(--transition-duration), transform 0.3s;
  }
  :host ::ng-deep .layout-drawer .layout-sidebar .layout-menu-container {
    overflow: hidden;
  }
  :host ::ng-deep .layout-drawer .layout-sidebar .layout-menu-container .layout-menu {
    transition: all 0.4s;
  }
  :host ::ng-deep .layout-drawer .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem > .layout-menuitem-root-text {
    opacity: 1;
    white-space: nowrap;
    display: flex;
    justify-content: flex-end;
    height: 2.92rem;
  }
  :host ::ng-deep .layout-drawer .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem > .layout-menuitem-root-text > span {
    margin-right: auto;
    opacity: 0;
    transition: all 0.1s;
  }
  :host ::ng-deep .layout-drawer .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem > .layout-menuitem-root-text .layout-menuitem-icon {
    font-size: 1.25rem;
    width: 1.25rem;
  }
  :host ::ng-deep .layout-drawer .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem > .layout-menuitem-root-text > .layout-menuitem-root-icon {
    display: block;
    margin-left: 0.125rem;
    font-size: 1.25rem;
  }
  :host ::ng-deep .layout-drawer .layout-sidebar .layout-menu-container .layout-menu ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
  :host ::ng-deep .layout-drawer .layout-sidebar .layout-menu-container .layout-menu ul a span {
    opacity: 0;
    white-space: nowrap;
    transition: all 0.1s;
  }
  :host ::ng-deep .layout-drawer .layout-sidebar .layout-menu-container .layout-menu ul a .layout-menuitem-icon {
    font-size: 1.25rem;
    width: auto;
  }
  :host ::ng-deep .layout-drawer .layout-sidebar .layout-menu-container .layout-menu ul a .layout-submenu-toggler {
    display: none;
  }
  :host ::ng-deep .layout-drawer .layout-sidebar .layout-menu-container .layout-menu ul ul li a {
    padding: 0.75rem 1.5rem;
  }
  :host ::ng-deep .layout-drawer .layout-sidebar .layout-menu-profile > button {
    padding: 0.75rem 1rem;
  }
  :host ::ng-deep .layout-drawer .layout-sidebar .layout-menu-profile > button span {
    opacity: 0;
    white-space: nowrap;
    transition: all 0.1s;
  }
  :host ::ng-deep .layout-drawer .layout-sidebar .layout-menu-profile > ul > li > button > i {
    margin-right: 0.5rem;
    font-size: 1.25rem;
    width: auto;
  }
  :host ::ng-deep .layout-drawer .layout-topbar {
    padding-left: 4.25rem;
  }
  :host ::ng-deep .layout-drawer .layout-topbar .layout-topbar-start {
    display: none;
  }
  :host ::ng-deep .layout-drawer.layout-drawer .layout-content-wrapper {
    margin-left: 4.25rem;
    transition: margin-left 0.3s cubic-bezier(0, 0, 0.2, 1);
    overflow-x: hidden;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-active .layout-sidebar {
    width: 17rem;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-active .layout-sidebar .layout-sidebar-top {
    padding: 0 1.5rem;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-active .layout-sidebar .layout-sidebar-top .layout-sidebar-logo {
    display: inline;
    width: 100%;
    transition: width 0.2s cubic-bezier(0, 0, 0.2, 1);
    transition-delay: 0.3s;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-active .layout-sidebar .layout-sidebar-top .layout-sidebar-logo-slim {
    display: none;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-active .layout-sidebar .layout-sidebar-top .layout-sidebar-anchor {
    display: block;
    animation: px-fadein 0.15s linear;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container {
    overflow: auto;
    overflow-x: hidden;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem > .layout-menuitem-root-text {
    white-space: nowrap;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem > .layout-menuitem-root-text > .layout-menuitem-root-icon {
    display: none;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem > .layout-menuitem-root-text > span {
    margin-right: auto;
    opacity: 1;
    transition: all 0.1s;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul a {
    width: auto;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul a .layout-submenu-toggler {
    display: block;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul a span {
    opacity: 1;
    white-space: nowrap;
    transition: all 0.3s;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul ul {
    overflow: hidden;
    border-radius: var(--border-radius);
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul ul li a {
    padding-left: 2.5rem;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul ul li li a {
    padding-left: 3rem;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul ul li li li a {
    padding-left: 3.5rem;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul ul li li li li a {
    padding-left: 4rem;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul ul li li li li li a {
    padding-left: 5.5rem;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul ul li li li li li li a {
    padding-left: 5rem;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-profile > button span {
    opacity: 1;
    white-space: nowrap;
    transition: all 0.1s;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-profile > ul > li > button > i {
    margin-right: 0.5rem;
    font-size: 1.25rem;
    width: auto;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-anchored .layout-topbar {
    padding-left: 17rem;
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-anchored .layout-sidebar-top .layout-sidebar-anchor {
    background-color: var(--topbar-menu-button-bg);
  }
  :host ::ng-deep .layout-drawer.layout-sidebar-anchored .layout-content-wrapper {
    margin-left: 17rem;
  }
}
:host ::ng-deep .layout-container.layout-menu-profile-active .layout-menu-profile-toggler {
  transform: rotate(-180deg);
}
:host ::ng-deep .layout-container.layout-menu-profile-end .layout-menu-profile {
  border-top: 1px solid var(--inline-menu-border-color);
}
:host ::ng-deep .layout-container.layout-menu-profile-start .layout-menu-profile {
  border-bottom: 1px solid var(--inline-menu-border-color);
}
:host ::ng-deep .layout-menu-profile {
  width: 100%;
  background: var(--menu-bg);
  overflow: hidden;
  border-bottom: 1px solid var(--surface-border);
}
:host ::ng-deep .layout-menu-profile > button {
  display: flex;
  width: 100%;
  align-items: center;
  padding: 0.5rem 1.5rem;
  color: var(--menuitem-text-color);
  transition: background-color var(--transition-duration);
}
:host ::ng-deep .layout-menu-profile > button > span {
  display: flex;
  flex-direction: column;
  margin-left: 0.5rem;
}
:host ::ng-deep .layout-menu-profile > button > i {
  margin-left: auto;
  transition: transform var(--transition-duration);
}
:host ::ng-deep .layout-menu-profile > button:hover {
  background-color: var(--menuitem-hover-bg);
}
:host ::ng-deep .layout-menu-profile > ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
:host ::ng-deep .layout-menu-profile > ul > li > button {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0.75rem 1.5rem;
  transition: background-color var(--transition-duration), box-shadow var(--transition-duration);
  color: var(--menuitem-text-color);
}
:host ::ng-deep .layout-menu-profile > ul > li > button > i {
  margin-right: 0.5rem;
  color: var(--menuitem-text-color);
}
:host ::ng-deep .layout-menu-profile > ul > li > button:hover {
  background-color: var(--menuitem-hover-bg);
}
:host ::ng-deep .layout-megamenu.p-megamenu {
  border: 0 none;
  padding: 0;
}
:host ::ng-deep .parallax__layer__0 {
  transform: translateZ(-150px) scale(2.5);
}
:host ::ng-deep .parallax__layer__1 {
  transform: translateZ(-100px) scale(2);
}
:host ::ng-deep .parallax__layer__2 {
  transform: translateZ(-50px) scale(1.5);
}
:host ::ng-deep .parallax__layer__3 {
  transform: translateZ(0) scale(1);
}
:host ::ng-deep html {
  height: 100%;
  font-size: 14px;
}
:host ::ng-deep body {
  font-weight: 400;
  padding: 0;
  margin: 0;
  min-height: 100%;
  background: var(--surface-ground);
  color: var(--text-color);
  font-family: var(--font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
:host ::ng-deep a {
  text-decoration: none;
}
:host ::ng-deep .p-toast.p-toast-top-right, :host ::ng-deep .p-toast.p-toast-top-left, :host ::ng-deep .p-toast.p-toast-top-center {
  top: 85px;
}
:host ::ng-deep .layout-content-wrapper {
  padding-top: 4rem;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
:host ::ng-deep .layout-content-wrapper .layout-content {
  flex: 1 1 auto;
  padding: 2rem;
}
:host ::ng-deep .layout-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem;
  background-color: var(--surface-card);
}
:host ::ng-deep .layout-config-button.p-button {
  z-index: 999;
  position: fixed;
  top: 50%;
  right: 0;
  width: auto;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  padding: 0.5rem;
}
:host ::ng-deep .layout-config-button.p-button .p-button-icon {
  font-size: 2rem;
}
:host ::ng-deep .layout-breadcrumb-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--surface-border);
  padding: 0.5rem 2rem;
  background-color: var(--surface-card);
}
:host ::ng-deep .layout-breadcrumb-container .layout-breadcrumb ol {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
  gap: 0.5rem;
  flex-wrap: wrap;
  color: var(--text-color-secondary);
}
:host ::ng-deep .layout-breadcrumb-container .layout-breadcrumb ol li {
  display: flex;
  align-items: center;
}
:host ::ng-deep .layout-breadcrumb-container .layout-breadcrumb-buttons {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
:host ::ng-deep .layout-breadcrumb-container .layout-breadcrumb-buttons button {
  flex-shrink: 0;
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .layout-container.layout-static .layout-sidebar {
    transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1);
  }
  :host ::ng-deep .layout-container.layout-static .layout-content-wrapper {
    margin-left: 17rem;
    transition: margin-left 0.3s cubic-bezier(0, 0, 0.2, 1);
  }
  :host ::ng-deep .layout-container.layout-static .layout-topbar .layout-menu-button i {
    transform: rotate(180deg);
  }
  :host ::ng-deep .layout-container.layout-static-inactive .layout-sidebar {
    transform: translate(-100%);
  }
  :host ::ng-deep .layout-container.layout-static-inactive .layout-content-wrapper {
    margin-left: 0;
  }
  :host ::ng-deep .layout-container.layout-static-inactive .layout-topbar .layout-menu-button i {
    transform: rotate(0);
  }
  :host ::ng-deep .layout-container.layout-overlay .layout-content-wrapper {
    margin-left: 0;
  }
  :host ::ng-deep .layout-container.layout-overlay .layout-sidebar {
    z-index: 999;
    transform: translate(-100%);
    transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1);
  }
  :host ::ng-deep .layout-container.layout-overlay.layout-overlay-active .layout-sidebar {
    transform: translate(0);
  }
  :host ::ng-deep .layout-container.layout-overlay.layout-overlay-active .layout-topbar .layout-menu-button i {
    transform: rotate(180deg);
  }
}
@media screen and (max-width: 991px) {
  :host ::ng-deep .blocked-scroll {
    overflow: hidden;
  }
  :host ::ng-deep .layout-container .layout-content-wrapper {
    margin-left: 0;
  }
  :host ::ng-deep .layout-container .layout-sidebar {
    z-index: 999;
    transform: translate(-100%);
    transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1);
  }
  :host ::ng-deep .layout-container.layout-mobile-active .layout-sidebar {
    transform: translate(0);
  }
  :host ::ng-deep .layout-container.layout-mobile-active .layout-mask {
    display: block;
    animation: px-mask-in 0.3s cubic-bezier(0, 0, 0.2, 1);
  }
  :host ::ng-deep .layout-container.layout-mobile-active .layout-topbar .layout-menu-button i {
    transform: rotate(180deg);
  }
  :host ::ng-deep .layout-container .layout-mask {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
    width: 100%;
    height: 100%;
    background-color: var(--maskbg);
  }
  :host ::ng-deep .layout-container.layout-topbar-menu-active .layout-topbar .layout-topbar-end {
    display: flex;
    flex-direction: column-reverse;
    align-items: stretch;
    position: fixed;
    top: 4rem;
    width: 100%;
    background-color: var(--topbar-bg);
    padding-left: 0;
  }
  :host ::ng-deep .layout-container.layout-topbar-menu-active .layout-topbar .layout-topbar-end .layout-megamenu {
    height: 3rem;
  }
  :host ::ng-deep .layout-container.layout-topbar-menu-active .layout-topbar .layout-topbar-end .layout-megamenu.p-megamenu .p-megamenu-root-list > .p-menuitem {
    position: static;
  }
  :host ::ng-deep .layout-container.layout-topbar-menu-active .layout-topbar .layout-topbar-end .layout-megamenu.p-megamenu .p-megamenu-root-list > .p-menuitem .p-megamenu-panel {
    position: absolute;
    left: 1rem;
    right: 1rem;
    max-height: 20rem;
    overflow: auto;
  }
  :host ::ng-deep .layout-container.layout-topbar-menu-active .layout-topbar .layout-topbar-end .layout-megamenu.p-megamenu .p-megamenu-root-list > .p-menuitem .p-megamenu-grid {
    flex-direction: column;
  }
  :host ::ng-deep .layout-container.layout-topbar-menu-active .layout-topbar .layout-topbar-end .layout-topbar-items {
    justify-content: space-between;
    align-items: center;
    height: 4rem;
    padding: 0 1rem;
  }
  :host ::ng-deep .layout-container.layout-topbar-menu-active .layout-topbar .layout-topbar-end .layout-topbar-items > li {
    position: static;
  }
  :host ::ng-deep .layout-container.layout-topbar-menu-active .layout-topbar .layout-topbar-end .layout-topbar-items > li > div {
    left: 1rem;
    right: 1rem;
  }
  :host ::ng-deep .layout-container.layout-topbar-menu-active .layout-topbar .layout-topbar-end .layout-topbar-items .layout-topbar-search {
    position: relative;
  }
  :host ::ng-deep .layout-container.layout-topbar-menu-active .layout-topbar .layout-topbar-actions-start {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 3rem;
  }
  :host ::ng-deep .layout-topbar {
    display: flex;
    flex-direction: column;
  }
  :host ::ng-deep .layout-topbar .layout-topbar-start {
    padding: 0 1rem;
    width: 100%;
    height: 4rem;
    justify-content: flex-start;
  }
  :host ::ng-deep .layout-topbar .layout-topbar-start .layout-menu-button {
    position: relative;
    margin-top: 0;
    margin-left: 1rem;
    top: auto;
  }
  :host ::ng-deep .layout-topbar .layout-topbar-start .layout-topbar-mobile-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    transition: background-color var(--transition-duration);
  }
  :host ::ng-deep .layout-topbar .layout-topbar-start .layout-topbar-mobile-button:hover {
    background-color: var(--topbar-bg);
  }
  :host ::ng-deep .layout-topbar .layout-topbar-end {
    display: none;
  }
}
@media screen and (min-width: 1729px) {
  :host ::ng-deep .layout-content {
    width: 1504px;
    margin-left: auto !important;
    margin-right: auto !important;
  }
}
:host ::ng-deep .grid {
  display: flex;
  flex-wrap: wrap;
  margin-right: -1rem;
  margin-left: -1rem;
  margin-top: -1rem;
}
:host ::ng-deep .grid > .col, :host ::ng-deep .grid > [class*=col] {
  box-sizing: border-box;
}
:host ::ng-deep .grid-nogutter {
  margin-right: 0;
  margin-left: 0;
  margin-top: 0;
}
:host ::ng-deep .grid-nogutter > .col, :host ::ng-deep .grid-nogutter > [class*=col-] {
  padding: 0;
}
:host ::ng-deep .col {
  flex-grow: 1;
  flex-basis: 0;
  padding: 1rem;
}
:host ::ng-deep .col-fixed {
  flex: 0 0 auto;
  padding: 1rem;
}
:host ::ng-deep .col-1 {
  flex: 0 0 auto;
  padding: 1rem;
  width: 8.3333%;
}
:host ::ng-deep .col-2 {
  flex: 0 0 auto;
  padding: 1rem;
  width: 16.6667%;
}
:host ::ng-deep .col-3 {
  flex: 0 0 auto;
  padding: 1rem;
  width: 25%;
}
:host ::ng-deep .col-4 {
  flex: 0 0 auto;
  padding: 1rem;
  width: 33.3333%;
}
:host ::ng-deep .col-5 {
  flex: 0 0 auto;
  padding: 1rem;
  width: 41.6667%;
}
:host ::ng-deep .col-6 {
  flex: 0 0 auto;
  padding: 1rem;
  width: 50%;
}
:host ::ng-deep .col-7 {
  flex: 0 0 auto;
  padding: 1rem;
  width: 58.3333%;
}
:host ::ng-deep .col-8 {
  flex: 0 0 auto;
  padding: 1rem;
  width: 66.6667%;
}
:host ::ng-deep .col-9 {
  flex: 0 0 auto;
  padding: 1rem;
  width: 75%;
}
:host ::ng-deep .col-10 {
  flex: 0 0 auto;
  padding: 1rem;
  width: 83.3333%;
}
:host ::ng-deep .col-11 {
  flex: 0 0 auto;
  padding: 1rem;
  width: 91.6667%;
}
:host ::ng-deep .col-12 {
  flex: 0 0 auto;
  width: 100%;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:col {
    flex-grow: 1;
    flex-basis: 0;
    padding: 1rem;
  }
  :host ::ng-deep .sm\\:col-fixed {
    flex: 0 0 auto;
    padding: 1rem;
  }
  :host ::ng-deep .sm\\:col-1 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 8.3333%;
  }
  :host ::ng-deep .sm\\:col-2 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 16.6667%;
  }
  :host ::ng-deep .sm\\:col-3 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 25%;
  }
  :host ::ng-deep .sm\\:col-4 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 33.3333%;
  }
  :host ::ng-deep .sm\\:col-5 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 41.6667%;
  }
  :host ::ng-deep .sm\\:col-6 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 50%;
  }
  :host ::ng-deep .sm\\:col-7 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 58.3333%;
  }
  :host ::ng-deep .sm\\:col-8 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 66.6667%;
  }
  :host ::ng-deep .sm\\:col-9 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 75%;
  }
  :host ::ng-deep .sm\\:col-10 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 83.3333%;
  }
  :host ::ng-deep .sm\\:col-11 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 91.6667%;
  }
  :host ::ng-deep .sm\\:col-12 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 100%;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:col {
    flex-grow: 1;
    flex-basis: 0;
    padding: 1rem;
  }
  :host ::ng-deep .md\\:col-fixed {
    flex: 0 0 auto;
    padding: 1rem;
  }
  :host ::ng-deep .md\\:col-1 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 8.3333%;
  }
  :host ::ng-deep .md\\:col-2 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 16.6667%;
  }
  :host ::ng-deep .md\\:col-3 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 25%;
  }
  :host ::ng-deep .md\\:col-4 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 33.3333%;
  }
  :host ::ng-deep .md\\:col-5 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 41.6667%;
  }
  :host ::ng-deep .md\\:col-6 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 50%;
  }
  :host ::ng-deep .md\\:col-7 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 58.3333%;
  }
  :host ::ng-deep .md\\:col-8 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 66.6667%;
  }
  :host ::ng-deep .md\\:col-9 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 75%;
  }
  :host ::ng-deep .md\\:col-10 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 83.3333%;
  }
  :host ::ng-deep .md\\:col-11 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 91.6667%;
  }
  :host ::ng-deep .md\\:col-12 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 100%;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:col {
    flex-grow: 1;
    flex-basis: 0;
    padding: 1rem;
  }
  :host ::ng-deep .lg\\:col-fixed {
    flex: 0 0 auto;
    padding: 1rem;
  }
  :host ::ng-deep .lg\\:col-1 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 8.3333%;
  }
  :host ::ng-deep .lg\\:col-2 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 16.6667%;
  }
  :host ::ng-deep .lg\\:col-3 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 25%;
  }
  :host ::ng-deep .lg\\:col-4 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 33.3333%;
  }
  :host ::ng-deep .lg\\:col-5 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 41.6667%;
  }
  :host ::ng-deep .lg\\:col-6 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 50%;
  }
  :host ::ng-deep .lg\\:col-7 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 58.3333%;
  }
  :host ::ng-deep .lg\\:col-8 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 66.6667%;
  }
  :host ::ng-deep .lg\\:col-9 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 75%;
  }
  :host ::ng-deep .lg\\:col-10 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 83.3333%;
  }
  :host ::ng-deep .lg\\:col-11 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 91.6667%;
  }
  :host ::ng-deep .lg\\:col-12 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 100%;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:col {
    flex-grow: 1;
    flex-basis: 0;
    padding: 1rem;
  }
  :host ::ng-deep .xl\\:col-fixed {
    flex: 0 0 auto;
    padding: 1rem;
  }
  :host ::ng-deep .xl\\:col-1 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 8.3333%;
  }
  :host ::ng-deep .xl\\:col-2 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 16.6667%;
  }
  :host ::ng-deep .xl\\:col-3 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 25%;
  }
  :host ::ng-deep .xl\\:col-4 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 33.3333%;
  }
  :host ::ng-deep .xl\\:col-5 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 41.6667%;
  }
  :host ::ng-deep .xl\\:col-6 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 50%;
  }
  :host ::ng-deep .xl\\:col-7 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 58.3333%;
  }
  :host ::ng-deep .xl\\:col-8 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 66.6667%;
  }
  :host ::ng-deep .xl\\:col-9 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 75%;
  }
  :host ::ng-deep .xl\\:col-10 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 83.3333%;
  }
  :host ::ng-deep .xl\\:col-11 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 91.6667%;
  }
  :host ::ng-deep .xl\\:col-12 {
    flex: 0 0 auto;
    padding: 1rem;
    width: 100%;
  }
}
:host ::ng-deep .col-offset-0 {
  margin-left: 0 !important;
}
:host ::ng-deep .col-offset-1 {
  margin-left: 8.3333% !important;
}
:host ::ng-deep .col-offset-2 {
  margin-left: 16.6667% !important;
}
:host ::ng-deep .col-offset-3 {
  margin-left: 25% !important;
}
:host ::ng-deep .col-offset-4 {
  margin-left: 33.3333% !important;
}
:host ::ng-deep .col-offset-5 {
  margin-left: 41.6667% !important;
}
:host ::ng-deep .col-offset-6 {
  margin-left: 50% !important;
}
:host ::ng-deep .col-offset-7 {
  margin-left: 58.3333% !important;
}
:host ::ng-deep .col-offset-8 {
  margin-left: 66.6667% !important;
}
:host ::ng-deep .col-offset-9 {
  margin-left: 75% !important;
}
:host ::ng-deep .col-offset-10 {
  margin-left: 83.3333% !important;
}
:host ::ng-deep .col-offset-11 {
  margin-left: 91.6667% !important;
}
:host ::ng-deep .col-offset-12 {
  margin-left: 100% !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:col-offset-0 {
    margin-left: 0 !important;
  }
  :host ::ng-deep .sm\\:col-offset-1 {
    margin-left: 8.3333% !important;
  }
  :host ::ng-deep .sm\\:col-offset-2 {
    margin-left: 16.6667% !important;
  }
  :host ::ng-deep .sm\\:col-offset-3 {
    margin-left: 25% !important;
  }
  :host ::ng-deep .sm\\:col-offset-4 {
    margin-left: 33.3333% !important;
  }
  :host ::ng-deep .sm\\:col-offset-5 {
    margin-left: 41.6667% !important;
  }
  :host ::ng-deep .sm\\:col-offset-6 {
    margin-left: 50% !important;
  }
  :host ::ng-deep .sm\\:col-offset-7 {
    margin-left: 58.3333% !important;
  }
  :host ::ng-deep .sm\\:col-offset-8 {
    margin-left: 66.6667% !important;
  }
  :host ::ng-deep .sm\\:col-offset-9 {
    margin-left: 75% !important;
  }
  :host ::ng-deep .sm\\:col-offset-10 {
    margin-left: 83.3333% !important;
  }
  :host ::ng-deep .sm\\:col-offset-11 {
    margin-left: 91.6667% !important;
  }
  :host ::ng-deep .sm\\:col-offset-12 {
    margin-left: 100% !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:col-offset-0 {
    margin-left: 0 !important;
  }
  :host ::ng-deep .md\\:col-offset-1 {
    margin-left: 8.3333% !important;
  }
  :host ::ng-deep .md\\:col-offset-2 {
    margin-left: 16.6667% !important;
  }
  :host ::ng-deep .md\\:col-offset-3 {
    margin-left: 25% !important;
  }
  :host ::ng-deep .md\\:col-offset-4 {
    margin-left: 33.3333% !important;
  }
  :host ::ng-deep .md\\:col-offset-5 {
    margin-left: 41.6667% !important;
  }
  :host ::ng-deep .md\\:col-offset-6 {
    margin-left: 50% !important;
  }
  :host ::ng-deep .md\\:col-offset-7 {
    margin-left: 58.3333% !important;
  }
  :host ::ng-deep .md\\:col-offset-8 {
    margin-left: 66.6667% !important;
  }
  :host ::ng-deep .md\\:col-offset-9 {
    margin-left: 75% !important;
  }
  :host ::ng-deep .md\\:col-offset-10 {
    margin-left: 83.3333% !important;
  }
  :host ::ng-deep .md\\:col-offset-11 {
    margin-left: 91.6667% !important;
  }
  :host ::ng-deep .md\\:col-offset-12 {
    margin-left: 100% !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:col-offset-0 {
    margin-left: 0 !important;
  }
  :host ::ng-deep .lg\\:col-offset-1 {
    margin-left: 8.3333% !important;
  }
  :host ::ng-deep .lg\\:col-offset-2 {
    margin-left: 16.6667% !important;
  }
  :host ::ng-deep .lg\\:col-offset-3 {
    margin-left: 25% !important;
  }
  :host ::ng-deep .lg\\:col-offset-4 {
    margin-left: 33.3333% !important;
  }
  :host ::ng-deep .lg\\:col-offset-5 {
    margin-left: 41.6667% !important;
  }
  :host ::ng-deep .lg\\:col-offset-6 {
    margin-left: 50% !important;
  }
  :host ::ng-deep .lg\\:col-offset-7 {
    margin-left: 58.3333% !important;
  }
  :host ::ng-deep .lg\\:col-offset-8 {
    margin-left: 66.6667% !important;
  }
  :host ::ng-deep .lg\\:col-offset-9 {
    margin-left: 75% !important;
  }
  :host ::ng-deep .lg\\:col-offset-10 {
    margin-left: 83.3333% !important;
  }
  :host ::ng-deep .lg\\:col-offset-11 {
    margin-left: 91.6667% !important;
  }
  :host ::ng-deep .lg\\:col-offset-12 {
    margin-left: 100% !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:col-offset-0 {
    margin-left: 0 !important;
  }
  :host ::ng-deep .xl\\:col-offset-1 {
    margin-left: 8.3333% !important;
  }
  :host ::ng-deep .xl\\:col-offset-2 {
    margin-left: 16.6667% !important;
  }
  :host ::ng-deep .xl\\:col-offset-3 {
    margin-left: 25% !important;
  }
  :host ::ng-deep .xl\\:col-offset-4 {
    margin-left: 33.3333% !important;
  }
  :host ::ng-deep .xl\\:col-offset-5 {
    margin-left: 41.6667% !important;
  }
  :host ::ng-deep .xl\\:col-offset-6 {
    margin-left: 50% !important;
  }
  :host ::ng-deep .xl\\:col-offset-7 {
    margin-left: 58.3333% !important;
  }
  :host ::ng-deep .xl\\:col-offset-8 {
    margin-left: 66.6667% !important;
  }
  :host ::ng-deep .xl\\:col-offset-9 {
    margin-left: 75% !important;
  }
  :host ::ng-deep .xl\\:col-offset-10 {
    margin-left: 83.3333% !important;
  }
  :host ::ng-deep .xl\\:col-offset-11 {
    margin-left: 91.6667% !important;
  }
  :host ::ng-deep .xl\\:col-offset-12 {
    margin-left: 100% !important;
  }
}
:host ::ng-deep .text-0 {
  color: var(--surface-0) !important;
}
:host ::ng-deep .text-50 {
  color: var(--surface-50) !important;
}
:host ::ng-deep .text-100 {
  color: var(--surface-100) !important;
}
:host ::ng-deep .text-200 {
  color: var(--surface-200) !important;
}
:host ::ng-deep .text-300 {
  color: var(--surface-300) !important;
}
:host ::ng-deep .text-400 {
  color: var(--surface-400) !important;
}
:host ::ng-deep .text-500 {
  color: var(--surface-500) !important;
}
:host ::ng-deep .text-600 {
  color: var(--surface-600) !important;
}
:host ::ng-deep .text-700 {
  color: var(--surface-700) !important;
}
:host ::ng-deep .text-800 {
  color: var(--surface-800) !important;
}
:host ::ng-deep .text-900 {
  color: var(--surface-900) !important;
}
:host ::ng-deep .focus\\:text-0:focus {
  color: var(--surface-0) !important;
}
:host ::ng-deep .hover\\:text-0:hover, :host ::ng-deep .active\\:text-0:active {
  color: var(--surface-0) !important;
}
:host ::ng-deep .focus\\:text-50:focus {
  color: var(--surface-50) !important;
}
:host ::ng-deep .hover\\:text-50:hover, :host ::ng-deep .active\\:text-50:active {
  color: var(--surface-50) !important;
}
:host ::ng-deep .focus\\:text-100:focus {
  color: var(--surface-100) !important;
}
:host ::ng-deep .hover\\:text-100:hover, :host ::ng-deep .active\\:text-100:active {
  color: var(--surface-100) !important;
}
:host ::ng-deep .focus\\:text-200:focus {
  color: var(--surface-200) !important;
}
:host ::ng-deep .hover\\:text-200:hover, :host ::ng-deep .active\\:text-200:active {
  color: var(--surface-200) !important;
}
:host ::ng-deep .focus\\:text-300:focus {
  color: var(--surface-300) !important;
}
:host ::ng-deep .hover\\:text-300:hover, :host ::ng-deep .active\\:text-300:active {
  color: var(--surface-300) !important;
}
:host ::ng-deep .focus\\:text-400:focus {
  color: var(--surface-400) !important;
}
:host ::ng-deep .hover\\:text-400:hover, :host ::ng-deep .active\\:text-400:active {
  color: var(--surface-400) !important;
}
:host ::ng-deep .focus\\:text-500:focus {
  color: var(--surface-500) !important;
}
:host ::ng-deep .hover\\:text-500:hover, :host ::ng-deep .active\\:text-500:active {
  color: var(--surface-500) !important;
}
:host ::ng-deep .focus\\:text-600:focus {
  color: var(--surface-600) !important;
}
:host ::ng-deep .hover\\:text-600:hover, :host ::ng-deep .active\\:text-600:active {
  color: var(--surface-600) !important;
}
:host ::ng-deep .focus\\:text-700:focus {
  color: var(--surface-700) !important;
}
:host ::ng-deep .hover\\:text-700:hover, :host ::ng-deep .active\\:text-700:active {
  color: var(--surface-700) !important;
}
:host ::ng-deep .focus\\:text-800:focus {
  color: var(--surface-800) !important;
}
:host ::ng-deep .hover\\:text-800:hover, :host ::ng-deep .active\\:text-800:active {
  color: var(--surface-800) !important;
}
:host ::ng-deep .focus\\:text-900:focus {
  color: var(--surface-900) !important;
}
:host ::ng-deep .hover\\:text-900:hover, :host ::ng-deep .active\\:text-900:active {
  color: var(--surface-900) !important;
}
:host ::ng-deep .surface-0 {
  background-color: var(--surface-0) !important;
}
:host ::ng-deep .surface-50 {
  background-color: var(--surface-50) !important;
}
:host ::ng-deep .surface-100 {
  background-color: var(--surface-100) !important;
}
:host ::ng-deep .surface-200 {
  background-color: var(--surface-200) !important;
}
:host ::ng-deep .surface-300 {
  background-color: var(--surface-300) !important;
}
:host ::ng-deep .surface-400 {
  background-color: var(--surface-400) !important;
}
:host ::ng-deep .surface-500 {
  background-color: var(--surface-500) !important;
}
:host ::ng-deep .surface-600 {
  background-color: var(--surface-600) !important;
}
:host ::ng-deep .surface-700 {
  background-color: var(--surface-700) !important;
}
:host ::ng-deep .surface-800 {
  background-color: var(--surface-800) !important;
}
:host ::ng-deep .surface-900 {
  background-color: var(--surface-900) !important;
}
:host ::ng-deep .focus\\:surface-0:focus {
  background-color: var(--surface-0) !important;
}
:host ::ng-deep .hover\\:surface-0:hover, :host ::ng-deep .active\\:surface-0:active {
  background-color: var(--surface-0) !important;
}
:host ::ng-deep .focus\\:surface-50:focus {
  background-color: var(--surface-50) !important;
}
:host ::ng-deep .hover\\:surface-50:hover, :host ::ng-deep .active\\:surface-50:active {
  background-color: var(--surface-50) !important;
}
:host ::ng-deep .focus\\:surface-100:focus {
  background-color: var(--surface-100) !important;
}
:host ::ng-deep .hover\\:surface-100:hover, :host ::ng-deep .active\\:surface-100:active {
  background-color: var(--surface-100) !important;
}
:host ::ng-deep .focus\\:surface-200:focus {
  background-color: var(--surface-200) !important;
}
:host ::ng-deep .hover\\:surface-200:hover, :host ::ng-deep .active\\:surface-200:active {
  background-color: var(--surface-200) !important;
}
:host ::ng-deep .focus\\:surface-300:focus {
  background-color: var(--surface-300) !important;
}
:host ::ng-deep .hover\\:surface-300:hover, :host ::ng-deep .active\\:surface-300:active {
  background-color: var(--surface-300) !important;
}
:host ::ng-deep .focus\\:surface-400:focus {
  background-color: var(--surface-400) !important;
}
:host ::ng-deep .hover\\:surface-400:hover, :host ::ng-deep .active\\:surface-400:active {
  background-color: var(--surface-400) !important;
}
:host ::ng-deep .focus\\:surface-500:focus {
  background-color: var(--surface-500) !important;
}
:host ::ng-deep .hover\\:surface-500:hover, :host ::ng-deep .active\\:surface-500:active {
  background-color: var(--surface-500) !important;
}
:host ::ng-deep .focus\\:surface-600:focus {
  background-color: var(--surface-600) !important;
}
:host ::ng-deep .hover\\:surface-600:hover, :host ::ng-deep .active\\:surface-600:active {
  background-color: var(--surface-600) !important;
}
:host ::ng-deep .focus\\:surface-700:focus {
  background-color: var(--surface-700) !important;
}
:host ::ng-deep .hover\\:surface-700:hover, :host ::ng-deep .active\\:surface-700:active {
  background-color: var(--surface-700) !important;
}
:host ::ng-deep .focus\\:surface-800:focus {
  background-color: var(--surface-800) !important;
}
:host ::ng-deep .hover\\:surface-800:hover, :host ::ng-deep .active\\:surface-800:active {
  background-color: var(--surface-800) !important;
}
:host ::ng-deep .focus\\:surface-900:focus {
  background-color: var(--surface-900) !important;
}
:host ::ng-deep .hover\\:surface-900:hover, :host ::ng-deep .active\\:surface-900:active {
  background-color: var(--surface-900) !important;
}
:host ::ng-deep .border-0 {
  border-color: var(--surface-0) !important;
}
:host ::ng-deep .border-50 {
  border-color: var(--surface-50) !important;
}
:host ::ng-deep .border-100 {
  border-color: var(--surface-100) !important;
}
:host ::ng-deep .border-200 {
  border-color: var(--surface-200) !important;
}
:host ::ng-deep .border-300 {
  border-color: var(--surface-300) !important;
}
:host ::ng-deep .border-400 {
  border-color: var(--surface-400) !important;
}
:host ::ng-deep .border-500 {
  border-color: var(--surface-500) !important;
}
:host ::ng-deep .border-600 {
  border-color: var(--surface-600) !important;
}
:host ::ng-deep .border-700 {
  border-color: var(--surface-700) !important;
}
:host ::ng-deep .border-800 {
  border-color: var(--surface-800) !important;
}
:host ::ng-deep .border-900 {
  border-color: var(--surface-900) !important;
}
:host ::ng-deep .focus\\:border-0:focus {
  border-color: var(--surface-0) !important;
}
:host ::ng-deep .hover\\:border-0:hover, :host ::ng-deep .active\\:border-0:active {
  border-color: var(--surface-0) !important;
}
:host ::ng-deep .focus\\:border-50:focus {
  border-color: var(--surface-50) !important;
}
:host ::ng-deep .hover\\:border-50:hover, :host ::ng-deep .active\\:border-50:active {
  border-color: var(--surface-50) !important;
}
:host ::ng-deep .focus\\:border-100:focus {
  border-color: var(--surface-100) !important;
}
:host ::ng-deep .hover\\:border-100:hover, :host ::ng-deep .active\\:border-100:active {
  border-color: var(--surface-100) !important;
}
:host ::ng-deep .focus\\:border-200:focus {
  border-color: var(--surface-200) !important;
}
:host ::ng-deep .hover\\:border-200:hover, :host ::ng-deep .active\\:border-200:active {
  border-color: var(--surface-200) !important;
}
:host ::ng-deep .focus\\:border-300:focus {
  border-color: var(--surface-300) !important;
}
:host ::ng-deep .hover\\:border-300:hover, :host ::ng-deep .active\\:border-300:active {
  border-color: var(--surface-300) !important;
}
:host ::ng-deep .focus\\:border-400:focus {
  border-color: var(--surface-400) !important;
}
:host ::ng-deep .hover\\:border-400:hover, :host ::ng-deep .active\\:border-400:active {
  border-color: var(--surface-400) !important;
}
:host ::ng-deep .focus\\:border-500:focus {
  border-color: var(--surface-500) !important;
}
:host ::ng-deep .hover\\:border-500:hover, :host ::ng-deep .active\\:border-500:active {
  border-color: var(--surface-500) !important;
}
:host ::ng-deep .focus\\:border-600:focus {
  border-color: var(--surface-600) !important;
}
:host ::ng-deep .hover\\:border-600:hover, :host ::ng-deep .active\\:border-600:active {
  border-color: var(--surface-600) !important;
}
:host ::ng-deep .focus\\:border-700:focus {
  border-color: var(--surface-700) !important;
}
:host ::ng-deep .hover\\:border-700:hover, :host ::ng-deep .active\\:border-700:active {
  border-color: var(--surface-700) !important;
}
:host ::ng-deep .focus\\:border-800:focus {
  border-color: var(--surface-800) !important;
}
:host ::ng-deep .hover\\:border-800:hover, :host ::ng-deep .active\\:border-800:active {
  border-color: var(--surface-800) !important;
}
:host ::ng-deep .focus\\:border-900:focus {
  border-color: var(--surface-900) !important;
}
:host ::ng-deep .hover\\:border-900:hover, :host ::ng-deep .active\\:border-900:active {
  border-color: var(--surface-900) !important;
}
:host ::ng-deep .bg-transparent {
  background-color: transparent !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:bg-transparent {
    background-color: transparent !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:bg-transparent {
    background-color: transparent !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:bg-transparent {
    background-color: transparent !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:bg-transparent {
    background-color: transparent !important;
  }
}
:host ::ng-deep .border-transparent {
  border-color: transparent !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:border-transparent {
    border-color: transparent !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:border-transparent {
    border-color: transparent !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:border-transparent {
    border-color: transparent !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:border-transparent {
    border-color: transparent !important;
  }
}
:host ::ng-deep .text-blue-50 {
  color: var(--blue-50) !important;
}
:host ::ng-deep .text-blue-100 {
  color: var(--blue-100) !important;
}
:host ::ng-deep .text-blue-200 {
  color: var(--blue-200) !important;
}
:host ::ng-deep .text-blue-300 {
  color: var(--blue-300) !important;
}
:host ::ng-deep .text-blue-400 {
  color: var(--blue-400) !important;
}
:host ::ng-deep .text-blue-500 {
  color: var(--blue-500) !important;
}
:host ::ng-deep .text-blue-600 {
  color: var(--blue-600) !important;
}
:host ::ng-deep .text-blue-700 {
  color: var(--blue-700) !important;
}
:host ::ng-deep .text-blue-800 {
  color: var(--blue-800) !important;
}
:host ::ng-deep .text-blue-900 {
  color: var(--blue-900) !important;
}
:host ::ng-deep .focus\\:text-blue-50:focus {
  color: var(--blue-50) !important;
}
:host ::ng-deep .focus\\:text-blue-100:focus {
  color: var(--blue-100) !important;
}
:host ::ng-deep .focus\\:text-blue-200:focus {
  color: var(--blue-200) !important;
}
:host ::ng-deep .focus\\:text-blue-300:focus {
  color: var(--blue-300) !important;
}
:host ::ng-deep .focus\\:text-blue-400:focus {
  color: var(--blue-400) !important;
}
:host ::ng-deep .focus\\:text-blue-500:focus {
  color: var(--blue-500) !important;
}
:host ::ng-deep .focus\\:text-blue-600:focus {
  color: var(--blue-600) !important;
}
:host ::ng-deep .focus\\:text-blue-700:focus {
  color: var(--blue-700) !important;
}
:host ::ng-deep .focus\\:text-blue-800:focus {
  color: var(--blue-800) !important;
}
:host ::ng-deep .focus\\:text-blue-900:focus {
  color: var(--blue-900) !important;
}
:host ::ng-deep .hover\\:text-blue-50:hover {
  color: var(--blue-50) !important;
}
:host ::ng-deep .hover\\:text-blue-100:hover {
  color: var(--blue-100) !important;
}
:host ::ng-deep .hover\\:text-blue-200:hover {
  color: var(--blue-200) !important;
}
:host ::ng-deep .hover\\:text-blue-300:hover {
  color: var(--blue-300) !important;
}
:host ::ng-deep .hover\\:text-blue-400:hover {
  color: var(--blue-400) !important;
}
:host ::ng-deep .hover\\:text-blue-500:hover {
  color: var(--blue-500) !important;
}
:host ::ng-deep .hover\\:text-blue-600:hover {
  color: var(--blue-600) !important;
}
:host ::ng-deep .hover\\:text-blue-700:hover {
  color: var(--blue-700) !important;
}
:host ::ng-deep .hover\\:text-blue-800:hover {
  color: var(--blue-800) !important;
}
:host ::ng-deep .hover\\:text-blue-900:hover {
  color: var(--blue-900) !important;
}
:host ::ng-deep .active\\:text-blue-50:active {
  color: var(--blue-50) !important;
}
:host ::ng-deep .active\\:text-blue-100:active {
  color: var(--blue-100) !important;
}
:host ::ng-deep .active\\:text-blue-200:active {
  color: var(--blue-200) !important;
}
:host ::ng-deep .active\\:text-blue-300:active {
  color: var(--blue-300) !important;
}
:host ::ng-deep .active\\:text-blue-400:active {
  color: var(--blue-400) !important;
}
:host ::ng-deep .active\\:text-blue-500:active {
  color: var(--blue-500) !important;
}
:host ::ng-deep .active\\:text-blue-600:active {
  color: var(--blue-600) !important;
}
:host ::ng-deep .active\\:text-blue-700:active {
  color: var(--blue-700) !important;
}
:host ::ng-deep .active\\:text-blue-800:active {
  color: var(--blue-800) !important;
}
:host ::ng-deep .active\\:text-blue-900:active {
  color: var(--blue-900) !important;
}
:host ::ng-deep .text-green-50 {
  color: var(--green-50) !important;
}
:host ::ng-deep .text-green-100 {
  color: var(--green-100) !important;
}
:host ::ng-deep .text-green-200 {
  color: var(--green-200) !important;
}
:host ::ng-deep .text-green-300 {
  color: var(--green-300) !important;
}
:host ::ng-deep .text-green-400 {
  color: var(--green-400) !important;
}
:host ::ng-deep .text-green-500 {
  color: var(--green-500) !important;
}
:host ::ng-deep .text-green-600 {
  color: var(--green-600) !important;
}
:host ::ng-deep .text-green-700 {
  color: var(--green-700) !important;
}
:host ::ng-deep .text-green-800 {
  color: var(--green-800) !important;
}
:host ::ng-deep .text-green-900 {
  color: var(--green-900) !important;
}
:host ::ng-deep .focus\\:text-green-50:focus {
  color: var(--green-50) !important;
}
:host ::ng-deep .focus\\:text-green-100:focus {
  color: var(--green-100) !important;
}
:host ::ng-deep .focus\\:text-green-200:focus {
  color: var(--green-200) !important;
}
:host ::ng-deep .focus\\:text-green-300:focus {
  color: var(--green-300) !important;
}
:host ::ng-deep .focus\\:text-green-400:focus {
  color: var(--green-400) !important;
}
:host ::ng-deep .focus\\:text-green-500:focus {
  color: var(--green-500) !important;
}
:host ::ng-deep .focus\\:text-green-600:focus {
  color: var(--green-600) !important;
}
:host ::ng-deep .focus\\:text-green-700:focus {
  color: var(--green-700) !important;
}
:host ::ng-deep .focus\\:text-green-800:focus {
  color: var(--green-800) !important;
}
:host ::ng-deep .focus\\:text-green-900:focus {
  color: var(--green-900) !important;
}
:host ::ng-deep .hover\\:text-green-50:hover {
  color: var(--green-50) !important;
}
:host ::ng-deep .hover\\:text-green-100:hover {
  color: var(--green-100) !important;
}
:host ::ng-deep .hover\\:text-green-200:hover {
  color: var(--green-200) !important;
}
:host ::ng-deep .hover\\:text-green-300:hover {
  color: var(--green-300) !important;
}
:host ::ng-deep .hover\\:text-green-400:hover {
  color: var(--green-400) !important;
}
:host ::ng-deep .hover\\:text-green-500:hover {
  color: var(--green-500) !important;
}
:host ::ng-deep .hover\\:text-green-600:hover {
  color: var(--green-600) !important;
}
:host ::ng-deep .hover\\:text-green-700:hover {
  color: var(--green-700) !important;
}
:host ::ng-deep .hover\\:text-green-800:hover {
  color: var(--green-800) !important;
}
:host ::ng-deep .hover\\:text-green-900:hover {
  color: var(--green-900) !important;
}
:host ::ng-deep .active\\:text-green-50:active {
  color: var(--green-50) !important;
}
:host ::ng-deep .active\\:text-green-100:active {
  color: var(--green-100) !important;
}
:host ::ng-deep .active\\:text-green-200:active {
  color: var(--green-200) !important;
}
:host ::ng-deep .active\\:text-green-300:active {
  color: var(--green-300) !important;
}
:host ::ng-deep .active\\:text-green-400:active {
  color: var(--green-400) !important;
}
:host ::ng-deep .active\\:text-green-500:active {
  color: var(--green-500) !important;
}
:host ::ng-deep .active\\:text-green-600:active {
  color: var(--green-600) !important;
}
:host ::ng-deep .active\\:text-green-700:active {
  color: var(--green-700) !important;
}
:host ::ng-deep .active\\:text-green-800:active {
  color: var(--green-800) !important;
}
:host ::ng-deep .active\\:text-green-900:active {
  color: var(--green-900) !important;
}
:host ::ng-deep .text-yellow-50 {
  color: var(--yellow-50) !important;
}
:host ::ng-deep .text-yellow-100 {
  color: var(--yellow-100) !important;
}
:host ::ng-deep .text-yellow-200 {
  color: var(--yellow-200) !important;
}
:host ::ng-deep .text-yellow-300 {
  color: var(--yellow-300) !important;
}
:host ::ng-deep .text-yellow-400 {
  color: var(--yellow-400) !important;
}
:host ::ng-deep .text-yellow-500 {
  color: var(--yellow-500) !important;
}
:host ::ng-deep .text-yellow-600 {
  color: var(--yellow-600) !important;
}
:host ::ng-deep .text-yellow-700 {
  color: var(--yellow-700) !important;
}
:host ::ng-deep .text-yellow-800 {
  color: var(--yellow-800) !important;
}
:host ::ng-deep .text-yellow-900 {
  color: var(--yellow-900) !important;
}
:host ::ng-deep .focus\\:text-yellow-50:focus {
  color: var(--yellow-50) !important;
}
:host ::ng-deep .focus\\:text-yellow-100:focus {
  color: var(--yellow-100) !important;
}
:host ::ng-deep .focus\\:text-yellow-200:focus {
  color: var(--yellow-200) !important;
}
:host ::ng-deep .focus\\:text-yellow-300:focus {
  color: var(--yellow-300) !important;
}
:host ::ng-deep .focus\\:text-yellow-400:focus {
  color: var(--yellow-400) !important;
}
:host ::ng-deep .focus\\:text-yellow-500:focus {
  color: var(--yellow-500) !important;
}
:host ::ng-deep .focus\\:text-yellow-600:focus {
  color: var(--yellow-600) !important;
}
:host ::ng-deep .focus\\:text-yellow-700:focus {
  color: var(--yellow-700) !important;
}
:host ::ng-deep .focus\\:text-yellow-800:focus {
  color: var(--yellow-800) !important;
}
:host ::ng-deep .focus\\:text-yellow-900:focus {
  color: var(--yellow-900) !important;
}
:host ::ng-deep .hover\\:text-yellow-50:hover {
  color: var(--yellow-50) !important;
}
:host ::ng-deep .hover\\:text-yellow-100:hover {
  color: var(--yellow-100) !important;
}
:host ::ng-deep .hover\\:text-yellow-200:hover {
  color: var(--yellow-200) !important;
}
:host ::ng-deep .hover\\:text-yellow-300:hover {
  color: var(--yellow-300) !important;
}
:host ::ng-deep .hover\\:text-yellow-400:hover {
  color: var(--yellow-400) !important;
}
:host ::ng-deep .hover\\:text-yellow-500:hover {
  color: var(--yellow-500) !important;
}
:host ::ng-deep .hover\\:text-yellow-600:hover {
  color: var(--yellow-600) !important;
}
:host ::ng-deep .hover\\:text-yellow-700:hover {
  color: var(--yellow-700) !important;
}
:host ::ng-deep .hover\\:text-yellow-800:hover {
  color: var(--yellow-800) !important;
}
:host ::ng-deep .hover\\:text-yellow-900:hover {
  color: var(--yellow-900) !important;
}
:host ::ng-deep .active\\:text-yellow-50:active {
  color: var(--yellow-50) !important;
}
:host ::ng-deep .active\\:text-yellow-100:active {
  color: var(--yellow-100) !important;
}
:host ::ng-deep .active\\:text-yellow-200:active {
  color: var(--yellow-200) !important;
}
:host ::ng-deep .active\\:text-yellow-300:active {
  color: var(--yellow-300) !important;
}
:host ::ng-deep .active\\:text-yellow-400:active {
  color: var(--yellow-400) !important;
}
:host ::ng-deep .active\\:text-yellow-500:active {
  color: var(--yellow-500) !important;
}
:host ::ng-deep .active\\:text-yellow-600:active {
  color: var(--yellow-600) !important;
}
:host ::ng-deep .active\\:text-yellow-700:active {
  color: var(--yellow-700) !important;
}
:host ::ng-deep .active\\:text-yellow-800:active {
  color: var(--yellow-800) !important;
}
:host ::ng-deep .active\\:text-yellow-900:active {
  color: var(--yellow-900) !important;
}
:host ::ng-deep .text-cyan-50 {
  color: var(--cyan-50) !important;
}
:host ::ng-deep .text-cyan-100 {
  color: var(--cyan-100) !important;
}
:host ::ng-deep .text-cyan-200 {
  color: var(--cyan-200) !important;
}
:host ::ng-deep .text-cyan-300 {
  color: var(--cyan-300) !important;
}
:host ::ng-deep .text-cyan-400 {
  color: var(--cyan-400) !important;
}
:host ::ng-deep .text-cyan-500 {
  color: var(--cyan-500) !important;
}
:host ::ng-deep .text-cyan-600 {
  color: var(--cyan-600) !important;
}
:host ::ng-deep .text-cyan-700 {
  color: var(--cyan-700) !important;
}
:host ::ng-deep .text-cyan-800 {
  color: var(--cyan-800) !important;
}
:host ::ng-deep .text-cyan-900 {
  color: var(--cyan-900) !important;
}
:host ::ng-deep .focus\\:text-cyan-50:focus {
  color: var(--cyan-50) !important;
}
:host ::ng-deep .focus\\:text-cyan-100:focus {
  color: var(--cyan-100) !important;
}
:host ::ng-deep .focus\\:text-cyan-200:focus {
  color: var(--cyan-200) !important;
}
:host ::ng-deep .focus\\:text-cyan-300:focus {
  color: var(--cyan-300) !important;
}
:host ::ng-deep .focus\\:text-cyan-400:focus {
  color: var(--cyan-400) !important;
}
:host ::ng-deep .focus\\:text-cyan-500:focus {
  color: var(--cyan-500) !important;
}
:host ::ng-deep .focus\\:text-cyan-600:focus {
  color: var(--cyan-600) !important;
}
:host ::ng-deep .focus\\:text-cyan-700:focus {
  color: var(--cyan-700) !important;
}
:host ::ng-deep .focus\\:text-cyan-800:focus {
  color: var(--cyan-800) !important;
}
:host ::ng-deep .focus\\:text-cyan-900:focus {
  color: var(--cyan-900) !important;
}
:host ::ng-deep .hover\\:text-cyan-50:hover {
  color: var(--cyan-50) !important;
}
:host ::ng-deep .hover\\:text-cyan-100:hover {
  color: var(--cyan-100) !important;
}
:host ::ng-deep .hover\\:text-cyan-200:hover {
  color: var(--cyan-200) !important;
}
:host ::ng-deep .hover\\:text-cyan-300:hover {
  color: var(--cyan-300) !important;
}
:host ::ng-deep .hover\\:text-cyan-400:hover {
  color: var(--cyan-400) !important;
}
:host ::ng-deep .hover\\:text-cyan-500:hover {
  color: var(--cyan-500) !important;
}
:host ::ng-deep .hover\\:text-cyan-600:hover {
  color: var(--cyan-600) !important;
}
:host ::ng-deep .hover\\:text-cyan-700:hover {
  color: var(--cyan-700) !important;
}
:host ::ng-deep .hover\\:text-cyan-800:hover {
  color: var(--cyan-800) !important;
}
:host ::ng-deep .hover\\:text-cyan-900:hover {
  color: var(--cyan-900) !important;
}
:host ::ng-deep .active\\:text-cyan-50:active {
  color: var(--cyan-50) !important;
}
:host ::ng-deep .active\\:text-cyan-100:active {
  color: var(--cyan-100) !important;
}
:host ::ng-deep .active\\:text-cyan-200:active {
  color: var(--cyan-200) !important;
}
:host ::ng-deep .active\\:text-cyan-300:active {
  color: var(--cyan-300) !important;
}
:host ::ng-deep .active\\:text-cyan-400:active {
  color: var(--cyan-400) !important;
}
:host ::ng-deep .active\\:text-cyan-500:active {
  color: var(--cyan-500) !important;
}
:host ::ng-deep .active\\:text-cyan-600:active {
  color: var(--cyan-600) !important;
}
:host ::ng-deep .active\\:text-cyan-700:active {
  color: var(--cyan-700) !important;
}
:host ::ng-deep .active\\:text-cyan-800:active {
  color: var(--cyan-800) !important;
}
:host ::ng-deep .active\\:text-cyan-900:active {
  color: var(--cyan-900) !important;
}
:host ::ng-deep .text-pink-50 {
  color: var(--pink-50) !important;
}
:host ::ng-deep .text-pink-100 {
  color: var(--pink-100) !important;
}
:host ::ng-deep .text-pink-200 {
  color: var(--pink-200) !important;
}
:host ::ng-deep .text-pink-300 {
  color: var(--pink-300) !important;
}
:host ::ng-deep .text-pink-400 {
  color: var(--pink-400) !important;
}
:host ::ng-deep .text-pink-500 {
  color: var(--pink-500) !important;
}
:host ::ng-deep .text-pink-600 {
  color: var(--pink-600) !important;
}
:host ::ng-deep .text-pink-700 {
  color: var(--pink-700) !important;
}
:host ::ng-deep .text-pink-800 {
  color: var(--pink-800) !important;
}
:host ::ng-deep .text-pink-900 {
  color: var(--pink-900) !important;
}
:host ::ng-deep .focus\\:text-pink-50:focus {
  color: var(--pink-50) !important;
}
:host ::ng-deep .focus\\:text-pink-100:focus {
  color: var(--pink-100) !important;
}
:host ::ng-deep .focus\\:text-pink-200:focus {
  color: var(--pink-200) !important;
}
:host ::ng-deep .focus\\:text-pink-300:focus {
  color: var(--pink-300) !important;
}
:host ::ng-deep .focus\\:text-pink-400:focus {
  color: var(--pink-400) !important;
}
:host ::ng-deep .focus\\:text-pink-500:focus {
  color: var(--pink-500) !important;
}
:host ::ng-deep .focus\\:text-pink-600:focus {
  color: var(--pink-600) !important;
}
:host ::ng-deep .focus\\:text-pink-700:focus {
  color: var(--pink-700) !important;
}
:host ::ng-deep .focus\\:text-pink-800:focus {
  color: var(--pink-800) !important;
}
:host ::ng-deep .focus\\:text-pink-900:focus {
  color: var(--pink-900) !important;
}
:host ::ng-deep .hover\\:text-pink-50:hover {
  color: var(--pink-50) !important;
}
:host ::ng-deep .hover\\:text-pink-100:hover {
  color: var(--pink-100) !important;
}
:host ::ng-deep .hover\\:text-pink-200:hover {
  color: var(--pink-200) !important;
}
:host ::ng-deep .hover\\:text-pink-300:hover {
  color: var(--pink-300) !important;
}
:host ::ng-deep .hover\\:text-pink-400:hover {
  color: var(--pink-400) !important;
}
:host ::ng-deep .hover\\:text-pink-500:hover {
  color: var(--pink-500) !important;
}
:host ::ng-deep .hover\\:text-pink-600:hover {
  color: var(--pink-600) !important;
}
:host ::ng-deep .hover\\:text-pink-700:hover {
  color: var(--pink-700) !important;
}
:host ::ng-deep .hover\\:text-pink-800:hover {
  color: var(--pink-800) !important;
}
:host ::ng-deep .hover\\:text-pink-900:hover {
  color: var(--pink-900) !important;
}
:host ::ng-deep .active\\:text-pink-50:active {
  color: var(--pink-50) !important;
}
:host ::ng-deep .active\\:text-pink-100:active {
  color: var(--pink-100) !important;
}
:host ::ng-deep .active\\:text-pink-200:active {
  color: var(--pink-200) !important;
}
:host ::ng-deep .active\\:text-pink-300:active {
  color: var(--pink-300) !important;
}
:host ::ng-deep .active\\:text-pink-400:active {
  color: var(--pink-400) !important;
}
:host ::ng-deep .active\\:text-pink-500:active {
  color: var(--pink-500) !important;
}
:host ::ng-deep .active\\:text-pink-600:active {
  color: var(--pink-600) !important;
}
:host ::ng-deep .active\\:text-pink-700:active {
  color: var(--pink-700) !important;
}
:host ::ng-deep .active\\:text-pink-800:active {
  color: var(--pink-800) !important;
}
:host ::ng-deep .active\\:text-pink-900:active {
  color: var(--pink-900) !important;
}
:host ::ng-deep .text-indigo-50 {
  color: var(--indigo-50) !important;
}
:host ::ng-deep .text-indigo-100 {
  color: var(--indigo-100) !important;
}
:host ::ng-deep .text-indigo-200 {
  color: var(--indigo-200) !important;
}
:host ::ng-deep .text-indigo-300 {
  color: var(--indigo-300) !important;
}
:host ::ng-deep .text-indigo-400 {
  color: var(--indigo-400) !important;
}
:host ::ng-deep .text-indigo-500 {
  color: var(--indigo-500) !important;
}
:host ::ng-deep .text-indigo-600 {
  color: var(--indigo-600) !important;
}
:host ::ng-deep .text-indigo-700 {
  color: var(--indigo-700) !important;
}
:host ::ng-deep .text-indigo-800 {
  color: var(--indigo-800) !important;
}
:host ::ng-deep .text-indigo-900 {
  color: var(--indigo-900) !important;
}
:host ::ng-deep .focus\\:text-indigo-50:focus {
  color: var(--indigo-50) !important;
}
:host ::ng-deep .focus\\:text-indigo-100:focus {
  color: var(--indigo-100) !important;
}
:host ::ng-deep .focus\\:text-indigo-200:focus {
  color: var(--indigo-200) !important;
}
:host ::ng-deep .focus\\:text-indigo-300:focus {
  color: var(--indigo-300) !important;
}
:host ::ng-deep .focus\\:text-indigo-400:focus {
  color: var(--indigo-400) !important;
}
:host ::ng-deep .focus\\:text-indigo-500:focus {
  color: var(--indigo-500) !important;
}
:host ::ng-deep .focus\\:text-indigo-600:focus {
  color: var(--indigo-600) !important;
}
:host ::ng-deep .focus\\:text-indigo-700:focus {
  color: var(--indigo-700) !important;
}
:host ::ng-deep .focus\\:text-indigo-800:focus {
  color: var(--indigo-800) !important;
}
:host ::ng-deep .focus\\:text-indigo-900:focus {
  color: var(--indigo-900) !important;
}
:host ::ng-deep .hover\\:text-indigo-50:hover {
  color: var(--indigo-50) !important;
}
:host ::ng-deep .hover\\:text-indigo-100:hover {
  color: var(--indigo-100) !important;
}
:host ::ng-deep .hover\\:text-indigo-200:hover {
  color: var(--indigo-200) !important;
}
:host ::ng-deep .hover\\:text-indigo-300:hover {
  color: var(--indigo-300) !important;
}
:host ::ng-deep .hover\\:text-indigo-400:hover {
  color: var(--indigo-400) !important;
}
:host ::ng-deep .hover\\:text-indigo-500:hover {
  color: var(--indigo-500) !important;
}
:host ::ng-deep .hover\\:text-indigo-600:hover {
  color: var(--indigo-600) !important;
}
:host ::ng-deep .hover\\:text-indigo-700:hover {
  color: var(--indigo-700) !important;
}
:host ::ng-deep .hover\\:text-indigo-800:hover {
  color: var(--indigo-800) !important;
}
:host ::ng-deep .hover\\:text-indigo-900:hover {
  color: var(--indigo-900) !important;
}
:host ::ng-deep .active\\:text-indigo-50:active {
  color: var(--indigo-50) !important;
}
:host ::ng-deep .active\\:text-indigo-100:active {
  color: var(--indigo-100) !important;
}
:host ::ng-deep .active\\:text-indigo-200:active {
  color: var(--indigo-200) !important;
}
:host ::ng-deep .active\\:text-indigo-300:active {
  color: var(--indigo-300) !important;
}
:host ::ng-deep .active\\:text-indigo-400:active {
  color: var(--indigo-400) !important;
}
:host ::ng-deep .active\\:text-indigo-500:active {
  color: var(--indigo-500) !important;
}
:host ::ng-deep .active\\:text-indigo-600:active {
  color: var(--indigo-600) !important;
}
:host ::ng-deep .active\\:text-indigo-700:active {
  color: var(--indigo-700) !important;
}
:host ::ng-deep .active\\:text-indigo-800:active {
  color: var(--indigo-800) !important;
}
:host ::ng-deep .active\\:text-indigo-900:active {
  color: var(--indigo-900) !important;
}
:host ::ng-deep .text-teal-50 {
  color: var(--teal-50) !important;
}
:host ::ng-deep .text-teal-100 {
  color: var(--teal-100) !important;
}
:host ::ng-deep .text-teal-200 {
  color: var(--teal-200) !important;
}
:host ::ng-deep .text-teal-300 {
  color: var(--teal-300) !important;
}
:host ::ng-deep .text-teal-400 {
  color: var(--teal-400) !important;
}
:host ::ng-deep .text-teal-500 {
  color: var(--teal-500) !important;
}
:host ::ng-deep .text-teal-600 {
  color: var(--teal-600) !important;
}
:host ::ng-deep .text-teal-700 {
  color: var(--teal-700) !important;
}
:host ::ng-deep .text-teal-800 {
  color: var(--teal-800) !important;
}
:host ::ng-deep .text-teal-900 {
  color: var(--teal-900) !important;
}
:host ::ng-deep .focus\\:text-teal-50:focus {
  color: var(--teal-50) !important;
}
:host ::ng-deep .focus\\:text-teal-100:focus {
  color: var(--teal-100) !important;
}
:host ::ng-deep .focus\\:text-teal-200:focus {
  color: var(--teal-200) !important;
}
:host ::ng-deep .focus\\:text-teal-300:focus {
  color: var(--teal-300) !important;
}
:host ::ng-deep .focus\\:text-teal-400:focus {
  color: var(--teal-400) !important;
}
:host ::ng-deep .focus\\:text-teal-500:focus {
  color: var(--teal-500) !important;
}
:host ::ng-deep .focus\\:text-teal-600:focus {
  color: var(--teal-600) !important;
}
:host ::ng-deep .focus\\:text-teal-700:focus {
  color: var(--teal-700) !important;
}
:host ::ng-deep .focus\\:text-teal-800:focus {
  color: var(--teal-800) !important;
}
:host ::ng-deep .focus\\:text-teal-900:focus {
  color: var(--teal-900) !important;
}
:host ::ng-deep .hover\\:text-teal-50:hover {
  color: var(--teal-50) !important;
}
:host ::ng-deep .hover\\:text-teal-100:hover {
  color: var(--teal-100) !important;
}
:host ::ng-deep .hover\\:text-teal-200:hover {
  color: var(--teal-200) !important;
}
:host ::ng-deep .hover\\:text-teal-300:hover {
  color: var(--teal-300) !important;
}
:host ::ng-deep .hover\\:text-teal-400:hover {
  color: var(--teal-400) !important;
}
:host ::ng-deep .hover\\:text-teal-500:hover {
  color: var(--teal-500) !important;
}
:host ::ng-deep .hover\\:text-teal-600:hover {
  color: var(--teal-600) !important;
}
:host ::ng-deep .hover\\:text-teal-700:hover {
  color: var(--teal-700) !important;
}
:host ::ng-deep .hover\\:text-teal-800:hover {
  color: var(--teal-800) !important;
}
:host ::ng-deep .hover\\:text-teal-900:hover {
  color: var(--teal-900) !important;
}
:host ::ng-deep .active\\:text-teal-50:active {
  color: var(--teal-50) !important;
}
:host ::ng-deep .active\\:text-teal-100:active {
  color: var(--teal-100) !important;
}
:host ::ng-deep .active\\:text-teal-200:active {
  color: var(--teal-200) !important;
}
:host ::ng-deep .active\\:text-teal-300:active {
  color: var(--teal-300) !important;
}
:host ::ng-deep .active\\:text-teal-400:active {
  color: var(--teal-400) !important;
}
:host ::ng-deep .active\\:text-teal-500:active {
  color: var(--teal-500) !important;
}
:host ::ng-deep .active\\:text-teal-600:active {
  color: var(--teal-600) !important;
}
:host ::ng-deep .active\\:text-teal-700:active {
  color: var(--teal-700) !important;
}
:host ::ng-deep .active\\:text-teal-800:active {
  color: var(--teal-800) !important;
}
:host ::ng-deep .active\\:text-teal-900:active {
  color: var(--teal-900) !important;
}
:host ::ng-deep .text-orange-50 {
  color: var(--orange-50) !important;
}
:host ::ng-deep .text-orange-100 {
  color: var(--orange-100) !important;
}
:host ::ng-deep .text-orange-200 {
  color: var(--orange-200) !important;
}
:host ::ng-deep .text-orange-300 {
  color: var(--orange-300) !important;
}
:host ::ng-deep .text-orange-400 {
  color: var(--orange-400) !important;
}
:host ::ng-deep .text-orange-500 {
  color: var(--orange-500) !important;
}
:host ::ng-deep .text-orange-600 {
  color: var(--orange-600) !important;
}
:host ::ng-deep .text-orange-700 {
  color: var(--orange-700) !important;
}
:host ::ng-deep .text-orange-800 {
  color: var(--orange-800) !important;
}
:host ::ng-deep .text-orange-900 {
  color: var(--orange-900) !important;
}
:host ::ng-deep .focus\\:text-orange-50:focus {
  color: var(--orange-50) !important;
}
:host ::ng-deep .focus\\:text-orange-100:focus {
  color: var(--orange-100) !important;
}
:host ::ng-deep .focus\\:text-orange-200:focus {
  color: var(--orange-200) !important;
}
:host ::ng-deep .focus\\:text-orange-300:focus {
  color: var(--orange-300) !important;
}
:host ::ng-deep .focus\\:text-orange-400:focus {
  color: var(--orange-400) !important;
}
:host ::ng-deep .focus\\:text-orange-500:focus {
  color: var(--orange-500) !important;
}
:host ::ng-deep .focus\\:text-orange-600:focus {
  color: var(--orange-600) !important;
}
:host ::ng-deep .focus\\:text-orange-700:focus {
  color: var(--orange-700) !important;
}
:host ::ng-deep .focus\\:text-orange-800:focus {
  color: var(--orange-800) !important;
}
:host ::ng-deep .focus\\:text-orange-900:focus {
  color: var(--orange-900) !important;
}
:host ::ng-deep .hover\\:text-orange-50:hover {
  color: var(--orange-50) !important;
}
:host ::ng-deep .hover\\:text-orange-100:hover {
  color: var(--orange-100) !important;
}
:host ::ng-deep .hover\\:text-orange-200:hover {
  color: var(--orange-200) !important;
}
:host ::ng-deep .hover\\:text-orange-300:hover {
  color: var(--orange-300) !important;
}
:host ::ng-deep .hover\\:text-orange-400:hover {
  color: var(--orange-400) !important;
}
:host ::ng-deep .hover\\:text-orange-500:hover {
  color: var(--orange-500) !important;
}
:host ::ng-deep .hover\\:text-orange-600:hover {
  color: var(--orange-600) !important;
}
:host ::ng-deep .hover\\:text-orange-700:hover {
  color: var(--orange-700) !important;
}
:host ::ng-deep .hover\\:text-orange-800:hover {
  color: var(--orange-800) !important;
}
:host ::ng-deep .hover\\:text-orange-900:hover {
  color: var(--orange-900) !important;
}
:host ::ng-deep .active\\:text-orange-50:active {
  color: var(--orange-50) !important;
}
:host ::ng-deep .active\\:text-orange-100:active {
  color: var(--orange-100) !important;
}
:host ::ng-deep .active\\:text-orange-200:active {
  color: var(--orange-200) !important;
}
:host ::ng-deep .active\\:text-orange-300:active {
  color: var(--orange-300) !important;
}
:host ::ng-deep .active\\:text-orange-400:active {
  color: var(--orange-400) !important;
}
:host ::ng-deep .active\\:text-orange-500:active {
  color: var(--orange-500) !important;
}
:host ::ng-deep .active\\:text-orange-600:active {
  color: var(--orange-600) !important;
}
:host ::ng-deep .active\\:text-orange-700:active {
  color: var(--orange-700) !important;
}
:host ::ng-deep .active\\:text-orange-800:active {
  color: var(--orange-800) !important;
}
:host ::ng-deep .active\\:text-orange-900:active {
  color: var(--orange-900) !important;
}
:host ::ng-deep .text-bluegray-50 {
  color: var(--bluegray-50) !important;
}
:host ::ng-deep .text-bluegray-100 {
  color: var(--bluegray-100) !important;
}
:host ::ng-deep .text-bluegray-200 {
  color: var(--bluegray-200) !important;
}
:host ::ng-deep .text-bluegray-300 {
  color: var(--bluegray-300) !important;
}
:host ::ng-deep .text-bluegray-400 {
  color: var(--bluegray-400) !important;
}
:host ::ng-deep .text-bluegray-500 {
  color: var(--bluegray-500) !important;
}
:host ::ng-deep .text-bluegray-600 {
  color: var(--bluegray-600) !important;
}
:host ::ng-deep .text-bluegray-700 {
  color: var(--bluegray-700) !important;
}
:host ::ng-deep .text-bluegray-800 {
  color: var(--bluegray-800) !important;
}
:host ::ng-deep .text-bluegray-900 {
  color: var(--bluegray-900) !important;
}
:host ::ng-deep .focus\\:text-bluegray-50:focus {
  color: var(--bluegray-50) !important;
}
:host ::ng-deep .focus\\:text-bluegray-100:focus {
  color: var(--bluegray-100) !important;
}
:host ::ng-deep .focus\\:text-bluegray-200:focus {
  color: var(--bluegray-200) !important;
}
:host ::ng-deep .focus\\:text-bluegray-300:focus {
  color: var(--bluegray-300) !important;
}
:host ::ng-deep .focus\\:text-bluegray-400:focus {
  color: var(--bluegray-400) !important;
}
:host ::ng-deep .focus\\:text-bluegray-500:focus {
  color: var(--bluegray-500) !important;
}
:host ::ng-deep .focus\\:text-bluegray-600:focus {
  color: var(--bluegray-600) !important;
}
:host ::ng-deep .focus\\:text-bluegray-700:focus {
  color: var(--bluegray-700) !important;
}
:host ::ng-deep .focus\\:text-bluegray-800:focus {
  color: var(--bluegray-800) !important;
}
:host ::ng-deep .focus\\:text-bluegray-900:focus {
  color: var(--bluegray-900) !important;
}
:host ::ng-deep .hover\\:text-bluegray-50:hover {
  color: var(--bluegray-50) !important;
}
:host ::ng-deep .hover\\:text-bluegray-100:hover {
  color: var(--bluegray-100) !important;
}
:host ::ng-deep .hover\\:text-bluegray-200:hover {
  color: var(--bluegray-200) !important;
}
:host ::ng-deep .hover\\:text-bluegray-300:hover {
  color: var(--bluegray-300) !important;
}
:host ::ng-deep .hover\\:text-bluegray-400:hover {
  color: var(--bluegray-400) !important;
}
:host ::ng-deep .hover\\:text-bluegray-500:hover {
  color: var(--bluegray-500) !important;
}
:host ::ng-deep .hover\\:text-bluegray-600:hover {
  color: var(--bluegray-600) !important;
}
:host ::ng-deep .hover\\:text-bluegray-700:hover {
  color: var(--bluegray-700) !important;
}
:host ::ng-deep .hover\\:text-bluegray-800:hover {
  color: var(--bluegray-800) !important;
}
:host ::ng-deep .hover\\:text-bluegray-900:hover {
  color: var(--bluegray-900) !important;
}
:host ::ng-deep .active\\:text-bluegray-50:active {
  color: var(--bluegray-50) !important;
}
:host ::ng-deep .active\\:text-bluegray-100:active {
  color: var(--bluegray-100) !important;
}
:host ::ng-deep .active\\:text-bluegray-200:active {
  color: var(--bluegray-200) !important;
}
:host ::ng-deep .active\\:text-bluegray-300:active {
  color: var(--bluegray-300) !important;
}
:host ::ng-deep .active\\:text-bluegray-400:active {
  color: var(--bluegray-400) !important;
}
:host ::ng-deep .active\\:text-bluegray-500:active {
  color: var(--bluegray-500) !important;
}
:host ::ng-deep .active\\:text-bluegray-600:active {
  color: var(--bluegray-600) !important;
}
:host ::ng-deep .active\\:text-bluegray-700:active {
  color: var(--bluegray-700) !important;
}
:host ::ng-deep .active\\:text-bluegray-800:active {
  color: var(--bluegray-800) !important;
}
:host ::ng-deep .active\\:text-bluegray-900:active {
  color: var(--bluegray-900) !important;
}
:host ::ng-deep .text-purple-50 {
  color: var(--purple-50) !important;
}
:host ::ng-deep .text-purple-100 {
  color: var(--purple-100) !important;
}
:host ::ng-deep .text-purple-200 {
  color: var(--purple-200) !important;
}
:host ::ng-deep .text-purple-300 {
  color: var(--purple-300) !important;
}
:host ::ng-deep .text-purple-400 {
  color: var(--purple-400) !important;
}
:host ::ng-deep .text-purple-500 {
  color: var(--purple-500) !important;
}
:host ::ng-deep .text-purple-600 {
  color: var(--purple-600) !important;
}
:host ::ng-deep .text-purple-700 {
  color: var(--purple-700) !important;
}
:host ::ng-deep .text-purple-800 {
  color: var(--purple-800) !important;
}
:host ::ng-deep .text-purple-900 {
  color: var(--purple-900) !important;
}
:host ::ng-deep .focus\\:text-purple-50:focus {
  color: var(--purple-50) !important;
}
:host ::ng-deep .focus\\:text-purple-100:focus {
  color: var(--purple-100) !important;
}
:host ::ng-deep .focus\\:text-purple-200:focus {
  color: var(--purple-200) !important;
}
:host ::ng-deep .focus\\:text-purple-300:focus {
  color: var(--purple-300) !important;
}
:host ::ng-deep .focus\\:text-purple-400:focus {
  color: var(--purple-400) !important;
}
:host ::ng-deep .focus\\:text-purple-500:focus {
  color: var(--purple-500) !important;
}
:host ::ng-deep .focus\\:text-purple-600:focus {
  color: var(--purple-600) !important;
}
:host ::ng-deep .focus\\:text-purple-700:focus {
  color: var(--purple-700) !important;
}
:host ::ng-deep .focus\\:text-purple-800:focus {
  color: var(--purple-800) !important;
}
:host ::ng-deep .focus\\:text-purple-900:focus {
  color: var(--purple-900) !important;
}
:host ::ng-deep .hover\\:text-purple-50:hover {
  color: var(--purple-50) !important;
}
:host ::ng-deep .hover\\:text-purple-100:hover {
  color: var(--purple-100) !important;
}
:host ::ng-deep .hover\\:text-purple-200:hover {
  color: var(--purple-200) !important;
}
:host ::ng-deep .hover\\:text-purple-300:hover {
  color: var(--purple-300) !important;
}
:host ::ng-deep .hover\\:text-purple-400:hover {
  color: var(--purple-400) !important;
}
:host ::ng-deep .hover\\:text-purple-500:hover {
  color: var(--purple-500) !important;
}
:host ::ng-deep .hover\\:text-purple-600:hover {
  color: var(--purple-600) !important;
}
:host ::ng-deep .hover\\:text-purple-700:hover {
  color: var(--purple-700) !important;
}
:host ::ng-deep .hover\\:text-purple-800:hover {
  color: var(--purple-800) !important;
}
:host ::ng-deep .hover\\:text-purple-900:hover {
  color: var(--purple-900) !important;
}
:host ::ng-deep .active\\:text-purple-50:active {
  color: var(--purple-50) !important;
}
:host ::ng-deep .active\\:text-purple-100:active {
  color: var(--purple-100) !important;
}
:host ::ng-deep .active\\:text-purple-200:active {
  color: var(--purple-200) !important;
}
:host ::ng-deep .active\\:text-purple-300:active {
  color: var(--purple-300) !important;
}
:host ::ng-deep .active\\:text-purple-400:active {
  color: var(--purple-400) !important;
}
:host ::ng-deep .active\\:text-purple-500:active {
  color: var(--purple-500) !important;
}
:host ::ng-deep .active\\:text-purple-600:active {
  color: var(--purple-600) !important;
}
:host ::ng-deep .active\\:text-purple-700:active {
  color: var(--purple-700) !important;
}
:host ::ng-deep .active\\:text-purple-800:active {
  color: var(--purple-800) !important;
}
:host ::ng-deep .active\\:text-purple-900:active {
  color: var(--purple-900) !important;
}
:host ::ng-deep .text-gray-50 {
  color: var(--gray-50) !important;
}
:host ::ng-deep .text-gray-100 {
  color: var(--gray-100) !important;
}
:host ::ng-deep .text-gray-200 {
  color: var(--gray-200) !important;
}
:host ::ng-deep .text-gray-300 {
  color: var(--gray-300) !important;
}
:host ::ng-deep .text-gray-400 {
  color: var(--gray-400) !important;
}
:host ::ng-deep .text-gray-500 {
  color: var(--gray-500) !important;
}
:host ::ng-deep .text-gray-600 {
  color: var(--gray-600) !important;
}
:host ::ng-deep .text-gray-700 {
  color: var(--gray-700) !important;
}
:host ::ng-deep .text-gray-800 {
  color: var(--gray-800) !important;
}
:host ::ng-deep .text-gray-900 {
  color: var(--gray-900) !important;
}
:host ::ng-deep .focus\\:text-gray-50:focus {
  color: var(--gray-50) !important;
}
:host ::ng-deep .focus\\:text-gray-100:focus {
  color: var(--gray-100) !important;
}
:host ::ng-deep .focus\\:text-gray-200:focus {
  color: var(--gray-200) !important;
}
:host ::ng-deep .focus\\:text-gray-300:focus {
  color: var(--gray-300) !important;
}
:host ::ng-deep .focus\\:text-gray-400:focus {
  color: var(--gray-400) !important;
}
:host ::ng-deep .focus\\:text-gray-500:focus {
  color: var(--gray-500) !important;
}
:host ::ng-deep .focus\\:text-gray-600:focus {
  color: var(--gray-600) !important;
}
:host ::ng-deep .focus\\:text-gray-700:focus {
  color: var(--gray-700) !important;
}
:host ::ng-deep .focus\\:text-gray-800:focus {
  color: var(--gray-800) !important;
}
:host ::ng-deep .focus\\:text-gray-900:focus {
  color: var(--gray-900) !important;
}
:host ::ng-deep .hover\\:text-gray-50:hover {
  color: var(--gray-50) !important;
}
:host ::ng-deep .hover\\:text-gray-100:hover {
  color: var(--gray-100) !important;
}
:host ::ng-deep .hover\\:text-gray-200:hover {
  color: var(--gray-200) !important;
}
:host ::ng-deep .hover\\:text-gray-300:hover {
  color: var(--gray-300) !important;
}
:host ::ng-deep .hover\\:text-gray-400:hover {
  color: var(--gray-400) !important;
}
:host ::ng-deep .hover\\:text-gray-500:hover {
  color: var(--gray-500) !important;
}
:host ::ng-deep .hover\\:text-gray-600:hover {
  color: var(--gray-600) !important;
}
:host ::ng-deep .hover\\:text-gray-700:hover {
  color: var(--gray-700) !important;
}
:host ::ng-deep .hover\\:text-gray-800:hover {
  color: var(--gray-800) !important;
}
:host ::ng-deep .hover\\:text-gray-900:hover {
  color: var(--gray-900) !important;
}
:host ::ng-deep .active\\:text-gray-50:active {
  color: var(--gray-50) !important;
}
:host ::ng-deep .active\\:text-gray-100:active {
  color: var(--gray-100) !important;
}
:host ::ng-deep .active\\:text-gray-200:active {
  color: var(--gray-200) !important;
}
:host ::ng-deep .active\\:text-gray-300:active {
  color: var(--gray-300) !important;
}
:host ::ng-deep .active\\:text-gray-400:active {
  color: var(--gray-400) !important;
}
:host ::ng-deep .active\\:text-gray-500:active {
  color: var(--gray-500) !important;
}
:host ::ng-deep .active\\:text-gray-600:active {
  color: var(--gray-600) !important;
}
:host ::ng-deep .active\\:text-gray-700:active {
  color: var(--gray-700) !important;
}
:host ::ng-deep .active\\:text-gray-800:active {
  color: var(--gray-800) !important;
}
:host ::ng-deep .active\\:text-gray-900:active {
  color: var(--gray-900) !important;
}
:host ::ng-deep .text-red-50 {
  color: var(--red-50) !important;
}
:host ::ng-deep .text-red-100 {
  color: var(--red-100) !important;
}
:host ::ng-deep .text-red-200 {
  color: var(--red-200) !important;
}
:host ::ng-deep .text-red-300 {
  color: var(--red-300) !important;
}
:host ::ng-deep .text-red-400 {
  color: var(--red-400) !important;
}
:host ::ng-deep .text-red-500 {
  color: var(--red-500) !important;
}
:host ::ng-deep .text-red-600 {
  color: var(--red-600) !important;
}
:host ::ng-deep .text-red-700 {
  color: var(--red-700) !important;
}
:host ::ng-deep .text-red-800 {
  color: var(--red-800) !important;
}
:host ::ng-deep .text-red-900 {
  color: var(--red-900) !important;
}
:host ::ng-deep .focus\\:text-red-50:focus {
  color: var(--red-50) !important;
}
:host ::ng-deep .focus\\:text-red-100:focus {
  color: var(--red-100) !important;
}
:host ::ng-deep .focus\\:text-red-200:focus {
  color: var(--red-200) !important;
}
:host ::ng-deep .focus\\:text-red-300:focus {
  color: var(--red-300) !important;
}
:host ::ng-deep .focus\\:text-red-400:focus {
  color: var(--red-400) !important;
}
:host ::ng-deep .focus\\:text-red-500:focus {
  color: var(--red-500) !important;
}
:host ::ng-deep .focus\\:text-red-600:focus {
  color: var(--red-600) !important;
}
:host ::ng-deep .focus\\:text-red-700:focus {
  color: var(--red-700) !important;
}
:host ::ng-deep .focus\\:text-red-800:focus {
  color: var(--red-800) !important;
}
:host ::ng-deep .focus\\:text-red-900:focus {
  color: var(--red-900) !important;
}
:host ::ng-deep .hover\\:text-red-50:hover {
  color: var(--red-50) !important;
}
:host ::ng-deep .hover\\:text-red-100:hover {
  color: var(--red-100) !important;
}
:host ::ng-deep .hover\\:text-red-200:hover {
  color: var(--red-200) !important;
}
:host ::ng-deep .hover\\:text-red-300:hover {
  color: var(--red-300) !important;
}
:host ::ng-deep .hover\\:text-red-400:hover {
  color: var(--red-400) !important;
}
:host ::ng-deep .hover\\:text-red-500:hover {
  color: var(--red-500) !important;
}
:host ::ng-deep .hover\\:text-red-600:hover {
  color: var(--red-600) !important;
}
:host ::ng-deep .hover\\:text-red-700:hover {
  color: var(--red-700) !important;
}
:host ::ng-deep .hover\\:text-red-800:hover {
  color: var(--red-800) !important;
}
:host ::ng-deep .hover\\:text-red-900:hover {
  color: var(--red-900) !important;
}
:host ::ng-deep .active\\:text-red-50:active {
  color: var(--red-50) !important;
}
:host ::ng-deep .active\\:text-red-100:active {
  color: var(--red-100) !important;
}
:host ::ng-deep .active\\:text-red-200:active {
  color: var(--red-200) !important;
}
:host ::ng-deep .active\\:text-red-300:active {
  color: var(--red-300) !important;
}
:host ::ng-deep .active\\:text-red-400:active {
  color: var(--red-400) !important;
}
:host ::ng-deep .active\\:text-red-500:active {
  color: var(--red-500) !important;
}
:host ::ng-deep .active\\:text-red-600:active {
  color: var(--red-600) !important;
}
:host ::ng-deep .active\\:text-red-700:active {
  color: var(--red-700) !important;
}
:host ::ng-deep .active\\:text-red-800:active {
  color: var(--red-800) !important;
}
:host ::ng-deep .active\\:text-red-900:active {
  color: var(--red-900) !important;
}
:host ::ng-deep .text-primary-50 {
  color: var(--primary-50) !important;
}
:host ::ng-deep .text-primary-100 {
  color: var(--primary-100) !important;
}
:host ::ng-deep .text-primary-200 {
  color: var(--primary-200) !important;
}
:host ::ng-deep .text-primary-300 {
  color: var(--primary-300) !important;
}
:host ::ng-deep .text-primary-400 {
  color: var(--primary-400) !important;
}
:host ::ng-deep .text-primary-500 {
  color: var(--primary-500) !important;
}
:host ::ng-deep .text-primary-600 {
  color: var(--primary-600) !important;
}
:host ::ng-deep .text-primary-700 {
  color: var(--primary-700) !important;
}
:host ::ng-deep .text-primary-800 {
  color: var(--primary-800) !important;
}
:host ::ng-deep .text-primary-900 {
  color: var(--primary-900) !important;
}
:host ::ng-deep .focus\\:text-primary-50:focus {
  color: var(--primary-50) !important;
}
:host ::ng-deep .focus\\:text-primary-100:focus {
  color: var(--primary-100) !important;
}
:host ::ng-deep .focus\\:text-primary-200:focus {
  color: var(--primary-200) !important;
}
:host ::ng-deep .focus\\:text-primary-300:focus {
  color: var(--primary-300) !important;
}
:host ::ng-deep .focus\\:text-primary-400:focus {
  color: var(--primary-400) !important;
}
:host ::ng-deep .focus\\:text-primary-500:focus {
  color: var(--primary-500) !important;
}
:host ::ng-deep .focus\\:text-primary-600:focus {
  color: var(--primary-600) !important;
}
:host ::ng-deep .focus\\:text-primary-700:focus {
  color: var(--primary-700) !important;
}
:host ::ng-deep .focus\\:text-primary-800:focus {
  color: var(--primary-800) !important;
}
:host ::ng-deep .focus\\:text-primary-900:focus {
  color: var(--primary-900) !important;
}
:host ::ng-deep .hover\\:text-primary-50:hover {
  color: var(--primary-50) !important;
}
:host ::ng-deep .hover\\:text-primary-100:hover {
  color: var(--primary-100) !important;
}
:host ::ng-deep .hover\\:text-primary-200:hover {
  color: var(--primary-200) !important;
}
:host ::ng-deep .hover\\:text-primary-300:hover {
  color: var(--primary-300) !important;
}
:host ::ng-deep .hover\\:text-primary-400:hover {
  color: var(--primary-400) !important;
}
:host ::ng-deep .hover\\:text-primary-500:hover {
  color: var(--primary-500) !important;
}
:host ::ng-deep .hover\\:text-primary-600:hover {
  color: var(--primary-600) !important;
}
:host ::ng-deep .hover\\:text-primary-700:hover {
  color: var(--primary-700) !important;
}
:host ::ng-deep .hover\\:text-primary-800:hover {
  color: var(--primary-800) !important;
}
:host ::ng-deep .hover\\:text-primary-900:hover {
  color: var(--primary-900) !important;
}
:host ::ng-deep .active\\:text-primary-50:active {
  color: var(--primary-50) !important;
}
:host ::ng-deep .active\\:text-primary-100:active {
  color: var(--primary-100) !important;
}
:host ::ng-deep .active\\:text-primary-200:active {
  color: var(--primary-200) !important;
}
:host ::ng-deep .active\\:text-primary-300:active {
  color: var(--primary-300) !important;
}
:host ::ng-deep .active\\:text-primary-400:active {
  color: var(--primary-400) !important;
}
:host ::ng-deep .active\\:text-primary-500:active {
  color: var(--primary-500) !important;
}
:host ::ng-deep .active\\:text-primary-600:active {
  color: var(--primary-600) !important;
}
:host ::ng-deep .active\\:text-primary-700:active {
  color: var(--primary-700) !important;
}
:host ::ng-deep .active\\:text-primary-800:active {
  color: var(--primary-800) !important;
}
:host ::ng-deep .active\\:text-primary-900:active {
  color: var(--primary-900) !important;
}
:host ::ng-deep .bg-blue-50 {
  background-color: var(--blue-50) !important;
}
:host ::ng-deep .bg-blue-100 {
  background-color: var(--blue-100) !important;
}
:host ::ng-deep .bg-blue-200 {
  background-color: var(--blue-200) !important;
}
:host ::ng-deep .bg-blue-300 {
  background-color: var(--blue-300) !important;
}
:host ::ng-deep .bg-blue-400 {
  background-color: var(--blue-400) !important;
}
:host ::ng-deep .bg-blue-500 {
  background-color: var(--blue-500) !important;
}
:host ::ng-deep .bg-blue-600 {
  background-color: var(--blue-600) !important;
}
:host ::ng-deep .bg-blue-700 {
  background-color: var(--blue-700) !important;
}
:host ::ng-deep .bg-blue-800 {
  background-color: var(--blue-800) !important;
}
:host ::ng-deep .bg-blue-900 {
  background-color: var(--blue-900) !important;
}
:host ::ng-deep .focus\\:bg-blue-50:focus {
  background-color: var(--blue-50) !important;
}
:host ::ng-deep .focus\\:bg-blue-100:focus {
  background-color: var(--blue-100) !important;
}
:host ::ng-deep .focus\\:bg-blue-200:focus {
  background-color: var(--blue-200) !important;
}
:host ::ng-deep .focus\\:bg-blue-300:focus {
  background-color: var(--blue-300) !important;
}
:host ::ng-deep .focus\\:bg-blue-400:focus {
  background-color: var(--blue-400) !important;
}
:host ::ng-deep .focus\\:bg-blue-500:focus {
  background-color: var(--blue-500) !important;
}
:host ::ng-deep .focus\\:bg-blue-600:focus {
  background-color: var(--blue-600) !important;
}
:host ::ng-deep .focus\\:bg-blue-700:focus {
  background-color: var(--blue-700) !important;
}
:host ::ng-deep .focus\\:bg-blue-800:focus {
  background-color: var(--blue-800) !important;
}
:host ::ng-deep .focus\\:bg-blue-900:focus {
  background-color: var(--blue-900) !important;
}
:host ::ng-deep .hover\\:bg-blue-50:hover {
  background-color: var(--blue-50) !important;
}
:host ::ng-deep .hover\\:bg-blue-100:hover {
  background-color: var(--blue-100) !important;
}
:host ::ng-deep .hover\\:bg-blue-200:hover {
  background-color: var(--blue-200) !important;
}
:host ::ng-deep .hover\\:bg-blue-300:hover {
  background-color: var(--blue-300) !important;
}
:host ::ng-deep .hover\\:bg-blue-400:hover {
  background-color: var(--blue-400) !important;
}
:host ::ng-deep .hover\\:bg-blue-500:hover {
  background-color: var(--blue-500) !important;
}
:host ::ng-deep .hover\\:bg-blue-600:hover {
  background-color: var(--blue-600) !important;
}
:host ::ng-deep .hover\\:bg-blue-700:hover {
  background-color: var(--blue-700) !important;
}
:host ::ng-deep .hover\\:bg-blue-800:hover {
  background-color: var(--blue-800) !important;
}
:host ::ng-deep .hover\\:bg-blue-900:hover {
  background-color: var(--blue-900) !important;
}
:host ::ng-deep .active\\:bg-blue-50:active {
  background-color: var(--blue-50) !important;
}
:host ::ng-deep .active\\:bg-blue-100:active {
  background-color: var(--blue-100) !important;
}
:host ::ng-deep .active\\:bg-blue-200:active {
  background-color: var(--blue-200) !important;
}
:host ::ng-deep .active\\:bg-blue-300:active {
  background-color: var(--blue-300) !important;
}
:host ::ng-deep .active\\:bg-blue-400:active {
  background-color: var(--blue-400) !important;
}
:host ::ng-deep .active\\:bg-blue-500:active {
  background-color: var(--blue-500) !important;
}
:host ::ng-deep .active\\:bg-blue-600:active {
  background-color: var(--blue-600) !important;
}
:host ::ng-deep .active\\:bg-blue-700:active {
  background-color: var(--blue-700) !important;
}
:host ::ng-deep .active\\:bg-blue-800:active {
  background-color: var(--blue-800) !important;
}
:host ::ng-deep .active\\:bg-blue-900:active {
  background-color: var(--blue-900) !important;
}
:host ::ng-deep .bg-green-50 {
  background-color: var(--green-50) !important;
}
:host ::ng-deep .bg-green-100 {
  background-color: var(--green-100) !important;
}
:host ::ng-deep .bg-green-200 {
  background-color: var(--green-200) !important;
}
:host ::ng-deep .bg-green-300 {
  background-color: var(--green-300) !important;
}
:host ::ng-deep .bg-green-400 {
  background-color: var(--green-400) !important;
}
:host ::ng-deep .bg-green-500 {
  background-color: var(--green-500) !important;
}
:host ::ng-deep .bg-green-600 {
  background-color: var(--green-600) !important;
}
:host ::ng-deep .bg-green-700 {
  background-color: var(--green-700) !important;
}
:host ::ng-deep .bg-green-800 {
  background-color: var(--green-800) !important;
}
:host ::ng-deep .bg-green-900 {
  background-color: var(--green-900) !important;
}
:host ::ng-deep .focus\\:bg-green-50:focus {
  background-color: var(--green-50) !important;
}
:host ::ng-deep .focus\\:bg-green-100:focus {
  background-color: var(--green-100) !important;
}
:host ::ng-deep .focus\\:bg-green-200:focus {
  background-color: var(--green-200) !important;
}
:host ::ng-deep .focus\\:bg-green-300:focus {
  background-color: var(--green-300) !important;
}
:host ::ng-deep .focus\\:bg-green-400:focus {
  background-color: var(--green-400) !important;
}
:host ::ng-deep .focus\\:bg-green-500:focus {
  background-color: var(--green-500) !important;
}
:host ::ng-deep .focus\\:bg-green-600:focus {
  background-color: var(--green-600) !important;
}
:host ::ng-deep .focus\\:bg-green-700:focus {
  background-color: var(--green-700) !important;
}
:host ::ng-deep .focus\\:bg-green-800:focus {
  background-color: var(--green-800) !important;
}
:host ::ng-deep .focus\\:bg-green-900:focus {
  background-color: var(--green-900) !important;
}
:host ::ng-deep .hover\\:bg-green-50:hover {
  background-color: var(--green-50) !important;
}
:host ::ng-deep .hover\\:bg-green-100:hover {
  background-color: var(--green-100) !important;
}
:host ::ng-deep .hover\\:bg-green-200:hover {
  background-color: var(--green-200) !important;
}
:host ::ng-deep .hover\\:bg-green-300:hover {
  background-color: var(--green-300) !important;
}
:host ::ng-deep .hover\\:bg-green-400:hover {
  background-color: var(--green-400) !important;
}
:host ::ng-deep .hover\\:bg-green-500:hover {
  background-color: var(--green-500) !important;
}
:host ::ng-deep .hover\\:bg-green-600:hover {
  background-color: var(--green-600) !important;
}
:host ::ng-deep .hover\\:bg-green-700:hover {
  background-color: var(--green-700) !important;
}
:host ::ng-deep .hover\\:bg-green-800:hover {
  background-color: var(--green-800) !important;
}
:host ::ng-deep .hover\\:bg-green-900:hover {
  background-color: var(--green-900) !important;
}
:host ::ng-deep .active\\:bg-green-50:active {
  background-color: var(--green-50) !important;
}
:host ::ng-deep .active\\:bg-green-100:active {
  background-color: var(--green-100) !important;
}
:host ::ng-deep .active\\:bg-green-200:active {
  background-color: var(--green-200) !important;
}
:host ::ng-deep .active\\:bg-green-300:active {
  background-color: var(--green-300) !important;
}
:host ::ng-deep .active\\:bg-green-400:active {
  background-color: var(--green-400) !important;
}
:host ::ng-deep .active\\:bg-green-500:active {
  background-color: var(--green-500) !important;
}
:host ::ng-deep .active\\:bg-green-600:active {
  background-color: var(--green-600) !important;
}
:host ::ng-deep .active\\:bg-green-700:active {
  background-color: var(--green-700) !important;
}
:host ::ng-deep .active\\:bg-green-800:active {
  background-color: var(--green-800) !important;
}
:host ::ng-deep .active\\:bg-green-900:active {
  background-color: var(--green-900) !important;
}
:host ::ng-deep .bg-yellow-50 {
  background-color: var(--yellow-50) !important;
}
:host ::ng-deep .bg-yellow-100 {
  background-color: var(--yellow-100) !important;
}
:host ::ng-deep .bg-yellow-200 {
  background-color: var(--yellow-200) !important;
}
:host ::ng-deep .bg-yellow-300 {
  background-color: var(--yellow-300) !important;
}
:host ::ng-deep .bg-yellow-400 {
  background-color: var(--yellow-400) !important;
}
:host ::ng-deep .bg-yellow-500 {
  background-color: var(--yellow-500) !important;
}
:host ::ng-deep .bg-yellow-600 {
  background-color: var(--yellow-600) !important;
}
:host ::ng-deep .bg-yellow-700 {
  background-color: var(--yellow-700) !important;
}
:host ::ng-deep .bg-yellow-800 {
  background-color: var(--yellow-800) !important;
}
:host ::ng-deep .bg-yellow-900 {
  background-color: var(--yellow-900) !important;
}
:host ::ng-deep .focus\\:bg-yellow-50:focus {
  background-color: var(--yellow-50) !important;
}
:host ::ng-deep .focus\\:bg-yellow-100:focus {
  background-color: var(--yellow-100) !important;
}
:host ::ng-deep .focus\\:bg-yellow-200:focus {
  background-color: var(--yellow-200) !important;
}
:host ::ng-deep .focus\\:bg-yellow-300:focus {
  background-color: var(--yellow-300) !important;
}
:host ::ng-deep .focus\\:bg-yellow-400:focus {
  background-color: var(--yellow-400) !important;
}
:host ::ng-deep .focus\\:bg-yellow-500:focus {
  background-color: var(--yellow-500) !important;
}
:host ::ng-deep .focus\\:bg-yellow-600:focus {
  background-color: var(--yellow-600) !important;
}
:host ::ng-deep .focus\\:bg-yellow-700:focus {
  background-color: var(--yellow-700) !important;
}
:host ::ng-deep .focus\\:bg-yellow-800:focus {
  background-color: var(--yellow-800) !important;
}
:host ::ng-deep .focus\\:bg-yellow-900:focus {
  background-color: var(--yellow-900) !important;
}
:host ::ng-deep .hover\\:bg-yellow-50:hover {
  background-color: var(--yellow-50) !important;
}
:host ::ng-deep .hover\\:bg-yellow-100:hover {
  background-color: var(--yellow-100) !important;
}
:host ::ng-deep .hover\\:bg-yellow-200:hover {
  background-color: var(--yellow-200) !important;
}
:host ::ng-deep .hover\\:bg-yellow-300:hover {
  background-color: var(--yellow-300) !important;
}
:host ::ng-deep .hover\\:bg-yellow-400:hover {
  background-color: var(--yellow-400) !important;
}
:host ::ng-deep .hover\\:bg-yellow-500:hover {
  background-color: var(--yellow-500) !important;
}
:host ::ng-deep .hover\\:bg-yellow-600:hover {
  background-color: var(--yellow-600) !important;
}
:host ::ng-deep .hover\\:bg-yellow-700:hover {
  background-color: var(--yellow-700) !important;
}
:host ::ng-deep .hover\\:bg-yellow-800:hover {
  background-color: var(--yellow-800) !important;
}
:host ::ng-deep .hover\\:bg-yellow-900:hover {
  background-color: var(--yellow-900) !important;
}
:host ::ng-deep .active\\:bg-yellow-50:active {
  background-color: var(--yellow-50) !important;
}
:host ::ng-deep .active\\:bg-yellow-100:active {
  background-color: var(--yellow-100) !important;
}
:host ::ng-deep .active\\:bg-yellow-200:active {
  background-color: var(--yellow-200) !important;
}
:host ::ng-deep .active\\:bg-yellow-300:active {
  background-color: var(--yellow-300) !important;
}
:host ::ng-deep .active\\:bg-yellow-400:active {
  background-color: var(--yellow-400) !important;
}
:host ::ng-deep .active\\:bg-yellow-500:active {
  background-color: var(--yellow-500) !important;
}
:host ::ng-deep .active\\:bg-yellow-600:active {
  background-color: var(--yellow-600) !important;
}
:host ::ng-deep .active\\:bg-yellow-700:active {
  background-color: var(--yellow-700) !important;
}
:host ::ng-deep .active\\:bg-yellow-800:active {
  background-color: var(--yellow-800) !important;
}
:host ::ng-deep .active\\:bg-yellow-900:active {
  background-color: var(--yellow-900) !important;
}
:host ::ng-deep .bg-cyan-50 {
  background-color: var(--cyan-50) !important;
}
:host ::ng-deep .bg-cyan-100 {
  background-color: var(--cyan-100) !important;
}
:host ::ng-deep .bg-cyan-200 {
  background-color: var(--cyan-200) !important;
}
:host ::ng-deep .bg-cyan-300 {
  background-color: var(--cyan-300) !important;
}
:host ::ng-deep .bg-cyan-400 {
  background-color: var(--cyan-400) !important;
}
:host ::ng-deep .bg-cyan-500 {
  background-color: var(--cyan-500) !important;
}
:host ::ng-deep .bg-cyan-600 {
  background-color: var(--cyan-600) !important;
}
:host ::ng-deep .bg-cyan-700 {
  background-color: var(--cyan-700) !important;
}
:host ::ng-deep .bg-cyan-800 {
  background-color: var(--cyan-800) !important;
}
:host ::ng-deep .bg-cyan-900 {
  background-color: var(--cyan-900) !important;
}
:host ::ng-deep .focus\\:bg-cyan-50:focus {
  background-color: var(--cyan-50) !important;
}
:host ::ng-deep .focus\\:bg-cyan-100:focus {
  background-color: var(--cyan-100) !important;
}
:host ::ng-deep .focus\\:bg-cyan-200:focus {
  background-color: var(--cyan-200) !important;
}
:host ::ng-deep .focus\\:bg-cyan-300:focus {
  background-color: var(--cyan-300) !important;
}
:host ::ng-deep .focus\\:bg-cyan-400:focus {
  background-color: var(--cyan-400) !important;
}
:host ::ng-deep .focus\\:bg-cyan-500:focus {
  background-color: var(--cyan-500) !important;
}
:host ::ng-deep .focus\\:bg-cyan-600:focus {
  background-color: var(--cyan-600) !important;
}
:host ::ng-deep .focus\\:bg-cyan-700:focus {
  background-color: var(--cyan-700) !important;
}
:host ::ng-deep .focus\\:bg-cyan-800:focus {
  background-color: var(--cyan-800) !important;
}
:host ::ng-deep .focus\\:bg-cyan-900:focus {
  background-color: var(--cyan-900) !important;
}
:host ::ng-deep .hover\\:bg-cyan-50:hover {
  background-color: var(--cyan-50) !important;
}
:host ::ng-deep .hover\\:bg-cyan-100:hover {
  background-color: var(--cyan-100) !important;
}
:host ::ng-deep .hover\\:bg-cyan-200:hover {
  background-color: var(--cyan-200) !important;
}
:host ::ng-deep .hover\\:bg-cyan-300:hover {
  background-color: var(--cyan-300) !important;
}
:host ::ng-deep .hover\\:bg-cyan-400:hover {
  background-color: var(--cyan-400) !important;
}
:host ::ng-deep .hover\\:bg-cyan-500:hover {
  background-color: var(--cyan-500) !important;
}
:host ::ng-deep .hover\\:bg-cyan-600:hover {
  background-color: var(--cyan-600) !important;
}
:host ::ng-deep .hover\\:bg-cyan-700:hover {
  background-color: var(--cyan-700) !important;
}
:host ::ng-deep .hover\\:bg-cyan-800:hover {
  background-color: var(--cyan-800) !important;
}
:host ::ng-deep .hover\\:bg-cyan-900:hover {
  background-color: var(--cyan-900) !important;
}
:host ::ng-deep .active\\:bg-cyan-50:active {
  background-color: var(--cyan-50) !important;
}
:host ::ng-deep .active\\:bg-cyan-100:active {
  background-color: var(--cyan-100) !important;
}
:host ::ng-deep .active\\:bg-cyan-200:active {
  background-color: var(--cyan-200) !important;
}
:host ::ng-deep .active\\:bg-cyan-300:active {
  background-color: var(--cyan-300) !important;
}
:host ::ng-deep .active\\:bg-cyan-400:active {
  background-color: var(--cyan-400) !important;
}
:host ::ng-deep .active\\:bg-cyan-500:active {
  background-color: var(--cyan-500) !important;
}
:host ::ng-deep .active\\:bg-cyan-600:active {
  background-color: var(--cyan-600) !important;
}
:host ::ng-deep .active\\:bg-cyan-700:active {
  background-color: var(--cyan-700) !important;
}
:host ::ng-deep .active\\:bg-cyan-800:active {
  background-color: var(--cyan-800) !important;
}
:host ::ng-deep .active\\:bg-cyan-900:active {
  background-color: var(--cyan-900) !important;
}
:host ::ng-deep .bg-pink-50 {
  background-color: var(--pink-50) !important;
}
:host ::ng-deep .bg-pink-100 {
  background-color: var(--pink-100) !important;
}
:host ::ng-deep .bg-pink-200 {
  background-color: var(--pink-200) !important;
}
:host ::ng-deep .bg-pink-300 {
  background-color: var(--pink-300) !important;
}
:host ::ng-deep .bg-pink-400 {
  background-color: var(--pink-400) !important;
}
:host ::ng-deep .bg-pink-500 {
  background-color: var(--pink-500) !important;
}
:host ::ng-deep .bg-pink-600 {
  background-color: var(--pink-600) !important;
}
:host ::ng-deep .bg-pink-700 {
  background-color: var(--pink-700) !important;
}
:host ::ng-deep .bg-pink-800 {
  background-color: var(--pink-800) !important;
}
:host ::ng-deep .bg-pink-900 {
  background-color: var(--pink-900) !important;
}
:host ::ng-deep .focus\\:bg-pink-50:focus {
  background-color: var(--pink-50) !important;
}
:host ::ng-deep .focus\\:bg-pink-100:focus {
  background-color: var(--pink-100) !important;
}
:host ::ng-deep .focus\\:bg-pink-200:focus {
  background-color: var(--pink-200) !important;
}
:host ::ng-deep .focus\\:bg-pink-300:focus {
  background-color: var(--pink-300) !important;
}
:host ::ng-deep .focus\\:bg-pink-400:focus {
  background-color: var(--pink-400) !important;
}
:host ::ng-deep .focus\\:bg-pink-500:focus {
  background-color: var(--pink-500) !important;
}
:host ::ng-deep .focus\\:bg-pink-600:focus {
  background-color: var(--pink-600) !important;
}
:host ::ng-deep .focus\\:bg-pink-700:focus {
  background-color: var(--pink-700) !important;
}
:host ::ng-deep .focus\\:bg-pink-800:focus {
  background-color: var(--pink-800) !important;
}
:host ::ng-deep .focus\\:bg-pink-900:focus {
  background-color: var(--pink-900) !important;
}
:host ::ng-deep .hover\\:bg-pink-50:hover {
  background-color: var(--pink-50) !important;
}
:host ::ng-deep .hover\\:bg-pink-100:hover {
  background-color: var(--pink-100) !important;
}
:host ::ng-deep .hover\\:bg-pink-200:hover {
  background-color: var(--pink-200) !important;
}
:host ::ng-deep .hover\\:bg-pink-300:hover {
  background-color: var(--pink-300) !important;
}
:host ::ng-deep .hover\\:bg-pink-400:hover {
  background-color: var(--pink-400) !important;
}
:host ::ng-deep .hover\\:bg-pink-500:hover {
  background-color: var(--pink-500) !important;
}
:host ::ng-deep .hover\\:bg-pink-600:hover {
  background-color: var(--pink-600) !important;
}
:host ::ng-deep .hover\\:bg-pink-700:hover {
  background-color: var(--pink-700) !important;
}
:host ::ng-deep .hover\\:bg-pink-800:hover {
  background-color: var(--pink-800) !important;
}
:host ::ng-deep .hover\\:bg-pink-900:hover {
  background-color: var(--pink-900) !important;
}
:host ::ng-deep .active\\:bg-pink-50:active {
  background-color: var(--pink-50) !important;
}
:host ::ng-deep .active\\:bg-pink-100:active {
  background-color: var(--pink-100) !important;
}
:host ::ng-deep .active\\:bg-pink-200:active {
  background-color: var(--pink-200) !important;
}
:host ::ng-deep .active\\:bg-pink-300:active {
  background-color: var(--pink-300) !important;
}
:host ::ng-deep .active\\:bg-pink-400:active {
  background-color: var(--pink-400) !important;
}
:host ::ng-deep .active\\:bg-pink-500:active {
  background-color: var(--pink-500) !important;
}
:host ::ng-deep .active\\:bg-pink-600:active {
  background-color: var(--pink-600) !important;
}
:host ::ng-deep .active\\:bg-pink-700:active {
  background-color: var(--pink-700) !important;
}
:host ::ng-deep .active\\:bg-pink-800:active {
  background-color: var(--pink-800) !important;
}
:host ::ng-deep .active\\:bg-pink-900:active {
  background-color: var(--pink-900) !important;
}
:host ::ng-deep .bg-indigo-50 {
  background-color: var(--indigo-50) !important;
}
:host ::ng-deep .bg-indigo-100 {
  background-color: var(--indigo-100) !important;
}
:host ::ng-deep .bg-indigo-200 {
  background-color: var(--indigo-200) !important;
}
:host ::ng-deep .bg-indigo-300 {
  background-color: var(--indigo-300) !important;
}
:host ::ng-deep .bg-indigo-400 {
  background-color: var(--indigo-400) !important;
}
:host ::ng-deep .bg-indigo-500 {
  background-color: var(--indigo-500) !important;
}
:host ::ng-deep .bg-indigo-600 {
  background-color: var(--indigo-600) !important;
}
:host ::ng-deep .bg-indigo-700 {
  background-color: var(--indigo-700) !important;
}
:host ::ng-deep .bg-indigo-800 {
  background-color: var(--indigo-800) !important;
}
:host ::ng-deep .bg-indigo-900 {
  background-color: var(--indigo-900) !important;
}
:host ::ng-deep .focus\\:bg-indigo-50:focus {
  background-color: var(--indigo-50) !important;
}
:host ::ng-deep .focus\\:bg-indigo-100:focus {
  background-color: var(--indigo-100) !important;
}
:host ::ng-deep .focus\\:bg-indigo-200:focus {
  background-color: var(--indigo-200) !important;
}
:host ::ng-deep .focus\\:bg-indigo-300:focus {
  background-color: var(--indigo-300) !important;
}
:host ::ng-deep .focus\\:bg-indigo-400:focus {
  background-color: var(--indigo-400) !important;
}
:host ::ng-deep .focus\\:bg-indigo-500:focus {
  background-color: var(--indigo-500) !important;
}
:host ::ng-deep .focus\\:bg-indigo-600:focus {
  background-color: var(--indigo-600) !important;
}
:host ::ng-deep .focus\\:bg-indigo-700:focus {
  background-color: var(--indigo-700) !important;
}
:host ::ng-deep .focus\\:bg-indigo-800:focus {
  background-color: var(--indigo-800) !important;
}
:host ::ng-deep .focus\\:bg-indigo-900:focus {
  background-color: var(--indigo-900) !important;
}
:host ::ng-deep .hover\\:bg-indigo-50:hover {
  background-color: var(--indigo-50) !important;
}
:host ::ng-deep .hover\\:bg-indigo-100:hover {
  background-color: var(--indigo-100) !important;
}
:host ::ng-deep .hover\\:bg-indigo-200:hover {
  background-color: var(--indigo-200) !important;
}
:host ::ng-deep .hover\\:bg-indigo-300:hover {
  background-color: var(--indigo-300) !important;
}
:host ::ng-deep .hover\\:bg-indigo-400:hover {
  background-color: var(--indigo-400) !important;
}
:host ::ng-deep .hover\\:bg-indigo-500:hover {
  background-color: var(--indigo-500) !important;
}
:host ::ng-deep .hover\\:bg-indigo-600:hover {
  background-color: var(--indigo-600) !important;
}
:host ::ng-deep .hover\\:bg-indigo-700:hover {
  background-color: var(--indigo-700) !important;
}
:host ::ng-deep .hover\\:bg-indigo-800:hover {
  background-color: var(--indigo-800) !important;
}
:host ::ng-deep .hover\\:bg-indigo-900:hover {
  background-color: var(--indigo-900) !important;
}
:host ::ng-deep .active\\:bg-indigo-50:active {
  background-color: var(--indigo-50) !important;
}
:host ::ng-deep .active\\:bg-indigo-100:active {
  background-color: var(--indigo-100) !important;
}
:host ::ng-deep .active\\:bg-indigo-200:active {
  background-color: var(--indigo-200) !important;
}
:host ::ng-deep .active\\:bg-indigo-300:active {
  background-color: var(--indigo-300) !important;
}
:host ::ng-deep .active\\:bg-indigo-400:active {
  background-color: var(--indigo-400) !important;
}
:host ::ng-deep .active\\:bg-indigo-500:active {
  background-color: var(--indigo-500) !important;
}
:host ::ng-deep .active\\:bg-indigo-600:active {
  background-color: var(--indigo-600) !important;
}
:host ::ng-deep .active\\:bg-indigo-700:active {
  background-color: var(--indigo-700) !important;
}
:host ::ng-deep .active\\:bg-indigo-800:active {
  background-color: var(--indigo-800) !important;
}
:host ::ng-deep .active\\:bg-indigo-900:active {
  background-color: var(--indigo-900) !important;
}
:host ::ng-deep .bg-teal-50 {
  background-color: var(--teal-50) !important;
}
:host ::ng-deep .bg-teal-100 {
  background-color: var(--teal-100) !important;
}
:host ::ng-deep .bg-teal-200 {
  background-color: var(--teal-200) !important;
}
:host ::ng-deep .bg-teal-300 {
  background-color: var(--teal-300) !important;
}
:host ::ng-deep .bg-teal-400 {
  background-color: var(--teal-400) !important;
}
:host ::ng-deep .bg-teal-500 {
  background-color: var(--teal-500) !important;
}
:host ::ng-deep .bg-teal-600 {
  background-color: var(--teal-600) !important;
}
:host ::ng-deep .bg-teal-700 {
  background-color: var(--teal-700) !important;
}
:host ::ng-deep .bg-teal-800 {
  background-color: var(--teal-800) !important;
}
:host ::ng-deep .bg-teal-900 {
  background-color: var(--teal-900) !important;
}
:host ::ng-deep .focus\\:bg-teal-50:focus {
  background-color: var(--teal-50) !important;
}
:host ::ng-deep .focus\\:bg-teal-100:focus {
  background-color: var(--teal-100) !important;
}
:host ::ng-deep .focus\\:bg-teal-200:focus {
  background-color: var(--teal-200) !important;
}
:host ::ng-deep .focus\\:bg-teal-300:focus {
  background-color: var(--teal-300) !important;
}
:host ::ng-deep .focus\\:bg-teal-400:focus {
  background-color: var(--teal-400) !important;
}
:host ::ng-deep .focus\\:bg-teal-500:focus {
  background-color: var(--teal-500) !important;
}
:host ::ng-deep .focus\\:bg-teal-600:focus {
  background-color: var(--teal-600) !important;
}
:host ::ng-deep .focus\\:bg-teal-700:focus {
  background-color: var(--teal-700) !important;
}
:host ::ng-deep .focus\\:bg-teal-800:focus {
  background-color: var(--teal-800) !important;
}
:host ::ng-deep .focus\\:bg-teal-900:focus {
  background-color: var(--teal-900) !important;
}
:host ::ng-deep .hover\\:bg-teal-50:hover {
  background-color: var(--teal-50) !important;
}
:host ::ng-deep .hover\\:bg-teal-100:hover {
  background-color: var(--teal-100) !important;
}
:host ::ng-deep .hover\\:bg-teal-200:hover {
  background-color: var(--teal-200) !important;
}
:host ::ng-deep .hover\\:bg-teal-300:hover {
  background-color: var(--teal-300) !important;
}
:host ::ng-deep .hover\\:bg-teal-400:hover {
  background-color: var(--teal-400) !important;
}
:host ::ng-deep .hover\\:bg-teal-500:hover {
  background-color: var(--teal-500) !important;
}
:host ::ng-deep .hover\\:bg-teal-600:hover {
  background-color: var(--teal-600) !important;
}
:host ::ng-deep .hover\\:bg-teal-700:hover {
  background-color: var(--teal-700) !important;
}
:host ::ng-deep .hover\\:bg-teal-800:hover {
  background-color: var(--teal-800) !important;
}
:host ::ng-deep .hover\\:bg-teal-900:hover {
  background-color: var(--teal-900) !important;
}
:host ::ng-deep .active\\:bg-teal-50:active {
  background-color: var(--teal-50) !important;
}
:host ::ng-deep .active\\:bg-teal-100:active {
  background-color: var(--teal-100) !important;
}
:host ::ng-deep .active\\:bg-teal-200:active {
  background-color: var(--teal-200) !important;
}
:host ::ng-deep .active\\:bg-teal-300:active {
  background-color: var(--teal-300) !important;
}
:host ::ng-deep .active\\:bg-teal-400:active {
  background-color: var(--teal-400) !important;
}
:host ::ng-deep .active\\:bg-teal-500:active {
  background-color: var(--teal-500) !important;
}
:host ::ng-deep .active\\:bg-teal-600:active {
  background-color: var(--teal-600) !important;
}
:host ::ng-deep .active\\:bg-teal-700:active {
  background-color: var(--teal-700) !important;
}
:host ::ng-deep .active\\:bg-teal-800:active {
  background-color: var(--teal-800) !important;
}
:host ::ng-deep .active\\:bg-teal-900:active {
  background-color: var(--teal-900) !important;
}
:host ::ng-deep .bg-orange-50 {
  background-color: var(--orange-50) !important;
}
:host ::ng-deep .bg-orange-100 {
  background-color: var(--orange-100) !important;
}
:host ::ng-deep .bg-orange-200 {
  background-color: var(--orange-200) !important;
}
:host ::ng-deep .bg-orange-300 {
  background-color: var(--orange-300) !important;
}
:host ::ng-deep .bg-orange-400 {
  background-color: var(--orange-400) !important;
}
:host ::ng-deep .bg-orange-500 {
  background-color: var(--orange-500) !important;
}
:host ::ng-deep .bg-orange-600 {
  background-color: var(--orange-600) !important;
}
:host ::ng-deep .bg-orange-700 {
  background-color: var(--orange-700) !important;
}
:host ::ng-deep .bg-orange-800 {
  background-color: var(--orange-800) !important;
}
:host ::ng-deep .bg-orange-900 {
  background-color: var(--orange-900) !important;
}
:host ::ng-deep .focus\\:bg-orange-50:focus {
  background-color: var(--orange-50) !important;
}
:host ::ng-deep .focus\\:bg-orange-100:focus {
  background-color: var(--orange-100) !important;
}
:host ::ng-deep .focus\\:bg-orange-200:focus {
  background-color: var(--orange-200) !important;
}
:host ::ng-deep .focus\\:bg-orange-300:focus {
  background-color: var(--orange-300) !important;
}
:host ::ng-deep .focus\\:bg-orange-400:focus {
  background-color: var(--orange-400) !important;
}
:host ::ng-deep .focus\\:bg-orange-500:focus {
  background-color: var(--orange-500) !important;
}
:host ::ng-deep .focus\\:bg-orange-600:focus {
  background-color: var(--orange-600) !important;
}
:host ::ng-deep .focus\\:bg-orange-700:focus {
  background-color: var(--orange-700) !important;
}
:host ::ng-deep .focus\\:bg-orange-800:focus {
  background-color: var(--orange-800) !important;
}
:host ::ng-deep .focus\\:bg-orange-900:focus {
  background-color: var(--orange-900) !important;
}
:host ::ng-deep .hover\\:bg-orange-50:hover {
  background-color: var(--orange-50) !important;
}
:host ::ng-deep .hover\\:bg-orange-100:hover {
  background-color: var(--orange-100) !important;
}
:host ::ng-deep .hover\\:bg-orange-200:hover {
  background-color: var(--orange-200) !important;
}
:host ::ng-deep .hover\\:bg-orange-300:hover {
  background-color: var(--orange-300) !important;
}
:host ::ng-deep .hover\\:bg-orange-400:hover {
  background-color: var(--orange-400) !important;
}
:host ::ng-deep .hover\\:bg-orange-500:hover {
  background-color: var(--orange-500) !important;
}
:host ::ng-deep .hover\\:bg-orange-600:hover {
  background-color: var(--orange-600) !important;
}
:host ::ng-deep .hover\\:bg-orange-700:hover {
  background-color: var(--orange-700) !important;
}
:host ::ng-deep .hover\\:bg-orange-800:hover {
  background-color: var(--orange-800) !important;
}
:host ::ng-deep .hover\\:bg-orange-900:hover {
  background-color: var(--orange-900) !important;
}
:host ::ng-deep .active\\:bg-orange-50:active {
  background-color: var(--orange-50) !important;
}
:host ::ng-deep .active\\:bg-orange-100:active {
  background-color: var(--orange-100) !important;
}
:host ::ng-deep .active\\:bg-orange-200:active {
  background-color: var(--orange-200) !important;
}
:host ::ng-deep .active\\:bg-orange-300:active {
  background-color: var(--orange-300) !important;
}
:host ::ng-deep .active\\:bg-orange-400:active {
  background-color: var(--orange-400) !important;
}
:host ::ng-deep .active\\:bg-orange-500:active {
  background-color: var(--orange-500) !important;
}
:host ::ng-deep .active\\:bg-orange-600:active {
  background-color: var(--orange-600) !important;
}
:host ::ng-deep .active\\:bg-orange-700:active {
  background-color: var(--orange-700) !important;
}
:host ::ng-deep .active\\:bg-orange-800:active {
  background-color: var(--orange-800) !important;
}
:host ::ng-deep .active\\:bg-orange-900:active {
  background-color: var(--orange-900) !important;
}
:host ::ng-deep .bg-bluegray-50 {
  background-color: var(--bluegray-50) !important;
}
:host ::ng-deep .bg-bluegray-100 {
  background-color: var(--bluegray-100) !important;
}
:host ::ng-deep .bg-bluegray-200 {
  background-color: var(--bluegray-200) !important;
}
:host ::ng-deep .bg-bluegray-300 {
  background-color: var(--bluegray-300) !important;
}
:host ::ng-deep .bg-bluegray-400 {
  background-color: var(--bluegray-400) !important;
}
:host ::ng-deep .bg-bluegray-500 {
  background-color: var(--bluegray-500) !important;
}
:host ::ng-deep .bg-bluegray-600 {
  background-color: var(--bluegray-600) !important;
}
:host ::ng-deep .bg-bluegray-700 {
  background-color: var(--bluegray-700) !important;
}
:host ::ng-deep .bg-bluegray-800 {
  background-color: var(--bluegray-800) !important;
}
:host ::ng-deep .bg-bluegray-900 {
  background-color: var(--bluegray-900) !important;
}
:host ::ng-deep .focus\\:bg-bluegray-50:focus {
  background-color: var(--bluegray-50) !important;
}
:host ::ng-deep .focus\\:bg-bluegray-100:focus {
  background-color: var(--bluegray-100) !important;
}
:host ::ng-deep .focus\\:bg-bluegray-200:focus {
  background-color: var(--bluegray-200) !important;
}
:host ::ng-deep .focus\\:bg-bluegray-300:focus {
  background-color: var(--bluegray-300) !important;
}
:host ::ng-deep .focus\\:bg-bluegray-400:focus {
  background-color: var(--bluegray-400) !important;
}
:host ::ng-deep .focus\\:bg-bluegray-500:focus {
  background-color: var(--bluegray-500) !important;
}
:host ::ng-deep .focus\\:bg-bluegray-600:focus {
  background-color: var(--bluegray-600) !important;
}
:host ::ng-deep .focus\\:bg-bluegray-700:focus {
  background-color: var(--bluegray-700) !important;
}
:host ::ng-deep .focus\\:bg-bluegray-800:focus {
  background-color: var(--bluegray-800) !important;
}
:host ::ng-deep .focus\\:bg-bluegray-900:focus {
  background-color: var(--bluegray-900) !important;
}
:host ::ng-deep .hover\\:bg-bluegray-50:hover {
  background-color: var(--bluegray-50) !important;
}
:host ::ng-deep .hover\\:bg-bluegray-100:hover {
  background-color: var(--bluegray-100) !important;
}
:host ::ng-deep .hover\\:bg-bluegray-200:hover {
  background-color: var(--bluegray-200) !important;
}
:host ::ng-deep .hover\\:bg-bluegray-300:hover {
  background-color: var(--bluegray-300) !important;
}
:host ::ng-deep .hover\\:bg-bluegray-400:hover {
  background-color: var(--bluegray-400) !important;
}
:host ::ng-deep .hover\\:bg-bluegray-500:hover {
  background-color: var(--bluegray-500) !important;
}
:host ::ng-deep .hover\\:bg-bluegray-600:hover {
  background-color: var(--bluegray-600) !important;
}
:host ::ng-deep .hover\\:bg-bluegray-700:hover {
  background-color: var(--bluegray-700) !important;
}
:host ::ng-deep .hover\\:bg-bluegray-800:hover {
  background-color: var(--bluegray-800) !important;
}
:host ::ng-deep .hover\\:bg-bluegray-900:hover {
  background-color: var(--bluegray-900) !important;
}
:host ::ng-deep .active\\:bg-bluegray-50:active {
  background-color: var(--bluegray-50) !important;
}
:host ::ng-deep .active\\:bg-bluegray-100:active {
  background-color: var(--bluegray-100) !important;
}
:host ::ng-deep .active\\:bg-bluegray-200:active {
  background-color: var(--bluegray-200) !important;
}
:host ::ng-deep .active\\:bg-bluegray-300:active {
  background-color: var(--bluegray-300) !important;
}
:host ::ng-deep .active\\:bg-bluegray-400:active {
  background-color: var(--bluegray-400) !important;
}
:host ::ng-deep .active\\:bg-bluegray-500:active {
  background-color: var(--bluegray-500) !important;
}
:host ::ng-deep .active\\:bg-bluegray-600:active {
  background-color: var(--bluegray-600) !important;
}
:host ::ng-deep .active\\:bg-bluegray-700:active {
  background-color: var(--bluegray-700) !important;
}
:host ::ng-deep .active\\:bg-bluegray-800:active {
  background-color: var(--bluegray-800) !important;
}
:host ::ng-deep .active\\:bg-bluegray-900:active {
  background-color: var(--bluegray-900) !important;
}
:host ::ng-deep .bg-purple-50 {
  background-color: var(--purple-50) !important;
}
:host ::ng-deep .bg-purple-100 {
  background-color: var(--purple-100) !important;
}
:host ::ng-deep .bg-purple-200 {
  background-color: var(--purple-200) !important;
}
:host ::ng-deep .bg-purple-300 {
  background-color: var(--purple-300) !important;
}
:host ::ng-deep .bg-purple-400 {
  background-color: var(--purple-400) !important;
}
:host ::ng-deep .bg-purple-500 {
  background-color: var(--purple-500) !important;
}
:host ::ng-deep .bg-purple-600 {
  background-color: var(--purple-600) !important;
}
:host ::ng-deep .bg-purple-700 {
  background-color: var(--purple-700) !important;
}
:host ::ng-deep .bg-purple-800 {
  background-color: var(--purple-800) !important;
}
:host ::ng-deep .bg-purple-900 {
  background-color: var(--purple-900) !important;
}
:host ::ng-deep .focus\\:bg-purple-50:focus {
  background-color: var(--purple-50) !important;
}
:host ::ng-deep .focus\\:bg-purple-100:focus {
  background-color: var(--purple-100) !important;
}
:host ::ng-deep .focus\\:bg-purple-200:focus {
  background-color: var(--purple-200) !important;
}
:host ::ng-deep .focus\\:bg-purple-300:focus {
  background-color: var(--purple-300) !important;
}
:host ::ng-deep .focus\\:bg-purple-400:focus {
  background-color: var(--purple-400) !important;
}
:host ::ng-deep .focus\\:bg-purple-500:focus {
  background-color: var(--purple-500) !important;
}
:host ::ng-deep .focus\\:bg-purple-600:focus {
  background-color: var(--purple-600) !important;
}
:host ::ng-deep .focus\\:bg-purple-700:focus {
  background-color: var(--purple-700) !important;
}
:host ::ng-deep .focus\\:bg-purple-800:focus {
  background-color: var(--purple-800) !important;
}
:host ::ng-deep .focus\\:bg-purple-900:focus {
  background-color: var(--purple-900) !important;
}
:host ::ng-deep .hover\\:bg-purple-50:hover {
  background-color: var(--purple-50) !important;
}
:host ::ng-deep .hover\\:bg-purple-100:hover {
  background-color: var(--purple-100) !important;
}
:host ::ng-deep .hover\\:bg-purple-200:hover {
  background-color: var(--purple-200) !important;
}
:host ::ng-deep .hover\\:bg-purple-300:hover {
  background-color: var(--purple-300) !important;
}
:host ::ng-deep .hover\\:bg-purple-400:hover {
  background-color: var(--purple-400) !important;
}
:host ::ng-deep .hover\\:bg-purple-500:hover {
  background-color: var(--purple-500) !important;
}
:host ::ng-deep .hover\\:bg-purple-600:hover {
  background-color: var(--purple-600) !important;
}
:host ::ng-deep .hover\\:bg-purple-700:hover {
  background-color: var(--purple-700) !important;
}
:host ::ng-deep .hover\\:bg-purple-800:hover {
  background-color: var(--purple-800) !important;
}
:host ::ng-deep .hover\\:bg-purple-900:hover {
  background-color: var(--purple-900) !important;
}
:host ::ng-deep .active\\:bg-purple-50:active {
  background-color: var(--purple-50) !important;
}
:host ::ng-deep .active\\:bg-purple-100:active {
  background-color: var(--purple-100) !important;
}
:host ::ng-deep .active\\:bg-purple-200:active {
  background-color: var(--purple-200) !important;
}
:host ::ng-deep .active\\:bg-purple-300:active {
  background-color: var(--purple-300) !important;
}
:host ::ng-deep .active\\:bg-purple-400:active {
  background-color: var(--purple-400) !important;
}
:host ::ng-deep .active\\:bg-purple-500:active {
  background-color: var(--purple-500) !important;
}
:host ::ng-deep .active\\:bg-purple-600:active {
  background-color: var(--purple-600) !important;
}
:host ::ng-deep .active\\:bg-purple-700:active {
  background-color: var(--purple-700) !important;
}
:host ::ng-deep .active\\:bg-purple-800:active {
  background-color: var(--purple-800) !important;
}
:host ::ng-deep .active\\:bg-purple-900:active {
  background-color: var(--purple-900) !important;
}
:host ::ng-deep .bg-gray-50 {
  background-color: var(--gray-50) !important;
}
:host ::ng-deep .bg-gray-100 {
  background-color: var(--gray-100) !important;
}
:host ::ng-deep .bg-gray-200 {
  background-color: var(--gray-200) !important;
}
:host ::ng-deep .bg-gray-300 {
  background-color: var(--gray-300) !important;
}
:host ::ng-deep .bg-gray-400 {
  background-color: var(--gray-400) !important;
}
:host ::ng-deep .bg-gray-500 {
  background-color: var(--gray-500) !important;
}
:host ::ng-deep .bg-gray-600 {
  background-color: var(--gray-600) !important;
}
:host ::ng-deep .bg-gray-700 {
  background-color: var(--gray-700) !important;
}
:host ::ng-deep .bg-gray-800 {
  background-color: var(--gray-800) !important;
}
:host ::ng-deep .bg-gray-900 {
  background-color: var(--gray-900) !important;
}
:host ::ng-deep .focus\\:bg-gray-50:focus {
  background-color: var(--gray-50) !important;
}
:host ::ng-deep .focus\\:bg-gray-100:focus {
  background-color: var(--gray-100) !important;
}
:host ::ng-deep .focus\\:bg-gray-200:focus {
  background-color: var(--gray-200) !important;
}
:host ::ng-deep .focus\\:bg-gray-300:focus {
  background-color: var(--gray-300) !important;
}
:host ::ng-deep .focus\\:bg-gray-400:focus {
  background-color: var(--gray-400) !important;
}
:host ::ng-deep .focus\\:bg-gray-500:focus {
  background-color: var(--gray-500) !important;
}
:host ::ng-deep .focus\\:bg-gray-600:focus {
  background-color: var(--gray-600) !important;
}
:host ::ng-deep .focus\\:bg-gray-700:focus {
  background-color: var(--gray-700) !important;
}
:host ::ng-deep .focus\\:bg-gray-800:focus {
  background-color: var(--gray-800) !important;
}
:host ::ng-deep .focus\\:bg-gray-900:focus {
  background-color: var(--gray-900) !important;
}
:host ::ng-deep .hover\\:bg-gray-50:hover {
  background-color: var(--gray-50) !important;
}
:host ::ng-deep .hover\\:bg-gray-100:hover {
  background-color: var(--gray-100) !important;
}
:host ::ng-deep .hover\\:bg-gray-200:hover {
  background-color: var(--gray-200) !important;
}
:host ::ng-deep .hover\\:bg-gray-300:hover {
  background-color: var(--gray-300) !important;
}
:host ::ng-deep .hover\\:bg-gray-400:hover {
  background-color: var(--gray-400) !important;
}
:host ::ng-deep .hover\\:bg-gray-500:hover {
  background-color: var(--gray-500) !important;
}
:host ::ng-deep .hover\\:bg-gray-600:hover {
  background-color: var(--gray-600) !important;
}
:host ::ng-deep .hover\\:bg-gray-700:hover {
  background-color: var(--gray-700) !important;
}
:host ::ng-deep .hover\\:bg-gray-800:hover {
  background-color: var(--gray-800) !important;
}
:host ::ng-deep .hover\\:bg-gray-900:hover {
  background-color: var(--gray-900) !important;
}
:host ::ng-deep .active\\:bg-gray-50:active {
  background-color: var(--gray-50) !important;
}
:host ::ng-deep .active\\:bg-gray-100:active {
  background-color: var(--gray-100) !important;
}
:host ::ng-deep .active\\:bg-gray-200:active {
  background-color: var(--gray-200) !important;
}
:host ::ng-deep .active\\:bg-gray-300:active {
  background-color: var(--gray-300) !important;
}
:host ::ng-deep .active\\:bg-gray-400:active {
  background-color: var(--gray-400) !important;
}
:host ::ng-deep .active\\:bg-gray-500:active {
  background-color: var(--gray-500) !important;
}
:host ::ng-deep .active\\:bg-gray-600:active {
  background-color: var(--gray-600) !important;
}
:host ::ng-deep .active\\:bg-gray-700:active {
  background-color: var(--gray-700) !important;
}
:host ::ng-deep .active\\:bg-gray-800:active {
  background-color: var(--gray-800) !important;
}
:host ::ng-deep .active\\:bg-gray-900:active {
  background-color: var(--gray-900) !important;
}
:host ::ng-deep .bg-red-50 {
  background-color: var(--red-50) !important;
}
:host ::ng-deep .bg-red-100 {
  background-color: var(--red-100) !important;
}
:host ::ng-deep .bg-red-200 {
  background-color: var(--red-200) !important;
}
:host ::ng-deep .bg-red-300 {
  background-color: var(--red-300) !important;
}
:host ::ng-deep .bg-red-400 {
  background-color: var(--red-400) !important;
}
:host ::ng-deep .bg-red-500 {
  background-color: var(--red-500) !important;
}
:host ::ng-deep .bg-red-600 {
  background-color: var(--red-600) !important;
}
:host ::ng-deep .bg-red-700 {
  background-color: var(--red-700) !important;
}
:host ::ng-deep .bg-red-800 {
  background-color: var(--red-800) !important;
}
:host ::ng-deep .bg-red-900 {
  background-color: var(--red-900) !important;
}
:host ::ng-deep .focus\\:bg-red-50:focus {
  background-color: var(--red-50) !important;
}
:host ::ng-deep .focus\\:bg-red-100:focus {
  background-color: var(--red-100) !important;
}
:host ::ng-deep .focus\\:bg-red-200:focus {
  background-color: var(--red-200) !important;
}
:host ::ng-deep .focus\\:bg-red-300:focus {
  background-color: var(--red-300) !important;
}
:host ::ng-deep .focus\\:bg-red-400:focus {
  background-color: var(--red-400) !important;
}
:host ::ng-deep .focus\\:bg-red-500:focus {
  background-color: var(--red-500) !important;
}
:host ::ng-deep .focus\\:bg-red-600:focus {
  background-color: var(--red-600) !important;
}
:host ::ng-deep .focus\\:bg-red-700:focus {
  background-color: var(--red-700) !important;
}
:host ::ng-deep .focus\\:bg-red-800:focus {
  background-color: var(--red-800) !important;
}
:host ::ng-deep .focus\\:bg-red-900:focus {
  background-color: var(--red-900) !important;
}
:host ::ng-deep .hover\\:bg-red-50:hover {
  background-color: var(--red-50) !important;
}
:host ::ng-deep .hover\\:bg-red-100:hover {
  background-color: var(--red-100) !important;
}
:host ::ng-deep .hover\\:bg-red-200:hover {
  background-color: var(--red-200) !important;
}
:host ::ng-deep .hover\\:bg-red-300:hover {
  background-color: var(--red-300) !important;
}
:host ::ng-deep .hover\\:bg-red-400:hover {
  background-color: var(--red-400) !important;
}
:host ::ng-deep .hover\\:bg-red-500:hover {
  background-color: var(--red-500) !important;
}
:host ::ng-deep .hover\\:bg-red-600:hover {
  background-color: var(--red-600) !important;
}
:host ::ng-deep .hover\\:bg-red-700:hover {
  background-color: var(--red-700) !important;
}
:host ::ng-deep .hover\\:bg-red-800:hover {
  background-color: var(--red-800) !important;
}
:host ::ng-deep .hover\\:bg-red-900:hover {
  background-color: var(--red-900) !important;
}
:host ::ng-deep .active\\:bg-red-50:active {
  background-color: var(--red-50) !important;
}
:host ::ng-deep .active\\:bg-red-100:active {
  background-color: var(--red-100) !important;
}
:host ::ng-deep .active\\:bg-red-200:active {
  background-color: var(--red-200) !important;
}
:host ::ng-deep .active\\:bg-red-300:active {
  background-color: var(--red-300) !important;
}
:host ::ng-deep .active\\:bg-red-400:active {
  background-color: var(--red-400) !important;
}
:host ::ng-deep .active\\:bg-red-500:active {
  background-color: var(--red-500) !important;
}
:host ::ng-deep .active\\:bg-red-600:active {
  background-color: var(--red-600) !important;
}
:host ::ng-deep .active\\:bg-red-700:active {
  background-color: var(--red-700) !important;
}
:host ::ng-deep .active\\:bg-red-800:active {
  background-color: var(--red-800) !important;
}
:host ::ng-deep .active\\:bg-red-900:active {
  background-color: var(--red-900) !important;
}
:host ::ng-deep .bg-primary-50 {
  background-color: var(--primary-50) !important;
}
:host ::ng-deep .bg-primary-100 {
  background-color: var(--primary-100) !important;
}
:host ::ng-deep .bg-primary-200 {
  background-color: var(--primary-200) !important;
}
:host ::ng-deep .bg-primary-300 {
  background-color: var(--primary-300) !important;
}
:host ::ng-deep .bg-primary-400 {
  background-color: var(--primary-400) !important;
}
:host ::ng-deep .bg-primary-500 {
  background-color: var(--primary-500) !important;
}
:host ::ng-deep .bg-primary-600 {
  background-color: var(--primary-600) !important;
}
:host ::ng-deep .bg-primary-700 {
  background-color: var(--primary-700) !important;
}
:host ::ng-deep .bg-primary-800 {
  background-color: var(--primary-800) !important;
}
:host ::ng-deep .bg-primary-900 {
  background-color: var(--primary-900) !important;
}
:host ::ng-deep .focus\\:bg-primary-50:focus {
  background-color: var(--primary-50) !important;
}
:host ::ng-deep .focus\\:bg-primary-100:focus {
  background-color: var(--primary-100) !important;
}
:host ::ng-deep .focus\\:bg-primary-200:focus {
  background-color: var(--primary-200) !important;
}
:host ::ng-deep .focus\\:bg-primary-300:focus {
  background-color: var(--primary-300) !important;
}
:host ::ng-deep .focus\\:bg-primary-400:focus {
  background-color: var(--primary-400) !important;
}
:host ::ng-deep .focus\\:bg-primary-500:focus {
  background-color: var(--primary-500) !important;
}
:host ::ng-deep .focus\\:bg-primary-600:focus {
  background-color: var(--primary-600) !important;
}
:host ::ng-deep .focus\\:bg-primary-700:focus {
  background-color: var(--primary-700) !important;
}
:host ::ng-deep .focus\\:bg-primary-800:focus {
  background-color: var(--primary-800) !important;
}
:host ::ng-deep .focus\\:bg-primary-900:focus {
  background-color: var(--primary-900) !important;
}
:host ::ng-deep .hover\\:bg-primary-50:hover {
  background-color: var(--primary-50) !important;
}
:host ::ng-deep .hover\\:bg-primary-100:hover {
  background-color: var(--primary-100) !important;
}
:host ::ng-deep .hover\\:bg-primary-200:hover {
  background-color: var(--primary-200) !important;
}
:host ::ng-deep .hover\\:bg-primary-300:hover {
  background-color: var(--primary-300) !important;
}
:host ::ng-deep .hover\\:bg-primary-400:hover {
  background-color: var(--primary-400) !important;
}
:host ::ng-deep .hover\\:bg-primary-500:hover {
  background-color: var(--primary-500) !important;
}
:host ::ng-deep .hover\\:bg-primary-600:hover {
  background-color: var(--primary-600) !important;
}
:host ::ng-deep .hover\\:bg-primary-700:hover {
  background-color: var(--primary-700) !important;
}
:host ::ng-deep .hover\\:bg-primary-800:hover {
  background-color: var(--primary-800) !important;
}
:host ::ng-deep .hover\\:bg-primary-900:hover {
  background-color: var(--primary-900) !important;
}
:host ::ng-deep .active\\:bg-primary-50:active {
  background-color: var(--primary-50) !important;
}
:host ::ng-deep .active\\:bg-primary-100:active {
  background-color: var(--primary-100) !important;
}
:host ::ng-deep .active\\:bg-primary-200:active {
  background-color: var(--primary-200) !important;
}
:host ::ng-deep .active\\:bg-primary-300:active {
  background-color: var(--primary-300) !important;
}
:host ::ng-deep .active\\:bg-primary-400:active {
  background-color: var(--primary-400) !important;
}
:host ::ng-deep .active\\:bg-primary-500:active {
  background-color: var(--primary-500) !important;
}
:host ::ng-deep .active\\:bg-primary-600:active {
  background-color: var(--primary-600) !important;
}
:host ::ng-deep .active\\:bg-primary-700:active {
  background-color: var(--primary-700) !important;
}
:host ::ng-deep .active\\:bg-primary-800:active {
  background-color: var(--primary-800) !important;
}
:host ::ng-deep .active\\:bg-primary-900:active {
  background-color: var(--primary-900) !important;
}
:host ::ng-deep .border-blue-50 {
  border-color: var(--blue-50) !important;
}
:host ::ng-deep .border-blue-100 {
  border-color: var(--blue-100) !important;
}
:host ::ng-deep .border-blue-200 {
  border-color: var(--blue-200) !important;
}
:host ::ng-deep .border-blue-300 {
  border-color: var(--blue-300) !important;
}
:host ::ng-deep .border-blue-400 {
  border-color: var(--blue-400) !important;
}
:host ::ng-deep .border-blue-500 {
  border-color: var(--blue-500) !important;
}
:host ::ng-deep .border-blue-600 {
  border-color: var(--blue-600) !important;
}
:host ::ng-deep .border-blue-700 {
  border-color: var(--blue-700) !important;
}
:host ::ng-deep .border-blue-800 {
  border-color: var(--blue-800) !important;
}
:host ::ng-deep .border-blue-900 {
  border-color: var(--blue-900) !important;
}
:host ::ng-deep .focus\\:border-blue-50:focus {
  border-color: var(--blue-50) !important;
}
:host ::ng-deep .focus\\:border-blue-100:focus {
  border-color: var(--blue-100) !important;
}
:host ::ng-deep .focus\\:border-blue-200:focus {
  border-color: var(--blue-200) !important;
}
:host ::ng-deep .focus\\:border-blue-300:focus {
  border-color: var(--blue-300) !important;
}
:host ::ng-deep .focus\\:border-blue-400:focus {
  border-color: var(--blue-400) !important;
}
:host ::ng-deep .focus\\:border-blue-500:focus {
  border-color: var(--blue-500) !important;
}
:host ::ng-deep .focus\\:border-blue-600:focus {
  border-color: var(--blue-600) !important;
}
:host ::ng-deep .focus\\:border-blue-700:focus {
  border-color: var(--blue-700) !important;
}
:host ::ng-deep .focus\\:border-blue-800:focus {
  border-color: var(--blue-800) !important;
}
:host ::ng-deep .focus\\:border-blue-900:focus {
  border-color: var(--blue-900) !important;
}
:host ::ng-deep .hover\\:border-blue-50:hover {
  border-color: var(--blue-50) !important;
}
:host ::ng-deep .hover\\:border-blue-100:hover {
  border-color: var(--blue-100) !important;
}
:host ::ng-deep .hover\\:border-blue-200:hover {
  border-color: var(--blue-200) !important;
}
:host ::ng-deep .hover\\:border-blue-300:hover {
  border-color: var(--blue-300) !important;
}
:host ::ng-deep .hover\\:border-blue-400:hover {
  border-color: var(--blue-400) !important;
}
:host ::ng-deep .hover\\:border-blue-500:hover {
  border-color: var(--blue-500) !important;
}
:host ::ng-deep .hover\\:border-blue-600:hover {
  border-color: var(--blue-600) !important;
}
:host ::ng-deep .hover\\:border-blue-700:hover {
  border-color: var(--blue-700) !important;
}
:host ::ng-deep .hover\\:border-blue-800:hover {
  border-color: var(--blue-800) !important;
}
:host ::ng-deep .hover\\:border-blue-900:hover {
  border-color: var(--blue-900) !important;
}
:host ::ng-deep .active\\:border-blue-50:active {
  border-color: var(--blue-50) !important;
}
:host ::ng-deep .active\\:border-blue-100:active {
  border-color: var(--blue-100) !important;
}
:host ::ng-deep .active\\:border-blue-200:active {
  border-color: var(--blue-200) !important;
}
:host ::ng-deep .active\\:border-blue-300:active {
  border-color: var(--blue-300) !important;
}
:host ::ng-deep .active\\:border-blue-400:active {
  border-color: var(--blue-400) !important;
}
:host ::ng-deep .active\\:border-blue-500:active {
  border-color: var(--blue-500) !important;
}
:host ::ng-deep .active\\:border-blue-600:active {
  border-color: var(--blue-600) !important;
}
:host ::ng-deep .active\\:border-blue-700:active {
  border-color: var(--blue-700) !important;
}
:host ::ng-deep .active\\:border-blue-800:active {
  border-color: var(--blue-800) !important;
}
:host ::ng-deep .active\\:border-blue-900:active {
  border-color: var(--blue-900) !important;
}
:host ::ng-deep .border-green-50 {
  border-color: var(--green-50) !important;
}
:host ::ng-deep .border-green-100 {
  border-color: var(--green-100) !important;
}
:host ::ng-deep .border-green-200 {
  border-color: var(--green-200) !important;
}
:host ::ng-deep .border-green-300 {
  border-color: var(--green-300) !important;
}
:host ::ng-deep .border-green-400 {
  border-color: var(--green-400) !important;
}
:host ::ng-deep .border-green-500 {
  border-color: var(--green-500) !important;
}
:host ::ng-deep .border-green-600 {
  border-color: var(--green-600) !important;
}
:host ::ng-deep .border-green-700 {
  border-color: var(--green-700) !important;
}
:host ::ng-deep .border-green-800 {
  border-color: var(--green-800) !important;
}
:host ::ng-deep .border-green-900 {
  border-color: var(--green-900) !important;
}
:host ::ng-deep .focus\\:border-green-50:focus {
  border-color: var(--green-50) !important;
}
:host ::ng-deep .focus\\:border-green-100:focus {
  border-color: var(--green-100) !important;
}
:host ::ng-deep .focus\\:border-green-200:focus {
  border-color: var(--green-200) !important;
}
:host ::ng-deep .focus\\:border-green-300:focus {
  border-color: var(--green-300) !important;
}
:host ::ng-deep .focus\\:border-green-400:focus {
  border-color: var(--green-400) !important;
}
:host ::ng-deep .focus\\:border-green-500:focus {
  border-color: var(--green-500) !important;
}
:host ::ng-deep .focus\\:border-green-600:focus {
  border-color: var(--green-600) !important;
}
:host ::ng-deep .focus\\:border-green-700:focus {
  border-color: var(--green-700) !important;
}
:host ::ng-deep .focus\\:border-green-800:focus {
  border-color: var(--green-800) !important;
}
:host ::ng-deep .focus\\:border-green-900:focus {
  border-color: var(--green-900) !important;
}
:host ::ng-deep .hover\\:border-green-50:hover {
  border-color: var(--green-50) !important;
}
:host ::ng-deep .hover\\:border-green-100:hover {
  border-color: var(--green-100) !important;
}
:host ::ng-deep .hover\\:border-green-200:hover {
  border-color: var(--green-200) !important;
}
:host ::ng-deep .hover\\:border-green-300:hover {
  border-color: var(--green-300) !important;
}
:host ::ng-deep .hover\\:border-green-400:hover {
  border-color: var(--green-400) !important;
}
:host ::ng-deep .hover\\:border-green-500:hover {
  border-color: var(--green-500) !important;
}
:host ::ng-deep .hover\\:border-green-600:hover {
  border-color: var(--green-600) !important;
}
:host ::ng-deep .hover\\:border-green-700:hover {
  border-color: var(--green-700) !important;
}
:host ::ng-deep .hover\\:border-green-800:hover {
  border-color: var(--green-800) !important;
}
:host ::ng-deep .hover\\:border-green-900:hover {
  border-color: var(--green-900) !important;
}
:host ::ng-deep .active\\:border-green-50:active {
  border-color: var(--green-50) !important;
}
:host ::ng-deep .active\\:border-green-100:active {
  border-color: var(--green-100) !important;
}
:host ::ng-deep .active\\:border-green-200:active {
  border-color: var(--green-200) !important;
}
:host ::ng-deep .active\\:border-green-300:active {
  border-color: var(--green-300) !important;
}
:host ::ng-deep .active\\:border-green-400:active {
  border-color: var(--green-400) !important;
}
:host ::ng-deep .active\\:border-green-500:active {
  border-color: var(--green-500) !important;
}
:host ::ng-deep .active\\:border-green-600:active {
  border-color: var(--green-600) !important;
}
:host ::ng-deep .active\\:border-green-700:active {
  border-color: var(--green-700) !important;
}
:host ::ng-deep .active\\:border-green-800:active {
  border-color: var(--green-800) !important;
}
:host ::ng-deep .active\\:border-green-900:active {
  border-color: var(--green-900) !important;
}
:host ::ng-deep .border-yellow-50 {
  border-color: var(--yellow-50) !important;
}
:host ::ng-deep .border-yellow-100 {
  border-color: var(--yellow-100) !important;
}
:host ::ng-deep .border-yellow-200 {
  border-color: var(--yellow-200) !important;
}
:host ::ng-deep .border-yellow-300 {
  border-color: var(--yellow-300) !important;
}
:host ::ng-deep .border-yellow-400 {
  border-color: var(--yellow-400) !important;
}
:host ::ng-deep .border-yellow-500 {
  border-color: var(--yellow-500) !important;
}
:host ::ng-deep .border-yellow-600 {
  border-color: var(--yellow-600) !important;
}
:host ::ng-deep .border-yellow-700 {
  border-color: var(--yellow-700) !important;
}
:host ::ng-deep .border-yellow-800 {
  border-color: var(--yellow-800) !important;
}
:host ::ng-deep .border-yellow-900 {
  border-color: var(--yellow-900) !important;
}
:host ::ng-deep .focus\\:border-yellow-50:focus {
  border-color: var(--yellow-50) !important;
}
:host ::ng-deep .focus\\:border-yellow-100:focus {
  border-color: var(--yellow-100) !important;
}
:host ::ng-deep .focus\\:border-yellow-200:focus {
  border-color: var(--yellow-200) !important;
}
:host ::ng-deep .focus\\:border-yellow-300:focus {
  border-color: var(--yellow-300) !important;
}
:host ::ng-deep .focus\\:border-yellow-400:focus {
  border-color: var(--yellow-400) !important;
}
:host ::ng-deep .focus\\:border-yellow-500:focus {
  border-color: var(--yellow-500) !important;
}
:host ::ng-deep .focus\\:border-yellow-600:focus {
  border-color: var(--yellow-600) !important;
}
:host ::ng-deep .focus\\:border-yellow-700:focus {
  border-color: var(--yellow-700) !important;
}
:host ::ng-deep .focus\\:border-yellow-800:focus {
  border-color: var(--yellow-800) !important;
}
:host ::ng-deep .focus\\:border-yellow-900:focus {
  border-color: var(--yellow-900) !important;
}
:host ::ng-deep .hover\\:border-yellow-50:hover {
  border-color: var(--yellow-50) !important;
}
:host ::ng-deep .hover\\:border-yellow-100:hover {
  border-color: var(--yellow-100) !important;
}
:host ::ng-deep .hover\\:border-yellow-200:hover {
  border-color: var(--yellow-200) !important;
}
:host ::ng-deep .hover\\:border-yellow-300:hover {
  border-color: var(--yellow-300) !important;
}
:host ::ng-deep .hover\\:border-yellow-400:hover {
  border-color: var(--yellow-400) !important;
}
:host ::ng-deep .hover\\:border-yellow-500:hover {
  border-color: var(--yellow-500) !important;
}
:host ::ng-deep .hover\\:border-yellow-600:hover {
  border-color: var(--yellow-600) !important;
}
:host ::ng-deep .hover\\:border-yellow-700:hover {
  border-color: var(--yellow-700) !important;
}
:host ::ng-deep .hover\\:border-yellow-800:hover {
  border-color: var(--yellow-800) !important;
}
:host ::ng-deep .hover\\:border-yellow-900:hover {
  border-color: var(--yellow-900) !important;
}
:host ::ng-deep .active\\:border-yellow-50:active {
  border-color: var(--yellow-50) !important;
}
:host ::ng-deep .active\\:border-yellow-100:active {
  border-color: var(--yellow-100) !important;
}
:host ::ng-deep .active\\:border-yellow-200:active {
  border-color: var(--yellow-200) !important;
}
:host ::ng-deep .active\\:border-yellow-300:active {
  border-color: var(--yellow-300) !important;
}
:host ::ng-deep .active\\:border-yellow-400:active {
  border-color: var(--yellow-400) !important;
}
:host ::ng-deep .active\\:border-yellow-500:active {
  border-color: var(--yellow-500) !important;
}
:host ::ng-deep .active\\:border-yellow-600:active {
  border-color: var(--yellow-600) !important;
}
:host ::ng-deep .active\\:border-yellow-700:active {
  border-color: var(--yellow-700) !important;
}
:host ::ng-deep .active\\:border-yellow-800:active {
  border-color: var(--yellow-800) !important;
}
:host ::ng-deep .active\\:border-yellow-900:active {
  border-color: var(--yellow-900) !important;
}
:host ::ng-deep .border-cyan-50 {
  border-color: var(--cyan-50) !important;
}
:host ::ng-deep .border-cyan-100 {
  border-color: var(--cyan-100) !important;
}
:host ::ng-deep .border-cyan-200 {
  border-color: var(--cyan-200) !important;
}
:host ::ng-deep .border-cyan-300 {
  border-color: var(--cyan-300) !important;
}
:host ::ng-deep .border-cyan-400 {
  border-color: var(--cyan-400) !important;
}
:host ::ng-deep .border-cyan-500 {
  border-color: var(--cyan-500) !important;
}
:host ::ng-deep .border-cyan-600 {
  border-color: var(--cyan-600) !important;
}
:host ::ng-deep .border-cyan-700 {
  border-color: var(--cyan-700) !important;
}
:host ::ng-deep .border-cyan-800 {
  border-color: var(--cyan-800) !important;
}
:host ::ng-deep .border-cyan-900 {
  border-color: var(--cyan-900) !important;
}
:host ::ng-deep .focus\\:border-cyan-50:focus {
  border-color: var(--cyan-50) !important;
}
:host ::ng-deep .focus\\:border-cyan-100:focus {
  border-color: var(--cyan-100) !important;
}
:host ::ng-deep .focus\\:border-cyan-200:focus {
  border-color: var(--cyan-200) !important;
}
:host ::ng-deep .focus\\:border-cyan-300:focus {
  border-color: var(--cyan-300) !important;
}
:host ::ng-deep .focus\\:border-cyan-400:focus {
  border-color: var(--cyan-400) !important;
}
:host ::ng-deep .focus\\:border-cyan-500:focus {
  border-color: var(--cyan-500) !important;
}
:host ::ng-deep .focus\\:border-cyan-600:focus {
  border-color: var(--cyan-600) !important;
}
:host ::ng-deep .focus\\:border-cyan-700:focus {
  border-color: var(--cyan-700) !important;
}
:host ::ng-deep .focus\\:border-cyan-800:focus {
  border-color: var(--cyan-800) !important;
}
:host ::ng-deep .focus\\:border-cyan-900:focus {
  border-color: var(--cyan-900) !important;
}
:host ::ng-deep .hover\\:border-cyan-50:hover {
  border-color: var(--cyan-50) !important;
}
:host ::ng-deep .hover\\:border-cyan-100:hover {
  border-color: var(--cyan-100) !important;
}
:host ::ng-deep .hover\\:border-cyan-200:hover {
  border-color: var(--cyan-200) !important;
}
:host ::ng-deep .hover\\:border-cyan-300:hover {
  border-color: var(--cyan-300) !important;
}
:host ::ng-deep .hover\\:border-cyan-400:hover {
  border-color: var(--cyan-400) !important;
}
:host ::ng-deep .hover\\:border-cyan-500:hover {
  border-color: var(--cyan-500) !important;
}
:host ::ng-deep .hover\\:border-cyan-600:hover {
  border-color: var(--cyan-600) !important;
}
:host ::ng-deep .hover\\:border-cyan-700:hover {
  border-color: var(--cyan-700) !important;
}
:host ::ng-deep .hover\\:border-cyan-800:hover {
  border-color: var(--cyan-800) !important;
}
:host ::ng-deep .hover\\:border-cyan-900:hover {
  border-color: var(--cyan-900) !important;
}
:host ::ng-deep .active\\:border-cyan-50:active {
  border-color: var(--cyan-50) !important;
}
:host ::ng-deep .active\\:border-cyan-100:active {
  border-color: var(--cyan-100) !important;
}
:host ::ng-deep .active\\:border-cyan-200:active {
  border-color: var(--cyan-200) !important;
}
:host ::ng-deep .active\\:border-cyan-300:active {
  border-color: var(--cyan-300) !important;
}
:host ::ng-deep .active\\:border-cyan-400:active {
  border-color: var(--cyan-400) !important;
}
:host ::ng-deep .active\\:border-cyan-500:active {
  border-color: var(--cyan-500) !important;
}
:host ::ng-deep .active\\:border-cyan-600:active {
  border-color: var(--cyan-600) !important;
}
:host ::ng-deep .active\\:border-cyan-700:active {
  border-color: var(--cyan-700) !important;
}
:host ::ng-deep .active\\:border-cyan-800:active {
  border-color: var(--cyan-800) !important;
}
:host ::ng-deep .active\\:border-cyan-900:active {
  border-color: var(--cyan-900) !important;
}
:host ::ng-deep .border-pink-50 {
  border-color: var(--pink-50) !important;
}
:host ::ng-deep .border-pink-100 {
  border-color: var(--pink-100) !important;
}
:host ::ng-deep .border-pink-200 {
  border-color: var(--pink-200) !important;
}
:host ::ng-deep .border-pink-300 {
  border-color: var(--pink-300) !important;
}
:host ::ng-deep .border-pink-400 {
  border-color: var(--pink-400) !important;
}
:host ::ng-deep .border-pink-500 {
  border-color: var(--pink-500) !important;
}
:host ::ng-deep .border-pink-600 {
  border-color: var(--pink-600) !important;
}
:host ::ng-deep .border-pink-700 {
  border-color: var(--pink-700) !important;
}
:host ::ng-deep .border-pink-800 {
  border-color: var(--pink-800) !important;
}
:host ::ng-deep .border-pink-900 {
  border-color: var(--pink-900) !important;
}
:host ::ng-deep .focus\\:border-pink-50:focus {
  border-color: var(--pink-50) !important;
}
:host ::ng-deep .focus\\:border-pink-100:focus {
  border-color: var(--pink-100) !important;
}
:host ::ng-deep .focus\\:border-pink-200:focus {
  border-color: var(--pink-200) !important;
}
:host ::ng-deep .focus\\:border-pink-300:focus {
  border-color: var(--pink-300) !important;
}
:host ::ng-deep .focus\\:border-pink-400:focus {
  border-color: var(--pink-400) !important;
}
:host ::ng-deep .focus\\:border-pink-500:focus {
  border-color: var(--pink-500) !important;
}
:host ::ng-deep .focus\\:border-pink-600:focus {
  border-color: var(--pink-600) !important;
}
:host ::ng-deep .focus\\:border-pink-700:focus {
  border-color: var(--pink-700) !important;
}
:host ::ng-deep .focus\\:border-pink-800:focus {
  border-color: var(--pink-800) !important;
}
:host ::ng-deep .focus\\:border-pink-900:focus {
  border-color: var(--pink-900) !important;
}
:host ::ng-deep .hover\\:border-pink-50:hover {
  border-color: var(--pink-50) !important;
}
:host ::ng-deep .hover\\:border-pink-100:hover {
  border-color: var(--pink-100) !important;
}
:host ::ng-deep .hover\\:border-pink-200:hover {
  border-color: var(--pink-200) !important;
}
:host ::ng-deep .hover\\:border-pink-300:hover {
  border-color: var(--pink-300) !important;
}
:host ::ng-deep .hover\\:border-pink-400:hover {
  border-color: var(--pink-400) !important;
}
:host ::ng-deep .hover\\:border-pink-500:hover {
  border-color: var(--pink-500) !important;
}
:host ::ng-deep .hover\\:border-pink-600:hover {
  border-color: var(--pink-600) !important;
}
:host ::ng-deep .hover\\:border-pink-700:hover {
  border-color: var(--pink-700) !important;
}
:host ::ng-deep .hover\\:border-pink-800:hover {
  border-color: var(--pink-800) !important;
}
:host ::ng-deep .hover\\:border-pink-900:hover {
  border-color: var(--pink-900) !important;
}
:host ::ng-deep .active\\:border-pink-50:active {
  border-color: var(--pink-50) !important;
}
:host ::ng-deep .active\\:border-pink-100:active {
  border-color: var(--pink-100) !important;
}
:host ::ng-deep .active\\:border-pink-200:active {
  border-color: var(--pink-200) !important;
}
:host ::ng-deep .active\\:border-pink-300:active {
  border-color: var(--pink-300) !important;
}
:host ::ng-deep .active\\:border-pink-400:active {
  border-color: var(--pink-400) !important;
}
:host ::ng-deep .active\\:border-pink-500:active {
  border-color: var(--pink-500) !important;
}
:host ::ng-deep .active\\:border-pink-600:active {
  border-color: var(--pink-600) !important;
}
:host ::ng-deep .active\\:border-pink-700:active {
  border-color: var(--pink-700) !important;
}
:host ::ng-deep .active\\:border-pink-800:active {
  border-color: var(--pink-800) !important;
}
:host ::ng-deep .active\\:border-pink-900:active {
  border-color: var(--pink-900) !important;
}
:host ::ng-deep .border-indigo-50 {
  border-color: var(--indigo-50) !important;
}
:host ::ng-deep .border-indigo-100 {
  border-color: var(--indigo-100) !important;
}
:host ::ng-deep .border-indigo-200 {
  border-color: var(--indigo-200) !important;
}
:host ::ng-deep .border-indigo-300 {
  border-color: var(--indigo-300) !important;
}
:host ::ng-deep .border-indigo-400 {
  border-color: var(--indigo-400) !important;
}
:host ::ng-deep .border-indigo-500 {
  border-color: var(--indigo-500) !important;
}
:host ::ng-deep .border-indigo-600 {
  border-color: var(--indigo-600) !important;
}
:host ::ng-deep .border-indigo-700 {
  border-color: var(--indigo-700) !important;
}
:host ::ng-deep .border-indigo-800 {
  border-color: var(--indigo-800) !important;
}
:host ::ng-deep .border-indigo-900 {
  border-color: var(--indigo-900) !important;
}
:host ::ng-deep .focus\\:border-indigo-50:focus {
  border-color: var(--indigo-50) !important;
}
:host ::ng-deep .focus\\:border-indigo-100:focus {
  border-color: var(--indigo-100) !important;
}
:host ::ng-deep .focus\\:border-indigo-200:focus {
  border-color: var(--indigo-200) !important;
}
:host ::ng-deep .focus\\:border-indigo-300:focus {
  border-color: var(--indigo-300) !important;
}
:host ::ng-deep .focus\\:border-indigo-400:focus {
  border-color: var(--indigo-400) !important;
}
:host ::ng-deep .focus\\:border-indigo-500:focus {
  border-color: var(--indigo-500) !important;
}
:host ::ng-deep .focus\\:border-indigo-600:focus {
  border-color: var(--indigo-600) !important;
}
:host ::ng-deep .focus\\:border-indigo-700:focus {
  border-color: var(--indigo-700) !important;
}
:host ::ng-deep .focus\\:border-indigo-800:focus {
  border-color: var(--indigo-800) !important;
}
:host ::ng-deep .focus\\:border-indigo-900:focus {
  border-color: var(--indigo-900) !important;
}
:host ::ng-deep .hover\\:border-indigo-50:hover {
  border-color: var(--indigo-50) !important;
}
:host ::ng-deep .hover\\:border-indigo-100:hover {
  border-color: var(--indigo-100) !important;
}
:host ::ng-deep .hover\\:border-indigo-200:hover {
  border-color: var(--indigo-200) !important;
}
:host ::ng-deep .hover\\:border-indigo-300:hover {
  border-color: var(--indigo-300) !important;
}
:host ::ng-deep .hover\\:border-indigo-400:hover {
  border-color: var(--indigo-400) !important;
}
:host ::ng-deep .hover\\:border-indigo-500:hover {
  border-color: var(--indigo-500) !important;
}
:host ::ng-deep .hover\\:border-indigo-600:hover {
  border-color: var(--indigo-600) !important;
}
:host ::ng-deep .hover\\:border-indigo-700:hover {
  border-color: var(--indigo-700) !important;
}
:host ::ng-deep .hover\\:border-indigo-800:hover {
  border-color: var(--indigo-800) !important;
}
:host ::ng-deep .hover\\:border-indigo-900:hover {
  border-color: var(--indigo-900) !important;
}
:host ::ng-deep .active\\:border-indigo-50:active {
  border-color: var(--indigo-50) !important;
}
:host ::ng-deep .active\\:border-indigo-100:active {
  border-color: var(--indigo-100) !important;
}
:host ::ng-deep .active\\:border-indigo-200:active {
  border-color: var(--indigo-200) !important;
}
:host ::ng-deep .active\\:border-indigo-300:active {
  border-color: var(--indigo-300) !important;
}
:host ::ng-deep .active\\:border-indigo-400:active {
  border-color: var(--indigo-400) !important;
}
:host ::ng-deep .active\\:border-indigo-500:active {
  border-color: var(--indigo-500) !important;
}
:host ::ng-deep .active\\:border-indigo-600:active {
  border-color: var(--indigo-600) !important;
}
:host ::ng-deep .active\\:border-indigo-700:active {
  border-color: var(--indigo-700) !important;
}
:host ::ng-deep .active\\:border-indigo-800:active {
  border-color: var(--indigo-800) !important;
}
:host ::ng-deep .active\\:border-indigo-900:active {
  border-color: var(--indigo-900) !important;
}
:host ::ng-deep .border-teal-50 {
  border-color: var(--teal-50) !important;
}
:host ::ng-deep .border-teal-100 {
  border-color: var(--teal-100) !important;
}
:host ::ng-deep .border-teal-200 {
  border-color: var(--teal-200) !important;
}
:host ::ng-deep .border-teal-300 {
  border-color: var(--teal-300) !important;
}
:host ::ng-deep .border-teal-400 {
  border-color: var(--teal-400) !important;
}
:host ::ng-deep .border-teal-500 {
  border-color: var(--teal-500) !important;
}
:host ::ng-deep .border-teal-600 {
  border-color: var(--teal-600) !important;
}
:host ::ng-deep .border-teal-700 {
  border-color: var(--teal-700) !important;
}
:host ::ng-deep .border-teal-800 {
  border-color: var(--teal-800) !important;
}
:host ::ng-deep .border-teal-900 {
  border-color: var(--teal-900) !important;
}
:host ::ng-deep .focus\\:border-teal-50:focus {
  border-color: var(--teal-50) !important;
}
:host ::ng-deep .focus\\:border-teal-100:focus {
  border-color: var(--teal-100) !important;
}
:host ::ng-deep .focus\\:border-teal-200:focus {
  border-color: var(--teal-200) !important;
}
:host ::ng-deep .focus\\:border-teal-300:focus {
  border-color: var(--teal-300) !important;
}
:host ::ng-deep .focus\\:border-teal-400:focus {
  border-color: var(--teal-400) !important;
}
:host ::ng-deep .focus\\:border-teal-500:focus {
  border-color: var(--teal-500) !important;
}
:host ::ng-deep .focus\\:border-teal-600:focus {
  border-color: var(--teal-600) !important;
}
:host ::ng-deep .focus\\:border-teal-700:focus {
  border-color: var(--teal-700) !important;
}
:host ::ng-deep .focus\\:border-teal-800:focus {
  border-color: var(--teal-800) !important;
}
:host ::ng-deep .focus\\:border-teal-900:focus {
  border-color: var(--teal-900) !important;
}
:host ::ng-deep .hover\\:border-teal-50:hover {
  border-color: var(--teal-50) !important;
}
:host ::ng-deep .hover\\:border-teal-100:hover {
  border-color: var(--teal-100) !important;
}
:host ::ng-deep .hover\\:border-teal-200:hover {
  border-color: var(--teal-200) !important;
}
:host ::ng-deep .hover\\:border-teal-300:hover {
  border-color: var(--teal-300) !important;
}
:host ::ng-deep .hover\\:border-teal-400:hover {
  border-color: var(--teal-400) !important;
}
:host ::ng-deep .hover\\:border-teal-500:hover {
  border-color: var(--teal-500) !important;
}
:host ::ng-deep .hover\\:border-teal-600:hover {
  border-color: var(--teal-600) !important;
}
:host ::ng-deep .hover\\:border-teal-700:hover {
  border-color: var(--teal-700) !important;
}
:host ::ng-deep .hover\\:border-teal-800:hover {
  border-color: var(--teal-800) !important;
}
:host ::ng-deep .hover\\:border-teal-900:hover {
  border-color: var(--teal-900) !important;
}
:host ::ng-deep .active\\:border-teal-50:active {
  border-color: var(--teal-50) !important;
}
:host ::ng-deep .active\\:border-teal-100:active {
  border-color: var(--teal-100) !important;
}
:host ::ng-deep .active\\:border-teal-200:active {
  border-color: var(--teal-200) !important;
}
:host ::ng-deep .active\\:border-teal-300:active {
  border-color: var(--teal-300) !important;
}
:host ::ng-deep .active\\:border-teal-400:active {
  border-color: var(--teal-400) !important;
}
:host ::ng-deep .active\\:border-teal-500:active {
  border-color: var(--teal-500) !important;
}
:host ::ng-deep .active\\:border-teal-600:active {
  border-color: var(--teal-600) !important;
}
:host ::ng-deep .active\\:border-teal-700:active {
  border-color: var(--teal-700) !important;
}
:host ::ng-deep .active\\:border-teal-800:active {
  border-color: var(--teal-800) !important;
}
:host ::ng-deep .active\\:border-teal-900:active {
  border-color: var(--teal-900) !important;
}
:host ::ng-deep .border-orange-50 {
  border-color: var(--orange-50) !important;
}
:host ::ng-deep .border-orange-100 {
  border-color: var(--orange-100) !important;
}
:host ::ng-deep .border-orange-200 {
  border-color: var(--orange-200) !important;
}
:host ::ng-deep .border-orange-300 {
  border-color: var(--orange-300) !important;
}
:host ::ng-deep .border-orange-400 {
  border-color: var(--orange-400) !important;
}
:host ::ng-deep .border-orange-500 {
  border-color: var(--orange-500) !important;
}
:host ::ng-deep .border-orange-600 {
  border-color: var(--orange-600) !important;
}
:host ::ng-deep .border-orange-700 {
  border-color: var(--orange-700) !important;
}
:host ::ng-deep .border-orange-800 {
  border-color: var(--orange-800) !important;
}
:host ::ng-deep .border-orange-900 {
  border-color: var(--orange-900) !important;
}
:host ::ng-deep .focus\\:border-orange-50:focus {
  border-color: var(--orange-50) !important;
}
:host ::ng-deep .focus\\:border-orange-100:focus {
  border-color: var(--orange-100) !important;
}
:host ::ng-deep .focus\\:border-orange-200:focus {
  border-color: var(--orange-200) !important;
}
:host ::ng-deep .focus\\:border-orange-300:focus {
  border-color: var(--orange-300) !important;
}
:host ::ng-deep .focus\\:border-orange-400:focus {
  border-color: var(--orange-400) !important;
}
:host ::ng-deep .focus\\:border-orange-500:focus {
  border-color: var(--orange-500) !important;
}
:host ::ng-deep .focus\\:border-orange-600:focus {
  border-color: var(--orange-600) !important;
}
:host ::ng-deep .focus\\:border-orange-700:focus {
  border-color: var(--orange-700) !important;
}
:host ::ng-deep .focus\\:border-orange-800:focus {
  border-color: var(--orange-800) !important;
}
:host ::ng-deep .focus\\:border-orange-900:focus {
  border-color: var(--orange-900) !important;
}
:host ::ng-deep .hover\\:border-orange-50:hover {
  border-color: var(--orange-50) !important;
}
:host ::ng-deep .hover\\:border-orange-100:hover {
  border-color: var(--orange-100) !important;
}
:host ::ng-deep .hover\\:border-orange-200:hover {
  border-color: var(--orange-200) !important;
}
:host ::ng-deep .hover\\:border-orange-300:hover {
  border-color: var(--orange-300) !important;
}
:host ::ng-deep .hover\\:border-orange-400:hover {
  border-color: var(--orange-400) !important;
}
:host ::ng-deep .hover\\:border-orange-500:hover {
  border-color: var(--orange-500) !important;
}
:host ::ng-deep .hover\\:border-orange-600:hover {
  border-color: var(--orange-600) !important;
}
:host ::ng-deep .hover\\:border-orange-700:hover {
  border-color: var(--orange-700) !important;
}
:host ::ng-deep .hover\\:border-orange-800:hover {
  border-color: var(--orange-800) !important;
}
:host ::ng-deep .hover\\:border-orange-900:hover {
  border-color: var(--orange-900) !important;
}
:host ::ng-deep .active\\:border-orange-50:active {
  border-color: var(--orange-50) !important;
}
:host ::ng-deep .active\\:border-orange-100:active {
  border-color: var(--orange-100) !important;
}
:host ::ng-deep .active\\:border-orange-200:active {
  border-color: var(--orange-200) !important;
}
:host ::ng-deep .active\\:border-orange-300:active {
  border-color: var(--orange-300) !important;
}
:host ::ng-deep .active\\:border-orange-400:active {
  border-color: var(--orange-400) !important;
}
:host ::ng-deep .active\\:border-orange-500:active {
  border-color: var(--orange-500) !important;
}
:host ::ng-deep .active\\:border-orange-600:active {
  border-color: var(--orange-600) !important;
}
:host ::ng-deep .active\\:border-orange-700:active {
  border-color: var(--orange-700) !important;
}
:host ::ng-deep .active\\:border-orange-800:active {
  border-color: var(--orange-800) !important;
}
:host ::ng-deep .active\\:border-orange-900:active {
  border-color: var(--orange-900) !important;
}
:host ::ng-deep .border-bluegray-50 {
  border-color: var(--bluegray-50) !important;
}
:host ::ng-deep .border-bluegray-100 {
  border-color: var(--bluegray-100) !important;
}
:host ::ng-deep .border-bluegray-200 {
  border-color: var(--bluegray-200) !important;
}
:host ::ng-deep .border-bluegray-300 {
  border-color: var(--bluegray-300) !important;
}
:host ::ng-deep .border-bluegray-400 {
  border-color: var(--bluegray-400) !important;
}
:host ::ng-deep .border-bluegray-500 {
  border-color: var(--bluegray-500) !important;
}
:host ::ng-deep .border-bluegray-600 {
  border-color: var(--bluegray-600) !important;
}
:host ::ng-deep .border-bluegray-700 {
  border-color: var(--bluegray-700) !important;
}
:host ::ng-deep .border-bluegray-800 {
  border-color: var(--bluegray-800) !important;
}
:host ::ng-deep .border-bluegray-900 {
  border-color: var(--bluegray-900) !important;
}
:host ::ng-deep .focus\\:border-bluegray-50:focus {
  border-color: var(--bluegray-50) !important;
}
:host ::ng-deep .focus\\:border-bluegray-100:focus {
  border-color: var(--bluegray-100) !important;
}
:host ::ng-deep .focus\\:border-bluegray-200:focus {
  border-color: var(--bluegray-200) !important;
}
:host ::ng-deep .focus\\:border-bluegray-300:focus {
  border-color: var(--bluegray-300) !important;
}
:host ::ng-deep .focus\\:border-bluegray-400:focus {
  border-color: var(--bluegray-400) !important;
}
:host ::ng-deep .focus\\:border-bluegray-500:focus {
  border-color: var(--bluegray-500) !important;
}
:host ::ng-deep .focus\\:border-bluegray-600:focus {
  border-color: var(--bluegray-600) !important;
}
:host ::ng-deep .focus\\:border-bluegray-700:focus {
  border-color: var(--bluegray-700) !important;
}
:host ::ng-deep .focus\\:border-bluegray-800:focus {
  border-color: var(--bluegray-800) !important;
}
:host ::ng-deep .focus\\:border-bluegray-900:focus {
  border-color: var(--bluegray-900) !important;
}
:host ::ng-deep .hover\\:border-bluegray-50:hover {
  border-color: var(--bluegray-50) !important;
}
:host ::ng-deep .hover\\:border-bluegray-100:hover {
  border-color: var(--bluegray-100) !important;
}
:host ::ng-deep .hover\\:border-bluegray-200:hover {
  border-color: var(--bluegray-200) !important;
}
:host ::ng-deep .hover\\:border-bluegray-300:hover {
  border-color: var(--bluegray-300) !important;
}
:host ::ng-deep .hover\\:border-bluegray-400:hover {
  border-color: var(--bluegray-400) !important;
}
:host ::ng-deep .hover\\:border-bluegray-500:hover {
  border-color: var(--bluegray-500) !important;
}
:host ::ng-deep .hover\\:border-bluegray-600:hover {
  border-color: var(--bluegray-600) !important;
}
:host ::ng-deep .hover\\:border-bluegray-700:hover {
  border-color: var(--bluegray-700) !important;
}
:host ::ng-deep .hover\\:border-bluegray-800:hover {
  border-color: var(--bluegray-800) !important;
}
:host ::ng-deep .hover\\:border-bluegray-900:hover {
  border-color: var(--bluegray-900) !important;
}
:host ::ng-deep .active\\:border-bluegray-50:active {
  border-color: var(--bluegray-50) !important;
}
:host ::ng-deep .active\\:border-bluegray-100:active {
  border-color: var(--bluegray-100) !important;
}
:host ::ng-deep .active\\:border-bluegray-200:active {
  border-color: var(--bluegray-200) !important;
}
:host ::ng-deep .active\\:border-bluegray-300:active {
  border-color: var(--bluegray-300) !important;
}
:host ::ng-deep .active\\:border-bluegray-400:active {
  border-color: var(--bluegray-400) !important;
}
:host ::ng-deep .active\\:border-bluegray-500:active {
  border-color: var(--bluegray-500) !important;
}
:host ::ng-deep .active\\:border-bluegray-600:active {
  border-color: var(--bluegray-600) !important;
}
:host ::ng-deep .active\\:border-bluegray-700:active {
  border-color: var(--bluegray-700) !important;
}
:host ::ng-deep .active\\:border-bluegray-800:active {
  border-color: var(--bluegray-800) !important;
}
:host ::ng-deep .active\\:border-bluegray-900:active {
  border-color: var(--bluegray-900) !important;
}
:host ::ng-deep .border-purple-50 {
  border-color: var(--purple-50) !important;
}
:host ::ng-deep .border-purple-100 {
  border-color: var(--purple-100) !important;
}
:host ::ng-deep .border-purple-200 {
  border-color: var(--purple-200) !important;
}
:host ::ng-deep .border-purple-300 {
  border-color: var(--purple-300) !important;
}
:host ::ng-deep .border-purple-400 {
  border-color: var(--purple-400) !important;
}
:host ::ng-deep .border-purple-500 {
  border-color: var(--purple-500) !important;
}
:host ::ng-deep .border-purple-600 {
  border-color: var(--purple-600) !important;
}
:host ::ng-deep .border-purple-700 {
  border-color: var(--purple-700) !important;
}
:host ::ng-deep .border-purple-800 {
  border-color: var(--purple-800) !important;
}
:host ::ng-deep .border-purple-900 {
  border-color: var(--purple-900) !important;
}
:host ::ng-deep .focus\\:border-purple-50:focus {
  border-color: var(--purple-50) !important;
}
:host ::ng-deep .focus\\:border-purple-100:focus {
  border-color: var(--purple-100) !important;
}
:host ::ng-deep .focus\\:border-purple-200:focus {
  border-color: var(--purple-200) !important;
}
:host ::ng-deep .focus\\:border-purple-300:focus {
  border-color: var(--purple-300) !important;
}
:host ::ng-deep .focus\\:border-purple-400:focus {
  border-color: var(--purple-400) !important;
}
:host ::ng-deep .focus\\:border-purple-500:focus {
  border-color: var(--purple-500) !important;
}
:host ::ng-deep .focus\\:border-purple-600:focus {
  border-color: var(--purple-600) !important;
}
:host ::ng-deep .focus\\:border-purple-700:focus {
  border-color: var(--purple-700) !important;
}
:host ::ng-deep .focus\\:border-purple-800:focus {
  border-color: var(--purple-800) !important;
}
:host ::ng-deep .focus\\:border-purple-900:focus {
  border-color: var(--purple-900) !important;
}
:host ::ng-deep .hover\\:border-purple-50:hover {
  border-color: var(--purple-50) !important;
}
:host ::ng-deep .hover\\:border-purple-100:hover {
  border-color: var(--purple-100) !important;
}
:host ::ng-deep .hover\\:border-purple-200:hover {
  border-color: var(--purple-200) !important;
}
:host ::ng-deep .hover\\:border-purple-300:hover {
  border-color: var(--purple-300) !important;
}
:host ::ng-deep .hover\\:border-purple-400:hover {
  border-color: var(--purple-400) !important;
}
:host ::ng-deep .hover\\:border-purple-500:hover {
  border-color: var(--purple-500) !important;
}
:host ::ng-deep .hover\\:border-purple-600:hover {
  border-color: var(--purple-600) !important;
}
:host ::ng-deep .hover\\:border-purple-700:hover {
  border-color: var(--purple-700) !important;
}
:host ::ng-deep .hover\\:border-purple-800:hover {
  border-color: var(--purple-800) !important;
}
:host ::ng-deep .hover\\:border-purple-900:hover {
  border-color: var(--purple-900) !important;
}
:host ::ng-deep .active\\:border-purple-50:active {
  border-color: var(--purple-50) !important;
}
:host ::ng-deep .active\\:border-purple-100:active {
  border-color: var(--purple-100) !important;
}
:host ::ng-deep .active\\:border-purple-200:active {
  border-color: var(--purple-200) !important;
}
:host ::ng-deep .active\\:border-purple-300:active {
  border-color: var(--purple-300) !important;
}
:host ::ng-deep .active\\:border-purple-400:active {
  border-color: var(--purple-400) !important;
}
:host ::ng-deep .active\\:border-purple-500:active {
  border-color: var(--purple-500) !important;
}
:host ::ng-deep .active\\:border-purple-600:active {
  border-color: var(--purple-600) !important;
}
:host ::ng-deep .active\\:border-purple-700:active {
  border-color: var(--purple-700) !important;
}
:host ::ng-deep .active\\:border-purple-800:active {
  border-color: var(--purple-800) !important;
}
:host ::ng-deep .active\\:border-purple-900:active {
  border-color: var(--purple-900) !important;
}
:host ::ng-deep .border-gray-50 {
  border-color: var(--gray-50) !important;
}
:host ::ng-deep .border-gray-100 {
  border-color: var(--gray-100) !important;
}
:host ::ng-deep .border-gray-200 {
  border-color: var(--gray-200) !important;
}
:host ::ng-deep .border-gray-300 {
  border-color: var(--gray-300) !important;
}
:host ::ng-deep .border-gray-400 {
  border-color: var(--gray-400) !important;
}
:host ::ng-deep .border-gray-500 {
  border-color: var(--gray-500) !important;
}
:host ::ng-deep .border-gray-600 {
  border-color: var(--gray-600) !important;
}
:host ::ng-deep .border-gray-700 {
  border-color: var(--gray-700) !important;
}
:host ::ng-deep .border-gray-800 {
  border-color: var(--gray-800) !important;
}
:host ::ng-deep .border-gray-900 {
  border-color: var(--gray-900) !important;
}
:host ::ng-deep .focus\\:border-gray-50:focus {
  border-color: var(--gray-50) !important;
}
:host ::ng-deep .focus\\:border-gray-100:focus {
  border-color: var(--gray-100) !important;
}
:host ::ng-deep .focus\\:border-gray-200:focus {
  border-color: var(--gray-200) !important;
}
:host ::ng-deep .focus\\:border-gray-300:focus {
  border-color: var(--gray-300) !important;
}
:host ::ng-deep .focus\\:border-gray-400:focus {
  border-color: var(--gray-400) !important;
}
:host ::ng-deep .focus\\:border-gray-500:focus {
  border-color: var(--gray-500) !important;
}
:host ::ng-deep .focus\\:border-gray-600:focus {
  border-color: var(--gray-600) !important;
}
:host ::ng-deep .focus\\:border-gray-700:focus {
  border-color: var(--gray-700) !important;
}
:host ::ng-deep .focus\\:border-gray-800:focus {
  border-color: var(--gray-800) !important;
}
:host ::ng-deep .focus\\:border-gray-900:focus {
  border-color: var(--gray-900) !important;
}
:host ::ng-deep .hover\\:border-gray-50:hover {
  border-color: var(--gray-50) !important;
}
:host ::ng-deep .hover\\:border-gray-100:hover {
  border-color: var(--gray-100) !important;
}
:host ::ng-deep .hover\\:border-gray-200:hover {
  border-color: var(--gray-200) !important;
}
:host ::ng-deep .hover\\:border-gray-300:hover {
  border-color: var(--gray-300) !important;
}
:host ::ng-deep .hover\\:border-gray-400:hover {
  border-color: var(--gray-400) !important;
}
:host ::ng-deep .hover\\:border-gray-500:hover {
  border-color: var(--gray-500) !important;
}
:host ::ng-deep .hover\\:border-gray-600:hover {
  border-color: var(--gray-600) !important;
}
:host ::ng-deep .hover\\:border-gray-700:hover {
  border-color: var(--gray-700) !important;
}
:host ::ng-deep .hover\\:border-gray-800:hover {
  border-color: var(--gray-800) !important;
}
:host ::ng-deep .hover\\:border-gray-900:hover {
  border-color: var(--gray-900) !important;
}
:host ::ng-deep .active\\:border-gray-50:active {
  border-color: var(--gray-50) !important;
}
:host ::ng-deep .active\\:border-gray-100:active {
  border-color: var(--gray-100) !important;
}
:host ::ng-deep .active\\:border-gray-200:active {
  border-color: var(--gray-200) !important;
}
:host ::ng-deep .active\\:border-gray-300:active {
  border-color: var(--gray-300) !important;
}
:host ::ng-deep .active\\:border-gray-400:active {
  border-color: var(--gray-400) !important;
}
:host ::ng-deep .active\\:border-gray-500:active {
  border-color: var(--gray-500) !important;
}
:host ::ng-deep .active\\:border-gray-600:active {
  border-color: var(--gray-600) !important;
}
:host ::ng-deep .active\\:border-gray-700:active {
  border-color: var(--gray-700) !important;
}
:host ::ng-deep .active\\:border-gray-800:active {
  border-color: var(--gray-800) !important;
}
:host ::ng-deep .active\\:border-gray-900:active {
  border-color: var(--gray-900) !important;
}
:host ::ng-deep .border-red-50 {
  border-color: var(--red-50) !important;
}
:host ::ng-deep .border-red-100 {
  border-color: var(--red-100) !important;
}
:host ::ng-deep .border-red-200 {
  border-color: var(--red-200) !important;
}
:host ::ng-deep .border-red-300 {
  border-color: var(--red-300) !important;
}
:host ::ng-deep .border-red-400 {
  border-color: var(--red-400) !important;
}
:host ::ng-deep .border-red-500 {
  border-color: var(--red-500) !important;
}
:host ::ng-deep .border-red-600 {
  border-color: var(--red-600) !important;
}
:host ::ng-deep .border-red-700 {
  border-color: var(--red-700) !important;
}
:host ::ng-deep .border-red-800 {
  border-color: var(--red-800) !important;
}
:host ::ng-deep .border-red-900 {
  border-color: var(--red-900) !important;
}
:host ::ng-deep .focus\\:border-red-50:focus {
  border-color: var(--red-50) !important;
}
:host ::ng-deep .focus\\:border-red-100:focus {
  border-color: var(--red-100) !important;
}
:host ::ng-deep .focus\\:border-red-200:focus {
  border-color: var(--red-200) !important;
}
:host ::ng-deep .focus\\:border-red-300:focus {
  border-color: var(--red-300) !important;
}
:host ::ng-deep .focus\\:border-red-400:focus {
  border-color: var(--red-400) !important;
}
:host ::ng-deep .focus\\:border-red-500:focus {
  border-color: var(--red-500) !important;
}
:host ::ng-deep .focus\\:border-red-600:focus {
  border-color: var(--red-600) !important;
}
:host ::ng-deep .focus\\:border-red-700:focus {
  border-color: var(--red-700) !important;
}
:host ::ng-deep .focus\\:border-red-800:focus {
  border-color: var(--red-800) !important;
}
:host ::ng-deep .focus\\:border-red-900:focus {
  border-color: var(--red-900) !important;
}
:host ::ng-deep .hover\\:border-red-50:hover {
  border-color: var(--red-50) !important;
}
:host ::ng-deep .hover\\:border-red-100:hover {
  border-color: var(--red-100) !important;
}
:host ::ng-deep .hover\\:border-red-200:hover {
  border-color: var(--red-200) !important;
}
:host ::ng-deep .hover\\:border-red-300:hover {
  border-color: var(--red-300) !important;
}
:host ::ng-deep .hover\\:border-red-400:hover {
  border-color: var(--red-400) !important;
}
:host ::ng-deep .hover\\:border-red-500:hover {
  border-color: var(--red-500) !important;
}
:host ::ng-deep .hover\\:border-red-600:hover {
  border-color: var(--red-600) !important;
}
:host ::ng-deep .hover\\:border-red-700:hover {
  border-color: var(--red-700) !important;
}
:host ::ng-deep .hover\\:border-red-800:hover {
  border-color: var(--red-800) !important;
}
:host ::ng-deep .hover\\:border-red-900:hover {
  border-color: var(--red-900) !important;
}
:host ::ng-deep .active\\:border-red-50:active {
  border-color: var(--red-50) !important;
}
:host ::ng-deep .active\\:border-red-100:active {
  border-color: var(--red-100) !important;
}
:host ::ng-deep .active\\:border-red-200:active {
  border-color: var(--red-200) !important;
}
:host ::ng-deep .active\\:border-red-300:active {
  border-color: var(--red-300) !important;
}
:host ::ng-deep .active\\:border-red-400:active {
  border-color: var(--red-400) !important;
}
:host ::ng-deep .active\\:border-red-500:active {
  border-color: var(--red-500) !important;
}
:host ::ng-deep .active\\:border-red-600:active {
  border-color: var(--red-600) !important;
}
:host ::ng-deep .active\\:border-red-700:active {
  border-color: var(--red-700) !important;
}
:host ::ng-deep .active\\:border-red-800:active {
  border-color: var(--red-800) !important;
}
:host ::ng-deep .active\\:border-red-900:active {
  border-color: var(--red-900) !important;
}
:host ::ng-deep .border-primary-50 {
  border-color: var(--primary-50) !important;
}
:host ::ng-deep .border-primary-100 {
  border-color: var(--primary-100) !important;
}
:host ::ng-deep .border-primary-200 {
  border-color: var(--primary-200) !important;
}
:host ::ng-deep .border-primary-300 {
  border-color: var(--primary-300) !important;
}
:host ::ng-deep .border-primary-400 {
  border-color: var(--primary-400) !important;
}
:host ::ng-deep .border-primary-500 {
  border-color: var(--primary-500) !important;
}
:host ::ng-deep .border-primary-600 {
  border-color: var(--primary-600) !important;
}
:host ::ng-deep .border-primary-700 {
  border-color: var(--primary-700) !important;
}
:host ::ng-deep .border-primary-800 {
  border-color: var(--primary-800) !important;
}
:host ::ng-deep .border-primary-900 {
  border-color: var(--primary-900) !important;
}
:host ::ng-deep .focus\\:border-primary-50:focus {
  border-color: var(--primary-50) !important;
}
:host ::ng-deep .focus\\:border-primary-100:focus {
  border-color: var(--primary-100) !important;
}
:host ::ng-deep .focus\\:border-primary-200:focus {
  border-color: var(--primary-200) !important;
}
:host ::ng-deep .focus\\:border-primary-300:focus {
  border-color: var(--primary-300) !important;
}
:host ::ng-deep .focus\\:border-primary-400:focus {
  border-color: var(--primary-400) !important;
}
:host ::ng-deep .focus\\:border-primary-500:focus {
  border-color: var(--primary-500) !important;
}
:host ::ng-deep .focus\\:border-primary-600:focus {
  border-color: var(--primary-600) !important;
}
:host ::ng-deep .focus\\:border-primary-700:focus {
  border-color: var(--primary-700) !important;
}
:host ::ng-deep .focus\\:border-primary-800:focus {
  border-color: var(--primary-800) !important;
}
:host ::ng-deep .focus\\:border-primary-900:focus {
  border-color: var(--primary-900) !important;
}
:host ::ng-deep .hover\\:border-primary-50:hover {
  border-color: var(--primary-50) !important;
}
:host ::ng-deep .hover\\:border-primary-100:hover {
  border-color: var(--primary-100) !important;
}
:host ::ng-deep .hover\\:border-primary-200:hover {
  border-color: var(--primary-200) !important;
}
:host ::ng-deep .hover\\:border-primary-300:hover {
  border-color: var(--primary-300) !important;
}
:host ::ng-deep .hover\\:border-primary-400:hover {
  border-color: var(--primary-400) !important;
}
:host ::ng-deep .hover\\:border-primary-500:hover {
  border-color: var(--primary-500) !important;
}
:host ::ng-deep .hover\\:border-primary-600:hover {
  border-color: var(--primary-600) !important;
}
:host ::ng-deep .hover\\:border-primary-700:hover {
  border-color: var(--primary-700) !important;
}
:host ::ng-deep .hover\\:border-primary-800:hover {
  border-color: var(--primary-800) !important;
}
:host ::ng-deep .hover\\:border-primary-900:hover {
  border-color: var(--primary-900) !important;
}
:host ::ng-deep .active\\:border-primary-50:active {
  border-color: var(--primary-50) !important;
}
:host ::ng-deep .active\\:border-primary-100:active {
  border-color: var(--primary-100) !important;
}
:host ::ng-deep .active\\:border-primary-200:active {
  border-color: var(--primary-200) !important;
}
:host ::ng-deep .active\\:border-primary-300:active {
  border-color: var(--primary-300) !important;
}
:host ::ng-deep .active\\:border-primary-400:active {
  border-color: var(--primary-400) !important;
}
:host ::ng-deep .active\\:border-primary-500:active {
  border-color: var(--primary-500) !important;
}
:host ::ng-deep .active\\:border-primary-600:active {
  border-color: var(--primary-600) !important;
}
:host ::ng-deep .active\\:border-primary-700:active {
  border-color: var(--primary-700) !important;
}
:host ::ng-deep .active\\:border-primary-800:active {
  border-color: var(--primary-800) !important;
}
:host ::ng-deep .active\\:border-primary-900:active {
  border-color: var(--primary-900) !important;
}
:host ::ng-deep .bg-white-alpha-10 {
  background-color: rgba(255, 255, 255, 0.1019607843) !important;
}
:host ::ng-deep .bg-white-alpha-20 {
  background-color: rgba(255, 255, 255, 0.2) !important;
}
:host ::ng-deep .bg-white-alpha-30 {
  background-color: rgba(255, 255, 255, 0.3019607843) !important;
}
:host ::ng-deep .bg-white-alpha-40 {
  background-color: rgba(255, 255, 255, 0.4) !important;
}
:host ::ng-deep .bg-white-alpha-50 {
  background-color: rgba(255, 255, 255, 0.5019607843) !important;
}
:host ::ng-deep .bg-white-alpha-60 {
  background-color: rgba(255, 255, 255, 0.6) !important;
}
:host ::ng-deep .bg-white-alpha-70 {
  background-color: rgba(255, 255, 255, 0.7019607843) !important;
}
:host ::ng-deep .bg-white-alpha-80 {
  background-color: rgba(255, 255, 255, 0.8) !important;
}
:host ::ng-deep .bg-white-alpha-90 {
  background-color: rgba(255, 255, 255, 0.9019607843) !important;
}
:host ::ng-deep .hover\\:bg-white-alpha-10:hover {
  background-color: rgba(255, 255, 255, 0.1019607843) !important;
}
:host ::ng-deep .hover\\:bg-white-alpha-20:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
}
:host ::ng-deep .hover\\:bg-white-alpha-30:hover {
  background-color: rgba(255, 255, 255, 0.3019607843) !important;
}
:host ::ng-deep .hover\\:bg-white-alpha-40:hover {
  background-color: rgba(255, 255, 255, 0.4) !important;
}
:host ::ng-deep .hover\\:bg-white-alpha-50:hover {
  background-color: rgba(255, 255, 255, 0.5019607843) !important;
}
:host ::ng-deep .hover\\:bg-white-alpha-60:hover {
  background-color: rgba(255, 255, 255, 0.6) !important;
}
:host ::ng-deep .hover\\:bg-white-alpha-70:hover {
  background-color: rgba(255, 255, 255, 0.7019607843) !important;
}
:host ::ng-deep .hover\\:bg-white-alpha-80:hover {
  background-color: rgba(255, 255, 255, 0.8) !important;
}
:host ::ng-deep .hover\\:bg-white-alpha-90:hover {
  background-color: rgba(255, 255, 255, 0.9019607843) !important;
}
:host ::ng-deep .focus\\:bg-white-alpha-10:focus {
  background-color: rgba(255, 255, 255, 0.1019607843) !important;
}
:host ::ng-deep .focus\\:bg-white-alpha-20:focus {
  background-color: rgba(255, 255, 255, 0.2) !important;
}
:host ::ng-deep .focus\\:bg-white-alpha-30:focus {
  background-color: rgba(255, 255, 255, 0.3019607843) !important;
}
:host ::ng-deep .focus\\:bg-white-alpha-40:focus {
  background-color: rgba(255, 255, 255, 0.4) !important;
}
:host ::ng-deep .focus\\:bg-white-alpha-50:focus {
  background-color: rgba(255, 255, 255, 0.5019607843) !important;
}
:host ::ng-deep .focus\\:bg-white-alpha-60:focus {
  background-color: rgba(255, 255, 255, 0.6) !important;
}
:host ::ng-deep .focus\\:bg-white-alpha-70:focus {
  background-color: rgba(255, 255, 255, 0.7019607843) !important;
}
:host ::ng-deep .focus\\:bg-white-alpha-80:focus {
  background-color: rgba(255, 255, 255, 0.8) !important;
}
:host ::ng-deep .focus\\:bg-white-alpha-90:focus {
  background-color: rgba(255, 255, 255, 0.9019607843) !important;
}
:host ::ng-deep .active\\:bg-white-alpha-10:active {
  background-color: rgba(255, 255, 255, 0.1019607843) !important;
}
:host ::ng-deep .active\\:bg-white-alpha-20:active {
  background-color: rgba(255, 255, 255, 0.2) !important;
}
:host ::ng-deep .active\\:bg-white-alpha-30:active {
  background-color: rgba(255, 255, 255, 0.3019607843) !important;
}
:host ::ng-deep .active\\:bg-white-alpha-40:active {
  background-color: rgba(255, 255, 255, 0.4) !important;
}
:host ::ng-deep .active\\:bg-white-alpha-50:active {
  background-color: rgba(255, 255, 255, 0.5019607843) !important;
}
:host ::ng-deep .active\\:bg-white-alpha-60:active {
  background-color: rgba(255, 255, 255, 0.6) !important;
}
:host ::ng-deep .active\\:bg-white-alpha-70:active {
  background-color: rgba(255, 255, 255, 0.7019607843) !important;
}
:host ::ng-deep .active\\:bg-white-alpha-80:active {
  background-color: rgba(255, 255, 255, 0.8) !important;
}
:host ::ng-deep .active\\:bg-white-alpha-90:active {
  background-color: rgba(255, 255, 255, 0.9019607843) !important;
}
:host ::ng-deep .bg-black-alpha-10 {
  background-color: rgba(0, 0, 0, 0.1019607843) !important;
}
:host ::ng-deep .bg-black-alpha-20 {
  background-color: rgba(0, 0, 0, 0.2) !important;
}
:host ::ng-deep .bg-black-alpha-30 {
  background-color: rgba(0, 0, 0, 0.3019607843) !important;
}
:host ::ng-deep .bg-black-alpha-40 {
  background-color: rgba(0, 0, 0, 0.4) !important;
}
:host ::ng-deep .bg-black-alpha-50 {
  background-color: rgba(0, 0, 0, 0.5019607843) !important;
}
:host ::ng-deep .bg-black-alpha-60 {
  background-color: rgba(0, 0, 0, 0.6) !important;
}
:host ::ng-deep .bg-black-alpha-70 {
  background-color: rgba(0, 0, 0, 0.7019607843) !important;
}
:host ::ng-deep .bg-black-alpha-80 {
  background-color: rgba(0, 0, 0, 0.8) !important;
}
:host ::ng-deep .bg-black-alpha-90 {
  background-color: rgba(0, 0, 0, 0.9019607843) !important;
}
:host ::ng-deep .hover\\:bg-black-alpha-10:hover {
  background-color: rgba(0, 0, 0, 0.1019607843) !important;
}
:host ::ng-deep .hover\\:bg-black-alpha-20:hover {
  background-color: rgba(0, 0, 0, 0.2) !important;
}
:host ::ng-deep .hover\\:bg-black-alpha-30:hover {
  background-color: rgba(0, 0, 0, 0.3019607843) !important;
}
:host ::ng-deep .hover\\:bg-black-alpha-40:hover {
  background-color: rgba(0, 0, 0, 0.4) !important;
}
:host ::ng-deep .hover\\:bg-black-alpha-50:hover {
  background-color: rgba(0, 0, 0, 0.5019607843) !important;
}
:host ::ng-deep .hover\\:bg-black-alpha-60:hover {
  background-color: rgba(0, 0, 0, 0.6) !important;
}
:host ::ng-deep .hover\\:bg-black-alpha-70:hover {
  background-color: rgba(0, 0, 0, 0.7019607843) !important;
}
:host ::ng-deep .hover\\:bg-black-alpha-80:hover {
  background-color: rgba(0, 0, 0, 0.8) !important;
}
:host ::ng-deep .hover\\:bg-black-alpha-90:hover {
  background-color: rgba(0, 0, 0, 0.9019607843) !important;
}
:host ::ng-deep .focus\\:bg-black-alpha-10:focus {
  background-color: rgba(0, 0, 0, 0.1019607843) !important;
}
:host ::ng-deep .focus\\:bg-black-alpha-20:focus {
  background-color: rgba(0, 0, 0, 0.2) !important;
}
:host ::ng-deep .focus\\:bg-black-alpha-30:focus {
  background-color: rgba(0, 0, 0, 0.3019607843) !important;
}
:host ::ng-deep .focus\\:bg-black-alpha-40:focus {
  background-color: rgba(0, 0, 0, 0.4) !important;
}
:host ::ng-deep .focus\\:bg-black-alpha-50:focus {
  background-color: rgba(0, 0, 0, 0.5019607843) !important;
}
:host ::ng-deep .focus\\:bg-black-alpha-60:focus {
  background-color: rgba(0, 0, 0, 0.6) !important;
}
:host ::ng-deep .focus\\:bg-black-alpha-70:focus {
  background-color: rgba(0, 0, 0, 0.7019607843) !important;
}
:host ::ng-deep .focus\\:bg-black-alpha-80:focus {
  background-color: rgba(0, 0, 0, 0.8) !important;
}
:host ::ng-deep .focus\\:bg-black-alpha-90:focus {
  background-color: rgba(0, 0, 0, 0.9019607843) !important;
}
:host ::ng-deep .active\\:bg-black-alpha-10:active {
  background-color: rgba(0, 0, 0, 0.1019607843) !important;
}
:host ::ng-deep .active\\:bg-black-alpha-20:active {
  background-color: rgba(0, 0, 0, 0.2) !important;
}
:host ::ng-deep .active\\:bg-black-alpha-30:active {
  background-color: rgba(0, 0, 0, 0.3019607843) !important;
}
:host ::ng-deep .active\\:bg-black-alpha-40:active {
  background-color: rgba(0, 0, 0, 0.4) !important;
}
:host ::ng-deep .active\\:bg-black-alpha-50:active {
  background-color: rgba(0, 0, 0, 0.5019607843) !important;
}
:host ::ng-deep .active\\:bg-black-alpha-60:active {
  background-color: rgba(0, 0, 0, 0.6) !important;
}
:host ::ng-deep .active\\:bg-black-alpha-70:active {
  background-color: rgba(0, 0, 0, 0.7019607843) !important;
}
:host ::ng-deep .active\\:bg-black-alpha-80:active {
  background-color: rgba(0, 0, 0, 0.8) !important;
}
:host ::ng-deep .active\\:bg-black-alpha-90:active {
  background-color: rgba(0, 0, 0, 0.9019607843) !important;
}
:host ::ng-deep .border-white-alpha-10 {
  border-color: rgba(255, 255, 255, 0.1019607843) !important;
}
:host ::ng-deep .border-white-alpha-20 {
  border-color: rgba(255, 255, 255, 0.2) !important;
}
:host ::ng-deep .border-white-alpha-30 {
  border-color: rgba(255, 255, 255, 0.3019607843) !important;
}
:host ::ng-deep .border-white-alpha-40 {
  border-color: rgba(255, 255, 255, 0.4) !important;
}
:host ::ng-deep .border-white-alpha-50 {
  border-color: rgba(255, 255, 255, 0.5019607843) !important;
}
:host ::ng-deep .border-white-alpha-60 {
  border-color: rgba(255, 255, 255, 0.6) !important;
}
:host ::ng-deep .border-white-alpha-70 {
  border-color: rgba(255, 255, 255, 0.7019607843) !important;
}
:host ::ng-deep .border-white-alpha-80 {
  border-color: rgba(255, 255, 255, 0.8) !important;
}
:host ::ng-deep .border-white-alpha-90 {
  border-color: rgba(255, 255, 255, 0.9019607843) !important;
}
:host ::ng-deep .hover\\:border-white-alpha-10:hover {
  border-color: rgba(255, 255, 255, 0.1019607843) !important;
}
:host ::ng-deep .hover\\:border-white-alpha-20:hover {
  border-color: rgba(255, 255, 255, 0.2) !important;
}
:host ::ng-deep .hover\\:border-white-alpha-30:hover {
  border-color: rgba(255, 255, 255, 0.3019607843) !important;
}
:host ::ng-deep .hover\\:border-white-alpha-40:hover {
  border-color: rgba(255, 255, 255, 0.4) !important;
}
:host ::ng-deep .hover\\:border-white-alpha-50:hover {
  border-color: rgba(255, 255, 255, 0.5019607843) !important;
}
:host ::ng-deep .hover\\:border-white-alpha-60:hover {
  border-color: rgba(255, 255, 255, 0.6) !important;
}
:host ::ng-deep .hover\\:border-white-alpha-70:hover {
  border-color: rgba(255, 255, 255, 0.7019607843) !important;
}
:host ::ng-deep .hover\\:border-white-alpha-80:hover {
  border-color: rgba(255, 255, 255, 0.8) !important;
}
:host ::ng-deep .hover\\:border-white-alpha-90:hover {
  border-color: rgba(255, 255, 255, 0.9019607843) !important;
}
:host ::ng-deep .focus\\:border-white-alpha-10:focus {
  border-color: rgba(255, 255, 255, 0.1019607843) !important;
}
:host ::ng-deep .focus\\:border-white-alpha-20:focus {
  border-color: rgba(255, 255, 255, 0.2) !important;
}
:host ::ng-deep .focus\\:border-white-alpha-30:focus {
  border-color: rgba(255, 255, 255, 0.3019607843) !important;
}
:host ::ng-deep .focus\\:border-white-alpha-40:focus {
  border-color: rgba(255, 255, 255, 0.4) !important;
}
:host ::ng-deep .focus\\:border-white-alpha-50:focus {
  border-color: rgba(255, 255, 255, 0.5019607843) !important;
}
:host ::ng-deep .focus\\:border-white-alpha-60:focus {
  border-color: rgba(255, 255, 255, 0.6) !important;
}
:host ::ng-deep .focus\\:border-white-alpha-70:focus {
  border-color: rgba(255, 255, 255, 0.7019607843) !important;
}
:host ::ng-deep .focus\\:border-white-alpha-80:focus {
  border-color: rgba(255, 255, 255, 0.8) !important;
}
:host ::ng-deep .focus\\:border-white-alpha-90:focus {
  border-color: rgba(255, 255, 255, 0.9019607843) !important;
}
:host ::ng-deep .active\\:border-white-alpha-10:active {
  border-color: rgba(255, 255, 255, 0.1019607843) !important;
}
:host ::ng-deep .active\\:border-white-alpha-20:active {
  border-color: rgba(255, 255, 255, 0.2) !important;
}
:host ::ng-deep .active\\:border-white-alpha-30:active {
  border-color: rgba(255, 255, 255, 0.3019607843) !important;
}
:host ::ng-deep .active\\:border-white-alpha-40:active {
  border-color: rgba(255, 255, 255, 0.4) !important;
}
:host ::ng-deep .active\\:border-white-alpha-50:active {
  border-color: rgba(255, 255, 255, 0.5019607843) !important;
}
:host ::ng-deep .active\\:border-white-alpha-60:active {
  border-color: rgba(255, 255, 255, 0.6) !important;
}
:host ::ng-deep .active\\:border-white-alpha-70:active {
  border-color: rgba(255, 255, 255, 0.7019607843) !important;
}
:host ::ng-deep .active\\:border-white-alpha-80:active {
  border-color: rgba(255, 255, 255, 0.8) !important;
}
:host ::ng-deep .active\\:border-white-alpha-90:active {
  border-color: rgba(255, 255, 255, 0.9019607843) !important;
}
:host ::ng-deep .border-black-alpha-10 {
  border-color: rgba(0, 0, 0, 0.1019607843) !important;
}
:host ::ng-deep .border-black-alpha-20 {
  border-color: rgba(0, 0, 0, 0.2) !important;
}
:host ::ng-deep .border-black-alpha-30 {
  border-color: rgba(0, 0, 0, 0.3019607843) !important;
}
:host ::ng-deep .border-black-alpha-40 {
  border-color: rgba(0, 0, 0, 0.4) !important;
}
:host ::ng-deep .border-black-alpha-50 {
  border-color: rgba(0, 0, 0, 0.5019607843) !important;
}
:host ::ng-deep .border-black-alpha-60 {
  border-color: rgba(0, 0, 0, 0.6) !important;
}
:host ::ng-deep .border-black-alpha-70 {
  border-color: rgba(0, 0, 0, 0.7019607843) !important;
}
:host ::ng-deep .border-black-alpha-80 {
  border-color: rgba(0, 0, 0, 0.8) !important;
}
:host ::ng-deep .border-black-alpha-90 {
  border-color: rgba(0, 0, 0, 0.9019607843) !important;
}
:host ::ng-deep .hover\\:border-black-alpha-10:hover {
  border-color: rgba(0, 0, 0, 0.1019607843) !important;
}
:host ::ng-deep .hover\\:border-black-alpha-20:hover {
  border-color: rgba(0, 0, 0, 0.2) !important;
}
:host ::ng-deep .hover\\:border-black-alpha-30:hover {
  border-color: rgba(0, 0, 0, 0.3019607843) !important;
}
:host ::ng-deep .hover\\:border-black-alpha-40:hover {
  border-color: rgba(0, 0, 0, 0.4) !important;
}
:host ::ng-deep .hover\\:border-black-alpha-50:hover {
  border-color: rgba(0, 0, 0, 0.5019607843) !important;
}
:host ::ng-deep .hover\\:border-black-alpha-60:hover {
  border-color: rgba(0, 0, 0, 0.6) !important;
}
:host ::ng-deep .hover\\:border-black-alpha-70:hover {
  border-color: rgba(0, 0, 0, 0.7019607843) !important;
}
:host ::ng-deep .hover\\:border-black-alpha-80:hover {
  border-color: rgba(0, 0, 0, 0.8) !important;
}
:host ::ng-deep .hover\\:border-black-alpha-90:hover {
  border-color: rgba(0, 0, 0, 0.9019607843) !important;
}
:host ::ng-deep .focus\\:border-black-alpha-10:focus {
  border-color: rgba(0, 0, 0, 0.1019607843) !important;
}
:host ::ng-deep .focus\\:border-black-alpha-20:focus {
  border-color: rgba(0, 0, 0, 0.2) !important;
}
:host ::ng-deep .focus\\:border-black-alpha-30:focus {
  border-color: rgba(0, 0, 0, 0.3019607843) !important;
}
:host ::ng-deep .focus\\:border-black-alpha-40:focus {
  border-color: rgba(0, 0, 0, 0.4) !important;
}
:host ::ng-deep .focus\\:border-black-alpha-50:focus {
  border-color: rgba(0, 0, 0, 0.5019607843) !important;
}
:host ::ng-deep .focus\\:border-black-alpha-60:focus {
  border-color: rgba(0, 0, 0, 0.6) !important;
}
:host ::ng-deep .focus\\:border-black-alpha-70:focus {
  border-color: rgba(0, 0, 0, 0.7019607843) !important;
}
:host ::ng-deep .focus\\:border-black-alpha-80:focus {
  border-color: rgba(0, 0, 0, 0.8) !important;
}
:host ::ng-deep .focus\\:border-black-alpha-90:focus {
  border-color: rgba(0, 0, 0, 0.9019607843) !important;
}
:host ::ng-deep .active\\:border-black-alpha-10:active {
  border-color: rgba(0, 0, 0, 0.1019607843) !important;
}
:host ::ng-deep .active\\:border-black-alpha-20:active {
  border-color: rgba(0, 0, 0, 0.2) !important;
}
:host ::ng-deep .active\\:border-black-alpha-30:active {
  border-color: rgba(0, 0, 0, 0.3019607843) !important;
}
:host ::ng-deep .active\\:border-black-alpha-40:active {
  border-color: rgba(0, 0, 0, 0.4) !important;
}
:host ::ng-deep .active\\:border-black-alpha-50:active {
  border-color: rgba(0, 0, 0, 0.5019607843) !important;
}
:host ::ng-deep .active\\:border-black-alpha-60:active {
  border-color: rgba(0, 0, 0, 0.6) !important;
}
:host ::ng-deep .active\\:border-black-alpha-70:active {
  border-color: rgba(0, 0, 0, 0.7019607843) !important;
}
:host ::ng-deep .active\\:border-black-alpha-80:active {
  border-color: rgba(0, 0, 0, 0.8) !important;
}
:host ::ng-deep .active\\:border-black-alpha-90:active {
  border-color: rgba(0, 0, 0, 0.9019607843) !important;
}
:host ::ng-deep .text-white-alpha-10 {
  color: rgba(255, 255, 255, 0.1019607843) !important;
}
:host ::ng-deep .text-white-alpha-20 {
  color: rgba(255, 255, 255, 0.2) !important;
}
:host ::ng-deep .text-white-alpha-30 {
  color: rgba(255, 255, 255, 0.3019607843) !important;
}
:host ::ng-deep .text-white-alpha-40 {
  color: rgba(255, 255, 255, 0.4) !important;
}
:host ::ng-deep .text-white-alpha-50 {
  color: rgba(255, 255, 255, 0.5019607843) !important;
}
:host ::ng-deep .text-white-alpha-60 {
  color: rgba(255, 255, 255, 0.6) !important;
}
:host ::ng-deep .text-white-alpha-70 {
  color: rgba(255, 255, 255, 0.7019607843) !important;
}
:host ::ng-deep .text-white-alpha-80 {
  color: rgba(255, 255, 255, 0.8) !important;
}
:host ::ng-deep .text-white-alpha-90 {
  color: rgba(255, 255, 255, 0.9019607843) !important;
}
:host ::ng-deep .hover\\:text-white-alpha-10:hover {
  color: rgba(255, 255, 255, 0.1019607843) !important;
}
:host ::ng-deep .hover\\:text-white-alpha-20:hover {
  color: rgba(255, 255, 255, 0.2) !important;
}
:host ::ng-deep .hover\\:text-white-alpha-30:hover {
  color: rgba(255, 255, 255, 0.3019607843) !important;
}
:host ::ng-deep .hover\\:text-white-alpha-40:hover {
  color: rgba(255, 255, 255, 0.4) !important;
}
:host ::ng-deep .hover\\:text-white-alpha-50:hover {
  color: rgba(255, 255, 255, 0.5019607843) !important;
}
:host ::ng-deep .hover\\:text-white-alpha-60:hover {
  color: rgba(255, 255, 255, 0.6) !important;
}
:host ::ng-deep .hover\\:text-white-alpha-70:hover {
  color: rgba(255, 255, 255, 0.7019607843) !important;
}
:host ::ng-deep .hover\\:text-white-alpha-80:hover {
  color: rgba(255, 255, 255, 0.8) !important;
}
:host ::ng-deep .hover\\:text-white-alpha-90:hover {
  color: rgba(255, 255, 255, 0.9019607843) !important;
}
:host ::ng-deep .focus\\:text-white-alpha-10:focus {
  color: rgba(255, 255, 255, 0.1019607843) !important;
}
:host ::ng-deep .focus\\:text-white-alpha-20:focus {
  color: rgba(255, 255, 255, 0.2) !important;
}
:host ::ng-deep .focus\\:text-white-alpha-30:focus {
  color: rgba(255, 255, 255, 0.3019607843) !important;
}
:host ::ng-deep .focus\\:text-white-alpha-40:focus {
  color: rgba(255, 255, 255, 0.4) !important;
}
:host ::ng-deep .focus\\:text-white-alpha-50:focus {
  color: rgba(255, 255, 255, 0.5019607843) !important;
}
:host ::ng-deep .focus\\:text-white-alpha-60:focus {
  color: rgba(255, 255, 255, 0.6) !important;
}
:host ::ng-deep .focus\\:text-white-alpha-70:focus {
  color: rgba(255, 255, 255, 0.7019607843) !important;
}
:host ::ng-deep .focus\\:text-white-alpha-80:focus {
  color: rgba(255, 255, 255, 0.8) !important;
}
:host ::ng-deep .focus\\:text-white-alpha-90:focus {
  color: rgba(255, 255, 255, 0.9019607843) !important;
}
:host ::ng-deep .active\\:text-white-alpha-10:active {
  color: rgba(255, 255, 255, 0.1019607843) !important;
}
:host ::ng-deep .active\\:text-white-alpha-20:active {
  color: rgba(255, 255, 255, 0.2) !important;
}
:host ::ng-deep .active\\:text-white-alpha-30:active {
  color: rgba(255, 255, 255, 0.3019607843) !important;
}
:host ::ng-deep .active\\:text-white-alpha-40:active {
  color: rgba(255, 255, 255, 0.4) !important;
}
:host ::ng-deep .active\\:text-white-alpha-50:active {
  color: rgba(255, 255, 255, 0.5019607843) !important;
}
:host ::ng-deep .active\\:text-white-alpha-60:active {
  color: rgba(255, 255, 255, 0.6) !important;
}
:host ::ng-deep .active\\:text-white-alpha-70:active {
  color: rgba(255, 255, 255, 0.7019607843) !important;
}
:host ::ng-deep .active\\:text-white-alpha-80:active {
  color: rgba(255, 255, 255, 0.8) !important;
}
:host ::ng-deep .active\\:text-white-alpha-90:active {
  color: rgba(255, 255, 255, 0.9019607843) !important;
}
:host ::ng-deep .text-black-alpha-10 {
  color: rgba(0, 0, 0, 0.1019607843) !important;
}
:host ::ng-deep .text-black-alpha-20 {
  color: rgba(0, 0, 0, 0.2) !important;
}
:host ::ng-deep .text-black-alpha-30 {
  color: rgba(0, 0, 0, 0.3019607843) !important;
}
:host ::ng-deep .text-black-alpha-40 {
  color: rgba(0, 0, 0, 0.4) !important;
}
:host ::ng-deep .text-black-alpha-50 {
  color: rgba(0, 0, 0, 0.5019607843) !important;
}
:host ::ng-deep .text-black-alpha-60 {
  color: rgba(0, 0, 0, 0.6) !important;
}
:host ::ng-deep .text-black-alpha-70 {
  color: rgba(0, 0, 0, 0.7019607843) !important;
}
:host ::ng-deep .text-black-alpha-80 {
  color: rgba(0, 0, 0, 0.8) !important;
}
:host ::ng-deep .text-black-alpha-90 {
  color: rgba(0, 0, 0, 0.9019607843) !important;
}
:host ::ng-deep .hover\\:text-black-alpha-10:hover {
  color: rgba(0, 0, 0, 0.1019607843) !important;
}
:host ::ng-deep .hover\\:text-black-alpha-20:hover {
  color: rgba(0, 0, 0, 0.2) !important;
}
:host ::ng-deep .hover\\:text-black-alpha-30:hover {
  color: rgba(0, 0, 0, 0.3019607843) !important;
}
:host ::ng-deep .hover\\:text-black-alpha-40:hover {
  color: rgba(0, 0, 0, 0.4) !important;
}
:host ::ng-deep .hover\\:text-black-alpha-50:hover {
  color: rgba(0, 0, 0, 0.5019607843) !important;
}
:host ::ng-deep .hover\\:text-black-alpha-60:hover {
  color: rgba(0, 0, 0, 0.6) !important;
}
:host ::ng-deep .hover\\:text-black-alpha-70:hover {
  color: rgba(0, 0, 0, 0.7019607843) !important;
}
:host ::ng-deep .hover\\:text-black-alpha-80:hover {
  color: rgba(0, 0, 0, 0.8) !important;
}
:host ::ng-deep .hover\\:text-black-alpha-90:hover {
  color: rgba(0, 0, 0, 0.9019607843) !important;
}
:host ::ng-deep .focus\\:text-black-alpha-10:focus {
  color: rgba(0, 0, 0, 0.1019607843) !important;
}
:host ::ng-deep .focus\\:text-black-alpha-20:focus {
  color: rgba(0, 0, 0, 0.2) !important;
}
:host ::ng-deep .focus\\:text-black-alpha-30:focus {
  color: rgba(0, 0, 0, 0.3019607843) !important;
}
:host ::ng-deep .focus\\:text-black-alpha-40:focus {
  color: rgba(0, 0, 0, 0.4) !important;
}
:host ::ng-deep .focus\\:text-black-alpha-50:focus {
  color: rgba(0, 0, 0, 0.5019607843) !important;
}
:host ::ng-deep .focus\\:text-black-alpha-60:focus {
  color: rgba(0, 0, 0, 0.6) !important;
}
:host ::ng-deep .focus\\:text-black-alpha-70:focus {
  color: rgba(0, 0, 0, 0.7019607843) !important;
}
:host ::ng-deep .focus\\:text-black-alpha-80:focus {
  color: rgba(0, 0, 0, 0.8) !important;
}
:host ::ng-deep .focus\\:text-black-alpha-90:focus {
  color: rgba(0, 0, 0, 0.9019607843) !important;
}
:host ::ng-deep .active\\:text-black-alpha-10:active {
  color: rgba(0, 0, 0, 0.1019607843) !important;
}
:host ::ng-deep .active\\:text-black-alpha-20:active {
  color: rgba(0, 0, 0, 0.2) !important;
}
:host ::ng-deep .active\\:text-black-alpha-30:active {
  color: rgba(0, 0, 0, 0.3019607843) !important;
}
:host ::ng-deep .active\\:text-black-alpha-40:active {
  color: rgba(0, 0, 0, 0.4) !important;
}
:host ::ng-deep .active\\:text-black-alpha-50:active {
  color: rgba(0, 0, 0, 0.5019607843) !important;
}
:host ::ng-deep .active\\:text-black-alpha-60:active {
  color: rgba(0, 0, 0, 0.6) !important;
}
:host ::ng-deep .active\\:text-black-alpha-70:active {
  color: rgba(0, 0, 0, 0.7019607843) !important;
}
:host ::ng-deep .active\\:text-black-alpha-80:active {
  color: rgba(0, 0, 0, 0.8) !important;
}
:host ::ng-deep .active\\:text-black-alpha-90:active {
  color: rgba(0, 0, 0, 0.9019607843) !important;
}
:host ::ng-deep .text-primary {
  color: var(--primary-color) !important;
}
:host ::ng-deep .bg-primary {
  color: var(--primary-color-text) !important;
  background-color: var(--primary-color) !important;
}
:host ::ng-deep .bg-primary-reverse {
  color: var(--primary-color) !important;
  background-color: var(--primary-color-text) !important;
}
:host ::ng-deep .bg-white {
  background-color: #fff !important;
}
:host ::ng-deep .border-primary {
  border-color: var(--primary-color) !important;
}
:host ::ng-deep .text-white {
  color: #fff !important;
}
:host ::ng-deep .border-white {
  border-color: #fff !important;
}
:host ::ng-deep .text-color {
  color: var(--text-color) !important;
}
:host ::ng-deep .text-color-secondary {
  color: var(--text-color-secondary) !important;
}
:host ::ng-deep .surface-ground {
  background-color: var(--surface-ground) !important;
}
:host ::ng-deep .surface-section {
  background-color: var(--surface-section) !important;
}
:host ::ng-deep .surface-card {
  background-color: var(--surface-card) !important;
}
:host ::ng-deep .surface-card\\:hover:hover {
  box-shadow: var(--shadow-4);
}
:host ::ng-deep .surface-overlay {
  background-color: var(--surface-overlay) !important;
}
:host ::ng-deep .surface-hover {
  background-color: var(--surface-hover) !important;
}
:host ::ng-deep .surface-border {
  border-color: var(--surface-border) !important;
}
:host ::ng-deep .focus\\:text-primary:focus {
  color: var(--primary-color) !important;
}
:host ::ng-deep .hover\\:text-primary:hover, :host ::ng-deep .active\\:text-primary:active {
  color: var(--primary-color) !important;
}
:host ::ng-deep .focus\\:bg-primary:focus {
  color: var(--primary-color-text) !important;
  background-color: var(--primary-color) !important;
}
:host ::ng-deep .hover\\:bg-primary:hover, :host ::ng-deep .active\\:bg-primary:active {
  color: var(--primary-color-text) !important;
  background-color: var(--primary-color) !important;
}
:host ::ng-deep .focus\\:bg-primary-reverse:focus {
  color: var(--primary-color) !important;
  background-color: var(--primary-color-text) !important;
}
:host ::ng-deep .hover\\:bg-primary-reverse:hover, :host ::ng-deep .active\\:bg-primary-reverse:active {
  color: var(--primary-color) !important;
  background-color: var(--primary-color-text) !important;
}
:host ::ng-deep .focus\\:bg-white:focus {
  background-color: #fff !important;
}
:host ::ng-deep .hover\\:bg-white:hover, :host ::ng-deep .active\\:bg-white:active {
  background-color: #fff !important;
}
:host ::ng-deep .focus\\:border-primary:focus {
  border-color: var(--primary-color) !important;
}
:host ::ng-deep .hover\\:border-primary:hover, :host ::ng-deep .active\\:border-primary:active {
  border-color: var(--primary-color) !important;
}
:host ::ng-deep .focus\\:text-white:focus {
  color: #fff !important;
}
:host ::ng-deep .hover\\:text-white:hover, :host ::ng-deep .active\\:text-white:active {
  color: #fff !important;
}
:host ::ng-deep .focus\\:border-white:focus {
  border-color: #fff !important;
}
:host ::ng-deep .hover\\:border-white:hover, :host ::ng-deep .active\\:border-white:active {
  border-color: #fff !important;
}
:host ::ng-deep .focus\\:text-color:focus {
  color: var(--text-color) !important;
}
:host ::ng-deep .hover\\:text-color:hover, :host ::ng-deep .active\\:text-color:active {
  color: var(--text-color) !important;
}
:host ::ng-deep .focus\\:text-color-secondary:focus {
  color: var(--text-color-secondary) !important;
}
:host ::ng-deep .hover\\:text-color-secondary:hover, :host ::ng-deep .active\\:text-color-secondary:active {
  color: var(--text-color-secondary) !important;
}
:host ::ng-deep .focus\\:surface-ground:focus {
  background-color: var(--surface-ground) !important;
}
:host ::ng-deep .hover\\:surface-ground:hover, :host ::ng-deep .active\\:surface-ground:active {
  background-color: var(--surface-ground) !important;
}
:host ::ng-deep .focus\\:surface-section:focus {
  background-color: var(--surface-section) !important;
}
:host ::ng-deep .hover\\:surface-section:hover, :host ::ng-deep .active\\:surface-section:active {
  background-color: var(--surface-section) !important;
}
:host ::ng-deep .focus\\:surface-card:focus {
  background-color: var(--surface-card) !important;
}
:host ::ng-deep .hover\\:surface-card:hover, :host ::ng-deep .active\\:surface-card:active {
  background-color: var(--surface-card) !important;
}
:host ::ng-deep .focus\\:surface-overlay:focus {
  background-color: var(--surface-overlay) !important;
}
:host ::ng-deep .hover\\:surface-overlay:hover, :host ::ng-deep .active\\:surface-overlay:active {
  background-color: var(--surface-overlay) !important;
}
:host ::ng-deep .focus\\:surface-hover:focus {
  background-color: var(--surface-hover) !important;
}
:host ::ng-deep .hover\\:surface-hover:hover, :host ::ng-deep .active\\:surface-hover:active {
  background-color: var(--surface-hover) !important;
}
:host ::ng-deep .focus\\:surface-border:focus {
  border-color: var(--surface-border) !important;
}
:host ::ng-deep .hover\\:surface-border:hover, :host ::ng-deep .active\\:surface-border:active {
  border-color: var(--surface-border) !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:text-primary {
    color: var(--primary-color) !important;
  }
  :host ::ng-deep .sm\\:bg-primary {
    color: var(--primary-color-text) !important;
    background-color: var(--primary-color) !important;
  }
  :host ::ng-deep .sm\\:bg-primary-reverse {
    color: var(--primary-color) !important;
    background-color: var(--primary-color-text) !important;
  }
  :host ::ng-deep .sm\\:bg-white {
    background-color: #fff !important;
  }
  :host ::ng-deep .sm\\:border-primary {
    border-color: var(--primary-color) !important;
  }
  :host ::ng-deep .sm\\:text-white {
    color: #fff !important;
  }
  :host ::ng-deep .sm\\:border-white {
    border-color: #fff !important;
  }
  :host ::ng-deep .sm\\:text-color {
    color: var(--text-color) !important;
  }
  :host ::ng-deep .sm\\:text-color-secondary {
    color: var(--text-color-secondary) !important;
  }
  :host ::ng-deep .sm\\:surface-ground {
    background-color: var(--surface-ground) !important;
  }
  :host ::ng-deep .sm\\:surface-section {
    background-color: var(--surface-section) !important;
  }
  :host ::ng-deep .sm\\:surface-card {
    background-color: var(--surface-card) !important;
  }
  :host ::ng-deep .sm\\:surface-overlay {
    background-color: var(--surface-overlay) !important;
  }
  :host ::ng-deep .sm\\:surface-hover {
    background-color: var(--surface-hover) !important;
  }
  :host ::ng-deep .sm\\:surface-border {
    border-color: var(--surface-border) !important;
  }
  :host ::ng-deep .sm\\:focus\\:text-primary:focus {
    color: var(--primary-color) !important;
  }
  :host ::ng-deep .sm\\:hover\\:text-primary:hover, :host ::ng-deep .sm\\:active\\:text-primary:active {
    color: var(--primary-color) !important;
  }
  :host ::ng-deep .sm\\:focus\\:bg-primary:focus {
    color: var(--primary-color-text) !important;
    background-color: var(--primary-color) !important;
  }
  :host ::ng-deep .sm\\:hover\\:bg-primary:hover, :host ::ng-deep .sm\\:active\\:bg-primary:active {
    color: var(--primary-color-text) !important;
    background-color: var(--primary-color) !important;
  }
  :host ::ng-deep .sm\\:focus\\:bg-primary-reverse:focus {
    color: var(--primary-color) !important;
    background-color: var(--primary-color-text) !important;
  }
  :host ::ng-deep .sm\\:hover\\:bg-primary-reverse:hover, :host ::ng-deep .sm\\:active\\:bg-primary-reverse:active {
    color: var(--primary-color) !important;
    background-color: var(--primary-color-text) !important;
  }
  :host ::ng-deep .sm\\:focus\\:bg-white:focus {
    background-color: #fff !important;
  }
  :host ::ng-deep .sm\\:hover\\:bg-white:hover, :host ::ng-deep .sm\\:active\\:bg-white:active {
    background-color: #fff !important;
  }
  :host ::ng-deep .sm\\:focus\\:border-primary:focus {
    border-color: var(--primary-color) !important;
  }
  :host ::ng-deep .sm\\:hover\\:border-primary:hover, :host ::ng-deep .sm\\:active\\:border-primary:active {
    border-color: var(--primary-color) !important;
  }
  :host ::ng-deep .sm\\:focus\\:text-white:focus {
    color: #fff !important;
  }
  :host ::ng-deep .sm\\:hover\\:text-white:hover, :host ::ng-deep .sm\\:active\\:text-white:active {
    color: #fff !important;
  }
  :host ::ng-deep .sm\\:focus\\:border-white:focus {
    border-color: #fff !important;
  }
  :host ::ng-deep .sm\\:hover\\:border-white:hover, :host ::ng-deep .sm\\:active\\:border-white:active {
    border-color: #fff !important;
  }
  :host ::ng-deep .sm\\:focus\\:text-color:focus {
    color: var(--text-color) !important;
  }
  :host ::ng-deep .sm\\:hover\\:text-color:hover, :host ::ng-deep .sm\\:active\\:text-color:active {
    color: var(--text-color) !important;
  }
  :host ::ng-deep .sm\\:focus\\:text-color-secondary:focus {
    color: var(--text-color-secondary) !important;
  }
  :host ::ng-deep .sm\\:hover\\:text-color-secondary:hover, :host ::ng-deep .sm\\:active\\:text-color-secondary:active {
    color: var(--text-color-secondary) !important;
  }
  :host ::ng-deep .sm\\:focus\\:surface-ground:focus {
    background-color: var(--surface-ground) !important;
  }
  :host ::ng-deep .sm\\:hover\\:surface-ground:hover, :host ::ng-deep .sm\\:active\\:surface-ground:active {
    background-color: var(--surface-ground) !important;
  }
  :host ::ng-deep .sm\\:focus\\:surface-section:focus {
    background-color: var(--surface-section) !important;
  }
  :host ::ng-deep .sm\\:hover\\:surface-section:hover, :host ::ng-deep .sm\\:active\\:surface-section:active {
    background-color: var(--surface-section) !important;
  }
  :host ::ng-deep .sm\\:focus\\:surface-card:focus {
    background-color: var(--surface-card) !important;
  }
  :host ::ng-deep .sm\\:hover\\:surface-card:hover, :host ::ng-deep .sm\\:active\\:surface-card:active {
    background-color: var(--surface-card) !important;
  }
  :host ::ng-deep .sm\\:focus\\:surface-overlay:focus {
    background-color: var(--surface-overlay) !important;
  }
  :host ::ng-deep .sm\\:hover\\:surface-overlay:hover, :host ::ng-deep .sm\\:active\\:surface-overlay:active {
    background-color: var(--surface-overlay) !important;
  }
  :host ::ng-deep .sm\\:focus\\:surface-hover:focus {
    background-color: var(--surface-hover) !important;
  }
  :host ::ng-deep .sm\\:hover\\:surface-hover:hover, :host ::ng-deep .sm\\:active\\:surface-hover:active {
    background-color: var(--surface-hover) !important;
  }
  :host ::ng-deep .sm\\:focus\\:surface-border:focus {
    border-color: var(--surface-border) !important;
  }
  :host ::ng-deep .sm\\:hover\\:surface-border:hover, :host ::ng-deep .sm\\:active\\:surface-border:active {
    border-color: var(--surface-border) !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:text-primary {
    color: var(--primary-color) !important;
  }
  :host ::ng-deep .md\\:bg-primary {
    color: var(--primary-color-text) !important;
    background-color: var(--primary-color) !important;
  }
  :host ::ng-deep .md\\:bg-primary-reverse {
    color: var(--primary-color) !important;
    background-color: var(--primary-color-text) !important;
  }
  :host ::ng-deep .md\\:bg-white {
    background-color: #fff !important;
  }
  :host ::ng-deep .md\\:border-primary {
    border-color: var(--primary-color) !important;
  }
  :host ::ng-deep .md\\:text-white {
    color: #fff !important;
  }
  :host ::ng-deep .md\\:border-white {
    border-color: #fff !important;
  }
  :host ::ng-deep .md\\:text-color {
    color: var(--text-color) !important;
  }
  :host ::ng-deep .md\\:text-color-secondary {
    color: var(--text-color-secondary) !important;
  }
  :host ::ng-deep .md\\:surface-ground {
    background-color: var(--surface-ground) !important;
  }
  :host ::ng-deep .md\\:surface-section {
    background-color: var(--surface-section) !important;
  }
  :host ::ng-deep .md\\:surface-card {
    background-color: var(--surface-card) !important;
  }
  :host ::ng-deep .md\\:surface-overlay {
    background-color: var(--surface-overlay) !important;
  }
  :host ::ng-deep .md\\:surface-hover {
    background-color: var(--surface-hover) !important;
  }
  :host ::ng-deep .md\\:surface-border {
    border-color: var(--surface-border) !important;
  }
  :host ::ng-deep .md\\:focus\\:text-primary:focus {
    color: var(--primary-color) !important;
  }
  :host ::ng-deep .md\\:hover\\:text-primary:hover, :host ::ng-deep .md\\:active\\:text-primary:active {
    color: var(--primary-color) !important;
  }
  :host ::ng-deep .md\\:focus\\:bg-primary:focus {
    color: var(--primary-color-text) !important;
    background-color: var(--primary-color) !important;
  }
  :host ::ng-deep .md\\:hover\\:bg-primary:hover, :host ::ng-deep .md\\:active\\:bg-primary:active {
    color: var(--primary-color-text) !important;
    background-color: var(--primary-color) !important;
  }
  :host ::ng-deep .md\\:focus\\:bg-primary-reverse:focus {
    color: var(--primary-color) !important;
    background-color: var(--primary-color-text) !important;
  }
  :host ::ng-deep .md\\:hover\\:bg-primary-reverse:hover, :host ::ng-deep .md\\:active\\:bg-primary-reverse:active {
    color: var(--primary-color) !important;
    background-color: var(--primary-color-text) !important;
  }
  :host ::ng-deep .md\\:focus\\:bg-white:focus {
    background-color: #fff !important;
  }
  :host ::ng-deep .md\\:hover\\:bg-white:hover, :host ::ng-deep .md\\:active\\:bg-white:active {
    background-color: #fff !important;
  }
  :host ::ng-deep .md\\:focus\\:border-primary:focus {
    border-color: var(--primary-color) !important;
  }
  :host ::ng-deep .md\\:hover\\:border-primary:hover, :host ::ng-deep .md\\:active\\:border-primary:active {
    border-color: var(--primary-color) !important;
  }
  :host ::ng-deep .md\\:focus\\:text-white:focus {
    color: #fff !important;
  }
  :host ::ng-deep .md\\:hover\\:text-white:hover, :host ::ng-deep .md\\:active\\:text-white:active {
    color: #fff !important;
  }
  :host ::ng-deep .md\\:focus\\:border-white:focus {
    border-color: #fff !important;
  }
  :host ::ng-deep .md\\:hover\\:border-white:hover, :host ::ng-deep .md\\:active\\:border-white:active {
    border-color: #fff !important;
  }
  :host ::ng-deep .md\\:focus\\:text-color:focus {
    color: var(--text-color) !important;
  }
  :host ::ng-deep .md\\:hover\\:text-color:hover, :host ::ng-deep .md\\:active\\:text-color:active {
    color: var(--text-color) !important;
  }
  :host ::ng-deep .md\\:focus\\:text-color-secondary:focus {
    color: var(--text-color-secondary) !important;
  }
  :host ::ng-deep .md\\:hover\\:text-color-secondary:hover, :host ::ng-deep .md\\:active\\:text-color-secondary:active {
    color: var(--text-color-secondary) !important;
  }
  :host ::ng-deep .md\\:focus\\:surface-ground:focus {
    background-color: var(--surface-ground) !important;
  }
  :host ::ng-deep .md\\:hover\\:surface-ground:hover, :host ::ng-deep .md\\:active\\:surface-ground:active {
    background-color: var(--surface-ground) !important;
  }
  :host ::ng-deep .md\\:focus\\:surface-section:focus {
    background-color: var(--surface-section) !important;
  }
  :host ::ng-deep .md\\:hover\\:surface-section:hover, :host ::ng-deep .md\\:active\\:surface-section:active {
    background-color: var(--surface-section) !important;
  }
  :host ::ng-deep .md\\:focus\\:surface-card:focus {
    background-color: var(--surface-card) !important;
  }
  :host ::ng-deep .md\\:hover\\:surface-card:hover, :host ::ng-deep .md\\:active\\:surface-card:active {
    background-color: var(--surface-card) !important;
  }
  :host ::ng-deep .md\\:focus\\:surface-overlay:focus {
    background-color: var(--surface-overlay) !important;
  }
  :host ::ng-deep .md\\:hover\\:surface-overlay:hover, :host ::ng-deep .md\\:active\\:surface-overlay:active {
    background-color: var(--surface-overlay) !important;
  }
  :host ::ng-deep .md\\:focus\\:surface-hover:focus {
    background-color: var(--surface-hover) !important;
  }
  :host ::ng-deep .md\\:hover\\:surface-hover:hover, :host ::ng-deep .md\\:active\\:surface-hover:active {
    background-color: var(--surface-hover) !important;
  }
  :host ::ng-deep .md\\:focus\\:surface-border:focus {
    border-color: var(--surface-border) !important;
  }
  :host ::ng-deep .md\\:hover\\:surface-border:hover, :host ::ng-deep .md\\:active\\:surface-border:active {
    border-color: var(--surface-border) !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:text-primary {
    color: var(--primary-color) !important;
  }
  :host ::ng-deep .lg\\:bg-primary {
    color: var(--primary-color-text) !important;
    background-color: var(--primary-color) !important;
  }
  :host ::ng-deep .lg\\:bg-primary-reverse {
    color: var(--primary-color) !important;
    background-color: var(--primary-color-text) !important;
  }
  :host ::ng-deep .lg\\:bg-white {
    background-color: #fff !important;
  }
  :host ::ng-deep .lg\\:border-primary {
    border-color: var(--primary-color) !important;
  }
  :host ::ng-deep .lg\\:text-white {
    color: #fff !important;
  }
  :host ::ng-deep .lg\\:border-white {
    border-color: #fff !important;
  }
  :host ::ng-deep .lg\\:text-color {
    color: var(--text-color) !important;
  }
  :host ::ng-deep .lg\\:text-color-secondary {
    color: var(--text-color-secondary) !important;
  }
  :host ::ng-deep .lg\\:surface-ground {
    background-color: var(--surface-ground) !important;
  }
  :host ::ng-deep .lg\\:surface-section {
    background-color: var(--surface-section) !important;
  }
  :host ::ng-deep .lg\\:surface-card {
    background-color: var(--surface-card) !important;
  }
  :host ::ng-deep .lg\\:surface-overlay {
    background-color: var(--surface-overlay) !important;
  }
  :host ::ng-deep .lg\\:surface-hover {
    background-color: var(--surface-hover) !important;
  }
  :host ::ng-deep .lg\\:surface-border {
    border-color: var(--surface-border) !important;
  }
  :host ::ng-deep .lg\\:focus\\:text-primary:focus {
    color: var(--primary-color) !important;
  }
  :host ::ng-deep .lg\\:hover\\:text-primary:hover, :host ::ng-deep .lg\\:active\\:text-primary:active {
    color: var(--primary-color) !important;
  }
  :host ::ng-deep .lg\\:focus\\:bg-primary:focus {
    color: var(--primary-color-text) !important;
    background-color: var(--primary-color) !important;
  }
  :host ::ng-deep .lg\\:hover\\:bg-primary:hover, :host ::ng-deep .lg\\:active\\:bg-primary:active {
    color: var(--primary-color-text) !important;
    background-color: var(--primary-color) !important;
  }
  :host ::ng-deep .lg\\:focus\\:bg-primary-reverse:focus {
    color: var(--primary-color) !important;
    background-color: var(--primary-color-text) !important;
  }
  :host ::ng-deep .lg\\:hover\\:bg-primary-reverse:hover, :host ::ng-deep .lg\\:active\\:bg-primary-reverse:active {
    color: var(--primary-color) !important;
    background-color: var(--primary-color-text) !important;
  }
  :host ::ng-deep .lg\\:focus\\:bg-white:focus {
    background-color: #fff !important;
  }
  :host ::ng-deep .lg\\:hover\\:bg-white:hover, :host ::ng-deep .lg\\:active\\:bg-white:active {
    background-color: #fff !important;
  }
  :host ::ng-deep .lg\\:focus\\:border-primary:focus {
    border-color: var(--primary-color) !important;
  }
  :host ::ng-deep .lg\\:hover\\:border-primary:hover, :host ::ng-deep .lg\\:active\\:border-primary:active {
    border-color: var(--primary-color) !important;
  }
  :host ::ng-deep .lg\\:focus\\:text-white:focus {
    color: #fff !important;
  }
  :host ::ng-deep .lg\\:hover\\:text-white:hover, :host ::ng-deep .lg\\:active\\:text-white:active {
    color: #fff !important;
  }
  :host ::ng-deep .lg\\:focus\\:border-white:focus {
    border-color: #fff !important;
  }
  :host ::ng-deep .lg\\:hover\\:border-white:hover, :host ::ng-deep .lg\\:active\\:border-white:active {
    border-color: #fff !important;
  }
  :host ::ng-deep .lg\\:focus\\:text-color:focus {
    color: var(--text-color) !important;
  }
  :host ::ng-deep .lg\\:hover\\:text-color:hover, :host ::ng-deep .lg\\:active\\:text-color:active {
    color: var(--text-color) !important;
  }
  :host ::ng-deep .lg\\:focus\\:text-color-secondary:focus {
    color: var(--text-color-secondary) !important;
  }
  :host ::ng-deep .lg\\:hover\\:text-color-secondary:hover, :host ::ng-deep .lg\\:active\\:text-color-secondary:active {
    color: var(--text-color-secondary) !important;
  }
  :host ::ng-deep .lg\\:focus\\:surface-ground:focus {
    background-color: var(--surface-ground) !important;
  }
  :host ::ng-deep .lg\\:hover\\:surface-ground:hover, :host ::ng-deep .lg\\:active\\:surface-ground:active {
    background-color: var(--surface-ground) !important;
  }
  :host ::ng-deep .lg\\:focus\\:surface-section:focus {
    background-color: var(--surface-section) !important;
  }
  :host ::ng-deep .lg\\:hover\\:surface-section:hover, :host ::ng-deep .lg\\:active\\:surface-section:active {
    background-color: var(--surface-section) !important;
  }
  :host ::ng-deep .lg\\:focus\\:surface-card:focus {
    background-color: var(--surface-card) !important;
  }
  :host ::ng-deep .lg\\:hover\\:surface-card:hover, :host ::ng-deep .lg\\:active\\:surface-card:active {
    background-color: var(--surface-card) !important;
  }
  :host ::ng-deep .lg\\:focus\\:surface-overlay:focus {
    background-color: var(--surface-overlay) !important;
  }
  :host ::ng-deep .lg\\:hover\\:surface-overlay:hover, :host ::ng-deep .lg\\:active\\:surface-overlay:active {
    background-color: var(--surface-overlay) !important;
  }
  :host ::ng-deep .lg\\:focus\\:surface-hover:focus {
    background-color: var(--surface-hover) !important;
  }
  :host ::ng-deep .lg\\:hover\\:surface-hover:hover, :host ::ng-deep .lg\\:active\\:surface-hover:active {
    background-color: var(--surface-hover) !important;
  }
  :host ::ng-deep .lg\\:focus\\:surface-border:focus {
    border-color: var(--surface-border) !important;
  }
  :host ::ng-deep .lg\\:hover\\:surface-border:hover, :host ::ng-deep .lg\\:active\\:surface-border:active {
    border-color: var(--surface-border) !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:text-primary {
    color: var(--primary-color) !important;
  }
  :host ::ng-deep .xl\\:bg-primary {
    color: var(--primary-color-text) !important;
    background-color: var(--primary-color) !important;
  }
  :host ::ng-deep .xl\\:bg-primary-reverse {
    color: var(--primary-color) !important;
    background-color: var(--primary-color-text) !important;
  }
  :host ::ng-deep .xl\\:bg-white {
    background-color: #fff !important;
  }
  :host ::ng-deep .xl\\:border-primary {
    border-color: var(--primary-color) !important;
  }
  :host ::ng-deep .xl\\:text-white {
    color: #fff !important;
  }
  :host ::ng-deep .xl\\:border-white {
    border-color: #fff !important;
  }
  :host ::ng-deep .xl\\:text-color {
    color: var(--text-color) !important;
  }
  :host ::ng-deep .xl\\:text-color-secondary {
    color: var(--text-color-secondary) !important;
  }
  :host ::ng-deep .xl\\:surface-ground {
    background-color: var(--surface-ground) !important;
  }
  :host ::ng-deep .xl\\:surface-section {
    background-color: var(--surface-section) !important;
  }
  :host ::ng-deep .xl\\:surface-card {
    background-color: var(--surface-card) !important;
  }
  :host ::ng-deep .xl\\:surface-overlay {
    background-color: var(--surface-overlay) !important;
  }
  :host ::ng-deep .xl\\:surface-hover {
    background-color: var(--surface-hover) !important;
  }
  :host ::ng-deep .xl\\:surface-border {
    border-color: var(--surface-border) !important;
  }
  :host ::ng-deep .xl\\:focus\\:text-primary:focus {
    color: var(--primary-color) !important;
  }
  :host ::ng-deep .xl\\:hover\\:text-primary:hover, :host ::ng-deep .xl\\:active\\:text-primary:active {
    color: var(--primary-color) !important;
  }
  :host ::ng-deep .xl\\:focus\\:bg-primary:focus {
    color: var(--primary-color-text) !important;
    background-color: var(--primary-color) !important;
  }
  :host ::ng-deep .xl\\:hover\\:bg-primary:hover, :host ::ng-deep .xl\\:active\\:bg-primary:active {
    color: var(--primary-color-text) !important;
    background-color: var(--primary-color) !important;
  }
  :host ::ng-deep .xl\\:focus\\:bg-primary-reverse:focus {
    color: var(--primary-color) !important;
    background-color: var(--primary-color-text) !important;
  }
  :host ::ng-deep .xl\\:hover\\:bg-primary-reverse:hover, :host ::ng-deep .xl\\:active\\:bg-primary-reverse:active {
    color: var(--primary-color) !important;
    background-color: var(--primary-color-text) !important;
  }
  :host ::ng-deep .xl\\:focus\\:bg-white:focus {
    background-color: #fff !important;
  }
  :host ::ng-deep .xl\\:hover\\:bg-white:hover, :host ::ng-deep .xl\\:active\\:bg-white:active {
    background-color: #fff !important;
  }
  :host ::ng-deep .xl\\:focus\\:border-primary:focus {
    border-color: var(--primary-color) !important;
  }
  :host ::ng-deep .xl\\:hover\\:border-primary:hover, :host ::ng-deep .xl\\:active\\:border-primary:active {
    border-color: var(--primary-color) !important;
  }
  :host ::ng-deep .xl\\:focus\\:text-white:focus {
    color: #fff !important;
  }
  :host ::ng-deep .xl\\:hover\\:text-white:hover, :host ::ng-deep .xl\\:active\\:text-white:active {
    color: #fff !important;
  }
  :host ::ng-deep .xl\\:focus\\:border-white:focus {
    border-color: #fff !important;
  }
  :host ::ng-deep .xl\\:hover\\:border-white:hover, :host ::ng-deep .xl\\:active\\:border-white:active {
    border-color: #fff !important;
  }
  :host ::ng-deep .xl\\:focus\\:text-color:focus {
    color: var(--text-color) !important;
  }
  :host ::ng-deep .xl\\:hover\\:text-color:hover, :host ::ng-deep .xl\\:active\\:text-color:active {
    color: var(--text-color) !important;
  }
  :host ::ng-deep .xl\\:focus\\:text-color-secondary:focus {
    color: var(--text-color-secondary) !important;
  }
  :host ::ng-deep .xl\\:hover\\:text-color-secondary:hover, :host ::ng-deep .xl\\:active\\:text-color-secondary:active {
    color: var(--text-color-secondary) !important;
  }
  :host ::ng-deep .xl\\:focus\\:surface-ground:focus {
    background-color: var(--surface-ground) !important;
  }
  :host ::ng-deep .xl\\:hover\\:surface-ground:hover, :host ::ng-deep .xl\\:active\\:surface-ground:active {
    background-color: var(--surface-ground) !important;
  }
  :host ::ng-deep .xl\\:focus\\:surface-section:focus {
    background-color: var(--surface-section) !important;
  }
  :host ::ng-deep .xl\\:hover\\:surface-section:hover, :host ::ng-deep .xl\\:active\\:surface-section:active {
    background-color: var(--surface-section) !important;
  }
  :host ::ng-deep .xl\\:focus\\:surface-card:focus {
    background-color: var(--surface-card) !important;
  }
  :host ::ng-deep .xl\\:hover\\:surface-card:hover, :host ::ng-deep .xl\\:active\\:surface-card:active {
    background-color: var(--surface-card) !important;
  }
  :host ::ng-deep .xl\\:focus\\:surface-overlay:focus {
    background-color: var(--surface-overlay) !important;
  }
  :host ::ng-deep .xl\\:hover\\:surface-overlay:hover, :host ::ng-deep .xl\\:active\\:surface-overlay:active {
    background-color: var(--surface-overlay) !important;
  }
  :host ::ng-deep .xl\\:focus\\:surface-hover:focus {
    background-color: var(--surface-hover) !important;
  }
  :host ::ng-deep .xl\\:hover\\:surface-hover:hover, :host ::ng-deep .xl\\:active\\:surface-hover:active {
    background-color: var(--surface-hover) !important;
  }
  :host ::ng-deep .xl\\:focus\\:surface-border:focus {
    border-color: var(--surface-border) !important;
  }
  :host ::ng-deep .xl\\:hover\\:surface-border:hover, :host ::ng-deep .xl\\:active\\:surface-border:active {
    border-color: var(--surface-border) !important;
  }
}
:host ::ng-deep .field {
  margin-bottom: 1rem;
}
:host ::ng-deep .field > label {
  display: inline-block;
  margin-bottom: 0.5rem;
}
:host ::ng-deep .field.grid > label {
  display: flex;
  align-items: center;
}
:host ::ng-deep .field > small {
  margin-top: 0.25rem;
}
:host ::ng-deep .field.grid, :host ::ng-deep .formgrid.grid {
  margin-top: 0;
}
:host ::ng-deep .field.grid .col-fixed, :host ::ng-deep .formgrid.grid .col-fixed, :host ::ng-deep .field.grid .col, :host ::ng-deep .formgrid.grid .col, :host ::ng-deep .field.grid .col-1, :host ::ng-deep .formgrid.grid .col-1, :host ::ng-deep .field.grid .col-2, :host ::ng-deep .formgrid.grid .col-2, :host ::ng-deep .field.grid .col-3, :host ::ng-deep .formgrid.grid .col-3, :host ::ng-deep .field.grid .col-4, :host ::ng-deep .formgrid.grid .col-4, :host ::ng-deep .field.grid .col-5, :host ::ng-deep .formgrid.grid .col-5, :host ::ng-deep .field.grid .col-6, :host ::ng-deep .formgrid.grid .col-6, :host ::ng-deep .field.grid .col-7, :host ::ng-deep .formgrid.grid .col-7, :host ::ng-deep .field.grid .col-8, :host ::ng-deep .formgrid.grid .col-8, :host ::ng-deep .field.grid .col-9, :host ::ng-deep .formgrid.grid .col-9, :host ::ng-deep .field.grid .col-10, :host ::ng-deep .formgrid.grid .col-10, :host ::ng-deep .field.grid .col-11, :host ::ng-deep .formgrid.grid .col-11, :host ::ng-deep .field.grid .col-12, :host ::ng-deep .formgrid.grid .col-12 {
  padding-top: 0;
  padding-bottom: 0;
}
:host ::ng-deep .formgroup-inline {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}
:host ::ng-deep .formgroup-inline .field, :host ::ng-deep .formgroup-inline .field-checkbox, :host ::ng-deep .formgroup-inline .field-radiobutton {
  margin-right: 1rem;
}
:host ::ng-deep .formgroup-inline .field > label, :host ::ng-deep .formgroup-inline .field-checkbox > label, :host ::ng-deep .formgroup-inline .field-radiobutton > label {
  margin-right: 0.5rem;
  margin-bottom: 0;
}
:host ::ng-deep .field-checkbox, :host ::ng-deep .field-radiobutton {
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
}
:host ::ng-deep .field-checkbox > label, :host ::ng-deep .field-radiobutton > label {
  margin-left: 0.5rem;
  line-height: 1;
}
:host ::ng-deep .hidden {
  display: none !important;
}
:host ::ng-deep .block {
  display: block !important;
}
:host ::ng-deep .inline {
  display: inline !important;
}
:host ::ng-deep .inline-block {
  display: inline-block !important;
}
:host ::ng-deep .flex {
  display: flex !important;
}
:host ::ng-deep .inline-flex {
  display: inline-flex !important;
}
:host ::ng-deep .flex-center {
  align-items: center !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:hidden {
    display: none !important;
  }
  :host ::ng-deep .sm\\:block {
    display: block !important;
  }
  :host ::ng-deep .sm\\:inline {
    display: inline !important;
  }
  :host ::ng-deep .sm\\:inline-block {
    display: inline-block !important;
  }
  :host ::ng-deep .sm\\:flex {
    display: flex !important;
  }
  :host ::ng-deep .sm\\:inline-flex {
    display: inline-flex !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:hidden {
    display: none !important;
  }
  :host ::ng-deep .md\\:block {
    display: block !important;
  }
  :host ::ng-deep .md\\:inline {
    display: inline !important;
  }
  :host ::ng-deep .md\\:inline-block {
    display: inline-block !important;
  }
  :host ::ng-deep .md\\:flex {
    display: flex !important;
  }
  :host ::ng-deep .md\\:inline-flex {
    display: inline-flex !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:hidden {
    display: none !important;
  }
  :host ::ng-deep .lg\\:block {
    display: block !important;
  }
  :host ::ng-deep .lg\\:inline {
    display: inline !important;
  }
  :host ::ng-deep .lg\\:inline-block {
    display: inline-block !important;
  }
  :host ::ng-deep .lg\\:flex {
    display: flex !important;
  }
  :host ::ng-deep .lg\\:inline-flex {
    display: inline-flex !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:hidden {
    display: none !important;
  }
  :host ::ng-deep .xl\\:block {
    display: block !important;
  }
  :host ::ng-deep .xl\\:inline {
    display: inline !important;
  }
  :host ::ng-deep .xl\\:inline-block {
    display: inline-block !important;
  }
  :host ::ng-deep .xl\\:flex {
    display: flex !important;
  }
  :host ::ng-deep .xl\\:inline-flex {
    display: inline-flex !important;
  }
}
:host ::ng-deep .text-center {
  text-align: center !important;
}
:host ::ng-deep .text-justify {
  text-align: justify !important;
}
:host ::ng-deep .text-left {
  text-align: left !important;
}
:host ::ng-deep .text-right {
  text-align: right !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:text-center {
    text-align: center !important;
  }
  :host ::ng-deep .sm\\:text-justify {
    text-align: justify !important;
  }
  :host ::ng-deep .sm\\:text-left {
    text-align: left !important;
  }
  :host ::ng-deep .sm\\:text-right {
    text-align: right !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:text-center {
    text-align: center !important;
  }
  :host ::ng-deep .md\\:text-justify {
    text-align: justify !important;
  }
  :host ::ng-deep .md\\:text-left {
    text-align: left !important;
  }
  :host ::ng-deep .md\\:text-right {
    text-align: right !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:text-center {
    text-align: center !important;
  }
  :host ::ng-deep .lg\\:text-justify {
    text-align: justify !important;
  }
  :host ::ng-deep .lg\\:text-left {
    text-align: left !important;
  }
  :host ::ng-deep .lg\\:text-right {
    text-align: right !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:text-center {
    text-align: center !important;
  }
  :host ::ng-deep .xl\\:text-justify {
    text-align: justify !important;
  }
  :host ::ng-deep .xl\\:text-left {
    text-align: left !important;
  }
  :host ::ng-deep .xl\\:text-right {
    text-align: right !important;
  }
}
:host ::ng-deep .underline {
  text-decoration: underline !important;
}
:host ::ng-deep .line-through {
  text-decoration: line-through !important;
}
:host ::ng-deep .no-underline {
  text-decoration: none !important;
}
:host ::ng-deep .focus\\:underline:focus {
  text-decoration: underline !important;
}
:host ::ng-deep .hover\\:underline:hover, :host ::ng-deep .active\\:underline:active {
  text-decoration: underline !important;
}
:host ::ng-deep .focus\\:line-through:focus {
  text-decoration: line-through !important;
}
:host ::ng-deep .hover\\:line-through:hover, :host ::ng-deep .active\\:line-through:active {
  text-decoration: line-through !important;
}
:host ::ng-deep .focus\\:no-underline:focus {
  text-decoration: none !important;
}
:host ::ng-deep .hover\\:no-underline:hover, :host ::ng-deep .active\\:no-underline:active {
  text-decoration: none !important;
}
:host ::ng-deep .lowercase {
  text-transform: lowercase !important;
}
:host ::ng-deep .uppercase {
  text-transform: uppercase !important;
}
:host ::ng-deep .capitalize {
  text-transform: capitalize !important;
}
:host ::ng-deep .text-overflow-clip {
  text-overflow: clip !important;
}
:host ::ng-deep .text-overflow-ellipsis {
  text-overflow: ellipsis !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:text-overflow-clip {
    text-overflow: clip !important;
  }
  :host ::ng-deep .sm\\:text-overflow-ellipsis {
    text-overflow: ellipsis !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:text-overflow-clip {
    text-overflow: clip !important;
  }
  :host ::ng-deep .md\\:text-overflow-ellipsis {
    text-overflow: ellipsis !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:text-overflow-clip {
    text-overflow: clip !important;
  }
  :host ::ng-deep .lg\\:text-overflow-ellipsis {
    text-overflow: ellipsis !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:text-overflow-clip {
    text-overflow: clip !important;
  }
  :host ::ng-deep .xl\\:text-overflow-ellipsis {
    text-overflow: ellipsis !important;
  }
}
:host ::ng-deep .font-light {
  font-weight: 300 !important;
}
:host ::ng-deep .font-normal {
  font-weight: 400 !important;
}
:host ::ng-deep .font-medium {
  font-weight: 500 !important;
}
:host ::ng-deep .font-semibold {
  font-weight: 600 !important;
}
:host ::ng-deep .font-bold {
  font-weight: 700 !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:font-light {
    font-weight: 300 !important;
  }
  :host ::ng-deep .sm\\:font-normal {
    font-weight: 400 !important;
  }
  :host ::ng-deep .sm\\:font-medium {
    font-weight: 500 !important;
  }
  :host ::ng-deep .sm\\:font-semibold {
    font-weight: 600 !important;
  }
  :host ::ng-deep .sm\\:font-bold {
    font-weight: 700 !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:font-light {
    font-weight: 300 !important;
  }
  :host ::ng-deep .md\\:font-normal {
    font-weight: 400 !important;
  }
  :host ::ng-deep .md\\:font-medium {
    font-weight: 500 !important;
  }
  :host ::ng-deep .md\\:font-semibold {
    font-weight: 600 !important;
  }
  :host ::ng-deep .md\\:font-bold {
    font-weight: 700 !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:font-light {
    font-weight: 300 !important;
  }
  :host ::ng-deep .lg\\:font-normal {
    font-weight: 400 !important;
  }
  :host ::ng-deep .lg\\:font-medium {
    font-weight: 500 !important;
  }
  :host ::ng-deep .lg\\:font-semibold {
    font-weight: 600 !important;
  }
  :host ::ng-deep .lg\\:font-bold {
    font-weight: 700 !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:font-light {
    font-weight: 300 !important;
  }
  :host ::ng-deep .xl\\:font-normal {
    font-weight: 400 !important;
  }
  :host ::ng-deep .xl\\:font-medium {
    font-weight: 500 !important;
  }
  :host ::ng-deep .xl\\:font-semibold {
    font-weight: 600 !important;
  }
  :host ::ng-deep .xl\\:font-bold {
    font-weight: 700 !important;
  }
}
:host ::ng-deep .font-italic {
  font-style: italic !important;
}
:host ::ng-deep .text-xs {
  font-size: 0.75rem !important;
}
:host ::ng-deep .text-sm {
  font-size: 0.875rem !important;
}
:host ::ng-deep .text-base {
  font-size: 1rem !important;
}
:host ::ng-deep .text-lg {
  font-size: 1.125rem !important;
}
:host ::ng-deep .text-xl {
  font-size: 1.25rem !important;
}
:host ::ng-deep .text-2xl {
  font-size: 1.5rem !important;
}
:host ::ng-deep .text-3xl {
  font-size: 1.75rem !important;
}
:host ::ng-deep .text-4xl {
  font-size: 2rem !important;
}
:host ::ng-deep .text-5xl {
  font-size: 2.5rem !important;
}
:host ::ng-deep .text-6xl {
  font-size: 3rem !important;
}
:host ::ng-deep .text-7xl {
  font-size: 4rem !important;
}
:host ::ng-deep .text-8xl {
  font-size: 6rem !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:text-xs {
    font-size: 0.75rem !important;
  }
  :host ::ng-deep .sm\\:text-sm {
    font-size: 0.875rem !important;
  }
  :host ::ng-deep .sm\\:text-base {
    font-size: 1rem !important;
  }
  :host ::ng-deep .sm\\:text-lg {
    font-size: 1.125rem !important;
  }
  :host ::ng-deep .sm\\:text-xl {
    font-size: 1.25rem !important;
  }
  :host ::ng-deep .sm\\:text-2xl {
    font-size: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:text-3xl {
    font-size: 1.75rem !important;
  }
  :host ::ng-deep .sm\\:text-4xl {
    font-size: 2rem !important;
  }
  :host ::ng-deep .sm\\:text-5xl {
    font-size: 2.5rem !important;
  }
  :host ::ng-deep .sm\\:text-6xl {
    font-size: 3rem !important;
  }
  :host ::ng-deep .sm\\:text-7xl {
    font-size: 4rem !important;
  }
  :host ::ng-deep .sm\\:text-8xl {
    font-size: 6rem !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:text-xs {
    font-size: 0.75rem !important;
  }
  :host ::ng-deep .md\\:text-sm {
    font-size: 0.875rem !important;
  }
  :host ::ng-deep .md\\:text-base {
    font-size: 1rem !important;
  }
  :host ::ng-deep .md\\:text-lg {
    font-size: 1.125rem !important;
  }
  :host ::ng-deep .md\\:text-xl {
    font-size: 1.25rem !important;
  }
  :host ::ng-deep .md\\:text-2xl {
    font-size: 1.5rem !important;
  }
  :host ::ng-deep .md\\:text-3xl {
    font-size: 1.75rem !important;
  }
  :host ::ng-deep .md\\:text-4xl {
    font-size: 2rem !important;
  }
  :host ::ng-deep .md\\:text-5xl {
    font-size: 2.5rem !important;
  }
  :host ::ng-deep .md\\:text-6xl {
    font-size: 3rem !important;
  }
  :host ::ng-deep .md\\:text-7xl {
    font-size: 4rem !important;
  }
  :host ::ng-deep .md\\:text-8xl {
    font-size: 6rem !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:text-xs {
    font-size: 0.75rem !important;
  }
  :host ::ng-deep .lg\\:text-sm {
    font-size: 0.875rem !important;
  }
  :host ::ng-deep .lg\\:text-base {
    font-size: 1rem !important;
  }
  :host ::ng-deep .lg\\:text-lg {
    font-size: 1.125rem !important;
  }
  :host ::ng-deep .lg\\:text-xl {
    font-size: 1.25rem !important;
  }
  :host ::ng-deep .lg\\:text-2xl {
    font-size: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:text-3xl {
    font-size: 1.75rem !important;
  }
  :host ::ng-deep .lg\\:text-4xl {
    font-size: 2rem !important;
  }
  :host ::ng-deep .lg\\:text-5xl {
    font-size: 2.5rem !important;
  }
  :host ::ng-deep .lg\\:text-6xl {
    font-size: 3rem !important;
  }
  :host ::ng-deep .lg\\:text-7xl {
    font-size: 4rem !important;
  }
  :host ::ng-deep .lg\\:text-8xl {
    font-size: 6rem !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:text-xs {
    font-size: 0.75rem !important;
  }
  :host ::ng-deep .xl\\:text-sm {
    font-size: 0.875rem !important;
  }
  :host ::ng-deep .xl\\:text-base {
    font-size: 1rem !important;
  }
  :host ::ng-deep .xl\\:text-lg {
    font-size: 1.125rem !important;
  }
  :host ::ng-deep .xl\\:text-xl {
    font-size: 1.25rem !important;
  }
  :host ::ng-deep .xl\\:text-2xl {
    font-size: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:text-3xl {
    font-size: 1.75rem !important;
  }
  :host ::ng-deep .xl\\:text-4xl {
    font-size: 2rem !important;
  }
  :host ::ng-deep .xl\\:text-5xl {
    font-size: 2.5rem !important;
  }
  :host ::ng-deep .xl\\:text-6xl {
    font-size: 3rem !important;
  }
  :host ::ng-deep .xl\\:text-7xl {
    font-size: 4rem !important;
  }
  :host ::ng-deep .xl\\:text-8xl {
    font-size: 6rem !important;
  }
}
:host ::ng-deep .line-height-1 {
  line-height: 1 !important;
}
:host ::ng-deep .line-height-2 {
  line-height: 1.25 !important;
}
:host ::ng-deep .line-height-3 {
  line-height: 1.5 !important;
}
:host ::ng-deep .line-height-4 {
  line-height: 2 !important;
}
:host ::ng-deep .white-space-normal {
  white-space: normal !important;
}
:host ::ng-deep .white-space-nowrap {
  white-space: nowrap !important;
}
:host ::ng-deep .vertical-align-baseline {
  vertical-align: baseline !important;
}
:host ::ng-deep .vertical-align-top {
  vertical-align: top !important;
}
:host ::ng-deep .vertical-align-middle {
  vertical-align: middle !important;
}
:host ::ng-deep .vertical-align-bottom {
  vertical-align: bottom !important;
}
:host ::ng-deep .vertical-align-text-top {
  vertical-align: text-top !important;
}
:host ::ng-deep .vertical-align-text-bottom {
  vertical-align: text-bottom !important;
}
:host ::ng-deep .vertical-align-sub {
  vertical-align: sub !important;
}
:host ::ng-deep .vertical-align-super {
  vertical-align: super !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:vertical-align-baseline {
    vertical-align: baseline !important;
  }
  :host ::ng-deep .sm\\:vertical-align-top {
    vertical-align: top !important;
  }
  :host ::ng-deep .sm\\:vertical-align-middle {
    vertical-align: middle !important;
  }
  :host ::ng-deep .sm\\:vertical-align-bottom {
    vertical-align: bottom !important;
  }
  :host ::ng-deep .sm\\:vertical-align-text-top {
    vertical-align: text-top !important;
  }
  :host ::ng-deep .sm\\:vertical-align-text-bottom {
    vertical-align: text-bottom !important;
  }
  :host ::ng-deep .sm\\:vertical-align-sub {
    vertical-align: sub !important;
  }
  :host ::ng-deep .sm\\:vertical-align-super {
    vertical-align: super !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:vertical-align-baseline {
    vertical-align: baseline !important;
  }
  :host ::ng-deep .md\\:vertical-align-top {
    vertical-align: top !important;
  }
  :host ::ng-deep .md\\:vertical-align-middle {
    vertical-align: middle !important;
  }
  :host ::ng-deep .md\\:vertical-align-bottom {
    vertical-align: bottom !important;
  }
  :host ::ng-deep .md\\:vertical-align-text-top {
    vertical-align: text-top !important;
  }
  :host ::ng-deep .md\\:vertical-align-text-bottom {
    vertical-align: text-bottom !important;
  }
  :host ::ng-deep .md\\:vertical-align-sub {
    vertical-align: sub !important;
  }
  :host ::ng-deep .md\\:vertical-align-super {
    vertical-align: super !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:vertical-align-baseline {
    vertical-align: baseline !important;
  }
  :host ::ng-deep .lg\\:vertical-align-top {
    vertical-align: top !important;
  }
  :host ::ng-deep .lg\\:vertical-align-middle {
    vertical-align: middle !important;
  }
  :host ::ng-deep .lg\\:vertical-align-bottom {
    vertical-align: bottom !important;
  }
  :host ::ng-deep .lg\\:vertical-align-text-top {
    vertical-align: text-top !important;
  }
  :host ::ng-deep .lg\\:vertical-align-text-bottom {
    vertical-align: text-bottom !important;
  }
  :host ::ng-deep .lg\\:vertical-align-sub {
    vertical-align: sub !important;
  }
  :host ::ng-deep .lg\\:vertical-align-super {
    vertical-align: super !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:vertical-align-baseline {
    vertical-align: baseline !important;
  }
  :host ::ng-deep .xl\\:vertical-align-top {
    vertical-align: top !important;
  }
  :host ::ng-deep .xl\\:vertical-align-middle {
    vertical-align: middle !important;
  }
  :host ::ng-deep .xl\\:vertical-align-bottom {
    vertical-align: bottom !important;
  }
  :host ::ng-deep .xl\\:vertical-align-text-top {
    vertical-align: text-top !important;
  }
  :host ::ng-deep .xl\\:vertical-align-text-bottom {
    vertical-align: text-bottom !important;
  }
  :host ::ng-deep .xl\\:vertical-align-sub {
    vertical-align: sub !important;
  }
  :host ::ng-deep .xl\\:vertical-align-super {
    vertical-align: super !important;
  }
}
:host ::ng-deep .flex-row {
  flex-direction: row !important;
}
:host ::ng-deep .flex-row-reverse {
  flex-direction: row-reverse !important;
}
:host ::ng-deep .flex-column {
  flex-direction: column !important;
}
:host ::ng-deep .flex-column-reverse {
  flex-direction: column-reverse !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:flex-row {
    flex-direction: row !important;
  }
  :host ::ng-deep .sm\\:flex-row-reverse {
    flex-direction: row-reverse !important;
  }
  :host ::ng-deep .sm\\:flex-column {
    flex-direction: column !important;
  }
  :host ::ng-deep .sm\\:flex-column-reverse {
    flex-direction: column-reverse !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:flex-row {
    flex-direction: row !important;
  }
  :host ::ng-deep .md\\:flex-row-reverse {
    flex-direction: row-reverse !important;
  }
  :host ::ng-deep .md\\:flex-column {
    flex-direction: column !important;
  }
  :host ::ng-deep .md\\:flex-column-reverse {
    flex-direction: column-reverse !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:flex-row {
    flex-direction: row !important;
  }
  :host ::ng-deep .lg\\:flex-row-reverse {
    flex-direction: row-reverse !important;
  }
  :host ::ng-deep .lg\\:flex-column {
    flex-direction: column !important;
  }
  :host ::ng-deep .lg\\:flex-column-reverse {
    flex-direction: column-reverse !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:flex-row {
    flex-direction: row !important;
  }
  :host ::ng-deep .xl\\:flex-row-reverse {
    flex-direction: row-reverse !important;
  }
  :host ::ng-deep .xl\\:flex-column {
    flex-direction: column !important;
  }
  :host ::ng-deep .xl\\:flex-column-reverse {
    flex-direction: column-reverse !important;
  }
}
:host ::ng-deep .flex-wrap {
  flex-wrap: wrap !important;
}
:host ::ng-deep .flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}
:host ::ng-deep .flex-nowrap {
  flex-wrap: nowrap !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:flex-wrap {
    flex-wrap: wrap !important;
  }
  :host ::ng-deep .sm\\:flex-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  :host ::ng-deep .sm\\:flex-nowrap {
    flex-wrap: nowrap !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:flex-wrap {
    flex-wrap: wrap !important;
  }
  :host ::ng-deep .md\\:flex-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  :host ::ng-deep .md\\:flex-nowrap {
    flex-wrap: nowrap !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:flex-wrap {
    flex-wrap: wrap !important;
  }
  :host ::ng-deep .lg\\:flex-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  :host ::ng-deep .lg\\:flex-nowrap {
    flex-wrap: nowrap !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:flex-wrap {
    flex-wrap: wrap !important;
  }
  :host ::ng-deep .xl\\:flex-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  :host ::ng-deep .xl\\:flex-nowrap {
    flex-wrap: nowrap !important;
  }
}
:host ::ng-deep .justify-content-start {
  justify-content: flex-start !important;
}
:host ::ng-deep .justify-content-end {
  justify-content: flex-end !important;
}
:host ::ng-deep .justify-content-center {
  justify-content: center !important;
}
:host ::ng-deep .justify-content-between {
  justify-content: space-between !important;
}
:host ::ng-deep .justify-content-around {
  justify-content: space-around !important;
}
:host ::ng-deep .justify-content-evenly {
  justify-content: space-evenly !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:justify-content-start {
    justify-content: flex-start !important;
  }
  :host ::ng-deep .sm\\:justify-content-end {
    justify-content: flex-end !important;
  }
  :host ::ng-deep .sm\\:justify-content-center {
    justify-content: center !important;
  }
  :host ::ng-deep .sm\\:justify-content-between {
    justify-content: space-between !important;
  }
  :host ::ng-deep .sm\\:justify-content-around {
    justify-content: space-around !important;
  }
  :host ::ng-deep .sm\\:justify-content-evenly {
    justify-content: space-evenly !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:justify-content-start {
    justify-content: flex-start !important;
  }
  :host ::ng-deep .md\\:justify-content-end {
    justify-content: flex-end !important;
  }
  :host ::ng-deep .md\\:justify-content-center {
    justify-content: center !important;
  }
  :host ::ng-deep .md\\:justify-content-between {
    justify-content: space-between !important;
  }
  :host ::ng-deep .md\\:justify-content-around {
    justify-content: space-around !important;
  }
  :host ::ng-deep .md\\:justify-content-evenly {
    justify-content: space-evenly !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:justify-content-start {
    justify-content: flex-start !important;
  }
  :host ::ng-deep .lg\\:justify-content-end {
    justify-content: flex-end !important;
  }
  :host ::ng-deep .lg\\:justify-content-center {
    justify-content: center !important;
  }
  :host ::ng-deep .lg\\:justify-content-between {
    justify-content: space-between !important;
  }
  :host ::ng-deep .lg\\:justify-content-around {
    justify-content: space-around !important;
  }
  :host ::ng-deep .lg\\:justify-content-evenly {
    justify-content: space-evenly !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:justify-content-start {
    justify-content: flex-start !important;
  }
  :host ::ng-deep .xl\\:justify-content-end {
    justify-content: flex-end !important;
  }
  :host ::ng-deep .xl\\:justify-content-center {
    justify-content: center !important;
  }
  :host ::ng-deep .xl\\:justify-content-between {
    justify-content: space-between !important;
  }
  :host ::ng-deep .xl\\:justify-content-around {
    justify-content: space-around !important;
  }
  :host ::ng-deep .xl\\:justify-content-evenly {
    justify-content: space-evenly !important;
  }
}
:host ::ng-deep .align-content-start {
  align-content: flex-start !important;
}
:host ::ng-deep .align-content-end {
  align-content: flex-end !important;
}
:host ::ng-deep .align-content-center {
  align-content: center !important;
}
:host ::ng-deep .align-content-between {
  align-content: space-between !important;
}
:host ::ng-deep .align-content-around {
  align-content: space-around !important;
}
:host ::ng-deep .align-content-evenly {
  align-content: space-evenly !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:align-content-start {
    align-content: flex-start !important;
  }
  :host ::ng-deep .sm\\:align-content-end {
    align-content: flex-end !important;
  }
  :host ::ng-deep .sm\\:align-content-center {
    align-content: center !important;
  }
  :host ::ng-deep .sm\\:align-content-between {
    align-content: space-between !important;
  }
  :host ::ng-deep .sm\\:align-content-around {
    align-content: space-around !important;
  }
  :host ::ng-deep .sm\\:align-content-evenly {
    align-content: space-evenly !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:align-content-start {
    align-content: flex-start !important;
  }
  :host ::ng-deep .md\\:align-content-end {
    align-content: flex-end !important;
  }
  :host ::ng-deep .md\\:align-content-center {
    align-content: center !important;
  }
  :host ::ng-deep .md\\:align-content-between {
    align-content: space-between !important;
  }
  :host ::ng-deep .md\\:align-content-around {
    align-content: space-around !important;
  }
  :host ::ng-deep .md\\:align-content-evenly {
    align-content: space-evenly !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:align-content-start {
    align-content: flex-start !important;
  }
  :host ::ng-deep .lg\\:align-content-end {
    align-content: flex-end !important;
  }
  :host ::ng-deep .lg\\:align-content-center {
    align-content: center !important;
  }
  :host ::ng-deep .lg\\:align-content-between {
    align-content: space-between !important;
  }
  :host ::ng-deep .lg\\:align-content-around {
    align-content: space-around !important;
  }
  :host ::ng-deep .lg\\:align-content-evenly {
    align-content: space-evenly !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:align-content-start {
    align-content: flex-start !important;
  }
  :host ::ng-deep .xl\\:align-content-end {
    align-content: flex-end !important;
  }
  :host ::ng-deep .xl\\:align-content-center {
    align-content: center !important;
  }
  :host ::ng-deep .xl\\:align-content-between {
    align-content: space-between !important;
  }
  :host ::ng-deep .xl\\:align-content-around {
    align-content: space-around !important;
  }
  :host ::ng-deep .xl\\:align-content-evenly {
    align-content: space-evenly !important;
  }
}
:host ::ng-deep .align-items-stretch {
  align-items: stretch !important;
}
:host ::ng-deep .align-items-start {
  align-items: flex-start !important;
}
:host ::ng-deep .align-items-center {
  align-items: center !important;
}
:host ::ng-deep .align-items-end {
  align-items: flex-end !important;
}
:host ::ng-deep .align-items-baseline {
  align-items: baseline !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:align-items-stretch {
    align-items: stretch !important;
  }
  :host ::ng-deep .sm\\:align-items-start {
    align-items: flex-start !important;
  }
  :host ::ng-deep .sm\\:align-items-center {
    align-items: center !important;
  }
  :host ::ng-deep .sm\\:align-items-end {
    align-items: flex-end !important;
  }
  :host ::ng-deep .sm\\:align-items-baseline {
    align-items: baseline !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:align-items-stretch {
    align-items: stretch !important;
  }
  :host ::ng-deep .md\\:align-items-start {
    align-items: flex-start !important;
  }
  :host ::ng-deep .md\\:align-items-center {
    align-items: center !important;
  }
  :host ::ng-deep .md\\:align-items-end {
    align-items: flex-end !important;
  }
  :host ::ng-deep .md\\:align-items-baseline {
    align-items: baseline !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:align-items-stretch {
    align-items: stretch !important;
  }
  :host ::ng-deep .lg\\:align-items-start {
    align-items: flex-start !important;
  }
  :host ::ng-deep .lg\\:align-items-center {
    align-items: center !important;
  }
  :host ::ng-deep .lg\\:align-items-end {
    align-items: flex-end !important;
  }
  :host ::ng-deep .lg\\:align-items-baseline {
    align-items: baseline !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:align-items-stretch {
    align-items: stretch !important;
  }
  :host ::ng-deep .xl\\:align-items-start {
    align-items: flex-start !important;
  }
  :host ::ng-deep .xl\\:align-items-center {
    align-items: center !important;
  }
  :host ::ng-deep .xl\\:align-items-end {
    align-items: flex-end !important;
  }
  :host ::ng-deep .xl\\:align-items-baseline {
    align-items: baseline !important;
  }
}
:host ::ng-deep .align-self-auto {
  align-self: auto !important;
}
:host ::ng-deep .align-self-start {
  align-self: flex-start !important;
}
:host ::ng-deep .align-self-end {
  align-self: flex-end !important;
}
:host ::ng-deep .align-self-center {
  align-self: center !important;
}
:host ::ng-deep .align-self-stretch {
  align-self: stretch !important;
}
:host ::ng-deep .align-self-baseline {
  align-self: baseline !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:align-self-auto {
    align-self: auto !important;
  }
  :host ::ng-deep .sm\\:align-self-start {
    align-self: flex-start !important;
  }
  :host ::ng-deep .sm\\:align-self-end {
    align-self: flex-end !important;
  }
  :host ::ng-deep .sm\\:align-self-center {
    align-self: center !important;
  }
  :host ::ng-deep .sm\\:align-self-stretch {
    align-self: stretch !important;
  }
  :host ::ng-deep .sm\\:align-self-baseline {
    align-self: baseline !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:align-self-auto {
    align-self: auto !important;
  }
  :host ::ng-deep .md\\:align-self-start {
    align-self: flex-start !important;
  }
  :host ::ng-deep .md\\:align-self-end {
    align-self: flex-end !important;
  }
  :host ::ng-deep .md\\:align-self-center {
    align-self: center !important;
  }
  :host ::ng-deep .md\\:align-self-stretch {
    align-self: stretch !important;
  }
  :host ::ng-deep .md\\:align-self-baseline {
    align-self: baseline !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:align-self-auto {
    align-self: auto !important;
  }
  :host ::ng-deep .lg\\:align-self-start {
    align-self: flex-start !important;
  }
  :host ::ng-deep .lg\\:align-self-end {
    align-self: flex-end !important;
  }
  :host ::ng-deep .lg\\:align-self-center {
    align-self: center !important;
  }
  :host ::ng-deep .lg\\:align-self-stretch {
    align-self: stretch !important;
  }
  :host ::ng-deep .lg\\:align-self-baseline {
    align-self: baseline !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:align-self-auto {
    align-self: auto !important;
  }
  :host ::ng-deep .xl\\:align-self-start {
    align-self: flex-start !important;
  }
  :host ::ng-deep .xl\\:align-self-end {
    align-self: flex-end !important;
  }
  :host ::ng-deep .xl\\:align-self-center {
    align-self: center !important;
  }
  :host ::ng-deep .xl\\:align-self-stretch {
    align-self: stretch !important;
  }
  :host ::ng-deep .xl\\:align-self-baseline {
    align-self: baseline !important;
  }
}
:host ::ng-deep .flex-order-0 {
  order: 0 !important;
}
:host ::ng-deep .flex-order-1 {
  order: 1 !important;
}
:host ::ng-deep .flex-order-2 {
  order: 2 !important;
}
:host ::ng-deep .flex-order-3 {
  order: 3 !important;
}
:host ::ng-deep .flex-order-4 {
  order: 4 !important;
}
:host ::ng-deep .flex-order-5 {
  order: 5 !important;
}
:host ::ng-deep .flex-order-6 {
  order: 6 !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:flex-order-0 {
    order: 0 !important;
  }
  :host ::ng-deep .sm\\:flex-order-1 {
    order: 1 !important;
  }
  :host ::ng-deep .sm\\:flex-order-2 {
    order: 2 !important;
  }
  :host ::ng-deep .sm\\:flex-order-3 {
    order: 3 !important;
  }
  :host ::ng-deep .sm\\:flex-order-4 {
    order: 4 !important;
  }
  :host ::ng-deep .sm\\:flex-order-5 {
    order: 5 !important;
  }
  :host ::ng-deep .sm\\:flex-order-6 {
    order: 6 !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:flex-order-0 {
    order: 0 !important;
  }
  :host ::ng-deep .md\\:flex-order-1 {
    order: 1 !important;
  }
  :host ::ng-deep .md\\:flex-order-2 {
    order: 2 !important;
  }
  :host ::ng-deep .md\\:flex-order-3 {
    order: 3 !important;
  }
  :host ::ng-deep .md\\:flex-order-4 {
    order: 4 !important;
  }
  :host ::ng-deep .md\\:flex-order-5 {
    order: 5 !important;
  }
  :host ::ng-deep .md\\:flex-order-6 {
    order: 6 !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:flex-order-0 {
    order: 0 !important;
  }
  :host ::ng-deep .lg\\:flex-order-1 {
    order: 1 !important;
  }
  :host ::ng-deep .lg\\:flex-order-2 {
    order: 2 !important;
  }
  :host ::ng-deep .lg\\:flex-order-3 {
    order: 3 !important;
  }
  :host ::ng-deep .lg\\:flex-order-4 {
    order: 4 !important;
  }
  :host ::ng-deep .lg\\:flex-order-5 {
    order: 5 !important;
  }
  :host ::ng-deep .lg\\:flex-order-6 {
    order: 6 !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:flex-order-0 {
    order: 0 !important;
  }
  :host ::ng-deep .xl\\:flex-order-1 {
    order: 1 !important;
  }
  :host ::ng-deep .xl\\:flex-order-2 {
    order: 2 !important;
  }
  :host ::ng-deep .xl\\:flex-order-3 {
    order: 3 !important;
  }
  :host ::ng-deep .xl\\:flex-order-4 {
    order: 4 !important;
  }
  :host ::ng-deep .xl\\:flex-order-5 {
    order: 5 !important;
  }
  :host ::ng-deep .xl\\:flex-order-6 {
    order: 6 !important;
  }
}
:host ::ng-deep .flex-1 {
  flex: 1 1 0% !important;
}
:host ::ng-deep .flex-auto {
  flex: 1 1 auto !important;
}
:host ::ng-deep .flex-initial {
  flex: 0 1 auto !important;
}
:host ::ng-deep .flex-none {
  flex: none !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:flex-1 {
    flex: 1 1 0% !important;
  }
  :host ::ng-deep .sm\\:flex-auto {
    flex: 1 1 auto !important;
  }
  :host ::ng-deep .sm\\:flex-initial {
    flex: 0 1 auto !important;
  }
  :host ::ng-deep .sm\\:flex-none {
    flex: none !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:flex-1 {
    flex: 1 1 0% !important;
  }
  :host ::ng-deep .md\\:flex-auto {
    flex: 1 1 auto !important;
  }
  :host ::ng-deep .md\\:flex-initial {
    flex: 0 1 auto !important;
  }
  :host ::ng-deep .md\\:flex-none {
    flex: none !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:flex-1 {
    flex: 1 1 0% !important;
  }
  :host ::ng-deep .lg\\:flex-auto {
    flex: 1 1 auto !important;
  }
  :host ::ng-deep .lg\\:flex-initial {
    flex: 0 1 auto !important;
  }
  :host ::ng-deep .lg\\:flex-none {
    flex: none !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:flex-1 {
    flex: 1 1 0% !important;
  }
  :host ::ng-deep .xl\\:flex-auto {
    flex: 1 1 auto !important;
  }
  :host ::ng-deep .xl\\:flex-initial {
    flex: 0 1 auto !important;
  }
  :host ::ng-deep .xl\\:flex-none {
    flex: none !important;
  }
}
:host ::ng-deep .flex-grow-0 {
  flex-grow: 0 !important;
}
:host ::ng-deep .flex-grow-1 {
  flex-grow: 1 !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:flex-grow-0 {
    flex-grow: 0 !important;
  }
  :host ::ng-deep .sm\\:flex-grow-1 {
    flex-grow: 1 !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:flex-grow-0 {
    flex-grow: 0 !important;
  }
  :host ::ng-deep .md\\:flex-grow-1 {
    flex-grow: 1 !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:flex-grow-0 {
    flex-grow: 0 !important;
  }
  :host ::ng-deep .lg\\:flex-grow-1 {
    flex-grow: 1 !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:flex-grow-0 {
    flex-grow: 0 !important;
  }
  :host ::ng-deep .xl\\:flex-grow-1 {
    flex-grow: 1 !important;
  }
}
:host ::ng-deep .flex-shrink-0 {
  flex-shrink: 0 !important;
}
:host ::ng-deep .flex-shrink-1 {
  flex-shrink: 1 !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:flex-shrink-0 {
    flex-shrink: 0 !important;
  }
  :host ::ng-deep .sm\\:flex-shrink-1 {
    flex-shrink: 1 !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:flex-shrink-0 {
    flex-shrink: 0 !important;
  }
  :host ::ng-deep .md\\:flex-shrink-1 {
    flex-shrink: 1 !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:flex-shrink-0 {
    flex-shrink: 0 !important;
  }
  :host ::ng-deep .lg\\:flex-shrink-1 {
    flex-shrink: 1 !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:flex-shrink-0 {
    flex-shrink: 0 !important;
  }
  :host ::ng-deep .xl\\:flex-shrink-1 {
    flex-shrink: 1 !important;
  }
}
:host ::ng-deep .gap-0 {
  gap: 0rem !important;
}
:host ::ng-deep .gap-1 {
  gap: 0.25rem !important;
}
:host ::ng-deep .gap-2 {
  gap: 0.5rem !important;
}
:host ::ng-deep .gap-3 {
  gap: 1rem !important;
}
:host ::ng-deep .gap-4 {
  gap: 1.5rem !important;
}
:host ::ng-deep .gap-5 {
  gap: 2rem !important;
}
:host ::ng-deep .gap-6 {
  gap: 3rem !important;
}
:host ::ng-deep .gap-7 {
  gap: 4rem !important;
}
:host ::ng-deep .gap-8 {
  gap: 5rem !important;
}
:host ::ng-deep .row-gap-0 {
  row-gap: 0rem !important;
}
:host ::ng-deep .row-gap-1 {
  row-gap: 0.25rem !important;
}
:host ::ng-deep .row-gap-2 {
  row-gap: 0.5rem !important;
}
:host ::ng-deep .row-gap-3 {
  row-gap: 1rem !important;
}
:host ::ng-deep .row-gap-4 {
  row-gap: 1.5rem !important;
}
:host ::ng-deep .row-gap-5 {
  row-gap: 2rem !important;
}
:host ::ng-deep .row-gap-6 {
  row-gap: 3rem !important;
}
:host ::ng-deep .row-gap-7 {
  row-gap: 4rem !important;
}
:host ::ng-deep .row-gap-8 {
  row-gap: 5rem !important;
}
:host ::ng-deep .column-gap-0 {
  column-gap: 0rem !important;
}
:host ::ng-deep .column-gap-1 {
  column-gap: 0.25rem !important;
}
:host ::ng-deep .column-gap-2 {
  column-gap: 0.5rem !important;
}
:host ::ng-deep .column-gap-3 {
  column-gap: 1rem !important;
}
:host ::ng-deep .column-gap-4 {
  column-gap: 1.5rem !important;
}
:host ::ng-deep .column-gap-5 {
  column-gap: 2rem !important;
}
:host ::ng-deep .column-gap-6 {
  column-gap: 3rem !important;
}
:host ::ng-deep .column-gap-7 {
  column-gap: 4rem !important;
}
:host ::ng-deep .column-gap-8 {
  column-gap: 5rem !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:gap-0 {
    gap: 0rem !important;
  }
  :host ::ng-deep .sm\\:gap-1 {
    gap: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:gap-2 {
    gap: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:gap-3 {
    gap: 1rem !important;
  }
  :host ::ng-deep .sm\\:gap-4 {
    gap: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:gap-5 {
    gap: 2rem !important;
  }
  :host ::ng-deep .sm\\:gap-6 {
    gap: 3rem !important;
  }
  :host ::ng-deep .sm\\:gap-7 {
    gap: 4rem !important;
  }
  :host ::ng-deep .sm\\:gap-8 {
    gap: 5rem !important;
  }
  :host ::ng-deep .sm\\:row-gap-0 {
    row-gap: 0rem !important;
  }
  :host ::ng-deep .sm\\:row-gap-1 {
    row-gap: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:row-gap-2 {
    row-gap: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:row-gap-3 {
    row-gap: 1rem !important;
  }
  :host ::ng-deep .sm\\:row-gap-4 {
    row-gap: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:row-gap-5 {
    row-gap: 2rem !important;
  }
  :host ::ng-deep .sm\\:row-gap-6 {
    row-gap: 3rem !important;
  }
  :host ::ng-deep .sm\\:row-gap-7 {
    row-gap: 4rem !important;
  }
  :host ::ng-deep .sm\\:row-gap-8 {
    row-gap: 5rem !important;
  }
  :host ::ng-deep .sm\\:column-gap-0 {
    column-gap: 0rem !important;
  }
  :host ::ng-deep .sm\\:column-gap-1 {
    column-gap: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:column-gap-2 {
    column-gap: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:column-gap-3 {
    column-gap: 1rem !important;
  }
  :host ::ng-deep .sm\\:column-gap-4 {
    column-gap: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:column-gap-5 {
    column-gap: 2rem !important;
  }
  :host ::ng-deep .sm\\:column-gap-6 {
    column-gap: 3rem !important;
  }
  :host ::ng-deep .sm\\:column-gap-7 {
    column-gap: 4rem !important;
  }
  :host ::ng-deep .sm\\:column-gap-8 {
    column-gap: 5rem !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:gap-0 {
    gap: 0rem !important;
  }
  :host ::ng-deep .md\\:gap-1 {
    gap: 0.25rem !important;
  }
  :host ::ng-deep .md\\:gap-2 {
    gap: 0.5rem !important;
  }
  :host ::ng-deep .md\\:gap-3 {
    gap: 1rem !important;
  }
  :host ::ng-deep .md\\:gap-4 {
    gap: 1.5rem !important;
  }
  :host ::ng-deep .md\\:gap-5 {
    gap: 2rem !important;
  }
  :host ::ng-deep .md\\:gap-6 {
    gap: 3rem !important;
  }
  :host ::ng-deep .md\\:gap-7 {
    gap: 4rem !important;
  }
  :host ::ng-deep .md\\:gap-8 {
    gap: 5rem !important;
  }
  :host ::ng-deep .md\\:row-gap-0 {
    row-gap: 0rem !important;
  }
  :host ::ng-deep .md\\:row-gap-1 {
    row-gap: 0.25rem !important;
  }
  :host ::ng-deep .md\\:row-gap-2 {
    row-gap: 0.5rem !important;
  }
  :host ::ng-deep .md\\:row-gap-3 {
    row-gap: 1rem !important;
  }
  :host ::ng-deep .md\\:row-gap-4 {
    row-gap: 1.5rem !important;
  }
  :host ::ng-deep .md\\:row-gap-5 {
    row-gap: 2rem !important;
  }
  :host ::ng-deep .md\\:row-gap-6 {
    row-gap: 3rem !important;
  }
  :host ::ng-deep .md\\:row-gap-7 {
    row-gap: 4rem !important;
  }
  :host ::ng-deep .md\\:row-gap-8 {
    row-gap: 5rem !important;
  }
  :host ::ng-deep .md\\:column-gap-0 {
    column-gap: 0rem !important;
  }
  :host ::ng-deep .md\\:column-gap-1 {
    column-gap: 0.25rem !important;
  }
  :host ::ng-deep .md\\:column-gap-2 {
    column-gap: 0.5rem !important;
  }
  :host ::ng-deep .md\\:column-gap-3 {
    column-gap: 1rem !important;
  }
  :host ::ng-deep .md\\:column-gap-4 {
    column-gap: 1.5rem !important;
  }
  :host ::ng-deep .md\\:column-gap-5 {
    column-gap: 2rem !important;
  }
  :host ::ng-deep .md\\:column-gap-6 {
    column-gap: 3rem !important;
  }
  :host ::ng-deep .md\\:column-gap-7 {
    column-gap: 4rem !important;
  }
  :host ::ng-deep .md\\:column-gap-8 {
    column-gap: 5rem !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:gap-0 {
    gap: 0rem !important;
  }
  :host ::ng-deep .lg\\:gap-1 {
    gap: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:gap-2 {
    gap: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:gap-3 {
    gap: 1rem !important;
  }
  :host ::ng-deep .lg\\:gap-4 {
    gap: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:gap-5 {
    gap: 2rem !important;
  }
  :host ::ng-deep .lg\\:gap-6 {
    gap: 3rem !important;
  }
  :host ::ng-deep .lg\\:gap-7 {
    gap: 4rem !important;
  }
  :host ::ng-deep .lg\\:gap-8 {
    gap: 5rem !important;
  }
  :host ::ng-deep .lg\\:row-gap-0 {
    row-gap: 0rem !important;
  }
  :host ::ng-deep .lg\\:row-gap-1 {
    row-gap: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:row-gap-2 {
    row-gap: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:row-gap-3 {
    row-gap: 1rem !important;
  }
  :host ::ng-deep .lg\\:row-gap-4 {
    row-gap: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:row-gap-5 {
    row-gap: 2rem !important;
  }
  :host ::ng-deep .lg\\:row-gap-6 {
    row-gap: 3rem !important;
  }
  :host ::ng-deep .lg\\:row-gap-7 {
    row-gap: 4rem !important;
  }
  :host ::ng-deep .lg\\:row-gap-8 {
    row-gap: 5rem !important;
  }
  :host ::ng-deep .lg\\:column-gap-0 {
    column-gap: 0rem !important;
  }
  :host ::ng-deep .lg\\:column-gap-1 {
    column-gap: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:column-gap-2 {
    column-gap: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:column-gap-3 {
    column-gap: 1rem !important;
  }
  :host ::ng-deep .lg\\:column-gap-4 {
    column-gap: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:column-gap-5 {
    column-gap: 2rem !important;
  }
  :host ::ng-deep .lg\\:column-gap-6 {
    column-gap: 3rem !important;
  }
  :host ::ng-deep .lg\\:column-gap-7 {
    column-gap: 4rem !important;
  }
  :host ::ng-deep .lg\\:column-gap-8 {
    column-gap: 5rem !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:gap-0 {
    gap: 0rem !important;
  }
  :host ::ng-deep .xl\\:gap-1 {
    gap: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:gap-2 {
    gap: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:gap-3 {
    gap: 1rem !important;
  }
  :host ::ng-deep .xl\\:gap-4 {
    gap: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:gap-5 {
    gap: 2rem !important;
  }
  :host ::ng-deep .xl\\:gap-6 {
    gap: 3rem !important;
  }
  :host ::ng-deep .xl\\:gap-7 {
    gap: 4rem !important;
  }
  :host ::ng-deep .xl\\:gap-8 {
    gap: 5rem !important;
  }
  :host ::ng-deep .xl\\:row-gap-0 {
    row-gap: 0rem !important;
  }
  :host ::ng-deep .xl\\:row-gap-1 {
    row-gap: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:row-gap-2 {
    row-gap: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:row-gap-3 {
    row-gap: 1rem !important;
  }
  :host ::ng-deep .xl\\:row-gap-4 {
    row-gap: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:row-gap-5 {
    row-gap: 2rem !important;
  }
  :host ::ng-deep .xl\\:row-gap-6 {
    row-gap: 3rem !important;
  }
  :host ::ng-deep .xl\\:row-gap-7 {
    row-gap: 4rem !important;
  }
  :host ::ng-deep .xl\\:row-gap-8 {
    row-gap: 5rem !important;
  }
  :host ::ng-deep .xl\\:column-gap-0 {
    column-gap: 0rem !important;
  }
  :host ::ng-deep .xl\\:column-gap-1 {
    column-gap: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:column-gap-2 {
    column-gap: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:column-gap-3 {
    column-gap: 1rem !important;
  }
  :host ::ng-deep .xl\\:column-gap-4 {
    column-gap: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:column-gap-5 {
    column-gap: 2rem !important;
  }
  :host ::ng-deep .xl\\:column-gap-6 {
    column-gap: 3rem !important;
  }
  :host ::ng-deep .xl\\:column-gap-7 {
    column-gap: 4rem !important;
  }
  :host ::ng-deep .xl\\:column-gap-8 {
    column-gap: 5rem !important;
  }
}
:host ::ng-deep .p-0 {
  padding: 0rem !important;
}
:host ::ng-deep .p-1 {
  padding: 0.25rem !important;
}
:host ::ng-deep .p-2 {
  padding: 0.5rem !important;
}
:host ::ng-deep .p-3 {
  padding: 1rem !important;
}
:host ::ng-deep .p-4 {
  padding: 1.5rem !important;
}
:host ::ng-deep .p-5 {
  padding: 2rem !important;
}
:host ::ng-deep .p-6 {
  padding: 3rem !important;
}
:host ::ng-deep .p-7 {
  padding: 4rem !important;
}
:host ::ng-deep .p-8 {
  padding: 5rem !important;
}
:host ::ng-deep .pt-0 {
  padding-top: 0rem !important;
}
:host ::ng-deep .pt-1 {
  padding-top: 0.25rem !important;
}
:host ::ng-deep .pt-2 {
  padding-top: 0.5rem !important;
}
:host ::ng-deep .pt-3 {
  padding-top: 1rem !important;
}
:host ::ng-deep .pt-4 {
  padding-top: 1.5rem !important;
}
:host ::ng-deep .pt-5 {
  padding-top: 2rem !important;
}
:host ::ng-deep .pt-6 {
  padding-top: 3rem !important;
}
:host ::ng-deep .pt-7 {
  padding-top: 4rem !important;
}
:host ::ng-deep .pt-8 {
  padding-top: 5rem !important;
}
:host ::ng-deep .pr-0 {
  padding-right: 0rem !important;
}
:host ::ng-deep .pr-1 {
  padding-right: 0.25rem !important;
}
:host ::ng-deep .pr-2 {
  padding-right: 0.5rem !important;
}
:host ::ng-deep .pr-3 {
  padding-right: 1rem !important;
}
:host ::ng-deep .pr-4 {
  padding-right: 1.5rem !important;
}
:host ::ng-deep .pr-5 {
  padding-right: 2rem !important;
}
:host ::ng-deep .pr-6 {
  padding-right: 3rem !important;
}
:host ::ng-deep .pr-7 {
  padding-right: 4rem !important;
}
:host ::ng-deep .pr-8 {
  padding-right: 5rem !important;
}
:host ::ng-deep .pl-0 {
  padding-left: 0rem !important;
}
:host ::ng-deep .pl-1 {
  padding-left: 0.25rem !important;
}
:host ::ng-deep .pl-2 {
  padding-left: 0.5rem !important;
}
:host ::ng-deep .pl-3 {
  padding-left: 1rem !important;
}
:host ::ng-deep .pl-4 {
  padding-left: 1.5rem !important;
}
:host ::ng-deep .pl-5 {
  padding-left: 2rem !important;
}
:host ::ng-deep .pl-6 {
  padding-left: 3rem !important;
}
:host ::ng-deep .pl-7 {
  padding-left: 4rem !important;
}
:host ::ng-deep .pl-8 {
  padding-left: 5rem !important;
}
:host ::ng-deep .pb-0 {
  padding-bottom: 0rem !important;
}
:host ::ng-deep .pb-1 {
  padding-bottom: 0.25rem !important;
}
:host ::ng-deep .pb-2 {
  padding-bottom: 0.5rem !important;
}
:host ::ng-deep .pb-3 {
  padding-bottom: 1rem !important;
}
:host ::ng-deep .pb-4 {
  padding-bottom: 1.5rem !important;
}
:host ::ng-deep .pb-5 {
  padding-bottom: 2rem !important;
}
:host ::ng-deep .pb-6 {
  padding-bottom: 3rem !important;
}
:host ::ng-deep .pb-7 {
  padding-bottom: 4rem !important;
}
:host ::ng-deep .pb-8 {
  padding-bottom: 5rem !important;
}
:host ::ng-deep .px-0 {
  padding-left: 0rem !important;
  padding-right: 0rem !important;
}
:host ::ng-deep .px-1 {
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}
:host ::ng-deep .px-2 {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
:host ::ng-deep .px-3 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
:host ::ng-deep .px-4 {
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}
:host ::ng-deep .px-5 {
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}
:host ::ng-deep .px-6 {
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}
:host ::ng-deep .px-7 {
  padding-left: 4rem !important;
  padding-right: 4rem !important;
}
:host ::ng-deep .px-8 {
  padding-left: 5rem !important;
  padding-right: 5rem !important;
}
:host ::ng-deep .py-0 {
  padding-top: 0rem !important;
  padding-bottom: 0rem !important;
}
:host ::ng-deep .py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
:host ::ng-deep .py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
:host ::ng-deep .py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
:host ::ng-deep .py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
:host ::ng-deep .py-5 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
:host ::ng-deep .py-6 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}
:host ::ng-deep .py-7 {
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
}
:host ::ng-deep .py-8 {
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:p-0 {
    padding: unset !important;
  }
  :host ::ng-deep .sm\\:p-1 {
    padding: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:p-2 {
    padding: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:p-3 {
    padding: 1rem !important;
  }
  :host ::ng-deep .sm\\:p-4 {
    padding: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:p-5 {
    padding: 2rem !important;
  }
  :host ::ng-deep .sm\\:p-6 {
    padding: 3rem !important;
  }
  :host ::ng-deep .sm\\:p-7 {
    padding: 4rem !important;
  }
  :host ::ng-deep .sm\\:p-8 {
    padding: 5rem !important;
  }
  :host ::ng-deep .sm\\:pt-0 {
    padding-top: 0rem !important;
  }
  :host ::ng-deep .sm\\:pt-1 {
    padding-top: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:pt-2 {
    padding-top: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:pt-3 {
    padding-top: 1rem !important;
  }
  :host ::ng-deep .sm\\:pt-4 {
    padding-top: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:pt-5 {
    padding-top: 2rem !important;
  }
  :host ::ng-deep .sm\\:pt-6 {
    padding-top: 3rem !important;
  }
  :host ::ng-deep .sm\\:pt-7 {
    padding-top: 4rem !important;
  }
  :host ::ng-deep .sm\\:pt-8 {
    padding-top: 5rem !important;
  }
  :host ::ng-deep .sm\\:pr-0 {
    padding-right: 0rem !important;
  }
  :host ::ng-deep .sm\\:pr-1 {
    padding-right: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:pr-2 {
    padding-right: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:pr-3 {
    padding-right: 1rem !important;
  }
  :host ::ng-deep .sm\\:pr-4 {
    padding-right: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:pr-5 {
    padding-right: 2rem !important;
  }
  :host ::ng-deep .sm\\:pr-6 {
    padding-right: 3rem !important;
  }
  :host ::ng-deep .sm\\:pr-7 {
    padding-right: 4rem !important;
  }
  :host ::ng-deep .sm\\:pr-8 {
    padding-right: 5rem !important;
  }
  :host ::ng-deep .sm\\:pl-0 {
    padding-left: 0rem !important;
  }
  :host ::ng-deep .sm\\:pl-1 {
    padding-left: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:pl-2 {
    padding-left: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:pl-3 {
    padding-left: 1rem !important;
  }
  :host ::ng-deep .sm\\:pl-4 {
    padding-left: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:pl-5 {
    padding-left: 2rem !important;
  }
  :host ::ng-deep .sm\\:pl-6 {
    padding-left: 3rem !important;
  }
  :host ::ng-deep .sm\\:pl-7 {
    padding-left: 4rem !important;
  }
  :host ::ng-deep .sm\\:pl-8 {
    padding-left: 5rem !important;
  }
  :host ::ng-deep .sm\\:pb-0 {
    padding-bottom: 0rem !important;
  }
  :host ::ng-deep .sm\\:pb-1 {
    padding-bottom: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:pb-2 {
    padding-bottom: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:pb-3 {
    padding-bottom: 1rem !important;
  }
  :host ::ng-deep .sm\\:pb-4 {
    padding-bottom: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:pb-5 {
    padding-bottom: 2rem !important;
  }
  :host ::ng-deep .sm\\:pb-6 {
    padding-bottom: 3rem !important;
  }
  :host ::ng-deep .sm\\:pb-7 {
    padding-bottom: 4rem !important;
  }
  :host ::ng-deep .sm\\:pb-8 {
    padding-bottom: 5rem !important;
  }
  :host ::ng-deep .sm\\:px-0 {
    padding-left: 0rem !important;
    padding-right: 0rem !important;
  }
  :host ::ng-deep .sm\\:px-1 {
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:px-2 {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:px-3 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  :host ::ng-deep .sm\\:px-4 {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:px-5 {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }
  :host ::ng-deep .sm\\:px-6 {
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }
  :host ::ng-deep .sm\\:px-7 {
    padding-left: 4rem !important;
    padding-right: 4rem !important;
  }
  :host ::ng-deep .sm\\:px-8 {
    padding-left: 5rem !important;
    padding-right: 5rem !important;
  }
  :host ::ng-deep .sm\\:py-0 {
    padding-top: 0rem !important;
    padding-bottom: 0rem !important;
  }
  :host ::ng-deep .sm\\:py-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:py-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:py-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  :host ::ng-deep .sm\\:py-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:py-5 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  :host ::ng-deep .sm\\:py-6 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  :host ::ng-deep .sm\\:py-7 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  :host ::ng-deep .sm\\:py-8 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:p-0 {
    padding: 0 !important;
  }
  :host ::ng-deep .md\\:p-1 {
    padding: 0.25rem !important;
  }
  :host ::ng-deep .md\\:p-2 {
    padding: 0.5rem !important;
  }
  :host ::ng-deep .md\\:p-3 {
    padding: 1rem !important;
  }
  :host ::ng-deep .md\\:p-4 {
    padding: 1.5rem !important;
  }
  :host ::ng-deep .md\\:p-5 {
    padding: 2rem !important;
  }
  :host ::ng-deep .md\\:p-6 {
    padding: 3rem !important;
  }
  :host ::ng-deep .md\\:p-7 {
    padding: 4rem !important;
  }
  :host ::ng-deep .md\\:p-8 {
    padding: 5rem !important;
  }
  :host ::ng-deep .md\\:pt-0 {
    padding-top: 0rem !important;
  }
  :host ::ng-deep .md\\:pt-1 {
    padding-top: 0.25rem !important;
  }
  :host ::ng-deep .md\\:pt-2 {
    padding-top: 0.5rem !important;
  }
  :host ::ng-deep .md\\:pt-3 {
    padding-top: 1rem !important;
  }
  :host ::ng-deep .md\\:pt-4 {
    padding-top: 1.5rem !important;
  }
  :host ::ng-deep .md\\:pt-5 {
    padding-top: 2rem !important;
  }
  :host ::ng-deep .md\\:pt-6 {
    padding-top: 3rem !important;
  }
  :host ::ng-deep .md\\:pt-7 {
    padding-top: 4rem !important;
  }
  :host ::ng-deep .md\\:pt-8 {
    padding-top: 5rem !important;
  }
  :host ::ng-deep .md\\:pr-0 {
    padding-right: 0rem !important;
  }
  :host ::ng-deep .md\\:pr-1 {
    padding-right: 0.25rem !important;
  }
  :host ::ng-deep .md\\:pr-2 {
    padding-right: 0.5rem !important;
  }
  :host ::ng-deep .md\\:pr-3 {
    padding-right: 1rem !important;
  }
  :host ::ng-deep .md\\:pr-4 {
    padding-right: 1.5rem !important;
  }
  :host ::ng-deep .md\\:pr-5 {
    padding-right: 2rem !important;
  }
  :host ::ng-deep .md\\:pr-6 {
    padding-right: 3rem !important;
  }
  :host ::ng-deep .md\\:pr-7 {
    padding-right: 4rem !important;
  }
  :host ::ng-deep .md\\:pr-8 {
    padding-right: 5rem !important;
  }
  :host ::ng-deep .md\\:pl-0 {
    padding-left: 0rem !important;
  }
  :host ::ng-deep .md\\:pl-1 {
    padding-left: 0.25rem !important;
  }
  :host ::ng-deep .md\\:pl-2 {
    padding-left: 0.5rem !important;
  }
  :host ::ng-deep .md\\:pl-3 {
    padding-left: 1rem !important;
  }
  :host ::ng-deep .md\\:pl-4 {
    padding-left: 1.5rem !important;
  }
  :host ::ng-deep .md\\:pl-5 {
    padding-left: 2rem !important;
  }
  :host ::ng-deep .md\\:pl-6 {
    padding-left: 3rem !important;
  }
  :host ::ng-deep .md\\:pl-7 {
    padding-left: 4rem !important;
  }
  :host ::ng-deep .md\\:pl-8 {
    padding-left: 5rem !important;
  }
  :host ::ng-deep .md\\:pb-0 {
    padding-bottom: 0rem !important;
  }
  :host ::ng-deep .md\\:pb-1 {
    padding-bottom: 0.25rem !important;
  }
  :host ::ng-deep .md\\:pb-2 {
    padding-bottom: 0.5rem !important;
  }
  :host ::ng-deep .md\\:pb-3 {
    padding-bottom: 1rem !important;
  }
  :host ::ng-deep .md\\:pb-4 {
    padding-bottom: 1.5rem !important;
  }
  :host ::ng-deep .md\\:pb-5 {
    padding-bottom: 2rem !important;
  }
  :host ::ng-deep .md\\:pb-6 {
    padding-bottom: 3rem !important;
  }
  :host ::ng-deep .md\\:pb-7 {
    padding-bottom: 4rem !important;
  }
  :host ::ng-deep .md\\:pb-8 {
    padding-bottom: 5rem !important;
  }
  :host ::ng-deep .md\\:px-0 {
    padding-left: 0rem !important;
    padding-right: 0rem !important;
  }
  :host ::ng-deep .md\\:px-1 {
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
  }
  :host ::ng-deep .md\\:px-2 {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }
  :host ::ng-deep .md\\:px-3 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  :host ::ng-deep .md\\:px-4 {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }
  :host ::ng-deep .md\\:px-5 {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }
  :host ::ng-deep .md\\:px-6 {
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }
  :host ::ng-deep .md\\:px-7 {
    padding-left: 4rem !important;
    padding-right: 4rem !important;
  }
  :host ::ng-deep .md\\:px-8 {
    padding-left: 5rem !important;
    padding-right: 5rem !important;
  }
  :host ::ng-deep .md\\:py-0 {
    padding-top: 0rem !important;
    padding-bottom: 0rem !important;
  }
  :host ::ng-deep .md\\:py-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  :host ::ng-deep .md\\:py-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  :host ::ng-deep .md\\:py-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  :host ::ng-deep .md\\:py-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  :host ::ng-deep .md\\:py-5 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  :host ::ng-deep .md\\:py-6 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  :host ::ng-deep .md\\:py-7 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  :host ::ng-deep .md\\:py-8 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:p-0 {
    padding: 0 !important;
  }
  :host ::ng-deep .lg\\:p-1 {
    padding: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:p-2 {
    padding: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:p-3 {
    padding: 1rem !important;
  }
  :host ::ng-deep .lg\\:p-4 {
    padding: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:p-5 {
    padding: 2rem !important;
  }
  :host ::ng-deep .lg\\:p-6 {
    padding: 3rem !important;
  }
  :host ::ng-deep .lg\\:p-7 {
    padding: 4rem !important;
  }
  :host ::ng-deep .lg\\:p-8 {
    padding: 5rem !important;
  }
  :host ::ng-deep .lg\\:pt-0 {
    padding-top: 0rem !important;
  }
  :host ::ng-deep .lg\\:pt-1 {
    padding-top: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:pt-2 {
    padding-top: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:pt-3 {
    padding-top: 1rem !important;
  }
  :host ::ng-deep .lg\\:pt-4 {
    padding-top: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:pt-5 {
    padding-top: 2rem !important;
  }
  :host ::ng-deep .lg\\:pt-6 {
    padding-top: 3rem !important;
  }
  :host ::ng-deep .lg\\:pt-7 {
    padding-top: 4rem !important;
  }
  :host ::ng-deep .lg\\:pt-8 {
    padding-top: 5rem !important;
  }
  :host ::ng-deep .lg\\:pr-0 {
    padding-right: 0rem !important;
  }
  :host ::ng-deep .lg\\:pr-1 {
    padding-right: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:pr-2 {
    padding-right: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:pr-3 {
    padding-right: 1rem !important;
  }
  :host ::ng-deep .lg\\:pr-4 {
    padding-right: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:pr-5 {
    padding-right: 2rem !important;
  }
  :host ::ng-deep .lg\\:pr-6 {
    padding-right: 3rem !important;
  }
  :host ::ng-deep .lg\\:pr-7 {
    padding-right: 4rem !important;
  }
  :host ::ng-deep .lg\\:pr-8 {
    padding-right: 5rem !important;
  }
  :host ::ng-deep .lg\\:pl-0 {
    padding-left: 0rem !important;
  }
  :host ::ng-deep .lg\\:pl-1 {
    padding-left: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:pl-2 {
    padding-left: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:pl-3 {
    padding-left: 1rem !important;
  }
  :host ::ng-deep .lg\\:pl-4 {
    padding-left: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:pl-5 {
    padding-left: 2rem !important;
  }
  :host ::ng-deep .lg\\:pl-6 {
    padding-left: 3rem !important;
  }
  :host ::ng-deep .lg\\:pl-7 {
    padding-left: 4rem !important;
  }
  :host ::ng-deep .lg\\:pl-8 {
    padding-left: 5rem !important;
  }
  :host ::ng-deep .lg\\:pb-0 {
    padding-bottom: 0rem !important;
  }
  :host ::ng-deep .lg\\:pb-1 {
    padding-bottom: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:pb-2 {
    padding-bottom: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:pb-3 {
    padding-bottom: 1rem !important;
  }
  :host ::ng-deep .lg\\:pb-4 {
    padding-bottom: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:pb-5 {
    padding-bottom: 2rem !important;
  }
  :host ::ng-deep .lg\\:pb-6 {
    padding-bottom: 3rem !important;
  }
  :host ::ng-deep .lg\\:pb-7 {
    padding-bottom: 4rem !important;
  }
  :host ::ng-deep .lg\\:pb-8 {
    padding-bottom: 5rem !important;
  }
  :host ::ng-deep .lg\\:px-0 {
    padding-left: 0rem !important;
    padding-right: 0rem !important;
  }
  :host ::ng-deep .lg\\:px-1 {
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:px-2 {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:px-3 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  :host ::ng-deep .lg\\:px-4 {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:px-5 {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }
  :host ::ng-deep .lg\\:px-6 {
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }
  :host ::ng-deep .lg\\:px-7 {
    padding-left: 4rem !important;
    padding-right: 4rem !important;
  }
  :host ::ng-deep .lg\\:px-8 {
    padding-left: 5rem !important;
    padding-right: 5rem !important;
  }
  :host ::ng-deep .lg\\:py-0 {
    padding-top: 0rem !important;
    padding-bottom: 0rem !important;
  }
  :host ::ng-deep .lg\\:py-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:py-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:py-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  :host ::ng-deep .lg\\:py-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:py-5 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  :host ::ng-deep .lg\\:py-6 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  :host ::ng-deep .lg\\:py-7 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  :host ::ng-deep .lg\\:py-8 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:p-0 {
    padding: 0 !important;
  }
  :host ::ng-deep .xl\\:p-1 {
    padding: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:p-2 {
    padding: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:p-3 {
    padding: 1rem !important;
  }
  :host ::ng-deep .xl\\:p-4 {
    padding: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:p-5 {
    padding: 2rem !important;
  }
  :host ::ng-deep .xl\\:p-6 {
    padding: 3rem !important;
  }
  :host ::ng-deep .xl\\:p-7 {
    padding: 4rem !important;
  }
  :host ::ng-deep .xl\\:p-8 {
    padding: 5rem !important;
  }
  :host ::ng-deep .xl\\:pt-0 {
    padding-top: 0rem !important;
  }
  :host ::ng-deep .xl\\:pt-1 {
    padding-top: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:pt-2 {
    padding-top: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:pt-3 {
    padding-top: 1rem !important;
  }
  :host ::ng-deep .xl\\:pt-4 {
    padding-top: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:pt-5 {
    padding-top: 2rem !important;
  }
  :host ::ng-deep .xl\\:pt-6 {
    padding-top: 3rem !important;
  }
  :host ::ng-deep .xl\\:pt-7 {
    padding-top: 4rem !important;
  }
  :host ::ng-deep .xl\\:pt-8 {
    padding-top: 5rem !important;
  }
  :host ::ng-deep .xl\\:pr-0 {
    padding-right: 0rem !important;
  }
  :host ::ng-deep .xl\\:pr-1 {
    padding-right: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:pr-2 {
    padding-right: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:pr-3 {
    padding-right: 1rem !important;
  }
  :host ::ng-deep .xl\\:pr-4 {
    padding-right: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:pr-5 {
    padding-right: 2rem !important;
  }
  :host ::ng-deep .xl\\:pr-6 {
    padding-right: 3rem !important;
  }
  :host ::ng-deep .xl\\:pr-7 {
    padding-right: 4rem !important;
  }
  :host ::ng-deep .xl\\:pr-8 {
    padding-right: 5rem !important;
  }
  :host ::ng-deep .xl\\:pl-0 {
    padding-left: 0rem !important;
  }
  :host ::ng-deep .xl\\:pl-1 {
    padding-left: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:pl-2 {
    padding-left: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:pl-3 {
    padding-left: 1rem !important;
  }
  :host ::ng-deep .xl\\:pl-4 {
    padding-left: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:pl-5 {
    padding-left: 2rem !important;
  }
  :host ::ng-deep .xl\\:pl-6 {
    padding-left: 3rem !important;
  }
  :host ::ng-deep .xl\\:pl-7 {
    padding-left: 4rem !important;
  }
  :host ::ng-deep .xl\\:pl-8 {
    padding-left: 5rem !important;
  }
  :host ::ng-deep .xl\\:pb-0 {
    padding-bottom: 0rem !important;
  }
  :host ::ng-deep .xl\\:pb-1 {
    padding-bottom: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:pb-2 {
    padding-bottom: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:pb-3 {
    padding-bottom: 1rem !important;
  }
  :host ::ng-deep .xl\\:pb-4 {
    padding-bottom: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:pb-5 {
    padding-bottom: 2rem !important;
  }
  :host ::ng-deep .xl\\:pb-6 {
    padding-bottom: 3rem !important;
  }
  :host ::ng-deep .xl\\:pb-7 {
    padding-bottom: 4rem !important;
  }
  :host ::ng-deep .xl\\:pb-8 {
    padding-bottom: 5rem !important;
  }
  :host ::ng-deep .xl\\:px-0 {
    padding-left: 0rem !important;
    padding-right: 0rem !important;
  }
  :host ::ng-deep .xl\\:px-1 {
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:px-2 {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:px-3 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  :host ::ng-deep .xl\\:px-4 {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:px-5 {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }
  :host ::ng-deep .xl\\:px-6 {
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }
  :host ::ng-deep .xl\\:px-7 {
    padding-left: 4rem !important;
    padding-right: 4rem !important;
  }
  :host ::ng-deep .xl\\:px-8 {
    padding-left: 5rem !important;
    padding-right: 5rem !important;
  }
  :host ::ng-deep .xl\\:py-0 {
    padding-top: 0rem !important;
    padding-bottom: 0rem !important;
  }
  :host ::ng-deep .xl\\:py-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:py-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:py-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  :host ::ng-deep .xl\\:py-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:py-5 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  :host ::ng-deep .xl\\:py-6 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  :host ::ng-deep .xl\\:py-7 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  :host ::ng-deep .xl\\:py-8 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
}
:host ::ng-deep .m-0 {
  margin: 0rem !important;
}
:host ::ng-deep .m-1 {
  margin: 0.25rem !important;
}
:host ::ng-deep .m-2 {
  margin: 0.5rem !important;
}
:host ::ng-deep .m-3 {
  margin: 1rem !important;
}
:host ::ng-deep .m-4 {
  margin: 1.5rem !important;
}
:host ::ng-deep .m-5 {
  margin: 2rem !important;
}
:host ::ng-deep .m-6 {
  margin: 3rem !important;
}
:host ::ng-deep .m-7 {
  margin: 4rem !important;
}
:host ::ng-deep .m-8 {
  margin: 5rem !important;
}
:host ::ng-deep .-m-1 {
  margin: -0.25rem !important;
}
:host ::ng-deep .-m-2 {
  margin: -0.5rem !important;
}
:host ::ng-deep .-m-3 {
  margin: -1rem !important;
}
:host ::ng-deep .-m-4 {
  margin: -1.5rem !important;
}
:host ::ng-deep .-m-5 {
  margin: -2rem !important;
}
:host ::ng-deep .-m-6 {
  margin: -3rem !important;
}
:host ::ng-deep .-m-7 {
  margin: -4rem !important;
}
:host ::ng-deep .-m-8 {
  margin: -5rem !important;
}
:host ::ng-deep .m-auto {
  margin: auto !important;
}
:host ::ng-deep .mt-0 {
  margin-top: 0rem !important;
}
:host ::ng-deep .mt-1 {
  margin-top: 0.25rem !important;
}
:host ::ng-deep .mt-2 {
  margin-top: 0.5rem !important;
}
:host ::ng-deep .mt-3 {
  margin-top: 1rem !important;
}
:host ::ng-deep .mt-4 {
  margin-top: 1.5rem !important;
}
:host ::ng-deep .mt-5 {
  margin-top: 2rem !important;
}
:host ::ng-deep .mt-6 {
  margin-top: 3rem !important;
}
:host ::ng-deep .mt-7 {
  margin-top: 4rem !important;
}
:host ::ng-deep .mt-8 {
  margin-top: 5rem !important;
}
:host ::ng-deep .-mt-1 {
  margin-top: -0.25rem !important;
}
:host ::ng-deep .-mt-2 {
  margin-top: -0.5rem !important;
}
:host ::ng-deep .-mt-3 {
  margin-top: -1rem !important;
}
:host ::ng-deep .-mt-4 {
  margin-top: -1.5rem !important;
}
:host ::ng-deep .-mt-5 {
  margin-top: -2rem !important;
}
:host ::ng-deep .-mt-6 {
  margin-top: -3rem !important;
}
:host ::ng-deep .-mt-7 {
  margin-top: -4rem !important;
}
:host ::ng-deep .-mt-8 {
  margin-top: -5rem !important;
}
:host ::ng-deep .mt-auto {
  margin-top: auto !important;
}
:host ::ng-deep .mr-0 {
  margin-right: 0rem !important;
}
:host ::ng-deep .mr-1 {
  margin-right: 0.25rem !important;
}
:host ::ng-deep .mr-2 {
  margin-right: 0.5rem !important;
}
:host ::ng-deep .mr-3 {
  margin-right: 1rem !important;
}
:host ::ng-deep .mr-4 {
  margin-right: 1.5rem !important;
}
:host ::ng-deep .mr-5 {
  margin-right: 2rem !important;
}
:host ::ng-deep .mr-6 {
  margin-right: 3rem !important;
}
:host ::ng-deep .mr-7 {
  margin-right: 4rem !important;
}
:host ::ng-deep .mr-8 {
  margin-right: 5rem !important;
}
:host ::ng-deep .-mr-1 {
  margin-right: -0.25rem !important;
}
:host ::ng-deep .-mr-2 {
  margin-right: -0.5rem !important;
}
:host ::ng-deep .-mr-3 {
  margin-right: -1rem !important;
}
:host ::ng-deep .-mr-4 {
  margin-right: -1.5rem !important;
}
:host ::ng-deep .-mr-5 {
  margin-right: -2rem !important;
}
:host ::ng-deep .-mr-6 {
  margin-right: -3rem !important;
}
:host ::ng-deep .-mr-7 {
  margin-right: -4rem !important;
}
:host ::ng-deep .-mr-8 {
  margin-right: -5rem !important;
}
:host ::ng-deep .mr-auto {
  margin-right: auto !important;
}
:host ::ng-deep .ml-0 {
  margin-left: 0rem !important;
}
:host ::ng-deep .ml-1 {
  margin-left: 0.25rem !important;
}
:host ::ng-deep .ml-2 {
  margin-left: 0.5rem !important;
}
:host ::ng-deep .ml-3 {
  margin-left: 1rem !important;
}
:host ::ng-deep .ml-4 {
  margin-left: 1.5rem !important;
}
:host ::ng-deep .ml-5 {
  margin-left: 2rem !important;
}
:host ::ng-deep .ml-6 {
  margin-left: 3rem !important;
}
:host ::ng-deep .ml-7 {
  margin-left: 4rem !important;
}
:host ::ng-deep .ml-8 {
  margin-left: 5rem !important;
}
:host ::ng-deep .-ml-1 {
  margin-left: -0.25rem !important;
}
:host ::ng-deep .-ml-2 {
  margin-left: -0.5rem !important;
}
:host ::ng-deep .-ml-3 {
  margin-left: -1rem !important;
}
:host ::ng-deep .-ml-4 {
  margin-left: -1.5rem !important;
}
:host ::ng-deep .-ml-5 {
  margin-left: -2rem !important;
}
:host ::ng-deep .-ml-6 {
  margin-left: -3rem !important;
}
:host ::ng-deep .-ml-7 {
  margin-left: -4rem !important;
}
:host ::ng-deep .-ml-8 {
  margin-left: -5rem !important;
}
:host ::ng-deep .ml-auto {
  margin-left: auto !important;
}
:host ::ng-deep .mb-0 {
  margin-bottom: 0rem !important;
}
:host ::ng-deep .mb-1 {
  margin-bottom: 0.25rem !important;
}
:host ::ng-deep .mb-2 {
  margin-bottom: 0.5rem !important;
}
:host ::ng-deep .mb-3 {
  margin-bottom: 1rem !important;
}
:host ::ng-deep .mb-4 {
  margin-bottom: 1.5rem !important;
}
:host ::ng-deep .mb-5 {
  margin-bottom: 2rem !important;
}
:host ::ng-deep .mb-6 {
  margin-bottom: 3rem !important;
}
:host ::ng-deep .mb-7 {
  margin-bottom: 4rem !important;
}
:host ::ng-deep .mb-8 {
  margin-bottom: 5rem !important;
}
:host ::ng-deep .-mb-1 {
  margin-bottom: -0.25rem !important;
}
:host ::ng-deep .-mb-2 {
  margin-bottom: -0.5rem !important;
}
:host ::ng-deep .-mb-3 {
  margin-bottom: -1rem !important;
}
:host ::ng-deep .-mb-4 {
  margin-bottom: -1.5rem !important;
}
:host ::ng-deep .-mb-5 {
  margin-bottom: -2rem !important;
}
:host ::ng-deep .-mb-6 {
  margin-bottom: -3rem !important;
}
:host ::ng-deep .-mb-7 {
  margin-bottom: -4rem !important;
}
:host ::ng-deep .-mb-8 {
  margin-bottom: -5rem !important;
}
:host ::ng-deep .mb-auto {
  margin-bottom: auto !important;
}
:host ::ng-deep .mx-0 {
  margin-left: 0rem !important;
  margin-right: 0rem !important;
}
:host ::ng-deep .mx-1 {
  margin-left: 0.25rem !important;
  margin-right: 0.25rem !important;
}
:host ::ng-deep .mx-2 {
  margin-left: 0.5rem !important;
  margin-right: 0.5rem !important;
}
:host ::ng-deep .mx-3 {
  margin-left: 1rem !important;
  margin-right: 1rem !important;
}
:host ::ng-deep .mx-4 {
  margin-left: 1.5rem !important;
  margin-right: 1.5rem !important;
}
:host ::ng-deep .mx-5 {
  margin-left: 2rem !important;
  margin-right: 2rem !important;
}
:host ::ng-deep .mx-6 {
  margin-left: 3rem !important;
  margin-right: 3rem !important;
}
:host ::ng-deep .mx-7 {
  margin-left: 4rem !important;
  margin-right: 4rem !important;
}
:host ::ng-deep .mx-8 {
  margin-left: 5rem !important;
  margin-right: 5rem !important;
}
:host ::ng-deep .-mx-1 {
  margin-left: -0.25rem !important;
  margin-right: -0.25rem !important;
}
:host ::ng-deep .-mx-2 {
  margin-left: -0.5rem !important;
  margin-right: -0.5rem !important;
}
:host ::ng-deep .-mx-3 {
  margin-left: -1rem !important;
  margin-right: -1rem !important;
}
:host ::ng-deep .-mx-4 {
  margin-left: -1.5rem !important;
  margin-right: -1.5rem !important;
}
:host ::ng-deep .-mx-5 {
  margin-left: -2rem !important;
  margin-right: -2rem !important;
}
:host ::ng-deep .-mx-6 {
  margin-left: -3rem !important;
  margin-right: -3rem !important;
}
:host ::ng-deep .-mx-7 {
  margin-left: -4rem !important;
  margin-right: -4rem !important;
}
:host ::ng-deep .-mx-8 {
  margin-left: -5rem !important;
  margin-right: -5rem !important;
}
:host ::ng-deep .mx-auto {
  margin-left: auto !important;
  margin-right: auto !important;
}
:host ::ng-deep .my-0 {
  margin-top: 0rem !important;
  margin-bottom: 0rem !important;
}
:host ::ng-deep .my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}
:host ::ng-deep .my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}
:host ::ng-deep .my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}
:host ::ng-deep .my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}
:host ::ng-deep .my-5 {
  margin-top: 2rem !important;
  margin-bottom: 2rem !important;
}
:host ::ng-deep .my-6 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}
:host ::ng-deep .my-7 {
  margin-top: 4rem !important;
  margin-bottom: 4rem !important;
}
:host ::ng-deep .my-8 {
  margin-top: 5rem !important;
  margin-bottom: 5rem !important;
}
:host ::ng-deep .-my-1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}
:host ::ng-deep .-my-2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}
:host ::ng-deep .-my-3 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}
:host ::ng-deep .-my-4 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}
:host ::ng-deep .-my-5 {
  margin-top: -2rem !important;
  margin-bottom: -2rem !important;
}
:host ::ng-deep .-my-6 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}
:host ::ng-deep .-my-7 {
  margin-top: -4rem !important;
  margin-bottom: -4rem !important;
}
:host ::ng-deep .-my-8 {
  margin-top: -5rem !important;
  margin-bottom: -5rem !important;
}
:host ::ng-deep .my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:m-0 {
    margin: 0rem !important;
  }
  :host ::ng-deep .sm\\:m-1 {
    margin: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:m-2 {
    margin: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:m-3 {
    margin: 1rem !important;
  }
  :host ::ng-deep .sm\\:m-4 {
    margin: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:m-5 {
    margin: 2rem !important;
  }
  :host ::ng-deep .sm\\:m-6 {
    margin: 3rem !important;
  }
  :host ::ng-deep .sm\\:m-7 {
    margin: 4rem !important;
  }
  :host ::ng-deep .sm\\:m-8 {
    margin: 5rem !important;
  }
  :host ::ng-deep .sm\\:-m-1 {
    margin: -0.25rem !important;
  }
  :host ::ng-deep .sm\\:-m-2 {
    margin: -0.5rem !important;
  }
  :host ::ng-deep .sm\\:-m-3 {
    margin: -1rem !important;
  }
  :host ::ng-deep .sm\\:-m-4 {
    margin: -1.5rem !important;
  }
  :host ::ng-deep .sm\\:-m-5 {
    margin: -2rem !important;
  }
  :host ::ng-deep .sm\\:-m-6 {
    margin: -3rem !important;
  }
  :host ::ng-deep .sm\\:-m-7 {
    margin: -4rem !important;
  }
  :host ::ng-deep .sm\\:-m-8 {
    margin: -5rem !important;
  }
  :host ::ng-deep .sm\\:m-auto {
    margin: auto !important;
  }
  :host ::ng-deep .sm\\:mt-0 {
    margin-top: 0rem !important;
  }
  :host ::ng-deep .sm\\:mt-1 {
    margin-top: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:mt-2 {
    margin-top: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:mt-3 {
    margin-top: 1rem !important;
  }
  :host ::ng-deep .sm\\:mt-4 {
    margin-top: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:mt-5 {
    margin-top: 2rem !important;
  }
  :host ::ng-deep .sm\\:mt-6 {
    margin-top: 3rem !important;
  }
  :host ::ng-deep .sm\\:mt-7 {
    margin-top: 4rem !important;
  }
  :host ::ng-deep .sm\\:mt-8 {
    margin-top: 5rem !important;
  }
  :host ::ng-deep .sm\\:-mt-1 {
    margin-top: -0.25rem !important;
  }
  :host ::ng-deep .sm\\:-mt-2 {
    margin-top: -0.5rem !important;
  }
  :host ::ng-deep .sm\\:-mt-3 {
    margin-top: -1rem !important;
  }
  :host ::ng-deep .sm\\:-mt-4 {
    margin-top: -1.5rem !important;
  }
  :host ::ng-deep .sm\\:-mt-5 {
    margin-top: -2rem !important;
  }
  :host ::ng-deep .sm\\:-mt-6 {
    margin-top: -3rem !important;
  }
  :host ::ng-deep .sm\\:-mt-7 {
    margin-top: -4rem !important;
  }
  :host ::ng-deep .sm\\:-mt-8 {
    margin-top: -5rem !important;
  }
  :host ::ng-deep .sm\\:mt-auto {
    margin-top: auto !important;
  }
  :host ::ng-deep .sm\\:mr-0 {
    margin-right: 0rem !important;
  }
  :host ::ng-deep .sm\\:mr-1 {
    margin-right: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:mr-2 {
    margin-right: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:mr-3 {
    margin-right: 1rem !important;
  }
  :host ::ng-deep .sm\\:mr-4 {
    margin-right: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:mr-5 {
    margin-right: 2rem !important;
  }
  :host ::ng-deep .sm\\:mr-6 {
    margin-right: 3rem !important;
  }
  :host ::ng-deep .sm\\:mr-7 {
    margin-right: 4rem !important;
  }
  :host ::ng-deep .sm\\:mr-8 {
    margin-right: 5rem !important;
  }
  :host ::ng-deep .sm\\:-mr-1 {
    margin-right: -0.25rem !important;
  }
  :host ::ng-deep .sm\\:-mr-2 {
    margin-right: -0.5rem !important;
  }
  :host ::ng-deep .sm\\:-mr-3 {
    margin-right: -1rem !important;
  }
  :host ::ng-deep .sm\\:-mr-4 {
    margin-right: -1.5rem !important;
  }
  :host ::ng-deep .sm\\:-mr-5 {
    margin-right: -2rem !important;
  }
  :host ::ng-deep .sm\\:-mr-6 {
    margin-right: -3rem !important;
  }
  :host ::ng-deep .sm\\:-mr-7 {
    margin-right: -4rem !important;
  }
  :host ::ng-deep .sm\\:-mr-8 {
    margin-right: -5rem !important;
  }
  :host ::ng-deep .sm\\:mr-auto {
    margin-right: auto !important;
  }
  :host ::ng-deep .sm\\:ml-0 {
    margin-left: 0rem !important;
  }
  :host ::ng-deep .sm\\:ml-1 {
    margin-left: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:ml-2 {
    margin-left: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:ml-3 {
    margin-left: 1rem !important;
  }
  :host ::ng-deep .sm\\:ml-4 {
    margin-left: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:ml-5 {
    margin-left: 2rem !important;
  }
  :host ::ng-deep .sm\\:ml-6 {
    margin-left: 3rem !important;
  }
  :host ::ng-deep .sm\\:ml-7 {
    margin-left: 4rem !important;
  }
  :host ::ng-deep .sm\\:ml-8 {
    margin-left: 5rem !important;
  }
  :host ::ng-deep .sm\\:-ml-1 {
    margin-left: -0.25rem !important;
  }
  :host ::ng-deep .sm\\:-ml-2 {
    margin-left: -0.5rem !important;
  }
  :host ::ng-deep .sm\\:-ml-3 {
    margin-left: -1rem !important;
  }
  :host ::ng-deep .sm\\:-ml-4 {
    margin-left: -1.5rem !important;
  }
  :host ::ng-deep .sm\\:-ml-5 {
    margin-left: -2rem !important;
  }
  :host ::ng-deep .sm\\:-ml-6 {
    margin-left: -3rem !important;
  }
  :host ::ng-deep .sm\\:-ml-7 {
    margin-left: -4rem !important;
  }
  :host ::ng-deep .sm\\:-ml-8 {
    margin-left: -5rem !important;
  }
  :host ::ng-deep .sm\\:ml-auto {
    margin-left: auto !important;
  }
  :host ::ng-deep .sm\\:mb-0 {
    margin-bottom: 0rem !important;
  }
  :host ::ng-deep .sm\\:mb-1 {
    margin-bottom: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:mb-2 {
    margin-bottom: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:mb-3 {
    margin-bottom: 1rem !important;
  }
  :host ::ng-deep .sm\\:mb-4 {
    margin-bottom: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:mb-5 {
    margin-bottom: 2rem !important;
  }
  :host ::ng-deep .sm\\:mb-6 {
    margin-bottom: 3rem !important;
  }
  :host ::ng-deep .sm\\:mb-7 {
    margin-bottom: 4rem !important;
  }
  :host ::ng-deep .sm\\:mb-8 {
    margin-bottom: 5rem !important;
  }
  :host ::ng-deep .sm\\:-mb-1 {
    margin-bottom: -0.25rem !important;
  }
  :host ::ng-deep .sm\\:-mb-2 {
    margin-bottom: -0.5rem !important;
  }
  :host ::ng-deep .sm\\:-mb-3 {
    margin-bottom: -1rem !important;
  }
  :host ::ng-deep .sm\\:-mb-4 {
    margin-bottom: -1.5rem !important;
  }
  :host ::ng-deep .sm\\:-mb-5 {
    margin-bottom: -2rem !important;
  }
  :host ::ng-deep .sm\\:-mb-6 {
    margin-bottom: -3rem !important;
  }
  :host ::ng-deep .sm\\:-mb-7 {
    margin-bottom: -4rem !important;
  }
  :host ::ng-deep .sm\\:-mb-8 {
    margin-bottom: -5rem !important;
  }
  :host ::ng-deep .sm\\:mb-auto {
    margin-bottom: auto !important;
  }
  :host ::ng-deep .sm\\:mx-0 {
    margin-left: 0rem !important;
    margin-right: 0rem !important;
  }
  :host ::ng-deep .sm\\:mx-1 {
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:mx-2 {
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:mx-3 {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }
  :host ::ng-deep .sm\\:mx-4 {
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:mx-5 {
    margin-left: 2rem !important;
    margin-right: 2rem !important;
  }
  :host ::ng-deep .sm\\:mx-6 {
    margin-left: 3rem !important;
    margin-right: 3rem !important;
  }
  :host ::ng-deep .sm\\:mx-7 {
    margin-left: 4rem !important;
    margin-right: 4rem !important;
  }
  :host ::ng-deep .sm\\:mx-8 {
    margin-left: 5rem !important;
    margin-right: 5rem !important;
  }
  :host ::ng-deep .sm\\:-mx-1 {
    margin-left: -0.25rem !important;
    margin-right: -0.25rem !important;
  }
  :host ::ng-deep .sm\\:-mx-2 {
    margin-left: -0.5rem !important;
    margin-right: -0.5rem !important;
  }
  :host ::ng-deep .sm\\:-mx-3 {
    margin-left: -1rem !important;
    margin-right: -1rem !important;
  }
  :host ::ng-deep .sm\\:-mx-4 {
    margin-left: -1.5rem !important;
    margin-right: -1.5rem !important;
  }
  :host ::ng-deep .sm\\:-mx-5 {
    margin-left: -2rem !important;
    margin-right: -2rem !important;
  }
  :host ::ng-deep .sm\\:-mx-6 {
    margin-left: -3rem !important;
    margin-right: -3rem !important;
  }
  :host ::ng-deep .sm\\:-mx-7 {
    margin-left: -4rem !important;
    margin-right: -4rem !important;
  }
  :host ::ng-deep .sm\\:-mx-8 {
    margin-left: -5rem !important;
    margin-right: -5rem !important;
  }
  :host ::ng-deep .sm\\:mx-auto {
    margin-left: auto !important;
    margin-right: auto !important;
  }
  :host ::ng-deep .sm\\:my-0 {
    margin-top: 0rem !important;
    margin-bottom: 0rem !important;
  }
  :host ::ng-deep .sm\\:my-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:my-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:my-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  :host ::ng-deep .sm\\:my-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:my-5 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  :host ::ng-deep .sm\\:my-6 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  :host ::ng-deep .sm\\:my-7 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  :host ::ng-deep .sm\\:my-8 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  :host ::ng-deep .sm\\:-my-1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  :host ::ng-deep .sm\\:-my-2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  :host ::ng-deep .sm\\:-my-3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  :host ::ng-deep .sm\\:-my-4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  :host ::ng-deep .sm\\:-my-5 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  :host ::ng-deep .sm\\:-my-6 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  :host ::ng-deep .sm\\:-my-7 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  :host ::ng-deep .sm\\:-my-8 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  :host ::ng-deep .sm\\:my-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:m-0 {
    margin: 0rem !important;
  }
  :host ::ng-deep .md\\:m-1 {
    margin: 0.25rem !important;
  }
  :host ::ng-deep .md\\:m-2 {
    margin: 0.5rem !important;
  }
  :host ::ng-deep .md\\:m-3 {
    margin: 1rem !important;
  }
  :host ::ng-deep .md\\:m-4 {
    margin: 1.5rem !important;
  }
  :host ::ng-deep .md\\:m-5 {
    margin: 2rem !important;
  }
  :host ::ng-deep .md\\:m-6 {
    margin: 3rem !important;
  }
  :host ::ng-deep .md\\:m-7 {
    margin: 4rem !important;
  }
  :host ::ng-deep .md\\:m-8 {
    margin: 5rem !important;
  }
  :host ::ng-deep .md\\:-m-1 {
    margin: -0.25rem !important;
  }
  :host ::ng-deep .md\\:-m-2 {
    margin: -0.5rem !important;
  }
  :host ::ng-deep .md\\:-m-3 {
    margin: -1rem !important;
  }
  :host ::ng-deep .md\\:-m-4 {
    margin: -1.5rem !important;
  }
  :host ::ng-deep .md\\:-m-5 {
    margin: -2rem !important;
  }
  :host ::ng-deep .md\\:-m-6 {
    margin: -3rem !important;
  }
  :host ::ng-deep .md\\:-m-7 {
    margin: -4rem !important;
  }
  :host ::ng-deep .md\\:-m-8 {
    margin: -5rem !important;
  }
  :host ::ng-deep .md\\:m-auto {
    margin: auto !important;
  }
  :host ::ng-deep .md\\:mt-0 {
    margin-top: 0rem !important;
  }
  :host ::ng-deep .md\\:mt-1 {
    margin-top: 0.25rem !important;
  }
  :host ::ng-deep .md\\:mt-2 {
    margin-top: 0.5rem !important;
  }
  :host ::ng-deep .md\\:mt-3 {
    margin-top: 1rem !important;
  }
  :host ::ng-deep .md\\:mt-4 {
    margin-top: 1.5rem !important;
  }
  :host ::ng-deep .md\\:mt-5 {
    margin-top: 2rem !important;
  }
  :host ::ng-deep .md\\:mt-6 {
    margin-top: 3rem !important;
  }
  :host ::ng-deep .md\\:mt-7 {
    margin-top: 4rem !important;
  }
  :host ::ng-deep .md\\:mt-8 {
    margin-top: 5rem !important;
  }
  :host ::ng-deep .md\\:-mt-1 {
    margin-top: -0.25rem !important;
  }
  :host ::ng-deep .md\\:-mt-2 {
    margin-top: -0.5rem !important;
  }
  :host ::ng-deep .md\\:-mt-3 {
    margin-top: -1rem !important;
  }
  :host ::ng-deep .md\\:-mt-4 {
    margin-top: -1.5rem !important;
  }
  :host ::ng-deep .md\\:-mt-5 {
    margin-top: -2rem !important;
  }
  :host ::ng-deep .md\\:-mt-6 {
    margin-top: -3rem !important;
  }
  :host ::ng-deep .md\\:-mt-7 {
    margin-top: -4rem !important;
  }
  :host ::ng-deep .md\\:-mt-8 {
    margin-top: -5rem !important;
  }
  :host ::ng-deep .md\\:mt-auto {
    margin-top: auto !important;
  }
  :host ::ng-deep .md\\:mr-0 {
    margin-right: 0rem !important;
  }
  :host ::ng-deep .md\\:mr-1 {
    margin-right: 0.25rem !important;
  }
  :host ::ng-deep .md\\:mr-2 {
    margin-right: 0.5rem !important;
  }
  :host ::ng-deep .md\\:mr-3 {
    margin-right: 1rem !important;
  }
  :host ::ng-deep .md\\:mr-4 {
    margin-right: 1.5rem !important;
  }
  :host ::ng-deep .md\\:mr-5 {
    margin-right: 2rem !important;
  }
  :host ::ng-deep .md\\:mr-6 {
    margin-right: 3rem !important;
  }
  :host ::ng-deep .md\\:mr-7 {
    margin-right: 4rem !important;
  }
  :host ::ng-deep .md\\:mr-8 {
    margin-right: 5rem !important;
  }
  :host ::ng-deep .md\\:-mr-1 {
    margin-right: -0.25rem !important;
  }
  :host ::ng-deep .md\\:-mr-2 {
    margin-right: -0.5rem !important;
  }
  :host ::ng-deep .md\\:-mr-3 {
    margin-right: -1rem !important;
  }
  :host ::ng-deep .md\\:-mr-4 {
    margin-right: -1.5rem !important;
  }
  :host ::ng-deep .md\\:-mr-5 {
    margin-right: -2rem !important;
  }
  :host ::ng-deep .md\\:-mr-6 {
    margin-right: -3rem !important;
  }
  :host ::ng-deep .md\\:-mr-7 {
    margin-right: -4rem !important;
  }
  :host ::ng-deep .md\\:-mr-8 {
    margin-right: -5rem !important;
  }
  :host ::ng-deep .md\\:mr-auto {
    margin-right: auto !important;
  }
  :host ::ng-deep .md\\:ml-0 {
    margin-left: 0rem !important;
  }
  :host ::ng-deep .md\\:ml-1 {
    margin-left: 0.25rem !important;
  }
  :host ::ng-deep .md\\:ml-2 {
    margin-left: 0.5rem !important;
  }
  :host ::ng-deep .md\\:ml-3 {
    margin-left: 1rem !important;
  }
  :host ::ng-deep .md\\:ml-4 {
    margin-left: 1.5rem !important;
  }
  :host ::ng-deep .md\\:ml-5 {
    margin-left: 2rem !important;
  }
  :host ::ng-deep .md\\:ml-6 {
    margin-left: 3rem !important;
  }
  :host ::ng-deep .md\\:ml-7 {
    margin-left: 4rem !important;
  }
  :host ::ng-deep .md\\:ml-8 {
    margin-left: 5rem !important;
  }
  :host ::ng-deep .md\\:-ml-1 {
    margin-left: -0.25rem !important;
  }
  :host ::ng-deep .md\\:-ml-2 {
    margin-left: -0.5rem !important;
  }
  :host ::ng-deep .md\\:-ml-3 {
    margin-left: -1rem !important;
  }
  :host ::ng-deep .md\\:-ml-4 {
    margin-left: -1.5rem !important;
  }
  :host ::ng-deep .md\\:-ml-5 {
    margin-left: -2rem !important;
  }
  :host ::ng-deep .md\\:-ml-6 {
    margin-left: -3rem !important;
  }
  :host ::ng-deep .md\\:-ml-7 {
    margin-left: -4rem !important;
  }
  :host ::ng-deep .md\\:-ml-8 {
    margin-left: -5rem !important;
  }
  :host ::ng-deep .md\\:ml-auto {
    margin-left: auto !important;
  }
  :host ::ng-deep .md\\:mb-0 {
    margin-bottom: 0rem !important;
  }
  :host ::ng-deep .md\\:mb-1 {
    margin-bottom: 0.25rem !important;
  }
  :host ::ng-deep .md\\:mb-2 {
    margin-bottom: 0.5rem !important;
  }
  :host ::ng-deep .md\\:mb-3 {
    margin-bottom: 1rem !important;
  }
  :host ::ng-deep .md\\:mb-4 {
    margin-bottom: 1.5rem !important;
  }
  :host ::ng-deep .md\\:mb-5 {
    margin-bottom: 2rem !important;
  }
  :host ::ng-deep .md\\:mb-6 {
    margin-bottom: 3rem !important;
  }
  :host ::ng-deep .md\\:mb-7 {
    margin-bottom: 4rem !important;
  }
  :host ::ng-deep .md\\:mb-8 {
    margin-bottom: 5rem !important;
  }
  :host ::ng-deep .md\\:-mb-1 {
    margin-bottom: -0.25rem !important;
  }
  :host ::ng-deep .md\\:-mb-2 {
    margin-bottom: -0.5rem !important;
  }
  :host ::ng-deep .md\\:-mb-3 {
    margin-bottom: -1rem !important;
  }
  :host ::ng-deep .md\\:-mb-4 {
    margin-bottom: -1.5rem !important;
  }
  :host ::ng-deep .md\\:-mb-5 {
    margin-bottom: -2rem !important;
  }
  :host ::ng-deep .md\\:-mb-6 {
    margin-bottom: -3rem !important;
  }
  :host ::ng-deep .md\\:-mb-7 {
    margin-bottom: -4rem !important;
  }
  :host ::ng-deep .md\\:-mb-8 {
    margin-bottom: -5rem !important;
  }
  :host ::ng-deep .md\\:mb-auto {
    margin-bottom: auto !important;
  }
  :host ::ng-deep .md\\:mx-0 {
    margin-left: 0rem !important;
    margin-right: 0rem !important;
  }
  :host ::ng-deep .md\\:mx-1 {
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
  }
  :host ::ng-deep .md\\:mx-2 {
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }
  :host ::ng-deep .md\\:mx-3 {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }
  :host ::ng-deep .md\\:mx-4 {
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;
  }
  :host ::ng-deep .md\\:mx-5 {
    margin-left: 2rem !important;
    margin-right: 2rem !important;
  }
  :host ::ng-deep .md\\:mx-6 {
    margin-left: 3rem !important;
    margin-right: 3rem !important;
  }
  :host ::ng-deep .md\\:mx-7 {
    margin-left: 4rem !important;
    margin-right: 4rem !important;
  }
  :host ::ng-deep .md\\:mx-8 {
    margin-left: 5rem !important;
    margin-right: 5rem !important;
  }
  :host ::ng-deep .md\\:-mx-1 {
    margin-left: -0.25rem !important;
    margin-right: -0.25rem !important;
  }
  :host ::ng-deep .md\\:-mx-2 {
    margin-left: -0.5rem !important;
    margin-right: -0.5rem !important;
  }
  :host ::ng-deep .md\\:-mx-3 {
    margin-left: -1rem !important;
    margin-right: -1rem !important;
  }
  :host ::ng-deep .md\\:-mx-4 {
    margin-left: -1.5rem !important;
    margin-right: -1.5rem !important;
  }
  :host ::ng-deep .md\\:-mx-5 {
    margin-left: -2rem !important;
    margin-right: -2rem !important;
  }
  :host ::ng-deep .md\\:-mx-6 {
    margin-left: -3rem !important;
    margin-right: -3rem !important;
  }
  :host ::ng-deep .md\\:-mx-7 {
    margin-left: -4rem !important;
    margin-right: -4rem !important;
  }
  :host ::ng-deep .md\\:-mx-8 {
    margin-left: -5rem !important;
    margin-right: -5rem !important;
  }
  :host ::ng-deep .md\\:mx-auto {
    margin-left: auto !important;
    margin-right: auto !important;
  }
  :host ::ng-deep .md\\:my-0 {
    margin-top: 0rem !important;
    margin-bottom: 0rem !important;
  }
  :host ::ng-deep .md\\:my-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  :host ::ng-deep .md\\:my-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  :host ::ng-deep .md\\:my-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  :host ::ng-deep .md\\:my-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  :host ::ng-deep .md\\:my-5 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  :host ::ng-deep .md\\:my-6 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  :host ::ng-deep .md\\:my-7 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  :host ::ng-deep .md\\:my-8 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  :host ::ng-deep .md\\:-my-1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  :host ::ng-deep .md\\:-my-2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  :host ::ng-deep .md\\:-my-3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  :host ::ng-deep .md\\:-my-4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  :host ::ng-deep .md\\:-my-5 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  :host ::ng-deep .md\\:-my-6 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  :host ::ng-deep .md\\:-my-7 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  :host ::ng-deep .md\\:-my-8 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  :host ::ng-deep .md\\:my-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:m-0 {
    margin: 0rem !important;
  }
  :host ::ng-deep .lg\\:m-1 {
    margin: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:m-2 {
    margin: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:m-3 {
    margin: 1rem !important;
  }
  :host ::ng-deep .lg\\:m-4 {
    margin: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:m-5 {
    margin: 2rem !important;
  }
  :host ::ng-deep .lg\\:m-6 {
    margin: 3rem !important;
  }
  :host ::ng-deep .lg\\:m-7 {
    margin: 4rem !important;
  }
  :host ::ng-deep .lg\\:m-8 {
    margin: 5rem !important;
  }
  :host ::ng-deep .lg\\:-m-1 {
    margin: -0.25rem !important;
  }
  :host ::ng-deep .lg\\:-m-2 {
    margin: -0.5rem !important;
  }
  :host ::ng-deep .lg\\:-m-3 {
    margin: -1rem !important;
  }
  :host ::ng-deep .lg\\:-m-4 {
    margin: -1.5rem !important;
  }
  :host ::ng-deep .lg\\:-m-5 {
    margin: -2rem !important;
  }
  :host ::ng-deep .lg\\:-m-6 {
    margin: -3rem !important;
  }
  :host ::ng-deep .lg\\:-m-7 {
    margin: -4rem !important;
  }
  :host ::ng-deep .lg\\:-m-8 {
    margin: -5rem !important;
  }
  :host ::ng-deep .lg\\:m-auto {
    margin: auto !important;
  }
  :host ::ng-deep .lg\\:mt-0 {
    margin-top: 0rem !important;
  }
  :host ::ng-deep .lg\\:mt-1 {
    margin-top: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:mt-2 {
    margin-top: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:mt-3 {
    margin-top: 1rem !important;
  }
  :host ::ng-deep .lg\\:mt-4 {
    margin-top: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:mt-5 {
    margin-top: 2rem !important;
  }
  :host ::ng-deep .lg\\:mt-6 {
    margin-top: 3rem !important;
  }
  :host ::ng-deep .lg\\:mt-7 {
    margin-top: 4rem !important;
  }
  :host ::ng-deep .lg\\:mt-8 {
    margin-top: 5rem !important;
  }
  :host ::ng-deep .lg\\:-mt-1 {
    margin-top: -0.25rem !important;
  }
  :host ::ng-deep .lg\\:-mt-2 {
    margin-top: -0.5rem !important;
  }
  :host ::ng-deep .lg\\:-mt-3 {
    margin-top: -1rem !important;
  }
  :host ::ng-deep .lg\\:-mt-4 {
    margin-top: -1.5rem !important;
  }
  :host ::ng-deep .lg\\:-mt-5 {
    margin-top: -2rem !important;
  }
  :host ::ng-deep .lg\\:-mt-6 {
    margin-top: -3rem !important;
  }
  :host ::ng-deep .lg\\:-mt-7 {
    margin-top: -4rem !important;
  }
  :host ::ng-deep .lg\\:-mt-8 {
    margin-top: -5rem !important;
  }
  :host ::ng-deep .lg\\:mt-auto {
    margin-top: auto !important;
  }
  :host ::ng-deep .lg\\:mr-0 {
    margin-right: 0rem !important;
  }
  :host ::ng-deep .lg\\:mr-1 {
    margin-right: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:mr-2 {
    margin-right: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:mr-3 {
    margin-right: 1rem !important;
  }
  :host ::ng-deep .lg\\:mr-4 {
    margin-right: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:mr-5 {
    margin-right: 2rem !important;
  }
  :host ::ng-deep .lg\\:mr-6 {
    margin-right: 3rem !important;
  }
  :host ::ng-deep .lg\\:mr-7 {
    margin-right: 4rem !important;
  }
  :host ::ng-deep .lg\\:mr-8 {
    margin-right: 5rem !important;
  }
  :host ::ng-deep .lg\\:-mr-1 {
    margin-right: -0.25rem !important;
  }
  :host ::ng-deep .lg\\:-mr-2 {
    margin-right: -0.5rem !important;
  }
  :host ::ng-deep .lg\\:-mr-3 {
    margin-right: -1rem !important;
  }
  :host ::ng-deep .lg\\:-mr-4 {
    margin-right: -1.5rem !important;
  }
  :host ::ng-deep .lg\\:-mr-5 {
    margin-right: -2rem !important;
  }
  :host ::ng-deep .lg\\:-mr-6 {
    margin-right: -3rem !important;
  }
  :host ::ng-deep .lg\\:-mr-7 {
    margin-right: -4rem !important;
  }
  :host ::ng-deep .lg\\:-mr-8 {
    margin-right: -5rem !important;
  }
  :host ::ng-deep .lg\\:mr-auto {
    margin-right: auto !important;
  }
  :host ::ng-deep .lg\\:ml-0 {
    margin-left: 0rem !important;
  }
  :host ::ng-deep .lg\\:ml-1 {
    margin-left: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:ml-2 {
    margin-left: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:ml-3 {
    margin-left: 1rem !important;
  }
  :host ::ng-deep .lg\\:ml-4 {
    margin-left: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:ml-5 {
    margin-left: 2rem !important;
  }
  :host ::ng-deep .lg\\:ml-6 {
    margin-left: 3rem !important;
  }
  :host ::ng-deep .lg\\:ml-7 {
    margin-left: 4rem !important;
  }
  :host ::ng-deep .lg\\:ml-8 {
    margin-left: 5rem !important;
  }
  :host ::ng-deep .lg\\:-ml-1 {
    margin-left: -0.25rem !important;
  }
  :host ::ng-deep .lg\\:-ml-2 {
    margin-left: -0.5rem !important;
  }
  :host ::ng-deep .lg\\:-ml-3 {
    margin-left: -1rem !important;
  }
  :host ::ng-deep .lg\\:-ml-4 {
    margin-left: -1.5rem !important;
  }
  :host ::ng-deep .lg\\:-ml-5 {
    margin-left: -2rem !important;
  }
  :host ::ng-deep .lg\\:-ml-6 {
    margin-left: -3rem !important;
  }
  :host ::ng-deep .lg\\:-ml-7 {
    margin-left: -4rem !important;
  }
  :host ::ng-deep .lg\\:-ml-8 {
    margin-left: -5rem !important;
  }
  :host ::ng-deep .lg\\:ml-auto {
    margin-left: auto !important;
  }
  :host ::ng-deep .lg\\:mb-0 {
    margin-bottom: 0rem !important;
  }
  :host ::ng-deep .lg\\:mb-1 {
    margin-bottom: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:mb-2 {
    margin-bottom: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:mb-3 {
    margin-bottom: 1rem !important;
  }
  :host ::ng-deep .lg\\:mb-4 {
    margin-bottom: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:mb-5 {
    margin-bottom: 2rem !important;
  }
  :host ::ng-deep .lg\\:mb-6 {
    margin-bottom: 3rem !important;
  }
  :host ::ng-deep .lg\\:mb-7 {
    margin-bottom: 4rem !important;
  }
  :host ::ng-deep .lg\\:mb-8 {
    margin-bottom: 5rem !important;
  }
  :host ::ng-deep .lg\\:-mb-1 {
    margin-bottom: -0.25rem !important;
  }
  :host ::ng-deep .lg\\:-mb-2 {
    margin-bottom: -0.5rem !important;
  }
  :host ::ng-deep .lg\\:-mb-3 {
    margin-bottom: -1rem !important;
  }
  :host ::ng-deep .lg\\:-mb-4 {
    margin-bottom: -1.5rem !important;
  }
  :host ::ng-deep .lg\\:-mb-5 {
    margin-bottom: -2rem !important;
  }
  :host ::ng-deep .lg\\:-mb-6 {
    margin-bottom: -3rem !important;
  }
  :host ::ng-deep .lg\\:-mb-7 {
    margin-bottom: -4rem !important;
  }
  :host ::ng-deep .lg\\:-mb-8 {
    margin-bottom: -5rem !important;
  }
  :host ::ng-deep .lg\\:mb-auto {
    margin-bottom: auto !important;
  }
  :host ::ng-deep .lg\\:mx-0 {
    margin-left: 0rem !important;
    margin-right: 0rem !important;
  }
  :host ::ng-deep .lg\\:mx-1 {
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:mx-2 {
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:mx-3 {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }
  :host ::ng-deep .lg\\:mx-4 {
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:mx-5 {
    margin-left: 2rem !important;
    margin-right: 2rem !important;
  }
  :host ::ng-deep .lg\\:mx-6 {
    margin-left: 3rem !important;
    margin-right: 3rem !important;
  }
  :host ::ng-deep .lg\\:mx-7 {
    margin-left: 4rem !important;
    margin-right: 4rem !important;
  }
  :host ::ng-deep .lg\\:mx-8 {
    margin-left: 5rem !important;
    margin-right: 5rem !important;
  }
  :host ::ng-deep .lg\\:-mx-1 {
    margin-left: -0.25rem !important;
    margin-right: -0.25rem !important;
  }
  :host ::ng-deep .lg\\:-mx-2 {
    margin-left: -0.5rem !important;
    margin-right: -0.5rem !important;
  }
  :host ::ng-deep .lg\\:-mx-3 {
    margin-left: -1rem !important;
    margin-right: -1rem !important;
  }
  :host ::ng-deep .lg\\:-mx-4 {
    margin-left: -1.5rem !important;
    margin-right: -1.5rem !important;
  }
  :host ::ng-deep .lg\\:-mx-5 {
    margin-left: -2rem !important;
    margin-right: -2rem !important;
  }
  :host ::ng-deep .lg\\:-mx-6 {
    margin-left: -3rem !important;
    margin-right: -3rem !important;
  }
  :host ::ng-deep .lg\\:-mx-7 {
    margin-left: -4rem !important;
    margin-right: -4rem !important;
  }
  :host ::ng-deep .lg\\:-mx-8 {
    margin-left: -5rem !important;
    margin-right: -5rem !important;
  }
  :host ::ng-deep .lg\\:mx-auto {
    margin-left: auto !important;
    margin-right: auto !important;
  }
  :host ::ng-deep .lg\\:my-0 {
    margin-top: 0rem !important;
    margin-bottom: 0rem !important;
  }
  :host ::ng-deep .lg\\:my-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:my-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:my-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  :host ::ng-deep .lg\\:my-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:my-5 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  :host ::ng-deep .lg\\:my-6 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  :host ::ng-deep .lg\\:my-7 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  :host ::ng-deep .lg\\:my-8 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  :host ::ng-deep .lg\\:-my-1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  :host ::ng-deep .lg\\:-my-2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  :host ::ng-deep .lg\\:-my-3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  :host ::ng-deep .lg\\:-my-4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  :host ::ng-deep .lg\\:-my-5 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  :host ::ng-deep .lg\\:-my-6 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  :host ::ng-deep .lg\\:-my-7 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  :host ::ng-deep .lg\\:-my-8 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  :host ::ng-deep .lg\\:my-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:m-0 {
    margin: 0rem !important;
  }
  :host ::ng-deep .xl\\:m-1 {
    margin: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:m-2 {
    margin: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:m-3 {
    margin: 1rem !important;
  }
  :host ::ng-deep .xl\\:m-4 {
    margin: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:m-5 {
    margin: 2rem !important;
  }
  :host ::ng-deep .xl\\:m-6 {
    margin: 3rem !important;
  }
  :host ::ng-deep .xl\\:m-7 {
    margin: 4rem !important;
  }
  :host ::ng-deep .xl\\:m-8 {
    margin: 5rem !important;
  }
  :host ::ng-deep .xl\\:-m-1 {
    margin: -0.25rem !important;
  }
  :host ::ng-deep .xl\\:-m-2 {
    margin: -0.5rem !important;
  }
  :host ::ng-deep .xl\\:-m-3 {
    margin: -1rem !important;
  }
  :host ::ng-deep .xl\\:-m-4 {
    margin: -1.5rem !important;
  }
  :host ::ng-deep .xl\\:-m-5 {
    margin: -2rem !important;
  }
  :host ::ng-deep .xl\\:-m-6 {
    margin: -3rem !important;
  }
  :host ::ng-deep .xl\\:-m-7 {
    margin: -4rem !important;
  }
  :host ::ng-deep .xl\\:-m-8 {
    margin: -5rem !important;
  }
  :host ::ng-deep .xl\\:m-auto {
    margin: auto !important;
  }
  :host ::ng-deep .xl\\:mt-0 {
    margin-top: 0rem !important;
  }
  :host ::ng-deep .xl\\:mt-1 {
    margin-top: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:mt-2 {
    margin-top: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:mt-3 {
    margin-top: 1rem !important;
  }
  :host ::ng-deep .xl\\:mt-4 {
    margin-top: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:mt-5 {
    margin-top: 2rem !important;
  }
  :host ::ng-deep .xl\\:mt-6 {
    margin-top: 3rem !important;
  }
  :host ::ng-deep .xl\\:mt-7 {
    margin-top: 4rem !important;
  }
  :host ::ng-deep .xl\\:mt-8 {
    margin-top: 5rem !important;
  }
  :host ::ng-deep .xl\\:-mt-1 {
    margin-top: -0.25rem !important;
  }
  :host ::ng-deep .xl\\:-mt-2 {
    margin-top: -0.5rem !important;
  }
  :host ::ng-deep .xl\\:-mt-3 {
    margin-top: -1rem !important;
  }
  :host ::ng-deep .xl\\:-mt-4 {
    margin-top: -1.5rem !important;
  }
  :host ::ng-deep .xl\\:-mt-5 {
    margin-top: -2rem !important;
  }
  :host ::ng-deep .xl\\:-mt-6 {
    margin-top: -3rem !important;
  }
  :host ::ng-deep .xl\\:-mt-7 {
    margin-top: -4rem !important;
  }
  :host ::ng-deep .xl\\:-mt-8 {
    margin-top: -5rem !important;
  }
  :host ::ng-deep .xl\\:mt-auto {
    margin-top: auto !important;
  }
  :host ::ng-deep .xl\\:mr-0 {
    margin-right: 0rem !important;
  }
  :host ::ng-deep .xl\\:mr-1 {
    margin-right: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:mr-2 {
    margin-right: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:mr-3 {
    margin-right: 1rem !important;
  }
  :host ::ng-deep .xl\\:mr-4 {
    margin-right: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:mr-5 {
    margin-right: 2rem !important;
  }
  :host ::ng-deep .xl\\:mr-6 {
    margin-right: 3rem !important;
  }
  :host ::ng-deep .xl\\:mr-7 {
    margin-right: 4rem !important;
  }
  :host ::ng-deep .xl\\:mr-8 {
    margin-right: 5rem !important;
  }
  :host ::ng-deep .xl\\:-mr-1 {
    margin-right: -0.25rem !important;
  }
  :host ::ng-deep .xl\\:-mr-2 {
    margin-right: -0.5rem !important;
  }
  :host ::ng-deep .xl\\:-mr-3 {
    margin-right: -1rem !important;
  }
  :host ::ng-deep .xl\\:-mr-4 {
    margin-right: -1.5rem !important;
  }
  :host ::ng-deep .xl\\:-mr-5 {
    margin-right: -2rem !important;
  }
  :host ::ng-deep .xl\\:-mr-6 {
    margin-right: -3rem !important;
  }
  :host ::ng-deep .xl\\:-mr-7 {
    margin-right: -4rem !important;
  }
  :host ::ng-deep .xl\\:-mr-8 {
    margin-right: -5rem !important;
  }
  :host ::ng-deep .xl\\:mr-auto {
    margin-right: auto !important;
  }
  :host ::ng-deep .xl\\:ml-0 {
    margin-left: 0rem !important;
  }
  :host ::ng-deep .xl\\:ml-1 {
    margin-left: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:ml-2 {
    margin-left: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:ml-3 {
    margin-left: 1rem !important;
  }
  :host ::ng-deep .xl\\:ml-4 {
    margin-left: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:ml-5 {
    margin-left: 2rem !important;
  }
  :host ::ng-deep .xl\\:ml-6 {
    margin-left: 3rem !important;
  }
  :host ::ng-deep .xl\\:ml-7 {
    margin-left: 4rem !important;
  }
  :host ::ng-deep .xl\\:ml-8 {
    margin-left: 5rem !important;
  }
  :host ::ng-deep .xl\\:-ml-1 {
    margin-left: -0.25rem !important;
  }
  :host ::ng-deep .xl\\:-ml-2 {
    margin-left: -0.5rem !important;
  }
  :host ::ng-deep .xl\\:-ml-3 {
    margin-left: -1rem !important;
  }
  :host ::ng-deep .xl\\:-ml-4 {
    margin-left: -1.5rem !important;
  }
  :host ::ng-deep .xl\\:-ml-5 {
    margin-left: -2rem !important;
  }
  :host ::ng-deep .xl\\:-ml-6 {
    margin-left: -3rem !important;
  }
  :host ::ng-deep .xl\\:-ml-7 {
    margin-left: -4rem !important;
  }
  :host ::ng-deep .xl\\:-ml-8 {
    margin-left: -5rem !important;
  }
  :host ::ng-deep .xl\\:ml-auto {
    margin-left: auto !important;
  }
  :host ::ng-deep .xl\\:mb-0 {
    margin-bottom: 0rem !important;
  }
  :host ::ng-deep .xl\\:mb-1 {
    margin-bottom: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:mb-2 {
    margin-bottom: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:mb-3 {
    margin-bottom: 1rem !important;
  }
  :host ::ng-deep .xl\\:mb-4 {
    margin-bottom: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:mb-5 {
    margin-bottom: 2rem !important;
  }
  :host ::ng-deep .xl\\:mb-6 {
    margin-bottom: 3rem !important;
  }
  :host ::ng-deep .xl\\:mb-7 {
    margin-bottom: 4rem !important;
  }
  :host ::ng-deep .xl\\:mb-8 {
    margin-bottom: 5rem !important;
  }
  :host ::ng-deep .xl\\:-mb-1 {
    margin-bottom: -0.25rem !important;
  }
  :host ::ng-deep .xl\\:-mb-2 {
    margin-bottom: -0.5rem !important;
  }
  :host ::ng-deep .xl\\:-mb-3 {
    margin-bottom: -1rem !important;
  }
  :host ::ng-deep .xl\\:-mb-4 {
    margin-bottom: -1.5rem !important;
  }
  :host ::ng-deep .xl\\:-mb-5 {
    margin-bottom: -2rem !important;
  }
  :host ::ng-deep .xl\\:-mb-6 {
    margin-bottom: -3rem !important;
  }
  :host ::ng-deep .xl\\:-mb-7 {
    margin-bottom: -4rem !important;
  }
  :host ::ng-deep .xl\\:-mb-8 {
    margin-bottom: -5rem !important;
  }
  :host ::ng-deep .xl\\:mb-auto {
    margin-bottom: auto !important;
  }
  :host ::ng-deep .xl\\:mx-0 {
    margin-left: 0rem !important;
    margin-right: 0rem !important;
  }
  :host ::ng-deep .xl\\:mx-1 {
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:mx-2 {
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:mx-3 {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }
  :host ::ng-deep .xl\\:mx-4 {
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:mx-5 {
    margin-left: 2rem !important;
    margin-right: 2rem !important;
  }
  :host ::ng-deep .xl\\:mx-6 {
    margin-left: 3rem !important;
    margin-right: 3rem !important;
  }
  :host ::ng-deep .xl\\:mx-7 {
    margin-left: 4rem !important;
    margin-right: 4rem !important;
  }
  :host ::ng-deep .xl\\:mx-8 {
    margin-left: 5rem !important;
    margin-right: 5rem !important;
  }
  :host ::ng-deep .xl\\:-mx-1 {
    margin-left: -0.25rem !important;
    margin-right: -0.25rem !important;
  }
  :host ::ng-deep .xl\\:-mx-2 {
    margin-left: -0.5rem !important;
    margin-right: -0.5rem !important;
  }
  :host ::ng-deep .xl\\:-mx-3 {
    margin-left: -1rem !important;
    margin-right: -1rem !important;
  }
  :host ::ng-deep .xl\\:-mx-4 {
    margin-left: -1.5rem !important;
    margin-right: -1.5rem !important;
  }
  :host ::ng-deep .xl\\:-mx-5 {
    margin-left: -2rem !important;
    margin-right: -2rem !important;
  }
  :host ::ng-deep .xl\\:-mx-6 {
    margin-left: -3rem !important;
    margin-right: -3rem !important;
  }
  :host ::ng-deep .xl\\:-mx-7 {
    margin-left: -4rem !important;
    margin-right: -4rem !important;
  }
  :host ::ng-deep .xl\\:-mx-8 {
    margin-left: -5rem !important;
    margin-right: -5rem !important;
  }
  :host ::ng-deep .xl\\:mx-auto {
    margin-left: auto !important;
    margin-right: auto !important;
  }
  :host ::ng-deep .xl\\:my-0 {
    margin-top: 0rem !important;
    margin-bottom: 0rem !important;
  }
  :host ::ng-deep .xl\\:my-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:my-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:my-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  :host ::ng-deep .xl\\:my-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:my-5 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  :host ::ng-deep .xl\\:my-6 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  :host ::ng-deep .xl\\:my-7 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  :host ::ng-deep .xl\\:my-8 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  :host ::ng-deep .xl\\:-my-1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  :host ::ng-deep .xl\\:-my-2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  :host ::ng-deep .xl\\:-my-3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  :host ::ng-deep .xl\\:-my-4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  :host ::ng-deep .xl\\:-my-5 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  :host ::ng-deep .xl\\:-my-6 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  :host ::ng-deep .xl\\:-my-7 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  :host ::ng-deep .xl\\:-my-8 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  :host ::ng-deep .xl\\:my-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
}
:host ::ng-deep .shadow-none {
  box-shadow: none !important;
}
:host ::ng-deep .shadow-1 {
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0196078431), 0 0 2px rgba(0, 0, 0, 0.0509803922), 0 1px 4px rgba(0, 0, 0, 0.0784313725) !important;
}
:host ::ng-deep .shadow-2 {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.031372549), 0 0 2px rgba(0, 0, 0, 0.0588235294), 0 2px 6px rgba(0, 0, 0, 0.1215686275) !important;
}
:host ::ng-deep .shadow-3 {
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.0784313725), 0 3px 4px rgba(0, 0, 0, 0.1019607843), 0 1px 4px -1px rgba(0, 0, 0, 0.1019607843) !important;
}
:host ::ng-deep .shadow-4 {
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1215686275), 0 4px 5px rgba(0, 0, 0, 0.1411764706), 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important;
}
:host ::ng-deep .shadow-5 {
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.1019607843), 0 4px 5px -2px rgba(0, 0, 0, 0.1215686275), 0 10px 15px -5px rgba(0, 0, 0, 0.2) !important;
}
:host ::ng-deep .shadow-6 {
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0588235294), 0 7px 9px rgba(0, 0, 0, 0.1215686275), 0 20px 25px -8px rgba(0, 0, 0, 0.1803921569) !important;
}
:host ::ng-deep .shadow-7 {
  box-shadow: 0 7px 30px rgba(0, 0, 0, 0.0784313725), 0 22px 30px 2px rgba(0, 0, 0, 0.1490196078), 0 8px 10px rgba(0, 0, 0, 0.1490196078) !important;
}
:host ::ng-deep .shadow-8 {
  box-shadow: 0 9px 46px 8px rgba(0, 0, 0, 0.1215686275), 0 24px 38px 3px rgba(0, 0, 0, 0.1411764706), 0 11px 15px rgba(0, 0, 0, 0.2) !important;
}
:host ::ng-deep .focus\\:shadow-none:focus {
  box-shadow: none !important;
}
:host ::ng-deep .hover\\:shadow-none:hover, :host ::ng-deep .active\\:shadow-none:active {
  box-shadow: none !important;
}
:host ::ng-deep .focus\\:shadow-1:focus {
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0196078431), 0 0 2px rgba(0, 0, 0, 0.0509803922), 0 1px 4px rgba(0, 0, 0, 0.0784313725) !important;
}
:host ::ng-deep .hover\\:shadow-1:hover, :host ::ng-deep .active\\:shadow-1:active {
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0196078431), 0 0 2px rgba(0, 0, 0, 0.0509803922), 0 1px 4px rgba(0, 0, 0, 0.0784313725) !important;
}
:host ::ng-deep .focus\\:shadow-2:focus {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.031372549), 0 0 2px rgba(0, 0, 0, 0.0588235294), 0 2px 6px rgba(0, 0, 0, 0.1215686275) !important;
}
:host ::ng-deep .hover\\:shadow-2:hover, :host ::ng-deep .active\\:shadow-2:active {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.031372549), 0 0 2px rgba(0, 0, 0, 0.0588235294), 0 2px 6px rgba(0, 0, 0, 0.1215686275) !important;
}
:host ::ng-deep .focus\\:shadow-3:focus {
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.0784313725), 0 3px 4px rgba(0, 0, 0, 0.1019607843), 0 1px 4px -1px rgba(0, 0, 0, 0.1019607843) !important;
}
:host ::ng-deep .hover\\:shadow-3:hover, :host ::ng-deep .active\\:shadow-3:active {
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.0784313725), 0 3px 4px rgba(0, 0, 0, 0.1019607843), 0 1px 4px -1px rgba(0, 0, 0, 0.1019607843) !important;
}
:host ::ng-deep .focus\\:shadow-4:focus {
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1215686275), 0 4px 5px rgba(0, 0, 0, 0.1411764706), 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important;
}
:host ::ng-deep .hover\\:shadow-4:hover, :host ::ng-deep .active\\:shadow-4:active {
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1215686275), 0 4px 5px rgba(0, 0, 0, 0.1411764706), 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important;
}
:host ::ng-deep .focus\\:shadow-5:focus {
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.1019607843), 0 4px 5px -2px rgba(0, 0, 0, 0.1215686275), 0 10px 15px -5px rgba(0, 0, 0, 0.2) !important;
}
:host ::ng-deep .hover\\:shadow-5:hover, :host ::ng-deep .active\\:shadow-5:active {
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.1019607843), 0 4px 5px -2px rgba(0, 0, 0, 0.1215686275), 0 10px 15px -5px rgba(0, 0, 0, 0.2) !important;
}
:host ::ng-deep .focus\\:shadow-6:focus {
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0588235294), 0 7px 9px rgba(0, 0, 0, 0.1215686275), 0 20px 25px -8px rgba(0, 0, 0, 0.1803921569) !important;
}
:host ::ng-deep .hover\\:shadow-6:hover, :host ::ng-deep .active\\:shadow-6:active {
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0588235294), 0 7px 9px rgba(0, 0, 0, 0.1215686275), 0 20px 25px -8px rgba(0, 0, 0, 0.1803921569) !important;
}
:host ::ng-deep .focus\\:shadow-7:focus {
  box-shadow: 0 7px 30px rgba(0, 0, 0, 0.0784313725), 0 22px 30px 2px rgba(0, 0, 0, 0.1490196078), 0 8px 10px rgba(0, 0, 0, 0.1490196078) !important;
}
:host ::ng-deep .hover\\:shadow-7:hover, :host ::ng-deep .active\\:shadow-7:active {
  box-shadow: 0 7px 30px rgba(0, 0, 0, 0.0784313725), 0 22px 30px 2px rgba(0, 0, 0, 0.1490196078), 0 8px 10px rgba(0, 0, 0, 0.1490196078) !important;
}
:host ::ng-deep .focus\\:shadow-8:focus {
  box-shadow: 0 9px 46px 8px rgba(0, 0, 0, 0.1215686275), 0 24px 38px 3px rgba(0, 0, 0, 0.1411764706), 0 11px 15px rgba(0, 0, 0, 0.2) !important;
}
:host ::ng-deep .hover\\:shadow-8:hover, :host ::ng-deep .active\\:shadow-8:active {
  box-shadow: 0 9px 46px 8px rgba(0, 0, 0, 0.1215686275), 0 24px 38px 3px rgba(0, 0, 0, 0.1411764706), 0 11px 15px rgba(0, 0, 0, 0.2) !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:shadow-none {
    box-shadow: none !important;
  }
  :host ::ng-deep .sm\\:shadow-1 {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0196078431), 0 0 2px rgba(0, 0, 0, 0.0509803922), 0 1px 4px rgba(0, 0, 0, 0.0784313725) !important;
  }
  :host ::ng-deep .sm\\:shadow-2 {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.031372549), 0 0 2px rgba(0, 0, 0, 0.0588235294), 0 2px 6px rgba(0, 0, 0, 0.1215686275) !important;
  }
  :host ::ng-deep .sm\\:shadow-3 {
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.0784313725), 0 3px 4px rgba(0, 0, 0, 0.1019607843), 0 1px 4px -1px rgba(0, 0, 0, 0.1019607843) !important;
  }
  :host ::ng-deep .sm\\:shadow-4 {
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1215686275), 0 4px 5px rgba(0, 0, 0, 0.1411764706), 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .sm\\:shadow-5 {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.1019607843), 0 4px 5px -2px rgba(0, 0, 0, 0.1215686275), 0 10px 15px -5px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .sm\\:shadow-6 {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0588235294), 0 7px 9px rgba(0, 0, 0, 0.1215686275), 0 20px 25px -8px rgba(0, 0, 0, 0.1803921569) !important;
  }
  :host ::ng-deep .sm\\:shadow-7 {
    box-shadow: 0 7px 30px rgba(0, 0, 0, 0.0784313725), 0 22px 30px 2px rgba(0, 0, 0, 0.1490196078), 0 8px 10px rgba(0, 0, 0, 0.1490196078) !important;
  }
  :host ::ng-deep .sm\\:shadow-8 {
    box-shadow: 0 9px 46px 8px rgba(0, 0, 0, 0.1215686275), 0 24px 38px 3px rgba(0, 0, 0, 0.1411764706), 0 11px 15px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .sm\\:focus\\:shadow-none:focus {
    box-shadow: none !important;
  }
  :host ::ng-deep .sm\\:hover\\:shadow-none:hover, :host ::ng-deep .sm\\:active\\:shadow-none:active {
    box-shadow: none !important;
  }
  :host ::ng-deep .sm\\:focus\\:shadow-1:focus {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0196078431), 0 0 2px rgba(0, 0, 0, 0.0509803922), 0 1px 4px rgba(0, 0, 0, 0.0784313725) !important;
  }
  :host ::ng-deep .sm\\:hover\\:shadow-1:hover, :host ::ng-deep .sm\\:active\\:shadow-1:active {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0196078431), 0 0 2px rgba(0, 0, 0, 0.0509803922), 0 1px 4px rgba(0, 0, 0, 0.0784313725) !important;
  }
  :host ::ng-deep .sm\\:focus\\:shadow-2:focus {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.031372549), 0 0 2px rgba(0, 0, 0, 0.0588235294), 0 2px 6px rgba(0, 0, 0, 0.1215686275) !important;
  }
  :host ::ng-deep .sm\\:hover\\:shadow-2:hover, :host ::ng-deep .sm\\:active\\:shadow-2:active {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.031372549), 0 0 2px rgba(0, 0, 0, 0.0588235294), 0 2px 6px rgba(0, 0, 0, 0.1215686275) !important;
  }
  :host ::ng-deep .sm\\:focus\\:shadow-3:focus {
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.0784313725), 0 3px 4px rgba(0, 0, 0, 0.1019607843), 0 1px 4px -1px rgba(0, 0, 0, 0.1019607843) !important;
  }
  :host ::ng-deep .sm\\:hover\\:shadow-3:hover, :host ::ng-deep .sm\\:active\\:shadow-3:active {
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.0784313725), 0 3px 4px rgba(0, 0, 0, 0.1019607843), 0 1px 4px -1px rgba(0, 0, 0, 0.1019607843) !important;
  }
  :host ::ng-deep .sm\\:focus\\:shadow-4:focus {
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1215686275), 0 4px 5px rgba(0, 0, 0, 0.1411764706), 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .sm\\:hover\\:shadow-4:hover, :host ::ng-deep .sm\\:active\\:shadow-4:active {
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1215686275), 0 4px 5px rgba(0, 0, 0, 0.1411764706), 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .sm\\:focus\\:shadow-5:focus {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.1019607843), 0 4px 5px -2px rgba(0, 0, 0, 0.1215686275), 0 10px 15px -5px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .sm\\:hover\\:shadow-5:hover, :host ::ng-deep .sm\\:active\\:shadow-5:active {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.1019607843), 0 4px 5px -2px rgba(0, 0, 0, 0.1215686275), 0 10px 15px -5px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .sm\\:focus\\:shadow-6:focus {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0588235294), 0 7px 9px rgba(0, 0, 0, 0.1215686275), 0 20px 25px -8px rgba(0, 0, 0, 0.1803921569) !important;
  }
  :host ::ng-deep .sm\\:hover\\:shadow-6:hover, :host ::ng-deep .sm\\:active\\:shadow-6:active {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0588235294), 0 7px 9px rgba(0, 0, 0, 0.1215686275), 0 20px 25px -8px rgba(0, 0, 0, 0.1803921569) !important;
  }
  :host ::ng-deep .sm\\:focus\\:shadow-7:focus {
    box-shadow: 0 7px 30px rgba(0, 0, 0, 0.0784313725), 0 22px 30px 2px rgba(0, 0, 0, 0.1490196078), 0 8px 10px rgba(0, 0, 0, 0.1490196078) !important;
  }
  :host ::ng-deep .sm\\:hover\\:shadow-7:hover, :host ::ng-deep .sm\\:active\\:shadow-7:active {
    box-shadow: 0 7px 30px rgba(0, 0, 0, 0.0784313725), 0 22px 30px 2px rgba(0, 0, 0, 0.1490196078), 0 8px 10px rgba(0, 0, 0, 0.1490196078) !important;
  }
  :host ::ng-deep .sm\\:focus\\:shadow-8:focus {
    box-shadow: 0 9px 46px 8px rgba(0, 0, 0, 0.1215686275), 0 24px 38px 3px rgba(0, 0, 0, 0.1411764706), 0 11px 15px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .sm\\:hover\\:shadow-8:hover, :host ::ng-deep .sm\\:active\\:shadow-8:active {
    box-shadow: 0 9px 46px 8px rgba(0, 0, 0, 0.1215686275), 0 24px 38px 3px rgba(0, 0, 0, 0.1411764706), 0 11px 15px rgba(0, 0, 0, 0.2) !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:shadow-none {
    box-shadow: none !important;
  }
  :host ::ng-deep .md\\:shadow-1 {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0196078431), 0 0 2px rgba(0, 0, 0, 0.0509803922), 0 1px 4px rgba(0, 0, 0, 0.0784313725) !important;
  }
  :host ::ng-deep .md\\:shadow-2 {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.031372549), 0 0 2px rgba(0, 0, 0, 0.0588235294), 0 2px 6px rgba(0, 0, 0, 0.1215686275) !important;
  }
  :host ::ng-deep .md\\:shadow-3 {
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.0784313725), 0 3px 4px rgba(0, 0, 0, 0.1019607843), 0 1px 4px -1px rgba(0, 0, 0, 0.1019607843) !important;
  }
  :host ::ng-deep .md\\:shadow-4 {
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1215686275), 0 4px 5px rgba(0, 0, 0, 0.1411764706), 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .md\\:shadow-5 {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.1019607843), 0 4px 5px -2px rgba(0, 0, 0, 0.1215686275), 0 10px 15px -5px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .md\\:shadow-6 {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0588235294), 0 7px 9px rgba(0, 0, 0, 0.1215686275), 0 20px 25px -8px rgba(0, 0, 0, 0.1803921569) !important;
  }
  :host ::ng-deep .md\\:shadow-7 {
    box-shadow: 0 7px 30px rgba(0, 0, 0, 0.0784313725), 0 22px 30px 2px rgba(0, 0, 0, 0.1490196078), 0 8px 10px rgba(0, 0, 0, 0.1490196078) !important;
  }
  :host ::ng-deep .md\\:shadow-8 {
    box-shadow: 0 9px 46px 8px rgba(0, 0, 0, 0.1215686275), 0 24px 38px 3px rgba(0, 0, 0, 0.1411764706), 0 11px 15px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .md\\:focus\\:shadow-none:focus {
    box-shadow: none !important;
  }
  :host ::ng-deep .md\\:hover\\:shadow-none:hover, :host ::ng-deep .md\\:active\\:shadow-none:active {
    box-shadow: none !important;
  }
  :host ::ng-deep .md\\:focus\\:shadow-1:focus {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0196078431), 0 0 2px rgba(0, 0, 0, 0.0509803922), 0 1px 4px rgba(0, 0, 0, 0.0784313725) !important;
  }
  :host ::ng-deep .md\\:hover\\:shadow-1:hover, :host ::ng-deep .md\\:active\\:shadow-1:active {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0196078431), 0 0 2px rgba(0, 0, 0, 0.0509803922), 0 1px 4px rgba(0, 0, 0, 0.0784313725) !important;
  }
  :host ::ng-deep .md\\:focus\\:shadow-2:focus {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.031372549), 0 0 2px rgba(0, 0, 0, 0.0588235294), 0 2px 6px rgba(0, 0, 0, 0.1215686275) !important;
  }
  :host ::ng-deep .md\\:hover\\:shadow-2:hover, :host ::ng-deep .md\\:active\\:shadow-2:active {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.031372549), 0 0 2px rgba(0, 0, 0, 0.0588235294), 0 2px 6px rgba(0, 0, 0, 0.1215686275) !important;
  }
  :host ::ng-deep .md\\:focus\\:shadow-3:focus {
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.0784313725), 0 3px 4px rgba(0, 0, 0, 0.1019607843), 0 1px 4px -1px rgba(0, 0, 0, 0.1019607843) !important;
  }
  :host ::ng-deep .md\\:hover\\:shadow-3:hover, :host ::ng-deep .md\\:active\\:shadow-3:active {
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.0784313725), 0 3px 4px rgba(0, 0, 0, 0.1019607843), 0 1px 4px -1px rgba(0, 0, 0, 0.1019607843) !important;
  }
  :host ::ng-deep .md\\:focus\\:shadow-4:focus {
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1215686275), 0 4px 5px rgba(0, 0, 0, 0.1411764706), 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .md\\:hover\\:shadow-4:hover, :host ::ng-deep .md\\:active\\:shadow-4:active {
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1215686275), 0 4px 5px rgba(0, 0, 0, 0.1411764706), 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .md\\:focus\\:shadow-5:focus {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.1019607843), 0 4px 5px -2px rgba(0, 0, 0, 0.1215686275), 0 10px 15px -5px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .md\\:hover\\:shadow-5:hover, :host ::ng-deep .md\\:active\\:shadow-5:active {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.1019607843), 0 4px 5px -2px rgba(0, 0, 0, 0.1215686275), 0 10px 15px -5px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .md\\:focus\\:shadow-6:focus {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0588235294), 0 7px 9px rgba(0, 0, 0, 0.1215686275), 0 20px 25px -8px rgba(0, 0, 0, 0.1803921569) !important;
  }
  :host ::ng-deep .md\\:hover\\:shadow-6:hover, :host ::ng-deep .md\\:active\\:shadow-6:active {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0588235294), 0 7px 9px rgba(0, 0, 0, 0.1215686275), 0 20px 25px -8px rgba(0, 0, 0, 0.1803921569) !important;
  }
  :host ::ng-deep .md\\:focus\\:shadow-7:focus {
    box-shadow: 0 7px 30px rgba(0, 0, 0, 0.0784313725), 0 22px 30px 2px rgba(0, 0, 0, 0.1490196078), 0 8px 10px rgba(0, 0, 0, 0.1490196078) !important;
  }
  :host ::ng-deep .md\\:hover\\:shadow-7:hover, :host ::ng-deep .md\\:active\\:shadow-7:active {
    box-shadow: 0 7px 30px rgba(0, 0, 0, 0.0784313725), 0 22px 30px 2px rgba(0, 0, 0, 0.1490196078), 0 8px 10px rgba(0, 0, 0, 0.1490196078) !important;
  }
  :host ::ng-deep .md\\:focus\\:shadow-8:focus {
    box-shadow: 0 9px 46px 8px rgba(0, 0, 0, 0.1215686275), 0 24px 38px 3px rgba(0, 0, 0, 0.1411764706), 0 11px 15px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .md\\:hover\\:shadow-8:hover, :host ::ng-deep .md\\:active\\:shadow-8:active {
    box-shadow: 0 9px 46px 8px rgba(0, 0, 0, 0.1215686275), 0 24px 38px 3px rgba(0, 0, 0, 0.1411764706), 0 11px 15px rgba(0, 0, 0, 0.2) !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:shadow-none {
    box-shadow: none !important;
  }
  :host ::ng-deep .lg\\:shadow-1 {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0196078431), 0 0 2px rgba(0, 0, 0, 0.0509803922), 0 1px 4px rgba(0, 0, 0, 0.0784313725) !important;
  }
  :host ::ng-deep .lg\\:shadow-2 {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.031372549), 0 0 2px rgba(0, 0, 0, 0.0588235294), 0 2px 6px rgba(0, 0, 0, 0.1215686275) !important;
  }
  :host ::ng-deep .lg\\:shadow-3 {
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.0784313725), 0 3px 4px rgba(0, 0, 0, 0.1019607843), 0 1px 4px -1px rgba(0, 0, 0, 0.1019607843) !important;
  }
  :host ::ng-deep .lg\\:shadow-4 {
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1215686275), 0 4px 5px rgba(0, 0, 0, 0.1411764706), 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .lg\\:shadow-5 {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.1019607843), 0 4px 5px -2px rgba(0, 0, 0, 0.1215686275), 0 10px 15px -5px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .lg\\:shadow-6 {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0588235294), 0 7px 9px rgba(0, 0, 0, 0.1215686275), 0 20px 25px -8px rgba(0, 0, 0, 0.1803921569) !important;
  }
  :host ::ng-deep .lg\\:shadow-7 {
    box-shadow: 0 7px 30px rgba(0, 0, 0, 0.0784313725), 0 22px 30px 2px rgba(0, 0, 0, 0.1490196078), 0 8px 10px rgba(0, 0, 0, 0.1490196078) !important;
  }
  :host ::ng-deep .lg\\:shadow-8 {
    box-shadow: 0 9px 46px 8px rgba(0, 0, 0, 0.1215686275), 0 24px 38px 3px rgba(0, 0, 0, 0.1411764706), 0 11px 15px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .lg\\:focus\\:shadow-none:focus {
    box-shadow: none !important;
  }
  :host ::ng-deep .lg\\:hover\\:shadow-none:hover, :host ::ng-deep .lg\\:active\\:shadow-none:active {
    box-shadow: none !important;
  }
  :host ::ng-deep .lg\\:focus\\:shadow-1:focus {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0196078431), 0 0 2px rgba(0, 0, 0, 0.0509803922), 0 1px 4px rgba(0, 0, 0, 0.0784313725) !important;
  }
  :host ::ng-deep .lg\\:hover\\:shadow-1:hover, :host ::ng-deep .lg\\:active\\:shadow-1:active {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0196078431), 0 0 2px rgba(0, 0, 0, 0.0509803922), 0 1px 4px rgba(0, 0, 0, 0.0784313725) !important;
  }
  :host ::ng-deep .lg\\:focus\\:shadow-2:focus {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.031372549), 0 0 2px rgba(0, 0, 0, 0.0588235294), 0 2px 6px rgba(0, 0, 0, 0.1215686275) !important;
  }
  :host ::ng-deep .lg\\:hover\\:shadow-2:hover, :host ::ng-deep .lg\\:active\\:shadow-2:active {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.031372549), 0 0 2px rgba(0, 0, 0, 0.0588235294), 0 2px 6px rgba(0, 0, 0, 0.1215686275) !important;
  }
  :host ::ng-deep .lg\\:focus\\:shadow-3:focus {
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.0784313725), 0 3px 4px rgba(0, 0, 0, 0.1019607843), 0 1px 4px -1px rgba(0, 0, 0, 0.1019607843) !important;
  }
  :host ::ng-deep .lg\\:hover\\:shadow-3:hover, :host ::ng-deep .lg\\:active\\:shadow-3:active {
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.0784313725), 0 3px 4px rgba(0, 0, 0, 0.1019607843), 0 1px 4px -1px rgba(0, 0, 0, 0.1019607843) !important;
  }
  :host ::ng-deep .lg\\:focus\\:shadow-4:focus {
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1215686275), 0 4px 5px rgba(0, 0, 0, 0.1411764706), 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .lg\\:hover\\:shadow-4:hover, :host ::ng-deep .lg\\:active\\:shadow-4:active {
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1215686275), 0 4px 5px rgba(0, 0, 0, 0.1411764706), 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .lg\\:focus\\:shadow-5:focus {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.1019607843), 0 4px 5px -2px rgba(0, 0, 0, 0.1215686275), 0 10px 15px -5px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .lg\\:hover\\:shadow-5:hover, :host ::ng-deep .lg\\:active\\:shadow-5:active {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.1019607843), 0 4px 5px -2px rgba(0, 0, 0, 0.1215686275), 0 10px 15px -5px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .lg\\:focus\\:shadow-6:focus {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0588235294), 0 7px 9px rgba(0, 0, 0, 0.1215686275), 0 20px 25px -8px rgba(0, 0, 0, 0.1803921569) !important;
  }
  :host ::ng-deep .lg\\:hover\\:shadow-6:hover, :host ::ng-deep .lg\\:active\\:shadow-6:active {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0588235294), 0 7px 9px rgba(0, 0, 0, 0.1215686275), 0 20px 25px -8px rgba(0, 0, 0, 0.1803921569) !important;
  }
  :host ::ng-deep .lg\\:focus\\:shadow-7:focus {
    box-shadow: 0 7px 30px rgba(0, 0, 0, 0.0784313725), 0 22px 30px 2px rgba(0, 0, 0, 0.1490196078), 0 8px 10px rgba(0, 0, 0, 0.1490196078) !important;
  }
  :host ::ng-deep .lg\\:hover\\:shadow-7:hover, :host ::ng-deep .lg\\:active\\:shadow-7:active {
    box-shadow: 0 7px 30px rgba(0, 0, 0, 0.0784313725), 0 22px 30px 2px rgba(0, 0, 0, 0.1490196078), 0 8px 10px rgba(0, 0, 0, 0.1490196078) !important;
  }
  :host ::ng-deep .lg\\:focus\\:shadow-8:focus {
    box-shadow: 0 9px 46px 8px rgba(0, 0, 0, 0.1215686275), 0 24px 38px 3px rgba(0, 0, 0, 0.1411764706), 0 11px 15px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .lg\\:hover\\:shadow-8:hover, :host ::ng-deep .lg\\:active\\:shadow-8:active {
    box-shadow: 0 9px 46px 8px rgba(0, 0, 0, 0.1215686275), 0 24px 38px 3px rgba(0, 0, 0, 0.1411764706), 0 11px 15px rgba(0, 0, 0, 0.2) !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:shadow-none {
    box-shadow: none !important;
  }
  :host ::ng-deep .xl\\:shadow-1 {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0196078431), 0 0 2px rgba(0, 0, 0, 0.0509803922), 0 1px 4px rgba(0, 0, 0, 0.0784313725) !important;
  }
  :host ::ng-deep .xl\\:shadow-2 {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.031372549), 0 0 2px rgba(0, 0, 0, 0.0588235294), 0 2px 6px rgba(0, 0, 0, 0.1215686275) !important;
  }
  :host ::ng-deep .xl\\:shadow-3 {
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.0784313725), 0 3px 4px rgba(0, 0, 0, 0.1019607843), 0 1px 4px -1px rgba(0, 0, 0, 0.1019607843) !important;
  }
  :host ::ng-deep .xl\\:shadow-4 {
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1215686275), 0 4px 5px rgba(0, 0, 0, 0.1411764706), 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .xl\\:shadow-5 {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.1019607843), 0 4px 5px -2px rgba(0, 0, 0, 0.1215686275), 0 10px 15px -5px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .xl\\:shadow-6 {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0588235294), 0 7px 9px rgba(0, 0, 0, 0.1215686275), 0 20px 25px -8px rgba(0, 0, 0, 0.1803921569) !important;
  }
  :host ::ng-deep .xl\\:shadow-7 {
    box-shadow: 0 7px 30px rgba(0, 0, 0, 0.0784313725), 0 22px 30px 2px rgba(0, 0, 0, 0.1490196078), 0 8px 10px rgba(0, 0, 0, 0.1490196078) !important;
  }
  :host ::ng-deep .xl\\:shadow-8 {
    box-shadow: 0 9px 46px 8px rgba(0, 0, 0, 0.1215686275), 0 24px 38px 3px rgba(0, 0, 0, 0.1411764706), 0 11px 15px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .xl\\:focus\\:shadow-none:focus {
    box-shadow: none !important;
  }
  :host ::ng-deep .xl\\:hover\\:shadow-none:hover, :host ::ng-deep .xl\\:active\\:shadow-none:active {
    box-shadow: none !important;
  }
  :host ::ng-deep .xl\\:focus\\:shadow-1:focus {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0196078431), 0 0 2px rgba(0, 0, 0, 0.0509803922), 0 1px 4px rgba(0, 0, 0, 0.0784313725) !important;
  }
  :host ::ng-deep .xl\\:hover\\:shadow-1:hover, :host ::ng-deep .xl\\:active\\:shadow-1:active {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0196078431), 0 0 2px rgba(0, 0, 0, 0.0509803922), 0 1px 4px rgba(0, 0, 0, 0.0784313725) !important;
  }
  :host ::ng-deep .xl\\:focus\\:shadow-2:focus {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.031372549), 0 0 2px rgba(0, 0, 0, 0.0588235294), 0 2px 6px rgba(0, 0, 0, 0.1215686275) !important;
  }
  :host ::ng-deep .xl\\:hover\\:shadow-2:hover, :host ::ng-deep .xl\\:active\\:shadow-2:active {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.031372549), 0 0 2px rgba(0, 0, 0, 0.0588235294), 0 2px 6px rgba(0, 0, 0, 0.1215686275) !important;
  }
  :host ::ng-deep .xl\\:focus\\:shadow-3:focus {
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.0784313725), 0 3px 4px rgba(0, 0, 0, 0.1019607843), 0 1px 4px -1px rgba(0, 0, 0, 0.1019607843) !important;
  }
  :host ::ng-deep .xl\\:hover\\:shadow-3:hover, :host ::ng-deep .xl\\:active\\:shadow-3:active {
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.0784313725), 0 3px 4px rgba(0, 0, 0, 0.1019607843), 0 1px 4px -1px rgba(0, 0, 0, 0.1019607843) !important;
  }
  :host ::ng-deep .xl\\:focus\\:shadow-4:focus {
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1215686275), 0 4px 5px rgba(0, 0, 0, 0.1411764706), 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .xl\\:hover\\:shadow-4:hover, :host ::ng-deep .xl\\:active\\:shadow-4:active {
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1215686275), 0 4px 5px rgba(0, 0, 0, 0.1411764706), 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .xl\\:focus\\:shadow-5:focus {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.1019607843), 0 4px 5px -2px rgba(0, 0, 0, 0.1215686275), 0 10px 15px -5px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .xl\\:hover\\:shadow-5:hover, :host ::ng-deep .xl\\:active\\:shadow-5:active {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.1019607843), 0 4px 5px -2px rgba(0, 0, 0, 0.1215686275), 0 10px 15px -5px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .xl\\:focus\\:shadow-6:focus {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0588235294), 0 7px 9px rgba(0, 0, 0, 0.1215686275), 0 20px 25px -8px rgba(0, 0, 0, 0.1803921569) !important;
  }
  :host ::ng-deep .xl\\:hover\\:shadow-6:hover, :host ::ng-deep .xl\\:active\\:shadow-6:active {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0588235294), 0 7px 9px rgba(0, 0, 0, 0.1215686275), 0 20px 25px -8px rgba(0, 0, 0, 0.1803921569) !important;
  }
  :host ::ng-deep .xl\\:focus\\:shadow-7:focus {
    box-shadow: 0 7px 30px rgba(0, 0, 0, 0.0784313725), 0 22px 30px 2px rgba(0, 0, 0, 0.1490196078), 0 8px 10px rgba(0, 0, 0, 0.1490196078) !important;
  }
  :host ::ng-deep .xl\\:hover\\:shadow-7:hover, :host ::ng-deep .xl\\:active\\:shadow-7:active {
    box-shadow: 0 7px 30px rgba(0, 0, 0, 0.0784313725), 0 22px 30px 2px rgba(0, 0, 0, 0.1490196078), 0 8px 10px rgba(0, 0, 0, 0.1490196078) !important;
  }
  :host ::ng-deep .xl\\:focus\\:shadow-8:focus {
    box-shadow: 0 9px 46px 8px rgba(0, 0, 0, 0.1215686275), 0 24px 38px 3px rgba(0, 0, 0, 0.1411764706), 0 11px 15px rgba(0, 0, 0, 0.2) !important;
  }
  :host ::ng-deep .xl\\:hover\\:shadow-8:hover, :host ::ng-deep .xl\\:active\\:shadow-8:active {
    box-shadow: 0 9px 46px 8px rgba(0, 0, 0, 0.1215686275), 0 24px 38px 3px rgba(0, 0, 0, 0.1411764706), 0 11px 15px rgba(0, 0, 0, 0.2) !important;
  }
}
:host ::ng-deep .border-none {
  border-width: 0 !important;
  border-style: none;
}
:host ::ng-deep .border-1 {
  border-width: 1px !important;
  border-style: solid;
}
:host ::ng-deep .border-2 {
  border-width: 2px !important;
  border-style: solid;
}
:host ::ng-deep .border-3 {
  border-width: 3px !important;
  border-style: solid;
}
:host ::ng-deep .border-top-none {
  border-top-width: 0 !important;
  border-top-style: none;
}
:host ::ng-deep .border-top-1 {
  border-top-width: 1px !important;
  border-top-style: solid;
}
:host ::ng-deep .border-top-2 {
  border-top-width: 2px !important;
  border-top-style: solid;
}
:host ::ng-deep .border-top-3 {
  border-top-width: 3px !important;
  border-top-style: solid;
}
:host ::ng-deep .border-right-none {
  border-right-width: 0 !important;
  border-right-style: none;
}
:host ::ng-deep .border-right-1 {
  border-right-width: 1px !important;
  border-right-style: solid;
}
:host ::ng-deep .border-right-2 {
  border-right-width: 2px !important;
  border-right-style: solid;
}
:host ::ng-deep .border-right-3 {
  border-right-width: 3px !important;
  border-right-style: solid;
}
:host ::ng-deep .border-left-none {
  border-left-width: 0 !important;
  border-left-style: none;
}
:host ::ng-deep .border-left-1 {
  border-left-width: 1px !important;
  border-left-style: solid;
}
:host ::ng-deep .border-left-2 {
  border-left-width: 2px !important;
  border-left-style: solid;
}
:host ::ng-deep .border-left-3 {
  border-left-width: 3px !important;
  border-left-style: solid;
}
:host ::ng-deep .border-bottom-none {
  border-bottom-width: 0 !important;
  border-bottom-style: none;
}
:host ::ng-deep .border-bottom-1 {
  border-bottom-width: 1px !important;
  border-bottom-style: solid;
}
:host ::ng-deep .border-bottom-2 {
  border-bottom-width: 2px !important;
  border-bottom-style: solid;
}
:host ::ng-deep .border-bottom-3 {
  border-bottom-width: 3px !important;
  border-bottom-style: solid;
}
:host ::ng-deep .border-x-none {
  border-left-width: 0 !important;
  border-left-style: none;
  border-right-width: 0 !important;
  border-right-style: none;
}
:host ::ng-deep .border-x-1 {
  border-left-width: 1px !important;
  border-left-style: solid;
  border-right-width: 1px !important;
  border-right-style: solid;
}
:host ::ng-deep .border-x-2 {
  border-left-width: 2px !important;
  border-left-style: solid;
  border-right-width: 2px !important;
  border-right-style: solid;
}
:host ::ng-deep .border-x-3 {
  border-left-width: 3px !important;
  border-left-style: solid;
  border-right-width: 3px !important;
  border-right-style: solid;
}
:host ::ng-deep .border-y-none {
  border-top-width: 0 !important;
  border-top-style: none;
  border-bottom-width: 0 !important;
  border-bottom-style: none;
}
:host ::ng-deep .border-y-1 {
  border-top-width: 1px !important;
  border-top-style: solid;
  border-bottom-width: 1px !important;
  border-bottom-style: solid;
}
:host ::ng-deep .border-y-2 {
  border-top-width: 2px !important;
  border-top-style: solid;
  border-bottom-width: 2px !important;
  border-bottom-style: solid;
}
:host ::ng-deep .border-y-3 {
  border-top-width: 3px !important;
  border-top-style: solid;
  border-bottom-width: 3px !important;
  border-bottom-style: solid;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:border-none {
    border-width: 0 !important;
    border-style: none;
  }
  :host ::ng-deep .sm\\:border-1 {
    border-width: 1px !important;
    border-style: solid;
  }
  :host ::ng-deep .sm\\:border-2 {
    border-width: 2px !important;
    border-style: solid;
  }
  :host ::ng-deep .sm\\:border-3 {
    border-width: 3px !important;
    border-style: solid;
  }
  :host ::ng-deep .sm\\:border-top-none {
    border-top-width: 0 !important;
    border-top-style: none;
  }
  :host ::ng-deep .sm\\:border-top-1 {
    border-top-width: 1px !important;
    border-top-style: solid;
  }
  :host ::ng-deep .sm\\:border-top-2 {
    border-top-width: 2px !important;
    border-top-style: solid;
  }
  :host ::ng-deep .sm\\:border-top-3 {
    border-top-width: 3px !important;
    border-top-style: solid;
  }
  :host ::ng-deep .sm\\:border-right-none {
    border-right-width: 0 !important;
    border-right-style: none;
  }
  :host ::ng-deep .sm\\:border-right-1 {
    border-right-width: 1px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .sm\\:border-right-2 {
    border-right-width: 2px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .sm\\:border-right-3 {
    border-right-width: 3px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .sm\\:border-left-none {
    border-left-width: 0 !important;
    border-left-style: none;
  }
  :host ::ng-deep .sm\\:border-left-1 {
    border-left-width: 1px !important;
    border-left-style: solid;
  }
  :host ::ng-deep .sm\\:border-left-2 {
    border-left-width: 2px !important;
    border-left-style: solid;
  }
  :host ::ng-deep .sm\\:border-left-3 {
    border-left-width: 3px !important;
    border-left-style: solid;
  }
  :host ::ng-deep .sm\\:border-bottom-none {
    border-bottom-width: 0 !important;
    border-bottom-style: none;
  }
  :host ::ng-deep .sm\\:border-bottom-1 {
    border-bottom-width: 1px !important;
    border-bottom-style: solid;
  }
  :host ::ng-deep .sm\\:border-bottom-2 {
    border-bottom-width: 2px !important;
    border-bottom-style: solid;
  }
  :host ::ng-deep .sm\\:border-bottom-3 {
    border-bottom-width: 3px !important;
    border-bottom-style: solid;
  }
  :host ::ng-deep .sm\\:border-x-none {
    border-left-width: 0 !important;
    border-left-style: none;
    border-right-width: 0 !important;
    border-right-style: none;
  }
  :host ::ng-deep .sm\\:border-x-1 {
    border-left-width: 1px !important;
    border-left-style: solid;
    border-right-width: 1px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .sm\\:border-x-2 {
    border-left-width: 2px !important;
    border-left-style: solid;
    border-right-width: 2px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .sm\\:border-x-3 {
    border-left-width: 3px !important;
    border-left-style: solid;
    border-right-width: 3px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .sm\\:border-y-none {
    border-top-width: 0 !important;
    border-top-style: none;
    border-bottom-width: 0 !important;
    border-bottom-style: none;
  }
  :host ::ng-deep .sm\\:border-y-1 {
    border-top-width: 1px !important;
    border-top-style: solid;
    border-bottom-width: 1px !important;
    border-bottom-style: solid;
  }
  :host ::ng-deep .sm\\:border-y-2 {
    border-top-width: 2px !important;
    border-top-style: solid;
    border-bottom-width: 2px !important;
    border-bottom-style: solid;
  }
  :host ::ng-deep .sm\\:border-y-3 {
    border-top-width: 3px !important;
    border-top-style: solid;
    border-bottom-width: 3px !important;
    border-bottom-style: solid;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:border-none {
    border-width: 0 !important;
    border-style: none;
  }
  :host ::ng-deep .md\\:border-1 {
    border-width: 1px !important;
    border-style: solid;
  }
  :host ::ng-deep .md\\:border-2 {
    border-width: 2px !important;
    border-style: solid;
  }
  :host ::ng-deep .md\\:border-3 {
    border-width: 3px !important;
    border-style: solid;
  }
  :host ::ng-deep .md\\:border-top-none {
    border-top-width: 0 !important;
    border-top-style: none;
  }
  :host ::ng-deep .md\\:border-top-1 {
    border-top-width: 1px !important;
    border-top-style: solid;
  }
  :host ::ng-deep .md\\:border-top-2 {
    border-top-width: 2px !important;
    border-top-style: solid;
  }
  :host ::ng-deep .md\\:border-top-3 {
    border-top-width: 3px !important;
    border-top-style: solid;
  }
  :host ::ng-deep .md\\:border-right-none {
    border-right-width: 0 !important;
    border-right-style: none;
  }
  :host ::ng-deep .md\\:border-right-1 {
    border-right-width: 1px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .md\\:border-right-2 {
    border-right-width: 2px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .md\\:border-right-3 {
    border-right-width: 3px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .md\\:border-left-none {
    border-left-width: 0 !important;
    border-left-style: none;
  }
  :host ::ng-deep .md\\:border-left-1 {
    border-left-width: 1px !important;
    border-left-style: solid;
  }
  :host ::ng-deep .md\\:border-left-2 {
    border-left-width: 2px !important;
    border-left-style: solid;
  }
  :host ::ng-deep .md\\:border-left-3 {
    border-left-width: 3px !important;
    border-left-style: solid;
  }
  :host ::ng-deep .md\\:border-bottom-none {
    border-bottom-width: 0 !important;
    border-bottom-style: none;
  }
  :host ::ng-deep .md\\:border-bottom-1 {
    border-bottom-width: 1px !important;
    border-bottom-style: solid;
  }
  :host ::ng-deep .md\\:border-bottom-2 {
    border-bottom-width: 2px !important;
    border-bottom-style: solid;
  }
  :host ::ng-deep .md\\:border-bottom-3 {
    border-bottom-width: 3px !important;
    border-bottom-style: solid;
  }
  :host ::ng-deep .md\\:border-x-none {
    border-left-width: 0 !important;
    border-left-style: none;
    border-right-width: 0 !important;
    border-right-style: none;
  }
  :host ::ng-deep .md\\:border-x-1 {
    border-left-width: 1px !important;
    border-left-style: solid;
    border-right-width: 1px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .md\\:border-x-2 {
    border-left-width: 2px !important;
    border-left-style: solid;
    border-right-width: 2px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .md\\:border-x-3 {
    border-left-width: 3px !important;
    border-left-style: solid;
    border-right-width: 3px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .md\\:border-y-none {
    border-top-width: 0 !important;
    border-top-style: none;
    border-bottom-width: 0 !important;
    border-bottom-style: none;
  }
  :host ::ng-deep .md\\:border-y-1 {
    border-top-width: 1px !important;
    border-top-style: solid;
    border-bottom-width: 1px !important;
    border-bottom-style: solid;
  }
  :host ::ng-deep .md\\:border-y-2 {
    border-top-width: 2px !important;
    border-top-style: solid;
    border-bottom-width: 2px !important;
    border-bottom-style: solid;
  }
  :host ::ng-deep .md\\:border-y-3 {
    border-top-width: 3px !important;
    border-top-style: solid;
    border-bottom-width: 3px !important;
    border-bottom-style: solid;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:border-none {
    border-width: 0 !important;
    border-style: none;
  }
  :host ::ng-deep .lg\\:border-1 {
    border-width: 1px !important;
    border-style: solid;
  }
  :host ::ng-deep .lg\\:border-2 {
    border-width: 2px !important;
    border-style: solid;
  }
  :host ::ng-deep .lg\\:border-3 {
    border-width: 3px !important;
    border-style: solid;
  }
  :host ::ng-deep .lg\\:border-top-none {
    border-top-width: 0 !important;
    border-top-style: none;
  }
  :host ::ng-deep .lg\\:border-top-1 {
    border-top-width: 1px !important;
    border-top-style: solid;
  }
  :host ::ng-deep .lg\\:border-top-2 {
    border-top-width: 2px !important;
    border-top-style: solid;
  }
  :host ::ng-deep .lg\\:border-top-3 {
    border-top-width: 3px !important;
    border-top-style: solid;
  }
  :host ::ng-deep .lg\\:border-right-none {
    border-right-width: 0 !important;
    border-right-style: none;
  }
  :host ::ng-deep .lg\\:border-right-1 {
    border-right-width: 1px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .lg\\:border-right-2 {
    border-right-width: 2px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .lg\\:border-right-3 {
    border-right-width: 3px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .lg\\:border-left-none {
    border-left-width: 0 !important;
    border-left-style: none;
  }
  :host ::ng-deep .lg\\:border-left-1 {
    border-left-width: 1px !important;
    border-left-style: solid;
  }
  :host ::ng-deep .lg\\:border-left-2 {
    border-left-width: 2px !important;
    border-left-style: solid;
  }
  :host ::ng-deep .lg\\:border-left-3 {
    border-left-width: 3px !important;
    border-left-style: solid;
  }
  :host ::ng-deep .lg\\:border-bottom-none {
    border-bottom-width: 0 !important;
    border-bottom-style: none;
  }
  :host ::ng-deep .lg\\:border-bottom-1 {
    border-bottom-width: 1px !important;
    border-bottom-style: solid;
  }
  :host ::ng-deep .lg\\:border-bottom-2 {
    border-bottom-width: 2px !important;
    border-bottom-style: solid;
  }
  :host ::ng-deep .lg\\:border-bottom-3 {
    border-bottom-width: 3px !important;
    border-bottom-style: solid;
  }
  :host ::ng-deep .lg\\:border-x-none {
    border-left-width: 0 !important;
    border-left-style: none;
    border-right-width: 0 !important;
    border-right-style: none;
  }
  :host ::ng-deep .lg\\:border-x-1 {
    border-left-width: 1px !important;
    border-left-style: solid;
    border-right-width: 1px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .lg\\:border-x-2 {
    border-left-width: 2px !important;
    border-left-style: solid;
    border-right-width: 2px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .lg\\:border-x-3 {
    border-left-width: 3px !important;
    border-left-style: solid;
    border-right-width: 3px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .lg\\:border-y-none {
    border-top-width: 0 !important;
    border-top-style: none;
    border-bottom-width: 0 !important;
    border-bottom-style: none;
  }
  :host ::ng-deep .lg\\:border-y-1 {
    border-top-width: 1px !important;
    border-top-style: solid;
    border-bottom-width: 1px !important;
    border-bottom-style: solid;
  }
  :host ::ng-deep .lg\\:border-y-2 {
    border-top-width: 2px !important;
    border-top-style: solid;
    border-bottom-width: 2px !important;
    border-bottom-style: solid;
  }
  :host ::ng-deep .lg\\:border-y-3 {
    border-top-width: 3px !important;
    border-top-style: solid;
    border-bottom-width: 3px !important;
    border-bottom-style: solid;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:border-none {
    border-width: 0 !important;
    border-style: none;
  }
  :host ::ng-deep .xl\\:border-1 {
    border-width: 1px !important;
    border-style: solid;
  }
  :host ::ng-deep .xl\\:border-2 {
    border-width: 2px !important;
    border-style: solid;
  }
  :host ::ng-deep .xl\\:border-3 {
    border-width: 3px !important;
    border-style: solid;
  }
  :host ::ng-deep .xl\\:border-top-none {
    border-top-width: 0 !important;
    border-top-style: none;
  }
  :host ::ng-deep .xl\\:border-top-1 {
    border-top-width: 1px !important;
    border-top-style: solid;
  }
  :host ::ng-deep .xl\\:border-top-2 {
    border-top-width: 2px !important;
    border-top-style: solid;
  }
  :host ::ng-deep .xl\\:border-top-3 {
    border-top-width: 3px !important;
    border-top-style: solid;
  }
  :host ::ng-deep .xl\\:border-right-none {
    border-right-width: 0 !important;
    border-right-style: none;
  }
  :host ::ng-deep .xl\\:border-right-1 {
    border-right-width: 1px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .xl\\:border-right-2 {
    border-right-width: 2px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .xl\\:border-right-3 {
    border-right-width: 3px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .xl\\:border-left-none {
    border-left-width: 0 !important;
    border-left-style: none;
  }
  :host ::ng-deep .xl\\:border-left-1 {
    border-left-width: 1px !important;
    border-left-style: solid;
  }
  :host ::ng-deep .xl\\:border-left-2 {
    border-left-width: 2px !important;
    border-left-style: solid;
  }
  :host ::ng-deep .xl\\:border-left-3 {
    border-left-width: 3px !important;
    border-left-style: solid;
  }
  :host ::ng-deep .xl\\:border-bottom-none {
    border-bottom-width: 0 !important;
    border-bottom-style: none;
  }
  :host ::ng-deep .xl\\:border-bottom-1 {
    border-bottom-width: 1px !important;
    border-bottom-style: solid;
  }
  :host ::ng-deep .xl\\:border-bottom-2 {
    border-bottom-width: 2px !important;
    border-bottom-style: solid;
  }
  :host ::ng-deep .xl\\:border-bottom-3 {
    border-bottom-width: 3px !important;
    border-bottom-style: solid;
  }
  :host ::ng-deep .xl\\:border-x-none {
    border-left-width: 0 !important;
    border-left-style: none;
    border-right-width: 0 !important;
    border-right-style: none;
  }
  :host ::ng-deep .xl\\:border-x-1 {
    border-left-width: 1px !important;
    border-left-style: solid;
    border-right-width: 1px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .xl\\:border-x-2 {
    border-left-width: 2px !important;
    border-left-style: solid;
    border-right-width: 2px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .xl\\:border-x-3 {
    border-left-width: 3px !important;
    border-left-style: solid;
    border-right-width: 3px !important;
    border-right-style: solid;
  }
  :host ::ng-deep .xl\\:border-y-none {
    border-top-width: 0 !important;
    border-top-style: none;
    border-bottom-width: 0 !important;
    border-bottom-style: none;
  }
  :host ::ng-deep .xl\\:border-y-1 {
    border-top-width: 1px !important;
    border-top-style: solid;
    border-bottom-width: 1px !important;
    border-bottom-style: solid;
  }
  :host ::ng-deep .xl\\:border-y-2 {
    border-top-width: 2px !important;
    border-top-style: solid;
    border-bottom-width: 2px !important;
    border-bottom-style: solid;
  }
  :host ::ng-deep .xl\\:border-y-3 {
    border-top-width: 3px !important;
    border-top-style: solid;
    border-bottom-width: 3px !important;
    border-bottom-style: solid;
  }
}
:host ::ng-deep .border-solid {
  border-style: solid !important;
}
:host ::ng-deep .border-dashed {
  border-style: dashed !important;
}
:host ::ng-deep .border-dotted {
  border-style: dotted !important;
}
:host ::ng-deep .border-double {
  border-style: double !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:border-solid {
    border-style: solid !important;
  }
  :host ::ng-deep .sm\\:border-dashed {
    border-style: dashed !important;
  }
  :host ::ng-deep .sm\\:border-dotted {
    border-style: dotted !important;
  }
  :host ::ng-deep .sm\\:border-double {
    border-style: double !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:border-solid {
    border-style: solid !important;
  }
  :host ::ng-deep .md\\:border-dashed {
    border-style: dashed !important;
  }
  :host ::ng-deep .md\\:border-dotted {
    border-style: dotted !important;
  }
  :host ::ng-deep .md\\:border-double {
    border-style: double !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:border-solid {
    border-style: solid !important;
  }
  :host ::ng-deep .lg\\:border-dashed {
    border-style: dashed !important;
  }
  :host ::ng-deep .lg\\:border-dotted {
    border-style: dotted !important;
  }
  :host ::ng-deep .lg\\:border-double {
    border-style: double !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:border-solid {
    border-style: solid !important;
  }
  :host ::ng-deep .xl\\:border-dashed {
    border-style: dashed !important;
  }
  :host ::ng-deep .xl\\:border-dotted {
    border-style: dotted !important;
  }
  :host ::ng-deep .xl\\:border-double {
    border-style: double !important;
  }
}
:host ::ng-deep .border-noround {
  border-radius: 0 !important;
}
:host ::ng-deep .border-round {
  border-radius: var(--border-radius) !important;
}
:host ::ng-deep .border-round-xs {
  border-radius: 0.125rem !important;
}
:host ::ng-deep .border-round-sm {
  border-radius: 0.25rem !important;
}
:host ::ng-deep .border-round-md {
  border-radius: 0.375rem !important;
}
:host ::ng-deep .border-round-lg {
  border-radius: 0.5rem !important;
}
:host ::ng-deep .border-round-xl {
  border-radius: 0.75rem !important;
}
:host ::ng-deep .border-round-2xl {
  border-radius: 1rem !important;
}
:host ::ng-deep .border-round-3xl {
  border-radius: 1.5rem !important;
}
:host ::ng-deep .border-circle {
  border-radius: 50% !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:border-noround {
    border-radius: 0 !important;
  }
  :host ::ng-deep .sm\\:border-round {
    border-radius: var(--border-radius) !important;
  }
  :host ::ng-deep .sm\\:border-round-xs {
    border-radius: 0.125rem !important;
  }
  :host ::ng-deep .sm\\:border-round-sm {
    border-radius: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:border-round-md {
    border-radius: 0.375rem !important;
  }
  :host ::ng-deep .sm\\:border-round-lg {
    border-radius: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:border-round-xl {
    border-radius: 0.75rem !important;
  }
  :host ::ng-deep .sm\\:border-round-2xl {
    border-radius: 1rem !important;
  }
  :host ::ng-deep .sm\\:border-round-3xl {
    border-radius: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:border-circle {
    border-radius: 50% !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:border-noround {
    border-radius: 0 !important;
  }
  :host ::ng-deep .md\\:border-round {
    border-radius: var(--border-radius) !important;
  }
  :host ::ng-deep .md\\:border-round-xs {
    border-radius: 0.125rem !important;
  }
  :host ::ng-deep .md\\:border-round-sm {
    border-radius: 0.25rem !important;
  }
  :host ::ng-deep .md\\:border-round-md {
    border-radius: 0.375rem !important;
  }
  :host ::ng-deep .md\\:border-round-lg {
    border-radius: 0.5rem !important;
  }
  :host ::ng-deep .md\\:border-round-xl {
    border-radius: 0.75rem !important;
  }
  :host ::ng-deep .md\\:border-round-2xl {
    border-radius: 1rem !important;
  }
  :host ::ng-deep .md\\:border-round-3xl {
    border-radius: 1.5rem !important;
  }
  :host ::ng-deep .md\\:border-circle {
    border-radius: 50% !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:border-noround {
    border-radius: 0 !important;
  }
  :host ::ng-deep .lg\\:border-round {
    border-radius: var(--border-radius) !important;
  }
  :host ::ng-deep .lg\\:border-round-xs {
    border-radius: 0.125rem !important;
  }
  :host ::ng-deep .lg\\:border-round-sm {
    border-radius: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:border-round-md {
    border-radius: 0.375rem !important;
  }
  :host ::ng-deep .lg\\:border-round-lg {
    border-radius: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:border-round-xl {
    border-radius: 0.75rem !important;
  }
  :host ::ng-deep .lg\\:border-round-2xl {
    border-radius: 1rem !important;
  }
  :host ::ng-deep .lg\\:border-round-3xl {
    border-radius: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:border-circle {
    border-radius: 50% !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:border-noround {
    border-radius: 0 !important;
  }
  :host ::ng-deep .xl\\:border-round {
    border-radius: var(--border-radius) !important;
  }
  :host ::ng-deep .xl\\:border-round-xs {
    border-radius: 0.125rem !important;
  }
  :host ::ng-deep .xl\\:border-round-sm {
    border-radius: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:border-round-md {
    border-radius: 0.375rem !important;
  }
  :host ::ng-deep .xl\\:border-round-lg {
    border-radius: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:border-round-xl {
    border-radius: 0.75rem !important;
  }
  :host ::ng-deep .xl\\:border-round-2xl {
    border-radius: 1rem !important;
  }
  :host ::ng-deep .xl\\:border-round-3xl {
    border-radius: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:border-circle {
    border-radius: 50% !important;
  }
}
:host ::ng-deep .border-noround-left {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
:host ::ng-deep .border-noround-top {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
:host ::ng-deep .border-noround-right {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
:host ::ng-deep .border-noround-bottom {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
:host ::ng-deep .border-round-left {
  border-top-left-radius: var(--border-radius) !important;
  border-bottom-left-radius: var(--border-radius) !important;
}
:host ::ng-deep .border-round-top {
  border-top-left-radius: var(--border-radius) !important;
  border-top-right-radius: var(--border-radius) !important;
}
:host ::ng-deep .border-round-right {
  border-top-right-radius: var(--border-radius) !important;
  border-bottom-right-radius: var(--border-radius) !important;
}
:host ::ng-deep .border-round-bottom {
  border-bottom-left-radius: var(--border-radius) !important;
  border-bottom-right-radius: var(--border-radius) !important;
}
:host ::ng-deep .border-round-left-xs {
  border-top-left-radius: 0.125rem !important;
  border-bottom-left-radius: 0.125rem !important;
}
:host ::ng-deep .border-round-top-xs {
  border-top-left-radius: 0.125rem !important;
  border-top-right-radius: 0.125rem !important;
}
:host ::ng-deep .border-round-right-xs {
  border-top-right-radius: 0.125rem !important;
  border-bottom-right-radius: 0.125rem !important;
}
:host ::ng-deep .border-round-bottom-xs {
  border-bottom-left-radius: 0.125rem !important;
  border-bottom-right-radius: 0.125rem !important;
}
:host ::ng-deep .border-round-left-sm {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}
:host ::ng-deep .border-round-top-sm {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}
:host ::ng-deep .border-round-right-sm {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}
:host ::ng-deep .border-round-bottom-sm {
  border-bottom-left-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}
:host ::ng-deep .border-round-left-md {
  border-top-left-radius: 0.375rem !important;
  border-bottom-left-radius: 0.375rem !important;
}
:host ::ng-deep .border-round-top-md {
  border-top-left-radius: 0.375rem !important;
  border-top-right-radius: 0.375rem !important;
}
:host ::ng-deep .border-round-right-md {
  border-top-right-radius: 0.375rem !important;
  border-bottom-right-radius: 0.375rem !important;
}
:host ::ng-deep .border-round-bottom-md {
  border-bottom-left-radius: 0.375rem !important;
  border-bottom-right-radius: 0.375rem !important;
}
:host ::ng-deep .border-round-left-lg {
  border-top-left-radius: 0.5rem !important;
  border-bottom-left-radius: 0.5rem !important;
}
:host ::ng-deep .border-round-top-lg {
  border-top-left-radius: 0.5rem !important;
  border-top-right-radius: 0.5rem !important;
}
:host ::ng-deep .border-round-right-lg {
  border-top-right-radius: 0.5rem !important;
  border-bottom-right-radius: 0.5rem !important;
}
:host ::ng-deep .border-round-bottom-lg {
  border-bottom-left-radius: 0.5rem !important;
  border-bottom-right-radius: 0.5rem !important;
}
:host ::ng-deep .border-round-left-xl {
  border-top-left-radius: 0.75rem !important;
  border-bottom-left-radius: 0.75rem !important;
}
:host ::ng-deep .border-round-top-xl {
  border-top-left-radius: 0.75rem !important;
  border-top-right-radius: 0.75rem !important;
}
:host ::ng-deep .border-round-right-xl {
  border-top-right-radius: 0.75rem !important;
  border-bottom-right-radius: 0.75rem !important;
}
:host ::ng-deep .border-round-bottom-xl {
  border-bottom-left-radius: 0.75rem !important;
  border-bottom-right-radius: 0.75rem !important;
}
:host ::ng-deep .border-round-left-2xl {
  border-top-left-radius: 1rem !important;
  border-bottom-left-radius: 1rem !important;
}
:host ::ng-deep .border-round-top-2xl {
  border-top-left-radius: 1rem !important;
  border-top-right-radius: 1rem !important;
}
:host ::ng-deep .border-round-right-2xl {
  border-top-right-radius: 1rem !important;
  border-bottom-right-radius: 1rem !important;
}
:host ::ng-deep .border-round-bottom-2xl {
  border-bottom-left-radius: 1rem !important;
  border-bottom-right-radius: 1rem !important;
}
:host ::ng-deep .border-round-left-3xl {
  border-top-left-radius: 1.5rem !important;
  border-bottom-left-radius: 1.5rem !important;
}
:host ::ng-deep .border-round-top-3xl {
  border-top-left-radius: 1.5rem !important;
  border-top-right-radius: 1.5rem !important;
}
:host ::ng-deep .border-round-right-3xl {
  border-top-right-radius: 1.5rem !important;
  border-bottom-right-radius: 1.5rem !important;
}
:host ::ng-deep .border-round-bottom-3xl {
  border-bottom-left-radius: 1.5rem !important;
  border-bottom-right-radius: 1.5rem !important;
}
:host ::ng-deep .border-circle-left {
  border-top-left-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}
:host ::ng-deep .border-circle-top {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}
:host ::ng-deep .border-circle-right {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}
:host ::ng-deep .border-circle-bottom {
  border-bottom-left-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:border-noround-left {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
  :host ::ng-deep .sm\\:border-noround-top {
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
  }
  :host ::ng-deep .sm\\:border-noround-right {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  :host ::ng-deep .sm\\:border-noround-bottom {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  :host ::ng-deep .sm\\:border-round-left {
    border-top-left-radius: var(--border-radius) !important;
    border-bottom-left-radius: var(--border-radius) !important;
  }
  :host ::ng-deep .sm\\:border-round-top {
    border-top-left-radius: var(--border-radius) !important;
    border-top-right-radius: var(--border-radius) !important;
  }
  :host ::ng-deep .sm\\:border-round-right {
    border-top-right-radius: var(--border-radius) !important;
    border-bottom-right-radius: var(--border-radius) !important;
  }
  :host ::ng-deep .sm\\:border-round-bottom {
    border-bottom-left-radius: var(--border-radius) !important;
    border-bottom-right-radius: var(--border-radius) !important;
  }
  :host ::ng-deep .sm\\:border-round-left-xs {
    border-top-left-radius: 0.125rem !important;
    border-bottom-left-radius: 0.125rem !important;
  }
  :host ::ng-deep .sm\\:border-round-top-xs {
    border-top-left-radius: 0.125rem !important;
    border-top-right-radius: 0.125rem !important;
  }
  :host ::ng-deep .sm\\:border-round-right-xs {
    border-top-right-radius: 0.125rem !important;
    border-bottom-right-radius: 0.125rem !important;
  }
  :host ::ng-deep .sm\\:border-round-bottom-xs {
    border-bottom-left-radius: 0.125rem !important;
    border-bottom-right-radius: 0.125rem !important;
  }
  :host ::ng-deep .sm\\:border-round-left-sm {
    border-top-left-radius: 0.25rem !important;
    border-bottom-left-radius: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:border-round-top-sm {
    border-top-left-radius: 0.25rem !important;
    border-top-right-radius: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:border-round-right-sm {
    border-top-right-radius: 0.25rem !important;
    border-bottom-right-radius: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:border-round-bottom-sm {
    border-bottom-left-radius: 0.25rem !important;
    border-bottom-right-radius: 0.25rem !important;
  }
  :host ::ng-deep .sm\\:border-round-left-md {
    border-top-left-radius: 0.375rem !important;
    border-bottom-left-radius: 0.375rem !important;
  }
  :host ::ng-deep .sm\\:border-round-top-md {
    border-top-left-radius: 0.375rem !important;
    border-top-right-radius: 0.375rem !important;
  }
  :host ::ng-deep .sm\\:border-round-right-md {
    border-top-right-radius: 0.375rem !important;
    border-bottom-right-radius: 0.375rem !important;
  }
  :host ::ng-deep .sm\\:border-round-bottom-md {
    border-bottom-left-radius: 0.375rem !important;
    border-bottom-right-radius: 0.375rem !important;
  }
  :host ::ng-deep .sm\\:border-round-left-lg {
    border-top-left-radius: 0.5rem !important;
    border-bottom-left-radius: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:border-round-top-lg {
    border-top-left-radius: 0.5rem !important;
    border-top-right-radius: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:border-round-right-lg {
    border-top-right-radius: 0.5rem !important;
    border-bottom-right-radius: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:border-round-bottom-lg {
    border-bottom-left-radius: 0.5rem !important;
    border-bottom-right-radius: 0.5rem !important;
  }
  :host ::ng-deep .sm\\:border-round-left-xl {
    border-top-left-radius: 0.75rem !important;
    border-bottom-left-radius: 0.75rem !important;
  }
  :host ::ng-deep .sm\\:border-round-top-xl {
    border-top-left-radius: 0.75rem !important;
    border-top-right-radius: 0.75rem !important;
  }
  :host ::ng-deep .sm\\:border-round-right-xl {
    border-top-right-radius: 0.75rem !important;
    border-bottom-right-radius: 0.75rem !important;
  }
  :host ::ng-deep .sm\\:border-round-bottom-xl {
    border-bottom-left-radius: 0.75rem !important;
    border-bottom-right-radius: 0.75rem !important;
  }
  :host ::ng-deep .sm\\:border-round-left-2xl {
    border-top-left-radius: 1rem !important;
    border-bottom-left-radius: 1rem !important;
  }
  :host ::ng-deep .sm\\:border-round-top-2xl {
    border-top-left-radius: 1rem !important;
    border-top-right-radius: 1rem !important;
  }
  :host ::ng-deep .sm\\:border-round-right-2xl {
    border-top-right-radius: 1rem !important;
    border-bottom-right-radius: 1rem !important;
  }
  :host ::ng-deep .sm\\:border-round-bottom-2xl {
    border-bottom-left-radius: 1rem !important;
    border-bottom-right-radius: 1rem !important;
  }
  :host ::ng-deep .sm\\:border-round-left-3xl {
    border-top-left-radius: 1.5rem !important;
    border-bottom-left-radius: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:border-round-top-3xl {
    border-top-left-radius: 1.5rem !important;
    border-top-right-radius: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:border-round-right-3xl {
    border-top-right-radius: 1.5rem !important;
    border-bottom-right-radius: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:border-round-bottom-3xl {
    border-bottom-left-radius: 1.5rem !important;
    border-bottom-right-radius: 1.5rem !important;
  }
  :host ::ng-deep .sm\\:border-circle-left {
    border-top-left-radius: 50% !important;
    border-bottom-left-radius: 50% !important;
  }
  :host ::ng-deep .sm\\:border-circle-top {
    border-top-left-radius: 50% !important;
    border-top-right-radius: 50% !important;
  }
  :host ::ng-deep .sm\\:border-circle-right {
    border-top-right-radius: 50% !important;
    border-bottom-right-radius: 50% !important;
  }
  :host ::ng-deep .sm\\:border-circle-bottom {
    border-bottom-left-radius: 50% !important;
    border-bottom-right-radius: 50% !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:border-noround-left {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
  :host ::ng-deep .md\\:border-noround-top {
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
  }
  :host ::ng-deep .md\\:border-noround-right {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  :host ::ng-deep .md\\:border-noround-bottom {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  :host ::ng-deep .md\\:border-round-left {
    border-top-left-radius: var(--border-radius) !important;
    border-bottom-left-radius: var(--border-radius) !important;
  }
  :host ::ng-deep .md\\:border-round-top {
    border-top-left-radius: var(--border-radius) !important;
    border-top-right-radius: var(--border-radius) !important;
  }
  :host ::ng-deep .md\\:border-round-right {
    border-top-right-radius: var(--border-radius) !important;
    border-bottom-right-radius: var(--border-radius) !important;
  }
  :host ::ng-deep .md\\:border-round-bottom {
    border-bottom-left-radius: var(--border-radius) !important;
    border-bottom-right-radius: var(--border-radius) !important;
  }
  :host ::ng-deep .md\\:border-round-left-xs {
    border-top-left-radius: 0.125rem !important;
    border-bottom-left-radius: 0.125rem !important;
  }
  :host ::ng-deep .md\\:border-round-top-xs {
    border-top-left-radius: 0.125rem !important;
    border-top-right-radius: 0.125rem !important;
  }
  :host ::ng-deep .md\\:border-round-right-xs {
    border-top-right-radius: 0.125rem !important;
    border-bottom-right-radius: 0.125rem !important;
  }
  :host ::ng-deep .md\\:border-round-bottom-xs {
    border-bottom-left-radius: 0.125rem !important;
    border-bottom-right-radius: 0.125rem !important;
  }
  :host ::ng-deep .md\\:border-round-left-sm {
    border-top-left-radius: 0.25rem !important;
    border-bottom-left-radius: 0.25rem !important;
  }
  :host ::ng-deep .md\\:border-round-top-sm {
    border-top-left-radius: 0.25rem !important;
    border-top-right-radius: 0.25rem !important;
  }
  :host ::ng-deep .md\\:border-round-right-sm {
    border-top-right-radius: 0.25rem !important;
    border-bottom-right-radius: 0.25rem !important;
  }
  :host ::ng-deep .md\\:border-round-bottom-sm {
    border-bottom-left-radius: 0.25rem !important;
    border-bottom-right-radius: 0.25rem !important;
  }
  :host ::ng-deep .md\\:border-round-left-md {
    border-top-left-radius: 0.375rem !important;
    border-bottom-left-radius: 0.375rem !important;
  }
  :host ::ng-deep .md\\:border-round-top-md {
    border-top-left-radius: 0.375rem !important;
    border-top-right-radius: 0.375rem !important;
  }
  :host ::ng-deep .md\\:border-round-right-md {
    border-top-right-radius: 0.375rem !important;
    border-bottom-right-radius: 0.375rem !important;
  }
  :host ::ng-deep .md\\:border-round-bottom-md {
    border-bottom-left-radius: 0.375rem !important;
    border-bottom-right-radius: 0.375rem !important;
  }
  :host ::ng-deep .md\\:border-round-left-lg {
    border-top-left-radius: 0.5rem !important;
    border-bottom-left-radius: 0.5rem !important;
  }
  :host ::ng-deep .md\\:border-round-top-lg {
    border-top-left-radius: 0.5rem !important;
    border-top-right-radius: 0.5rem !important;
  }
  :host ::ng-deep .md\\:border-round-right-lg {
    border-top-right-radius: 0.5rem !important;
    border-bottom-right-radius: 0.5rem !important;
  }
  :host ::ng-deep .md\\:border-round-bottom-lg {
    border-bottom-left-radius: 0.5rem !important;
    border-bottom-right-radius: 0.5rem !important;
  }
  :host ::ng-deep .md\\:border-round-left-xl {
    border-top-left-radius: 0.75rem !important;
    border-bottom-left-radius: 0.75rem !important;
  }
  :host ::ng-deep .md\\:border-round-top-xl {
    border-top-left-radius: 0.75rem !important;
    border-top-right-radius: 0.75rem !important;
  }
  :host ::ng-deep .md\\:border-round-right-xl {
    border-top-right-radius: 0.75rem !important;
    border-bottom-right-radius: 0.75rem !important;
  }
  :host ::ng-deep .md\\:border-round-bottom-xl {
    border-bottom-left-radius: 0.75rem !important;
    border-bottom-right-radius: 0.75rem !important;
  }
  :host ::ng-deep .md\\:border-round-left-2xl {
    border-top-left-radius: 1rem !important;
    border-bottom-left-radius: 1rem !important;
  }
  :host ::ng-deep .md\\:border-round-top-2xl {
    border-top-left-radius: 1rem !important;
    border-top-right-radius: 1rem !important;
  }
  :host ::ng-deep .md\\:border-round-right-2xl {
    border-top-right-radius: 1rem !important;
    border-bottom-right-radius: 1rem !important;
  }
  :host ::ng-deep .md\\:border-round-bottom-2xl {
    border-bottom-left-radius: 1rem !important;
    border-bottom-right-radius: 1rem !important;
  }
  :host ::ng-deep .md\\:border-round-left-3xl {
    border-top-left-radius: 1.5rem !important;
    border-bottom-left-radius: 1.5rem !important;
  }
  :host ::ng-deep .md\\:border-round-top-3xl {
    border-top-left-radius: 1.5rem !important;
    border-top-right-radius: 1.5rem !important;
  }
  :host ::ng-deep .md\\:border-round-right-3xl {
    border-top-right-radius: 1.5rem !important;
    border-bottom-right-radius: 1.5rem !important;
  }
  :host ::ng-deep .md\\:border-round-bottom-3xl {
    border-bottom-left-radius: 1.5rem !important;
    border-bottom-right-radius: 1.5rem !important;
  }
  :host ::ng-deep .md\\:border-circle-left {
    border-top-left-radius: 50% !important;
    border-bottom-left-radius: 50% !important;
  }
  :host ::ng-deep .md\\:border-circle-top {
    border-top-left-radius: 50% !important;
    border-top-right-radius: 50% !important;
  }
  :host ::ng-deep .md\\:border-circle-right {
    border-top-right-radius: 50% !important;
    border-bottom-right-radius: 50% !important;
  }
  :host ::ng-deep .md\\:border-circle-bottom {
    border-bottom-left-radius: 50% !important;
    border-bottom-right-radius: 50% !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:border-noround-left {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
  :host ::ng-deep .lg\\:border-noround-top {
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
  }
  :host ::ng-deep .lg\\:border-noround-right {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  :host ::ng-deep .lg\\:border-noround-bottom {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  :host ::ng-deep .lg\\:border-round-left {
    border-top-left-radius: var(--border-radius) !important;
    border-bottom-left-radius: var(--border-radius) !important;
  }
  :host ::ng-deep .lg\\:border-round-top {
    border-top-left-radius: var(--border-radius) !important;
    border-top-right-radius: var(--border-radius) !important;
  }
  :host ::ng-deep .lg\\:border-round-right {
    border-top-right-radius: var(--border-radius) !important;
    border-bottom-right-radius: var(--border-radius) !important;
  }
  :host ::ng-deep .lg\\:border-round-bottom {
    border-bottom-left-radius: var(--border-radius) !important;
    border-bottom-right-radius: var(--border-radius) !important;
  }
  :host ::ng-deep .lg\\:border-round-left-xs {
    border-top-left-radius: 0.125rem !important;
    border-bottom-left-radius: 0.125rem !important;
  }
  :host ::ng-deep .lg\\:border-round-top-xs {
    border-top-left-radius: 0.125rem !important;
    border-top-right-radius: 0.125rem !important;
  }
  :host ::ng-deep .lg\\:border-round-right-xs {
    border-top-right-radius: 0.125rem !important;
    border-bottom-right-radius: 0.125rem !important;
  }
  :host ::ng-deep .lg\\:border-round-bottom-xs {
    border-bottom-left-radius: 0.125rem !important;
    border-bottom-right-radius: 0.125rem !important;
  }
  :host ::ng-deep .lg\\:border-round-left-sm {
    border-top-left-radius: 0.25rem !important;
    border-bottom-left-radius: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:border-round-top-sm {
    border-top-left-radius: 0.25rem !important;
    border-top-right-radius: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:border-round-right-sm {
    border-top-right-radius: 0.25rem !important;
    border-bottom-right-radius: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:border-round-bottom-sm {
    border-bottom-left-radius: 0.25rem !important;
    border-bottom-right-radius: 0.25rem !important;
  }
  :host ::ng-deep .lg\\:border-round-left-md {
    border-top-left-radius: 0.375rem !important;
    border-bottom-left-radius: 0.375rem !important;
  }
  :host ::ng-deep .lg\\:border-round-top-md {
    border-top-left-radius: 0.375rem !important;
    border-top-right-radius: 0.375rem !important;
  }
  :host ::ng-deep .lg\\:border-round-right-md {
    border-top-right-radius: 0.375rem !important;
    border-bottom-right-radius: 0.375rem !important;
  }
  :host ::ng-deep .lg\\:border-round-bottom-md {
    border-bottom-left-radius: 0.375rem !important;
    border-bottom-right-radius: 0.375rem !important;
  }
  :host ::ng-deep .lg\\:border-round-left-lg {
    border-top-left-radius: 0.5rem !important;
    border-bottom-left-radius: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:border-round-top-lg {
    border-top-left-radius: 0.5rem !important;
    border-top-right-radius: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:border-round-right-lg {
    border-top-right-radius: 0.5rem !important;
    border-bottom-right-radius: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:border-round-bottom-lg {
    border-bottom-left-radius: 0.5rem !important;
    border-bottom-right-radius: 0.5rem !important;
  }
  :host ::ng-deep .lg\\:border-round-left-xl {
    border-top-left-radius: 0.75rem !important;
    border-bottom-left-radius: 0.75rem !important;
  }
  :host ::ng-deep .lg\\:border-round-top-xl {
    border-top-left-radius: 0.75rem !important;
    border-top-right-radius: 0.75rem !important;
  }
  :host ::ng-deep .lg\\:border-round-right-xl {
    border-top-right-radius: 0.75rem !important;
    border-bottom-right-radius: 0.75rem !important;
  }
  :host ::ng-deep .lg\\:border-round-bottom-xl {
    border-bottom-left-radius: 0.75rem !important;
    border-bottom-right-radius: 0.75rem !important;
  }
  :host ::ng-deep .lg\\:border-round-left-2xl {
    border-top-left-radius: 1rem !important;
    border-bottom-left-radius: 1rem !important;
  }
  :host ::ng-deep .lg\\:border-round-top-2xl {
    border-top-left-radius: 1rem !important;
    border-top-right-radius: 1rem !important;
  }
  :host ::ng-deep .lg\\:border-round-right-2xl {
    border-top-right-radius: 1rem !important;
    border-bottom-right-radius: 1rem !important;
  }
  :host ::ng-deep .lg\\:border-round-bottom-2xl {
    border-bottom-left-radius: 1rem !important;
    border-bottom-right-radius: 1rem !important;
  }
  :host ::ng-deep .lg\\:border-round-left-3xl {
    border-top-left-radius: 1.5rem !important;
    border-bottom-left-radius: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:border-round-top-3xl {
    border-top-left-radius: 1.5rem !important;
    border-top-right-radius: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:border-round-right-3xl {
    border-top-right-radius: 1.5rem !important;
    border-bottom-right-radius: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:border-round-bottom-3xl {
    border-bottom-left-radius: 1.5rem !important;
    border-bottom-right-radius: 1.5rem !important;
  }
  :host ::ng-deep .lg\\:border-circle-left {
    border-top-left-radius: 50% !important;
    border-bottom-left-radius: 50% !important;
  }
  :host ::ng-deep .lg\\:border-circle-top {
    border-top-left-radius: 50% !important;
    border-top-right-radius: 50% !important;
  }
  :host ::ng-deep .lg\\:border-circle-right {
    border-top-right-radius: 50% !important;
    border-bottom-right-radius: 50% !important;
  }
  :host ::ng-deep .lg\\:border-circle-bottom {
    border-bottom-left-radius: 50% !important;
    border-bottom-right-radius: 50% !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:border-noround-left {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
  :host ::ng-deep .xl\\:border-noround-top {
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
  }
  :host ::ng-deep .xl\\:border-noround-right {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  :host ::ng-deep .xl\\:border-noround-bottom {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  :host ::ng-deep .xl\\:border-round-left {
    border-top-left-radius: var(--border-radius) !important;
    border-bottom-left-radius: var(--border-radius) !important;
  }
  :host ::ng-deep .xl\\:border-round-top {
    border-top-left-radius: var(--border-radius) !important;
    border-top-right-radius: var(--border-radius) !important;
  }
  :host ::ng-deep .xl\\:border-round-right {
    border-top-right-radius: var(--border-radius) !important;
    border-bottom-right-radius: var(--border-radius) !important;
  }
  :host ::ng-deep .xl\\:border-round-bottom {
    border-bottom-left-radius: var(--border-radius) !important;
    border-bottom-right-radius: var(--border-radius) !important;
  }
  :host ::ng-deep .xl\\:border-round-left-xs {
    border-top-left-radius: 0.125rem !important;
    border-bottom-left-radius: 0.125rem !important;
  }
  :host ::ng-deep .xl\\:border-round-top-xs {
    border-top-left-radius: 0.125rem !important;
    border-top-right-radius: 0.125rem !important;
  }
  :host ::ng-deep .xl\\:border-round-right-xs {
    border-top-right-radius: 0.125rem !important;
    border-bottom-right-radius: 0.125rem !important;
  }
  :host ::ng-deep .xl\\:border-round-bottom-xs {
    border-bottom-left-radius: 0.125rem !important;
    border-bottom-right-radius: 0.125rem !important;
  }
  :host ::ng-deep .xl\\:border-round-left-sm {
    border-top-left-radius: 0.25rem !important;
    border-bottom-left-radius: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:border-round-top-sm {
    border-top-left-radius: 0.25rem !important;
    border-top-right-radius: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:border-round-right-sm {
    border-top-right-radius: 0.25rem !important;
    border-bottom-right-radius: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:border-round-bottom-sm {
    border-bottom-left-radius: 0.25rem !important;
    border-bottom-right-radius: 0.25rem !important;
  }
  :host ::ng-deep .xl\\:border-round-left-md {
    border-top-left-radius: 0.375rem !important;
    border-bottom-left-radius: 0.375rem !important;
  }
  :host ::ng-deep .xl\\:border-round-top-md {
    border-top-left-radius: 0.375rem !important;
    border-top-right-radius: 0.375rem !important;
  }
  :host ::ng-deep .xl\\:border-round-right-md {
    border-top-right-radius: 0.375rem !important;
    border-bottom-right-radius: 0.375rem !important;
  }
  :host ::ng-deep .xl\\:border-round-bottom-md {
    border-bottom-left-radius: 0.375rem !important;
    border-bottom-right-radius: 0.375rem !important;
  }
  :host ::ng-deep .xl\\:border-round-left-lg {
    border-top-left-radius: 0.5rem !important;
    border-bottom-left-radius: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:border-round-top-lg {
    border-top-left-radius: 0.5rem !important;
    border-top-right-radius: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:border-round-right-lg {
    border-top-right-radius: 0.5rem !important;
    border-bottom-right-radius: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:border-round-bottom-lg {
    border-bottom-left-radius: 0.5rem !important;
    border-bottom-right-radius: 0.5rem !important;
  }
  :host ::ng-deep .xl\\:border-round-left-xl {
    border-top-left-radius: 0.75rem !important;
    border-bottom-left-radius: 0.75rem !important;
  }
  :host ::ng-deep .xl\\:border-round-top-xl {
    border-top-left-radius: 0.75rem !important;
    border-top-right-radius: 0.75rem !important;
  }
  :host ::ng-deep .xl\\:border-round-right-xl {
    border-top-right-radius: 0.75rem !important;
    border-bottom-right-radius: 0.75rem !important;
  }
  :host ::ng-deep .xl\\:border-round-bottom-xl {
    border-bottom-left-radius: 0.75rem !important;
    border-bottom-right-radius: 0.75rem !important;
  }
  :host ::ng-deep .xl\\:border-round-left-2xl {
    border-top-left-radius: 1rem !important;
    border-bottom-left-radius: 1rem !important;
  }
  :host ::ng-deep .xl\\:border-round-top-2xl {
    border-top-left-radius: 1rem !important;
    border-top-right-radius: 1rem !important;
  }
  :host ::ng-deep .xl\\:border-round-right-2xl {
    border-top-right-radius: 1rem !important;
    border-bottom-right-radius: 1rem !important;
  }
  :host ::ng-deep .xl\\:border-round-bottom-2xl {
    border-bottom-left-radius: 1rem !important;
    border-bottom-right-radius: 1rem !important;
  }
  :host ::ng-deep .xl\\:border-round-left-3xl {
    border-top-left-radius: 1.5rem !important;
    border-bottom-left-radius: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:border-round-top-3xl {
    border-top-left-radius: 1.5rem !important;
    border-top-right-radius: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:border-round-right-3xl {
    border-top-right-radius: 1.5rem !important;
    border-bottom-right-radius: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:border-round-bottom-3xl {
    border-bottom-left-radius: 1.5rem !important;
    border-bottom-right-radius: 1.5rem !important;
  }
  :host ::ng-deep .xl\\:border-circle-left {
    border-top-left-radius: 50% !important;
    border-bottom-left-radius: 50% !important;
  }
  :host ::ng-deep .xl\\:border-circle-top {
    border-top-left-radius: 50% !important;
    border-top-right-radius: 50% !important;
  }
  :host ::ng-deep .xl\\:border-circle-right {
    border-top-right-radius: 50% !important;
    border-bottom-right-radius: 50% !important;
  }
  :host ::ng-deep .xl\\:border-circle-bottom {
    border-bottom-left-radius: 50% !important;
    border-bottom-right-radius: 50% !important;
  }
}
:host ::ng-deep .w-full {
  width: 100% !important;
}
:host ::ng-deep .w-screen {
  width: 100vw !important;
}
:host ::ng-deep .w-auto {
  width: auto !important;
}
:host ::ng-deep .w-1 {
  width: 8.3333% !important;
}
:host ::ng-deep .w-2 {
  width: 16.6667% !important;
}
:host ::ng-deep .w-3 {
  width: 25% !important;
}
:host ::ng-deep .w-4 {
  width: 33.3333% !important;
}
:host ::ng-deep .w-5 {
  width: 41.6667% !important;
}
:host ::ng-deep .w-6 {
  width: 50% !important;
}
:host ::ng-deep .w-7 {
  width: 58.3333% !important;
}
:host ::ng-deep .w-8 {
  width: 66.6667% !important;
}
:host ::ng-deep .w-9 {
  width: 75% !important;
}
:host ::ng-deep .w-10 {
  width: 83.3333% !important;
}
:host ::ng-deep .w-11 {
  width: 91.6667% !important;
}
:host ::ng-deep .w-12 {
  width: 100% !important;
}
:host ::ng-deep .w-min {
  width: min-content !important;
}
:host ::ng-deep .w-max {
  width: max-content !important;
}
:host ::ng-deep .w-fit {
  width: -moz-fit-content !important;
  width: fit-content !important;
}
:host ::ng-deep .w-1rem {
  width: 1rem !important;
}
:host ::ng-deep .w-2rem {
  width: 2rem !important;
}
:host ::ng-deep .w-3rem {
  width: 3rem !important;
}
:host ::ng-deep .w-4rem {
  width: 4rem !important;
}
:host ::ng-deep .w-5rem {
  width: 5rem !important;
}
:host ::ng-deep .w-6rem {
  width: 6rem !important;
}
:host ::ng-deep .w-7rem {
  width: 7rem !important;
}
:host ::ng-deep .w-8rem {
  width: 8rem !important;
}
:host ::ng-deep .w-9rem {
  width: 9rem !important;
}
:host ::ng-deep .w-10rem {
  width: 10rem !important;
}
:host ::ng-deep .w-11rem {
  width: 11rem !important;
}
:host ::ng-deep .w-12rem {
  width: 12rem !important;
}
:host ::ng-deep .w-13rem {
  width: 13rem !important;
}
:host ::ng-deep .w-14rem {
  width: 14rem !important;
}
:host ::ng-deep .w-15rem {
  width: 15rem !important;
}
:host ::ng-deep .w-16rem {
  width: 16rem !important;
}
:host ::ng-deep .w-17rem {
  width: 17rem !important;
}
:host ::ng-deep .w-18rem {
  width: 18rem !important;
}
:host ::ng-deep .w-19rem {
  width: 19rem !important;
}
:host ::ng-deep .w-20rem {
  width: 20rem !important;
}
:host ::ng-deep .w-21rem {
  width: 21rem !important;
}
:host ::ng-deep .w-22rem {
  width: 22rem !important;
}
:host ::ng-deep .w-23rem {
  width: 23rem !important;
}
:host ::ng-deep .w-24rem {
  width: 24rem !important;
}
:host ::ng-deep .w-25rem {
  width: 25rem !important;
}
:host ::ng-deep .w-26rem {
  width: 26rem !important;
}
:host ::ng-deep .w-27rem {
  width: 27rem !important;
}
:host ::ng-deep .w-28rem {
  width: 28rem !important;
}
:host ::ng-deep .w-29rem {
  width: 29rem !important;
}
:host ::ng-deep .w-30rem {
  width: 30rem !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:w-full {
    width: 100% !important;
  }
  :host ::ng-deep .sm\\:w-screen {
    width: 100vw !important;
  }
  :host ::ng-deep .sm\\:w-auto {
    width: auto !important;
  }
  :host ::ng-deep .sm\\:w-1 {
    width: 8.3333% !important;
  }
  :host ::ng-deep .sm\\:w-2 {
    width: 16.6667% !important;
  }
  :host ::ng-deep .sm\\:w-3 {
    width: 25% !important;
  }
  :host ::ng-deep .sm\\:w-4 {
    width: 33.3333% !important;
  }
  :host ::ng-deep .sm\\:w-5 {
    width: 41.6667% !important;
  }
  :host ::ng-deep .sm\\:w-6 {
    width: 50% !important;
  }
  :host ::ng-deep .sm\\:w-7 {
    width: 58.3333% !important;
  }
  :host ::ng-deep .sm\\:w-8 {
    width: 66.6667% !important;
  }
  :host ::ng-deep .sm\\:w-9 {
    width: 75% !important;
  }
  :host ::ng-deep .sm\\:w-10 {
    width: 83.3333% !important;
  }
  :host ::ng-deep .sm\\:w-11 {
    width: 91.6667% !important;
  }
  :host ::ng-deep .sm\\:w-12 {
    width: 100% !important;
  }
  :host ::ng-deep .sm\\:w-min {
    width: min-content !important;
  }
  :host ::ng-deep .sm\\:w-max {
    width: max-content !important;
  }
  :host ::ng-deep .sm\\:w-fit {
    width: -moz-fit-content !important;
    width: fit-content !important;
  }
  :host ::ng-deep .sm\\:w-1rem {
    width: 1rem !important;
  }
  :host ::ng-deep .sm\\:w-2rem {
    width: 2rem !important;
  }
  :host ::ng-deep .sm\\:w-3rem {
    width: 3rem !important;
  }
  :host ::ng-deep .sm\\:w-4rem {
    width: 4rem !important;
  }
  :host ::ng-deep .sm\\:w-5rem {
    width: 5rem !important;
  }
  :host ::ng-deep .sm\\:w-6rem {
    width: 6rem !important;
  }
  :host ::ng-deep .sm\\:w-7rem {
    width: 7rem !important;
  }
  :host ::ng-deep .sm\\:w-8rem {
    width: 8rem !important;
  }
  :host ::ng-deep .sm\\:w-9rem {
    width: 9rem !important;
  }
  :host ::ng-deep .sm\\:w-10rem {
    width: 10rem !important;
  }
  :host ::ng-deep .sm\\:w-11rem {
    width: 11rem !important;
  }
  :host ::ng-deep .sm\\:w-12rem {
    width: 12rem !important;
  }
  :host ::ng-deep .sm\\:w-13rem {
    width: 13rem !important;
  }
  :host ::ng-deep .sm\\:w-14rem {
    width: 14rem !important;
  }
  :host ::ng-deep .sm\\:w-15rem {
    width: 15rem !important;
  }
  :host ::ng-deep .sm\\:w-16rem {
    width: 16rem !important;
  }
  :host ::ng-deep .sm\\:w-17rem {
    width: 17rem !important;
  }
  :host ::ng-deep .sm\\:w-18rem {
    width: 18rem !important;
  }
  :host ::ng-deep .sm\\:w-19rem {
    width: 19rem !important;
  }
  :host ::ng-deep .sm\\:w-20rem {
    width: 20rem !important;
  }
  :host ::ng-deep .sm\\:w-21rem {
    width: 21rem !important;
  }
  :host ::ng-deep .sm\\:w-22rem {
    width: 22rem !important;
  }
  :host ::ng-deep .sm\\:w-23rem {
    width: 23rem !important;
  }
  :host ::ng-deep .sm\\:w-24rem {
    width: 24rem !important;
  }
  :host ::ng-deep .sm\\:w-25rem {
    width: 25rem !important;
  }
  :host ::ng-deep .sm\\:w-26rem {
    width: 26rem !important;
  }
  :host ::ng-deep .sm\\:w-27rem {
    width: 27rem !important;
  }
  :host ::ng-deep .sm\\:w-28rem {
    width: 28rem !important;
  }
  :host ::ng-deep .sm\\:w-29rem {
    width: 29rem !important;
  }
  :host ::ng-deep .sm\\:w-30rem {
    width: 30rem !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:w-full {
    width: 100% !important;
  }
  :host ::ng-deep .md\\:w-screen {
    width: 100vw !important;
  }
  :host ::ng-deep .md\\:w-auto {
    width: auto !important;
  }
  :host ::ng-deep .md\\:w-1 {
    width: 8.3333% !important;
  }
  :host ::ng-deep .md\\:w-2 {
    width: 16.6667% !important;
  }
  :host ::ng-deep .md\\:w-3 {
    width: 25% !important;
  }
  :host ::ng-deep .md\\:w-4 {
    width: 33.3333% !important;
  }
  :host ::ng-deep .md\\:w-5 {
    width: 41.6667% !important;
  }
  :host ::ng-deep .md\\:w-6 {
    width: 50% !important;
  }
  :host ::ng-deep .md\\:w-7 {
    width: 58.3333% !important;
  }
  :host ::ng-deep .md\\:w-8 {
    width: 66.6667% !important;
  }
  :host ::ng-deep .md\\:w-9 {
    width: 75% !important;
  }
  :host ::ng-deep .md\\:w-10 {
    width: 83.3333% !important;
  }
  :host ::ng-deep .md\\:w-11 {
    width: 91.6667% !important;
  }
  :host ::ng-deep .md\\:w-12 {
    width: 100% !important;
  }
  :host ::ng-deep .md\\:w-min {
    width: min-content !important;
  }
  :host ::ng-deep .md\\:w-max {
    width: max-content !important;
  }
  :host ::ng-deep .md\\:w-fit {
    width: -moz-fit-content !important;
    width: fit-content !important;
  }
  :host ::ng-deep .md\\:w-1rem {
    width: 1rem !important;
  }
  :host ::ng-deep .md\\:w-2rem {
    width: 2rem !important;
  }
  :host ::ng-deep .md\\:w-3rem {
    width: 3rem !important;
  }
  :host ::ng-deep .md\\:w-4rem {
    width: 4rem !important;
  }
  :host ::ng-deep .md\\:w-5rem {
    width: 5rem !important;
  }
  :host ::ng-deep .md\\:w-6rem {
    width: 6rem !important;
  }
  :host ::ng-deep .md\\:w-7rem {
    width: 7rem !important;
  }
  :host ::ng-deep .md\\:w-8rem {
    width: 8rem !important;
  }
  :host ::ng-deep .md\\:w-9rem {
    width: 9rem !important;
  }
  :host ::ng-deep .md\\:w-10rem {
    width: 10rem !important;
  }
  :host ::ng-deep .md\\:w-11rem {
    width: 11rem !important;
  }
  :host ::ng-deep .md\\:w-12rem {
    width: 12rem !important;
  }
  :host ::ng-deep .md\\:w-13rem {
    width: 13rem !important;
  }
  :host ::ng-deep .md\\:w-14rem {
    width: 14rem !important;
  }
  :host ::ng-deep .md\\:w-15rem {
    width: 15rem !important;
  }
  :host ::ng-deep .md\\:w-16rem {
    width: 16rem !important;
  }
  :host ::ng-deep .md\\:w-17rem {
    width: 17rem !important;
  }
  :host ::ng-deep .md\\:w-18rem {
    width: 18rem !important;
  }
  :host ::ng-deep .md\\:w-19rem {
    width: 19rem !important;
  }
  :host ::ng-deep .md\\:w-20rem {
    width: 20rem !important;
  }
  :host ::ng-deep .md\\:w-21rem {
    width: 21rem !important;
  }
  :host ::ng-deep .md\\:w-22rem {
    width: 22rem !important;
  }
  :host ::ng-deep .md\\:w-23rem {
    width: 23rem !important;
  }
  :host ::ng-deep .md\\:w-24rem {
    width: 24rem !important;
  }
  :host ::ng-deep .md\\:w-25rem {
    width: 25rem !important;
  }
  :host ::ng-deep .md\\:w-26rem {
    width: 26rem !important;
  }
  :host ::ng-deep .md\\:w-27rem {
    width: 27rem !important;
  }
  :host ::ng-deep .md\\:w-28rem {
    width: 28rem !important;
  }
  :host ::ng-deep .md\\:w-29rem {
    width: 29rem !important;
  }
  :host ::ng-deep .md\\:w-30rem {
    width: 30rem !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:w-full {
    width: 100% !important;
  }
  :host ::ng-deep .lg\\:w-screen {
    width: 100vw !important;
  }
  :host ::ng-deep .lg\\:w-auto {
    width: auto !important;
  }
  :host ::ng-deep .lg\\:w-1 {
    width: 8.3333% !important;
  }
  :host ::ng-deep .lg\\:w-2 {
    width: 16.6667% !important;
  }
  :host ::ng-deep .lg\\:w-3 {
    width: 25% !important;
  }
  :host ::ng-deep .lg\\:w-4 {
    width: 33.3333% !important;
  }
  :host ::ng-deep .lg\\:w-5 {
    width: 41.6667% !important;
  }
  :host ::ng-deep .lg\\:w-6 {
    width: 50% !important;
  }
  :host ::ng-deep .lg\\:w-7 {
    width: 58.3333% !important;
  }
  :host ::ng-deep .lg\\:w-8 {
    width: 66.6667% !important;
  }
  :host ::ng-deep .lg\\:w-9 {
    width: 75% !important;
  }
  :host ::ng-deep .lg\\:w-10 {
    width: 83.3333% !important;
  }
  :host ::ng-deep .lg\\:w-11 {
    width: 91.6667% !important;
  }
  :host ::ng-deep .lg\\:w-12 {
    width: 100% !important;
  }
  :host ::ng-deep .lg\\:w-min {
    width: min-content !important;
  }
  :host ::ng-deep .lg\\:w-max {
    width: max-content !important;
  }
  :host ::ng-deep .lg\\:w-fit {
    width: -moz-fit-content !important;
    width: fit-content !important;
  }
  :host ::ng-deep .lg\\:w-1rem {
    width: 1rem !important;
  }
  :host ::ng-deep .lg\\:w-2rem {
    width: 2rem !important;
  }
  :host ::ng-deep .lg\\:w-3rem {
    width: 3rem !important;
  }
  :host ::ng-deep .lg\\:w-4rem {
    width: 4rem !important;
  }
  :host ::ng-deep .lg\\:w-5rem {
    width: 5rem !important;
  }
  :host ::ng-deep .lg\\:w-6rem {
    width: 6rem !important;
  }
  :host ::ng-deep .lg\\:w-7rem {
    width: 7rem !important;
  }
  :host ::ng-deep .lg\\:w-8rem {
    width: 8rem !important;
  }
  :host ::ng-deep .lg\\:w-9rem {
    width: 9rem !important;
  }
  :host ::ng-deep .lg\\:w-10rem {
    width: 10rem !important;
  }
  :host ::ng-deep .lg\\:w-11rem {
    width: 11rem !important;
  }
  :host ::ng-deep .lg\\:w-12rem {
    width: 12rem !important;
  }
  :host ::ng-deep .lg\\:w-13rem {
    width: 13rem !important;
  }
  :host ::ng-deep .lg\\:w-14rem {
    width: 14rem !important;
  }
  :host ::ng-deep .lg\\:w-15rem {
    width: 15rem !important;
  }
  :host ::ng-deep .lg\\:w-16rem {
    width: 16rem !important;
  }
  :host ::ng-deep .lg\\:w-17rem {
    width: 17rem !important;
  }
  :host ::ng-deep .lg\\:w-18rem {
    width: 18rem !important;
  }
  :host ::ng-deep .lg\\:w-19rem {
    width: 19rem !important;
  }
  :host ::ng-deep .lg\\:w-20rem {
    width: 20rem !important;
  }
  :host ::ng-deep .lg\\:w-21rem {
    width: 21rem !important;
  }
  :host ::ng-deep .lg\\:w-22rem {
    width: 22rem !important;
  }
  :host ::ng-deep .lg\\:w-23rem {
    width: 23rem !important;
  }
  :host ::ng-deep .lg\\:w-24rem {
    width: 24rem !important;
  }
  :host ::ng-deep .lg\\:w-25rem {
    width: 25rem !important;
  }
  :host ::ng-deep .lg\\:w-26rem {
    width: 26rem !important;
  }
  :host ::ng-deep .lg\\:w-27rem {
    width: 27rem !important;
  }
  :host ::ng-deep .lg\\:w-28rem {
    width: 28rem !important;
  }
  :host ::ng-deep .lg\\:w-29rem {
    width: 29rem !important;
  }
  :host ::ng-deep .lg\\:w-30rem {
    width: 30rem !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:w-full {
    width: 100% !important;
  }
  :host ::ng-deep .xl\\:w-screen {
    width: 100vw !important;
  }
  :host ::ng-deep .xl\\:w-auto {
    width: auto !important;
  }
  :host ::ng-deep .xl\\:w-1 {
    width: 8.3333% !important;
  }
  :host ::ng-deep .xl\\:w-2 {
    width: 16.6667% !important;
  }
  :host ::ng-deep .xl\\:w-3 {
    width: 25% !important;
  }
  :host ::ng-deep .xl\\:w-4 {
    width: 33.3333% !important;
  }
  :host ::ng-deep .xl\\:w-5 {
    width: 41.6667% !important;
  }
  :host ::ng-deep .xl\\:w-6 {
    width: 50% !important;
  }
  :host ::ng-deep .xl\\:w-7 {
    width: 58.3333% !important;
  }
  :host ::ng-deep .xl\\:w-8 {
    width: 66.6667% !important;
  }
  :host ::ng-deep .xl\\:w-9 {
    width: 75% !important;
  }
  :host ::ng-deep .xl\\:w-10 {
    width: 83.3333% !important;
  }
  :host ::ng-deep .xl\\:w-11 {
    width: 91.6667% !important;
  }
  :host ::ng-deep .xl\\:w-12 {
    width: 100% !important;
  }
  :host ::ng-deep .xl\\:w-min {
    width: min-content !important;
  }
  :host ::ng-deep .xl\\:w-max {
    width: max-content !important;
  }
  :host ::ng-deep .xl\\:w-fit {
    width: -moz-fit-content !important;
    width: fit-content !important;
  }
  :host ::ng-deep .xl\\:w-1rem {
    width: 1rem !important;
  }
  :host ::ng-deep .xl\\:w-2rem {
    width: 2rem !important;
  }
  :host ::ng-deep .xl\\:w-3rem {
    width: 3rem !important;
  }
  :host ::ng-deep .xl\\:w-4rem {
    width: 4rem !important;
  }
  :host ::ng-deep .xl\\:w-5rem {
    width: 5rem !important;
  }
  :host ::ng-deep .xl\\:w-6rem {
    width: 6rem !important;
  }
  :host ::ng-deep .xl\\:w-7rem {
    width: 7rem !important;
  }
  :host ::ng-deep .xl\\:w-8rem {
    width: 8rem !important;
  }
  :host ::ng-deep .xl\\:w-9rem {
    width: 9rem !important;
  }
  :host ::ng-deep .xl\\:w-10rem {
    width: 10rem !important;
  }
  :host ::ng-deep .xl\\:w-11rem {
    width: 11rem !important;
  }
  :host ::ng-deep .xl\\:w-12rem {
    width: 12rem !important;
  }
  :host ::ng-deep .xl\\:w-13rem {
    width: 13rem !important;
  }
  :host ::ng-deep .xl\\:w-14rem {
    width: 14rem !important;
  }
  :host ::ng-deep .xl\\:w-15rem {
    width: 15rem !important;
  }
  :host ::ng-deep .xl\\:w-16rem {
    width: 16rem !important;
  }
  :host ::ng-deep .xl\\:w-17rem {
    width: 17rem !important;
  }
  :host ::ng-deep .xl\\:w-18rem {
    width: 18rem !important;
  }
  :host ::ng-deep .xl\\:w-19rem {
    width: 19rem !important;
  }
  :host ::ng-deep .xl\\:w-20rem {
    width: 20rem !important;
  }
  :host ::ng-deep .xl\\:w-21rem {
    width: 21rem !important;
  }
  :host ::ng-deep .xl\\:w-22rem {
    width: 22rem !important;
  }
  :host ::ng-deep .xl\\:w-23rem {
    width: 23rem !important;
  }
  :host ::ng-deep .xl\\:w-24rem {
    width: 24rem !important;
  }
  :host ::ng-deep .xl\\:w-25rem {
    width: 25rem !important;
  }
  :host ::ng-deep .xl\\:w-26rem {
    width: 26rem !important;
  }
  :host ::ng-deep .xl\\:w-27rem {
    width: 27rem !important;
  }
  :host ::ng-deep .xl\\:w-28rem {
    width: 28rem !important;
  }
  :host ::ng-deep .xl\\:w-29rem {
    width: 29rem !important;
  }
  :host ::ng-deep .xl\\:w-30rem {
    width: 30rem !important;
  }
}
:host ::ng-deep .h-full {
  height: 100% !important;
}
:host ::ng-deep .h-screen {
  height: 100vh !important;
}
:host ::ng-deep .h-auto {
  height: auto !important;
}
:host ::ng-deep .h-min {
  height: min-content !important;
}
:host ::ng-deep .h-max {
  height: max-content !important;
}
:host ::ng-deep .h-fit {
  height: -moz-fit-content !important;
  height: fit-content !important;
}
:host ::ng-deep .h-1rem {
  height: 1rem !important;
}
:host ::ng-deep .h-2rem {
  height: 2rem !important;
}
:host ::ng-deep .h-3rem {
  height: 3rem !important;
}
:host ::ng-deep .h-4rem {
  height: 4rem !important;
}
:host ::ng-deep .h-5rem {
  height: 5rem !important;
}
:host ::ng-deep .h-6rem {
  height: 6rem !important;
}
:host ::ng-deep .h-7rem {
  height: 7rem !important;
}
:host ::ng-deep .h-8rem {
  height: 8rem !important;
}
:host ::ng-deep .h-9rem {
  height: 9rem !important;
}
:host ::ng-deep .h-10rem {
  height: 10rem !important;
}
:host ::ng-deep .h-11rem {
  height: 11rem !important;
}
:host ::ng-deep .h-12rem {
  height: 12rem !important;
}
:host ::ng-deep .h-13rem {
  height: 13rem !important;
}
:host ::ng-deep .h-14rem {
  height: 14rem !important;
}
:host ::ng-deep .h-15rem {
  height: 15rem !important;
}
:host ::ng-deep .h-16rem {
  height: 16rem !important;
}
:host ::ng-deep .h-17rem {
  height: 17rem !important;
}
:host ::ng-deep .h-18rem {
  height: 18rem !important;
}
:host ::ng-deep .h-19rem {
  height: 19rem !important;
}
:host ::ng-deep .h-20rem {
  height: 20rem !important;
}
:host ::ng-deep .h-21rem {
  height: 21rem !important;
}
:host ::ng-deep .h-22rem {
  height: 22rem !important;
}
:host ::ng-deep .h-23rem {
  height: 23rem !important;
}
:host ::ng-deep .h-24rem {
  height: 24rem !important;
}
:host ::ng-deep .h-25rem {
  height: 25rem !important;
}
:host ::ng-deep .h-26rem {
  height: 26rem !important;
}
:host ::ng-deep .h-27rem {
  height: 27rem !important;
}
:host ::ng-deep .h-28rem {
  height: 28rem !important;
}
:host ::ng-deep .h-29rem {
  height: 29rem !important;
}
:host ::ng-deep .h-30rem {
  height: 30rem !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:h-full {
    height: 100% !important;
  }
  :host ::ng-deep .sm\\:h-screen {
    height: 100vh !important;
  }
  :host ::ng-deep .sm\\:h-auto {
    height: auto !important;
  }
  :host ::ng-deep .sm\\:h-min {
    height: min-content !important;
  }
  :host ::ng-deep .sm\\:h-max {
    height: max-content !important;
  }
  :host ::ng-deep .sm\\:h-fit {
    height: -moz-fit-content !important;
    height: fit-content !important;
  }
  :host ::ng-deep .sm\\:h-1rem {
    height: 1rem !important;
  }
  :host ::ng-deep .sm\\:h-2rem {
    height: 2rem !important;
  }
  :host ::ng-deep .sm\\:h-3rem {
    height: 3rem !important;
  }
  :host ::ng-deep .sm\\:h-4rem {
    height: 4rem !important;
  }
  :host ::ng-deep .sm\\:h-5rem {
    height: 5rem !important;
  }
  :host ::ng-deep .sm\\:h-6rem {
    height: 6rem !important;
  }
  :host ::ng-deep .sm\\:h-7rem {
    height: 7rem !important;
  }
  :host ::ng-deep .sm\\:h-8rem {
    height: 8rem !important;
  }
  :host ::ng-deep .sm\\:h-9rem {
    height: 9rem !important;
  }
  :host ::ng-deep .sm\\:h-10rem {
    height: 10rem !important;
  }
  :host ::ng-deep .sm\\:h-11rem {
    height: 11rem !important;
  }
  :host ::ng-deep .sm\\:h-12rem {
    height: 12rem !important;
  }
  :host ::ng-deep .sm\\:h-13rem {
    height: 13rem !important;
  }
  :host ::ng-deep .sm\\:h-14rem {
    height: 14rem !important;
  }
  :host ::ng-deep .sm\\:h-15rem {
    height: 15rem !important;
  }
  :host ::ng-deep .sm\\:h-16rem {
    height: 16rem !important;
  }
  :host ::ng-deep .sm\\:h-17rem {
    height: 17rem !important;
  }
  :host ::ng-deep .sm\\:h-18rem {
    height: 18rem !important;
  }
  :host ::ng-deep .sm\\:h-19rem {
    height: 19rem !important;
  }
  :host ::ng-deep .sm\\:h-20rem {
    height: 20rem !important;
  }
  :host ::ng-deep .sm\\:h-21rem {
    height: 21rem !important;
  }
  :host ::ng-deep .sm\\:h-22rem {
    height: 22rem !important;
  }
  :host ::ng-deep .sm\\:h-23rem {
    height: 23rem !important;
  }
  :host ::ng-deep .sm\\:h-24rem {
    height: 24rem !important;
  }
  :host ::ng-deep .sm\\:h-25rem {
    height: 25rem !important;
  }
  :host ::ng-deep .sm\\:h-26rem {
    height: 26rem !important;
  }
  :host ::ng-deep .sm\\:h-27rem {
    height: 27rem !important;
  }
  :host ::ng-deep .sm\\:h-28rem {
    height: 28rem !important;
  }
  :host ::ng-deep .sm\\:h-29rem {
    height: 29rem !important;
  }
  :host ::ng-deep .sm\\:h-30rem {
    height: 30rem !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:h-full {
    height: 100% !important;
  }
  :host ::ng-deep .md\\:h-screen {
    height: 100vh !important;
  }
  :host ::ng-deep .md\\:h-auto {
    height: auto !important;
  }
  :host ::ng-deep .md\\:h-min {
    height: min-content !important;
  }
  :host ::ng-deep .md\\:h-max {
    height: max-content !important;
  }
  :host ::ng-deep .md\\:h-fit {
    height: -moz-fit-content !important;
    height: fit-content !important;
  }
  :host ::ng-deep .md\\:h-1rem {
    height: 1rem !important;
  }
  :host ::ng-deep .md\\:h-2rem {
    height: 2rem !important;
  }
  :host ::ng-deep .md\\:h-3rem {
    height: 3rem !important;
  }
  :host ::ng-deep .md\\:h-4rem {
    height: 4rem !important;
  }
  :host ::ng-deep .md\\:h-5rem {
    height: 5rem !important;
  }
  :host ::ng-deep .md\\:h-6rem {
    height: 6rem !important;
  }
  :host ::ng-deep .md\\:h-7rem {
    height: 7rem !important;
  }
  :host ::ng-deep .md\\:h-8rem {
    height: 8rem !important;
  }
  :host ::ng-deep .md\\:h-9rem {
    height: 9rem !important;
  }
  :host ::ng-deep .md\\:h-10rem {
    height: 10rem !important;
  }
  :host ::ng-deep .md\\:h-11rem {
    height: 11rem !important;
  }
  :host ::ng-deep .md\\:h-12rem {
    height: 12rem !important;
  }
  :host ::ng-deep .md\\:h-13rem {
    height: 13rem !important;
  }
  :host ::ng-deep .md\\:h-14rem {
    height: 14rem !important;
  }
  :host ::ng-deep .md\\:h-15rem {
    height: 15rem !important;
  }
  :host ::ng-deep .md\\:h-16rem {
    height: 16rem !important;
  }
  :host ::ng-deep .md\\:h-17rem {
    height: 17rem !important;
  }
  :host ::ng-deep .md\\:h-18rem {
    height: 18rem !important;
  }
  :host ::ng-deep .md\\:h-19rem {
    height: 19rem !important;
  }
  :host ::ng-deep .md\\:h-20rem {
    height: 20rem !important;
  }
  :host ::ng-deep .md\\:h-21rem {
    height: 21rem !important;
  }
  :host ::ng-deep .md\\:h-22rem {
    height: 22rem !important;
  }
  :host ::ng-deep .md\\:h-23rem {
    height: 23rem !important;
  }
  :host ::ng-deep .md\\:h-24rem {
    height: 24rem !important;
  }
  :host ::ng-deep .md\\:h-25rem {
    height: 25rem !important;
  }
  :host ::ng-deep .md\\:h-26rem {
    height: 26rem !important;
  }
  :host ::ng-deep .md\\:h-27rem {
    height: 27rem !important;
  }
  :host ::ng-deep .md\\:h-28rem {
    height: 28rem !important;
  }
  :host ::ng-deep .md\\:h-29rem {
    height: 29rem !important;
  }
  :host ::ng-deep .md\\:h-30rem {
    height: 30rem !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:h-full {
    height: 100% !important;
  }
  :host ::ng-deep .lg\\:h-screen {
    height: 100vh !important;
  }
  :host ::ng-deep .lg\\:h-auto {
    height: auto !important;
  }
  :host ::ng-deep .lg\\:h-min {
    height: min-content !important;
  }
  :host ::ng-deep .lg\\:h-max {
    height: max-content !important;
  }
  :host ::ng-deep .lg\\:h-fit {
    height: -moz-fit-content !important;
    height: fit-content !important;
  }
  :host ::ng-deep .lg\\:h-1rem {
    height: 1rem !important;
  }
  :host ::ng-deep .lg\\:h-2rem {
    height: 2rem !important;
  }
  :host ::ng-deep .lg\\:h-3rem {
    height: 3rem !important;
  }
  :host ::ng-deep .lg\\:h-4rem {
    height: 4rem !important;
  }
  :host ::ng-deep .lg\\:h-5rem {
    height: 5rem !important;
  }
  :host ::ng-deep .lg\\:h-6rem {
    height: 6rem !important;
  }
  :host ::ng-deep .lg\\:h-7rem {
    height: 7rem !important;
  }
  :host ::ng-deep .lg\\:h-8rem {
    height: 8rem !important;
  }
  :host ::ng-deep .lg\\:h-9rem {
    height: 9rem !important;
  }
  :host ::ng-deep .lg\\:h-10rem {
    height: 10rem !important;
  }
  :host ::ng-deep .lg\\:h-11rem {
    height: 11rem !important;
  }
  :host ::ng-deep .lg\\:h-12rem {
    height: 12rem !important;
  }
  :host ::ng-deep .lg\\:h-13rem {
    height: 13rem !important;
  }
  :host ::ng-deep .lg\\:h-14rem {
    height: 14rem !important;
  }
  :host ::ng-deep .lg\\:h-15rem {
    height: 15rem !important;
  }
  :host ::ng-deep .lg\\:h-16rem {
    height: 16rem !important;
  }
  :host ::ng-deep .lg\\:h-17rem {
    height: 17rem !important;
  }
  :host ::ng-deep .lg\\:h-18rem {
    height: 18rem !important;
  }
  :host ::ng-deep .lg\\:h-19rem {
    height: 19rem !important;
  }
  :host ::ng-deep .lg\\:h-20rem {
    height: 20rem !important;
  }
  :host ::ng-deep .lg\\:h-21rem {
    height: 21rem !important;
  }
  :host ::ng-deep .lg\\:h-22rem {
    height: 22rem !important;
  }
  :host ::ng-deep .lg\\:h-23rem {
    height: 23rem !important;
  }
  :host ::ng-deep .lg\\:h-24rem {
    height: 24rem !important;
  }
  :host ::ng-deep .lg\\:h-25rem {
    height: 25rem !important;
  }
  :host ::ng-deep .lg\\:h-26rem {
    height: 26rem !important;
  }
  :host ::ng-deep .lg\\:h-27rem {
    height: 27rem !important;
  }
  :host ::ng-deep .lg\\:h-28rem {
    height: 28rem !important;
  }
  :host ::ng-deep .lg\\:h-29rem {
    height: 29rem !important;
  }
  :host ::ng-deep .lg\\:h-30rem {
    height: 30rem !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:h-full {
    height: 100% !important;
  }
  :host ::ng-deep .xl\\:h-screen {
    height: 100vh !important;
  }
  :host ::ng-deep .xl\\:h-auto {
    height: auto !important;
  }
  :host ::ng-deep .xl\\:h-min {
    height: min-content !important;
  }
  :host ::ng-deep .xl\\:h-max {
    height: max-content !important;
  }
  :host ::ng-deep .xl\\:h-fit {
    height: -moz-fit-content !important;
    height: fit-content !important;
  }
  :host ::ng-deep .xl\\:h-1rem {
    height: 1rem !important;
  }
  :host ::ng-deep .xl\\:h-2rem {
    height: 2rem !important;
  }
  :host ::ng-deep .xl\\:h-3rem {
    height: 3rem !important;
  }
  :host ::ng-deep .xl\\:h-4rem {
    height: 4rem !important;
  }
  :host ::ng-deep .xl\\:h-5rem {
    height: 5rem !important;
  }
  :host ::ng-deep .xl\\:h-6rem {
    height: 6rem !important;
  }
  :host ::ng-deep .xl\\:h-7rem {
    height: 7rem !important;
  }
  :host ::ng-deep .xl\\:h-8rem {
    height: 8rem !important;
  }
  :host ::ng-deep .xl\\:h-9rem {
    height: 9rem !important;
  }
  :host ::ng-deep .xl\\:h-10rem {
    height: 10rem !important;
  }
  :host ::ng-deep .xl\\:h-11rem {
    height: 11rem !important;
  }
  :host ::ng-deep .xl\\:h-12rem {
    height: 12rem !important;
  }
  :host ::ng-deep .xl\\:h-13rem {
    height: 13rem !important;
  }
  :host ::ng-deep .xl\\:h-14rem {
    height: 14rem !important;
  }
  :host ::ng-deep .xl\\:h-15rem {
    height: 15rem !important;
  }
  :host ::ng-deep .xl\\:h-16rem {
    height: 16rem !important;
  }
  :host ::ng-deep .xl\\:h-17rem {
    height: 17rem !important;
  }
  :host ::ng-deep .xl\\:h-18rem {
    height: 18rem !important;
  }
  :host ::ng-deep .xl\\:h-19rem {
    height: 19rem !important;
  }
  :host ::ng-deep .xl\\:h-20rem {
    height: 20rem !important;
  }
  :host ::ng-deep .xl\\:h-21rem {
    height: 21rem !important;
  }
  :host ::ng-deep .xl\\:h-22rem {
    height: 22rem !important;
  }
  :host ::ng-deep .xl\\:h-23rem {
    height: 23rem !important;
  }
  :host ::ng-deep .xl\\:h-24rem {
    height: 24rem !important;
  }
  :host ::ng-deep .xl\\:h-25rem {
    height: 25rem !important;
  }
  :host ::ng-deep .xl\\:h-26rem {
    height: 26rem !important;
  }
  :host ::ng-deep .xl\\:h-27rem {
    height: 27rem !important;
  }
  :host ::ng-deep .xl\\:h-28rem {
    height: 28rem !important;
  }
  :host ::ng-deep .xl\\:h-29rem {
    height: 29rem !important;
  }
  :host ::ng-deep .xl\\:h-30rem {
    height: 30rem !important;
  }
}
:host ::ng-deep .min-w-0 {
  min-width: 0px !important;
}
:host ::ng-deep .min-w-full {
  min-width: 100% !important;
}
:host ::ng-deep .min-w-screen {
  min-width: 100vw !important;
}
:host ::ng-deep .min-w-min {
  min-width: min-content !important;
}
:host ::ng-deep .min-w-max {
  min-width: max-content !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:min-w-0 {
    min-width: 0px !important;
  }
  :host ::ng-deep .sm\\:min-w-full {
    min-width: 100% !important;
  }
  :host ::ng-deep .sm\\:min-w-screen {
    min-width: 100vw !important;
  }
  :host ::ng-deep .sm\\:min-w-min {
    min-width: min-content !important;
  }
  :host ::ng-deep .sm\\:min-w-max {
    min-width: max-content !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:min-w-0 {
    min-width: 0px !important;
  }
  :host ::ng-deep .md\\:min-w-full {
    min-width: 100% !important;
  }
  :host ::ng-deep .md\\:min-w-screen {
    min-width: 100vw !important;
  }
  :host ::ng-deep .md\\:min-w-min {
    min-width: min-content !important;
  }
  :host ::ng-deep .md\\:min-w-max {
    min-width: max-content !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:min-w-0 {
    min-width: 0px !important;
  }
  :host ::ng-deep .lg\\:min-w-full {
    min-width: 100% !important;
  }
  :host ::ng-deep .lg\\:min-w-screen {
    min-width: 100vw !important;
  }
  :host ::ng-deep .lg\\:min-w-min {
    min-width: min-content !important;
  }
  :host ::ng-deep .lg\\:min-w-max {
    min-width: max-content !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:min-w-0 {
    min-width: 0px !important;
  }
  :host ::ng-deep .xl\\:min-w-full {
    min-width: 100% !important;
  }
  :host ::ng-deep .xl\\:min-w-screen {
    min-width: 100vw !important;
  }
  :host ::ng-deep .xl\\:min-w-min {
    min-width: min-content !important;
  }
  :host ::ng-deep .xl\\:min-w-max {
    min-width: max-content !important;
  }
}
:host ::ng-deep .max-w-0 {
  max-width: 0px !important;
}
:host ::ng-deep .max-w-full {
  max-width: 100% !important;
}
:host ::ng-deep .max-w-screen {
  max-width: 100vw !important;
}
:host ::ng-deep .max-w-min {
  max-width: min-content !important;
}
:host ::ng-deep .max-w-max {
  max-width: max-content !important;
}
:host ::ng-deep .max-w-fit {
  max-width: -moz-fit-content !important;
  max-width: fit-content !important;
}
:host ::ng-deep .max-w-1rem {
  max-width: 1rem !important;
}
:host ::ng-deep .max-w-2rem {
  max-width: 2rem !important;
}
:host ::ng-deep .max-w-3rem {
  max-width: 3rem !important;
}
:host ::ng-deep .max-w-4rem {
  max-width: 4rem !important;
}
:host ::ng-deep .max-w-5rem {
  max-width: 5rem !important;
}
:host ::ng-deep .max-w-6rem {
  max-width: 6rem !important;
}
:host ::ng-deep .max-w-7rem {
  max-width: 7rem !important;
}
:host ::ng-deep .max-w-8rem {
  max-width: 8rem !important;
}
:host ::ng-deep .max-w-9rem {
  max-width: 9rem !important;
}
:host ::ng-deep .max-w-10rem {
  max-width: 10rem !important;
}
:host ::ng-deep .max-w-11rem {
  max-width: 11rem !important;
}
:host ::ng-deep .max-w-12rem {
  max-width: 12rem !important;
}
:host ::ng-deep .max-w-13rem {
  max-width: 13rem !important;
}
:host ::ng-deep .max-w-14rem {
  max-width: 14rem !important;
}
:host ::ng-deep .max-w-15rem {
  max-width: 15rem !important;
}
:host ::ng-deep .max-w-16rem {
  max-width: 16rem !important;
}
:host ::ng-deep .max-w-17rem {
  max-width: 17rem !important;
}
:host ::ng-deep .max-w-18rem {
  max-width: 18rem !important;
}
:host ::ng-deep .max-w-19rem {
  max-width: 19rem !important;
}
:host ::ng-deep .max-w-20rem {
  max-width: 20rem !important;
}
:host ::ng-deep .max-w-21rem {
  max-width: 21rem !important;
}
:host ::ng-deep .max-w-22rem {
  max-width: 22rem !important;
}
:host ::ng-deep .max-w-23rem {
  max-width: 23rem !important;
}
:host ::ng-deep .max-w-24rem {
  max-width: 24rem !important;
}
:host ::ng-deep .max-w-25rem {
  max-width: 25rem !important;
}
:host ::ng-deep .max-w-26rem {
  max-width: 26rem !important;
}
:host ::ng-deep .max-w-27rem {
  max-width: 27rem !important;
}
:host ::ng-deep .max-w-28rem {
  max-width: 28rem !important;
}
:host ::ng-deep .max-w-29rem {
  max-width: 29rem !important;
}
:host ::ng-deep .max-w-30rem {
  max-width: 30rem !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:max-w-0 {
    max-width: 0px !important;
  }
  :host ::ng-deep .sm\\:max-w-full {
    max-width: 100% !important;
  }
  :host ::ng-deep .sm\\:max-w-screen {
    max-width: 100vw !important;
  }
  :host ::ng-deep .sm\\:max-w-min {
    max-width: min-content !important;
  }
  :host ::ng-deep .sm\\:max-w-max {
    max-width: max-content !important;
  }
  :host ::ng-deep .sm\\:max-w-fit {
    max-width: -moz-fit-content !important;
    max-width: fit-content !important;
  }
  :host ::ng-deep .sm\\:max-w-1rem {
    max-width: 1rem !important;
  }
  :host ::ng-deep .sm\\:max-w-2rem {
    max-width: 2rem !important;
  }
  :host ::ng-deep .sm\\:max-w-3rem {
    max-width: 3rem !important;
  }
  :host ::ng-deep .sm\\:max-w-4rem {
    max-width: 4rem !important;
  }
  :host ::ng-deep .sm\\:max-w-5rem {
    max-width: 5rem !important;
  }
  :host ::ng-deep .sm\\:max-w-6rem {
    max-width: 6rem !important;
  }
  :host ::ng-deep .sm\\:max-w-7rem {
    max-width: 7rem !important;
  }
  :host ::ng-deep .sm\\:max-w-8rem {
    max-width: 8rem !important;
  }
  :host ::ng-deep .sm\\:max-w-9rem {
    max-width: 9rem !important;
  }
  :host ::ng-deep .sm\\:max-w-10rem {
    max-width: 10rem !important;
  }
  :host ::ng-deep .sm\\:max-w-11rem {
    max-width: 11rem !important;
  }
  :host ::ng-deep .sm\\:max-w-12rem {
    max-width: 12rem !important;
  }
  :host ::ng-deep .sm\\:max-w-13rem {
    max-width: 13rem !important;
  }
  :host ::ng-deep .sm\\:max-w-14rem {
    max-width: 14rem !important;
  }
  :host ::ng-deep .sm\\:max-w-15rem {
    max-width: 15rem !important;
  }
  :host ::ng-deep .sm\\:max-w-16rem {
    max-width: 16rem !important;
  }
  :host ::ng-deep .sm\\:max-w-17rem {
    max-width: 17rem !important;
  }
  :host ::ng-deep .sm\\:max-w-18rem {
    max-width: 18rem !important;
  }
  :host ::ng-deep .sm\\:max-w-19rem {
    max-width: 19rem !important;
  }
  :host ::ng-deep .sm\\:max-w-20rem {
    max-width: 20rem !important;
  }
  :host ::ng-deep .sm\\:max-w-21rem {
    max-width: 21rem !important;
  }
  :host ::ng-deep .sm\\:max-w-22rem {
    max-width: 22rem !important;
  }
  :host ::ng-deep .sm\\:max-w-23rem {
    max-width: 23rem !important;
  }
  :host ::ng-deep .sm\\:max-w-24rem {
    max-width: 24rem !important;
  }
  :host ::ng-deep .sm\\:max-w-25rem {
    max-width: 25rem !important;
  }
  :host ::ng-deep .sm\\:max-w-26rem {
    max-width: 26rem !important;
  }
  :host ::ng-deep .sm\\:max-w-27rem {
    max-width: 27rem !important;
  }
  :host ::ng-deep .sm\\:max-w-28rem {
    max-width: 28rem !important;
  }
  :host ::ng-deep .sm\\:max-w-29rem {
    max-width: 29rem !important;
  }
  :host ::ng-deep .sm\\:max-w-30rem {
    max-width: 30rem !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:max-w-0 {
    max-width: 0px !important;
  }
  :host ::ng-deep .md\\:max-w-full {
    max-width: 100% !important;
  }
  :host ::ng-deep .md\\:max-w-screen {
    max-width: 100vw !important;
  }
  :host ::ng-deep .md\\:max-w-min {
    max-width: min-content !important;
  }
  :host ::ng-deep .md\\:max-w-max {
    max-width: max-content !important;
  }
  :host ::ng-deep .md\\:max-w-fit {
    max-width: -moz-fit-content !important;
    max-width: fit-content !important;
  }
  :host ::ng-deep .md\\:max-w-1rem {
    max-width: 1rem !important;
  }
  :host ::ng-deep .md\\:max-w-2rem {
    max-width: 2rem !important;
  }
  :host ::ng-deep .md\\:max-w-3rem {
    max-width: 3rem !important;
  }
  :host ::ng-deep .md\\:max-w-4rem {
    max-width: 4rem !important;
  }
  :host ::ng-deep .md\\:max-w-5rem {
    max-width: 5rem !important;
  }
  :host ::ng-deep .md\\:max-w-6rem {
    max-width: 6rem !important;
  }
  :host ::ng-deep .md\\:max-w-7rem {
    max-width: 7rem !important;
  }
  :host ::ng-deep .md\\:max-w-8rem {
    max-width: 8rem !important;
  }
  :host ::ng-deep .md\\:max-w-9rem {
    max-width: 9rem !important;
  }
  :host ::ng-deep .md\\:max-w-10rem {
    max-width: 10rem !important;
  }
  :host ::ng-deep .md\\:max-w-11rem {
    max-width: 11rem !important;
  }
  :host ::ng-deep .md\\:max-w-12rem {
    max-width: 12rem !important;
  }
  :host ::ng-deep .md\\:max-w-13rem {
    max-width: 13rem !important;
  }
  :host ::ng-deep .md\\:max-w-14rem {
    max-width: 14rem !important;
  }
  :host ::ng-deep .md\\:max-w-15rem {
    max-width: 15rem !important;
  }
  :host ::ng-deep .md\\:max-w-16rem {
    max-width: 16rem !important;
  }
  :host ::ng-deep .md\\:max-w-17rem {
    max-width: 17rem !important;
  }
  :host ::ng-deep .md\\:max-w-18rem {
    max-width: 18rem !important;
  }
  :host ::ng-deep .md\\:max-w-19rem {
    max-width: 19rem !important;
  }
  :host ::ng-deep .md\\:max-w-20rem {
    max-width: 20rem !important;
  }
  :host ::ng-deep .md\\:max-w-21rem {
    max-width: 21rem !important;
  }
  :host ::ng-deep .md\\:max-w-22rem {
    max-width: 22rem !important;
  }
  :host ::ng-deep .md\\:max-w-23rem {
    max-width: 23rem !important;
  }
  :host ::ng-deep .md\\:max-w-24rem {
    max-width: 24rem !important;
  }
  :host ::ng-deep .md\\:max-w-25rem {
    max-width: 25rem !important;
  }
  :host ::ng-deep .md\\:max-w-26rem {
    max-width: 26rem !important;
  }
  :host ::ng-deep .md\\:max-w-27rem {
    max-width: 27rem !important;
  }
  :host ::ng-deep .md\\:max-w-28rem {
    max-width: 28rem !important;
  }
  :host ::ng-deep .md\\:max-w-29rem {
    max-width: 29rem !important;
  }
  :host ::ng-deep .md\\:max-w-30rem {
    max-width: 30rem !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:max-w-0 {
    max-width: 0px !important;
  }
  :host ::ng-deep .lg\\:max-w-full {
    max-width: 100% !important;
  }
  :host ::ng-deep .lg\\:max-w-screen {
    max-width: 100vw !important;
  }
  :host ::ng-deep .lg\\:max-w-min {
    max-width: min-content !important;
  }
  :host ::ng-deep .lg\\:max-w-max {
    max-width: max-content !important;
  }
  :host ::ng-deep .lg\\:max-w-fit {
    max-width: -moz-fit-content !important;
    max-width: fit-content !important;
  }
  :host ::ng-deep .lg\\:max-w-1rem {
    max-width: 1rem !important;
  }
  :host ::ng-deep .lg\\:max-w-2rem {
    max-width: 2rem !important;
  }
  :host ::ng-deep .lg\\:max-w-3rem {
    max-width: 3rem !important;
  }
  :host ::ng-deep .lg\\:max-w-4rem {
    max-width: 4rem !important;
  }
  :host ::ng-deep .lg\\:max-w-5rem {
    max-width: 5rem !important;
  }
  :host ::ng-deep .lg\\:max-w-6rem {
    max-width: 6rem !important;
  }
  :host ::ng-deep .lg\\:max-w-7rem {
    max-width: 7rem !important;
  }
  :host ::ng-deep .lg\\:max-w-8rem {
    max-width: 8rem !important;
  }
  :host ::ng-deep .lg\\:max-w-9rem {
    max-width: 9rem !important;
  }
  :host ::ng-deep .lg\\:max-w-10rem {
    max-width: 10rem !important;
  }
  :host ::ng-deep .lg\\:max-w-11rem {
    max-width: 11rem !important;
  }
  :host ::ng-deep .lg\\:max-w-12rem {
    max-width: 12rem !important;
  }
  :host ::ng-deep .lg\\:max-w-13rem {
    max-width: 13rem !important;
  }
  :host ::ng-deep .lg\\:max-w-14rem {
    max-width: 14rem !important;
  }
  :host ::ng-deep .lg\\:max-w-15rem {
    max-width: 15rem !important;
  }
  :host ::ng-deep .lg\\:max-w-16rem {
    max-width: 16rem !important;
  }
  :host ::ng-deep .lg\\:max-w-17rem {
    max-width: 17rem !important;
  }
  :host ::ng-deep .lg\\:max-w-18rem {
    max-width: 18rem !important;
  }
  :host ::ng-deep .lg\\:max-w-19rem {
    max-width: 19rem !important;
  }
  :host ::ng-deep .lg\\:max-w-20rem {
    max-width: 20rem !important;
  }
  :host ::ng-deep .lg\\:max-w-21rem {
    max-width: 21rem !important;
  }
  :host ::ng-deep .lg\\:max-w-22rem {
    max-width: 22rem !important;
  }
  :host ::ng-deep .lg\\:max-w-23rem {
    max-width: 23rem !important;
  }
  :host ::ng-deep .lg\\:max-w-24rem {
    max-width: 24rem !important;
  }
  :host ::ng-deep .lg\\:max-w-25rem {
    max-width: 25rem !important;
  }
  :host ::ng-deep .lg\\:max-w-26rem {
    max-width: 26rem !important;
  }
  :host ::ng-deep .lg\\:max-w-27rem {
    max-width: 27rem !important;
  }
  :host ::ng-deep .lg\\:max-w-28rem {
    max-width: 28rem !important;
  }
  :host ::ng-deep .lg\\:max-w-29rem {
    max-width: 29rem !important;
  }
  :host ::ng-deep .lg\\:max-w-30rem {
    max-width: 30rem !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:max-w-0 {
    max-width: 0px !important;
  }
  :host ::ng-deep .xl\\:max-w-full {
    max-width: 100% !important;
  }
  :host ::ng-deep .xl\\:max-w-screen {
    max-width: 100vw !important;
  }
  :host ::ng-deep .xl\\:max-w-min {
    max-width: min-content !important;
  }
  :host ::ng-deep .xl\\:max-w-max {
    max-width: max-content !important;
  }
  :host ::ng-deep .xl\\:max-w-fit {
    max-width: -moz-fit-content !important;
    max-width: fit-content !important;
  }
  :host ::ng-deep .xl\\:max-w-1rem {
    max-width: 1rem !important;
  }
  :host ::ng-deep .xl\\:max-w-2rem {
    max-width: 2rem !important;
  }
  :host ::ng-deep .xl\\:max-w-3rem {
    max-width: 3rem !important;
  }
  :host ::ng-deep .xl\\:max-w-4rem {
    max-width: 4rem !important;
  }
  :host ::ng-deep .xl\\:max-w-5rem {
    max-width: 5rem !important;
  }
  :host ::ng-deep .xl\\:max-w-6rem {
    max-width: 6rem !important;
  }
  :host ::ng-deep .xl\\:max-w-7rem {
    max-width: 7rem !important;
  }
  :host ::ng-deep .xl\\:max-w-8rem {
    max-width: 8rem !important;
  }
  :host ::ng-deep .xl\\:max-w-9rem {
    max-width: 9rem !important;
  }
  :host ::ng-deep .xl\\:max-w-10rem {
    max-width: 10rem !important;
  }
  :host ::ng-deep .xl\\:max-w-11rem {
    max-width: 11rem !important;
  }
  :host ::ng-deep .xl\\:max-w-12rem {
    max-width: 12rem !important;
  }
  :host ::ng-deep .xl\\:max-w-13rem {
    max-width: 13rem !important;
  }
  :host ::ng-deep .xl\\:max-w-14rem {
    max-width: 14rem !important;
  }
  :host ::ng-deep .xl\\:max-w-15rem {
    max-width: 15rem !important;
  }
  :host ::ng-deep .xl\\:max-w-16rem {
    max-width: 16rem !important;
  }
  :host ::ng-deep .xl\\:max-w-17rem {
    max-width: 17rem !important;
  }
  :host ::ng-deep .xl\\:max-w-18rem {
    max-width: 18rem !important;
  }
  :host ::ng-deep .xl\\:max-w-19rem {
    max-width: 19rem !important;
  }
  :host ::ng-deep .xl\\:max-w-20rem {
    max-width: 20rem !important;
  }
  :host ::ng-deep .xl\\:max-w-21rem {
    max-width: 21rem !important;
  }
  :host ::ng-deep .xl\\:max-w-22rem {
    max-width: 22rem !important;
  }
  :host ::ng-deep .xl\\:max-w-23rem {
    max-width: 23rem !important;
  }
  :host ::ng-deep .xl\\:max-w-24rem {
    max-width: 24rem !important;
  }
  :host ::ng-deep .xl\\:max-w-25rem {
    max-width: 25rem !important;
  }
  :host ::ng-deep .xl\\:max-w-26rem {
    max-width: 26rem !important;
  }
  :host ::ng-deep .xl\\:max-w-27rem {
    max-width: 27rem !important;
  }
  :host ::ng-deep .xl\\:max-w-28rem {
    max-width: 28rem !important;
  }
  :host ::ng-deep .xl\\:max-w-29rem {
    max-width: 29rem !important;
  }
  :host ::ng-deep .xl\\:max-w-30rem {
    max-width: 30rem !important;
  }
}
:host ::ng-deep .min-h-0 {
  min-height: 0px !important;
}
:host ::ng-deep .min-h-full {
  min-height: 100% !important;
}
:host ::ng-deep .min-h-screen {
  min-height: 100vh !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:min-h-0 {
    min-height: 0px !important;
  }
  :host ::ng-deep .sm\\:min-h-full {
    min-height: 100% !important;
  }
  :host ::ng-deep .sm\\:min-h-screen {
    min-height: 100vh !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:min-h-0 {
    min-height: 0px !important;
  }
  :host ::ng-deep .md\\:min-h-full {
    min-height: 100% !important;
  }
  :host ::ng-deep .md\\:min-h-screen {
    min-height: 100vh !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:min-h-0 {
    min-height: 0px !important;
  }
  :host ::ng-deep .lg\\:min-h-full {
    min-height: 100% !important;
  }
  :host ::ng-deep .lg\\:min-h-screen {
    min-height: 100vh !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:min-h-0 {
    min-height: 0px !important;
  }
  :host ::ng-deep .xl\\:min-h-full {
    min-height: 100% !important;
  }
  :host ::ng-deep .xl\\:min-h-screen {
    min-height: 100vh !important;
  }
}
:host ::ng-deep .max-h-0 {
  max-height: 0px !important;
}
:host ::ng-deep .max-h-full {
  max-height: 100% !important;
}
:host ::ng-deep .max-h-screen {
  max-height: 100vh !important;
}
:host ::ng-deep .max-h-min {
  max-height: min-content !important;
}
:host ::ng-deep .max-h-max {
  max-height: max-content !important;
}
:host ::ng-deep .max-h-fit {
  max-height: -moz-fit-content !important;
  max-height: fit-content !important;
}
:host ::ng-deep .max-h-1rem {
  max-height: 1rem !important;
}
:host ::ng-deep .max-h-2rem {
  max-height: 2rem !important;
}
:host ::ng-deep .max-h-3rem {
  max-height: 3rem !important;
}
:host ::ng-deep .max-h-4rem {
  max-height: 4rem !important;
}
:host ::ng-deep .max-h-5rem {
  max-height: 5rem !important;
}
:host ::ng-deep .max-h-6rem {
  max-height: 6rem !important;
}
:host ::ng-deep .max-h-7rem {
  max-height: 7rem !important;
}
:host ::ng-deep .max-h-8rem {
  max-height: 8rem !important;
}
:host ::ng-deep .max-h-9rem {
  max-height: 9rem !important;
}
:host ::ng-deep .max-h-10rem {
  max-height: 10rem !important;
}
:host ::ng-deep .max-h-11rem {
  max-height: 11rem !important;
}
:host ::ng-deep .max-h-12rem {
  max-height: 12rem !important;
}
:host ::ng-deep .max-h-13rem {
  max-height: 13rem !important;
}
:host ::ng-deep .max-h-14rem {
  max-height: 14rem !important;
}
:host ::ng-deep .max-h-15rem {
  max-height: 15rem !important;
}
:host ::ng-deep .max-h-16rem {
  max-height: 16rem !important;
}
:host ::ng-deep .max-h-17rem {
  max-height: 17rem !important;
}
:host ::ng-deep .max-h-18rem {
  max-height: 18rem !important;
}
:host ::ng-deep .max-h-19rem {
  max-height: 19rem !important;
}
:host ::ng-deep .max-h-20rem {
  max-height: 20rem !important;
}
:host ::ng-deep .max-h-21rem {
  max-height: 21rem !important;
}
:host ::ng-deep .max-h-22rem {
  max-height: 22rem !important;
}
:host ::ng-deep .max-h-23rem {
  max-height: 23rem !important;
}
:host ::ng-deep .max-h-24rem {
  max-height: 24rem !important;
}
:host ::ng-deep .max-h-25rem {
  max-height: 25rem !important;
}
:host ::ng-deep .max-h-26rem {
  max-height: 26rem !important;
}
:host ::ng-deep .max-h-27rem {
  max-height: 27rem !important;
}
:host ::ng-deep .max-h-28rem {
  max-height: 28rem !important;
}
:host ::ng-deep .max-h-29rem {
  max-height: 29rem !important;
}
:host ::ng-deep .max-h-30rem {
  max-height: 30rem !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:max-h-0 {
    max-height: 0px !important;
  }
  :host ::ng-deep .sm\\:max-h-full {
    max-height: 100% !important;
  }
  :host ::ng-deep .sm\\:max-h-screen {
    max-height: 100vh !important;
  }
  :host ::ng-deep .sm\\:max-h-min {
    max-height: min-content !important;
  }
  :host ::ng-deep .sm\\:max-h-max {
    max-height: max-content !important;
  }
  :host ::ng-deep .sm\\:max-h-fit {
    max-height: -moz-fit-content !important;
    max-height: fit-content !important;
  }
  :host ::ng-deep .sm\\:max-h-1rem {
    max-height: 1rem !important;
  }
  :host ::ng-deep .sm\\:max-h-2rem {
    max-height: 2rem !important;
  }
  :host ::ng-deep .sm\\:max-h-3rem {
    max-height: 3rem !important;
  }
  :host ::ng-deep .sm\\:max-h-4rem {
    max-height: 4rem !important;
  }
  :host ::ng-deep .sm\\:max-h-5rem {
    max-height: 5rem !important;
  }
  :host ::ng-deep .sm\\:max-h-6rem {
    max-height: 6rem !important;
  }
  :host ::ng-deep .sm\\:max-h-7rem {
    max-height: 7rem !important;
  }
  :host ::ng-deep .sm\\:max-h-8rem {
    max-height: 8rem !important;
  }
  :host ::ng-deep .sm\\:max-h-9rem {
    max-height: 9rem !important;
  }
  :host ::ng-deep .sm\\:max-h-10rem {
    max-height: 10rem !important;
  }
  :host ::ng-deep .sm\\:max-h-11rem {
    max-height: 11rem !important;
  }
  :host ::ng-deep .sm\\:max-h-12rem {
    max-height: 12rem !important;
  }
  :host ::ng-deep .sm\\:max-h-13rem {
    max-height: 13rem !important;
  }
  :host ::ng-deep .sm\\:max-h-14rem {
    max-height: 14rem !important;
  }
  :host ::ng-deep .sm\\:max-h-15rem {
    max-height: 15rem !important;
  }
  :host ::ng-deep .sm\\:max-h-16rem {
    max-height: 16rem !important;
  }
  :host ::ng-deep .sm\\:max-h-17rem {
    max-height: 17rem !important;
  }
  :host ::ng-deep .sm\\:max-h-18rem {
    max-height: 18rem !important;
  }
  :host ::ng-deep .sm\\:max-h-19rem {
    max-height: 19rem !important;
  }
  :host ::ng-deep .sm\\:max-h-20rem {
    max-height: 20rem !important;
  }
  :host ::ng-deep .sm\\:max-h-21rem {
    max-height: 21rem !important;
  }
  :host ::ng-deep .sm\\:max-h-22rem {
    max-height: 22rem !important;
  }
  :host ::ng-deep .sm\\:max-h-23rem {
    max-height: 23rem !important;
  }
  :host ::ng-deep .sm\\:max-h-24rem {
    max-height: 24rem !important;
  }
  :host ::ng-deep .sm\\:max-h-25rem {
    max-height: 25rem !important;
  }
  :host ::ng-deep .sm\\:max-h-26rem {
    max-height: 26rem !important;
  }
  :host ::ng-deep .sm\\:max-h-27rem {
    max-height: 27rem !important;
  }
  :host ::ng-deep .sm\\:max-h-28rem {
    max-height: 28rem !important;
  }
  :host ::ng-deep .sm\\:max-h-29rem {
    max-height: 29rem !important;
  }
  :host ::ng-deep .sm\\:max-h-30rem {
    max-height: 30rem !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:max-h-0 {
    max-height: 0px !important;
  }
  :host ::ng-deep .md\\:max-h-full {
    max-height: 100% !important;
  }
  :host ::ng-deep .md\\:max-h-screen {
    max-height: 100vh !important;
  }
  :host ::ng-deep .md\\:max-h-min {
    max-height: min-content !important;
  }
  :host ::ng-deep .md\\:max-h-max {
    max-height: max-content !important;
  }
  :host ::ng-deep .md\\:max-h-fit {
    max-height: -moz-fit-content !important;
    max-height: fit-content !important;
  }
  :host ::ng-deep .md\\:max-h-1rem {
    max-height: 1rem !important;
  }
  :host ::ng-deep .md\\:max-h-2rem {
    max-height: 2rem !important;
  }
  :host ::ng-deep .md\\:max-h-3rem {
    max-height: 3rem !important;
  }
  :host ::ng-deep .md\\:max-h-4rem {
    max-height: 4rem !important;
  }
  :host ::ng-deep .md\\:max-h-5rem {
    max-height: 5rem !important;
  }
  :host ::ng-deep .md\\:max-h-6rem {
    max-height: 6rem !important;
  }
  :host ::ng-deep .md\\:max-h-7rem {
    max-height: 7rem !important;
  }
  :host ::ng-deep .md\\:max-h-8rem {
    max-height: 8rem !important;
  }
  :host ::ng-deep .md\\:max-h-9rem {
    max-height: 9rem !important;
  }
  :host ::ng-deep .md\\:max-h-10rem {
    max-height: 10rem !important;
  }
  :host ::ng-deep .md\\:max-h-11rem {
    max-height: 11rem !important;
  }
  :host ::ng-deep .md\\:max-h-12rem {
    max-height: 12rem !important;
  }
  :host ::ng-deep .md\\:max-h-13rem {
    max-height: 13rem !important;
  }
  :host ::ng-deep .md\\:max-h-14rem {
    max-height: 14rem !important;
  }
  :host ::ng-deep .md\\:max-h-15rem {
    max-height: 15rem !important;
  }
  :host ::ng-deep .md\\:max-h-16rem {
    max-height: 16rem !important;
  }
  :host ::ng-deep .md\\:max-h-17rem {
    max-height: 17rem !important;
  }
  :host ::ng-deep .md\\:max-h-18rem {
    max-height: 18rem !important;
  }
  :host ::ng-deep .md\\:max-h-19rem {
    max-height: 19rem !important;
  }
  :host ::ng-deep .md\\:max-h-20rem {
    max-height: 20rem !important;
  }
  :host ::ng-deep .md\\:max-h-21rem {
    max-height: 21rem !important;
  }
  :host ::ng-deep .md\\:max-h-22rem {
    max-height: 22rem !important;
  }
  :host ::ng-deep .md\\:max-h-23rem {
    max-height: 23rem !important;
  }
  :host ::ng-deep .md\\:max-h-24rem {
    max-height: 24rem !important;
  }
  :host ::ng-deep .md\\:max-h-25rem {
    max-height: 25rem !important;
  }
  :host ::ng-deep .md\\:max-h-26rem {
    max-height: 26rem !important;
  }
  :host ::ng-deep .md\\:max-h-27rem {
    max-height: 27rem !important;
  }
  :host ::ng-deep .md\\:max-h-28rem {
    max-height: 28rem !important;
  }
  :host ::ng-deep .md\\:max-h-29rem {
    max-height: 29rem !important;
  }
  :host ::ng-deep .md\\:max-h-30rem {
    max-height: 30rem !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:max-h-0 {
    max-height: 0px !important;
  }
  :host ::ng-deep .lg\\:max-h-full {
    max-height: 100% !important;
  }
  :host ::ng-deep .lg\\:max-h-screen {
    max-height: 100vh !important;
  }
  :host ::ng-deep .lg\\:max-h-min {
    max-height: min-content !important;
  }
  :host ::ng-deep .lg\\:max-h-max {
    max-height: max-content !important;
  }
  :host ::ng-deep .lg\\:max-h-fit {
    max-height: -moz-fit-content !important;
    max-height: fit-content !important;
  }
  :host ::ng-deep .lg\\:max-h-1rem {
    max-height: 1rem !important;
  }
  :host ::ng-deep .lg\\:max-h-2rem {
    max-height: 2rem !important;
  }
  :host ::ng-deep .lg\\:max-h-3rem {
    max-height: 3rem !important;
  }
  :host ::ng-deep .lg\\:max-h-4rem {
    max-height: 4rem !important;
  }
  :host ::ng-deep .lg\\:max-h-5rem {
    max-height: 5rem !important;
  }
  :host ::ng-deep .lg\\:max-h-6rem {
    max-height: 6rem !important;
  }
  :host ::ng-deep .lg\\:max-h-7rem {
    max-height: 7rem !important;
  }
  :host ::ng-deep .lg\\:max-h-8rem {
    max-height: 8rem !important;
  }
  :host ::ng-deep .lg\\:max-h-9rem {
    max-height: 9rem !important;
  }
  :host ::ng-deep .lg\\:max-h-10rem {
    max-height: 10rem !important;
  }
  :host ::ng-deep .lg\\:max-h-11rem {
    max-height: 11rem !important;
  }
  :host ::ng-deep .lg\\:max-h-12rem {
    max-height: 12rem !important;
  }
  :host ::ng-deep .lg\\:max-h-13rem {
    max-height: 13rem !important;
  }
  :host ::ng-deep .lg\\:max-h-14rem {
    max-height: 14rem !important;
  }
  :host ::ng-deep .lg\\:max-h-15rem {
    max-height: 15rem !important;
  }
  :host ::ng-deep .lg\\:max-h-16rem {
    max-height: 16rem !important;
  }
  :host ::ng-deep .lg\\:max-h-17rem {
    max-height: 17rem !important;
  }
  :host ::ng-deep .lg\\:max-h-18rem {
    max-height: 18rem !important;
  }
  :host ::ng-deep .lg\\:max-h-19rem {
    max-height: 19rem !important;
  }
  :host ::ng-deep .lg\\:max-h-20rem {
    max-height: 20rem !important;
  }
  :host ::ng-deep .lg\\:max-h-21rem {
    max-height: 21rem !important;
  }
  :host ::ng-deep .lg\\:max-h-22rem {
    max-height: 22rem !important;
  }
  :host ::ng-deep .lg\\:max-h-23rem {
    max-height: 23rem !important;
  }
  :host ::ng-deep .lg\\:max-h-24rem {
    max-height: 24rem !important;
  }
  :host ::ng-deep .lg\\:max-h-25rem {
    max-height: 25rem !important;
  }
  :host ::ng-deep .lg\\:max-h-26rem {
    max-height: 26rem !important;
  }
  :host ::ng-deep .lg\\:max-h-27rem {
    max-height: 27rem !important;
  }
  :host ::ng-deep .lg\\:max-h-28rem {
    max-height: 28rem !important;
  }
  :host ::ng-deep .lg\\:max-h-29rem {
    max-height: 29rem !important;
  }
  :host ::ng-deep .lg\\:max-h-30rem {
    max-height: 30rem !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:max-h-0 {
    max-height: 0px !important;
  }
  :host ::ng-deep .xl\\:max-h-full {
    max-height: 100% !important;
  }
  :host ::ng-deep .xl\\:max-h-screen {
    max-height: 100vh !important;
  }
  :host ::ng-deep .xl\\:max-h-min {
    max-height: min-content !important;
  }
  :host ::ng-deep .xl\\:max-h-max {
    max-height: max-content !important;
  }
  :host ::ng-deep .xl\\:max-h-fit {
    max-height: -moz-fit-content !important;
    max-height: fit-content !important;
  }
  :host ::ng-deep .xl\\:max-h-1rem {
    max-height: 1rem !important;
  }
  :host ::ng-deep .xl\\:max-h-2rem {
    max-height: 2rem !important;
  }
  :host ::ng-deep .xl\\:max-h-3rem {
    max-height: 3rem !important;
  }
  :host ::ng-deep .xl\\:max-h-4rem {
    max-height: 4rem !important;
  }
  :host ::ng-deep .xl\\:max-h-5rem {
    max-height: 5rem !important;
  }
  :host ::ng-deep .xl\\:max-h-6rem {
    max-height: 6rem !important;
  }
  :host ::ng-deep .xl\\:max-h-7rem {
    max-height: 7rem !important;
  }
  :host ::ng-deep .xl\\:max-h-8rem {
    max-height: 8rem !important;
  }
  :host ::ng-deep .xl\\:max-h-9rem {
    max-height: 9rem !important;
  }
  :host ::ng-deep .xl\\:max-h-10rem {
    max-height: 10rem !important;
  }
  :host ::ng-deep .xl\\:max-h-11rem {
    max-height: 11rem !important;
  }
  :host ::ng-deep .xl\\:max-h-12rem {
    max-height: 12rem !important;
  }
  :host ::ng-deep .xl\\:max-h-13rem {
    max-height: 13rem !important;
  }
  :host ::ng-deep .xl\\:max-h-14rem {
    max-height: 14rem !important;
  }
  :host ::ng-deep .xl\\:max-h-15rem {
    max-height: 15rem !important;
  }
  :host ::ng-deep .xl\\:max-h-16rem {
    max-height: 16rem !important;
  }
  :host ::ng-deep .xl\\:max-h-17rem {
    max-height: 17rem !important;
  }
  :host ::ng-deep .xl\\:max-h-18rem {
    max-height: 18rem !important;
  }
  :host ::ng-deep .xl\\:max-h-19rem {
    max-height: 19rem !important;
  }
  :host ::ng-deep .xl\\:max-h-20rem {
    max-height: 20rem !important;
  }
  :host ::ng-deep .xl\\:max-h-21rem {
    max-height: 21rem !important;
  }
  :host ::ng-deep .xl\\:max-h-22rem {
    max-height: 22rem !important;
  }
  :host ::ng-deep .xl\\:max-h-23rem {
    max-height: 23rem !important;
  }
  :host ::ng-deep .xl\\:max-h-24rem {
    max-height: 24rem !important;
  }
  :host ::ng-deep .xl\\:max-h-25rem {
    max-height: 25rem !important;
  }
  :host ::ng-deep .xl\\:max-h-26rem {
    max-height: 26rem !important;
  }
  :host ::ng-deep .xl\\:max-h-27rem {
    max-height: 27rem !important;
  }
  :host ::ng-deep .xl\\:max-h-28rem {
    max-height: 28rem !important;
  }
  :host ::ng-deep .xl\\:max-h-29rem {
    max-height: 29rem !important;
  }
  :host ::ng-deep .xl\\:max-h-30rem {
    max-height: 30rem !important;
  }
}
:host ::ng-deep .static {
  position: static !important;
}
:host ::ng-deep .fixed {
  position: fixed !important;
}
:host ::ng-deep .absolute {
  position: absolute !important;
}
:host ::ng-deep .relative {
  position: relative !important;
}
:host ::ng-deep .sticky {
  position: sticky !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:static {
    position: static !important;
  }
  :host ::ng-deep .sm\\:fixed {
    position: fixed !important;
  }
  :host ::ng-deep .sm\\:absolute {
    position: absolute !important;
  }
  :host ::ng-deep .sm\\:relative {
    position: relative !important;
  }
  :host ::ng-deep .sm\\:sticky {
    position: sticky !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:static {
    position: static !important;
  }
  :host ::ng-deep .md\\:fixed {
    position: fixed !important;
  }
  :host ::ng-deep .md\\:absolute {
    position: absolute !important;
  }
  :host ::ng-deep .md\\:relative {
    position: relative !important;
  }
  :host ::ng-deep .md\\:sticky {
    position: sticky !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:static {
    position: static !important;
  }
  :host ::ng-deep .lg\\:fixed {
    position: fixed !important;
  }
  :host ::ng-deep .lg\\:absolute {
    position: absolute !important;
  }
  :host ::ng-deep .lg\\:relative {
    position: relative !important;
  }
  :host ::ng-deep .lg\\:sticky {
    position: sticky !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:static {
    position: static !important;
  }
  :host ::ng-deep .xl\\:fixed {
    position: fixed !important;
  }
  :host ::ng-deep .xl\\:absolute {
    position: absolute !important;
  }
  :host ::ng-deep .xl\\:relative {
    position: relative !important;
  }
  :host ::ng-deep .xl\\:sticky {
    position: sticky !important;
  }
}
:host ::ng-deep .top-auto {
  top: auto !important;
}
:host ::ng-deep .top-0 {
  top: 0 !important;
}
:host ::ng-deep .top-50 {
  top: 50% !important;
}
:host ::ng-deep .top-100 {
  top: 100% !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:top-auto {
    top: auto !important;
  }
  :host ::ng-deep .sm\\:top-0 {
    top: 0 !important;
  }
  :host ::ng-deep .sm\\:top-50 {
    top: 50% !important;
  }
  :host ::ng-deep .sm\\:top-100 {
    top: 100% !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:top-auto {
    top: auto !important;
  }
  :host ::ng-deep .md\\:top-0 {
    top: 0 !important;
  }
  :host ::ng-deep .md\\:top-50 {
    top: 50% !important;
  }
  :host ::ng-deep .md\\:top-100 {
    top: 100% !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:top-auto {
    top: auto !important;
  }
  :host ::ng-deep .lg\\:top-0 {
    top: 0 !important;
  }
  :host ::ng-deep .lg\\:top-50 {
    top: 50% !important;
  }
  :host ::ng-deep .lg\\:top-100 {
    top: 100% !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:top-auto {
    top: auto !important;
  }
  :host ::ng-deep .xl\\:top-0 {
    top: 0 !important;
  }
  :host ::ng-deep .xl\\:top-50 {
    top: 50% !important;
  }
  :host ::ng-deep .xl\\:top-100 {
    top: 100% !important;
  }
}
:host ::ng-deep .left-auto {
  left: auto !important;
}
:host ::ng-deep .left-0 {
  left: 0 !important;
}
:host ::ng-deep .left-50 {
  left: 50% !important;
}
:host ::ng-deep .left-100 {
  left: 100% !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:left-auto {
    left: auto !important;
  }
  :host ::ng-deep .sm\\:left-0 {
    left: 0 !important;
  }
  :host ::ng-deep .sm\\:left-50 {
    left: 50% !important;
  }
  :host ::ng-deep .sm\\:left-100 {
    left: 100% !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:left-auto {
    left: auto !important;
  }
  :host ::ng-deep .md\\:left-0 {
    left: 0 !important;
  }
  :host ::ng-deep .md\\:left-50 {
    left: 50% !important;
  }
  :host ::ng-deep .md\\:left-100 {
    left: 100% !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:left-auto {
    left: auto !important;
  }
  :host ::ng-deep .lg\\:left-0 {
    left: 0 !important;
  }
  :host ::ng-deep .lg\\:left-50 {
    left: 50% !important;
  }
  :host ::ng-deep .lg\\:left-100 {
    left: 100% !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:left-auto {
    left: auto !important;
  }
  :host ::ng-deep .xl\\:left-0 {
    left: 0 !important;
  }
  :host ::ng-deep .xl\\:left-50 {
    left: 50% !important;
  }
  :host ::ng-deep .xl\\:left-100 {
    left: 100% !important;
  }
}
:host ::ng-deep .right-auto {
  right: auto !important;
}
:host ::ng-deep .right-0 {
  right: 0 !important;
}
:host ::ng-deep .right-50 {
  right: 50% !important;
}
:host ::ng-deep .right-100 {
  right: 100% !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:right-auto {
    right: auto !important;
  }
  :host ::ng-deep .sm\\:right-0 {
    right: 0 !important;
  }
  :host ::ng-deep .sm\\:right-50 {
    right: 50% !important;
  }
  :host ::ng-deep .sm\\:right-100 {
    right: 100% !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:right-auto {
    right: auto !important;
  }
  :host ::ng-deep .md\\:right-0 {
    right: 0 !important;
  }
  :host ::ng-deep .md\\:right-50 {
    right: 50% !important;
  }
  :host ::ng-deep .md\\:right-100 {
    right: 100% !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:right-auto {
    right: auto !important;
  }
  :host ::ng-deep .lg\\:right-0 {
    right: 0 !important;
  }
  :host ::ng-deep .lg\\:right-50 {
    right: 50% !important;
  }
  :host ::ng-deep .lg\\:right-100 {
    right: 100% !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:right-auto {
    right: auto !important;
  }
  :host ::ng-deep .xl\\:right-0 {
    right: 0 !important;
  }
  :host ::ng-deep .xl\\:right-50 {
    right: 50% !important;
  }
  :host ::ng-deep .xl\\:right-100 {
    right: 100% !important;
  }
}
:host ::ng-deep .bottom-auto {
  bottom: auto !important;
}
:host ::ng-deep .bottom-0 {
  bottom: 0 !important;
}
:host ::ng-deep .bottom-50 {
  bottom: 50% !important;
}
:host ::ng-deep .bottom-100 {
  bottom: 100% !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:bottom-auto {
    bottom: auto !important;
  }
  :host ::ng-deep .sm\\:bottom-0 {
    bottom: 0 !important;
  }
  :host ::ng-deep .sm\\:bottom-50 {
    bottom: 50% !important;
  }
  :host ::ng-deep .sm\\:bottom-100 {
    bottom: 100% !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:bottom-auto {
    bottom: auto !important;
  }
  :host ::ng-deep .md\\:bottom-0 {
    bottom: 0 !important;
  }
  :host ::ng-deep .md\\:bottom-50 {
    bottom: 50% !important;
  }
  :host ::ng-deep .md\\:bottom-100 {
    bottom: 100% !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:bottom-auto {
    bottom: auto !important;
  }
  :host ::ng-deep .lg\\:bottom-0 {
    bottom: 0 !important;
  }
  :host ::ng-deep .lg\\:bottom-50 {
    bottom: 50% !important;
  }
  :host ::ng-deep .lg\\:bottom-100 {
    bottom: 100% !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:bottom-auto {
    bottom: auto !important;
  }
  :host ::ng-deep .xl\\:bottom-0 {
    bottom: 0 !important;
  }
  :host ::ng-deep .xl\\:bottom-50 {
    bottom: 50% !important;
  }
  :host ::ng-deep .xl\\:bottom-100 {
    bottom: 100% !important;
  }
}
:host ::ng-deep .overflow-auto {
  overflow: auto !important;
}
:host ::ng-deep .overflow-hidden {
  overflow: hidden !important;
}
:host ::ng-deep .overflow-visible {
  overflow: visible !important;
}
:host ::ng-deep .overflow-scroll {
  overflow: scroll !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:overflow-auto {
    overflow: auto !important;
  }
  :host ::ng-deep .sm\\:overflow-hidden {
    overflow: hidden !important;
  }
  :host ::ng-deep .sm\\:overflow-visible {
    overflow: visible !important;
  }
  :host ::ng-deep .sm\\:overflow-scroll {
    overflow: scroll !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:overflow-auto {
    overflow: auto !important;
  }
  :host ::ng-deep .md\\:overflow-hidden {
    overflow: hidden !important;
  }
  :host ::ng-deep .md\\:overflow-visible {
    overflow: visible !important;
  }
  :host ::ng-deep .md\\:overflow-scroll {
    overflow: scroll !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:overflow-auto {
    overflow: auto !important;
  }
  :host ::ng-deep .lg\\:overflow-hidden {
    overflow: hidden !important;
  }
  :host ::ng-deep .lg\\:overflow-visible {
    overflow: visible !important;
  }
  :host ::ng-deep .lg\\:overflow-scroll {
    overflow: scroll !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:overflow-auto {
    overflow: auto !important;
  }
  :host ::ng-deep .xl\\:overflow-hidden {
    overflow: hidden !important;
  }
  :host ::ng-deep .xl\\:overflow-visible {
    overflow: visible !important;
  }
  :host ::ng-deep .xl\\:overflow-scroll {
    overflow: scroll !important;
  }
}
:host ::ng-deep .overflow-x-auto {
  overflow-x: auto !important;
}
:host ::ng-deep .overflow-x-hidden {
  overflow-x: hidden !important;
}
:host ::ng-deep .overflow-x-visible {
  overflow-x: visible !important;
}
:host ::ng-deep .overflow-x-scroll {
  overflow-x: scroll !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:overflow-x-auto {
    overflow-x: auto !important;
  }
  :host ::ng-deep .sm\\:overflow-x-hidden {
    overflow-x: hidden !important;
  }
  :host ::ng-deep .sm\\:overflow-x-visible {
    overflow-x: visible !important;
  }
  :host ::ng-deep .sm\\:overflow-x-scroll {
    overflow-x: scroll !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:overflow-x-auto {
    overflow-x: auto !important;
  }
  :host ::ng-deep .md\\:overflow-x-hidden {
    overflow-x: hidden !important;
  }
  :host ::ng-deep .md\\:overflow-x-visible {
    overflow-x: visible !important;
  }
  :host ::ng-deep .md\\:overflow-x-scroll {
    overflow-x: scroll !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:overflow-x-auto {
    overflow-x: auto !important;
  }
  :host ::ng-deep .lg\\:overflow-x-hidden {
    overflow-x: hidden !important;
  }
  :host ::ng-deep .lg\\:overflow-x-visible {
    overflow-x: visible !important;
  }
  :host ::ng-deep .lg\\:overflow-x-scroll {
    overflow-x: scroll !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:overflow-x-auto {
    overflow-x: auto !important;
  }
  :host ::ng-deep .xl\\:overflow-x-hidden {
    overflow-x: hidden !important;
  }
  :host ::ng-deep .xl\\:overflow-x-visible {
    overflow-x: visible !important;
  }
  :host ::ng-deep .xl\\:overflow-x-scroll {
    overflow-x: scroll !important;
  }
}
:host ::ng-deep .overflow-y-auto {
  overflow-y: auto !important;
}
:host ::ng-deep .overflow-y-hidden {
  overflow-y: hidden !important;
}
:host ::ng-deep .overflow-y-visible {
  overflow-y: visible !important;
}
:host ::ng-deep .overflow-y-scroll {
  overflow-y: scroll !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:overflow-y-auto {
    overflow-y: auto !important;
  }
  :host ::ng-deep .sm\\:overflow-y-hidden {
    overflow-y: hidden !important;
  }
  :host ::ng-deep .sm\\:overflow-y-visible {
    overflow-y: visible !important;
  }
  :host ::ng-deep .sm\\:overflow-y-scroll {
    overflow-y: scroll !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:overflow-y-auto {
    overflow-y: auto !important;
  }
  :host ::ng-deep .md\\:overflow-y-hidden {
    overflow-y: hidden !important;
  }
  :host ::ng-deep .md\\:overflow-y-visible {
    overflow-y: visible !important;
  }
  :host ::ng-deep .md\\:overflow-y-scroll {
    overflow-y: scroll !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:overflow-y-auto {
    overflow-y: auto !important;
  }
  :host ::ng-deep .lg\\:overflow-y-hidden {
    overflow-y: hidden !important;
  }
  :host ::ng-deep .lg\\:overflow-y-visible {
    overflow-y: visible !important;
  }
  :host ::ng-deep .lg\\:overflow-y-scroll {
    overflow-y: scroll !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:overflow-y-auto {
    overflow-y: auto !important;
  }
  :host ::ng-deep .xl\\:overflow-y-hidden {
    overflow-y: hidden !important;
  }
  :host ::ng-deep .xl\\:overflow-y-visible {
    overflow-y: visible !important;
  }
  :host ::ng-deep .xl\\:overflow-y-scroll {
    overflow-y: scroll !important;
  }
}
:host ::ng-deep .z-auto {
  z-index: auto !important;
}
:host ::ng-deep .z-0 {
  z-index: 0 !important;
}
:host ::ng-deep .z-1 {
  z-index: 1 !important;
}
:host ::ng-deep .z-2 {
  z-index: 2 !important;
}
:host ::ng-deep .z-3 {
  z-index: 3 !important;
}
:host ::ng-deep .z-4 {
  z-index: 4 !important;
}
:host ::ng-deep .z-5 {
  z-index: 5 !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:z-auto {
    z-index: auto !important;
  }
  :host ::ng-deep .sm\\:z-0 {
    z-index: 0 !important;
  }
  :host ::ng-deep .sm\\:z-1 {
    z-index: 1 !important;
  }
  :host ::ng-deep .sm\\:z-2 {
    z-index: 2 !important;
  }
  :host ::ng-deep .sm\\:z-3 {
    z-index: 3 !important;
  }
  :host ::ng-deep .sm\\:z-4 {
    z-index: 4 !important;
  }
  :host ::ng-deep .sm\\:z-5 {
    z-index: 5 !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:z-auto {
    z-index: auto !important;
  }
  :host ::ng-deep .md\\:z-0 {
    z-index: 0 !important;
  }
  :host ::ng-deep .md\\:z-1 {
    z-index: 1 !important;
  }
  :host ::ng-deep .md\\:z-2 {
    z-index: 2 !important;
  }
  :host ::ng-deep .md\\:z-3 {
    z-index: 3 !important;
  }
  :host ::ng-deep .md\\:z-4 {
    z-index: 4 !important;
  }
  :host ::ng-deep .md\\:z-5 {
    z-index: 5 !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:z-auto {
    z-index: auto !important;
  }
  :host ::ng-deep .lg\\:z-0 {
    z-index: 0 !important;
  }
  :host ::ng-deep .lg\\:z-1 {
    z-index: 1 !important;
  }
  :host ::ng-deep .lg\\:z-2 {
    z-index: 2 !important;
  }
  :host ::ng-deep .lg\\:z-3 {
    z-index: 3 !important;
  }
  :host ::ng-deep .lg\\:z-4 {
    z-index: 4 !important;
  }
  :host ::ng-deep .lg\\:z-5 {
    z-index: 5 !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:z-auto {
    z-index: auto !important;
  }
  :host ::ng-deep .xl\\:z-0 {
    z-index: 0 !important;
  }
  :host ::ng-deep .xl\\:z-1 {
    z-index: 1 !important;
  }
  :host ::ng-deep .xl\\:z-2 {
    z-index: 2 !important;
  }
  :host ::ng-deep .xl\\:z-3 {
    z-index: 3 !important;
  }
  :host ::ng-deep .xl\\:z-4 {
    z-index: 4 !important;
  }
  :host ::ng-deep .xl\\:z-5 {
    z-index: 5 !important;
  }
}
:host ::ng-deep .bg-repeat {
  background-repeat: repeat !important;
}
:host ::ng-deep .bg-no-repeat {
  background-repeat: no-repeat !important;
}
:host ::ng-deep .bg-repeat-x {
  background-repeat: repeat-x !important;
}
:host ::ng-deep .bg-repeat-y {
  background-repeat: repeat-y !important;
}
:host ::ng-deep .bg-repeat-round {
  background-repeat: round !important;
}
:host ::ng-deep .bg-repeat-space {
  background-repeat: space !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:bg-repeat {
    background-repeat: repeat !important;
  }
  :host ::ng-deep .sm\\:bg-no-repeat {
    background-repeat: no-repeat !important;
  }
  :host ::ng-deep .sm\\:bg-repeat-x {
    background-repeat: repeat-x !important;
  }
  :host ::ng-deep .sm\\:bg-repeat-y {
    background-repeat: repeat-y !important;
  }
  :host ::ng-deep .sm\\:bg-repeat-round {
    background-repeat: round !important;
  }
  :host ::ng-deep .sm\\:bg-repeat-space {
    background-repeat: space !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:bg-repeat {
    background-repeat: repeat !important;
  }
  :host ::ng-deep .md\\:bg-no-repeat {
    background-repeat: no-repeat !important;
  }
  :host ::ng-deep .md\\:bg-repeat-x {
    background-repeat: repeat-x !important;
  }
  :host ::ng-deep .md\\:bg-repeat-y {
    background-repeat: repeat-y !important;
  }
  :host ::ng-deep .md\\:bg-repeat-round {
    background-repeat: round !important;
  }
  :host ::ng-deep .md\\:bg-repeat-space {
    background-repeat: space !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:bg-repeat {
    background-repeat: repeat !important;
  }
  :host ::ng-deep .lg\\:bg-no-repeat {
    background-repeat: no-repeat !important;
  }
  :host ::ng-deep .lg\\:bg-repeat-x {
    background-repeat: repeat-x !important;
  }
  :host ::ng-deep .lg\\:bg-repeat-y {
    background-repeat: repeat-y !important;
  }
  :host ::ng-deep .lg\\:bg-repeat-round {
    background-repeat: round !important;
  }
  :host ::ng-deep .lg\\:bg-repeat-space {
    background-repeat: space !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:bg-repeat {
    background-repeat: repeat !important;
  }
  :host ::ng-deep .xl\\:bg-no-repeat {
    background-repeat: no-repeat !important;
  }
  :host ::ng-deep .xl\\:bg-repeat-x {
    background-repeat: repeat-x !important;
  }
  :host ::ng-deep .xl\\:bg-repeat-y {
    background-repeat: repeat-y !important;
  }
  :host ::ng-deep .xl\\:bg-repeat-round {
    background-repeat: round !important;
  }
  :host ::ng-deep .xl\\:bg-repeat-space {
    background-repeat: space !important;
  }
}
:host ::ng-deep .bg-auto {
  background-size: auto !important;
}
:host ::ng-deep .bg-cover {
  background-size: cover !important;
}
:host ::ng-deep .bg-contain {
  background-size: contain !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:bg-auto {
    background-size: auto !important;
  }
  :host ::ng-deep .sm\\:bg-cover {
    background-size: cover !important;
  }
  :host ::ng-deep .sm\\:bg-contain {
    background-size: contain !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:bg-auto {
    background-size: auto !important;
  }
  :host ::ng-deep .md\\:bg-cover {
    background-size: cover !important;
  }
  :host ::ng-deep .md\\:bg-contain {
    background-size: contain !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:bg-auto {
    background-size: auto !important;
  }
  :host ::ng-deep .lg\\:bg-cover {
    background-size: cover !important;
  }
  :host ::ng-deep .lg\\:bg-contain {
    background-size: contain !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:bg-auto {
    background-size: auto !important;
  }
  :host ::ng-deep .xl\\:bg-cover {
    background-size: cover !important;
  }
  :host ::ng-deep .xl\\:bg-contain {
    background-size: contain !important;
  }
}
:host ::ng-deep .bg-bottom {
  background-position: bottom !important;
}
:host ::ng-deep .bg-center {
  background-position: center !important;
}
:host ::ng-deep .bg-left {
  background-position: left !important;
}
:host ::ng-deep .bg-left-bottom {
  background-position: left bottom !important;
}
:host ::ng-deep .bg-left-top {
  background-position: left top !important;
}
:host ::ng-deep .bg-right {
  background-position: right !important;
}
:host ::ng-deep .bg-right-bottom {
  background-position: right bottom !important;
}
:host ::ng-deep .bg-right-top {
  background-position: right top !important;
}
:host ::ng-deep .bg-top {
  background-position: top !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:bg-bottom {
    background-position: bottom !important;
  }
  :host ::ng-deep .sm\\:bg-center {
    background-position: center !important;
  }
  :host ::ng-deep .sm\\:bg-left {
    background-position: left !important;
  }
  :host ::ng-deep .sm\\:bg-left-bottom {
    background-position: left bottom !important;
  }
  :host ::ng-deep .sm\\:bg-left-top {
    background-position: left top !important;
  }
  :host ::ng-deep .sm\\:bg-right {
    background-position: right !important;
  }
  :host ::ng-deep .sm\\:bg-right-bottom {
    background-position: right bottom !important;
  }
  :host ::ng-deep .sm\\:bg-right-top {
    background-position: right top !important;
  }
  :host ::ng-deep .sm\\:bg-top {
    background-position: top !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:bg-bottom {
    background-position: bottom !important;
  }
  :host ::ng-deep .md\\:bg-center {
    background-position: center !important;
  }
  :host ::ng-deep .md\\:bg-left {
    background-position: left !important;
  }
  :host ::ng-deep .md\\:bg-left-bottom {
    background-position: left bottom !important;
  }
  :host ::ng-deep .md\\:bg-left-top {
    background-position: left top !important;
  }
  :host ::ng-deep .md\\:bg-right {
    background-position: right !important;
  }
  :host ::ng-deep .md\\:bg-right-bottom {
    background-position: right bottom !important;
  }
  :host ::ng-deep .md\\:bg-right-top {
    background-position: right top !important;
  }
  :host ::ng-deep .md\\:bg-top {
    background-position: top !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:bg-bottom {
    background-position: bottom !important;
  }
  :host ::ng-deep .lg\\:bg-center {
    background-position: center !important;
  }
  :host ::ng-deep .lg\\:bg-left {
    background-position: left !important;
  }
  :host ::ng-deep .lg\\:bg-left-bottom {
    background-position: left bottom !important;
  }
  :host ::ng-deep .lg\\:bg-left-top {
    background-position: left top !important;
  }
  :host ::ng-deep .lg\\:bg-right {
    background-position: right !important;
  }
  :host ::ng-deep .lg\\:bg-right-bottom {
    background-position: right bottom !important;
  }
  :host ::ng-deep .lg\\:bg-right-top {
    background-position: right top !important;
  }
  :host ::ng-deep .lg\\:bg-top {
    background-position: top !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:bg-bottom {
    background-position: bottom !important;
  }
  :host ::ng-deep .xl\\:bg-center {
    background-position: center !important;
  }
  :host ::ng-deep .xl\\:bg-left {
    background-position: left !important;
  }
  :host ::ng-deep .xl\\:bg-left-bottom {
    background-position: left bottom !important;
  }
  :host ::ng-deep .xl\\:bg-left-top {
    background-position: left top !important;
  }
  :host ::ng-deep .xl\\:bg-right {
    background-position: right !important;
  }
  :host ::ng-deep .xl\\:bg-right-bottom {
    background-position: right bottom !important;
  }
  :host ::ng-deep .xl\\:bg-right-top {
    background-position: right top !important;
  }
  :host ::ng-deep .xl\\:bg-top {
    background-position: top !important;
  }
}
:host ::ng-deep .list-none {
  list-style: none !important;
}
:host ::ng-deep .list-disc {
  list-style: disc !important;
}
:host ::ng-deep .list-decimal {
  list-style: decimal !important;
}
:host ::ng-deep .appearance-none {
  appearance: none !important;
}
:host ::ng-deep .outline-none {
  outline: none !important;
}
:host ::ng-deep .pointer-events-none {
  pointer-events: none !important;
}
:host ::ng-deep .pointer-events-auto {
  pointer-events: auto !important;
}
:host ::ng-deep .cursor-auto {
  cursor: auto !important;
}
:host ::ng-deep .cursor-pointer {
  cursor: pointer !important;
}
:host ::ng-deep .cursor-wait {
  cursor: wait !important;
}
:host ::ng-deep .cursor-move {
  cursor: move !important;
}
:host ::ng-deep .select-none {
  -webkit-user-select: none !important;
  user-select: none !important;
}
:host ::ng-deep .select-text {
  -webkit-user-select: text !important;
  user-select: text !important;
}
:host ::ng-deep .select-all {
  -webkit-user-select: all !important;
  user-select: all !important;
}
:host ::ng-deep .select-auto {
  -webkit-user-select: auto !important;
  user-select: auto !important;
}
:host ::ng-deep .opacity-0 {
  opacity: 0 !important;
}
:host ::ng-deep .opacity-10 {
  opacity: 0.1 !important;
}
:host ::ng-deep .opacity-20 {
  opacity: 0.2 !important;
}
:host ::ng-deep .opacity-30 {
  opacity: 0.3 !important;
}
:host ::ng-deep .opacity-40 {
  opacity: 0.4 !important;
}
:host ::ng-deep .opacity-50 {
  opacity: 0.5 !important;
}
:host ::ng-deep .opacity-60 {
  opacity: 0.6 !important;
}
:host ::ng-deep .opacity-70 {
  opacity: 0.7 !important;
}
:host ::ng-deep .opacity-80 {
  opacity: 0.8 !important;
}
:host ::ng-deep .opacity-90 {
  opacity: 0.9 !important;
}
:host ::ng-deep .opacity-100 {
  opacity: 1 !important;
}
:host ::ng-deep .reset {
  all: unset;
}
:host ::ng-deep .transition-none {
  transition-property: none !important;
}
:host ::ng-deep .transition-all {
  transition-property: all !important;
}
:host ::ng-deep .transition-colors {
  transition-property: background-color, border-color, color !important;
}
:host ::ng-deep .transition-transform {
  transition-property: transform !important;
}
:host ::ng-deep .transition-duration-100 {
  transition-duration: 0.1s !important;
}
:host ::ng-deep .transition-duration-150 {
  transition-duration: 0.15s !important;
}
:host ::ng-deep .transition-duration-200 {
  transition-duration: 0.2s !important;
}
:host ::ng-deep .transition-duration-300 {
  transition-duration: 0.3s !important;
}
:host ::ng-deep .transition-duration-400 {
  transition-duration: 0.4s !important;
}
:host ::ng-deep .transition-duration-500 {
  transition-duration: 0.5s !important;
}
:host ::ng-deep .transition-duration-1000 {
  transition-duration: 1s !important;
}
:host ::ng-deep .transition-duration-2000 {
  transition-duration: 2s !important;
}
:host ::ng-deep .transition-duration-3000 {
  transition-duration: 3s !important;
}
:host ::ng-deep .transition-linear {
  transition-timing-function: linear !important;
}
:host ::ng-deep .transition-ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1) !important;
}
:host ::ng-deep .transition-ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1) !important;
}
:host ::ng-deep .transition-ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}
:host ::ng-deep .transition-delay-100 {
  transition-delay: 0.1s !important;
}
:host ::ng-deep .transition-delay-150 {
  transition-delay: 0.15s !important;
}
:host ::ng-deep .transition-delay-200 {
  transition-delay: 0.2s !important;
}
:host ::ng-deep .transition-delay-300 {
  transition-delay: 0.3s !important;
}
:host ::ng-deep .transition-delay-400 {
  transition-delay: 0.4s !important;
}
:host ::ng-deep .transition-delay-500 {
  transition-delay: 0.5s !important;
}
:host ::ng-deep .transition-delay-1000 {
  transition-delay: 1s !important;
}
:host ::ng-deep .translate-x-0 {
  transform: translate(0) !important;
}
:host ::ng-deep .translate-x-100 {
  transform: translate(100%) !important;
}
:host ::ng-deep .-translate-x-100 {
  transform: translate(-100%) !important;
}
:host ::ng-deep .translate-y-0 {
  transform: translateY(0) !important;
}
:host ::ng-deep .translate-y-100 {
  transform: translateY(100%) !important;
}
:host ::ng-deep .-translate-y-100 {
  transform: translateY(-100%) !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:translate-x-0 {
    transform: translate(0) !important;
  }
  :host ::ng-deep .sm\\:translate-x-100 {
    transform: translate(100%) !important;
  }
  :host ::ng-deep .sm\\:-translate-x-100 {
    transform: translate(-100%) !important;
  }
  :host ::ng-deep .sm\\:translate-y-0 {
    transform: translateY(0) !important;
  }
  :host ::ng-deep .sm\\:translate-y-100 {
    transform: translateY(100%) !important;
  }
  :host ::ng-deep .sm\\:-translate-y-100 {
    transform: translateY(-100%) !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:translate-x-0 {
    transform: translate(0) !important;
  }
  :host ::ng-deep .md\\:translate-x-100 {
    transform: translate(100%) !important;
  }
  :host ::ng-deep .md\\:-translate-x-100 {
    transform: translate(-100%) !important;
  }
  :host ::ng-deep .md\\:translate-y-0 {
    transform: translateY(0) !important;
  }
  :host ::ng-deep .md\\:translate-y-100 {
    transform: translateY(100%) !important;
  }
  :host ::ng-deep .md\\:-translate-y-100 {
    transform: translateY(-100%) !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:translate-x-0 {
    transform: translate(0) !important;
  }
  :host ::ng-deep .lg\\:translate-x-100 {
    transform: translate(100%) !important;
  }
  :host ::ng-deep .lg\\:-translate-x-100 {
    transform: translate(-100%) !important;
  }
  :host ::ng-deep .lg\\:translate-y-0 {
    transform: translateY(0) !important;
  }
  :host ::ng-deep .lg\\:translate-y-100 {
    transform: translateY(100%) !important;
  }
  :host ::ng-deep .lg\\:-translate-y-100 {
    transform: translateY(-100%) !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:translate-x-0 {
    transform: translate(0) !important;
  }
  :host ::ng-deep .xl\\:translate-x-100 {
    transform: translate(100%) !important;
  }
  :host ::ng-deep .xl\\:-translate-x-100 {
    transform: translate(-100%) !important;
  }
  :host ::ng-deep .xl\\:translate-y-0 {
    transform: translateY(0) !important;
  }
  :host ::ng-deep .xl\\:translate-y-100 {
    transform: translateY(100%) !important;
  }
  :host ::ng-deep .xl\\:-translate-y-100 {
    transform: translateY(-100%) !important;
  }
}
:host ::ng-deep .rotate-45 {
  transform: rotate(45deg) !important;
}
:host ::ng-deep .-rotate-45 {
  transform: rotate(-45deg) !important;
}
:host ::ng-deep .rotate-90 {
  transform: rotate(90deg) !important;
}
:host ::ng-deep .-rotate-90 {
  transform: rotate(-90deg) !important;
}
:host ::ng-deep .rotate-180 {
  transform: rotate(180deg) !important;
}
:host ::ng-deep .-rotate-180 {
  transform: rotate(-180deg) !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:rotate-45 {
    transform: rotate(45deg) !important;
  }
  :host ::ng-deep .sm\\:-rotate-45 {
    transform: rotate(-45deg) !important;
  }
  :host ::ng-deep .sm\\:rotate-90 {
    transform: rotate(90deg) !important;
  }
  :host ::ng-deep .sm\\:-rotate-90 {
    transform: rotate(-90deg) !important;
  }
  :host ::ng-deep .sm\\:rotate-180 {
    transform: rotate(180deg) !important;
  }
  :host ::ng-deep .sm\\:-rotate-180 {
    transform: rotate(-180deg) !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:rotate-45 {
    transform: rotate(45deg) !important;
  }
  :host ::ng-deep .md\\:-rotate-45 {
    transform: rotate(-45deg) !important;
  }
  :host ::ng-deep .md\\:rotate-90 {
    transform: rotate(90deg) !important;
  }
  :host ::ng-deep .md\\:-rotate-90 {
    transform: rotate(-90deg) !important;
  }
  :host ::ng-deep .md\\:rotate-180 {
    transform: rotate(180deg) !important;
  }
  :host ::ng-deep .md\\:-rotate-180 {
    transform: rotate(-180deg) !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:rotate-45 {
    transform: rotate(45deg) !important;
  }
  :host ::ng-deep .lg\\:-rotate-45 {
    transform: rotate(-45deg) !important;
  }
  :host ::ng-deep .lg\\:rotate-90 {
    transform: rotate(90deg) !important;
  }
  :host ::ng-deep .lg\\:-rotate-90 {
    transform: rotate(-90deg) !important;
  }
  :host ::ng-deep .lg\\:rotate-180 {
    transform: rotate(180deg) !important;
  }
  :host ::ng-deep .lg\\:-rotate-180 {
    transform: rotate(-180deg) !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:rotate-45 {
    transform: rotate(45deg) !important;
  }
  :host ::ng-deep .xl\\:-rotate-45 {
    transform: rotate(-45deg) !important;
  }
  :host ::ng-deep .xl\\:rotate-90 {
    transform: rotate(90deg) !important;
  }
  :host ::ng-deep .xl\\:-rotate-90 {
    transform: rotate(-90deg) !important;
  }
  :host ::ng-deep .xl\\:rotate-180 {
    transform: rotate(180deg) !important;
  }
  :host ::ng-deep .xl\\:-rotate-180 {
    transform: rotate(-180deg) !important;
  }
}
:host ::ng-deep .origin-center {
  transform-origin: center !important;
}
:host ::ng-deep .origin-top {
  transform-origin: top !important;
}
:host ::ng-deep .origin-top-right {
  transform-origin: top right !important;
}
:host ::ng-deep .origin-right {
  transform-origin: right !important;
}
:host ::ng-deep .origin-bottom-right {
  transform-origin: bottom right !important;
}
:host ::ng-deep .origin-bottom {
  transform-origin: bottom !important;
}
:host ::ng-deep .origin-bottom-left {
  transform-origin: bottom left !important;
}
:host ::ng-deep .origin-left {
  transform-origin: left !important;
}
:host ::ng-deep .origin-top-left {
  transform-origin: top-left !important;
}
@media only screen and (max-width: 600px) {
  :host ::ng-deep .sm\\:origin-center {
    transform-origin: center !important;
  }
  :host ::ng-deep .sm\\:origin-top {
    transform-origin: top !important;
  }
  :host ::ng-deep .sm\\:origin-top-right {
    transform-origin: top right !important;
  }
  :host ::ng-deep .sm\\:origin-right {
    transform-origin: right !important;
  }
  :host ::ng-deep .sm\\:origin-bottom-right {
    transform-origin: bottom right !important;
  }
  :host ::ng-deep .sm\\:origin-bottom {
    transform-origin: bottom !important;
  }
  :host ::ng-deep .sm\\:origin-bottom-left {
    transform-origin: bottom left !important;
  }
  :host ::ng-deep .sm\\:origin-left {
    transform-origin: left !important;
  }
  :host ::ng-deep .sm\\:origin-top-left {
    transform-origin: top-left !important;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .md\\:origin-center {
    transform-origin: center !important;
  }
  :host ::ng-deep .md\\:origin-top {
    transform-origin: top !important;
  }
  :host ::ng-deep .md\\:origin-top-right {
    transform-origin: top right !important;
  }
  :host ::ng-deep .md\\:origin-right {
    transform-origin: right !important;
  }
  :host ::ng-deep .md\\:origin-bottom-right {
    transform-origin: bottom right !important;
  }
  :host ::ng-deep .md\\:origin-bottom {
    transform-origin: bottom !important;
  }
  :host ::ng-deep .md\\:origin-bottom-left {
    transform-origin: bottom left !important;
  }
  :host ::ng-deep .md\\:origin-left {
    transform-origin: left !important;
  }
  :host ::ng-deep .md\\:origin-top-left {
    transform-origin: top-left !important;
  }
}
@media screen and (min-width: 992px) {
  :host ::ng-deep .lg\\:origin-center {
    transform-origin: center !important;
  }
  :host ::ng-deep .lg\\:origin-top {
    transform-origin: top !important;
  }
  :host ::ng-deep .lg\\:origin-top-right {
    transform-origin: top right !important;
  }
  :host ::ng-deep .lg\\:origin-right {
    transform-origin: right !important;
  }
  :host ::ng-deep .lg\\:origin-bottom-right {
    transform-origin: bottom right !important;
  }
  :host ::ng-deep .lg\\:origin-bottom {
    transform-origin: bottom !important;
  }
  :host ::ng-deep .lg\\:origin-bottom-left {
    transform-origin: bottom left !important;
  }
  :host ::ng-deep .lg\\:origin-left {
    transform-origin: left !important;
  }
  :host ::ng-deep .lg\\:origin-top-left {
    transform-origin: top-left !important;
  }
}
@media screen and (min-width: 1200px) {
  :host ::ng-deep .xl\\:origin-center {
    transform-origin: center !important;
  }
  :host ::ng-deep .xl\\:origin-top {
    transform-origin: top !important;
  }
  :host ::ng-deep .xl\\:origin-top-right {
    transform-origin: top right !important;
  }
  :host ::ng-deep .xl\\:origin-right {
    transform-origin: right !important;
  }
  :host ::ng-deep .xl\\:origin-bottom-right {
    transform-origin: bottom right !important;
  }
  :host ::ng-deep .xl\\:origin-bottom {
    transform-origin: bottom !important;
  }
  :host ::ng-deep .xl\\:origin-bottom-left {
    transform-origin: bottom left !important;
  }
  :host ::ng-deep .xl\\:origin-left {
    transform-origin: left !important;
  }
  :host ::ng-deep .xl\\:origin-top-left {
    transform-origin: top-left !important;
  }
}
@keyframes fadein {
  0% {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeout {
  0% {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes scalein {
  0% {
    opacity: 0;
    transform: scaleY(0.8);
    transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1), opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
  }
  to {
    opacity: 1;
    transform: scaleY(1);
  }
}
@keyframes slidedown {
  0% {
    max-height: 0;
  }
  to {
    max-height: auto;
  }
}
@keyframes slideup {
  0% {
    max-height: 1000px;
  }
  to {
    max-height: 0;
  }
}
@keyframes fadeinleft {
  0% {
    opacity: 0;
    transform: translate(-100%);
    transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1), opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
  }
  to {
    opacity: 1;
    transform: translate(0);
  }
}
@keyframes fadeoutleft {
  0% {
    opacity: 1;
    transform: translate(0);
    transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1), opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
  }
  to {
    opacity: 0;
    transform: translate(-100%);
  }
}
@keyframes fadeinright {
  0% {
    opacity: 0;
    transform: translate(100%);
    transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1), opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
  }
  to {
    opacity: 1;
    transform: translate(0);
  }
}
@keyframes fadeoutright {
  0% {
    opacity: 1;
    transform: translate(0);
    transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1), opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
  }
  to {
    opacity: 0;
    transform: translate(100%);
  }
}
@keyframes fadeinup {
  0% {
    opacity: 0;
    transform: translateY(-100%);
    transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1), opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeoutup {
  0% {
    opacity: 1;
    transform: translateY(0);
    transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1), opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
  }
  to {
    opacity: 0;
    transform: translateY(-100%);
  }
}
@keyframes fadeindown {
  0% {
    opacity: 0;
    transform: translateY(100%);
    transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1), opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeoutdown {
  0% {
    opacity: 1;
    transform: translateY(0);
    transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1), opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
  }
  to {
    opacity: 0;
    transform: translateY(100%);
  }
}
@keyframes animate-width {
  0% {
    width: 0;
  }
  to {
    width: 100%;
  }
}
@keyframes flip {
  0% {
    transform: perspective(2000px) rotateX(-100deg);
  }
  to {
    transform: perspective(2000px) rotateX(0);
  }
}
@keyframes flipleft {
  0% {
    transform: perspective(2000px) rotateY(-100deg);
    opacity: 0;
  }
  to {
    transform: perspective(2000px) rotateY(0);
    opacity: 1;
  }
}
@keyframes flipright {
  0% {
    transform: perspective(2000px) rotateY(100deg);
    opacity: 0;
  }
  to {
    transform: perspective(2000px) rotateY(0);
    opacity: 1;
  }
}
@keyframes flipup {
  0% {
    transform: perspective(2000px) rotateX(-100deg);
    opacity: 0;
  }
  to {
    transform: perspective(2000px) rotateX(0);
    opacity: 1;
  }
}
@keyframes zoomin {
  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
@keyframes zoomindown {
  0% {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
  }
  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
  }
}
@keyframes zoominleft {
  0% {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);
  }
}
@keyframes zoominright {
  0% {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);
  }
}
@keyframes zoominup {
  0% {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);
  }
  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
  }
}
:host ::ng-deep .fadein {
  animation: fadein 0.15s linear;
}
:host ::ng-deep .fadeout {
  animation: fadeout 0.15s linear;
}
:host ::ng-deep .slidedown {
  animation: slidedown 0.45s ease-in-out;
}
:host ::ng-deep .slideup {
  animation: slideup 0.45s cubic-bezier(0, 1, 0, 1);
}
:host ::ng-deep .scalein {
  animation: scalein 0.15s linear;
}
:host ::ng-deep .fadeinleft {
  animation: fadeinleft 0.15s linear;
}
:host ::ng-deep .fadeoutleft {
  animation: fadeoutleft 0.15s linear;
}
:host ::ng-deep .fadeinright {
  animation: fadeinright 0.15s linear;
}
:host ::ng-deep .fadeoutright {
  animation: fadeoutright 0.15s linear;
}
:host ::ng-deep .fadeinup {
  animation: fadeinup 0.15s linear;
}
:host ::ng-deep .fadeoutup {
  animation: fadeoutup 0.15s linear;
}
:host ::ng-deep .fadeindown {
  animation: fadeindown 0.15s linear;
}
:host ::ng-deep .fadeoutdown {
  animation: fadeoutdown 0.15s linear;
}
:host ::ng-deep .animate-width {
  animation: animate-width 1s linear;
}
:host ::ng-deep .flip {
  backface-visibility: visible;
  animation: flip 0.15s linear;
}
:host ::ng-deep .flipup {
  backface-visibility: visible;
  animation: flipup 0.15s linear;
}
:host ::ng-deep .flipleft {
  backface-visibility: visible;
  animation: flipleft 0.15s linear;
}
:host ::ng-deep .flipright {
  backface-visibility: visible;
  animation: flipright 0.15s linear;
}
:host ::ng-deep .zoomin {
  animation: zoomin 0.15s linear;
}
:host ::ng-deep .zoomindown {
  animation: zoomindown 0.15s linear;
}
:host ::ng-deep .zoominleft {
  animation: zoominleft 0.15s linear;
}
:host ::ng-deep .zoominright {
  animation: zoominright 0.15s linear;
}
:host ::ng-deep .zoominup {
  animation: zoominup 0.15s linear;
}
:host ::ng-deep .animation-duration-100 {
  animation-duration: 0.1s !important;
}
:host ::ng-deep .animation-duration-150 {
  animation-duration: 0.15s !important;
}
:host ::ng-deep .animation-duration-200 {
  animation-duration: 0.2s !important;
}
:host ::ng-deep .animation-duration-300 {
  animation-duration: 0.3s !important;
}
:host ::ng-deep .animation-duration-400 {
  animation-duration: 0.4s !important;
}
:host ::ng-deep .animation-duration-500 {
  animation-duration: 0.5s !important;
}
:host ::ng-deep .animation-duration-1000 {
  animation-duration: 1s !important;
}
:host ::ng-deep .animation-duration-2000 {
  animation-duration: 2s !important;
}
:host ::ng-deep .animation-duration-3000 {
  animation-duration: 3s !important;
}
:host ::ng-deep .animation-delay-100 {
  animation-delay: 0.1s !important;
}
:host ::ng-deep .animation-delay-150 {
  animation-delay: 0.15s !important;
}
:host ::ng-deep .animation-delay-200 {
  animation-delay: 0.2s !important;
}
:host ::ng-deep .animation-delay-300 {
  animation-delay: 0.3s !important;
}
:host ::ng-deep .animation-delay-400 {
  animation-delay: 0.4s !important;
}
:host ::ng-deep .animation-delay-500 {
  animation-delay: 0.5s !important;
}
:host ::ng-deep .animation-delay-1000 {
  animation-delay: 1s !important;
}
:host ::ng-deep .animation-iteration-1 {
  animation-iteration-count: 1 !important;
}
:host ::ng-deep .animation-iteration-2 {
  animation-iteration-count: 2 !important;
}
:host ::ng-deep .animation-iteration-infinite {
  animation-iteration-count: infinite !important;
}
:host ::ng-deep .animation-linear {
  animation-timing-function: linear !important;
}
:host ::ng-deep .animation-ease-in {
  animation-timing-function: cubic-bezier(0.4, 0, 1, 1) !important;
}
:host ::ng-deep .animation-ease-out {
  animation-timing-function: cubic-bezier(0, 0, 0.2, 1) !important;
}
:host ::ng-deep .animation-ease-in-out {
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}
:host ::ng-deep .animation-fill-none {
  animation-fill-mode: none !important;
}
:host ::ng-deep .animation-fill-forwards {
  animation-fill-mode: forwards !important;
}
:host ::ng-deep .animation-fill-backwards {
  animation-fill-mode: backwards !important;
}
:host ::ng-deep .animation-fill-both {
  animation-fill-mode: both !important;
}
:host ::ng-deep .product-badge {
  border-radius: var(--border-radius);
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
}
:host ::ng-deep .product-badge.status-instock {
  background: var(--green-200);
  color: var(--green-800);
}
:host ::ng-deep .product-badge.status-outofstock {
  background: var(--pink-200);
  color: var(--pink-800);
}
:host ::ng-deep .product-badge.status-lowstock {
  background: var(--yellow-200);
  color: var(--yellow-800);
}
:host ::ng-deep .product-badge-text {
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
}
:host ::ng-deep .product-badge-text.status-instock {
  color: var(--green-500);
}
:host ::ng-deep .product-badge-text.status-outofstock {
  color: var(--pink-500);
}
:host ::ng-deep .product-badge-text.status-lowstock {
  color: var(--yellow-500);
}
:host ::ng-deep .customer-badge {
  border-radius: var(--border-radius);
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
}
:host ::ng-deep .customer-badge.status-qualified {
  background: var(--green-200);
  color: var(--green-800);
}
:host ::ng-deep .customer-badge.status-unqualified {
  background: var(--pink-200);
  color: var(--pink-800);
}
:host ::ng-deep .customer-badge.status-negotiation {
  background: var(--yellow-200);
  color: var(--yellow-800);
}
:host ::ng-deep .customer-badge.status-new {
  background: var(--blue-200);
  color: var(--blue-800);
}
:host ::ng-deep .customer-badge.status-renewal {
  background: var(--purple-200);
  color: var(--purple-800);
}
:host ::ng-deep .customer-badge.status-proposal {
  background: var(--orange-200);
  color: var(--orange-800);
}
:host ::ng-deep .order-badge {
  border-radius: var(--border-radius);
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
}
:host ::ng-deep .order-badge.order-delivered {
  background: #C8E6C9;
  color: #256029;
}
:host ::ng-deep .order-badge.order-cancelled {
  background: #FFCDD2;
  color: #c63737;
}
:host ::ng-deep .order-badge.order-pending {
  background: #FEEDAF;
  color: #8a5340;
}
:host ::ng-deep .order-badge.order-returned {
  background: #ECCFFF;
  color: #694382;
}
:host ::ng-deep pre.app-code {
  background-color: var(--surface-ground);
  margin: 0 0 1rem;
  padding: 0;
  border-radius: var(--border-radius);
  overflow: auto;
}
:host ::ng-deep pre.app-code code {
  color: var(--surface-900);
  padding: 1rem;
  line-height: 1.5;
  display: block;
  font-family: monaco, Consolas, monospace;
}

/*inset 0 0 0 0.15rem \$focusOutlineColor;*/
:root {
  --border-radius:8px;
}

/*inset 0 0 0 0.15rem \$focusOutlineColor;*/
:root {
  --border-radius:8px;
}

/*inset 0 0 0 0.15rem \$focusOutlineColor;*/
:root {
  --border-radius:8px;
}

/*inset 0 0 0 0.15rem \$focusOutlineColor;*/
:root {
  --border-radius:8px;
}

.p-megamenu {
  padding: 0;
  background: #3E642F;
  color: rgba(255, 255, 255, 0.7);
  border: 0 none;
  border-radius: 8px;
}
.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link {
  padding: 0.75rem 0.5rem;
  color: rgba(255, 255, 255, 0.7);
  border-radius: 0;
  transition: box-shadow 0.15s;
  -webkit-user-select: none;
          user-select: none;
}
.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link .p-menuitem-text {
  color: rgba(255, 255, 255, 0.7);
}
.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link .p-menuitem-icon {
  color: rgba(254, 197, 48, 0.8);
  margin-right: 0.5rem;
}
.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link .p-submenu-icon {
  color: rgba(255, 255, 255, 0.7); /*\$horizontalMenuRootMenuitemIconColor*/
  margin-left: 0.5rem;
}
.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover {
  background: var(--primary);
}
.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {
  color: rgb(255, 255, 255);
}
.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {
  color: rgb(254, 197, 48);
}
.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {
  color: rgb(254, 197, 48);
}
.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
}
.p-megamenu .p-megamenu-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link,
.p-megamenu .p-megamenu-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link:not(.p-disabled):hover {
  background: var(--primary);
}
.p-megamenu .p-megamenu-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link .p-menuitem-text,
.p-megamenu .p-megamenu-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {
  color: rgba(255, 255, 255, 0.9);
}
.p-megamenu .p-megamenu-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link .p-menuitem-icon,
.p-megamenu .p-megamenu-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {
  color: rgba(254, 197, 48, 0.9);
}
.p-megamenu .p-megamenu-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link .p-submenu-icon,
.p-megamenu .p-megamenu-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {
  color: rgba(254, 197, 48, 0.9);
}
.p-megamenu .p-menuitem-link {
  padding: 0.75rem 1rem;
  color: #292B2C;
  border-radius: 0;
  transition: box-shadow 0.15s;
  -webkit-user-select: none;
          user-select: none;
  width: max-content;
}
.p-megamenu .p-menuitem-link .p-menuitem-text {
  color: #292B2C;
}
.p-megamenu .p-menuitem-link .p-menuitem-icon {
  color: #292B2C;
  margin-right: 0.5rem;
}
.p-megamenu .p-menuitem-link .p-submenu-icon {
  color: #292B2C;
}
.p-megamenu .p-menuitem-link:not(.p-disabled):hover {
  background: #e9ecef;
}
.p-megamenu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {
  color: #292B2C;
}
.p-megamenu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {
  color: #292B2C;
}
.p-megamenu .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {
  color: #292B2C;
}
.p-megamenu .p-menuitem-link:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
}
.p-megamenu .p-megamenu-panel {
  background: #ffffff;
  color: #292B2C;
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: none;
}
.p-megamenu .p-megamenu-submenu-header {
  margin: 0;
  padding: 0.75rem 1rem;
  color: #292B2C;
  background: #ffffff;
  font-weight: 600;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}
.p-megamenu .p-megamenu-submenu {
  padding: 0.5rem 0;
  width: auto;
}
.p-megamenu .p-megamenu-submenu .p-menu-separator {
  border-top: 1px solid #dee2e6;
  margin: 0.5rem 0;
}
.p-megamenu .p-megamenu-submenu .p-menuitem {
  margin: 0;
}
.p-megamenu .p-megamenu-submenu .p-menuitem:last-child {
  margin: 0;
}
.p-megamenu .p-menuitem.p-menuitem-active > .p-menuitem-link {
  background: #e9ecef;
}
.p-megamenu .p-menuitem.p-menuitem-active > .p-menuitem-link .p-menuitem-text {
  color: #292B2C;
}
.p-megamenu .p-menuitem.p-menuitem-active > .p-menuitem-link .p-menuitem-icon, .p-megamenu .p-menuitem.p-menuitem-active > .p-menuitem-link .p-submenu-icon {
  color: #292B2C;
}

::ng-deep .ui-inputgroup {
  width: 100%;
  display: flex;
  padding: 0 !important;
  /* Styling for ui-inputgroup-addon when it comes AFTER ui-inputgroup-widget */
  /* Styling for ui-inputgroup-addon when it comes BEFORE ui-inputgroup-widget */
}
::ng-deep .ui-inputgroup .ui-inputgroup-addon {
  background-color: #f8f9fa;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-width: 36px !important;
  height: inherit;
}
::ng-deep .ui-inputgroup .ui-inputgroup-widget + .ui-inputgroup-addon {
  border-top: 1px solid var(--border-light);
  border-right: 1px solid var(--border-light);
  border-bottom: 1px solid var(--border-light);
  border-left: none;
  border-radius: 0 4px 4px 0;
}
::ng-deep .ui-inputgroup .ui-inputgroup-addon:not(.ui-inputgroup-widget + .ui-inputgroup-addon) {
  border-top: 1px solid var(--border-light);
  border-left: 1px solid var(--border-light);
  border-bottom: 1px solid var(--border-light);
  border-right: none;
  border-radius: 4px 0 0 4px;
}
::ng-deep .ui-inputgroup .ui-inputgroup-widget {
  display: table-cell;
  height: inherit;
  width: inherit;
  border-radius: 3px;
}
::ng-deep .ui-inputgroup .ui-inputgroup-widget.border-left-zero .p-inputtext {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
::ng-deep .ui-inputgroup .ui-inputgroup-widget.border-right-zero .p-inputtext {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
::ng-deep .ui-inputgroup .ui-inputgroup-widget.border-zero .p-inputtext {
  border-radius: 0 !important;
}

:host ::ng-deep .contact-section,
:host ::ng-deep .generic-section {
  position: relative;
  z-index: 3;
}
:host ::ng-deep .contact-item {
  display: flex;
  border: 1px solid var(--gray-4);
  border-radius: 10px;
  background: var(--white);
  margin-bottom: 30px;
  padding: 20px 30px;
  transition: all 0.3s ease-out 0s;
}
:host ::ng-deep .contact-item .contact-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: var(--primary);
  color: var(--white);
  transition: all 0.3s ease-out 0s;
}
:host ::ng-deep .contact-item .contact-content {
  margin-left: 25px;
}
:host ::ng-deep .contact-item .contact-content a,
:host ::ng-deep .contact-item .contact-content a:visited {
  color: var(--primary);
}
:host ::ng-deep .contact-item .contact-content a:hover {
  color: var(--dark-2);
}
:host ::ng-deep .contact-item .contact-content h4 {
  color: var(--primary);
  margin-bottom: 10px;
}
:host ::ng-deep .contact-item:hover {
  box-shadow: var(--shadow-4);
}
:host ::ng-deep .contact-form-wrapper,
:host ::ng-deep .build-form-wrapper,
:host ::ng-deep .about-form-wrapper,
:host ::ng-deep .retail-form-wrapper,
:host ::ng-deep .orthodox-form-wrapper,
:host ::ng-deep .products-form-wrapper {
  position: relative;
  z-index: 1;
  padding: 50px 40px;
  background: var(--white);
  border: 1px solid var(--gray-4);
  margin-left: 0;
  border-radius: 10px;
  min-height: 50vh;
  transition: all 0.3s ease-out 0s;
}
:host ::ng-deep .contact-form-wrapper .contact-form .primary-btn,
:host ::ng-deep .build-form-wrapper .build-form .primary-btn,
:host ::ng-deep .about-form-wrapper .about-form .primary-btn,
:host ::ng-deep .retail-form-wrapper .retail-form .primary-btn,
:host ::ng-deep .orthodox-form-wrapper .orthodox-form .primary-btn,
:host ::ng-deep .products-form-wrapper .retail-form .primary-btn {
  background: var(--primary);
  color: var(--white);
  box-shadow: var(--shadow-2);
}
:host ::ng-deep .contact-form-wrapper .contact-form .active.primary-btn,
:host ::ng-deep .contact-form-wrapper .contact-form .primary-btn:hover,
:host ::ng-deep .contact-form-wrapper .contact-form .primary-btn:focus,
:host ::ng-deep .build-form-wrapper .build-form .active.primary-btn,
:host ::ng-deep .build-form-wrapper .build-form .primary-btn:hover,
:host ::ng-deep .build-form-wrapper .build-form .primary-btn:focus,
:host ::ng-deep .about-form-wrapper .about-form .active.primary-btn,
:host ::ng-deep .about-form-wrapper .about-form .primary-btn:hover,
:host ::ng-deep .about-form-wrapper .about-form .primary-btn:focus,
:host ::ng-deep .retail-form-wrapper .retail-form .active.primary-btn,
:host ::ng-deep .retail-form-wrapper .retail-form .primary-btn:hover,
:host ::ng-deep .retail-form-wrapper .retail-form .primary-btn:focus,
:host ::ng-deep .orthodox-form-wrapper .orthodox-form .active.primary-btn,
:host ::ng-deep .orthodox-form-wrapper .orthodox-form .primary-btn:hover,
:host ::ng-deep .orthodox-form-wrapper .orthodox-form .primary-btn:focus,
:host ::ng-deep .products-form-wrapper .products-form .active.primary-btn,
:host ::ng-deep .products-form-wrapper .products-form .primary-btn:hover,
:host ::ng-deep .products-form-wrapper .products-form .primary-btn:focus {
  background: var(--primary-dark);
  color: var(--white);
  box-shadow: var(--shadow-4);
}
:host ::ng-deep .contact-form-wrapper .contact-form .deactive.primary-btn,
:host ::ng-deep .build-form-wrapper .build-form .deactive.primary-btn,
:host ::ng-deep .about-form-wrapper .about-form .deactive.primary-btn,
:host ::ng-deep .retail-form-wrapper .retail-form .deactive.primary-btn,
:host ::ng-deep .orthodox-form-wrapper .orthodox-form .deactive.primary-btn,
:host ::ng-deep .products-form-wrapper .products-form .deactive.primary-btn {
  background: var(--gray-4);
  color: var(--dark-3);
  pointer-events: none;
}
:host ::ng-deep .contact-form-wrapper:hover,
:host ::ng-deep .build-form-wrapper:hover,
:host ::ng-deep .about-form-wrapper:hover,
:host ::ng-deep .retail-form-wrapper:hover,
:host ::ng-deep .orthodox-form-wrapper:hover,
:host ::ng-deep .products-form-wrapper:hover {
  box-shadow: var(--shadow-4);
}
:host ::ng-deep .contact-form-wrapper .section-title,
:host ::ng-deep .build-form-wrapper .section-title,
:host ::ng-deep .about-form-wrapper .section-title,
:host ::ng-deep .retail-form-wrapper .section-title,
:host ::ng-deep .orthodox-form-wrapper .section-title,
:host ::ng-deep .products-form-wrapper .section-title {
  margin-bottom: 30px;
}
:host ::ng-deep .contact-form-wrapper .section-title span,
:host ::ng-deep .build-form-wrapper .section-title span,
:host ::ng-deep .about-form-wrapper .section-title span,
:host ::ng-deep .retail-form-wrapper .section-title span,
:host ::ng-deep .orthodox-form-wrapper .section-title span,
:host ::ng-deep .products-form-wrapper .section-title span {
  font-size: 20px;
  color: var(--primary);
  font-weight: 700;
}
:host ::ng-deep .contact-form-wrapper .section-title h2,
:host ::ng-deep .build-form-wrapper .section-title h2,
:host ::ng-deep .about-form-wrapper .section-title h2,
:host ::ng-deep .retail-form-wrapper .section-title h2,
:host ::ng-deep .orthodox-form-wrapper .section-title h2,
:host ::ng-deep .products-form-wrapper .section-title h2 {
  margin-bottom: 10px;
}
:host ::ng-deep .contact-form-wrapper .section-title p,
:host ::ng-deep .build-form-wrapper .section-title p,
:host ::ng-deep .about-form-wrapper .section-title p,
:host ::ng-deep .retail-form-wrapper .section-title p,
:host ::ng-deep .orthodox-form-wrapper .section-title p,
:host ::ng-deep .products-form-wrapper .section-title p {
  color: var(--dark-2);
}
:host ::ng-deep .contact-form-wrapper .contact-form input,
:host ::ng-deep .contact-form-wrapper .contact-form textarea,
:host ::ng-deep .contact-form-wrapper .build-form input,
:host ::ng-deep .contact-form-wrapper .build-form textarea,
:host ::ng-deep .contact-form-wrapper .about-form input,
:host ::ng-deep .contact-form-wrapper .about-form textarea,
:host ::ng-deep .contact-form-wrapper .retail-form input,
:host ::ng-deep .contact-form-wrapper .retail-form textarea,
:host ::ng-deep .contact-form-wrapper .orthodox-form input,
:host ::ng-deep .contact-form-wrapper .orthodox-form textarea,
:host ::ng-deep .contact-form-wrapper .products-form input,
:host ::ng-deep .contact-form-wrapper .products-form textarea,
:host ::ng-deep .build-form-wrapper .contact-form input,
:host ::ng-deep .build-form-wrapper .contact-form textarea,
:host ::ng-deep .build-form-wrapper .build-form input,
:host ::ng-deep .build-form-wrapper .build-form textarea,
:host ::ng-deep .build-form-wrapper .about-form input,
:host ::ng-deep .build-form-wrapper .about-form textarea,
:host ::ng-deep .build-form-wrapper .retail-form input,
:host ::ng-deep .build-form-wrapper .retail-form textarea,
:host ::ng-deep .build-form-wrapper .orthodox-form input,
:host ::ng-deep .build-form-wrapper .orthodox-form textarea,
:host ::ng-deep .build-form-wrapper .products-form input,
:host ::ng-deep .build-form-wrapper .products-form textarea,
:host ::ng-deep .about-form-wrapper .contact-form input,
:host ::ng-deep .about-form-wrapper .contact-form textarea,
:host ::ng-deep .about-form-wrapper .build-form input,
:host ::ng-deep .about-form-wrapper .build-form textarea,
:host ::ng-deep .about-form-wrapper .about-form input,
:host ::ng-deep .about-form-wrapper .about-form textarea,
:host ::ng-deep .about-form-wrapper .retail-form input,
:host ::ng-deep .about-form-wrapper .retail-form textarea,
:host ::ng-deep .about-form-wrapper .orthodox-form input,
:host ::ng-deep .about-form-wrapper .orthodox-form textarea,
:host ::ng-deep .about-form-wrapper .products-form input,
:host ::ng-deep .about-form-wrapper .products-form textarea,
:host ::ng-deep .retail-form-wrapper .contact-form input,
:host ::ng-deep .retail-form-wrapper .contact-form textarea,
:host ::ng-deep .retail-form-wrapper .build-form input,
:host ::ng-deep .retail-form-wrapper .build-form textarea,
:host ::ng-deep .retail-form-wrapper .about-form input,
:host ::ng-deep .retail-form-wrapper .about-form textarea,
:host ::ng-deep .retail-form-wrapper .retail-form input,
:host ::ng-deep .retail-form-wrapper .retail-form textarea,
:host ::ng-deep .retail-form-wrapper .orthodox-form input,
:host ::ng-deep .retail-form-wrapper .orthodox-form textarea,
:host ::ng-deep .retail-form-wrapper .products-form input,
:host ::ng-deep .retail-form-wrapper .products-form textarea,
:host ::ng-deep .orthodox-form-wrapper .contact-form input,
:host ::ng-deep .orthodox-form-wrapper .contact-form textarea,
:host ::ng-deep .orthodox-form-wrapper .build-form input,
:host ::ng-deep .orthodox-form-wrapper .build-form textarea,
:host ::ng-deep .orthodox-form-wrapper .about-form input,
:host ::ng-deep .orthodox-form-wrapper .about-form textarea,
:host ::ng-deep .orthodox-form-wrapper .retail-form input,
:host ::ng-deep .orthodox-form-wrapper .retail-form textarea,
:host ::ng-deep .orthodox-form-wrapper .orthodox-form input,
:host ::ng-deep .orthodox-form-wrapper .orthodox-form textarea,
:host ::ng-deep .orthodox-form-wrapper .products-form input,
:host ::ng-deep .orthodox-form-wrapper .products-form textarea,
:host ::ng-deep .products-form-wrapper .contact-form input,
:host ::ng-deep .products-form-wrapper .contact-form textarea,
:host ::ng-deep .products-form-wrapper .build-form input,
:host ::ng-deep .products-form-wrapper .build-form textarea,
:host ::ng-deep .products-form-wrapper .about-form input,
:host ::ng-deep .products-form-wrapper .about-form textarea,
:host ::ng-deep .products-form-wrapper .retail-form input,
:host ::ng-deep .products-form-wrapper .retail-form textarea,
:host ::ng-deep .products-form-wrapper .orthodox-form input,
:host ::ng-deep .products-form-wrapper .orthodox-form textarea,
:host ::ng-deep .products-form-wrapper .products-form input,
:host ::ng-deep .products-form-wrapper .products-form textarea {
  padding: 15px 25px;
  border-radius: 30px;
  border: 1px solid var(--gray-4);
  margin-bottom: 25px;
  width: 100%;
  transition: all 0.3s ease-out 0s;
}
:host ::ng-deep .contact-form-wrapper .contact-form input:focus,
:host ::ng-deep .contact-form-wrapper .contact-form textarea:focus,
:host ::ng-deep .contact-form-wrapper .build-form input:focus,
:host ::ng-deep .contact-form-wrapper .build-form textarea:focus,
:host ::ng-deep .contact-form-wrapper .about-form input:focus,
:host ::ng-deep .contact-form-wrapper .about-form textarea:focus,
:host ::ng-deep .contact-form-wrapper .retail-form input:focus,
:host ::ng-deep .contact-form-wrapper .retail-form textarea:focus,
:host ::ng-deep .contact-form-wrapper .orthodox-form input:focus,
:host ::ng-deep .contact-form-wrapper .orthodox-form textarea:focus,
:host ::ng-deep .contact-form-wrapper .products-form input:focus,
:host ::ng-deep .contact-form-wrapper .products-form textarea:focus,
:host ::ng-deep .build-form-wrapper .contact-form input:focus,
:host ::ng-deep .build-form-wrapper .contact-form textarea:focus,
:host ::ng-deep .build-form-wrapper .build-form input:focus,
:host ::ng-deep .build-form-wrapper .build-form textarea:focus,
:host ::ng-deep .build-form-wrapper .about-form input:focus,
:host ::ng-deep .build-form-wrapper .about-form textarea:focus,
:host ::ng-deep .build-form-wrapper .retail-form input:focus,
:host ::ng-deep .build-form-wrapper .retail-form textarea:focus,
:host ::ng-deep .build-form-wrapper .orthodox-form input:focus,
:host ::ng-deep .build-form-wrapper .orthodox-form textarea:focus,
:host ::ng-deep .build-form-wrapper .products-form input:focus,
:host ::ng-deep .build-form-wrapper .products-form textarea:focus,
:host ::ng-deep .about-form-wrapper .contact-form input:focus,
:host ::ng-deep .about-form-wrapper .contact-form textarea:focus,
:host ::ng-deep .about-form-wrapper .build-form input:focus,
:host ::ng-deep .about-form-wrapper .build-form textarea:focus,
:host ::ng-deep .about-form-wrapper .about-form input:focus,
:host ::ng-deep .about-form-wrapper .about-form textarea:focus,
:host ::ng-deep .about-form-wrapper .retail-form input:focus,
:host ::ng-deep .about-form-wrapper .retail-form textarea:focus,
:host ::ng-deep .about-form-wrapper .orthodox-form input:focus,
:host ::ng-deep .about-form-wrapper .orthodox-form textarea:focus,
:host ::ng-deep .about-form-wrapper .products-form input:focus,
:host ::ng-deep .about-form-wrapper .products-form textarea:focus,
:host ::ng-deep .retail-form-wrapper .contact-form input:focus,
:host ::ng-deep .retail-form-wrapper .contact-form textarea:focus,
:host ::ng-deep .retail-form-wrapper .build-form input:focus,
:host ::ng-deep .retail-form-wrapper .build-form textarea:focus,
:host ::ng-deep .retail-form-wrapper .about-form input:focus,
:host ::ng-deep .retail-form-wrapper .about-form textarea:focus,
:host ::ng-deep .retail-form-wrapper .retail-form input:focus,
:host ::ng-deep .retail-form-wrapper .retail-form textarea:focus,
:host ::ng-deep .retail-form-wrapper .orthodox-form input:focus,
:host ::ng-deep .retail-form-wrapper .orthodox-form textarea:focus,
:host ::ng-deep .retail-form-wrapper .products-form input:focus,
:host ::ng-deep .retail-form-wrapper .products-form textarea:focus,
:host ::ng-deep .orthodox-form-wrapper .contact-form input:focus,
:host ::ng-deep .orthodox-form-wrapper .contact-form textarea:focus,
:host ::ng-deep .orthodox-form-wrapper .build-form input:focus,
:host ::ng-deep .orthodox-form-wrapper .build-form textarea:focus,
:host ::ng-deep .orthodox-form-wrapper .about-form input:focus,
:host ::ng-deep .orthodox-form-wrapper .about-form textarea:focus,
:host ::ng-deep .orthodox-form-wrapper .retail-form input:focus,
:host ::ng-deep .orthodox-form-wrapper .retail-form textarea:focus,
:host ::ng-deep .orthodox-form-wrapper .orthodox-form input:focus,
:host ::ng-deep .orthodox-form-wrapper .orthodox-form textarea:focus,
:host ::ng-deep .orthodox-form-wrapper .products-form input:focus,
:host ::ng-deep .orthodox-form-wrapper .products-form textarea:focus,
:host ::ng-deep .products-form-wrapper .contact-form input:focus,
:host ::ng-deep .products-form-wrapper .contact-form textarea:focus,
:host ::ng-deep .products-form-wrapper .build-form input:focus,
:host ::ng-deep .products-form-wrapper .build-form textarea:focus,
:host ::ng-deep .products-form-wrapper .about-form input:focus,
:host ::ng-deep .products-form-wrapper .about-form textarea:focus,
:host ::ng-deep .products-form-wrapper .retail-form input:focus,
:host ::ng-deep .products-form-wrapper .retail-form textarea:focus,
:host ::ng-deep .products-form-wrapper .orthodox-form input:focus,
:host ::ng-deep .products-form-wrapper .orthodox-form textarea:focus,
:host ::ng-deep .products-form-wrapper .products-form input:focus,
:host ::ng-deep .products-form-wrapper .products-form textarea:focus {
  border-color: var(--primary);
}
:host ::ng-deep .contact-form-wrapper .contact-form textarea,
:host ::ng-deep .contact-form-wrapper .build-form textarea,
:host ::ng-deep .contact-form-wrapper .about-form textarea,
:host ::ng-deep .contact-form-wrapper .retail-form textarea,
:host ::ng-deep .contact-form-wrapper .orthodox-form textarea,
:host ::ng-deep .contact-form-wrapper .products-form textarea,
:host ::ng-deep .build-form-wrapper .contact-form textarea,
:host ::ng-deep .build-form-wrapper .build-form textarea,
:host ::ng-deep .build-form-wrapper .about-form textarea,
:host ::ng-deep .build-form-wrapper .retail-form textarea,
:host ::ng-deep .build-form-wrapper .orthodox-form textarea,
:host ::ng-deep .build-form-wrapper .products-form textarea,
:host ::ng-deep .about-form-wrapper .contact-form textarea,
:host ::ng-deep .about-form-wrapper .build-form textarea,
:host ::ng-deep .about-form-wrapper .about-form textarea,
:host ::ng-deep .about-form-wrapper .retail-form textarea,
:host ::ng-deep .about-form-wrapper .orthodox-form textarea,
:host ::ng-deep .about-form-wrapper .products-form textarea,
:host ::ng-deep .retail-form-wrapper .contact-form textarea,
:host ::ng-deep .retail-form-wrapper .build-form textarea,
:host ::ng-deep .retail-form-wrapper .about-form textarea,
:host ::ng-deep .retail-form-wrapper .retail-form textarea,
:host ::ng-deep .retail-form-wrapper .orthodox-form textarea,
:host ::ng-deep .retail-form-wrapper .products-form textarea,
:host ::ng-deep .orthodox-form-wrapper .contact-form textarea,
:host ::ng-deep .orthodox-form-wrapper .build-form textarea,
:host ::ng-deep .orthodox-form-wrapper .about-form textarea,
:host ::ng-deep .orthodox-form-wrapper .retail-form textarea,
:host ::ng-deep .orthodox-form-wrapper .orthodox-form textarea,
:host ::ng-deep .orthodox-form-wrapper .products-form textarea,
:host ::ng-deep .products-form-wrapper .contact-form textarea,
:host ::ng-deep .products-form-wrapper .build-form textarea,
:host ::ng-deep .products-form-wrapper .about-form textarea,
:host ::ng-deep .products-form-wrapper .retail-form textarea,
:host ::ng-deep .products-form-wrapper .orthodox-form textarea,
:host ::ng-deep .products-form-wrapper .products-form textarea {
  border-radius: 18px;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  :host ::ng-deep .contact-form-wrapper,
  :host ::ng-deep .build-form-wrapper,
  :host ::ng-deep .about-form-wrapper,
  :host ::ng-deep .retail-form-wrapper,
  :host ::ng-deep .orthodox-form-wrapper,
  :host ::ng-deep .products-form-wrapper {
    padding: 10px;
  }
  :host ::ng-deep .contact-form-wrapper .contact-form input,
  :host ::ng-deep .contact-form-wrapper .contact-form textarea,
  :host ::ng-deep .contact-form-wrapper .build-form input,
  :host ::ng-deep .contact-form-wrapper .build-form textarea,
  :host ::ng-deep .contact-form-wrapper .about-form input,
  :host ::ng-deep .contact-form-wrapper .about-form textarea,
  :host ::ng-deep .contact-form-wrapper .retail-form input,
  :host ::ng-deep .contact-form-wrapper .retail-form textarea,
  :host ::ng-deep .contact-form-wrapper .orthodox-form input,
  :host ::ng-deep .contact-form-wrapper .orthodox-form textarea,
  :host ::ng-deep .contact-form-wrapper .products-form input,
  :host ::ng-deep .contact-form-wrapper .products-form textarea,
  :host ::ng-deep .build-form-wrapper .contact-form input,
  :host ::ng-deep .build-form-wrapper .contact-form textarea,
  :host ::ng-deep .build-form-wrapper .build-form input,
  :host ::ng-deep .build-form-wrapper .build-form textarea,
  :host ::ng-deep .build-form-wrapper .about-form input,
  :host ::ng-deep .build-form-wrapper .about-form textarea,
  :host ::ng-deep .build-form-wrapper .retail-form input,
  :host ::ng-deep .build-form-wrapper .retail-form textarea,
  :host ::ng-deep .build-form-wrapper .orthodox-form input,
  :host ::ng-deep .build-form-wrapper .orthodox-form textarea,
  :host ::ng-deep .build-form-wrapper .products-form input,
  :host ::ng-deep .build-form-wrapper .products-form textarea,
  :host ::ng-deep .about-form-wrapper .contact-form input,
  :host ::ng-deep .about-form-wrapper .contact-form textarea,
  :host ::ng-deep .about-form-wrapper .build-form input,
  :host ::ng-deep .about-form-wrapper .build-form textarea,
  :host ::ng-deep .about-form-wrapper .about-form input,
  :host ::ng-deep .about-form-wrapper .about-form textarea,
  :host ::ng-deep .about-form-wrapper .retail-form input,
  :host ::ng-deep .about-form-wrapper .retail-form textarea,
  :host ::ng-deep .about-form-wrapper .orthodox-form input,
  :host ::ng-deep .about-form-wrapper .orthodox-form textarea,
  :host ::ng-deep .about-form-wrapper .products-form input,
  :host ::ng-deep .about-form-wrapper .products-form textarea,
  :host ::ng-deep .retail-form-wrapper .contact-form input,
  :host ::ng-deep .retail-form-wrapper .contact-form textarea,
  :host ::ng-deep .retail-form-wrapper .build-form input,
  :host ::ng-deep .retail-form-wrapper .build-form textarea,
  :host ::ng-deep .retail-form-wrapper .about-form input,
  :host ::ng-deep .retail-form-wrapper .about-form textarea,
  :host ::ng-deep .retail-form-wrapper .retail-form input,
  :host ::ng-deep .retail-form-wrapper .retail-form textarea,
  :host ::ng-deep .retail-form-wrapper .orthodox-form input,
  :host ::ng-deep .retail-form-wrapper .orthodox-form textarea,
  :host ::ng-deep .retail-form-wrapper .products-form input,
  :host ::ng-deep .retail-form-wrapper .products-form textarea,
  :host ::ng-deep .orthodox-form-wrapper .contact-form input,
  :host ::ng-deep .orthodox-form-wrapper .contact-form textarea,
  :host ::ng-deep .orthodox-form-wrapper .build-form input,
  :host ::ng-deep .orthodox-form-wrapper .build-form textarea,
  :host ::ng-deep .orthodox-form-wrapper .about-form input,
  :host ::ng-deep .orthodox-form-wrapper .about-form textarea,
  :host ::ng-deep .orthodox-form-wrapper .retail-form input,
  :host ::ng-deep .orthodox-form-wrapper .retail-form textarea,
  :host ::ng-deep .orthodox-form-wrapper .orthodox-form input,
  :host ::ng-deep .orthodox-form-wrapper .orthodox-form textarea,
  :host ::ng-deep .orthodox-form-wrapper .products-form input,
  :host ::ng-deep .orthodox-form-wrapper .products-form textarea,
  :host ::ng-deep .products-form-wrapper .contact-form input,
  :host ::ng-deep .products-form-wrapper .contact-form textarea,
  :host ::ng-deep .products-form-wrapper .build-form input,
  :host ::ng-deep .products-form-wrapper .build-form textarea,
  :host ::ng-deep .products-form-wrapper .about-form input,
  :host ::ng-deep .products-form-wrapper .about-form textarea,
  :host ::ng-deep .products-form-wrapper .retail-form input,
  :host ::ng-deep .products-form-wrapper .retail-form textarea,
  :host ::ng-deep .products-form-wrapper .orthodox-form input,
  :host ::ng-deep .products-form-wrapper .orthodox-form textarea,
  :host ::ng-deep .products-form-wrapper .products-form input,
  :host ::ng-deep .products-form-wrapper .products-form textarea {
    padding: 12px 25px;
  }
  :host ::ng-deep .contact-form-wrapper .p-accordion .p-accordion-content,
  :host ::ng-deep .build-form-wrapper .p-accordion .p-accordion-content,
  :host ::ng-deep .about-form-wrapper .p-accordion .p-accordion-content,
  :host ::ng-deep .retail-form-wrapper .p-accordion .p-accordion-content,
  :host ::ng-deep .orthodox-form-wrapper .p-accordion .p-accordion-content,
  :host ::ng-deep .products-form-wrapper .p-accordion .p-accordion-content {
    padding: 10px;
  }
  :host ::ng-deep .contact-form-wrapper .p-accordion .p-accordion-content .p-tabview .p-tabview-panels,
  :host ::ng-deep .build-form-wrapper .p-accordion .p-accordion-content .p-tabview .p-tabview-panels,
  :host ::ng-deep .about-form-wrapper .p-accordion .p-accordion-content .p-tabview .p-tabview-panels,
  :host ::ng-deep .retail-form-wrapper .p-accordion .p-accordion-content .p-tabview .p-tabview-panels,
  :host ::ng-deep .orthodox-form-wrapper .p-accordion .p-accordion-content .p-tabview .p-tabview-panels,
  :host ::ng-deep .products-form-wrapper .p-accordion .p-accordion-content .p-tabview .p-tabview-panels {
    padding: 10px 0;
  }
  :host ::ng-deep .contact-item {
    margin-bottom: 0.75rem;
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  :host ::ng-deep .contact-form-wrapper,
  :host ::ng-deep .build-form-wrapper,
  :host ::ng-deep .about-form-wrapper,
  :host ::ng-deep .retail-form-wrapper,
  :host ::ng-deep .orthodox-form-wrapper,
  :host ::ng-deep .products-form-wrapper {
    padding: 15px 12px;
  }
  :host ::ng-deep .contact-form-wrapper .contact-form input,
  :host ::ng-deep .contact-form-wrapper .contact-form textarea,
  :host ::ng-deep .contact-form-wrapper .build-form input,
  :host ::ng-deep .contact-form-wrapper .build-form textarea,
  :host ::ng-deep .contact-form-wrapper .about-form input,
  :host ::ng-deep .contact-form-wrapper .about-form textarea,
  :host ::ng-deep .contact-form-wrapper .retail-form input,
  :host ::ng-deep .contact-form-wrapper .retail-form textarea,
  :host ::ng-deep .contact-form-wrapper .orthodox-form input,
  :host ::ng-deep .contact-form-wrapper .orthodox-form textarea,
  :host ::ng-deep .contact-form-wrapper .products-form input,
  :host ::ng-deep .contact-form-wrapper .products-form textarea,
  :host ::ng-deep .build-form-wrapper .contact-form input,
  :host ::ng-deep .build-form-wrapper .contact-form textarea,
  :host ::ng-deep .build-form-wrapper .build-form input,
  :host ::ng-deep .build-form-wrapper .build-form textarea,
  :host ::ng-deep .build-form-wrapper .about-form input,
  :host ::ng-deep .build-form-wrapper .about-form textarea,
  :host ::ng-deep .build-form-wrapper .retail-form input,
  :host ::ng-deep .build-form-wrapper .retail-form textarea,
  :host ::ng-deep .build-form-wrapper .orthodox-form input,
  :host ::ng-deep .build-form-wrapper .orthodox-form textarea,
  :host ::ng-deep .build-form-wrapper .products-form input,
  :host ::ng-deep .build-form-wrapper .products-form textarea,
  :host ::ng-deep .about-form-wrapper .contact-form input,
  :host ::ng-deep .about-form-wrapper .contact-form textarea,
  :host ::ng-deep .about-form-wrapper .build-form input,
  :host ::ng-deep .about-form-wrapper .build-form textarea,
  :host ::ng-deep .about-form-wrapper .about-form input,
  :host ::ng-deep .about-form-wrapper .about-form textarea,
  :host ::ng-deep .about-form-wrapper .retail-form input,
  :host ::ng-deep .about-form-wrapper .retail-form textarea,
  :host ::ng-deep .about-form-wrapper .orthodox-form input,
  :host ::ng-deep .about-form-wrapper .orthodox-form textarea,
  :host ::ng-deep .about-form-wrapper .products-form input,
  :host ::ng-deep .about-form-wrapper .products-form textarea,
  :host ::ng-deep .retail-form-wrapper .contact-form input,
  :host ::ng-deep .retail-form-wrapper .contact-form textarea,
  :host ::ng-deep .retail-form-wrapper .build-form input,
  :host ::ng-deep .retail-form-wrapper .build-form textarea,
  :host ::ng-deep .retail-form-wrapper .about-form input,
  :host ::ng-deep .retail-form-wrapper .about-form textarea,
  :host ::ng-deep .retail-form-wrapper .retail-form input,
  :host ::ng-deep .retail-form-wrapper .retail-form textarea,
  :host ::ng-deep .retail-form-wrapper .orthodox-form input,
  :host ::ng-deep .retail-form-wrapper .orthodox-form textarea,
  :host ::ng-deep .retail-form-wrapper .products-form input,
  :host ::ng-deep .retail-form-wrapper .products-form textarea,
  :host ::ng-deep .orthodox-form-wrapper .contact-form input,
  :host ::ng-deep .orthodox-form-wrapper .contact-form textarea,
  :host ::ng-deep .orthodox-form-wrapper .build-form input,
  :host ::ng-deep .orthodox-form-wrapper .build-form textarea,
  :host ::ng-deep .orthodox-form-wrapper .about-form input,
  :host ::ng-deep .orthodox-form-wrapper .about-form textarea,
  :host ::ng-deep .orthodox-form-wrapper .retail-form input,
  :host ::ng-deep .orthodox-form-wrapper .retail-form textarea,
  :host ::ng-deep .orthodox-form-wrapper .orthodox-form input,
  :host ::ng-deep .orthodox-form-wrapper .orthodox-form textarea,
  :host ::ng-deep .orthodox-form-wrapper .products-form input,
  :host ::ng-deep .orthodox-form-wrapper .products-form textarea,
  :host ::ng-deep .products-form-wrapper .contact-form input,
  :host ::ng-deep .products-form-wrapper .contact-form textarea,
  :host ::ng-deep .products-form-wrapper .build-form input,
  :host ::ng-deep .products-form-wrapper .build-form textarea,
  :host ::ng-deep .products-form-wrapper .about-form input,
  :host ::ng-deep .products-form-wrapper .about-form textarea,
  :host ::ng-deep .products-form-wrapper .retail-form input,
  :host ::ng-deep .products-form-wrapper .retail-form textarea,
  :host ::ng-deep .products-form-wrapper .orthodox-form input,
  :host ::ng-deep .products-form-wrapper .orthodox-form textarea,
  :host ::ng-deep .products-form-wrapper .products-form input,
  :host ::ng-deep .products-form-wrapper .products-form textarea {
    padding: 12px 25px;
  }
  :host ::ng-deep .contact-section {
    padding-top: 0;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  :host ::ng-deep .contact-form-wrapper,
  :host ::ng-deep .build-form-wrapper,
  :host ::ng-deep .about-form-wrapper,
  :host ::ng-deep .retail-form-wrapper,
  :host ::ng-deep .orthodox-form-wrapper,
  :host ::ng-deep .products-form-wrapper {
    padding: 25px 20px;
  }
  :host ::ng-deep .contact-section {
    padding-top: 0;
  }
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  :host ::ng-deep .contact-form-wrapper,
  :host ::ng-deep .build-form-wrapper,
  :host ::ng-deep .about-form-wrapper,
  :host ::ng-deep .retail-form-wrapper,
  :host ::ng-deep .orthodox-form-wrapper,
  :host ::ng-deep .products-form-wrapper {
    padding: 35px 30px;
  }
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  :host ::ng-deep .contact-form-wrapper,
  :host ::ng-deep .build-form-wrapper,
  :host ::ng-deep .about-form-wrapper,
  :host ::ng-deep .retail-form-wrapper,
  :host ::ng-deep .orthodox-form-wrapper,
  :host ::ng-deep .products-form-wrapper {
    padding: 35px 40px 40px 40px !important;
  }
  :host ::ng-deep .contact-section .contact-item-wrapper .contact-item {
    padding: 20px;
  }
  :host ::ng-deep .contact-section .contact-item-wrapper .contact-item .contact-content {
    margin-left: 20px;
  }
  :host ::ng-deep .contact-form-wrapper,
  :host ::ng-deep .about-form-wrapper {
    margin-left: 30px;
  }
}
/*===========================
  RESPONSIVE css dimensions
===========================*/
/* Small devices (portrait phones, less than 576px) */
/* Medium devices (landscape phones, 576px and up) */
/* Tablets (portrait and landscape) */
/* Large devices (desktops, 992px and up) */
/* Extra large devices (large desktops, 1200px and up) */
/* For very high resolution screens or when you want to use viewport units */
/*===========================
  COMMON css
===========================*/
:root {
  --font-family: "Inter", sans-serif;
  /*--primary: #155bd5;*/
  --primary: #446a35;
  /*--primary-dark: #1c3ab6;*/
  --primary-dark: #50783f;
  --primary-light: #84c785;
  --accent: #274482;
  --accent-dark: #122754;
  --accent-light: #3f5d92;
  --success: #13d527;
  --success-dark: #00ae11;
  --success-light: #eafbe7;
  --secondary: #f2c22f;
  --secondary-dark: #96791e;
  --secondary-light: #f8cf51;
  --info: #15b2d5;
  --info-dark: #0f8ca8;
  --info-light: #e0f5fa;
  --border-light: #ced3d9;
  --caution: #dbbb25;
  --caution-dark: #d58f15;
  --caution-light: #fbf9e4;
  --error: #e6185e;
  --error-dark: #bf1257;
  --error-light: #fce4eb;
  --black: #1d1d1d;
  --charcoal: #3a4353;
  --dark-1: #2d2d2d;
  --dark-2: #4d4d4d;
  --dark-3: #6d6d6d;
  --gray-1: #8d8d8d;
  --gray-2: #adadad;
  --gray-3: #cdcdcd;
  --gray-4: #e0e0e0;
  --light-1: #efefef;
  --light-2: #f5f5f5;
  --light-3: #fafafa;
  --visualage-1: #a22025;
  --white: #ffffff;
  --gradient-1: linear-gradient(180deg, #155bd5 0%, #1c3ab6 100%);
  --gradient-2: linear-gradient(180deg, #155bd5 13.02%, #00d4d7 85.42%);
  --gradient-3: linear-gradient(180deg, #155bd5 0%, #8f15d5 100%);
  --gradient-4: linear-gradient(180deg, #155bd5 0%, #13d527 100%);
  --gradient-5: linear-gradient(180deg, #155bd5 0%, #15bbd5 100%);
  --gradient-6: linear-gradient(180deg, #155bd5 0%, #dbbb25 100%);
  --gradient-7: linear-gradient(180deg, #155bd5 0%, #e6185e 100%);
  --gradient-8: linear-gradient(180deg, #1c3ab6 0%, #00bac1 100%);
  --gradient-9: linear-gradient(180deg, #00d4d7 13.02%, #155bd5 85.42%);
  --shadow-1: 0px 0px 1px rgba(40, 41, 61, 0.08),
  0px 0.5px 2px rgba(96, 97, 112, 0.16);
  --shadow-2: 0px 0px 1px rgba(40, 41, 61, 0.04),
  0px 2px 4px rgba(96, 97, 112, 0.16);
  --shadow-3: 0px 0px 2px rgba(40, 41, 61, 0.04),
  0px 4px 8px rgba(96, 97, 112, 0.16);
  --shadow-4: 0px 2px 4px rgba(40, 41, 61, 0.04),
  0px 8px 16px rgba(96, 97, 112, 0.16);
  --shadow-5: 0px 2px 8px rgba(40, 41, 61, 0.04),
  0px 16px 24px rgba(96, 97, 112, 0.16);
  --shadow-6: 0px 2px 8px rgba(40, 41, 61, 0.08),
  0px 20px 32px rgba(96, 97, 112, 0.24);
  --shadow-7: 0px 4px 16px rgba(40, 41, 61, 0.04),
  0px 25px 40px rgba(96, 97, 112, 0.16);
}

/* Default styles for desktop */
html, body {
  height: 100%; /* Ensure that ancestors have defined height */
}

body, a, p, label, input, li {
  font-family: var(--font-family);
  color: var(--dark-2);
  font-size: 16px; /* Base font size */
  line-height: 1.5; /* Line height for better readability */
}

h1, .h1 {
  font-size: 2em; /* 32px if base font size is 16px */
  color: var(--accent) !important;
  font-weight: 700 !important;
}

h2, .h2 {
  color: var(--accent) !important;
  font-size: 1.5em; /* 24px */
}

h3, .h3 {
  color: var(--accent) !important;
  font-size: 1.17em; /* 18.72px */
}

h4, .h4 {
  color: var(--accent) !important;
  font-size: 1em; /* 16px */
}

h5, .h5 {
  color: var(--accent) !important;
  font-size: 0.83em; /* 13.28px */
}

h6, .h6 {
  color: var(--accent) !important;
  font-size: 0.67em; /* 10.72px */
}

div, span, label, p, a, input, li {
  font-size: 1em !important; /* Inherits from body font size */
}

/* Additional elements */
button, input, textarea, button > span {
  font-size: 1em; /* Inherits from body font size */
}

p {
  margin: 0 0 1rem;
  line-height: 1.5;
}

p:last-child {
  margin-bottom: 0;
}

/* Small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
  body {
    font-size: 12px; /* Smaller base size for smaller screens */
  }
  h1, .h1 {
    font-size: 1.7em; /* 23.8px */
  }
  h2, .h2 {
    font-size: 1.4em; /* 19.6px */
  }
  h3, .h3 {
    font-size: 1.2em; /* 16.8px */
  }
  h4, h5, h6, .h4, .h5, .h6 {
    font-size: 1em; /* Keep consistent with body text */
  }
  p {
    margin: 0 0 0.75rem;
    line-height: 1.35;
  }
}
/* Medium devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
  body {
    font-size: 12.5px;
  }
  h1, .h1 {
    font-size: 1.8em; /* 27px */
  }
  h2, .h2 {
    font-size: 1.4em; /* 21px */
  }
  h3, .h3 {
    font-size: 1.2em; /* 18px */
  }
  p {
    margin: 0 0 0.5rem;
    line-height: 1.35;
  }
}
/* Tablets (portrait and landscape) */
@media (min-width: 768px) and (max-width: 991.98px) {
  body {
    font-size: 13px; /* Back to default desktop size */
  }
  h1, .h1 {
    font-size: 2em; /* 32px */
  }
  h2, .h2 {
    font-size: 1.5em; /* 24px */
  }
  h3, .h3 {
    font-size: 1.17em; /* 18.72px */
  }
  p {
    margin: 0 0 0.5rem;
    line-height: 1.35;
  }
}
/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {
  /* Use the default desktop sizes from above */
}
/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  /* You might want to slightly increase font sizes for larger screens */
  body {
    font-size: 17px;
  }
  h1, .h1 {
    font-size: 2.1em; /* 35.7px */
  }
  h2, .h2 {
    font-size: 1.6em; /* 27.2px */
  }
  h3, .h3 {
    font-size: 1.3em; /* 22.1px */
  }
}
/* For very high resolution screens or when you want to use viewport units */
@media (min-width: 1920px) {
  body {
    font-size: 17px;
  }
  h1, .h1 {
    font-size: calc(2em + 0.3vw);
  }
  h2, .h2 {
    font-size: calc(1.5em + 0.2vw);
  }
  h3, .h3 {
    font-size: calc(1.17em + 0.1vw);
  }
}
img {
  max-width: 100%;
}

a {
  display: inline-block;
}

a:hover {
  cursor: pointer;
}

a,
button,
a:hover,
a:focus,
input:focus,
textarea:focus,
button:focus {
  text-decoration: none;
  outline: none;
}

ul,
ol {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.display-table {
  display: table;
}

.display-1 {
  font-size: 5.5em;
  line-height: 1.25;
}

.display-2 {
  font-size: 4.75em;
  line-height: 1.25;
}

.display-3 {
  font-size: 4em;
  line-height: 1.25;
}

.display-4 {
  font-size: 3.25em;
  line-height: 1.25;
}

.no-margin {
  margin: 0 !important;
}

.no-margin-top {
  margin-top: 0 !important;
}

.no-margin-bottom {
  margin-bottom: 0 !important;
}

.no-margin-left {
  margin-left: 0 !important;
}

.no-margin-right {
  margin-right: 0 !important;
}

.no-padding {
  padding: 0 !important;
}

.no-padding-top {
  padding-top: 0 !important;
}

.no-padding-bottom {
  padding-bottom: 0 !important;
}

.no-padding-left {
  padding-left: 0 !important;
}

.no-padding-right {
  padding-right: 0 !important;
}

.text-smaller {
  font-size: 0.875em !important;
  line-height: 1.35;
}

.text-small {
  font-size: 0.67em !important;
  line-height: 1.15;
}

.text-lg {
  font-size: 1.15em;
  line-height: 1.5;
}

.bg_cover {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.container {
  padding-left: 20px;
  padding-right: 20px;
}

.btn {
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 12px 24px;
  border-radius: 4px;
  border: 1px solid transparent;
}

.btn:hover {
  color: inherit;
}

.btn:focus {
  box-shadow: none;
  outline: none;
}

.btn.btn-lg {
  font-size: 1.15em;
  padding: 16px 24px;
}

.btn.btn-sm {
  padding: 8px 16px;
}

.btn.square {
  border-radius: 0px;
}

.btn.semi-rounded {
  border-radius: 12px;
}

.btn.rounded-full {
  border-radius: 50px;
}

.btn.icon-left span,
.btn.icon-left i {
  margin-right: 8px;
}

.btn.icon-right span,
.btn.icon-right i {
  margin-left: 8px;
}

.btn.icon-btn {
  width: 48px;
  height: 48px;
  padding: 0;
  line-height: 48px;
}

.btn.icon-btn.btn-lg {
  width: 56px;
  height: 56px;
  line-height: 56px;
}

.btn.icon-btn.btn-sm {
  width: 40px;
  height: 40px;
  line-height: 40px;
}

.p-grid {
  margin-bottom: -0.5rem;
  flex-wrap: nowrap;
}

.p-field.p-grid .p-col-0,
.p-formgrid.p-grid .p-col-0 {
  padding-top: 0;
  padding-bottom: 0;
}

.p-col-0,
.p-sm-0,
.p-md-0,
.p-lg-0,
.p-xl-0 {
  flex: 0;
  padding: 0;
  width: 0;
}

.p-col-0.p-sm-1, .p-col-0.p-sm-2, .p-col-0.p-sm-3, .p-col-0.p-sm-4, .p-col-0.p-sm-5, .p-col-0.p-sm-6, .p-col-0.p-sm-7, .p-col-0.p-sm-8, .p-col-0.p-sm-9, .p-col-0.p-sm-10, .p-col-0.p-sm-11, .p-col-0.p-sm-12, .p-col-0.p-md-1, .p-col-0.p-md-2, .p-col-0.p-md-3, .p-col-0.p-md-4, .p-col-0.p-md-5, .p-col-0.p-md-6, .p-col-0.p-md-7, .p-col-0.p-md-8, .p-col-0.p-md-9, .p-col-0.p-md-10, .p-col-0.p-md-11, .p-col-0.p-md-12, .p-col-0.p-lg-1, .p-col-0.p-lg-2, .p-col-0.p-lg-3, .p-col-0.p-lg-4, .p-col-0.p-lg-5, .p-col-0.p-lg-6, .p-col-0.p-lg-7, .p-col-0.p-lg-8, .p-col-0.p-lg-9, .p-col-0.p-lg-10, .p-col-0.p-lg-11, .p-col-0.p-lg-12, .p-col-0.p-xl-1, .p-col-0.p-xl-2, .p-col-0.p-xl-3, .p-col-0.p-xl-4, .p-col-0.p-xl-5, .p-col-0.p-xl-6, .p-col-0.p-xl-7, .p-col-0.p-xl-8, .p-col-0.p-xl-9, .p-col-0.p-xl-10, .p-col-0.p-xl-11, .p-col-0.p-xl-12 {
  padding: 0 !important;
}

.p-sm-0.p-md-1, .p-sm-0.p-md-2, .p-sm-0.p-md-3, .p-sm-0.p-md-4, .p-sm-0.p-md-5, .p-sm-0.p-md-6, .p-sm-0.p-md-7, .p-sm-0.p-md-8, .p-sm-0.p-md-9, .p-sm-0.p-md-10, .p-sm-0.p-md-11, .p-sm-0.p-md-12, .p-sm-0.p-lg-1, .p-sm-0.p-lg-2, .p-sm-0.p-lg-3, .p-sm-0.p-lg-4, .p-sm-0.p-lg-5, .p-sm-0.p-lg-6, .p-sm-0.p-lg-7, .p-sm-0.p-lg-8, .p-sm-0.p-lg-9, .p-sm-0.p-lg-10, .p-sm-0.p-lg-11, .p-sm-0.p-lg-12, .p-sm-0.p-xl-1, .p-sm-0.p-xl-2, .p-sm-0.p-xl-3, .p-sm-0.p-xl-4, .p-sm-0.p-xl-5, .p-sm-0.p-xl-6, .p-sm-0.p-xl-7, .p-sm-0.p-xl-8, .p-sm-0.p-xl-9, .p-sm-0.p-xl-10, .p-sm-0.p-xl-11, .p-sm-0.p-xl-12 {
  padding: 0 !important;
}

.p-md-0.p-lg-1, .p-md-0.p-lg-2, .p-md-0.p-lg-3, .p-md-0.p-lg-4, .p-md-0.p-lg-5, .p-md-0.p-lg-6, .p-md-0.p-lg-7, .p-md-0.p-lg-8, .p-md-0.p-lg-9, .p-md-0.p-lg-10, .p-md-0.p-lg-11, .p-md-0.p-lg-12, .p-md-0.p-xl-1, .p-md-0.p-xl-2, .p-md-0.p-xl-3, .p-md-0.p-xl-4, .p-md-0.p-xl-5, .p-md-0.p-xl-6, .p-md-0.p-xl-7, .p-md-0.p-xl-8, .p-md-0.p-xl-9, .p-md-0.p-xl-10, .p-md-0.p-xl-11, .p-md-0.p-xl-12 {
  padding: 0 !important;
}

.p-lg-0.p-xl-1, .p-lg-0.p-xl-2, .p-lg-0.p-xl-3, .p-lg-0.p-xl-4, .p-lg-0.p-xl-5, .p-lg-0.p-xl-6, .p-lg-0.p-xl-7, .p-lg-0.p-xl-8, .p-lg-0.p-xl-9, .p-lg-0.p-xl-10, .p-lg-0.p-xl-11, .p-lg-0.p-xl-12 {
  padding: 0 !important;
}

@media screen and (min-width: 576px) {
  .p-sm-0 {
    flex: 0 0 auto;
  }
  .p-sm-0 {
    width: 0;
  }
}
@media screen and (min-width: 768px) {
  .p-md-0 {
    flex: 0 0 auto;
  }
  .p-md-0 {
    width: 0;
  }
}
@media screen and (min-width: 992px) {
  .p-lg-0 {
    flex: 0 0 auto;
  }
  .p-lg-0 {
    width: 0;
  }
}
@media screen and (min-width: 1200px) {
  .p-xl-0 {
    flex: 0 0 auto;
  }
  .p-xl-0 {
    width: 0;
  }
}
/* ===== Buttons Css ===== */
.primary-btn {
  background: var(--primary);
  color: var(--white);
  box-shadow: var(--shadow-2);
}

.active.primary-btn, .primary-btn:hover, .primary-btn:focus {
  background: var(--primary-dark);
  color: var(--white);
  box-shadow: var(--shadow-4);
}

.deactive.primary-btn {
  background: var(--gray-4);
  color: var(--dark-3);
  pointer-events: none;
}

.primary-btn-outline {
  border-color: var(--primary);
  color: var(--primary);
}

.active.primary-btn-outline, .primary-btn-outline:hover, .primary-btn-outline:focus {
  background: var(--primary-dark);
  color: var(--white);
}

.deactive.primary-btn-outline {
  color: var(--dark-3);
  border-color: var(--gray-4);
  pointer-events: none;
}

/* One Click Scrool Top Button*/
.scroll-top {
  width: 45px;
  height: 45px;
  line-height: 45px;
  background: var(--primary);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #fff !important;
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 8;
  cursor: pointer;
  transition: all 0.3s ease-out 0s;
  border-radius: 5px;
}

.scroll-top:hover {
  box-shadow: 0 1rem 3rem rgba(35, 38, 45, 0.15) !important;
  transform: translate3d(0, -5px, 0);
  background-color: var(--dark-1);
}

/*===========================
  Section Title Five CSS
===========================*/
.section-title-five {
  text-align: center;
  max-width: 550px;
  margin: auto;
  margin-bottom: 50px;
  position: relative;
  z-index: 5;
}

.section-title-five h6 {
  font-weight: 600;
  display: inline-block;
  margin-bottom: 15px;
  color: var(--primary);
  border: 2px solid var(--primary);
  border-radius: 30px;
  padding: 8px 30px;
}

.section-title-five h2 {
  margin-bottom: 15px;
}

.section-title-five p {
  color: var(--dark-3);
}

/*===========================
  Section Title Six CSS
===========================*/
.section-title-six {
  font-family: "Times New Roman", Hoefler Text, Liberation Serif, Times, Cambria, serif;
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 1rem;
  margin-top: 1.5rem;
}
.section-title-six .heading {
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.section-title-six .heading .heading-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: transparent;
  border: 1px solid var(--accent);
  color: var(--accent);
}
.section-title-six h2 {
  color: var(--accent);
  font-weight: 500;
  font-size: 32px;
  line-height: 1.3em;
}
.section-title-six h2 i {
  font-style: italic;
}
.section-title-six ul {
  border-top: 1px solid var(--accent);
  border-bottom: 1px solid var(--accent);
}
.section-title-six ul li {
  font-family: "Times New Roman", Hoefler Text, Liberation Serif, Times, Cambria, serif;
  color: var(--accent);
  font-size: 1.3em !important;
  margin: 0.5rem;
  margin-left: 2rem;
}
.section-title-six ul li:last-child:not(:first-child) {
  margin-top: 0;
}
.section-title-six ul li:first-child:not(:last-child) {
  margin-bottom: 0;
}

@media (max-width: 575.98px) {
  .section-title-six {
    margin: 0.5rem;
    margin-top: 0.75rem;
  }
}
.made-in-ayroui {
  position: fixed;
  left: 5px;
  bottom: 5px;
  z-index: 999;
  transition: all 0.4s ease;
}

.made-in-ayroui:hover {
  transform: translateY(-5px);
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .section-title-five {
    margin-bottom: 5px;
  }
  .section-title-five h2 {
    font-size: 1.5rem;
    line-height: 1.9rem;
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .section-title-five {
    margin-bottom: 5px;
  }
  .section-title-five h2 {
    font-size: 1.5rem;
    line-height: 1.9rem;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .section-title-five {
    margin-bottom: 10px;
  }
  .section-title-five h2 {
    font-size: 2rem;
    line-height: 2.8rem;
  }
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .section-title-five {
    margin-bottom: 15px;
  }
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .section-title-five {
    margin-bottom: 20px;
  }
}
/*===========================
  NAVBAR css
===========================*/
.navbar-toggler:focus {
  box-shadow: none;
}

.mb-100 {
  margin-bottom: 100px;
}

/*===== NAVBAR NINE =====*/
.navbar-area.navbar-nine {
  background: var(--primary);
  padding: 0;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 9;
}

.sticky {
  position: fixed !important;
  z-index: 99 !important;
  transition: all 0.3s ease-out 0s;
  top: 0;
  width: 100%;
}

.navbar-area.navbar-nine .navbar-brand {
  margin: 0;
}

.navbar-area.navbar-nine .navbar {
  position: relative;
  padding: 0;
}

.navbar-area.navbar-nine .navbar .navbar-toggler .toggler-icon {
  width: 30px;
  height: 2px;
  background-color: var(--white);
  margin: 5px 0;
  display: block;
  position: relative;
  transition: all 0.3s ease-out 0s;
}

.navbar-area.navbar-nine .navbar .navbar-toggler.active .toggler-icon:nth-of-type(1) {
  transform: rotate(45deg);
  top: 7px;
}

.navbar-area.navbar-nine .navbar .navbar-toggler.active .toggler-icon:nth-of-type(2) {
  opacity: 0;
}

.navbar-area.navbar-nine .navbar .navbar-toggler.active .toggler-icon:nth-of-type(3) {
  transform: rotate(135deg);
  top: -7px;
}

@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .navbar-area.navbar-nine .navbar .navbar-collapse {
    position: absolute;
    top: 116%;
    left: 0;
    width: 100%;
    background-color: var(--primary);
    z-index: 8;
    padding: 10px 16px;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1399px), only screen and (min-width: 1400px) {
  .navbar-area.navbar-nine .navbar .navbar-nav {
    margin-left: 80px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .navbar-area.navbar-nine .navbar .navbar-nav {
    margin-right: 0;
  }
}
.navbar-area.navbar-nine .navbar .navbar-nav .nav-item {
  position: relative;
}

.navbar-area.navbar-nine .navbar .navbar-nav .nav-item a {
  display: flex;
  align-items: center;
  padding: 11px 16px;
  color: var(--white);
  text-transform: capitalize;
  position: relative;
  border-radius: 5px;
  font-weight: 500;
  transition: all 0.3s ease-out 0s;
  margin: 14px 0;
  opacity: 0.7;
}

.navbar-area.navbar-nine .navbar .navbar-nav .nav-item a:hover {
  opacity: 1;
}

@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item a {
    padding: 10px 0;
    display: block;
    border: 0;
    margin: 0;
  }
}
.navbar-area.navbar-nine .navbar .navbar-nav .nav-item a.active {
  opacity: 1;
}

.navbar-area.navbar-nine .navbar .navbar-nav .nav-item a i {
  font-size: 12px;
  font-weight: 700;
  padding-left: 7px;
  transition: all 0.3s ease-out 0s;
}

@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item a i {
    position: relative;
    top: -5px;
  }
}
.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu {
  position: absolute;
  left: 0;
  top: 130%;
  width: 230px;
  background-color: var(--white);
  border-radius: 5px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease-out 0s;
  z-index: 99;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
  padding: 10px;
}

@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu {
    position: relative !important;
    width: 100% !important;
    left: 0 !important;
    top: auto !important;
    opacity: 1 !important;
    visibility: visible !important;
    right: auto;
    transform: translateX(0%);
    transition: all none ease-out 0s;
    box-shadow: none;
    text-align: left;
    border-top: 0;
    height: 0;
  }
}
.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu.collapse:not(.show) {
  height: auto;
  display: block;
}

@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu.collapse:not(.show) {
    height: 0;
    display: none;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu.show {
    height: auto;
  }
}
.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li {
  position: relative;
}

.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li .sub-nav-toggler {
  color: var(--black);
  transition: all 0.3s ease-out 0s;
}

.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  position: relative;
  color: var(--dark-2);
  transition: all 0.3s ease-out 0s;
  border-radius: 0;
  margin: 0 0;
  z-index: 5;
  opacity: 1;
}

.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li a i {
  font-weight: 700;
  font-size: 12px;
}

@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li a i {
    display: none;
  }
}
.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li a .sub-nav-toggler i {
  display: inline-block;
}

.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li .sub-menu {
  right: auto;
  left: 100%;
  top: 0;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease-out 0s;
}

@media only screen and (min-width: 1200px) and (max-width: 1399px), only screen and (min-width: 1400px) {
  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li .sub-menu {
    margin-left: 10px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li .sub-menu {
    padding-left: 30px;
  }
}
@media (max-width: 767px) {
  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li .sub-menu {
    padding-left: 30px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li .sub-menu.show {
    visibility: visible;
    height: auto;
    position: relative;
  }
}
.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li:hover .sub-menu {
  opacity: 1;
  visibility: visible;
}

.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li:hover .sub-nav-toggler {
  color: var(--white);
}

@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li:hover .sub-nav-toggler {
    color: var(--primary);
  }
}
.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li:hover > a {
  color: var(--primary);
  padding-left: 22px;
}

.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li:hover > a i {
  color: var(--primary);
}

@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li:hover > a {
    color: var(--primary);
  }
}
.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li:hover > a::after {
  opacity: 1;
}

.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li:hover > a::before {
  opacity: 1;
}

.navbar-area.navbar-nine .navbar .navbar-nav .nav-item:hover .sub-menu {
  opacity: 1;
  visibility: visible;
  top: 115%;
}

@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-nav-toggler {
    display: inline-block;
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px 14px;
    font-size: 16px;
    background: none;
    border: 0;
    color: var(--white);
  }
}
.navbar-area.navbar-nine .navbar .navbar-btn {
  margin-top: 6px;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .navbar-area.navbar-nine .navbar .navbar-btn {
    position: absolute;
    right: 70px;
    top: 7px;
  }
}
@media (max-width: 767px) {
  .navbar-area.navbar-nine .navbar .navbar-btn {
    position: absolute;
    right: 60px;
    top: 7px;
  }
}
.navbar-area.navbar-nine .navbar .navbar-btn .menu-bar,
.navbar-btn .menu-bar {
  font-size: inherit;
  position: relative;
  overflow: hidden;
  color: var(--white);
  height: 40px;
  width: 40px;
  line-height: 42px;
  text-align: center;
  border: 1px solid rgba(238, 238, 238, 0.425);
  border-radius: 50%;
  transition: all 0.3s ease-out 0s;
}

.navbar-area.navbar-nine .navbar .navbar-btn .menu-bar:hover {
  border-color: transparent;
  color: var(--primary);
  background-color: var(--white);
}

/*===== SIDEBAR ONE =====*/
.sidebar-left {
  position: fixed;
  top: 0;
  right: 0;
  background-color: var(--white);
  height: 100%;
  width: 350px;
  padding-top: 80px;
  z-index: 999;
  transform: translateX(100%);
  transition: all 0.4s ease-in-out;
  text-align: left;
}

.sidebar-left.open {
  transform: translateX(0);
}

@media (max-width: 767px) {
  .sidebar-left {
    width: 100%;
    max-width: 480px;
    overflow-y: scroll;
  }
}
.sidebar-left .sidebar-close {
  position: absolute;
  top: 30px;
  right: 30px;
}

.sidebar-left .sidebar-close .close {
  font-size: 18px;
  color: var(--black);
  transition: all 0.2s ease-out 0s;
}

.sidebar-left .sidebar-close .close:hover {
  cursor: pointer;
  transform: rotate(90deg);
}

.sidebar-left .sidebar-content {
  padding: 0px 30px;
}

.sidebar-left .sidebar-content .sidebar-logo h3 {
  color: var(--primary);
}

.sidebar-left .sidebar-content .sidebar-menu {
  margin-top: 30px;
}

.sidebar-left .sidebar-content .sidebar-menu .menu-title {
  font-size: 18px;
  font-weight: 600;
}

.sidebar-left .sidebar-content .sidebar-menu ul {
  margin-top: 15px;
}

.sidebar-left .sidebar-content .sidebar-menu ul li a {
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  padding: 8px 0;
  color: var(--primary);
  text-transform: capitalize;
  position: relative;
  border-radius: 5px;
  transition: all 0.3s ease-out 0s;
  display: block;
}

.sidebar-left .sidebar-content .sidebar-menu ul li a:hover {
  color: var(--primary-dark);
  padding-left: 5px;
  cursor: pointer;
}

.sidebar-left .sidebar-content .text {
  margin-top: 20px;
}

.sidebar-left .sidebar-content .sidebar-social {
  margin-top: 30px;
}

.sidebar-left .sidebar-content .sidebar-social .social-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 25px;
}

.sidebar-left .sidebar-content .sidebar-social ul li {
  display: inline-block;
  margin-right: 5px;
}

.sidebar-left .sidebar-content .sidebar-social ul li:last-child {
  margin: 0;
}

.sidebar-left .sidebar-content .sidebar-social ul li a {
  height: 38px;
  width: 38px;
  line-height: 38px;
  text-align: center;
  border: 1px solid #eee;
  border-radius: 50%;
  font-size: 18px;
  color: #666;
  transition: all 0.3s ease-out 0s;
}

.sidebar-left .sidebar-content .sidebar-social ul li a:hover {
  color: var(--white);
  background-color: var(--primary);
  border-color: transparent;
}

.overlay-left {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
  z-index: 99;
}

.overlay-left.open {
  display: block;
}

/* ===== Buttons Css ===== */
.header-eight .primary-btn {
  background: var(--primary);
  color: var(--white);
  box-shadow: var(--shadow-2);
}

.header-eight .active.primary-btn, .header-eight .primary-btn:hover, .header-eight .primary-btn:focus {
  background: var(--primary-dark);
  color: var(--white);
  box-shadow: var(--shadow-4);
}

.header-eight .deactive.primary-btn {
  background: var(--gray-4);
  color: var(--dark-3);
  pointer-events: none;
}

/*======================================
    header Area CSS
========================================*/
.header-eight {
  height: auto;
  min-height: calc(100vh - 78px);
  margin-top: -78px;
  display: flex;
  flex-direction: column;
  position: relative;
  background: var(--white);
  transition: 0.9s;
}
.header-eight.landscape.navbar-collapse {
  padding: 46px 0 0 !important;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  ::ng-deep .header-eight {
    height: calc(100vh - 54px) !important;
    max-height: 100vw !important;
    padding-top: 0;
    margin-top: 54px;
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) and (max-width: 767px) {
  ::ng-deep .header-eight {
    height: calc(100vh - 54px) !important;
    max-height: 155vw !important;
    padding-top: 0;
    margin-top: 54px;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  ::ng-deep .header-eight {
    height: calc(100vh - 62px) !important;
    padding-top: 0;
    margin-top: 62px;
  }
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  ::ng-deep .header-eight {
    padding: 94px 0 80px 0 !important;
  }
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
.banner1:after {
  content: "";
  background: url('rooftop-solar-suburb.jpeg') no-repeat top left fixed;
  background-size: cover;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.2;
}

.banner2:after {
  content: "";
  background: url('rooftop-solar-grid.jpeg') no-repeat top left fixed;
  background-size: cover;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.5;
}

.header-eight .header-image img {
  width: 100%;
  border-radius: 8px;
}

@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .header-eight .header-image {
    margin-top: 40px;
  }
}
.header-eight .header-content {
  border-radius: 0;
  position: relative;
  z-index: 1;
  text-align: left;
  margin-top: 156px;
}

.header-eight .header-content h1 {
  font-weight: 700;
  color: var(--accent);
  text-shadow: 0 3px 8px rgba(0, 0, 0, 0.0901960784);
  text-transform: capitalize;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .header-eight .header-content h1 {
    font-size: 35px;
    line-height: 45px;
  }
}
@media (max-width: 767px) {
  .header-eight .header-content h1 {
    font-size: 30px;
    line-height: 42px;
  }
}
.header-eight .header-content h1 span {
  display: block;
}

.header-eight .header-content p {
  margin-top: 30px;
  color: var(--charcoal);
  opacity: 0.7;
}

.header-eight .button {
  margin-top: 40px;
}

.header-eight .primary-btn {
  margin-right: 12px;
  background-color: var(--white);
  color: var(--primary);
  border: 1px solid transparent;
}

.header-eight .primary-btn:hover {
  background-color: transparent;
  color: var(--white);
  border-color: var(--white);
}

.header-eight .video-button {
  display: inline-flex;
  align-items: center;
}

@media (max-width: 767px) {
  .header-eight .video-button {
    margin-top: 20px;
  }
}
.header-eight .video-button .text {
  display: inline-block;
  margin-left: 15px;
  color: var(--white);
  font-weight: 600;
}

.header-eight .video-button .icon-btn {
  background: var(--white);
  color: var(--primary);
}

/*===========================
  about-05 css
===========================*/
.about-five {
  background-color: var(--light-3);
  padding-top: 120px;
  padding-bottom: 90px;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-five {
    padding-top: 100px;
    padding-bottom: 70px;
  }
}
@media (max-width: 767px) {
  .about-five {
    padding-top: 80px;
    padding-bottom: 60px;
  }
}
.about-five-content {
  padding-left: 50px;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-five-content {
    padding-left: 0;
  }
}
@media (max-width: 767px) {
  .about-five-content {
    padding-left: 0;
  }
}
.about-five-content .small-title {
  position: relative;
  padding-left: 30px;
}

.about-five-content .small-title::before {
  position: absolute;
  content: "";
  left: 0;
  top: 50%;
  background-color: var(--primary);
  height: 2px;
  width: 20px;
  margin-top: -1px;
}

.about-five-content .main-title {
  margin-top: 20px;
}

.about-five-content .about-five-tab {
  margin-top: 40px;
}

.about-five-content .about-five-tab nav {
  border: none;
  background-color: var(--light-1);
  padding: 15px;
  border-radius: 5px;
}

.about-five-content .about-five-tab nav .nav-tabs {
  border: none;
}

.about-five-content .about-five-tab nav button {
  border: none;
  color: var(--dark-1);
  font-weight: 600;
  padding: 0;
  margin-right: 20px;
  position: relative;
  background-color: var(--white);
  padding: 10px 18px;
  border-radius: 4px;
  text-transform: capitalize;
}

@media (max-width: 767px) {
  .about-five-content .about-five-tab nav button {
    margin: 0;
    margin-bottom: 10px;
    width: 100%;
  }
  .about-five-content .about-five-tab nav button:last-child {
    margin: 0;
  }
}
.about-five-content .about-five-tab nav button:hover {
  color: var(--primary);
}

.about-five-content .about-five-tab nav button.active {
  background-color: var(--primary);
  color: var(--white);
}

.about-five-content .about-five-tab nav button:last-child {
  margin-right: 0;
}

.about-five-content .about-five-tab .tab-content {
  border: none;
}

.about-five-content .about-five-tab .tab-content p {
  margin-bottom: 20px;
}

.about-five-content .about-five-tab .tab-content p:last-child {
  margin: 0;
}

.about-image-five {
  padding-left: 60px;
  position: relative;
  z-index: 2;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-image-five {
    margin-bottom: 70px;
    padding-left: 30px;
  }
}
@media (max-width: 767px) {
  .about-image-five {
    margin-bottom: 60px;
    padding-left: 0;
  }
}
.about-image-five .shape {
  position: absolute;
  left: 30px;
  top: -30px;
  z-index: -1;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-image-five .shape {
    left: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-image-five::before {
    right: -15px;
    bottom: -15px;
  }
}
@media (max-width: 767px) {
  .about-image-five::before {
    display: none;
  }
}
.about-image-five img {
  width: 100%;
  z-index: 2;
}

/*===========================
  services css
===========================*/
.services-eight {
  padding: 100px 0;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .services-eight {
    padding: 80px 0 50px 0;
  }
}
@media (max-width: 767px) {
  .services-eight {
    padding: 60px 0 30px 0;
  }
}
.services-eight .single-services {
  padding: 40px 30px;
  border: 1px solid var(--light-1);
  border-radius: 10px;
  margin-bottom: 30px;
  transition: all 0.3s ease-out 0s;
}

.services-eight .single-services:hover {
  box-shadow: var(--shadow-4);
}

.services-eight .single-services:hover .service-icon {
  color: var(--white);
  border-color: transparent;
  background: var(--primary);
}

.services-eight .single-services:hover .service-icon::after {
  opacity: 1;
  visibility: visible;
}

.services-eight .single-services .service-icon {
  width: 78px;
  height: 78px;
  border-radius: 50%;
  margin-bottom: 25px;
  background: var(--white);
  border: 2px solid var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary);
  font-size: 40px;
  transition: all 0.3s ease-out 0s;
  position: relative;
}

.services-eight .single-services .service-icon::after {
  content: "";
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  opacity: 0;
  visibility: hidden;
  background: var(--primary);
  transition: all 0.3s ease-out 0s;
  z-index: -1;
  border-radius: 50%;
  border: 1px solid transparent;
}

.services-eight .single-services .service-content h4 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
}

.services-eight .single-services .service-content p {
  color: var(--dark-3);
}

/*===== VIDEO ONE =====*/
.video-one {
  background-color: var(--light-3);
  padding: 100px 0;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .video-one {
    padding: 80px;
  }
}
@media (max-width: 767px) {
  .video-one {
    padding: 60px 0;
  }
}
.video-one .video-title h5 {
  font-weight: 600;
  color: var(--primary);
}

.video-one .video-title h2 {
  font-weight: 700;
  color: var(--black);
  margin-top: 10px;
}

.video-one .video-title .text-lg {
  margin-top: 24px;
  color: var(--dark-3);
}

.video-one .video-content {
  position: relative;
  margin-top: 20px;
  border-radius: 8px;
  overflow: hidden;
}

.video-one .video-content img {
  border-radius: 8px;
}

.video-one .video-content a {
  width: 88px;
  height: 88px;
  line-height: 88px;
  text-align: center;
  border-radius: 50%;
  background-color: var(--primary);
  color: var(--white);
  font-size: 30px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.3s ease-out 0s;
  padding-left: 3px;
}

@media (max-width: 767px) {
  .video-one .video-content a {
    width: 68px;
    height: 68px;
    line-height: 68px;
    font-size: 20px;
  }
}
.video-one .video-content a:hover {
  background-color: var(--white);
  color: var(--primary);
}

/*===== PRICING THIRTEEN =====*/
.pricing-fourteen {
  padding: 100px 0;
  background-color: var(--light-3);
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .pricing-fourteen {
    padding: 80px;
  }
}
@media (max-width: 767px) {
  .pricing-fourteen {
    padding: 60px 0;
  }
}
.pricing-style-fourteen {
  border: 1px solid var(--light-1);
  border-radius: 10px;
  margin-top: 30px;
  background-color: var(--white);
  transition: all 0.4s ease;
  padding: 50px 35px;
  text-align: center;
  z-index: 0;
}

.pricing-style-fourteen:hover {
  box-shadow: var(--shadow-4);
}

.pricing-style-fourteen.middle {
  box-shadow: var(--shadow-4);
}

.pricing-style-fourteen.middle .title {
  border-color: var(--primary);
  background: var(--primary);
  color: var(--white);
}

.pricing-style-fourteen .title {
  font-weight: 500;
  margin-bottom: 25px;
  color: var(--primary);
  padding: 8px 20px;
  border: 2px solid var(--primary);
  display: inline-block;
  border-radius: 30px;
  font-size: 16px;
}

.pricing-style-fourteen .table-head p {
  color: var(--dark-3);
}

.pricing-style-fourteen .price {
  padding-top: 30px;
}

.pricing-style-fourteen .amount {
  font-weight: 600;
  display: inline-block;
  position: relative;
  padding-left: 15px;
  font-size: 55px;
}

.pricing-style-fourteen .currency {
  font-weight: 400;
  color: var(--dark-3);
  font-size: 20px;
  position: absolute;
  left: 0;
  top: 6px;
}

.pricing-style-fourteen .duration {
  display: inline-block;
  font-size: 18px;
  color: var(--dark-3);
  font-weight: 400;
}

.pricing-style-fourteen .light-rounded-buttons {
  margin: 0;
  margin-top: 30px;
  margin-bottom: 40px;
}

.pricing-style-fourteen .table-list li {
  position: relative;
  margin-bottom: 10px;
  color: var(--dark-3);
  text-align: left;
}

.pricing-style-fourteen .table-list li:last-child {
  margin: 0;
}

.pricing-style-fourteen .table-list li i {
  color: var(--primary);
  font-size: 16px;
  padding-right: 8px;
}

.pricing-style-fourteen .table-list li i.deactive {
  color: var(--dark-3);
}

/* ===== Buttons Css ===== */
.call-action .inner-content .light-rounded-buttons .primary-btn-outline {
  border-color: var(--primary);
  color: var(--primary);
}

.call-action .inner-content .light-rounded-buttons .active.primary-btn-outline, .call-action .inner-content .light-rounded-buttons .primary-btn-outline:hover, .call-action .inner-content .light-rounded-buttons .primary-btn-outline:focus {
  background: var(--white);
  color: var(--primary);
  border-color: transparent;
}

.call-action .inner-content .light-rounded-buttons .deactive.primary-btn-outline {
  color: var(--dark-3);
  border-color: var(--gray-4);
  pointer-events: none;
}

/*===== call action four =====*/
.call-action {
  z-index: 2;
  padding: 100px 0;
  background: linear-gradient(45deg, var(--primary), var(--primary-dark));
  position: relative;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .call-action {
    padding: 80px;
  }
}
@media (max-width: 767px) {
  .call-action {
    padding: 60px 0;
  }
}
.call-action:before {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background-image: url('overlay.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  z-index: -1;
}

.call-action .inner-content {
  text-align: center;
}

.call-action .inner-content h2 {
  font-weight: 700;
  margin-bottom: 30px;
  color: var(--white);
}

.call-action .inner-content p {
  color: var(--white);
}

.call-action .inner-content .light-rounded-buttons {
  margin-top: 45px;
  display: block;
}

.call-action .inner-content .light-rounded-buttons .primary-btn-outline {
  border-color: var(--white);
  color: var(--white);
}

/*======================================
    Brand CSS
========================================*/
.brand-area {
  padding: 100px 0;
  background: var(--light-3);
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .brand-area {
    padding: 80px;
  }
}
@media (max-width: 767px) {
  .brand-area {
    padding: 60px 0;
  }
}
.brand-area .clients-logos {
  text-align: center;
  display: inline-block;
  margin-top: 20px;
}

.brand-area .clients-logos .single-image {
  display: inline-block;
  margin: 13px 10px;
  line-height: 100px;
  padding: 8px 25px;
  border-radius: 8px;
  transition: all 0.4s ease-out 0s;
  border: 1px solid #eee;
}

.brand-area .clients-logos .single-image:hover {
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.096);
  transform: translateY(-5px);
}

.brand-area .clients-logos img {
  max-width: 170px;
  transition: all 0.4s ease-in-out;
  cursor: pointer;
}

.map-style-9 {
  margin-top: -130px;
}

/* Footer eleven css */
.footer-eleven {
  padding-top: 30px;
  padding-bottom: 100px;
  background-color: var(--dark-1);
  position: relative;
  border-top: 2px solid black;
}
.footer-eleven h3 {
  color: var(--primary);
}

@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .footer-eleven {
    padding-top: 30px;
    padding-bottom: 70px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .footer-eleven .footer-widget {
    margin-top: 40px;
  }
}
@media (max-width: 1199px) {
  .footer-eleven .footer-widget {
    margin-top: 40px;
    /*text-align: center;*/
  }
  .footer-eleven .footer-widget.f-about {
    margin-top: 40px;
    text-align: center;
  }
}
.footer-eleven .footer-widget h4 {
  font-weight: 700;
  margin-bottom: 6px;
  color: var(--primary);
}

@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .footer-eleven .footer-widget h4 {
    margin-bottom: 6px;
  }
}
.footer-eleven .f-about {
  padding-right: 30px;
}

@media (max-width: 767px) {
  .footer-eleven .f-about {
    padding: 0;
  }
}
.footer-eleven .f-about p {
  /*color: var(--dark-3);*/
  color: var(--light-1);
  margin-top: 20px;
}

.footer-eleven .f-about .copyright-text {
  /*color: var(--dark-3);*/
  color: var(--light-1);
  margin-top: 20px;
}
@media (max-width: 1199px) {
  .footer-eleven .f-about .copyright-text .visualage {
    display: flex;
    width: -moz-fit-content;
    width: fit-content;
    margin: auto;
  }
}
.footer-eleven .f-about .copyright-text .visualage {
  display: flex;
  width: -moz-fit-content;
  width: fit-content;
}

.footer-eleven .f-about .copyright-text span {
  display: block;
}

@media (max-width: 767px) {
  .footer-eleven .f-about .copyright-text {
    margin-top: 20px;
  }
}
.footer-eleven .f-about .copyright-text a {
  color: var(--light-1);
}

.footer-eleven .f-about .copyright-text a:hover {
  color: var(--visualage-1);
}

.footer-eleven .f-link li {
  display: block;
  margin-bottom: 6px;
}

.footer-eleven .f-link li:last-child {
  margin: 0 0 25px 0;
}

.footer-eleven .f-link li a {
  /*color: var(--dark-3);*/
  color: var(--light-1);
  transition: all 0.4s ease-out 0s;
}

.footer-eleven .f-link li a:hover {
  color: var(--primary);
}

@media only screen and (min-width: 1200px) and (max-width: 1399px), only screen and (min-width: 1400px) {
  .footer-eleven .newsletter {
    padding-left: 80px;
  }
}
.footer-eleven .newsletter p {
  color: var(--dark-3);
}

.footer-eleven .newsletter-form {
  margin-top: 30px;
  position: relative;
}

.footer-eleven .newsletter-form input {
  height: 55px;
  width: 100%;
  border-radius: 8px;
  border: 1px solid var(--gray-4);
  box-shadow: none;
  text-shadow: none;
  padding-left: 18px;
  padding-right: 65px;
  transition: all 0.4s ease;
}

.footer-eleven .newsletter-form input:focus {
  border-color: var(--primary);
}

.footer-eleven .newsletter-form .button {
  position: absolute;
  right: 7px;
  top: 50%;
  transform: translateY(-50%);
}

.footer-eleven .newsletter-form .sub-btn {
  height: 42px;
  width: 42px;
  border-radius: 6px;
  background-color: var(--primary);
  color: var(--white);
  text-align: center;
  line-height: 42px;
  border: none;
  box-shadow: none;
  text-shadow: none;
  font-size: 17px;
  transition: all 0.4s ease;
}

.footer-eleven .newsletter-form .sub-btn:hover {
  color: var(--white);
  background-color: var(--primary-dark);
}

.insight {
  padding: 0.5rem 0.5rem 0.5rem 3rem !important;
}
.insight .pi.pi-info-circle {
  color: var(--primary);
  font-size: xx-large;
}

@media (max-width: 991px) {
  .insight {
    padding: 0.5rem !important;
  }
}
.p-span-12 {
  width: 100% !important;
}

:host ::ng-deep .p-breadcrumb ul li.p-breadcrumb-home span.pi.pi-home {
  color: var(--primary);
  font-size: 1.25rem;
}

:host ::ng-deep .p-breadcrumb ul li.p-breadcrumb-home span.pi.pi-home:hover {
  color: var(--primary-light);
}

:host ::ng-deep .p-breadcrumb ul li.p-breadcrumb-home a {
  vertical-align: text-top;
}

:host ::ng-deep .p-breadcrumb ul li .p-menuitem-link .p-menuitem-text {
  color: var(--primary);
}

:host ::ng-deep .p-breadcrumb ul li .p-menuitem-link .p-menuitem-text:hover {
  color: var(--primary-light);
}

:host ::ng-deep .p-breadcrumb ul li:last-child .p-menuitem-text {
  color: var(--text-color);
}

:host ::ng-deep .p-breadcrumb ul li:last-child .p-menuitem-text:hover {
  color: var(--text-color);
}

:host ::ng-deep p-panel.blank .p-panel-header {
  padding: 0;
  border: none;
  display: none;
}
:host ::ng-deep p-panel.blank .p-panel-content {
  padding: 0;
  border: none;
}
:host ::ng-deep p-panel.blank .p-panel-footer {
  padding: 0;
  border: none;
  display: none;
}

:host ::ng-deep .sc-blockui {
  background-color: rgba(255, 255, 255, 0.85) !important;
  border-radius: 10px;
  z-index: 4 !important;
}

@keyframes ui-progress-spinner-color {
  100%, 0% {
    stroke: #6ea2fc;
  }
  40% {
    stroke: #6ea2fc;
  }
  66% {
    stroke: #6ea2fc;
  }
  80%, 90% {
    stroke: #6ea2fc;
  }
}
.loading-indicator {
  position: fixed;
  z-index: 1010;
  height: 50px;
  width: 50px;
  overflow: visible;
  top: calc(50% - 25px);
  left: calc(50% - 25px);
  bottom: 0;
  right: 0;
}

.loading-indicator:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.25);
}

p-progressSpinner {
  z-index: 1011;
  width: 50px;
  height: 50px;
  display: block;
  position: absolute;
  top: calc(50vh - 25px);
  left: calc(50% - 25px);
}

p-progressBar {
  z-index: 1011;
  width: 100%;
  height: 6px !important;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  line-height: 6px;
}

.p-progressbar {
  border: 0 none;
  height: 0.5rem;
  background: #dcdcdc;
  border-radius: 5px 5px 0 0;
}
.p-progressbar .p-progressbar-value {
  border: 0 none;
  margin: 0;
  background: #4CAF50;
}
.p-progressbar .p-progressbar-label {
  color: #292B2C;
  line-height: 0.5rem;
}

:host ::ng-deep .p-blockui.p-component-overlay {
  background: rgba(195, 195, 195, 0.5) !important;
}
:host ::ng-deep section:not(.map-section) {
  padding: 2rem 0;
}
:host ::ng-deep section:nth-child(odd):not(#contact-area):not(#navbar-area) {
  /*background-color: white !important;*/
}
:host ::ng-deep section:nth-child(even):not(#navbar-area):not(#contact-area) {
  /*background: var(--light-3) !important;*/
}

.line-height-inherit {
  line-height: inherit !important;
}

.heading-plus {
  width: 100%;
  line-height: 31px;
  display: flex;
  padding: 0.375rem 0.5rem !important;
  border: 1px solid var(--primary);
}
.heading-plus .heading-sub-west {
  display: table-cell;
  width: 31px;
  height: 100%;
}
.heading-plus .heading-sub-east {
  display: table-cell;
  width: inherit;
  height: inherit;
}
.heading-plus .heading-sub-east h5 {
  line-height: inherit;
  color: var(--primary);
  margin-left: 0.5rem;
}
.heading-plus .p-button {
  height: 31px;
  width: 31px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/common/elements/heading-plus/heading-plus.component.scss","webpack://./src/styles.scss","webpack://./src/blocks.scss","webpack://./src/assets/sass/theme/_variables.scss","webpack://./src/assets/sass/theme/designer/components/_megamenu.scss","webpack://./src/assets/sass/layout/_mixins.scss","webpack://./src/assets/sass/theme/designer/components/_input.scss","webpack://./src/assets/sass/theme/designer/_sections.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,mHAAA;ACAA;EA4oDE;;;;;GAAA;AFnoDF;AERE;EACE,gBAAA;EACA,qCAAA;AFUJ;AEPA;EACE;IACE,sBAAA;EFSF;EENA;IACE,aAAA;EFQF;EELA;IACE,kBAAA;EFOF;EEJA;IACE,SAAA;IACA,mBAAA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;IACA,UAAA;IACA,kBAAA;IACA,UAAA;EFMF;EEHA;IACE,mBAAA;EFKF;EEFA;IACE,SAAA;IACA,UAAA;IACA,SAAA;IACA,UAAA;IACA,qBAAA;IACA,eAAA;IACA,gBAAA;EFIF;EEDA;IACE,0BAAA;IACA,oBAAA;EFGF;EEAA;IACE,eAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;EFEF;EECA;IACE,yBAAA;IACA,iBAAA;EFCF;EEEA;IACE,YAAA;IACA,aAAA;IACA,gBAAA;IACA,kBAAA;IACA,YAAA;EFAF;EEGA;IACE;MACE,UAAA;IFDF;IEIA;MACE,UAAA;IFFF;EACF;EEKA;IACE,gBAAA;IACA,6BAAA;IACA,SAAA;IACA,UAAA;IACA,SAAA;IACA,eAAA;IACA,yBAAA;IACA,iBAAA;EFHF;EEMA;IACE,eAAA;EFJF;EEOA;IACE,SAAA;IACA,8BAAA;IACA,qBAAA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;IACA,UAAA;IACA,kBAAA;IACA,UAAA;IACA,4BAAA;EFLF;EEQA;IACE,UAAA;IACA,sBAAA;IACA,gGAAA;EFNF;EESA;IACE,UAAA;IACA,oBAAA;EFPF;EEUA;IACE,UAAA;IACA,oBAAA;IACA,+BAAA;EFRF;EEWA;IACE,gBAAA;EFTF;EEYA;IACE,oBAAA;EFVF;EEaA;IACE,qBAAA;EFXF;EEcA;IACE,yCAAA;EFZF;AACF;AEeE;EACE;IACE,oBAAA;EFbJ;EEgBE;IACE,yBAAA;EFdJ;AACF;AEiBA;EACE;IACE,qBAAA;IACA,mBAAA;IACA,kBAAA;IACA,iBAAA;EFfF;EEkBA;IACE,kBAAA;EFhBF;EEmBA;IACE,kBAAA;IACA,MAAA;IACA,QAAA;IACA,+BAAA;IACA,wBAAA;IACA,SAAA;EFjBF;EEoBA;IACE,aAAA;IACA,iBAAA;IACA,cAAA;IACA,kBAAA;IACA,UAAA;EFlBF;EEqBA;IACE,UAAA;IACA,kBAAA;EFnBF;AACF;AEsBA;EACE;IACE,SAAA;IACA,oBAAA;IACA,eAAA;IACA,yBAAA;IACA,iBAAA;IACA,mBAAA;IACA,sBAAA;IACA,kBAAA;IACA,gBAAA;IACA,kBAAA;EFpBF;EEuBA;IACE,cAAA;EFrBF;EEwBA;IACE,QAAA;EFtBF;EEyBA;IACE,eAAA;IACA,oBAAA;EFvBF;EE0BA;IACE,uBAAA;EFxBF;EE2BA;IACE,YAAA;IACA,kBAAA;IACA,mBAAA;IACA,QAAA;EFzBF;EE4BA;IACE,sBAAA;EF1BF;EE6BA;IACE,QAAA;EF3BF;EE8BA;IACE,SAAA;EF5BF;EE+BA;IACE,oBAAA;EF7BF;EEgCA;IACE,gBAAA;EF9BF;EEiCA;IACE,0BAAA;IACA,6BAAA;EF/BF;EEkCA;IACE,yBAAA;IACA,4BAAA;EFhCF;EEmCA;IACE,kBAAA;IACA,UAAA;EFjCF;EEoCA;IACE,QAAA;EFlCF;AACF;AEqCA;EACE;IACE,oBAAA;IACA,eAAA;IACA,yBAAA;IACA,iBAAA;IACA,sBAAA;IACA,kBAAA;EFnCF;EEsCA;IACE,0BAAA;IACA,oBAAA;EFpCF;EEuCA;IACE,aAAA;IACA,uBAAA;IACA,mBAAA;EFrCF;EEwCA;IACE,oBAAA;IACA,sBAAA;IACA,mBAAA;EFtCF;EEyCA;IACE,cAAA;EFvCF;AACF;AE0CE;EACE,0CAAA;AFxCJ;AE2CE;EACE,0CAAA;AFzCJ;AE4CA;EACE;IACE,SAAA;EF1CF;EE6CA;IACE,WAAA;EF3CF;EE8CA;IACE,aAAA;IACA,oBAAA;IACA,WAAA;EF5CF;EE+CA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;EF7CF;EEgDA;IACE,aAAA;IACA,oBAAA;IACA,WAAA;EF9CF;EEiDA;IACE,cAAA;IACA,SAAA;EF/CF;EEkDA;IACE,cAAA;IACA,kBAAA;EFhDF;EEmDA;IACE,kBAAA;IACA,oBAAA;IACA,QAAA;IACA,mBAAA;IACA,wBAAA;IACA,gCAAA;IACA,cAAA;EFjDF;EEoDA;IACE,SAAA;EFlDF;EEqDA;IACE,aAAA;IACA,eAAA;EFnDF;EEsDA;IACE,UAAA;IACA,eAAA;EFpDF;EEuDA;IACE,UAAA;IACA,wBAAA;IACA,gCAAA;EFrDF;EEwDA;IACE,UAAA;IACA,wBAAA;IACA,gCAAA;EFtDF;EEyDA;IACE,kBAAA;IACA,qBAAA;EFvDF;EE0DA;IACE,kBAAA;IACA,QAAA;IACA,mBAAA;EFxDF;EE2DA;IACE,cAAA;IACA,WAAA;EFzDF;AACF;AE4DA;EACE;IACE,gBAAA;IACA,YAAA;EF1DF;EE6DA;IACE,WAAA;EF3DF;AACF;AE8DA;EACE;IACE,kBAAA;IACA,oBAAA;EF5DF;EE+DA;IACE,kBAAA;IACA,MAAA;IACA,OAAA;EF7DF;EEgEA;IACE,eAAA;EF9DF;EEiEA;IACE,YAAA;EF/DF;EEkEA;IACE,YAAA;IACA,QAAA;IACA,gCAAA;EFhEF;EEmEA;IACE,aAAA;EFjEF;EEoEA;IACE,aAAA;EFlEF;EEqEA;IACE,kBAAA;IACA,QAAA;IACA,mBAAA;IACA,eAAA;EFnEF;EEsEA;IACE,iBAAA;EFpEF;EEuEA;IACE,kBAAA;EFrEF;AACF;AEwEA;EACE;IACE,oBAAA;IACA,eAAA;IACA,yBAAA;IACA,iBAAA;IACA,sBAAA;IACA,kBAAA;EFtEF;EEyEA;IACE,aAAA;IACA,uBAAA;IACA,mBAAA;EFvEF;EE0EA;IACE,2BAAA;IACA,mCAAA;IACA,kBAAA;IACA,kBAAA;EFxEF;EE2EA;IACE,iCAAA;IACA,mBAAA;EFzEF;EE4EA;IACE,oBAAA;IACA,sBAAA;IACA,mBAAA;EF1EF;EE6EA;IACE,cAAA;EF3EF;AACF;AE8EA;EACE;IACE,gBAAA;IACA,kBAAA;EF5EF;EE+EA;IACE,cAAA;IACA,kBAAA;IACA,oCAAA;IACA,mBAAA;IACA,mBAAA;EF7EF;EEgFA;IACE,6BAAA;EF9EF;EEiFA;IACE,wBAAA;EF/EF;AACF;AEkFE;EACE;IACE,UAAA;IACA,qBAAA;EFhFJ;AACF;AEmFA;EACE;IACE,kBAAA;IACA,aAAA;IACA,sBAAA;IACA,kBAAA;IACA,oBAAA;EFjFF;EEoFA;IACE,kBAAA;EFlFF;EEqFA;IACE,iBAAA;EFnFF;EEsFA;IACE,qBAAA;IACA,sBAAA;EFpFF;EEuFA;IACE,kBAAA;IACA,QAAA;IACA,SAAA;IACA,yBAAA;IACA,mBAAA;EFrFF;EEwFA;IACE,QAAA;IACA,OAAA;IACA,oBAAA;IACA,oCAAA;EFtFF;EEyFA;IACE,QAAA;IACA,QAAA;IACA,oBAAA;IACA,qCAAA;EFvFF;EE0FA;IACE,iBAAA;EFxFF;EE2FA;IACE,SAAA;IACA,SAAA;IACA,qBAAA;IACA,6BAAA;EFzFF;EE4FA;IACE,MAAA;IACA,SAAA;IACA,qBAAA;IACA,8BAAA;EF1FF;AACF;AE6FE;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AF3FJ;AE8FE;EACE,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,qBAAA;EACA,mCAAA;EACA,kCAAA;AF5FJ;AE+FE;EACE,oCAAA;EACA,2BAAA;AF7FJ;AEgGE;EACE,mBAAA;EACA,kBAAA;AF9FJ;AEiGE;EACE,qCAAA;AF/FJ;AEkGE;EACE;IACE,oBAAA;EFhGJ;EEmGE;IACE,yBAAA;EFjGJ;AACF;AEoGE;EACE,gBAAA;AFlGJ;AEqGE;EACE,gBAAA;AFnGJ;AEsGE;EACE,gBAAA;AFpGJ;AEuGE;EACE,gBAAA;AFrGJ;AEwGE;EACE,gBAAA;AFtGJ;AEyGE;EACE,gBAAA;AFvGJ;AE0GE;EACE,gBAAA;AFxGJ;AE2GE;EACE,gBAAA;AFzGJ;AE4GE;EACE,gBAAA;AF1GJ;AE6GE;EACE,gBAAA;AF3GJ;AE8GE;EACE,gBAAA;AF5GJ;AE+GE;EACE,gBAAA;AF7GJ;AEgHE;EACE,gBAAA;AF9GJ;AEiHE;EACE,gBAAA;AF/GJ;AEkHE;EACE,gBAAA;AFhHJ;AEmHE;EACE,gBAAA;AFjHJ;AEoHE;EACE,gBAAA;AFlHJ;AEqHE;EACE,gBAAA;AFnHJ;AEsHE;EACE,gBAAA;AFpHJ;AEuHE;EACE,gBAAA;AFrHJ;AEwHE;EACE,gBAAA;AFtHJ;AEyHE;EACE,gBAAA;AFvHJ;AE0HE;EACE,gBAAA;AFxHJ;AE2HE;EACE,gBAAA;AFzHJ;AE4HE;EACE,gBAAA;AF1HJ;AE6HE;EACE,gBAAA;AF3HJ;AE8HE;EACE,gBAAA;AF5HJ;AE+HE;EACE,gBAAA;AF7HJ;AEgIE;EACE,gBAAA;AF9HJ;AEiIE;EACE,gBAAA;AF/HJ;AEkIE;EACE,gBAAA;AFhIJ;AEmIE;EACE,gBAAA;AFjIJ;AEoIE;EACE,gBAAA;AFlIJ;AEqIE;EACE,gBAAA;AFnIJ;AEsIE;EACE,gBAAA;AFpIJ;AEuIE;EACE,gBAAA;AFrIJ;AEwIE;EACE,gBAAA;AFtIJ;AEyIE;EACE,gBAAA;AFvIJ;AE0IE;EACE,gBAAA;AFxIJ;AE2IE;EACE,gBAAA;AFzIJ;AE4IE;EACE,gBAAA;AF1IJ;AE6IE;EACE,gBAAA;AF3IJ;AE8IE;EACE,gBAAA;AF5IJ;AE+IE;EACE,gBAAA;AF7IJ;AEgJE;EACE,gBAAA;AF9IJ;AEiJE;EACE,gBAAA;AF/IJ;AEkJE;EACE,gBAAA;AFhJJ;AEmJE;EACE,gBAAA;AFjJJ;AEoJE;EACE,gBAAA;AFlJJ;AEqJE;EACE,gBAAA;AFnJJ;AEsJE;EACE,gBAAA;AFpJJ;AEuJE;EACE,gBAAA;AFrJJ;AEwJE;EACE,gBAAA;AFtJJ;AEyJE;EACE,gBAAA;AFvJJ;AE0JE;EACE,gBAAA;AFxJJ;AE2JE;EACE,gBAAA;AFzJJ;AE4JE;EACE,gBAAA;AF1JJ;AE6JE;EACE,gBAAA;AF3JJ;AE8JE;EACE,gBAAA;AF5JJ;AE+JE;EACE,gBAAA;AF7JJ;AEgKE;EACE,gBAAA;AF9JJ;AEiKE;EACE,gBAAA;AF/JJ;AEkKE;EACE,gBAAA;AFhKJ;AEmKE;EACE,gBAAA;AFjKJ;AEoKE;EACE,gBAAA;AFlKJ;AEqKE;EACE,gBAAA;AFnKJ;AEsKE;EACE,gBAAA;AFpKJ;AEuKE;EACE,gBAAA;AFrKJ;AEwKE;EACE,gBAAA;AFtKJ;AEyKE;EACE,gBAAA;AFvKJ;AE0KE;EACE,gBAAA;AFxKJ;AE2KE;EACE,gBAAA;AFzKJ;AE4KE;EACE,gBAAA;AF1KJ;AE6KE;EACE,gBAAA;AF3KJ;AE8KE;EACE,gBAAA;AF5KJ;AE+KE;EACE,gBAAA;AF7KJ;AEgLE;EACE,gBAAA;AF9KJ;AEiLE;EACE,gBAAA;AF/KJ;AEkLE;EACE,gBAAA;AFhLJ;AEmLE;EACE,gBAAA;AFjLJ;AEoLE;EACE,gBAAA;AFlLJ;AEqLE;EACE,gBAAA;AFnLJ;AEsLE;EACE,gBAAA;AFpLJ;AEuLE;EACE,gBAAA;AFrLJ;AEwLE;EACE,gBAAA;AFtLJ;AEyLE;EACE,gBAAA;AFvLJ;AE0LE;EACE,gBAAA;AFxLJ;AE2LE;EACE,gBAAA;AFzLJ;AE4LE;EACE,gBAAA;AF1LJ;AE6LE;EACE,gBAAA;AF3LJ;AE8LE;EACE,gBAAA;AF5LJ;AE+LE;EACE,gBAAA;AF7LJ;AEgME;EACE,gBAAA;AF9LJ;AEiME;EACE,gBAAA;AF/LJ;AEkME;EACE,gBAAA;AFhMJ;AEmME;EACE,gBAAA;AFjMJ;AEoME;EACE,gBAAA;AFlMJ;AEqME;EACE,gBAAA;AFnMJ;AEsME;EACE,gBAAA;AFpMJ;AEuME;EACE,gBAAA;AFrMJ;AEwME;EACE,gBAAA;AFtMJ;AEyME;EACE,gBAAA;AFvMJ;AE0ME;EACE,gBAAA;AFxMJ;AE2ME;EACE,gBAAA;AFzMJ;AE4ME;EACE,gBAAA;AF1MJ;AE6ME;EACE,gBAAA;AF3MJ;AE8ME;EACE,gBAAA;AF5MJ;AE+ME;EACE,gBAAA;AF7MJ;AEgNE;EACE,gBAAA;AF9MJ;AEiNE;EACE,gBAAA;AF/MJ;AEkNE;EACE,gBAAA;AFhNJ;AEmNE;EACE,gBAAA;AFjNJ;AEoNE;EACE,gBAAA;AFlNJ;AEqNE;EACE,gBAAA;AFnNJ;AEsNE;EACE,gBAAA;AFpNJ;AEuNE;EACE,gBAAA;AFrNJ;AEwNE;EACE,gBAAA;AFtNJ;AEyNE;EACE,gBAAA;AFvNJ;AE0NE;EACE,gBAAA;AFxNJ;AE2NE;EACE,gBAAA;AFzNJ;AE4NE;EACE,gBAAA;AF1NJ;AE6NE;EACE,gBAAA;AF3NJ;AE8NE;EACE,gBAAA;AF5NJ;AE+NE;EACE,gBAAA;AF7NJ;AEgOE;EACE,gBAAA;AF9NJ;AEiOE;EACE,gBAAA;AF/NJ;AEkOE;EACE,gBAAA;AFhOJ;AEmOE;EACE,gBAAA;AFjOJ;AEoOE;EACE,gBAAA;AFlOJ;AEqOE;EACE,gBAAA;AFnOJ;AEsOE;EACE,gBAAA;AFpOJ;AEuOE;EACE,gBAAA;AFrOJ;AEwOE;EACE,gBAAA;AFtOJ;AEyOE;EACE,gBAAA;AFvOJ;AE0OE;EACE,gBAAA;AFxOJ;AE2OE;EACE,gBAAA;AFzOJ;AE4OE;EACE,gBAAA;AF1OJ;AE6OE;EACE,gBAAA;AF3OJ;AE8OE;EACE,gBAAA;AF5OJ;AE+OE;EACE,gBAAA;AF7OJ;AEgPE;EACE,gBAAA;AF9OJ;AEiPE;EACE,gBAAA;AF/OJ;AEkPE;EACE,gBAAA;AFhPJ;AEmPE;EACE,gBAAA;AFjPJ;AEoPE;EACE,gBAAA;AFlPJ;AEqPE;EACE,gBAAA;AFnPJ;AEsPE;EACE,gBAAA;AFpPJ;AEuPE;EACE,gBAAA;AFrPJ;AEwPE;EACE,gBAAA;AFtPJ;AEyPE;EACE,gBAAA;AFvPJ;AE0PE;EACE,gBAAA;AFxPJ;AE2PE;EACE,gBAAA;AFzPJ;AE4PE;EACE,gBAAA;AF1PJ;AE6PE;EACE,gBAAA;AF3PJ;AE8PE;EACE,gBAAA;AF5PJ;AE+PE;EACE,gBAAA;AF7PJ;AEgQE;EACE,gBAAA;AF9PJ;AEiQE;EACE,gBAAA;AF/PJ;AEkQE;EACE,gBAAA;AFhQJ;AEmQE;EACE,gBAAA;AFjQJ;AEoQE;EACE,gBAAA;AFlQJ;AEqQE;EACE,gBAAA;AFnQJ;AEsQE;EACE,gBAAA;AFpQJ;AEuQE;EACE,gBAAA;AFrQJ;AEwQE;EACE,gBAAA;AFtQJ;AEyQE;EACE,gBAAA;AFvQJ;AE0QE;EACE,gBAAA;AFxQJ;AE2QE;EACE,gBAAA;AFzQJ;AE4QE;EACE,gBAAA;AF1QJ;AE6QE;EACE,gBAAA;AF3QJ;AE8QE;EACE,gBAAA;AF5QJ;AE+QE;EACE,gBAAA;AF7QJ;AEgRE;EACE,gBAAA;AF9QJ;AEiRE;EACE,gBAAA;AF/QJ;AEkRE;EACE,gBAAA;AFhRJ;AEmRE;EACE,gBAAA;AFjRJ;AEoRE;EACE,gBAAA;AFlRJ;AEqRE;EACE,gBAAA;AFnRJ;AEsRE;EACE,gBAAA;AFpRJ;AEuRE;EACE,gBAAA;AFrRJ;AEwRE;EACE,gBAAA;AFtRJ;AEyRE;EACE,gBAAA;AFvRJ;AE0RE;EACE,gBAAA;AFxRJ;AE2RE;EACE,gBAAA;AFzRJ;AE4RE;EACE,gBAAA;AF1RJ;AE6RE;EACE,gBAAA;AF3RJ;AE8RE;EACE,gBAAA;AF5RJ;AE+RE;EACE,gBAAA;AF7RJ;AEgSE;EACE,gBAAA;AF9RJ;AEiSE;EACE,gBAAA;AF/RJ;AEkSE;EACE,gBAAA;AFhSJ;AEmSE;EACE,gBAAA;AFjSJ;AEoSE;EACE,gBAAA;AFlSJ;AEqSE;EACE,gBAAA;AFnSJ;AEsSE;EACE,gBAAA;AFpSJ;AEuSE;EACE,gBAAA;AFrSJ;AEwSE;EACE,gBAAA;AFtSJ;AEySE;EACE,gBAAA;AFvSJ;AE0SE;EACE,gBAAA;AFxSJ;AE2SE;EACE,gBAAA;AFzSJ;AE4SE;EACE,gBAAA;AF1SJ;AE6SE;EACE,gBAAA;AF3SJ;AE8SE;EACE,gBAAA;AF5SJ;AE+SE;EACE,gBAAA;AF7SJ;AEgTE;EACE,gBAAA;AF9SJ;AEiTE;EACE,gBAAA;AF/SJ;AEkTE;EACE,gBAAA;AFhTJ;AEmTE;EACE,gBAAA;AFjTJ;AEoTE;EACE,gBAAA;AFlTJ;AEqTE;EACE,gBAAA;AFnTJ;AEsTE;EACE,gBAAA;AFpTJ;AEuTE;EACE,gBAAA;AFrTJ;AEwTE;EACE,gBAAA;AFtTJ;AEyTE;EACE,gBAAA;AFvTJ;AE0TE;EACE,gBAAA;AFxTJ;AE2TE;EACE,gBAAA;AFzTJ;AE4TE;EACE,gBAAA;AF1TJ;AE6TE;EACE,gBAAA;AF3TJ;AE8TE;EACE,gBAAA;AF5TJ;AE+TE;EACE,gBAAA;AF7TJ;AEgUE;EACE,gBAAA;AF9TJ;AEiUE;EACE,gBAAA;AF/TJ;AEkUE;EACE,gBAAA;AFhUJ;AEmUE;EACE,gBAAA;AFjUJ;AEoUE;EACE,gBAAA;AFlUJ;AEqUE;EACE,gBAAA;AFnUJ;AEsUE;EACE,gBAAA;AFpUJ;AEuUE;EACE,gBAAA;AFrUJ;AEwUE;EACE,gBAAA;AFtUJ;AEyUE;EACE,gBAAA;AFvUJ;AE0UE;EACE,gBAAA;AFxUJ;AE2UE;EACE,gBAAA;AFzUJ;AE4UE;EACE,gBAAA;AF1UJ;AE6UE;EACE,gBAAA;AF3UJ;AE8UE;EACE,gBAAA;AF5UJ;AE+UE;EACE,gBAAA;AF7UJ;AEgVE;EACE,gBAAA;AF9UJ;AEiVE;EACE,gBAAA;AF/UJ;AEkVE;EACE,gBAAA;AFhVJ;AEmVE;EACE,gBAAA;AFjVJ;AEoVE;EACE,gBAAA;AFlVJ;AEqVE;EACE,gBAAA;AFnVJ;AEsVE;EACE,gBAAA;AFpVJ;AEuVE;EACE,gBAAA;AFrVJ;AEwVE;EACE,gBAAA;AFtVJ;AEyVE;EACE,gBAAA;AFvVJ;AE0VE;EACE,gBAAA;AFxVJ;AE2VE;EACE,gBAAA;AFzVJ;AE4VE;EACE,gBAAA;AF1VJ;AE6VE;EACE,gBAAA;AF3VJ;AE8VE;EACE,gBAAA;AF5VJ;AE+VE;EACE,gBAAA;AF7VJ;AEgWE;EACE,gBAAA;AF9VJ;AEiWE;EACE,gBAAA;AF/VJ;AEkWE;EACE,gBAAA;AFhWJ;AEmWE;EACE,gBAAA;AFjWJ;AEoWE;EACE,gBAAA;AFlWJ;AEqWE;EACE,gBAAA;AFnWJ;AEsWE;EACE,gBAAA;AFpWJ;AEuWE;EACE,gBAAA;AFrWJ;AEwWE;EACE,gBAAA;AFtWJ;AE+WE;EACE,sBAAA;EACA,yCAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AF7WJ;AEgXE;EACE,kBAAA;AF9WJ;AEiXE;EACE,oBAAA;AF/WJ;AEkXE;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AFhXJ;AEmXE;EACE,SAAA;EACA,UAAA;AFjXJ;AEoXE;EACE,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;AFlXJ;AEqXE;EACE,YAAA;AFnXJ;AEsXE;EACE,SAAA;EACA,UAAA;EACA,6EAAA;AFpXJ;AEuXE;EACE,mBAAA;AFrXJ;AEwXE;EACE,qBAAA;AFtXJ;AEyXE;EACE,YAAA;AFvXJ;AE0XE;EACE,oBAAA;AFxXJ;AE2XE;EACE,mBAAA;AFzXJ;AE4XE;EACE,WAAA;EACA,eAAA;EACA,mBAAA;AF1XJ;AE6XE;EACE,YAAA;AF3XJ;AE8XE;EACE,YAAA;AF5XJ;AE+XE;EACE,qBAAA;EACA,mBAAA;EACA,YAAA;AF7XJ;AEgYE;EACE,mBAAA;EACA,mBAAA;EACA,iBAAA;AF9XJ;AEiYE;EACE,kBAAA;EACA,oBAAA;AF/XJ;AEkYE;EACE,mBAAA;AFhYJ;AEmYE;EACE,oBAAA;AFjYJ;AEoYE;EACE,6EAAA;EACA,yBAAA;AFlYJ;AEqYE;EACE,sCAAA;AFnYJ;AEsYE;EACE,yBAAA;AFpYJ;AEuYE;EACE,0CAAA;AFrYJ;AEwYE;EACE,sEAAA;AFtYJ;AEyYE;EACE,yBAAA;AFvYJ;AE0YE;EACE,0CAAA;AFxYJ;AE2YE;EACE,+DAAA;AFzYJ;AE4YE;EACE,yBAAA;AF1YJ;AE6YE;EACE,sCAAA;AF3YJ;AE8YE;EACE,wDAAA;AF5YJ;AE+YE;EACE,yBAAA;AF7YJ;AEgZE;EACE,0CAAA;AF9YJ;AEiZE;EACE,iDAAA;AF/YJ;AEkZE;EACE,yBAAA;AFhZJ;AEmZE;EACE,0CAAA;AFjZJ;AEoZE;EACE,0CAAA;AFlZJ;AEqZE;EACE,yBAAA;AFnZJ;AEsZE;EACE,sCAAA;AFpZJ;AEuZE;EACE,mCAAA;AFrZJ;AEwZE;EACE,yBAAA;AFtZJ;AEyZE;EACE,0CAAA;AFvZJ;AE0ZE;EACE,4BAAA;AFxZJ;AE2ZE;EACE,yBAAA;AFzZJ;AE4ZE;EACE,0CAAA;AF1ZJ;AE6ZE;EACE,qBAAA;AF3ZJ;AE8ZE;EACE,yBAAA;AF5ZJ;AE+ZE;EACE,sCAAA;AF7ZJ;AEgaE;EACE,iBAAA;AF9ZJ;AEiaE;EACE,mBAAA;AF/ZJ;AEkaE;EACE,kBAAA;AFhaJ;AEmaE;EACE,oBAAA;AFjaJ;AEoaE;EACE,iBAAA;AFlaJ;AEqaE;EACE,mBAAA;AFnaJ;AEsaE;EACE,kBAAA;AFpaJ;AEuaE;EACE,oBAAA;AFraJ;AEwaE;EACE,iBAAA;AFtaJ;AEyaE;EACE,oBAAA;AFvaJ;AE0aE;EACE,kBAAA;AFxaJ;AE2aE;EACE,qBAAA;AFzaJ;AE4aE;EACE,kBAAA;AF1aJ;AE6aE;EACE,oBAAA;AF3aJ;AE8aE;EACE,mBAAA;AF5aJ;AE+aE;EACE,qBAAA;AF7aJ;AEgbE;EACE,kBAAA;AF9aJ;AEibE;EACE,oBAAA;AF/aJ;AEkbE;EACE,mBAAA;AFhbJ;AEmbE;EACE,qBAAA;AFjbJ;AEobE;EACE,kBAAA;AFlbJ;AEqbE;EACE,oBAAA;AFnbJ;AEsbE;EACE,mBAAA;AFpbJ;AEubE;EACE,qBAAA;AFrbJ;AEwbE;EACE,kBAAA;AFtbJ;AEybE;EACE,oBAAA;AFvbJ;AE0bE;EACE,mBAAA;AFxbJ;AE2bE;EACE,qBAAA;AFzbJ;AE4bE;EACE,kBAAA;AF1bJ;AE6bE;EACE,oBAAA;AF3bJ;AE8bE;EACE,mBAAA;AF5bJ;AE+bE;EACE,qBAAA;AF7bJ;AEgcE;EACE,kBAAA;AF9bJ;AEicE;EACE,oBAAA;AF/bJ;AEkcE;EACE,mBAAA;AFhcJ;AEmcE;EACE,qBAAA;AFjcJ;AEocE;EACE,cAAA;EACA,eAAA;AFlcJ;AEqcE;EACE,cAAA;AFncJ;AEscE;EACE,kBAAA;AFpcJ;AEucE;EACE,sBAAA;AFrcJ;AEwcE;EACE,yBAAA;AFtcJ;AEycE;EACE,sBAAA;AFvcJ;AE0cE;EACE,sBAAA;AFxcJ;AE2cE;EACE,yBAAA;AFzcJ;AE4cE;EACE,sBAAA;AF1cJ;AE6cE;EACE,sBAAA;AF3cJ;AE8cE;EACE,WAAA;AF5cJ;AE+cE;EACE,cAAA;AF7cJ;AEgdE;EACE,WAAA;AF9cJ;AEidE;EACE,WAAA;AF/cJ;AEkdE;EACE,cAAA;AFhdJ;AEmdE;EACE,WAAA;AFjdJ;AEodE;EACE,WAAA;AFldJ;AEqdE;EACE,4CAAA;AFndJ;AEsdE;EACE,2CAAA;AFpdJ;AEudE;EACE,iBAAA;AFrdJ;AEwdE;EACE,gBAAA;AFtdJ;AEydE;EACE,gBAAA;AFvdJ;AE0dE;EACE,cAAA;EACA,mBAAA;AFxdJ;AE2dE;EACE,kBAAA;AFzdJ;AE4dE;EACE,mBAAA;AF1dJ;AE6dE;EACE,iBAAA;AF3dJ;AE8dE;EACE,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;AF5dJ;AE+dE;EACE,WAAA;EACA,WAAA;EACA,cAAA;AF7dJ;AEgeE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AF9dJ;AEieE;EACE,WAAA;EACA,YAAA;AF/dJ;AEkeE;EACE,aAAA;AFheJ;AEmeE;EACE,aAAA;AFjeJ;AEoeE;EACE,WAAA;AFleJ;AEqeE;EACE,UAAA;AFneJ;AEseE;EACE,YAAA;AFpeJ;AEueE;EACE;IACE,WAAA;EFreJ;EEweE;IACE,UAAA;EFteJ;EEyeE;IACE,YAAA;EFveJ;AACF;AE0eE;EACE,sBAAA;AFxeJ;AE2eE;EACE,aAAA;AFzeJ;AE4eE;EACE,kBAAA;AF1eJ;AE6eE;EACE,kBAAA;EACA,2BAAA;AF3eJ;AE8eE;EACE,eAAA;EACA,qBAAA;AF5eJ;AE+eE;EACE,4BAAA;AF7eJ;AEgfE;EACE,qBAAA;EACA,sBAAA;AF9eJ;AEifE;EACE,WAAA;EACA,WAAA;EACA,cAAA;AF/eJ;AEkfE;EACE,UAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;AFhfJ;AEmfE;EACE,UAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;AFjfJ;AEofE;EACE,UAAA;AFlfJ;AEqfE;EACE,UAAA;AFnfJ;AEsfE;EACE,kBAAA;AFpfJ;AEufE;EACE,eAAA;AFrfJ;AEwfE;EACE,YAAA;AFtfJ;AEyfE;EACE,aAAA;AFvfJ;AE0fE;EACE,eAAA;AFxfJ;AE2fE;EACE,aAAA;AFzfJ;AE4fE;EACE,cAAA;AF1fJ;AE6fE;EACE,gBAAA;AF3fJ;AE8fE;EACE,iBAAA;AF5fJ;AE+fE;EACE,cAAA;AF7fJ;AEggBE;EACE,iBAAA;AF9fJ;AEigBE;EACE,iBAAA;AF/fJ;AEkgBE;EACE,0BAAA;AFhgBJ;AEmgBE;EACE,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AFjgBJ;AEogBE;EACE,yBAAA;EACA,kBAAA;AFlgBJ;AEqgBE;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AFngBJ;AEsgBE;EACE,cAAA;EACA,gBAAA;AFpgBJ;AEugBE;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;AFrgBJ;AEwgBE;EACE,eAAA;AFtgBJ;AEygBE;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AFvgBJ;AE0gBE;EACE,eAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AFxgBJ;AE2gBE;EACE,qBAAA;EACA,iBAAA;AFzgBJ;AE4gBE;EACE,sBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AF1gBJ;AE6gBE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AF3gBJ;AE8gBE;EACE,WAAA;EACA,UAAA;AF5gBJ;AE+gBE;EACE,UAAA;AF7gBJ;AEghBE;EACE,YAAA;AF9gBJ;AEihBE;EACE,cAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AF/gBJ;AEkhBE;EACE,WAAA;AFhhBJ;AEmhBE;EACE,gBAAA;AFjhBJ;AEohBE;EACE,UAAA;AFlhBJ;AEqhBE;EACE,cAAA;AFnhBJ;AEshBE;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AFphBJ;AEuhBE;EACE,gBAAA;EACA,YAAA;AFrhBJ;AEwhBE;EACE,6BAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AFthBJ;AEyhBE;EACE,kBAAA;EACA,gBAAA;EACA,QAAA;EACA,QAAA;EACA,WAAA;AFvhBJ;AE0hBE;EACE,yBAAA;AFxhBJ;AE2hBE;EACE,WAAA;AFzhBJ;AE4hBE;EACE,iBAAA;AF1hBJ;AE6hBE;EACE,oBAAA;AF3hBJ;AE8hBE;EACE,oBAAA;AF5hBJ;AE+hBE;EACE,oBAAA;AF7hBJ;AEgiBE;EACE,oBAAA;AF9hBJ;AEiiBE;EACE,oBAAA;AF/hBJ;AEkiBE;EACE,oBAAA;AFhiBJ;AEmiBE;EACE,cAAA;AFjiBJ;AEoiBE;EACE,gBAAA;AFliBJ;AEqiBE;EACE,iBAAA;AFniBJ;AEsiBE;EACE,cAAA;AFpiBJ;AEuiBE;EACE,iBAAA;AFriBJ;AEwiBE;EACE,iBAAA;AFtiBJ;AEyiBE;EACE,YAAA;AFviBJ;AE0iBE;EACE,qBAAA;AFxiBJ;AE2iBE;EACE,gBAAA;AFziBJ;AE4iBE;EACE,oBAAA;AF1iBJ;AE6iBE;EACE,4CAAA;AF3iBJ;AE8iBE;EACE,2CAAA;AF5iBJ;AE+iBE;EACE,WAAA;AF7iBJ;AEgjBE;EACE,iBAAA;AF9iBJ;AEijBE;EACE,gBAAA;AF/iBJ;AEkjBE;EACE,gBAAA;AFhjBJ;AEmjBE;EACE,eAAA;AFjjBJ;AEojBE;EACE,eAAA;AFljBJ;AEqjBE;EACE,eAAA;AFnjBJ;AEsjBE;EACE,eAAA;AFpjBJ;AEujBE;EACE,sBAAA;AFrjBJ;AEwjBE;EACE,sBAAA;AFtjBJ;AEyjBE;EACE,sBAAA;EACA,sBAAA;EACA,yDAAA;EACA,YAAA;AFvjBJ;AE0jBE;EACE,kBAAA;AFxjBJ;AE2jBE;EACE,6BAAA;AFzjBJ;AE4jBE;EACE,6BAAA;EACA,wCAAA;AF1jBJ;AE6jBE;EACE,kBAAA;AF3jBJ;AE8jBE;EACE,kBAAA;AF5jBJ;AE+jBE;EACE,eAAA;AF7jBJ;AEgkBE;EACE,sBAAA;EACA,sBAAA;EACA,wBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AF9jBJ;AEikBE;EACE,qBAAA;EACA,iBAAA;EACA,iBAAA;AF/jBJ;AEkkBE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;AFhkBJ;AEmkBE;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AFjkBJ;AEokBE;EACE,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AFlkBJ;AEqkBE;EACE,iBAAA;EACA,gBAAA;AFnkBJ;AEskBE;EACE,iBAAA;AFpkBJ;AEukBE;EACE,aAAA;AFrkBJ;AEwkBE;EACE,qBAAA;AFtkBJ;AEykBE;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;AFvkBJ;AE0kBE;EACE,sBAAA;AFxkBJ;AE2kBE;EACE,yBAAA;AFzkBJ;AE4kBE;EACE,uBAAA;AF1kBJ;AE6kBE;EACE,WAAA;AF3kBJ;AE8kBE;EACE,sBAAA;AF5kBJ;AE+kBE;EACE,WAAA;EACA,YAAA;EACA,qBAAA;AF7kBJ;AEglBE;EACE,WAAA;AF9kBJ;AEilBE;EACE,qBAAA;EACA,sBAAA;AF/kBJ;AEklBE;EACE,gCAAA;AFhlBJ;AEmlBE;EACE,gCAAA;AFjlBJ;AEolBE;EACE,gCAAA;AFllBJ;AEqlBE;EACE,gCAAA;AFnlBJ;AEslBE;EACE,gCAAA;AFplBJ;AEulBE;EACE,gCAAA;AFrlBJ;AEwlBE;EACE,gCAAA;AFtlBJ;AEylBE;EACE,gCAAA;AFvlBJ;AE0lBE;EACE,gCAAA;AFxlBJ;AE2lBE;EACE,gCAAA;AFzlBJ;AE4lBE;EACE,gCAAA;AF1lBJ;AE6lBE;EACE,gCAAA;AF3lBJ;AE8lBE;EACE,gCAAA;AF5lBJ;AE+lBE;EACE,gCAAA;AF7lBJ;AEgmBE;EACE,gCAAA;AF9lBJ;AEimBE;EACE,+BAAA;AF/lBJ;AEkmBE;EACE,gCAAA;AFhmBJ;AEmmBE;EACE,gCAAA;AFjmBJ;AEomBE;EACE,+BAAA;AFlmBJ;AEqmBE;EACE,gCAAA;AFnmBJ;AEsmBE;EACE,gCAAA;AFpmBJ;AEumBE;EACE,gCAAA;AFrmBJ;AEwmBE;EACE,gCAAA;AFtmBJ;AEymBE;EACE,gCAAA;AFvmBJ;AE0mBE;EACE,iCAAA;AFxmBJ;AE2mBE;EACE,iCAAA;AFzmBJ;AE4mBE;EACE,iCAAA;AF1mBJ;AE6mBE;EACE,iCAAA;AF3mBJ;AE8mBE;EACE,iCAAA;AF5mBJ;AE+mBE;EACE,iCAAA;AF7mBJ;AEgnBE;EACE,iCAAA;AF9mBJ;AEinBE;EACE,gCAAA;AF/mBJ;AEknBE;EACE,iCAAA;AFhnBJ;AEmnBE;EACE,iCAAA;AFjnBJ;AEonBE;EACE,gCAAA;AFlnBJ;AEqnBE;EACE,iCAAA;AFnnBJ;AEsnBE;EACE,iCAAA;AFpnBJ;AEunBE;EACE,iCAAA;AFrnBJ;AEwnBE;EACE,iCAAA;AFtnBJ;AEynBE;EACE,iCAAA;AFvnBJ;AE0nBE;EACE,iCAAA;AFxnBJ;AE2nBE;EACE,iCAAA;AFznBJ;AE4nBE;EACE,iCAAA;AF1nBJ;AE6nBE;EACE,iCAAA;AF3nBJ;AE8nBE;EACE,iCAAA;AF5nBJ;AE+nBE;EACE,iCAAA;AF7nBJ;AEgoBE;EACE,iCAAA;AF9nBJ;AEioBE;EACE,iCAAA;AF/nBJ;AEkoBE;EACE,iCAAA;AFhoBJ;AEmoBE;EACE,iCAAA;AFjoBJ;AEooBE;EACE,gCAAA;AFloBJ;AEqoBE;EACE,iCAAA;AFnoBJ;AEsoBE;EACE,iCAAA;AFpoBJ;AEuoBE;EACE,gCAAA;AFroBJ;AEwoBE;EACE,iCAAA;AFtoBJ;AEyoBE;EACE,iCAAA;AFvoBJ;AE0oBE;EACE,iCAAA;AFxoBJ;AE2oBE;EACE,iCAAA;AFzoBJ;AE4oBE;EACE,iCAAA;AF1oBJ;AE6oBE;EACE,iCAAA;AF3oBJ;AE8oBE;EACE,iCAAA;AF5oBJ;AE+oBE;EACE,iCAAA;AF7oBJ;AEgpBE;EACE,iCAAA;AF9oBJ;AEipBE;EACE,iCAAA;AF/oBJ;AEkpBE;EACE,iCAAA;AFhpBJ;AEmpBE;EACE,iCAAA;AFjpBJ;AEopBE;EACE,gCAAA;AFlpBJ;AEqpBE;EACE,iCAAA;AFnpBJ;AEspBE;EACE,iCAAA;AFppBJ;AEupBE;EACE,gCAAA;AFrpBJ;AEwpBE;EACE,iCAAA;AFtpBJ;AEypBE;EACE,iCAAA;AFvpBJ;AE0pBE;EACE,iCAAA;AFxpBJ;AE2pBE;EACE,iCAAA;AFzpBJ;AE4pBE;EACE,iCAAA;AF1pBJ;AE6pBE;EACE,iCAAA;AF3pBJ;AE8pBE;EACE,iCAAA;AF5pBJ;AE+pBE;EACE,iCAAA;AF7pBJ;AEgqBE;EACE,iCAAA;AF9pBJ;AEiqBE;EACE,iCAAA;AF/pBJ;AEkqBE;EACE,iCAAA;AFhqBJ;AEmqBE;EACE,iCAAA;AFjqBJ;AEoqBE;EACE,iCAAA;AFlqBJ;AEqqBE;EACE,iCAAA;AFnqBJ;AEsqBE;EACE,iCAAA;AFpqBJ;AEuqBE;EACE,gCAAA;AFrqBJ;AEwqBE;EACE,iCAAA;AFtqBJ;AEyqBE;EACE,iCAAA;AFvqBJ;AE0qBE;EACE,gCAAA;AFxqBJ;AE2qBE;EACE,iCAAA;AFzqBJ;AE4qBE;EACE,iCAAA;AF1qBJ;AE6qBE;EACE,iCAAA;AF3qBJ;AE8qBE;EACE,iCAAA;AF5qBJ;AE+qBE;EACE,iCAAA;AF7qBJ;AEgrBE;EACE,iCAAA;AF9qBJ;AEirBE;EACE,iCAAA;AF/qBJ;AEkrBE;EACE,iCAAA;AFhrBJ;AEmrBE;EACE,iCAAA;AFjrBJ;AEorBE;EACE,iCAAA;AFlrBJ;AEqrBE;EACE,iCAAA;AFnrBJ;AEsrBE;EACE,iCAAA;AFprBJ;AEurBE;EACE,gCAAA;AFrrBJ;AEwrBE;EACE,iCAAA;AFtrBJ;AEyrBE;EACE,iCAAA;AFvrBJ;AE0rBE;EACE,gCAAA;AFxrBJ;AE2rBE;EACE,iCAAA;AFzrBJ;AE4rBE;EACE,iCAAA;AF1rBJ;AE6rBE;EACE,iCAAA;AF3rBJ;AE8rBE;EACE,iCAAA;AF5rBJ;AE+rBE;EACE,iCAAA;AF7rBJ;AEgsBE;EACE,iCAAA;AF9rBJ;AEisBE;EACE,iCAAA;AF/rBJ;AEksBE;EACE,iCAAA;AFhsBJ;AEmsBE;EACE,iCAAA;AFjsBJ;AEosBE;EACE,iCAAA;AFlsBJ;AEqsBE;EACE,iCAAA;AFnsBJ;AEssBE;EACE,iCAAA;AFpsBJ;AEusBE;EACE,iCAAA;AFrsBJ;AEwsBE;EACE,iCAAA;AFtsBJ;AEysBE;EACE,iCAAA;AFvsBJ;AE0sBE;EACE,0BAAA;AFxsBJ;AE2sBE;EACE,iCAAA;AFzsBJ;AE4sBE;EACE,iCAAA;AF1sBJ;AE6sBE;EACE,iCAAA;AF3sBJ;AE8sBE;EACE,iCAAA;AF5sBJ;AE+sBE;EACE,iCAAA;AF7sBJ;AEgtBE;EACE,iCAAA;AF9sBJ;AEitBE;EACE,iCAAA;AF/sBJ;AEktBE;EACE,iCAAA;AFhtBJ;AEmtBE;EACE,iCAAA;AFjtBJ;AEotBE;EACE,iCAAA;AFltBJ;AEqtBE;EACE,iCAAA;AFntBJ;AEstBE;EACE,iCAAA;AFptBJ;AEutBE;EACE,iCAAA;AFrtBJ;AEwtBE;EACE,iCAAA;AFttBJ;AEytBE;EACE,iCAAA;AFvtBJ;AE0tBE;EACE,gCAAA;AFxtBJ;AE2tBE;EACE,iCAAA;AFztBJ;AE4tBE;EACE,iCAAA;AF1tBJ;AE6tBE;EACE,gCAAA;AF3tBJ;AE8tBE;EACE,iCAAA;AF5tBJ;AE+tBE;EACE,iCAAA;AF7tBJ;AEguBE;EACE,iCAAA;AF9tBJ;AEiuBE;EACE,iCAAA;AF/tBJ;AEkuBE;EACE,iCAAA;AFhuBJ;AEmuBE;EACE,iCAAA;AFjuBJ;AEouBE;EACE,iCAAA;AFluBJ;AEquBE;EACE,iCAAA;AFnuBJ;AEsuBE;EACE,iCAAA;AFpuBJ;AEuuBE;EACE,iCAAA;AFruBJ;AEwuBE;EACE,iCAAA;AFtuBJ;AEyuBE;EACE,iCAAA;AFvuBJ;AE0uBE;EACE,gCAAA;AFxuBJ;AE2uBE;EACE,iCAAA;AFzuBJ;AE4uBE;EACE,iCAAA;AF1uBJ;AE6uBE;EACE,gCAAA;AF3uBJ;AE8uBE;EACE,iCAAA;AF5uBJ;AE+uBE;EACE,iCAAA;AF7uBJ;AEgvBE;EACE,iCAAA;AF9uBJ;AEivBE;EACE,iCAAA;AF/uBJ;AEkvBE;EACE,iCAAA;AFhvBJ;AEmvBE;EACE,iCAAA;AFjvBJ;AEovBE;EACE,iCAAA;AFlvBJ;AEqvBE;EACE,iCAAA;AFnvBJ;AEsvBE;EACE,iCAAA;AFpvBJ;AEuvBE;EACE,iCAAA;AFrvBJ;AEwvBE;EACE,iCAAA;AFtvBJ;AEyvBE;EACE,iCAAA;AFvvBJ;AE0vBE;EACE,iCAAA;AFxvBJ;AE2vBE;EACE,iCAAA;AFzvBJ;AE4vBE;EACE,iCAAA;AF1vBJ;AE6vBE;EACE,gCAAA;AF3vBJ;AE8vBE;EACE,iCAAA;AF5vBJ;AE+vBE;EACE,iCAAA;AF7vBJ;AEgwBE;EACE,gCAAA;AF9vBJ;AEiwBE;EACE,iCAAA;AF/vBJ;AEkwBE;EACE,iCAAA;AFhwBJ;AEmwBE;EACE,iCAAA;AFjwBJ;AEowBE;EACE,iCAAA;AFlwBJ;AEqwBE;EACE,iCAAA;AFnwBJ;AEswBE;EACE,iCAAA;AFpwBJ;AEuwBE;EACE,iCAAA;AFrwBJ;AEwwBE;EACE,iCAAA;AFtwBJ;AEywBE;EACE,iCAAA;AFvwBJ;AE0wBE;EACE,iCAAA;AFxwBJ;AE2wBE;EACE,iCAAA;AFzwBJ;AE4wBE;EACE,iCAAA;AF1wBJ;AE6wBE;EACE,gCAAA;AF3wBJ;AE8wBE;EACE,iCAAA;AF5wBJ;AE+wBE;EACE,iCAAA;AF7wBJ;AEgxBE;EACE,gCAAA;AF9wBJ;AEixBE;EACE,iCAAA;AF/wBJ;AEkxBE;EACE,iCAAA;AFhxBJ;AEmxBE;EACE,iCAAA;AFjxBJ;AEoxBE;EACE,iCAAA;AFlxBJ;AEqxBE;EACE,iCAAA;AFnxBJ;AEsxBE;EACE,iCAAA;AFpxBJ;AEuxBE;EACE,iCAAA;AFrxBJ;AEwxBE;EACE,iCAAA;AFtxBJ;AEyxBE;EACE,iCAAA;AFvxBJ;AE0xBE;EACE,iCAAA;AFxxBJ;AE2xBE;EACE,iCAAA;AFzxBJ;AE4xBE;EACE,iCAAA;AF1xBJ;AE6xBE;EACE,iCAAA;AF3xBJ;AE8xBE;EACE,iCAAA;AF5xBJ;AE+xBE;EACE,iCAAA;AF7xBJ;AEgyBE;EACE,gCAAA;AF9xBJ;AEiyBE;EACE,iCAAA;AF/xBJ;AEkyBE;EACE,iCAAA;AFhyBJ;AEmyBE;EACE,gCAAA;AFjyBJ;AEoyBE;EACE,iCAAA;AFlyBJ;AEqyBE;EACE,iCAAA;AFnyBJ;AEsyBE;EACE,iCAAA;AFpyBJ;AEuyBE;EACE,iCAAA;AFryBJ;AEwyBE;EACE,iCAAA;AFtyBJ;AEyyBE;EACE,iCAAA;AFvyBJ;AE0yBE;EACE,iCAAA;AFxyBJ;AE2yBE;EACE,iCAAA;AFzyBJ;AE4yBE;EACE,iCAAA;AF1yBJ;AE6yBE;EACE,iCAAA;AF3yBJ;AE8yBE;EACE,iCAAA;AF5yBJ;AE+yBE;EACE,iCAAA;AF7yBJ;AEgzBE;EACE,gCAAA;AF9yBJ;AEizBE;EACE,iCAAA;AF/yBJ;AEkzBE;EACE,iCAAA;AFhzBJ;AEmzBE;EACE,gCAAA;AFjzBJ;AEozBE;EACE,iCAAA;AFlzBJ;AEqzBE;EACE,iCAAA;AFnzBJ;AEszBE;EACE,iCAAA;AFpzBJ;AEuzBE;EACE,iCAAA;AFrzBJ;AEwzBE;EACE,iCAAA;AFtzBJ;AEyzBE;EACE,iCAAA;AFvzBJ;AE0zBE;EACE,iCAAA;AFxzBJ;AE2zBE;EACE,iCAAA;AFzzBJ;AE4zBE;EACE,iCAAA;AF1zBJ;AE6zBE;EACE,iCAAA;AF3zBJ;AE8zBE;EACE,iCAAA;AF5zBJ;AE+zBE;EACE,iCAAA;AF7zBJ;AEg0BE;EACE,iCAAA;AF9zBJ;AEi0BE;EACE,iCAAA;AF/zBJ;AEk0BE;EACE,iCAAA;AFh0BJ;AEm0BE;EACE,2BAAA;AFj0BJ;AEo0BE;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;AFl0BJ;AEq0BE;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;AFn0BJ;AEs0BE;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;AFp0BJ;AEu0BE;EACE,qCAAA;EACA,mBAAA;EACA,uCAAA;EACA,mCAAA;AFr0BJ;AEw0BE;EACE,gBAAA;AFt0BJ;AEy0BE;EACE,wBAAA;AFv0BJ;AE00BE;;;;;;EAME,gBAAA;EACA,oBAAA;EACA,eAAA;AFx0BJ;AE20BE;EACE,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kDAAA;AFz0BJ;AE20BE;EACE,cAAA;EACA,gBAAA;EACA,oBAAA;AFz0BJ;AE20BE;EACE,gBAAA;EACA,gBAAA;AFz0BJ;AE20BE;EACE,cAAA;EACA,gBAAA;AFz0BJ;AE20BE;EACE,kBAAA;EACA,gBAAA;AFz0BJ;AE40BE;EACE,aAAA;AF10BJ;AE80BE;EACE;IACE,gBAAA;IACA,iBAAA;IACA,oBAAA;IACA,gBAAA;IACA,kDAAA;EF50BJ;EE80BE;IACE,iBAAA;IACA,iBAAA;IACA,oBAAA;EF50BJ;EE80BE;IACE,gBAAA;IACA,iBAAA;EF50BJ;EE80BE;IACE,iBAAA;IACA,iBAAA;EF50BJ;EE80BE;IACE,gBAAA;IACA,iBAAA;EF50BJ;EE80BE;IACE,kBAAA;IACA,iBAAA;EF50BJ;AACF;AE+0BE;EACE;IACE,iBAAA;IACA,iBAAA;IACA,oBAAA;IACA,gBAAA;IACA,kDAAA;EF70BJ;EE+0BE;IACE,iBAAA;IACA,gBAAA;IACA,oBAAA;EF70BJ;EE+0BE;IACE,iBAAA;IACA,iBAAA;EF70BJ;EE+0BE;IACE,gBAAA;IACA,iBAAA;EF70BJ;EE+0BE;IACE,iBAAA;IACA,iBAAA;EF70BJ;EE+0BE;IACE,kBAAA;IACA,iBAAA;EF70BJ;AACF;AEg1BE;EACE;IACE,gBAAA;IACA,iBAAA;IACA,oBAAA;IACA,gBAAA;IACA,kDAAA;EF90BJ;EEg1BE;IACE,gBAAA;IACA,iBAAA;IACA,oBAAA;EF90BJ;EEg1BE;IACE,gBAAA;IACA,iBAAA;EF90BJ;EEg1BE;IACE,iBAAA;IACA,iBAAA;EF90BJ;EEg1BE;IACE,gBAAA;IACA,iBAAA;EF90BJ;EEg1BE;IACE,iBAAA;IACA,iBAAA;EF90BJ;AACF;AEi1BE;EACE;IACE,iBAAA;IACA,iBAAA;IACA,oBAAA;IACA,gBAAA;IACA,kDAAA;EF/0BJ;EEi1BE;IACE,iBAAA;IACA,iBAAA;IACA,oBAAA;EF/0BJ;EEi1BE;IACE,iBAAA;IACA,iBAAA;EF/0BJ;EEi1BE;IACE,gBAAA;IACA,iBAAA;EF/0BJ;EEi1BE;IACE,iBAAA;IACA,iBAAA;EF/0BJ;EEi1BE;IACE,kBAAA;IACA,iBAAA;EF/0BJ;AACF;AEk1BE;EACE,mBAAA;EACA,uBAAA;EACA,mCAAA;EACA,sBAAA;AFh1BJ;AEm1BE;EACE,cAAA;EACA,eAAA;EACA,8BAAA;AFj1BJ;AEo1BE;EACE,uCAAA;EACA,uBAAA;EACA,cAAA;AFl1BJ;AEq1BE;EACE,gBAAA;EACA,gBAAA;AFn1BJ;AEs1BE;EACE,gBAAA;AFp1BJ;AEu1BE;EACE;IACE,6BAAA;EFr1BJ;EEw1BE;IACE,+BAAA;EFt1BJ;AACF;AEy1BE;EACE;IACE,UAAA;IACA,sBAAA;EFv1BJ;EE01BE;IACE,UAAA;IACA,oBAAA;EFx1BJ;AACF;AE21BE;EACE;IACE,UAAA;EFz1BJ;EE41BE;IACE,UAAA;EF11BJ;AACF;AE61BE;EACE;IACE,UAAA;EF31BJ;EE81BE;IACE,UAAA;EF51BJ;AACF;AE+1BE;EACE,sDAAA;AF71BJ;AEg2BE;EACE,iCAAA;AF91BJ;AEi2BE;EACE,kCAAA;AF/1BJ;AEk2BE;EACE,oBAAA;EACA,gCAAA;EACA,wCAAA;EACA,kCAAA;AFh2BJ;AEm2BE;EACE,oBAAA;EACA,6CAAA;EACA,wCAAA;EACA,kCAAA;AFj2BJ;AEo2BE;EACE,oBAAA;EACA,gCAAA;EACA,wCAAA;EACA,kCAAA;AFl2BJ;AEq2BE;EACE,oBAAA;EACA,gCAAA;EACA,wCAAA;EACA,kCAAA;AFn2BJ;AEs2BE;EACE,oBAAA;EACA,gCAAA;EACA,wCAAA;EACA,kCAAA;AFp2BJ;AEu2BE;EACE,oBAAA;EACA,gCAAA;EACA,wCAAA;EACA,kCAAA;AFr2BJ;AEw2BE;EACE,oBAAA;EACA,gCAAA;EACA,wCAAA;EACA,kCAAA;AFt2BJ;AEy2BE;EACE,oBAAA;EACA,gCAAA;EACA,wCAAA;EACA,kCAAA;AFv2BJ;AE02BE;EACE,oBAAA;EACA,gCAAA;EACA,wCAAA;EACA,kCAAA;AFx2BJ;AE22BE;EACE,oBAAA;EACA,gCAAA;EACA,wCAAA;EACA,kCAAA;AFz2BJ;AE42BE;EACE,oBAAA;EACA,gCAAA;EACA,wCAAA;EACA,kCAAA;AF12BJ;AE62BE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,4CAAA;EACA,aAAA;EACA,oCAAA;EACA,kCAAA;EACA,8CAAA;AF32BJ;AE82BE;EACE,SAAA;EACA,UAAA;EACA,qBAAA;AF52BJ;AE+2BE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AF72BJ;AEg3BE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AF92BJ;AEi3BE;EACE,cAAA;AF/2BJ;AEk3BE;EACE,aAAA;AFh3BJ;AEm3BE;EACE,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;EACA,2CAAA;EACA,8CAAA;EACA,uDAAA;EACA,eAAA;AFj3BJ;AEo3BE;EACE,eAAA;EACA,gDAAA;AFl3BJ;AEq3BE;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AFn3BJ;AEs3BE;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AFp3BJ;AEu3BE;EACE,gBAAA;AFr3BJ;AEw3BE;EACE,oCAAA;AFt3BJ;AEy3BE;EACE,uCAAA;EACA,uDAAA;AFv3BJ;AE03BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AFx3BJ;AE23BE;EACE,kBAAA;AFz3BJ;AE43BE;EACE,aAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,oCAAA;AF13BJ;AE63BE;EACE,kBAAA;AF33BJ;AE83BE;EACE,6CAAA;EACA,uDAAA;AF53BJ;AE+3BE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kCAAA;EACA,wBAAA;EACA,sCAAA;EACA,qIAAA;AF73BJ;AEg4BE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AF93BJ;AEi4BE;EACE,oCAAA;EACA,oCAAA;EACA,0CAAA;EACA,+CAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,sCAAA;AF/3BJ;AEk4BE;EACE,oCAAA;AFh4BJ;AEm4BE;EACE,eAAA;EACA,+CAAA;AFj4BJ;AEo4BE;EACE,oCAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AFl4BJ;AEq4BE;EACE,kBAAA;EACA,mCAAA;EACA,8BAAA;EACA,oCAAA;EACA,gDAAA;EACA,uCAAA;EACA,oCAAA;AFn4BJ;AEs4BE;EACE,kBAAA;EACA,gDAAA;EACA,4CAAA;EACA,wCAAA;EACA,mDAAA;EACA,yCAAA;EACA,gDAAA;AFp4BJ;AEu4BE;EACE,eAAA;EACA,yBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,0BAAA;EACA,6CAAA;EACA,aAAA;EACA,sBAAA;AFr4BJ;AEw4BE;EACE,aAAA;AFt4BJ;AEy4BE;EACE,OAAA;EACA,oBAAA;EACA,cAAA;AFv4BJ;AE04BE;EACE,SAAA;EACA,UAAA;EACA,qBAAA;AFx4BJ;AE24BE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,sCAAA;EACA,8BAAA;AFz4BJ;AE44BE;EACE,aAAA;AF14BJ;AE64BE;EACE,aAAA;AF34BJ;AE84BE;EACE,yBAAA;EACA,iBAAA;AF54BJ;AE+4BE;EACE,wCAAA;EACA,2CAAA;AF74BJ;AEg5BE;EACE,oBAAA;EACA,wCAAA;AF94BJ;AEi5BE;EACE,0BAAA;AF/4BJ;AEk5BE;EACE,SAAA;EACA,UAAA;EACA,qBAAA;AFh5BJ;AEm5BE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;EACA,eAAA;EACA,uBAAA;EACA,8FAAA;AFj5BJ;AEo5BE;EACE,oBAAA;EACA,iCAAA;AFl5BJ;AEq5BE;EACE,cAAA;EACA,iBAAA;EACA,gDAAA;AFn5BJ;AEs5BE;EACE,gBAAA;AFp5BJ;AEu5BE;EACE,0CAAA;AFr5BJ;AEw5BE;EACE,gBAAA;EACA,mCAAA;AFt5BJ;AEy5BE;EACE,oBAAA;AFv5BJ;AE05BE;EACE,kBAAA;AFx5BJ;AE25BE;EACE,oBAAA;AFz5BJ;AE45BE;EACE,kBAAA;AF15BJ;AE65BE;EACE,oBAAA;AF35BJ;AE85BE;EACE,kBAAA;AF55BJ;AE+5BE;EACE;IACE,WAAA;IACA,iBAAA;IACA,YAAA;EF75BJ;EEg6BE;IACE,cAAA;EF95BJ;EEi6BE;IACE,aAAA;EF/5BJ;EEk6BE;IACE,WAAA;EFh6BJ;EEm6BE;IACE,aAAA;EFj6BJ;EEo6BE;IACE,cAAA;EFl6BJ;EEq6BE;IACE,aAAA;EFn6BJ;EEs6BE;IACE,iBAAA;EFp6BJ;EEu6BE;IACE,eAAA;EFr6BJ;EEw6BE;IACE,iBAAA;EFt6BJ;EEy6BE;IACE,aAAA;EFv6BJ;EE06BE;IACE,aAAA;EFx6BJ;EE26BE;IACE,aAAA;EFz6BJ;EE46BE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,kBAAA;IACA,eAAA;IACA,aAAA;IACA,uDAAA;IACA,WAAA;IACA,YAAA;IACA,cAAA;EF16BJ;EE66BE;IACE,aAAA;EF36BJ;EE86BE;IACE,iBAAA;IACA,iCAAA;EF56BJ;EE+6BE;IACE,aAAA;EF76BJ;EEg7BE;IACE,0CAAA;EF96BJ;EEi7BE;IACE,kBAAA;IACA,UAAA;IACA,MAAA;IACA,gBAAA;IACA,gCAAA;IACA,mCAAA;IACA,iBAAA;IACA,iBAAA;IACA,cAAA;IACA,YAAA;IACA,qIAAA;EF/6BJ;EEk7BE;IACE,aAAA;EFh7BJ;EEm7BE;IACE,qBAAA;EFj7BJ;EEo7BE;IACE,oBAAA;EFl7BJ;EEq7BE;IACE,kBAAA;EFn7BJ;EEs7BE;IACE,oBAAA;EFp7BJ;EEu7BE;IACE,kBAAA;EFr7BJ;EEw7BE;IACE,oBAAA;EFt7BJ;EEy7BE;IACE,kBAAA;EFv7BJ;EE07BE;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;EFx7BJ;EE27BE;IACE,WAAA;IACA,YAAA;IACA,UAAA;IACA,kBAAA;IACA,uBAAA;IACA,iBAAA;EFz7BJ;EE47BE;IACE,aAAA;EF17BJ;EE67BE;IACE,iBAAA;EF37BJ;EE87BE;IACE,aAAA;EF57BJ;EE+7BE;IACE,WAAA;IACA,YAAA;IACA,UAAA;IACA,uBAAA;IACA,kBAAA;EF77BJ;EEg8BE;IACE,iBAAA;IACA,eAAA;EF97BJ;EEi8BE;IACE,aAAA;EF/7BJ;EEk8BE;IACE,mBAAA;EFh8BJ;AACF;AEm8BE;EACE;IACE,WAAA;IACA,iBAAA;IACA,YAAA;EFj8BJ;EEo8BE;IACE,cAAA;EFl8BJ;EEq8BE;IACE,aAAA;EFn8BJ;EEs8BE;IACE,WAAA;EFp8BJ;EEu8BE;IACE,aAAA;EFr8BJ;EEw8BE;IACE,cAAA;EFt8BJ;EEy8BE;IACE,aAAA;EFv8BJ;EE08BE;IACE,iBAAA;EFx8BJ;EE28BE;IACE,eAAA;EFz8BJ;EE48BE;IACE,aAAA;EF18BJ;EE68BE;IACE,cAAA;EF38BJ;EE88BE;IACE,iBAAA;EF58BJ;EE+8BE;IACE,aAAA;EF78BJ;EEg9BE;IACE,aAAA;EF98BJ;EEi9BE;IACE,aAAA;EF/8BJ;EEk9BE;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;IACA,kBAAA;IACA,mCAAA;IACA,eAAA;IACA,aAAA;IACA,uDAAA;IACA,WAAA;IACA,YAAA;IACA,mBAAA;IACA,kBAAA;EFh9BJ;EEm9BE;IACE,aAAA;EFj9BJ;EEo9BE;IACE,iBAAA;IACA,iCAAA;EFl9BJ;EEq9BE;IACE,mBAAA;IACA,cAAA;IACA,mBAAA;IACA,iCAAA;EFn9BJ;EEs9BE;IACE,0CAAA;EFp9BJ;EEu9BE;IACE,kBAAA;IACA,UAAA;IACA,MAAA;IACA,gBAAA;IACA,gCAAA;IACA,mCAAA;IACA,iBAAA;IACA,iBAAA;IACA,cAAA;IACA,YAAA;IACA,qIAAA;EFr9BJ;EEw9BE;IACE,aAAA;EFt9BJ;EEy9BE;IACE,qBAAA;EFv9BJ;EE09BE;IACE,oBAAA;EFx9BJ;EE29BE;IACE,kBAAA;EFz9BJ;EE49BE;IACE,oBAAA;EF19BJ;EE69BE;IACE,kBAAA;EF39BJ;EE89BE;IACE,oBAAA;EF59BJ;EE+9BE;IACE,kBAAA;EF79BJ;EEg+BE;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;EF99BJ;EEi+BE;IACE,WAAA;IACA,YAAA;IACA,UAAA;IACA,kBAAA;IACA,uBAAA;IACA,iBAAA;EF/9BJ;EEk+BE;IACE,aAAA;EFh+BJ;EEm+BE;IACE,iBAAA;EFj+BJ;EEo+BE;IACE,aAAA;EFl+BJ;EEq+BE;IACE,WAAA;IACA,YAAA;IACA,UAAA;IACA,uBAAA;IACA,kBAAA;EFn+BJ;EEs+BE;IACE,iBAAA;IACA,eAAA;EFp+BJ;EEu+BE;IACE,aAAA;EFr+BJ;EEw+BE;IACE,mBAAA;EFt+BJ;AACF;AEy+BE;EACE;IACE,WAAA;IACA,YAAA;IACA,SAAA;IACA,eAAA;IACA,YAAA;IACA,iBAAA;IACA,mBAAA;IACA,eAAA;EFv+BJ;EE0+BE;IACE,cAAA;IACA,iBAAA;EFx+BJ;EE2+BE;IACE,aAAA;EFz+BJ;EE4+BE;IACE,aAAA;EF1+BJ;EE6+BE;IACE,iBAAA;EF3+BJ;EE8+BE;IACE,aAAA;IACA,iBAAA;IACA,mBAAA;IACA,mBAAA;IACA,YAAA;EF5+BJ;EE++BE;IACE,aAAA;EF7+BJ;EEg/BE;IACE,mCAAA;EF9+BJ;EEi/BE;IACE,aAAA;EF/+BJ;EEk/BE;IACE,aAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;IACA,eAAA;IACA,aAAA;IACA,iCAAA;IACA,uDAAA;EFh/BJ;EEm/BE;IACE,cAAA;IACA,iBAAA;IACA,0BAAA;EFj/BJ;EEo/BE;IACE,kBAAA;IACA,iCAAA;EFl/BJ;EEq/BE;IACE,mBAAA;IACA,cAAA;IACA,oBAAA;IACA,qBAAA;IACA,mBAAA;EFn/BJ;EEs/BE;IACE,0CAAA;EFp/BJ;EEu/BE;IACE,kBAAA;IACA,UAAA;IACA,SAAA;IACA,gBAAA;IACA,gCAAA;IACA,qIAAA;IACA,iBAAA;IACA,mCAAA;IACA,iBAAA;IACA,cAAA;IACA,YAAA;EFr/BJ;EEw/BE;IACE,aAAA;EFt/BJ;EEy/BE;IACE,qBAAA;EFv/BJ;EE0/BE;IACE,oBAAA;EFx/BJ;EE2/BE;IACE,kBAAA;EFz/BJ;EE4/BE;IACE,oBAAA;EF1/BJ;EE6/BE;IACE,kBAAA;EF3/BJ;EE8/BE;IACE,oBAAA;EF5/BJ;EE+/BE;IACE,kBAAA;EF7/BJ;EEggCE;IACE,qBAAA;EF9/BJ;EEigCE;IACE,OAAA;EF//BJ;EEkgCE;IACE,kBAAA;EFhgCJ;EEmgCE;IACE,QAAA;EFjgCJ;EEogCE;IACE,kBAAA;IACA,iBAAA;IACA,WAAA;IACA,YAAA;EFlgCJ;EEqgCE;IACE,kBAAA;IACA,WAAA;IACA,YAAA;EFngCJ;EEsgCE;IACE,mBAAA;EFpgCJ;EEugCE;IACE,kBAAA;IACA,SAAA;IACA,gBAAA;IACA,gCAAA;IACA,qIAAA;IACA,aAAA;IACA,mCAAA;IACA,iBAAA;IACA,cAAA;IACA,YAAA;IACA,4BAAA;EFrgCJ;EEwgCE;IACE,uBAAA;EFtgCJ;AACF;AEygCE;EACE;IACE,YAAA;IACA,MAAA;IACA,qDAAA;IACA,+BAAA;IACA,YAAA;EFvgCJ;EE0gCE;IACE,aAAA;IACA,mBAAA;IACA,yBAAA;IACA,kBAAA;IACA,YAAA;IACA,kCAAA;IACA,oCAAA;EFxgCJ;EE2gCE;IACE,aAAA;EFzgCJ;EE4gCE;IACE,eAAA;EF1gCJ;EE6gCE;IACE,aAAA;IACA,cAAA;IACA,eAAA;IACA,kBAAA;IACA,8CAAA;IACA,6BAAA;IACA,uEAAA;EF3gCJ;EE8gCE;IACE,gBAAA;EF5gCJ;EE+gCE;IACE,kBAAA;EF7gCJ;EEghCE;IACE,cAAA;IACA,sBAAA;EF9gCJ;EEihCE;IACE,SAAA;IACA,UAAA;IACA,qBAAA;EF/gCJ;EEkhCE;IACE,QAAA;IACA,kBAAA;EFhhCJ;EEmhCE;IACE,QAAA;IACA,aAAA;IACA,oBAAA;EFjhCJ;EEohCE;IACE,QAAA;IACA,eAAA;IACA,kBAAA;IACA,WAAA;EFlhCJ;EEqhCE;IACE,2BAAA;EFnhCJ;EEshCE;IACE,eAAA;IACA,iBAAA;IACA,kBAAA;IACA,WAAA;EFphCJ;EEuhCE;IACE,qBAAA;EFrhCJ;EEwhCE;IACE,aAAA;EFthCJ;EEyhCE;IACE,oBAAA;IACA,uDAAA;EFvhCJ;EE0hCE;IACE,uBAAA;EFxhCJ;EE2hCE;IACE,iBAAA;IACA,8BAAA;EFzhCJ;EE4hCE;IACE,eAAA;EF1hCJ;EE6hCE;IACE,aAAA;EF3hCJ;EE8hCE;IACE,cAAA;IACA,iCAAA;EF5hCJ;EE+hCE;IACE,cAAA;EF7hCJ;EEgiCE;IACE,aAAA;EF9hCJ;EEiiCE;IACE,cAAA;EF/hCJ;EEkiCE;IACE,mBAAA;EFhiCJ;EEmiCE;IACE,8CAAA;EFjiCJ;EEoiCE;IACE,kBAAA;EFliCJ;AACF;AEqiCE;EACE;IACE,YAAA;IACA,MAAA;IACA,iDAAA;IACA,cAAA;IACA,YAAA;EFniCJ;EEsiCE;IACE,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,kBAAA;IACA,YAAA;IACA,kCAAA;IACA,oCAAA;EFpiCJ;EEuiCE;IACE,aAAA;IACA,QAAA;IACA,iDAAA;IACA,sBAAA;EFriCJ;EEwiCE;IACE,eAAA;IACA,QAAA;EFtiCJ;EEyiCE;IACE,aAAA;IACA,cAAA;IACA,eAAA;IACA,kBAAA;IACA,8CAAA;IACA,6BAAA;IACA,uEAAA;EFviCJ;EE0iCE;IACE,gBAAA;EFxiCJ;EE2iCE;IACE,oBAAA;EFziCJ;EE4iCE;IACE,UAAA;IACA,mBAAA;IACA,aAAA;IACA,yBAAA;IACA,eAAA;EF1iCJ;EE6iCE;IACE,kBAAA;IACA,UAAA;IACA,oBAAA;EF3iCJ;EE8iCE;IACE,kBAAA;IACA,cAAA;EF5iCJ;EE+iCE;IACE,cAAA;IACA,qBAAA;IACA,kBAAA;EF7iCJ;EEgjCE;IACE,SAAA;IACA,UAAA;IACA,qBAAA;EF9iCJ;EEijCE;IACE,UAAA;IACA,mBAAA;IACA,oBAAA;EF/iCJ;EEkjCE;IACE,kBAAA;IACA,WAAA;EFhjCJ;EEmjCE;IACE,aAAA;EFjjCJ;EEojCE;IACE,uBAAA;EFljCJ;EEqjCE;IACE,qBAAA;EFnjCJ;EEsjCE;IACE,UAAA;IACA,mBAAA;IACA,oBAAA;EFpjCJ;EEujCE;IACE,oBAAA;IACA,kBAAA;IACA,WAAA;EFrjCJ;EEwjCE;IACE,qBAAA;EFtjCJ;EEyjCE;IACE,aAAA;EFvjCJ;EE0jCE;IACE,oBAAA;IACA,uDAAA;IACA,kBAAA;EFxjCJ;EE2jCE;IACE,YAAA;EFzjCJ;EE4jCE;IACE,iBAAA;EF1jCJ;EE6jCE;IACE,eAAA;IACA,WAAA;IACA,iDAAA;IACA,sBAAA;EF3jCJ;EE8jCE;IACE,aAAA;EF5jCJ;EE+jCE;IACE,cAAA;IACA,iCAAA;EF7jCJ;EEgkCE;IACE,cAAA;IACA,kBAAA;EF9jCJ;EEikCE;IACE,mBAAA;EF/jCJ;EEkkCE;IACE,aAAA;EFhkCJ;EEmkCE;IACE,kBAAA;IACA,UAAA;IACA,oBAAA;EFjkCJ;EEokCE;IACE,WAAA;EFlkCJ;EEqkCE;IACE,cAAA;EFnkCJ;EEskCE;IACE,UAAA;IACA,mBAAA;IACA,oBAAA;EFpkCJ;EEukCE;IACE,gBAAA;IACA,mCAAA;EFrkCJ;EEwkCE;IACE,oBAAA;EFtkCJ;EEykCE;IACE,kBAAA;EFvkCJ;EE0kCE;IACE,oBAAA;EFxkCJ;EE2kCE;IACE,kBAAA;EFzkCJ;EE4kCE;IACE,oBAAA;EF1kCJ;EE6kCE;IACE,kBAAA;EF3kCJ;EE8kCE;IACE,UAAA;IACA,mBAAA;IACA,oBAAA;EF5kCJ;EE+kCE;IACE,oBAAA;IACA,kBAAA;IACA,WAAA;EF7kCJ;EEglCE;IACE,mBAAA;EF9kCJ;EEilCE;IACE,8CAAA;EF/kCJ;EEklCE;IACE,kBAAA;EFhlCJ;AACF;AEmlCE;EACE,0BAAA;AFjlCJ;AEolCE;EACE,qDAAA;AFllCJ;AEqlCE;EACE,wDAAA;AFnlCJ;AEslCE;EACE,WAAA;EACA,0BAAA;EACA,gBAAA;EACA,8CAAA;AFplCJ;AEulCE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,iCAAA;EACA,uDAAA;AFrlCJ;AEwlCE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AFtlCJ;AEylCE;EACE,iBAAA;EACA,gDAAA;AFvlCJ;AE0lCE;EACE,0CAAA;AFxlCJ;AE2lCE;EACE,qBAAA;EACA,SAAA;EACA,UAAA;AFzlCJ;AE4lCE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8FAAA;EACA,iCAAA;AF1lCJ;AE6lCE;EACE,oBAAA;EACA,iCAAA;AF3lCJ;AE8lCE;EACE,0CAAA;AF5lCJ;AE+lCE;EACE,cAAA;EACA,UAAA;AF7lCJ;AEgmCE;EACE,wCAAA;AF9lCJ;AEimCE;EACE,sCAAA;AF/lCJ;AEkmCE;EACE,uCAAA;AFhmCJ;AEmmCE;EACE,iCAAA;AFjmCJ;AEomCE;EACE,YAAA;EACA,eAAA;AFlmCJ;AEqmCE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,iCAAA;EACA,wBAAA;EACA,+BAAA;EACA,mCAAA;EACA,kCAAA;AFnmCJ;AEsmCE;EACE,qBAAA;AFpmCJ;AEumCE;EACE,SAAA;AFrmCJ;AEwmCE;EACE,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AFtmCJ;AEymCE;EACE,cAAA;EACA,aAAA;AFvmCJ;AE0mCE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,qCAAA;AFxmCJ;AE2mCE;EACE,YAAA;EACA,eAAA;EACA,QAAA;EACA,QAAA;EACA,WAAA;EACA,0BAAA;EACA,6BAAA;EACA,eAAA;AFzmCJ;AE4mCE;EACE,eAAA;AF1mCJ;AE6mCE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,8CAAA;EACA,oBAAA;EACA,qCAAA;AF3mCJ;AE8mCE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,kCAAA;AF5mCJ;AE+mCE;EACE,aAAA;EACA,mBAAA;AF7mCJ;AEgnCE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AF9mCJ;AEinCE;EACE,cAAA;AF/mCJ;AEknCE;EACE;IACE,qDAAA;EFhnCJ;EEmnCE;IACE,kBAAA;IACA,uDAAA;EFjnCJ;EEonCE;IACE,yBAAA;EFlnCJ;EEqnCE;IACE,2BAAA;EFnnCJ;EEsnCE;IACE,cAAA;EFpnCJ;EEunCE;IACE,oBAAA;EFrnCJ;EEwnCE;IACE,cAAA;EFtnCJ;EEynCE;IACE,YAAA;IACA,2BAAA;IACA,qDAAA;EFvnCJ;EE0nCE;IACE,uBAAA;EFxnCJ;EE2nCE;IACE,yBAAA;EFznCJ;AACF;AE4nCE;EACE;IACE,gBAAA;EF1nCJ;EE6nCE;IACE,cAAA;EF3nCJ;EE8nCE;IACE,YAAA;IACA,2BAAA;IACA,qDAAA;EF5nCJ;EE+nCE;IACE,uBAAA;EF7nCJ;EEgoCE;IACE,cAAA;IACA,qDAAA;EF9nCJ;EEioCE;IACE,yBAAA;EF/nCJ;EEkoCE;IACE,aAAA;IACA,eAAA;IACA,MAAA;IACA,OAAA;IACA,YAAA;IACA,WAAA;IACA,YAAA;IACA,+BAAA;EFhoCJ;EEmoCE;IACE,aAAA;IACA,8BAAA;IACA,oBAAA;IACA,eAAA;IACA,SAAA;IACA,WAAA;IACA,kCAAA;IACA,eAAA;EFjoCJ;EEooCE;IACE,YAAA;EFloCJ;EEqoCE;IACE,gBAAA;EFnoCJ;EEsoCE;IACE,kBAAA;IACA,UAAA;IACA,WAAA;IACA,iBAAA;IACA,cAAA;EFpoCJ;EEuoCE;IACE,sBAAA;EFroCJ;EEwoCE;IACE,8BAAA;IACA,mBAAA;IACA,YAAA;IACA,eAAA;EFtoCJ;EEyoCE;IACE,gBAAA;EFvoCJ;EE0oCE;IACE,UAAA;IACA,WAAA;EFxoCJ;EE2oCE;IACE,kBAAA;EFzoCJ;EE4oCE;IACE,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,YAAA;EF1oCJ;EE6oCE;IACE,aAAA;IACA,sBAAA;EF3oCJ;EE8oCE;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,2BAAA;EF5oCJ;EE+oCE;IACE,kBAAA;IACA,aAAA;IACA,iBAAA;IACA,SAAA;EF7oCJ;EEgpCE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,iBAAA;IACA,uDAAA;EF9oCJ;EEipCE;IACE,kCAAA;EF/oCJ;EEkpCE;IACE,aAAA;EFhpCJ;AACF;AEmpCE;EACE;IACE,aAAA;IACA,4BAAA;IACA,6BAAA;EFjpCJ;AACF;AEopCE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AFlpCJ;AEqpCE;EACE,sBAAA;AFnpCJ;AEspCE;EACE,eAAA;EACA,cAAA;EACA,aAAA;AFppCJ;AEupCE;EACE,UAAA;AFrpCJ;AEwpCE;EACE,YAAA;EACA,aAAA;EACA,aAAA;AFtpCJ;AEypCE;EACE,cAAA;EACA,aAAA;AFvpCJ;AE0pCE;EACE,cAAA;EACA,aAAA;EACA,cAAA;AFxpCJ;AE2pCE;EACE,cAAA;EACA,aAAA;EACA,eAAA;AFzpCJ;AE4pCE;EACE,cAAA;EACA,aAAA;EACA,UAAA;AF1pCJ;AE6pCE;EACE,cAAA;EACA,aAAA;EACA,eAAA;AF3pCJ;AE8pCE;EACE,cAAA;EACA,aAAA;EACA,eAAA;AF5pCJ;AE+pCE;EACE,cAAA;EACA,aAAA;EACA,UAAA;AF7pCJ;AEgqCE;EACE,cAAA;EACA,aAAA;EACA,eAAA;AF9pCJ;AEiqCE;EACE,cAAA;EACA,aAAA;EACA,eAAA;AF/pCJ;AEkqCE;EACE,cAAA;EACA,aAAA;EACA,UAAA;AFhqCJ;AEmqCE;EACE,cAAA;EACA,aAAA;EACA,eAAA;AFjqCJ;AEoqCE;EACE,cAAA;EACA,aAAA;EACA,eAAA;AFlqCJ;AEqqCE;EACE,cAAA;EACA,WAAA;AFnqCJ;AEsqCE;EACE;IACE,YAAA;IACA,aAAA;IACA,aAAA;EFpqCJ;EEuqCE;IACE,cAAA;IACA,aAAA;EFrqCJ;EEwqCE;IACE,cAAA;IACA,aAAA;IACA,cAAA;EFtqCJ;EEyqCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EFvqCJ;EE0qCE;IACE,cAAA;IACA,aAAA;IACA,UAAA;EFxqCJ;EE2qCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EFzqCJ;EE4qCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EF1qCJ;EE6qCE;IACE,cAAA;IACA,aAAA;IACA,UAAA;EF3qCJ;EE8qCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EF5qCJ;EE+qCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EF7qCJ;EEgrCE;IACE,cAAA;IACA,aAAA;IACA,UAAA;EF9qCJ;EEirCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EF/qCJ;EEkrCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EFhrCJ;EEmrCE;IACE,cAAA;IACA,aAAA;IACA,WAAA;EFjrCJ;AACF;AEorCE;EACE;IACE,YAAA;IACA,aAAA;IACA,aAAA;EFlrCJ;EEqrCE;IACE,cAAA;IACA,aAAA;EFnrCJ;EEsrCE;IACE,cAAA;IACA,aAAA;IACA,cAAA;EFprCJ;EEurCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EFrrCJ;EEwrCE;IACE,cAAA;IACA,aAAA;IACA,UAAA;EFtrCJ;EEyrCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EFvrCJ;EE0rCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EFxrCJ;EE2rCE;IACE,cAAA;IACA,aAAA;IACA,UAAA;EFzrCJ;EE4rCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EF1rCJ;EE6rCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EF3rCJ;EE8rCE;IACE,cAAA;IACA,aAAA;IACA,UAAA;EF5rCJ;EE+rCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EF7rCJ;EEgsCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EF9rCJ;EEisCE;IACE,cAAA;IACA,aAAA;IACA,WAAA;EF/rCJ;AACF;AEksCE;EACE;IACE,YAAA;IACA,aAAA;IACA,aAAA;EFhsCJ;EEmsCE;IACE,cAAA;IACA,aAAA;EFjsCJ;EEosCE;IACE,cAAA;IACA,aAAA;IACA,cAAA;EFlsCJ;EEqsCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EFnsCJ;EEssCE;IACE,cAAA;IACA,aAAA;IACA,UAAA;EFpsCJ;EEusCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EFrsCJ;EEwsCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EFtsCJ;EEysCE;IACE,cAAA;IACA,aAAA;IACA,UAAA;EFvsCJ;EE0sCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EFxsCJ;EE2sCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EFzsCJ;EE4sCE;IACE,cAAA;IACA,aAAA;IACA,UAAA;EF1sCJ;EE6sCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EF3sCJ;EE8sCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EF5sCJ;EE+sCE;IACE,cAAA;IACA,aAAA;IACA,WAAA;EF7sCJ;AACF;AEgtCE;EACE;IACE,YAAA;IACA,aAAA;IACA,aAAA;EF9sCJ;EEitCE;IACE,cAAA;IACA,aAAA;EF/sCJ;EEktCE;IACE,cAAA;IACA,aAAA;IACA,cAAA;EFhtCJ;EEmtCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EFjtCJ;EEotCE;IACE,cAAA;IACA,aAAA;IACA,UAAA;EFltCJ;EEqtCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EFntCJ;EEstCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EFptCJ;EEutCE;IACE,cAAA;IACA,aAAA;IACA,UAAA;EFrtCJ;EEwtCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EFttCJ;EEytCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EFvtCJ;EE0tCE;IACE,cAAA;IACA,aAAA;IACA,UAAA;EFxtCJ;EE2tCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EFztCJ;EE4tCE;IACE,cAAA;IACA,aAAA;IACA,eAAA;EF1tCJ;EE6tCE;IACE,cAAA;IACA,aAAA;IACA,WAAA;EF3tCJ;AACF;AE8tCE;EACE,yBAAA;AF5tCJ;AE+tCE;EACE,+BAAA;AF7tCJ;AEguCE;EACE,gCAAA;AF9tCJ;AEiuCE;EACE,2BAAA;AF/tCJ;AEkuCE;EACE,gCAAA;AFhuCJ;AEmuCE;EACE,gCAAA;AFjuCJ;AEouCE;EACE,2BAAA;AFluCJ;AEquCE;EACE,gCAAA;AFnuCJ;AEsuCE;EACE,gCAAA;AFpuCJ;AEuuCE;EACE,2BAAA;AFruCJ;AEwuCE;EACE,gCAAA;AFtuCJ;AEyuCE;EACE,gCAAA;AFvuCJ;AE0uCE;EACE,4BAAA;AFxuCJ;AE2uCE;EACE;IACE,yBAAA;EFzuCJ;EE4uCE;IACE,+BAAA;EF1uCJ;EE6uCE;IACE,gCAAA;EF3uCJ;EE8uCE;IACE,2BAAA;EF5uCJ;EE+uCE;IACE,gCAAA;EF7uCJ;EEgvCE;IACE,gCAAA;EF9uCJ;EEivCE;IACE,2BAAA;EF/uCJ;EEkvCE;IACE,gCAAA;EFhvCJ;EEmvCE;IACE,gCAAA;EFjvCJ;EEovCE;IACE,2BAAA;EFlvCJ;EEqvCE;IACE,gCAAA;EFnvCJ;EEsvCE;IACE,gCAAA;EFpvCJ;EEuvCE;IACE,4BAAA;EFrvCJ;AACF;AEwvCE;EACE;IACE,yBAAA;EFtvCJ;EEyvCE;IACE,+BAAA;EFvvCJ;EE0vCE;IACE,gCAAA;EFxvCJ;EE2vCE;IACE,2BAAA;EFzvCJ;EE4vCE;IACE,gCAAA;EF1vCJ;EE6vCE;IACE,gCAAA;EF3vCJ;EE8vCE;IACE,2BAAA;EF5vCJ;EE+vCE;IACE,gCAAA;EF7vCJ;EEgwCE;IACE,gCAAA;EF9vCJ;EEiwCE;IACE,2BAAA;EF/vCJ;EEkwCE;IACE,gCAAA;EFhwCJ;EEmwCE;IACE,gCAAA;EFjwCJ;EEowCE;IACE,4BAAA;EFlwCJ;AACF;AEqwCE;EACE;IACE,yBAAA;EFnwCJ;EEswCE;IACE,+BAAA;EFpwCJ;EEuwCE;IACE,gCAAA;EFrwCJ;EEwwCE;IACE,2BAAA;EFtwCJ;EEywCE;IACE,gCAAA;EFvwCJ;EE0wCE;IACE,gCAAA;EFxwCJ;EE2wCE;IACE,2BAAA;EFzwCJ;EE4wCE;IACE,gCAAA;EF1wCJ;EE6wCE;IACE,gCAAA;EF3wCJ;EE8wCE;IACE,2BAAA;EF5wCJ;EE+wCE;IACE,gCAAA;EF7wCJ;EEgxCE;IACE,gCAAA;EF9wCJ;EEixCE;IACE,4BAAA;EF/wCJ;AACF;AEkxCE;EACE;IACE,yBAAA;EFhxCJ;EEmxCE;IACE,+BAAA;EFjxCJ;EEoxCE;IACE,gCAAA;EFlxCJ;EEqxCE;IACE,2BAAA;EFnxCJ;EEsxCE;IACE,gCAAA;EFpxCJ;EEuxCE;IACE,gCAAA;EFrxCJ;EEwxCE;IACE,2BAAA;EFtxCJ;EEyxCE;IACE,gCAAA;EFvxCJ;EE0xCE;IACE,gCAAA;EFxxCJ;EE2xCE;IACE,2BAAA;EFzxCJ;EE4xCE;IACE,gCAAA;EF1xCJ;EE6xCE;IACE,gCAAA;EF3xCJ;EE8xCE;IACE,4BAAA;EF5xCJ;AACF;AE+xCE;EACE,kCAAA;AF7xCJ;AEgyCE;EACE,mCAAA;AF9xCJ;AEiyCE;EACE,oCAAA;AF/xCJ;AEkyCE;EACE,oCAAA;AFhyCJ;AEmyCE;EACE,oCAAA;AFjyCJ;AEoyCE;EACE,oCAAA;AFlyCJ;AEqyCE;EACE,oCAAA;AFnyCJ;AEsyCE;EACE,oCAAA;AFpyCJ;AEuyCE;EACE,oCAAA;AFryCJ;AEwyCE;EACE,oCAAA;AFtyCJ;AEyyCE;EACE,oCAAA;AFvyCJ;AE0yCE;EACE,kCAAA;AFxyCJ;AE2yCE;EACE,kCAAA;AFzyCJ;AE4yCE;EACE,mCAAA;AF1yCJ;AE6yCE;EACE,mCAAA;AF3yCJ;AE8yCE;EACE,oCAAA;AF5yCJ;AE+yCE;EACE,oCAAA;AF7yCJ;AEgzCE;EACE,oCAAA;AF9yCJ;AEizCE;EACE,oCAAA;AF/yCJ;AEkzCE;EACE,oCAAA;AFhzCJ;AEmzCE;EACE,oCAAA;AFjzCJ;AEozCE;EACE,oCAAA;AFlzCJ;AEqzCE;EACE,oCAAA;AFnzCJ;AEszCE;EACE,oCAAA;AFpzCJ;AEuzCE;EACE,oCAAA;AFrzCJ;AEwzCE;EACE,oCAAA;AFtzCJ;AEyzCE;EACE,oCAAA;AFvzCJ;AE0zCE;EACE,oCAAA;AFxzCJ;AE2zCE;EACE,oCAAA;AFzzCJ;AE4zCE;EACE,oCAAA;AF1zCJ;AE6zCE;EACE,oCAAA;AF3zCJ;AE8zCE;EACE,oCAAA;AF5zCJ;AE+zCE;EACE,oCAAA;AF7zCJ;AEg0CE;EACE,6CAAA;AF9zCJ;AEi0CE;EACE,8CAAA;AF/zCJ;AEk0CE;EACE,+CAAA;AFh0CJ;AEm0CE;EACE,+CAAA;AFj0CJ;AEo0CE;EACE,+CAAA;AFl0CJ;AEq0CE;EACE,+CAAA;AFn0CJ;AEs0CE;EACE,+CAAA;AFp0CJ;AEu0CE;EACE,+CAAA;AFr0CJ;AEw0CE;EACE,+CAAA;AFt0CJ;AEy0CE;EACE,+CAAA;AFv0CJ;AE00CE;EACE,+CAAA;AFx0CJ;AE20CE;EACE,6CAAA;AFz0CJ;AE40CE;EACE,6CAAA;AF10CJ;AE60CE;EACE,8CAAA;AF30CJ;AE80CE;EACE,8CAAA;AF50CJ;AE+0CE;EACE,+CAAA;AF70CJ;AEg1CE;EACE,+CAAA;AF90CJ;AEi1CE;EACE,+CAAA;AF/0CJ;AEk1CE;EACE,+CAAA;AFh1CJ;AEm1CE;EACE,+CAAA;AFj1CJ;AEo1CE;EACE,+CAAA;AFl1CJ;AEq1CE;EACE,+CAAA;AFn1CJ;AEs1CE;EACE,+CAAA;AFp1CJ;AEu1CE;EACE,+CAAA;AFr1CJ;AEw1CE;EACE,+CAAA;AFt1CJ;AEy1CE;EACE,+CAAA;AFv1CJ;AE01CE;EACE,+CAAA;AFx1CJ;AE21CE;EACE,+CAAA;AFz1CJ;AE41CE;EACE,+CAAA;AF11CJ;AE61CE;EACE,+CAAA;AF31CJ;AE81CE;EACE,+CAAA;AF51CJ;AE+1CE;EACE,+CAAA;AF71CJ;AEg2CE;EACE,+CAAA;AF91CJ;AEi2CE;EACE,yCAAA;AF/1CJ;AEk2CE;EACE,0CAAA;AFh2CJ;AEm2CE;EACE,2CAAA;AFj2CJ;AEo2CE;EACE,2CAAA;AFl2CJ;AEq2CE;EACE,2CAAA;AFn2CJ;AEs2CE;EACE,2CAAA;AFp2CJ;AEu2CE;EACE,2CAAA;AFr2CJ;AEw2CE;EACE,2CAAA;AFt2CJ;AEy2CE;EACE,2CAAA;AFv2CJ;AE02CE;EACE,2CAAA;AFx2CJ;AE22CE;EACE,2CAAA;AFz2CJ;AE42CE;EACE,yCAAA;AF12CJ;AE62CE;EACE,yCAAA;AF32CJ;AE82CE;EACE,0CAAA;AF52CJ;AE+2CE;EACE,0CAAA;AF72CJ;AEg3CE;EACE,2CAAA;AF92CJ;AEi3CE;EACE,2CAAA;AF/2CJ;AEk3CE;EACE,2CAAA;AFh3CJ;AEm3CE;EACE,2CAAA;AFj3CJ;AEo3CE;EACE,2CAAA;AFl3CJ;AEq3CE;EACE,2CAAA;AFn3CJ;AEs3CE;EACE,2CAAA;AFp3CJ;AEu3CE;EACE,2CAAA;AFr3CJ;AEw3CE;EACE,2CAAA;AFt3CJ;AEy3CE;EACE,2CAAA;AFv3CJ;AE03CE;EACE,2CAAA;AFx3CJ;AE23CE;EACE,2CAAA;AFz3CJ;AE43CE;EACE,2CAAA;AF13CJ;AE63CE;EACE,2CAAA;AF33CJ;AE83CE;EACE,2CAAA;AF53CJ;AE+3CE;EACE,2CAAA;AF73CJ;AEg4CE;EACE,2CAAA;AF93CJ;AEi4CE;EACE,2CAAA;AF/3CJ;AEk4CE;EACE,wCAAA;AFh4CJ;AEm4CE;EACE;IACE,wCAAA;EFj4CJ;AACF;AEo4CE;EACE;IACE,wCAAA;EFl4CJ;AACF;AEq4CE;EACE;IACE,wCAAA;EFn4CJ;AACF;AEs4CE;EACE;IACE,wCAAA;EFp4CJ;AACF;AEu4CE;EACE,oCAAA;AFr4CJ;AEw4CE;EACE;IACE,oCAAA;EFt4CJ;AACF;AEy4CE;EACE;IACE,oCAAA;EFv4CJ;AACF;AE04CE;EACE;IACE,oCAAA;EFx4CJ;AACF;AE24CE;EACE;IACE,oCAAA;EFz4CJ;AACF;AE44CE;EACE,gCAAA;AF14CJ;AE64CE;EACE,iCAAA;AF34CJ;AE84CE;EACE,iCAAA;AF54CJ;AE+4CE;EACE,iCAAA;AF74CJ;AEg5CE;EACE,iCAAA;AF94CJ;AEi5CE;EACE,iCAAA;AF/4CJ;AEk5CE;EACE,iCAAA;AFh5CJ;AEm5CE;EACE,iCAAA;AFj5CJ;AEo5CE;EACE,iCAAA;AFl5CJ;AEq5CE;EACE,iCAAA;AFn5CJ;AEs5CE;EACE,gCAAA;AFp5CJ;AEu5CE;EACE,iCAAA;AFr5CJ;AEw5CE;EACE,iCAAA;AFt5CJ;AEy5CE;EACE,iCAAA;AFv5CJ;AE05CE;EACE,iCAAA;AFx5CJ;AE25CE;EACE,iCAAA;AFz5CJ;AE45CE;EACE,iCAAA;AF15CJ;AE65CE;EACE,iCAAA;AF35CJ;AE85CE;EACE,iCAAA;AF55CJ;AE+5CE;EACE,iCAAA;AF75CJ;AEg6CE;EACE,gCAAA;AF95CJ;AEi6CE;EACE,iCAAA;AF/5CJ;AEk6CE;EACE,iCAAA;AFh6CJ;AEm6CE;EACE,iCAAA;AFj6CJ;AEo6CE;EACE,iCAAA;AFl6CJ;AEq6CE;EACE,iCAAA;AFn6CJ;AEs6CE;EACE,iCAAA;AFp6CJ;AEu6CE;EACE,iCAAA;AFr6CJ;AEw6CE;EACE,iCAAA;AFt6CJ;AEy6CE;EACE,iCAAA;AFv6CJ;AE06CE;EACE,gCAAA;AFx6CJ;AE26CE;EACE,iCAAA;AFz6CJ;AE46CE;EACE,iCAAA;AF16CJ;AE66CE;EACE,iCAAA;AF36CJ;AE86CE;EACE,iCAAA;AF56CJ;AE+6CE;EACE,iCAAA;AF76CJ;AEg7CE;EACE,iCAAA;AF96CJ;AEi7CE;EACE,iCAAA;AF/6CJ;AEk7CE;EACE,iCAAA;AFh7CJ;AEm7CE;EACE,iCAAA;AFj7CJ;AEo7CE;EACE,iCAAA;AFl7CJ;AEq7CE;EACE,kCAAA;AFn7CJ;AEs7CE;EACE,kCAAA;AFp7CJ;AEu7CE;EACE,kCAAA;AFr7CJ;AEw7CE;EACE,kCAAA;AFt7CJ;AEy7CE;EACE,kCAAA;AFv7CJ;AE07CE;EACE,kCAAA;AFx7CJ;AE27CE;EACE,kCAAA;AFz7CJ;AE47CE;EACE,kCAAA;AF17CJ;AE67CE;EACE,kCAAA;AF37CJ;AE87CE;EACE,iCAAA;AF57CJ;AE+7CE;EACE,kCAAA;AF77CJ;AEg8CE;EACE,kCAAA;AF97CJ;AEi8CE;EACE,kCAAA;AF/7CJ;AEk8CE;EACE,kCAAA;AFh8CJ;AEm8CE;EACE,kCAAA;AFj8CJ;AEo8CE;EACE,kCAAA;AFl8CJ;AEq8CE;EACE,kCAAA;AFn8CJ;AEs8CE;EACE,kCAAA;AFp8CJ;AEu8CE;EACE,kCAAA;AFr8CJ;AEw8CE;EACE,iCAAA;AFt8CJ;AEy8CE;EACE,kCAAA;AFv8CJ;AE08CE;EACE,kCAAA;AFx8CJ;AE28CE;EACE,kCAAA;AFz8CJ;AE48CE;EACE,kCAAA;AF18CJ;AE68CE;EACE,kCAAA;AF38CJ;AE88CE;EACE,kCAAA;AF58CJ;AE+8CE;EACE,kCAAA;AF78CJ;AEg9CE;EACE,kCAAA;AF98CJ;AEi9CE;EACE,kCAAA;AF/8CJ;AEk9CE;EACE,iCAAA;AFh9CJ;AEm9CE;EACE,kCAAA;AFj9CJ;AEo9CE;EACE,kCAAA;AFl9CJ;AEq9CE;EACE,kCAAA;AFn9CJ;AEs9CE;EACE,kCAAA;AFp9CJ;AEu9CE;EACE,kCAAA;AFr9CJ;AEw9CE;EACE,kCAAA;AFt9CJ;AEy9CE;EACE,kCAAA;AFv9CJ;AE09CE;EACE,kCAAA;AFx9CJ;AE29CE;EACE,kCAAA;AFz9CJ;AE49CE;EACE,kCAAA;AF19CJ;AE69CE;EACE,mCAAA;AF39CJ;AE89CE;EACE,mCAAA;AF59CJ;AE+9CE;EACE,mCAAA;AF79CJ;AEg+CE;EACE,mCAAA;AF99CJ;AEi+CE;EACE,mCAAA;AF/9CJ;AEk+CE;EACE,mCAAA;AFh+CJ;AEm+CE;EACE,mCAAA;AFj+CJ;AEo+CE;EACE,mCAAA;AFl+CJ;AEq+CE;EACE,mCAAA;AFn+CJ;AEs+CE;EACE,kCAAA;AFp+CJ;AEu+CE;EACE,mCAAA;AFr+CJ;AEw+CE;EACE,mCAAA;AFt+CJ;AEy+CE;EACE,mCAAA;AFv+CJ;AE0+CE;EACE,mCAAA;AFx+CJ;AE2+CE;EACE,mCAAA;AFz+CJ;AE4+CE;EACE,mCAAA;AF1+CJ;AE6+CE;EACE,mCAAA;AF3+CJ;AE8+CE;EACE,mCAAA;AF5+CJ;AE++CE;EACE,mCAAA;AF7+CJ;AEg/CE;EACE,kCAAA;AF9+CJ;AEi/CE;EACE,mCAAA;AF/+CJ;AEk/CE;EACE,mCAAA;AFh/CJ;AEm/CE;EACE,mCAAA;AFj/CJ;AEo/CE;EACE,mCAAA;AFl/CJ;AEq/CE;EACE,mCAAA;AFn/CJ;AEs/CE;EACE,mCAAA;AFp/CJ;AEu/CE;EACE,mCAAA;AFr/CJ;AEw/CE;EACE,mCAAA;AFt/CJ;AEy/CE;EACE,mCAAA;AFv/CJ;AE0/CE;EACE,kCAAA;AFx/CJ;AE2/CE;EACE,mCAAA;AFz/CJ;AE4/CE;EACE,mCAAA;AF1/CJ;AE6/CE;EACE,mCAAA;AF3/CJ;AE8/CE;EACE,mCAAA;AF5/CJ;AE+/CE;EACE,mCAAA;AF7/CJ;AEggDE;EACE,mCAAA;AF9/CJ;AEigDE;EACE,mCAAA;AF//CJ;AEkgDE;EACE,mCAAA;AFhgDJ;AEmgDE;EACE,mCAAA;AFjgDJ;AEogDE;EACE,gCAAA;AFlgDJ;AEqgDE;EACE,iCAAA;AFngDJ;AEsgDE;EACE,iCAAA;AFpgDJ;AEugDE;EACE,iCAAA;AFrgDJ;AEwgDE;EACE,iCAAA;AFtgDJ;AEygDE;EACE,iCAAA;AFvgDJ;AE0gDE;EACE,iCAAA;AFxgDJ;AE2gDE;EACE,iCAAA;AFzgDJ;AE4gDE;EACE,iCAAA;AF1gDJ;AE6gDE;EACE,iCAAA;AF3gDJ;AE8gDE;EACE,gCAAA;AF5gDJ;AE+gDE;EACE,iCAAA;AF7gDJ;AEghDE;EACE,iCAAA;AF9gDJ;AEihDE;EACE,iCAAA;AF/gDJ;AEkhDE;EACE,iCAAA;AFhhDJ;AEmhDE;EACE,iCAAA;AFjhDJ;AEohDE;EACE,iCAAA;AFlhDJ;AEqhDE;EACE,iCAAA;AFnhDJ;AEshDE;EACE,iCAAA;AFphDJ;AEuhDE;EACE,iCAAA;AFrhDJ;AEwhDE;EACE,gCAAA;AFthDJ;AEyhDE;EACE,iCAAA;AFvhDJ;AE0hDE;EACE,iCAAA;AFxhDJ;AE2hDE;EACE,iCAAA;AFzhDJ;AE4hDE;EACE,iCAAA;AF1hDJ;AE6hDE;EACE,iCAAA;AF3hDJ;AE8hDE;EACE,iCAAA;AF5hDJ;AE+hDE;EACE,iCAAA;AF7hDJ;AEgiDE;EACE,iCAAA;AF9hDJ;AEiiDE;EACE,iCAAA;AF/hDJ;AEkiDE;EACE,gCAAA;AFhiDJ;AEmiDE;EACE,iCAAA;AFjiDJ;AEoiDE;EACE,iCAAA;AFliDJ;AEqiDE;EACE,iCAAA;AFniDJ;AEsiDE;EACE,iCAAA;AFpiDJ;AEuiDE;EACE,iCAAA;AFriDJ;AEwiDE;EACE,iCAAA;AFtiDJ;AEyiDE;EACE,iCAAA;AFviDJ;AE0iDE;EACE,iCAAA;AFxiDJ;AE2iDE;EACE,iCAAA;AFziDJ;AE4iDE;EACE,gCAAA;AF1iDJ;AE6iDE;EACE,iCAAA;AF3iDJ;AE8iDE;EACE,iCAAA;AF5iDJ;AE+iDE;EACE,iCAAA;AF7iDJ;AEgjDE;EACE,iCAAA;AF9iDJ;AEijDE;EACE,iCAAA;AF/iDJ;AEkjDE;EACE,iCAAA;AFhjDJ;AEmjDE;EACE,iCAAA;AFjjDJ;AEojDE;EACE,iCAAA;AFljDJ;AEqjDE;EACE,iCAAA;AFnjDJ;AEsjDE;EACE,gCAAA;AFpjDJ;AEujDE;EACE,iCAAA;AFrjDJ;AEwjDE;EACE,iCAAA;AFtjDJ;AEyjDE;EACE,iCAAA;AFvjDJ;AE0jDE;EACE,iCAAA;AFxjDJ;AE2jDE;EACE,iCAAA;AFzjDJ;AE4jDE;EACE,iCAAA;AF1jDJ;AE6jDE;EACE,iCAAA;AF3jDJ;AE8jDE;EACE,iCAAA;AF5jDJ;AE+jDE;EACE,iCAAA;AF7jDJ;AEgkDE;EACE,gCAAA;AF9jDJ;AEikDE;EACE,iCAAA;AF/jDJ;AEkkDE;EACE,iCAAA;AFhkDJ;AEmkDE;EACE,iCAAA;AFjkDJ;AEokDE;EACE,iCAAA;AFlkDJ;AEqkDE;EACE,iCAAA;AFnkDJ;AEskDE;EACE,iCAAA;AFpkDJ;AEukDE;EACE,iCAAA;AFrkDJ;AEwkDE;EACE,iCAAA;AFtkDJ;AEykDE;EACE,iCAAA;AFvkDJ;AE0kDE;EACE,gCAAA;AFxkDJ;AE2kDE;EACE,iCAAA;AFzkDJ;AE4kDE;EACE,iCAAA;AF1kDJ;AE6kDE;EACE,iCAAA;AF3kDJ;AE8kDE;EACE,iCAAA;AF5kDJ;AE+kDE;EACE,iCAAA;AF7kDJ;AEglDE;EACE,iCAAA;AF9kDJ;AEilDE;EACE,iCAAA;AF/kDJ;AEklDE;EACE,iCAAA;AFhlDJ;AEmlDE;EACE,iCAAA;AFjlDJ;AEolDE;EACE,kCAAA;AFllDJ;AEqlDE;EACE,mCAAA;AFnlDJ;AEslDE;EACE,mCAAA;AFplDJ;AEulDE;EACE,mCAAA;AFrlDJ;AEwlDE;EACE,mCAAA;AFtlDJ;AEylDE;EACE,mCAAA;AFvlDJ;AE0lDE;EACE,mCAAA;AFxlDJ;AE2lDE;EACE,mCAAA;AFzlDJ;AE4lDE;EACE,mCAAA;AF1lDJ;AE6lDE;EACE,mCAAA;AF3lDJ;AE8lDE;EACE,kCAAA;AF5lDJ;AE+lDE;EACE,mCAAA;AF7lDJ;AEgmDE;EACE,mCAAA;AF9lDJ;AEimDE;EACE,mCAAA;AF/lDJ;AEkmDE;EACE,mCAAA;AFhmDJ;AEmmDE;EACE,mCAAA;AFjmDJ;AEomDE;EACE,mCAAA;AFlmDJ;AEqmDE;EACE,mCAAA;AFnmDJ;AEsmDE;EACE,mCAAA;AFpmDJ;AEumDE;EACE,mCAAA;AFrmDJ;AEwmDE;EACE,kCAAA;AFtmDJ;AEymDE;EACE,mCAAA;AFvmDJ;AE0mDE;EACE,mCAAA;AFxmDJ;AE2mDE;EACE,mCAAA;AFzmDJ;AE4mDE;EACE,mCAAA;AF1mDJ;AE6mDE;EACE,mCAAA;AF3mDJ;AE8mDE;EACE,mCAAA;AF5mDJ;AE+mDE;EACE,mCAAA;AF7mDJ;AEgnDE;EACE,mCAAA;AF9mDJ;AEinDE;EACE,mCAAA;AF/mDJ;AEknDE;EACE,kCAAA;AFhnDJ;AEmnDE;EACE,mCAAA;AFjnDJ;AEonDE;EACE,mCAAA;AFlnDJ;AEqnDE;EACE,mCAAA;AFnnDJ;AEsnDE;EACE,mCAAA;AFpnDJ;AEunDE;EACE,mCAAA;AFrnDJ;AEwnDE;EACE,mCAAA;AFtnDJ;AEynDE;EACE,mCAAA;AFvnDJ;AE0nDE;EACE,mCAAA;AFxnDJ;AE2nDE;EACE,mCAAA;AFznDJ;AE4nDE;EACE,gCAAA;AF1nDJ;AE6nDE;EACE,iCAAA;AF3nDJ;AE8nDE;EACE,iCAAA;AF5nDJ;AE+nDE;EACE,iCAAA;AF7nDJ;AEgoDE;EACE,iCAAA;AF9nDJ;AEioDE;EACE,iCAAA;AF/nDJ;AEkoDE;EACE,iCAAA;AFhoDJ;AEmoDE;EACE,iCAAA;AFjoDJ;AEooDE;EACE,iCAAA;AFloDJ;AEqoDE;EACE,iCAAA;AFnoDJ;AEsoDE;EACE,gCAAA;AFpoDJ;AEuoDE;EACE,iCAAA;AFroDJ;AEwoDE;EACE,iCAAA;AFtoDJ;AEyoDE;EACE,iCAAA;AFvoDJ;AE0oDE;EACE,iCAAA;AFxoDJ;AE2oDE;EACE,iCAAA;AFzoDJ;AE4oDE;EACE,iCAAA;AF1oDJ;AE6oDE;EACE,iCAAA;AF3oDJ;AE8oDE;EACE,iCAAA;AF5oDJ;AE+oDE;EACE,iCAAA;AF7oDJ;AEgpDE;EACE,gCAAA;AF9oDJ;AEipDE;EACE,iCAAA;AF/oDJ;AEkpDE;EACE,iCAAA;AFhpDJ;AEmpDE;EACE,iCAAA;AFjpDJ;AEopDE;EACE,iCAAA;AFlpDJ;AEqpDE;EACE,iCAAA;AFnpDJ;AEspDE;EACE,iCAAA;AFppDJ;AEupDE;EACE,iCAAA;AFrpDJ;AEwpDE;EACE,iCAAA;AFtpDJ;AEypDE;EACE,iCAAA;AFvpDJ;AE0pDE;EACE,gCAAA;AFxpDJ;AE2pDE;EACE,iCAAA;AFzpDJ;AE4pDE;EACE,iCAAA;AF1pDJ;AE6pDE;EACE,iCAAA;AF3pDJ;AE8pDE;EACE,iCAAA;AF5pDJ;AE+pDE;EACE,iCAAA;AF7pDJ;AEgqDE;EACE,iCAAA;AF9pDJ;AEiqDE;EACE,iCAAA;AF/pDJ;AEkqDE;EACE,iCAAA;AFhqDJ;AEmqDE;EACE,iCAAA;AFjqDJ;AEoqDE;EACE,kCAAA;AFlqDJ;AEqqDE;EACE,mCAAA;AFnqDJ;AEsqDE;EACE,mCAAA;AFpqDJ;AEuqDE;EACE,mCAAA;AFrqDJ;AEwqDE;EACE,mCAAA;AFtqDJ;AEyqDE;EACE,mCAAA;AFvqDJ;AE0qDE;EACE,mCAAA;AFxqDJ;AE2qDE;EACE,mCAAA;AFzqDJ;AE4qDE;EACE,mCAAA;AF1qDJ;AE6qDE;EACE,mCAAA;AF3qDJ;AE8qDE;EACE,kCAAA;AF5qDJ;AE+qDE;EACE,mCAAA;AF7qDJ;AEgrDE;EACE,mCAAA;AF9qDJ;AEirDE;EACE,mCAAA;AF/qDJ;AEkrDE;EACE,mCAAA;AFhrDJ;AEmrDE;EACE,mCAAA;AFjrDJ;AEorDE;EACE,mCAAA;AFlrDJ;AEqrDE;EACE,mCAAA;AFnrDJ;AEsrDE;EACE,mCAAA;AFprDJ;AEurDE;EACE,mCAAA;AFrrDJ;AEwrDE;EACE,kCAAA;AFtrDJ;AEyrDE;EACE,mCAAA;AFvrDJ;AE0rDE;EACE,mCAAA;AFxrDJ;AE2rDE;EACE,mCAAA;AFzrDJ;AE4rDE;EACE,mCAAA;AF1rDJ;AE6rDE;EACE,mCAAA;AF3rDJ;AE8rDE;EACE,mCAAA;AF5rDJ;AE+rDE;EACE,mCAAA;AF7rDJ;AEgsDE;EACE,mCAAA;AF9rDJ;AEisDE;EACE,mCAAA;AF/rDJ;AEksDE;EACE,kCAAA;AFhsDJ;AEmsDE;EACE,mCAAA;AFjsDJ;AEosDE;EACE,mCAAA;AFlsDJ;AEqsDE;EACE,mCAAA;AFnsDJ;AEssDE;EACE,mCAAA;AFpsDJ;AEusDE;EACE,mCAAA;AFrsDJ;AEwsDE;EACE,mCAAA;AFtsDJ;AEysDE;EACE,mCAAA;AFvsDJ;AE0sDE;EACE,mCAAA;AFxsDJ;AE2sDE;EACE,mCAAA;AFzsDJ;AE4sDE;EACE,oCAAA;AF1sDJ;AE6sDE;EACE,qCAAA;AF3sDJ;AE8sDE;EACE,qCAAA;AF5sDJ;AE+sDE;EACE,qCAAA;AF7sDJ;AEgtDE;EACE,qCAAA;AF9sDJ;AEitDE;EACE,qCAAA;AF/sDJ;AEktDE;EACE,qCAAA;AFhtDJ;AEmtDE;EACE,qCAAA;AFjtDJ;AEotDE;EACE,qCAAA;AFltDJ;AEqtDE;EACE,qCAAA;AFntDJ;AEstDE;EACE,oCAAA;AFptDJ;AEutDE;EACE,qCAAA;AFrtDJ;AEwtDE;EACE,qCAAA;AFttDJ;AEytDE;EACE,qCAAA;AFvtDJ;AE0tDE;EACE,qCAAA;AFxtDJ;AE2tDE;EACE,qCAAA;AFztDJ;AE4tDE;EACE,qCAAA;AF1tDJ;AE6tDE;EACE,qCAAA;AF3tDJ;AE8tDE;EACE,qCAAA;AF5tDJ;AE+tDE;EACE,qCAAA;AF7tDJ;AEguDE;EACE,oCAAA;AF9tDJ;AEiuDE;EACE,qCAAA;AF/tDJ;AEkuDE;EACE,qCAAA;AFhuDJ;AEmuDE;EACE,qCAAA;AFjuDJ;AEouDE;EACE,qCAAA;AFluDJ;AEquDE;EACE,qCAAA;AFnuDJ;AEsuDE;EACE,qCAAA;AFpuDJ;AEuuDE;EACE,qCAAA;AFruDJ;AEwuDE;EACE,qCAAA;AFtuDJ;AEyuDE;EACE,qCAAA;AFvuDJ;AE0uDE;EACE,oCAAA;AFxuDJ;AE2uDE;EACE,qCAAA;AFzuDJ;AE4uDE;EACE,qCAAA;AF1uDJ;AE6uDE;EACE,qCAAA;AF3uDJ;AE8uDE;EACE,qCAAA;AF5uDJ;AE+uDE;EACE,qCAAA;AF7uDJ;AEgvDE;EACE,qCAAA;AF9uDJ;AEivDE;EACE,qCAAA;AF/uDJ;AEkvDE;EACE,qCAAA;AFhvDJ;AEmvDE;EACE,qCAAA;AFjvDJ;AEovDE;EACE,kCAAA;AFlvDJ;AEqvDE;EACE,mCAAA;AFnvDJ;AEsvDE;EACE,mCAAA;AFpvDJ;AEuvDE;EACE,mCAAA;AFrvDJ;AEwvDE;EACE,mCAAA;AFtvDJ;AEyvDE;EACE,mCAAA;AFvvDJ;AE0vDE;EACE,mCAAA;AFxvDJ;AE2vDE;EACE,mCAAA;AFzvDJ;AE4vDE;EACE,mCAAA;AF1vDJ;AE6vDE;EACE,mCAAA;AF3vDJ;AE8vDE;EACE,kCAAA;AF5vDJ;AE+vDE;EACE,mCAAA;AF7vDJ;AEgwDE;EACE,mCAAA;AF9vDJ;AEiwDE;EACE,mCAAA;AF/vDJ;AEkwDE;EACE,mCAAA;AFhwDJ;AEmwDE;EACE,mCAAA;AFjwDJ;AEowDE;EACE,mCAAA;AFlwDJ;AEqwDE;EACE,mCAAA;AFnwDJ;AEswDE;EACE,mCAAA;AFpwDJ;AEuwDE;EACE,mCAAA;AFrwDJ;AEwwDE;EACE,kCAAA;AFtwDJ;AEywDE;EACE,mCAAA;AFvwDJ;AE0wDE;EACE,mCAAA;AFxwDJ;AE2wDE;EACE,mCAAA;AFzwDJ;AE4wDE;EACE,mCAAA;AF1wDJ;AE6wDE;EACE,mCAAA;AF3wDJ;AE8wDE;EACE,mCAAA;AF5wDJ;AE+wDE;EACE,mCAAA;AF7wDJ;AEgxDE;EACE,mCAAA;AF9wDJ;AEixDE;EACE,mCAAA;AF/wDJ;AEkxDE;EACE,kCAAA;AFhxDJ;AEmxDE;EACE,mCAAA;AFjxDJ;AEoxDE;EACE,mCAAA;AFlxDJ;AEqxDE;EACE,mCAAA;AFnxDJ;AEsxDE;EACE,mCAAA;AFpxDJ;AEuxDE;EACE,mCAAA;AFrxDJ;AEwxDE;EACE,mCAAA;AFtxDJ;AEyxDE;EACE,mCAAA;AFvxDJ;AE0xDE;EACE,mCAAA;AFxxDJ;AE2xDE;EACE,mCAAA;AFzxDJ;AE4xDE;EACE,gCAAA;AF1xDJ;AE6xDE;EACE,iCAAA;AF3xDJ;AE8xDE;EACE,iCAAA;AF5xDJ;AE+xDE;EACE,iCAAA;AF7xDJ;AEgyDE;EACE,iCAAA;AF9xDJ;AEiyDE;EACE,iCAAA;AF/xDJ;AEkyDE;EACE,iCAAA;AFhyDJ;AEmyDE;EACE,iCAAA;AFjyDJ;AEoyDE;EACE,iCAAA;AFlyDJ;AEqyDE;EACE,iCAAA;AFnyDJ;AEsyDE;EACE,gCAAA;AFpyDJ;AEuyDE;EACE,iCAAA;AFryDJ;AEwyDE;EACE,iCAAA;AFtyDJ;AEyyDE;EACE,iCAAA;AFvyDJ;AE0yDE;EACE,iCAAA;AFxyDJ;AE2yDE;EACE,iCAAA;AFzyDJ;AE4yDE;EACE,iCAAA;AF1yDJ;AE6yDE;EACE,iCAAA;AF3yDJ;AE8yDE;EACE,iCAAA;AF5yDJ;AE+yDE;EACE,iCAAA;AF7yDJ;AEgzDE;EACE,gCAAA;AF9yDJ;AEizDE;EACE,iCAAA;AF/yDJ;AEkzDE;EACE,iCAAA;AFhzDJ;AEmzDE;EACE,iCAAA;AFjzDJ;AEozDE;EACE,iCAAA;AFlzDJ;AEqzDE;EACE,iCAAA;AFnzDJ;AEszDE;EACE,iCAAA;AFpzDJ;AEuzDE;EACE,iCAAA;AFrzDJ;AEwzDE;EACE,iCAAA;AFtzDJ;AEyzDE;EACE,iCAAA;AFvzDJ;AE0zDE;EACE,gCAAA;AFxzDJ;AE2zDE;EACE,iCAAA;AFzzDJ;AE4zDE;EACE,iCAAA;AF1zDJ;AE6zDE;EACE,iCAAA;AF3zDJ;AE8zDE;EACE,iCAAA;AF5zDJ;AE+zDE;EACE,iCAAA;AF7zDJ;AEg0DE;EACE,iCAAA;AF9zDJ;AEi0DE;EACE,iCAAA;AF/zDJ;AEk0DE;EACE,iCAAA;AFh0DJ;AEm0DE;EACE,iCAAA;AFj0DJ;AEo0DE;EACE,+BAAA;AFl0DJ;AEq0DE;EACE,gCAAA;AFn0DJ;AEs0DE;EACE,gCAAA;AFp0DJ;AEu0DE;EACE,gCAAA;AFr0DJ;AEw0DE;EACE,gCAAA;AFt0DJ;AEy0DE;EACE,gCAAA;AFv0DJ;AE00DE;EACE,gCAAA;AFx0DJ;AE20DE;EACE,gCAAA;AFz0DJ;AE40DE;EACE,gCAAA;AF10DJ;AE60DE;EACE,gCAAA;AF30DJ;AE80DE;EACE,+BAAA;AF50DJ;AE+0DE;EACE,gCAAA;AF70DJ;AEg1DE;EACE,gCAAA;AF90DJ;AEi1DE;EACE,gCAAA;AF/0DJ;AEk1DE;EACE,gCAAA;AFh1DJ;AEm1DE;EACE,gCAAA;AFj1DJ;AEo1DE;EACE,gCAAA;AFl1DJ;AEq1DE;EACE,gCAAA;AFn1DJ;AEs1DE;EACE,gCAAA;AFp1DJ;AEu1DE;EACE,gCAAA;AFr1DJ;AEw1DE;EACE,+BAAA;AFt1DJ;AEy1DE;EACE,gCAAA;AFv1DJ;AE01DE;EACE,gCAAA;AFx1DJ;AE21DE;EACE,gCAAA;AFz1DJ;AE41DE;EACE,gCAAA;AF11DJ;AE61DE;EACE,gCAAA;AF31DJ;AE81DE;EACE,gCAAA;AF51DJ;AE+1DE;EACE,gCAAA;AF71DJ;AEg2DE;EACE,gCAAA;AF91DJ;AEi2DE;EACE,gCAAA;AF/1DJ;AEk2DE;EACE,+BAAA;AFh2DJ;AEm2DE;EACE,gCAAA;AFj2DJ;AEo2DE;EACE,gCAAA;AFl2DJ;AEq2DE;EACE,gCAAA;AFn2DJ;AEs2DE;EACE,gCAAA;AFp2DJ;AEu2DE;EACE,gCAAA;AFr2DJ;AEw2DE;EACE,gCAAA;AFt2DJ;AEy2DE;EACE,gCAAA;AFv2DJ;AE02DE;EACE,gCAAA;AFx2DJ;AE22DE;EACE,gCAAA;AFz2DJ;AE42DE;EACE,mCAAA;AF12DJ;AE62DE;EACE,oCAAA;AF32DJ;AE82DE;EACE,oCAAA;AF52DJ;AE+2DE;EACE,oCAAA;AF72DJ;AEg3DE;EACE,oCAAA;AF92DJ;AEi3DE;EACE,oCAAA;AF/2DJ;AEk3DE;EACE,oCAAA;AFh3DJ;AEm3DE;EACE,oCAAA;AFj3DJ;AEo3DE;EACE,oCAAA;AFl3DJ;AEq3DE;EACE,oCAAA;AFn3DJ;AEs3DE;EACE,mCAAA;AFp3DJ;AEu3DE;EACE,oCAAA;AFr3DJ;AEw3DE;EACE,oCAAA;AFt3DJ;AEy3DE;EACE,oCAAA;AFv3DJ;AE03DE;EACE,oCAAA;AFx3DJ;AE23DE;EACE,oCAAA;AFz3DJ;AE43DE;EACE,oCAAA;AF13DJ;AE63DE;EACE,oCAAA;AF33DJ;AE83DE;EACE,oCAAA;AF53DJ;AE+3DE;EACE,oCAAA;AF73DJ;AEg4DE;EACE,mCAAA;AF93DJ;AEi4DE;EACE,oCAAA;AF/3DJ;AEk4DE;EACE,oCAAA;AFh4DJ;AEm4DE;EACE,oCAAA;AFj4DJ;AEo4DE;EACE,oCAAA;AFl4DJ;AEq4DE;EACE,oCAAA;AFn4DJ;AEs4DE;EACE,oCAAA;AFp4DJ;AEu4DE;EACE,oCAAA;AFr4DJ;AEw4DE;EACE,oCAAA;AFt4DJ;AEy4DE;EACE,oCAAA;AFv4DJ;AE04DE;EACE,mCAAA;AFx4DJ;AE24DE;EACE,oCAAA;AFz4DJ;AE44DE;EACE,oCAAA;AF14DJ;AE64DE;EACE,oCAAA;AF34DJ;AE84DE;EACE,oCAAA;AF54DJ;AE+4DE;EACE,oCAAA;AF74DJ;AEg5DE;EACE,oCAAA;AF94DJ;AEi5DE;EACE,oCAAA;AF/4DJ;AEk5DE;EACE,oCAAA;AFh5DJ;AEm5DE;EACE,oCAAA;AFj5DJ;AEo5DE;EACE,2CAAA;AFl5DJ;AEq5DE;EACE,4CAAA;AFn5DJ;AEs5DE;EACE,4CAAA;AFp5DJ;AEu5DE;EACE,4CAAA;AFr5DJ;AEw5DE;EACE,4CAAA;AFt5DJ;AEy5DE;EACE,4CAAA;AFv5DJ;AE05DE;EACE,4CAAA;AFx5DJ;AE25DE;EACE,4CAAA;AFz5DJ;AE45DE;EACE,4CAAA;AF15DJ;AE65DE;EACE,4CAAA;AF35DJ;AE85DE;EACE,2CAAA;AF55DJ;AE+5DE;EACE,4CAAA;AF75DJ;AEg6DE;EACE,4CAAA;AF95DJ;AEi6DE;EACE,4CAAA;AF/5DJ;AEk6DE;EACE,4CAAA;AFh6DJ;AEm6DE;EACE,4CAAA;AFj6DJ;AEo6DE;EACE,4CAAA;AFl6DJ;AEq6DE;EACE,4CAAA;AFn6DJ;AEs6DE;EACE,4CAAA;AFp6DJ;AEu6DE;EACE,4CAAA;AFr6DJ;AEw6DE;EACE,2CAAA;AFt6DJ;AEy6DE;EACE,4CAAA;AFv6DJ;AE06DE;EACE,4CAAA;AFx6DJ;AE26DE;EACE,4CAAA;AFz6DJ;AE46DE;EACE,4CAAA;AF16DJ;AE66DE;EACE,4CAAA;AF36DJ;AE86DE;EACE,4CAAA;AF56DJ;AE+6DE;EACE,4CAAA;AF76DJ;AEg7DE;EACE,4CAAA;AF96DJ;AEi7DE;EACE,4CAAA;AF/6DJ;AEk7DE;EACE,2CAAA;AFh7DJ;AEm7DE;EACE,4CAAA;AFj7DJ;AEo7DE;EACE,4CAAA;AFl7DJ;AEq7DE;EACE,4CAAA;AFn7DJ;AEs7DE;EACE,4CAAA;AFp7DJ;AEu7DE;EACE,4CAAA;AFr7DJ;AEw7DE;EACE,4CAAA;AFt7DJ;AEy7DE;EACE,4CAAA;AFv7DJ;AE07DE;EACE,4CAAA;AFx7DJ;AE27DE;EACE,4CAAA;AFz7DJ;AE47DE;EACE,4CAAA;AF17DJ;AE67DE;EACE,6CAAA;AF37DJ;AE87DE;EACE,6CAAA;AF57DJ;AE+7DE;EACE,6CAAA;AF77DJ;AEg8DE;EACE,6CAAA;AF97DJ;AEi8DE;EACE,6CAAA;AF/7DJ;AEk8DE;EACE,6CAAA;AFh8DJ;AEm8DE;EACE,6CAAA;AFj8DJ;AEo8DE;EACE,6CAAA;AFl8DJ;AEq8DE;EACE,6CAAA;AFn8DJ;AEs8DE;EACE,4CAAA;AFp8DJ;AEu8DE;EACE,6CAAA;AFr8DJ;AEw8DE;EACE,6CAAA;AFt8DJ;AEy8DE;EACE,6CAAA;AFv8DJ;AE08DE;EACE,6CAAA;AFx8DJ;AE28DE;EACE,6CAAA;AFz8DJ;AE48DE;EACE,6CAAA;AF18DJ;AE68DE;EACE,6CAAA;AF38DJ;AE88DE;EACE,6CAAA;AF58DJ;AE+8DE;EACE,6CAAA;AF78DJ;AEg9DE;EACE,4CAAA;AF98DJ;AEi9DE;EACE,6CAAA;AF/8DJ;AEk9DE;EACE,6CAAA;AFh9DJ;AEm9DE;EACE,6CAAA;AFj9DJ;AEo9DE;EACE,6CAAA;AFl9DJ;AEq9DE;EACE,6CAAA;AFn9DJ;AEs9DE;EACE,6CAAA;AFp9DJ;AEu9DE;EACE,6CAAA;AFr9DJ;AEw9DE;EACE,6CAAA;AFt9DJ;AEy9DE;EACE,6CAAA;AFv9DJ;AE09DE;EACE,4CAAA;AFx9DJ;AE29DE;EACE,6CAAA;AFz9DJ;AE49DE;EACE,6CAAA;AF19DJ;AE69DE;EACE,6CAAA;AF39DJ;AE89DE;EACE,6CAAA;AF59DJ;AE+9DE;EACE,6CAAA;AF79DJ;AEg+DE;EACE,6CAAA;AF99DJ;AEi+DE;EACE,6CAAA;AF/9DJ;AEk+DE;EACE,6CAAA;AFh+DJ;AEm+DE;EACE,6CAAA;AFj+DJ;AEo+DE;EACE,6CAAA;AFl+DJ;AEq+DE;EACE,8CAAA;AFn+DJ;AEs+DE;EACE,8CAAA;AFp+DJ;AEu+DE;EACE,8CAAA;AFr+DJ;AEw+DE;EACE,8CAAA;AFt+DJ;AEy+DE;EACE,8CAAA;AFv+DJ;AE0+DE;EACE,8CAAA;AFx+DJ;AE2+DE;EACE,8CAAA;AFz+DJ;AE4+DE;EACE,8CAAA;AF1+DJ;AE6+DE;EACE,8CAAA;AF3+DJ;AE8+DE;EACE,6CAAA;AF5+DJ;AE++DE;EACE,8CAAA;AF7+DJ;AEg/DE;EACE,8CAAA;AF9+DJ;AEi/DE;EACE,8CAAA;AF/+DJ;AEk/DE;EACE,8CAAA;AFh/DJ;AEm/DE;EACE,8CAAA;AFj/DJ;AEo/DE;EACE,8CAAA;AFl/DJ;AEq/DE;EACE,8CAAA;AFn/DJ;AEs/DE;EACE,8CAAA;AFp/DJ;AEu/DE;EACE,8CAAA;AFr/DJ;AEw/DE;EACE,6CAAA;AFt/DJ;AEy/DE;EACE,8CAAA;AFv/DJ;AE0/DE;EACE,8CAAA;AFx/DJ;AE2/DE;EACE,8CAAA;AFz/DJ;AE4/DE;EACE,8CAAA;AF1/DJ;AE6/DE;EACE,8CAAA;AF3/DJ;AE8/DE;EACE,8CAAA;AF5/DJ;AE+/DE;EACE,8CAAA;AF7/DJ;AEggEE;EACE,8CAAA;AF9/DJ;AEigEE;EACE,8CAAA;AF//DJ;AEkgEE;EACE,6CAAA;AFhgEJ;AEmgEE;EACE,8CAAA;AFjgEJ;AEogEE;EACE,8CAAA;AFlgEJ;AEqgEE;EACE,8CAAA;AFngEJ;AEsgEE;EACE,8CAAA;AFpgEJ;AEugEE;EACE,8CAAA;AFrgEJ;AEwgEE;EACE,8CAAA;AFtgEJ;AEygEE;EACE,8CAAA;AFvgEJ;AE0gEE;EACE,8CAAA;AFxgEJ;AE2gEE;EACE,8CAAA;AFzgEJ;AE4gEE;EACE,2CAAA;AF1gEJ;AE6gEE;EACE,4CAAA;AF3gEJ;AE8gEE;EACE,4CAAA;AF5gEJ;AE+gEE;EACE,4CAAA;AF7gEJ;AEghEE;EACE,4CAAA;AF9gEJ;AEihEE;EACE,4CAAA;AF/gEJ;AEkhEE;EACE,4CAAA;AFhhEJ;AEmhEE;EACE,4CAAA;AFjhEJ;AEohEE;EACE,4CAAA;AFlhEJ;AEqhEE;EACE,4CAAA;AFnhEJ;AEshEE;EACE,2CAAA;AFphEJ;AEuhEE;EACE,4CAAA;AFrhEJ;AEwhEE;EACE,4CAAA;AFthEJ;AEyhEE;EACE,4CAAA;AFvhEJ;AE0hEE;EACE,4CAAA;AFxhEJ;AE2hEE;EACE,4CAAA;AFzhEJ;AE4hEE;EACE,4CAAA;AF1hEJ;AE6hEE;EACE,4CAAA;AF3hEJ;AE8hEE;EACE,4CAAA;AF5hEJ;AE+hEE;EACE,4CAAA;AF7hEJ;AEgiEE;EACE,2CAAA;AF9hEJ;AEiiEE;EACE,4CAAA;AF/hEJ;AEkiEE;EACE,4CAAA;AFhiEJ;AEmiEE;EACE,4CAAA;AFjiEJ;AEoiEE;EACE,4CAAA;AFliEJ;AEqiEE;EACE,4CAAA;AFniEJ;AEsiEE;EACE,4CAAA;AFpiEJ;AEuiEE;EACE,4CAAA;AFriEJ;AEwiEE;EACE,4CAAA;AFtiEJ;AEyiEE;EACE,4CAAA;AFviEJ;AE0iEE;EACE,2CAAA;AFxiEJ;AE2iEE;EACE,4CAAA;AFziEJ;AE4iEE;EACE,4CAAA;AF1iEJ;AE6iEE;EACE,4CAAA;AF3iEJ;AE8iEE;EACE,4CAAA;AF5iEJ;AE+iEE;EACE,4CAAA;AF7iEJ;AEgjEE;EACE,4CAAA;AF9iEJ;AEijEE;EACE,4CAAA;AF/iEJ;AEkjEE;EACE,4CAAA;AFhjEJ;AEmjEE;EACE,4CAAA;AFjjEJ;AEojEE;EACE,2CAAA;AFljEJ;AEqjEE;EACE,4CAAA;AFnjEJ;AEsjEE;EACE,4CAAA;AFpjEJ;AEujEE;EACE,4CAAA;AFrjEJ;AEwjEE;EACE,4CAAA;AFtjEJ;AEyjEE;EACE,4CAAA;AFvjEJ;AE0jEE;EACE,4CAAA;AFxjEJ;AE2jEE;EACE,4CAAA;AFzjEJ;AE4jEE;EACE,4CAAA;AF1jEJ;AE6jEE;EACE,4CAAA;AF3jEJ;AE8jEE;EACE,2CAAA;AF5jEJ;AE+jEE;EACE,4CAAA;AF7jEJ;AEgkEE;EACE,4CAAA;AF9jEJ;AEikEE;EACE,4CAAA;AF/jEJ;AEkkEE;EACE,4CAAA;AFhkEJ;AEmkEE;EACE,4CAAA;AFjkEJ;AEokEE;EACE,4CAAA;AFlkEJ;AEqkEE;EACE,4CAAA;AFnkEJ;AEskEE;EACE,4CAAA;AFpkEJ;AEukEE;EACE,4CAAA;AFrkEJ;AEwkEE;EACE,2CAAA;AFtkEJ;AEykEE;EACE,4CAAA;AFvkEJ;AE0kEE;EACE,4CAAA;AFxkEJ;AE2kEE;EACE,4CAAA;AFzkEJ;AE4kEE;EACE,4CAAA;AF1kEJ;AE6kEE;EACE,4CAAA;AF3kEJ;AE8kEE;EACE,4CAAA;AF5kEJ;AE+kEE;EACE,4CAAA;AF7kEJ;AEglEE;EACE,4CAAA;AF9kEJ;AEilEE;EACE,4CAAA;AF/kEJ;AEklEE;EACE,2CAAA;AFhlEJ;AEmlEE;EACE,4CAAA;AFjlEJ;AEolEE;EACE,4CAAA;AFllEJ;AEqlEE;EACE,4CAAA;AFnlEJ;AEslEE;EACE,4CAAA;AFplEJ;AEulEE;EACE,4CAAA;AFrlEJ;AEwlEE;EACE,4CAAA;AFtlEJ;AEylEE;EACE,4CAAA;AFvlEJ;AE0lEE;EACE,4CAAA;AFxlEJ;AE2lEE;EACE,4CAAA;AFzlEJ;AE4lEE;EACE,6CAAA;AF1lEJ;AE6lEE;EACE,8CAAA;AF3lEJ;AE8lEE;EACE,8CAAA;AF5lEJ;AE+lEE;EACE,8CAAA;AF7lEJ;AEgmEE;EACE,8CAAA;AF9lEJ;AEimEE;EACE,8CAAA;AF/lEJ;AEkmEE;EACE,8CAAA;AFhmEJ;AEmmEE;EACE,8CAAA;AFjmEJ;AEomEE;EACE,8CAAA;AFlmEJ;AEqmEE;EACE,8CAAA;AFnmEJ;AEsmEE;EACE,6CAAA;AFpmEJ;AEumEE;EACE,8CAAA;AFrmEJ;AEwmEE;EACE,8CAAA;AFtmEJ;AEymEE;EACE,8CAAA;AFvmEJ;AE0mEE;EACE,8CAAA;AFxmEJ;AE2mEE;EACE,8CAAA;AFzmEJ;AE4mEE;EACE,8CAAA;AF1mEJ;AE6mEE;EACE,8CAAA;AF3mEJ;AE8mEE;EACE,8CAAA;AF5mEJ;AE+mEE;EACE,8CAAA;AF7mEJ;AEgnEE;EACE,6CAAA;AF9mEJ;AEinEE;EACE,8CAAA;AF/mEJ;AEknEE;EACE,8CAAA;AFhnEJ;AEmnEE;EACE,8CAAA;AFjnEJ;AEonEE;EACE,8CAAA;AFlnEJ;AEqnEE;EACE,8CAAA;AFnnEJ;AEsnEE;EACE,8CAAA;AFpnEJ;AEunEE;EACE,8CAAA;AFrnEJ;AEwnEE;EACE,8CAAA;AFtnEJ;AEynEE;EACE,8CAAA;AFvnEJ;AE0nEE;EACE,6CAAA;AFxnEJ;AE2nEE;EACE,8CAAA;AFznEJ;AE4nEE;EACE,8CAAA;AF1nEJ;AE6nEE;EACE,8CAAA;AF3nEJ;AE8nEE;EACE,8CAAA;AF5nEJ;AE+nEE;EACE,8CAAA;AF7nEJ;AEgoEE;EACE,8CAAA;AF9nEJ;AEioEE;EACE,8CAAA;AF/nEJ;AEkoEE;EACE,8CAAA;AFhoEJ;AEmoEE;EACE,8CAAA;AFjoEJ;AEooEE;EACE,2CAAA;AFloEJ;AEqoEE;EACE,4CAAA;AFnoEJ;AEsoEE;EACE,4CAAA;AFpoEJ;AEuoEE;EACE,4CAAA;AFroEJ;AEwoEE;EACE,4CAAA;AFtoEJ;AEyoEE;EACE,4CAAA;AFvoEJ;AE0oEE;EACE,4CAAA;AFxoEJ;AE2oEE;EACE,4CAAA;AFzoEJ;AE4oEE;EACE,4CAAA;AF1oEJ;AE6oEE;EACE,4CAAA;AF3oEJ;AE8oEE;EACE,2CAAA;AF5oEJ;AE+oEE;EACE,4CAAA;AF7oEJ;AEgpEE;EACE,4CAAA;AF9oEJ;AEipEE;EACE,4CAAA;AF/oEJ;AEkpEE;EACE,4CAAA;AFhpEJ;AEmpEE;EACE,4CAAA;AFjpEJ;AEopEE;EACE,4CAAA;AFlpEJ;AEqpEE;EACE,4CAAA;AFnpEJ;AEspEE;EACE,4CAAA;AFppEJ;AEupEE;EACE,4CAAA;AFrpEJ;AEwpEE;EACE,2CAAA;AFtpEJ;AEypEE;EACE,4CAAA;AFvpEJ;AE0pEE;EACE,4CAAA;AFxpEJ;AE2pEE;EACE,4CAAA;AFzpEJ;AE4pEE;EACE,4CAAA;AF1pEJ;AE6pEE;EACE,4CAAA;AF3pEJ;AE8pEE;EACE,4CAAA;AF5pEJ;AE+pEE;EACE,4CAAA;AF7pEJ;AEgqEE;EACE,4CAAA;AF9pEJ;AEiqEE;EACE,4CAAA;AF/pEJ;AEkqEE;EACE,2CAAA;AFhqEJ;AEmqEE;EACE,4CAAA;AFjqEJ;AEoqEE;EACE,4CAAA;AFlqEJ;AEqqEE;EACE,4CAAA;AFnqEJ;AEsqEE;EACE,4CAAA;AFpqEJ;AEuqEE;EACE,4CAAA;AFrqEJ;AEwqEE;EACE,4CAAA;AFtqEJ;AEyqEE;EACE,4CAAA;AFvqEJ;AE0qEE;EACE,4CAAA;AFxqEJ;AE2qEE;EACE,4CAAA;AFzqEJ;AE4qEE;EACE,6CAAA;AF1qEJ;AE6qEE;EACE,8CAAA;AF3qEJ;AE8qEE;EACE,8CAAA;AF5qEJ;AE+qEE;EACE,8CAAA;AF7qEJ;AEgrEE;EACE,8CAAA;AF9qEJ;AEirEE;EACE,8CAAA;AF/qEJ;AEkrEE;EACE,8CAAA;AFhrEJ;AEmrEE;EACE,8CAAA;AFjrEJ;AEorEE;EACE,8CAAA;AFlrEJ;AEqrEE;EACE,8CAAA;AFnrEJ;AEsrEE;EACE,6CAAA;AFprEJ;AEurEE;EACE,8CAAA;AFrrEJ;AEwrEE;EACE,8CAAA;AFtrEJ;AEyrEE;EACE,8CAAA;AFvrEJ;AE0rEE;EACE,8CAAA;AFxrEJ;AE2rEE;EACE,8CAAA;AFzrEJ;AE4rEE;EACE,8CAAA;AF1rEJ;AE6rEE;EACE,8CAAA;AF3rEJ;AE8rEE;EACE,8CAAA;AF5rEJ;AE+rEE;EACE,8CAAA;AF7rEJ;AEgsEE;EACE,6CAAA;AF9rEJ;AEisEE;EACE,8CAAA;AF/rEJ;AEksEE;EACE,8CAAA;AFhsEJ;AEmsEE;EACE,8CAAA;AFjsEJ;AEosEE;EACE,8CAAA;AFlsEJ;AEqsEE;EACE,8CAAA;AFnsEJ;AEssEE;EACE,8CAAA;AFpsEJ;AEusEE;EACE,8CAAA;AFrsEJ;AEwsEE;EACE,8CAAA;AFtsEJ;AEysEE;EACE,8CAAA;AFvsEJ;AE0sEE;EACE,6CAAA;AFxsEJ;AE2sEE;EACE,8CAAA;AFzsEJ;AE4sEE;EACE,8CAAA;AF1sEJ;AE6sEE;EACE,8CAAA;AF3sEJ;AE8sEE;EACE,8CAAA;AF5sEJ;AE+sEE;EACE,8CAAA;AF7sEJ;AEgtEE;EACE,8CAAA;AF9sEJ;AEitEE;EACE,8CAAA;AF/sEJ;AEktEE;EACE,8CAAA;AFhtEJ;AEmtEE;EACE,8CAAA;AFjtEJ;AEotEE;EACE,+CAAA;AFltEJ;AEqtEE;EACE,gDAAA;AFntEJ;AEstEE;EACE,gDAAA;AFptEJ;AEutEE;EACE,gDAAA;AFrtEJ;AEwtEE;EACE,gDAAA;AFttEJ;AEytEE;EACE,gDAAA;AFvtEJ;AE0tEE;EACE,gDAAA;AFxtEJ;AE2tEE;EACE,gDAAA;AFztEJ;AE4tEE;EACE,gDAAA;AF1tEJ;AE6tEE;EACE,gDAAA;AF3tEJ;AE8tEE;EACE,+CAAA;AF5tEJ;AE+tEE;EACE,gDAAA;AF7tEJ;AEguEE;EACE,gDAAA;AF9tEJ;AEiuEE;EACE,gDAAA;AF/tEJ;AEkuEE;EACE,gDAAA;AFhuEJ;AEmuEE;EACE,gDAAA;AFjuEJ;AEouEE;EACE,gDAAA;AFluEJ;AEquEE;EACE,gDAAA;AFnuEJ;AEsuEE;EACE,gDAAA;AFpuEJ;AEuuEE;EACE,gDAAA;AFruEJ;AEwuEE;EACE,+CAAA;AFtuEJ;AEyuEE;EACE,gDAAA;AFvuEJ;AE0uEE;EACE,gDAAA;AFxuEJ;AE2uEE;EACE,gDAAA;AFzuEJ;AE4uEE;EACE,gDAAA;AF1uEJ;AE6uEE;EACE,gDAAA;AF3uEJ;AE8uEE;EACE,gDAAA;AF5uEJ;AE+uEE;EACE,gDAAA;AF7uEJ;AEgvEE;EACE,gDAAA;AF9uEJ;AEivEE;EACE,gDAAA;AF/uEJ;AEkvEE;EACE,+CAAA;AFhvEJ;AEmvEE;EACE,gDAAA;AFjvEJ;AEovEE;EACE,gDAAA;AFlvEJ;AEqvEE;EACE,gDAAA;AFnvEJ;AEsvEE;EACE,gDAAA;AFpvEJ;AEuvEE;EACE,gDAAA;AFrvEJ;AEwvEE;EACE,gDAAA;AFtvEJ;AEyvEE;EACE,gDAAA;AFvvEJ;AE0vEE;EACE,gDAAA;AFxvEJ;AE2vEE;EACE,gDAAA;AFzvEJ;AE4vEE;EACE,6CAAA;AF1vEJ;AE6vEE;EACE,8CAAA;AF3vEJ;AE8vEE;EACE,8CAAA;AF5vEJ;AE+vEE;EACE,8CAAA;AF7vEJ;AEgwEE;EACE,8CAAA;AF9vEJ;AEiwEE;EACE,8CAAA;AF/vEJ;AEkwEE;EACE,8CAAA;AFhwEJ;AEmwEE;EACE,8CAAA;AFjwEJ;AEowEE;EACE,8CAAA;AFlwEJ;AEqwEE;EACE,8CAAA;AFnwEJ;AEswEE;EACE,6CAAA;AFpwEJ;AEuwEE;EACE,8CAAA;AFrwEJ;AEwwEE;EACE,8CAAA;AFtwEJ;AEywEE;EACE,8CAAA;AFvwEJ;AE0wEE;EACE,8CAAA;AFxwEJ;AE2wEE;EACE,8CAAA;AFzwEJ;AE4wEE;EACE,8CAAA;AF1wEJ;AE6wEE;EACE,8CAAA;AF3wEJ;AE8wEE;EACE,8CAAA;AF5wEJ;AE+wEE;EACE,8CAAA;AF7wEJ;AEgxEE;EACE,6CAAA;AF9wEJ;AEixEE;EACE,8CAAA;AF/wEJ;AEkxEE;EACE,8CAAA;AFhxEJ;AEmxEE;EACE,8CAAA;AFjxEJ;AEoxEE;EACE,8CAAA;AFlxEJ;AEqxEE;EACE,8CAAA;AFnxEJ;AEsxEE;EACE,8CAAA;AFpxEJ;AEuxEE;EACE,8CAAA;AFrxEJ;AEwxEE;EACE,8CAAA;AFtxEJ;AEyxEE;EACE,8CAAA;AFvxEJ;AE0xEE;EACE,6CAAA;AFxxEJ;AE2xEE;EACE,8CAAA;AFzxEJ;AE4xEE;EACE,8CAAA;AF1xEJ;AE6xEE;EACE,8CAAA;AF3xEJ;AE8xEE;EACE,8CAAA;AF5xEJ;AE+xEE;EACE,8CAAA;AF7xEJ;AEgyEE;EACE,8CAAA;AF9xEJ;AEiyEE;EACE,8CAAA;AF/xEJ;AEkyEE;EACE,8CAAA;AFhyEJ;AEmyEE;EACE,8CAAA;AFjyEJ;AEoyEE;EACE,2CAAA;AFlyEJ;AEqyEE;EACE,4CAAA;AFnyEJ;AEsyEE;EACE,4CAAA;AFpyEJ;AEuyEE;EACE,4CAAA;AFryEJ;AEwyEE;EACE,4CAAA;AFtyEJ;AEyyEE;EACE,4CAAA;AFvyEJ;AE0yEE;EACE,4CAAA;AFxyEJ;AE2yEE;EACE,4CAAA;AFzyEJ;AE4yEE;EACE,4CAAA;AF1yEJ;AE6yEE;EACE,4CAAA;AF3yEJ;AE8yEE;EACE,2CAAA;AF5yEJ;AE+yEE;EACE,4CAAA;AF7yEJ;AEgzEE;EACE,4CAAA;AF9yEJ;AEizEE;EACE,4CAAA;AF/yEJ;AEkzEE;EACE,4CAAA;AFhzEJ;AEmzEE;EACE,4CAAA;AFjzEJ;AEozEE;EACE,4CAAA;AFlzEJ;AEqzEE;EACE,4CAAA;AFnzEJ;AEszEE;EACE,4CAAA;AFpzEJ;AEuzEE;EACE,4CAAA;AFrzEJ;AEwzEE;EACE,2CAAA;AFtzEJ;AEyzEE;EACE,4CAAA;AFvzEJ;AE0zEE;EACE,4CAAA;AFxzEJ;AE2zEE;EACE,4CAAA;AFzzEJ;AE4zEE;EACE,4CAAA;AF1zEJ;AE6zEE;EACE,4CAAA;AF3zEJ;AE8zEE;EACE,4CAAA;AF5zEJ;AE+zEE;EACE,4CAAA;AF7zEJ;AEg0EE;EACE,4CAAA;AF9zEJ;AEi0EE;EACE,4CAAA;AF/zEJ;AEk0EE;EACE,2CAAA;AFh0EJ;AEm0EE;EACE,4CAAA;AFj0EJ;AEo0EE;EACE,4CAAA;AFl0EJ;AEq0EE;EACE,4CAAA;AFn0EJ;AEs0EE;EACE,4CAAA;AFp0EJ;AEu0EE;EACE,4CAAA;AFr0EJ;AEw0EE;EACE,4CAAA;AFt0EJ;AEy0EE;EACE,4CAAA;AFv0EJ;AE00EE;EACE,4CAAA;AFx0EJ;AE20EE;EACE,4CAAA;AFz0EJ;AE40EE;EACE,0CAAA;AF10EJ;AE60EE;EACE,2CAAA;AF30EJ;AE80EE;EACE,2CAAA;AF50EJ;AE+0EE;EACE,2CAAA;AF70EJ;AEg1EE;EACE,2CAAA;AF90EJ;AEi1EE;EACE,2CAAA;AF/0EJ;AEk1EE;EACE,2CAAA;AFh1EJ;AEm1EE;EACE,2CAAA;AFj1EJ;AEo1EE;EACE,2CAAA;AFl1EJ;AEq1EE;EACE,2CAAA;AFn1EJ;AEs1EE;EACE,0CAAA;AFp1EJ;AEu1EE;EACE,2CAAA;AFr1EJ;AEw1EE;EACE,2CAAA;AFt1EJ;AEy1EE;EACE,2CAAA;AFv1EJ;AE01EE;EACE,2CAAA;AFx1EJ;AE21EE;EACE,2CAAA;AFz1EJ;AE41EE;EACE,2CAAA;AF11EJ;AE61EE;EACE,2CAAA;AF31EJ;AE81EE;EACE,2CAAA;AF51EJ;AE+1EE;EACE,2CAAA;AF71EJ;AEg2EE;EACE,0CAAA;AF91EJ;AEi2EE;EACE,2CAAA;AF/1EJ;AEk2EE;EACE,2CAAA;AFh2EJ;AEm2EE;EACE,2CAAA;AFj2EJ;AEo2EE;EACE,2CAAA;AFl2EJ;AEq2EE;EACE,2CAAA;AFn2EJ;AEs2EE;EACE,2CAAA;AFp2EJ;AEu2EE;EACE,2CAAA;AFr2EJ;AEw2EE;EACE,2CAAA;AFt2EJ;AEy2EE;EACE,2CAAA;AFv2EJ;AE02EE;EACE,0CAAA;AFx2EJ;AE22EE;EACE,2CAAA;AFz2EJ;AE42EE;EACE,2CAAA;AF12EJ;AE62EE;EACE,2CAAA;AF32EJ;AE82EE;EACE,2CAAA;AF52EJ;AE+2EE;EACE,2CAAA;AF72EJ;AEg3EE;EACE,2CAAA;AF92EJ;AEi3EE;EACE,2CAAA;AF/2EJ;AEk3EE;EACE,2CAAA;AFh3EJ;AEm3EE;EACE,2CAAA;AFj3EJ;AEo3EE;EACE,8CAAA;AFl3EJ;AEq3EE;EACE,+CAAA;AFn3EJ;AEs3EE;EACE,+CAAA;AFp3EJ;AEu3EE;EACE,+CAAA;AFr3EJ;AEw3EE;EACE,+CAAA;AFt3EJ;AEy3EE;EACE,+CAAA;AFv3EJ;AE03EE;EACE,+CAAA;AFx3EJ;AE23EE;EACE,+CAAA;AFz3EJ;AE43EE;EACE,+CAAA;AF13EJ;AE63EE;EACE,+CAAA;AF33EJ;AE83EE;EACE,8CAAA;AF53EJ;AE+3EE;EACE,+CAAA;AF73EJ;AEg4EE;EACE,+CAAA;AF93EJ;AEi4EE;EACE,+CAAA;AF/3EJ;AEk4EE;EACE,+CAAA;AFh4EJ;AEm4EE;EACE,+CAAA;AFj4EJ;AEo4EE;EACE,+CAAA;AFl4EJ;AEq4EE;EACE,+CAAA;AFn4EJ;AEs4EE;EACE,+CAAA;AFp4EJ;AEu4EE;EACE,+CAAA;AFr4EJ;AEw4EE;EACE,8CAAA;AFt4EJ;AEy4EE;EACE,+CAAA;AFv4EJ;AE04EE;EACE,+CAAA;AFx4EJ;AE24EE;EACE,+CAAA;AFz4EJ;AE44EE;EACE,+CAAA;AF14EJ;AE64EE;EACE,+CAAA;AF34EJ;AE84EE;EACE,+CAAA;AF54EJ;AE+4EE;EACE,+CAAA;AF74EJ;AEg5EE;EACE,+CAAA;AF94EJ;AEi5EE;EACE,+CAAA;AF/4EJ;AEk5EE;EACE,8CAAA;AFh5EJ;AEm5EE;EACE,+CAAA;AFj5EJ;AEo5EE;EACE,+CAAA;AFl5EJ;AEq5EE;EACE,+CAAA;AFn5EJ;AEs5EE;EACE,+CAAA;AFp5EJ;AEu5EE;EACE,+CAAA;AFr5EJ;AEw5EE;EACE,+CAAA;AFt5EJ;AEy5EE;EACE,+CAAA;AFv5EJ;AE05EE;EACE,+CAAA;AFx5EJ;AE25EE;EACE,+CAAA;AFz5EJ;AE45EE;EACE,uCAAA;AF15EJ;AE65EE;EACE,wCAAA;AF35EJ;AE85EE;EACE,wCAAA;AF55EJ;AE+5EE;EACE,wCAAA;AF75EJ;AEg6EE;EACE,wCAAA;AF95EJ;AEi6EE;EACE,wCAAA;AF/5EJ;AEk6EE;EACE,wCAAA;AFh6EJ;AEm6EE;EACE,wCAAA;AFj6EJ;AEo6EE;EACE,wCAAA;AFl6EJ;AEq6EE;EACE,wCAAA;AFn6EJ;AEs6EE;EACE,uCAAA;AFp6EJ;AEu6EE;EACE,wCAAA;AFr6EJ;AEw6EE;EACE,wCAAA;AFt6EJ;AEy6EE;EACE,wCAAA;AFv6EJ;AE06EE;EACE,wCAAA;AFx6EJ;AE26EE;EACE,wCAAA;AFz6EJ;AE46EE;EACE,wCAAA;AF16EJ;AE66EE;EACE,wCAAA;AF36EJ;AE86EE;EACE,wCAAA;AF56EJ;AE+6EE;EACE,wCAAA;AF76EJ;AEg7EE;EACE,uCAAA;AF96EJ;AEi7EE;EACE,wCAAA;AF/6EJ;AEk7EE;EACE,wCAAA;AFh7EJ;AEm7EE;EACE,wCAAA;AFj7EJ;AEo7EE;EACE,wCAAA;AFl7EJ;AEq7EE;EACE,wCAAA;AFn7EJ;AEs7EE;EACE,wCAAA;AFp7EJ;AEu7EE;EACE,wCAAA;AFr7EJ;AEw7EE;EACE,wCAAA;AFt7EJ;AEy7EE;EACE,wCAAA;AFv7EJ;AE07EE;EACE,uCAAA;AFx7EJ;AE27EE;EACE,wCAAA;AFz7EJ;AE47EE;EACE,wCAAA;AF17EJ;AE67EE;EACE,wCAAA;AF37EJ;AE87EE;EACE,wCAAA;AF57EJ;AE+7EE;EACE,wCAAA;AF77EJ;AEg8EE;EACE,wCAAA;AF97EJ;AEi8EE;EACE,wCAAA;AF/7EJ;AEk8EE;EACE,wCAAA;AFh8EJ;AEm8EE;EACE,wCAAA;AFj8EJ;AEo8EE;EACE,wCAAA;AFl8EJ;AEq8EE;EACE,yCAAA;AFn8EJ;AEs8EE;EACE,yCAAA;AFp8EJ;AEu8EE;EACE,yCAAA;AFr8EJ;AEw8EE;EACE,yCAAA;AFt8EJ;AEy8EE;EACE,yCAAA;AFv8EJ;AE08EE;EACE,yCAAA;AFx8EJ;AE28EE;EACE,yCAAA;AFz8EJ;AE48EE;EACE,yCAAA;AF18EJ;AE68EE;EACE,yCAAA;AF38EJ;AE88EE;EACE,wCAAA;AF58EJ;AE+8EE;EACE,yCAAA;AF78EJ;AEg9EE;EACE,yCAAA;AF98EJ;AEi9EE;EACE,yCAAA;AF/8EJ;AEk9EE;EACE,yCAAA;AFh9EJ;AEm9EE;EACE,yCAAA;AFj9EJ;AEo9EE;EACE,yCAAA;AFl9EJ;AEq9EE;EACE,yCAAA;AFn9EJ;AEs9EE;EACE,yCAAA;AFp9EJ;AEu9EE;EACE,yCAAA;AFr9EJ;AEw9EE;EACE,wCAAA;AFt9EJ;AEy9EE;EACE,yCAAA;AFv9EJ;AE09EE;EACE,yCAAA;AFx9EJ;AE29EE;EACE,yCAAA;AFz9EJ;AE49EE;EACE,yCAAA;AF19EJ;AE69EE;EACE,yCAAA;AF39EJ;AE89EE;EACE,yCAAA;AF59EJ;AE+9EE;EACE,yCAAA;AF79EJ;AEg+EE;EACE,yCAAA;AF99EJ;AEi+EE;EACE,yCAAA;AF/9EJ;AEk+EE;EACE,wCAAA;AFh+EJ;AEm+EE;EACE,yCAAA;AFj+EJ;AEo+EE;EACE,yCAAA;AFl+EJ;AEq+EE;EACE,yCAAA;AFn+EJ;AEs+EE;EACE,yCAAA;AFp+EJ;AEu+EE;EACE,yCAAA;AFr+EJ;AEw+EE;EACE,yCAAA;AFt+EJ;AEy+EE;EACE,yCAAA;AFv+EJ;AE0+EE;EACE,yCAAA;AFx+EJ;AE2+EE;EACE,yCAAA;AFz+EJ;AE4+EE;EACE,yCAAA;AF1+EJ;AE6+EE;EACE,0CAAA;AF3+EJ;AE8+EE;EACE,0CAAA;AF5+EJ;AE++EE;EACE,0CAAA;AF7+EJ;AEg/EE;EACE,0CAAA;AF9+EJ;AEi/EE;EACE,0CAAA;AF/+EJ;AEk/EE;EACE,0CAAA;AFh/EJ;AEm/EE;EACE,0CAAA;AFj/EJ;AEo/EE;EACE,0CAAA;AFl/EJ;AEq/EE;EACE,0CAAA;AFn/EJ;AEs/EE;EACE,yCAAA;AFp/EJ;AEu/EE;EACE,0CAAA;AFr/EJ;AEw/EE;EACE,0CAAA;AFt/EJ;AEy/EE;EACE,0CAAA;AFv/EJ;AE0/EE;EACE,0CAAA;AFx/EJ;AE2/EE;EACE,0CAAA;AFz/EJ;AE4/EE;EACE,0CAAA;AF1/EJ;AE6/EE;EACE,0CAAA;AF3/EJ;AE8/EE;EACE,0CAAA;AF5/EJ;AE+/EE;EACE,0CAAA;AF7/EJ;AEggFE;EACE,yCAAA;AF9/EJ;AEigFE;EACE,0CAAA;AF//EJ;AEkgFE;EACE,0CAAA;AFhgFJ;AEmgFE;EACE,0CAAA;AFjgFJ;AEogFE;EACE,0CAAA;AFlgFJ;AEqgFE;EACE,0CAAA;AFngFJ;AEsgFE;EACE,0CAAA;AFpgFJ;AEugFE;EACE,0CAAA;AFrgFJ;AEwgFE;EACE,0CAAA;AFtgFJ;AEygFE;EACE,0CAAA;AFvgFJ;AE0gFE;EACE,yCAAA;AFxgFJ;AE2gFE;EACE,0CAAA;AFzgFJ;AE4gFE;EACE,0CAAA;AF1gFJ;AE6gFE;EACE,0CAAA;AF3gFJ;AE8gFE;EACE,0CAAA;AF5gFJ;AE+gFE;EACE,0CAAA;AF7gFJ;AEghFE;EACE,0CAAA;AF9gFJ;AEihFE;EACE,0CAAA;AF/gFJ;AEkhFE;EACE,0CAAA;AFhhFJ;AEmhFE;EACE,0CAAA;AFjhFJ;AEohFE;EACE,uCAAA;AFlhFJ;AEqhFE;EACE,wCAAA;AFnhFJ;AEshFE;EACE,wCAAA;AFphFJ;AEuhFE;EACE,wCAAA;AFrhFJ;AEwhFE;EACE,wCAAA;AFthFJ;AEyhFE;EACE,wCAAA;AFvhFJ;AE0hFE;EACE,wCAAA;AFxhFJ;AE2hFE;EACE,wCAAA;AFzhFJ;AE4hFE;EACE,wCAAA;AF1hFJ;AE6hFE;EACE,wCAAA;AF3hFJ;AE8hFE;EACE,uCAAA;AF5hFJ;AE+hFE;EACE,wCAAA;AF7hFJ;AEgiFE;EACE,wCAAA;AF9hFJ;AEiiFE;EACE,wCAAA;AF/hFJ;AEkiFE;EACE,wCAAA;AFhiFJ;AEmiFE;EACE,wCAAA;AFjiFJ;AEoiFE;EACE,wCAAA;AFliFJ;AEqiFE;EACE,wCAAA;AFniFJ;AEsiFE;EACE,wCAAA;AFpiFJ;AEuiFE;EACE,wCAAA;AFriFJ;AEwiFE;EACE,uCAAA;AFtiFJ;AEyiFE;EACE,wCAAA;AFviFJ;AE0iFE;EACE,wCAAA;AFxiFJ;AE2iFE;EACE,wCAAA;AFziFJ;AE4iFE;EACE,wCAAA;AF1iFJ;AE6iFE;EACE,wCAAA;AF3iFJ;AE8iFE;EACE,wCAAA;AF5iFJ;AE+iFE;EACE,wCAAA;AF7iFJ;AEgjFE;EACE,wCAAA;AF9iFJ;AEijFE;EACE,wCAAA;AF/iFJ;AEkjFE;EACE,uCAAA;AFhjFJ;AEmjFE;EACE,wCAAA;AFjjFJ;AEojFE;EACE,wCAAA;AFljFJ;AEqjFE;EACE,wCAAA;AFnjFJ;AEsjFE;EACE,wCAAA;AFpjFJ;AEujFE;EACE,wCAAA;AFrjFJ;AEwjFE;EACE,wCAAA;AFtjFJ;AEyjFE;EACE,wCAAA;AFvjFJ;AE0jFE;EACE,wCAAA;AFxjFJ;AE2jFE;EACE,wCAAA;AFzjFJ;AE4jFE;EACE,uCAAA;AF1jFJ;AE6jFE;EACE,wCAAA;AF3jFJ;AE8jFE;EACE,wCAAA;AF5jFJ;AE+jFE;EACE,wCAAA;AF7jFJ;AEgkFE;EACE,wCAAA;AF9jFJ;AEikFE;EACE,wCAAA;AF/jFJ;AEkkFE;EACE,wCAAA;AFhkFJ;AEmkFE;EACE,wCAAA;AFjkFJ;AEokFE;EACE,wCAAA;AFlkFJ;AEqkFE;EACE,wCAAA;AFnkFJ;AEskFE;EACE,uCAAA;AFpkFJ;AEukFE;EACE,wCAAA;AFrkFJ;AEwkFE;EACE,wCAAA;AFtkFJ;AEykFE;EACE,wCAAA;AFvkFJ;AE0kFE;EACE,wCAAA;AFxkFJ;AE2kFE;EACE,wCAAA;AFzkFJ;AE4kFE;EACE,wCAAA;AF1kFJ;AE6kFE;EACE,wCAAA;AF3kFJ;AE8kFE;EACE,wCAAA;AF5kFJ;AE+kFE;EACE,wCAAA;AF7kFJ;AEglFE;EACE,uCAAA;AF9kFJ;AEilFE;EACE,wCAAA;AF/kFJ;AEklFE;EACE,wCAAA;AFhlFJ;AEmlFE;EACE,wCAAA;AFjlFJ;AEolFE;EACE,wCAAA;AFllFJ;AEqlFE;EACE,wCAAA;AFnlFJ;AEslFE;EACE,wCAAA;AFplFJ;AEulFE;EACE,wCAAA;AFrlFJ;AEwlFE;EACE,wCAAA;AFtlFJ;AEylFE;EACE,wCAAA;AFvlFJ;AE0lFE;EACE,uCAAA;AFxlFJ;AE2lFE;EACE,wCAAA;AFzlFJ;AE4lFE;EACE,wCAAA;AF1lFJ;AE6lFE;EACE,wCAAA;AF3lFJ;AE8lFE;EACE,wCAAA;AF5lFJ;AE+lFE;EACE,wCAAA;AF7lFJ;AEgmFE;EACE,wCAAA;AF9lFJ;AEimFE;EACE,wCAAA;AF/lFJ;AEkmFE;EACE,wCAAA;AFhmFJ;AEmmFE;EACE,wCAAA;AFjmFJ;AEomFE;EACE,yCAAA;AFlmFJ;AEqmFE;EACE,0CAAA;AFnmFJ;AEsmFE;EACE,0CAAA;AFpmFJ;AEumFE;EACE,0CAAA;AFrmFJ;AEwmFE;EACE,0CAAA;AFtmFJ;AEymFE;EACE,0CAAA;AFvmFJ;AE0mFE;EACE,0CAAA;AFxmFJ;AE2mFE;EACE,0CAAA;AFzmFJ;AE4mFE;EACE,0CAAA;AF1mFJ;AE6mFE;EACE,0CAAA;AF3mFJ;AE8mFE;EACE,yCAAA;AF5mFJ;AE+mFE;EACE,0CAAA;AF7mFJ;AEgnFE;EACE,0CAAA;AF9mFJ;AEinFE;EACE,0CAAA;AF/mFJ;AEknFE;EACE,0CAAA;AFhnFJ;AEmnFE;EACE,0CAAA;AFjnFJ;AEonFE;EACE,0CAAA;AFlnFJ;AEqnFE;EACE,0CAAA;AFnnFJ;AEsnFE;EACE,0CAAA;AFpnFJ;AEunFE;EACE,0CAAA;AFrnFJ;AEwnFE;EACE,yCAAA;AFtnFJ;AEynFE;EACE,0CAAA;AFvnFJ;AE0nFE;EACE,0CAAA;AFxnFJ;AE2nFE;EACE,0CAAA;AFznFJ;AE4nFE;EACE,0CAAA;AF1nFJ;AE6nFE;EACE,0CAAA;AF3nFJ;AE8nFE;EACE,0CAAA;AF5nFJ;AE+nFE;EACE,0CAAA;AF7nFJ;AEgoFE;EACE,0CAAA;AF9nFJ;AEioFE;EACE,0CAAA;AF/nFJ;AEkoFE;EACE,yCAAA;AFhoFJ;AEmoFE;EACE,0CAAA;AFjoFJ;AEooFE;EACE,0CAAA;AFloFJ;AEqoFE;EACE,0CAAA;AFnoFJ;AEsoFE;EACE,0CAAA;AFpoFJ;AEuoFE;EACE,0CAAA;AFroFJ;AEwoFE;EACE,0CAAA;AFtoFJ;AEyoFE;EACE,0CAAA;AFvoFJ;AE0oFE;EACE,0CAAA;AFxoFJ;AE2oFE;EACE,0CAAA;AFzoFJ;AE4oFE;EACE,uCAAA;AF1oFJ;AE6oFE;EACE,wCAAA;AF3oFJ;AE8oFE;EACE,wCAAA;AF5oFJ;AE+oFE;EACE,wCAAA;AF7oFJ;AEgpFE;EACE,wCAAA;AF9oFJ;AEipFE;EACE,wCAAA;AF/oFJ;AEkpFE;EACE,wCAAA;AFhpFJ;AEmpFE;EACE,wCAAA;AFjpFJ;AEopFE;EACE,wCAAA;AFlpFJ;AEqpFE;EACE,wCAAA;AFnpFJ;AEspFE;EACE,uCAAA;AFppFJ;AEupFE;EACE,wCAAA;AFrpFJ;AEwpFE;EACE,wCAAA;AFtpFJ;AEypFE;EACE,wCAAA;AFvpFJ;AE0pFE;EACE,wCAAA;AFxpFJ;AE2pFE;EACE,wCAAA;AFzpFJ;AE4pFE;EACE,wCAAA;AF1pFJ;AE6pFE;EACE,wCAAA;AF3pFJ;AE8pFE;EACE,wCAAA;AF5pFJ;AE+pFE;EACE,wCAAA;AF7pFJ;AEgqFE;EACE,uCAAA;AF9pFJ;AEiqFE;EACE,wCAAA;AF/pFJ;AEkqFE;EACE,wCAAA;AFhqFJ;AEmqFE;EACE,wCAAA;AFjqFJ;AEoqFE;EACE,wCAAA;AFlqFJ;AEqqFE;EACE,wCAAA;AFnqFJ;AEsqFE;EACE,wCAAA;AFpqFJ;AEuqFE;EACE,wCAAA;AFrqFJ;AEwqFE;EACE,wCAAA;AFtqFJ;AEyqFE;EACE,wCAAA;AFvqFJ;AE0qFE;EACE,uCAAA;AFxqFJ;AE2qFE;EACE,wCAAA;AFzqFJ;AE4qFE;EACE,wCAAA;AF1qFJ;AE6qFE;EACE,wCAAA;AF3qFJ;AE8qFE;EACE,wCAAA;AF5qFJ;AE+qFE;EACE,wCAAA;AF7qFJ;AEgrFE;EACE,wCAAA;AF9qFJ;AEirFE;EACE,wCAAA;AF/qFJ;AEkrFE;EACE,wCAAA;AFhrFJ;AEmrFE;EACE,wCAAA;AFjrFJ;AEorFE;EACE,yCAAA;AFlrFJ;AEqrFE;EACE,0CAAA;AFnrFJ;AEsrFE;EACE,0CAAA;AFprFJ;AEurFE;EACE,0CAAA;AFrrFJ;AEwrFE;EACE,0CAAA;AFtrFJ;AEyrFE;EACE,0CAAA;AFvrFJ;AE0rFE;EACE,0CAAA;AFxrFJ;AE2rFE;EACE,0CAAA;AFzrFJ;AE4rFE;EACE,0CAAA;AF1rFJ;AE6rFE;EACE,0CAAA;AF3rFJ;AE8rFE;EACE,yCAAA;AF5rFJ;AE+rFE;EACE,0CAAA;AF7rFJ;AEgsFE;EACE,0CAAA;AF9rFJ;AEisFE;EACE,0CAAA;AF/rFJ;AEksFE;EACE,0CAAA;AFhsFJ;AEmsFE;EACE,0CAAA;AFjsFJ;AEosFE;EACE,0CAAA;AFlsFJ;AEqsFE;EACE,0CAAA;AFnsFJ;AEssFE;EACE,0CAAA;AFpsFJ;AEusFE;EACE,0CAAA;AFrsFJ;AEwsFE;EACE,yCAAA;AFtsFJ;AEysFE;EACE,0CAAA;AFvsFJ;AE0sFE;EACE,0CAAA;AFxsFJ;AE2sFE;EACE,0CAAA;AFzsFJ;AE4sFE;EACE,0CAAA;AF1sFJ;AE6sFE;EACE,0CAAA;AF3sFJ;AE8sFE;EACE,0CAAA;AF5sFJ;AE+sFE;EACE,0CAAA;AF7sFJ;AEgtFE;EACE,0CAAA;AF9sFJ;AEitFE;EACE,0CAAA;AF/sFJ;AEktFE;EACE,yCAAA;AFhtFJ;AEmtFE;EACE,0CAAA;AFjtFJ;AEotFE;EACE,0CAAA;AFltFJ;AEqtFE;EACE,0CAAA;AFntFJ;AEstFE;EACE,0CAAA;AFptFJ;AEutFE;EACE,0CAAA;AFrtFJ;AEwtFE;EACE,0CAAA;AFttFJ;AEytFE;EACE,0CAAA;AFvtFJ;AE0tFE;EACE,0CAAA;AFxtFJ;AE2tFE;EACE,0CAAA;AFztFJ;AE4tFE;EACE,2CAAA;AF1tFJ;AE6tFE;EACE,4CAAA;AF3tFJ;AE8tFE;EACE,4CAAA;AF5tFJ;AE+tFE;EACE,4CAAA;AF7tFJ;AEguFE;EACE,4CAAA;AF9tFJ;AEiuFE;EACE,4CAAA;AF/tFJ;AEkuFE;EACE,4CAAA;AFhuFJ;AEmuFE;EACE,4CAAA;AFjuFJ;AEouFE;EACE,4CAAA;AFluFJ;AEquFE;EACE,4CAAA;AFnuFJ;AEsuFE;EACE,2CAAA;AFpuFJ;AEuuFE;EACE,4CAAA;AFruFJ;AEwuFE;EACE,4CAAA;AFtuFJ;AEyuFE;EACE,4CAAA;AFvuFJ;AE0uFE;EACE,4CAAA;AFxuFJ;AE2uFE;EACE,4CAAA;AFzuFJ;AE4uFE;EACE,4CAAA;AF1uFJ;AE6uFE;EACE,4CAAA;AF3uFJ;AE8uFE;EACE,4CAAA;AF5uFJ;AE+uFE;EACE,4CAAA;AF7uFJ;AEgvFE;EACE,2CAAA;AF9uFJ;AEivFE;EACE,4CAAA;AF/uFJ;AEkvFE;EACE,4CAAA;AFhvFJ;AEmvFE;EACE,4CAAA;AFjvFJ;AEovFE;EACE,4CAAA;AFlvFJ;AEqvFE;EACE,4CAAA;AFnvFJ;AEsvFE;EACE,4CAAA;AFpvFJ;AEuvFE;EACE,4CAAA;AFrvFJ;AEwvFE;EACE,4CAAA;AFtvFJ;AEyvFE;EACE,4CAAA;AFvvFJ;AE0vFE;EACE,2CAAA;AFxvFJ;AE2vFE;EACE,4CAAA;AFzvFJ;AE4vFE;EACE,4CAAA;AF1vFJ;AE6vFE;EACE,4CAAA;AF3vFJ;AE8vFE;EACE,4CAAA;AF5vFJ;AE+vFE;EACE,4CAAA;AF7vFJ;AEgwFE;EACE,4CAAA;AF9vFJ;AEiwFE;EACE,4CAAA;AF/vFJ;AEkwFE;EACE,4CAAA;AFhwFJ;AEmwFE;EACE,4CAAA;AFjwFJ;AEowFE;EACE,yCAAA;AFlwFJ;AEqwFE;EACE,0CAAA;AFnwFJ;AEswFE;EACE,0CAAA;AFpwFJ;AEuwFE;EACE,0CAAA;AFrwFJ;AEwwFE;EACE,0CAAA;AFtwFJ;AEywFE;EACE,0CAAA;AFvwFJ;AE0wFE;EACE,0CAAA;AFxwFJ;AE2wFE;EACE,0CAAA;AFzwFJ;AE4wFE;EACE,0CAAA;AF1wFJ;AE6wFE;EACE,0CAAA;AF3wFJ;AE8wFE;EACE,yCAAA;AF5wFJ;AE+wFE;EACE,0CAAA;AF7wFJ;AEgxFE;EACE,0CAAA;AF9wFJ;AEixFE;EACE,0CAAA;AF/wFJ;AEkxFE;EACE,0CAAA;AFhxFJ;AEmxFE;EACE,0CAAA;AFjxFJ;AEoxFE;EACE,0CAAA;AFlxFJ;AEqxFE;EACE,0CAAA;AFnxFJ;AEsxFE;EACE,0CAAA;AFpxFJ;AEuxFE;EACE,0CAAA;AFrxFJ;AEwxFE;EACE,yCAAA;AFtxFJ;AEyxFE;EACE,0CAAA;AFvxFJ;AE0xFE;EACE,0CAAA;AFxxFJ;AE2xFE;EACE,0CAAA;AFzxFJ;AE4xFE;EACE,0CAAA;AF1xFJ;AE6xFE;EACE,0CAAA;AF3xFJ;AE8xFE;EACE,0CAAA;AF5xFJ;AE+xFE;EACE,0CAAA;AF7xFJ;AEgyFE;EACE,0CAAA;AF9xFJ;AEiyFE;EACE,0CAAA;AF/xFJ;AEkyFE;EACE,yCAAA;AFhyFJ;AEmyFE;EACE,0CAAA;AFjyFJ;AEoyFE;EACE,0CAAA;AFlyFJ;AEqyFE;EACE,0CAAA;AFnyFJ;AEsyFE;EACE,0CAAA;AFpyFJ;AEuyFE;EACE,0CAAA;AFryFJ;AEwyFE;EACE,0CAAA;AFtyFJ;AEyyFE;EACE,0CAAA;AFvyFJ;AE0yFE;EACE,0CAAA;AFxyFJ;AE2yFE;EACE,0CAAA;AFzyFJ;AE4yFE;EACE,uCAAA;AF1yFJ;AE6yFE;EACE,wCAAA;AF3yFJ;AE8yFE;EACE,wCAAA;AF5yFJ;AE+yFE;EACE,wCAAA;AF7yFJ;AEgzFE;EACE,wCAAA;AF9yFJ;AEizFE;EACE,wCAAA;AF/yFJ;AEkzFE;EACE,wCAAA;AFhzFJ;AEmzFE;EACE,wCAAA;AFjzFJ;AEozFE;EACE,wCAAA;AFlzFJ;AEqzFE;EACE,wCAAA;AFnzFJ;AEszFE;EACE,uCAAA;AFpzFJ;AEuzFE;EACE,wCAAA;AFrzFJ;AEwzFE;EACE,wCAAA;AFtzFJ;AEyzFE;EACE,wCAAA;AFvzFJ;AE0zFE;EACE,wCAAA;AFxzFJ;AE2zFE;EACE,wCAAA;AFzzFJ;AE4zFE;EACE,wCAAA;AF1zFJ;AE6zFE;EACE,wCAAA;AF3zFJ;AE8zFE;EACE,wCAAA;AF5zFJ;AE+zFE;EACE,wCAAA;AF7zFJ;AEg0FE;EACE,uCAAA;AF9zFJ;AEi0FE;EACE,wCAAA;AF/zFJ;AEk0FE;EACE,wCAAA;AFh0FJ;AEm0FE;EACE,wCAAA;AFj0FJ;AEo0FE;EACE,wCAAA;AFl0FJ;AEq0FE;EACE,wCAAA;AFn0FJ;AEs0FE;EACE,wCAAA;AFp0FJ;AEu0FE;EACE,wCAAA;AFr0FJ;AEw0FE;EACE,wCAAA;AFt0FJ;AEy0FE;EACE,wCAAA;AFv0FJ;AE00FE;EACE,uCAAA;AFx0FJ;AE20FE;EACE,wCAAA;AFz0FJ;AE40FE;EACE,wCAAA;AF10FJ;AE60FE;EACE,wCAAA;AF30FJ;AE80FE;EACE,wCAAA;AF50FJ;AE+0FE;EACE,wCAAA;AF70FJ;AEg1FE;EACE,wCAAA;AF90FJ;AEi1FE;EACE,wCAAA;AF/0FJ;AEk1FE;EACE,wCAAA;AFh1FJ;AEm1FE;EACE,wCAAA;AFj1FJ;AEo1FE;EACE,sCAAA;AFl1FJ;AEq1FE;EACE,uCAAA;AFn1FJ;AEs1FE;EACE,uCAAA;AFp1FJ;AEu1FE;EACE,uCAAA;AFr1FJ;AEw1FE;EACE,uCAAA;AFt1FJ;AEy1FE;EACE,uCAAA;AFv1FJ;AE01FE;EACE,uCAAA;AFx1FJ;AE21FE;EACE,uCAAA;AFz1FJ;AE41FE;EACE,uCAAA;AF11FJ;AE61FE;EACE,uCAAA;AF31FJ;AE81FE;EACE,sCAAA;AF51FJ;AE+1FE;EACE,uCAAA;AF71FJ;AEg2FE;EACE,uCAAA;AF91FJ;AEi2FE;EACE,uCAAA;AF/1FJ;AEk2FE;EACE,uCAAA;AFh2FJ;AEm2FE;EACE,uCAAA;AFj2FJ;AEo2FE;EACE,uCAAA;AFl2FJ;AEq2FE;EACE,uCAAA;AFn2FJ;AEs2FE;EACE,uCAAA;AFp2FJ;AEu2FE;EACE,uCAAA;AFr2FJ;AEw2FE;EACE,sCAAA;AFt2FJ;AEy2FE;EACE,uCAAA;AFv2FJ;AE02FE;EACE,uCAAA;AFx2FJ;AE22FE;EACE,uCAAA;AFz2FJ;AE42FE;EACE,uCAAA;AF12FJ;AE62FE;EACE,uCAAA;AF32FJ;AE82FE;EACE,uCAAA;AF52FJ;AE+2FE;EACE,uCAAA;AF72FJ;AEg3FE;EACE,uCAAA;AF92FJ;AEi3FE;EACE,uCAAA;AF/2FJ;AEk3FE;EACE,sCAAA;AFh3FJ;AEm3FE;EACE,uCAAA;AFj3FJ;AEo3FE;EACE,uCAAA;AFl3FJ;AEq3FE;EACE,uCAAA;AFn3FJ;AEs3FE;EACE,uCAAA;AFp3FJ;AEu3FE;EACE,uCAAA;AFr3FJ;AEw3FE;EACE,uCAAA;AFt3FJ;AEy3FE;EACE,uCAAA;AFv3FJ;AE03FE;EACE,uCAAA;AFx3FJ;AE23FE;EACE,uCAAA;AFz3FJ;AE43FE;EACE,0CAAA;AF13FJ;AE63FE;EACE,2CAAA;AF33FJ;AE83FE;EACE,2CAAA;AF53FJ;AE+3FE;EACE,2CAAA;AF73FJ;AEg4FE;EACE,2CAAA;AF93FJ;AEi4FE;EACE,2CAAA;AF/3FJ;AEk4FE;EACE,2CAAA;AFh4FJ;AEm4FE;EACE,2CAAA;AFj4FJ;AEo4FE;EACE,2CAAA;AFl4FJ;AEq4FE;EACE,2CAAA;AFn4FJ;AEs4FE;EACE,0CAAA;AFp4FJ;AEu4FE;EACE,2CAAA;AFr4FJ;AEw4FE;EACE,2CAAA;AFt4FJ;AEy4FE;EACE,2CAAA;AFv4FJ;AE04FE;EACE,2CAAA;AFx4FJ;AE24FE;EACE,2CAAA;AFz4FJ;AE44FE;EACE,2CAAA;AF14FJ;AE64FE;EACE,2CAAA;AF34FJ;AE84FE;EACE,2CAAA;AF54FJ;AE+4FE;EACE,2CAAA;AF74FJ;AEg5FE;EACE,0CAAA;AF94FJ;AEi5FE;EACE,2CAAA;AF/4FJ;AEk5FE;EACE,2CAAA;AFh5FJ;AEm5FE;EACE,2CAAA;AFj5FJ;AEo5FE;EACE,2CAAA;AFl5FJ;AEq5FE;EACE,2CAAA;AFn5FJ;AEs5FE;EACE,2CAAA;AFp5FJ;AEu5FE;EACE,2CAAA;AFr5FJ;AEw5FE;EACE,2CAAA;AFt5FJ;AEy5FE;EACE,2CAAA;AFv5FJ;AE05FE;EACE,0CAAA;AFx5FJ;AE25FE;EACE,2CAAA;AFz5FJ;AE45FE;EACE,2CAAA;AF15FJ;AE65FE;EACE,2CAAA;AF35FJ;AE85FE;EACE,2CAAA;AF55FJ;AE+5FE;EACE,2CAAA;AF75FJ;AEg6FE;EACE,2CAAA;AF95FJ;AEi6FE;EACE,2CAAA;AF/5FJ;AEk6FE;EACE,2CAAA;AFh6FJ;AEm6FE;EACE,2CAAA;AFj6FJ;AEo6FE;EACE,8DAAA;AFl6FJ;AEq6FE;EACE,qDAAA;AFn6FJ;AEs6FE;EACE,8DAAA;AFp6FJ;AEu6FE;EACE,qDAAA;AFr6FJ;AEw6FE;EACE,8DAAA;AFt6FJ;AEy6FE;EACE,qDAAA;AFv6FJ;AE06FE;EACE,8DAAA;AFx6FJ;AE26FE;EACE,qDAAA;AFz6FJ;AE46FE;EACE,8DAAA;AF16FJ;AE66FE;EACE,8DAAA;AF36FJ;AE86FE;EACE,qDAAA;AF56FJ;AE+6FE;EACE,8DAAA;AF76FJ;AEg7FE;EACE,qDAAA;AF96FJ;AEi7FE;EACE,8DAAA;AF/6FJ;AEk7FE;EACE,qDAAA;AFh7FJ;AEm7FE;EACE,8DAAA;AFj7FJ;AEo7FE;EACE,qDAAA;AFl7FJ;AEq7FE;EACE,8DAAA;AFn7FJ;AEs7FE;EACE,8DAAA;AFp7FJ;AEu7FE;EACE,qDAAA;AFr7FJ;AEw7FE;EACE,8DAAA;AFt7FJ;AEy7FE;EACE,qDAAA;AFv7FJ;AE07FE;EACE,8DAAA;AFx7FJ;AE27FE;EACE,qDAAA;AFz7FJ;AE47FE;EACE,8DAAA;AF17FJ;AE67FE;EACE,qDAAA;AF37FJ;AE87FE;EACE,8DAAA;AF57FJ;AE+7FE;EACE,8DAAA;AF77FJ;AEg8FE;EACE,qDAAA;AF97FJ;AEi8FE;EACE,8DAAA;AF/7FJ;AEk8FE;EACE,qDAAA;AFh8FJ;AEm8FE;EACE,8DAAA;AFj8FJ;AEo8FE;EACE,qDAAA;AFl8FJ;AEq8FE;EACE,8DAAA;AFn8FJ;AEs8FE;EACE,qDAAA;AFp8FJ;AEu8FE;EACE,8DAAA;AFr8FJ;AEw8FE;EACE,wDAAA;AFt8FJ;AEy8FE;EACE,+CAAA;AFv8FJ;AE08FE;EACE,wDAAA;AFx8FJ;AE28FE;EACE,+CAAA;AFz8FJ;AE48FE;EACE,wDAAA;AF18FJ;AE68FE;EACE,+CAAA;AF38FJ;AE88FE;EACE,wDAAA;AF58FJ;AE+8FE;EACE,+CAAA;AF78FJ;AEg9FE;EACE,wDAAA;AF98FJ;AEi9FE;EACE,wDAAA;AF/8FJ;AEk9FE;EACE,+CAAA;AFh9FJ;AEm9FE;EACE,wDAAA;AFj9FJ;AEo9FE;EACE,+CAAA;AFl9FJ;AEq9FE;EACE,wDAAA;AFn9FJ;AEs9FE;EACE,+CAAA;AFp9FJ;AEu9FE;EACE,wDAAA;AFr9FJ;AEw9FE;EACE,+CAAA;AFt9FJ;AEy9FE;EACE,wDAAA;AFv9FJ;AE09FE;EACE,wDAAA;AFx9FJ;AE29FE;EACE,+CAAA;AFz9FJ;AE49FE;EACE,wDAAA;AF19FJ;AE69FE;EACE,+CAAA;AF39FJ;AE89FE;EACE,wDAAA;AF59FJ;AE+9FE;EACE,+CAAA;AF79FJ;AEg+FE;EACE,wDAAA;AF99FJ;AEi+FE;EACE,+CAAA;AF/9FJ;AEk+FE;EACE,wDAAA;AFh+FJ;AEm+FE;EACE,wDAAA;AFj+FJ;AEo+FE;EACE,+CAAA;AFl+FJ;AEq+FE;EACE,wDAAA;AFn+FJ;AEs+FE;EACE,+CAAA;AFp+FJ;AEu+FE;EACE,wDAAA;AFr+FJ;AEw+FE;EACE,+CAAA;AFt+FJ;AEy+FE;EACE,wDAAA;AFv+FJ;AE0+FE;EACE,+CAAA;AFx+FJ;AE2+FE;EACE,wDAAA;AFz+FJ;AE4+FE;EACE,0DAAA;AF1+FJ;AE6+FE;EACE,iDAAA;AF3+FJ;AE8+FE;EACE,0DAAA;AF5+FJ;AE++FE;EACE,iDAAA;AF7+FJ;AEg/FE;EACE,0DAAA;AF9+FJ;AEi/FE;EACE,iDAAA;AF/+FJ;AEk/FE;EACE,0DAAA;AFh/FJ;AEm/FE;EACE,iDAAA;AFj/FJ;AEo/FE;EACE,0DAAA;AFl/FJ;AEq/FE;EACE,0DAAA;AFn/FJ;AEs/FE;EACE,iDAAA;AFp/FJ;AEu/FE;EACE,0DAAA;AFr/FJ;AEw/FE;EACE,iDAAA;AFt/FJ;AEy/FE;EACE,0DAAA;AFv/FJ;AE0/FE;EACE,iDAAA;AFx/FJ;AE2/FE;EACE,0DAAA;AFz/FJ;AE4/FE;EACE,iDAAA;AF1/FJ;AE6/FE;EACE,0DAAA;AF3/FJ;AE8/FE;EACE,0DAAA;AF5/FJ;AE+/FE;EACE,iDAAA;AF7/FJ;AEggGE;EACE,0DAAA;AF9/FJ;AEigGE;EACE,iDAAA;AF//FJ;AEkgGE;EACE,0DAAA;AFhgGJ;AEmgGE;EACE,iDAAA;AFjgGJ;AEogGE;EACE,0DAAA;AFlgGJ;AEqgGE;EACE,iDAAA;AFngGJ;AEsgGE;EACE,0DAAA;AFpgGJ;AEugGE;EACE,0DAAA;AFrgGJ;AEwgGE;EACE,iDAAA;AFtgGJ;AEygGE;EACE,0DAAA;AFvgGJ;AE0gGE;EACE,iDAAA;AFxgGJ;AE2gGE;EACE,0DAAA;AFzgGJ;AE4gGE;EACE,iDAAA;AF1gGJ;AE6gGE;EACE,0DAAA;AF3gGJ;AE8gGE;EACE,iDAAA;AF5gGJ;AE+gGE;EACE,0DAAA;AF7gGJ;AEghGE;EACE,oDAAA;AF9gGJ;AEihGE;EACE,2CAAA;AF/gGJ;AEkhGE;EACE,oDAAA;AFhhGJ;AEmhGE;EACE,2CAAA;AFjhGJ;AEohGE;EACE,oDAAA;AFlhGJ;AEqhGE;EACE,2CAAA;AFnhGJ;AEshGE;EACE,oDAAA;AFphGJ;AEuhGE;EACE,2CAAA;AFrhGJ;AEwhGE;EACE,oDAAA;AFthGJ;AEyhGE;EACE,oDAAA;AFvhGJ;AE0hGE;EACE,2CAAA;AFxhGJ;AE2hGE;EACE,oDAAA;AFzhGJ;AE4hGE;EACE,2CAAA;AF1hGJ;AE6hGE;EACE,oDAAA;AF3hGJ;AE8hGE;EACE,2CAAA;AF5hGJ;AE+hGE;EACE,oDAAA;AF7hGJ;AEgiGE;EACE,2CAAA;AF9hGJ;AEiiGE;EACE,oDAAA;AF/hGJ;AEkiGE;EACE,oDAAA;AFhiGJ;AEmiGE;EACE,2CAAA;AFjiGJ;AEoiGE;EACE,oDAAA;AFliGJ;AEqiGE;EACE,2CAAA;AFniGJ;AEsiGE;EACE,oDAAA;AFpiGJ;AEuiGE;EACE,2CAAA;AFriGJ;AEwiGE;EACE,oDAAA;AFtiGJ;AEyiGE;EACE,2CAAA;AFviGJ;AE0iGE;EACE,oDAAA;AFxiGJ;AE2iGE;EACE,oDAAA;AFziGJ;AE4iGE;EACE,2CAAA;AF1iGJ;AE6iGE;EACE,oDAAA;AF3iGJ;AE8iGE;EACE,2CAAA;AF5iGJ;AE+iGE;EACE,oDAAA;AF7iGJ;AEgjGE;EACE,2CAAA;AF9iGJ;AEijGE;EACE,oDAAA;AF/iGJ;AEkjGE;EACE,2CAAA;AFhjGJ;AEmjGE;EACE,oDAAA;AFjjGJ;AEojGE;EACE,mDAAA;AFljGJ;AEqjGE;EACE,0CAAA;AFnjGJ;AEsjGE;EACE,mDAAA;AFpjGJ;AEujGE;EACE,0CAAA;AFrjGJ;AEwjGE;EACE,mDAAA;AFtjGJ;AEyjGE;EACE,0CAAA;AFvjGJ;AE0jGE;EACE,mDAAA;AFxjGJ;AE2jGE;EACE,0CAAA;AFzjGJ;AE4jGE;EACE,mDAAA;AF1jGJ;AE6jGE;EACE,mDAAA;AF3jGJ;AE8jGE;EACE,0CAAA;AF5jGJ;AE+jGE;EACE,mDAAA;AF7jGJ;AEgkGE;EACE,0CAAA;AF9jGJ;AEikGE;EACE,mDAAA;AF/jGJ;AEkkGE;EACE,0CAAA;AFhkGJ;AEmkGE;EACE,mDAAA;AFjkGJ;AEokGE;EACE,0CAAA;AFlkGJ;AEqkGE;EACE,mDAAA;AFnkGJ;AEskGE;EACE,mDAAA;AFpkGJ;AEukGE;EACE,0CAAA;AFrkGJ;AEwkGE;EACE,mDAAA;AFtkGJ;AEykGE;EACE,0CAAA;AFvkGJ;AE0kGE;EACE,mDAAA;AFxkGJ;AE2kGE;EACE,0CAAA;AFzkGJ;AE4kGE;EACE,mDAAA;AF1kGJ;AE6kGE;EACE,0CAAA;AF3kGJ;AE8kGE;EACE,mDAAA;AF5kGJ;AE+kGE;EACE,mDAAA;AF7kGJ;AEglGE;EACE,0CAAA;AF9kGJ;AEilGE;EACE,mDAAA;AF/kGJ;AEklGE;EACE,0CAAA;AFhlGJ;AEmlGE;EACE,mDAAA;AFjlGJ;AEolGE;EACE,0CAAA;AFllGJ;AEqlGE;EACE,mDAAA;AFnlGJ;AEslGE;EACE,0CAAA;AFplGJ;AEulGE;EACE,mDAAA;AFrlGJ;AEwlGE;EACE,6CAAA;AFtlGJ;AEylGE;EACE,oCAAA;AFvlGJ;AE0lGE;EACE,6CAAA;AFxlGJ;AE2lGE;EACE,oCAAA;AFzlGJ;AE4lGE;EACE,6CAAA;AF1lGJ;AE6lGE;EACE,oCAAA;AF3lGJ;AE8lGE;EACE,6CAAA;AF5lGJ;AE+lGE;EACE,oCAAA;AF7lGJ;AEgmGE;EACE,6CAAA;AF9lGJ;AEimGE;EACE,6CAAA;AF/lGJ;AEkmGE;EACE,oCAAA;AFhmGJ;AEmmGE;EACE,6CAAA;AFjmGJ;AEomGE;EACE,oCAAA;AFlmGJ;AEqmGE;EACE,6CAAA;AFnmGJ;AEsmGE;EACE,oCAAA;AFpmGJ;AEumGE;EACE,6CAAA;AFrmGJ;AEwmGE;EACE,oCAAA;AFtmGJ;AEymGE;EACE,6CAAA;AFvmGJ;AE0mGE;EACE,6CAAA;AFxmGJ;AE2mGE;EACE,oCAAA;AFzmGJ;AE4mGE;EACE,6CAAA;AF1mGJ;AE6mGE;EACE,oCAAA;AF3mGJ;AE8mGE;EACE,6CAAA;AF5mGJ;AE+mGE;EACE,oCAAA;AF7mGJ;AEgnGE;EACE,6CAAA;AF9mGJ;AEinGE;EACE,oCAAA;AF/mGJ;AEknGE;EACE,6CAAA;AFhnGJ;AEmnGE;EACE,6CAAA;AFjnGJ;AEonGE;EACE,oCAAA;AFlnGJ;AEqnGE;EACE,6CAAA;AFnnGJ;AEsnGE;EACE,oCAAA;AFpnGJ;AEunGE;EACE,6CAAA;AFrnGJ;AEwnGE;EACE,oCAAA;AFtnGJ;AEynGE;EACE,6CAAA;AFvnGJ;AE0nGE;EACE,oCAAA;AFxnGJ;AE2nGE;EACE,6CAAA;AFznGJ;AE4nGE;EACE,sCAAA;AF1nGJ;AE6nGE;EACE,2CAAA;EACA,iDAAA;AF3nGJ;AE8nGE;EACE,sCAAA;EACA,sDAAA;AF5nGJ;AE+nGE;EACE,iCAAA;AF7nGJ;AEgoGE;EACE,6CAAA;AF9nGJ;AEioGE;EACE,sBAAA;AF/nGJ;AEkoGE;EACE,6BAAA;AFhoGJ;AEmoGE;EACE,mCAAA;AFjoGJ;AEooGE;EACE,6CAAA;AFloGJ;AEqoGE;EACE,kDAAA;AFnoGJ;AEsoGE;EACE,mDAAA;AFpoGJ;AEuoGE;EACE,gDAAA;AFroGJ;AEwoGE;EACE,2BAAA;AFtoGJ;AEyoGE;EACE,mDAAA;AFvoGJ;AE0oGE;EACE,iDAAA;AFxoGJ;AE2oGE;EACE,8CAAA;AFzoGJ;AE4oGE;EACE,sCAAA;AF1oGJ;AE6oGE;EACE,sCAAA;AF3oGJ;AE8oGE;EACE,2CAAA;EACA,iDAAA;AF5oGJ;AE+oGE;EACE,2CAAA;EACA,iDAAA;AF7oGJ;AEgpGE;EACE,sCAAA;EACA,sDAAA;AF9oGJ;AEipGE;EACE,sCAAA;EACA,sDAAA;AF/oGJ;AEkpGE;EACE,iCAAA;AFhpGJ;AEmpGE;EACE,iCAAA;AFjpGJ;AEopGE;EACE,6CAAA;AFlpGJ;AEqpGE;EACE,6CAAA;AFnpGJ;AEspGE;EACE,sBAAA;AFppGJ;AEupGE;EACE,sBAAA;AFrpGJ;AEwpGE;EACE,6BAAA;AFtpGJ;AEypGE;EACE,6BAAA;AFvpGJ;AE0pGE;EACE,mCAAA;AFxpGJ;AE2pGE;EACE,mCAAA;AFzpGJ;AE4pGE;EACE,6CAAA;AF1pGJ;AE6pGE;EACE,6CAAA;AF3pGJ;AE8pGE;EACE,kDAAA;AF5pGJ;AE+pGE;EACE,kDAAA;AF7pGJ;AEgqGE;EACE,mDAAA;AF9pGJ;AEiqGE;EACE,mDAAA;AF/pGJ;AEkqGE;EACE,gDAAA;AFhqGJ;AEmqGE;EACE,gDAAA;AFjqGJ;AEoqGE;EACE,mDAAA;AFlqGJ;AEqqGE;EACE,mDAAA;AFnqGJ;AEsqGE;EACE,iDAAA;AFpqGJ;AEuqGE;EACE,iDAAA;AFrqGJ;AEwqGE;EACE,8CAAA;AFtqGJ;AEyqGE;EACE,8CAAA;AFvqGJ;AE0qGE;EACE;IACE,sCAAA;EFxqGJ;EE2qGE;IACE,2CAAA;IACA,iDAAA;EFzqGJ;EE4qGE;IACE,sCAAA;IACA,sDAAA;EF1qGJ;EE6qGE;IACE,iCAAA;EF3qGJ;EE8qGE;IACE,6CAAA;EF5qGJ;EE+qGE;IACE,sBAAA;EF7qGJ;EEgrGE;IACE,6BAAA;EF9qGJ;EEirGE;IACE,mCAAA;EF/qGJ;EEkrGE;IACE,6CAAA;EFhrGJ;EEmrGE;IACE,kDAAA;EFjrGJ;EEorGE;IACE,mDAAA;EFlrGJ;EEqrGE;IACE,gDAAA;EFnrGJ;EEsrGE;IACE,mDAAA;EFprGJ;EEurGE;IACE,iDAAA;EFrrGJ;EEwrGE;IACE,8CAAA;EFtrGJ;EEyrGE;IACE,sCAAA;EFvrGJ;EE0rGE;IACE,sCAAA;EFxrGJ;EE2rGE;IACE,2CAAA;IACA,iDAAA;EFzrGJ;EE4rGE;IACE,2CAAA;IACA,iDAAA;EF1rGJ;EE6rGE;IACE,sCAAA;IACA,sDAAA;EF3rGJ;EE8rGE;IACE,sCAAA;IACA,sDAAA;EF5rGJ;EE+rGE;IACE,iCAAA;EF7rGJ;EEgsGE;IACE,iCAAA;EF9rGJ;EEisGE;IACE,6CAAA;EF/rGJ;EEksGE;IACE,6CAAA;EFhsGJ;EEmsGE;IACE,sBAAA;EFjsGJ;EEosGE;IACE,sBAAA;EFlsGJ;EEqsGE;IACE,6BAAA;EFnsGJ;EEssGE;IACE,6BAAA;EFpsGJ;EEusGE;IACE,mCAAA;EFrsGJ;EEwsGE;IACE,mCAAA;EFtsGJ;EEysGE;IACE,6CAAA;EFvsGJ;EE0sGE;IACE,6CAAA;EFxsGJ;EE2sGE;IACE,kDAAA;EFzsGJ;EE4sGE;IACE,kDAAA;EF1sGJ;EE6sGE;IACE,mDAAA;EF3sGJ;EE8sGE;IACE,mDAAA;EF5sGJ;EE+sGE;IACE,gDAAA;EF7sGJ;EEgtGE;IACE,gDAAA;EF9sGJ;EEitGE;IACE,mDAAA;EF/sGJ;EEktGE;IACE,mDAAA;EFhtGJ;EEmtGE;IACE,iDAAA;EFjtGJ;EEotGE;IACE,iDAAA;EFltGJ;EEqtGE;IACE,8CAAA;EFntGJ;EEstGE;IACE,8CAAA;EFptGJ;AACF;AEutGE;EACE;IACE,sCAAA;EFrtGJ;EEwtGE;IACE,2CAAA;IACA,iDAAA;EFttGJ;EEytGE;IACE,sCAAA;IACA,sDAAA;EFvtGJ;EE0tGE;IACE,iCAAA;EFxtGJ;EE2tGE;IACE,6CAAA;EFztGJ;EE4tGE;IACE,sBAAA;EF1tGJ;EE6tGE;IACE,6BAAA;EF3tGJ;EE8tGE;IACE,mCAAA;EF5tGJ;EE+tGE;IACE,6CAAA;EF7tGJ;EEguGE;IACE,kDAAA;EF9tGJ;EEiuGE;IACE,mDAAA;EF/tGJ;EEkuGE;IACE,gDAAA;EFhuGJ;EEmuGE;IACE,mDAAA;EFjuGJ;EEouGE;IACE,iDAAA;EFluGJ;EEquGE;IACE,8CAAA;EFnuGJ;EEsuGE;IACE,sCAAA;EFpuGJ;EEuuGE;IACE,sCAAA;EFruGJ;EEwuGE;IACE,2CAAA;IACA,iDAAA;EFtuGJ;EEyuGE;IACE,2CAAA;IACA,iDAAA;EFvuGJ;EE0uGE;IACE,sCAAA;IACA,sDAAA;EFxuGJ;EE2uGE;IACE,sCAAA;IACA,sDAAA;EFzuGJ;EE4uGE;IACE,iCAAA;EF1uGJ;EE6uGE;IACE,iCAAA;EF3uGJ;EE8uGE;IACE,6CAAA;EF5uGJ;EE+uGE;IACE,6CAAA;EF7uGJ;EEgvGE;IACE,sBAAA;EF9uGJ;EEivGE;IACE,sBAAA;EF/uGJ;EEkvGE;IACE,6BAAA;EFhvGJ;EEmvGE;IACE,6BAAA;EFjvGJ;EEovGE;IACE,mCAAA;EFlvGJ;EEqvGE;IACE,mCAAA;EFnvGJ;EEsvGE;IACE,6CAAA;EFpvGJ;EEuvGE;IACE,6CAAA;EFrvGJ;EEwvGE;IACE,kDAAA;EFtvGJ;EEyvGE;IACE,kDAAA;EFvvGJ;EE0vGE;IACE,mDAAA;EFxvGJ;EE2vGE;IACE,mDAAA;EFzvGJ;EE4vGE;IACE,gDAAA;EF1vGJ;EE6vGE;IACE,gDAAA;EF3vGJ;EE8vGE;IACE,mDAAA;EF5vGJ;EE+vGE;IACE,mDAAA;EF7vGJ;EEgwGE;IACE,iDAAA;EF9vGJ;EEiwGE;IACE,iDAAA;EF/vGJ;EEkwGE;IACE,8CAAA;EFhwGJ;EEmwGE;IACE,8CAAA;EFjwGJ;AACF;AEowGE;EACE;IACE,sCAAA;EFlwGJ;EEqwGE;IACE,2CAAA;IACA,iDAAA;EFnwGJ;EEswGE;IACE,sCAAA;IACA,sDAAA;EFpwGJ;EEuwGE;IACE,iCAAA;EFrwGJ;EEwwGE;IACE,6CAAA;EFtwGJ;EEywGE;IACE,sBAAA;EFvwGJ;EE0wGE;IACE,6BAAA;EFxwGJ;EE2wGE;IACE,mCAAA;EFzwGJ;EE4wGE;IACE,6CAAA;EF1wGJ;EE6wGE;IACE,kDAAA;EF3wGJ;EE8wGE;IACE,mDAAA;EF5wGJ;EE+wGE;IACE,gDAAA;EF7wGJ;EEgxGE;IACE,mDAAA;EF9wGJ;EEixGE;IACE,iDAAA;EF/wGJ;EEkxGE;IACE,8CAAA;EFhxGJ;EEmxGE;IACE,sCAAA;EFjxGJ;EEoxGE;IACE,sCAAA;EFlxGJ;EEqxGE;IACE,2CAAA;IACA,iDAAA;EFnxGJ;EEsxGE;IACE,2CAAA;IACA,iDAAA;EFpxGJ;EEuxGE;IACE,sCAAA;IACA,sDAAA;EFrxGJ;EEwxGE;IACE,sCAAA;IACA,sDAAA;EFtxGJ;EEyxGE;IACE,iCAAA;EFvxGJ;EE0xGE;IACE,iCAAA;EFxxGJ;EE2xGE;IACE,6CAAA;EFzxGJ;EE4xGE;IACE,6CAAA;EF1xGJ;EE6xGE;IACE,sBAAA;EF3xGJ;EE8xGE;IACE,sBAAA;EF5xGJ;EE+xGE;IACE,6BAAA;EF7xGJ;EEgyGE;IACE,6BAAA;EF9xGJ;EEiyGE;IACE,mCAAA;EF/xGJ;EEkyGE;IACE,mCAAA;EFhyGJ;EEmyGE;IACE,6CAAA;EFjyGJ;EEoyGE;IACE,6CAAA;EFlyGJ;EEqyGE;IACE,kDAAA;EFnyGJ;EEsyGE;IACE,kDAAA;EFpyGJ;EEuyGE;IACE,mDAAA;EFryGJ;EEwyGE;IACE,mDAAA;EFtyGJ;EEyyGE;IACE,gDAAA;EFvyGJ;EE0yGE;IACE,gDAAA;EFxyGJ;EE2yGE;IACE,mDAAA;EFzyGJ;EE4yGE;IACE,mDAAA;EF1yGJ;EE6yGE;IACE,iDAAA;EF3yGJ;EE8yGE;IACE,iDAAA;EF5yGJ;EE+yGE;IACE,8CAAA;EF7yGJ;EEgzGE;IACE,8CAAA;EF9yGJ;AACF;AEizGE;EACE;IACE,sCAAA;EF/yGJ;EEkzGE;IACE,2CAAA;IACA,iDAAA;EFhzGJ;EEmzGE;IACE,sCAAA;IACA,sDAAA;EFjzGJ;EEozGE;IACE,iCAAA;EFlzGJ;EEqzGE;IACE,6CAAA;EFnzGJ;EEszGE;IACE,sBAAA;EFpzGJ;EEuzGE;IACE,6BAAA;EFrzGJ;EEwzGE;IACE,mCAAA;EFtzGJ;EEyzGE;IACE,6CAAA;EFvzGJ;EE0zGE;IACE,kDAAA;EFxzGJ;EE2zGE;IACE,mDAAA;EFzzGJ;EE4zGE;IACE,gDAAA;EF1zGJ;EE6zGE;IACE,mDAAA;EF3zGJ;EE8zGE;IACE,iDAAA;EF5zGJ;EE+zGE;IACE,8CAAA;EF7zGJ;EEg0GE;IACE,sCAAA;EF9zGJ;EEi0GE;IACE,sCAAA;EF/zGJ;EEk0GE;IACE,2CAAA;IACA,iDAAA;EFh0GJ;EEm0GE;IACE,2CAAA;IACA,iDAAA;EFj0GJ;EEo0GE;IACE,sCAAA;IACA,sDAAA;EFl0GJ;EEq0GE;IACE,sCAAA;IACA,sDAAA;EFn0GJ;EEs0GE;IACE,iCAAA;EFp0GJ;EEu0GE;IACE,iCAAA;EFr0GJ;EEw0GE;IACE,6CAAA;EFt0GJ;EEy0GE;IACE,6CAAA;EFv0GJ;EE00GE;IACE,sBAAA;EFx0GJ;EE20GE;IACE,sBAAA;EFz0GJ;EE40GE;IACE,6BAAA;EF10GJ;EE60GE;IACE,6BAAA;EF30GJ;EE80GE;IACE,mCAAA;EF50GJ;EE+0GE;IACE,mCAAA;EF70GJ;EEg1GE;IACE,6CAAA;EF90GJ;EEi1GE;IACE,6CAAA;EF/0GJ;EEk1GE;IACE,kDAAA;EFh1GJ;EEm1GE;IACE,kDAAA;EFj1GJ;EEo1GE;IACE,mDAAA;EFl1GJ;EEq1GE;IACE,mDAAA;EFn1GJ;EEs1GE;IACE,gDAAA;EFp1GJ;EEu1GE;IACE,gDAAA;EFr1GJ;EEw1GE;IACE,mDAAA;EFt1GJ;EEy1GE;IACE,mDAAA;EFv1GJ;EE01GE;IACE,iDAAA;EFx1GJ;EE21GE;IACE,iDAAA;EFz1GJ;EE41GE;IACE,8CAAA;EF11GJ;EE61GE;IACE,8CAAA;EF31GJ;AACF;AE81GE;EACE,mBAAA;AF51GJ;AE+1GE;EACE,qBAAA;EACA,qBAAA;AF71GJ;AEg2GE;EACE,aAAA;EACA,mBAAA;AF91GJ;AEi2GE;EACE,mBAAA;AF/1GJ;AEk2GE;EACE,aAAA;AFh2GJ;AEm2GE;EACE,cAAA;EACA,iBAAA;AFj2GJ;AEo2GE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;AFl2GJ;AEq2GE;EACE,kBAAA;AFn2GJ;AEs2GE;EACE,oBAAA;EACA,gBAAA;AFp2GJ;AEu2GE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;AFr2GJ;AEw2GE;EACE,mBAAA;EACA,cAAA;AFt2GJ;AEy2GE;EACE,wBAAA;AFv2GJ;AE02GE;EACE,yBAAA;AFx2GJ;AE22GE;EACE,0BAAA;AFz2GJ;AE42GE;EACE,gCAAA;AF12GJ;AE62GE;EACE,wBAAA;AF32GJ;AE82GE;EACE,+BAAA;AF52GJ;AE+2GE;EACE,8BAAA;AF72GJ;AEg3GE;EACE;IACE,wBAAA;EF92GJ;EEi3GE;IACE,yBAAA;EF/2GJ;EEk3GE;IACE,0BAAA;EFh3GJ;EEm3GE;IACE,gCAAA;EFj3GJ;EEo3GE;IACE,wBAAA;EFl3GJ;EEq3GE;IACE,+BAAA;EFn3GJ;AACF;AEs3GE;EACE;IACE,wBAAA;EFp3GJ;EEu3GE;IACE,yBAAA;EFr3GJ;EEw3GE;IACE,0BAAA;EFt3GJ;EEy3GE;IACE,gCAAA;EFv3GJ;EE03GE;IACE,wBAAA;EFx3GJ;EE23GE;IACE,+BAAA;EFz3GJ;AACF;AE43GE;EACE;IACE,wBAAA;EF13GJ;EE63GE;IACE,yBAAA;EF33GJ;EE83GE;IACE,0BAAA;EF53GJ;EE+3GE;IACE,gCAAA;EF73GJ;EEg4GE;IACE,wBAAA;EF93GJ;EEi4GE;IACE,+BAAA;EF/3GJ;AACF;AEk4GE;EACE;IACE,wBAAA;EFh4GJ;EEm4GE;IACE,yBAAA;EFj4GJ;EEo4GE;IACE,0BAAA;EFl4GJ;EEq4GE;IACE,gCAAA;EFn4GJ;EEs4GE;IACE,wBAAA;EFp4GJ;EEu4GE;IACE,+BAAA;EFr4GJ;AACF;AEw4GE;EACE,6BAAA;AFt4GJ;AEy4GE;EACE,8BAAA;AFv4GJ;AE04GE;EACE,2BAAA;AFx4GJ;AE24GE;EACE,4BAAA;AFz4GJ;AE44GE;EACE;IACE,6BAAA;EF14GJ;EE64GE;IACE,8BAAA;EF34GJ;EE84GE;IACE,2BAAA;EF54GJ;EE+4GE;IACE,4BAAA;EF74GJ;AACF;AEg5GE;EACE;IACE,6BAAA;EF94GJ;EEi5GE;IACE,8BAAA;EF/4GJ;EEk5GE;IACE,2BAAA;EFh5GJ;EEm5GE;IACE,4BAAA;EFj5GJ;AACF;AEo5GE;EACE;IACE,6BAAA;EFl5GJ;EEq5GE;IACE,8BAAA;EFn5GJ;EEs5GE;IACE,2BAAA;EFp5GJ;EEu5GE;IACE,4BAAA;EFr5GJ;AACF;AEw5GE;EACE;IACE,6BAAA;EFt5GJ;EEy5GE;IACE,8BAAA;EFv5GJ;EE05GE;IACE,2BAAA;EFx5GJ;EE25GE;IACE,4BAAA;EFz5GJ;AACF;AE45GE;EACE,qCAAA;AF15GJ;AE65GE;EACE,wCAAA;AF35GJ;AE85GE;EACE,gCAAA;AF55GJ;AE+5GE;EACE,qCAAA;AF75GJ;AEg6GE;EACE,qCAAA;AF95GJ;AEi6GE;EACE,wCAAA;AF/5GJ;AEk6GE;EACE,wCAAA;AFh6GJ;AEm6GE;EACE,gCAAA;AFj6GJ;AEo6GE;EACE,gCAAA;AFl6GJ;AEq6GE;EACE,oCAAA;AFn6GJ;AEs6GE;EACE,oCAAA;AFp6GJ;AEu6GE;EACE,qCAAA;AFr6GJ;AEw6GE;EACE,8BAAA;AFt6GJ;AEy6GE;EACE,kCAAA;AFv6GJ;AE06GE;EACE;IACE,8BAAA;EFx6GJ;EE26GE;IACE,kCAAA;EFz6GJ;AACF;AE46GE;EACE;IACE,8BAAA;EF16GJ;EE66GE;IACE,kCAAA;EF36GJ;AACF;AE86GE;EACE;IACE,8BAAA;EF56GJ;EE+6GE;IACE,kCAAA;EF76GJ;AACF;AEg7GE;EACE;IACE,8BAAA;EF96GJ;EEi7GE;IACE,kCAAA;EF/6GJ;AACF;AEk7GE;EACE,2BAAA;AFh7GJ;AEm7GE;EACE,2BAAA;AFj7GJ;AEo7GE;EACE,2BAAA;AFl7GJ;AEq7GE;EACE,2BAAA;AFn7GJ;AEs7GE;EACE,2BAAA;AFp7GJ;AEu7GE;EACE;IACE,2BAAA;EFr7GJ;EEw7GE;IACE,2BAAA;EFt7GJ;EEy7GE;IACE,2BAAA;EFv7GJ;EE07GE;IACE,2BAAA;EFx7GJ;EE27GE;IACE,2BAAA;EFz7GJ;AACF;AE47GE;EACE;IACE,2BAAA;EF17GJ;EE67GE;IACE,2BAAA;EF37GJ;EE87GE;IACE,2BAAA;EF57GJ;EE+7GE;IACE,2BAAA;EF77GJ;EEg8GE;IACE,2BAAA;EF97GJ;AACF;AEi8GE;EACE;IACE,2BAAA;EF/7GJ;EEk8GE;IACE,2BAAA;EFh8GJ;EEm8GE;IACE,2BAAA;EFj8GJ;EEo8GE;IACE,2BAAA;EFl8GJ;EEq8GE;IACE,2BAAA;EFn8GJ;AACF;AEs8GE;EACE;IACE,2BAAA;EFp8GJ;EEu8GE;IACE,2BAAA;EFr8GJ;EEw8GE;IACE,2BAAA;EFt8GJ;EEy8GE;IACE,2BAAA;EFv8GJ;EE08GE;IACE,2BAAA;EFx8GJ;AACF;AE28GE;EACE,6BAAA;AFz8GJ;AE48GE;EACE,6BAAA;AF18GJ;AE68GE;EACE,8BAAA;AF38GJ;AE88GE;EACE,0BAAA;AF58GJ;AE+8GE;EACE,8BAAA;AF78GJ;AEg9GE;EACE,6BAAA;AF98GJ;AEi9GE;EACE,4BAAA;AF/8GJ;AEk9GE;EACE,6BAAA;AFh9GJ;AEm9GE;EACE,0BAAA;AFj9GJ;AEo9GE;EACE,4BAAA;AFl9GJ;AEq9GE;EACE,0BAAA;AFn9GJ;AEs9GE;EACE,0BAAA;AFp9GJ;AEu9GE;EACE,0BAAA;AFr9GJ;AEw9GE;EACE;IACE,6BAAA;EFt9GJ;EEy9GE;IACE,8BAAA;EFv9GJ;EE09GE;IACE,0BAAA;EFx9GJ;EE29GE;IACE,8BAAA;EFz9GJ;EE49GE;IACE,6BAAA;EF19GJ;EE69GE;IACE,4BAAA;EF39GJ;EE89GE;IACE,6BAAA;EF59GJ;EE+9GE;IACE,0BAAA;EF79GJ;EEg+GE;IACE,4BAAA;EF99GJ;EEi+GE;IACE,0BAAA;EF/9GJ;EEk+GE;IACE,0BAAA;EFh+GJ;EEm+GE;IACE,0BAAA;EFj+GJ;AACF;AEo+GE;EACE;IACE,6BAAA;EFl+GJ;EEq+GE;IACE,8BAAA;EFn+GJ;EEs+GE;IACE,0BAAA;EFp+GJ;EEu+GE;IACE,8BAAA;EFr+GJ;EEw+GE;IACE,6BAAA;EFt+GJ;EEy+GE;IACE,4BAAA;EFv+GJ;EE0+GE;IACE,6BAAA;EFx+GJ;EE2+GE;IACE,0BAAA;EFz+GJ;EE4+GE;IACE,4BAAA;EF1+GJ;EE6+GE;IACE,0BAAA;EF3+GJ;EE8+GE;IACE,0BAAA;EF5+GJ;EE++GE;IACE,0BAAA;EF7+GJ;AACF;AEg/GE;EACE;IACE,6BAAA;EF9+GJ;EEi/GE;IACE,8BAAA;EF/+GJ;EEk/GE;IACE,0BAAA;EFh/GJ;EEm/GE;IACE,8BAAA;EFj/GJ;EEo/GE;IACE,6BAAA;EFl/GJ;EEq/GE;IACE,4BAAA;EFn/GJ;EEs/GE;IACE,6BAAA;EFp/GJ;EEu/GE;IACE,0BAAA;EFr/GJ;EEw/GE;IACE,4BAAA;EFt/GJ;EEy/GE;IACE,0BAAA;EFv/GJ;EE0/GE;IACE,0BAAA;EFx/GJ;EE2/GE;IACE,0BAAA;EFz/GJ;AACF;AE4/GE;EACE;IACE,6BAAA;EF1/GJ;EE6/GE;IACE,8BAAA;EF3/GJ;EE8/GE;IACE,0BAAA;EF5/GJ;EE+/GE;IACE,8BAAA;EF7/GJ;EEggHE;IACE,6BAAA;EF9/GJ;EEigHE;IACE,4BAAA;EF//GJ;EEkgHE;IACE,6BAAA;EFhgHJ;EEmgHE;IACE,0BAAA;EFjgHJ;EEogHE;IACE,4BAAA;EFlgHJ;EEqgHE;IACE,0BAAA;EFngHJ;EEsgHE;IACE,0BAAA;EFpgHJ;EEugHE;IACE,0BAAA;EFrgHJ;AACF;AEwgHE;EACE,yBAAA;AFtgHJ;AEygHE;EACE,4BAAA;AFvgHJ;AE0gHE;EACE,2BAAA;AFxgHJ;AE2gHE;EACE,yBAAA;AFzgHJ;AE4gHE;EACE,8BAAA;AF1gHJ;AE6gHE;EACE,8BAAA;AF3gHJ;AE8gHE;EACE,mCAAA;AF5gHJ;AE+gHE;EACE,8BAAA;AF7gHJ;AEghHE;EACE,iCAAA;AF9gHJ;AEihHE;EACE,iCAAA;AF/gHJ;AEkhHE;EACE,mCAAA;AFhhHJ;AEmhHE;EACE,sCAAA;AFjhHJ;AEohHE;EACE,8BAAA;AFlhHJ;AEqhHE;EACE,gCAAA;AFnhHJ;AEshHE;EACE;IACE,mCAAA;EFphHJ;EEuhHE;IACE,8BAAA;EFrhHJ;EEwhHE;IACE,iCAAA;EFthHJ;EEyhHE;IACE,iCAAA;EFvhHJ;EE0hHE;IACE,mCAAA;EFxhHJ;EE2hHE;IACE,sCAAA;EFzhHJ;EE4hHE;IACE,8BAAA;EF1hHJ;EE6hHE;IACE,gCAAA;EF3hHJ;AACF;AE8hHE;EACE;IACE,mCAAA;EF5hHJ;EE+hHE;IACE,8BAAA;EF7hHJ;EEgiHE;IACE,iCAAA;EF9hHJ;EEiiHE;IACE,iCAAA;EF/hHJ;EEkiHE;IACE,mCAAA;EFhiHJ;EEmiHE;IACE,sCAAA;EFjiHJ;EEoiHE;IACE,8BAAA;EFliHJ;EEqiHE;IACE,gCAAA;EFniHJ;AACF;AEsiHE;EACE;IACE,mCAAA;EFpiHJ;EEuiHE;IACE,8BAAA;EFriHJ;EEwiHE;IACE,iCAAA;EFtiHJ;EEyiHE;IACE,iCAAA;EFviHJ;EE0iHE;IACE,mCAAA;EFxiHJ;EE2iHE;IACE,sCAAA;EFziHJ;EE4iHE;IACE,8BAAA;EF1iHJ;EE6iHE;IACE,gCAAA;EF3iHJ;AACF;AE8iHE;EACE;IACE,mCAAA;EF5iHJ;EE+iHE;IACE,8BAAA;EF7iHJ;EEgjHE;IACE,iCAAA;EF9iHJ;EEijHE;IACE,iCAAA;EF/iHJ;EEkjHE;IACE,mCAAA;EFhjHJ;EEmjHE;IACE,sCAAA;EFjjHJ;EEojHE;IACE,8BAAA;EFljHJ;EEqjHE;IACE,gCAAA;EFnjHJ;AACF;AEsjHE;EACE,8BAAA;AFpjHJ;AEujHE;EACE,sCAAA;AFrjHJ;AEwjHE;EACE,iCAAA;AFtjHJ;AEyjHE;EACE,yCAAA;AFvjHJ;AE0jHE;EACE;IACE,8BAAA;EFxjHJ;EE2jHE;IACE,sCAAA;EFzjHJ;EE4jHE;IACE,iCAAA;EF1jHJ;EE6jHE;IACE,yCAAA;EF3jHJ;AACF;AE8jHE;EACE;IACE,8BAAA;EF5jHJ;EE+jHE;IACE,sCAAA;EF7jHJ;EEgkHE;IACE,iCAAA;EF9jHJ;EEikHE;IACE,yCAAA;EF/jHJ;AACF;AEkkHE;EACE;IACE,8BAAA;EFhkHJ;EEmkHE;IACE,sCAAA;EFjkHJ;EEokHE;IACE,iCAAA;EFlkHJ;EEqkHE;IACE,yCAAA;EFnkHJ;AACF;AEskHE;EACE;IACE,8BAAA;EFpkHJ;EEukHE;IACE,sCAAA;EFrkHJ;EEwkHE;IACE,iCAAA;EFtkHJ;EEykHE;IACE,yCAAA;EFvkHJ;AACF;AE0kHE;EACE,0BAAA;AFxkHJ;AE2kHE;EACE,kCAAA;AFzkHJ;AE4kHE;EACE,4BAAA;AF1kHJ;AE6kHE;EACE;IACE,0BAAA;EF3kHJ;EE8kHE;IACE,kCAAA;EF5kHJ;EE+kHE;IACE,4BAAA;EF7kHJ;AACF;AEglHE;EACE;IACE,0BAAA;EF9kHJ;EEilHE;IACE,kCAAA;EF/kHJ;EEklHE;IACE,4BAAA;EFhlHJ;AACF;AEmlHE;EACE;IACE,0BAAA;EFjlHJ;EEolHE;IACE,kCAAA;EFllHJ;EEqlHE;IACE,4BAAA;EFnlHJ;AACF;AEslHE;EACE;IACE,0BAAA;EFplHJ;EEulHE;IACE,kCAAA;EFrlHJ;EEwlHE;IACE,4BAAA;EFtlHJ;AACF;AEylHE;EACE,sCAAA;AFvlHJ;AE0lHE;EACE,oCAAA;AFxlHJ;AE2lHE;EACE,kCAAA;AFzlHJ;AE4lHE;EACE,yCAAA;AF1lHJ;AE6lHE;EACE,wCAAA;AF3lHJ;AE8lHE;EACE,wCAAA;AF5lHJ;AE+lHE;EACE;IACE,sCAAA;EF7lHJ;EEgmHE;IACE,oCAAA;EF9lHJ;EEimHE;IACE,kCAAA;EF/lHJ;EEkmHE;IACE,yCAAA;EFhmHJ;EEmmHE;IACE,wCAAA;EFjmHJ;EEomHE;IACE,wCAAA;EFlmHJ;AACF;AEqmHE;EACE;IACE,sCAAA;EFnmHJ;EEsmHE;IACE,oCAAA;EFpmHJ;EEumHE;IACE,kCAAA;EFrmHJ;EEwmHE;IACE,yCAAA;EFtmHJ;EEymHE;IACE,wCAAA;EFvmHJ;EE0mHE;IACE,wCAAA;EFxmHJ;AACF;AE2mHE;EACE;IACE,sCAAA;EFzmHJ;EE4mHE;IACE,oCAAA;EF1mHJ;EE6mHE;IACE,kCAAA;EF3mHJ;EE8mHE;IACE,yCAAA;EF5mHJ;EE+mHE;IACE,wCAAA;EF7mHJ;EEgnHE;IACE,wCAAA;EF9mHJ;AACF;AEinHE;EACE;IACE,sCAAA;EF/mHJ;EEknHE;IACE,oCAAA;EFhnHJ;EEmnHE;IACE,kCAAA;EFjnHJ;EEonHE;IACE,yCAAA;EFlnHJ;EEqnHE;IACE,wCAAA;EFnnHJ;EEsnHE;IACE,wCAAA;EFpnHJ;AACF;AEunHE;EACE,oCAAA;AFrnHJ;AEwnHE;EACE,kCAAA;AFtnHJ;AEynHE;EACE,gCAAA;AFvnHJ;AE0nHE;EACE,uCAAA;AFxnHJ;AE2nHE;EACE,sCAAA;AFznHJ;AE4nHE;EACE,sCAAA;AF1nHJ;AE6nHE;EACE;IACE,oCAAA;EF3nHJ;EE8nHE;IACE,kCAAA;EF5nHJ;EE+nHE;IACE,gCAAA;EF7nHJ;EEgoHE;IACE,uCAAA;EF9nHJ;EEioHE;IACE,sCAAA;EF/nHJ;EEkoHE;IACE,sCAAA;EFhoHJ;AACF;AEmoHE;EACE;IACE,oCAAA;EFjoHJ;EEooHE;IACE,kCAAA;EFloHJ;EEqoHE;IACE,gCAAA;EFnoHJ;EEsoHE;IACE,uCAAA;EFpoHJ;EEuoHE;IACE,sCAAA;EFroHJ;EEwoHE;IACE,sCAAA;EFtoHJ;AACF;AEyoHE;EACE;IACE,oCAAA;EFvoHJ;EE0oHE;IACE,kCAAA;EFxoHJ;EE2oHE;IACE,gCAAA;EFzoHJ;EE4oHE;IACE,uCAAA;EF1oHJ;EE6oHE;IACE,sCAAA;EF3oHJ;EE8oHE;IACE,sCAAA;EF5oHJ;AACF;AE+oHE;EACE;IACE,oCAAA;EF7oHJ;EEgpHE;IACE,kCAAA;EF9oHJ;EEipHE;IACE,gCAAA;EF/oHJ;EEkpHE;IACE,uCAAA;EFhpHJ;EEmpHE;IACE,sCAAA;EFjpHJ;EEopHE;IACE,sCAAA;EFlpHJ;AACF;AEqpHE;EACE,+BAAA;AFnpHJ;AEspHE;EACE,kCAAA;AFppHJ;AEupHE;EACE,8BAAA;AFrpHJ;AEwpHE;EACE,gCAAA;AFtpHJ;AEypHE;EACE,gCAAA;AFvpHJ;AE0pHE;EACE;IACE,+BAAA;EFxpHJ;EE2pHE;IACE,kCAAA;EFzpHJ;EE4pHE;IACE,8BAAA;EF1pHJ;EE6pHE;IACE,gCAAA;EF3pHJ;EE8pHE;IACE,gCAAA;EF5pHJ;AACF;AE+pHE;EACE;IACE,+BAAA;EF7pHJ;EEgqHE;IACE,kCAAA;EF9pHJ;EEiqHE;IACE,8BAAA;EF/pHJ;EEkqHE;IACE,gCAAA;EFhqHJ;EEmqHE;IACE,gCAAA;EFjqHJ;AACF;AEoqHE;EACE;IACE,+BAAA;EFlqHJ;EEqqHE;IACE,kCAAA;EFnqHJ;EEsqHE;IACE,8BAAA;EFpqHJ;EEuqHE;IACE,gCAAA;EFrqHJ;EEwqHE;IACE,gCAAA;EFtqHJ;AACF;AEyqHE;EACE;IACE,+BAAA;EFvqHJ;EE0qHE;IACE,kCAAA;EFxqHJ;EE2qHE;IACE,8BAAA;EFzqHJ;EE4qHE;IACE,gCAAA;EF1qHJ;EE6qHE;IACE,gCAAA;EF3qHJ;AACF;AE8qHE;EACE,2BAAA;AF5qHJ;AE+qHE;EACE,iCAAA;AF7qHJ;AEgrHE;EACE,+BAAA;AF9qHJ;AEirHE;EACE,6BAAA;AF/qHJ;AEkrHE;EACE,8BAAA;AFhrHJ;AEmrHE;EACE,+BAAA;AFjrHJ;AEorHE;EACE;IACE,2BAAA;EFlrHJ;EEqrHE;IACE,iCAAA;EFnrHJ;EEsrHE;IACE,+BAAA;EFprHJ;EEurHE;IACE,6BAAA;EFrrHJ;EEwrHE;IACE,8BAAA;EFtrHJ;EEyrHE;IACE,+BAAA;EFvrHJ;AACF;AE0rHE;EACE;IACE,2BAAA;EFxrHJ;EE2rHE;IACE,iCAAA;EFzrHJ;EE4rHE;IACE,+BAAA;EF1rHJ;EE6rHE;IACE,6BAAA;EF3rHJ;EE8rHE;IACE,8BAAA;EF5rHJ;EE+rHE;IACE,+BAAA;EF7rHJ;AACF;AEgsHE;EACE;IACE,2BAAA;EF9rHJ;EEisHE;IACE,iCAAA;EF/rHJ;EEksHE;IACE,+BAAA;EFhsHJ;EEmsHE;IACE,6BAAA;EFjsHJ;EEosHE;IACE,8BAAA;EFlsHJ;EEqsHE;IACE,+BAAA;EFnsHJ;AACF;AEssHE;EACE;IACE,2BAAA;EFpsHJ;EEusHE;IACE,iCAAA;EFrsHJ;EEwsHE;IACE,+BAAA;EFtsHJ;EEysHE;IACE,6BAAA;EFvsHJ;EE0sHE;IACE,8BAAA;EFxsHJ;EE2sHE;IACE,+BAAA;EFzsHJ;AACF;AE4sHE;EACE,mBAAA;AF1sHJ;AE6sHE;EACE,mBAAA;AF3sHJ;AE8sHE;EACE,mBAAA;AF5sHJ;AE+sHE;EACE,mBAAA;AF7sHJ;AEgtHE;EACE,mBAAA;AF9sHJ;AEitHE;EACE,mBAAA;AF/sHJ;AEktHE;EACE,mBAAA;AFhtHJ;AEmtHE;EACE;IACE,mBAAA;EFjtHJ;EEotHE;IACE,mBAAA;EFltHJ;EEqtHE;IACE,mBAAA;EFntHJ;EEstHE;IACE,mBAAA;EFptHJ;EEutHE;IACE,mBAAA;EFrtHJ;EEwtHE;IACE,mBAAA;EFttHJ;EEytHE;IACE,mBAAA;EFvtHJ;AACF;AE0tHE;EACE;IACE,mBAAA;EFxtHJ;EE2tHE;IACE,mBAAA;EFztHJ;EE4tHE;IACE,mBAAA;EF1tHJ;EE6tHE;IACE,mBAAA;EF3tHJ;EE8tHE;IACE,mBAAA;EF5tHJ;EE+tHE;IACE,mBAAA;EF7tHJ;EEguHE;IACE,mBAAA;EF9tHJ;AACF;AEiuHE;EACE;IACE,mBAAA;EF/tHJ;EEkuHE;IACE,mBAAA;EFhuHJ;EEmuHE;IACE,mBAAA;EFjuHJ;EEouHE;IACE,mBAAA;EFluHJ;EEquHE;IACE,mBAAA;EFnuHJ;EEsuHE;IACE,mBAAA;EFpuHJ;EEuuHE;IACE,mBAAA;EFruHJ;AACF;AEwuHE;EACE;IACE,mBAAA;EFtuHJ;EEyuHE;IACE,mBAAA;EFvuHJ;EE0uHE;IACE,mBAAA;EFxuHJ;EE2uHE;IACE,mBAAA;EFzuHJ;EE4uHE;IACE,mBAAA;EF1uHJ;EE6uHE;IACE,mBAAA;EF3uHJ;EE8uHE;IACE,mBAAA;EF5uHJ;AACF;AE+uHE;EACE,uBAAA;AF7uHJ;AEgvHE;EACE,yBAAA;AF9uHJ;AEivHE;EACE,yBAAA;AF/uHJ;AEkvHE;EACE,qBAAA;AFhvHJ;AEmvHE;EACE;IACE,uBAAA;EFjvHJ;EEovHE;IACE,yBAAA;EFlvHJ;EEqvHE;IACE,yBAAA;EFnvHJ;EEsvHE;IACE,qBAAA;EFpvHJ;AACF;AEuvHE;EACE;IACE,uBAAA;EFrvHJ;EEwvHE;IACE,yBAAA;EFtvHJ;EEyvHE;IACE,yBAAA;EFvvHJ;EE0vHE;IACE,qBAAA;EFxvHJ;AACF;AE2vHE;EACE;IACE,uBAAA;EFzvHJ;EE4vHE;IACE,yBAAA;EF1vHJ;EE6vHE;IACE,yBAAA;EF3vHJ;EE8vHE;IACE,qBAAA;EF5vHJ;AACF;AE+vHE;EACE;IACE,uBAAA;EF7vHJ;EEgwHE;IACE,yBAAA;EF9vHJ;EEiwHE;IACE,yBAAA;EF/vHJ;EEkwHE;IACE,qBAAA;EFhwHJ;AACF;AEmwHE;EACE,uBAAA;AFjwHJ;AEowHE;EACE,uBAAA;AFlwHJ;AEqwHE;EACE;IACE,uBAAA;EFnwHJ;EEswHE;IACE,uBAAA;EFpwHJ;AACF;AEuwHE;EACE;IACE,uBAAA;EFrwHJ;EEwwHE;IACE,uBAAA;EFtwHJ;AACF;AEywHE;EACE;IACE,uBAAA;EFvwHJ;EE0wHE;IACE,uBAAA;EFxwHJ;AACF;AE2wHE;EACE;IACE,uBAAA;EFzwHJ;EE4wHE;IACE,uBAAA;EF1wHJ;AACF;AE6wHE;EACE,yBAAA;AF3wHJ;AE8wHE;EACE,yBAAA;AF5wHJ;AE+wHE;EACE;IACE,yBAAA;EF7wHJ;EEgxHE;IACE,yBAAA;EF9wHJ;AACF;AEixHE;EACE;IACE,yBAAA;EF/wHJ;EEkxHE;IACE,yBAAA;EFhxHJ;AACF;AEmxHE;EACE;IACE,yBAAA;EFjxHJ;EEoxHE;IACE,yBAAA;EFlxHJ;AACF;AEqxHE;EACE;IACE,yBAAA;EFnxHJ;EEsxHE;IACE,yBAAA;EFpxHJ;AACF;AEuxHE;EACE,oBAAA;AFrxHJ;AEwxHE;EACE,uBAAA;AFtxHJ;AEyxHE;EACE,sBAAA;AFvxHJ;AE0xHE;EACE,oBAAA;AFxxHJ;AE2xHE;EACE,sBAAA;AFzxHJ;AE4xHE;EACE,oBAAA;AF1xHJ;AE6xHE;EACE,oBAAA;AF3xHJ;AE8xHE;EACE,oBAAA;AF5xHJ;AE+xHE;EACE,oBAAA;AF7xHJ;AEgyHE;EACE,wBAAA;AF9xHJ;AEiyHE;EACE,2BAAA;AF/xHJ;AEkyHE;EACE,0BAAA;AFhyHJ;AEmyHE;EACE,wBAAA;AFjyHJ;AEoyHE;EACE,0BAAA;AFlyHJ;AEqyHE;EACE,wBAAA;AFnyHJ;AEsyHE;EACE,wBAAA;AFpyHJ;AEuyHE;EACE,wBAAA;AFryHJ;AEwyHE;EACE,wBAAA;AFtyHJ;AEyyHE;EACE,2BAAA;AFvyHJ;AE0yHE;EACE,8BAAA;AFxyHJ;AE2yHE;EACE,6BAAA;AFzyHJ;AE4yHE;EACE,2BAAA;AF1yHJ;AE6yHE;EACE,6BAAA;AF3yHJ;AE8yHE;EACE,2BAAA;AF5yHJ;AE+yHE;EACE,2BAAA;AF7yHJ;AEgzHE;EACE,2BAAA;AF9yHJ;AEizHE;EACE,2BAAA;AF/yHJ;AEkzHE;EACE;IACE,oBAAA;EFhzHJ;EEmzHE;IACE,uBAAA;EFjzHJ;EEozHE;IACE,sBAAA;EFlzHJ;EEqzHE;IACE,oBAAA;EFnzHJ;EEszHE;IACE,sBAAA;EFpzHJ;EEuzHE;IACE,oBAAA;EFrzHJ;EEwzHE;IACE,oBAAA;EFtzHJ;EEyzHE;IACE,oBAAA;EFvzHJ;EE0zHE;IACE,oBAAA;EFxzHJ;EE2zHE;IACE,wBAAA;EFzzHJ;EE4zHE;IACE,2BAAA;EF1zHJ;EE6zHE;IACE,0BAAA;EF3zHJ;EE8zHE;IACE,wBAAA;EF5zHJ;EE+zHE;IACE,0BAAA;EF7zHJ;EEg0HE;IACE,wBAAA;EF9zHJ;EEi0HE;IACE,wBAAA;EF/zHJ;EEk0HE;IACE,wBAAA;EFh0HJ;EEm0HE;IACE,wBAAA;EFj0HJ;EEo0HE;IACE,2BAAA;EFl0HJ;EEq0HE;IACE,8BAAA;EFn0HJ;EEs0HE;IACE,6BAAA;EFp0HJ;EEu0HE;IACE,2BAAA;EFr0HJ;EEw0HE;IACE,6BAAA;EFt0HJ;EEy0HE;IACE,2BAAA;EFv0HJ;EE00HE;IACE,2BAAA;EFx0HJ;EE20HE;IACE,2BAAA;EFz0HJ;EE40HE;IACE,2BAAA;EF10HJ;AACF;AE60HE;EACE;IACE,oBAAA;EF30HJ;EE80HE;IACE,uBAAA;EF50HJ;EE+0HE;IACE,sBAAA;EF70HJ;EEg1HE;IACE,oBAAA;EF90HJ;EEi1HE;IACE,sBAAA;EF/0HJ;EEk1HE;IACE,oBAAA;EFh1HJ;EEm1HE;IACE,oBAAA;EFj1HJ;EEo1HE;IACE,oBAAA;EFl1HJ;EEq1HE;IACE,oBAAA;EFn1HJ;EEs1HE;IACE,wBAAA;EFp1HJ;EEu1HE;IACE,2BAAA;EFr1HJ;EEw1HE;IACE,0BAAA;EFt1HJ;EEy1HE;IACE,wBAAA;EFv1HJ;EE01HE;IACE,0BAAA;EFx1HJ;EE21HE;IACE,wBAAA;EFz1HJ;EE41HE;IACE,wBAAA;EF11HJ;EE61HE;IACE,wBAAA;EF31HJ;EE81HE;IACE,wBAAA;EF51HJ;EE+1HE;IACE,2BAAA;EF71HJ;EEg2HE;IACE,8BAAA;EF91HJ;EEi2HE;IACE,6BAAA;EF/1HJ;EEk2HE;IACE,2BAAA;EFh2HJ;EEm2HE;IACE,6BAAA;EFj2HJ;EEo2HE;IACE,2BAAA;EFl2HJ;EEq2HE;IACE,2BAAA;EFn2HJ;EEs2HE;IACE,2BAAA;EFp2HJ;EEu2HE;IACE,2BAAA;EFr2HJ;AACF;AEw2HE;EACE;IACE,oBAAA;EFt2HJ;EEy2HE;IACE,uBAAA;EFv2HJ;EE02HE;IACE,sBAAA;EFx2HJ;EE22HE;IACE,oBAAA;EFz2HJ;EE42HE;IACE,sBAAA;EF12HJ;EE62HE;IACE,oBAAA;EF32HJ;EE82HE;IACE,oBAAA;EF52HJ;EE+2HE;IACE,oBAAA;EF72HJ;EEg3HE;IACE,oBAAA;EF92HJ;EEi3HE;IACE,wBAAA;EF/2HJ;EEk3HE;IACE,2BAAA;EFh3HJ;EEm3HE;IACE,0BAAA;EFj3HJ;EEo3HE;IACE,wBAAA;EFl3HJ;EEq3HE;IACE,0BAAA;EFn3HJ;EEs3HE;IACE,wBAAA;EFp3HJ;EEu3HE;IACE,wBAAA;EFr3HJ;EEw3HE;IACE,wBAAA;EFt3HJ;EEy3HE;IACE,wBAAA;EFv3HJ;EE03HE;IACE,2BAAA;EFx3HJ;EE23HE;IACE,8BAAA;EFz3HJ;EE43HE;IACE,6BAAA;EF13HJ;EE63HE;IACE,2BAAA;EF33HJ;EE83HE;IACE,6BAAA;EF53HJ;EE+3HE;IACE,2BAAA;EF73HJ;EEg4HE;IACE,2BAAA;EF93HJ;EEi4HE;IACE,2BAAA;EF/3HJ;EEk4HE;IACE,2BAAA;EFh4HJ;AACF;AEm4HE;EACE;IACE,oBAAA;EFj4HJ;EEo4HE;IACE,uBAAA;EFl4HJ;EEq4HE;IACE,sBAAA;EFn4HJ;EEs4HE;IACE,oBAAA;EFp4HJ;EEu4HE;IACE,sBAAA;EFr4HJ;EEw4HE;IACE,oBAAA;EFt4HJ;EEy4HE;IACE,oBAAA;EFv4HJ;EE04HE;IACE,oBAAA;EFx4HJ;EE24HE;IACE,oBAAA;EFz4HJ;EE44HE;IACE,wBAAA;EF14HJ;EE64HE;IACE,2BAAA;EF34HJ;EE84HE;IACE,0BAAA;EF54HJ;EE+4HE;IACE,wBAAA;EF74HJ;EEg5HE;IACE,0BAAA;EF94HJ;EEi5HE;IACE,wBAAA;EF/4HJ;EEk5HE;IACE,wBAAA;EFh5HJ;EEm5HE;IACE,wBAAA;EFj5HJ;EEo5HE;IACE,wBAAA;EFl5HJ;EEq5HE;IACE,2BAAA;EFn5HJ;EEs5HE;IACE,8BAAA;EFp5HJ;EEu5HE;IACE,6BAAA;EFr5HJ;EEw5HE;IACE,2BAAA;EFt5HJ;EEy5HE;IACE,6BAAA;EFv5HJ;EE05HE;IACE,2BAAA;EFx5HJ;EE25HE;IACE,2BAAA;EFz5HJ;EE45HE;IACE,2BAAA;EF15HJ;EE65HE;IACE,2BAAA;EF35HJ;AACF;AE85HE;EACE,wBAAA;AF55HJ;AE+5HE;EACE,2BAAA;AF75HJ;AEg6HE;EACE,0BAAA;AF95HJ;AEi6HE;EACE,wBAAA;AF/5HJ;AEk6HE;EACE,0BAAA;AFh6HJ;AEm6HE;EACE,wBAAA;AFj6HJ;AEo6HE;EACE,wBAAA;AFl6HJ;AEq6HE;EACE,wBAAA;AFn6HJ;AEs6HE;EACE,wBAAA;AFp6HJ;AEu6HE;EACE,4BAAA;AFr6HJ;AEw6HE;EACE,+BAAA;AFt6HJ;AEy6HE;EACE,8BAAA;AFv6HJ;AE06HE;EACE,4BAAA;AFx6HJ;AE26HE;EACE,8BAAA;AFz6HJ;AE46HE;EACE,4BAAA;AF16HJ;AE66HE;EACE,4BAAA;AF36HJ;AE86HE;EACE,4BAAA;AF56HJ;AE+6HE;EACE,4BAAA;AF76HJ;AEg7HE;EACE,8BAAA;AF96HJ;AEi7HE;EACE,iCAAA;AF/6HJ;AEk7HE;EACE,gCAAA;AFh7HJ;AEm7HE;EACE,8BAAA;AFj7HJ;AEo7HE;EACE,gCAAA;AFl7HJ;AEq7HE;EACE,8BAAA;AFn7HJ;AEs7HE;EACE,8BAAA;AFp7HJ;AEu7HE;EACE,8BAAA;AFr7HJ;AEw7HE;EACE,8BAAA;AFt7HJ;AEy7HE;EACE,6BAAA;AFv7HJ;AE07HE;EACE,gCAAA;AFx7HJ;AE27HE;EACE,+BAAA;AFz7HJ;AE47HE;EACE,6BAAA;AF17HJ;AE67HE;EACE,+BAAA;AF37HJ;AE87HE;EACE,6BAAA;AF57HJ;AE+7HE;EACE,6BAAA;AF77HJ;AEg8HE;EACE,6BAAA;AF97HJ;AEi8HE;EACE,6BAAA;AF/7HJ;AEk8HE;EACE,+BAAA;AFh8HJ;AEm8HE;EACE,kCAAA;AFj8HJ;AEo8HE;EACE,iCAAA;AFl8HJ;AEq8HE;EACE,+BAAA;AFn8HJ;AEs8HE;EACE,iCAAA;AFp8HJ;AEu8HE;EACE,+BAAA;AFr8HJ;AEw8HE;EACE,+BAAA;AFt8HJ;AEy8HE;EACE,+BAAA;AFv8HJ;AE08HE;EACE,+BAAA;AFx8HJ;AE28HE;EACE,6BAAA;EACA,8BAAA;AFz8HJ;AE48HE;EACE,gCAAA;EACA,iCAAA;AF18HJ;AE68HE;EACE,+BAAA;EACA,gCAAA;AF38HJ;AE88HE;EACE,6BAAA;EACA,8BAAA;AF58HJ;AE+8HE;EACE,+BAAA;EACA,gCAAA;AF78HJ;AEg9HE;EACE,6BAAA;EACA,8BAAA;AF98HJ;AEi9HE;EACE,6BAAA;EACA,8BAAA;AF/8HJ;AEk9HE;EACE,6BAAA;EACA,8BAAA;AFh9HJ;AEm9HE;EACE,6BAAA;EACA,8BAAA;AFj9HJ;AEo9HE;EACE,4BAAA;EACA,+BAAA;AFl9HJ;AEq9HE;EACE,+BAAA;EACA,kCAAA;AFn9HJ;AEs9HE;EACE,8BAAA;EACA,iCAAA;AFp9HJ;AEu9HE;EACE,4BAAA;EACA,+BAAA;AFr9HJ;AEw9HE;EACE,8BAAA;EACA,iCAAA;AFt9HJ;AEy9HE;EACE,4BAAA;EACA,+BAAA;AFv9HJ;AE09HE;EACE,4BAAA;EACA,+BAAA;AFx9HJ;AE29HE;EACE,4BAAA;EACA,+BAAA;AFz9HJ;AE49HE;EACE,4BAAA;EACA,+BAAA;AF19HJ;AE69HE;EACE;IACE,yBAAA;EF39HJ;EE89HE;IACE,2BAAA;EF59HJ;EE+9HE;IACE,0BAAA;EF79HJ;EEg+HE;IACE,wBAAA;EF99HJ;EEi+HE;IACE,0BAAA;EF/9HJ;EEk+HE;IACE,wBAAA;EFh+HJ;EEm+HE;IACE,wBAAA;EFj+HJ;EEo+HE;IACE,wBAAA;EFl+HJ;EEq+HE;IACE,wBAAA;EFn+HJ;EEs+HE;IACE,4BAAA;EFp+HJ;EEu+HE;IACE,+BAAA;EFr+HJ;EEw+HE;IACE,8BAAA;EFt+HJ;EEy+HE;IACE,4BAAA;EFv+HJ;EE0+HE;IACE,8BAAA;EFx+HJ;EE2+HE;IACE,4BAAA;EFz+HJ;EE4+HE;IACE,4BAAA;EF1+HJ;EE6+HE;IACE,4BAAA;EF3+HJ;EE8+HE;IACE,4BAAA;EF5+HJ;EE++HE;IACE,8BAAA;EF7+HJ;EEg/HE;IACE,iCAAA;EF9+HJ;EEi/HE;IACE,gCAAA;EF/+HJ;EEk/HE;IACE,8BAAA;EFh/HJ;EEm/HE;IACE,gCAAA;EFj/HJ;EEo/HE;IACE,8BAAA;EFl/HJ;EEq/HE;IACE,8BAAA;EFn/HJ;EEs/HE;IACE,8BAAA;EFp/HJ;EEu/HE;IACE,8BAAA;EFr/HJ;EEw/HE;IACE,6BAAA;EFt/HJ;EEy/HE;IACE,gCAAA;EFv/HJ;EE0/HE;IACE,+BAAA;EFx/HJ;EE2/HE;IACE,6BAAA;EFz/HJ;EE4/HE;IACE,+BAAA;EF1/HJ;EE6/HE;IACE,6BAAA;EF3/HJ;EE8/HE;IACE,6BAAA;EF5/HJ;EE+/HE;IACE,6BAAA;EF7/HJ;EEggIE;IACE,6BAAA;EF9/HJ;EEigIE;IACE,+BAAA;EF//HJ;EEkgIE;IACE,kCAAA;EFhgIJ;EEmgIE;IACE,iCAAA;EFjgIJ;EEogIE;IACE,+BAAA;EFlgIJ;EEqgIE;IACE,iCAAA;EFngIJ;EEsgIE;IACE,+BAAA;EFpgIJ;EEugIE;IACE,+BAAA;EFrgIJ;EEwgIE;IACE,+BAAA;EFtgIJ;EEygIE;IACE,+BAAA;EFvgIJ;EE0gIE;IACE,6BAAA;IACA,8BAAA;EFxgIJ;EE2gIE;IACE,gCAAA;IACA,iCAAA;EFzgIJ;EE4gIE;IACE,+BAAA;IACA,gCAAA;EF1gIJ;EE6gIE;IACE,6BAAA;IACA,8BAAA;EF3gIJ;EE8gIE;IACE,+BAAA;IACA,gCAAA;EF5gIJ;EE+gIE;IACE,6BAAA;IACA,8BAAA;EF7gIJ;EEghIE;IACE,6BAAA;IACA,8BAAA;EF9gIJ;EEihIE;IACE,6BAAA;IACA,8BAAA;EF/gIJ;EEkhIE;IACE,6BAAA;IACA,8BAAA;EFhhIJ;EEmhIE;IACE,4BAAA;IACA,+BAAA;EFjhIJ;EEohIE;IACE,+BAAA;IACA,kCAAA;EFlhIJ;EEqhIE;IACE,8BAAA;IACA,iCAAA;EFnhIJ;EEshIE;IACE,4BAAA;IACA,+BAAA;EFphIJ;EEuhIE;IACE,8BAAA;IACA,iCAAA;EFrhIJ;EEwhIE;IACE,4BAAA;IACA,+BAAA;EFthIJ;EEyhIE;IACE,4BAAA;IACA,+BAAA;EFvhIJ;EE0hIE;IACE,4BAAA;IACA,+BAAA;EFxhIJ;EE2hIE;IACE,4BAAA;IACA,+BAAA;EFzhIJ;AACF;AE4hIE;EACE;IACE,qBAAA;EF1hIJ;EE6hIE;IACE,2BAAA;EF3hIJ;EE8hIE;IACE,0BAAA;EF5hIJ;EE+hIE;IACE,wBAAA;EF7hIJ;EEgiIE;IACE,0BAAA;EF9hIJ;EEiiIE;IACE,wBAAA;EF/hIJ;EEkiIE;IACE,wBAAA;EFhiIJ;EEmiIE;IACE,wBAAA;EFjiIJ;EEoiIE;IACE,wBAAA;EFliIJ;EEqiIE;IACE,4BAAA;EFniIJ;EEsiIE;IACE,+BAAA;EFpiIJ;EEuiIE;IACE,8BAAA;EFriIJ;EEwiIE;IACE,4BAAA;EFtiIJ;EEyiIE;IACE,8BAAA;EFviIJ;EE0iIE;IACE,4BAAA;EFxiIJ;EE2iIE;IACE,4BAAA;EFziIJ;EE4iIE;IACE,4BAAA;EF1iIJ;EE6iIE;IACE,4BAAA;EF3iIJ;EE8iIE;IACE,8BAAA;EF5iIJ;EE+iIE;IACE,iCAAA;EF7iIJ;EEgjIE;IACE,gCAAA;EF9iIJ;EEijIE;IACE,8BAAA;EF/iIJ;EEkjIE;IACE,gCAAA;EFhjIJ;EEmjIE;IACE,8BAAA;EFjjIJ;EEojIE;IACE,8BAAA;EFljIJ;EEqjIE;IACE,8BAAA;EFnjIJ;EEsjIE;IACE,8BAAA;EFpjIJ;EEujIE;IACE,6BAAA;EFrjIJ;EEwjIE;IACE,gCAAA;EFtjIJ;EEyjIE;IACE,+BAAA;EFvjIJ;EE0jIE;IACE,6BAAA;EFxjIJ;EE2jIE;IACE,+BAAA;EFzjIJ;EE4jIE;IACE,6BAAA;EF1jIJ;EE6jIE;IACE,6BAAA;EF3jIJ;EE8jIE;IACE,6BAAA;EF5jIJ;EE+jIE;IACE,6BAAA;EF7jIJ;EEgkIE;IACE,+BAAA;EF9jIJ;EEikIE;IACE,kCAAA;EF/jIJ;EEkkIE;IACE,iCAAA;EFhkIJ;EEmkIE;IACE,+BAAA;EFjkIJ;EEokIE;IACE,iCAAA;EFlkIJ;EEqkIE;IACE,+BAAA;EFnkIJ;EEskIE;IACE,+BAAA;EFpkIJ;EEukIE;IACE,+BAAA;EFrkIJ;EEwkIE;IACE,+BAAA;EFtkIJ;EEykIE;IACE,6BAAA;IACA,8BAAA;EFvkIJ;EE0kIE;IACE,gCAAA;IACA,iCAAA;EFxkIJ;EE2kIE;IACE,+BAAA;IACA,gCAAA;EFzkIJ;EE4kIE;IACE,6BAAA;IACA,8BAAA;EF1kIJ;EE6kIE;IACE,+BAAA;IACA,gCAAA;EF3kIJ;EE8kIE;IACE,6BAAA;IACA,8BAAA;EF5kIJ;EE+kIE;IACE,6BAAA;IACA,8BAAA;EF7kIJ;EEglIE;IACE,6BAAA;IACA,8BAAA;EF9kIJ;EEilIE;IACE,6BAAA;IACA,8BAAA;EF/kIJ;EEklIE;IACE,4BAAA;IACA,+BAAA;EFhlIJ;EEmlIE;IACE,+BAAA;IACA,kCAAA;EFjlIJ;EEolIE;IACE,8BAAA;IACA,iCAAA;EFllIJ;EEqlIE;IACE,4BAAA;IACA,+BAAA;EFnlIJ;EEslIE;IACE,8BAAA;IACA,iCAAA;EFplIJ;EEulIE;IACE,4BAAA;IACA,+BAAA;EFrlIJ;EEwlIE;IACE,4BAAA;IACA,+BAAA;EFtlIJ;EEylIE;IACE,4BAAA;IACA,+BAAA;EFvlIJ;EE0lIE;IACE,4BAAA;IACA,+BAAA;EFxlIJ;AACF;AE2lIE;EACE;IACE,qBAAA;EFzlIJ;EE4lIE;IACE,2BAAA;EF1lIJ;EE6lIE;IACE,0BAAA;EF3lIJ;EE8lIE;IACE,wBAAA;EF5lIJ;EE+lIE;IACE,0BAAA;EF7lIJ;EEgmIE;IACE,wBAAA;EF9lIJ;EEimIE;IACE,wBAAA;EF/lIJ;EEkmIE;IACE,wBAAA;EFhmIJ;EEmmIE;IACE,wBAAA;EFjmIJ;EEomIE;IACE,4BAAA;EFlmIJ;EEqmIE;IACE,+BAAA;EFnmIJ;EEsmIE;IACE,8BAAA;EFpmIJ;EEumIE;IACE,4BAAA;EFrmIJ;EEwmIE;IACE,8BAAA;EFtmIJ;EEymIE;IACE,4BAAA;EFvmIJ;EE0mIE;IACE,4BAAA;EFxmIJ;EE2mIE;IACE,4BAAA;EFzmIJ;EE4mIE;IACE,4BAAA;EF1mIJ;EE6mIE;IACE,8BAAA;EF3mIJ;EE8mIE;IACE,iCAAA;EF5mIJ;EE+mIE;IACE,gCAAA;EF7mIJ;EEgnIE;IACE,8BAAA;EF9mIJ;EEinIE;IACE,gCAAA;EF/mIJ;EEknIE;IACE,8BAAA;EFhnIJ;EEmnIE;IACE,8BAAA;EFjnIJ;EEonIE;IACE,8BAAA;EFlnIJ;EEqnIE;IACE,8BAAA;EFnnIJ;EEsnIE;IACE,6BAAA;EFpnIJ;EEunIE;IACE,gCAAA;EFrnIJ;EEwnIE;IACE,+BAAA;EFtnIJ;EEynIE;IACE,6BAAA;EFvnIJ;EE0nIE;IACE,+BAAA;EFxnIJ;EE2nIE;IACE,6BAAA;EFznIJ;EE4nIE;IACE,6BAAA;EF1nIJ;EE6nIE;IACE,6BAAA;EF3nIJ;EE8nIE;IACE,6BAAA;EF5nIJ;EE+nIE;IACE,+BAAA;EF7nIJ;EEgoIE;IACE,kCAAA;EF9nIJ;EEioIE;IACE,iCAAA;EF/nIJ;EEkoIE;IACE,+BAAA;EFhoIJ;EEmoIE;IACE,iCAAA;EFjoIJ;EEooIE;IACE,+BAAA;EFloIJ;EEqoIE;IACE,+BAAA;EFnoIJ;EEsoIE;IACE,+BAAA;EFpoIJ;EEuoIE;IACE,+BAAA;EFroIJ;EEwoIE;IACE,6BAAA;IACA,8BAAA;EFtoIJ;EEyoIE;IACE,gCAAA;IACA,iCAAA;EFvoIJ;EE0oIE;IACE,+BAAA;IACA,gCAAA;EFxoIJ;EE2oIE;IACE,6BAAA;IACA,8BAAA;EFzoIJ;EE4oIE;IACE,+BAAA;IACA,gCAAA;EF1oIJ;EE6oIE;IACE,6BAAA;IACA,8BAAA;EF3oIJ;EE8oIE;IACE,6BAAA;IACA,8BAAA;EF5oIJ;EE+oIE;IACE,6BAAA;IACA,8BAAA;EF7oIJ;EEgpIE;IACE,6BAAA;IACA,8BAAA;EF9oIJ;EEipIE;IACE,4BAAA;IACA,+BAAA;EF/oIJ;EEkpIE;IACE,+BAAA;IACA,kCAAA;EFhpIJ;EEmpIE;IACE,8BAAA;IACA,iCAAA;EFjpIJ;EEopIE;IACE,4BAAA;IACA,+BAAA;EFlpIJ;EEqpIE;IACE,8BAAA;IACA,iCAAA;EFnpIJ;EEspIE;IACE,4BAAA;IACA,+BAAA;EFppIJ;EEupIE;IACE,4BAAA;IACA,+BAAA;EFrpIJ;EEwpIE;IACE,4BAAA;IACA,+BAAA;EFtpIJ;EEypIE;IACE,4BAAA;IACA,+BAAA;EFvpIJ;AACF;AE0pIE;EACE;IACE,qBAAA;EFxpIJ;EE2pIE;IACE,2BAAA;EFzpIJ;EE4pIE;IACE,0BAAA;EF1pIJ;EE6pIE;IACE,wBAAA;EF3pIJ;EE8pIE;IACE,0BAAA;EF5pIJ;EE+pIE;IACE,wBAAA;EF7pIJ;EEgqIE;IACE,wBAAA;EF9pIJ;EEiqIE;IACE,wBAAA;EF/pIJ;EEkqIE;IACE,wBAAA;EFhqIJ;EEmqIE;IACE,4BAAA;EFjqIJ;EEoqIE;IACE,+BAAA;EFlqIJ;EEqqIE;IACE,8BAAA;EFnqIJ;EEsqIE;IACE,4BAAA;EFpqIJ;EEuqIE;IACE,8BAAA;EFrqIJ;EEwqIE;IACE,4BAAA;EFtqIJ;EEyqIE;IACE,4BAAA;EFvqIJ;EE0qIE;IACE,4BAAA;EFxqIJ;EE2qIE;IACE,4BAAA;EFzqIJ;EE4qIE;IACE,8BAAA;EF1qIJ;EE6qIE;IACE,iCAAA;EF3qIJ;EE8qIE;IACE,gCAAA;EF5qIJ;EE+qIE;IACE,8BAAA;EF7qIJ;EEgrIE;IACE,gCAAA;EF9qIJ;EEirIE;IACE,8BAAA;EF/qIJ;EEkrIE;IACE,8BAAA;EFhrIJ;EEmrIE;IACE,8BAAA;EFjrIJ;EEorIE;IACE,8BAAA;EFlrIJ;EEqrIE;IACE,6BAAA;EFnrIJ;EEsrIE;IACE,gCAAA;EFprIJ;EEurIE;IACE,+BAAA;EFrrIJ;EEwrIE;IACE,6BAAA;EFtrIJ;EEyrIE;IACE,+BAAA;EFvrIJ;EE0rIE;IACE,6BAAA;EFxrIJ;EE2rIE;IACE,6BAAA;EFzrIJ;EE4rIE;IACE,6BAAA;EF1rIJ;EE6rIE;IACE,6BAAA;EF3rIJ;EE8rIE;IACE,+BAAA;EF5rIJ;EE+rIE;IACE,kCAAA;EF7rIJ;EEgsIE;IACE,iCAAA;EF9rIJ;EEisIE;IACE,+BAAA;EF/rIJ;EEksIE;IACE,iCAAA;EFhsIJ;EEmsIE;IACE,+BAAA;EFjsIJ;EEosIE;IACE,+BAAA;EFlsIJ;EEqsIE;IACE,+BAAA;EFnsIJ;EEssIE;IACE,+BAAA;EFpsIJ;EEusIE;IACE,6BAAA;IACA,8BAAA;EFrsIJ;EEwsIE;IACE,gCAAA;IACA,iCAAA;EFtsIJ;EEysIE;IACE,+BAAA;IACA,gCAAA;EFvsIJ;EE0sIE;IACE,6BAAA;IACA,8BAAA;EFxsIJ;EE2sIE;IACE,+BAAA;IACA,gCAAA;EFzsIJ;EE4sIE;IACE,6BAAA;IACA,8BAAA;EF1sIJ;EE6sIE;IACE,6BAAA;IACA,8BAAA;EF3sIJ;EE8sIE;IACE,6BAAA;IACA,8BAAA;EF5sIJ;EE+sIE;IACE,6BAAA;IACA,8BAAA;EF7sIJ;EEgtIE;IACE,4BAAA;IACA,+BAAA;EF9sIJ;EEitIE;IACE,+BAAA;IACA,kCAAA;EF/sIJ;EEktIE;IACE,8BAAA;IACA,iCAAA;EFhtIJ;EEmtIE;IACE,4BAAA;IACA,+BAAA;EFjtIJ;EEotIE;IACE,8BAAA;IACA,iCAAA;EFltIJ;EEqtIE;IACE,4BAAA;IACA,+BAAA;EFntIJ;EEstIE;IACE,4BAAA;IACA,+BAAA;EFptIJ;EEutIE;IACE,4BAAA;IACA,+BAAA;EFrtIJ;EEwtIE;IACE,4BAAA;IACA,+BAAA;EFttIJ;AACF;AEytIE;EACE,uBAAA;AFvtIJ;AE0tIE;EACE,0BAAA;AFxtIJ;AE2tIE;EACE,yBAAA;AFztIJ;AE4tIE;EACE,uBAAA;AF1tIJ;AE6tIE;EACE,yBAAA;AF3tIJ;AE8tIE;EACE,uBAAA;AF5tIJ;AE+tIE;EACE,uBAAA;AF7tIJ;AEguIE;EACE,uBAAA;AF9tIJ;AEiuIE;EACE,uBAAA;AF/tIJ;AEkuIE;EACE,2BAAA;AFhuIJ;AEmuIE;EACE,0BAAA;AFjuIJ;AEouIE;EACE,wBAAA;AFluIJ;AEquIE;EACE,0BAAA;AFnuIJ;AEsuIE;EACE,wBAAA;AFpuIJ;AEuuIE;EACE,wBAAA;AFruIJ;AEwuIE;EACE,wBAAA;AFtuIJ;AEyuIE;EACE,wBAAA;AFvuIJ;AE0uIE;EACE,uBAAA;AFxuIJ;AE2uIE;EACE,2BAAA;AFzuIJ;AE4uIE;EACE,8BAAA;AF1uIJ;AE6uIE;EACE,6BAAA;AF3uIJ;AE8uIE;EACE,2BAAA;AF5uIJ;AE+uIE;EACE,6BAAA;AF7uIJ;AEgvIE;EACE,2BAAA;AF9uIJ;AEivIE;EACE,2BAAA;AF/uIJ;AEkvIE;EACE,2BAAA;AFhvIJ;AEmvIE;EACE,2BAAA;AFjvIJ;AEovIE;EACE,+BAAA;AFlvIJ;AEqvIE;EACE,8BAAA;AFnvIJ;AEsvIE;EACE,4BAAA;AFpvIJ;AEuvIE;EACE,8BAAA;AFrvIJ;AEwvIE;EACE,4BAAA;AFtvIJ;AEyvIE;EACE,4BAAA;AFvvIJ;AE0vIE;EACE,4BAAA;AFxvIJ;AE2vIE;EACE,4BAAA;AFzvIJ;AE4vIE;EACE,2BAAA;AF1vIJ;AE6vIE;EACE,6BAAA;AF3vIJ;AE8vIE;EACE,gCAAA;AF5vIJ;AE+vIE;EACE,+BAAA;AF7vIJ;AEgwIE;EACE,6BAAA;AF9vIJ;AEiwIE;EACE,+BAAA;AF/vIJ;AEkwIE;EACE,6BAAA;AFhwIJ;AEmwIE;EACE,6BAAA;AFjwIJ;AEowIE;EACE,6BAAA;AFlwIJ;AEqwIE;EACE,6BAAA;AFnwIJ;AEswIE;EACE,iCAAA;AFpwIJ;AEuwIE;EACE,gCAAA;AFrwIJ;AEwwIE;EACE,8BAAA;AFtwIJ;AEywIE;EACE,gCAAA;AFvwIJ;AE0wIE;EACE,8BAAA;AFxwIJ;AE2wIE;EACE,8BAAA;AFzwIJ;AE4wIE;EACE,8BAAA;AF1wIJ;AE6wIE;EACE,8BAAA;AF3wIJ;AE8wIE;EACE,6BAAA;AF5wIJ;AE+wIE;EACE,4BAAA;AF7wIJ;AEgxIE;EACE,+BAAA;AF9wIJ;AEixIE;EACE,8BAAA;AF/wIJ;AEkxIE;EACE,4BAAA;AFhxIJ;AEmxIE;EACE,8BAAA;AFjxIJ;AEoxIE;EACE,4BAAA;AFlxIJ;AEqxIE;EACE,4BAAA;AFnxIJ;AEsxIE;EACE,4BAAA;AFpxIJ;AEuxIE;EACE,4BAAA;AFrxIJ;AEwxIE;EACE,gCAAA;AFtxIJ;AEyxIE;EACE,+BAAA;AFvxIJ;AE0xIE;EACE,6BAAA;AFxxIJ;AE2xIE;EACE,+BAAA;AFzxIJ;AE4xIE;EACE,6BAAA;AF1xIJ;AE6xIE;EACE,6BAAA;AF3xIJ;AE8xIE;EACE,6BAAA;AF5xIJ;AE+xIE;EACE,6BAAA;AF7xIJ;AEgyIE;EACE,4BAAA;AF9xIJ;AEiyIE;EACE,8BAAA;AF/xIJ;AEkyIE;EACE,iCAAA;AFhyIJ;AEmyIE;EACE,gCAAA;AFjyIJ;AEoyIE;EACE,8BAAA;AFlyIJ;AEqyIE;EACE,gCAAA;AFnyIJ;AEsyIE;EACE,8BAAA;AFpyIJ;AEuyIE;EACE,8BAAA;AFryIJ;AEwyIE;EACE,8BAAA;AFtyIJ;AEyyIE;EACE,8BAAA;AFvyIJ;AE0yIE;EACE,kCAAA;AFxyIJ;AE2yIE;EACE,iCAAA;AFzyIJ;AE4yIE;EACE,+BAAA;AF1yIJ;AE6yIE;EACE,iCAAA;AF3yIJ;AE8yIE;EACE,+BAAA;AF5yIJ;AE+yIE;EACE,+BAAA;AF7yIJ;AEgzIE;EACE,+BAAA;AF9yIJ;AEizIE;EACE,+BAAA;AF/yIJ;AEkzIE;EACE,8BAAA;AFhzIJ;AEmzIE;EACE,4BAAA;EACA,6BAAA;AFjzIJ;AEozIE;EACE,+BAAA;EACA,gCAAA;AFlzIJ;AEqzIE;EACE,8BAAA;EACA,+BAAA;AFnzIJ;AEszIE;EACE,4BAAA;EACA,6BAAA;AFpzIJ;AEuzIE;EACE,8BAAA;EACA,+BAAA;AFrzIJ;AEwzIE;EACE,4BAAA;EACA,6BAAA;AFtzIJ;AEyzIE;EACE,4BAAA;EACA,6BAAA;AFvzIJ;AE0zIE;EACE,4BAAA;EACA,6BAAA;AFxzIJ;AE2zIE;EACE,4BAAA;EACA,6BAAA;AFzzIJ;AE4zIE;EACE,gCAAA;EACA,iCAAA;AF1zIJ;AE6zIE;EACE,+BAAA;EACA,gCAAA;AF3zIJ;AE8zIE;EACE,6BAAA;EACA,8BAAA;AF5zIJ;AE+zIE;EACE,+BAAA;EACA,gCAAA;AF7zIJ;AEg0IE;EACE,6BAAA;EACA,8BAAA;AF9zIJ;AEi0IE;EACE,6BAAA;EACA,8BAAA;AF/zIJ;AEk0IE;EACE,6BAAA;EACA,8BAAA;AFh0IJ;AEm0IE;EACE,6BAAA;EACA,8BAAA;AFj0IJ;AEo0IE;EACE,4BAAA;EACA,6BAAA;AFl0IJ;AEq0IE;EACE,2BAAA;EACA,8BAAA;AFn0IJ;AEs0IE;EACE,8BAAA;EACA,iCAAA;AFp0IJ;AEu0IE;EACE,6BAAA;EACA,gCAAA;AFr0IJ;AEw0IE;EACE,2BAAA;EACA,8BAAA;AFt0IJ;AEy0IE;EACE,6BAAA;EACA,gCAAA;AFv0IJ;AE00IE;EACE,2BAAA;EACA,8BAAA;AFx0IJ;AE20IE;EACE,2BAAA;EACA,8BAAA;AFz0IJ;AE40IE;EACE,2BAAA;EACA,8BAAA;AF10IJ;AE60IE;EACE,2BAAA;EACA,8BAAA;AF30IJ;AE80IE;EACE,+BAAA;EACA,kCAAA;AF50IJ;AE+0IE;EACE,8BAAA;EACA,iCAAA;AF70IJ;AEg1IE;EACE,4BAAA;EACA,+BAAA;AF90IJ;AEi1IE;EACE,8BAAA;EACA,iCAAA;AF/0IJ;AEk1IE;EACE,4BAAA;EACA,+BAAA;AFh1IJ;AEm1IE;EACE,4BAAA;EACA,+BAAA;AFj1IJ;AEo1IE;EACE,4BAAA;EACA,+BAAA;AFl1IJ;AEq1IE;EACE,4BAAA;EACA,+BAAA;AFn1IJ;AEs1IE;EACE,2BAAA;EACA,8BAAA;AFp1IJ;AEu1IE;EACE;IACE,uBAAA;EFr1IJ;EEw1IE;IACE,0BAAA;EFt1IJ;EEy1IE;IACE,yBAAA;EFv1IJ;EE01IE;IACE,uBAAA;EFx1IJ;EE21IE;IACE,yBAAA;EFz1IJ;EE41IE;IACE,uBAAA;EF11IJ;EE61IE;IACE,uBAAA;EF31IJ;EE81IE;IACE,uBAAA;EF51IJ;EE+1IE;IACE,uBAAA;EF71IJ;EEg2IE;IACE,2BAAA;EF91IJ;EEi2IE;IACE,0BAAA;EF/1IJ;EEk2IE;IACE,wBAAA;EFh2IJ;EEm2IE;IACE,0BAAA;EFj2IJ;EEo2IE;IACE,wBAAA;EFl2IJ;EEq2IE;IACE,wBAAA;EFn2IJ;EEs2IE;IACE,wBAAA;EFp2IJ;EEu2IE;IACE,wBAAA;EFr2IJ;EEw2IE;IACE,uBAAA;EFt2IJ;EEy2IE;IACE,2BAAA;EFv2IJ;EE02IE;IACE,8BAAA;EFx2IJ;EE22IE;IACE,6BAAA;EFz2IJ;EE42IE;IACE,2BAAA;EF12IJ;EE62IE;IACE,6BAAA;EF32IJ;EE82IE;IACE,2BAAA;EF52IJ;EE+2IE;IACE,2BAAA;EF72IJ;EEg3IE;IACE,2BAAA;EF92IJ;EEi3IE;IACE,2BAAA;EF/2IJ;EEk3IE;IACE,+BAAA;EFh3IJ;EEm3IE;IACE,8BAAA;EFj3IJ;EEo3IE;IACE,4BAAA;EFl3IJ;EEq3IE;IACE,8BAAA;EFn3IJ;EEs3IE;IACE,4BAAA;EFp3IJ;EEu3IE;IACE,4BAAA;EFr3IJ;EEw3IE;IACE,4BAAA;EFt3IJ;EEy3IE;IACE,4BAAA;EFv3IJ;EE03IE;IACE,2BAAA;EFx3IJ;EE23IE;IACE,6BAAA;EFz3IJ;EE43IE;IACE,gCAAA;EF13IJ;EE63IE;IACE,+BAAA;EF33IJ;EE83IE;IACE,6BAAA;EF53IJ;EE+3IE;IACE,+BAAA;EF73IJ;EEg4IE;IACE,6BAAA;EF93IJ;EEi4IE;IACE,6BAAA;EF/3IJ;EEk4IE;IACE,6BAAA;EFh4IJ;EEm4IE;IACE,6BAAA;EFj4IJ;EEo4IE;IACE,iCAAA;EFl4IJ;EEq4IE;IACE,gCAAA;EFn4IJ;EEs4IE;IACE,8BAAA;EFp4IJ;EEu4IE;IACE,gCAAA;EFr4IJ;EEw4IE;IACE,8BAAA;EFt4IJ;EEy4IE;IACE,8BAAA;EFv4IJ;EE04IE;IACE,8BAAA;EFx4IJ;EE24IE;IACE,8BAAA;EFz4IJ;EE44IE;IACE,6BAAA;EF14IJ;EE64IE;IACE,4BAAA;EF34IJ;EE84IE;IACE,+BAAA;EF54IJ;EE+4IE;IACE,8BAAA;EF74IJ;EEg5IE;IACE,4BAAA;EF94IJ;EEi5IE;IACE,8BAAA;EF/4IJ;EEk5IE;IACE,4BAAA;EFh5IJ;EEm5IE;IACE,4BAAA;EFj5IJ;EEo5IE;IACE,4BAAA;EFl5IJ;EEq5IE;IACE,4BAAA;EFn5IJ;EEs5IE;IACE,gCAAA;EFp5IJ;EEu5IE;IACE,+BAAA;EFr5IJ;EEw5IE;IACE,6BAAA;EFt5IJ;EEy5IE;IACE,+BAAA;EFv5IJ;EE05IE;IACE,6BAAA;EFx5IJ;EE25IE;IACE,6BAAA;EFz5IJ;EE45IE;IACE,6BAAA;EF15IJ;EE65IE;IACE,6BAAA;EF35IJ;EE85IE;IACE,4BAAA;EF55IJ;EE+5IE;IACE,8BAAA;EF75IJ;EEg6IE;IACE,iCAAA;EF95IJ;EEi6IE;IACE,gCAAA;EF/5IJ;EEk6IE;IACE,8BAAA;EFh6IJ;EEm6IE;IACE,gCAAA;EFj6IJ;EEo6IE;IACE,8BAAA;EFl6IJ;EEq6IE;IACE,8BAAA;EFn6IJ;EEs6IE;IACE,8BAAA;EFp6IJ;EEu6IE;IACE,8BAAA;EFr6IJ;EEw6IE;IACE,kCAAA;EFt6IJ;EEy6IE;IACE,iCAAA;EFv6IJ;EE06IE;IACE,+BAAA;EFx6IJ;EE26IE;IACE,iCAAA;EFz6IJ;EE46IE;IACE,+BAAA;EF16IJ;EE66IE;IACE,+BAAA;EF36IJ;EE86IE;IACE,+BAAA;EF56IJ;EE+6IE;IACE,+BAAA;EF76IJ;EEg7IE;IACE,8BAAA;EF96IJ;EEi7IE;IACE,4BAAA;IACA,6BAAA;EF/6IJ;EEk7IE;IACE,+BAAA;IACA,gCAAA;EFh7IJ;EEm7IE;IACE,8BAAA;IACA,+BAAA;EFj7IJ;EEo7IE;IACE,4BAAA;IACA,6BAAA;EFl7IJ;EEq7IE;IACE,8BAAA;IACA,+BAAA;EFn7IJ;EEs7IE;IACE,4BAAA;IACA,6BAAA;EFp7IJ;EEu7IE;IACE,4BAAA;IACA,6BAAA;EFr7IJ;EEw7IE;IACE,4BAAA;IACA,6BAAA;EFt7IJ;EEy7IE;IACE,4BAAA;IACA,6BAAA;EFv7IJ;EE07IE;IACE,gCAAA;IACA,iCAAA;EFx7IJ;EE27IE;IACE,+BAAA;IACA,gCAAA;EFz7IJ;EE47IE;IACE,6BAAA;IACA,8BAAA;EF17IJ;EE67IE;IACE,+BAAA;IACA,gCAAA;EF37IJ;EE87IE;IACE,6BAAA;IACA,8BAAA;EF57IJ;EE+7IE;IACE,6BAAA;IACA,8BAAA;EF77IJ;EEg8IE;IACE,6BAAA;IACA,8BAAA;EF97IJ;EEi8IE;IACE,6BAAA;IACA,8BAAA;EF/7IJ;EEk8IE;IACE,4BAAA;IACA,6BAAA;EFh8IJ;EEm8IE;IACE,2BAAA;IACA,8BAAA;EFj8IJ;EEo8IE;IACE,8BAAA;IACA,iCAAA;EFl8IJ;EEq8IE;IACE,6BAAA;IACA,gCAAA;EFn8IJ;EEs8IE;IACE,2BAAA;IACA,8BAAA;EFp8IJ;EEu8IE;IACE,6BAAA;IACA,gCAAA;EFr8IJ;EEw8IE;IACE,2BAAA;IACA,8BAAA;EFt8IJ;EEy8IE;IACE,2BAAA;IACA,8BAAA;EFv8IJ;EE08IE;IACE,2BAAA;IACA,8BAAA;EFx8IJ;EE28IE;IACE,2BAAA;IACA,8BAAA;EFz8IJ;EE48IE;IACE,+BAAA;IACA,kCAAA;EF18IJ;EE68IE;IACE,8BAAA;IACA,iCAAA;EF38IJ;EE88IE;IACE,4BAAA;IACA,+BAAA;EF58IJ;EE+8IE;IACE,8BAAA;IACA,iCAAA;EF78IJ;EEg9IE;IACE,4BAAA;IACA,+BAAA;EF98IJ;EEi9IE;IACE,4BAAA;IACA,+BAAA;EF/8IJ;EEk9IE;IACE,4BAAA;IACA,+BAAA;EFh9IJ;EEm9IE;IACE,4BAAA;IACA,+BAAA;EFj9IJ;EEo9IE;IACE,2BAAA;IACA,8BAAA;EFl9IJ;AACF;AEq9IE;EACE;IACE,uBAAA;EFn9IJ;EEs9IE;IACE,0BAAA;EFp9IJ;EEu9IE;IACE,yBAAA;EFr9IJ;EEw9IE;IACE,uBAAA;EFt9IJ;EEy9IE;IACE,yBAAA;EFv9IJ;EE09IE;IACE,uBAAA;EFx9IJ;EE29IE;IACE,uBAAA;EFz9IJ;EE49IE;IACE,uBAAA;EF19IJ;EE69IE;IACE,uBAAA;EF39IJ;EE89IE;IACE,2BAAA;EF59IJ;EE+9IE;IACE,0BAAA;EF79IJ;EEg+IE;IACE,wBAAA;EF99IJ;EEi+IE;IACE,0BAAA;EF/9IJ;EEk+IE;IACE,wBAAA;EFh+IJ;EEm+IE;IACE,wBAAA;EFj+IJ;EEo+IE;IACE,wBAAA;EFl+IJ;EEq+IE;IACE,wBAAA;EFn+IJ;EEs+IE;IACE,uBAAA;EFp+IJ;EEu+IE;IACE,2BAAA;EFr+IJ;EEw+IE;IACE,8BAAA;EFt+IJ;EEy+IE;IACE,6BAAA;EFv+IJ;EE0+IE;IACE,2BAAA;EFx+IJ;EE2+IE;IACE,6BAAA;EFz+IJ;EE4+IE;IACE,2BAAA;EF1+IJ;EE6+IE;IACE,2BAAA;EF3+IJ;EE8+IE;IACE,2BAAA;EF5+IJ;EE++IE;IACE,2BAAA;EF7+IJ;EEg/IE;IACE,+BAAA;EF9+IJ;EEi/IE;IACE,8BAAA;EF/+IJ;EEk/IE;IACE,4BAAA;EFh/IJ;EEm/IE;IACE,8BAAA;EFj/IJ;EEo/IE;IACE,4BAAA;EFl/IJ;EEq/IE;IACE,4BAAA;EFn/IJ;EEs/IE;IACE,4BAAA;EFp/IJ;EEu/IE;IACE,4BAAA;EFr/IJ;EEw/IE;IACE,2BAAA;EFt/IJ;EEy/IE;IACE,6BAAA;EFv/IJ;EE0/IE;IACE,gCAAA;EFx/IJ;EE2/IE;IACE,+BAAA;EFz/IJ;EE4/IE;IACE,6BAAA;EF1/IJ;EE6/IE;IACE,+BAAA;EF3/IJ;EE8/IE;IACE,6BAAA;EF5/IJ;EE+/IE;IACE,6BAAA;EF7/IJ;EEggJE;IACE,6BAAA;EF9/IJ;EEigJE;IACE,6BAAA;EF//IJ;EEkgJE;IACE,iCAAA;EFhgJJ;EEmgJE;IACE,gCAAA;EFjgJJ;EEogJE;IACE,8BAAA;EFlgJJ;EEqgJE;IACE,gCAAA;EFngJJ;EEsgJE;IACE,8BAAA;EFpgJJ;EEugJE;IACE,8BAAA;EFrgJJ;EEwgJE;IACE,8BAAA;EFtgJJ;EEygJE;IACE,8BAAA;EFvgJJ;EE0gJE;IACE,6BAAA;EFxgJJ;EE2gJE;IACE,4BAAA;EFzgJJ;EE4gJE;IACE,+BAAA;EF1gJJ;EE6gJE;IACE,8BAAA;EF3gJJ;EE8gJE;IACE,4BAAA;EF5gJJ;EE+gJE;IACE,8BAAA;EF7gJJ;EEghJE;IACE,4BAAA;EF9gJJ;EEihJE;IACE,4BAAA;EF/gJJ;EEkhJE;IACE,4BAAA;EFhhJJ;EEmhJE;IACE,4BAAA;EFjhJJ;EEohJE;IACE,gCAAA;EFlhJJ;EEqhJE;IACE,+BAAA;EFnhJJ;EEshJE;IACE,6BAAA;EFphJJ;EEuhJE;IACE,+BAAA;EFrhJJ;EEwhJE;IACE,6BAAA;EFthJJ;EEyhJE;IACE,6BAAA;EFvhJJ;EE0hJE;IACE,6BAAA;EFxhJJ;EE2hJE;IACE,6BAAA;EFzhJJ;EE4hJE;IACE,4BAAA;EF1hJJ;EE6hJE;IACE,8BAAA;EF3hJJ;EE8hJE;IACE,iCAAA;EF5hJJ;EE+hJE;IACE,gCAAA;EF7hJJ;EEgiJE;IACE,8BAAA;EF9hJJ;EEiiJE;IACE,gCAAA;EF/hJJ;EEkiJE;IACE,8BAAA;EFhiJJ;EEmiJE;IACE,8BAAA;EFjiJJ;EEoiJE;IACE,8BAAA;EFliJJ;EEqiJE;IACE,8BAAA;EFniJJ;EEsiJE;IACE,kCAAA;EFpiJJ;EEuiJE;IACE,iCAAA;EFriJJ;EEwiJE;IACE,+BAAA;EFtiJJ;EEyiJE;IACE,iCAAA;EFviJJ;EE0iJE;IACE,+BAAA;EFxiJJ;EE2iJE;IACE,+BAAA;EFziJJ;EE4iJE;IACE,+BAAA;EF1iJJ;EE6iJE;IACE,+BAAA;EF3iJJ;EE8iJE;IACE,8BAAA;EF5iJJ;EE+iJE;IACE,4BAAA;IACA,6BAAA;EF7iJJ;EEgjJE;IACE,+BAAA;IACA,gCAAA;EF9iJJ;EEijJE;IACE,8BAAA;IACA,+BAAA;EF/iJJ;EEkjJE;IACE,4BAAA;IACA,6BAAA;EFhjJJ;EEmjJE;IACE,8BAAA;IACA,+BAAA;EFjjJJ;EEojJE;IACE,4BAAA;IACA,6BAAA;EFljJJ;EEqjJE;IACE,4BAAA;IACA,6BAAA;EFnjJJ;EEsjJE;IACE,4BAAA;IACA,6BAAA;EFpjJJ;EEujJE;IACE,4BAAA;IACA,6BAAA;EFrjJJ;EEwjJE;IACE,gCAAA;IACA,iCAAA;EFtjJJ;EEyjJE;IACE,+BAAA;IACA,gCAAA;EFvjJJ;EE0jJE;IACE,6BAAA;IACA,8BAAA;EFxjJJ;EE2jJE;IACE,+BAAA;IACA,gCAAA;EFzjJJ;EE4jJE;IACE,6BAAA;IACA,8BAAA;EF1jJJ;EE6jJE;IACE,6BAAA;IACA,8BAAA;EF3jJJ;EE8jJE;IACE,6BAAA;IACA,8BAAA;EF5jJJ;EE+jJE;IACE,6BAAA;IACA,8BAAA;EF7jJJ;EEgkJE;IACE,4BAAA;IACA,6BAAA;EF9jJJ;EEikJE;IACE,2BAAA;IACA,8BAAA;EF/jJJ;EEkkJE;IACE,8BAAA;IACA,iCAAA;EFhkJJ;EEmkJE;IACE,6BAAA;IACA,gCAAA;EFjkJJ;EEokJE;IACE,2BAAA;IACA,8BAAA;EFlkJJ;EEqkJE;IACE,6BAAA;IACA,gCAAA;EFnkJJ;EEskJE;IACE,2BAAA;IACA,8BAAA;EFpkJJ;EEukJE;IACE,2BAAA;IACA,8BAAA;EFrkJJ;EEwkJE;IACE,2BAAA;IACA,8BAAA;EFtkJJ;EEykJE;IACE,2BAAA;IACA,8BAAA;EFvkJJ;EE0kJE;IACE,+BAAA;IACA,kCAAA;EFxkJJ;EE2kJE;IACE,8BAAA;IACA,iCAAA;EFzkJJ;EE4kJE;IACE,4BAAA;IACA,+BAAA;EF1kJJ;EE6kJE;IACE,8BAAA;IACA,iCAAA;EF3kJJ;EE8kJE;IACE,4BAAA;IACA,+BAAA;EF5kJJ;EE+kJE;IACE,4BAAA;IACA,+BAAA;EF7kJJ;EEglJE;IACE,4BAAA;IACA,+BAAA;EF9kJJ;EEilJE;IACE,4BAAA;IACA,+BAAA;EF/kJJ;EEklJE;IACE,2BAAA;IACA,8BAAA;EFhlJJ;AACF;AEmlJE;EACE;IACE,uBAAA;EFjlJJ;EEolJE;IACE,0BAAA;EFllJJ;EEqlJE;IACE,yBAAA;EFnlJJ;EEslJE;IACE,uBAAA;EFplJJ;EEulJE;IACE,yBAAA;EFrlJJ;EEwlJE;IACE,uBAAA;EFtlJJ;EEylJE;IACE,uBAAA;EFvlJJ;EE0lJE;IACE,uBAAA;EFxlJJ;EE2lJE;IACE,uBAAA;EFzlJJ;EE4lJE;IACE,2BAAA;EF1lJJ;EE6lJE;IACE,0BAAA;EF3lJJ;EE8lJE;IACE,wBAAA;EF5lJJ;EE+lJE;IACE,0BAAA;EF7lJJ;EEgmJE;IACE,wBAAA;EF9lJJ;EEimJE;IACE,wBAAA;EF/lJJ;EEkmJE;IACE,wBAAA;EFhmJJ;EEmmJE;IACE,wBAAA;EFjmJJ;EEomJE;IACE,uBAAA;EFlmJJ;EEqmJE;IACE,2BAAA;EFnmJJ;EEsmJE;IACE,8BAAA;EFpmJJ;EEumJE;IACE,6BAAA;EFrmJJ;EEwmJE;IACE,2BAAA;EFtmJJ;EEymJE;IACE,6BAAA;EFvmJJ;EE0mJE;IACE,2BAAA;EFxmJJ;EE2mJE;IACE,2BAAA;EFzmJJ;EE4mJE;IACE,2BAAA;EF1mJJ;EE6mJE;IACE,2BAAA;EF3mJJ;EE8mJE;IACE,+BAAA;EF5mJJ;EE+mJE;IACE,8BAAA;EF7mJJ;EEgnJE;IACE,4BAAA;EF9mJJ;EEinJE;IACE,8BAAA;EF/mJJ;EEknJE;IACE,4BAAA;EFhnJJ;EEmnJE;IACE,4BAAA;EFjnJJ;EEonJE;IACE,4BAAA;EFlnJJ;EEqnJE;IACE,4BAAA;EFnnJJ;EEsnJE;IACE,2BAAA;EFpnJJ;EEunJE;IACE,6BAAA;EFrnJJ;EEwnJE;IACE,gCAAA;EFtnJJ;EEynJE;IACE,+BAAA;EFvnJJ;EE0nJE;IACE,6BAAA;EFxnJJ;EE2nJE;IACE,+BAAA;EFznJJ;EE4nJE;IACE,6BAAA;EF1nJJ;EE6nJE;IACE,6BAAA;EF3nJJ;EE8nJE;IACE,6BAAA;EF5nJJ;EE+nJE;IACE,6BAAA;EF7nJJ;EEgoJE;IACE,iCAAA;EF9nJJ;EEioJE;IACE,gCAAA;EF/nJJ;EEkoJE;IACE,8BAAA;EFhoJJ;EEmoJE;IACE,gCAAA;EFjoJJ;EEooJE;IACE,8BAAA;EFloJJ;EEqoJE;IACE,8BAAA;EFnoJJ;EEsoJE;IACE,8BAAA;EFpoJJ;EEuoJE;IACE,8BAAA;EFroJJ;EEwoJE;IACE,6BAAA;EFtoJJ;EEyoJE;IACE,4BAAA;EFvoJJ;EE0oJE;IACE,+BAAA;EFxoJJ;EE2oJE;IACE,8BAAA;EFzoJJ;EE4oJE;IACE,4BAAA;EF1oJJ;EE6oJE;IACE,8BAAA;EF3oJJ;EE8oJE;IACE,4BAAA;EF5oJJ;EE+oJE;IACE,4BAAA;EF7oJJ;EEgpJE;IACE,4BAAA;EF9oJJ;EEipJE;IACE,4BAAA;EF/oJJ;EEkpJE;IACE,gCAAA;EFhpJJ;EEmpJE;IACE,+BAAA;EFjpJJ;EEopJE;IACE,6BAAA;EFlpJJ;EEqpJE;IACE,+BAAA;EFnpJJ;EEspJE;IACE,6BAAA;EFppJJ;EEupJE;IACE,6BAAA;EFrpJJ;EEwpJE;IACE,6BAAA;EFtpJJ;EEypJE;IACE,6BAAA;EFvpJJ;EE0pJE;IACE,4BAAA;EFxpJJ;EE2pJE;IACE,8BAAA;EFzpJJ;EE4pJE;IACE,iCAAA;EF1pJJ;EE6pJE;IACE,gCAAA;EF3pJJ;EE8pJE;IACE,8BAAA;EF5pJJ;EE+pJE;IACE,gCAAA;EF7pJJ;EEgqJE;IACE,8BAAA;EF9pJJ;EEiqJE;IACE,8BAAA;EF/pJJ;EEkqJE;IACE,8BAAA;EFhqJJ;EEmqJE;IACE,8BAAA;EFjqJJ;EEoqJE;IACE,kCAAA;EFlqJJ;EEqqJE;IACE,iCAAA;EFnqJJ;EEsqJE;IACE,+BAAA;EFpqJJ;EEuqJE;IACE,iCAAA;EFrqJJ;EEwqJE;IACE,+BAAA;EFtqJJ;EEyqJE;IACE,+BAAA;EFvqJJ;EE0qJE;IACE,+BAAA;EFxqJJ;EE2qJE;IACE,+BAAA;EFzqJJ;EE4qJE;IACE,8BAAA;EF1qJJ;EE6qJE;IACE,4BAAA;IACA,6BAAA;EF3qJJ;EE8qJE;IACE,+BAAA;IACA,gCAAA;EF5qJJ;EE+qJE;IACE,8BAAA;IACA,+BAAA;EF7qJJ;EEgrJE;IACE,4BAAA;IACA,6BAAA;EF9qJJ;EEirJE;IACE,8BAAA;IACA,+BAAA;EF/qJJ;EEkrJE;IACE,4BAAA;IACA,6BAAA;EFhrJJ;EEmrJE;IACE,4BAAA;IACA,6BAAA;EFjrJJ;EEorJE;IACE,4BAAA;IACA,6BAAA;EFlrJJ;EEqrJE;IACE,4BAAA;IACA,6BAAA;EFnrJJ;EEsrJE;IACE,gCAAA;IACA,iCAAA;EFprJJ;EEurJE;IACE,+BAAA;IACA,gCAAA;EFrrJJ;EEwrJE;IACE,6BAAA;IACA,8BAAA;EFtrJJ;EEyrJE;IACE,+BAAA;IACA,gCAAA;EFvrJJ;EE0rJE;IACE,6BAAA;IACA,8BAAA;EFxrJJ;EE2rJE;IACE,6BAAA;IACA,8BAAA;EFzrJJ;EE4rJE;IACE,6BAAA;IACA,8BAAA;EF1rJJ;EE6rJE;IACE,6BAAA;IACA,8BAAA;EF3rJJ;EE8rJE;IACE,4BAAA;IACA,6BAAA;EF5rJJ;EE+rJE;IACE,2BAAA;IACA,8BAAA;EF7rJJ;EEgsJE;IACE,8BAAA;IACA,iCAAA;EF9rJJ;EEisJE;IACE,6BAAA;IACA,gCAAA;EF/rJJ;EEksJE;IACE,2BAAA;IACA,8BAAA;EFhsJJ;EEmsJE;IACE,6BAAA;IACA,gCAAA;EFjsJJ;EEosJE;IACE,2BAAA;IACA,8BAAA;EFlsJJ;EEqsJE;IACE,2BAAA;IACA,8BAAA;EFnsJJ;EEssJE;IACE,2BAAA;IACA,8BAAA;EFpsJJ;EEusJE;IACE,2BAAA;IACA,8BAAA;EFrsJJ;EEwsJE;IACE,+BAAA;IACA,kCAAA;EFtsJJ;EEysJE;IACE,8BAAA;IACA,iCAAA;EFvsJJ;EE0sJE;IACE,4BAAA;IACA,+BAAA;EFxsJJ;EE2sJE;IACE,8BAAA;IACA,iCAAA;EFzsJJ;EE4sJE;IACE,4BAAA;IACA,+BAAA;EF1sJJ;EE6sJE;IACE,4BAAA;IACA,+BAAA;EF3sJJ;EE8sJE;IACE,4BAAA;IACA,+BAAA;EF5sJJ;EE+sJE;IACE,4BAAA;IACA,+BAAA;EF7sJJ;EEgtJE;IACE,2BAAA;IACA,8BAAA;EF9sJJ;AACF;AEitJE;EACE;IACE,uBAAA;EF/sJJ;EEktJE;IACE,0BAAA;EFhtJJ;EEmtJE;IACE,yBAAA;EFjtJJ;EEotJE;IACE,uBAAA;EFltJJ;EEqtJE;IACE,yBAAA;EFntJJ;EEstJE;IACE,uBAAA;EFptJJ;EEutJE;IACE,uBAAA;EFrtJJ;EEwtJE;IACE,uBAAA;EFttJJ;EEytJE;IACE,uBAAA;EFvtJJ;EE0tJE;IACE,2BAAA;EFxtJJ;EE2tJE;IACE,0BAAA;EFztJJ;EE4tJE;IACE,wBAAA;EF1tJJ;EE6tJE;IACE,0BAAA;EF3tJJ;EE8tJE;IACE,wBAAA;EF5tJJ;EE+tJE;IACE,wBAAA;EF7tJJ;EEguJE;IACE,wBAAA;EF9tJJ;EEiuJE;IACE,wBAAA;EF/tJJ;EEkuJE;IACE,uBAAA;EFhuJJ;EEmuJE;IACE,2BAAA;EFjuJJ;EEouJE;IACE,8BAAA;EFluJJ;EEquJE;IACE,6BAAA;EFnuJJ;EEsuJE;IACE,2BAAA;EFpuJJ;EEuuJE;IACE,6BAAA;EFruJJ;EEwuJE;IACE,2BAAA;EFtuJJ;EEyuJE;IACE,2BAAA;EFvuJJ;EE0uJE;IACE,2BAAA;EFxuJJ;EE2uJE;IACE,2BAAA;EFzuJJ;EE4uJE;IACE,+BAAA;EF1uJJ;EE6uJE;IACE,8BAAA;EF3uJJ;EE8uJE;IACE,4BAAA;EF5uJJ;EE+uJE;IACE,8BAAA;EF7uJJ;EEgvJE;IACE,4BAAA;EF9uJJ;EEivJE;IACE,4BAAA;EF/uJJ;EEkvJE;IACE,4BAAA;EFhvJJ;EEmvJE;IACE,4BAAA;EFjvJJ;EEovJE;IACE,2BAAA;EFlvJJ;EEqvJE;IACE,6BAAA;EFnvJJ;EEsvJE;IACE,gCAAA;EFpvJJ;EEuvJE;IACE,+BAAA;EFrvJJ;EEwvJE;IACE,6BAAA;EFtvJJ;EEyvJE;IACE,+BAAA;EFvvJJ;EE0vJE;IACE,6BAAA;EFxvJJ;EE2vJE;IACE,6BAAA;EFzvJJ;EE4vJE;IACE,6BAAA;EF1vJJ;EE6vJE;IACE,6BAAA;EF3vJJ;EE8vJE;IACE,iCAAA;EF5vJJ;EE+vJE;IACE,gCAAA;EF7vJJ;EEgwJE;IACE,8BAAA;EF9vJJ;EEiwJE;IACE,gCAAA;EF/vJJ;EEkwJE;IACE,8BAAA;EFhwJJ;EEmwJE;IACE,8BAAA;EFjwJJ;EEowJE;IACE,8BAAA;EFlwJJ;EEqwJE;IACE,8BAAA;EFnwJJ;EEswJE;IACE,6BAAA;EFpwJJ;EEuwJE;IACE,4BAAA;EFrwJJ;EEwwJE;IACE,+BAAA;EFtwJJ;EEywJE;IACE,8BAAA;EFvwJJ;EE0wJE;IACE,4BAAA;EFxwJJ;EE2wJE;IACE,8BAAA;EFzwJJ;EE4wJE;IACE,4BAAA;EF1wJJ;EE6wJE;IACE,4BAAA;EF3wJJ;EE8wJE;IACE,4BAAA;EF5wJJ;EE+wJE;IACE,4BAAA;EF7wJJ;EEgxJE;IACE,gCAAA;EF9wJJ;EEixJE;IACE,+BAAA;EF/wJJ;EEkxJE;IACE,6BAAA;EFhxJJ;EEmxJE;IACE,+BAAA;EFjxJJ;EEoxJE;IACE,6BAAA;EFlxJJ;EEqxJE;IACE,6BAAA;EFnxJJ;EEsxJE;IACE,6BAAA;EFpxJJ;EEuxJE;IACE,6BAAA;EFrxJJ;EEwxJE;IACE,4BAAA;EFtxJJ;EEyxJE;IACE,8BAAA;EFvxJJ;EE0xJE;IACE,iCAAA;EFxxJJ;EE2xJE;IACE,gCAAA;EFzxJJ;EE4xJE;IACE,8BAAA;EF1xJJ;EE6xJE;IACE,gCAAA;EF3xJJ;EE8xJE;IACE,8BAAA;EF5xJJ;EE+xJE;IACE,8BAAA;EF7xJJ;EEgyJE;IACE,8BAAA;EF9xJJ;EEiyJE;IACE,8BAAA;EF/xJJ;EEkyJE;IACE,kCAAA;EFhyJJ;EEmyJE;IACE,iCAAA;EFjyJJ;EEoyJE;IACE,+BAAA;EFlyJJ;EEqyJE;IACE,iCAAA;EFnyJJ;EEsyJE;IACE,+BAAA;EFpyJJ;EEuyJE;IACE,+BAAA;EFryJJ;EEwyJE;IACE,+BAAA;EFtyJJ;EEyyJE;IACE,+BAAA;EFvyJJ;EE0yJE;IACE,8BAAA;EFxyJJ;EE2yJE;IACE,4BAAA;IACA,6BAAA;EFzyJJ;EE4yJE;IACE,+BAAA;IACA,gCAAA;EF1yJJ;EE6yJE;IACE,8BAAA;IACA,+BAAA;EF3yJJ;EE8yJE;IACE,4BAAA;IACA,6BAAA;EF5yJJ;EE+yJE;IACE,8BAAA;IACA,+BAAA;EF7yJJ;EEgzJE;IACE,4BAAA;IACA,6BAAA;EF9yJJ;EEizJE;IACE,4BAAA;IACA,6BAAA;EF/yJJ;EEkzJE;IACE,4BAAA;IACA,6BAAA;EFhzJJ;EEmzJE;IACE,4BAAA;IACA,6BAAA;EFjzJJ;EEozJE;IACE,gCAAA;IACA,iCAAA;EFlzJJ;EEqzJE;IACE,+BAAA;IACA,gCAAA;EFnzJJ;EEszJE;IACE,6BAAA;IACA,8BAAA;EFpzJJ;EEuzJE;IACE,+BAAA;IACA,gCAAA;EFrzJJ;EEwzJE;IACE,6BAAA;IACA,8BAAA;EFtzJJ;EEyzJE;IACE,6BAAA;IACA,8BAAA;EFvzJJ;EE0zJE;IACE,6BAAA;IACA,8BAAA;EFxzJJ;EE2zJE;IACE,6BAAA;IACA,8BAAA;EFzzJJ;EE4zJE;IACE,4BAAA;IACA,6BAAA;EF1zJJ;EE6zJE;IACE,2BAAA;IACA,8BAAA;EF3zJJ;EE8zJE;IACE,8BAAA;IACA,iCAAA;EF5zJJ;EE+zJE;IACE,6BAAA;IACA,gCAAA;EF7zJJ;EEg0JE;IACE,2BAAA;IACA,8BAAA;EF9zJJ;EEi0JE;IACE,6BAAA;IACA,gCAAA;EF/zJJ;EEk0JE;IACE,2BAAA;IACA,8BAAA;EFh0JJ;EEm0JE;IACE,2BAAA;IACA,8BAAA;EFj0JJ;EEo0JE;IACE,2BAAA;IACA,8BAAA;EFl0JJ;EEq0JE;IACE,2BAAA;IACA,8BAAA;EFn0JJ;EEs0JE;IACE,+BAAA;IACA,kCAAA;EFp0JJ;EEu0JE;IACE,8BAAA;IACA,iCAAA;EFr0JJ;EEw0JE;IACE,4BAAA;IACA,+BAAA;EFt0JJ;EEy0JE;IACE,8BAAA;IACA,iCAAA;EFv0JJ;EE00JE;IACE,4BAAA;IACA,+BAAA;EFx0JJ;EE20JE;IACE,4BAAA;IACA,+BAAA;EFz0JJ;EE40JE;IACE,4BAAA;IACA,+BAAA;EF10JJ;EE60JE;IACE,4BAAA;IACA,+BAAA;EF30JJ;EE80JE;IACE,2BAAA;IACA,8BAAA;EF50JJ;AACF;AE+0JE;EACE,2BAAA;AF70JJ;AEg1JE;EACE,wIAAA;AF90JJ;AEi1JE;EACE,wIAAA;AF/0JJ;AEk1JE;EACE,+IAAA;AFh1JJ;AEm1JE;EACE,uIAAA;AFj1JJ;AEo1JE;EACE,6IAAA;AFl1JJ;AEq1JE;EACE,iJAAA;AFn1JJ;AEs1JE;EACE,kJAAA;AFp1JJ;AEu1JE;EACE,8IAAA;AFr1JJ;AEw1JE;EACE,2BAAA;AFt1JJ;AEy1JE;EACE,2BAAA;AFv1JJ;AE01JE;EACE,wIAAA;AFx1JJ;AE21JE;EACE,wIAAA;AFz1JJ;AE41JE;EACE,wIAAA;AF11JJ;AE61JE;EACE,wIAAA;AF31JJ;AE81JE;EACE,+IAAA;AF51JJ;AE+1JE;EACE,+IAAA;AF71JJ;AEg2JE;EACE,uIAAA;AF91JJ;AEi2JE;EACE,uIAAA;AF/1JJ;AEk2JE;EACE,6IAAA;AFh2JJ;AEm2JE;EACE,6IAAA;AFj2JJ;AEo2JE;EACE,iJAAA;AFl2JJ;AEq2JE;EACE,iJAAA;AFn2JJ;AEs2JE;EACE,kJAAA;AFp2JJ;AEu2JE;EACE,kJAAA;AFr2JJ;AEw2JE;EACE,8IAAA;AFt2JJ;AEy2JE;EACE,8IAAA;AFv2JJ;AE02JE;EACE;IACE,2BAAA;EFx2JJ;EE22JE;IACE,wIAAA;EFz2JJ;EE42JE;IACE,wIAAA;EF12JJ;EE62JE;IACE,+IAAA;EF32JJ;EE82JE;IACE,uIAAA;EF52JJ;EE+2JE;IACE,6IAAA;EF72JJ;EEg3JE;IACE,iJAAA;EF92JJ;EEi3JE;IACE,kJAAA;EF/2JJ;EEk3JE;IACE,8IAAA;EFh3JJ;EEm3JE;IACE,2BAAA;EFj3JJ;EEo3JE;IACE,2BAAA;EFl3JJ;EEq3JE;IACE,wIAAA;EFn3JJ;EEs3JE;IACE,wIAAA;EFp3JJ;EEu3JE;IACE,wIAAA;EFr3JJ;EEw3JE;IACE,wIAAA;EFt3JJ;EEy3JE;IACE,+IAAA;EFv3JJ;EE03JE;IACE,+IAAA;EFx3JJ;EE23JE;IACE,uIAAA;EFz3JJ;EE43JE;IACE,uIAAA;EF13JJ;EE63JE;IACE,6IAAA;EF33JJ;EE83JE;IACE,6IAAA;EF53JJ;EE+3JE;IACE,iJAAA;EF73JJ;EEg4JE;IACE,iJAAA;EF93JJ;EEi4JE;IACE,kJAAA;EF/3JJ;EEk4JE;IACE,kJAAA;EFh4JJ;EEm4JE;IACE,8IAAA;EFj4JJ;EEo4JE;IACE,8IAAA;EFl4JJ;AACF;AEq4JE;EACE;IACE,2BAAA;EFn4JJ;EEs4JE;IACE,wIAAA;EFp4JJ;EEu4JE;IACE,wIAAA;EFr4JJ;EEw4JE;IACE,+IAAA;EFt4JJ;EEy4JE;IACE,uIAAA;EFv4JJ;EE04JE;IACE,6IAAA;EFx4JJ;EE24JE;IACE,iJAAA;EFz4JJ;EE44JE;IACE,kJAAA;EF14JJ;EE64JE;IACE,8IAAA;EF34JJ;EE84JE;IACE,2BAAA;EF54JJ;EE+4JE;IACE,2BAAA;EF74JJ;EEg5JE;IACE,wIAAA;EF94JJ;EEi5JE;IACE,wIAAA;EF/4JJ;EEk5JE;IACE,wIAAA;EFh5JJ;EEm5JE;IACE,wIAAA;EFj5JJ;EEo5JE;IACE,+IAAA;EFl5JJ;EEq5JE;IACE,+IAAA;EFn5JJ;EEs5JE;IACE,uIAAA;EFp5JJ;EEu5JE;IACE,uIAAA;EFr5JJ;EEw5JE;IACE,6IAAA;EFt5JJ;EEy5JE;IACE,6IAAA;EFv5JJ;EE05JE;IACE,iJAAA;EFx5JJ;EE25JE;IACE,iJAAA;EFz5JJ;EE45JE;IACE,kJAAA;EF15JJ;EE65JE;IACE,kJAAA;EF35JJ;EE85JE;IACE,8IAAA;EF55JJ;EE+5JE;IACE,8IAAA;EF75JJ;AACF;AEg6JE;EACE;IACE,2BAAA;EF95JJ;EEi6JE;IACE,wIAAA;EF/5JJ;EEk6JE;IACE,wIAAA;EFh6JJ;EEm6JE;IACE,+IAAA;EFj6JJ;EEo6JE;IACE,uIAAA;EFl6JJ;EEq6JE;IACE,6IAAA;EFn6JJ;EEs6JE;IACE,iJAAA;EFp6JJ;EEu6JE;IACE,kJAAA;EFr6JJ;EEw6JE;IACE,8IAAA;EFt6JJ;EEy6JE;IACE,2BAAA;EFv6JJ;EE06JE;IACE,2BAAA;EFx6JJ;EE26JE;IACE,wIAAA;EFz6JJ;EE46JE;IACE,wIAAA;EF16JJ;EE66JE;IACE,wIAAA;EF36JJ;EE86JE;IACE,wIAAA;EF56JJ;EE+6JE;IACE,+IAAA;EF76JJ;EEg7JE;IACE,+IAAA;EF96JJ;EEi7JE;IACE,uIAAA;EF/6JJ;EEk7JE;IACE,uIAAA;EFh7JJ;EEm7JE;IACE,6IAAA;EFj7JJ;EEo7JE;IACE,6IAAA;EFl7JJ;EEq7JE;IACE,iJAAA;EFn7JJ;EEs7JE;IACE,iJAAA;EFp7JJ;EEu7JE;IACE,kJAAA;EFr7JJ;EEw7JE;IACE,kJAAA;EFt7JJ;EEy7JE;IACE,8IAAA;EFv7JJ;EE07JE;IACE,8IAAA;EFx7JJ;AACF;AE27JE;EACE;IACE,2BAAA;EFz7JJ;EE47JE;IACE,wIAAA;EF17JJ;EE67JE;IACE,wIAAA;EF37JJ;EE87JE;IACE,+IAAA;EF57JJ;EE+7JE;IACE,uIAAA;EF77JJ;EEg8JE;IACE,6IAAA;EF97JJ;EEi8JE;IACE,iJAAA;EF/7JJ;EEk8JE;IACE,kJAAA;EFh8JJ;EEm8JE;IACE,8IAAA;EFj8JJ;EEo8JE;IACE,2BAAA;EFl8JJ;EEq8JE;IACE,2BAAA;EFn8JJ;EEs8JE;IACE,wIAAA;EFp8JJ;EEu8JE;IACE,wIAAA;EFr8JJ;EEw8JE;IACE,wIAAA;EFt8JJ;EEy8JE;IACE,wIAAA;EFv8JJ;EE08JE;IACE,+IAAA;EFx8JJ;EE28JE;IACE,+IAAA;EFz8JJ;EE48JE;IACE,uIAAA;EF18JJ;EE68JE;IACE,uIAAA;EF38JJ;EE88JE;IACE,6IAAA;EF58JJ;EE+8JE;IACE,6IAAA;EF78JJ;EEg9JE;IACE,iJAAA;EF98JJ;EEi9JE;IACE,iJAAA;EF/8JJ;EEk9JE;IACE,kJAAA;EFh9JJ;EEm9JE;IACE,kJAAA;EFj9JJ;EEo9JE;IACE,8IAAA;EFl9JJ;EEq9JE;IACE,8IAAA;EFn9JJ;AACF;AEs9JE;EACE,0BAAA;EACA,kBAAA;AFp9JJ;AEu9JE;EACE,4BAAA;EACA,mBAAA;AFr9JJ;AEw9JE;EACE,4BAAA;EACA,mBAAA;AFt9JJ;AEy9JE;EACE,4BAAA;EACA,mBAAA;AFv9JJ;AE09JE;EACE,8BAAA;EACA,sBAAA;AFx9JJ;AE29JE;EACE,gCAAA;EACA,uBAAA;AFz9JJ;AE49JE;EACE,gCAAA;EACA,uBAAA;AF19JJ;AE69JE;EACE,gCAAA;EACA,uBAAA;AF39JJ;AE89JE;EACE,gCAAA;EACA,wBAAA;AF59JJ;AE+9JE;EACE,kCAAA;EACA,yBAAA;AF79JJ;AEg+JE;EACE,kCAAA;EACA,yBAAA;AF99JJ;AEi+JE;EACE,kCAAA;EACA,yBAAA;AF/9JJ;AEk+JE;EACE,+BAAA;EACA,uBAAA;AFh+JJ;AEm+JE;EACE,iCAAA;EACA,wBAAA;AFj+JJ;AEo+JE;EACE,iCAAA;EACA,wBAAA;AFl+JJ;AEq+JE;EACE,iCAAA;EACA,wBAAA;AFn+JJ;AEs+JE;EACE,iCAAA;EACA,yBAAA;AFp+JJ;AEu+JE;EACE,mCAAA;EACA,0BAAA;AFr+JJ;AEw+JE;EACE,mCAAA;EACA,0BAAA;AFt+JJ;AEy+JE;EACE,mCAAA;EACA,0BAAA;AFv+JJ;AE0+JE;EACE,+BAAA;EACA,uBAAA;EACA,gCAAA;EACA,wBAAA;AFx+JJ;AE2+JE;EACE,iCAAA;EACA,wBAAA;EACA,kCAAA;EACA,yBAAA;AFz+JJ;AE4+JE;EACE,iCAAA;EACA,wBAAA;EACA,kCAAA;EACA,yBAAA;AF1+JJ;AE6+JE;EACE,iCAAA;EACA,wBAAA;EACA,kCAAA;EACA,yBAAA;AF3+JJ;AE8+JE;EACE,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AF5+JJ;AE++JE;EACE,gCAAA;EACA,uBAAA;EACA,mCAAA;EACA,0BAAA;AF7+JJ;AEg/JE;EACE,gCAAA;EACA,uBAAA;EACA,mCAAA;EACA,0BAAA;AF9+JJ;AEi/JE;EACE,gCAAA;EACA,uBAAA;EACA,mCAAA;EACA,0BAAA;AF/+JJ;AEk/JE;EACE;IACE,0BAAA;IACA,kBAAA;EFh/JJ;EEm/JE;IACE,4BAAA;IACA,mBAAA;EFj/JJ;EEo/JE;IACE,4BAAA;IACA,mBAAA;EFl/JJ;EEq/JE;IACE,4BAAA;IACA,mBAAA;EFn/JJ;EEs/JE;IACE,8BAAA;IACA,sBAAA;EFp/JJ;EEu/JE;IACE,gCAAA;IACA,uBAAA;EFr/JJ;EEw/JE;IACE,gCAAA;IACA,uBAAA;EFt/JJ;EEy/JE;IACE,gCAAA;IACA,uBAAA;EFv/JJ;EE0/JE;IACE,gCAAA;IACA,wBAAA;EFx/JJ;EE2/JE;IACE,kCAAA;IACA,yBAAA;EFz/JJ;EE4/JE;IACE,kCAAA;IACA,yBAAA;EF1/JJ;EE6/JE;IACE,kCAAA;IACA,yBAAA;EF3/JJ;EE8/JE;IACE,+BAAA;IACA,uBAAA;EF5/JJ;EE+/JE;IACE,iCAAA;IACA,wBAAA;EF7/JJ;EEggKE;IACE,iCAAA;IACA,wBAAA;EF9/JJ;EEigKE;IACE,iCAAA;IACA,wBAAA;EF//JJ;EEkgKE;IACE,iCAAA;IACA,yBAAA;EFhgKJ;EEmgKE;IACE,mCAAA;IACA,0BAAA;EFjgKJ;EEogKE;IACE,mCAAA;IACA,0BAAA;EFlgKJ;EEqgKE;IACE,mCAAA;IACA,0BAAA;EFngKJ;EEsgKE;IACE,+BAAA;IACA,uBAAA;IACA,gCAAA;IACA,wBAAA;EFpgKJ;EEugKE;IACE,iCAAA;IACA,wBAAA;IACA,kCAAA;IACA,yBAAA;EFrgKJ;EEwgKE;IACE,iCAAA;IACA,wBAAA;IACA,kCAAA;IACA,yBAAA;EFtgKJ;EEygKE;IACE,iCAAA;IACA,wBAAA;IACA,kCAAA;IACA,yBAAA;EFvgKJ;EE0gKE;IACE,8BAAA;IACA,sBAAA;IACA,iCAAA;IACA,yBAAA;EFxgKJ;EE2gKE;IACE,gCAAA;IACA,uBAAA;IACA,mCAAA;IACA,0BAAA;EFzgKJ;EE4gKE;IACE,gCAAA;IACA,uBAAA;IACA,mCAAA;IACA,0BAAA;EF1gKJ;EE6gKE;IACE,gCAAA;IACA,uBAAA;IACA,mCAAA;IACA,0BAAA;EF3gKJ;AACF;AE8gKE;EACE;IACE,0BAAA;IACA,kBAAA;EF5gKJ;EE+gKE;IACE,4BAAA;IACA,mBAAA;EF7gKJ;EEghKE;IACE,4BAAA;IACA,mBAAA;EF9gKJ;EEihKE;IACE,4BAAA;IACA,mBAAA;EF/gKJ;EEkhKE;IACE,8BAAA;IACA,sBAAA;EFhhKJ;EEmhKE;IACE,gCAAA;IACA,uBAAA;EFjhKJ;EEohKE;IACE,gCAAA;IACA,uBAAA;EFlhKJ;EEqhKE;IACE,gCAAA;IACA,uBAAA;EFnhKJ;EEshKE;IACE,gCAAA;IACA,wBAAA;EFphKJ;EEuhKE;IACE,kCAAA;IACA,yBAAA;EFrhKJ;EEwhKE;IACE,kCAAA;IACA,yBAAA;EFthKJ;EEyhKE;IACE,kCAAA;IACA,yBAAA;EFvhKJ;EE0hKE;IACE,+BAAA;IACA,uBAAA;EFxhKJ;EE2hKE;IACE,iCAAA;IACA,wBAAA;EFzhKJ;EE4hKE;IACE,iCAAA;IACA,wBAAA;EF1hKJ;EE6hKE;IACE,iCAAA;IACA,wBAAA;EF3hKJ;EE8hKE;IACE,iCAAA;IACA,yBAAA;EF5hKJ;EE+hKE;IACE,mCAAA;IACA,0BAAA;EF7hKJ;EEgiKE;IACE,mCAAA;IACA,0BAAA;EF9hKJ;EEiiKE;IACE,mCAAA;IACA,0BAAA;EF/hKJ;EEkiKE;IACE,+BAAA;IACA,uBAAA;IACA,gCAAA;IACA,wBAAA;EFhiKJ;EEmiKE;IACE,iCAAA;IACA,wBAAA;IACA,kCAAA;IACA,yBAAA;EFjiKJ;EEoiKE;IACE,iCAAA;IACA,wBAAA;IACA,kCAAA;IACA,yBAAA;EFliKJ;EEqiKE;IACE,iCAAA;IACA,wBAAA;IACA,kCAAA;IACA,yBAAA;EFniKJ;EEsiKE;IACE,8BAAA;IACA,sBAAA;IACA,iCAAA;IACA,yBAAA;EFpiKJ;EEuiKE;IACE,gCAAA;IACA,uBAAA;IACA,mCAAA;IACA,0BAAA;EFriKJ;EEwiKE;IACE,gCAAA;IACA,uBAAA;IACA,mCAAA;IACA,0BAAA;EFtiKJ;EEyiKE;IACE,gCAAA;IACA,uBAAA;IACA,mCAAA;IACA,0BAAA;EFviKJ;AACF;AE0iKE;EACE;IACE,0BAAA;IACA,kBAAA;EFxiKJ;EE2iKE;IACE,4BAAA;IACA,mBAAA;EFziKJ;EE4iKE;IACE,4BAAA;IACA,mBAAA;EF1iKJ;EE6iKE;IACE,4BAAA;IACA,mBAAA;EF3iKJ;EE8iKE;IACE,8BAAA;IACA,sBAAA;EF5iKJ;EE+iKE;IACE,gCAAA;IACA,uBAAA;EF7iKJ;EEgjKE;IACE,gCAAA;IACA,uBAAA;EF9iKJ;EEijKE;IACE,gCAAA;IACA,uBAAA;EF/iKJ;EEkjKE;IACE,gCAAA;IACA,wBAAA;EFhjKJ;EEmjKE;IACE,kCAAA;IACA,yBAAA;EFjjKJ;EEojKE;IACE,kCAAA;IACA,yBAAA;EFljKJ;EEqjKE;IACE,kCAAA;IACA,yBAAA;EFnjKJ;EEsjKE;IACE,+BAAA;IACA,uBAAA;EFpjKJ;EEujKE;IACE,iCAAA;IACA,wBAAA;EFrjKJ;EEwjKE;IACE,iCAAA;IACA,wBAAA;EFtjKJ;EEyjKE;IACE,iCAAA;IACA,wBAAA;EFvjKJ;EE0jKE;IACE,iCAAA;IACA,yBAAA;EFxjKJ;EE2jKE;IACE,mCAAA;IACA,0BAAA;EFzjKJ;EE4jKE;IACE,mCAAA;IACA,0BAAA;EF1jKJ;EE6jKE;IACE,mCAAA;IACA,0BAAA;EF3jKJ;EE8jKE;IACE,+BAAA;IACA,uBAAA;IACA,gCAAA;IACA,wBAAA;EF5jKJ;EE+jKE;IACE,iCAAA;IACA,wBAAA;IACA,kCAAA;IACA,yBAAA;EF7jKJ;EEgkKE;IACE,iCAAA;IACA,wBAAA;IACA,kCAAA;IACA,yBAAA;EF9jKJ;EEikKE;IACE,iCAAA;IACA,wBAAA;IACA,kCAAA;IACA,yBAAA;EF/jKJ;EEkkKE;IACE,8BAAA;IACA,sBAAA;IACA,iCAAA;IACA,yBAAA;EFhkKJ;EEmkKE;IACE,gCAAA;IACA,uBAAA;IACA,mCAAA;IACA,0BAAA;EFjkKJ;EEokKE;IACE,gCAAA;IACA,uBAAA;IACA,mCAAA;IACA,0BAAA;EFlkKJ;EEqkKE;IACE,gCAAA;IACA,uBAAA;IACA,mCAAA;IACA,0BAAA;EFnkKJ;AACF;AEskKE;EACE;IACE,0BAAA;IACA,kBAAA;EFpkKJ;EEukKE;IACE,4BAAA;IACA,mBAAA;EFrkKJ;EEwkKE;IACE,4BAAA;IACA,mBAAA;EFtkKJ;EEykKE;IACE,4BAAA;IACA,mBAAA;EFvkKJ;EE0kKE;IACE,8BAAA;IACA,sBAAA;EFxkKJ;EE2kKE;IACE,gCAAA;IACA,uBAAA;EFzkKJ;EE4kKE;IACE,gCAAA;IACA,uBAAA;EF1kKJ;EE6kKE;IACE,gCAAA;IACA,uBAAA;EF3kKJ;EE8kKE;IACE,gCAAA;IACA,wBAAA;EF5kKJ;EE+kKE;IACE,kCAAA;IACA,yBAAA;EF7kKJ;EEglKE;IACE,kCAAA;IACA,yBAAA;EF9kKJ;EEilKE;IACE,kCAAA;IACA,yBAAA;EF/kKJ;EEklKE;IACE,+BAAA;IACA,uBAAA;EFhlKJ;EEmlKE;IACE,iCAAA;IACA,wBAAA;EFjlKJ;EEolKE;IACE,iCAAA;IACA,wBAAA;EFllKJ;EEqlKE;IACE,iCAAA;IACA,wBAAA;EFnlKJ;EEslKE;IACE,iCAAA;IACA,yBAAA;EFplKJ;EEulKE;IACE,mCAAA;IACA,0BAAA;EFrlKJ;EEwlKE;IACE,mCAAA;IACA,0BAAA;EFtlKJ;EEylKE;IACE,mCAAA;IACA,0BAAA;EFvlKJ;EE0lKE;IACE,+BAAA;IACA,uBAAA;IACA,gCAAA;IACA,wBAAA;EFxlKJ;EE2lKE;IACE,iCAAA;IACA,wBAAA;IACA,kCAAA;IACA,yBAAA;EFzlKJ;EE4lKE;IACE,iCAAA;IACA,wBAAA;IACA,kCAAA;IACA,yBAAA;EF1lKJ;EE6lKE;IACE,iCAAA;IACA,wBAAA;IACA,kCAAA;IACA,yBAAA;EF3lKJ;EE8lKE;IACE,8BAAA;IACA,sBAAA;IACA,iCAAA;IACA,yBAAA;EF5lKJ;EE+lKE;IACE,gCAAA;IACA,uBAAA;IACA,mCAAA;IACA,0BAAA;EF7lKJ;EEgmKE;IACE,gCAAA;IACA,uBAAA;IACA,mCAAA;IACA,0BAAA;EF9lKJ;EEimKE;IACE,gCAAA;IACA,uBAAA;IACA,mCAAA;IACA,0BAAA;EF/lKJ;AACF;AEkmKE;EACE,8BAAA;AFhmKJ;AEmmKE;EACE,+BAAA;AFjmKJ;AEomKE;EACE,+BAAA;AFlmKJ;AEqmKE;EACE,+BAAA;AFnmKJ;AEsmKE;EACE;IACE,8BAAA;EFpmKJ;EEumKE;IACE,+BAAA;EFrmKJ;EEwmKE;IACE,+BAAA;EFtmKJ;EEymKE;IACE,+BAAA;EFvmKJ;AACF;AE0mKE;EACE;IACE,8BAAA;EFxmKJ;EE2mKE;IACE,+BAAA;EFzmKJ;EE4mKE;IACE,+BAAA;EF1mKJ;EE6mKE;IACE,+BAAA;EF3mKJ;AACF;AE8mKE;EACE;IACE,8BAAA;EF5mKJ;EE+mKE;IACE,+BAAA;EF7mKJ;EEgnKE;IACE,+BAAA;EF9mKJ;EEinKE;IACE,+BAAA;EF/mKJ;AACF;AEknKE;EACE;IACE,8BAAA;EFhnKJ;EEmnKE;IACE,+BAAA;EFjnKJ;EEonKE;IACE,+BAAA;EFlnKJ;EEqnKE;IACE,+BAAA;EFnnKJ;AACF;AEsnKE;EACE,2BAAA;AFpnKJ;AEunKE;EACE,8CAAA;AFrnKJ;AEwnKE;EACE,kCAAA;AFtnKJ;AEynKE;EACE,iCAAA;AFvnKJ;AE0nKE;EACE,kCAAA;AFxnKJ;AE2nKE;EACE,gCAAA;AFznKJ;AE4nKE;EACE,iCAAA;AF1nKJ;AE6nKE;EACE,8BAAA;AF3nKJ;AE8nKE;EACE,gCAAA;AF5nKJ;AE+nKE;EACE,6BAAA;AF7nKJ;AEgoKE;EACE;IACE,2BAAA;EF9nKJ;EEioKE;IACE,8CAAA;EF/nKJ;EEkoKE;IACE,kCAAA;EFhoKJ;EEmoKE;IACE,iCAAA;EFjoKJ;EEooKE;IACE,kCAAA;EFloKJ;EEqoKE;IACE,gCAAA;EFnoKJ;EEsoKE;IACE,iCAAA;EFpoKJ;EEuoKE;IACE,8BAAA;EFroKJ;EEwoKE;IACE,gCAAA;EFtoKJ;EEyoKE;IACE,6BAAA;EFvoKJ;AACF;AE0oKE;EACE;IACE,2BAAA;EFxoKJ;EE2oKE;IACE,8CAAA;EFzoKJ;EE4oKE;IACE,kCAAA;EF1oKJ;EE6oKE;IACE,iCAAA;EF3oKJ;EE8oKE;IACE,kCAAA;EF5oKJ;EE+oKE;IACE,gCAAA;EF7oKJ;EEgpKE;IACE,iCAAA;EF9oKJ;EEipKE;IACE,8BAAA;EF/oKJ;EEkpKE;IACE,gCAAA;EFhpKJ;EEmpKE;IACE,6BAAA;EFjpKJ;AACF;AEopKE;EACE;IACE,2BAAA;EFlpKJ;EEqpKE;IACE,8CAAA;EFnpKJ;EEspKE;IACE,kCAAA;EFppKJ;EEupKE;IACE,iCAAA;EFrpKJ;EEwpKE;IACE,kCAAA;EFtpKJ;EEypKE;IACE,gCAAA;EFvpKJ;EE0pKE;IACE,iCAAA;EFxpKJ;EE2pKE;IACE,8BAAA;EFzpKJ;EE4pKE;IACE,gCAAA;EF1pKJ;EE6pKE;IACE,6BAAA;EF3pKJ;AACF;AE8pKE;EACE;IACE,2BAAA;EF5pKJ;EE+pKE;IACE,8CAAA;EF7pKJ;EEgqKE;IACE,kCAAA;EF9pKJ;EEiqKE;IACE,iCAAA;EF/pKJ;EEkqKE;IACE,kCAAA;EFhqKJ;EEmqKE;IACE,gCAAA;EFjqKJ;EEoqKE;IACE,iCAAA;EFlqKJ;EEqqKE;IACE,8BAAA;EFnqKJ;EEsqKE;IACE,gCAAA;EFpqKJ;EEuqKE;IACE,6BAAA;EFrqKJ;AACF;AEwqKE;EACE,oCAAA;EACA,uCAAA;AFtqKJ;AEyqKE;EACE,oCAAA;EACA,qCAAA;AFvqKJ;AE0qKE;EACE,qCAAA;EACA,wCAAA;AFxqKJ;AE2qKE;EACE,uCAAA;EACA,wCAAA;AFzqKJ;AE4qKE;EACE,uDAAA;EACA,0DAAA;AF1qKJ;AE6qKE;EACE,uDAAA;EACA,wDAAA;AF3qKJ;AE8qKE;EACE,wDAAA;EACA,2DAAA;AF5qKJ;AE+qKE;EACE,0DAAA;EACA,2DAAA;AF7qKJ;AEgrKE;EACE,2CAAA;EACA,8CAAA;AF9qKJ;AEirKE;EACE,2CAAA;EACA,4CAAA;AF/qKJ;AEkrKE;EACE,4CAAA;EACA,+CAAA;AFhrKJ;AEmrKE;EACE,8CAAA;EACA,+CAAA;AFjrKJ;AEorKE;EACE,0CAAA;EACA,6CAAA;AFlrKJ;AEqrKE;EACE,0CAAA;EACA,2CAAA;AFnrKJ;AEsrKE;EACE,2CAAA;EACA,8CAAA;AFprKJ;AEurKE;EACE,6CAAA;EACA,8CAAA;AFrrKJ;AEwrKE;EACE,2CAAA;EACA,8CAAA;AFtrKJ;AEyrKE;EACE,2CAAA;EACA,4CAAA;AFvrKJ;AE0rKE;EACE,4CAAA;EACA,+CAAA;AFxrKJ;AE2rKE;EACE,8CAAA;EACA,+CAAA;AFzrKJ;AE4rKE;EACE,yCAAA;EACA,4CAAA;AF1rKJ;AE6rKE;EACE,yCAAA;EACA,0CAAA;AF3rKJ;AE8rKE;EACE,0CAAA;EACA,6CAAA;AF5rKJ;AE+rKE;EACE,4CAAA;EACA,6CAAA;AF7rKJ;AEgsKE;EACE,0CAAA;EACA,6CAAA;AF9rKJ;AEisKE;EACE,0CAAA;EACA,2CAAA;AF/rKJ;AEksKE;EACE,2CAAA;EACA,8CAAA;AFhsKJ;AEmsKE;EACE,6CAAA;EACA,8CAAA;AFjsKJ;AEosKE;EACE,uCAAA;EACA,0CAAA;AFlsKJ;AEqsKE;EACE,uCAAA;EACA,wCAAA;AFnsKJ;AEssKE;EACE,wCAAA;EACA,2CAAA;AFpsKJ;AEusKE;EACE,0CAAA;EACA,2CAAA;AFrsKJ;AEwsKE;EACE,yCAAA;EACA,4CAAA;AFtsKJ;AEysKE;EACE,yCAAA;EACA,0CAAA;AFvsKJ;AE0sKE;EACE,0CAAA;EACA,6CAAA;AFxsKJ;AE2sKE;EACE,4CAAA;EACA,6CAAA;AFzsKJ;AE4sKE;EACE,sCAAA;EACA,yCAAA;AF1sKJ;AE6sKE;EACE,sCAAA;EACA,uCAAA;AF3sKJ;AE8sKE;EACE,uCAAA;EACA,0CAAA;AF5sKJ;AE+sKE;EACE,yCAAA;EACA,0CAAA;AF7sKJ;AEgtKE;EACE;IACE,oCAAA;IACA,uCAAA;EF9sKJ;EEitKE;IACE,oCAAA;IACA,qCAAA;EF/sKJ;EEktKE;IACE,qCAAA;IACA,wCAAA;EFhtKJ;EEmtKE;IACE,uCAAA;IACA,wCAAA;EFjtKJ;EEotKE;IACE,uDAAA;IACA,0DAAA;EFltKJ;EEqtKE;IACE,uDAAA;IACA,wDAAA;EFntKJ;EEstKE;IACE,wDAAA;IACA,2DAAA;EFptKJ;EEutKE;IACE,0DAAA;IACA,2DAAA;EFrtKJ;EEwtKE;IACE,2CAAA;IACA,8CAAA;EFttKJ;EEytKE;IACE,2CAAA;IACA,4CAAA;EFvtKJ;EE0tKE;IACE,4CAAA;IACA,+CAAA;EFxtKJ;EE2tKE;IACE,8CAAA;IACA,+CAAA;EFztKJ;EE4tKE;IACE,0CAAA;IACA,6CAAA;EF1tKJ;EE6tKE;IACE,0CAAA;IACA,2CAAA;EF3tKJ;EE8tKE;IACE,2CAAA;IACA,8CAAA;EF5tKJ;EE+tKE;IACE,6CAAA;IACA,8CAAA;EF7tKJ;EEguKE;IACE,2CAAA;IACA,8CAAA;EF9tKJ;EEiuKE;IACE,2CAAA;IACA,4CAAA;EF/tKJ;EEkuKE;IACE,4CAAA;IACA,+CAAA;EFhuKJ;EEmuKE;IACE,8CAAA;IACA,+CAAA;EFjuKJ;EEouKE;IACE,yCAAA;IACA,4CAAA;EFluKJ;EEquKE;IACE,yCAAA;IACA,0CAAA;EFnuKJ;EEsuKE;IACE,0CAAA;IACA,6CAAA;EFpuKJ;EEuuKE;IACE,4CAAA;IACA,6CAAA;EFruKJ;EEwuKE;IACE,0CAAA;IACA,6CAAA;EFtuKJ;EEyuKE;IACE,0CAAA;IACA,2CAAA;EFvuKJ;EE0uKE;IACE,2CAAA;IACA,8CAAA;EFxuKJ;EE2uKE;IACE,6CAAA;IACA,8CAAA;EFzuKJ;EE4uKE;IACE,uCAAA;IACA,0CAAA;EF1uKJ;EE6uKE;IACE,uCAAA;IACA,wCAAA;EF3uKJ;EE8uKE;IACE,wCAAA;IACA,2CAAA;EF5uKJ;EE+uKE;IACE,0CAAA;IACA,2CAAA;EF7uKJ;EEgvKE;IACE,yCAAA;IACA,4CAAA;EF9uKJ;EEivKE;IACE,yCAAA;IACA,0CAAA;EF/uKJ;EEkvKE;IACE,0CAAA;IACA,6CAAA;EFhvKJ;EEmvKE;IACE,4CAAA;IACA,6CAAA;EFjvKJ;EEovKE;IACE,sCAAA;IACA,yCAAA;EFlvKJ;EEqvKE;IACE,sCAAA;IACA,uCAAA;EFnvKJ;EEsvKE;IACE,uCAAA;IACA,0CAAA;EFpvKJ;EEuvKE;IACE,yCAAA;IACA,0CAAA;EFrvKJ;AACF;AEwvKE;EACE;IACE,oCAAA;IACA,uCAAA;EFtvKJ;EEyvKE;IACE,oCAAA;IACA,qCAAA;EFvvKJ;EE0vKE;IACE,qCAAA;IACA,wCAAA;EFxvKJ;EE2vKE;IACE,uCAAA;IACA,wCAAA;EFzvKJ;EE4vKE;IACE,uDAAA;IACA,0DAAA;EF1vKJ;EE6vKE;IACE,uDAAA;IACA,wDAAA;EF3vKJ;EE8vKE;IACE,wDAAA;IACA,2DAAA;EF5vKJ;EE+vKE;IACE,0DAAA;IACA,2DAAA;EF7vKJ;EEgwKE;IACE,2CAAA;IACA,8CAAA;EF9vKJ;EEiwKE;IACE,2CAAA;IACA,4CAAA;EF/vKJ;EEkwKE;IACE,4CAAA;IACA,+CAAA;EFhwKJ;EEmwKE;IACE,8CAAA;IACA,+CAAA;EFjwKJ;EEowKE;IACE,0CAAA;IACA,6CAAA;EFlwKJ;EEqwKE;IACE,0CAAA;IACA,2CAAA;EFnwKJ;EEswKE;IACE,2CAAA;IACA,8CAAA;EFpwKJ;EEuwKE;IACE,6CAAA;IACA,8CAAA;EFrwKJ;EEwwKE;IACE,2CAAA;IACA,8CAAA;EFtwKJ;EEywKE;IACE,2CAAA;IACA,4CAAA;EFvwKJ;EE0wKE;IACE,4CAAA;IACA,+CAAA;EFxwKJ;EE2wKE;IACE,8CAAA;IACA,+CAAA;EFzwKJ;EE4wKE;IACE,yCAAA;IACA,4CAAA;EF1wKJ;EE6wKE;IACE,yCAAA;IACA,0CAAA;EF3wKJ;EE8wKE;IACE,0CAAA;IACA,6CAAA;EF5wKJ;EE+wKE;IACE,4CAAA;IACA,6CAAA;EF7wKJ;EEgxKE;IACE,0CAAA;IACA,6CAAA;EF9wKJ;EEixKE;IACE,0CAAA;IACA,2CAAA;EF/wKJ;EEkxKE;IACE,2CAAA;IACA,8CAAA;EFhxKJ;EEmxKE;IACE,6CAAA;IACA,8CAAA;EFjxKJ;EEoxKE;IACE,uCAAA;IACA,0CAAA;EFlxKJ;EEqxKE;IACE,uCAAA;IACA,wCAAA;EFnxKJ;EEsxKE;IACE,wCAAA;IACA,2CAAA;EFpxKJ;EEuxKE;IACE,0CAAA;IACA,2CAAA;EFrxKJ;EEwxKE;IACE,yCAAA;IACA,4CAAA;EFtxKJ;EEyxKE;IACE,yCAAA;IACA,0CAAA;EFvxKJ;EE0xKE;IACE,0CAAA;IACA,6CAAA;EFxxKJ;EE2xKE;IACE,4CAAA;IACA,6CAAA;EFzxKJ;EE4xKE;IACE,sCAAA;IACA,yCAAA;EF1xKJ;EE6xKE;IACE,sCAAA;IACA,uCAAA;EF3xKJ;EE8xKE;IACE,uCAAA;IACA,0CAAA;EF5xKJ;EE+xKE;IACE,yCAAA;IACA,0CAAA;EF7xKJ;AACF;AEgyKE;EACE;IACE,oCAAA;IACA,uCAAA;EF9xKJ;EEiyKE;IACE,oCAAA;IACA,qCAAA;EF/xKJ;EEkyKE;IACE,qCAAA;IACA,wCAAA;EFhyKJ;EEmyKE;IACE,uCAAA;IACA,wCAAA;EFjyKJ;EEoyKE;IACE,uDAAA;IACA,0DAAA;EFlyKJ;EEqyKE;IACE,uDAAA;IACA,wDAAA;EFnyKJ;EEsyKE;IACE,wDAAA;IACA,2DAAA;EFpyKJ;EEuyKE;IACE,0DAAA;IACA,2DAAA;EFryKJ;EEwyKE;IACE,2CAAA;IACA,8CAAA;EFtyKJ;EEyyKE;IACE,2CAAA;IACA,4CAAA;EFvyKJ;EE0yKE;IACE,4CAAA;IACA,+CAAA;EFxyKJ;EE2yKE;IACE,8CAAA;IACA,+CAAA;EFzyKJ;EE4yKE;IACE,0CAAA;IACA,6CAAA;EF1yKJ;EE6yKE;IACE,0CAAA;IACA,2CAAA;EF3yKJ;EE8yKE;IACE,2CAAA;IACA,8CAAA;EF5yKJ;EE+yKE;IACE,6CAAA;IACA,8CAAA;EF7yKJ;EEgzKE;IACE,2CAAA;IACA,8CAAA;EF9yKJ;EEizKE;IACE,2CAAA;IACA,4CAAA;EF/yKJ;EEkzKE;IACE,4CAAA;IACA,+CAAA;EFhzKJ;EEmzKE;IACE,8CAAA;IACA,+CAAA;EFjzKJ;EEozKE;IACE,yCAAA;IACA,4CAAA;EFlzKJ;EEqzKE;IACE,yCAAA;IACA,0CAAA;EFnzKJ;EEszKE;IACE,0CAAA;IACA,6CAAA;EFpzKJ;EEuzKE;IACE,4CAAA;IACA,6CAAA;EFrzKJ;EEwzKE;IACE,0CAAA;IACA,6CAAA;EFtzKJ;EEyzKE;IACE,0CAAA;IACA,2CAAA;EFvzKJ;EE0zKE;IACE,2CAAA;IACA,8CAAA;EFxzKJ;EE2zKE;IACE,6CAAA;IACA,8CAAA;EFzzKJ;EE4zKE;IACE,uCAAA;IACA,0CAAA;EF1zKJ;EE6zKE;IACE,uCAAA;IACA,wCAAA;EF3zKJ;EE8zKE;IACE,wCAAA;IACA,2CAAA;EF5zKJ;EE+zKE;IACE,0CAAA;IACA,2CAAA;EF7zKJ;EEg0KE;IACE,yCAAA;IACA,4CAAA;EF9zKJ;EEi0KE;IACE,yCAAA;IACA,0CAAA;EF/zKJ;EEk0KE;IACE,0CAAA;IACA,6CAAA;EFh0KJ;EEm0KE;IACE,4CAAA;IACA,6CAAA;EFj0KJ;EEo0KE;IACE,sCAAA;IACA,yCAAA;EFl0KJ;EEq0KE;IACE,sCAAA;IACA,uCAAA;EFn0KJ;EEs0KE;IACE,uCAAA;IACA,0CAAA;EFp0KJ;EEu0KE;IACE,yCAAA;IACA,0CAAA;EFr0KJ;AACF;AEw0KE;EACE;IACE,oCAAA;IACA,uCAAA;EFt0KJ;EEy0KE;IACE,oCAAA;IACA,qCAAA;EFv0KJ;EE00KE;IACE,qCAAA;IACA,wCAAA;EFx0KJ;EE20KE;IACE,uCAAA;IACA,wCAAA;EFz0KJ;EE40KE;IACE,uDAAA;IACA,0DAAA;EF10KJ;EE60KE;IACE,uDAAA;IACA,wDAAA;EF30KJ;EE80KE;IACE,wDAAA;IACA,2DAAA;EF50KJ;EE+0KE;IACE,0DAAA;IACA,2DAAA;EF70KJ;EEg1KE;IACE,2CAAA;IACA,8CAAA;EF90KJ;EEi1KE;IACE,2CAAA;IACA,4CAAA;EF/0KJ;EEk1KE;IACE,4CAAA;IACA,+CAAA;EFh1KJ;EEm1KE;IACE,8CAAA;IACA,+CAAA;EFj1KJ;EEo1KE;IACE,0CAAA;IACA,6CAAA;EFl1KJ;EEq1KE;IACE,0CAAA;IACA,2CAAA;EFn1KJ;EEs1KE;IACE,2CAAA;IACA,8CAAA;EFp1KJ;EEu1KE;IACE,6CAAA;IACA,8CAAA;EFr1KJ;EEw1KE;IACE,2CAAA;IACA,8CAAA;EFt1KJ;EEy1KE;IACE,2CAAA;IACA,4CAAA;EFv1KJ;EE01KE;IACE,4CAAA;IACA,+CAAA;EFx1KJ;EE21KE;IACE,8CAAA;IACA,+CAAA;EFz1KJ;EE41KE;IACE,yCAAA;IACA,4CAAA;EF11KJ;EE61KE;IACE,yCAAA;IACA,0CAAA;EF31KJ;EE81KE;IACE,0CAAA;IACA,6CAAA;EF51KJ;EE+1KE;IACE,4CAAA;IACA,6CAAA;EF71KJ;EEg2KE;IACE,0CAAA;IACA,6CAAA;EF91KJ;EEi2KE;IACE,0CAAA;IACA,2CAAA;EF/1KJ;EEk2KE;IACE,2CAAA;IACA,8CAAA;EFh2KJ;EEm2KE;IACE,6CAAA;IACA,8CAAA;EFj2KJ;EEo2KE;IACE,uCAAA;IACA,0CAAA;EFl2KJ;EEq2KE;IACE,uCAAA;IACA,wCAAA;EFn2KJ;EEs2KE;IACE,wCAAA;IACA,2CAAA;EFp2KJ;EEu2KE;IACE,0CAAA;IACA,2CAAA;EFr2KJ;EEw2KE;IACE,yCAAA;IACA,4CAAA;EFt2KJ;EEy2KE;IACE,yCAAA;IACA,0CAAA;EFv2KJ;EE02KE;IACE,0CAAA;IACA,6CAAA;EFx2KJ;EE22KE;IACE,4CAAA;IACA,6CAAA;EFz2KJ;EE42KE;IACE,sCAAA;IACA,yCAAA;EF12KJ;EE62KE;IACE,sCAAA;IACA,uCAAA;EF32KJ;EE82KE;IACE,uCAAA;IACA,0CAAA;EF52KJ;EE+2KE;IACE,yCAAA;IACA,0CAAA;EF72KJ;AACF;AEg3KE;EACE,sBAAA;AF92KJ;AEi3KE;EACE,uBAAA;AF/2KJ;AEk3KE;EACE,sBAAA;AFh3KJ;AEm3KE;EACE,yBAAA;AFj3KJ;AEo3KE;EACE,0BAAA;AFl3KJ;AEq3KE;EACE,qBAAA;AFn3KJ;AEs3KE;EACE,0BAAA;AFp3KJ;AEu3KE;EACE,0BAAA;AFr3KJ;AEw3KE;EACE,qBAAA;AFt3KJ;AEy3KE;EACE,0BAAA;AFv3KJ;AE03KE;EACE,0BAAA;AFx3KJ;AE23KE;EACE,qBAAA;AFz3KJ;AE43KE;EACE,0BAAA;AF13KJ;AE63KE;EACE,0BAAA;AF33KJ;AE83KE;EACE,sBAAA;AF53KJ;AE+3KE;EACE,6BAAA;AF73KJ;AEg4KE;EACE,6BAAA;AF93KJ;AEi4KE;EACE,kCAAA;EACA,6BAAA;AF/3KJ;AEk4KE;EACE,sBAAA;AFh4KJ;AEm4KE;EACE,sBAAA;AFj4KJ;AEo4KE;EACE,sBAAA;AFl4KJ;AEq4KE;EACE,sBAAA;AFn4KJ;AEs4KE;EACE,sBAAA;AFp4KJ;AEu4KE;EACE,sBAAA;AFr4KJ;AEw4KE;EACE,sBAAA;AFt4KJ;AEy4KE;EACE,sBAAA;AFv4KJ;AE04KE;EACE,sBAAA;AFx4KJ;AE24KE;EACE,uBAAA;AFz4KJ;AE44KE;EACE,uBAAA;AF14KJ;AE64KE;EACE,uBAAA;AF34KJ;AE84KE;EACE,uBAAA;AF54KJ;AE+4KE;EACE,uBAAA;AF74KJ;AEg5KE;EACE,uBAAA;AF94KJ;AEi5KE;EACE,uBAAA;AF/4KJ;AEk5KE;EACE,uBAAA;AFh5KJ;AEm5KE;EACE,uBAAA;AFj5KJ;AEo5KE;EACE,uBAAA;AFl5KJ;AEq5KE;EACE,uBAAA;AFn5KJ;AEs5KE;EACE,uBAAA;AFp5KJ;AEu5KE;EACE,uBAAA;AFr5KJ;AEw5KE;EACE,uBAAA;AFt5KJ;AEy5KE;EACE,uBAAA;AFv5KJ;AE05KE;EACE,uBAAA;AFx5KJ;AE25KE;EACE,uBAAA;AFz5KJ;AE45KE;EACE,uBAAA;AF15KJ;AE65KE;EACE,uBAAA;AF35KJ;AE85KE;EACE,uBAAA;AF55KJ;AE+5KE;EACE,uBAAA;AF75KJ;AEg6KE;EACE;IACE,sBAAA;EF95KJ;EEi6KE;IACE,uBAAA;EF/5KJ;EEk6KE;IACE,sBAAA;EFh6KJ;EEm6KE;IACE,yBAAA;EFj6KJ;EEo6KE;IACE,0BAAA;EFl6KJ;EEq6KE;IACE,qBAAA;EFn6KJ;EEs6KE;IACE,0BAAA;EFp6KJ;EEu6KE;IACE,0BAAA;EFr6KJ;EEw6KE;IACE,qBAAA;EFt6KJ;EEy6KE;IACE,0BAAA;EFv6KJ;EE06KE;IACE,0BAAA;EFx6KJ;EE26KE;IACE,qBAAA;EFz6KJ;EE46KE;IACE,0BAAA;EF16KJ;EE66KE;IACE,0BAAA;EF36KJ;EE86KE;IACE,sBAAA;EF56KJ;EE+6KE;IACE,6BAAA;EF76KJ;EEg7KE;IACE,6BAAA;EF96KJ;EEi7KE;IACE,kCAAA;IACA,6BAAA;EF/6KJ;EEk7KE;IACE,sBAAA;EFh7KJ;EEm7KE;IACE,sBAAA;EFj7KJ;EEo7KE;IACE,sBAAA;EFl7KJ;EEq7KE;IACE,sBAAA;EFn7KJ;EEs7KE;IACE,sBAAA;EFp7KJ;EEu7KE;IACE,sBAAA;EFr7KJ;EEw7KE;IACE,sBAAA;EFt7KJ;EEy7KE;IACE,sBAAA;EFv7KJ;EE07KE;IACE,sBAAA;EFx7KJ;EE27KE;IACE,uBAAA;EFz7KJ;EE47KE;IACE,uBAAA;EF17KJ;EE67KE;IACE,uBAAA;EF37KJ;EE87KE;IACE,uBAAA;EF57KJ;EE+7KE;IACE,uBAAA;EF77KJ;EEg8KE;IACE,uBAAA;EF97KJ;EEi8KE;IACE,uBAAA;EF/7KJ;EEk8KE;IACE,uBAAA;EFh8KJ;EEm8KE;IACE,uBAAA;EFj8KJ;EEo8KE;IACE,uBAAA;EFl8KJ;EEq8KE;IACE,uBAAA;EFn8KJ;EEs8KE;IACE,uBAAA;EFp8KJ;EEu8KE;IACE,uBAAA;EFr8KJ;EEw8KE;IACE,uBAAA;EFt8KJ;EEy8KE;IACE,uBAAA;EFv8KJ;EE08KE;IACE,uBAAA;EFx8KJ;EE28KE;IACE,uBAAA;EFz8KJ;EE48KE;IACE,uBAAA;EF18KJ;EE68KE;IACE,uBAAA;EF38KJ;EE88KE;IACE,uBAAA;EF58KJ;EE+8KE;IACE,uBAAA;EF78KJ;AACF;AEg9KE;EACE;IACE,sBAAA;EF98KJ;EEi9KE;IACE,uBAAA;EF/8KJ;EEk9KE;IACE,sBAAA;EFh9KJ;EEm9KE;IACE,yBAAA;EFj9KJ;EEo9KE;IACE,0BAAA;EFl9KJ;EEq9KE;IACE,qBAAA;EFn9KJ;EEs9KE;IACE,0BAAA;EFp9KJ;EEu9KE;IACE,0BAAA;EFr9KJ;EEw9KE;IACE,qBAAA;EFt9KJ;EEy9KE;IACE,0BAAA;EFv9KJ;EE09KE;IACE,0BAAA;EFx9KJ;EE29KE;IACE,qBAAA;EFz9KJ;EE49KE;IACE,0BAAA;EF19KJ;EE69KE;IACE,0BAAA;EF39KJ;EE89KE;IACE,sBAAA;EF59KJ;EE+9KE;IACE,6BAAA;EF79KJ;EEg+KE;IACE,6BAAA;EF99KJ;EEi+KE;IACE,kCAAA;IACA,6BAAA;EF/9KJ;EEk+KE;IACE,sBAAA;EFh+KJ;EEm+KE;IACE,sBAAA;EFj+KJ;EEo+KE;IACE,sBAAA;EFl+KJ;EEq+KE;IACE,sBAAA;EFn+KJ;EEs+KE;IACE,sBAAA;EFp+KJ;EEu+KE;IACE,sBAAA;EFr+KJ;EEw+KE;IACE,sBAAA;EFt+KJ;EEy+KE;IACE,sBAAA;EFv+KJ;EE0+KE;IACE,sBAAA;EFx+KJ;EE2+KE;IACE,uBAAA;EFz+KJ;EE4+KE;IACE,uBAAA;EF1+KJ;EE6+KE;IACE,uBAAA;EF3+KJ;EE8+KE;IACE,uBAAA;EF5+KJ;EE++KE;IACE,uBAAA;EF7+KJ;EEg/KE;IACE,uBAAA;EF9+KJ;EEi/KE;IACE,uBAAA;EF/+KJ;EEk/KE;IACE,uBAAA;EFh/KJ;EEm/KE;IACE,uBAAA;EFj/KJ;EEo/KE;IACE,uBAAA;EFl/KJ;EEq/KE;IACE,uBAAA;EFn/KJ;EEs/KE;IACE,uBAAA;EFp/KJ;EEu/KE;IACE,uBAAA;EFr/KJ;EEw/KE;IACE,uBAAA;EFt/KJ;EEy/KE;IACE,uBAAA;EFv/KJ;EE0/KE;IACE,uBAAA;EFx/KJ;EE2/KE;IACE,uBAAA;EFz/KJ;EE4/KE;IACE,uBAAA;EF1/KJ;EE6/KE;IACE,uBAAA;EF3/KJ;EE8/KE;IACE,uBAAA;EF5/KJ;EE+/KE;IACE,uBAAA;EF7/KJ;AACF;AEggLE;EACE;IACE,sBAAA;EF9/KJ;EEigLE;IACE,uBAAA;EF//KJ;EEkgLE;IACE,sBAAA;EFhgLJ;EEmgLE;IACE,yBAAA;EFjgLJ;EEogLE;IACE,0BAAA;EFlgLJ;EEqgLE;IACE,qBAAA;EFngLJ;EEsgLE;IACE,0BAAA;EFpgLJ;EEugLE;IACE,0BAAA;EFrgLJ;EEwgLE;IACE,qBAAA;EFtgLJ;EEygLE;IACE,0BAAA;EFvgLJ;EE0gLE;IACE,0BAAA;EFxgLJ;EE2gLE;IACE,qBAAA;EFzgLJ;EE4gLE;IACE,0BAAA;EF1gLJ;EE6gLE;IACE,0BAAA;EF3gLJ;EE8gLE;IACE,sBAAA;EF5gLJ;EE+gLE;IACE,6BAAA;EF7gLJ;EEghLE;IACE,6BAAA;EF9gLJ;EEihLE;IACE,kCAAA;IACA,6BAAA;EF/gLJ;EEkhLE;IACE,sBAAA;EFhhLJ;EEmhLE;IACE,sBAAA;EFjhLJ;EEohLE;IACE,sBAAA;EFlhLJ;EEqhLE;IACE,sBAAA;EFnhLJ;EEshLE;IACE,sBAAA;EFphLJ;EEuhLE;IACE,sBAAA;EFrhLJ;EEwhLE;IACE,sBAAA;EFthLJ;EEyhLE;IACE,sBAAA;EFvhLJ;EE0hLE;IACE,sBAAA;EFxhLJ;EE2hLE;IACE,uBAAA;EFzhLJ;EE4hLE;IACE,uBAAA;EF1hLJ;EE6hLE;IACE,uBAAA;EF3hLJ;EE8hLE;IACE,uBAAA;EF5hLJ;EE+hLE;IACE,uBAAA;EF7hLJ;EEgiLE;IACE,uBAAA;EF9hLJ;EEiiLE;IACE,uBAAA;EF/hLJ;EEkiLE;IACE,uBAAA;EFhiLJ;EEmiLE;IACE,uBAAA;EFjiLJ;EEoiLE;IACE,uBAAA;EFliLJ;EEqiLE;IACE,uBAAA;EFniLJ;EEsiLE;IACE,uBAAA;EFpiLJ;EEuiLE;IACE,uBAAA;EFriLJ;EEwiLE;IACE,uBAAA;EFtiLJ;EEyiLE;IACE,uBAAA;EFviLJ;EE0iLE;IACE,uBAAA;EFxiLJ;EE2iLE;IACE,uBAAA;EFziLJ;EE4iLE;IACE,uBAAA;EF1iLJ;EE6iLE;IACE,uBAAA;EF3iLJ;EE8iLE;IACE,uBAAA;EF5iLJ;EE+iLE;IACE,uBAAA;EF7iLJ;AACF;AEgjLE;EACE;IACE,sBAAA;EF9iLJ;EEijLE;IACE,uBAAA;EF/iLJ;EEkjLE;IACE,sBAAA;EFhjLJ;EEmjLE;IACE,yBAAA;EFjjLJ;EEojLE;IACE,0BAAA;EFljLJ;EEqjLE;IACE,qBAAA;EFnjLJ;EEsjLE;IACE,0BAAA;EFpjLJ;EEujLE;IACE,0BAAA;EFrjLJ;EEwjLE;IACE,qBAAA;EFtjLJ;EEyjLE;IACE,0BAAA;EFvjLJ;EE0jLE;IACE,0BAAA;EFxjLJ;EE2jLE;IACE,qBAAA;EFzjLJ;EE4jLE;IACE,0BAAA;EF1jLJ;EE6jLE;IACE,0BAAA;EF3jLJ;EE8jLE;IACE,sBAAA;EF5jLJ;EE+jLE;IACE,6BAAA;EF7jLJ;EEgkLE;IACE,6BAAA;EF9jLJ;EEikLE;IACE,kCAAA;IACA,6BAAA;EF/jLJ;EEkkLE;IACE,sBAAA;EFhkLJ;EEmkLE;IACE,sBAAA;EFjkLJ;EEokLE;IACE,sBAAA;EFlkLJ;EEqkLE;IACE,sBAAA;EFnkLJ;EEskLE;IACE,sBAAA;EFpkLJ;EEukLE;IACE,sBAAA;EFrkLJ;EEwkLE;IACE,sBAAA;EFtkLJ;EEykLE;IACE,sBAAA;EFvkLJ;EE0kLE;IACE,sBAAA;EFxkLJ;EE2kLE;IACE,uBAAA;EFzkLJ;EE4kLE;IACE,uBAAA;EF1kLJ;EE6kLE;IACE,uBAAA;EF3kLJ;EE8kLE;IACE,uBAAA;EF5kLJ;EE+kLE;IACE,uBAAA;EF7kLJ;EEglLE;IACE,uBAAA;EF9kLJ;EEilLE;IACE,uBAAA;EF/kLJ;EEklLE;IACE,uBAAA;EFhlLJ;EEmlLE;IACE,uBAAA;EFjlLJ;EEolLE;IACE,uBAAA;EFllLJ;EEqlLE;IACE,uBAAA;EFnlLJ;EEslLE;IACE,uBAAA;EFplLJ;EEulLE;IACE,uBAAA;EFrlLJ;EEwlLE;IACE,uBAAA;EFtlLJ;EEylLE;IACE,uBAAA;EFvlLJ;EE0lLE;IACE,uBAAA;EFxlLJ;EE2lLE;IACE,uBAAA;EFzlLJ;EE4lLE;IACE,uBAAA;EF1lLJ;EE6lLE;IACE,uBAAA;EF3lLJ;EE8lLE;IACE,uBAAA;EF5lLJ;EE+lLE;IACE,uBAAA;EF7lLJ;AACF;AEgmLE;EACE,uBAAA;AF9lLJ;AEimLE;EACE,wBAAA;AF/lLJ;AEkmLE;EACE,uBAAA;AFhmLJ;AEmmLE;EACE,8BAAA;AFjmLJ;AEomLE;EACE,8BAAA;AFlmLJ;AEqmLE;EACE,mCAAA;EACA,8BAAA;AFnmLJ;AEsmLE;EACE,uBAAA;AFpmLJ;AEumLE;EACE,uBAAA;AFrmLJ;AEwmLE;EACE,uBAAA;AFtmLJ;AEymLE;EACE,uBAAA;AFvmLJ;AE0mLE;EACE,uBAAA;AFxmLJ;AE2mLE;EACE,uBAAA;AFzmLJ;AE4mLE;EACE,uBAAA;AF1mLJ;AE6mLE;EACE,uBAAA;AF3mLJ;AE8mLE;EACE,uBAAA;AF5mLJ;AE+mLE;EACE,wBAAA;AF7mLJ;AEgnLE;EACE,wBAAA;AF9mLJ;AEinLE;EACE,wBAAA;AF/mLJ;AEknLE;EACE,wBAAA;AFhnLJ;AEmnLE;EACE,wBAAA;AFjnLJ;AEonLE;EACE,wBAAA;AFlnLJ;AEqnLE;EACE,wBAAA;AFnnLJ;AEsnLE;EACE,wBAAA;AFpnLJ;AEunLE;EACE,wBAAA;AFrnLJ;AEwnLE;EACE,wBAAA;AFtnLJ;AEynLE;EACE,wBAAA;AFvnLJ;AE0nLE;EACE,wBAAA;AFxnLJ;AE2nLE;EACE,wBAAA;AFznLJ;AE4nLE;EACE,wBAAA;AF1nLJ;AE6nLE;EACE,wBAAA;AF3nLJ;AE8nLE;EACE,wBAAA;AF5nLJ;AE+nLE;EACE,wBAAA;AF7nLJ;AEgoLE;EACE,wBAAA;AF9nLJ;AEioLE;EACE,wBAAA;AF/nLJ;AEkoLE;EACE,wBAAA;AFhoLJ;AEmoLE;EACE,wBAAA;AFjoLJ;AEooLE;EACE;IACE,uBAAA;EFloLJ;EEqoLE;IACE,wBAAA;EFnoLJ;EEsoLE;IACE,uBAAA;EFpoLJ;EEuoLE;IACE,8BAAA;EFroLJ;EEwoLE;IACE,8BAAA;EFtoLJ;EEyoLE;IACE,mCAAA;IACA,8BAAA;EFvoLJ;EE0oLE;IACE,uBAAA;EFxoLJ;EE2oLE;IACE,uBAAA;EFzoLJ;EE4oLE;IACE,uBAAA;EF1oLJ;EE6oLE;IACE,uBAAA;EF3oLJ;EE8oLE;IACE,uBAAA;EF5oLJ;EE+oLE;IACE,uBAAA;EF7oLJ;EEgpLE;IACE,uBAAA;EF9oLJ;EEipLE;IACE,uBAAA;EF/oLJ;EEkpLE;IACE,uBAAA;EFhpLJ;EEmpLE;IACE,wBAAA;EFjpLJ;EEopLE;IACE,wBAAA;EFlpLJ;EEqpLE;IACE,wBAAA;EFnpLJ;EEspLE;IACE,wBAAA;EFppLJ;EEupLE;IACE,wBAAA;EFrpLJ;EEwpLE;IACE,wBAAA;EFtpLJ;EEypLE;IACE,wBAAA;EFvpLJ;EE0pLE;IACE,wBAAA;EFxpLJ;EE2pLE;IACE,wBAAA;EFzpLJ;EE4pLE;IACE,wBAAA;EF1pLJ;EE6pLE;IACE,wBAAA;EF3pLJ;EE8pLE;IACE,wBAAA;EF5pLJ;EE+pLE;IACE,wBAAA;EF7pLJ;EEgqLE;IACE,wBAAA;EF9pLJ;EEiqLE;IACE,wBAAA;EF/pLJ;EEkqLE;IACE,wBAAA;EFhqLJ;EEmqLE;IACE,wBAAA;EFjqLJ;EEoqLE;IACE,wBAAA;EFlqLJ;EEqqLE;IACE,wBAAA;EFnqLJ;EEsqLE;IACE,wBAAA;EFpqLJ;EEuqLE;IACE,wBAAA;EFrqLJ;AACF;AEwqLE;EACE;IACE,uBAAA;EFtqLJ;EEyqLE;IACE,wBAAA;EFvqLJ;EE0qLE;IACE,uBAAA;EFxqLJ;EE2qLE;IACE,8BAAA;EFzqLJ;EE4qLE;IACE,8BAAA;EF1qLJ;EE6qLE;IACE,mCAAA;IACA,8BAAA;EF3qLJ;EE8qLE;IACE,uBAAA;EF5qLJ;EE+qLE;IACE,uBAAA;EF7qLJ;EEgrLE;IACE,uBAAA;EF9qLJ;EEirLE;IACE,uBAAA;EF/qLJ;EEkrLE;IACE,uBAAA;EFhrLJ;EEmrLE;IACE,uBAAA;EFjrLJ;EEorLE;IACE,uBAAA;EFlrLJ;EEqrLE;IACE,uBAAA;EFnrLJ;EEsrLE;IACE,uBAAA;EFprLJ;EEurLE;IACE,wBAAA;EFrrLJ;EEwrLE;IACE,wBAAA;EFtrLJ;EEyrLE;IACE,wBAAA;EFvrLJ;EE0rLE;IACE,wBAAA;EFxrLJ;EE2rLE;IACE,wBAAA;EFzrLJ;EE4rLE;IACE,wBAAA;EF1rLJ;EE6rLE;IACE,wBAAA;EF3rLJ;EE8rLE;IACE,wBAAA;EF5rLJ;EE+rLE;IACE,wBAAA;EF7rLJ;EEgsLE;IACE,wBAAA;EF9rLJ;EEisLE;IACE,wBAAA;EF/rLJ;EEksLE;IACE,wBAAA;EFhsLJ;EEmsLE;IACE,wBAAA;EFjsLJ;EEosLE;IACE,wBAAA;EFlsLJ;EEqsLE;IACE,wBAAA;EFnsLJ;EEssLE;IACE,wBAAA;EFpsLJ;EEusLE;IACE,wBAAA;EFrsLJ;EEwsLE;IACE,wBAAA;EFtsLJ;EEysLE;IACE,wBAAA;EFvsLJ;EE0sLE;IACE,wBAAA;EFxsLJ;EE2sLE;IACE,wBAAA;EFzsLJ;AACF;AE4sLE;EACE;IACE,uBAAA;EF1sLJ;EE6sLE;IACE,wBAAA;EF3sLJ;EE8sLE;IACE,uBAAA;EF5sLJ;EE+sLE;IACE,8BAAA;EF7sLJ;EEgtLE;IACE,8BAAA;EF9sLJ;EEitLE;IACE,mCAAA;IACA,8BAAA;EF/sLJ;EEktLE;IACE,uBAAA;EFhtLJ;EEmtLE;IACE,uBAAA;EFjtLJ;EEotLE;IACE,uBAAA;EFltLJ;EEqtLE;IACE,uBAAA;EFntLJ;EEstLE;IACE,uBAAA;EFptLJ;EEutLE;IACE,uBAAA;EFrtLJ;EEwtLE;IACE,uBAAA;EFttLJ;EEytLE;IACE,uBAAA;EFvtLJ;EE0tLE;IACE,uBAAA;EFxtLJ;EE2tLE;IACE,wBAAA;EFztLJ;EE4tLE;IACE,wBAAA;EF1tLJ;EE6tLE;IACE,wBAAA;EF3tLJ;EE8tLE;IACE,wBAAA;EF5tLJ;EE+tLE;IACE,wBAAA;EF7tLJ;EEguLE;IACE,wBAAA;EF9tLJ;EEiuLE;IACE,wBAAA;EF/tLJ;EEkuLE;IACE,wBAAA;EFhuLJ;EEmuLE;IACE,wBAAA;EFjuLJ;EEouLE;IACE,wBAAA;EFluLJ;EEquLE;IACE,wBAAA;EFnuLJ;EEsuLE;IACE,wBAAA;EFpuLJ;EEuuLE;IACE,wBAAA;EFruLJ;EEwuLE;IACE,wBAAA;EFtuLJ;EEyuLE;IACE,wBAAA;EFvuLJ;EE0uLE;IACE,wBAAA;EFxuLJ;EE2uLE;IACE,wBAAA;EFzuLJ;EE4uLE;IACE,wBAAA;EF1uLJ;EE6uLE;IACE,wBAAA;EF3uLJ;EE8uLE;IACE,wBAAA;EF5uLJ;EE+uLE;IACE,wBAAA;EF7uLJ;AACF;AEgvLE;EACE;IACE,uBAAA;EF9uLJ;EEivLE;IACE,wBAAA;EF/uLJ;EEkvLE;IACE,uBAAA;EFhvLJ;EEmvLE;IACE,8BAAA;EFjvLJ;EEovLE;IACE,8BAAA;EFlvLJ;EEqvLE;IACE,mCAAA;IACA,8BAAA;EFnvLJ;EEsvLE;IACE,uBAAA;EFpvLJ;EEuvLE;IACE,uBAAA;EFrvLJ;EEwvLE;IACE,uBAAA;EFtvLJ;EEyvLE;IACE,uBAAA;EFvvLJ;EE0vLE;IACE,uBAAA;EFxvLJ;EE2vLE;IACE,uBAAA;EFzvLJ;EE4vLE;IACE,uBAAA;EF1vLJ;EE6vLE;IACE,uBAAA;EF3vLJ;EE8vLE;IACE,uBAAA;EF5vLJ;EE+vLE;IACE,wBAAA;EF7vLJ;EEgwLE;IACE,wBAAA;EF9vLJ;EEiwLE;IACE,wBAAA;EF/vLJ;EEkwLE;IACE,wBAAA;EFhwLJ;EEmwLE;IACE,wBAAA;EFjwLJ;EEowLE;IACE,wBAAA;EFlwLJ;EEqwLE;IACE,wBAAA;EFnwLJ;EEswLE;IACE,wBAAA;EFpwLJ;EEuwLE;IACE,wBAAA;EFrwLJ;EEwwLE;IACE,wBAAA;EFtwLJ;EEywLE;IACE,wBAAA;EFvwLJ;EE0wLE;IACE,wBAAA;EFxwLJ;EE2wLE;IACE,wBAAA;EFzwLJ;EE4wLE;IACE,wBAAA;EF1wLJ;EE6wLE;IACE,wBAAA;EF3wLJ;EE8wLE;IACE,wBAAA;EF5wLJ;EE+wLE;IACE,wBAAA;EF7wLJ;EEgxLE;IACE,wBAAA;EF9wLJ;EEixLE;IACE,wBAAA;EF/wLJ;EEkxLE;IACE,wBAAA;EFhxLJ;EEmxLE;IACE,wBAAA;EFjxLJ;AACF;AEoxLE;EACE,yBAAA;AFlxLJ;AEqxLE;EACE,0BAAA;AFnxLJ;AEsxLE;EACE,2BAAA;AFpxLJ;AEuxLE;EACE,iCAAA;AFrxLJ;AEwxLE;EACE,iCAAA;AFtxLJ;AEyxLE;EACE;IACE,yBAAA;EFvxLJ;EE0xLE;IACE,0BAAA;EFxxLJ;EE2xLE;IACE,2BAAA;EFzxLJ;EE4xLE;IACE,iCAAA;EF1xLJ;EE6xLE;IACE,iCAAA;EF3xLJ;AACF;AE8xLE;EACE;IACE,yBAAA;EF5xLJ;EE+xLE;IACE,0BAAA;EF7xLJ;EEgyLE;IACE,2BAAA;EF9xLJ;EEiyLE;IACE,iCAAA;EF/xLJ;EEkyLE;IACE,iCAAA;EFhyLJ;AACF;AEmyLE;EACE;IACE,yBAAA;EFjyLJ;EEoyLE;IACE,0BAAA;EFlyLJ;EEqyLE;IACE,2BAAA;EFnyLJ;EEsyLE;IACE,iCAAA;EFpyLJ;EEuyLE;IACE,iCAAA;EFryLJ;AACF;AEwyLE;EACE;IACE,yBAAA;EFtyLJ;EEyyLE;IACE,0BAAA;EFvyLJ;EE0yLE;IACE,2BAAA;EFxyLJ;EE2yLE;IACE,iCAAA;EFzyLJ;EE4yLE;IACE,iCAAA;EF1yLJ;AACF;AE6yLE;EACE,yBAAA;AF3yLJ;AE8yLE;EACE,0BAAA;AF5yLJ;AE+yLE;EACE,2BAAA;AF7yLJ;AEgzLE;EACE,iCAAA;AF9yLJ;AEizLE;EACE,iCAAA;AF/yLJ;AEkzLE;EACE,sCAAA;EACA,iCAAA;AFhzLJ;AEmzLE;EACE,0BAAA;AFjzLJ;AEozLE;EACE,0BAAA;AFlzLJ;AEqzLE;EACE,0BAAA;AFnzLJ;AEszLE;EACE,0BAAA;AFpzLJ;AEuzLE;EACE,0BAAA;AFrzLJ;AEwzLE;EACE,0BAAA;AFtzLJ;AEyzLE;EACE,0BAAA;AFvzLJ;AE0zLE;EACE,0BAAA;AFxzLJ;AE2zLE;EACE,0BAAA;AFzzLJ;AE4zLE;EACE,2BAAA;AF1zLJ;AE6zLE;EACE,2BAAA;AF3zLJ;AE8zLE;EACE,2BAAA;AF5zLJ;AE+zLE;EACE,2BAAA;AF7zLJ;AEg0LE;EACE,2BAAA;AF9zLJ;AEi0LE;EACE,2BAAA;AF/zLJ;AEk0LE;EACE,2BAAA;AFh0LJ;AEm0LE;EACE,2BAAA;AFj0LJ;AEo0LE;EACE,2BAAA;AFl0LJ;AEq0LE;EACE,2BAAA;AFn0LJ;AEs0LE;EACE,2BAAA;AFp0LJ;AEu0LE;EACE,2BAAA;AFr0LJ;AEw0LE;EACE,2BAAA;AFt0LJ;AEy0LE;EACE,2BAAA;AFv0LJ;AE00LE;EACE,2BAAA;AFx0LJ;AE20LE;EACE,2BAAA;AFz0LJ;AE40LE;EACE,2BAAA;AF10LJ;AE60LE;EACE,2BAAA;AF30LJ;AE80LE;EACE,2BAAA;AF50LJ;AE+0LE;EACE,2BAAA;AF70LJ;AEg1LE;EACE,2BAAA;AF90LJ;AEi1LE;EACE;IACE,yBAAA;EF/0LJ;EEk1LE;IACE,0BAAA;EFh1LJ;EEm1LE;IACE,2BAAA;EFj1LJ;EEo1LE;IACE,iCAAA;EFl1LJ;EEq1LE;IACE,iCAAA;EFn1LJ;EEs1LE;IACE,sCAAA;IACA,iCAAA;EFp1LJ;EEu1LE;IACE,0BAAA;EFr1LJ;EEw1LE;IACE,0BAAA;EFt1LJ;EEy1LE;IACE,0BAAA;EFv1LJ;EE01LE;IACE,0BAAA;EFx1LJ;EE21LE;IACE,0BAAA;EFz1LJ;EE41LE;IACE,0BAAA;EF11LJ;EE61LE;IACE,0BAAA;EF31LJ;EE81LE;IACE,0BAAA;EF51LJ;EE+1LE;IACE,0BAAA;EF71LJ;EEg2LE;IACE,2BAAA;EF91LJ;EEi2LE;IACE,2BAAA;EF/1LJ;EEk2LE;IACE,2BAAA;EFh2LJ;EEm2LE;IACE,2BAAA;EFj2LJ;EEo2LE;IACE,2BAAA;EFl2LJ;EEq2LE;IACE,2BAAA;EFn2LJ;EEs2LE;IACE,2BAAA;EFp2LJ;EEu2LE;IACE,2BAAA;EFr2LJ;EEw2LE;IACE,2BAAA;EFt2LJ;EEy2LE;IACE,2BAAA;EFv2LJ;EE02LE;IACE,2BAAA;EFx2LJ;EE22LE;IACE,2BAAA;EFz2LJ;EE42LE;IACE,2BAAA;EF12LJ;EE62LE;IACE,2BAAA;EF32LJ;EE82LE;IACE,2BAAA;EF52LJ;EE+2LE;IACE,2BAAA;EF72LJ;EEg3LE;IACE,2BAAA;EF92LJ;EEi3LE;IACE,2BAAA;EF/2LJ;EEk3LE;IACE,2BAAA;EFh3LJ;EEm3LE;IACE,2BAAA;EFj3LJ;EEo3LE;IACE,2BAAA;EFl3LJ;AACF;AEq3LE;EACE;IACE,yBAAA;EFn3LJ;EEs3LE;IACE,0BAAA;EFp3LJ;EEu3LE;IACE,2BAAA;EFr3LJ;EEw3LE;IACE,iCAAA;EFt3LJ;EEy3LE;IACE,iCAAA;EFv3LJ;EE03LE;IACE,sCAAA;IACA,iCAAA;EFx3LJ;EE23LE;IACE,0BAAA;EFz3LJ;EE43LE;IACE,0BAAA;EF13LJ;EE63LE;IACE,0BAAA;EF33LJ;EE83LE;IACE,0BAAA;EF53LJ;EE+3LE;IACE,0BAAA;EF73LJ;EEg4LE;IACE,0BAAA;EF93LJ;EEi4LE;IACE,0BAAA;EF/3LJ;EEk4LE;IACE,0BAAA;EFh4LJ;EEm4LE;IACE,0BAAA;EFj4LJ;EEo4LE;IACE,2BAAA;EFl4LJ;EEq4LE;IACE,2BAAA;EFn4LJ;EEs4LE;IACE,2BAAA;EFp4LJ;EEu4LE;IACE,2BAAA;EFr4LJ;EEw4LE;IACE,2BAAA;EFt4LJ;EEy4LE;IACE,2BAAA;EFv4LJ;EE04LE;IACE,2BAAA;EFx4LJ;EE24LE;IACE,2BAAA;EFz4LJ;EE44LE;IACE,2BAAA;EF14LJ;EE64LE;IACE,2BAAA;EF34LJ;EE84LE;IACE,2BAAA;EF54LJ;EE+4LE;IACE,2BAAA;EF74LJ;EEg5LE;IACE,2BAAA;EF94LJ;EEi5LE;IACE,2BAAA;EF/4LJ;EEk5LE;IACE,2BAAA;EFh5LJ;EEm5LE;IACE,2BAAA;EFj5LJ;EEo5LE;IACE,2BAAA;EFl5LJ;EEq5LE;IACE,2BAAA;EFn5LJ;EEs5LE;IACE,2BAAA;EFp5LJ;EEu5LE;IACE,2BAAA;EFr5LJ;EEw5LE;IACE,2BAAA;EFt5LJ;AACF;AEy5LE;EACE;IACE,yBAAA;EFv5LJ;EE05LE;IACE,0BAAA;EFx5LJ;EE25LE;IACE,2BAAA;EFz5LJ;EE45LE;IACE,iCAAA;EF15LJ;EE65LE;IACE,iCAAA;EF35LJ;EE85LE;IACE,sCAAA;IACA,iCAAA;EF55LJ;EE+5LE;IACE,0BAAA;EF75LJ;EEg6LE;IACE,0BAAA;EF95LJ;EEi6LE;IACE,0BAAA;EF/5LJ;EEk6LE;IACE,0BAAA;EFh6LJ;EEm6LE;IACE,0BAAA;EFj6LJ;EEo6LE;IACE,0BAAA;EFl6LJ;EEq6LE;IACE,0BAAA;EFn6LJ;EEs6LE;IACE,0BAAA;EFp6LJ;EEu6LE;IACE,0BAAA;EFr6LJ;EEw6LE;IACE,2BAAA;EFt6LJ;EEy6LE;IACE,2BAAA;EFv6LJ;EE06LE;IACE,2BAAA;EFx6LJ;EE26LE;IACE,2BAAA;EFz6LJ;EE46LE;IACE,2BAAA;EF16LJ;EE66LE;IACE,2BAAA;EF36LJ;EE86LE;IACE,2BAAA;EF56LJ;EE+6LE;IACE,2BAAA;EF76LJ;EEg7LE;IACE,2BAAA;EF96LJ;EEi7LE;IACE,2BAAA;EF/6LJ;EEk7LE;IACE,2BAAA;EFh7LJ;EEm7LE;IACE,2BAAA;EFj7LJ;EEo7LE;IACE,2BAAA;EFl7LJ;EEq7LE;IACE,2BAAA;EFn7LJ;EEs7LE;IACE,2BAAA;EFp7LJ;EEu7LE;IACE,2BAAA;EFr7LJ;EEw7LE;IACE,2BAAA;EFt7LJ;EEy7LE;IACE,2BAAA;EFv7LJ;EE07LE;IACE,2BAAA;EFx7LJ;EE27LE;IACE,2BAAA;EFz7LJ;EE47LE;IACE,2BAAA;EF17LJ;AACF;AE67LE;EACE;IACE,yBAAA;EF37LJ;EE87LE;IACE,0BAAA;EF57LJ;EE+7LE;IACE,2BAAA;EF77LJ;EEg8LE;IACE,iCAAA;EF97LJ;EEi8LE;IACE,iCAAA;EF/7LJ;EEk8LE;IACE,sCAAA;IACA,iCAAA;EFh8LJ;EEm8LE;IACE,0BAAA;EFj8LJ;EEo8LE;IACE,0BAAA;EFl8LJ;EEq8LE;IACE,0BAAA;EFn8LJ;EEs8LE;IACE,0BAAA;EFp8LJ;EEu8LE;IACE,0BAAA;EFr8LJ;EEw8LE;IACE,0BAAA;EFt8LJ;EEy8LE;IACE,0BAAA;EFv8LJ;EE08LE;IACE,0BAAA;EFx8LJ;EE28LE;IACE,0BAAA;EFz8LJ;EE48LE;IACE,2BAAA;EF18LJ;EE68LE;IACE,2BAAA;EF38LJ;EE88LE;IACE,2BAAA;EF58LJ;EE+8LE;IACE,2BAAA;EF78LJ;EEg9LE;IACE,2BAAA;EF98LJ;EEi9LE;IACE,2BAAA;EF/8LJ;EEk9LE;IACE,2BAAA;EFh9LJ;EEm9LE;IACE,2BAAA;EFj9LJ;EEo9LE;IACE,2BAAA;EFl9LJ;EEq9LE;IACE,2BAAA;EFn9LJ;EEs9LE;IACE,2BAAA;EFp9LJ;EEu9LE;IACE,2BAAA;EFr9LJ;EEw9LE;IACE,2BAAA;EFt9LJ;EEy9LE;IACE,2BAAA;EFv9LJ;EE09LE;IACE,2BAAA;EFx9LJ;EE29LE;IACE,2BAAA;EFz9LJ;EE49LE;IACE,2BAAA;EF19LJ;EE69LE;IACE,2BAAA;EF39LJ;EE89LE;IACE,2BAAA;EF59LJ;EE+9LE;IACE,2BAAA;EF79LJ;EEg+LE;IACE,2BAAA;EF99LJ;AACF;AEi+LE;EACE,0BAAA;AF/9LJ;AEk+LE;EACE,2BAAA;AFh+LJ;AEm+LE;EACE,4BAAA;AFj+LJ;AEo+LE;EACE;IACE,0BAAA;EFl+LJ;EEq+LE;IACE,2BAAA;EFn+LJ;EEs+LE;IACE,4BAAA;EFp+LJ;AACF;AEu+LE;EACE;IACE,0BAAA;EFr+LJ;EEw+LE;IACE,2BAAA;EFt+LJ;EEy+LE;IACE,4BAAA;EFv+LJ;AACF;AE0+LE;EACE;IACE,0BAAA;EFx+LJ;EE2+LE;IACE,2BAAA;EFz+LJ;EE4+LE;IACE,4BAAA;EF1+LJ;AACF;AE6+LE;EACE;IACE,0BAAA;EF3+LJ;EE8+LE;IACE,2BAAA;EF5+LJ;EE++LE;IACE,4BAAA;EF7+LJ;AACF;AEg/LE;EACE,0BAAA;AF9+LJ;AEi/LE;EACE,2BAAA;AF/+LJ;AEk/LE;EACE,4BAAA;AFh/LJ;AEm/LE;EACE,kCAAA;AFj/LJ;AEo/LE;EACE,kCAAA;AFl/LJ;AEq/LE;EACE,uCAAA;EACA,kCAAA;AFn/LJ;AEs/LE;EACE,2BAAA;AFp/LJ;AEu/LE;EACE,2BAAA;AFr/LJ;AEw/LE;EACE,2BAAA;AFt/LJ;AEy/LE;EACE,2BAAA;AFv/LJ;AE0/LE;EACE,2BAAA;AFx/LJ;AE2/LE;EACE,2BAAA;AFz/LJ;AE4/LE;EACE,2BAAA;AF1/LJ;AE6/LE;EACE,2BAAA;AF3/LJ;AE8/LE;EACE,2BAAA;AF5/LJ;AE+/LE;EACE,4BAAA;AF7/LJ;AEggME;EACE,4BAAA;AF9/LJ;AEigME;EACE,4BAAA;AF//LJ;AEkgME;EACE,4BAAA;AFhgMJ;AEmgME;EACE,4BAAA;AFjgMJ;AEogME;EACE,4BAAA;AFlgMJ;AEqgME;EACE,4BAAA;AFngMJ;AEsgME;EACE,4BAAA;AFpgMJ;AEugME;EACE,4BAAA;AFrgMJ;AEwgME;EACE,4BAAA;AFtgMJ;AEygME;EACE,4BAAA;AFvgMJ;AE0gME;EACE,4BAAA;AFxgMJ;AE2gME;EACE,4BAAA;AFzgMJ;AE4gME;EACE,4BAAA;AF1gMJ;AE6gME;EACE,4BAAA;AF3gMJ;AE8gME;EACE,4BAAA;AF5gMJ;AE+gME;EACE,4BAAA;AF7gMJ;AEghME;EACE,4BAAA;AF9gMJ;AEihME;EACE,4BAAA;AF/gMJ;AEkhME;EACE,4BAAA;AFhhMJ;AEmhME;EACE,4BAAA;AFjhMJ;AEohME;EACE;IACE,0BAAA;EFlhMJ;EEqhME;IACE,2BAAA;EFnhMJ;EEshME;IACE,4BAAA;EFphMJ;EEuhME;IACE,kCAAA;EFrhMJ;EEwhME;IACE,kCAAA;EFthMJ;EEyhME;IACE,uCAAA;IACA,kCAAA;EFvhMJ;EE0hME;IACE,2BAAA;EFxhMJ;EE2hME;IACE,2BAAA;EFzhMJ;EE4hME;IACE,2BAAA;EF1hMJ;EE6hME;IACE,2BAAA;EF3hMJ;EE8hME;IACE,2BAAA;EF5hMJ;EE+hME;IACE,2BAAA;EF7hMJ;EEgiME;IACE,2BAAA;EF9hMJ;EEiiME;IACE,2BAAA;EF/hMJ;EEkiME;IACE,2BAAA;EFhiMJ;EEmiME;IACE,4BAAA;EFjiMJ;EEoiME;IACE,4BAAA;EFliMJ;EEqiME;IACE,4BAAA;EFniMJ;EEsiME;IACE,4BAAA;EFpiMJ;EEuiME;IACE,4BAAA;EFriMJ;EEwiME;IACE,4BAAA;EFtiMJ;EEyiME;IACE,4BAAA;EFviMJ;EE0iME;IACE,4BAAA;EFxiMJ;EE2iME;IACE,4BAAA;EFziMJ;EE4iME;IACE,4BAAA;EF1iMJ;EE6iME;IACE,4BAAA;EF3iMJ;EE8iME;IACE,4BAAA;EF5iMJ;EE+iME;IACE,4BAAA;EF7iMJ;EEgjME;IACE,4BAAA;EF9iMJ;EEijME;IACE,4BAAA;EF/iMJ;EEkjME;IACE,4BAAA;EFhjMJ;EEmjME;IACE,4BAAA;EFjjMJ;EEojME;IACE,4BAAA;EFljMJ;EEqjME;IACE,4BAAA;EFnjMJ;EEsjME;IACE,4BAAA;EFpjMJ;EEujME;IACE,4BAAA;EFrjMJ;AACF;AEwjME;EACE;IACE,0BAAA;EFtjMJ;EEyjME;IACE,2BAAA;EFvjMJ;EE0jME;IACE,4BAAA;EFxjMJ;EE2jME;IACE,kCAAA;EFzjMJ;EE4jME;IACE,kCAAA;EF1jMJ;EE6jME;IACE,uCAAA;IACA,kCAAA;EF3jMJ;EE8jME;IACE,2BAAA;EF5jMJ;EE+jME;IACE,2BAAA;EF7jMJ;EEgkME;IACE,2BAAA;EF9jMJ;EEikME;IACE,2BAAA;EF/jMJ;EEkkME;IACE,2BAAA;EFhkMJ;EEmkME;IACE,2BAAA;EFjkMJ;EEokME;IACE,2BAAA;EFlkMJ;EEqkME;IACE,2BAAA;EFnkMJ;EEskME;IACE,2BAAA;EFpkMJ;EEukME;IACE,4BAAA;EFrkMJ;EEwkME;IACE,4BAAA;EFtkMJ;EEykME;IACE,4BAAA;EFvkMJ;EE0kME;IACE,4BAAA;EFxkMJ;EE2kME;IACE,4BAAA;EFzkMJ;EE4kME;IACE,4BAAA;EF1kMJ;EE6kME;IACE,4BAAA;EF3kMJ;EE8kME;IACE,4BAAA;EF5kMJ;EE+kME;IACE,4BAAA;EF7kMJ;EEglME;IACE,4BAAA;EF9kMJ;EEilME;IACE,4BAAA;EF/kMJ;EEklME;IACE,4BAAA;EFhlMJ;EEmlME;IACE,4BAAA;EFjlMJ;EEolME;IACE,4BAAA;EFllMJ;EEqlME;IACE,4BAAA;EFnlMJ;EEslME;IACE,4BAAA;EFplMJ;EEulME;IACE,4BAAA;EFrlMJ;EEwlME;IACE,4BAAA;EFtlMJ;EEylME;IACE,4BAAA;EFvlMJ;EE0lME;IACE,4BAAA;EFxlMJ;EE2lME;IACE,4BAAA;EFzlMJ;AACF;AE4lME;EACE;IACE,0BAAA;EF1lMJ;EE6lME;IACE,2BAAA;EF3lMJ;EE8lME;IACE,4BAAA;EF5lMJ;EE+lME;IACE,kCAAA;EF7lMJ;EEgmME;IACE,kCAAA;EF9lMJ;EEimME;IACE,uCAAA;IACA,kCAAA;EF/lMJ;EEkmME;IACE,2BAAA;EFhmMJ;EEmmME;IACE,2BAAA;EFjmMJ;EEomME;IACE,2BAAA;EFlmMJ;EEqmME;IACE,2BAAA;EFnmMJ;EEsmME;IACE,2BAAA;EFpmMJ;EEumME;IACE,2BAAA;EFrmMJ;EEwmME;IACE,2BAAA;EFtmMJ;EEymME;IACE,2BAAA;EFvmMJ;EE0mME;IACE,2BAAA;EFxmMJ;EE2mME;IACE,4BAAA;EFzmMJ;EE4mME;IACE,4BAAA;EF1mMJ;EE6mME;IACE,4BAAA;EF3mMJ;EE8mME;IACE,4BAAA;EF5mMJ;EE+mME;IACE,4BAAA;EF7mMJ;EEgnME;IACE,4BAAA;EF9mMJ;EEinME;IACE,4BAAA;EF/mMJ;EEknME;IACE,4BAAA;EFhnMJ;EEmnME;IACE,4BAAA;EFjnMJ;EEonME;IACE,4BAAA;EFlnMJ;EEqnME;IACE,4BAAA;EFnnMJ;EEsnME;IACE,4BAAA;EFpnMJ;EEunME;IACE,4BAAA;EFrnMJ;EEwnME;IACE,4BAAA;EFtnMJ;EEynME;IACE,4BAAA;EFvnMJ;EE0nME;IACE,4BAAA;EFxnMJ;EE2nME;IACE,4BAAA;EFznMJ;EE4nME;IACE,4BAAA;EF1nMJ;EE6nME;IACE,4BAAA;EF3nMJ;EE8nME;IACE,4BAAA;EF5nMJ;EE+nME;IACE,4BAAA;EF7nMJ;AACF;AEgoME;EACE;IACE,0BAAA;EF9nMJ;EEioME;IACE,2BAAA;EF/nMJ;EEkoME;IACE,4BAAA;EFhoMJ;EEmoME;IACE,kCAAA;EFjoMJ;EEooME;IACE,kCAAA;EFloMJ;EEqoME;IACE,uCAAA;IACA,kCAAA;EFnoMJ;EEsoME;IACE,2BAAA;EFpoMJ;EEuoME;IACE,2BAAA;EFroMJ;EEwoME;IACE,2BAAA;EFtoMJ;EEyoME;IACE,2BAAA;EFvoMJ;EE0oME;IACE,2BAAA;EFxoMJ;EE2oME;IACE,2BAAA;EFzoMJ;EE4oME;IACE,2BAAA;EF1oMJ;EE6oME;IACE,2BAAA;EF3oMJ;EE8oME;IACE,2BAAA;EF5oMJ;EE+oME;IACE,4BAAA;EF7oMJ;EEgpME;IACE,4BAAA;EF9oMJ;EEipME;IACE,4BAAA;EF/oMJ;EEkpME;IACE,4BAAA;EFhpMJ;EEmpME;IACE,4BAAA;EFjpMJ;EEopME;IACE,4BAAA;EFlpMJ;EEqpME;IACE,4BAAA;EFnpMJ;EEspME;IACE,4BAAA;EFppMJ;EEupME;IACE,4BAAA;EFrpMJ;EEwpME;IACE,4BAAA;EFtpMJ;EEypME;IACE,4BAAA;EFvpMJ;EE0pME;IACE,4BAAA;EFxpMJ;EE2pME;IACE,4BAAA;EFzpMJ;EE4pME;IACE,4BAAA;EF1pMJ;EE6pME;IACE,4BAAA;EF3pMJ;EE8pME;IACE,4BAAA;EF5pMJ;EE+pME;IACE,4BAAA;EF7pMJ;EEgqME;IACE,4BAAA;EF9pMJ;EEiqME;IACE,4BAAA;EF/pMJ;EEkqME;IACE,4BAAA;EFhqMJ;EEmqME;IACE,4BAAA;EFjqMJ;AACF;AEoqME;EACE,2BAAA;AFlqMJ;AEqqME;EACE,0BAAA;AFnqMJ;AEsqME;EACE,6BAAA;AFpqMJ;AEuqME;EACE,6BAAA;AFrqMJ;AEwqME;EACE,2BAAA;AFtqMJ;AEyqME;EACE;IACE,2BAAA;EFvqMJ;EE0qME;IACE,0BAAA;EFxqMJ;EE2qME;IACE,6BAAA;EFzqMJ;EE4qME;IACE,6BAAA;EF1qMJ;EE6qME;IACE,2BAAA;EF3qMJ;AACF;AE8qME;EACE;IACE,2BAAA;EF5qMJ;EE+qME;IACE,0BAAA;EF7qMJ;EEgrME;IACE,6BAAA;EF9qMJ;EEirME;IACE,6BAAA;EF/qMJ;EEkrME;IACE,2BAAA;EFhrMJ;AACF;AEmrME;EACE;IACE,2BAAA;EFjrMJ;EEorME;IACE,0BAAA;EFlrMJ;EEqrME;IACE,6BAAA;EFnrMJ;EEsrME;IACE,6BAAA;EFprMJ;EEurME;IACE,2BAAA;EFrrMJ;AACF;AEwrME;EACE;IACE,2BAAA;EFtrMJ;EEyrME;IACE,0BAAA;EFvrMJ;EE0rME;IACE,6BAAA;EFxrMJ;EE2rME;IACE,6BAAA;EFzrMJ;EE4rME;IACE,2BAAA;EF1rMJ;AACF;AE6rME;EACE,oBAAA;AF3rMJ;AE8rME;EACE,iBAAA;AF5rMJ;AE+rME;EACE,mBAAA;AF7rMJ;AEgsME;EACE,oBAAA;AF9rMJ;AEisME;EACE;IACE,oBAAA;EF/rMJ;EEksME;IACE,iBAAA;EFhsMJ;EEmsME;IACE,mBAAA;EFjsMJ;EEosME;IACE,oBAAA;EFlsMJ;AACF;AEqsME;EACE;IACE,oBAAA;EFnsMJ;EEssME;IACE,iBAAA;EFpsMJ;EEusME;IACE,mBAAA;EFrsMJ;EEwsME;IACE,oBAAA;EFtsMJ;AACF;AEysME;EACE;IACE,oBAAA;EFvsMJ;EE0sME;IACE,iBAAA;EFxsMJ;EE2sME;IACE,mBAAA;EFzsMJ;EE4sME;IACE,oBAAA;EF1sMJ;AACF;AE6sME;EACE;IACE,oBAAA;EF3sMJ;EE8sME;IACE,iBAAA;EF5sMJ;EE+sME;IACE,mBAAA;EF7sMJ;EEgtME;IACE,oBAAA;EF9sMJ;AACF;AEitME;EACE,qBAAA;AF/sMJ;AEktME;EACE,kBAAA;AFhtMJ;AEmtME;EACE,oBAAA;AFjtMJ;AEotME;EACE,qBAAA;AFltMJ;AEqtME;EACE;IACE,qBAAA;EFntMJ;EEstME;IACE,kBAAA;EFptMJ;EEutME;IACE,oBAAA;EFrtMJ;EEwtME;IACE,qBAAA;EFttMJ;AACF;AEytME;EACE;IACE,qBAAA;EFvtMJ;EE0tME;IACE,kBAAA;EFxtMJ;EE2tME;IACE,oBAAA;EFztMJ;EE4tME;IACE,qBAAA;EF1tMJ;AACF;AE6tME;EACE;IACE,qBAAA;EF3tMJ;EE8tME;IACE,kBAAA;EF5tMJ;EE+tME;IACE,oBAAA;EF7tMJ;EEguME;IACE,qBAAA;EF9tMJ;AACF;AEiuME;EACE;IACE,qBAAA;EF/tMJ;EEkuME;IACE,kBAAA;EFhuMJ;EEmuME;IACE,oBAAA;EFjuMJ;EEouME;IACE,qBAAA;EFluMJ;AACF;AEquME;EACE,sBAAA;AFnuMJ;AEsuME;EACE,mBAAA;AFpuMJ;AEuuME;EACE,qBAAA;AFruMJ;AEwuME;EACE,sBAAA;AFtuMJ;AEyuME;EACE;IACE,sBAAA;EFvuMJ;EE0uME;IACE,mBAAA;EFxuMJ;EE2uME;IACE,qBAAA;EFzuMJ;EE4uME;IACE,sBAAA;EF1uMJ;AACF;AE6uME;EACE;IACE,sBAAA;EF3uMJ;EE8uME;IACE,mBAAA;EF5uMJ;EE+uME;IACE,qBAAA;EF7uMJ;EEgvME;IACE,sBAAA;EF9uMJ;AACF;AEivME;EACE;IACE,sBAAA;EF/uMJ;EEkvME;IACE,mBAAA;EFhvMJ;EEmvME;IACE,qBAAA;EFjvMJ;EEovME;IACE,sBAAA;EFlvMJ;AACF;AEqvME;EACE;IACE,sBAAA;EFnvMJ;EEsvME;IACE,mBAAA;EFpvMJ;EEuvME;IACE,qBAAA;EFrvMJ;EEwvME;IACE,sBAAA;EFtvMJ;AACF;AEyvME;EACE,uBAAA;AFvvMJ;AE0vME;EACE,oBAAA;AFxvMJ;AE2vME;EACE,sBAAA;AFzvMJ;AE4vME;EACE,uBAAA;AF1vMJ;AE6vME;EACE;IACE,uBAAA;EF3vMJ;EE8vME;IACE,oBAAA;EF5vMJ;EE+vME;IACE,sBAAA;EF7vMJ;EEgwME;IACE,uBAAA;EF9vMJ;AACF;AEiwME;EACE;IACE,uBAAA;EF/vMJ;EEkwME;IACE,oBAAA;EFhwMJ;EEmwME;IACE,sBAAA;EFjwMJ;EEowME;IACE,uBAAA;EFlwMJ;AACF;AEqwME;EACE;IACE,uBAAA;EFnwMJ;EEswME;IACE,oBAAA;EFpwMJ;EEuwME;IACE,sBAAA;EFrwMJ;EEwwME;IACE,uBAAA;EFtwMJ;AACF;AEywME;EACE;IACE,uBAAA;EFvwMJ;EE0wME;IACE,oBAAA;EFxwMJ;EE2wME;IACE,sBAAA;EFzwMJ;EE4wME;IACE,uBAAA;EF1wMJ;AACF;AE6wME;EACE,yBAAA;AF3wMJ;AE8wME;EACE,2BAAA;AF5wMJ;AE+wME;EACE,4BAAA;AF7wMJ;AEgxME;EACE,2BAAA;AF9wMJ;AEixME;EACE;IACE,yBAAA;EF/wMJ;EEkxME;IACE,2BAAA;EFhxMJ;EEmxME;IACE,4BAAA;EFjxMJ;EEoxME;IACE,2BAAA;EFlxMJ;AACF;AEqxME;EACE;IACE,yBAAA;EFnxMJ;EEsxME;IACE,2BAAA;EFpxMJ;EEuxME;IACE,4BAAA;EFrxMJ;EEwxME;IACE,2BAAA;EFtxMJ;AACF;AEyxME;EACE;IACE,yBAAA;EFvxMJ;EE0xME;IACE,2BAAA;EFxxMJ;EE2xME;IACE,4BAAA;EFzxMJ;EE4xME;IACE,2BAAA;EF1xMJ;AACF;AE6xME;EACE;IACE,yBAAA;EF3xMJ;EE8xME;IACE,2BAAA;EF5xMJ;EE+xME;IACE,4BAAA;EF7xMJ;EEgyME;IACE,2BAAA;EF9xMJ;AACF;AEiyME;EACE,2BAAA;AF/xMJ;AEkyME;EACE,6BAAA;AFhyMJ;AEmyME;EACE,8BAAA;AFjyMJ;AEoyME;EACE,6BAAA;AFlyMJ;AEqyME;EACE;IACE,2BAAA;EFnyMJ;EEsyME;IACE,6BAAA;EFpyMJ;EEuyME;IACE,8BAAA;EFryMJ;EEwyME;IACE,6BAAA;EFtyMJ;AACF;AEyyME;EACE;IACE,2BAAA;EFvyMJ;EE0yME;IACE,6BAAA;EFxyMJ;EE2yME;IACE,8BAAA;EFzyMJ;EE4yME;IACE,6BAAA;EF1yMJ;AACF;AE6yME;EACE;IACE,2BAAA;EF3yMJ;EE8yME;IACE,6BAAA;EF5yMJ;EE+yME;IACE,8BAAA;EF7yMJ;EEgzME;IACE,6BAAA;EF9yMJ;AACF;AEizME;EACE;IACE,2BAAA;EF/yMJ;EEkzME;IACE,6BAAA;EFhzMJ;EEmzME;IACE,8BAAA;EFjzMJ;EEozME;IACE,6BAAA;EFlzMJ;AACF;AEqzME;EACE,2BAAA;AFnzMJ;AEszME;EACE,6BAAA;AFpzMJ;AEuzME;EACE,8BAAA;AFrzMJ;AEwzME;EACE,6BAAA;AFtzMJ;AEyzME;EACE;IACE,2BAAA;EFvzMJ;EE0zME;IACE,6BAAA;EFxzMJ;EE2zME;IACE,8BAAA;EFzzMJ;EE4zME;IACE,6BAAA;EF1zMJ;AACF;AE6zME;EACE;IACE,2BAAA;EF3zMJ;EE8zME;IACE,6BAAA;EF5zMJ;EE+zME;IACE,8BAAA;EF7zMJ;EEg0ME;IACE,6BAAA;EF9zMJ;AACF;AEi0ME;EACE;IACE,2BAAA;EF/zMJ;EEk0ME;IACE,6BAAA;EFh0MJ;EEm0ME;IACE,8BAAA;EFj0MJ;EEo0ME;IACE,6BAAA;EFl0MJ;AACF;AEq0ME;EACE;IACE,2BAAA;EFn0MJ;EEs0ME;IACE,6BAAA;EFp0MJ;EEu0ME;IACE,8BAAA;EFr0MJ;EEw0ME;IACE,6BAAA;EFt0MJ;AACF;AEy0ME;EACE,wBAAA;AFv0MJ;AE00ME;EACE,qBAAA;AFx0MJ;AE20ME;EACE,qBAAA;AFz0MJ;AE40ME;EACE,qBAAA;AF10MJ;AE60ME;EACE,qBAAA;AF30MJ;AE80ME;EACE,qBAAA;AF50MJ;AE+0ME;EACE,qBAAA;AF70MJ;AEg1ME;EACE;IACE,wBAAA;EF90MJ;EEi1ME;IACE,qBAAA;EF/0MJ;EEk1ME;IACE,qBAAA;EFh1MJ;EEm1ME;IACE,qBAAA;EFj1MJ;EEo1ME;IACE,qBAAA;EFl1MJ;EEq1ME;IACE,qBAAA;EFn1MJ;EEs1ME;IACE,qBAAA;EFp1MJ;AACF;AEu1ME;EACE;IACE,wBAAA;EFr1MJ;EEw1ME;IACE,qBAAA;EFt1MJ;EEy1ME;IACE,qBAAA;EFv1MJ;EE01ME;IACE,qBAAA;EFx1MJ;EE21ME;IACE,qBAAA;EFz1MJ;EE41ME;IACE,qBAAA;EF11MJ;EE61ME;IACE,qBAAA;EF31MJ;AACF;AE81ME;EACE;IACE,wBAAA;EF51MJ;EE+1ME;IACE,qBAAA;EF71MJ;EEg2ME;IACE,qBAAA;EF91MJ;EEi2ME;IACE,qBAAA;EF/1MJ;EEk2ME;IACE,qBAAA;EFh2MJ;EEm2ME;IACE,qBAAA;EFj2MJ;EEo2ME;IACE,qBAAA;EFl2MJ;AACF;AEq2ME;EACE;IACE,wBAAA;EFn2MJ;EEs2ME;IACE,qBAAA;EFp2MJ;EEu2ME;IACE,qBAAA;EFr2MJ;EEw2ME;IACE,qBAAA;EFt2MJ;EEy2ME;IACE,qBAAA;EFv2MJ;EE02ME;IACE,qBAAA;EFx2MJ;EE22ME;IACE,qBAAA;EFz2MJ;AACF;AE42ME;EACE,oCAAA;AF12MJ;AE62ME;EACE,uCAAA;AF32MJ;AE82ME;EACE,sCAAA;AF52MJ;AE+2ME;EACE,sCAAA;AF72MJ;AEg3ME;EACE,mCAAA;AF92MJ;AEi3ME;EACE,mCAAA;AF/2MJ;AEk3ME;EACE;IACE,oCAAA;EFh3MJ;EEm3ME;IACE,uCAAA;EFj3MJ;EEo3ME;IACE,sCAAA;EFl3MJ;EEq3ME;IACE,sCAAA;EFn3MJ;EEs3ME;IACE,mCAAA;EFp3MJ;EEu3ME;IACE,mCAAA;EFr3MJ;AACF;AEw3ME;EACE;IACE,oCAAA;EFt3MJ;EEy3ME;IACE,uCAAA;EFv3MJ;EE03ME;IACE,sCAAA;EFx3MJ;EE23ME;IACE,sCAAA;EFz3MJ;EE43ME;IACE,mCAAA;EF13MJ;EE63ME;IACE,mCAAA;EF33MJ;AACF;AE83ME;EACE;IACE,oCAAA;EF53MJ;EE+3ME;IACE,uCAAA;EF73MJ;EEg4ME;IACE,sCAAA;EF93MJ;EEi4ME;IACE,sCAAA;EF/3MJ;EEk4ME;IACE,mCAAA;EFh4MJ;EEm4ME;IACE,mCAAA;EFj4MJ;AACF;AEo4ME;EACE;IACE,oCAAA;EFl4MJ;EEq4ME;IACE,uCAAA;EFn4MJ;EEs4ME;IACE,sCAAA;EFp4MJ;EEu4ME;IACE,sCAAA;EFr4MJ;EEw4ME;IACE,mCAAA;EFt4MJ;EEy4ME;IACE,mCAAA;EFv4MJ;AACF;AE04ME;EACE,gCAAA;AFx4MJ;AE24ME;EACE,iCAAA;AFz4MJ;AE44ME;EACE,mCAAA;AF14MJ;AE64ME;EACE;IACE,gCAAA;EF34MJ;EE84ME;IACE,iCAAA;EF54MJ;EE+4ME;IACE,mCAAA;EF74MJ;AACF;AEg5ME;EACE;IACE,gCAAA;EF94MJ;EEi5ME;IACE,iCAAA;EF/4MJ;EEk5ME;IACE,mCAAA;EFh5MJ;AACF;AEm5ME;EACE;IACE,gCAAA;EFj5MJ;EEo5ME;IACE,iCAAA;EFl5MJ;EEq5ME;IACE,mCAAA;EFn5MJ;AACF;AEs5ME;EACE;IACE,gCAAA;EFp5MJ;EEu5ME;IACE,iCAAA;EFr5MJ;EEw5ME;IACE,mCAAA;EFt5MJ;AACF;AEy5ME;EACE,sCAAA;AFv5MJ;AE05ME;EACE,sCAAA;AFx5MJ;AE25ME;EACE,oCAAA;AFz5MJ;AE45ME;EACE,2CAAA;AF15MJ;AE65ME;EACE,wCAAA;AF35MJ;AE85ME;EACE,qCAAA;AF55MJ;AE+5ME;EACE,4CAAA;AF75MJ;AEg6ME;EACE,yCAAA;AF95MJ;AEi6ME;EACE,mCAAA;AF/5MJ;AEk6ME;EACE;IACE,sCAAA;EFh6MJ;EEm6ME;IACE,sCAAA;EFj6MJ;EEo6ME;IACE,oCAAA;EFl6MJ;EEq6ME;IACE,2CAAA;EFn6MJ;EEs6ME;IACE,wCAAA;EFp6MJ;EEu6ME;IACE,qCAAA;EFr6MJ;EEw6ME;IACE,4CAAA;EFt6MJ;EEy6ME;IACE,yCAAA;EFv6MJ;EE06ME;IACE,mCAAA;EFx6MJ;AACF;AE26ME;EACE;IACE,sCAAA;EFz6MJ;EE46ME;IACE,sCAAA;EF16MJ;EE66ME;IACE,oCAAA;EF36MJ;EE86ME;IACE,2CAAA;EF56MJ;EE+6ME;IACE,wCAAA;EF76MJ;EEg7ME;IACE,qCAAA;EF96MJ;EEi7ME;IACE,4CAAA;EF/6MJ;EEk7ME;IACE,yCAAA;EFh7MJ;EEm7ME;IACE,mCAAA;EFj7MJ;AACF;AEo7ME;EACE;IACE,sCAAA;EFl7MJ;EEq7ME;IACE,sCAAA;EFn7MJ;EEs7ME;IACE,oCAAA;EFp7MJ;EEu7ME;IACE,2CAAA;EFr7MJ;EEw7ME;IACE,wCAAA;EFt7MJ;EEy7ME;IACE,qCAAA;EFv7MJ;EE07ME;IACE,4CAAA;EFx7MJ;EE27ME;IACE,yCAAA;EFz7MJ;EE47ME;IACE,mCAAA;EF17MJ;AACF;AE67ME;EACE;IACE,sCAAA;EF37MJ;EE87ME;IACE,sCAAA;EF57MJ;EE+7ME;IACE,oCAAA;EF77MJ;EEg8ME;IACE,2CAAA;EF97MJ;EEi8ME;IACE,wCAAA;EF/7MJ;EEk8ME;IACE,qCAAA;EFh8MJ;EEm8ME;IACE,4CAAA;EFj8MJ;EEo8ME;IACE,yCAAA;EFl8MJ;EEq8ME;IACE,mCAAA;EFn8MJ;AACF;AEs8ME;EACE,2BAAA;AFp8MJ;AEu8ME;EACE,2BAAA;AFr8MJ;AEw8ME;EACE,8BAAA;AFt8MJ;AEy8ME;EACE,2BAAA;AFv8MJ;AE08ME;EACE,wBAAA;AFx8MJ;AE28ME;EACE,+BAAA;AFz8MJ;AE48ME;EACE,+BAAA;AF18MJ;AE68ME;EACE,uBAAA;AF38MJ;AE88ME;EACE,0BAAA;AF58MJ;AE+8ME;EACE,uBAAA;AF78MJ;AEg9ME;EACE,uBAAA;AF98MJ;AEi9ME;EACE,oCAAA;EACA,4BAAA;AF/8MJ;AEk9ME;EACE,oCAAA;EACA,4BAAA;AFh9MJ;AEm9ME;EACE,mCAAA;EACA,2BAAA;AFj9MJ;AEo9ME;EACE,oCAAA;EACA,4BAAA;AFl9MJ;AEq9ME;EACE,qBAAA;AFn9MJ;AEs9ME;EACE,uBAAA;AFp9MJ;AEu9ME;EACE,uBAAA;AFr9MJ;AEw9ME;EACE,uBAAA;AFt9MJ;AEy9ME;EACE,uBAAA;AFv9MJ;AE09ME;EACE,uBAAA;AFx9MJ;AE29ME;EACE,uBAAA;AFz9MJ;AE49ME;EACE,uBAAA;AF19MJ;AE69ME;EACE,uBAAA;AF39MJ;AE89ME;EACE,uBAAA;AF59MJ;AE+9ME;EACE,qBAAA;AF79MJ;AEg+ME;EACE,UAAA;AF99MJ;AEi+ME;EACE,oCAAA;AF/9MJ;AEk+ME;EACE,mCAAA;AFh+MJ;AEm+ME;EACE,qEAAA;AFj+MJ;AEo+ME;EACE,yCAAA;AFl+MJ;AEq+ME;EACE,oCAAA;AFn+MJ;AEs+ME;EACE,qCAAA;AFp+MJ;AEu+ME;EACE,oCAAA;AFr+MJ;AEw+ME;EACE,oCAAA;AFt+MJ;AEy+ME;EACE,oCAAA;AFv+MJ;AE0+ME;EACE,oCAAA;AFx+MJ;AE2+ME;EACE,kCAAA;AFz+MJ;AE4+ME;EACE,kCAAA;AF1+MJ;AE6+ME;EACE,kCAAA;AF3+MJ;AE8+ME;EACE,6CAAA;AF5+MJ;AE++ME;EACE,iEAAA;AF7+MJ;AEg/ME;EACE,iEAAA;AF9+MJ;AEi/ME;EACE,mEAAA;AF/+MJ;AEk/ME;EACE,iCAAA;AFh/MJ;AEm/ME;EACE,kCAAA;AFj/MJ;AEo/ME;EACE,iCAAA;AFl/MJ;AEq/ME;EACE,iCAAA;AFn/MJ;AEs/ME;EACE,iCAAA;AFp/MJ;AEu/ME;EACE,iCAAA;AFr/MJ;AEw/ME;EACE,+BAAA;AFt/MJ;AEy/ME;EACE,kCAAA;AFv/MJ;AE0/ME;EACE,qCAAA;AFx/MJ;AE2/ME;EACE,sCAAA;AFz/MJ;AE4/ME;EACE,mCAAA;AF1/MJ;AE6/ME;EACE,sCAAA;AF3/MJ;AE8/ME;EACE,uCAAA;AF5/MJ;AE+/ME;EACE;IACE,kCAAA;EF7/MJ;EEggNE;IACE,qCAAA;EF9/MJ;EEigNE;IACE,sCAAA;EF//MJ;EEkgNE;IACE,mCAAA;EFhgNJ;EEmgNE;IACE,sCAAA;EFjgNJ;EEogNE;IACE,uCAAA;EFlgNJ;AACF;AEqgNE;EACE;IACE,kCAAA;EFngNJ;EEsgNE;IACE,qCAAA;EFpgNJ;EEugNE;IACE,sCAAA;EFrgNJ;EEwgNE;IACE,mCAAA;EFtgNJ;EEygNE;IACE,sCAAA;EFvgNJ;EE0gNE;IACE,uCAAA;EFxgNJ;AACF;AE2gNE;EACE;IACE,kCAAA;EFzgNJ;EE4gNE;IACE,qCAAA;EF1gNJ;EE6gNE;IACE,sCAAA;EF3gNJ;EE8gNE;IACE,mCAAA;EF5gNJ;EE+gNE;IACE,sCAAA;EF7gNJ;EEghNE;IACE,uCAAA;EF9gNJ;AACF;AEihNE;EACE;IACE,kCAAA;EF/gNJ;EEkhNE;IACE,qCAAA;EFhhNJ;EEmhNE;IACE,sCAAA;EFjhNJ;EEohNE;IACE,mCAAA;EFlhNJ;EEqhNE;IACE,sCAAA;EFnhNJ;EEshNE;IACE,uCAAA;EFphNJ;AACF;AEuhNE;EACE,mCAAA;AFrhNJ;AEwhNE;EACE,oCAAA;AFthNJ;AEyhNE;EACE,mCAAA;AFvhNJ;AE0hNE;EACE,oCAAA;AFxhNJ;AE2hNE;EACE,oCAAA;AFzhNJ;AE4hNE;EACE,qCAAA;AF1hNJ;AE6hNE;EACE;IACE,mCAAA;EF3hNJ;EE8hNE;IACE,oCAAA;EF5hNJ;EE+hNE;IACE,mCAAA;EF7hNJ;EEgiNE;IACE,oCAAA;EF9hNJ;EEiiNE;IACE,oCAAA;EF/hNJ;EEkiNE;IACE,qCAAA;EFhiNJ;AACF;AEmiNE;EACE;IACE,mCAAA;EFjiNJ;EEoiNE;IACE,oCAAA;EFliNJ;EEqiNE;IACE,mCAAA;EFniNJ;EEsiNE;IACE,oCAAA;EFpiNJ;EEuiNE;IACE,oCAAA;EFriNJ;EEwiNE;IACE,qCAAA;EFtiNJ;AACF;AEyiNE;EACE;IACE,mCAAA;EFviNJ;EE0iNE;IACE,oCAAA;EFxiNJ;EE2iNE;IACE,mCAAA;EFziNJ;EE4iNE;IACE,oCAAA;EF1iNJ;EE6iNE;IACE,oCAAA;EF3iNJ;EE8iNE;IACE,qCAAA;EF5iNJ;AACF;AE+iNE;EACE;IACE,mCAAA;EF7iNJ;EEgjNE;IACE,oCAAA;EF9iNJ;EEijNE;IACE,mCAAA;EF/iNJ;EEkjNE;IACE,oCAAA;EFhjNJ;EEmjNE;IACE,oCAAA;EFjjNJ;EEojNE;IACE,qCAAA;EFljNJ;AACF;AEqjNE;EACE,mCAAA;AFnjNJ;AEsjNE;EACE,gCAAA;AFpjNJ;AEujNE;EACE,sCAAA;AFrjNJ;AEwjNE;EACE,kCAAA;AFtjNJ;AEyjNE;EACE,yCAAA;AFvjNJ;AE0jNE;EACE,mCAAA;AFxjNJ;AE2jNE;EACE,wCAAA;AFzjNJ;AE4jNE;EACE,iCAAA;AF1jNJ;AE6jNE;EACE,qCAAA;AF3jNJ;AE8jNE;EACE;IACE,mCAAA;EF5jNJ;EE+jNE;IACE,gCAAA;EF7jNJ;EEgkNE;IACE,sCAAA;EF9jNJ;EEikNE;IACE,kCAAA;EF/jNJ;EEkkNE;IACE,yCAAA;EFhkNJ;EEmkNE;IACE,mCAAA;EFjkNJ;EEokNE;IACE,wCAAA;EFlkNJ;EEqkNE;IACE,iCAAA;EFnkNJ;EEskNE;IACE,qCAAA;EFpkNJ;AACF;AEukNE;EACE;IACE,mCAAA;EFrkNJ;EEwkNE;IACE,gCAAA;EFtkNJ;EEykNE;IACE,sCAAA;EFvkNJ;EE0kNE;IACE,kCAAA;EFxkNJ;EE2kNE;IACE,yCAAA;EFzkNJ;EE4kNE;IACE,mCAAA;EF1kNJ;EE6kNE;IACE,wCAAA;EF3kNJ;EE8kNE;IACE,iCAAA;EF5kNJ;EE+kNE;IACE,qCAAA;EF7kNJ;AACF;AEglNE;EACE;IACE,mCAAA;EF9kNJ;EEilNE;IACE,gCAAA;EF/kNJ;EEklNE;IACE,sCAAA;EFhlNJ;EEmlNE;IACE,kCAAA;EFjlNJ;EEolNE;IACE,yCAAA;EFllNJ;EEqlNE;IACE,mCAAA;EFnlNJ;EEslNE;IACE,wCAAA;EFplNJ;EEulNE;IACE,iCAAA;EFrlNJ;EEwlNE;IACE,qCAAA;EFtlNJ;AACF;AEylNE;EACE;IACE,mCAAA;EFvlNJ;EE0lNE;IACE,gCAAA;EFxlNJ;EE2lNE;IACE,sCAAA;EFzlNJ;EE4lNE;IACE,kCAAA;EF1lNJ;EE6lNE;IACE,yCAAA;EF3lNJ;EE8lNE;IACE,mCAAA;EF5lNJ;EE+lNE;IACE,wCAAA;EF7lNJ;EEgmNE;IACE,iCAAA;EF9lNJ;EEimNE;IACE,qCAAA;EF/lNJ;AACF;AEkmNE;EACE;IACE,UAAA;EFhmNJ;EEmmNE;IACE,UAAA;EFjmNJ;AACF;AEomNE;EACE;IACE,UAAA;EFlmNJ;EEqmNE;IACE,UAAA;EFnmNJ;AACF;AEsmNE;EACE;IACE,UAAA;IACA,sBAAA;IACA,gGAAA;EFpmNJ;EEumNE;IACE,UAAA;IACA,oBAAA;EFrmNJ;AACF;AEwmNE;EACE;IACE,aAAA;EFtmNJ;EEymNE;IACE,gBAAA;EFvmNJ;AACF;AE0mNE;EACE;IACE,kBAAA;EFxmNJ;EE2mNE;IACE,aAAA;EFzmNJ;AACF;AE4mNE;EACE;IACE,UAAA;IACA,2BAAA;IACA,gGAAA;EF1mNJ;EE6mNE;IACE,UAAA;IACA,uBAAA;EF3mNJ;AACF;AE8mNE;EACE;IACE,UAAA;IACA,uBAAA;IACA,gGAAA;EF5mNJ;EE+mNE;IACE,UAAA;IACA,2BAAA;EF7mNJ;AACF;AEgnNE;EACE;IACE,UAAA;IACA,0BAAA;IACA,gGAAA;EF9mNJ;EEinNE;IACE,UAAA;IACA,uBAAA;EF/mNJ;AACF;AEknNE;EACE;IACE,UAAA;IACA,uBAAA;IACA,gGAAA;EFhnNJ;EEmnNE;IACE,UAAA;IACA,0BAAA;EFjnNJ;AACF;AEonNE;EACE;IACE,UAAA;IACA,4BAAA;IACA,gGAAA;EFlnNJ;EEqnNE;IACE,UAAA;IACA,wBAAA;EFnnNJ;AACF;AEsnNE;EACE;IACE,UAAA;IACA,wBAAA;IACA,gGAAA;EFpnNJ;EEunNE;IACE,UAAA;IACA,4BAAA;EFrnNJ;AACF;AEwnNE;EACE;IACE,UAAA;IACA,2BAAA;IACA,gGAAA;EFtnNJ;EEynNE;IACE,UAAA;IACA,wBAAA;EFvnNJ;AACF;AE0nNE;EACE;IACE,UAAA;IACA,wBAAA;IACA,gGAAA;EFxnNJ;EE2nNE;IACE,UAAA;IACA,2BAAA;EFznNJ;AACF;AE4nNE;EACE;IACE,QAAA;EF1nNJ;EE6nNE;IACE,WAAA;EF3nNJ;AACF;AE8nNE;EACE;IACE,+CAAA;EF5nNJ;EE+nNE;IACE,yCAAA;EF7nNJ;AACF;AEgoNE;EACE;IACE,+CAAA;IACA,UAAA;EF9nNJ;EEioNE;IACE,yCAAA;IACA,UAAA;EF/nNJ;AACF;AEkoNE;EACE;IACE,8CAAA;IACA,UAAA;EFhoNJ;EEmoNE;IACE,yCAAA;IACA,UAAA;EFjoNJ;AACF;AEooNE;EACE;IACE,+CAAA;IACA,UAAA;EFloNJ;EEqoNE;IACE,yCAAA;IACA,UAAA;EFnoNJ;AACF;AEsoNE;EACE;IACE,UAAA;IACA,iCAAA;EFpoNJ;EEuoNE;IACE,UAAA;EFroNJ;AACF;AEwoNE;EACE;IACE,UAAA;IACA,4DAAA;EFtoNJ;EEyoNE;IACE,UAAA;IACA,+DAAA;EFvoNJ;AACF;AE0oNE;EACE;IACE,UAAA;IACA,4DAAA;EFxoNJ;EE2oNE;IACE,UAAA;IACA,+DAAA;EFzoNJ;AACF;AE4oNE;EACE;IACE,UAAA;IACA,2DAAA;EF1oNJ;EE6oNE;IACE,UAAA;IACA,gEAAA;EF3oNJ;AACF;AE8oNE;EACE;IACE,UAAA;IACA,2DAAA;EF5oNJ;EE+oNE;IACE,UAAA;IACA,gEAAA;EF7oNJ;AACF;AEgpNE;EACE,8BAAA;AF9oNJ;AEipNE;EACE,+BAAA;AF/oNJ;AEkpNE;EACE,sCAAA;AFhpNJ;AEmpNE;EACE,iDAAA;AFjpNJ;AEopNE;EACE,+BAAA;AFlpNJ;AEqpNE;EACE,kCAAA;AFnpNJ;AEspNE;EACE,mCAAA;AFppNJ;AEupNE;EACE,mCAAA;AFrpNJ;AEwpNE;EACE,oCAAA;AFtpNJ;AEypNE;EACE,gCAAA;AFvpNJ;AE0pNE;EACE,iCAAA;AFxpNJ;AE2pNE;EACE,kCAAA;AFzpNJ;AE4pNE;EACE,mCAAA;AF1pNJ;AE6pNE;EACE,kCAAA;AF3pNJ;AE8pNE;EACE,4BAAA;EACA,4BAAA;AF5pNJ;AE+pNE;EACE,4BAAA;EACA,8BAAA;AF7pNJ;AEgqNE;EACE,4BAAA;EACA,gCAAA;AF9pNJ;AEiqNE;EACE,4BAAA;EACA,iCAAA;AF/pNJ;AEkqNE;EACE,8BAAA;AFhqNJ;AEmqNE;EACE,kCAAA;AFjqNJ;AEoqNE;EACE,kCAAA;AFlqNJ;AEqqNE;EACE,mCAAA;AFnqNJ;AEsqNE;EACE,gCAAA;AFpqNJ;AEuqNE;EACE,mCAAA;AFrqNJ;AEwqNE;EACE,oCAAA;AFtqNJ;AEyqNE;EACE,mCAAA;AFvqNJ;AE0qNE;EACE,mCAAA;AFxqNJ;AE2qNE;EACE,mCAAA;AFzqNJ;AE4qNE;EACE,mCAAA;AF1qNJ;AE6qNE;EACE,iCAAA;AF3qNJ;AE8qNE;EACE,iCAAA;AF5qNJ;AE+qNE;EACE,iCAAA;AF7qNJ;AEgrNE;EACE,gCAAA;AF9qNJ;AEirNE;EACE,iCAAA;AF/qNJ;AEkrNE;EACE,gCAAA;AFhrNJ;AEmrNE;EACE,gCAAA;AFjrNJ;AEorNE;EACE,gCAAA;AFlrNJ;AEqrNE;EACE,gCAAA;AFnrNJ;AEsrNE;EACE,8BAAA;AFprNJ;AEurNE;EACE,uCAAA;AFrrNJ;AEwrNE;EACE,uCAAA;AFtrNJ;AEyrNE;EACE,8CAAA;AFvrNJ;AE0rNE;EACE,4CAAA;AFxrNJ;AE2rNE;EACE,gEAAA;AFzrNJ;AE4rNE;EACE,gEAAA;AF1rNJ;AE6rNE;EACE,kEAAA;AF3rNJ;AE8rNE;EACE,oCAAA;AF5rNJ;AE+rNE;EACE,wCAAA;AF7rNJ;AEgsNE;EACE,yCAAA;AF9rNJ;AEisNE;EACE,oCAAA;AF/rNJ;AEksNE;EACE,mCAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AFhsNJ;AEmsNE;EACE,4BAAA;EACA,uBAAA;AFjsNJ;AEosNE;EACE,2BAAA;EACA,sBAAA;AFlsNJ;AEqsNE;EACE,6BAAA;EACA,wBAAA;AFnsNJ;AEssNE;EACE,gBAAA;EACA,eAAA;EACA,qBAAA;AFpsNJ;AEusNE;EACE,uBAAA;AFrsNJ;AEwsNE;EACE,sBAAA;AFtsNJ;AEysNE;EACE,wBAAA;AFvsNJ;AE0sNE;EACE,mCAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AFxsNJ;AE2sNE;EACE,4BAAA;EACA,uBAAA;AFzsNJ;AE4sNE;EACE,2BAAA;EACA,sBAAA;AF1sNJ;AE6sNE;EACE,6BAAA;EACA,wBAAA;AF3sNJ;AE8sNE;EACE,2BAAA;EACA,sBAAA;AF5sNJ;AE+sNE;EACE,6BAAA;EACA,wBAAA;AF7sNJ;AEgtNE;EACE,6BAAA;EACA,wBAAA;AF9sNJ;AEitNE;EACE,mCAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AF/sNJ;AEktNE;EACE,mBAAA;EACA,cAAA;AFhtNJ;AEmtNE;EACE,mBAAA;EACA,cAAA;AFjtNJ;AEotNE;EACE,mBAAA;EACA,cAAA;AFltNJ;AEqtNE;EACE,mBAAA;EACA,cAAA;AFntNJ;AEstNE;EACE,uCAAA;EACA,gBAAA;EACA,UAAA;EACA,mCAAA;EACA,cAAA;AFptNJ;AEutNE;EACE,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,wCAAA;AFrtNJ;;AGh/sBgC,0CAAA;AAqDhC;EACE,mBAAA;AH+7sBF;;AGr/sBgC,0CAAA;AAqDhC;EACE,mBAAA;AHo8sBF;;AG1/sBgC,0CAAA;AAqDhC;EACE,mBAAA;AHy8sBF;;AG//sBgC,0CAAA;AAqDhC;EACE,mBAAA;AH88sBF;;AI/gtBA;EACI,UDcmB;ECbnB,mBDcc;ECbd,+BDeqB;ECdrB,cDakB;ECZlB,kBDOU;AH2gtBd;AI9gtBY;ECuCR,uBF7B+B;EE8B/B,+BF5BiC;EE6BjC,gBF9BoC;EE+BpC,4BF9CgB;EE+ChB,yBAAA;UAAA,iBAAA;AL0+sBJ;AKx+sBI;EACI,+BFlC6B;AH4gtBrC;AKv+sBI;EACI,8BFrC6B;EEsC7B,oBFtDO;AH+htBf;AKt+sBI;EACI,+BF3C6B,EE2CgB,uCAAA;EAC7C,mBF3DO;AHmitBf;AKr+sBI;EACI,0BF5C2B;AHmhtBnC;AKr+sBQ;EACI,yBFjD8B;AHwhtB1C;AKp+sBQ;EACI,wBFpD8B;AH0htB1C;AKn+sBQ;EACI,wBFxD8B;AH6htB1C;AKj+sBI;EA1CA,eFjCU;EEkCV,iBFjCgB;EEkChB,gBFjCsB;AH+itB1B;AI5itBgB;;EAEI,0BDYgB;AHkitBpC;AI5itBoB;;EACI,+BDOmB;AHwitB3C;AI5itBoB;;EACI,8BDImB;AH2itB3C;AI5itBoB;;EACI,8BAAA;AJ+itBxB;AIxitBI;EClCA,qBFkCa;EEjCb,cFCM;EEAN,gBFiCkB;EEhClB,4BFEgB;EEDhB,yBAAA;UAAA,iBAAA;EACA,kBAAA;AL6ktBJ;AK3ktBI;EACI,cFNE;AHmltBV;AK1ktBI;EACI,cFVE;EEWF,oBFPO;AHmltBf;AKzktBI;EACI,cFfE;AH0ltBV;AKxktBI;EACI,mBFrBE;AH+ltBV;AKxktBQ;EACI,cFtBF;AHgmtBV;AKvktBQ;EACI,cF1BF;AHmmtBV;AKtktBQ;EACI,cF9BF;AHsmtBV;AKpktBI;EAMA,eFjCU;EEkCV,iBFjCgB;EEkChB,gBFjCsB;AHkmtB1B;AIvktBI;EACI,mBDxCE;ECyCF,cDtCE;ECuCF,qCDSW;ECRX,gBDSW;AHgktBnB;AItktBI;EACI,SDFa;ECGb,qBDFc;ECGd,cD9CE;EC+CF,mBDlDE;ECmDF,gBDFiB;ECGjB,4BDvCM;ECwCN,2BDxCM;AHgntBd;AIrktBI;EACI,iBDJa;ECKb,WD1BG;AHimtBX;AIrktBQ;EACI,6BD/CH;ECgDG,gBDPS;AH8ktBrB;AIpktBQ;EACI,SDZY;AHkltBxB;AIpktBY;EACI,SAAA;AJsktBhB;AI/jtBY;EACI,mBD5EN;AH6otBV;AI/jtBgB;EACI,cD7EV;AH8otBV;AI9jtBgB;EACI,cDjFV;AHiptBV;;AMrptBC;EACC,WAAA;EACA,aAAA;EACA,qBAAA;EAYA,6EAAA;EASA,8EAAA;ANqotBF;AMxptBE;EACC,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;AN0ptBH;AMtptBE;EACC,yCAAA;EACA,2CAAA;EACA,4CAAA;EACA,iBAAA;EACA,0BAAA;ANwptBH;AMpptBE;EACC,yCAAA;EACA,0CAAA;EACA,4CAAA;EACA,kBAAA;EACA,0BAAA;ANsptBH;AMnptBE;EACC,mBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;ANqptBH;AMlptBI;EACC,oCAAA;EACA,uCAAA;ANoptBL;AM/otBI;EACC,qCAAA;EACA,wCAAA;ANiptBL;AM5otBI;EACC,2BAAA;AN8otBL;;AOrstBI;;EAEI,kBAAA;EACA,UAAA;APwstBR;AOrstBI;EACI,aAAA;EACA,+BAAA;EACA,mBAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EAKA,gCAAA;APustBR;AOrstBQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EAKA,gCAAA;APustBZ;AOpstBQ;EACI,iBAAA;APsstBZ;AOrstBY;;EAEI,qBAAA;APustBhB;AOrstBY;EACI,oBAAA;APustBhB;AOrstBY;EACI,qBAAA;EACA,mBAAA;APustBhB;AOnstBI;EACI,2BAAA;APqstBR;AOlstBI;;;;;;EAMI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,wBAAA;EACA,+BAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EAKA,gCAAA;APostBR;AOjstBI;;;;;;EAMI,0BAAA;EACA,mBAAA;EACA,2BAAA;APmstBR;AOjstBI;;;;;;;;;;;;;;;;;;EAkBI,+BAAA;EACA,mBAAA;EACA,2BAAA;APmstBR;AOjstBI;;;;;;EAMI,yBAAA;EACA,oBAAA;EACA,oBAAA;APmstBR;AOhstBI;;;;;;EAMI,2BAAA;APkstBR;AOzrtBQ;;;;;;EACI,mBAAA;APgstBZ;AO9rtBY;;;;;;EACI,eAAA;EACA,qBAAA;EACA,gBAAA;APqstBhB;AOlstBY;;;;;;EACI,mBAAA;APystBhB;AOtstBY;;;;;;EACI,oBAAA;AP6stBhB;AOnstBY;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAEI,kBAAA;EACA,mBAAA;EACA,+BAAA;EACA,mBAAA;EACA,WAAA;EAKA,gCAAA;AP2wtBhB;AOxwtBY;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAEI,4BAAA;APg1tBhB;AO70tBY;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EACI,mBAAA;APk3tBhB;;AO32tBA,iDAAA;AACA;EAEQ;;;;;;IAMI,aAAA;EP62tBV;EOr2tBc;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAEI,kBAAA;EP66tBlB;EOx6tBc;;;;;;IACI,aAAA;EP+6tBlB;EO56tBsB;;;;;;IACI,eAAA;EPm7tB1B;EO76tBM;IACI,sBAAA;EP+6tBV;AACF;AO36tBA,oEAAA;AACA;EAEQ;;;;;;IAMI,kBAAA;EP46tBV;EOp6tBc;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAEI,kBAAA;EP4+tBlB;EOv+tBM;IACI,cAAA;EPy+tBV;AACF;AOr+tBA,qDAAA;AACA;EAEQ;;;;;;IAMI,kBAAA;EPs+tBV;EOp+tBM;IACI,cAAA;EPs+tBV;AACF;AOl+tBA,mDAAA;AACA;EAEQ;;;;;;IAMI,kBAAA;EPm+tBV;AACF;AO/9tBA,oEAAA;AACA;EAEQ;;;;;;IAMI,uCAAA;EPg+tBV;EO39tBc;IACI,aAAA;EP69tBlB;EO59tBkB;IACI,iBAAA;EP89tBtB;EOx9tBM;;IAEI,iBAAA;EP09tBV;AACF;AC3wuBA;;4BAAA;AAGA,qDAAA;AAGA,oDAAA;AAGA,qCAAA;AAGA,2CAAA;AAGA,wDAAA;AAGA,4EAAA;AAIA;;4BAAA;AAGA;EACE,kCAAA;EACA,sBAAA;EACA,kBAAA;EACA,2BAAA;EACA,uBAAA;EACA,wBAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,oBAAA;EACA,yBAAA;EACA,0BAAA;EACA,eAAA;EACA,oBAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,+DAAA;EACA,qEAAA;EACA,+DAAA;EACA,+DAAA;EACA,+DAAA;EACA,+DAAA;EACA,+DAAA;EACA,+DAAA;EACA,qEAAA;EACA;uCAAA;EAEA;qCAAA;EAEA;qCAAA;EAEA;sCAAA;EAEA;uCAAA;EAEA;uCAAA;EAEA;uCAAA;ADiwuBF;;AC7vuBA,+BAAA;AACA;EACE,YAAA,EAAA,8CAAA;ADgwuBF;;AC7vuBA;EACE,+BAAA;EACA,oBAAA;EACA,eAAA,EAAA,mBAAA;EACA,gBAAA,EAAA,uCAAA;ADgwuBF;;AC7vuBA;EACE,cAAA,EAAA,mCAAA;EACA,+BAAA;EACA,2BAAA;ADgwuBF;;AC7vuBA;EACE,+BAAA;EACA,gBAAA,EAAA,SAAA;ADgwuBF;;AC7vuBA;EACE,+BAAA;EACA,iBAAA,EAAA,YAAA;ADgwuBF;;AC7vuBA;EACE,+BAAA;EACA,cAAA,EAAA,SAAA;ADgwuBF;;AC7vuBA;EACE,+BAAA;EACA,iBAAA,EAAA,YAAA;ADgwuBF;;AC7vuBA;EACE,+BAAA;EACA,iBAAA,EAAA,YAAA;ADgwuBF;;AC7vuBA;EACE,yBAAA,EAAA,iCAAA;ADgwuBF;;AC7vuBA,wBAAA;AACA;EACE,cAAA,EAAA,iCAAA;ADgwuBF;;AC7vuBA;EACE,gBAAA;EACA,gBAAA;ADgwuBF;;AC7vuBA;EACE,gBAAA;ADgwuBF;;AC5vuBA,qDAAA;AACA;EACE;IACE,eAAA,EAAA,0CAAA;ED+vuBF;EC7vuBA;IACE,gBAAA,EAAA,WAAA;ED+vuBF;EC7vuBA;IACE,gBAAA,EAAA,WAAA;ED+vuBF;EC7vuBA;IACE,gBAAA,EAAA,WAAA;ED+vuBF;EC7vuBA;IACE,cAAA,EAAA,mCAAA;ED+vuBF;EC7vuBA;IACE,mBAAA;IACA,iBAAA;ED+vuBF;AACF;AC5vuBA,oDAAA;AACA;EACE;IACE,iBAAA;ED8vuBF;EC5vuBA;IACE,gBAAA,EAAA,SAAA;ED8vuBF;EC5vuBA;IACE,gBAAA,EAAA,SAAA;ED8vuBF;EC5vuBA;IACE,gBAAA,EAAA,SAAA;ED8vuBF;EC5vuBA;IACE,kBAAA;IACA,iBAAA;ED8vuBF;AACF;AC3vuBA,qCAAA;AACA;EACE;IACE,eAAA,EAAA,iCAAA;ED6vuBF;EC3vuBA;IACE,cAAA,EAAA,SAAA;ED6vuBF;EC3vuBA;IACE,gBAAA,EAAA,SAAA;ED6vuBF;EC3vuBA;IACE,iBAAA,EAAA,YAAA;ED6vuBF;EC3vuBA;IACE,kBAAA;IACA,iBAAA;ED6vuBF;AACF;AC1vuBA,2CAAA;AACA;EACE,6CAAA;AD4vuBF;ACzvuBA,wDAAA;AACA;EACE,sEAAA;EACA;IACE,eAAA;ED2vuBF;ECzvuBA;IACE,gBAAA,EAAA,WAAA;ED2vuBF;ECzvuBA;IACE,gBAAA,EAAA,WAAA;ED2vuBF;ECzvuBA;IACE,gBAAA,EAAA,WAAA;ED2vuBF;AACF;ACxvuBA,4EAAA;AACA;EACE;IACE,eAAA;ED0vuBF;ECxvuBA;IACE,4BAAA;ED0vuBF;ECxvuBA;IACE,8BAAA;ED0vuBF;ECxvuBA;IACE,+BAAA;ED0vuBF;AACF;ACvvuBA;EACE,eAAA;ADyvuBF;;ACtvuBA;EAAI,qBAAA;AD0vuBJ;;ACzvuBA;EAAU,eAAA;AD6vuBV;;AC3vuBA;;;;;;;EAOE,qBAAA;EACA,aAAA;AD8vuBF;;AC3vuBA;;EAEE,SAAA;EACA,UAAA;EACA,qBAAA;AD8vuBF;;AC3vuBA;EACE,cAAA;AD8vuBF;;AC3vuBA;EACE,gBAAA;EACA,iBAAA;AD8vuBF;;AC3vuBA;EACE,iBAAA;EACA,iBAAA;AD8vuBF;;AC3vuBA;EACE,cAAA;EACA,iBAAA;AD8vuBF;;AC3vuBA;EACE,iBAAA;EACA,iBAAA;AD8vuBF;;AC3vuBA;EACE,oBAAA;AD8vuBF;;AC5vuBA;EACE,wBAAA;AD+vuBF;;AC7vuBA;EACE,2BAAA;ADgwuBF;;AC9vuBA;EACE,yBAAA;ADiwuBF;;AC/vuBA;EACE,0BAAA;ADkwuBF;;AChwuBA;EACE,qBAAA;ADmwuBF;;ACjwuBA;EACE,yBAAA;ADowuBF;;AClwuBA;EACE,4BAAA;ADqwuBF;;ACnwuBA;EACE,0BAAA;ADswuBF;;ACpwuBA;EACE,2BAAA;ADuwuBF;;ACpwuBA;EACE,6BAAA;EACA,iBAAA;ADuwuBF;;ACpwuBA;EACE,4BAAA;EACA,iBAAA;ADuwuBF;;ACpwuBA;EACE,iBAAA;EACA,gBAAA;ADuwuBF;;ACpwuBA;EACE,4BAAA;EACA,sBAAA;EACA,2BAAA;ADuwuBF;;ACpwuBA;EACE,kBAAA;EACA,mBAAA;ADuwuBF;;ACpwuBA;EACE,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;ADuwuBF;;ACrwuBA;EACE,cAAA;ADwwuBF;;ACtwuBA;EACE,gBAAA;EACA,aAAA;ADywuBF;;ACvwuBA;EACE,iBAAA;EACA,kBAAA;AD0wuBF;;ACxwuBA;EACE,iBAAA;AD2wuBF;;ACzwuBA;EACE,kBAAA;AD4wuBF;;AC1wuBA;EACE,mBAAA;AD6wuBF;;AC3wuBA;EACE,mBAAA;AD8wuBF;;AC5wuBA;;EAEE,iBAAA;AD+wuBF;;AC7wuBA;;EAEE,gBAAA;ADgxuBF;;AC9wuBA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;ADixuBF;;AC/wuBA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;ADkxuBF;;AChxuBA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;ADmxuBF;;AChxuBA;EACE,sBAAA;EACA,iBAAA;ADmxuBF;;AChxuBA;;EAEE,cAAA;EACA,iBAAA;ADmxuBF;;ACjxuBA;;;;;EAOE,OAAA;EACA,UAAA;EACA,QAAA;ADoxuBF;;ACjxuBE;EAgDE,qBAAA;ADquuBJ;;ACjuuBE;EAoCE,qBAAA;ADisuBJ;;AC7ruBE;EAwBE,qBAAA;ADyquBJ;;ACrquBE;EAYE,qBAAA;AD6puBJ;;AC1puBA;EACE;IAGE,cAAA;ED6puBF;EC3puBA;IACE,QAAA;ED6puBF;AACF;AC3puBA;EACE;IAGE,cAAA;ED6puBF;EC3puBA;IACE,QAAA;ED6puBF;AACF;AC3puBA;EACE;IAGE,cAAA;ED6puBF;EC3puBA;IACE,QAAA;ED6puBF;AACF;AC3puBA;EACE;IAGE,cAAA;ED6puBF;EC3puBA;IACE,QAAA;ED6puBF;AACF;AC1puBA,4BAAA;AACA;EACE,0BAAA;EACA,mBAAA;EACA,2BAAA;AD4puBF;;AC1puBA;EACE,+BAAA;EACA,mBAAA;EACA,2BAAA;AD6puBF;;AC3puBA;EACE,yBAAA;EACA,oBAAA;EACA,oBAAA;AD8puBF;;AC3puBA;EACE,4BAAA;EACA,qBAAA;AD8puBF;;AC5puBA;EACE,+BAAA;EACA,mBAAA;AD+puBF;;AC7puBA;EACE,oBAAA;EACA,2BAAA;EACA,oBAAA;ADgquBF;;AC5puBA,+BAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,0BAAA;EAGA,aAAA;EAGA,uBAAA;EAGA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EAEA,gCAAA;EACA,kBAAA;AD+puBF;;AC5puBA;EAEE,yDAAA;EAEA,kCAAA;EACA,+BAAA;AD+puBF;;AC5puBA;;4BAAA;AAGA;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AD+puBF;;AC7puBA;EACE,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gCAAA;EACA,mBAAA;EACA,iBAAA;ADgquBF;;AC9puBA;EACE,mBAAA;ADiquBF;;AC/puBA;EACE,oBAAA;ADkquBF;;AC/puBA;;4BAAA;AAGA;EACE,qFAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;EACA,YAAA;EACA,kBAAA;ADkquBF;AChquBE;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,8BAAA;EACA,mBAAA;ADkquBJ;AChquBI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,+BAAA;EACA,oBAAA;ADkquBN;AC9puBE;EACE,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;ADgquBJ;AC9puBI;EACE,kBAAA;ADgquBN;AC5puBE;EACE,mCAAA;EACA,sCAAA;AD8puBJ;AC5puBI;EACE,qFAAA;EACA,oBAAA;EACA,2BAAA;EACA,cAAA;EACA,iBAAA;AD8puBN;AC5puBM;EACE,aAAA;AD8puBR;AC3puBM;EACE,gBAAA;AD6puBR;;ACvpuBA;EACE;IACE,cAAA;IACA,mBAAA;ED0puBF;AACF;ACvpuBA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EAGA,yBAAA;ADypuBF;;ACvpuBA;EACE,2BAAA;AD0puBF;;ACvpuBA,iDAAA;AACA;EACE;IACE,kBAAA;ED0puBF;ECxpuBA;IACE,iBAAA;IACA,mBAAA;ED0puBF;AACF;ACvpuBA,oEAAA;AACA;EACE;IACE,kBAAA;EDypuBF;ECvpuBA;IACE,iBAAA;IACA,mBAAA;EDypuBF;AACF;ACtpuBA,qDAAA;AACA;EACE;IACE,mBAAA;EDwpuBF;ECtpuBA;IACE,eAAA;IACA,mBAAA;EDwpuBF;AACF;ACrpuBA,mDAAA;AACA;EACE;IACE,mBAAA;EDupuBF;AACF;ACppuBA,oEAAA;AACA;EACE;IACE,mBAAA;EDspuBF;AACF;ACjpuBA;;4BAAA;AAGA;EACE,gBAAA;ADmpuBF;;AChpuBA;EACE,oBAAA;ADmpuBF;;AChpuBA,0BAAA;AACA;EACE,0BAAA;EACA,UAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;ADmpuBF;;ACjpuBA;EACE,0BAAA;EACA,sBAAA;EAEA,gCAAA;EACA,MAAA;EACA,WAAA;ADopuBF;;ACjpuBA;EACE,SAAA;ADopuBF;;AClpuBA;EACE,kBAAA;EACA,UAAA;ADqpuBF;;ACnpuBA;EACE,WAAA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EAKA,gCAAA;ADspuBF;;ACppuBA;EAKE,wBAAA;EACA,QAAA;ADupuBF;;ACrpuBA;EACE,UAAA;ADwpuBF;;ACtpuBA;EAKE,yBAAA;EACA,SAAA;ADypuBF;;ACvpuBA;EACE;IACE,kBAAA;IACA,SAAA;IACA,OAAA;IACA,WAAA;IACA,gCAAA;IACA,UAAA;IACA,kBAAA;ED0puBF;AACF;ACxpuBA;EACE;IACE,iBAAA;ED0puBF;AACF;ACxpuBA;EACE;IACE,eAAA;ED0puBF;AACF;ACxpuBA;EACE,kBAAA;AD0puBF;;ACxpuBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EAKA,gCAAA;EACA,cAAA;EACA,YAAA;AD2puBF;;ACzpuBA;EACE,UAAA;AD4puBF;;AC1puBA;EACE;IACE,eAAA;IACA,cAAA;IACA,SAAA;IACA,SAAA;ED6puBF;AACF;AC3puBA;EACE,UAAA;AD6puBF;;AC3puBA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EAKA,gCAAA;AD8puBF;;AC5puBA;EACE;IACE,kBAAA;IACA,SAAA;ED+puBF;AACF;AC7puBA;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EAKA,gCAAA;EACA,WAAA;EACA,2CAAA;EACA,aAAA;AD+puBF;;AC7puBA;EACE;IACE,6BAAA;IACA,sBAAA;IACA,kBAAA;IACA,oBAAA;IACA,qBAAA;IACA,8BAAA;IACA,WAAA;IAKA,yBAAA;IAKA,gCAAA;IACA,gBAAA;IACA,gBAAA;IACA,aAAA;IACA,SAAA;EDgquBF;AACF;AC9puBA;EACE,YAAA;EACA,cAAA;ADgquBF;;AC9puBA;EACE;IACE,SAAA;IACA,aAAA;EDiquBF;AACF;AC/puBA;EACE;IACE,YAAA;EDiquBF;AACF;AC/puBA;EACE,kBAAA;ADiquBF;;AC/puBA;EACE,mBAAA;EAKA,gCAAA;ADkquBF;;AChquBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EAKA,gCAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;ADmquBF;;ACjquBA;EACE,gBAAA;EACA,eAAA;ADoquBF;;AClquBA;EACE;IACE,aAAA;EDqquBF;AACF;ACnquBA;EACE,qBAAA;ADqquBF;;ACnquBA;EACE,WAAA;EACA,UAAA;EACA,MAAA;EACA,UAAA;EACA,kBAAA;EAKA,gCAAA;ADsquBF;;ACpquBA;EACE;IACE,iBAAA;EDuquBF;AACF;ACrquBA;EACE;IACE,kBAAA;EDuquBF;AACF;ACrquBA;EACE;IACE,kBAAA;EDuquBF;AACF;ACrquBA;EACE;IACE,mBAAA;IACA,YAAA;IACA,kBAAA;EDuquBF;AACF;ACrquBA;EACE,UAAA;EACA,mBAAA;ADuquBF;;ACrquBA;EACE,mBAAA;ADwquBF;;ACtquBA;EACE;IACE,qBAAA;EDyquBF;AACF;ACvquBA;EACE,qBAAA;EACA,kBAAA;ADyquBF;;ACvquBA;EACE,qBAAA;AD0quBF;;ACxquBA;EACE;IACE,qBAAA;ED2quBF;AACF;ACzquBA;EACE,UAAA;AD2quBF;;ACzquBA;EACE,UAAA;AD4quBF;;AC1quBA;EACE,UAAA;EACA,mBAAA;EACA,SAAA;AD6quBF;;AC3quBA;EACE;IACE,qBAAA;IACA,kBAAA;IACA,MAAA;IACA,QAAA;IACA,kBAAA;IACA,eAAA;IACA,gBAAA;IACA,SAAA;IACA,mBAAA;ED8quBF;AACF;AC5quBA;EACE,eAAA;AD8quBF;;AC5quBA;EACE;IACE,kBAAA;IACA,WAAA;IACA,QAAA;ED+quBF;AACF;AC7quBA;EACE;IACE,kBAAA;IACA,WAAA;IACA,QAAA;ED+quBF;AACF;AC7quBA;;EAEE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,4CAAA;EACA,kBAAA;EAKA,gCAAA;AD+quBF;;AC7quBA;EACE,yBAAA;EACA,qBAAA;EACA,8BAAA;ADgruBF;;AC7quBA,0BAAA;AACA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EAKA,2BAAA;EACA,gCAAA;EACA,gBAAA;ADgruBF;;AC9quBA;EAKE,wBAAA;ADiruBF;;AC/quBA;EACE;IACE,WAAA;IACA,gBAAA;IACA,kBAAA;EDkruBF;AACF;AChruBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;ADkruBF;;AChruBA;EACE,eAAA;EACA,mBAAA;EAKA,gCAAA;ADmruBF;;ACjruBA;EACE,eAAA;EAKA,wBAAA;ADoruBF;;AClruBA;EACE,iBAAA;ADqruBF;;AClruBE;EACE,qBAAA;ADqruBJ;;AClruBA;EACE,gBAAA;ADqruBF;;ACnruBA;EACE,eAAA;EACA,gBAAA;ADsruBF;;ACpruBA;EACE,gBAAA;ADuruBF;;ACrruBA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;EAKA,gCAAA;EACA,cAAA;ADwruBF;;ACtruBA;EACE,0BAAA;EACA,iBAAA;EACA,eAAA;ADyruBF;;ACvruBA;EACE,gBAAA;AD0ruBF;;ACxruBA;EACE,gBAAA;AD2ruBF;;ACzruBA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AD4ruBF;;AC1ruBA;EACE,qBAAA;EACA,iBAAA;AD6ruBF;;AC3ruBA;EACE,SAAA;AD8ruBF;;AC5ruBA;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EAKA,gCAAA;AD+ruBF;;AC7ruBA;EACE,mBAAA;EACA,gCAAA;EACA,yBAAA;ADgsuBF;;AC7ruBA;EACE,eAAA;EACA,oCAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;ADgsuBF;;AC9ruBA;EACE,cAAA;ADisuBF;;AC7ruBA,4BAAA;AACA;EACE,0BAAA;EACA,mBAAA;EACA,2BAAA;ADgsuBF;;AC9ruBA;EACE,+BAAA;EACA,mBAAA;EACA,2BAAA;ADisuBF;;AC/ruBA;EACE,yBAAA;EACA,oBAAA;EACA,oBAAA;ADksuBF;;AC/ruBA;;yCAAA;AAGA;EACE,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;ADksuBF;AChsuBE;EACE,4BAAA;ADksuBJ;;AC/ruBA,iDAAA;AACA;EAEI;IACE,qCAAA;IACA,4BAAA;IACA,cAAA;IACA,gBAAA;EDisuBJ;AACF;AC7ruBA,oEAAA;AACA;EAEI;IACE,qCAAA;IACA,4BAAA;IACA,cAAA;IACA,gBAAA;ED8ruBJ;AACF;AC1ruBA,qDAAA;AACA;EAEI;IACE,qCAAA;IACA,cAAA;IACA,gBAAA;ED2ruBJ;AACF;ACvruBA,mDAAA;AACA;EAEI;IACE,iCAAA;EDwruBJ;AACF;ACpruBA,oEAAA;AAGA;EACE,WAAA;EACA,qEAAA;EACA,sBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;ADoruBF;;ACjruBA;EACE,WAAA;EACA,mEAAA;EACA,sBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;ADoruBF;;AClruBA;EACE,WAAA;EACA,kBAAA;ADqruBF;;ACnruBA;EACE;IACE,gBAAA;EDsruBF;AACF;ACpruBA;EACE,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;ADsruBF;;ACpruBA;EACE,gBAAA;EACA,oBAAA;EACA,kDAAA;EACA,0BAAA;ADuruBF;;ACrruBA;EACE;IACE,eAAA;IACA,iBAAA;EDwruBF;AACF;ACtruBA;EACE;IACE,eAAA;IACA,iBAAA;EDwruBF;AACF;ACtruBA;EACE,cAAA;ADwruBF;;ACtruBA;EACE,gBAAA;EACA,sBAAA;EACA,YAAA;ADyruBF;;ACvruBA;EACE,gBAAA;AD0ruBF;;ACxruBA;EACE,kBAAA;EACA,8BAAA;EACA,qBAAA;EACA,6BAAA;AD2ruBF;;ACzruBA;EACE,6BAAA;EACA,mBAAA;EACA,0BAAA;AD4ruBF;;AC1ruBA;EACE,oBAAA;EACA,mBAAA;AD6ruBF;;AC3ruBA;EACE;IACE,gBAAA;ED8ruBF;AACF;AC5ruBA;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AD8ruBF;;AC5ruBA;EACE,wBAAA;EACA,qBAAA;AD+ruBF;;AC5ruBA;;4BAAA;AAGA;EACE,gCAAA;EACA,kBAAA;EACA,oBAAA;AD+ruBF;;AC7ruBA;EACE;IACE,kBAAA;IACA,oBAAA;EDgsuBF;AACF;AC9ruBA;EACE;IACE,iBAAA;IACA,oBAAA;EDgsuBF;AACF;AC9ruBA;EACE,kBAAA;ADgsuBF;;AC9ruBA;EACE;IACE,eAAA;EDisuBF;AACF;AC/ruBA;EACE;IACE,eAAA;EDisuBF;AACF;AC/ruBA;EACE,kBAAA;EACA,kBAAA;ADisuBF;;AC/ruBA;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,gCAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;ADksuBF;;AChsuBA;EACE,gBAAA;ADmsuBF;;ACjsuBA;EACE,gBAAA;ADosuBF;;AClsuBA;EACE,YAAA;EACA,gCAAA;EACA,aAAA;EACA,kBAAA;ADqsuBF;;ACnsuBA;EACE,YAAA;ADssuBF;;ACpsuBA;EACE,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BAAA;ADusuBF;;ACrsuBA;EACE;IACE,SAAA;IACA,mBAAA;IACA,WAAA;EDwsuBF;ECtsuBA;IACE,SAAA;EDwsuBF;AACF;ACtsuBA;EACE,qBAAA;ADwsuBF;;ACtsuBA;EACE,gCAAA;EACA,mBAAA;ADysuBF;;ACvsuBA;EACE,eAAA;AD0suBF;;ACxsuBA;EACE,YAAA;AD2suBF;;ACzsuBA;EACE,mBAAA;AD4suBF;;AC1suBA;EACE,SAAA;AD6suBF;;AC1suBA;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;AD6suBF;;AC3suBA;EACE;IACE,mBAAA;IACA,kBAAA;ED8suBF;AACF;AC5suBA;EACE;IACE,mBAAA;IACA,eAAA;ED8suBF;AACF;AC5suBA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;AD8suBF;;AC5suBA;EACE;IACE,OAAA;ED+suBF;AACF;AC7suBA;EACE;IACE,YAAA;IACA,aAAA;ED+suBF;AACF;AC7suBA;EACE;IACE,aAAA;ED+suBF;AACF;AC7suBA;EACE,WAAA;EACA,UAAA;AD+suBF;;AC3suBA;;4BAAA;AAGA;EACE,gBAAA;AD8suBF;;AC5suBA;EACE;IACE,sBAAA;ED+suBF;AACF;AC7suBA;EACE;IACE,sBAAA;ED+suBF;AACF;AC7suBA;EACE,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,mBAAA;EAKA,gCAAA;AD+suBF;;AC7suBA;EACE,2BAAA;ADgtuBF;;AC9suBA;EACE,mBAAA;EACA,yBAAA;EACA,0BAAA;ADituBF;;AC/suBA;EACE,UAAA;EACA,mBAAA;ADktuBF;;AChtuBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EAKA,gCAAA;EACA,kBAAA;ADmtuBF;;ACjtuBA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,0BAAA;EAKA,gCAAA;EACA,WAAA;EACA,kBAAA;EACA,6BAAA;ADotuBF;;ACltuBA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;ADqtuBF;;ACntuBA;EACE,oBAAA;ADstuBF;;ACjtuBA,wBAAA;AACA;EACE,gCAAA;EACA,gBAAA;ADotuBF;;ACltuBA;EACE;IACE,aAAA;EDqtuBF;AACF;ACntuBA;EACE;IACE,eAAA;EDqtuBF;AACF;ACntuBA;EACE,gBAAA;EACA,qBAAA;ADqtuBF;;ACntuBA;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;ADstuBF;;ACptuBA;EACE,gBAAA;EACA,oBAAA;ADutuBF;;ACrtuBA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;ADwtuBF;;ACttuBA;EACE,kBAAA;ADytuBF;;ACvtuBA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EAKA,gCAAA;EAKA,gCAAA;EACA,iBAAA;AD0tuBF;;ACxtuBA;EACE;IACE,WAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;ED2tuBF;AACF;ACztuBA;EACE,8BAAA;EACA,qBAAA;AD2tuBF;;ACvtuBA,+BAAA;AACA;EACE,gBAAA;EACA,gCAAA;AD0tuBF;;ACxtuBA;EACE;IACE,aAAA;ED2tuBF;AACF;ACztuBA;EACE;IACE,eAAA;ED2tuBF;AACF;ACztuBA;EACE,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AD2tuBF;;ACztuBA;EACE,2BAAA;AD4tuBF;;AC1tuBA;EACE,2BAAA;AD6tuBF;;AC3tuBA;EACE,4BAAA;EACA,0BAAA;EACA,mBAAA;AD8tuBF;;AC5tuBA;EACE,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gCAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;AD+tuBF;;AC7tuBA;EACE,oBAAA;ADguuBF;;AC9tuBA;EACE,iBAAA;ADiuuBF;;AC/tuBA;EACE,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;ADkuuBF;;AChuuBA;EACE,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;ADmuuBF;;ACjuuBA;EACE,qBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;ADouuBF;;ACluuBA;EACE,SAAA;EACA,gBAAA;EACA,mBAAA;ADquuBF;;ACnuuBA;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;ADsuuBF;;ACpuuBA;EACE,SAAA;ADuuuBF;;ACruuBA;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;ADwuuBF;;ACtuuBA;EACE,oBAAA;ADyuuBF;;ACnuuBA,4BAAA;AACA;EACE,4BAAA;EACA,qBAAA;ADsuuBF;;ACpuuBA;EACE,wBAAA;EACA,qBAAA;EACA,yBAAA;ADuuuBF;;ACruuBA;EACE,oBAAA;EACA,2BAAA;EACA,oBAAA;ADwuuBF;;ACruuBA,+BAAA;AACA;EACE,UAAA;EACA,gBAAA;EACA,uEAAA;EACA,kBAAA;ADwuuBF;;ACtuuBA;EACE;IACE,aAAA;EDyuuBF;AACF;ACvuuBA;EACE;IACE,eAAA;EDyuuBF;AACF;ACvuuBA;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,oCAAA;EACA,sBAAA;EACA,4BAAA;EACA,wBAAA;EACA,WAAA;ADyuuBF;;ACvuuBA;EACE,kBAAA;AD0uuBF;;ACxuuBA;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;AD2uuBF;;ACzuuBA;EACE,mBAAA;AD4uuBF;;AC1uuBA;EACE,gBAAA;EACA,cAAA;AD6uuBF;;AC3uuBA;EACE,0BAAA;EACA,mBAAA;AD8uuBF;;AC3uuBA;;yCAAA;AAGA;EACE,gBAAA;EACA,0BAAA;AD8uuBF;;AC5uuBA;EACE;IACE,aAAA;ED+uuBF;AACF;AC7uuBA;EACE;IACE,eAAA;ED+uuBF;AACF;AC7uuBA;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;AD+uuBF;;AC7uuBA;EACE,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EAKA,gCAAA;EACA,sBAAA;ADgvuBF;;AC9uuBA;EACE,8CAAA;EAKA,2BAAA;ADivuBF;;AC/uuBA;EACE,gBAAA;EACA,gCAAA;EACA,eAAA;ADkvuBF;;AC/uuBA;EACE,kBAAA;ADkvuBF;;AC/uuBA,sBAAA;AACA;EACE,iBAAA;EACA,qBAAA;EACA,+BAAA;EACA,kBAAA;EACA,2BAAA;ADkvuBF;AChvuBE;EACE,qBAAA;ADkvuBJ;;AC/uuBA;EACE;IACE,iBAAA;IACA,oBAAA;EDkvuBF;AACF;AChvuBA;EACE;IACE,gBAAA;EDkvuBF;AACF;AChvuBA;EACE;IACE,gBAAA;IACA,sBAAA;EDkvuBF;EC/uuBA;IACE,gBAAA;IACA,kBAAA;EDivuBF;AACF;AC/uuBA;EACE,gBAAA;EACA,kBAAA;EACA,qBAAA;ADivuBF;;AC/uuBA;EACE;IACE,kBAAA;EDkvuBF;AACF;AChvuBA;EACE,mBAAA;ADkvuBF;;AChvuBA;EACE;IACE,UAAA;EDmvuBF;AACF;ACjvuBA;EACE,wBAAA;EACA,qBAAA;EACA,gBAAA;ADmvuBF;;ACjvuBA;EACE,wBAAA;EACA,qBAAA;EACA,gBAAA;ADovuBF;AClvuBE;EACE;IACE,aAAA;IACA,uBAAA;IAAA,kBAAA;IACA,YAAA;EDovuBJ;AACF;ACjvuBE;EACE,aAAA;EACA,uBAAA;EAAA,kBAAA;ADmvuBJ;;AChvuBA;EACE,cAAA;ADmvuBF;;ACjvuBA;EACE;IACE,gBAAA;EDovuBF;AACF;AClvuBA;EACE,qBAAA;ADovuBF;;AClvuBA;EACE,yBAAA;ADqvuBF;;ACnvuBA;EACE,cAAA;EACA,kBAAA;ADsvuBF;;ACpvuBA;EACE,kBAAA;ADuvuBF;;ACrvuBA;EACE,wBAAA;EACA,qBAAA;EAKA,gCAAA;ADwvuBF;;ACtvuBA;EACE,qBAAA;ADyvuBF;;ACvvuBA;EACE;IACE,kBAAA;ED0vuBF;AACF;ACxvuBA;EACE,oBAAA;AD0vuBF;;ACxvuBA;EACE,gBAAA;EACA,kBAAA;AD2vuBF;;ACzvuBA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AD4vuBF;;AC1vuBA;EACE,4BAAA;AD6vuBF;;AC3vuBA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;AD8vuBF;;AC5vuBA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AD+vuBF;;AC7vuBA;EACE,mBAAA;EACA,qCAAA;ADgwuBF;;AC9vuBA;EACE,6CAAA;ADiwuBF;AC/vuBE;EACE,qBAAA;EACA,mBAAA;ADiwuBJ;;AC9vuBA;EACE;IACE,0BAAA;EDiwuBF;AACF;AC/vuBA;EACE,sBAAA;ADiwuBF;;AC5vuBA;EAAuE,qBAAA;EAAuB,kBAAA;ADiwuB9F;;AChwuBA;EAA6E,2BAAA;ADowuB7E;;ACnwuBA;EAAyD,wBAAA;ADuwuBzD;;ACtwuBA;EAAuE,qBAAA;AD0wuBvE;;ACzwuBA;EAA6E,2BAAA;AD6wuB7E;;AC3wuBA;EAAiE,wBAAA;AD+wuBjE;;AC9wuBA;EAAuE,wBAAA;ADkxuBvE;;AC9wuBI;EAAkB,UAAA;EAAY,YAAA;EAAc,aAAA;ADoxuBhD;ACnxuBI;EAAmB,UAAA;EAAY,YAAA;ADuxuBnC;ACtxuBI;EAAkB,UAAA;EAAY,YAAA;EAAc,aAAA;AD2xuBhD;;ACvxuBA;EACE,sDAAA;EACA,mBAAA;EACA,qBAAA;AD0xuBF;;ACvxuBA;EACE;IACI,eAAA;ED0xuBJ;ECzxuBA;IAAK,eAAA;ED4xuBL;EC3xuBA;IAAK,eAAA;ED8xuBL;EC7xuBA;IAAS,eAAA;EDgyuBT;AACF;AC9xuBA;EAAoB,eAAA;EAAiB,aAAA;EAAe,YAAA;EAAc,WAAA;EAAa,iBAAA;EAAmB,qBAAA;EAAuB,sBAAA;EAAwB,SAAA;EAAW,QAAA;ADyyuB5J;;ACxyuBA;EAA2B,WAAA;EAAa,cAAA;EAAgB,eAAA;EAAiB,MAAA;EAAQ,OAAA;EAAS,WAAA;EAAa,YAAA;EAAc,qCAAA;ADmzuBrH;;AClzuBA;EAAmB,aAAA;EAAe,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,kBAAA;EAAoB,sBAAA;EAAwB,sBAAA;AD4zuBzH;;AC3zuBA;EAAe,aAAA;EAAe,WAAA;EAAa,sBAAA;EAAwB,cAAA;EAAgB,kBAAA;EAAoB,MAAA;EAAQ,OAAA;EAAS,gBAAA;ADs0uBxH;;ACp0uBA;EACE,cEhrEiB;EFirEjB,cElrEiB;EFmrEjB,mBAAA;EACA,0BAAA;ADu0uBF;ACr0uBE;EACE,cAAA;EACA,SAAA;EACA,mBAAA;ADu0uBJ;ACp0uBE;EACE,cEpvEM;EFqvEN,mBE9rEe;AHogzBnB;;ACj0uBE;EACE,+CAAA;ADo0uBJ;ACh0uBI;EACE,eAAA;ADk0uBN;AC/zuBI;EACE,sCAAA;ADi0uBN;AC9zuBI;EACE,yCAAA;ADg0uBN;;AA3kzBA;EAAuB,+BAAA;AA+kzBvB;;AA9kzBA;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mCAAA;EACA,gCAAA;AAilzBF;AA/kzBE;EACE,mBAAA;EAAqB,WAAA;EAAa,YAAA;AAmlzBtC;AAjlzBE;EACE,mBAAA;EAAqB,cAAA;EAAgB,eAAA;AAqlzBzC;AAplzBI;EAAK,oBAAA;EAAsB,qBAAA;EAAuB,mBAAA;AAylzBtD;AAtlzBE;EAAY,YAAA;EAAc,sBAAA;AA0lzB5B","sourcesContent":["@import \"../../../../styles\";\n\n.line-height-inherit { line-height: inherit !important; }\n.heading-plus {\n  width: 100%;\n  line-height: 31px;\n  display: flex;\n  padding: 0.375rem 0.5rem !important;\n  border: 1px solid var(--primary);\n\n  .heading-sub-west {\n    display: table-cell; width: 31px; height: 100%;\n  }\n  .heading-sub-east {\n    display: table-cell; width: inherit; height: inherit;\n    h5 { line-height: inherit; color: var(--primary); margin-left: 0.5rem; }\n  }\n\n  .p-button { height: 31px; width: 31px !important; }\n}","/*@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@200;300;400;500;600;700;800;900&display=swap\");*/\n@import \"blocks.scss\";\n\n@import \"assets/sass/theme/_variables.scss\";\n@import \"assets/sass/layout/_mixins.scss\";\n@import \"assets/sass/theme/designer/components/_megamenu.scss\";\n@import \"assets/sass/theme/designer/components/_input.scss\";\n@import \"assets/sass/theme/designer/_sections.scss\";\n\n/*===========================\n  RESPONSIVE css dimensions\n===========================*/\n/* Small devices (portrait phones, less than 576px) */\n@media (max-width: 575.98px) {}\n\n/* Medium devices (landscape phones, 576px and up) */\n@media (min-width: 576px) and (max-width: 767.98px) {}\n\n/* Tablets (portrait and landscape) */\n@media (min-width: 768px) and (max-width: 991.98px) {}\n\n/* Large devices (desktops, 992px and up) */\n@media (min-width: 992px) and (max-width: 1199.98px) {}\n\n/* Extra large devices (large desktops, 1200px and up) */\n@media (min-width: 1200px) {}\n\n/* For very high resolution screens or when you want to use viewport units */\n@media (min-width: 1920px) {}\n\n\n/*===========================\n  COMMON css\n===========================*/\n:root {\n  --font-family: \"Inter\", sans-serif;\n  /*--primary: #155bd5;*/\n  --primary: #446a35;\n  /*--primary-dark: #1c3ab6;*/\n  --primary-dark: #50783f;\n  --primary-light: #84c785;\n  --accent: #274482;\n  --accent-dark: #122754;\n  --accent-light: #3f5d92;\n  --success: #13d527;\n  --success-dark: #00ae11;\n  --success-light: #eafbe7;\n  --secondary: #f2c22f;\n  --secondary-dark: #96791e;\n  --secondary-light: #f8cf51;\n  --info: #15b2d5;\n  --info-dark: #0f8ca8;\n  --info-light: #e0f5fa;\n  --border-light: #ced3d9;\n  --caution: #dbbb25;\n  --caution-dark: #d58f15;\n  --caution-light: #fbf9e4;\n  --error: #e6185e;\n  --error-dark: #bf1257;\n  --error-light: #fce4eb;\n  --black: #1d1d1d;\n  --charcoal: #3a4353;\n  --dark-1: #2d2d2d;\n  --dark-2: #4d4d4d;\n  --dark-3: #6d6d6d;\n  --gray-1: #8d8d8d;\n  --gray-2: #adadad;\n  --gray-3: #cdcdcd;\n  --gray-4: #e0e0e0;\n  --light-1: #efefef;\n  --light-2: #f5f5f5;\n  --light-3: #fafafa;\n  --visualage-1: #a22025;\n  --white: #ffffff;\n  --gradient-1: linear-gradient(180deg, #155bd5 0%, #1c3ab6 100%);\n  --gradient-2: linear-gradient(180deg, #155bd5 13.02%, #00d4d7 85.42%);\n  --gradient-3: linear-gradient(180deg, #155bd5 0%, #8f15d5 100%);\n  --gradient-4: linear-gradient(180deg, #155bd5 0%, #13d527 100%);\n  --gradient-5: linear-gradient(180deg, #155bd5 0%, #15bbd5 100%);\n  --gradient-6: linear-gradient(180deg, #155bd5 0%, #dbbb25 100%);\n  --gradient-7: linear-gradient(180deg, #155bd5 0%, #e6185e 100%);\n  --gradient-8: linear-gradient(180deg, #1c3ab6 0%, #00bac1 100%);\n  --gradient-9: linear-gradient(180deg, #00d4d7 13.02%, #155bd5 85.42%);\n  --shadow-1: 0px 0px 1px rgba(40, 41, 61, 0.08),\n  0px 0.5px 2px rgba(96, 97, 112, 0.16);\n  --shadow-2: 0px 0px 1px rgba(40, 41, 61, 0.04),\n  0px 2px 4px rgba(96, 97, 112, 0.16);\n  --shadow-3: 0px 0px 2px rgba(40, 41, 61, 0.04),\n  0px 4px 8px rgba(96, 97, 112, 0.16);\n  --shadow-4: 0px 2px 4px rgba(40, 41, 61, 0.04),\n  0px 8px 16px rgba(96, 97, 112, 0.16);\n  --shadow-5: 0px 2px 8px rgba(40, 41, 61, 0.04),\n  0px 16px 24px rgba(96, 97, 112, 0.16);\n  --shadow-6: 0px 2px 8px rgba(40, 41, 61, 0.08),\n  0px 20px 32px rgba(96, 97, 112, 0.24);\n  --shadow-7: 0px 4px 16px rgba(40, 41, 61, 0.04),\n  0px 25px 40px rgba(96, 97, 112, 0.16);\n}\n\n/* Default styles for desktop */\nhtml, body {\n  height: 100%; /* Ensure that ancestors have defined height */\n}\n\nbody, a, p, label, input, li {\n  font-family: var(--font-family);\n  color: var(--dark-2);\n  font-size: 16px; /* Base font size */\n  line-height: 1.5; /* Line height for better readability */\n}\n\nh1, .h1 {\n  font-size: 2em; /* 32px if base font size is 16px */\n  color: var(--accent) !important;\n  font-weight: 700 !important;\n}\n\nh2, .h2 {\n  color: var(--accent) !important;\n  font-size: 1.5em; /* 24px */\n}\n\nh3, .h3 {\n  color: var(--accent) !important;\n  font-size: 1.17em; /* 18.72px */\n}\n\nh4, .h4 {\n  color: var(--accent) !important;\n  font-size: 1em; /* 16px */\n}\n\nh5, .h5 {\n  color: var(--accent) !important;\n  font-size: 0.83em; /* 13.28px */\n}\n\nh6, .h6 {\n  color: var(--accent) !important;\n  font-size: 0.67em; /* 10.72px */\n}\n\ndiv, span, label, p, a, input, li {\n  font-size: 1em !important; /* Inherits from body font size */\n}\n\n/* Additional elements */\nbutton, input, textarea, button > span {\n  font-size: 1em; /* Inherits from body font size */\n}\n\np {\n  margin: 0 0 1rem;\n  line-height: 1.5;\n}\n\np:last-child {\n  margin-bottom: 0\n}\n\n\n/* Small devices (portrait phones, less than 576px) */\n@media (max-width: 575.98px) {\n  body {\n    font-size: 12px; /* Smaller base size for smaller screens */\n  }\n  h1, .h1 {\n    font-size: 1.7em; /* 23.8px */\n  }\n  h2, .h2 {\n    font-size: 1.4em; /* 19.6px */\n  }\n  h3, .h3 {\n    font-size: 1.2em; /* 16.8px */\n  }\n  h4, h5, h6, .h4, .h5, .h6 {\n    font-size: 1em; /* Keep consistent with body text */\n  }\n  p {\n    margin: 0 0 .75rem;\n    line-height: 1.35;\n  }\n}\n\n/* Medium devices (landscape phones, 576px and up) */\n@media (min-width: 576px) and (max-width: 767.98px) {\n  body {\n    font-size: 12.5px;\n  }\n  h1, .h1 {\n    font-size: 1.8em; /* 27px */\n  }\n  h2, .h2 {\n    font-size: 1.4em; /* 21px */\n  }\n  h3, .h3 {\n    font-size: 1.2em; /* 18px */\n  }\n  p {\n    margin: 0 0 .5rem;\n    line-height: 1.35;\n  }\n}\n\n/* Tablets (portrait and landscape) */\n@media (min-width: 768px) and (max-width: 991.98px) {\n  body {\n    font-size: 13px; /* Back to default desktop size */\n  }\n  h1, .h1 {\n    font-size: 2em; /* 32px */\n  }\n  h2, .h2 {\n    font-size: 1.5em; /* 24px */\n  }\n  h3, .h3 {\n    font-size: 1.17em; /* 18.72px */\n  }\n  p {\n    margin: 0 0 .5rem;\n    line-height: 1.35;\n  }\n}\n\n/* Large devices (desktops, 992px and up) */\n@media (min-width: 992px) and (max-width: 1199.98px) {\n  /* Use the default desktop sizes from above */\n}\n\n/* Extra large devices (large desktops, 1200px and up) */\n@media (min-width: 1200px) {\n  /* You might want to slightly increase font sizes for larger screens */\n  body {\n    font-size: 17px;\n  }\n  h1, .h1 {\n    font-size: 2.1em; /* 35.7px */\n  }\n  h2, .h2 {\n    font-size: 1.6em; /* 27.2px */\n  }\n  h3, .h3 {\n    font-size: 1.3em; /* 22.1px */\n  }\n}\n\n/* For very high resolution screens or when you want to use viewport units */\n@media (min-width: 1920px) {\n  body {\n    font-size: 17px;\n  }\n  h1, .h1 {\n    font-size: calc(2em + 0.3vw);\n  }\n  h2, .h2 {\n    font-size: calc(1.5em + 0.2vw);\n  }\n  h3, .h3 {\n    font-size: calc(1.17em + 0.1vw);\n  }\n}\n\nimg {\n  max-width: 100%;\n}\n\na { display: inline-block; }\na:hover { cursor: pointer; }\n\na,\nbutton,\na:hover,\na:focus,\ninput:focus,\ntextarea:focus,\nbutton:focus {\n  text-decoration: none;\n  outline: none;\n}\n\nul,\nol {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n}\n\n.display-table {\n  display: table;\n}\n\n.display-1 {\n  font-size: 5.5em;\n  line-height: 1.25;\n}\n\n.display-2 {\n  font-size: 4.75em;\n  line-height: 1.25;\n}\n\n.display-3 {\n  font-size: 4em;\n  line-height: 1.25;\n}\n\n.display-4 {\n  font-size: 3.25em;\n  line-height: 1.25;\n}\n\n.no-margin {\n  margin: 0 !important;\n}\n.no-margin-top {\n  margin-top: 0 !important;\n}\n.no-margin-bottom {\n  margin-bottom: 0 !important;\n}\n.no-margin-left {\n  margin-left: 0 !important;\n}\n.no-margin-right {\n  margin-right: 0 !important;\n}\n.no-padding {\n  padding: 0 !important;\n}\n.no-padding-top {\n  padding-top: 0 !important;\n}\n.no-padding-bottom {\n  padding-bottom: 0 !important;\n}\n.no-padding-left {\n  padding-left: 0 !important;\n}\n.no-padding-right {\n  padding-right: 0 !important;\n}\n\n.text-smaller {\n  font-size: 0.875em !important;\n  line-height: 1.35;\n}\n\n.text-small {\n  font-size: 0.67em !important;\n  line-height: 1.15;\n}\n\n.text-lg {\n  font-size: 1.15em;\n  line-height: 1.5;\n}\n\n.bg_cover {\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n.container {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.btn {\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 20px;\n  text-align: center;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  padding: 12px 24px;\n  border-radius: 4px;\n  border: 1px solid transparent;\n}\n.btn:hover {\n  color: inherit;\n}\n.btn:focus {\n  box-shadow: none;\n  outline: none;\n}\n.btn.btn-lg {\n  font-size: 1.15em;\n  padding: 16px 24px;\n}\n.btn.btn-sm {\n  padding: 8px 16px;\n}\n.btn.square {\n  border-radius: 0px;\n}\n.btn.semi-rounded {\n  border-radius: 12px;\n}\n.btn.rounded-full {\n  border-radius: 50px;\n}\n.btn.icon-left span,\n.btn.icon-left i {\n  margin-right: 8px;\n}\n.btn.icon-right span,\n.btn.icon-right i {\n  margin-left: 8px;\n}\n.btn.icon-btn {\n  width: 48px;\n  height: 48px;\n  padding: 0;\n  line-height: 48px;\n}\n.btn.icon-btn.btn-lg {\n  width: 56px;\n  height: 56px;\n  line-height: 56px;\n}\n.btn.icon-btn.btn-sm {\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n}\n\n.p-grid {\n  margin-bottom: -0.5rem;\n  flex-wrap: nowrap;\n}\n\n.p-field.p-grid .p-col-0,\n.p-formgrid.p-grid .p-col-0 {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.p-col-0,\n.p-sm-0,\n.p-md-0,\n.p-lg-0,\n.p-xl-0 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0;\n  flex: 0;\n  padding: 0;\n  width: 0;\n}\n.p-col-0 {\n  &.p-sm-1,\n  &.p-sm-2,\n  &.p-sm-3,\n  &.p-sm-4,\n  &.p-sm-5,\n  &.p-sm-6,\n  &.p-sm-7,\n  &.p-sm-8,\n  &.p-sm-9,\n  &.p-sm-10,\n  &.p-sm-11,\n  &.p-sm-12,\n  &.p-md-1,\n  &.p-md-2,\n  &.p-md-3,\n  &.p-md-4,\n  &.p-md-5,\n  &.p-md-6,\n  &.p-md-7,\n  &.p-md-8,\n  &.p-md-9,\n  &.p-md-10,\n  &.p-md-11,\n  &.p-md-12,\n  &.p-lg-1,\n  &.p-lg-2,\n  &.p-lg-3,\n  &.p-lg-4,\n  &.p-lg-5,\n  &.p-lg-6,\n  &.p-lg-7,\n  &.p-lg-8,\n  &.p-lg-9,\n  &.p-lg-10,\n  &.p-lg-11,\n  &.p-lg-12,\n  &.p-xl-1,\n  &.p-xl-2,\n  &.p-xl-3,\n  &.p-xl-4,\n  &.p-xl-5,\n  &.p-xl-6,\n  &.p-xl-7,\n  &.p-xl-8,\n  &.p-xl-9,\n  &.p-xl-10,\n  &.p-xl-11,\n  &.p-xl-12 {\n    padding: 0 !important;\n  }\n}\n.p-sm-0 {\n  &.p-md-1,\n  &.p-md-2,\n  &.p-md-3,\n  &.p-md-4,\n  &.p-md-5,\n  &.p-md-6,\n  &.p-md-7,\n  &.p-md-8,\n  &.p-md-9,\n  &.p-md-10,\n  &.p-md-11,\n  &.p-md-12,\n  &.p-lg-1,\n  &.p-lg-2,\n  &.p-lg-3,\n  &.p-lg-4,\n  &.p-lg-5,\n  &.p-lg-6,\n  &.p-lg-7,\n  &.p-lg-8,\n  &.p-lg-9,\n  &.p-lg-10,\n  &.p-lg-11,\n  &.p-lg-12,\n  &.p-xl-1,\n  &.p-xl-2,\n  &.p-xl-3,\n  &.p-xl-4,\n  &.p-xl-5,\n  &.p-xl-6,\n  &.p-xl-7,\n  &.p-xl-8,\n  &.p-xl-9,\n  &.p-xl-10,\n  &.p-xl-11,\n  &.p-xl-12 {\n    padding: 0 !important;\n  }\n}\n.p-md-0 {\n  &.p-lg-1,\n  &.p-lg-2,\n  &.p-lg-3,\n  &.p-lg-4,\n  &.p-lg-5,\n  &.p-lg-6,\n  &.p-lg-7,\n  &.p-lg-8,\n  &.p-lg-9,\n  &.p-lg-10,\n  &.p-lg-11,\n  &.p-lg-12,\n  &.p-xl-1,\n  &.p-xl-2,\n  &.p-xl-3,\n  &.p-xl-4,\n  &.p-xl-5,\n  &.p-xl-6,\n  &.p-xl-7,\n  &.p-xl-8,\n  &.p-xl-9,\n  &.p-xl-10,\n  &.p-xl-11,\n  &.p-xl-12 {\n    padding: 0 !important;\n  }\n}\n.p-lg-0 {\n  &.p-xl-1,\n  &.p-xl-2,\n  &.p-xl-3,\n  &.p-xl-4,\n  &.p-xl-5,\n  &.p-xl-6,\n  &.p-xl-7,\n  &.p-xl-8,\n  &.p-xl-9,\n  &.p-xl-10,\n  &.p-xl-11,\n  &.p-xl-12 {\n    padding: 0 !important;\n  }\n}\n@media screen and (min-width: 576px) {\n  .p-sm-0 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n  }\n  .p-sm-0 {\n    width: 0;\n  }\n}\n@media screen and (min-width: 768px) {\n  .p-md-0 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n  }\n  .p-md-0 {\n    width: 0;\n  }\n}\n@media screen and (min-width: 992px) {\n  .p-lg-0 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n  }\n  .p-lg-0 {\n    width: 0;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .p-xl-0 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n  }\n  .p-xl-0 {\n    width: 0;\n  }\n}\n\n/* ===== Buttons Css ===== */\n.primary-btn {\n  background: var(--primary);\n  color: var(--white);\n  box-shadow: var(--shadow-2);\n}\n.active.primary-btn, .primary-btn:hover, .primary-btn:focus {\n  background: var(--primary-dark);\n  color: var(--white);\n  box-shadow: var(--shadow-4);\n}\n.deactive.primary-btn {\n  background: var(--gray-4);\n  color: var(--dark-3);\n  pointer-events: none;\n}\n\n.primary-btn-outline {\n  border-color: var(--primary);\n  color: var(--primary);\n}\n.active.primary-btn-outline, .primary-btn-outline:hover, .primary-btn-outline:focus {\n  background: var(--primary-dark);\n  color: var(--white);\n}\n.deactive.primary-btn-outline {\n  color: var(--dark-3);\n  border-color: var(--gray-4);\n  pointer-events: none;\n}\n\n\n/* One Click Scrool Top Button*/\n.scroll-top {\n  width: 45px;\n  height: 45px;\n  line-height: 45px;\n  background: var(--primary);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  font-size: 14px;\n  color: #fff !important;\n  position: fixed;\n  bottom: 30px;\n  right: 30px;\n  z-index: 8;\n  cursor: pointer;\n  -webkit-transition: all .3s ease-out 0s;\n  transition: all .3s ease-out 0s;\n  border-radius: 5px;\n}\n\n.scroll-top:hover {\n  -webkit-box-shadow: 0 1rem 3rem rgba(35, 38, 45, 0.15) !important;\n  box-shadow: 0 1rem 3rem rgba(35, 38, 45, 0.15) !important;\n  -webkit-transform: translate3d(0, -5px, 0);\n  transform: translate3d(0, -5px, 0);\n  background-color: var(--dark-1);\n}\n\n/*===========================\n  Section Title Five CSS\n===========================*/\n.section-title-five {\n  text-align: center;\n  max-width: 550px;\n  margin: auto;\n  margin-bottom: 50px;\n  position: relative;\n  z-index: 5;\n}\n.section-title-five h6 {\n  font-weight: 600;\n  display: inline-block;\n  margin-bottom: 15px;\n  color: var(--primary);\n  border: 2px solid var(--primary);\n  border-radius: 30px;\n  padding: 8px 30px;\n}\n.section-title-five h2 {\n  margin-bottom: 15px;\n}\n.section-title-five p {\n  color: var(--dark-3);\n}\n\n/*===========================\n  Section Title Six CSS\n===========================*/\n.section-title-six {\n  font-family: \"Times New Roman\", Hoefler Text, Liberation Serif, Times, Cambria, serif;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  margin: 1rem;\n  margin-top: 1.5rem;\n\n  .heading {\n    display: flex;\n    flex-direction: row;\n    flex: 1;\n    justify-content: space-between;\n    margin-bottom: 1rem;\n\n    .heading-icon {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: 22px;\n      width: 42px;\n      height: 42px;\n      border-radius: 50%;\n      background: transparent;\n      border: 1px solid var(--accent);\n      color: var(--accent);\n    }\n  }\n\n  h2 {\n    color: var(--accent);\n    font-weight: 500;\n    font-size: 32px;\n    line-height: 1.3em;\n\n    i {\n      font-style: italic;\n    }\n  }\n\n  ul {\n    border-top: 1px solid var(--accent);\n    border-bottom: 1px solid var(--accent);\n\n    li {\n      font-family: \"Times New Roman\", Hoefler Text, Liberation Serif, Times, Cambria, serif;\n      color: var(--accent);\n      font-size: 1.3em !important;\n      margin: .5rem;\n      margin-left: 2rem;\n\n      &:last-child:not(:first-child) {\n        margin-top: 0;\n      }\n\n      &:first-child:not(:last-child) {\n        margin-bottom: 0;\n      }\n    }\n  }\n}\n\n@media (max-width: 575.98px) {\n  .section-title-six {\n    margin: .5rem;\n    margin-top: .75rem;\n  }\n}\n\n.made-in-ayroui {\n  position: fixed;\n  left: 5px;\n  bottom: 5px;\n  z-index: 999;\n  -webkit-transition: all 0.4s ease;\n  -moz-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.made-in-ayroui:hover{\n  transform: translateY(-5px);\n}\n\n/* Extra small devices (phones, 600px and down) */\n@media only screen and (max-width: 600px) {\n  .section-title-five {\n    margin-bottom: 5px;\n  }\n  .section-title-five h2 {\n    font-size: 1.5rem;\n    line-height: 1.9rem;\n  }\n}\n\n/* Small devices (portrait tablets and large phones, 600px and up) */\n@media only screen and (min-width: 600px) {\n  .section-title-five {\n    margin-bottom: 5px;\n  }\n  .section-title-five h2 {\n    font-size: 1.5rem;\n    line-height: 1.9rem;\n  }\n}\n\n/* Medium devices (landscape tablets, 768px and up) */\n@media only screen and (min-width: 768px) {\n  .section-title-five {\n    margin-bottom: 10px;\n  }\n  .section-title-five h2 {\n    font-size: 2rem;\n    line-height: 2.8rem;\n  }\n}\n\n/* Large devices (laptops/desktops, 992px and up) */\n@media only screen and (min-width: 992px) {\n  .section-title-five {\n    margin-bottom: 15px;\n  }\n}\n\n/* Extra large devices (large laptops and desktops, 1200px and up) */\n@media only screen and (min-width: 1200px) {\n  .section-title-five {\n    margin-bottom: 20px;\n  }\n}\n\n\n\n/*===========================\n  NAVBAR css\n===========================*/\n.navbar-toggler:focus {\n  box-shadow: none;\n}\n\n.mb-100 {\n  margin-bottom: 100px;\n}\n\n/*===== NAVBAR NINE =====*/\n.navbar-area.navbar-nine {\n  background: var(--primary);\n  padding: 0;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  z-index: 9;\n}\n.sticky {\n  position: fixed !important;\n  z-index:99 !important;\n  -webkit-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n  top: 0;\n  width: 100%;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {}\n.navbar-area.navbar-nine .navbar-brand {\n  margin: 0;\n}\n.navbar-area.navbar-nine .navbar {\n  position: relative;\n  padding: 0;\n}\n.navbar-area.navbar-nine .navbar .navbar-toggler .toggler-icon {\n  width: 30px;\n  height: 2px;\n  background-color: var(--white);\n  margin: 5px 0;\n  display: block;\n  position: relative;\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n}\n.navbar-area.navbar-nine .navbar .navbar-toggler.active .toggler-icon:nth-of-type(1) {\n  -webkit-transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  -o-transform: rotate(45deg);\n  transform: rotate(45deg);\n  top: 7px;\n}\n.navbar-area.navbar-nine .navbar .navbar-toggler.active .toggler-icon:nth-of-type(2) {\n  opacity: 0;\n}\n.navbar-area.navbar-nine .navbar .navbar-toggler.active .toggler-icon:nth-of-type(3) {\n  -webkit-transform: rotate(135deg);\n  -moz-transform: rotate(135deg);\n  -ms-transform: rotate(135deg);\n  -o-transform: rotate(135deg);\n  transform: rotate(135deg);\n  top: -7px;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {\n  .navbar-area.navbar-nine .navbar .navbar-collapse {\n    position: absolute;\n    top: 116%;\n    left: 0;\n    width: 100%;\n    background-color: var(--primary);\n    z-index: 8;\n    padding: 10px 16px;\n  }\n}\n@media only screen and (min-width: 1200px) and (max-width: 1399px), only screen and (min-width: 1400px) {\n  .navbar-area.navbar-nine .navbar .navbar-nav {\n    margin-left: 80px;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {\n  .navbar-area.navbar-nine .navbar .navbar-nav {\n    margin-right: 0;\n  }\n}\n.navbar-area.navbar-nine .navbar .navbar-nav .nav-item {\n  position: relative;\n}\n.navbar-area.navbar-nine .navbar .navbar-nav .nav-item a {\n  display: flex;\n  align-items: center;\n  padding: 11px 16px;\n  color: var(--white);\n  text-transform: capitalize;\n  position: relative;\n  border-radius: 5px;\n  font-weight: 500;\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n  margin: 14px 0;\n  opacity: 0.7;\n}\n.navbar-area.navbar-nine .navbar .navbar-nav .nav-item a:hover {\n  opacity: 1;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {\n  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item a {\n    padding: 10px 0;\n    display: block;\n    border: 0;\n    margin: 0;\n  }\n}\n.navbar-area.navbar-nine .navbar .navbar-nav .nav-item a.active {\n  opacity: 1;\n}\n.navbar-area.navbar-nine .navbar .navbar-nav .nav-item a i {\n  font-size: 12px;\n  font-weight: 700;\n  padding-left: 7px;\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {\n  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item a i {\n    position: relative;\n    top: -5px;\n  }\n}\n.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu {\n  position: absolute;\n  left: 0;\n  top: 130%;\n  width: 230px;\n  background-color: var(--white);\n  border-radius: 5px;\n  opacity: 0;\n  visibility: hidden;\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n  z-index: 99;\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);\n  padding: 10px;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {\n  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu {\n    position: relative !important;\n    width: 100% !important;\n    left: 0 !important;\n    top: auto !important;\n    opacity: 1 !important;\n    visibility: visible !important;\n    right: auto;\n    -webkit-transform: translateX(0%);\n    -moz-transform: translateX(0%);\n    -ms-transform: translateX(0%);\n    -o-transform: translateX(0%);\n    transform: translateX(0%);\n    -webkit-transition: all none ease-out 0s;\n    -moz-transition: all none ease-out 0s;\n    -ms-transition: all none ease-out 0s;\n    -o-transition: all none ease-out 0s;\n    transition: all none ease-out 0s;\n    box-shadow: none;\n    text-align: left;\n    border-top: 0;\n    height: 0;\n  }\n}\n.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu.collapse:not(.show) {\n  height: auto;\n  display: block;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {\n  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu.collapse:not(.show) {\n    height: 0;\n    display: none;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {\n  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu.show {\n    height: auto;\n  }\n}\n.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li {\n  position: relative;\n}\n.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li .sub-nav-toggler {\n  color: var(--black);\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n}\n.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li a {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 16px;\n  position: relative;\n  color: var(--dark-2);\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n  border-radius: 0;\n  margin: 0 0;\n  z-index: 5;\n  opacity: 1;\n}\n.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li a i {\n  font-weight: 700;\n  font-size: 12px;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {\n  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li a i {\n    display: none;\n  }\n}\n.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li a .sub-nav-toggler i {\n  display: inline-block;\n}\n.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li .sub-menu {\n  right: auto;\n  left: 100%;\n  top: 0;\n  opacity: 0;\n  visibility: hidden;\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n}\n@media only screen and (min-width: 1200px) and (max-width: 1399px), only screen and (min-width: 1400px) {\n  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li .sub-menu {\n    margin-left: 10px;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li .sub-menu {\n    padding-left: 30px;\n  }\n}\n@media (max-width: 767px) {\n  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li .sub-menu {\n    padding-left: 30px;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {\n  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li .sub-menu.show {\n    visibility: visible;\n    height: auto;\n    position: relative;\n  }\n}\n.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li:hover .sub-menu {\n  opacity: 1;\n  visibility: visible;\n}\n.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li:hover .sub-nav-toggler {\n  color: var(--white);\n}\n@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {\n  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li:hover .sub-nav-toggler {\n    color: var(--primary);\n  }\n}\n.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li:hover > a {\n  color: var(--primary);\n  padding-left: 22px;\n}\n.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li:hover > a i {\n  color: var(--primary);\n}\n@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {\n  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li:hover > a {\n    color: var(--primary);\n  }\n}\n.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li:hover > a::after {\n  opacity: 1;\n}\n.navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-menu li:hover > a::before {\n  opacity: 1;\n}\n.navbar-area.navbar-nine .navbar .navbar-nav .nav-item:hover .sub-menu {\n  opacity: 1;\n  visibility: visible;\n  top: 115%;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {\n  .navbar-area.navbar-nine .navbar .navbar-nav .nav-item .sub-nav-toggler {\n    display: inline-block;\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 10px 14px;\n    font-size: 16px;\n    background: none;\n    border: 0;\n    color: var(--white);\n  }\n}\n.navbar-area.navbar-nine .navbar .navbar-btn {\n  margin-top: 6px;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .navbar-area.navbar-nine .navbar .navbar-btn {\n    position: absolute;\n    right: 70px;\n    top: 7px;\n  }\n}\n@media (max-width: 767px) {\n  .navbar-area.navbar-nine .navbar .navbar-btn {\n    position: absolute;\n    right: 60px;\n    top: 7px;\n  }\n}\n.navbar-area.navbar-nine .navbar .navbar-btn .menu-bar,\n.navbar-btn .menu-bar {\n  font-size: inherit;\n  position: relative;\n  overflow: hidden;\n  color: var(--white);\n  height: 40px;\n  width: 40px;\n  line-height: 42px;\n  text-align: center;\n  border: 1px solid rgba(238, 238, 238, 0.425);\n  border-radius: 50%;\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n}\n.navbar-area.navbar-nine .navbar .navbar-btn .menu-bar:hover {\n  border-color: transparent;\n  color: var(--primary);\n  background-color: var(--white);\n}\n\n/*===== SIDEBAR ONE =====*/\n.sidebar-left {\n  position: fixed;\n  top: 0;\n  right: 0;\n  background-color: var(--white);\n  height: 100%;\n  width: 350px;\n  padding-top: 80px;\n  z-index: 999;\n  -webkit-transform: translateX(100%);\n  -moz-transform: translateX(100%);\n  -ms-transform: translateX(100%);\n  -o-transform: translateX(100%);\n  transform: translateX(100%);\n  transition: all 0.4s ease-in-out;\n  text-align: left;\n}\n.sidebar-left.open {\n  -webkit-transform: translateX(0);\n  -moz-transform: translateX(0);\n  -ms-transform: translateX(0);\n  -o-transform: translateX(0);\n  transform: translateX(0);\n}\n@media (max-width: 767px) {\n  .sidebar-left {\n    width: 100%;\n    max-width: 480px;\n    overflow-y: scroll;\n  }\n}\n.sidebar-left .sidebar-close {\n  position: absolute;\n  top: 30px;\n  right: 30px;\n}\n.sidebar-left .sidebar-close .close {\n  font-size: 18px;\n  color: var(--black);\n  -webkit-transition: all 0.2s ease-out 0s;\n  -moz-transition: all 0.2s ease-out 0s;\n  -ms-transition: all 0.2s ease-out 0s;\n  -o-transition: all 0.2s ease-out 0s;\n  transition: all 0.2s ease-out 0s;\n}\n.sidebar-left .sidebar-close .close:hover {\n  cursor: pointer;\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.sidebar-left .sidebar-content {\n  padding: 0px 30px;\n}\n.sidebar-left .sidebar-content .sidebar-logo {\n  h3 {\n    color: var(--primary);\n  }\n}\n.sidebar-left .sidebar-content .sidebar-menu {\n  margin-top: 30px;\n}\n.sidebar-left .sidebar-content .sidebar-menu .menu-title {\n  font-size: 18px;\n  font-weight: 600;\n}\n.sidebar-left .sidebar-content .sidebar-menu ul {\n  margin-top: 15px;\n}\n.sidebar-left .sidebar-content .sidebar-menu ul li a {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 500;\n  padding: 8px 0;\n  color: var(--primary);\n  text-transform: capitalize;\n  position: relative;\n  border-radius: 5px;\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n  display: block;\n}\n.sidebar-left .sidebar-content .sidebar-menu ul li a:hover {\n  color: var(--primary-dark);\n  padding-left: 5px;\n  cursor: pointer;\n}\n.sidebar-left .sidebar-content .text {\n  margin-top: 20px;\n}\n.sidebar-left .sidebar-content .sidebar-social {\n  margin-top: 30px;\n}\n.sidebar-left .sidebar-content .sidebar-social .social-title {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 25px;\n}\n.sidebar-left .sidebar-content .sidebar-social ul li {\n  display: inline-block;\n  margin-right: 5px;\n}\n.sidebar-left .sidebar-content .sidebar-social ul li:last-child {\n  margin: 0;\n}\n.sidebar-left .sidebar-content .sidebar-social ul li a {\n  height: 38px;\n  width: 38px;\n  line-height: 38px;\n  text-align: center;\n  border: 1px solid #eee;\n  border-radius: 50%;\n  font-size: 18px;\n  color: #666;\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n}\n.sidebar-left .sidebar-content .sidebar-social ul li a:hover {\n  color: var(--white);\n  background-color: var(--primary);\n  border-color: transparent;\n}\n\n.overlay-left {\n  position: fixed;\n  background-color: rgba(0, 0, 0, 0.6);\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: none;\n  z-index: 99;\n}\n.overlay-left.open {\n  display: block;\n}\n\n\n/* ===== Buttons Css ===== */\n.header-eight .primary-btn {\n  background: var(--primary);\n  color: var(--white);\n  box-shadow: var(--shadow-2);\n}\n.header-eight .active.primary-btn, .header-eight .primary-btn:hover, .header-eight .primary-btn:focus {\n  background: var(--primary-dark);\n  color: var(--white);\n  box-shadow: var(--shadow-4);\n}\n.header-eight .deactive.primary-btn {\n  background: var(--gray-4);\n  color: var(--dark-3);\n  pointer-events: none;\n}\n\n/*======================================\n    header Area CSS\n========================================*/\n.header-eight {\n  height: auto;\n  min-height: calc(100vh - 78px);\n  margin-top: -78px;\n  display: flex;\n  flex-direction : column;\n  position: relative;\n  background: var(--white);\n  transition: .9s;\n\n  &.landscape.navbar-collapse {\n    padding: 46px 0 0 !important;\n  }\n}\n/* Extra small devices (phones, 600px and down) */\n@media only screen and (max-width: 600px) {\n  ::ng-deep {\n    .header-eight {\n      height: calc(100vh - 54px) !important;\n      max-height: calc(100vw * 1) !important;\n      padding-top: 0;\n      margin-top: 54px;\n    }\n  }\n}\n\n/* Small devices (portrait tablets and large phones, 600px and up) */\n@media only screen and (min-width: 600px) and (max-width: 767px) {\n  ::ng-deep {\n    .header-eight {\n      height: calc(100vh - 54px) !important;\n      max-height: calc(100vw * 1.55) !important;\n      padding-top: 0;\n      margin-top: 54px;\n    }\n  }\n}\n\n/* Medium devices (landscape tablets, 768px and up) */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  ::ng-deep {\n    .header-eight {\n      height: calc(100vh - 62px) !important;\n      padding-top: 0;\n      margin-top: 62px;\n    }\n  }\n}\n\n/* Large devices (laptops/desktops, 992px and up) */\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  ::ng-deep {\n    .header-eight {\n      padding: 94px 0 80px 0 !important;\n    }\n  }\n}\n\n/* Extra large devices (large laptops and desktops, 1200px and up) */\n@media only screen and (min-width: 1200px) {}\n\n.banner1:after {\n  content:'';\n  background: url('assets/images/rooftop-solar-suburb.jpeg') no-repeat top left fixed;\n  background-size: cover;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  opacity: 0.2;\n}\n\n.banner2:after {\n  content:'';\n  background: url('assets/images/rooftop-solar-grid.jpeg') no-repeat top left fixed;\n  background-size: cover;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  opacity: 0.5;\n}\n.header-eight .header-image img {\n  width: 100%;\n  border-radius: 8px;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {\n  .header-eight .header-image {\n    margin-top: 40px;\n  }\n}\n.header-eight .header-content {\n  border-radius: 0;\n  position: relative;\n  z-index: 1;\n  text-align: left;\n  margin-top: calc(78px * 2);\n}\n.header-eight .header-content h1 {\n  font-weight: 700;\n  color: var(--accent);\n  text-shadow: 0 3px 8px #00000017;\n  text-transform: capitalize;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .header-eight .header-content h1  {\n    font-size: 35px;\n    line-height: 45px;\n  }\n}\n@media (max-width: 767px) {\n  .header-eight .header-content h1  {\n    font-size: 30px;\n    line-height: 42px;\n  }\n}\n.header-eight .header-content h1 span {\n  display: block;\n}\n.header-eight .header-content p {\n  margin-top: 30px;\n  color: var(--charcoal);\n  opacity: 0.7;\n}\n.header-eight .button {\n  margin-top: 40px;\n}\n.header-eight .primary-btn {\n  margin-right: 12px;\n  background-color: var(--white);\n  color: var(--primary);\n  border: 1px solid transparent;\n}\n.header-eight .primary-btn:hover {\n  background-color: transparent;\n  color: var(--white);\n  border-color: var(--white);\n}\n.header-eight .video-button {\n  display: inline-flex;\n  align-items: center;\n}\n@media (max-width: 767px) {\n  .header-eight .video-button {\n    margin-top: 20px;\n  }\n}\n.header-eight .video-button .text {\n  display: inline-block;\n  margin-left: 15px;\n  color: var(--white);\n  font-weight: 600;\n}\n.header-eight .video-button .icon-btn {\n  background: var(--white);\n  color: var(--primary);\n}\n\n/*===========================\n  about-05 css\n===========================*/\n.about-five {\n  background-color: var(--light-3);\n  padding-top: 120px;\n  padding-bottom: 90px;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .about-five {\n    padding-top: 100px;\n    padding-bottom:70px;\n  }\n}\n@media (max-width: 767px) {\n  .about-five {\n    padding-top: 80px;\n    padding-bottom:60px;\n  }\n}\n.about-five-content{\n  padding-left: 50px;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .about-five-content {\n    padding-left: 0;\n  }\n}\n@media (max-width: 767px) {\n  .about-five-content {\n    padding-left: 0;\n  }\n}\n.about-five-content .small-title {\n  position: relative;\n  padding-left: 30px;\n}\n.about-five-content .small-title::before {\n  position: absolute;\n  content: \"\";\n  left: 0;\n  top: 50%;\n  background-color: var(--primary);\n  height: 2px;\n  width: 20px;\n  margin-top: -1px;\n}\n.about-five-content .main-title {\n  margin-top: 20px;\n}\n.about-five-content .about-five-tab {\n  margin-top: 40px;\n}\n.about-five-content .about-five-tab nav {\n  border: none;\n  background-color: var(--light-1);\n  padding: 15px;\n  border-radius: 5px;\n}\n.about-five-content .about-five-tab nav .nav-tabs {\n  border: none;\n}\n.about-five-content .about-five-tab nav button {\n  border: none;\n  color: var(--dark-1);\n  font-weight: 600;\n  padding: 0;\n  margin-right: 20px;\n  position: relative;\n  background-color: var(--white);\n  padding: 10px 18px;\n  border-radius: 4px;\n  text-transform: capitalize;\n}\n@media (max-width: 767px) {\n  .about-five-content .about-five-tab nav button {\n    margin: 0;\n    margin-bottom: 10px;\n    width: 100%;\n  }\n  .about-five-content .about-five-tab nav button:last-child {\n    margin: 0;\n  }\n}\n.about-five-content .about-five-tab nav button:hover {\n  color: var(--primary);\n}\n.about-five-content .about-five-tab nav button.active {\n  background-color: var(--primary);\n  color: var(--white);\n}\n.about-five-content .about-five-tab nav button:last-child {\n  margin-right: 0;\n}\n.about-five-content .about-five-tab .tab-content {\n  border: none;\n}\n.about-five-content .about-five-tab .tab-content p {\n  margin-bottom: 20px;\n}\n.about-five-content .about-five-tab .tab-content p:last-child {\n  margin: 0;\n}\n\n.about-image-five {\n  padding-left: 60px;\n  position: relative;\n  z-index: 2;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .about-image-five {\n    margin-bottom: 70px;\n    padding-left: 30px;\n  }\n}\n@media (max-width: 767px) {\n  .about-image-five {\n    margin-bottom: 60px;\n    padding-left: 0;\n  }\n}\n.about-image-five .shape {\n  position: absolute;\n  left: 30px;\n  top: -30px;\n  z-index: -1;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .about-image-five .shape {\n    left: 0;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .about-image-five::before {\n    right: -15px;\n    bottom: -15px;\n  }\n}\n@media (max-width: 767px) {\n  .about-image-five::before {\n    display: none;\n  }\n}\n.about-image-five img {\n  width: 100%;\n  z-index: 2;\n}\n\n\n/*===========================\n  services css\n===========================*/\n.services-eight {\n  padding: 100px 0;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .services-eight {\n    padding: 80px 0 50px 0;\n  }\n}\n@media (max-width: 767px) {\n  .services-eight {\n    padding: 60px 0 30px 0;\n  }\n}\n.services-eight .single-services {\n  padding: 40px 30px;\n  border: 1px solid var(--light-1);\n  border-radius: 10px;\n  margin-bottom: 30px;\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n}\n.services-eight .single-services:hover {\n  box-shadow: var(--shadow-4);\n}\n.services-eight .single-services:hover .service-icon {\n  color: var(--white);\n  border-color: transparent;\n  background: var(--primary);\n}\n.services-eight .single-services:hover .service-icon::after {\n  opacity: 1;\n  visibility: visible;\n}\n.services-eight .single-services .service-icon {\n  width: 78px;\n  height: 78px;\n  border-radius: 50%;\n  margin-bottom: 25px;\n  background: var(--white);\n  border: 2px solid var(--primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--primary);\n  font-size: 40px;\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n  position: relative;\n}\n.services-eight .single-services .service-icon::after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  position: absolute;\n  opacity: 0;\n  visibility: hidden;\n  background: var(--primary);\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n  z-index: -1;\n  border-radius: 50%;\n  border: 1px solid transparent;\n}\n.services-eight .single-services .service-content h4 {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 20px;\n}\n.services-eight .single-services .service-content p {\n  color: var(--dark-3);\n}\n\n\n\n/*===== VIDEO ONE =====*/\n.video-one {\n  background-color: var(--light-3);\n  padding: 100px 0;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .video-one {\n    padding: 80px;\n  }\n}\n@media (max-width: 767px) {\n  .video-one {\n    padding: 60px 0;\n  }\n}\n.video-one .video-title h5 {\n  font-weight: 600;\n  color: var(--primary);\n}\n.video-one .video-title h2 {\n  font-weight: 700;\n  color: var(--black);\n  margin-top: 10px;\n}\n.video-one .video-title .text-lg {\n  margin-top: 24px;\n  color: var(--dark-3);\n}\n.video-one .video-content {\n  position: relative;\n  margin-top: 20px;\n  border-radius: 8px;\n  overflow: hidden;\n}\n.video-one .video-content img {\n  border-radius: 8px;\n}\n.video-one .video-content a {\n  width: 88px;\n  height: 88px;\n  line-height: 88px;\n  text-align: center;\n  border-radius: 50%;\n  background-color: var(--primary);\n  color: var(--white);\n  font-size: 30px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n  padding-left: 3px;\n}\n@media (max-width: 767px) {\n  .video-one .video-content a {\n    width: 68px;\n    height: 68px;\n    line-height: 68px;\n    font-size: 20px;\n  }\n}\n.video-one .video-content a:hover {\n  background-color: var(--white);\n  color: var(--primary);\n}\n\n\n/*===== PRICING THIRTEEN =====*/\n.pricing-fourteen {\n  padding: 100px 0;\n  background-color: var(--light-3);\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .pricing-fourteen {\n    padding: 80px;\n  }\n}\n@media (max-width: 767px) {\n  .pricing-fourteen {\n    padding: 60px 0;\n  }\n}\n.pricing-style-fourteen {\n  border: 1px solid var(--light-1);\n  border-radius: 10px;\n  margin-top: 30px;\n  background-color: var(--white);\n  transition: all 0.4s ease;\n  padding: 50px 35px;\n  text-align: center;\n  z-index: 0;\n}\n.pricing-style-fourteen:hover {\n  box-shadow: var(--shadow-4);\n}\n.pricing-style-fourteen.middle {\n  box-shadow: var(--shadow-4);\n}\n.pricing-style-fourteen.middle .title {\n  border-color: var(--primary);\n  background: var(--primary);\n  color: var(--white);\n}\n.pricing-style-fourteen .title {\n  font-weight: 500;\n  margin-bottom: 25px;\n  color: var(--primary);\n  padding: 8px 20px;\n  border: 2px solid var(--primary);\n  display: inline-block;\n  border-radius: 30px;\n  font-size: 16px;\n}\n.pricing-style-fourteen .table-head p {\n  color: var(--dark-3);\n}\n.pricing-style-fourteen .price {\n  padding-top: 30px;\n}\n.pricing-style-fourteen .amount {\n  font-weight: 600;\n  display: inline-block;\n  position: relative;\n  padding-left: 15px;\n  font-size: 55px;\n}\n.pricing-style-fourteen .currency {\n  font-weight: 400;\n  color: var(--dark-3);\n  font-size: 20px;\n  position: absolute;\n  left: 0;\n  top: 6px;\n}\n.pricing-style-fourteen .duration {\n  display: inline-block;\n  font-size: 18px;\n  color: var(--dark-3);\n  font-weight: 400;\n}\n.pricing-style-fourteen .light-rounded-buttons {\n  margin: 0;\n  margin-top: 30px;\n  margin-bottom: 40px;\n}\n.pricing-style-fourteen .table-list li {\n  position: relative;\n  margin-bottom: 10px;\n  color: var(--dark-3);\n  text-align: left;\n}\n.pricing-style-fourteen .table-list li:last-child {\n  margin: 0;\n}\n.pricing-style-fourteen .table-list li i {\n  color: var(--primary);\n  font-size: 16px;\n  padding-right: 8px;\n}\n.pricing-style-fourteen .table-list li i.deactive {\n  color: var(--dark-3);\n}\n\n\n\n\n/* ===== Buttons Css ===== */\n.call-action .inner-content .light-rounded-buttons .primary-btn-outline {\n  border-color: var(--primary);\n  color: var(--primary);\n}\n.call-action .inner-content .light-rounded-buttons .active.primary-btn-outline, .call-action .inner-content .light-rounded-buttons .primary-btn-outline:hover, .call-action .inner-content .light-rounded-buttons .primary-btn-outline:focus {\n  background: var(--white);\n  color: var(--primary);\n  border-color: transparent;\n}\n.call-action .inner-content .light-rounded-buttons .deactive.primary-btn-outline {\n  color: var(--dark-3);\n  border-color: var(--gray-4);\n  pointer-events: none;\n}\n\n/*===== call action four =====*/\n.call-action {\n  z-index: 2;\n  padding: 100px 0;\n  background: linear-gradient(45deg, var(--primary), var(--primary-dark));\n  position: relative;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .call-action {\n    padding: 80px;\n  }\n}\n@media (max-width: 767px) {\n  .call-action {\n    padding: 60px 0;\n  }\n}\n.call-action:before {\n  position: absolute;\n  content: \"\";\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  background-image: url(\"assets/images/call-action/overlay.png\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: top;\n  z-index: -1;\n}\n.call-action .inner-content {\n  text-align: center;\n}\n.call-action .inner-content h2 {\n  font-weight: 700;\n  margin-bottom: 30px;\n  color: var(--white);\n}\n.call-action .inner-content p {\n  color: var(--white);\n}\n.call-action .inner-content .light-rounded-buttons {\n  margin-top: 45px;\n  display: block;\n}\n.call-action .inner-content .light-rounded-buttons .primary-btn-outline {\n  border-color: var(--white);\n  color: var(--white);\n}\n\n/*======================================\n    Brand CSS\n========================================*/\n.brand-area {\n  padding: 100px 0;\n  background: var(--light-3);\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .brand-area {\n    padding: 80px;\n  }\n}\n@media (max-width: 767px) {\n  .brand-area {\n    padding: 60px 0;\n  }\n}\n.brand-area .clients-logos {\n  text-align: center;\n  display: inline-block;\n  margin-top: 20px;\n}\n.brand-area .clients-logos .single-image {\n  display: inline-block;\n  margin: 13px 10px;\n  line-height: 100px;\n  padding: 8px 25px;\n  border-radius: 8px;\n  -webkit-transition: all 0.4s ease-out 0s;\n  -moz-transition: all 0.4s ease-out 0s;\n  -ms-transition: all 0.4s ease-out 0s;\n  -o-transition: all 0.4s ease-out 0s;\n  transition: all 0.4s ease-out 0s;\n  border: 1px solid #eee;\n}\n.brand-area .clients-logos .single-image:hover {\n  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.096);\n  -webkit-transform: translateY(-5px);\n  -moz-transform: translateY(-5px);\n  -ms-transform: translateY(-5px);\n  -o-transform: translateY(-5px);\n  transform: translateY(-5px);\n}\n.brand-area .clients-logos img {\n  max-width: 170px;\n  transition: all 0.4s ease-in-out;\n  cursor: pointer;\n}\n\n.map-style-9 {\n  margin-top: -130px;\n}\n\n/* Footer eleven css */\n.footer-eleven {\n  padding-top: 30px;\n  padding-bottom: 100px;\n  background-color: var(--dark-1);\n  position: relative;\n  border-top: 2px solid black;\n\n  h3 {\n    color: var(--primary);\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {\n  .footer-eleven {\n    padding-top: 30px;\n    padding-bottom: 70px;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .footer-eleven .footer-widget {\n    margin-top: 40px;\n  }\n}\n@media (max-width: 1199px) {\n  .footer-eleven .footer-widget {\n    margin-top: 40px;\n    /*text-align: center;*/\n  }\n\n  .footer-eleven .footer-widget.f-about {\n    margin-top: 40px;\n    text-align: center;\n  }\n}\n.footer-eleven .footer-widget h4 {\n  font-weight: 700;\n  margin-bottom: 6px;\n  color: var(--primary);\n}\n@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {\n  .footer-eleven .footer-widget h4 {\n    margin-bottom: 6px;\n  }\n}\n.footer-eleven .f-about {\n  padding-right: 30px;\n}\n@media (max-width: 767px) {\n  .footer-eleven .f-about {\n    padding: 0;\n  }\n}\n.footer-eleven .f-about p {\n  /*color: var(--dark-3);*/\n  color: var(--light-1);\n  margin-top: 20px;\n}\n.footer-eleven .f-about .copyright-text {\n  /*color: var(--dark-3);*/\n  color: var(--light-1);\n  margin-top: 20px;\n\n  @media (max-width: 1199px) {\n    .visualage {\n      display: flex;\n      width: fit-content;\n      margin: auto;\n    }\n  }\n\n  .visualage {\n    display: flex;\n    width: fit-content;\n  }\n}\n.footer-eleven .f-about .copyright-text span {\n  display: block;\n}\n@media (max-width: 767px) {\n  .footer-eleven .f-about .copyright-text {\n    margin-top: 20px;\n  }\n}\n.footer-eleven .f-about .copyright-text a {\n  color: var(--light-1);\n}\n.footer-eleven .f-about .copyright-text a:hover {\n  color: var(--visualage-1);\n}\n.footer-eleven .f-link li {\n  display: block;\n  margin-bottom: 6px;\n}\n.footer-eleven .f-link li:last-child {\n  margin: 0 0 25px 0;\n}\n.footer-eleven .f-link li a {\n  /*color: var(--dark-3);*/\n  color: var(--light-1);\n  -webkit-transition: all 0.4s ease-out 0s;\n  -moz-transition: all 0.4s ease-out 0s;\n  -ms-transition: all 0.4s ease-out 0s;\n  -o-transition: all 0.4s ease-out 0s;\n  transition: all 0.4s ease-out 0s;\n}\n.footer-eleven .f-link li a:hover {\n  color: var(--primary);\n}\n@media only screen and (min-width: 1200px) and (max-width: 1399px), only screen and (min-width: 1400px) {\n  .footer-eleven .newsletter {\n    padding-left: 80px;\n  }\n}\n.footer-eleven .newsletter p {\n  color: var(--dark-3);\n}\n.footer-eleven .newsletter-form {\n  margin-top: 30px;\n  position: relative;\n}\n.footer-eleven .newsletter-form input {\n  height: 55px;\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid var(--gray-4);\n  box-shadow: none;\n  text-shadow: none;\n  padding-left: 18px;\n  padding-right: 65px;\n  transition: all 0.4s ease;\n}\n.footer-eleven .newsletter-form input:focus {\n  border-color: var(--primary);\n}\n.footer-eleven .newsletter-form .button {\n  position: absolute;\n  right: 7px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.footer-eleven .newsletter-form .sub-btn {\n  height: 42px;\n  width: 42px;\n  border-radius: 6px;\n  background-color: var(--primary);\n  color: var(--white);\n  text-align: center;\n  line-height: 42px;\n  border: none;\n  box-shadow: none;\n  text-shadow: none;\n  font-size: 17px;\n  transition: all 0.4s ease;\n}\n.footer-eleven .newsletter-form .sub-btn:hover {\n  color: var(--white);\n  background-color: var(--primary-dark);\n}\n.insight {\n  padding: 0.5rem 0.5rem 0.5rem 3rem !important;\n\n  .pi.pi-info-circle {\n    color: var(--primary);\n    font-size: xx-large;\n  }\n}\n@media (max-width: 991px) {\n  .insight {\n    padding: 0.5rem !important;\n  }\n}\n.p-span-12 {\n  width: 100% !important;\n}\n\n\n:host ::ng-deep .p-breadcrumb {}\n:host ::ng-deep .p-breadcrumb ul li.p-breadcrumb-home span.pi.pi-home {color: var(--primary); font-size: 1.25rem;}\n:host ::ng-deep .p-breadcrumb ul li.p-breadcrumb-home span.pi.pi-home:hover {color: var(--primary-light);}\n:host ::ng-deep .p-breadcrumb ul li.p-breadcrumb-home a {vertical-align: text-top;}\n:host ::ng-deep .p-breadcrumb ul li .p-menuitem-link .p-menuitem-text {color: var(--primary);}\n:host ::ng-deep .p-breadcrumb ul li .p-menuitem-link .p-menuitem-text:hover {color: var(--primary-light);}\n:host ::ng-deep .p-breadcrumb ul li .p-breadcrumb-chevron {}\n:host ::ng-deep .p-breadcrumb ul li:last-child .p-menuitem-text {color: var(--text-color);}\n:host ::ng-deep .p-breadcrumb ul li:last-child .p-menuitem-text:hover {color: var(--text-color);}\n\n:host ::ng-deep p-panel {\n  &.blank {\n    .p-panel-header { padding: 0; border: none; display: none; }\n    .p-panel-content { padding: 0; border: none; }\n    .p-panel-footer { padding: 0; border: none; display: none; }\n  }\n}\n\n:host ::ng-deep .sc-blockui {\n  background-color: rgb(255, 255, 255, 0.85) !important;\n  border-radius: 10px;\n  z-index: 4 !important;\n}\n\n@keyframes ui-progress-spinner-color {\n  100%,\n  0% {stroke: #6ea2fc;}\n  40% {stroke: #6ea2fc;}\n  66% {stroke: #6ea2fc;}\n  80%,90% {stroke: #6ea2fc;}\n}\n\n.loading-indicator {position: fixed; z-index: 1010; height: 50px; width: 50px; overflow: visible; top: calc(50% - 25px); left: calc(50% - 25px); bottom: 0; right: 0;}\n.loading-indicator:before {content: ''; display: block; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.25);}\np-progressSpinner {z-index: 1011; width: 50px; height: 50px; display: block; position: absolute; top: calc(50vh - 25px); left: calc(50% - 25px);}\np-progressBar {z-index: 1011; width: 100%; height: 6px !important; display: block; position: absolute; top: 0; left: 0; line-height: 6px;}\n\n.p-progressbar {\n  border: $progressBarBorder;\n  height: $progressBarHeight;\n  background: #dcdcdc;\n  border-radius: $progressBarBorderTopLeftRadius $progressBarBorderTopRightRadius 0 0;\n\n  .p-progressbar-value {\n    border: 0 none;\n    margin: 0;\n    background: #4CAF50;\n  }\n\n  .p-progressbar-label {\n    color: $shade900;\n    line-height: $progressBarHeight;\n  }\n}\n\n:host ::ng-deep {\n  .p-blockui.p-component-overlay {\n    background: rgba(195, 195, 195, 0.5) !important;\n  }\n\n  section {\n    &:not(.map-section) {\n      padding: 2rem 0;\n    }\n\n    &:nth-child(odd):not(#contact-area):not(#navbar-area) {\n      /*background-color: white !important;*/\n    }\n\n    &:nth-child(even):not(#navbar-area):not(#contact-area) {\n      /*background: var(--light-3) !important;*/\n    }\n  }\n}",":host ::ng-deep {\n  .p-overflow-hidden {\n    overflow: hidden;\n    padding-right: var(--scrollbar-width)\n  }\n\n@layer primeng {\n  .p-component,.p-component * {\n    box-sizing: border-box\n  }\n\n  .p-hidden {\n    display: none\n  }\n\n  .p-hidden-space {\n    visibility: hidden\n  }\n\n  .p-hidden-accessible {\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px\n  }\n\n  .p-hidden-accessible input,.p-hidden-accessible select {\n    transform: scale(0)\n  }\n\n  .p-reset {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    outline: 0;\n    text-decoration: none;\n    font-size: 100%;\n    list-style: none\n  }\n\n  .p-disabled,.p-disabled * {\n    cursor: default!important;\n    pointer-events: none\n  }\n\n  .p-component-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%\n  }\n\n  .p-unselectable-text {\n    -webkit-user-select: none;\n    user-select: none\n  }\n\n  .p-scrollbar-measure {\n    width: 100px;\n    height: 100px;\n    overflow: scroll;\n    position: absolute;\n    top: -9999px\n  }\n\n  @keyframes p-fadein {\n    0% {\n      opacity: 0\n    }\n\n    to {\n      opacity: 1\n    }\n  }\n\n  .p-link {\n    text-align: left;\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    cursor: pointer;\n    -webkit-user-select: none;\n    user-select: none\n  }\n\n  .p-link:disabled {\n    cursor: default\n  }\n\n  .p-sr-only {\n    border: 0;\n    clip: rect(1px,1px,1px,1px);\n    clip-path: inset(50%);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n    word-wrap: normal!important\n  }\n\n  .p-connected-overlay {\n    opacity: 0;\n    transform: scaleY(.8);\n    transition: transform .12s cubic-bezier(0,0,.2,1),opacity .12s cubic-bezier(0,0,.2,1)\n  }\n\n  .p-connected-overlay-visible {\n    opacity: 1;\n    transform: scaleY(1)\n  }\n\n  .p-connected-overlay-hidden {\n    opacity: 0;\n    transform: scaleY(1);\n    transition: opacity .1s linear\n  }\n\n  .p-toggleable-content.ng-animating {\n    overflow: hidden\n  }\n\n  .p-icon-wrapper {\n    display: inline-flex\n  }\n\n  .p-icon {\n    display: inline-block\n  }\n\n  .p-icon-spin {\n    animation: p-icon-spin 2s infinite linear\n  }\n}\n\n  @keyframes p-icon-spin {\n    0% {\n      transform: rotate(0)\n    }\n\n    to {\n      transform: rotate(359deg)\n    }\n  }\n\n@layer primeng {\n  .p-badge {\n    display: inline-block;\n    border-radius: 10px;\n    text-align: center;\n    padding: 0 .5rem\n  }\n\n  .p-overlay-badge {\n    position: relative\n  }\n\n  .p-overlay-badge .p-badge {\n    position: absolute;\n    top: 0;\n    right: 0;\n    transform: translate(50%,-50%);\n    transform-origin: 100% 0;\n    margin: 0\n  }\n\n  .p-badge-dot {\n    width: .5rem;\n    min-width: .5rem;\n    height: .5rem;\n    border-radius: 50%;\n    padding: 0\n  }\n\n  .p-badge-no-gutter {\n    padding: 0;\n    border-radius: 50%\n  }\n}\n\n@layer primeng {\n  .p-button {\n    margin: 0;\n    display: inline-flex;\n    cursor: pointer;\n    -webkit-user-select: none;\n    user-select: none;\n    align-items: center;\n    vertical-align: bottom;\n    text-align: center;\n    overflow: hidden;\n    position: relative\n  }\n\n  .p-button-label {\n    flex: 1 1 auto\n  }\n\n  .p-button-icon-right {\n    order: 1\n  }\n\n  .p-button:disabled {\n    cursor: default;\n    pointer-events: none\n  }\n\n  .p-button-icon-only {\n    justify-content: center\n  }\n\n  .p-button-icon-only:after {\n    content: \"p\";\n    visibility: hidden;\n    clip: rect(0 0 0 0);\n    width: 0\n  }\n\n  .p-button-vertical {\n    flex-direction: column\n  }\n\n  .p-button-icon-bottom {\n    order: 2\n  }\n\n  .p-buttonset .p-button {\n    margin: 0\n  }\n\n  .p-buttonset .p-button:not(:last-child) {\n    border-right: 0 none\n  }\n\n  .p-buttonset .p-button:not(:first-of-type):not(:last-of-type) {\n    border-radius: 0\n  }\n\n  .p-buttonset .p-button:first-of-type {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0\n  }\n\n  .p-buttonset .p-button:last-of-type {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0\n  }\n\n  .p-buttonset .p-button:focus {\n    position: relative;\n    z-index: 1\n  }\n\n  p-button[iconpos=right] spinnericon {\n    order: 1\n  }\n}\n\n@layer primeng {\n  .p-checkbox {\n    display: inline-flex;\n    cursor: pointer;\n    -webkit-user-select: none;\n    user-select: none;\n    vertical-align: bottom;\n    position: relative\n  }\n\n  .p-checkbox-disabled {\n    cursor: default!important;\n    pointer-events: none\n  }\n\n  .p-checkbox-box {\n    display: flex;\n    justify-content: center;\n    align-items: center\n  }\n\n  p-checkbox {\n    display: inline-flex;\n    vertical-align: bottom;\n    align-items: center\n  }\n\n  .p-checkbox-label {\n    line-height: 1\n  }\n}\n\n  .p-colorpicker-panel .p-colorpicker-color {\n    background: transparent no-repeat left top\n  }\n\n  .p-colorpicker-panel .p-colorpicker-hue {\n    background: transparent no-repeat left top\n  }\n\n@layer primeng {\n  .p-inputtext {\n    margin: 0\n  }\n\n  .p-fluid .p-inputtext {\n    width: 100%\n  }\n\n  .p-inputgroup {\n    display: flex;\n    align-items: stretch;\n    width: 100%\n  }\n\n  .p-inputgroup-addon {\n    display: flex;\n    align-items: center;\n    justify-content: center\n  }\n\n  .p-inputgroup .p-float-label {\n    display: flex;\n    align-items: stretch;\n    width: 100%\n  }\n\n  .p-inputgroup .p-inputtext,.p-fluid .p-inputgroup .p-inputtext,.p-inputgroup .p-inputwrapper,.p-inputgroup .p-inputwrapper>.p-component {\n    flex: 1 1 auto;\n    width: 1%\n  }\n\n  .p-float-label {\n    display: block;\n    position: relative\n  }\n\n  .p-float-label label {\n    position: absolute;\n    pointer-events: none;\n    top: 50%;\n    margin-top: -.5rem;\n    transition-property: all;\n    transition-timing-function: ease;\n    line-height: 1\n  }\n\n  .p-float-label textarea~label {\n    top: 1rem\n  }\n\n  .p-float-label input:focus~label,.p-float-label input.p-filled~label,.p-float-label textarea:focus~label,.p-float-label textarea.p-filled~label,.p-float-label .p-inputwrapper-focus~label,.p-float-label .p-inputwrapper-filled~label {\n    top:-.75rem;\n    font-size: 12px\n  }\n\n  .p-float-label .input:-webkit-autofill~label {\n    top: -20px;\n    font-size: 12px\n  }\n\n  .p-float-label .p-placeholder,.p-float-label input::placeholder,.p-float-label .p-inputtext::placeholder {\n    opacity:0;\n    transition-property: all;\n    transition-timing-function: ease\n  }\n\n  .p-float-label .p-focus .p-placeholder,.p-float-label input:focus::placeholder,.p-float-label .p-inputtext:focus::placeholder {\n    opacity:1;\n    transition-property: all;\n    transition-timing-function: ease\n  }\n\n  .p-input-icon-left,.p-input-icon-right {\n    position: relative;\n    display: inline-block\n  }\n\n  .p-input-icon-left>i,.p-input-icon-left>.p-icon-wrapper,.p-input-icon-right>i,.p-input-icon-right>.p-icon-wrapper {\n    position: absolute;\n    top: 50%;\n    margin-top: -.5rem\n  }\n\n  .p-fluid .p-input-icon-left,.p-fluid .p-input-icon-right {\n    display: block;\n    width: 100%\n  }\n}\n\n@layer primeng {\n  .p-inputtextarea-resizable {\n    overflow: hidden;\n    resize: none\n  }\n\n  .p-fluid .p-inputtextarea {\n    width: 100%\n  }\n}\n\n@layer primeng {\n  .p-password {\n    position: relative;\n    display: inline-flex\n  }\n\n  .p-password-panel {\n    position: absolute;\n    top: 0;\n    left: 0\n  }\n\n  .p-password .p-password-panel {\n    min-width: 100%\n  }\n\n  .p-password-meter {\n    height: 10px\n  }\n\n  .p-password-strength {\n    height: 100%;\n    width: 0;\n    transition: width 1s ease-in-out\n  }\n\n  .p-fluid .p-password {\n    display: flex\n  }\n\n  .p-password-input::-ms-reveal,.p-password-input::-ms-clear {\n    display: none\n  }\n\n  .p-password-clear-icon {\n    position: absolute;\n    top: 50%;\n    margin-top: -.5rem;\n    cursor: pointer\n  }\n\n  .p-password-clearable.p-password-mask .p-password-clear-icon {\n    margin-top: unset\n  }\n\n  .p-password-clearable {\n    position: relative\n  }\n}\n\n@layer primeng {\n  .p-radiobutton {\n    display: inline-flex;\n    cursor: pointer;\n    -webkit-user-select: none;\n    user-select: none;\n    vertical-align: bottom;\n    position: relative\n  }\n\n  .p-radiobutton-box {\n    display: flex;\n    justify-content: center;\n    align-items: center\n  }\n\n  .p-radiobutton-icon {\n    backface-visibility: hidden;\n    transform: translateZ(0) scale(.1);\n    border-radius: 50%;\n    visibility: hidden\n  }\n\n  .p-radiobutton-box.p-highlight .p-radiobutton-icon {\n    transform: translateZ(0) scale(1);\n    visibility: visible\n  }\n\n  p-radiobutton {\n    display: inline-flex;\n    vertical-align: bottom;\n    align-items: center\n  }\n\n  .p-radiobutton-label {\n    line-height: 1\n  }\n}\n\n@layer primeng {\n  .p-ripple {\n    overflow: hidden;\n    position: relative\n  }\n\n  .p-ink {\n    display: block;\n    position: absolute;\n    background: rgba(255,255,255,.5);\n    border-radius: 100%;\n    transform: scale(0)\n  }\n\n  .p-ink-active {\n    animation: ripple .4s linear\n  }\n\n  .p-ripple-disabled .p-ink {\n    display: none!important\n  }\n}\n\n  @keyframes ripple {\n    to {\n      opacity: 0;\n      transform: scale(2.5)\n    }\n  }\n\n@layer primeng {\n  .p-tooltip {\n    position: absolute;\n    display: none;\n    padding: .25em .5rem;\n    max-width: 12.5rem;\n    pointer-events: none\n  }\n\n  .p-tooltip.p-tooltip-right,.p-tooltip.p-tooltip-left {\n    padding: 0 .25rem\n  }\n\n  .p-tooltip.p-tooltip-top,.p-tooltip.p-tooltip-bottom {\n    padding: .25em 0\n  }\n\n  .p-tooltip .p-tooltip-text {\n    white-space: pre-line;\n    word-break: break-word\n  }\n\n  .p-tooltip-arrow {\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-color: transparent;\n    border-style: solid\n  }\n\n  .p-tooltip-right .p-tooltip-arrow {\n    top: 50%;\n    left: 0;\n    margin-top: -.25rem;\n    border-width: .25em .25em .25em 0\n  }\n\n  .p-tooltip-left .p-tooltip-arrow {\n    top: 50%;\n    right: 0;\n    margin-top: -.25rem;\n    border-width: .25em 0 .25em .25rem\n  }\n\n  .p-tooltip.p-tooltip-top {\n    padding: .25em 0\n  }\n\n  .p-tooltip-top .p-tooltip-arrow {\n    bottom: 0;\n    left: 50%;\n    margin-left: -.25rem;\n    border-width: .25em .25em 0\n  }\n\n  .p-tooltip-bottom .p-tooltip-arrow {\n    top: 0;\n    left: 50%;\n    margin-left: -.25rem;\n    border-width: 0 .25em .25rem\n  }\n}\n\n  @font-face {\n    font-family: primeicons;\n    font-display: block;\n    font-weight: 400;\n    font-style: normal\n  }\n\n  .pi {\n    font-family: primeicons;\n    speak: none;\n    font-style: normal;\n    font-weight: 400;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n    display: inline-block;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale\n  }\n\n  .pi:before {\n    --webkit-backface-visibility: hidden;\n    backface-visibility: hidden\n  }\n\n  .pi-fw {\n    width: 1.28571429em;\n    text-align: center\n  }\n\n  .pi-spin {\n    animation: fa-spin 2s infinite linear\n  }\n\n  @keyframes fa-spin {\n    0% {\n      transform: rotate(0)\n    }\n\n    to {\n      transform: rotate(359deg)\n    }\n  }\n\n  .pi-eraser:before {\n    content: \"\\ea04\"\n  }\n\n  .pi-stopwatch:before {\n    content: \"\\ea01\"\n  }\n\n  .pi-verified:before {\n    content: \"\\ea02\"\n  }\n\n  .pi-delete-left:before {\n    content: \"\\ea03\"\n  }\n\n  .pi-hourglass:before {\n    content: \"\\e9fe\"\n  }\n\n  .pi-truck:before {\n    content: \"\\ea00\"\n  }\n\n  .pi-wrench:before {\n    content: \"\\e9ff\"\n  }\n\n  .pi-microphone:before {\n    content: \"\\e9fa\"\n  }\n\n  .pi-megaphone:before {\n    content: \"\\e9fb\"\n  }\n\n  .pi-arrow-right-arrow-left:before {\n    content: \"\\e9fc\"\n  }\n\n  .pi-bitcoin:before {\n    content: \"\\e9fd\"\n  }\n\n  .pi-file-edit:before {\n    content: \"\\e9f6\"\n  }\n\n  .pi-language:before {\n    content: \"\\e9f7\"\n  }\n\n  .pi-file-export:before {\n    content: \"\\e9f8\"\n  }\n\n  .pi-file-import:before {\n    content: \"\\e9f9\"\n  }\n\n  .pi-file-word:before {\n    content: \"\\e9f1\"\n  }\n\n  .pi-gift:before {\n    content: \"\\e9f2\"\n  }\n\n  .pi-cart-plus:before {\n    content: \"\\e9f3\"\n  }\n\n  .pi-thumbs-down-fill:before {\n    content: \"\\e9f4\"\n  }\n\n  .pi-thumbs-up-fill:before {\n    content: \"\\e9f5\"\n  }\n\n  .pi-arrows-alt:before {\n    content: \"\\e9f0\"\n  }\n\n  .pi-calculator:before {\n    content: \"\\e9ef\"\n  }\n\n  .pi-sort-alt-slash:before {\n    content: \"\\e9ee\"\n  }\n\n  .pi-arrows-h:before {\n    content: \"\\e9ec\"\n  }\n\n  .pi-arrows-v:before {\n    content: \"\\e9ed\"\n  }\n\n  .pi-pound:before {\n    content: \"\\e9eb\"\n  }\n\n  .pi-prime:before {\n    content: \"\\e9ea\"\n  }\n\n  .pi-chart-pie:before {\n    content: \"\\e9e9\"\n  }\n\n  .pi-reddit:before {\n    content: \"\\e9e8\"\n  }\n\n  .pi-code:before {\n    content: \"\\e9e7\"\n  }\n\n  .pi-sync:before {\n    content: \"\\e9e6\"\n  }\n\n  .pi-shopping-bag:before {\n    content: \"\\e9e5\"\n  }\n\n  .pi-server:before {\n    content: \"\\e9e4\"\n  }\n\n  .pi-database:before {\n    content: \"\\e9e3\"\n  }\n\n  .pi-hashtag:before {\n    content: \"\\e9e2\"\n  }\n\n  .pi-bookmark-fill:before {\n    content: \"\\e9df\"\n  }\n\n  .pi-filter-fill:before {\n    content: \"\\e9e0\"\n  }\n\n  .pi-heart-fill:before {\n    content: \"\\e9e1\"\n  }\n\n  .pi-flag-fill:before {\n    content: \"\\e9de\"\n  }\n\n  .pi-circle:before {\n    content: \"\\e9dc\"\n  }\n\n  .pi-circle-fill:before {\n    content: \"\\e9dd\"\n  }\n\n  .pi-bolt:before {\n    content: \"\\e9db\"\n  }\n\n  .pi-history:before {\n    content: \"\\e9da\"\n  }\n\n  .pi-box:before {\n    content: \"\\e9d9\"\n  }\n\n  .pi-at:before {\n    content: \"\\e9d8\"\n  }\n\n  .pi-arrow-up-right:before {\n    content: \"\\e9d4\"\n  }\n\n  .pi-arrow-up-left:before {\n    content: \"\\e9d5\"\n  }\n\n  .pi-arrow-down-left:before {\n    content: \"\\e9d6\"\n  }\n\n  .pi-arrow-down-right:before {\n    content: \"\\e9d7\"\n  }\n\n  .pi-telegram:before {\n    content: \"\\e9d3\"\n  }\n\n  .pi-stop-circle:before {\n    content: \"\\e9d2\"\n  }\n\n  .pi-stop:before {\n    content: \"\\e9d1\"\n  }\n\n  .pi-whatsapp:before {\n    content: \"\\e9d0\"\n  }\n\n  .pi-building:before {\n    content: \"\\e9cf\"\n  }\n\n  .pi-qrcode:before {\n    content: \"\\e9ce\"\n  }\n\n  .pi-car:before {\n    content: \"\\e9cd\"\n  }\n\n  .pi-instagram:before {\n    content: \"\\e9cc\"\n  }\n\n  .pi-linkedin:before {\n    content: \"\\e9cb\"\n  }\n\n  .pi-send:before {\n    content: \"\\e9ca\"\n  }\n\n  .pi-slack:before {\n    content: \"\\e9c9\"\n  }\n\n  .pi-sun:before {\n    content: \"\\e9c8\"\n  }\n\n  .pi-moon:before {\n    content: \"\\e9c7\"\n  }\n\n  .pi-vimeo:before {\n    content: \"\\e9c6\"\n  }\n\n  .pi-youtube:before {\n    content: \"\\e9c5\"\n  }\n\n  .pi-flag:before {\n    content: \"\\e9c4\"\n  }\n\n  .pi-wallet:before {\n    content: \"\\e9c3\"\n  }\n\n  .pi-map:before {\n    content: \"\\e9c2\"\n  }\n\n  .pi-link:before {\n    content: \"\\e9c1\"\n  }\n\n  .pi-credit-card:before {\n    content: \"\\e9bf\"\n  }\n\n  .pi-discord:before {\n    content: \"\\e9c0\"\n  }\n\n  .pi-percentage:before {\n    content: \"\\e9be\"\n  }\n\n  .pi-euro:before {\n    content: \"\\e9bd\"\n  }\n\n  .pi-book:before {\n    content: \"\\e9ba\"\n  }\n\n  .pi-shield:before {\n    content: \"\\e9b9\"\n  }\n\n  .pi-paypal:before {\n    content: \"\\e9bb\"\n  }\n\n  .pi-amazon:before {\n    content: \"\\e9bc\"\n  }\n\n  .pi-phone:before {\n    content: \"\\e9b8\"\n  }\n\n  .pi-filter-slash:before {\n    content: \"\\e9b7\"\n  }\n\n  .pi-facebook:before {\n    content: \"\\e9b4\"\n  }\n\n  .pi-github:before {\n    content: \"\\e9b5\"\n  }\n\n  .pi-twitter:before {\n    content: \"\\e9b6\"\n  }\n\n  .pi-step-backward-alt:before {\n    content: \"\\e9ac\"\n  }\n\n  .pi-step-forward-alt:before {\n    content: \"\\e9ad\"\n  }\n\n  .pi-forward:before {\n    content: \"\\e9ae\"\n  }\n\n  .pi-backward:before {\n    content: \"\\e9af\"\n  }\n\n  .pi-fast-backward:before {\n    content: \"\\e9b0\"\n  }\n\n  .pi-fast-forward:before {\n    content: \"\\e9b1\"\n  }\n\n  .pi-pause:before {\n    content: \"\\e9b2\"\n  }\n\n  .pi-play:before {\n    content: \"\\e9b3\"\n  }\n\n  .pi-compass:before {\n    content: \"\\e9ab\"\n  }\n\n  .pi-id-card:before {\n    content: \"\\e9aa\"\n  }\n\n  .pi-ticket:before {\n    content: \"\\e9a9\"\n  }\n\n  .pi-file-o:before {\n    content: \"\\e9a8\"\n  }\n\n  .pi-reply:before {\n    content: \"\\e9a7\"\n  }\n\n  .pi-directions-alt:before {\n    content: \"\\e9a5\"\n  }\n\n  .pi-directions:before {\n    content: \"\\e9a6\"\n  }\n\n  .pi-thumbs-up:before {\n    content: \"\\e9a3\"\n  }\n\n  .pi-thumbs-down:before {\n    content: \"\\e9a4\"\n  }\n\n  .pi-sort-numeric-down-alt:before {\n    content: \"\\e996\"\n  }\n\n  .pi-sort-numeric-up-alt:before {\n    content: \"\\e997\"\n  }\n\n  .pi-sort-alpha-down-alt:before {\n    content: \"\\e998\"\n  }\n\n  .pi-sort-alpha-up-alt:before {\n    content: \"\\e999\"\n  }\n\n  .pi-sort-numeric-down:before {\n    content: \"\\e99a\"\n  }\n\n  .pi-sort-numeric-up:before {\n    content: \"\\e99b\"\n  }\n\n  .pi-sort-alpha-down:before {\n    content: \"\\e99c\"\n  }\n\n  .pi-sort-alpha-up:before {\n    content: \"\\e99d\"\n  }\n\n  .pi-sort-alt:before {\n    content: \"\\e99e\"\n  }\n\n  .pi-sort-amount-up:before {\n    content: \"\\e99f\"\n  }\n\n  .pi-sort-amount-down:before {\n    content: \"\\e9a0\"\n  }\n\n  .pi-sort-amount-down-alt:before {\n    content: \"\\e9a1\"\n  }\n\n  .pi-sort-amount-up-alt:before {\n    content: \"\\e9a2\"\n  }\n\n  .pi-palette:before {\n    content: \"\\e995\"\n  }\n\n  .pi-undo:before {\n    content: \"\\e994\"\n  }\n\n  .pi-desktop:before {\n    content: \"\\e993\"\n  }\n\n  .pi-sliders-v:before {\n    content: \"\\e991\"\n  }\n\n  .pi-sliders-h:before {\n    content: \"\\e992\"\n  }\n\n  .pi-search-plus:before {\n    content: \"\\e98f\"\n  }\n\n  .pi-search-minus:before {\n    content: \"\\e990\"\n  }\n\n  .pi-file-excel:before {\n    content: \"\\e98e\"\n  }\n\n  .pi-file-pdf:before {\n    content: \"\\e98d\"\n  }\n\n  .pi-check-square:before {\n    content: \"\\e98c\"\n  }\n\n  .pi-chart-line:before {\n    content: \"\\e98b\"\n  }\n\n  .pi-user-edit:before {\n    content: \"\\e98a\"\n  }\n\n  .pi-exclamation-circle:before {\n    content: \"\\e989\"\n  }\n\n  .pi-android:before {\n    content: \"\\e985\"\n  }\n\n  .pi-google:before {\n    content: \"\\e986\"\n  }\n\n  .pi-apple:before {\n    content: \"\\e987\"\n  }\n\n  .pi-microsoft:before {\n    content: \"\\e988\"\n  }\n\n  .pi-heart:before {\n    content: \"\\e984\"\n  }\n\n  .pi-mobile:before {\n    content: \"\\e982\"\n  }\n\n  .pi-tablet:before {\n    content: \"\\e983\"\n  }\n\n  .pi-key:before {\n    content: \"\\e981\"\n  }\n\n  .pi-shopping-cart:before {\n    content: \"\\e980\"\n  }\n\n  .pi-comments:before {\n    content: \"\\e97e\"\n  }\n\n  .pi-comment:before {\n    content: \"\\e97f\"\n  }\n\n  .pi-briefcase:before {\n    content: \"\\e97d\"\n  }\n\n  .pi-bell:before {\n    content: \"\\e97c\"\n  }\n\n  .pi-paperclip:before {\n    content: \"\\e97b\"\n  }\n\n  .pi-share-alt:before {\n    content: \"\\e97a\"\n  }\n\n  .pi-envelope:before {\n    content: \"\\e979\"\n  }\n\n  .pi-volume-down:before {\n    content: \"\\e976\"\n  }\n\n  .pi-volume-up:before {\n    content: \"\\e977\"\n  }\n\n  .pi-volume-off:before {\n    content: \"\\e978\"\n  }\n\n  .pi-eject:before {\n    content: \"\\e975\"\n  }\n\n  .pi-money-bill:before {\n    content: \"\\e974\"\n  }\n\n  .pi-images:before {\n    content: \"\\e973\"\n  }\n\n  .pi-image:before {\n    content: \"\\e972\"\n  }\n\n  .pi-sign-in:before {\n    content: \"\\e970\"\n  }\n\n  .pi-sign-out:before {\n    content: \"\\e971\"\n  }\n\n  .pi-wifi:before {\n    content: \"\\e96f\"\n  }\n\n  .pi-sitemap:before {\n    content: \"\\e96e\"\n  }\n\n  .pi-chart-bar:before {\n    content: \"\\e96d\"\n  }\n\n  .pi-camera:before {\n    content: \"\\e96c\"\n  }\n\n  .pi-dollar:before {\n    content: \"\\e96b\"\n  }\n\n  .pi-lock-open:before {\n    content: \"\\e96a\"\n  }\n\n  .pi-table:before {\n    content: \"\\e969\"\n  }\n\n  .pi-map-marker:before {\n    content: \"\\e968\"\n  }\n\n  .pi-list:before {\n    content: \"\\e967\"\n  }\n\n  .pi-eye-slash:before {\n    content: \"\\e965\"\n  }\n\n  .pi-eye:before {\n    content: \"\\e966\"\n  }\n\n  .pi-folder-open:before {\n    content: \"\\e964\"\n  }\n\n  .pi-folder:before {\n    content: \"\\e963\"\n  }\n\n  .pi-video:before {\n    content: \"\\e962\"\n  }\n\n  .pi-inbox:before {\n    content: \"\\e961\"\n  }\n\n  .pi-lock:before {\n    content: \"\\e95f\"\n  }\n\n  .pi-unlock:before {\n    content: \"\\e960\"\n  }\n\n  .pi-tags:before {\n    content: \"\\e95d\"\n  }\n\n  .pi-tag:before {\n    content: \"\\e95e\"\n  }\n\n  .pi-power-off:before {\n    content: \"\\e95c\"\n  }\n\n  .pi-save:before {\n    content: \"\\e95b\"\n  }\n\n  .pi-question-circle:before {\n    content: \"\\e959\"\n  }\n\n  .pi-question:before {\n    content: \"\\e95a\"\n  }\n\n  .pi-copy:before {\n    content: \"\\e957\"\n  }\n\n  .pi-file:before {\n    content: \"\\e958\"\n  }\n\n  .pi-clone:before {\n    content: \"\\e955\"\n  }\n\n  .pi-calendar-times:before {\n    content: \"\\e952\"\n  }\n\n  .pi-calendar-minus:before {\n    content: \"\\e953\"\n  }\n\n  .pi-calendar-plus:before {\n    content: \"\\e954\"\n  }\n\n  .pi-ellipsis-v:before {\n    content: \"\\e950\"\n  }\n\n  .pi-ellipsis-h:before {\n    content: \"\\e951\"\n  }\n\n  .pi-bookmark:before {\n    content: \"\\e94e\"\n  }\n\n  .pi-globe:before {\n    content: \"\\e94f\"\n  }\n\n  .pi-replay:before {\n    content: \"\\e94d\"\n  }\n\n  .pi-filter:before {\n    content: \"\\e94c\"\n  }\n\n  .pi-print:before {\n    content: \"\\e94b\"\n  }\n\n  .pi-align-right:before {\n    content: \"\\e946\"\n  }\n\n  .pi-align-left:before {\n    content: \"\\e947\"\n  }\n\n  .pi-align-center:before {\n    content: \"\\e948\"\n  }\n\n  .pi-align-justify:before {\n    content: \"\\e949\"\n  }\n\n  .pi-cog:before {\n    content: \"\\e94a\"\n  }\n\n  .pi-cloud-download:before {\n    content: \"\\e943\"\n  }\n\n  .pi-cloud-upload:before {\n    content: \"\\e944\"\n  }\n\n  .pi-cloud:before {\n    content: \"\\e945\"\n  }\n\n  .pi-pencil:before {\n    content: \"\\e942\"\n  }\n\n  .pi-users:before {\n    content: \"\\e941\"\n  }\n\n  .pi-clock:before {\n    content: \"\\e940\"\n  }\n\n  .pi-user-minus:before {\n    content: \"\\e93e\"\n  }\n\n  .pi-user-plus:before {\n    content: \"\\e93f\"\n  }\n\n  .pi-trash:before {\n    content: \"\\e93d\"\n  }\n\n  .pi-external-link:before {\n    content: \"\\e93c\"\n  }\n\n  .pi-window-maximize:before {\n    content: \"\\e93b\"\n  }\n\n  .pi-window-minimize:before {\n    content: \"\\e93a\"\n  }\n\n  .pi-refresh:before {\n    content: \"\\e938\"\n  }\n\n  .pi-user:before {\n    content: \"\\e939\"\n  }\n\n  .pi-exclamation-triangle:before {\n    content: \"\\e922\"\n  }\n\n  .pi-calendar:before {\n    content: \"\\e927\"\n  }\n\n  .pi-chevron-circle-left:before {\n    content: \"\\e928\"\n  }\n\n  .pi-chevron-circle-down:before {\n    content: \"\\e929\"\n  }\n\n  .pi-chevron-circle-right:before {\n    content: \"\\e92a\"\n  }\n\n  .pi-chevron-circle-up:before {\n    content: \"\\e92b\"\n  }\n\n  .pi-angle-double-down:before {\n    content: \"\\e92c\"\n  }\n\n  .pi-angle-double-left:before {\n    content: \"\\e92d\"\n  }\n\n  .pi-angle-double-right:before {\n    content: \"\\e92e\"\n  }\n\n  .pi-angle-double-up:before {\n    content: \"\\e92f\"\n  }\n\n  .pi-angle-down:before {\n    content: \"\\e930\"\n  }\n\n  .pi-angle-left:before {\n    content: \"\\e931\"\n  }\n\n  .pi-angle-right:before {\n    content: \"\\e932\"\n  }\n\n  .pi-angle-up:before {\n    content: \"\\e933\"\n  }\n\n  .pi-upload:before {\n    content: \"\\e934\"\n  }\n\n  .pi-download:before {\n    content: \"\\e956\"\n  }\n\n  .pi-ban:before {\n    content: \"\\e935\"\n  }\n\n  .pi-star-fill:before {\n    content: \"\\e936\"\n  }\n\n  .pi-star:before {\n    content: \"\\e937\"\n  }\n\n  .pi-chevron-left:before {\n    content: \"\\e900\"\n  }\n\n  .pi-chevron-right:before {\n    content: \"\\e901\"\n  }\n\n  .pi-chevron-down:before {\n    content: \"\\e902\"\n  }\n\n  .pi-chevron-up:before {\n    content: \"\\e903\"\n  }\n\n  .pi-caret-left:before {\n    content: \"\\e904\"\n  }\n\n  .pi-caret-right:before {\n    content: \"\\e905\"\n  }\n\n  .pi-caret-down:before {\n    content: \"\\e906\"\n  }\n\n  .pi-caret-up:before {\n    content: \"\\e907\"\n  }\n\n  .pi-search:before {\n    content: \"\\e908\"\n  }\n\n  .pi-check:before {\n    content: \"\\e909\"\n  }\n\n  .pi-check-circle:before {\n    content: \"\\e90a\"\n  }\n\n  .pi-times:before {\n    content: \"\\e90b\"\n  }\n\n  .pi-times-circle:before {\n    content: \"\\e90c\"\n  }\n\n  .pi-plus:before {\n    content: \"\\e90d\"\n  }\n\n  .pi-plus-circle:before {\n    content: \"\\e90e\"\n  }\n\n  .pi-minus:before {\n    content: \"\\e90f\"\n  }\n\n  .pi-minus-circle:before {\n    content: \"\\e910\"\n  }\n\n  .pi-circle-on:before {\n    content: \"\\e911\"\n  }\n\n  .pi-circle-off:before {\n    content: \"\\e912\"\n  }\n\n  .pi-sort-down:before {\n    content: \"\\e913\"\n  }\n\n  .pi-sort-up:before {\n    content: \"\\e914\"\n  }\n\n  .pi-sort:before {\n    content: \"\\e915\"\n  }\n\n  .pi-step-backward:before {\n    content: \"\\e916\"\n  }\n\n  .pi-step-forward:before {\n    content: \"\\e917\"\n  }\n\n  .pi-th-large:before {\n    content: \"\\e918\"\n  }\n\n  .pi-arrow-down:before {\n    content: \"\\e919\"\n  }\n\n  .pi-arrow-left:before {\n    content: \"\\e91a\"\n  }\n\n  .pi-arrow-right:before {\n    content: \"\\e91b\"\n  }\n\n  .pi-arrow-up:before {\n    content: \"\\e91c\"\n  }\n\n  .pi-bars:before {\n    content: \"\\e91d\"\n  }\n\n  .pi-arrow-circle-down:before {\n    content: \"\\e91e\"\n  }\n\n  .pi-arrow-circle-left:before {\n    content: \"\\e91f\"\n  }\n\n  .pi-arrow-circle-right:before {\n    content: \"\\e920\"\n  }\n\n  .pi-arrow-circle-up:before {\n    content: \"\\e921\"\n  }\n\n  .pi-info:before {\n    content: \"\\e923\"\n  }\n\n  .pi-info-circle:before {\n    content: \"\\e924\"\n  }\n\n  .pi-home:before {\n    content: \"\\e925\"\n  }\n\n  .pi-spinner:before {\n    content: \"\\e926\"\n  }\n\n  /*!\n * Quill Editor v1.3.7\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */\n  .ql-container {\n    box-sizing: border-box;\n    font-family: Helvetica,Arial,sans-serif;\n    font-size: 13px;\n    height: 100%;\n    margin: 0;\n    position: relative\n  }\n\n  .ql-container.ql-disabled .ql-tooltip {\n    visibility: hidden\n  }\n\n  .ql-container.ql-disabled .ql-editor ul[data-checked]>li:before {\n    pointer-events: none\n  }\n\n  .ql-clipboard {\n    left: -100000px;\n    height: 1px;\n    overflow-y: hidden;\n    position: absolute;\n    top: 50%\n  }\n\n  .ql-clipboard p {\n    margin: 0;\n    padding: 0\n  }\n\n  .ql-editor {\n    box-sizing: border-box;\n    line-height: 1.42;\n    height: 100%;\n    outline: none;\n    overflow-y: auto;\n    padding: 12px 15px;\n    tab-size: 4;\n    -moz-tab-size: 4;\n    text-align: left;\n    white-space: pre-wrap;\n    word-wrap: break-word\n  }\n\n  .ql-editor>* {\n    cursor: text\n  }\n\n  .ql-editor p,.ql-editor ol,.ql-editor ul,.ql-editor pre,.ql-editor blockquote,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6 {\n    margin: 0;\n    padding: 0;\n    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9\n  }\n\n  .ql-editor ol,.ql-editor ul {\n    padding-left: 1.5em\n  }\n\n  .ql-editor ol>li,.ql-editor ul>li {\n    list-style-type: none\n  }\n\n  .ql-editor ul>li:before {\n    content: \"\\2022\"\n  }\n\n  .ql-editor ul[data-checked=true],.ql-editor ul[data-checked=false] {\n    pointer-events: none\n  }\n\n  .ql-editor ul[data-checked=true]>li *,.ql-editor ul[data-checked=false]>li * {\n    pointer-events: all\n  }\n\n  .ql-editor ul[data-checked=true]>li:before,.ql-editor ul[data-checked=false]>li:before {\n    color: #777;\n    cursor: pointer;\n    pointer-events: all\n  }\n\n  .ql-editor ul[data-checked=true]>li:before {\n    content: \"\\2611\"\n  }\n\n  .ql-editor ul[data-checked=false]>li:before {\n    content: \"\\2610\"\n  }\n\n  .ql-editor li:before {\n    display: inline-block;\n    white-space: nowrap;\n    width: 1.2em\n  }\n\n  .ql-editor li:not(.ql-direction-rtl):before {\n    margin-left: -1.5em;\n    margin-right: .3em;\n    text-align: right\n  }\n\n  .ql-editor li.ql-direction-rtl:before {\n    margin-left: .3em;\n    margin-right: -1.5em\n  }\n\n  .ql-editor ol li:not(.ql-direction-rtl),.ql-editor ul li:not(.ql-direction-rtl) {\n    padding-left: 1.5em\n  }\n\n  .ql-editor ol li.ql-direction-rtl,.ql-editor ul li.ql-direction-rtl {\n    padding-right: 1.5em\n  }\n\n  .ql-editor ol li {\n    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n    counter-increment: list-0\n  }\n\n  .ql-editor ol li:before {\n    content: counter(list-0,decimal) \". \"\n  }\n\n  .ql-editor ol li.ql-indent-1 {\n    counter-increment: list-1\n  }\n\n  .ql-editor ol li.ql-indent-1:before {\n    content: counter(list-1,lower-alpha) \". \"\n  }\n\n  .ql-editor ol li.ql-indent-1 {\n    counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9\n  }\n\n  .ql-editor ol li.ql-indent-2 {\n    counter-increment: list-2\n  }\n\n  .ql-editor ol li.ql-indent-2:before {\n    content: counter(list-2,lower-roman) \". \"\n  }\n\n  .ql-editor ol li.ql-indent-2 {\n    counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9\n  }\n\n  .ql-editor ol li.ql-indent-3 {\n    counter-increment: list-3\n  }\n\n  .ql-editor ol li.ql-indent-3:before {\n    content: counter(list-3,decimal) \". \"\n  }\n\n  .ql-editor ol li.ql-indent-3 {\n    counter-reset: list-4 list-5 list-6 list-7 list-8 list-9\n  }\n\n  .ql-editor ol li.ql-indent-4 {\n    counter-increment: list-4\n  }\n\n  .ql-editor ol li.ql-indent-4:before {\n    content: counter(list-4,lower-alpha) \". \"\n  }\n\n  .ql-editor ol li.ql-indent-4 {\n    counter-reset: list-5 list-6 list-7 list-8 list-9\n  }\n\n  .ql-editor ol li.ql-indent-5 {\n    counter-increment: list-5\n  }\n\n  .ql-editor ol li.ql-indent-5:before {\n    content: counter(list-5,lower-roman) \". \"\n  }\n\n  .ql-editor ol li.ql-indent-5 {\n    counter-reset: list-6 list-7 list-8 list-9\n  }\n\n  .ql-editor ol li.ql-indent-6 {\n    counter-increment: list-6\n  }\n\n  .ql-editor ol li.ql-indent-6:before {\n    content: counter(list-6,decimal) \". \"\n  }\n\n  .ql-editor ol li.ql-indent-6 {\n    counter-reset: list-7 list-8 list-9\n  }\n\n  .ql-editor ol li.ql-indent-7 {\n    counter-increment: list-7\n  }\n\n  .ql-editor ol li.ql-indent-7:before {\n    content: counter(list-7,lower-alpha) \". \"\n  }\n\n  .ql-editor ol li.ql-indent-7 {\n    counter-reset: list-8 list-9\n  }\n\n  .ql-editor ol li.ql-indent-8 {\n    counter-increment: list-8\n  }\n\n  .ql-editor ol li.ql-indent-8:before {\n    content: counter(list-8,lower-roman) \". \"\n  }\n\n  .ql-editor ol li.ql-indent-8 {\n    counter-reset: list-9\n  }\n\n  .ql-editor ol li.ql-indent-9 {\n    counter-increment: list-9\n  }\n\n  .ql-editor ol li.ql-indent-9:before {\n    content: counter(list-9,decimal) \". \"\n  }\n\n  .ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n    padding-left: 3em\n  }\n\n  .ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n    padding-left: 4.5em\n  }\n\n  .ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n    padding-right: 3em\n  }\n\n  .ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n    padding-right: 4.5em\n  }\n\n  .ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n    padding-left: 6em\n  }\n\n  .ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n    padding-left: 7.5em\n  }\n\n  .ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n    padding-right: 6em\n  }\n\n  .ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n    padding-right: 7.5em\n  }\n\n  .ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n    padding-left: 9em\n  }\n\n  .ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n    padding-left: 10.5em\n  }\n\n  .ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n    padding-right: 9em\n  }\n\n  .ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n    padding-right: 10.5em\n  }\n\n  .ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n    padding-left: 12em\n  }\n\n  .ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n    padding-left: 13.5em\n  }\n\n  .ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n    padding-right: 12em\n  }\n\n  .ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n    padding-right: 13.5em\n  }\n\n  .ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n    padding-left: 15em\n  }\n\n  .ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n    padding-left: 16.5em\n  }\n\n  .ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n    padding-right: 15em\n  }\n\n  .ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n    padding-right: 16.5em\n  }\n\n  .ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n    padding-left: 18em\n  }\n\n  .ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n    padding-left: 19.5em\n  }\n\n  .ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n    padding-right: 18em\n  }\n\n  .ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n    padding-right: 19.5em\n  }\n\n  .ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n    padding-left: 21em\n  }\n\n  .ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n    padding-left: 22.5em\n  }\n\n  .ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n    padding-right: 21em\n  }\n\n  .ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n    padding-right: 22.5em\n  }\n\n  .ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n    padding-left: 24em\n  }\n\n  .ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n    padding-left: 25.5em\n  }\n\n  .ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n    padding-right: 24em\n  }\n\n  .ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n    padding-right: 25.5em\n  }\n\n  .ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n    padding-left: 27em\n  }\n\n  .ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n    padding-left: 28.5em\n  }\n\n  .ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n    padding-right: 27em\n  }\n\n  .ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n    padding-right: 28.5em\n  }\n\n  .ql-editor .ql-video {\n    display: block;\n    max-width: 100%\n  }\n\n  .ql-editor .ql-video.ql-align-center {\n    margin: 0 auto\n  }\n\n  .ql-editor .ql-video.ql-align-right {\n    margin: 0 0 0 auto\n  }\n\n  .ql-editor .ql-bg-black {\n    background-color: #000\n  }\n\n  .ql-editor .ql-bg-red {\n    background-color: #e60000\n  }\n\n  .ql-editor .ql-bg-orange {\n    background-color: #f90\n  }\n\n  .ql-editor .ql-bg-yellow {\n    background-color: #ff0\n  }\n\n  .ql-editor .ql-bg-green {\n    background-color: #008a00\n  }\n\n  .ql-editor .ql-bg-blue {\n    background-color: #06c\n  }\n\n  .ql-editor .ql-bg-purple {\n    background-color: #93f\n  }\n\n  .ql-editor .ql-color-white {\n    color: #fff\n  }\n\n  .ql-editor .ql-color-red {\n    color: #e60000\n  }\n\n  .ql-editor .ql-color-orange {\n    color: #f90\n  }\n\n  .ql-editor .ql-color-yellow {\n    color: #ff0\n  }\n\n  .ql-editor .ql-color-green {\n    color: #008a00\n  }\n\n  .ql-editor .ql-color-blue {\n    color: #06c\n  }\n\n  .ql-editor .ql-color-purple {\n    color: #93f\n  }\n\n  .ql-editor .ql-font-serif {\n    font-family: Georgia,Times New Roman,serif\n  }\n\n  .ql-editor .ql-font-monospace {\n    font-family: Monaco,Courier New,monospace\n  }\n\n  .ql-editor .ql-size-small {\n    font-size: .75em\n  }\n\n  .ql-editor .ql-size-large {\n    font-size: 1.5em\n  }\n\n  .ql-editor .ql-size-huge {\n    font-size: 2.5em\n  }\n\n  .ql-editor .ql-direction-rtl {\n    direction: rtl;\n    text-align: inherit\n  }\n\n  .ql-editor .ql-align-center {\n    text-align: center\n  }\n\n  .ql-editor .ql-align-justify {\n    text-align: justify\n  }\n\n  .ql-editor .ql-align-right {\n    text-align: right\n  }\n\n  .ql-editor.ql-blank:before {\n    color: #0009;\n    content: attr(data-placeholder);\n    font-style: italic;\n    left: 15px;\n    pointer-events: none;\n    position: absolute;\n    right: 15px\n  }\n\n  .ql-snow.ql-toolbar:after,.ql-snow .ql-toolbar:after {\n    clear: both;\n    content: \"\";\n    display: table\n  }\n\n  .ql-snow.ql-toolbar button,.ql-snow .ql-toolbar button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    display: inline-block;\n    float: left;\n    height: 24px;\n    padding: 3px 5px;\n    width: 28px\n  }\n\n  .ql-snow.ql-toolbar button svg,.ql-snow .ql-toolbar button svg {\n    float: left;\n    height: 100%\n  }\n\n  .ql-snow.ql-toolbar button:active:hover,.ql-snow .ql-toolbar button:active:hover {\n    outline: none\n  }\n\n  .ql-snow.ql-toolbar input.ql-image[type=file],.ql-snow .ql-toolbar input.ql-image[type=file] {\n    display: none\n  }\n\n  .ql-snow.ql-toolbar button:hover,.ql-snow .ql-toolbar button:hover,.ql-snow.ql-toolbar button:focus,.ql-snow .ql-toolbar button:focus,.ql-snow.ql-toolbar button.ql-active,.ql-snow .ql-toolbar button.ql-active,.ql-snow.ql-toolbar .ql-picker-label:hover,.ql-snow .ql-toolbar .ql-picker-label:hover,.ql-snow.ql-toolbar .ql-picker-label.ql-active,.ql-snow .ql-toolbar .ql-picker-label.ql-active,.ql-snow.ql-toolbar .ql-picker-item:hover,.ql-snow .ql-toolbar .ql-picker-item:hover,.ql-snow.ql-toolbar .ql-picker-item.ql-selected,.ql-snow .ql-toolbar .ql-picker-item.ql-selected {\n    color: #06c\n  }\n\n  .ql-snow.ql-toolbar button:hover .ql-fill,.ql-snow .ql-toolbar button:hover .ql-fill,.ql-snow.ql-toolbar button:focus .ql-fill,.ql-snow .ql-toolbar button:focus .ql-fill,.ql-snow.ql-toolbar button.ql-active .ql-fill,.ql-snow .ql-toolbar button.ql-active .ql-fill,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {\n    fill: #06c\n  }\n\n  .ql-snow.ql-toolbar button:hover .ql-stroke,.ql-snow .ql-toolbar button:hover .ql-stroke,.ql-snow.ql-toolbar button:focus .ql-stroke,.ql-snow .ql-toolbar button:focus .ql-stroke,.ql-snow.ql-toolbar button.ql-active .ql-stroke,.ql-snow .ql-toolbar button.ql-active .ql-stroke,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-snow.ql-toolbar button:hover .ql-stroke-miter,.ql-snow .ql-toolbar button:hover .ql-stroke-miter,.ql-snow.ql-toolbar button:focus .ql-stroke-miter,.ql-snow .ql-toolbar button:focus .ql-stroke-miter,.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {\n    stroke: #06c\n  }\n\n  @media (pointer: coarse) {\n    .ql-snow.ql-toolbar button:hover:not(.ql-active),.ql-snow .ql-toolbar button:hover:not(.ql-active) {\n      color:#444\n    }\n\n    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {\n      fill: #444\n    }\n\n    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {\n      stroke: #444\n    }\n  }\n\n  .ql-snow,.ql-snow * {\n    box-sizing: border-box\n  }\n\n  .ql-snow .ql-hidden {\n    display: none\n  }\n\n  .ql-snow .ql-out-bottom,.ql-snow .ql-out-top {\n    visibility: hidden\n  }\n\n  .ql-snow .ql-tooltip {\n    position: absolute;\n    transform: translateY(10px)\n  }\n\n  .ql-snow .ql-tooltip a {\n    cursor: pointer;\n    text-decoration: none\n  }\n\n  .ql-snow .ql-tooltip.ql-flip {\n    transform: translateY(-10px)\n  }\n\n  .ql-snow .ql-formats {\n    display: inline-block;\n    vertical-align: middle\n  }\n\n  .ql-snow .ql-formats:after {\n    clear: both;\n    content: \"\";\n    display: table\n  }\n\n  .ql-snow .ql-stroke {\n    fill: none;\n    stroke: #444;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-width: 2\n  }\n\n  .ql-snow .ql-stroke-miter {\n    fill: none;\n    stroke: #444;\n    stroke-miterlimit: 10;\n    stroke-width: 2\n  }\n\n  .ql-snow .ql-fill,.ql-snow .ql-stroke.ql-fill {\n    fill: #444\n  }\n\n  .ql-snow .ql-empty {\n    fill: none\n  }\n\n  .ql-snow .ql-even {\n    fill-rule: evenodd\n  }\n\n  .ql-snow .ql-thin,.ql-snow .ql-stroke.ql-thin {\n    stroke-width: 1\n  }\n\n  .ql-snow .ql-transparent {\n    opacity: .4\n  }\n\n  .ql-snow .ql-direction svg:last-child {\n    display: none\n  }\n\n  .ql-snow .ql-direction.ql-active svg:last-child {\n    display: inline\n  }\n\n  .ql-snow .ql-direction.ql-active svg:first-child {\n    display: none\n  }\n\n  .ql-snow .ql-editor h1 {\n    font-size: 2em\n  }\n\n  .ql-snow .ql-editor h2 {\n    font-size: 1.5em\n  }\n\n  .ql-snow .ql-editor h3 {\n    font-size: 1.17em\n  }\n\n  .ql-snow .ql-editor h4 {\n    font-size: 1em\n  }\n\n  .ql-snow .ql-editor h5 {\n    font-size: .83em\n  }\n\n  .ql-snow .ql-editor h6 {\n    font-size: .67em\n  }\n\n  .ql-snow .ql-editor a {\n    text-decoration: underline\n  }\n\n  .ql-snow .ql-editor blockquote {\n    border-left: 4px solid #ccc;\n    margin-bottom: 5px;\n    margin-top: 5px;\n    padding-left: 16px\n  }\n\n  .ql-snow .ql-editor code,.ql-snow .ql-editor pre {\n    background-color: #f0f0f0;\n    border-radius: 3px\n  }\n\n  .ql-snow .ql-editor pre {\n    white-space: pre-wrap;\n    margin-bottom: 5px;\n    margin-top: 5px;\n    padding: 5px 10px\n  }\n\n  .ql-snow .ql-editor code {\n    font-size: 85%;\n    padding: 2px 4px\n  }\n\n  .ql-snow .ql-editor pre.ql-syntax {\n    background-color: #23241f;\n    color: #f8f8f2;\n    overflow: visible\n  }\n\n  .ql-snow .ql-editor img {\n    max-width: 100%\n  }\n\n  .ql-snow .ql-picker {\n    color: #444;\n    display: inline-block;\n    float: left;\n    font-size: 14px;\n    font-weight: 500;\n    height: 24px;\n    position: relative;\n    vertical-align: middle\n  }\n\n  .ql-snow .ql-picker-label {\n    cursor: pointer;\n    display: inline-block;\n    height: 100%;\n    padding-left: 8px;\n    padding-right: 2px;\n    position: relative;\n    width: 100%\n  }\n\n  .ql-snow .ql-picker-label:before {\n    display: inline-block;\n    line-height: 22px\n  }\n\n  .ql-snow .ql-picker-options {\n    background-color: #fff;\n    display: none;\n    min-width: 100%;\n    padding: 4px 8px;\n    position: absolute;\n    white-space: nowrap\n  }\n\n  .ql-snow .ql-picker-options .ql-picker-item {\n    cursor: pointer;\n    display: block;\n    padding-bottom: 5px;\n    padding-top: 5px\n  }\n\n  .ql-snow .ql-picker.ql-expanded .ql-picker-label {\n    color: #ccc;\n    z-index: 2\n  }\n\n  .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {\n    fill: #ccc\n  }\n\n  .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {\n    stroke: #ccc\n  }\n\n  .ql-snow .ql-picker.ql-expanded .ql-picker-options {\n    display: block;\n    margin-top: -1px;\n    top: 100%;\n    z-index: 1\n  }\n\n  .ql-snow .ql-color-picker,.ql-snow .ql-icon-picker {\n    width: 28px\n  }\n\n  .ql-snow .ql-color-picker .ql-picker-label,.ql-snow .ql-icon-picker .ql-picker-label {\n    padding: 2px 4px\n  }\n\n  .ql-snow .ql-color-picker .ql-picker-label svg,.ql-snow .ql-icon-picker .ql-picker-label svg {\n    right: 4px\n  }\n\n  .ql-snow .ql-icon-picker .ql-picker-options {\n    padding: 4px 0\n  }\n\n  .ql-snow .ql-icon-picker .ql-picker-item {\n    height: 24px;\n    width: 24px;\n    padding: 2px 4px\n  }\n\n  .ql-snow .ql-color-picker .ql-picker-options {\n    padding: 3px 5px;\n    width: 152px\n  }\n\n  .ql-snow .ql-color-picker .ql-picker-item {\n    border: 1px solid transparent;\n    float: left;\n    height: 16px;\n    margin: 2px;\n    padding: 0;\n    width: 16px\n  }\n\n  .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {\n    position: absolute;\n    margin-top: -9px;\n    right: 0;\n    top: 50%;\n    width: 18px\n  }\n\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=\"\"]):before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=\"\"]):before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=\"\"]):before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=\"\"]):before,.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=\"\"]):before,.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=\"\"]):before {\n    content: attr(data-label)\n  }\n\n  .ql-snow .ql-picker.ql-header {\n    width: 98px\n  }\n\n  .ql-snow .ql-picker.ql-header .ql-picker-label:before,.ql-snow .ql-picker.ql-header .ql-picker-item:before {\n    content: \"Normal\"\n  }\n\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"1\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]:before {\n    content: \"Heading 1\"\n  }\n\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"2\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]:before {\n    content: \"Heading 2\"\n  }\n\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"3\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]:before {\n    content: \"Heading 3\"\n  }\n\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]:before {\n    content: \"Heading 4\"\n  }\n\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"5\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]:before {\n    content: \"Heading 5\"\n  }\n\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"6\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]:before {\n    content: \"Heading 6\"\n  }\n\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]:before {\n    font-size: 2em\n  }\n\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]:before {\n    font-size: 1.5em\n  }\n\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]:before {\n    font-size: 1.17em\n  }\n\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]:before {\n    font-size: 1em\n  }\n\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]:before {\n    font-size: .83em\n  }\n\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]:before {\n    font-size: .67em\n  }\n\n  .ql-snow .ql-picker.ql-font {\n    width: 108px\n  }\n\n  .ql-snow .ql-picker.ql-font .ql-picker-label:before,.ql-snow .ql-picker.ql-font .ql-picker-item:before {\n    content: \"Sans Serif\"\n  }\n\n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]:before,.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]:before {\n    content: \"Serif\"\n  }\n\n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]:before,.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before {\n    content: \"Monospace\"\n  }\n\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]:before {\n    font-family: Georgia,Times New Roman,serif\n  }\n\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before {\n    font-family: Monaco,Courier New,monospace\n  }\n\n  .ql-snow .ql-picker.ql-size {\n    width: 98px\n  }\n\n  .ql-snow .ql-picker.ql-size .ql-picker-label:before,.ql-snow .ql-picker.ql-size .ql-picker-item:before {\n    content: \"Normal\"\n  }\n\n  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]:before,.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]:before {\n    content: \"Small\"\n  }\n\n  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]:before,.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]:before {\n    content: \"Large\"\n  }\n\n  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]:before,.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]:before {\n    content: \"Huge\"\n  }\n\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]:before {\n    font-size: 10px\n  }\n\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]:before {\n    font-size: 18px\n  }\n\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]:before {\n    font-size: 32px\n  }\n\n  .ql-snow .ql-color-picker.ql-background .ql-picker-item {\n    background-color: #fff\n  }\n\n  .ql-snow .ql-color-picker.ql-color .ql-picker-item {\n    background-color: #000\n  }\n\n  .ql-toolbar.ql-snow {\n    border: 1px solid #ccc;\n    box-sizing: border-box;\n    font-family: Helvetica Neue,Helvetica,Arial,sans-serif;\n    padding: 8px\n  }\n\n  .ql-toolbar.ql-snow .ql-formats {\n    margin-right: 15px\n  }\n\n  .ql-toolbar.ql-snow .ql-picker-label {\n    border: 1px solid transparent\n  }\n\n  .ql-toolbar.ql-snow .ql-picker-options {\n    border: 1px solid transparent;\n    box-shadow: #0003 0 2px 8px\n  }\n\n  .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label,.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n    border-color: #ccc\n  }\n\n  .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {\n    border-color: #000\n  }\n\n  .ql-toolbar.ql-snow+.ql-container.ql-snow {\n    border-top: 0px\n  }\n\n  .ql-snow .ql-tooltip {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    box-shadow: 0 0 5px #ddd;\n    color: #444;\n    padding: 5px 12px;\n    white-space: nowrap\n  }\n\n  .ql-snow .ql-tooltip:before {\n    content: \"Visit URL:\";\n    line-height: 26px;\n    margin-right: 8px\n  }\n\n  .ql-snow .ql-tooltip input[type=text] {\n    display: none;\n    border: 1px solid #ccc;\n    font-size: 13px;\n    height: 26px;\n    margin: 0;\n    padding: 3px 5px;\n    width: 170px\n  }\n\n  .ql-snow .ql-tooltip a.ql-preview {\n    display: inline-block;\n    max-width: 200px;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    vertical-align: top\n  }\n\n  .ql-snow .ql-tooltip a.ql-action:after {\n    border-right: 1px solid #ccc;\n    content: \"Edit\";\n    margin-left: 16px;\n    padding-right: 8px\n  }\n\n  .ql-snow .ql-tooltip a.ql-remove:before {\n    content: \"Remove\";\n    margin-left: 8px\n  }\n\n  .ql-snow .ql-tooltip a {\n    line-height: 26px\n  }\n\n  .ql-snow .ql-tooltip.ql-editing a.ql-preview,.ql-snow .ql-tooltip.ql-editing a.ql-remove {\n    display: none\n  }\n\n  .ql-snow .ql-tooltip.ql-editing input[type=text] {\n    display: inline-block\n  }\n\n  .ql-snow .ql-tooltip.ql-editing a.ql-action:after {\n    border-right: 0px;\n    content: \"Save\";\n    padding-right: 0\n  }\n\n  .ql-snow .ql-tooltip[data-mode=link]:before {\n    content: \"Enter link:\"\n  }\n\n  .ql-snow .ql-tooltip[data-mode=formula]:before {\n    content: \"Enter formula:\"\n  }\n\n  .ql-snow .ql-tooltip[data-mode=video]:before {\n    content: \"Enter video:\"\n  }\n\n  .ql-snow a {\n    color: #06c\n  }\n\n  .ql-container.ql-snow {\n    border: 1px solid #ccc\n  }\n\n  span.flag {\n    width: 44px;\n    height: 30px;\n    display: inline-block\n  }\n\n  img.flag {\n    width: 30px\n  }\n\n  .flag {\n    background-size: 100%;\n    vertical-align: middle\n  }\n\n  .flag-ad {\n    background-position: 0 .413223%\n  }\n\n  .flag-ae {\n    background-position: 0 .826446%\n  }\n\n  .flag-af {\n    background-position: 0 1.239669%\n  }\n\n  .flag-ag {\n    background-position: 0 1.652893%\n  }\n\n  .flag-ai {\n    background-position: 0 2.066116%\n  }\n\n  .flag-al {\n    background-position: 0 2.479339%\n  }\n\n  .flag-am {\n    background-position: 0 2.892562%\n  }\n\n  .flag-an {\n    background-position: 0 3.305785%\n  }\n\n  .flag-ao {\n    background-position: 0 3.719008%\n  }\n\n  .flag-aq {\n    background-position: 0 4.132231%\n  }\n\n  .flag-ar {\n    background-position: 0 4.545455%\n  }\n\n  .flag-as {\n    background-position: 0 4.958678%\n  }\n\n  .flag-at {\n    background-position: 0 5.371901%\n  }\n\n  .flag-au {\n    background-position: 0 5.785124%\n  }\n\n  .flag-aw {\n    background-position: 0 6.198347%\n  }\n\n  .flag-az {\n    background-position: 0 6.61157%\n  }\n\n  .flag-ba {\n    background-position: 0 7.024793%\n  }\n\n  .flag-bb {\n    background-position: 0 7.438017%\n  }\n\n  .flag-bd {\n    background-position: 0 7.85124%\n  }\n\n  .flag-be {\n    background-position: 0 8.264463%\n  }\n\n  .flag-bf {\n    background-position: 0 8.677686%\n  }\n\n  .flag-bg {\n    background-position: 0 9.090909%\n  }\n\n  .flag-bh {\n    background-position: 0 9.504132%\n  }\n\n  .flag-bi {\n    background-position: 0 9.917355%\n  }\n\n  .flag-bj {\n    background-position: 0 10.330579%\n  }\n\n  .flag-bm {\n    background-position: 0 10.743802%\n  }\n\n  .flag-bn {\n    background-position: 0 11.157025%\n  }\n\n  .flag-bo {\n    background-position: 0 11.570248%\n  }\n\n  .flag-br {\n    background-position: 0 11.983471%\n  }\n\n  .flag-bs {\n    background-position: 0 12.396694%\n  }\n\n  .flag-bt {\n    background-position: 0 12.809917%\n  }\n\n  .flag-bv {\n    background-position: 0 13.22314%\n  }\n\n  .flag-bw {\n    background-position: 0 13.636364%\n  }\n\n  .flag-by {\n    background-position: 0 14.049587%\n  }\n\n  .flag-bz {\n    background-position: 0 14.46281%\n  }\n\n  .flag-ca {\n    background-position: 0 14.876033%\n  }\n\n  .flag-cc {\n    background-position: 0 15.289256%\n  }\n\n  .flag-cd {\n    background-position: 0 15.702479%\n  }\n\n  .flag-cf {\n    background-position: 0 16.115702%\n  }\n\n  .flag-cg {\n    background-position: 0 16.528926%\n  }\n\n  .flag-ch {\n    background-position: 0 16.942149%\n  }\n\n  .flag-ci {\n    background-position: 0 17.355372%\n  }\n\n  .flag-ck {\n    background-position: 0 17.768595%\n  }\n\n  .flag-cl {\n    background-position: 0 18.181818%\n  }\n\n  .flag-cm {\n    background-position: 0 18.595041%\n  }\n\n  .flag-cn {\n    background-position: 0 19.008264%\n  }\n\n  .flag-co {\n    background-position: 0 19.421488%\n  }\n\n  .flag-cr {\n    background-position: 0 19.834711%\n  }\n\n  .flag-cu {\n    background-position: 0 20.247934%\n  }\n\n  .flag-cv {\n    background-position: 0 20.661157%\n  }\n\n  .flag-cx {\n    background-position: 0 21.07438%\n  }\n\n  .flag-cy {\n    background-position: 0 21.487603%\n  }\n\n  .flag-cz {\n    background-position: 0 21.900826%\n  }\n\n  .flag-de {\n    background-position: 0 22.31405%\n  }\n\n  .flag-dj {\n    background-position: 0 22.727273%\n  }\n\n  .flag-dk {\n    background-position: 0 23.140496%\n  }\n\n  .flag-dm {\n    background-position: 0 23.553719%\n  }\n\n  .flag-do {\n    background-position: 0 23.966942%\n  }\n\n  .flag-dz {\n    background-position: 0 24.380165%\n  }\n\n  .flag-ec {\n    background-position: 0 24.793388%\n  }\n\n  .flag-ee {\n    background-position: 0 25.206612%\n  }\n\n  .flag-eg {\n    background-position: 0 25.619835%\n  }\n\n  .flag-eh {\n    background-position: 0 26.033058%\n  }\n\n  .flag-er {\n    background-position: 0 26.446281%\n  }\n\n  .flag-es {\n    background-position: 0 26.859504%\n  }\n\n  .flag-et {\n    background-position: 0 27.272727%\n  }\n\n  .flag-fi {\n    background-position: 0 27.68595%\n  }\n\n  .flag-fj {\n    background-position: 0 28.099174%\n  }\n\n  .flag-fk {\n    background-position: 0 28.512397%\n  }\n\n  .flag-fm {\n    background-position: 0 28.92562%\n  }\n\n  .flag-fo {\n    background-position: 0 29.338843%\n  }\n\n  .flag-fr {\n    background-position: 0 29.752066%\n  }\n\n  .flag-ga {\n    background-position: 0 30.165289%\n  }\n\n  .flag-gd {\n    background-position: 0 30.578512%\n  }\n\n  .flag-ge {\n    background-position: 0 30.991736%\n  }\n\n  .flag-gf {\n    background-position: 0 31.404959%\n  }\n\n  .flag-gh {\n    background-position: 0 31.818182%\n  }\n\n  .flag-gi {\n    background-position: 0 32.231405%\n  }\n\n  .flag-gl {\n    background-position: 0 32.644628%\n  }\n\n  .flag-gm {\n    background-position: 0 33.057851%\n  }\n\n  .flag-gn {\n    background-position: 0 33.471074%\n  }\n\n  .flag-gp {\n    background-position: 0 33.884298%\n  }\n\n  .flag-gq {\n    background-position: 0 34.297521%\n  }\n\n  .flag-gr {\n    background-position: 0 34.710744%\n  }\n\n  .flag-gs {\n    background-position: 0 35.123967%\n  }\n\n  .flag-gt {\n    background-position: 0 35.53719%\n  }\n\n  .flag-gu {\n    background-position: 0 35.950413%\n  }\n\n  .flag-gw {\n    background-position: 0 36.363636%\n  }\n\n  .flag-gy {\n    background-position: 0 36.77686%\n  }\n\n  .flag-hk {\n    background-position: 0 37.190083%\n  }\n\n  .flag-hm {\n    background-position: 0 37.603306%\n  }\n\n  .flag-hn {\n    background-position: 0 38.016529%\n  }\n\n  .flag-hr {\n    background-position: 0 38.429752%\n  }\n\n  .flag-ht {\n    background-position: 0 38.842975%\n  }\n\n  .flag-hu {\n    background-position: 0 39.256198%\n  }\n\n  .flag-id {\n    background-position: 0 39.669421%\n  }\n\n  .flag-ie {\n    background-position: 0 40.082645%\n  }\n\n  .flag-il {\n    background-position: 0 40.495868%\n  }\n\n  .flag-in {\n    background-position: 0 40.909091%\n  }\n\n  .flag-io {\n    background-position: 0 41.322314%\n  }\n\n  .flag-iq {\n    background-position: 0 41.735537%\n  }\n\n  .flag-ir {\n    background-position: 0 42.14876%\n  }\n\n  .flag-is {\n    background-position: 0 42.561983%\n  }\n\n  .flag-it {\n    background-position: 0 42.975207%\n  }\n\n  .flag-jm {\n    background-position: 0 43.38843%\n  }\n\n  .flag-jo {\n    background-position: 0 43.801653%\n  }\n\n  .flag-jp {\n    background-position: 0 44.214876%\n  }\n\n  .flag-ke {\n    background-position: 0 44.628099%\n  }\n\n  .flag-kg {\n    background-position: 0 45.041322%\n  }\n\n  .flag-kh {\n    background-position: 0 45.454545%\n  }\n\n  .flag-ki {\n    background-position: 0 45.867769%\n  }\n\n  .flag-km {\n    background-position: 0 46.280992%\n  }\n\n  .flag-kn {\n    background-position: 0 46.694215%\n  }\n\n  .flag-kp {\n    background-position: 0 47.107438%\n  }\n\n  .flag-kr {\n    background-position: 0 47.520661%\n  }\n\n  .flag-kw {\n    background-position: 0 47.933884%\n  }\n\n  .flag-ky {\n    background-position: 0 48.347107%\n  }\n\n  .flag-kz {\n    background-position: 0 48.760331%\n  }\n\n  .flag-la {\n    background-position: 0 49.173554%\n  }\n\n  .flag-lb {\n    background-position: 0 49.586777%\n  }\n\n  .flag-lc {\n    background-position: 0 50%\n  }\n\n  .flag-li {\n    background-position: 0 50.413223%\n  }\n\n  .flag-lk {\n    background-position: 0 50.826446%\n  }\n\n  .flag-lr {\n    background-position: 0 51.239669%\n  }\n\n  .flag-ls {\n    background-position: 0 51.652893%\n  }\n\n  .flag-lt {\n    background-position: 0 52.066116%\n  }\n\n  .flag-lu {\n    background-position: 0 52.479339%\n  }\n\n  .flag-lv {\n    background-position: 0 52.892562%\n  }\n\n  .flag-ly {\n    background-position: 0 53.305785%\n  }\n\n  .flag-ma {\n    background-position: 0 53.719008%\n  }\n\n  .flag-mc {\n    background-position: 0 54.132231%\n  }\n\n  .flag-md {\n    background-position: 0 54.545455%\n  }\n\n  .flag-me {\n    background-position: 0 54.958678%\n  }\n\n  .flag-mg {\n    background-position: 0 55.371901%\n  }\n\n  .flag-mh {\n    background-position: 0 55.785124%\n  }\n\n  .flag-mk {\n    background-position: 0 56.198347%\n  }\n\n  .flag-ml {\n    background-position: 0 56.61157%\n  }\n\n  .flag-mm {\n    background-position: 0 57.024793%\n  }\n\n  .flag-mn {\n    background-position: 0 57.438017%\n  }\n\n  .flag-mo {\n    background-position: 0 57.85124%\n  }\n\n  .flag-mp {\n    background-position: 0 58.264463%\n  }\n\n  .flag-mq {\n    background-position: 0 58.677686%\n  }\n\n  .flag-mr {\n    background-position: 0 59.090909%\n  }\n\n  .flag-ms {\n    background-position: 0 59.504132%\n  }\n\n  .flag-mt {\n    background-position: 0 59.917355%\n  }\n\n  .flag-mu {\n    background-position: 0 60.330579%\n  }\n\n  .flag-mv {\n    background-position: 0 60.743802%\n  }\n\n  .flag-mw {\n    background-position: 0 61.157025%\n  }\n\n  .flag-mx {\n    background-position: 0 61.570248%\n  }\n\n  .flag-my {\n    background-position: 0 61.983471%\n  }\n\n  .flag-mz {\n    background-position: 0 62.396694%\n  }\n\n  .flag-na {\n    background-position: 0 62.809917%\n  }\n\n  .flag-nc {\n    background-position: 0 63.22314%\n  }\n\n  .flag-ne {\n    background-position: 0 63.636364%\n  }\n\n  .flag-nf {\n    background-position: 0 64.049587%\n  }\n\n  .flag-ng {\n    background-position: 0 64.46281%\n  }\n\n  .flag-ni {\n    background-position: 0 64.876033%\n  }\n\n  .flag-nl {\n    background-position: 0 65.289256%\n  }\n\n  .flag-no {\n    background-position: 0 65.702479%\n  }\n\n  .flag-np {\n    background-position: 0 66.115702%\n  }\n\n  .flag-nr {\n    background-position: 0 66.528926%\n  }\n\n  .flag-nu {\n    background-position: 0 66.942149%\n  }\n\n  .flag-nz {\n    background-position: 0 67.355372%\n  }\n\n  .flag-om {\n    background-position: 0 67.768595%\n  }\n\n  .flag-pa {\n    background-position: 0 68.181818%\n  }\n\n  .flag-pe {\n    background-position: 0 68.595041%\n  }\n\n  .flag-pf {\n    background-position: 0 69.008264%\n  }\n\n  .flag-pg {\n    background-position: 0 69.421488%\n  }\n\n  .flag-ph {\n    background-position: 0 69.834711%\n  }\n\n  .flag-pk {\n    background-position: 0 70.247934%\n  }\n\n  .flag-pl {\n    background-position: 0 70.661157%\n  }\n\n  .flag-pm {\n    background-position: 0 71.07438%\n  }\n\n  .flag-pn {\n    background-position: 0 71.487603%\n  }\n\n  .flag-pr {\n    background-position: 0 71.900826%\n  }\n\n  .flag-pt {\n    background-position: 0 72.31405%\n  }\n\n  .flag-pw {\n    background-position: 0 72.727273%\n  }\n\n  .flag-py {\n    background-position: 0 73.140496%\n  }\n\n  .flag-qa {\n    background-position: 0 73.553719%\n  }\n\n  .flag-re {\n    background-position: 0 73.966942%\n  }\n\n  .flag-ro {\n    background-position: 0 74.380165%\n  }\n\n  .flag-rs {\n    background-position: 0 74.793388%\n  }\n\n  .flag-ru {\n    background-position: 0 75.206612%\n  }\n\n  .flag-rw {\n    background-position: 0 75.619835%\n  }\n\n  .flag-sa {\n    background-position: 0 76.033058%\n  }\n\n  .flag-sb {\n    background-position: 0 76.446281%\n  }\n\n  .flag-sc {\n    background-position: 0 76.859504%\n  }\n\n  .flag-sd {\n    background-position: 0 77.272727%\n  }\n\n  .flag-se {\n    background-position: 0 77.68595%\n  }\n\n  .flag-sg {\n    background-position: 0 78.099174%\n  }\n\n  .flag-sh {\n    background-position: 0 78.512397%\n  }\n\n  .flag-si {\n    background-position: 0 78.92562%\n  }\n\n  .flag-sj {\n    background-position: 0 79.338843%\n  }\n\n  .flag-sk {\n    background-position: 0 79.752066%\n  }\n\n  .flag-sl {\n    background-position: 0 80.165289%\n  }\n\n  .flag-sm {\n    background-position: 0 80.578512%\n  }\n\n  .flag-sn {\n    background-position: 0 80.991736%\n  }\n\n  .flag-so {\n    background-position: 0 81.404959%\n  }\n\n  .flag-sr {\n    background-position: 0 81.818182%\n  }\n\n  .flag-ss {\n    background-position: 0 82.231405%\n  }\n\n  .flag-st {\n    background-position: 0 82.644628%\n  }\n\n  .flag-sv {\n    background-position: 0 83.057851%\n  }\n\n  .flag-sy {\n    background-position: 0 83.471074%\n  }\n\n  .flag-sz {\n    background-position: 0 83.884298%\n  }\n\n  .flag-tc {\n    background-position: 0 84.297521%\n  }\n\n  .flag-td {\n    background-position: 0 84.710744%\n  }\n\n  .flag-tf {\n    background-position: 0 85.123967%\n  }\n\n  .flag-tg {\n    background-position: 0 85.53719%\n  }\n\n  .flag-th {\n    background-position: 0 85.950413%\n  }\n\n  .flag-tj {\n    background-position: 0 86.363636%\n  }\n\n  .flag-tk {\n    background-position: 0 86.77686%\n  }\n\n  .flag-tl {\n    background-position: 0 87.190083%\n  }\n\n  .flag-tm {\n    background-position: 0 87.603306%\n  }\n\n  .flag-tn {\n    background-position: 0 88.016529%\n  }\n\n  .flag-to {\n    background-position: 0 88.429752%\n  }\n\n  .flag-tp {\n    background-position: 0 88.842975%\n  }\n\n  .flag-tr {\n    background-position: 0 89.256198%\n  }\n\n  .flag-tt {\n    background-position: 0 89.669421%\n  }\n\n  .flag-tv {\n    background-position: 0 90.082645%\n  }\n\n  .flag-tw {\n    background-position: 0 90.495868%\n  }\n\n  .flag-ty {\n    background-position: 0 90.909091%\n  }\n\n  .flag-tz {\n    background-position: 0 91.322314%\n  }\n\n  .flag-ua {\n    background-position: 0 91.735537%\n  }\n\n  .flag-ug {\n    background-position: 0 92.14876%\n  }\n\n  .flag-gb,.flag-uk {\n    background-position: 0 92.561983%\n  }\n\n  .flag-um {\n    background-position: 0 92.975207%\n  }\n\n  .flag-us {\n    background-position: 0 93.38843%\n  }\n\n  .flag-uy {\n    background-position: 0 93.801653%\n  }\n\n  .flag-uz {\n    background-position: 0 94.214876%\n  }\n\n  .flag-va {\n    background-position: 0 94.628099%\n  }\n\n  .flag-vc {\n    background-position: 0 95.041322%\n  }\n\n  .flag-ve {\n    background-position: 0 95.454545%\n  }\n\n  .flag-vg {\n    background-position: 0 95.867769%\n  }\n\n  .flag-vi {\n    background-position: 0 96.280992%\n  }\n\n  .flag-vn {\n    background-position: 0 96.694215%\n  }\n\n  .flag-vu {\n    background-position: 0 97.107438%\n  }\n\n  .flag-wf {\n    background-position: 0 97.520661%\n  }\n\n  .flag-ws {\n    background-position: 0 97.933884%\n  }\n\n  .flag-ye {\n    background-position: 0 98.347107%\n  }\n\n  .flag-za {\n    background-position: 0 98.760331%\n  }\n\n  .flag-zm {\n    background-position: 0 99.173554%\n  }\n\n  .flag-zr {\n    background-position: 0 99.586777%\n  }\n\n  .flag-zw {\n    background-position: 0 100%\n  }\n\n  @font-face {\n    font-family: Roboto;\n    font-style: normal;\n    font-weight: 400;\n  }\n\n  @font-face {\n    font-family: Roboto;\n    font-style: normal;\n    font-weight: 500;\n  }\n\n  @font-face {\n    font-family: Roboto;\n    font-style: normal;\n    font-weight: 700;\n  }\n\n  .card {\n    background-color: var(--surface-card);\n    margin-bottom: 2rem;\n    border: 1px solid var(--surface-border);\n    border-radius: var(--border-radius)\n  }\n\n  .card:last-child {\n    margin-bottom: 0\n  }\n\n  .ng-hidden {\n    display: none!important\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-weight: 400;\n    color: var(--accent);\n    margin: 0 0 8px;\n  }\n\n  h1, .h1 {\n    font-size: 2.55em;\n    line-height: 1.2;\n    color: var(--accent);\n    font-weight: 700;\n    text-shadow: 0 3px 8px #00000017;\n  }\n  h2, .h2 {\n    font-size: 2.0em;\n    line-height: 1.2;\n    color: var(--accent);\n  }\n  h3, .h3 {\n    font-size: 1.5em;\n    line-height: 1.2;\n  }\n  h5, .h5 {\n    font-size: 1em;\n    line-height: 1.2;\n  }\n  h6, .h6 {\n    font-size: 0.825em;\n    line-height: 1.2;\n  }\n\n  h1:first-child,h2:first-child,h3:first-child,h4:first-child,h5:first-child,h6:first-child {\n    margin-top: 0\n  }\n\n  // small (sm)\n  @media only screen and (max-width: 600px) {\n    h1, .h1 {\n      font-size: 2.4em;\n      line-height: 1.22;\n      color: var(--accent);\n      font-weight: 700;\n      text-shadow: 0 3px 8px #00000017;\n    }\n    h2, .h2 {\n      font-size: 1.95em;\n      line-height: 1.22;\n      color: var(--accent);\n    }\n    h3, .h3 {\n      font-size: 1.4em;\n      line-height: 1.22;\n    }\n    h4, .h4 {\n      font-size: 1.35em;\n      line-height: 1.22;\n    }\n    h5, .h5 {\n      font-size: 1.1em;\n      line-height: 1.22;\n    }\n    h6, .h6 {\n      font-size: 0.825em;\n      line-height: 1.22;\n    }\n  }\n  // medium (md)\n  @media screen and (min-width: 768px) {\n    h1, .h1 {\n      font-size: 2.65em;\n      line-height: 1.23;\n      color: var(--accent);\n      font-weight: 700;\n      text-shadow: 0 3px 8px #00000017;\n    }\n    h2, .h2 {\n      font-size: 2.15em;\n      line-height: 1.3;\n      color: var(--accent);\n    }\n    h3, .h3 {\n      font-size: 1.65em;\n      line-height: 1.23;\n    }\n    h4, .h4 {\n      font-size: 1.4em;\n      line-height: 1.23;\n    }\n    h5, .h5 {\n      font-size: 1.15em;\n      line-height: 1.23;\n    }\n    h6, .h6 {\n      font-size: 0.825em;\n      line-height: 1.23;\n    }\n  }\n  // large (lg)\n  @media screen and (min-width: 992px) {\n    h1, .h1 {\n      font-size: 2.70em;\n      line-height: 1.24;\n      color: var(--accent);\n      font-weight: 700;\n      text-shadow: 0 3px 8px #00000017;\n    }\n    h2, .h2 {\n      font-size: 2.20em;\n      line-height: 1.24;\n      color: var(--accent);\n    }\n    h3, .h3 {\n      font-size: 1.70em;\n      line-height: 1.24;\n    }\n    h4, .h4 {\n      font-size: 1.45em;\n      line-height: 1.24;\n    }\n    h5, .h5 {\n      font-size: 1.2em;\n      line-height: 1.24;\n    }\n    h6, .h6 {\n      font-size: 0.85em;\n      line-height: 1.24;\n    }\n  }\n  // x-large (xl)\n  @media screen and (min-width: 1200px) {\n    h1, .h1 {\n      font-size: 2.75em;\n      line-height: 1.25;\n      color: var(--accent);\n      font-weight: 700;\n      text-shadow: 0 3px 8px #00000017;\n    }\n    h2, .h2 {\n      font-size: 2.25em;\n      line-height: 1.25;\n      color: var(--accent);\n    }\n    h3, .h3 {\n      font-size: 1.75em;\n      line-height: 1.25;\n    }\n    h4, .h4 {\n      font-size: 1.5em;\n      line-height: 1.25;\n    }\n    h5, .h5 {\n      font-size: 1.25em;\n      line-height: 1.25;\n    }\n    h6, .h6 {\n      font-size: 0.875em;\n      line-height: 1.25;\n    }\n  }\n\n  mark {\n    background: #FFF8E1;\n    padding: .25rem .4rem;\n    border-radius: var(--border-radius);\n    font-family: monospace\n  }\n\n  blockquote {\n    margin: 1rem 0;\n    padding: 0 2rem;\n    border-left: 4px solid #90A4AE\n  }\n\n  hr {\n    border-top: solid var(--surface-border);\n    border-width: 1px 0 0 0;\n    margin: 1rem 0\n  }\n\n  p {\n    margin: 0 0 1rem;\n    line-height: 1.5\n  }\n\n  p:last-child {\n    margin-bottom: 0\n  }\n\n  @keyframes px-mask-in {\n    0% {\n      background-color: transparent\n    }\n\n    to {\n      background-color: var(--maskbg)\n    }\n  }\n\n  @keyframes px-scalein {\n    0% {\n      opacity: 0;\n      transform: scaleY(.8)\n    }\n\n    to {\n      opacity: 1;\n      transform: scaleY(1)\n    }\n  }\n\n  @keyframes px-fadein {\n    0% {\n      opacity: 0\n    }\n\n    to {\n      opacity: 1\n    }\n  }\n\n  @keyframes px-fadeout {\n    0% {\n      opacity: 1\n    }\n\n    to {\n      opacity: 0\n    }\n  }\n\n  .px-scalein {\n    animation: px-scalein .12s cubic-bezier(0,0,.2,1)\n  }\n\n  .px-fadein {\n    animation: px-fadein .15s linear\n  }\n\n  .px-fadeout {\n    animation: px-fadeout .15s linear\n  }\n\n  .layout-topbar-dark {\n    --topbar-bg: #2a323d;\n    --topbar-menu-button-bg: #ffffff;\n    --topbar-menu-button-text-color: #212529;\n    --topbar-item-text-color: #ffffff\n  }\n\n  .layout-topbar-light {\n    --topbar-bg: #ffffff;\n    --topbar-menu-button-bg: var(--primary-color);\n    --topbar-menu-button-text-color: #ffffff;\n    --topbar-item-text-color: #212529\n  }\n\n  .layout-topbar-blue {\n    --topbar-bg: #0d6efd;\n    --topbar-menu-button-bg: #ffffff;\n    --topbar-menu-button-text-color: #0d6efd;\n    --topbar-item-text-color: #ffffff\n  }\n\n  .layout-topbar-purple {\n    --topbar-bg: #6f42c1;\n    --topbar-menu-button-bg: #ffffff;\n    --topbar-menu-button-text-color: #6f42c1;\n    --topbar-item-text-color: #ffffff\n  }\n\n  .layout-topbar-pink {\n    --topbar-bg: #d63384;\n    --topbar-menu-button-bg: #ffffff;\n    --topbar-menu-button-text-color: #d63384;\n    --topbar-item-text-color: #ffffff\n  }\n\n  .layout-topbar-cyan {\n    --topbar-bg: #0dcaf0;\n    --topbar-menu-button-bg: #ffffff;\n    --topbar-menu-button-text-color: #0dcaf0;\n    --topbar-item-text-color: #ffffff\n  }\n\n  .layout-topbar-teal {\n    --topbar-bg: #20c997;\n    --topbar-menu-button-bg: #212529;\n    --topbar-menu-button-text-color: #20c997;\n    --topbar-item-text-color: #212529\n  }\n\n  .layout-topbar-green {\n    --topbar-bg: #198754;\n    --topbar-menu-button-bg: #ffffff;\n    --topbar-menu-button-text-color: #198754;\n    --topbar-item-text-color: #ffffff\n  }\n\n  .layout-topbar-yellow {\n    --topbar-bg: #ffc107;\n    --topbar-menu-button-bg: #212529;\n    --topbar-menu-button-text-color: #ffc107;\n    --topbar-item-text-color: #212529\n  }\n\n  .layout-topbar-orange {\n    --topbar-bg: #fd7e14;\n    --topbar-menu-button-bg: #212529;\n    --topbar-menu-button-text-color: #fd7e14;\n    --topbar-item-text-color: #212529\n  }\n\n  .layout-topbar-indigo {\n    --topbar-bg: #6610f2;\n    --topbar-menu-button-bg: #ffffff;\n    --topbar-menu-button-text-color: #6610f2;\n    --topbar-item-text-color: #ffffff\n  }\n\n  .layout-topbar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 999;\n    width: 100%;\n    height: 4rem;\n    transition: width var(--transition-duration);\n    display: flex;\n    color: var(--topbar-item-text-color);\n    background-color: var(--topbar-bg);\n    border-bottom: 1px solid var(--surface-border)\n  }\n\n  .layout-topbar ul {\n    margin: 0;\n    padding: 0;\n    list-style-type: none\n  }\n\n  .layout-topbar .layout-topbar-start {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 1rem;\n    position: relative;\n    width: 17rem\n  }\n\n  .layout-topbar .layout-topbar-start .layout-topbar-logo {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start\n  }\n\n  .layout-topbar .layout-topbar-start .layout-topbar-logo img {\n    height: 2.5rem\n  }\n\n  .layout-topbar .layout-topbar-start .layout-topbar-logo .layout-topbar-logo-slim {\n    display: none\n  }\n\n  .layout-topbar .layout-topbar-start .layout-menu-button {\n    position: absolute;\n    top: 50%;\n    margin-top: -1.25rem;\n    right: -1.25rem;\n    width: 2.5rem;\n    height: 2.5rem;\n    display: inline-flex;\n    flex-shrink: 0;\n    align-items: center;\n    justify-content: center;\n    border-radius: var(--border-radius);\n    color: var(--topbar-menu-button-text-color);\n    background-color: var(--topbar-menu-button-bg);\n    transition: background-color var(--transition-duration);\n    cursor: pointer\n  }\n\n  .layout-topbar .layout-topbar-start .layout-menu-button i {\n    font-size: 2rem;\n    transition: transform var(--transition-duration)\n  }\n\n  .layout-topbar .layout-topbar-start .layout-topbar-mobile-button {\n    display: none;\n    border-radius: 50%;\n    width: 2.5rem;\n    height: 2.5rem;\n    cursor: pointer\n  }\n\n  .layout-topbar .layout-topbar-end {\n    display: flex;\n    flex-grow: 1;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 0 2rem\n  }\n\n  .layout-topbar .layout-topbar-end .layout-megamenu {\n    background: none\n  }\n\n  .layout-topbar .layout-topbar-end .layout-megamenu.p-megamenu .p-megamenu-root-list>.p-menuitem>.p-menuitem-link .p-menuitem-text,.layout-topbar .layout-topbar-end .layout-megamenu.p-megamenu .p-megamenu-root-list>.p-menuitem>.p-menuitem-link .p-menuitem-icon,.layout-topbar .layout-topbar-end .layout-megamenu.p-megamenu .p-megamenu-root-list>.p-menuitem>.p-menuitem-link .p-submenu-icon {\n    color: var(--topbar-item-text-color)\n  }\n\n  .layout-topbar .layout-topbar-end .layout-megamenu.p-megamenu .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-disabled):hover {\n    background: var(--topbar-item-hover-bg);\n    transition: background-color var(--transition-duration)\n  }\n\n  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items {\n    display: flex;\n    flex-direction: row;\n    gap: 1rem\n  }\n\n  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items>li {\n    position: relative\n  }\n\n  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items>li>a {\n    width: 2.5rem;\n    height: 2.5rem;\n    -webkit-user-select: none;\n    user-select: none;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    color: var(--topbar-item-text-color)\n  }\n\n  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items>li>a i {\n    font-size: 1.25rem\n  }\n\n  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items>li>a:hover {\n    background-color: var(--topbar-item-hover-bg);\n    transition: background-color var(--transition-duration)\n  }\n\n  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items>li>div {\n    position: absolute;\n    top: 3.5rem;\n    right: 0;\n    min-width: 18rem;\n    padding: .5rem 0;\n    transform-origin: top;\n    background: var(--surface-overlay);\n    color: var(--text-color);\n    border-top: 4px solid var(--topbar-bg);\n    box-shadow: 0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f\n  }\n\n  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items>li.layout-topbar-search {\n    position: relative;\n    display: flex;\n    align-items: center\n  }\n\n  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items>li.layout-topbar-search input {\n    padding: .65rem 2.5rem .65rem 1rem;\n    color: var(--topbar-item-text-color);\n    background-color: #fff3;\n    border: 1px solid var(--topbar-item-text-color);\n    border-radius: 1.5rem;\n    width: 14rem;\n    font-size: 1rem;\n    transition: var(--transition-duration)\n  }\n\n  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items>li.layout-topbar-search input::placeholder {\n    color: var(--topbar-item-text-color)\n  }\n\n  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items>li.layout-topbar-search input:focus {\n    outline: 0 none;\n    border: 1px solid var(--topbar-item-text-color)\n  }\n\n  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items>li.layout-topbar-search>i {\n    color: var(--topbar-item-text-color);\n    position: absolute;\n    right: .75rem;\n    font-size: 1.25rem\n  }\n\n  .layout-menu-light {\n    --menu-bg: #ffffff;\n    --root-menuitem-text-color: #657380;\n    --menuitem-text-color: #515C66;\n    --menuitem-hover-bg: rgba(0,0,0,.04);\n    --active-menuitem-text-color: var(--primary-500);\n    --active-menuitem-bg: var(--primary-50);\n    --inline-menu-border-color: #e4e4e4\n  }\n\n  .layout-menu-dark {\n    --menu-bg: #2a323d;\n    --root-menuitem-text-color: rgba(255,255,255,.6);\n    --menuitem-text-color: rgba(255,255,255,.87);\n    --menuitem-hover-bg: hsla(0,0%,100%,.04);\n    --active-menuitem-text-color: rgba(255,255,255,.87);\n    --active-menuitem-bg: hsla(0,0%,100%,.04);\n    --inline-menu-border-color: hsla(0,0%,100%,.12)\n  }\n\n  .layout-sidebar {\n    position: fixed;\n    height: calc(100% - 4rem);\n    top: 4rem;\n    left: 0;\n    width: 17rem;\n    background: var(--menu-bg);\n    border-right: 1px solid var(--surface-border);\n    display: flex;\n    flex-direction: column\n  }\n\n  .layout-sidebar .layout-sidebar-top {\n    display: none\n  }\n\n  .layout-sidebar .layout-menu-container {\n    flex: 1;\n    padding-bottom: 2rem;\n    overflow: auto\n  }\n\n  .layout-sidebar .layout-menu {\n    margin: 0;\n    padding: 0;\n    list-style-type: none\n  }\n\n  .layout-sidebar .layout-menu .layout-root-menuitem>.layout-menuitem-root-text {\n    display: flex;\n    align-items: center;\n    font-size: .857rem;\n    text-transform: uppercase;\n    font-weight: 700;\n    color: var(--root-menuitem-text-color);\n    padding: 1rem 1.5rem 1rem 1rem\n  }\n\n  .layout-sidebar .layout-menu .layout-root-menuitem>.layout-menuitem-root-text>.layout-menuitem-root-icon {\n    display: none\n  }\n\n  .layout-sidebar .layout-menu .layout-root-menuitem>a {\n    display: none\n  }\n\n  .layout-sidebar .layout-menu a {\n    -webkit-user-select: none;\n    user-select: none\n  }\n\n  .layout-sidebar .layout-menu li.active-menuitem>a {\n    color: var(--active-menuitem-text-color);\n    background-color: var(--active-menuitem-bg)\n  }\n\n  .layout-sidebar .layout-menu li.active-menuitem>a .layout-menuitem-icon {\n    margin-right: .5rem;\n    color: var(--active-menuitem-text-color)\n  }\n\n  .layout-sidebar .layout-menu li.active-menuitem>a .layout-submenu-toggler {\n    transform: rotate(-180deg)\n  }\n\n  .layout-sidebar .layout-menu ul {\n    margin: 0;\n    padding: 0;\n    list-style-type: none\n  }\n\n  .layout-sidebar .layout-menu ul a {\n    display: flex;\n    align-items: center;\n    position: relative;\n    outline: 0 none;\n    color: var(--menuitem-text-color);\n    cursor: pointer;\n    padding: .75rem 1.5rem;\n    transition: background-color var(--transition-duration),box-shadow var(--transition-duration)\n  }\n\n  .layout-sidebar .layout-menu ul a .layout-menuitem-icon {\n    margin-right: .5rem;\n    color: var(--menuitem-text-color)\n  }\n\n  .layout-sidebar .layout-menu ul a .layout-submenu-toggler {\n    font-size: 75%;\n    margin-left: auto;\n    transition: transform var(--transition-duration)\n  }\n\n  .layout-sidebar .layout-menu ul a.active-route {\n    font-weight: 700\n  }\n\n  .layout-sidebar .layout-menu ul a:hover {\n    background-color: var(--menuitem-hover-bg)\n  }\n\n  .layout-sidebar .layout-menu ul ul {\n    overflow: hidden;\n    border-radius: var(--border-radius)\n  }\n\n  .layout-sidebar .layout-menu ul ul li a {\n    padding-left: 2.5rem\n  }\n\n  .layout-sidebar .layout-menu ul ul li li a {\n    padding-left: 3rem\n  }\n\n  .layout-sidebar .layout-menu ul ul li li li a {\n    padding-left: 3.5rem\n  }\n\n  .layout-sidebar .layout-menu ul ul li li li li a {\n    padding-left: 4rem\n  }\n\n  .layout-sidebar .layout-menu ul ul li li li li li a {\n    padding-left: 5.5rem\n  }\n\n  .layout-sidebar .layout-menu ul ul li li li li li li a {\n    padding-left: 5rem\n  }\n\n  @media screen and (min-width: 992px) {\n    .layout-container.layout-slim .layout-sidebar {\n      width:5rem;\n      overflow: visible;\n      z-index: 998\n    }\n\n    .layout-container.layout-slim .layout-sidebar .layout-menu-container {\n      overflow: auto\n    }\n\n    .layout-container.layout-slim .layout-sidebar .layout-menu-container::-webkit-scrollbar {\n      display: none\n    }\n\n    .layout-container.layout-slim .layout-topbar .layout-topbar-start {\n      width: 5rem\n    }\n\n    .layout-container.layout-slim .layout-topbar .layout-topbar-start .layout-topbar-logo .layout-topbar-logo-full {\n      display: none\n    }\n\n    .layout-container.layout-slim .layout-topbar .layout-topbar-start .layout-topbar-logo .layout-topbar-logo-slim {\n      display: block\n    }\n\n    .layout-container.layout-slim .layout-topbar .layout-topbar-start .layout-menu-button {\n      display: none\n    }\n\n    .layout-container.layout-slim .layout-content-wrapper {\n      margin-left: 5rem\n    }\n\n    .layout-container.layout-slim .layout-menu {\n      padding: 1rem 0\n    }\n\n    .layout-container.layout-slim .layout-menu .layout-root-menuitem {\n      margin: .75rem 0\n    }\n\n    .layout-container.layout-slim .layout-menu .layout-root-menuitem:first-child {\n      margin-top: 0\n    }\n\n    .layout-container.layout-slim .layout-menu .layout-root-menuitem:last-child {\n      margin-top: 0\n    }\n\n    .layout-container.layout-slim .layout-menu .layout-root-menuitem>.layout-menuitem-root-text {\n      display: none\n    }\n\n    .layout-container.layout-slim .layout-menu .layout-root-menuitem>a {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 50%;\n      cursor: pointer;\n      outline: none;\n      transition: background-color var(--transition-duration);\n      width: 3rem;\n      height: 3rem;\n      margin: 0 auto\n    }\n\n    .layout-container.layout-slim .layout-menu .layout-root-menuitem>a .layout-submenu-toggler {\n      display: none\n    }\n\n    .layout-container.layout-slim .layout-menu .layout-root-menuitem>a .layout-menuitem-icon {\n      font-size: 1.5rem;\n      color: var(--menuitem-text-color)\n    }\n\n    .layout-container.layout-slim .layout-menu .layout-root-menuitem>a .layout-menuitem-text {\n      display: none\n    }\n\n    .layout-container.layout-slim .layout-menu .layout-root-menuitem>a:hover {\n      background-color: var(--menuitem-hover-bg)\n    }\n\n    .layout-container.layout-slim .layout-menu .layout-root-menuitem>ul {\n      position: absolute;\n      left: 5rem;\n      top: 0;\n      min-width: 15rem;\n      background-color: var(--menu-bg);\n      border-radius: var(--border-radius);\n      padding: .5rem 0;\n      max-height: 20rem;\n      overflow: auto;\n      z-index: 999;\n      box-shadow: 0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f\n    }\n\n    .layout-container.layout-slim .layout-menu .layout-root-menuitem>ul::-webkit-scrollbar {\n      display: none\n    }\n\n    .layout-container.layout-slim .layout-menu .layout-root-menuitem>ul a {\n      padding-right: .5rem\n    }\n\n    .layout-container.layout-slim .layout-menu .layout-root-menuitem>ul li a {\n      padding-left: .5rem\n    }\n\n    .layout-container.layout-slim .layout-menu .layout-root-menuitem>ul li li a {\n      padding-left: 1rem\n    }\n\n    .layout-container.layout-slim .layout-menu .layout-root-menuitem>ul li li li a {\n      padding-left: 1.5rem\n    }\n\n    .layout-container.layout-slim .layout-menu .layout-root-menuitem>ul li li li li a {\n      padding-left: 2rem\n    }\n\n    .layout-container.layout-slim .layout-menu .layout-root-menuitem>ul li li li li li a {\n      padding-left: 2.5rem\n    }\n\n    .layout-container.layout-slim .layout-menu .layout-root-menuitem>ul li li li li li li a {\n      padding-left: 3rem\n    }\n\n    .layout-container.layout-slim .layout-menu-profile {\n      display: flex;\n      flex-direction: column;\n      align-items: center\n    }\n\n    .layout-container.layout-slim .layout-menu-profile>button {\n      width: 3rem;\n      height: 3rem;\n      padding: 0;\n      border-radius: 50%;\n      justify-content: center;\n      margin: .75rem 0\n    }\n\n    .layout-container.layout-slim .layout-menu-profile>button span,.layout-container.layout-slim .layout-menu-profile>button i {\n      display: none\n    }\n\n    .layout-container.layout-slim .layout-menu-profile>ul>li {\n      margin: .75rem 0\n    }\n\n    .layout-container.layout-slim .layout-menu-profile>ul>li:first-child {\n      margin-top: 0\n    }\n\n    .layout-container.layout-slim .layout-menu-profile>ul>li>button {\n      width: 3rem;\n      height: 3rem;\n      padding: 0;\n      justify-content: center;\n      border-radius: 50%\n    }\n\n    .layout-container.layout-slim .layout-menu-profile>ul>li>button>i {\n      font-size: 1.5rem;\n      margin-right: 0\n    }\n\n    .layout-container.layout-slim .layout-menu-profile>ul>li>button>span {\n      display: none\n    }\n\n    .layout-container.layout-slim .layout-menu-profile>ul>li:last-child {\n      margin-bottom: 1rem\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .layout-container.layout-slim-plus .layout-sidebar {\n      width:7rem;\n      overflow: visible;\n      z-index: 998\n    }\n\n    .layout-container.layout-slim-plus .layout-sidebar .layout-menu-container {\n      overflow: auto\n    }\n\n    .layout-container.layout-slim-plus .layout-sidebar .layout-menu-container::-webkit-scrollbar {\n      display: none\n    }\n\n    .layout-container.layout-slim-plus .layout-topbar .layout-topbar-start {\n      width: 7rem\n    }\n\n    .layout-container.layout-slim-plus .layout-topbar .layout-topbar-start .layout-topbar-logo .layout-topbar-logo-full {\n      display: none\n    }\n\n    .layout-container.layout-slim-plus .layout-topbar .layout-topbar-start .layout-topbar-logo .layout-topbar-logo-slim {\n      display: block\n    }\n\n    .layout-container.layout-slim-plus .layout-topbar .layout-topbar-start .layout-menu-button {\n      display: none\n    }\n\n    .layout-container.layout-slim-plus .layout-content-wrapper {\n      margin-left: 7rem\n    }\n\n    .layout-container.layout-slim-plus .layout-menu {\n      padding: 1rem 0\n    }\n\n    .layout-container.layout-slim-plus .layout-menu ul {\n      display: none\n    }\n\n    .layout-container.layout-slim-plus .layout-menu li.active-menuitem>ul {\n      display: block\n    }\n\n    .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem {\n      margin: .75rem 0\n    }\n\n    .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem:first-child {\n      margin-top: 0\n    }\n\n    .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem:last-child {\n      margin-top: 0\n    }\n\n    .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem>.layout-menuitem-root-text {\n      display: none\n    }\n\n    .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem>a {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      text-align: center;\n      border-radius: var(--border-radius);\n      cursor: pointer;\n      outline: none;\n      transition: background-color var(--transition-duration);\n      width: auto;\n      height: auto;\n      margin: 0 auto 1rem;\n      padding: .75rem 0\n    }\n\n    .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem>a .layout-submenu-toggler {\n      display: none\n    }\n\n    .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem>a .layout-menuitem-icon {\n      font-size: 1.5rem;\n      color: var(--menuitem-text-color)\n    }\n\n    .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem>a .layout-menuitem-text {\n      font-size: .875rem;\n      display: block;\n      margin-top: .25rem;\n      color: var(--menuitem-text-color)\n    }\n\n    .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem>a:hover {\n      background-color: var(--menuitem-hover-bg)\n    }\n\n    .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem>ul {\n      position: absolute;\n      left: 7rem;\n      top: 0;\n      min-width: 15rem;\n      background-color: var(--menu-bg);\n      border-radius: var(--border-radius);\n      padding: .5rem 0;\n      max-height: 20rem;\n      overflow: auto;\n      z-index: 999;\n      box-shadow: 0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f\n    }\n\n    .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem>ul::-webkit-scrollbar {\n      display: none\n    }\n\n    .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem>ul a {\n      padding-right: .5rem\n    }\n\n    .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem>ul li a {\n      padding-left: .5rem\n    }\n\n    .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem>ul li li a {\n      padding-left: 1rem\n    }\n\n    .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem>ul li li li a {\n      padding-left: 1.5rem\n    }\n\n    .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem>ul li li li li a {\n      padding-left: 2rem\n    }\n\n    .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem>ul li li li li li a {\n      padding-left: 2.5rem\n    }\n\n    .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem>ul li li li li li li a {\n      padding-left: 3rem\n    }\n\n    .layout-container.layout-slim-plus .layout-menu-profile {\n      display: flex;\n      flex-direction: column;\n      align-items: center\n    }\n\n    .layout-container.layout-slim-plus .layout-menu-profile>button {\n      width: 3rem;\n      height: 3rem;\n      padding: 0;\n      border-radius: 50%;\n      justify-content: center;\n      margin: .75rem 0\n    }\n\n    .layout-container.layout-slim-plus .layout-menu-profile>button span,.layout-container.layout-slim-plus .layout-menu-profile>button i {\n      display: none\n    }\n\n    .layout-container.layout-slim-plus .layout-menu-profile>ul>li {\n      margin: .75rem 0\n    }\n\n    .layout-container.layout-slim-plus .layout-menu-profile>ul>li:first-child {\n      margin-top: 0\n    }\n\n    .layout-container.layout-slim-plus .layout-menu-profile>ul>li>button {\n      width: 3rem;\n      height: 3rem;\n      padding: 0;\n      justify-content: center;\n      border-radius: 50%\n    }\n\n    .layout-container.layout-slim-plus .layout-menu-profile>ul>li>button>i {\n      font-size: 1.5rem;\n      margin-right: 0\n    }\n\n    .layout-container.layout-slim-plus .layout-menu-profile>ul>li>button>span {\n      display: none\n    }\n\n    .layout-container.layout-slim-plus .layout-menu-profile>ul>li:last-child {\n      margin-bottom: 1rem\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .layout-container.layout-horizontal .layout-sidebar {\n      width:100%;\n      height: 3rem;\n      top: 4rem;\n      position: fixed;\n      z-index: 998;\n      overflow: visible;\n      flex-direction: row;\n      padding: 0 2rem\n    }\n\n    .layout-container.layout-horizontal .layout-sidebar .layout-menu-container {\n      overflow: auto;\n      padding-bottom: 0\n    }\n\n    .layout-container.layout-horizontal .layout-sidebar .layout-menu-container::-webkit-scrollbar {\n      display: none\n    }\n\n    .layout-container.layout-horizontal .layout-topbar .layout-topbar-start .layout-menu-button {\n      display: none\n    }\n\n    .layout-container.layout-horizontal .layout-content-wrapper {\n      padding-top: 7rem\n    }\n\n    .layout-container.layout-horizontal .layout-menu {\n      display: flex;\n      flex-wrap: nowrap;\n      flex-direction: row;\n      align-items: center;\n      height: 100%\n    }\n\n    .layout-container.layout-horizontal .layout-menu ul {\n      display: none\n    }\n\n    .layout-container.layout-horizontal .layout-menu .layout-root-menuitem {\n      border-radius: var(--border-radius)\n    }\n\n    .layout-container.layout-horizontal .layout-menu .layout-root-menuitem>.layout-menuitem-root-text {\n      display: none\n    }\n\n    .layout-container.layout-horizontal .layout-menu .layout-root-menuitem>a {\n      display: flex;\n      align-items: center;\n      padding: .75rem;\n      border-radius: 0;\n      cursor: pointer;\n      outline: none;\n      color: var(--menuitem-text-color);\n      transition: background-color var(--transition-duration)\n    }\n\n    .layout-container.layout-horizontal .layout-menu .layout-root-menuitem>a .layout-submenu-toggler {\n      display: block;\n      margin-left: auto;\n      transition: transform .2s\n    }\n\n    .layout-container.layout-horizontal .layout-menu .layout-root-menuitem>a .layout-menuitem-icon {\n      font-size: 1.25rem;\n      color: var(--menuitem-text-color)\n    }\n\n    .layout-container.layout-horizontal .layout-menu .layout-root-menuitem>a .layout-menuitem-text {\n      font-size: .875rem;\n      display: block;\n      margin-left: .75rem;\n      margin-right: .75rem;\n      white-space: nowrap\n    }\n\n    .layout-container.layout-horizontal .layout-menu .layout-root-menuitem>a:hover {\n      background-color: var(--menuitem-hover-bg)\n    }\n\n    .layout-container.layout-horizontal .layout-menu .layout-root-menuitem>ul {\n      position: absolute;\n      left: auto;\n      top: 3rem;\n      min-width: 15rem;\n      background-color: var(--menu-bg);\n      box-shadow: 0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f;\n      padding: .5rem 0;\n      border-radius: var(--border-radius);\n      max-height: 20rem;\n      overflow: auto;\n      z-index: 999\n    }\n\n    .layout-container.layout-horizontal .layout-menu .layout-root-menuitem>ul::-webkit-scrollbar {\n      display: none\n    }\n\n    .layout-container.layout-horizontal .layout-menu .layout-root-menuitem>ul a {\n      padding-right: .5rem\n    }\n\n    .layout-container.layout-horizontal .layout-menu .layout-root-menuitem>ul li a {\n      padding-left: .5rem\n    }\n\n    .layout-container.layout-horizontal .layout-menu .layout-root-menuitem>ul li li a {\n      padding-left: 1rem\n    }\n\n    .layout-container.layout-horizontal .layout-menu .layout-root-menuitem>ul li li li a {\n      padding-left: 1.5rem\n    }\n\n    .layout-container.layout-horizontal .layout-menu .layout-root-menuitem>ul li li li li a {\n      padding-left: 2rem\n    }\n\n    .layout-container.layout-horizontal .layout-menu .layout-root-menuitem>ul li li li li li a {\n      padding-left: 2.5rem\n    }\n\n    .layout-container.layout-horizontal .layout-menu .layout-root-menuitem>ul li li li li li li a {\n      padding-left: 3rem\n    }\n\n    .layout-container.layout-horizontal.layout-menu-profile-start .layout-menu-profile {\n      border-bottom: 0 none\n    }\n\n    .layout-container.layout-horizontal.layout-menu-profile-start .layout-menu-profile>ul {\n      left: 0\n    }\n\n    .layout-container.layout-horizontal.layout-menu-profile-end .layout-menu-profile {\n      border-top: 0 none\n    }\n\n    .layout-container.layout-horizontal.layout-menu-profile-end .layout-menu-profile>ul {\n      right: 0\n    }\n\n    .layout-container.layout-horizontal .layout-menu-profile {\n      position: relative;\n      overflow: visible;\n      width: auto;\n      height: 100%\n    }\n\n    .layout-container.layout-horizontal .layout-menu-profile>button {\n      padding: 0 .75rem;\n      width: auto;\n      height: 100%\n    }\n\n    .layout-container.layout-horizontal .layout-menu-profile>button .layout-menu-profile-toggler {\n      margin-left: .5rem\n    }\n\n    .layout-container.layout-horizontal .layout-menu-profile>ul {\n      position: absolute;\n      top: 3rem;\n      min-width: 15rem;\n      background-color: var(--menu-bg);\n      box-shadow: 0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f;\n      padding: 1rem;\n      border-radius: var(--border-radius);\n      max-height: 20rem;\n      overflow: auto;\n      z-index: 999;\n      transform-origin: center top\n    }\n\n    .layout-container.layout-horizontal .layout-menu-profile>ul>li>button {\n      padding: .75rem .5rem\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .layout-reveal .layout-sidebar {\n      height:100%;\n      top: 0;\n      transition: transform .3s cubic-bezier(0,0,.2,1);\n      transform: translate(-12.75rem);\n      z-index: 999\n    }\n\n    .layout-reveal .layout-sidebar .layout-sidebar-top {\n      display: flex;\n      align-items: center;\n      justify-content: flex-end;\n      padding: 0 .75rem;\n      height: 4rem;\n      background-color: var(--topbar-bg);\n      color: var(--topbar-item-text-color)\n    }\n\n    .layout-reveal .layout-sidebar .layout-sidebar-top .layout-sidebar-logo {\n      display: none\n    }\n\n    .layout-reveal .layout-sidebar .layout-sidebar-top .layout-sidebar-logo-slim {\n      display: inline\n    }\n\n    .layout-reveal .layout-sidebar .layout-sidebar-top .layout-sidebar-anchor {\n      display: none;\n      width: 1.25rem;\n      height: 1.25rem;\n      border-radius: 50%;\n      border: 2px solid var(--topbar-menu-button-bg);\n      background-color: transparent;\n      transition: background-color var(--transition-duration),transform .3s\n    }\n\n    .layout-reveal .layout-sidebar .layout-menu-container {\n      overflow: hidden\n    }\n\n    .layout-reveal .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem>.layout-menuitem-root-text>span {\n      margin-right: auto\n    }\n\n    .layout-reveal .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem>.layout-menuitem-root-text>.layout-menuitem-root-icon {\n      display: block;\n      margin-right: .125rem\n    }\n\n    .layout-reveal .layout-sidebar .layout-menu-container .layout-menu ul {\n      margin: 0;\n      padding: 0;\n      list-style-type: none\n    }\n\n    .layout-reveal .layout-sidebar .layout-menu-container .layout-menu ul a .layout-menuitem-text {\n      order: 1;\n      margin-right: auto\n    }\n\n    .layout-reveal .layout-sidebar .layout-menu-container .layout-menu ul a .layout-submenu-toggler {\n      order: 2;\n      display: none;\n      margin-right: .5rem\n    }\n\n    .layout-reveal .layout-sidebar .layout-menu-container .layout-menu ul a .layout-menuitem-icon {\n      order: 3;\n      margin-right: 0;\n      font-size: 1.25rem;\n      width: auto\n    }\n\n    .layout-reveal .layout-sidebar .layout-menu-profile>ul>li>button {\n      flex-direction: row-reverse\n    }\n\n    .layout-reveal .layout-sidebar .layout-menu-profile>ul>li>button>i {\n      margin-right: 0;\n      margin-left: auto;\n      font-size: 1.25rem;\n      width: auto\n    }\n\n    .layout-reveal .layout-topbar {\n      padding-left: 4.25rem\n    }\n\n    .layout-reveal .layout-topbar .layout-topbar-start {\n      display: none\n    }\n\n    .layout-reveal.layout-reveal .layout-content-wrapper {\n      margin-left: 4.25rem;\n      transition: margin-left .3s cubic-bezier(0,0,.2,1)\n    }\n\n    .layout-reveal.layout-sidebar-active .layout-sidebar {\n      transform: translate(0)\n    }\n\n    .layout-reveal.layout-sidebar-active .layout-sidebar .layout-sidebar-top {\n      padding: 0 1.5rem;\n      justify-content: space-between\n    }\n\n    .layout-reveal.layout-sidebar-active .layout-sidebar .layout-sidebar-top .layout-sidebar-logo {\n      display: inline\n    }\n\n    .layout-reveal.layout-sidebar-active .layout-sidebar .layout-sidebar-top .layout-sidebar-logo-slim {\n      display: none\n    }\n\n    .layout-reveal.layout-sidebar-active .layout-sidebar .layout-sidebar-top .layout-sidebar-anchor {\n      display: block;\n      animation: px-fadein .15s linear\n    }\n\n    .layout-reveal.layout-sidebar-active .layout-sidebar .layout-menu-container {\n      overflow: auto\n    }\n\n    .layout-reveal.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem>.layout-menuitem-root-text>.layout-menuitem-root-icon {\n      display: none\n    }\n\n    .layout-reveal.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul a .layout-submenu-toggler {\n      display: block\n    }\n\n    .layout-reveal.layout-sidebar-anchored .layout-topbar {\n      padding-left: 17rem\n    }\n\n    .layout-reveal.layout-sidebar-anchored .layout-sidebar-top .layout-sidebar-anchor {\n      background-color: var(--topbar-menu-button-bg)\n    }\n\n    .layout-reveal.layout-sidebar-anchored .layout-content-wrapper {\n      margin-left: 17rem\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .layout-drawer .layout-sidebar {\n      height:100%;\n      top: 0;\n      transition: width .3s cubic-bezier(0,0,.2,1);\n      width: 4.25rem;\n      z-index: 999\n    }\n\n    .layout-drawer .layout-sidebar .layout-sidebar-top {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding: 0 .75rem;\n      height: 4rem;\n      background-color: var(--topbar-bg);\n      color: var(--topbar-item-text-color)\n    }\n\n    .layout-drawer .layout-sidebar .layout-sidebar-top .layout-sidebar-logo {\n      display: none;\n      width: 0;\n      transition: width .2s cubic-bezier(0,0,.2,1);\n      transition-delay: .3s\n    }\n\n    .layout-drawer .layout-sidebar .layout-sidebar-top .layout-sidebar-logo-slim {\n      display: inline;\n      order: 1\n    }\n\n    .layout-drawer .layout-sidebar .layout-sidebar-top .layout-sidebar-anchor {\n      display: none;\n      width: 1.25rem;\n      height: 1.25rem;\n      border-radius: 50%;\n      border: 2px solid var(--topbar-menu-button-bg);\n      background-color: transparent;\n      transition: background-color var(--transition-duration),transform .3s\n    }\n\n    .layout-drawer .layout-sidebar .layout-menu-container {\n      overflow: hidden\n    }\n\n    .layout-drawer .layout-sidebar .layout-menu-container .layout-menu {\n      transition: all .4s\n    }\n\n    .layout-drawer .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem>.layout-menuitem-root-text {\n      opacity: 1;\n      white-space: nowrap;\n      display: flex;\n      justify-content: flex-end;\n      height: 2.92rem\n    }\n\n    .layout-drawer .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem>.layout-menuitem-root-text>span {\n      margin-right: auto;\n      opacity: 0;\n      transition: all .1s\n    }\n\n    .layout-drawer .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem>.layout-menuitem-root-text .layout-menuitem-icon {\n      font-size: 1.25rem;\n      width: 1.25rem\n    }\n\n    .layout-drawer .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem>.layout-menuitem-root-text>.layout-menuitem-root-icon {\n      display: block;\n      margin-left: .125rem;\n      font-size: 1.25rem\n    }\n\n    .layout-drawer .layout-sidebar .layout-menu-container .layout-menu ul {\n      margin: 0;\n      padding: 0;\n      list-style-type: none\n    }\n\n    .layout-drawer .layout-sidebar .layout-menu-container .layout-menu ul a span {\n      opacity: 0;\n      white-space: nowrap;\n      transition: all .1s\n    }\n\n    .layout-drawer .layout-sidebar .layout-menu-container .layout-menu ul a .layout-menuitem-icon {\n      font-size: 1.25rem;\n      width: auto\n    }\n\n    .layout-drawer .layout-sidebar .layout-menu-container .layout-menu ul a .layout-submenu-toggler {\n      display: none\n    }\n\n    .layout-drawer .layout-sidebar .layout-menu-container .layout-menu ul ul li a {\n      padding: .75rem 1.5rem\n    }\n\n    .layout-drawer .layout-sidebar .layout-menu-profile>button {\n      padding: .75rem 1rem\n    }\n\n    .layout-drawer .layout-sidebar .layout-menu-profile>button span {\n      opacity: 0;\n      white-space: nowrap;\n      transition: all .1s\n    }\n\n    .layout-drawer .layout-sidebar .layout-menu-profile>ul>li>button>i {\n      margin-right: .5rem;\n      font-size: 1.25rem;\n      width: auto\n    }\n\n    .layout-drawer .layout-topbar {\n      padding-left: 4.25rem\n    }\n\n    .layout-drawer .layout-topbar .layout-topbar-start {\n      display: none\n    }\n\n    .layout-drawer.layout-drawer .layout-content-wrapper {\n      margin-left: 4.25rem;\n      transition: margin-left .3s cubic-bezier(0,0,.2,1);\n      overflow-x: hidden\n    }\n\n    .layout-drawer.layout-sidebar-active .layout-sidebar {\n      width: 17rem\n    }\n\n    .layout-drawer.layout-sidebar-active .layout-sidebar .layout-sidebar-top {\n      padding: 0 1.5rem\n    }\n\n    .layout-drawer.layout-sidebar-active .layout-sidebar .layout-sidebar-top .layout-sidebar-logo {\n      display: inline;\n      width: 100%;\n      transition: width .2s cubic-bezier(0,0,.2,1);\n      transition-delay: .3s\n    }\n\n    .layout-drawer.layout-sidebar-active .layout-sidebar .layout-sidebar-top .layout-sidebar-logo-slim {\n      display: none\n    }\n\n    .layout-drawer.layout-sidebar-active .layout-sidebar .layout-sidebar-top .layout-sidebar-anchor {\n      display: block;\n      animation: px-fadein .15s linear\n    }\n\n    .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container {\n      overflow: auto;\n      overflow-x: hidden\n    }\n\n    .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem>.layout-menuitem-root-text {\n      white-space: nowrap\n    }\n\n    .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem>.layout-menuitem-root-text>.layout-menuitem-root-icon {\n      display: none\n    }\n\n    .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem>.layout-menuitem-root-text>span {\n      margin-right: auto;\n      opacity: 1;\n      transition: all .1s\n    }\n\n    .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul a {\n      width: auto\n    }\n\n    .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul a .layout-submenu-toggler {\n      display: block\n    }\n\n    .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul a span {\n      opacity: 1;\n      white-space: nowrap;\n      transition: all .3s\n    }\n\n    .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul ul {\n      overflow: hidden;\n      border-radius: var(--border-radius)\n    }\n\n    .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul ul li a {\n      padding-left: 2.5rem\n    }\n\n    .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul ul li li a {\n      padding-left: 3rem\n    }\n\n    .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul ul li li li a {\n      padding-left: 3.5rem\n    }\n\n    .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul ul li li li li a {\n      padding-left: 4rem\n    }\n\n    .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul ul li li li li li a {\n      padding-left: 5.5rem\n    }\n\n    .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul ul li li li li li li a {\n      padding-left: 5rem\n    }\n\n    .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-profile>button span {\n      opacity: 1;\n      white-space: nowrap;\n      transition: all .1s\n    }\n\n    .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-profile>ul>li>button>i {\n      margin-right: .5rem;\n      font-size: 1.25rem;\n      width: auto\n    }\n\n    .layout-drawer.layout-sidebar-anchored .layout-topbar {\n      padding-left: 17rem\n    }\n\n    .layout-drawer.layout-sidebar-anchored .layout-sidebar-top .layout-sidebar-anchor {\n      background-color: var(--topbar-menu-button-bg)\n    }\n\n    .layout-drawer.layout-sidebar-anchored .layout-content-wrapper {\n      margin-left: 17rem\n    }\n  }\n\n  .layout-container.layout-menu-profile-active .layout-menu-profile-toggler {\n    transform: rotate(-180deg)\n  }\n\n  .layout-container.layout-menu-profile-end .layout-menu-profile {\n    border-top: 1px solid var(--inline-menu-border-color)\n  }\n\n  .layout-container.layout-menu-profile-start .layout-menu-profile {\n    border-bottom: 1px solid var(--inline-menu-border-color)\n  }\n\n  .layout-menu-profile {\n    width: 100%;\n    background: var(--menu-bg);\n    overflow: hidden;\n    border-bottom: 1px solid var(--surface-border)\n  }\n\n  .layout-menu-profile>button {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    padding: .5rem 1.5rem;\n    color: var(--menuitem-text-color);\n    transition: background-color var(--transition-duration)\n  }\n\n  .layout-menu-profile>button>span {\n    display: flex;\n    flex-direction: column;\n    margin-left: .5rem\n  }\n\n  .layout-menu-profile>button>i {\n    margin-left: auto;\n    transition: transform var(--transition-duration)\n  }\n\n  .layout-menu-profile>button:hover {\n    background-color: var(--menuitem-hover-bg)\n  }\n\n  .layout-menu-profile>ul {\n    list-style-type: none;\n    margin: 0;\n    padding: 0\n  }\n\n  .layout-menu-profile>ul>li>button {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    padding: .75rem 1.5rem;\n    transition: background-color var(--transition-duration),box-shadow var(--transition-duration);\n    color: var(--menuitem-text-color)\n  }\n\n  .layout-menu-profile>ul>li>button>i {\n    margin-right: .5rem;\n    color: var(--menuitem-text-color)\n  }\n\n  .layout-menu-profile>ul>li>button:hover {\n    background-color: var(--menuitem-hover-bg)\n  }\n\n  .layout-megamenu.p-megamenu {\n    border: 0 none;\n    padding: 0\n  }\n\n  .parallax__layer__0 {\n    transform: translateZ(-150px) scale(2.5)\n  }\n\n  .parallax__layer__1 {\n    transform: translateZ(-100px) scale(2)\n  }\n\n  .parallax__layer__2 {\n    transform: translateZ(-50px) scale(1.5)\n  }\n\n  .parallax__layer__3 {\n    transform: translateZ(0) scale(1)\n  }\n\n  html {\n    height: 100%;\n    font-size: 14px\n  }\n\n  body {\n    font-weight: 400;\n    padding: 0;\n    margin: 0;\n    min-height: 100%;\n    background: var(--surface-ground);\n    color: var(--text-color);\n    font-family: var(--font-family);\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale\n  }\n\n  a {\n    text-decoration: none\n  }\n\n  .p-toast.p-toast-top-right,.p-toast.p-toast-top-left,.p-toast.p-toast-top-center {\n    top: 85px\n  }\n\n  .layout-content-wrapper {\n    padding-top: 4rem;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column\n  }\n\n  .layout-content-wrapper .layout-content {\n    flex: 1 1 auto;\n    padding: 2rem\n  }\n\n  .layout-footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 1.5rem;\n    background-color: var(--surface-card)\n  }\n\n  .layout-config-button.p-button {\n    z-index: 999;\n    position: fixed;\n    top: 50%;\n    right: 0;\n    width: auto;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    padding: .5rem\n  }\n\n  .layout-config-button.p-button .p-button-icon {\n    font-size: 2rem\n  }\n\n  .layout-breadcrumb-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid var(--surface-border);\n    padding: .5rem 2rem;\n    background-color: var(--surface-card)\n  }\n\n  .layout-breadcrumb-container .layout-breadcrumb ol {\n    display: flex;\n    align-items: center;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    gap: .5rem;\n    flex-wrap: wrap;\n    color: var(--text-color-secondary)\n  }\n\n  .layout-breadcrumb-container .layout-breadcrumb ol li {\n    display: flex;\n    align-items: center\n  }\n\n  .layout-breadcrumb-container .layout-breadcrumb-buttons {\n    display: flex;\n    align-items: center;\n    gap: .25rem\n  }\n\n  .layout-breadcrumb-container .layout-breadcrumb-buttons button {\n    flex-shrink: 0\n  }\n\n  @media screen and (min-width: 992px) {\n    .layout-container.layout-static .layout-sidebar {\n      transition:transform .3s cubic-bezier(0,0,.2,1)\n    }\n\n    .layout-container.layout-static .layout-content-wrapper {\n      margin-left: 17rem;\n      transition: margin-left .3s cubic-bezier(0,0,.2,1)\n    }\n\n    .layout-container.layout-static .layout-topbar .layout-menu-button i {\n      transform: rotate(180deg)\n    }\n\n    .layout-container.layout-static-inactive .layout-sidebar {\n      transform: translate(-100%)\n    }\n\n    .layout-container.layout-static-inactive .layout-content-wrapper {\n      margin-left: 0\n    }\n\n    .layout-container.layout-static-inactive .layout-topbar .layout-menu-button i {\n      transform: rotate(0)\n    }\n\n    .layout-container.layout-overlay .layout-content-wrapper {\n      margin-left: 0\n    }\n\n    .layout-container.layout-overlay .layout-sidebar {\n      z-index: 999;\n      transform: translate(-100%);\n      transition: transform .3s cubic-bezier(0,0,.2,1)\n    }\n\n    .layout-container.layout-overlay.layout-overlay-active .layout-sidebar {\n      transform: translate(0)\n    }\n\n    .layout-container.layout-overlay.layout-overlay-active .layout-topbar .layout-menu-button i {\n      transform: rotate(180deg)\n    }\n  }\n\n  @media screen and (max-width: 991px) {\n    .blocked-scroll {\n      overflow:hidden\n    }\n\n    .layout-container .layout-content-wrapper {\n      margin-left: 0\n    }\n\n    .layout-container .layout-sidebar {\n      z-index: 999;\n      transform: translate(-100%);\n      transition: transform .3s cubic-bezier(0,0,.2,1)\n    }\n\n    .layout-container.layout-mobile-active .layout-sidebar {\n      transform: translate(0)\n    }\n\n    .layout-container.layout-mobile-active .layout-mask {\n      display: block;\n      animation: px-mask-in .3s cubic-bezier(0,0,.2,1)\n    }\n\n    .layout-container.layout-mobile-active .layout-topbar .layout-menu-button i {\n      transform: rotate(180deg)\n    }\n\n    .layout-container .layout-mask {\n      display: none;\n      position: fixed;\n      top: 0;\n      left: 0;\n      z-index: 998;\n      width: 100%;\n      height: 100%;\n      background-color: var(--maskbg)\n    }\n\n    .layout-container.layout-topbar-menu-active .layout-topbar .layout-topbar-end {\n      display: flex;\n      flex-direction: column-reverse;\n      align-items: stretch;\n      position: fixed;\n      top: 4rem;\n      width: 100%;\n      background-color: var(--topbar-bg);\n      padding-left: 0\n    }\n\n    .layout-container.layout-topbar-menu-active .layout-topbar .layout-topbar-end .layout-megamenu {\n      height: 3rem\n    }\n\n    .layout-container.layout-topbar-menu-active .layout-topbar .layout-topbar-end .layout-megamenu.p-megamenu .p-megamenu-root-list>.p-menuitem {\n      position: static\n    }\n\n    .layout-container.layout-topbar-menu-active .layout-topbar .layout-topbar-end .layout-megamenu.p-megamenu .p-megamenu-root-list>.p-menuitem .p-megamenu-panel {\n      position: absolute;\n      left: 1rem;\n      right: 1rem;\n      max-height: 20rem;\n      overflow: auto\n    }\n\n    .layout-container.layout-topbar-menu-active .layout-topbar .layout-topbar-end .layout-megamenu.p-megamenu .p-megamenu-root-list>.p-menuitem .p-megamenu-grid {\n      flex-direction: column\n    }\n\n    .layout-container.layout-topbar-menu-active .layout-topbar .layout-topbar-end .layout-topbar-items {\n      justify-content: space-between;\n      align-items: center;\n      height: 4rem;\n      padding: 0 1rem\n    }\n\n    .layout-container.layout-topbar-menu-active .layout-topbar .layout-topbar-end .layout-topbar-items>li {\n      position: static\n    }\n\n    .layout-container.layout-topbar-menu-active .layout-topbar .layout-topbar-end .layout-topbar-items>li>div {\n      left: 1rem;\n      right: 1rem\n    }\n\n    .layout-container.layout-topbar-menu-active .layout-topbar .layout-topbar-end .layout-topbar-items .layout-topbar-search {\n      position: relative\n    }\n\n    .layout-container.layout-topbar-menu-active .layout-topbar .layout-topbar-actions-start {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      height: 3rem\n    }\n\n    .layout-topbar {\n      display: flex;\n      flex-direction: column\n    }\n\n    .layout-topbar .layout-topbar-start {\n      padding: 0 1rem;\n      width: 100%;\n      height: 4rem;\n      justify-content: flex-start\n    }\n\n    .layout-topbar .layout-topbar-start .layout-menu-button {\n      position: relative;\n      margin-top: 0;\n      margin-left: 1rem;\n      top: auto\n    }\n\n    .layout-topbar .layout-topbar-start .layout-topbar-mobile-button {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-left: auto;\n      transition: background-color var(--transition-duration)\n    }\n\n    .layout-topbar .layout-topbar-start .layout-topbar-mobile-button:hover {\n      background-color: var(--topbar-bg)\n    }\n\n    .layout-topbar .layout-topbar-end {\n      display: none\n    }\n  }\n\n  @media screen and (min-width: 1729px) {\n    .layout-content {\n      width:1504px;\n      margin-left: auto!important;\n      margin-right: auto!important\n    }\n  }\n\n  .grid {\n    display: flex;\n    flex-wrap: wrap;\n    margin-right: -1rem;\n    margin-left: -1rem;\n    margin-top: -1rem\n  }\n\n  .grid>.col,.grid>[class*=col] {\n    box-sizing: border-box\n  }\n\n  .grid-nogutter {\n    margin-right: 0;\n    margin-left: 0;\n    margin-top: 0\n  }\n\n  .grid-nogutter>.col,.grid-nogutter>[class*=col-] {\n    padding: 0\n  }\n\n  .col {\n    flex-grow: 1;\n    flex-basis: 0;\n    padding: 1rem\n  }\n\n  .col-fixed {\n    flex: 0 0 auto;\n    padding: 1rem\n  }\n\n  .col-1 {\n    flex: 0 0 auto;\n    padding: 1rem;\n    width: 8.3333%\n  }\n\n  .col-2 {\n    flex: 0 0 auto;\n    padding: 1rem;\n    width: 16.6667%\n  }\n\n  .col-3 {\n    flex: 0 0 auto;\n    padding: 1rem;\n    width: 25%\n  }\n\n  .col-4 {\n    flex: 0 0 auto;\n    padding: 1rem;\n    width: 33.3333%\n  }\n\n  .col-5 {\n    flex: 0 0 auto;\n    padding: 1rem;\n    width: 41.6667%\n  }\n\n  .col-6 {\n    flex: 0 0 auto;\n    padding: 1rem;\n    width: 50%\n  }\n\n  .col-7 {\n    flex: 0 0 auto;\n    padding: 1rem;\n    width: 58.3333%\n  }\n\n  .col-8 {\n    flex: 0 0 auto;\n    padding: 1rem;\n    width: 66.6667%\n  }\n\n  .col-9 {\n    flex: 0 0 auto;\n    padding: 1rem;\n    width: 75%\n  }\n\n  .col-10 {\n    flex: 0 0 auto;\n    padding: 1rem;\n    width: 83.3333%\n  }\n\n  .col-11 {\n    flex: 0 0 auto;\n    padding: 1rem;\n    width: 91.6667%\n  }\n\n  .col-12 {\n    flex: 0 0 auto;\n    width: 100%\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:col {\n      flex-grow:1;\n      flex-basis: 0;\n      padding: 1rem\n    }\n\n    .sm\\:col-fixed {\n      flex: 0 0 auto;\n      padding: 1rem\n    }\n\n    .sm\\:col-1 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 8.3333%\n    }\n\n    .sm\\:col-2 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 16.6667%\n    }\n\n    .sm\\:col-3 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 25%\n    }\n\n    .sm\\:col-4 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 33.3333%\n    }\n\n    .sm\\:col-5 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 41.6667%\n    }\n\n    .sm\\:col-6 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 50%\n    }\n\n    .sm\\:col-7 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 58.3333%\n    }\n\n    .sm\\:col-8 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 66.6667%\n    }\n\n    .sm\\:col-9 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 75%\n    }\n\n    .sm\\:col-10 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 83.3333%\n    }\n\n    .sm\\:col-11 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 91.6667%\n    }\n\n    .sm\\:col-12 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 100%\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:col {\n      flex-grow:1;\n      flex-basis: 0;\n      padding: 1rem\n    }\n\n    .md\\:col-fixed {\n      flex: 0 0 auto;\n      padding: 1rem\n    }\n\n    .md\\:col-1 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 8.3333%\n    }\n\n    .md\\:col-2 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 16.6667%\n    }\n\n    .md\\:col-3 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 25%\n    }\n\n    .md\\:col-4 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 33.3333%\n    }\n\n    .md\\:col-5 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 41.6667%\n    }\n\n    .md\\:col-6 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 50%\n    }\n\n    .md\\:col-7 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 58.3333%\n    }\n\n    .md\\:col-8 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 66.6667%\n    }\n\n    .md\\:col-9 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 75%\n    }\n\n    .md\\:col-10 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 83.3333%\n    }\n\n    .md\\:col-11 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 91.6667%\n    }\n\n    .md\\:col-12 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 100%\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:col {\n      flex-grow:1;\n      flex-basis: 0;\n      padding: 1rem\n    }\n\n    .lg\\:col-fixed {\n      flex: 0 0 auto;\n      padding: 1rem\n    }\n\n    .lg\\:col-1 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 8.3333%\n    }\n\n    .lg\\:col-2 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 16.6667%\n    }\n\n    .lg\\:col-3 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 25%\n    }\n\n    .lg\\:col-4 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 33.3333%\n    }\n\n    .lg\\:col-5 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 41.6667%\n    }\n\n    .lg\\:col-6 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 50%\n    }\n\n    .lg\\:col-7 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 58.3333%\n    }\n\n    .lg\\:col-8 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 66.6667%\n    }\n\n    .lg\\:col-9 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 75%\n    }\n\n    .lg\\:col-10 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 83.3333%\n    }\n\n    .lg\\:col-11 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 91.6667%\n    }\n\n    .lg\\:col-12 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 100%\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:col {\n      flex-grow:1;\n      flex-basis: 0;\n      padding: 1rem\n    }\n\n    .xl\\:col-fixed {\n      flex: 0 0 auto;\n      padding: 1rem\n    }\n\n    .xl\\:col-1 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 8.3333%\n    }\n\n    .xl\\:col-2 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 16.6667%\n    }\n\n    .xl\\:col-3 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 25%\n    }\n\n    .xl\\:col-4 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 33.3333%\n    }\n\n    .xl\\:col-5 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 41.6667%\n    }\n\n    .xl\\:col-6 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 50%\n    }\n\n    .xl\\:col-7 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 58.3333%\n    }\n\n    .xl\\:col-8 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 66.6667%\n    }\n\n    .xl\\:col-9 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 75%\n    }\n\n    .xl\\:col-10 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 83.3333%\n    }\n\n    .xl\\:col-11 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 91.6667%\n    }\n\n    .xl\\:col-12 {\n      flex: 0 0 auto;\n      padding: 1rem;\n      width: 100%\n    }\n  }\n\n  .col-offset-0 {\n    margin-left: 0!important\n  }\n\n  .col-offset-1 {\n    margin-left: 8.3333%!important\n  }\n\n  .col-offset-2 {\n    margin-left: 16.6667%!important\n  }\n\n  .col-offset-3 {\n    margin-left: 25%!important\n  }\n\n  .col-offset-4 {\n    margin-left: 33.3333%!important\n  }\n\n  .col-offset-5 {\n    margin-left: 41.6667%!important\n  }\n\n  .col-offset-6 {\n    margin-left: 50%!important\n  }\n\n  .col-offset-7 {\n    margin-left: 58.3333%!important\n  }\n\n  .col-offset-8 {\n    margin-left: 66.6667%!important\n  }\n\n  .col-offset-9 {\n    margin-left: 75%!important\n  }\n\n  .col-offset-10 {\n    margin-left: 83.3333%!important\n  }\n\n  .col-offset-11 {\n    margin-left: 91.6667%!important\n  }\n\n  .col-offset-12 {\n    margin-left: 100%!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:col-offset-0 {\n      margin-left:0!important\n    }\n\n    .sm\\:col-offset-1 {\n      margin-left: 8.3333%!important\n    }\n\n    .sm\\:col-offset-2 {\n      margin-left: 16.6667%!important\n    }\n\n    .sm\\:col-offset-3 {\n      margin-left: 25%!important\n    }\n\n    .sm\\:col-offset-4 {\n      margin-left: 33.3333%!important\n    }\n\n    .sm\\:col-offset-5 {\n      margin-left: 41.6667%!important\n    }\n\n    .sm\\:col-offset-6 {\n      margin-left: 50%!important\n    }\n\n    .sm\\:col-offset-7 {\n      margin-left: 58.3333%!important\n    }\n\n    .sm\\:col-offset-8 {\n      margin-left: 66.6667%!important\n    }\n\n    .sm\\:col-offset-9 {\n      margin-left: 75%!important\n    }\n\n    .sm\\:col-offset-10 {\n      margin-left: 83.3333%!important\n    }\n\n    .sm\\:col-offset-11 {\n      margin-left: 91.6667%!important\n    }\n\n    .sm\\:col-offset-12 {\n      margin-left: 100%!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:col-offset-0 {\n      margin-left:0!important\n    }\n\n    .md\\:col-offset-1 {\n      margin-left: 8.3333%!important\n    }\n\n    .md\\:col-offset-2 {\n      margin-left: 16.6667%!important\n    }\n\n    .md\\:col-offset-3 {\n      margin-left: 25%!important\n    }\n\n    .md\\:col-offset-4 {\n      margin-left: 33.3333%!important\n    }\n\n    .md\\:col-offset-5 {\n      margin-left: 41.6667%!important\n    }\n\n    .md\\:col-offset-6 {\n      margin-left: 50%!important\n    }\n\n    .md\\:col-offset-7 {\n      margin-left: 58.3333%!important\n    }\n\n    .md\\:col-offset-8 {\n      margin-left: 66.6667%!important\n    }\n\n    .md\\:col-offset-9 {\n      margin-left: 75%!important\n    }\n\n    .md\\:col-offset-10 {\n      margin-left: 83.3333%!important\n    }\n\n    .md\\:col-offset-11 {\n      margin-left: 91.6667%!important\n    }\n\n    .md\\:col-offset-12 {\n      margin-left: 100%!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:col-offset-0 {\n      margin-left:0!important\n    }\n\n    .lg\\:col-offset-1 {\n      margin-left: 8.3333%!important\n    }\n\n    .lg\\:col-offset-2 {\n      margin-left: 16.6667%!important\n    }\n\n    .lg\\:col-offset-3 {\n      margin-left: 25%!important\n    }\n\n    .lg\\:col-offset-4 {\n      margin-left: 33.3333%!important\n    }\n\n    .lg\\:col-offset-5 {\n      margin-left: 41.6667%!important\n    }\n\n    .lg\\:col-offset-6 {\n      margin-left: 50%!important\n    }\n\n    .lg\\:col-offset-7 {\n      margin-left: 58.3333%!important\n    }\n\n    .lg\\:col-offset-8 {\n      margin-left: 66.6667%!important\n    }\n\n    .lg\\:col-offset-9 {\n      margin-left: 75%!important\n    }\n\n    .lg\\:col-offset-10 {\n      margin-left: 83.3333%!important\n    }\n\n    .lg\\:col-offset-11 {\n      margin-left: 91.6667%!important\n    }\n\n    .lg\\:col-offset-12 {\n      margin-left: 100%!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:col-offset-0 {\n      margin-left:0!important\n    }\n\n    .xl\\:col-offset-1 {\n      margin-left: 8.3333%!important\n    }\n\n    .xl\\:col-offset-2 {\n      margin-left: 16.6667%!important\n    }\n\n    .xl\\:col-offset-3 {\n      margin-left: 25%!important\n    }\n\n    .xl\\:col-offset-4 {\n      margin-left: 33.3333%!important\n    }\n\n    .xl\\:col-offset-5 {\n      margin-left: 41.6667%!important\n    }\n\n    .xl\\:col-offset-6 {\n      margin-left: 50%!important\n    }\n\n    .xl\\:col-offset-7 {\n      margin-left: 58.3333%!important\n    }\n\n    .xl\\:col-offset-8 {\n      margin-left: 66.6667%!important\n    }\n\n    .xl\\:col-offset-9 {\n      margin-left: 75%!important\n    }\n\n    .xl\\:col-offset-10 {\n      margin-left: 83.3333%!important\n    }\n\n    .xl\\:col-offset-11 {\n      margin-left: 91.6667%!important\n    }\n\n    .xl\\:col-offset-12 {\n      margin-left: 100%!important\n    }\n  }\n\n  .text-0 {\n    color: var(--surface-0)!important\n  }\n\n  .text-50 {\n    color: var(--surface-50)!important\n  }\n\n  .text-100 {\n    color: var(--surface-100)!important\n  }\n\n  .text-200 {\n    color: var(--surface-200)!important\n  }\n\n  .text-300 {\n    color: var(--surface-300)!important\n  }\n\n  .text-400 {\n    color: var(--surface-400)!important\n  }\n\n  .text-500 {\n    color: var(--surface-500)!important\n  }\n\n  .text-600 {\n    color: var(--surface-600)!important\n  }\n\n  .text-700 {\n    color: var(--surface-700)!important\n  }\n\n  .text-800 {\n    color: var(--surface-800)!important\n  }\n\n  .text-900 {\n    color: var(--surface-900)!important\n  }\n\n  .focus\\:text-0:focus {\n    color: var(--surface-0)!important\n  }\n\n  .hover\\:text-0:hover,.active\\:text-0:active {\n    color: var(--surface-0)!important\n  }\n\n  .focus\\:text-50:focus {\n    color: var(--surface-50)!important\n  }\n\n  .hover\\:text-50:hover,.active\\:text-50:active {\n    color: var(--surface-50)!important\n  }\n\n  .focus\\:text-100:focus {\n    color: var(--surface-100)!important\n  }\n\n  .hover\\:text-100:hover,.active\\:text-100:active {\n    color: var(--surface-100)!important\n  }\n\n  .focus\\:text-200:focus {\n    color: var(--surface-200)!important\n  }\n\n  .hover\\:text-200:hover,.active\\:text-200:active {\n    color: var(--surface-200)!important\n  }\n\n  .focus\\:text-300:focus {\n    color: var(--surface-300)!important\n  }\n\n  .hover\\:text-300:hover,.active\\:text-300:active {\n    color: var(--surface-300)!important\n  }\n\n  .focus\\:text-400:focus {\n    color: var(--surface-400)!important\n  }\n\n  .hover\\:text-400:hover,.active\\:text-400:active {\n    color: var(--surface-400)!important\n  }\n\n  .focus\\:text-500:focus {\n    color: var(--surface-500)!important\n  }\n\n  .hover\\:text-500:hover,.active\\:text-500:active {\n    color: var(--surface-500)!important\n  }\n\n  .focus\\:text-600:focus {\n    color: var(--surface-600)!important\n  }\n\n  .hover\\:text-600:hover,.active\\:text-600:active {\n    color: var(--surface-600)!important\n  }\n\n  .focus\\:text-700:focus {\n    color: var(--surface-700)!important\n  }\n\n  .hover\\:text-700:hover,.active\\:text-700:active {\n    color: var(--surface-700)!important\n  }\n\n  .focus\\:text-800:focus {\n    color: var(--surface-800)!important\n  }\n\n  .hover\\:text-800:hover,.active\\:text-800:active {\n    color: var(--surface-800)!important\n  }\n\n  .focus\\:text-900:focus {\n    color: var(--surface-900)!important\n  }\n\n  .hover\\:text-900:hover,.active\\:text-900:active {\n    color: var(--surface-900)!important\n  }\n\n  .surface-0 {\n    background-color: var(--surface-0)!important\n  }\n\n  .surface-50 {\n    background-color: var(--surface-50)!important\n  }\n\n  .surface-100 {\n    background-color: var(--surface-100)!important\n  }\n\n  .surface-200 {\n    background-color: var(--surface-200)!important\n  }\n\n  .surface-300 {\n    background-color: var(--surface-300)!important\n  }\n\n  .surface-400 {\n    background-color: var(--surface-400)!important\n  }\n\n  .surface-500 {\n    background-color: var(--surface-500)!important\n  }\n\n  .surface-600 {\n    background-color: var(--surface-600)!important\n  }\n\n  .surface-700 {\n    background-color: var(--surface-700)!important\n  }\n\n  .surface-800 {\n    background-color: var(--surface-800)!important\n  }\n\n  .surface-900 {\n    background-color: var(--surface-900)!important\n  }\n\n  .focus\\:surface-0:focus {\n    background-color: var(--surface-0)!important\n  }\n\n  .hover\\:surface-0:hover,.active\\:surface-0:active {\n    background-color: var(--surface-0)!important\n  }\n\n  .focus\\:surface-50:focus {\n    background-color: var(--surface-50)!important\n  }\n\n  .hover\\:surface-50:hover,.active\\:surface-50:active {\n    background-color: var(--surface-50)!important\n  }\n\n  .focus\\:surface-100:focus {\n    background-color: var(--surface-100)!important\n  }\n\n  .hover\\:surface-100:hover,.active\\:surface-100:active {\n    background-color: var(--surface-100)!important\n  }\n\n  .focus\\:surface-200:focus {\n    background-color: var(--surface-200)!important\n  }\n\n  .hover\\:surface-200:hover,.active\\:surface-200:active {\n    background-color: var(--surface-200)!important\n  }\n\n  .focus\\:surface-300:focus {\n    background-color: var(--surface-300)!important\n  }\n\n  .hover\\:surface-300:hover,.active\\:surface-300:active {\n    background-color: var(--surface-300)!important\n  }\n\n  .focus\\:surface-400:focus {\n    background-color: var(--surface-400)!important\n  }\n\n  .hover\\:surface-400:hover,.active\\:surface-400:active {\n    background-color: var(--surface-400)!important\n  }\n\n  .focus\\:surface-500:focus {\n    background-color: var(--surface-500)!important\n  }\n\n  .hover\\:surface-500:hover,.active\\:surface-500:active {\n    background-color: var(--surface-500)!important\n  }\n\n  .focus\\:surface-600:focus {\n    background-color: var(--surface-600)!important\n  }\n\n  .hover\\:surface-600:hover,.active\\:surface-600:active {\n    background-color: var(--surface-600)!important\n  }\n\n  .focus\\:surface-700:focus {\n    background-color: var(--surface-700)!important\n  }\n\n  .hover\\:surface-700:hover,.active\\:surface-700:active {\n    background-color: var(--surface-700)!important\n  }\n\n  .focus\\:surface-800:focus {\n    background-color: var(--surface-800)!important\n  }\n\n  .hover\\:surface-800:hover,.active\\:surface-800:active {\n    background-color: var(--surface-800)!important\n  }\n\n  .focus\\:surface-900:focus {\n    background-color: var(--surface-900)!important\n  }\n\n  .hover\\:surface-900:hover,.active\\:surface-900:active {\n    background-color: var(--surface-900)!important\n  }\n\n  .border-0 {\n    border-color: var(--surface-0)!important\n  }\n\n  .border-50 {\n    border-color: var(--surface-50)!important\n  }\n\n  .border-100 {\n    border-color: var(--surface-100)!important\n  }\n\n  .border-200 {\n    border-color: var(--surface-200)!important\n  }\n\n  .border-300 {\n    border-color: var(--surface-300)!important\n  }\n\n  .border-400 {\n    border-color: var(--surface-400)!important\n  }\n\n  .border-500 {\n    border-color: var(--surface-500)!important\n  }\n\n  .border-600 {\n    border-color: var(--surface-600)!important\n  }\n\n  .border-700 {\n    border-color: var(--surface-700)!important\n  }\n\n  .border-800 {\n    border-color: var(--surface-800)!important\n  }\n\n  .border-900 {\n    border-color: var(--surface-900)!important\n  }\n\n  .focus\\:border-0:focus {\n    border-color: var(--surface-0)!important\n  }\n\n  .hover\\:border-0:hover,.active\\:border-0:active {\n    border-color: var(--surface-0)!important\n  }\n\n  .focus\\:border-50:focus {\n    border-color: var(--surface-50)!important\n  }\n\n  .hover\\:border-50:hover,.active\\:border-50:active {\n    border-color: var(--surface-50)!important\n  }\n\n  .focus\\:border-100:focus {\n    border-color: var(--surface-100)!important\n  }\n\n  .hover\\:border-100:hover,.active\\:border-100:active {\n    border-color: var(--surface-100)!important\n  }\n\n  .focus\\:border-200:focus {\n    border-color: var(--surface-200)!important\n  }\n\n  .hover\\:border-200:hover,.active\\:border-200:active {\n    border-color: var(--surface-200)!important\n  }\n\n  .focus\\:border-300:focus {\n    border-color: var(--surface-300)!important\n  }\n\n  .hover\\:border-300:hover,.active\\:border-300:active {\n    border-color: var(--surface-300)!important\n  }\n\n  .focus\\:border-400:focus {\n    border-color: var(--surface-400)!important\n  }\n\n  .hover\\:border-400:hover,.active\\:border-400:active {\n    border-color: var(--surface-400)!important\n  }\n\n  .focus\\:border-500:focus {\n    border-color: var(--surface-500)!important\n  }\n\n  .hover\\:border-500:hover,.active\\:border-500:active {\n    border-color: var(--surface-500)!important\n  }\n\n  .focus\\:border-600:focus {\n    border-color: var(--surface-600)!important\n  }\n\n  .hover\\:border-600:hover,.active\\:border-600:active {\n    border-color: var(--surface-600)!important\n  }\n\n  .focus\\:border-700:focus {\n    border-color: var(--surface-700)!important\n  }\n\n  .hover\\:border-700:hover,.active\\:border-700:active {\n    border-color: var(--surface-700)!important\n  }\n\n  .focus\\:border-800:focus {\n    border-color: var(--surface-800)!important\n  }\n\n  .hover\\:border-800:hover,.active\\:border-800:active {\n    border-color: var(--surface-800)!important\n  }\n\n  .focus\\:border-900:focus {\n    border-color: var(--surface-900)!important\n  }\n\n  .hover\\:border-900:hover,.active\\:border-900:active {\n    border-color: var(--surface-900)!important\n  }\n\n  .bg-transparent {\n    background-color: transparent!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:bg-transparent {\n      background-color:transparent!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:bg-transparent {\n      background-color:transparent!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:bg-transparent {\n      background-color:transparent!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:bg-transparent {\n      background-color:transparent!important\n    }\n  }\n\n  .border-transparent {\n    border-color: transparent!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:border-transparent {\n      border-color:transparent!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:border-transparent {\n      border-color:transparent!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:border-transparent {\n      border-color:transparent!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:border-transparent {\n      border-color:transparent!important\n    }\n  }\n\n  .text-blue-50 {\n    color: var(--blue-50)!important\n  }\n\n  .text-blue-100 {\n    color: var(--blue-100)!important\n  }\n\n  .text-blue-200 {\n    color: var(--blue-200)!important\n  }\n\n  .text-blue-300 {\n    color: var(--blue-300)!important\n  }\n\n  .text-blue-400 {\n    color: var(--blue-400)!important\n  }\n\n  .text-blue-500 {\n    color: var(--blue-500)!important\n  }\n\n  .text-blue-600 {\n    color: var(--blue-600)!important\n  }\n\n  .text-blue-700 {\n    color: var(--blue-700)!important\n  }\n\n  .text-blue-800 {\n    color: var(--blue-800)!important\n  }\n\n  .text-blue-900 {\n    color: var(--blue-900)!important\n  }\n\n  .focus\\:text-blue-50:focus {\n    color: var(--blue-50)!important\n  }\n\n  .focus\\:text-blue-100:focus {\n    color: var(--blue-100)!important\n  }\n\n  .focus\\:text-blue-200:focus {\n    color: var(--blue-200)!important\n  }\n\n  .focus\\:text-blue-300:focus {\n    color: var(--blue-300)!important\n  }\n\n  .focus\\:text-blue-400:focus {\n    color: var(--blue-400)!important\n  }\n\n  .focus\\:text-blue-500:focus {\n    color: var(--blue-500)!important\n  }\n\n  .focus\\:text-blue-600:focus {\n    color: var(--blue-600)!important\n  }\n\n  .focus\\:text-blue-700:focus {\n    color: var(--blue-700)!important\n  }\n\n  .focus\\:text-blue-800:focus {\n    color: var(--blue-800)!important\n  }\n\n  .focus\\:text-blue-900:focus {\n    color: var(--blue-900)!important\n  }\n\n  .hover\\:text-blue-50:hover {\n    color: var(--blue-50)!important\n  }\n\n  .hover\\:text-blue-100:hover {\n    color: var(--blue-100)!important\n  }\n\n  .hover\\:text-blue-200:hover {\n    color: var(--blue-200)!important\n  }\n\n  .hover\\:text-blue-300:hover {\n    color: var(--blue-300)!important\n  }\n\n  .hover\\:text-blue-400:hover {\n    color: var(--blue-400)!important\n  }\n\n  .hover\\:text-blue-500:hover {\n    color: var(--blue-500)!important\n  }\n\n  .hover\\:text-blue-600:hover {\n    color: var(--blue-600)!important\n  }\n\n  .hover\\:text-blue-700:hover {\n    color: var(--blue-700)!important\n  }\n\n  .hover\\:text-blue-800:hover {\n    color: var(--blue-800)!important\n  }\n\n  .hover\\:text-blue-900:hover {\n    color: var(--blue-900)!important\n  }\n\n  .active\\:text-blue-50:active {\n    color: var(--blue-50)!important\n  }\n\n  .active\\:text-blue-100:active {\n    color: var(--blue-100)!important\n  }\n\n  .active\\:text-blue-200:active {\n    color: var(--blue-200)!important\n  }\n\n  .active\\:text-blue-300:active {\n    color: var(--blue-300)!important\n  }\n\n  .active\\:text-blue-400:active {\n    color: var(--blue-400)!important\n  }\n\n  .active\\:text-blue-500:active {\n    color: var(--blue-500)!important\n  }\n\n  .active\\:text-blue-600:active {\n    color: var(--blue-600)!important\n  }\n\n  .active\\:text-blue-700:active {\n    color: var(--blue-700)!important\n  }\n\n  .active\\:text-blue-800:active {\n    color: var(--blue-800)!important\n  }\n\n  .active\\:text-blue-900:active {\n    color: var(--blue-900)!important\n  }\n\n  .text-green-50 {\n    color: var(--green-50)!important\n  }\n\n  .text-green-100 {\n    color: var(--green-100)!important\n  }\n\n  .text-green-200 {\n    color: var(--green-200)!important\n  }\n\n  .text-green-300 {\n    color: var(--green-300)!important\n  }\n\n  .text-green-400 {\n    color: var(--green-400)!important\n  }\n\n  .text-green-500 {\n    color: var(--green-500)!important\n  }\n\n  .text-green-600 {\n    color: var(--green-600)!important\n  }\n\n  .text-green-700 {\n    color: var(--green-700)!important\n  }\n\n  .text-green-800 {\n    color: var(--green-800)!important\n  }\n\n  .text-green-900 {\n    color: var(--green-900)!important\n  }\n\n  .focus\\:text-green-50:focus {\n    color: var(--green-50)!important\n  }\n\n  .focus\\:text-green-100:focus {\n    color: var(--green-100)!important\n  }\n\n  .focus\\:text-green-200:focus {\n    color: var(--green-200)!important\n  }\n\n  .focus\\:text-green-300:focus {\n    color: var(--green-300)!important\n  }\n\n  .focus\\:text-green-400:focus {\n    color: var(--green-400)!important\n  }\n\n  .focus\\:text-green-500:focus {\n    color: var(--green-500)!important\n  }\n\n  .focus\\:text-green-600:focus {\n    color: var(--green-600)!important\n  }\n\n  .focus\\:text-green-700:focus {\n    color: var(--green-700)!important\n  }\n\n  .focus\\:text-green-800:focus {\n    color: var(--green-800)!important\n  }\n\n  .focus\\:text-green-900:focus {\n    color: var(--green-900)!important\n  }\n\n  .hover\\:text-green-50:hover {\n    color: var(--green-50)!important\n  }\n\n  .hover\\:text-green-100:hover {\n    color: var(--green-100)!important\n  }\n\n  .hover\\:text-green-200:hover {\n    color: var(--green-200)!important\n  }\n\n  .hover\\:text-green-300:hover {\n    color: var(--green-300)!important\n  }\n\n  .hover\\:text-green-400:hover {\n    color: var(--green-400)!important\n  }\n\n  .hover\\:text-green-500:hover {\n    color: var(--green-500)!important\n  }\n\n  .hover\\:text-green-600:hover {\n    color: var(--green-600)!important\n  }\n\n  .hover\\:text-green-700:hover {\n    color: var(--green-700)!important\n  }\n\n  .hover\\:text-green-800:hover {\n    color: var(--green-800)!important\n  }\n\n  .hover\\:text-green-900:hover {\n    color: var(--green-900)!important\n  }\n\n  .active\\:text-green-50:active {\n    color: var(--green-50)!important\n  }\n\n  .active\\:text-green-100:active {\n    color: var(--green-100)!important\n  }\n\n  .active\\:text-green-200:active {\n    color: var(--green-200)!important\n  }\n\n  .active\\:text-green-300:active {\n    color: var(--green-300)!important\n  }\n\n  .active\\:text-green-400:active {\n    color: var(--green-400)!important\n  }\n\n  .active\\:text-green-500:active {\n    color: var(--green-500)!important\n  }\n\n  .active\\:text-green-600:active {\n    color: var(--green-600)!important\n  }\n\n  .active\\:text-green-700:active {\n    color: var(--green-700)!important\n  }\n\n  .active\\:text-green-800:active {\n    color: var(--green-800)!important\n  }\n\n  .active\\:text-green-900:active {\n    color: var(--green-900)!important\n  }\n\n  .text-yellow-50 {\n    color: var(--yellow-50)!important\n  }\n\n  .text-yellow-100 {\n    color: var(--yellow-100)!important\n  }\n\n  .text-yellow-200 {\n    color: var(--yellow-200)!important\n  }\n\n  .text-yellow-300 {\n    color: var(--yellow-300)!important\n  }\n\n  .text-yellow-400 {\n    color: var(--yellow-400)!important\n  }\n\n  .text-yellow-500 {\n    color: var(--yellow-500)!important\n  }\n\n  .text-yellow-600 {\n    color: var(--yellow-600)!important\n  }\n\n  .text-yellow-700 {\n    color: var(--yellow-700)!important\n  }\n\n  .text-yellow-800 {\n    color: var(--yellow-800)!important\n  }\n\n  .text-yellow-900 {\n    color: var(--yellow-900)!important\n  }\n\n  .focus\\:text-yellow-50:focus {\n    color: var(--yellow-50)!important\n  }\n\n  .focus\\:text-yellow-100:focus {\n    color: var(--yellow-100)!important\n  }\n\n  .focus\\:text-yellow-200:focus {\n    color: var(--yellow-200)!important\n  }\n\n  .focus\\:text-yellow-300:focus {\n    color: var(--yellow-300)!important\n  }\n\n  .focus\\:text-yellow-400:focus {\n    color: var(--yellow-400)!important\n  }\n\n  .focus\\:text-yellow-500:focus {\n    color: var(--yellow-500)!important\n  }\n\n  .focus\\:text-yellow-600:focus {\n    color: var(--yellow-600)!important\n  }\n\n  .focus\\:text-yellow-700:focus {\n    color: var(--yellow-700)!important\n  }\n\n  .focus\\:text-yellow-800:focus {\n    color: var(--yellow-800)!important\n  }\n\n  .focus\\:text-yellow-900:focus {\n    color: var(--yellow-900)!important\n  }\n\n  .hover\\:text-yellow-50:hover {\n    color: var(--yellow-50)!important\n  }\n\n  .hover\\:text-yellow-100:hover {\n    color: var(--yellow-100)!important\n  }\n\n  .hover\\:text-yellow-200:hover {\n    color: var(--yellow-200)!important\n  }\n\n  .hover\\:text-yellow-300:hover {\n    color: var(--yellow-300)!important\n  }\n\n  .hover\\:text-yellow-400:hover {\n    color: var(--yellow-400)!important\n  }\n\n  .hover\\:text-yellow-500:hover {\n    color: var(--yellow-500)!important\n  }\n\n  .hover\\:text-yellow-600:hover {\n    color: var(--yellow-600)!important\n  }\n\n  .hover\\:text-yellow-700:hover {\n    color: var(--yellow-700)!important\n  }\n\n  .hover\\:text-yellow-800:hover {\n    color: var(--yellow-800)!important\n  }\n\n  .hover\\:text-yellow-900:hover {\n    color: var(--yellow-900)!important\n  }\n\n  .active\\:text-yellow-50:active {\n    color: var(--yellow-50)!important\n  }\n\n  .active\\:text-yellow-100:active {\n    color: var(--yellow-100)!important\n  }\n\n  .active\\:text-yellow-200:active {\n    color: var(--yellow-200)!important\n  }\n\n  .active\\:text-yellow-300:active {\n    color: var(--yellow-300)!important\n  }\n\n  .active\\:text-yellow-400:active {\n    color: var(--yellow-400)!important\n  }\n\n  .active\\:text-yellow-500:active {\n    color: var(--yellow-500)!important\n  }\n\n  .active\\:text-yellow-600:active {\n    color: var(--yellow-600)!important\n  }\n\n  .active\\:text-yellow-700:active {\n    color: var(--yellow-700)!important\n  }\n\n  .active\\:text-yellow-800:active {\n    color: var(--yellow-800)!important\n  }\n\n  .active\\:text-yellow-900:active {\n    color: var(--yellow-900)!important\n  }\n\n  .text-cyan-50 {\n    color: var(--cyan-50)!important\n  }\n\n  .text-cyan-100 {\n    color: var(--cyan-100)!important\n  }\n\n  .text-cyan-200 {\n    color: var(--cyan-200)!important\n  }\n\n  .text-cyan-300 {\n    color: var(--cyan-300)!important\n  }\n\n  .text-cyan-400 {\n    color: var(--cyan-400)!important\n  }\n\n  .text-cyan-500 {\n    color: var(--cyan-500)!important\n  }\n\n  .text-cyan-600 {\n    color: var(--cyan-600)!important\n  }\n\n  .text-cyan-700 {\n    color: var(--cyan-700)!important\n  }\n\n  .text-cyan-800 {\n    color: var(--cyan-800)!important\n  }\n\n  .text-cyan-900 {\n    color: var(--cyan-900)!important\n  }\n\n  .focus\\:text-cyan-50:focus {\n    color: var(--cyan-50)!important\n  }\n\n  .focus\\:text-cyan-100:focus {\n    color: var(--cyan-100)!important\n  }\n\n  .focus\\:text-cyan-200:focus {\n    color: var(--cyan-200)!important\n  }\n\n  .focus\\:text-cyan-300:focus {\n    color: var(--cyan-300)!important\n  }\n\n  .focus\\:text-cyan-400:focus {\n    color: var(--cyan-400)!important\n  }\n\n  .focus\\:text-cyan-500:focus {\n    color: var(--cyan-500)!important\n  }\n\n  .focus\\:text-cyan-600:focus {\n    color: var(--cyan-600)!important\n  }\n\n  .focus\\:text-cyan-700:focus {\n    color: var(--cyan-700)!important\n  }\n\n  .focus\\:text-cyan-800:focus {\n    color: var(--cyan-800)!important\n  }\n\n  .focus\\:text-cyan-900:focus {\n    color: var(--cyan-900)!important\n  }\n\n  .hover\\:text-cyan-50:hover {\n    color: var(--cyan-50)!important\n  }\n\n  .hover\\:text-cyan-100:hover {\n    color: var(--cyan-100)!important\n  }\n\n  .hover\\:text-cyan-200:hover {\n    color: var(--cyan-200)!important\n  }\n\n  .hover\\:text-cyan-300:hover {\n    color: var(--cyan-300)!important\n  }\n\n  .hover\\:text-cyan-400:hover {\n    color: var(--cyan-400)!important\n  }\n\n  .hover\\:text-cyan-500:hover {\n    color: var(--cyan-500)!important\n  }\n\n  .hover\\:text-cyan-600:hover {\n    color: var(--cyan-600)!important\n  }\n\n  .hover\\:text-cyan-700:hover {\n    color: var(--cyan-700)!important\n  }\n\n  .hover\\:text-cyan-800:hover {\n    color: var(--cyan-800)!important\n  }\n\n  .hover\\:text-cyan-900:hover {\n    color: var(--cyan-900)!important\n  }\n\n  .active\\:text-cyan-50:active {\n    color: var(--cyan-50)!important\n  }\n\n  .active\\:text-cyan-100:active {\n    color: var(--cyan-100)!important\n  }\n\n  .active\\:text-cyan-200:active {\n    color: var(--cyan-200)!important\n  }\n\n  .active\\:text-cyan-300:active {\n    color: var(--cyan-300)!important\n  }\n\n  .active\\:text-cyan-400:active {\n    color: var(--cyan-400)!important\n  }\n\n  .active\\:text-cyan-500:active {\n    color: var(--cyan-500)!important\n  }\n\n  .active\\:text-cyan-600:active {\n    color: var(--cyan-600)!important\n  }\n\n  .active\\:text-cyan-700:active {\n    color: var(--cyan-700)!important\n  }\n\n  .active\\:text-cyan-800:active {\n    color: var(--cyan-800)!important\n  }\n\n  .active\\:text-cyan-900:active {\n    color: var(--cyan-900)!important\n  }\n\n  .text-pink-50 {\n    color: var(--pink-50)!important\n  }\n\n  .text-pink-100 {\n    color: var(--pink-100)!important\n  }\n\n  .text-pink-200 {\n    color: var(--pink-200)!important\n  }\n\n  .text-pink-300 {\n    color: var(--pink-300)!important\n  }\n\n  .text-pink-400 {\n    color: var(--pink-400)!important\n  }\n\n  .text-pink-500 {\n    color: var(--pink-500)!important\n  }\n\n  .text-pink-600 {\n    color: var(--pink-600)!important\n  }\n\n  .text-pink-700 {\n    color: var(--pink-700)!important\n  }\n\n  .text-pink-800 {\n    color: var(--pink-800)!important\n  }\n\n  .text-pink-900 {\n    color: var(--pink-900)!important\n  }\n\n  .focus\\:text-pink-50:focus {\n    color: var(--pink-50)!important\n  }\n\n  .focus\\:text-pink-100:focus {\n    color: var(--pink-100)!important\n  }\n\n  .focus\\:text-pink-200:focus {\n    color: var(--pink-200)!important\n  }\n\n  .focus\\:text-pink-300:focus {\n    color: var(--pink-300)!important\n  }\n\n  .focus\\:text-pink-400:focus {\n    color: var(--pink-400)!important\n  }\n\n  .focus\\:text-pink-500:focus {\n    color: var(--pink-500)!important\n  }\n\n  .focus\\:text-pink-600:focus {\n    color: var(--pink-600)!important\n  }\n\n  .focus\\:text-pink-700:focus {\n    color: var(--pink-700)!important\n  }\n\n  .focus\\:text-pink-800:focus {\n    color: var(--pink-800)!important\n  }\n\n  .focus\\:text-pink-900:focus {\n    color: var(--pink-900)!important\n  }\n\n  .hover\\:text-pink-50:hover {\n    color: var(--pink-50)!important\n  }\n\n  .hover\\:text-pink-100:hover {\n    color: var(--pink-100)!important\n  }\n\n  .hover\\:text-pink-200:hover {\n    color: var(--pink-200)!important\n  }\n\n  .hover\\:text-pink-300:hover {\n    color: var(--pink-300)!important\n  }\n\n  .hover\\:text-pink-400:hover {\n    color: var(--pink-400)!important\n  }\n\n  .hover\\:text-pink-500:hover {\n    color: var(--pink-500)!important\n  }\n\n  .hover\\:text-pink-600:hover {\n    color: var(--pink-600)!important\n  }\n\n  .hover\\:text-pink-700:hover {\n    color: var(--pink-700)!important\n  }\n\n  .hover\\:text-pink-800:hover {\n    color: var(--pink-800)!important\n  }\n\n  .hover\\:text-pink-900:hover {\n    color: var(--pink-900)!important\n  }\n\n  .active\\:text-pink-50:active {\n    color: var(--pink-50)!important\n  }\n\n  .active\\:text-pink-100:active {\n    color: var(--pink-100)!important\n  }\n\n  .active\\:text-pink-200:active {\n    color: var(--pink-200)!important\n  }\n\n  .active\\:text-pink-300:active {\n    color: var(--pink-300)!important\n  }\n\n  .active\\:text-pink-400:active {\n    color: var(--pink-400)!important\n  }\n\n  .active\\:text-pink-500:active {\n    color: var(--pink-500)!important\n  }\n\n  .active\\:text-pink-600:active {\n    color: var(--pink-600)!important\n  }\n\n  .active\\:text-pink-700:active {\n    color: var(--pink-700)!important\n  }\n\n  .active\\:text-pink-800:active {\n    color: var(--pink-800)!important\n  }\n\n  .active\\:text-pink-900:active {\n    color: var(--pink-900)!important\n  }\n\n  .text-indigo-50 {\n    color: var(--indigo-50)!important\n  }\n\n  .text-indigo-100 {\n    color: var(--indigo-100)!important\n  }\n\n  .text-indigo-200 {\n    color: var(--indigo-200)!important\n  }\n\n  .text-indigo-300 {\n    color: var(--indigo-300)!important\n  }\n\n  .text-indigo-400 {\n    color: var(--indigo-400)!important\n  }\n\n  .text-indigo-500 {\n    color: var(--indigo-500)!important\n  }\n\n  .text-indigo-600 {\n    color: var(--indigo-600)!important\n  }\n\n  .text-indigo-700 {\n    color: var(--indigo-700)!important\n  }\n\n  .text-indigo-800 {\n    color: var(--indigo-800)!important\n  }\n\n  .text-indigo-900 {\n    color: var(--indigo-900)!important\n  }\n\n  .focus\\:text-indigo-50:focus {\n    color: var(--indigo-50)!important\n  }\n\n  .focus\\:text-indigo-100:focus {\n    color: var(--indigo-100)!important\n  }\n\n  .focus\\:text-indigo-200:focus {\n    color: var(--indigo-200)!important\n  }\n\n  .focus\\:text-indigo-300:focus {\n    color: var(--indigo-300)!important\n  }\n\n  .focus\\:text-indigo-400:focus {\n    color: var(--indigo-400)!important\n  }\n\n  .focus\\:text-indigo-500:focus {\n    color: var(--indigo-500)!important\n  }\n\n  .focus\\:text-indigo-600:focus {\n    color: var(--indigo-600)!important\n  }\n\n  .focus\\:text-indigo-700:focus {\n    color: var(--indigo-700)!important\n  }\n\n  .focus\\:text-indigo-800:focus {\n    color: var(--indigo-800)!important\n  }\n\n  .focus\\:text-indigo-900:focus {\n    color: var(--indigo-900)!important\n  }\n\n  .hover\\:text-indigo-50:hover {\n    color: var(--indigo-50)!important\n  }\n\n  .hover\\:text-indigo-100:hover {\n    color: var(--indigo-100)!important\n  }\n\n  .hover\\:text-indigo-200:hover {\n    color: var(--indigo-200)!important\n  }\n\n  .hover\\:text-indigo-300:hover {\n    color: var(--indigo-300)!important\n  }\n\n  .hover\\:text-indigo-400:hover {\n    color: var(--indigo-400)!important\n  }\n\n  .hover\\:text-indigo-500:hover {\n    color: var(--indigo-500)!important\n  }\n\n  .hover\\:text-indigo-600:hover {\n    color: var(--indigo-600)!important\n  }\n\n  .hover\\:text-indigo-700:hover {\n    color: var(--indigo-700)!important\n  }\n\n  .hover\\:text-indigo-800:hover {\n    color: var(--indigo-800)!important\n  }\n\n  .hover\\:text-indigo-900:hover {\n    color: var(--indigo-900)!important\n  }\n\n  .active\\:text-indigo-50:active {\n    color: var(--indigo-50)!important\n  }\n\n  .active\\:text-indigo-100:active {\n    color: var(--indigo-100)!important\n  }\n\n  .active\\:text-indigo-200:active {\n    color: var(--indigo-200)!important\n  }\n\n  .active\\:text-indigo-300:active {\n    color: var(--indigo-300)!important\n  }\n\n  .active\\:text-indigo-400:active {\n    color: var(--indigo-400)!important\n  }\n\n  .active\\:text-indigo-500:active {\n    color: var(--indigo-500)!important\n  }\n\n  .active\\:text-indigo-600:active {\n    color: var(--indigo-600)!important\n  }\n\n  .active\\:text-indigo-700:active {\n    color: var(--indigo-700)!important\n  }\n\n  .active\\:text-indigo-800:active {\n    color: var(--indigo-800)!important\n  }\n\n  .active\\:text-indigo-900:active {\n    color: var(--indigo-900)!important\n  }\n\n  .text-teal-50 {\n    color: var(--teal-50)!important\n  }\n\n  .text-teal-100 {\n    color: var(--teal-100)!important\n  }\n\n  .text-teal-200 {\n    color: var(--teal-200)!important\n  }\n\n  .text-teal-300 {\n    color: var(--teal-300)!important\n  }\n\n  .text-teal-400 {\n    color: var(--teal-400)!important\n  }\n\n  .text-teal-500 {\n    color: var(--teal-500)!important\n  }\n\n  .text-teal-600 {\n    color: var(--teal-600)!important\n  }\n\n  .text-teal-700 {\n    color: var(--teal-700)!important\n  }\n\n  .text-teal-800 {\n    color: var(--teal-800)!important\n  }\n\n  .text-teal-900 {\n    color: var(--teal-900)!important\n  }\n\n  .focus\\:text-teal-50:focus {\n    color: var(--teal-50)!important\n  }\n\n  .focus\\:text-teal-100:focus {\n    color: var(--teal-100)!important\n  }\n\n  .focus\\:text-teal-200:focus {\n    color: var(--teal-200)!important\n  }\n\n  .focus\\:text-teal-300:focus {\n    color: var(--teal-300)!important\n  }\n\n  .focus\\:text-teal-400:focus {\n    color: var(--teal-400)!important\n  }\n\n  .focus\\:text-teal-500:focus {\n    color: var(--teal-500)!important\n  }\n\n  .focus\\:text-teal-600:focus {\n    color: var(--teal-600)!important\n  }\n\n  .focus\\:text-teal-700:focus {\n    color: var(--teal-700)!important\n  }\n\n  .focus\\:text-teal-800:focus {\n    color: var(--teal-800)!important\n  }\n\n  .focus\\:text-teal-900:focus {\n    color: var(--teal-900)!important\n  }\n\n  .hover\\:text-teal-50:hover {\n    color: var(--teal-50)!important\n  }\n\n  .hover\\:text-teal-100:hover {\n    color: var(--teal-100)!important\n  }\n\n  .hover\\:text-teal-200:hover {\n    color: var(--teal-200)!important\n  }\n\n  .hover\\:text-teal-300:hover {\n    color: var(--teal-300)!important\n  }\n\n  .hover\\:text-teal-400:hover {\n    color: var(--teal-400)!important\n  }\n\n  .hover\\:text-teal-500:hover {\n    color: var(--teal-500)!important\n  }\n\n  .hover\\:text-teal-600:hover {\n    color: var(--teal-600)!important\n  }\n\n  .hover\\:text-teal-700:hover {\n    color: var(--teal-700)!important\n  }\n\n  .hover\\:text-teal-800:hover {\n    color: var(--teal-800)!important\n  }\n\n  .hover\\:text-teal-900:hover {\n    color: var(--teal-900)!important\n  }\n\n  .active\\:text-teal-50:active {\n    color: var(--teal-50)!important\n  }\n\n  .active\\:text-teal-100:active {\n    color: var(--teal-100)!important\n  }\n\n  .active\\:text-teal-200:active {\n    color: var(--teal-200)!important\n  }\n\n  .active\\:text-teal-300:active {\n    color: var(--teal-300)!important\n  }\n\n  .active\\:text-teal-400:active {\n    color: var(--teal-400)!important\n  }\n\n  .active\\:text-teal-500:active {\n    color: var(--teal-500)!important\n  }\n\n  .active\\:text-teal-600:active {\n    color: var(--teal-600)!important\n  }\n\n  .active\\:text-teal-700:active {\n    color: var(--teal-700)!important\n  }\n\n  .active\\:text-teal-800:active {\n    color: var(--teal-800)!important\n  }\n\n  .active\\:text-teal-900:active {\n    color: var(--teal-900)!important\n  }\n\n  .text-orange-50 {\n    color: var(--orange-50)!important\n  }\n\n  .text-orange-100 {\n    color: var(--orange-100)!important\n  }\n\n  .text-orange-200 {\n    color: var(--orange-200)!important\n  }\n\n  .text-orange-300 {\n    color: var(--orange-300)!important\n  }\n\n  .text-orange-400 {\n    color: var(--orange-400)!important\n  }\n\n  .text-orange-500 {\n    color: var(--orange-500)!important\n  }\n\n  .text-orange-600 {\n    color: var(--orange-600)!important\n  }\n\n  .text-orange-700 {\n    color: var(--orange-700)!important\n  }\n\n  .text-orange-800 {\n    color: var(--orange-800)!important\n  }\n\n  .text-orange-900 {\n    color: var(--orange-900)!important\n  }\n\n  .focus\\:text-orange-50:focus {\n    color: var(--orange-50)!important\n  }\n\n  .focus\\:text-orange-100:focus {\n    color: var(--orange-100)!important\n  }\n\n  .focus\\:text-orange-200:focus {\n    color: var(--orange-200)!important\n  }\n\n  .focus\\:text-orange-300:focus {\n    color: var(--orange-300)!important\n  }\n\n  .focus\\:text-orange-400:focus {\n    color: var(--orange-400)!important\n  }\n\n  .focus\\:text-orange-500:focus {\n    color: var(--orange-500)!important\n  }\n\n  .focus\\:text-orange-600:focus {\n    color: var(--orange-600)!important\n  }\n\n  .focus\\:text-orange-700:focus {\n    color: var(--orange-700)!important\n  }\n\n  .focus\\:text-orange-800:focus {\n    color: var(--orange-800)!important\n  }\n\n  .focus\\:text-orange-900:focus {\n    color: var(--orange-900)!important\n  }\n\n  .hover\\:text-orange-50:hover {\n    color: var(--orange-50)!important\n  }\n\n  .hover\\:text-orange-100:hover {\n    color: var(--orange-100)!important\n  }\n\n  .hover\\:text-orange-200:hover {\n    color: var(--orange-200)!important\n  }\n\n  .hover\\:text-orange-300:hover {\n    color: var(--orange-300)!important\n  }\n\n  .hover\\:text-orange-400:hover {\n    color: var(--orange-400)!important\n  }\n\n  .hover\\:text-orange-500:hover {\n    color: var(--orange-500)!important\n  }\n\n  .hover\\:text-orange-600:hover {\n    color: var(--orange-600)!important\n  }\n\n  .hover\\:text-orange-700:hover {\n    color: var(--orange-700)!important\n  }\n\n  .hover\\:text-orange-800:hover {\n    color: var(--orange-800)!important\n  }\n\n  .hover\\:text-orange-900:hover {\n    color: var(--orange-900)!important\n  }\n\n  .active\\:text-orange-50:active {\n    color: var(--orange-50)!important\n  }\n\n  .active\\:text-orange-100:active {\n    color: var(--orange-100)!important\n  }\n\n  .active\\:text-orange-200:active {\n    color: var(--orange-200)!important\n  }\n\n  .active\\:text-orange-300:active {\n    color: var(--orange-300)!important\n  }\n\n  .active\\:text-orange-400:active {\n    color: var(--orange-400)!important\n  }\n\n  .active\\:text-orange-500:active {\n    color: var(--orange-500)!important\n  }\n\n  .active\\:text-orange-600:active {\n    color: var(--orange-600)!important\n  }\n\n  .active\\:text-orange-700:active {\n    color: var(--orange-700)!important\n  }\n\n  .active\\:text-orange-800:active {\n    color: var(--orange-800)!important\n  }\n\n  .active\\:text-orange-900:active {\n    color: var(--orange-900)!important\n  }\n\n  .text-bluegray-50 {\n    color: var(--bluegray-50)!important\n  }\n\n  .text-bluegray-100 {\n    color: var(--bluegray-100)!important\n  }\n\n  .text-bluegray-200 {\n    color: var(--bluegray-200)!important\n  }\n\n  .text-bluegray-300 {\n    color: var(--bluegray-300)!important\n  }\n\n  .text-bluegray-400 {\n    color: var(--bluegray-400)!important\n  }\n\n  .text-bluegray-500 {\n    color: var(--bluegray-500)!important\n  }\n\n  .text-bluegray-600 {\n    color: var(--bluegray-600)!important\n  }\n\n  .text-bluegray-700 {\n    color: var(--bluegray-700)!important\n  }\n\n  .text-bluegray-800 {\n    color: var(--bluegray-800)!important\n  }\n\n  .text-bluegray-900 {\n    color: var(--bluegray-900)!important\n  }\n\n  .focus\\:text-bluegray-50:focus {\n    color: var(--bluegray-50)!important\n  }\n\n  .focus\\:text-bluegray-100:focus {\n    color: var(--bluegray-100)!important\n  }\n\n  .focus\\:text-bluegray-200:focus {\n    color: var(--bluegray-200)!important\n  }\n\n  .focus\\:text-bluegray-300:focus {\n    color: var(--bluegray-300)!important\n  }\n\n  .focus\\:text-bluegray-400:focus {\n    color: var(--bluegray-400)!important\n  }\n\n  .focus\\:text-bluegray-500:focus {\n    color: var(--bluegray-500)!important\n  }\n\n  .focus\\:text-bluegray-600:focus {\n    color: var(--bluegray-600)!important\n  }\n\n  .focus\\:text-bluegray-700:focus {\n    color: var(--bluegray-700)!important\n  }\n\n  .focus\\:text-bluegray-800:focus {\n    color: var(--bluegray-800)!important\n  }\n\n  .focus\\:text-bluegray-900:focus {\n    color: var(--bluegray-900)!important\n  }\n\n  .hover\\:text-bluegray-50:hover {\n    color: var(--bluegray-50)!important\n  }\n\n  .hover\\:text-bluegray-100:hover {\n    color: var(--bluegray-100)!important\n  }\n\n  .hover\\:text-bluegray-200:hover {\n    color: var(--bluegray-200)!important\n  }\n\n  .hover\\:text-bluegray-300:hover {\n    color: var(--bluegray-300)!important\n  }\n\n  .hover\\:text-bluegray-400:hover {\n    color: var(--bluegray-400)!important\n  }\n\n  .hover\\:text-bluegray-500:hover {\n    color: var(--bluegray-500)!important\n  }\n\n  .hover\\:text-bluegray-600:hover {\n    color: var(--bluegray-600)!important\n  }\n\n  .hover\\:text-bluegray-700:hover {\n    color: var(--bluegray-700)!important\n  }\n\n  .hover\\:text-bluegray-800:hover {\n    color: var(--bluegray-800)!important\n  }\n\n  .hover\\:text-bluegray-900:hover {\n    color: var(--bluegray-900)!important\n  }\n\n  .active\\:text-bluegray-50:active {\n    color: var(--bluegray-50)!important\n  }\n\n  .active\\:text-bluegray-100:active {\n    color: var(--bluegray-100)!important\n  }\n\n  .active\\:text-bluegray-200:active {\n    color: var(--bluegray-200)!important\n  }\n\n  .active\\:text-bluegray-300:active {\n    color: var(--bluegray-300)!important\n  }\n\n  .active\\:text-bluegray-400:active {\n    color: var(--bluegray-400)!important\n  }\n\n  .active\\:text-bluegray-500:active {\n    color: var(--bluegray-500)!important\n  }\n\n  .active\\:text-bluegray-600:active {\n    color: var(--bluegray-600)!important\n  }\n\n  .active\\:text-bluegray-700:active {\n    color: var(--bluegray-700)!important\n  }\n\n  .active\\:text-bluegray-800:active {\n    color: var(--bluegray-800)!important\n  }\n\n  .active\\:text-bluegray-900:active {\n    color: var(--bluegray-900)!important\n  }\n\n  .text-purple-50 {\n    color: var(--purple-50)!important\n  }\n\n  .text-purple-100 {\n    color: var(--purple-100)!important\n  }\n\n  .text-purple-200 {\n    color: var(--purple-200)!important\n  }\n\n  .text-purple-300 {\n    color: var(--purple-300)!important\n  }\n\n  .text-purple-400 {\n    color: var(--purple-400)!important\n  }\n\n  .text-purple-500 {\n    color: var(--purple-500)!important\n  }\n\n  .text-purple-600 {\n    color: var(--purple-600)!important\n  }\n\n  .text-purple-700 {\n    color: var(--purple-700)!important\n  }\n\n  .text-purple-800 {\n    color: var(--purple-800)!important\n  }\n\n  .text-purple-900 {\n    color: var(--purple-900)!important\n  }\n\n  .focus\\:text-purple-50:focus {\n    color: var(--purple-50)!important\n  }\n\n  .focus\\:text-purple-100:focus {\n    color: var(--purple-100)!important\n  }\n\n  .focus\\:text-purple-200:focus {\n    color: var(--purple-200)!important\n  }\n\n  .focus\\:text-purple-300:focus {\n    color: var(--purple-300)!important\n  }\n\n  .focus\\:text-purple-400:focus {\n    color: var(--purple-400)!important\n  }\n\n  .focus\\:text-purple-500:focus {\n    color: var(--purple-500)!important\n  }\n\n  .focus\\:text-purple-600:focus {\n    color: var(--purple-600)!important\n  }\n\n  .focus\\:text-purple-700:focus {\n    color: var(--purple-700)!important\n  }\n\n  .focus\\:text-purple-800:focus {\n    color: var(--purple-800)!important\n  }\n\n  .focus\\:text-purple-900:focus {\n    color: var(--purple-900)!important\n  }\n\n  .hover\\:text-purple-50:hover {\n    color: var(--purple-50)!important\n  }\n\n  .hover\\:text-purple-100:hover {\n    color: var(--purple-100)!important\n  }\n\n  .hover\\:text-purple-200:hover {\n    color: var(--purple-200)!important\n  }\n\n  .hover\\:text-purple-300:hover {\n    color: var(--purple-300)!important\n  }\n\n  .hover\\:text-purple-400:hover {\n    color: var(--purple-400)!important\n  }\n\n  .hover\\:text-purple-500:hover {\n    color: var(--purple-500)!important\n  }\n\n  .hover\\:text-purple-600:hover {\n    color: var(--purple-600)!important\n  }\n\n  .hover\\:text-purple-700:hover {\n    color: var(--purple-700)!important\n  }\n\n  .hover\\:text-purple-800:hover {\n    color: var(--purple-800)!important\n  }\n\n  .hover\\:text-purple-900:hover {\n    color: var(--purple-900)!important\n  }\n\n  .active\\:text-purple-50:active {\n    color: var(--purple-50)!important\n  }\n\n  .active\\:text-purple-100:active {\n    color: var(--purple-100)!important\n  }\n\n  .active\\:text-purple-200:active {\n    color: var(--purple-200)!important\n  }\n\n  .active\\:text-purple-300:active {\n    color: var(--purple-300)!important\n  }\n\n  .active\\:text-purple-400:active {\n    color: var(--purple-400)!important\n  }\n\n  .active\\:text-purple-500:active {\n    color: var(--purple-500)!important\n  }\n\n  .active\\:text-purple-600:active {\n    color: var(--purple-600)!important\n  }\n\n  .active\\:text-purple-700:active {\n    color: var(--purple-700)!important\n  }\n\n  .active\\:text-purple-800:active {\n    color: var(--purple-800)!important\n  }\n\n  .active\\:text-purple-900:active {\n    color: var(--purple-900)!important\n  }\n\n  .text-gray-50 {\n    color: var(--gray-50)!important\n  }\n\n  .text-gray-100 {\n    color: var(--gray-100)!important\n  }\n\n  .text-gray-200 {\n    color: var(--gray-200)!important\n  }\n\n  .text-gray-300 {\n    color: var(--gray-300)!important\n  }\n\n  .text-gray-400 {\n    color: var(--gray-400)!important\n  }\n\n  .text-gray-500 {\n    color: var(--gray-500)!important\n  }\n\n  .text-gray-600 {\n    color: var(--gray-600)!important\n  }\n\n  .text-gray-700 {\n    color: var(--gray-700)!important\n  }\n\n  .text-gray-800 {\n    color: var(--gray-800)!important\n  }\n\n  .text-gray-900 {\n    color: var(--gray-900)!important\n  }\n\n  .focus\\:text-gray-50:focus {\n    color: var(--gray-50)!important\n  }\n\n  .focus\\:text-gray-100:focus {\n    color: var(--gray-100)!important\n  }\n\n  .focus\\:text-gray-200:focus {\n    color: var(--gray-200)!important\n  }\n\n  .focus\\:text-gray-300:focus {\n    color: var(--gray-300)!important\n  }\n\n  .focus\\:text-gray-400:focus {\n    color: var(--gray-400)!important\n  }\n\n  .focus\\:text-gray-500:focus {\n    color: var(--gray-500)!important\n  }\n\n  .focus\\:text-gray-600:focus {\n    color: var(--gray-600)!important\n  }\n\n  .focus\\:text-gray-700:focus {\n    color: var(--gray-700)!important\n  }\n\n  .focus\\:text-gray-800:focus {\n    color: var(--gray-800)!important\n  }\n\n  .focus\\:text-gray-900:focus {\n    color: var(--gray-900)!important\n  }\n\n  .hover\\:text-gray-50:hover {\n    color: var(--gray-50)!important\n  }\n\n  .hover\\:text-gray-100:hover {\n    color: var(--gray-100)!important\n  }\n\n  .hover\\:text-gray-200:hover {\n    color: var(--gray-200)!important\n  }\n\n  .hover\\:text-gray-300:hover {\n    color: var(--gray-300)!important\n  }\n\n  .hover\\:text-gray-400:hover {\n    color: var(--gray-400)!important\n  }\n\n  .hover\\:text-gray-500:hover {\n    color: var(--gray-500)!important\n  }\n\n  .hover\\:text-gray-600:hover {\n    color: var(--gray-600)!important\n  }\n\n  .hover\\:text-gray-700:hover {\n    color: var(--gray-700)!important\n  }\n\n  .hover\\:text-gray-800:hover {\n    color: var(--gray-800)!important\n  }\n\n  .hover\\:text-gray-900:hover {\n    color: var(--gray-900)!important\n  }\n\n  .active\\:text-gray-50:active {\n    color: var(--gray-50)!important\n  }\n\n  .active\\:text-gray-100:active {\n    color: var(--gray-100)!important\n  }\n\n  .active\\:text-gray-200:active {\n    color: var(--gray-200)!important\n  }\n\n  .active\\:text-gray-300:active {\n    color: var(--gray-300)!important\n  }\n\n  .active\\:text-gray-400:active {\n    color: var(--gray-400)!important\n  }\n\n  .active\\:text-gray-500:active {\n    color: var(--gray-500)!important\n  }\n\n  .active\\:text-gray-600:active {\n    color: var(--gray-600)!important\n  }\n\n  .active\\:text-gray-700:active {\n    color: var(--gray-700)!important\n  }\n\n  .active\\:text-gray-800:active {\n    color: var(--gray-800)!important\n  }\n\n  .active\\:text-gray-900:active {\n    color: var(--gray-900)!important\n  }\n\n  .text-red-50 {\n    color: var(--red-50)!important\n  }\n\n  .text-red-100 {\n    color: var(--red-100)!important\n  }\n\n  .text-red-200 {\n    color: var(--red-200)!important\n  }\n\n  .text-red-300 {\n    color: var(--red-300)!important\n  }\n\n  .text-red-400 {\n    color: var(--red-400)!important\n  }\n\n  .text-red-500 {\n    color: var(--red-500)!important\n  }\n\n  .text-red-600 {\n    color: var(--red-600)!important\n  }\n\n  .text-red-700 {\n    color: var(--red-700)!important\n  }\n\n  .text-red-800 {\n    color: var(--red-800)!important\n  }\n\n  .text-red-900 {\n    color: var(--red-900)!important\n  }\n\n  .focus\\:text-red-50:focus {\n    color: var(--red-50)!important\n  }\n\n  .focus\\:text-red-100:focus {\n    color: var(--red-100)!important\n  }\n\n  .focus\\:text-red-200:focus {\n    color: var(--red-200)!important\n  }\n\n  .focus\\:text-red-300:focus {\n    color: var(--red-300)!important\n  }\n\n  .focus\\:text-red-400:focus {\n    color: var(--red-400)!important\n  }\n\n  .focus\\:text-red-500:focus {\n    color: var(--red-500)!important\n  }\n\n  .focus\\:text-red-600:focus {\n    color: var(--red-600)!important\n  }\n\n  .focus\\:text-red-700:focus {\n    color: var(--red-700)!important\n  }\n\n  .focus\\:text-red-800:focus {\n    color: var(--red-800)!important\n  }\n\n  .focus\\:text-red-900:focus {\n    color: var(--red-900)!important\n  }\n\n  .hover\\:text-red-50:hover {\n    color: var(--red-50)!important\n  }\n\n  .hover\\:text-red-100:hover {\n    color: var(--red-100)!important\n  }\n\n  .hover\\:text-red-200:hover {\n    color: var(--red-200)!important\n  }\n\n  .hover\\:text-red-300:hover {\n    color: var(--red-300)!important\n  }\n\n  .hover\\:text-red-400:hover {\n    color: var(--red-400)!important\n  }\n\n  .hover\\:text-red-500:hover {\n    color: var(--red-500)!important\n  }\n\n  .hover\\:text-red-600:hover {\n    color: var(--red-600)!important\n  }\n\n  .hover\\:text-red-700:hover {\n    color: var(--red-700)!important\n  }\n\n  .hover\\:text-red-800:hover {\n    color: var(--red-800)!important\n  }\n\n  .hover\\:text-red-900:hover {\n    color: var(--red-900)!important\n  }\n\n  .active\\:text-red-50:active {\n    color: var(--red-50)!important\n  }\n\n  .active\\:text-red-100:active {\n    color: var(--red-100)!important\n  }\n\n  .active\\:text-red-200:active {\n    color: var(--red-200)!important\n  }\n\n  .active\\:text-red-300:active {\n    color: var(--red-300)!important\n  }\n\n  .active\\:text-red-400:active {\n    color: var(--red-400)!important\n  }\n\n  .active\\:text-red-500:active {\n    color: var(--red-500)!important\n  }\n\n  .active\\:text-red-600:active {\n    color: var(--red-600)!important\n  }\n\n  .active\\:text-red-700:active {\n    color: var(--red-700)!important\n  }\n\n  .active\\:text-red-800:active {\n    color: var(--red-800)!important\n  }\n\n  .active\\:text-red-900:active {\n    color: var(--red-900)!important\n  }\n\n  .text-primary-50 {\n    color: var(--primary-50)!important\n  }\n\n  .text-primary-100 {\n    color: var(--primary-100)!important\n  }\n\n  .text-primary-200 {\n    color: var(--primary-200)!important\n  }\n\n  .text-primary-300 {\n    color: var(--primary-300)!important\n  }\n\n  .text-primary-400 {\n    color: var(--primary-400)!important\n  }\n\n  .text-primary-500 {\n    color: var(--primary-500)!important\n  }\n\n  .text-primary-600 {\n    color: var(--primary-600)!important\n  }\n\n  .text-primary-700 {\n    color: var(--primary-700)!important\n  }\n\n  .text-primary-800 {\n    color: var(--primary-800)!important\n  }\n\n  .text-primary-900 {\n    color: var(--primary-900)!important\n  }\n\n  .focus\\:text-primary-50:focus {\n    color: var(--primary-50)!important\n  }\n\n  .focus\\:text-primary-100:focus {\n    color: var(--primary-100)!important\n  }\n\n  .focus\\:text-primary-200:focus {\n    color: var(--primary-200)!important\n  }\n\n  .focus\\:text-primary-300:focus {\n    color: var(--primary-300)!important\n  }\n\n  .focus\\:text-primary-400:focus {\n    color: var(--primary-400)!important\n  }\n\n  .focus\\:text-primary-500:focus {\n    color: var(--primary-500)!important\n  }\n\n  .focus\\:text-primary-600:focus {\n    color: var(--primary-600)!important\n  }\n\n  .focus\\:text-primary-700:focus {\n    color: var(--primary-700)!important\n  }\n\n  .focus\\:text-primary-800:focus {\n    color: var(--primary-800)!important\n  }\n\n  .focus\\:text-primary-900:focus {\n    color: var(--primary-900)!important\n  }\n\n  .hover\\:text-primary-50:hover {\n    color: var(--primary-50)!important\n  }\n\n  .hover\\:text-primary-100:hover {\n    color: var(--primary-100)!important\n  }\n\n  .hover\\:text-primary-200:hover {\n    color: var(--primary-200)!important\n  }\n\n  .hover\\:text-primary-300:hover {\n    color: var(--primary-300)!important\n  }\n\n  .hover\\:text-primary-400:hover {\n    color: var(--primary-400)!important\n  }\n\n  .hover\\:text-primary-500:hover {\n    color: var(--primary-500)!important\n  }\n\n  .hover\\:text-primary-600:hover {\n    color: var(--primary-600)!important\n  }\n\n  .hover\\:text-primary-700:hover {\n    color: var(--primary-700)!important\n  }\n\n  .hover\\:text-primary-800:hover {\n    color: var(--primary-800)!important\n  }\n\n  .hover\\:text-primary-900:hover {\n    color: var(--primary-900)!important\n  }\n\n  .active\\:text-primary-50:active {\n    color: var(--primary-50)!important\n  }\n\n  .active\\:text-primary-100:active {\n    color: var(--primary-100)!important\n  }\n\n  .active\\:text-primary-200:active {\n    color: var(--primary-200)!important\n  }\n\n  .active\\:text-primary-300:active {\n    color: var(--primary-300)!important\n  }\n\n  .active\\:text-primary-400:active {\n    color: var(--primary-400)!important\n  }\n\n  .active\\:text-primary-500:active {\n    color: var(--primary-500)!important\n  }\n\n  .active\\:text-primary-600:active {\n    color: var(--primary-600)!important\n  }\n\n  .active\\:text-primary-700:active {\n    color: var(--primary-700)!important\n  }\n\n  .active\\:text-primary-800:active {\n    color: var(--primary-800)!important\n  }\n\n  .active\\:text-primary-900:active {\n    color: var(--primary-900)!important\n  }\n\n  .bg-blue-50 {\n    background-color: var(--blue-50)!important\n  }\n\n  .bg-blue-100 {\n    background-color: var(--blue-100)!important\n  }\n\n  .bg-blue-200 {\n    background-color: var(--blue-200)!important\n  }\n\n  .bg-blue-300 {\n    background-color: var(--blue-300)!important\n  }\n\n  .bg-blue-400 {\n    background-color: var(--blue-400)!important\n  }\n\n  .bg-blue-500 {\n    background-color: var(--blue-500)!important\n  }\n\n  .bg-blue-600 {\n    background-color: var(--blue-600)!important\n  }\n\n  .bg-blue-700 {\n    background-color: var(--blue-700)!important\n  }\n\n  .bg-blue-800 {\n    background-color: var(--blue-800)!important\n  }\n\n  .bg-blue-900 {\n    background-color: var(--blue-900)!important\n  }\n\n  .focus\\:bg-blue-50:focus {\n    background-color: var(--blue-50)!important\n  }\n\n  .focus\\:bg-blue-100:focus {\n    background-color: var(--blue-100)!important\n  }\n\n  .focus\\:bg-blue-200:focus {\n    background-color: var(--blue-200)!important\n  }\n\n  .focus\\:bg-blue-300:focus {\n    background-color: var(--blue-300)!important\n  }\n\n  .focus\\:bg-blue-400:focus {\n    background-color: var(--blue-400)!important\n  }\n\n  .focus\\:bg-blue-500:focus {\n    background-color: var(--blue-500)!important\n  }\n\n  .focus\\:bg-blue-600:focus {\n    background-color: var(--blue-600)!important\n  }\n\n  .focus\\:bg-blue-700:focus {\n    background-color: var(--blue-700)!important\n  }\n\n  .focus\\:bg-blue-800:focus {\n    background-color: var(--blue-800)!important\n  }\n\n  .focus\\:bg-blue-900:focus {\n    background-color: var(--blue-900)!important\n  }\n\n  .hover\\:bg-blue-50:hover {\n    background-color: var(--blue-50)!important\n  }\n\n  .hover\\:bg-blue-100:hover {\n    background-color: var(--blue-100)!important\n  }\n\n  .hover\\:bg-blue-200:hover {\n    background-color: var(--blue-200)!important\n  }\n\n  .hover\\:bg-blue-300:hover {\n    background-color: var(--blue-300)!important\n  }\n\n  .hover\\:bg-blue-400:hover {\n    background-color: var(--blue-400)!important\n  }\n\n  .hover\\:bg-blue-500:hover {\n    background-color: var(--blue-500)!important\n  }\n\n  .hover\\:bg-blue-600:hover {\n    background-color: var(--blue-600)!important\n  }\n\n  .hover\\:bg-blue-700:hover {\n    background-color: var(--blue-700)!important\n  }\n\n  .hover\\:bg-blue-800:hover {\n    background-color: var(--blue-800)!important\n  }\n\n  .hover\\:bg-blue-900:hover {\n    background-color: var(--blue-900)!important\n  }\n\n  .active\\:bg-blue-50:active {\n    background-color: var(--blue-50)!important\n  }\n\n  .active\\:bg-blue-100:active {\n    background-color: var(--blue-100)!important\n  }\n\n  .active\\:bg-blue-200:active {\n    background-color: var(--blue-200)!important\n  }\n\n  .active\\:bg-blue-300:active {\n    background-color: var(--blue-300)!important\n  }\n\n  .active\\:bg-blue-400:active {\n    background-color: var(--blue-400)!important\n  }\n\n  .active\\:bg-blue-500:active {\n    background-color: var(--blue-500)!important\n  }\n\n  .active\\:bg-blue-600:active {\n    background-color: var(--blue-600)!important\n  }\n\n  .active\\:bg-blue-700:active {\n    background-color: var(--blue-700)!important\n  }\n\n  .active\\:bg-blue-800:active {\n    background-color: var(--blue-800)!important\n  }\n\n  .active\\:bg-blue-900:active {\n    background-color: var(--blue-900)!important\n  }\n\n  .bg-green-50 {\n    background-color: var(--green-50)!important\n  }\n\n  .bg-green-100 {\n    background-color: var(--green-100)!important\n  }\n\n  .bg-green-200 {\n    background-color: var(--green-200)!important\n  }\n\n  .bg-green-300 {\n    background-color: var(--green-300)!important\n  }\n\n  .bg-green-400 {\n    background-color: var(--green-400)!important\n  }\n\n  .bg-green-500 {\n    background-color: var(--green-500)!important\n  }\n\n  .bg-green-600 {\n    background-color: var(--green-600)!important\n  }\n\n  .bg-green-700 {\n    background-color: var(--green-700)!important\n  }\n\n  .bg-green-800 {\n    background-color: var(--green-800)!important\n  }\n\n  .bg-green-900 {\n    background-color: var(--green-900)!important\n  }\n\n  .focus\\:bg-green-50:focus {\n    background-color: var(--green-50)!important\n  }\n\n  .focus\\:bg-green-100:focus {\n    background-color: var(--green-100)!important\n  }\n\n  .focus\\:bg-green-200:focus {\n    background-color: var(--green-200)!important\n  }\n\n  .focus\\:bg-green-300:focus {\n    background-color: var(--green-300)!important\n  }\n\n  .focus\\:bg-green-400:focus {\n    background-color: var(--green-400)!important\n  }\n\n  .focus\\:bg-green-500:focus {\n    background-color: var(--green-500)!important\n  }\n\n  .focus\\:bg-green-600:focus {\n    background-color: var(--green-600)!important\n  }\n\n  .focus\\:bg-green-700:focus {\n    background-color: var(--green-700)!important\n  }\n\n  .focus\\:bg-green-800:focus {\n    background-color: var(--green-800)!important\n  }\n\n  .focus\\:bg-green-900:focus {\n    background-color: var(--green-900)!important\n  }\n\n  .hover\\:bg-green-50:hover {\n    background-color: var(--green-50)!important\n  }\n\n  .hover\\:bg-green-100:hover {\n    background-color: var(--green-100)!important\n  }\n\n  .hover\\:bg-green-200:hover {\n    background-color: var(--green-200)!important\n  }\n\n  .hover\\:bg-green-300:hover {\n    background-color: var(--green-300)!important\n  }\n\n  .hover\\:bg-green-400:hover {\n    background-color: var(--green-400)!important\n  }\n\n  .hover\\:bg-green-500:hover {\n    background-color: var(--green-500)!important\n  }\n\n  .hover\\:bg-green-600:hover {\n    background-color: var(--green-600)!important\n  }\n\n  .hover\\:bg-green-700:hover {\n    background-color: var(--green-700)!important\n  }\n\n  .hover\\:bg-green-800:hover {\n    background-color: var(--green-800)!important\n  }\n\n  .hover\\:bg-green-900:hover {\n    background-color: var(--green-900)!important\n  }\n\n  .active\\:bg-green-50:active {\n    background-color: var(--green-50)!important\n  }\n\n  .active\\:bg-green-100:active {\n    background-color: var(--green-100)!important\n  }\n\n  .active\\:bg-green-200:active {\n    background-color: var(--green-200)!important\n  }\n\n  .active\\:bg-green-300:active {\n    background-color: var(--green-300)!important\n  }\n\n  .active\\:bg-green-400:active {\n    background-color: var(--green-400)!important\n  }\n\n  .active\\:bg-green-500:active {\n    background-color: var(--green-500)!important\n  }\n\n  .active\\:bg-green-600:active {\n    background-color: var(--green-600)!important\n  }\n\n  .active\\:bg-green-700:active {\n    background-color: var(--green-700)!important\n  }\n\n  .active\\:bg-green-800:active {\n    background-color: var(--green-800)!important\n  }\n\n  .active\\:bg-green-900:active {\n    background-color: var(--green-900)!important\n  }\n\n  .bg-yellow-50 {\n    background-color: var(--yellow-50)!important\n  }\n\n  .bg-yellow-100 {\n    background-color: var(--yellow-100)!important\n  }\n\n  .bg-yellow-200 {\n    background-color: var(--yellow-200)!important\n  }\n\n  .bg-yellow-300 {\n    background-color: var(--yellow-300)!important\n  }\n\n  .bg-yellow-400 {\n    background-color: var(--yellow-400)!important\n  }\n\n  .bg-yellow-500 {\n    background-color: var(--yellow-500)!important\n  }\n\n  .bg-yellow-600 {\n    background-color: var(--yellow-600)!important\n  }\n\n  .bg-yellow-700 {\n    background-color: var(--yellow-700)!important\n  }\n\n  .bg-yellow-800 {\n    background-color: var(--yellow-800)!important\n  }\n\n  .bg-yellow-900 {\n    background-color: var(--yellow-900)!important\n  }\n\n  .focus\\:bg-yellow-50:focus {\n    background-color: var(--yellow-50)!important\n  }\n\n  .focus\\:bg-yellow-100:focus {\n    background-color: var(--yellow-100)!important\n  }\n\n  .focus\\:bg-yellow-200:focus {\n    background-color: var(--yellow-200)!important\n  }\n\n  .focus\\:bg-yellow-300:focus {\n    background-color: var(--yellow-300)!important\n  }\n\n  .focus\\:bg-yellow-400:focus {\n    background-color: var(--yellow-400)!important\n  }\n\n  .focus\\:bg-yellow-500:focus {\n    background-color: var(--yellow-500)!important\n  }\n\n  .focus\\:bg-yellow-600:focus {\n    background-color: var(--yellow-600)!important\n  }\n\n  .focus\\:bg-yellow-700:focus {\n    background-color: var(--yellow-700)!important\n  }\n\n  .focus\\:bg-yellow-800:focus {\n    background-color: var(--yellow-800)!important\n  }\n\n  .focus\\:bg-yellow-900:focus {\n    background-color: var(--yellow-900)!important\n  }\n\n  .hover\\:bg-yellow-50:hover {\n    background-color: var(--yellow-50)!important\n  }\n\n  .hover\\:bg-yellow-100:hover {\n    background-color: var(--yellow-100)!important\n  }\n\n  .hover\\:bg-yellow-200:hover {\n    background-color: var(--yellow-200)!important\n  }\n\n  .hover\\:bg-yellow-300:hover {\n    background-color: var(--yellow-300)!important\n  }\n\n  .hover\\:bg-yellow-400:hover {\n    background-color: var(--yellow-400)!important\n  }\n\n  .hover\\:bg-yellow-500:hover {\n    background-color: var(--yellow-500)!important\n  }\n\n  .hover\\:bg-yellow-600:hover {\n    background-color: var(--yellow-600)!important\n  }\n\n  .hover\\:bg-yellow-700:hover {\n    background-color: var(--yellow-700)!important\n  }\n\n  .hover\\:bg-yellow-800:hover {\n    background-color: var(--yellow-800)!important\n  }\n\n  .hover\\:bg-yellow-900:hover {\n    background-color: var(--yellow-900)!important\n  }\n\n  .active\\:bg-yellow-50:active {\n    background-color: var(--yellow-50)!important\n  }\n\n  .active\\:bg-yellow-100:active {\n    background-color: var(--yellow-100)!important\n  }\n\n  .active\\:bg-yellow-200:active {\n    background-color: var(--yellow-200)!important\n  }\n\n  .active\\:bg-yellow-300:active {\n    background-color: var(--yellow-300)!important\n  }\n\n  .active\\:bg-yellow-400:active {\n    background-color: var(--yellow-400)!important\n  }\n\n  .active\\:bg-yellow-500:active {\n    background-color: var(--yellow-500)!important\n  }\n\n  .active\\:bg-yellow-600:active {\n    background-color: var(--yellow-600)!important\n  }\n\n  .active\\:bg-yellow-700:active {\n    background-color: var(--yellow-700)!important\n  }\n\n  .active\\:bg-yellow-800:active {\n    background-color: var(--yellow-800)!important\n  }\n\n  .active\\:bg-yellow-900:active {\n    background-color: var(--yellow-900)!important\n  }\n\n  .bg-cyan-50 {\n    background-color: var(--cyan-50)!important\n  }\n\n  .bg-cyan-100 {\n    background-color: var(--cyan-100)!important\n  }\n\n  .bg-cyan-200 {\n    background-color: var(--cyan-200)!important\n  }\n\n  .bg-cyan-300 {\n    background-color: var(--cyan-300)!important\n  }\n\n  .bg-cyan-400 {\n    background-color: var(--cyan-400)!important\n  }\n\n  .bg-cyan-500 {\n    background-color: var(--cyan-500)!important\n  }\n\n  .bg-cyan-600 {\n    background-color: var(--cyan-600)!important\n  }\n\n  .bg-cyan-700 {\n    background-color: var(--cyan-700)!important\n  }\n\n  .bg-cyan-800 {\n    background-color: var(--cyan-800)!important\n  }\n\n  .bg-cyan-900 {\n    background-color: var(--cyan-900)!important\n  }\n\n  .focus\\:bg-cyan-50:focus {\n    background-color: var(--cyan-50)!important\n  }\n\n  .focus\\:bg-cyan-100:focus {\n    background-color: var(--cyan-100)!important\n  }\n\n  .focus\\:bg-cyan-200:focus {\n    background-color: var(--cyan-200)!important\n  }\n\n  .focus\\:bg-cyan-300:focus {\n    background-color: var(--cyan-300)!important\n  }\n\n  .focus\\:bg-cyan-400:focus {\n    background-color: var(--cyan-400)!important\n  }\n\n  .focus\\:bg-cyan-500:focus {\n    background-color: var(--cyan-500)!important\n  }\n\n  .focus\\:bg-cyan-600:focus {\n    background-color: var(--cyan-600)!important\n  }\n\n  .focus\\:bg-cyan-700:focus {\n    background-color: var(--cyan-700)!important\n  }\n\n  .focus\\:bg-cyan-800:focus {\n    background-color: var(--cyan-800)!important\n  }\n\n  .focus\\:bg-cyan-900:focus {\n    background-color: var(--cyan-900)!important\n  }\n\n  .hover\\:bg-cyan-50:hover {\n    background-color: var(--cyan-50)!important\n  }\n\n  .hover\\:bg-cyan-100:hover {\n    background-color: var(--cyan-100)!important\n  }\n\n  .hover\\:bg-cyan-200:hover {\n    background-color: var(--cyan-200)!important\n  }\n\n  .hover\\:bg-cyan-300:hover {\n    background-color: var(--cyan-300)!important\n  }\n\n  .hover\\:bg-cyan-400:hover {\n    background-color: var(--cyan-400)!important\n  }\n\n  .hover\\:bg-cyan-500:hover {\n    background-color: var(--cyan-500)!important\n  }\n\n  .hover\\:bg-cyan-600:hover {\n    background-color: var(--cyan-600)!important\n  }\n\n  .hover\\:bg-cyan-700:hover {\n    background-color: var(--cyan-700)!important\n  }\n\n  .hover\\:bg-cyan-800:hover {\n    background-color: var(--cyan-800)!important\n  }\n\n  .hover\\:bg-cyan-900:hover {\n    background-color: var(--cyan-900)!important\n  }\n\n  .active\\:bg-cyan-50:active {\n    background-color: var(--cyan-50)!important\n  }\n\n  .active\\:bg-cyan-100:active {\n    background-color: var(--cyan-100)!important\n  }\n\n  .active\\:bg-cyan-200:active {\n    background-color: var(--cyan-200)!important\n  }\n\n  .active\\:bg-cyan-300:active {\n    background-color: var(--cyan-300)!important\n  }\n\n  .active\\:bg-cyan-400:active {\n    background-color: var(--cyan-400)!important\n  }\n\n  .active\\:bg-cyan-500:active {\n    background-color: var(--cyan-500)!important\n  }\n\n  .active\\:bg-cyan-600:active {\n    background-color: var(--cyan-600)!important\n  }\n\n  .active\\:bg-cyan-700:active {\n    background-color: var(--cyan-700)!important\n  }\n\n  .active\\:bg-cyan-800:active {\n    background-color: var(--cyan-800)!important\n  }\n\n  .active\\:bg-cyan-900:active {\n    background-color: var(--cyan-900)!important\n  }\n\n  .bg-pink-50 {\n    background-color: var(--pink-50)!important\n  }\n\n  .bg-pink-100 {\n    background-color: var(--pink-100)!important\n  }\n\n  .bg-pink-200 {\n    background-color: var(--pink-200)!important\n  }\n\n  .bg-pink-300 {\n    background-color: var(--pink-300)!important\n  }\n\n  .bg-pink-400 {\n    background-color: var(--pink-400)!important\n  }\n\n  .bg-pink-500 {\n    background-color: var(--pink-500)!important\n  }\n\n  .bg-pink-600 {\n    background-color: var(--pink-600)!important\n  }\n\n  .bg-pink-700 {\n    background-color: var(--pink-700)!important\n  }\n\n  .bg-pink-800 {\n    background-color: var(--pink-800)!important\n  }\n\n  .bg-pink-900 {\n    background-color: var(--pink-900)!important\n  }\n\n  .focus\\:bg-pink-50:focus {\n    background-color: var(--pink-50)!important\n  }\n\n  .focus\\:bg-pink-100:focus {\n    background-color: var(--pink-100)!important\n  }\n\n  .focus\\:bg-pink-200:focus {\n    background-color: var(--pink-200)!important\n  }\n\n  .focus\\:bg-pink-300:focus {\n    background-color: var(--pink-300)!important\n  }\n\n  .focus\\:bg-pink-400:focus {\n    background-color: var(--pink-400)!important\n  }\n\n  .focus\\:bg-pink-500:focus {\n    background-color: var(--pink-500)!important\n  }\n\n  .focus\\:bg-pink-600:focus {\n    background-color: var(--pink-600)!important\n  }\n\n  .focus\\:bg-pink-700:focus {\n    background-color: var(--pink-700)!important\n  }\n\n  .focus\\:bg-pink-800:focus {\n    background-color: var(--pink-800)!important\n  }\n\n  .focus\\:bg-pink-900:focus {\n    background-color: var(--pink-900)!important\n  }\n\n  .hover\\:bg-pink-50:hover {\n    background-color: var(--pink-50)!important\n  }\n\n  .hover\\:bg-pink-100:hover {\n    background-color: var(--pink-100)!important\n  }\n\n  .hover\\:bg-pink-200:hover {\n    background-color: var(--pink-200)!important\n  }\n\n  .hover\\:bg-pink-300:hover {\n    background-color: var(--pink-300)!important\n  }\n\n  .hover\\:bg-pink-400:hover {\n    background-color: var(--pink-400)!important\n  }\n\n  .hover\\:bg-pink-500:hover {\n    background-color: var(--pink-500)!important\n  }\n\n  .hover\\:bg-pink-600:hover {\n    background-color: var(--pink-600)!important\n  }\n\n  .hover\\:bg-pink-700:hover {\n    background-color: var(--pink-700)!important\n  }\n\n  .hover\\:bg-pink-800:hover {\n    background-color: var(--pink-800)!important\n  }\n\n  .hover\\:bg-pink-900:hover {\n    background-color: var(--pink-900)!important\n  }\n\n  .active\\:bg-pink-50:active {\n    background-color: var(--pink-50)!important\n  }\n\n  .active\\:bg-pink-100:active {\n    background-color: var(--pink-100)!important\n  }\n\n  .active\\:bg-pink-200:active {\n    background-color: var(--pink-200)!important\n  }\n\n  .active\\:bg-pink-300:active {\n    background-color: var(--pink-300)!important\n  }\n\n  .active\\:bg-pink-400:active {\n    background-color: var(--pink-400)!important\n  }\n\n  .active\\:bg-pink-500:active {\n    background-color: var(--pink-500)!important\n  }\n\n  .active\\:bg-pink-600:active {\n    background-color: var(--pink-600)!important\n  }\n\n  .active\\:bg-pink-700:active {\n    background-color: var(--pink-700)!important\n  }\n\n  .active\\:bg-pink-800:active {\n    background-color: var(--pink-800)!important\n  }\n\n  .active\\:bg-pink-900:active {\n    background-color: var(--pink-900)!important\n  }\n\n  .bg-indigo-50 {\n    background-color: var(--indigo-50)!important\n  }\n\n  .bg-indigo-100 {\n    background-color: var(--indigo-100)!important\n  }\n\n  .bg-indigo-200 {\n    background-color: var(--indigo-200)!important\n  }\n\n  .bg-indigo-300 {\n    background-color: var(--indigo-300)!important\n  }\n\n  .bg-indigo-400 {\n    background-color: var(--indigo-400)!important\n  }\n\n  .bg-indigo-500 {\n    background-color: var(--indigo-500)!important\n  }\n\n  .bg-indigo-600 {\n    background-color: var(--indigo-600)!important\n  }\n\n  .bg-indigo-700 {\n    background-color: var(--indigo-700)!important\n  }\n\n  .bg-indigo-800 {\n    background-color: var(--indigo-800)!important\n  }\n\n  .bg-indigo-900 {\n    background-color: var(--indigo-900)!important\n  }\n\n  .focus\\:bg-indigo-50:focus {\n    background-color: var(--indigo-50)!important\n  }\n\n  .focus\\:bg-indigo-100:focus {\n    background-color: var(--indigo-100)!important\n  }\n\n  .focus\\:bg-indigo-200:focus {\n    background-color: var(--indigo-200)!important\n  }\n\n  .focus\\:bg-indigo-300:focus {\n    background-color: var(--indigo-300)!important\n  }\n\n  .focus\\:bg-indigo-400:focus {\n    background-color: var(--indigo-400)!important\n  }\n\n  .focus\\:bg-indigo-500:focus {\n    background-color: var(--indigo-500)!important\n  }\n\n  .focus\\:bg-indigo-600:focus {\n    background-color: var(--indigo-600)!important\n  }\n\n  .focus\\:bg-indigo-700:focus {\n    background-color: var(--indigo-700)!important\n  }\n\n  .focus\\:bg-indigo-800:focus {\n    background-color: var(--indigo-800)!important\n  }\n\n  .focus\\:bg-indigo-900:focus {\n    background-color: var(--indigo-900)!important\n  }\n\n  .hover\\:bg-indigo-50:hover {\n    background-color: var(--indigo-50)!important\n  }\n\n  .hover\\:bg-indigo-100:hover {\n    background-color: var(--indigo-100)!important\n  }\n\n  .hover\\:bg-indigo-200:hover {\n    background-color: var(--indigo-200)!important\n  }\n\n  .hover\\:bg-indigo-300:hover {\n    background-color: var(--indigo-300)!important\n  }\n\n  .hover\\:bg-indigo-400:hover {\n    background-color: var(--indigo-400)!important\n  }\n\n  .hover\\:bg-indigo-500:hover {\n    background-color: var(--indigo-500)!important\n  }\n\n  .hover\\:bg-indigo-600:hover {\n    background-color: var(--indigo-600)!important\n  }\n\n  .hover\\:bg-indigo-700:hover {\n    background-color: var(--indigo-700)!important\n  }\n\n  .hover\\:bg-indigo-800:hover {\n    background-color: var(--indigo-800)!important\n  }\n\n  .hover\\:bg-indigo-900:hover {\n    background-color: var(--indigo-900)!important\n  }\n\n  .active\\:bg-indigo-50:active {\n    background-color: var(--indigo-50)!important\n  }\n\n  .active\\:bg-indigo-100:active {\n    background-color: var(--indigo-100)!important\n  }\n\n  .active\\:bg-indigo-200:active {\n    background-color: var(--indigo-200)!important\n  }\n\n  .active\\:bg-indigo-300:active {\n    background-color: var(--indigo-300)!important\n  }\n\n  .active\\:bg-indigo-400:active {\n    background-color: var(--indigo-400)!important\n  }\n\n  .active\\:bg-indigo-500:active {\n    background-color: var(--indigo-500)!important\n  }\n\n  .active\\:bg-indigo-600:active {\n    background-color: var(--indigo-600)!important\n  }\n\n  .active\\:bg-indigo-700:active {\n    background-color: var(--indigo-700)!important\n  }\n\n  .active\\:bg-indigo-800:active {\n    background-color: var(--indigo-800)!important\n  }\n\n  .active\\:bg-indigo-900:active {\n    background-color: var(--indigo-900)!important\n  }\n\n  .bg-teal-50 {\n    background-color: var(--teal-50)!important\n  }\n\n  .bg-teal-100 {\n    background-color: var(--teal-100)!important\n  }\n\n  .bg-teal-200 {\n    background-color: var(--teal-200)!important\n  }\n\n  .bg-teal-300 {\n    background-color: var(--teal-300)!important\n  }\n\n  .bg-teal-400 {\n    background-color: var(--teal-400)!important\n  }\n\n  .bg-teal-500 {\n    background-color: var(--teal-500)!important\n  }\n\n  .bg-teal-600 {\n    background-color: var(--teal-600)!important\n  }\n\n  .bg-teal-700 {\n    background-color: var(--teal-700)!important\n  }\n\n  .bg-teal-800 {\n    background-color: var(--teal-800)!important\n  }\n\n  .bg-teal-900 {\n    background-color: var(--teal-900)!important\n  }\n\n  .focus\\:bg-teal-50:focus {\n    background-color: var(--teal-50)!important\n  }\n\n  .focus\\:bg-teal-100:focus {\n    background-color: var(--teal-100)!important\n  }\n\n  .focus\\:bg-teal-200:focus {\n    background-color: var(--teal-200)!important\n  }\n\n  .focus\\:bg-teal-300:focus {\n    background-color: var(--teal-300)!important\n  }\n\n  .focus\\:bg-teal-400:focus {\n    background-color: var(--teal-400)!important\n  }\n\n  .focus\\:bg-teal-500:focus {\n    background-color: var(--teal-500)!important\n  }\n\n  .focus\\:bg-teal-600:focus {\n    background-color: var(--teal-600)!important\n  }\n\n  .focus\\:bg-teal-700:focus {\n    background-color: var(--teal-700)!important\n  }\n\n  .focus\\:bg-teal-800:focus {\n    background-color: var(--teal-800)!important\n  }\n\n  .focus\\:bg-teal-900:focus {\n    background-color: var(--teal-900)!important\n  }\n\n  .hover\\:bg-teal-50:hover {\n    background-color: var(--teal-50)!important\n  }\n\n  .hover\\:bg-teal-100:hover {\n    background-color: var(--teal-100)!important\n  }\n\n  .hover\\:bg-teal-200:hover {\n    background-color: var(--teal-200)!important\n  }\n\n  .hover\\:bg-teal-300:hover {\n    background-color: var(--teal-300)!important\n  }\n\n  .hover\\:bg-teal-400:hover {\n    background-color: var(--teal-400)!important\n  }\n\n  .hover\\:bg-teal-500:hover {\n    background-color: var(--teal-500)!important\n  }\n\n  .hover\\:bg-teal-600:hover {\n    background-color: var(--teal-600)!important\n  }\n\n  .hover\\:bg-teal-700:hover {\n    background-color: var(--teal-700)!important\n  }\n\n  .hover\\:bg-teal-800:hover {\n    background-color: var(--teal-800)!important\n  }\n\n  .hover\\:bg-teal-900:hover {\n    background-color: var(--teal-900)!important\n  }\n\n  .active\\:bg-teal-50:active {\n    background-color: var(--teal-50)!important\n  }\n\n  .active\\:bg-teal-100:active {\n    background-color: var(--teal-100)!important\n  }\n\n  .active\\:bg-teal-200:active {\n    background-color: var(--teal-200)!important\n  }\n\n  .active\\:bg-teal-300:active {\n    background-color: var(--teal-300)!important\n  }\n\n  .active\\:bg-teal-400:active {\n    background-color: var(--teal-400)!important\n  }\n\n  .active\\:bg-teal-500:active {\n    background-color: var(--teal-500)!important\n  }\n\n  .active\\:bg-teal-600:active {\n    background-color: var(--teal-600)!important\n  }\n\n  .active\\:bg-teal-700:active {\n    background-color: var(--teal-700)!important\n  }\n\n  .active\\:bg-teal-800:active {\n    background-color: var(--teal-800)!important\n  }\n\n  .active\\:bg-teal-900:active {\n    background-color: var(--teal-900)!important\n  }\n\n  .bg-orange-50 {\n    background-color: var(--orange-50)!important\n  }\n\n  .bg-orange-100 {\n    background-color: var(--orange-100)!important\n  }\n\n  .bg-orange-200 {\n    background-color: var(--orange-200)!important\n  }\n\n  .bg-orange-300 {\n    background-color: var(--orange-300)!important\n  }\n\n  .bg-orange-400 {\n    background-color: var(--orange-400)!important\n  }\n\n  .bg-orange-500 {\n    background-color: var(--orange-500)!important\n  }\n\n  .bg-orange-600 {\n    background-color: var(--orange-600)!important\n  }\n\n  .bg-orange-700 {\n    background-color: var(--orange-700)!important\n  }\n\n  .bg-orange-800 {\n    background-color: var(--orange-800)!important\n  }\n\n  .bg-orange-900 {\n    background-color: var(--orange-900)!important\n  }\n\n  .focus\\:bg-orange-50:focus {\n    background-color: var(--orange-50)!important\n  }\n\n  .focus\\:bg-orange-100:focus {\n    background-color: var(--orange-100)!important\n  }\n\n  .focus\\:bg-orange-200:focus {\n    background-color: var(--orange-200)!important\n  }\n\n  .focus\\:bg-orange-300:focus {\n    background-color: var(--orange-300)!important\n  }\n\n  .focus\\:bg-orange-400:focus {\n    background-color: var(--orange-400)!important\n  }\n\n  .focus\\:bg-orange-500:focus {\n    background-color: var(--orange-500)!important\n  }\n\n  .focus\\:bg-orange-600:focus {\n    background-color: var(--orange-600)!important\n  }\n\n  .focus\\:bg-orange-700:focus {\n    background-color: var(--orange-700)!important\n  }\n\n  .focus\\:bg-orange-800:focus {\n    background-color: var(--orange-800)!important\n  }\n\n  .focus\\:bg-orange-900:focus {\n    background-color: var(--orange-900)!important\n  }\n\n  .hover\\:bg-orange-50:hover {\n    background-color: var(--orange-50)!important\n  }\n\n  .hover\\:bg-orange-100:hover {\n    background-color: var(--orange-100)!important\n  }\n\n  .hover\\:bg-orange-200:hover {\n    background-color: var(--orange-200)!important\n  }\n\n  .hover\\:bg-orange-300:hover {\n    background-color: var(--orange-300)!important\n  }\n\n  .hover\\:bg-orange-400:hover {\n    background-color: var(--orange-400)!important\n  }\n\n  .hover\\:bg-orange-500:hover {\n    background-color: var(--orange-500)!important\n  }\n\n  .hover\\:bg-orange-600:hover {\n    background-color: var(--orange-600)!important\n  }\n\n  .hover\\:bg-orange-700:hover {\n    background-color: var(--orange-700)!important\n  }\n\n  .hover\\:bg-orange-800:hover {\n    background-color: var(--orange-800)!important\n  }\n\n  .hover\\:bg-orange-900:hover {\n    background-color: var(--orange-900)!important\n  }\n\n  .active\\:bg-orange-50:active {\n    background-color: var(--orange-50)!important\n  }\n\n  .active\\:bg-orange-100:active {\n    background-color: var(--orange-100)!important\n  }\n\n  .active\\:bg-orange-200:active {\n    background-color: var(--orange-200)!important\n  }\n\n  .active\\:bg-orange-300:active {\n    background-color: var(--orange-300)!important\n  }\n\n  .active\\:bg-orange-400:active {\n    background-color: var(--orange-400)!important\n  }\n\n  .active\\:bg-orange-500:active {\n    background-color: var(--orange-500)!important\n  }\n\n  .active\\:bg-orange-600:active {\n    background-color: var(--orange-600)!important\n  }\n\n  .active\\:bg-orange-700:active {\n    background-color: var(--orange-700)!important\n  }\n\n  .active\\:bg-orange-800:active {\n    background-color: var(--orange-800)!important\n  }\n\n  .active\\:bg-orange-900:active {\n    background-color: var(--orange-900)!important\n  }\n\n  .bg-bluegray-50 {\n    background-color: var(--bluegray-50)!important\n  }\n\n  .bg-bluegray-100 {\n    background-color: var(--bluegray-100)!important\n  }\n\n  .bg-bluegray-200 {\n    background-color: var(--bluegray-200)!important\n  }\n\n  .bg-bluegray-300 {\n    background-color: var(--bluegray-300)!important\n  }\n\n  .bg-bluegray-400 {\n    background-color: var(--bluegray-400)!important\n  }\n\n  .bg-bluegray-500 {\n    background-color: var(--bluegray-500)!important\n  }\n\n  .bg-bluegray-600 {\n    background-color: var(--bluegray-600)!important\n  }\n\n  .bg-bluegray-700 {\n    background-color: var(--bluegray-700)!important\n  }\n\n  .bg-bluegray-800 {\n    background-color: var(--bluegray-800)!important\n  }\n\n  .bg-bluegray-900 {\n    background-color: var(--bluegray-900)!important\n  }\n\n  .focus\\:bg-bluegray-50:focus {\n    background-color: var(--bluegray-50)!important\n  }\n\n  .focus\\:bg-bluegray-100:focus {\n    background-color: var(--bluegray-100)!important\n  }\n\n  .focus\\:bg-bluegray-200:focus {\n    background-color: var(--bluegray-200)!important\n  }\n\n  .focus\\:bg-bluegray-300:focus {\n    background-color: var(--bluegray-300)!important\n  }\n\n  .focus\\:bg-bluegray-400:focus {\n    background-color: var(--bluegray-400)!important\n  }\n\n  .focus\\:bg-bluegray-500:focus {\n    background-color: var(--bluegray-500)!important\n  }\n\n  .focus\\:bg-bluegray-600:focus {\n    background-color: var(--bluegray-600)!important\n  }\n\n  .focus\\:bg-bluegray-700:focus {\n    background-color: var(--bluegray-700)!important\n  }\n\n  .focus\\:bg-bluegray-800:focus {\n    background-color: var(--bluegray-800)!important\n  }\n\n  .focus\\:bg-bluegray-900:focus {\n    background-color: var(--bluegray-900)!important\n  }\n\n  .hover\\:bg-bluegray-50:hover {\n    background-color: var(--bluegray-50)!important\n  }\n\n  .hover\\:bg-bluegray-100:hover {\n    background-color: var(--bluegray-100)!important\n  }\n\n  .hover\\:bg-bluegray-200:hover {\n    background-color: var(--bluegray-200)!important\n  }\n\n  .hover\\:bg-bluegray-300:hover {\n    background-color: var(--bluegray-300)!important\n  }\n\n  .hover\\:bg-bluegray-400:hover {\n    background-color: var(--bluegray-400)!important\n  }\n\n  .hover\\:bg-bluegray-500:hover {\n    background-color: var(--bluegray-500)!important\n  }\n\n  .hover\\:bg-bluegray-600:hover {\n    background-color: var(--bluegray-600)!important\n  }\n\n  .hover\\:bg-bluegray-700:hover {\n    background-color: var(--bluegray-700)!important\n  }\n\n  .hover\\:bg-bluegray-800:hover {\n    background-color: var(--bluegray-800)!important\n  }\n\n  .hover\\:bg-bluegray-900:hover {\n    background-color: var(--bluegray-900)!important\n  }\n\n  .active\\:bg-bluegray-50:active {\n    background-color: var(--bluegray-50)!important\n  }\n\n  .active\\:bg-bluegray-100:active {\n    background-color: var(--bluegray-100)!important\n  }\n\n  .active\\:bg-bluegray-200:active {\n    background-color: var(--bluegray-200)!important\n  }\n\n  .active\\:bg-bluegray-300:active {\n    background-color: var(--bluegray-300)!important\n  }\n\n  .active\\:bg-bluegray-400:active {\n    background-color: var(--bluegray-400)!important\n  }\n\n  .active\\:bg-bluegray-500:active {\n    background-color: var(--bluegray-500)!important\n  }\n\n  .active\\:bg-bluegray-600:active {\n    background-color: var(--bluegray-600)!important\n  }\n\n  .active\\:bg-bluegray-700:active {\n    background-color: var(--bluegray-700)!important\n  }\n\n  .active\\:bg-bluegray-800:active {\n    background-color: var(--bluegray-800)!important\n  }\n\n  .active\\:bg-bluegray-900:active {\n    background-color: var(--bluegray-900)!important\n  }\n\n  .bg-purple-50 {\n    background-color: var(--purple-50)!important\n  }\n\n  .bg-purple-100 {\n    background-color: var(--purple-100)!important\n  }\n\n  .bg-purple-200 {\n    background-color: var(--purple-200)!important\n  }\n\n  .bg-purple-300 {\n    background-color: var(--purple-300)!important\n  }\n\n  .bg-purple-400 {\n    background-color: var(--purple-400)!important\n  }\n\n  .bg-purple-500 {\n    background-color: var(--purple-500)!important\n  }\n\n  .bg-purple-600 {\n    background-color: var(--purple-600)!important\n  }\n\n  .bg-purple-700 {\n    background-color: var(--purple-700)!important\n  }\n\n  .bg-purple-800 {\n    background-color: var(--purple-800)!important\n  }\n\n  .bg-purple-900 {\n    background-color: var(--purple-900)!important\n  }\n\n  .focus\\:bg-purple-50:focus {\n    background-color: var(--purple-50)!important\n  }\n\n  .focus\\:bg-purple-100:focus {\n    background-color: var(--purple-100)!important\n  }\n\n  .focus\\:bg-purple-200:focus {\n    background-color: var(--purple-200)!important\n  }\n\n  .focus\\:bg-purple-300:focus {\n    background-color: var(--purple-300)!important\n  }\n\n  .focus\\:bg-purple-400:focus {\n    background-color: var(--purple-400)!important\n  }\n\n  .focus\\:bg-purple-500:focus {\n    background-color: var(--purple-500)!important\n  }\n\n  .focus\\:bg-purple-600:focus {\n    background-color: var(--purple-600)!important\n  }\n\n  .focus\\:bg-purple-700:focus {\n    background-color: var(--purple-700)!important\n  }\n\n  .focus\\:bg-purple-800:focus {\n    background-color: var(--purple-800)!important\n  }\n\n  .focus\\:bg-purple-900:focus {\n    background-color: var(--purple-900)!important\n  }\n\n  .hover\\:bg-purple-50:hover {\n    background-color: var(--purple-50)!important\n  }\n\n  .hover\\:bg-purple-100:hover {\n    background-color: var(--purple-100)!important\n  }\n\n  .hover\\:bg-purple-200:hover {\n    background-color: var(--purple-200)!important\n  }\n\n  .hover\\:bg-purple-300:hover {\n    background-color: var(--purple-300)!important\n  }\n\n  .hover\\:bg-purple-400:hover {\n    background-color: var(--purple-400)!important\n  }\n\n  .hover\\:bg-purple-500:hover {\n    background-color: var(--purple-500)!important\n  }\n\n  .hover\\:bg-purple-600:hover {\n    background-color: var(--purple-600)!important\n  }\n\n  .hover\\:bg-purple-700:hover {\n    background-color: var(--purple-700)!important\n  }\n\n  .hover\\:bg-purple-800:hover {\n    background-color: var(--purple-800)!important\n  }\n\n  .hover\\:bg-purple-900:hover {\n    background-color: var(--purple-900)!important\n  }\n\n  .active\\:bg-purple-50:active {\n    background-color: var(--purple-50)!important\n  }\n\n  .active\\:bg-purple-100:active {\n    background-color: var(--purple-100)!important\n  }\n\n  .active\\:bg-purple-200:active {\n    background-color: var(--purple-200)!important\n  }\n\n  .active\\:bg-purple-300:active {\n    background-color: var(--purple-300)!important\n  }\n\n  .active\\:bg-purple-400:active {\n    background-color: var(--purple-400)!important\n  }\n\n  .active\\:bg-purple-500:active {\n    background-color: var(--purple-500)!important\n  }\n\n  .active\\:bg-purple-600:active {\n    background-color: var(--purple-600)!important\n  }\n\n  .active\\:bg-purple-700:active {\n    background-color: var(--purple-700)!important\n  }\n\n  .active\\:bg-purple-800:active {\n    background-color: var(--purple-800)!important\n  }\n\n  .active\\:bg-purple-900:active {\n    background-color: var(--purple-900)!important\n  }\n\n  .bg-gray-50 {\n    background-color: var(--gray-50)!important\n  }\n\n  .bg-gray-100 {\n    background-color: var(--gray-100)!important\n  }\n\n  .bg-gray-200 {\n    background-color: var(--gray-200)!important\n  }\n\n  .bg-gray-300 {\n    background-color: var(--gray-300)!important\n  }\n\n  .bg-gray-400 {\n    background-color: var(--gray-400)!important\n  }\n\n  .bg-gray-500 {\n    background-color: var(--gray-500)!important\n  }\n\n  .bg-gray-600 {\n    background-color: var(--gray-600)!important\n  }\n\n  .bg-gray-700 {\n    background-color: var(--gray-700)!important\n  }\n\n  .bg-gray-800 {\n    background-color: var(--gray-800)!important\n  }\n\n  .bg-gray-900 {\n    background-color: var(--gray-900)!important\n  }\n\n  .focus\\:bg-gray-50:focus {\n    background-color: var(--gray-50)!important\n  }\n\n  .focus\\:bg-gray-100:focus {\n    background-color: var(--gray-100)!important\n  }\n\n  .focus\\:bg-gray-200:focus {\n    background-color: var(--gray-200)!important\n  }\n\n  .focus\\:bg-gray-300:focus {\n    background-color: var(--gray-300)!important\n  }\n\n  .focus\\:bg-gray-400:focus {\n    background-color: var(--gray-400)!important\n  }\n\n  .focus\\:bg-gray-500:focus {\n    background-color: var(--gray-500)!important\n  }\n\n  .focus\\:bg-gray-600:focus {\n    background-color: var(--gray-600)!important\n  }\n\n  .focus\\:bg-gray-700:focus {\n    background-color: var(--gray-700)!important\n  }\n\n  .focus\\:bg-gray-800:focus {\n    background-color: var(--gray-800)!important\n  }\n\n  .focus\\:bg-gray-900:focus {\n    background-color: var(--gray-900)!important\n  }\n\n  .hover\\:bg-gray-50:hover {\n    background-color: var(--gray-50)!important\n  }\n\n  .hover\\:bg-gray-100:hover {\n    background-color: var(--gray-100)!important\n  }\n\n  .hover\\:bg-gray-200:hover {\n    background-color: var(--gray-200)!important\n  }\n\n  .hover\\:bg-gray-300:hover {\n    background-color: var(--gray-300)!important\n  }\n\n  .hover\\:bg-gray-400:hover {\n    background-color: var(--gray-400)!important\n  }\n\n  .hover\\:bg-gray-500:hover {\n    background-color: var(--gray-500)!important\n  }\n\n  .hover\\:bg-gray-600:hover {\n    background-color: var(--gray-600)!important\n  }\n\n  .hover\\:bg-gray-700:hover {\n    background-color: var(--gray-700)!important\n  }\n\n  .hover\\:bg-gray-800:hover {\n    background-color: var(--gray-800)!important\n  }\n\n  .hover\\:bg-gray-900:hover {\n    background-color: var(--gray-900)!important\n  }\n\n  .active\\:bg-gray-50:active {\n    background-color: var(--gray-50)!important\n  }\n\n  .active\\:bg-gray-100:active {\n    background-color: var(--gray-100)!important\n  }\n\n  .active\\:bg-gray-200:active {\n    background-color: var(--gray-200)!important\n  }\n\n  .active\\:bg-gray-300:active {\n    background-color: var(--gray-300)!important\n  }\n\n  .active\\:bg-gray-400:active {\n    background-color: var(--gray-400)!important\n  }\n\n  .active\\:bg-gray-500:active {\n    background-color: var(--gray-500)!important\n  }\n\n  .active\\:bg-gray-600:active {\n    background-color: var(--gray-600)!important\n  }\n\n  .active\\:bg-gray-700:active {\n    background-color: var(--gray-700)!important\n  }\n\n  .active\\:bg-gray-800:active {\n    background-color: var(--gray-800)!important\n  }\n\n  .active\\:bg-gray-900:active {\n    background-color: var(--gray-900)!important\n  }\n\n  .bg-red-50 {\n    background-color: var(--red-50)!important\n  }\n\n  .bg-red-100 {\n    background-color: var(--red-100)!important\n  }\n\n  .bg-red-200 {\n    background-color: var(--red-200)!important\n  }\n\n  .bg-red-300 {\n    background-color: var(--red-300)!important\n  }\n\n  .bg-red-400 {\n    background-color: var(--red-400)!important\n  }\n\n  .bg-red-500 {\n    background-color: var(--red-500)!important\n  }\n\n  .bg-red-600 {\n    background-color: var(--red-600)!important\n  }\n\n  .bg-red-700 {\n    background-color: var(--red-700)!important\n  }\n\n  .bg-red-800 {\n    background-color: var(--red-800)!important\n  }\n\n  .bg-red-900 {\n    background-color: var(--red-900)!important\n  }\n\n  .focus\\:bg-red-50:focus {\n    background-color: var(--red-50)!important\n  }\n\n  .focus\\:bg-red-100:focus {\n    background-color: var(--red-100)!important\n  }\n\n  .focus\\:bg-red-200:focus {\n    background-color: var(--red-200)!important\n  }\n\n  .focus\\:bg-red-300:focus {\n    background-color: var(--red-300)!important\n  }\n\n  .focus\\:bg-red-400:focus {\n    background-color: var(--red-400)!important\n  }\n\n  .focus\\:bg-red-500:focus {\n    background-color: var(--red-500)!important\n  }\n\n  .focus\\:bg-red-600:focus {\n    background-color: var(--red-600)!important\n  }\n\n  .focus\\:bg-red-700:focus {\n    background-color: var(--red-700)!important\n  }\n\n  .focus\\:bg-red-800:focus {\n    background-color: var(--red-800)!important\n  }\n\n  .focus\\:bg-red-900:focus {\n    background-color: var(--red-900)!important\n  }\n\n  .hover\\:bg-red-50:hover {\n    background-color: var(--red-50)!important\n  }\n\n  .hover\\:bg-red-100:hover {\n    background-color: var(--red-100)!important\n  }\n\n  .hover\\:bg-red-200:hover {\n    background-color: var(--red-200)!important\n  }\n\n  .hover\\:bg-red-300:hover {\n    background-color: var(--red-300)!important\n  }\n\n  .hover\\:bg-red-400:hover {\n    background-color: var(--red-400)!important\n  }\n\n  .hover\\:bg-red-500:hover {\n    background-color: var(--red-500)!important\n  }\n\n  .hover\\:bg-red-600:hover {\n    background-color: var(--red-600)!important\n  }\n\n  .hover\\:bg-red-700:hover {\n    background-color: var(--red-700)!important\n  }\n\n  .hover\\:bg-red-800:hover {\n    background-color: var(--red-800)!important\n  }\n\n  .hover\\:bg-red-900:hover {\n    background-color: var(--red-900)!important\n  }\n\n  .active\\:bg-red-50:active {\n    background-color: var(--red-50)!important\n  }\n\n  .active\\:bg-red-100:active {\n    background-color: var(--red-100)!important\n  }\n\n  .active\\:bg-red-200:active {\n    background-color: var(--red-200)!important\n  }\n\n  .active\\:bg-red-300:active {\n    background-color: var(--red-300)!important\n  }\n\n  .active\\:bg-red-400:active {\n    background-color: var(--red-400)!important\n  }\n\n  .active\\:bg-red-500:active {\n    background-color: var(--red-500)!important\n  }\n\n  .active\\:bg-red-600:active {\n    background-color: var(--red-600)!important\n  }\n\n  .active\\:bg-red-700:active {\n    background-color: var(--red-700)!important\n  }\n\n  .active\\:bg-red-800:active {\n    background-color: var(--red-800)!important\n  }\n\n  .active\\:bg-red-900:active {\n    background-color: var(--red-900)!important\n  }\n\n  .bg-primary-50 {\n    background-color: var(--primary-50)!important\n  }\n\n  .bg-primary-100 {\n    background-color: var(--primary-100)!important\n  }\n\n  .bg-primary-200 {\n    background-color: var(--primary-200)!important\n  }\n\n  .bg-primary-300 {\n    background-color: var(--primary-300)!important\n  }\n\n  .bg-primary-400 {\n    background-color: var(--primary-400)!important\n  }\n\n  .bg-primary-500 {\n    background-color: var(--primary-500)!important\n  }\n\n  .bg-primary-600 {\n    background-color: var(--primary-600)!important\n  }\n\n  .bg-primary-700 {\n    background-color: var(--primary-700)!important\n  }\n\n  .bg-primary-800 {\n    background-color: var(--primary-800)!important\n  }\n\n  .bg-primary-900 {\n    background-color: var(--primary-900)!important\n  }\n\n  .focus\\:bg-primary-50:focus {\n    background-color: var(--primary-50)!important\n  }\n\n  .focus\\:bg-primary-100:focus {\n    background-color: var(--primary-100)!important\n  }\n\n  .focus\\:bg-primary-200:focus {\n    background-color: var(--primary-200)!important\n  }\n\n  .focus\\:bg-primary-300:focus {\n    background-color: var(--primary-300)!important\n  }\n\n  .focus\\:bg-primary-400:focus {\n    background-color: var(--primary-400)!important\n  }\n\n  .focus\\:bg-primary-500:focus {\n    background-color: var(--primary-500)!important\n  }\n\n  .focus\\:bg-primary-600:focus {\n    background-color: var(--primary-600)!important\n  }\n\n  .focus\\:bg-primary-700:focus {\n    background-color: var(--primary-700)!important\n  }\n\n  .focus\\:bg-primary-800:focus {\n    background-color: var(--primary-800)!important\n  }\n\n  .focus\\:bg-primary-900:focus {\n    background-color: var(--primary-900)!important\n  }\n\n  .hover\\:bg-primary-50:hover {\n    background-color: var(--primary-50)!important\n  }\n\n  .hover\\:bg-primary-100:hover {\n    background-color: var(--primary-100)!important\n  }\n\n  .hover\\:bg-primary-200:hover {\n    background-color: var(--primary-200)!important\n  }\n\n  .hover\\:bg-primary-300:hover {\n    background-color: var(--primary-300)!important\n  }\n\n  .hover\\:bg-primary-400:hover {\n    background-color: var(--primary-400)!important\n  }\n\n  .hover\\:bg-primary-500:hover {\n    background-color: var(--primary-500)!important\n  }\n\n  .hover\\:bg-primary-600:hover {\n    background-color: var(--primary-600)!important\n  }\n\n  .hover\\:bg-primary-700:hover {\n    background-color: var(--primary-700)!important\n  }\n\n  .hover\\:bg-primary-800:hover {\n    background-color: var(--primary-800)!important\n  }\n\n  .hover\\:bg-primary-900:hover {\n    background-color: var(--primary-900)!important\n  }\n\n  .active\\:bg-primary-50:active {\n    background-color: var(--primary-50)!important\n  }\n\n  .active\\:bg-primary-100:active {\n    background-color: var(--primary-100)!important\n  }\n\n  .active\\:bg-primary-200:active {\n    background-color: var(--primary-200)!important\n  }\n\n  .active\\:bg-primary-300:active {\n    background-color: var(--primary-300)!important\n  }\n\n  .active\\:bg-primary-400:active {\n    background-color: var(--primary-400)!important\n  }\n\n  .active\\:bg-primary-500:active {\n    background-color: var(--primary-500)!important\n  }\n\n  .active\\:bg-primary-600:active {\n    background-color: var(--primary-600)!important\n  }\n\n  .active\\:bg-primary-700:active {\n    background-color: var(--primary-700)!important\n  }\n\n  .active\\:bg-primary-800:active {\n    background-color: var(--primary-800)!important\n  }\n\n  .active\\:bg-primary-900:active {\n    background-color: var(--primary-900)!important\n  }\n\n  .border-blue-50 {\n    border-color: var(--blue-50)!important\n  }\n\n  .border-blue-100 {\n    border-color: var(--blue-100)!important\n  }\n\n  .border-blue-200 {\n    border-color: var(--blue-200)!important\n  }\n\n  .border-blue-300 {\n    border-color: var(--blue-300)!important\n  }\n\n  .border-blue-400 {\n    border-color: var(--blue-400)!important\n  }\n\n  .border-blue-500 {\n    border-color: var(--blue-500)!important\n  }\n\n  .border-blue-600 {\n    border-color: var(--blue-600)!important\n  }\n\n  .border-blue-700 {\n    border-color: var(--blue-700)!important\n  }\n\n  .border-blue-800 {\n    border-color: var(--blue-800)!important\n  }\n\n  .border-blue-900 {\n    border-color: var(--blue-900)!important\n  }\n\n  .focus\\:border-blue-50:focus {\n    border-color: var(--blue-50)!important\n  }\n\n  .focus\\:border-blue-100:focus {\n    border-color: var(--blue-100)!important\n  }\n\n  .focus\\:border-blue-200:focus {\n    border-color: var(--blue-200)!important\n  }\n\n  .focus\\:border-blue-300:focus {\n    border-color: var(--blue-300)!important\n  }\n\n  .focus\\:border-blue-400:focus {\n    border-color: var(--blue-400)!important\n  }\n\n  .focus\\:border-blue-500:focus {\n    border-color: var(--blue-500)!important\n  }\n\n  .focus\\:border-blue-600:focus {\n    border-color: var(--blue-600)!important\n  }\n\n  .focus\\:border-blue-700:focus {\n    border-color: var(--blue-700)!important\n  }\n\n  .focus\\:border-blue-800:focus {\n    border-color: var(--blue-800)!important\n  }\n\n  .focus\\:border-blue-900:focus {\n    border-color: var(--blue-900)!important\n  }\n\n  .hover\\:border-blue-50:hover {\n    border-color: var(--blue-50)!important\n  }\n\n  .hover\\:border-blue-100:hover {\n    border-color: var(--blue-100)!important\n  }\n\n  .hover\\:border-blue-200:hover {\n    border-color: var(--blue-200)!important\n  }\n\n  .hover\\:border-blue-300:hover {\n    border-color: var(--blue-300)!important\n  }\n\n  .hover\\:border-blue-400:hover {\n    border-color: var(--blue-400)!important\n  }\n\n  .hover\\:border-blue-500:hover {\n    border-color: var(--blue-500)!important\n  }\n\n  .hover\\:border-blue-600:hover {\n    border-color: var(--blue-600)!important\n  }\n\n  .hover\\:border-blue-700:hover {\n    border-color: var(--blue-700)!important\n  }\n\n  .hover\\:border-blue-800:hover {\n    border-color: var(--blue-800)!important\n  }\n\n  .hover\\:border-blue-900:hover {\n    border-color: var(--blue-900)!important\n  }\n\n  .active\\:border-blue-50:active {\n    border-color: var(--blue-50)!important\n  }\n\n  .active\\:border-blue-100:active {\n    border-color: var(--blue-100)!important\n  }\n\n  .active\\:border-blue-200:active {\n    border-color: var(--blue-200)!important\n  }\n\n  .active\\:border-blue-300:active {\n    border-color: var(--blue-300)!important\n  }\n\n  .active\\:border-blue-400:active {\n    border-color: var(--blue-400)!important\n  }\n\n  .active\\:border-blue-500:active {\n    border-color: var(--blue-500)!important\n  }\n\n  .active\\:border-blue-600:active {\n    border-color: var(--blue-600)!important\n  }\n\n  .active\\:border-blue-700:active {\n    border-color: var(--blue-700)!important\n  }\n\n  .active\\:border-blue-800:active {\n    border-color: var(--blue-800)!important\n  }\n\n  .active\\:border-blue-900:active {\n    border-color: var(--blue-900)!important\n  }\n\n  .border-green-50 {\n    border-color: var(--green-50)!important\n  }\n\n  .border-green-100 {\n    border-color: var(--green-100)!important\n  }\n\n  .border-green-200 {\n    border-color: var(--green-200)!important\n  }\n\n  .border-green-300 {\n    border-color: var(--green-300)!important\n  }\n\n  .border-green-400 {\n    border-color: var(--green-400)!important\n  }\n\n  .border-green-500 {\n    border-color: var(--green-500)!important\n  }\n\n  .border-green-600 {\n    border-color: var(--green-600)!important\n  }\n\n  .border-green-700 {\n    border-color: var(--green-700)!important\n  }\n\n  .border-green-800 {\n    border-color: var(--green-800)!important\n  }\n\n  .border-green-900 {\n    border-color: var(--green-900)!important\n  }\n\n  .focus\\:border-green-50:focus {\n    border-color: var(--green-50)!important\n  }\n\n  .focus\\:border-green-100:focus {\n    border-color: var(--green-100)!important\n  }\n\n  .focus\\:border-green-200:focus {\n    border-color: var(--green-200)!important\n  }\n\n  .focus\\:border-green-300:focus {\n    border-color: var(--green-300)!important\n  }\n\n  .focus\\:border-green-400:focus {\n    border-color: var(--green-400)!important\n  }\n\n  .focus\\:border-green-500:focus {\n    border-color: var(--green-500)!important\n  }\n\n  .focus\\:border-green-600:focus {\n    border-color: var(--green-600)!important\n  }\n\n  .focus\\:border-green-700:focus {\n    border-color: var(--green-700)!important\n  }\n\n  .focus\\:border-green-800:focus {\n    border-color: var(--green-800)!important\n  }\n\n  .focus\\:border-green-900:focus {\n    border-color: var(--green-900)!important\n  }\n\n  .hover\\:border-green-50:hover {\n    border-color: var(--green-50)!important\n  }\n\n  .hover\\:border-green-100:hover {\n    border-color: var(--green-100)!important\n  }\n\n  .hover\\:border-green-200:hover {\n    border-color: var(--green-200)!important\n  }\n\n  .hover\\:border-green-300:hover {\n    border-color: var(--green-300)!important\n  }\n\n  .hover\\:border-green-400:hover {\n    border-color: var(--green-400)!important\n  }\n\n  .hover\\:border-green-500:hover {\n    border-color: var(--green-500)!important\n  }\n\n  .hover\\:border-green-600:hover {\n    border-color: var(--green-600)!important\n  }\n\n  .hover\\:border-green-700:hover {\n    border-color: var(--green-700)!important\n  }\n\n  .hover\\:border-green-800:hover {\n    border-color: var(--green-800)!important\n  }\n\n  .hover\\:border-green-900:hover {\n    border-color: var(--green-900)!important\n  }\n\n  .active\\:border-green-50:active {\n    border-color: var(--green-50)!important\n  }\n\n  .active\\:border-green-100:active {\n    border-color: var(--green-100)!important\n  }\n\n  .active\\:border-green-200:active {\n    border-color: var(--green-200)!important\n  }\n\n  .active\\:border-green-300:active {\n    border-color: var(--green-300)!important\n  }\n\n  .active\\:border-green-400:active {\n    border-color: var(--green-400)!important\n  }\n\n  .active\\:border-green-500:active {\n    border-color: var(--green-500)!important\n  }\n\n  .active\\:border-green-600:active {\n    border-color: var(--green-600)!important\n  }\n\n  .active\\:border-green-700:active {\n    border-color: var(--green-700)!important\n  }\n\n  .active\\:border-green-800:active {\n    border-color: var(--green-800)!important\n  }\n\n  .active\\:border-green-900:active {\n    border-color: var(--green-900)!important\n  }\n\n  .border-yellow-50 {\n    border-color: var(--yellow-50)!important\n  }\n\n  .border-yellow-100 {\n    border-color: var(--yellow-100)!important\n  }\n\n  .border-yellow-200 {\n    border-color: var(--yellow-200)!important\n  }\n\n  .border-yellow-300 {\n    border-color: var(--yellow-300)!important\n  }\n\n  .border-yellow-400 {\n    border-color: var(--yellow-400)!important\n  }\n\n  .border-yellow-500 {\n    border-color: var(--yellow-500)!important\n  }\n\n  .border-yellow-600 {\n    border-color: var(--yellow-600)!important\n  }\n\n  .border-yellow-700 {\n    border-color: var(--yellow-700)!important\n  }\n\n  .border-yellow-800 {\n    border-color: var(--yellow-800)!important\n  }\n\n  .border-yellow-900 {\n    border-color: var(--yellow-900)!important\n  }\n\n  .focus\\:border-yellow-50:focus {\n    border-color: var(--yellow-50)!important\n  }\n\n  .focus\\:border-yellow-100:focus {\n    border-color: var(--yellow-100)!important\n  }\n\n  .focus\\:border-yellow-200:focus {\n    border-color: var(--yellow-200)!important\n  }\n\n  .focus\\:border-yellow-300:focus {\n    border-color: var(--yellow-300)!important\n  }\n\n  .focus\\:border-yellow-400:focus {\n    border-color: var(--yellow-400)!important\n  }\n\n  .focus\\:border-yellow-500:focus {\n    border-color: var(--yellow-500)!important\n  }\n\n  .focus\\:border-yellow-600:focus {\n    border-color: var(--yellow-600)!important\n  }\n\n  .focus\\:border-yellow-700:focus {\n    border-color: var(--yellow-700)!important\n  }\n\n  .focus\\:border-yellow-800:focus {\n    border-color: var(--yellow-800)!important\n  }\n\n  .focus\\:border-yellow-900:focus {\n    border-color: var(--yellow-900)!important\n  }\n\n  .hover\\:border-yellow-50:hover {\n    border-color: var(--yellow-50)!important\n  }\n\n  .hover\\:border-yellow-100:hover {\n    border-color: var(--yellow-100)!important\n  }\n\n  .hover\\:border-yellow-200:hover {\n    border-color: var(--yellow-200)!important\n  }\n\n  .hover\\:border-yellow-300:hover {\n    border-color: var(--yellow-300)!important\n  }\n\n  .hover\\:border-yellow-400:hover {\n    border-color: var(--yellow-400)!important\n  }\n\n  .hover\\:border-yellow-500:hover {\n    border-color: var(--yellow-500)!important\n  }\n\n  .hover\\:border-yellow-600:hover {\n    border-color: var(--yellow-600)!important\n  }\n\n  .hover\\:border-yellow-700:hover {\n    border-color: var(--yellow-700)!important\n  }\n\n  .hover\\:border-yellow-800:hover {\n    border-color: var(--yellow-800)!important\n  }\n\n  .hover\\:border-yellow-900:hover {\n    border-color: var(--yellow-900)!important\n  }\n\n  .active\\:border-yellow-50:active {\n    border-color: var(--yellow-50)!important\n  }\n\n  .active\\:border-yellow-100:active {\n    border-color: var(--yellow-100)!important\n  }\n\n  .active\\:border-yellow-200:active {\n    border-color: var(--yellow-200)!important\n  }\n\n  .active\\:border-yellow-300:active {\n    border-color: var(--yellow-300)!important\n  }\n\n  .active\\:border-yellow-400:active {\n    border-color: var(--yellow-400)!important\n  }\n\n  .active\\:border-yellow-500:active {\n    border-color: var(--yellow-500)!important\n  }\n\n  .active\\:border-yellow-600:active {\n    border-color: var(--yellow-600)!important\n  }\n\n  .active\\:border-yellow-700:active {\n    border-color: var(--yellow-700)!important\n  }\n\n  .active\\:border-yellow-800:active {\n    border-color: var(--yellow-800)!important\n  }\n\n  .active\\:border-yellow-900:active {\n    border-color: var(--yellow-900)!important\n  }\n\n  .border-cyan-50 {\n    border-color: var(--cyan-50)!important\n  }\n\n  .border-cyan-100 {\n    border-color: var(--cyan-100)!important\n  }\n\n  .border-cyan-200 {\n    border-color: var(--cyan-200)!important\n  }\n\n  .border-cyan-300 {\n    border-color: var(--cyan-300)!important\n  }\n\n  .border-cyan-400 {\n    border-color: var(--cyan-400)!important\n  }\n\n  .border-cyan-500 {\n    border-color: var(--cyan-500)!important\n  }\n\n  .border-cyan-600 {\n    border-color: var(--cyan-600)!important\n  }\n\n  .border-cyan-700 {\n    border-color: var(--cyan-700)!important\n  }\n\n  .border-cyan-800 {\n    border-color: var(--cyan-800)!important\n  }\n\n  .border-cyan-900 {\n    border-color: var(--cyan-900)!important\n  }\n\n  .focus\\:border-cyan-50:focus {\n    border-color: var(--cyan-50)!important\n  }\n\n  .focus\\:border-cyan-100:focus {\n    border-color: var(--cyan-100)!important\n  }\n\n  .focus\\:border-cyan-200:focus {\n    border-color: var(--cyan-200)!important\n  }\n\n  .focus\\:border-cyan-300:focus {\n    border-color: var(--cyan-300)!important\n  }\n\n  .focus\\:border-cyan-400:focus {\n    border-color: var(--cyan-400)!important\n  }\n\n  .focus\\:border-cyan-500:focus {\n    border-color: var(--cyan-500)!important\n  }\n\n  .focus\\:border-cyan-600:focus {\n    border-color: var(--cyan-600)!important\n  }\n\n  .focus\\:border-cyan-700:focus {\n    border-color: var(--cyan-700)!important\n  }\n\n  .focus\\:border-cyan-800:focus {\n    border-color: var(--cyan-800)!important\n  }\n\n  .focus\\:border-cyan-900:focus {\n    border-color: var(--cyan-900)!important\n  }\n\n  .hover\\:border-cyan-50:hover {\n    border-color: var(--cyan-50)!important\n  }\n\n  .hover\\:border-cyan-100:hover {\n    border-color: var(--cyan-100)!important\n  }\n\n  .hover\\:border-cyan-200:hover {\n    border-color: var(--cyan-200)!important\n  }\n\n  .hover\\:border-cyan-300:hover {\n    border-color: var(--cyan-300)!important\n  }\n\n  .hover\\:border-cyan-400:hover {\n    border-color: var(--cyan-400)!important\n  }\n\n  .hover\\:border-cyan-500:hover {\n    border-color: var(--cyan-500)!important\n  }\n\n  .hover\\:border-cyan-600:hover {\n    border-color: var(--cyan-600)!important\n  }\n\n  .hover\\:border-cyan-700:hover {\n    border-color: var(--cyan-700)!important\n  }\n\n  .hover\\:border-cyan-800:hover {\n    border-color: var(--cyan-800)!important\n  }\n\n  .hover\\:border-cyan-900:hover {\n    border-color: var(--cyan-900)!important\n  }\n\n  .active\\:border-cyan-50:active {\n    border-color: var(--cyan-50)!important\n  }\n\n  .active\\:border-cyan-100:active {\n    border-color: var(--cyan-100)!important\n  }\n\n  .active\\:border-cyan-200:active {\n    border-color: var(--cyan-200)!important\n  }\n\n  .active\\:border-cyan-300:active {\n    border-color: var(--cyan-300)!important\n  }\n\n  .active\\:border-cyan-400:active {\n    border-color: var(--cyan-400)!important\n  }\n\n  .active\\:border-cyan-500:active {\n    border-color: var(--cyan-500)!important\n  }\n\n  .active\\:border-cyan-600:active {\n    border-color: var(--cyan-600)!important\n  }\n\n  .active\\:border-cyan-700:active {\n    border-color: var(--cyan-700)!important\n  }\n\n  .active\\:border-cyan-800:active {\n    border-color: var(--cyan-800)!important\n  }\n\n  .active\\:border-cyan-900:active {\n    border-color: var(--cyan-900)!important\n  }\n\n  .border-pink-50 {\n    border-color: var(--pink-50)!important\n  }\n\n  .border-pink-100 {\n    border-color: var(--pink-100)!important\n  }\n\n  .border-pink-200 {\n    border-color: var(--pink-200)!important\n  }\n\n  .border-pink-300 {\n    border-color: var(--pink-300)!important\n  }\n\n  .border-pink-400 {\n    border-color: var(--pink-400)!important\n  }\n\n  .border-pink-500 {\n    border-color: var(--pink-500)!important\n  }\n\n  .border-pink-600 {\n    border-color: var(--pink-600)!important\n  }\n\n  .border-pink-700 {\n    border-color: var(--pink-700)!important\n  }\n\n  .border-pink-800 {\n    border-color: var(--pink-800)!important\n  }\n\n  .border-pink-900 {\n    border-color: var(--pink-900)!important\n  }\n\n  .focus\\:border-pink-50:focus {\n    border-color: var(--pink-50)!important\n  }\n\n  .focus\\:border-pink-100:focus {\n    border-color: var(--pink-100)!important\n  }\n\n  .focus\\:border-pink-200:focus {\n    border-color: var(--pink-200)!important\n  }\n\n  .focus\\:border-pink-300:focus {\n    border-color: var(--pink-300)!important\n  }\n\n  .focus\\:border-pink-400:focus {\n    border-color: var(--pink-400)!important\n  }\n\n  .focus\\:border-pink-500:focus {\n    border-color: var(--pink-500)!important\n  }\n\n  .focus\\:border-pink-600:focus {\n    border-color: var(--pink-600)!important\n  }\n\n  .focus\\:border-pink-700:focus {\n    border-color: var(--pink-700)!important\n  }\n\n  .focus\\:border-pink-800:focus {\n    border-color: var(--pink-800)!important\n  }\n\n  .focus\\:border-pink-900:focus {\n    border-color: var(--pink-900)!important\n  }\n\n  .hover\\:border-pink-50:hover {\n    border-color: var(--pink-50)!important\n  }\n\n  .hover\\:border-pink-100:hover {\n    border-color: var(--pink-100)!important\n  }\n\n  .hover\\:border-pink-200:hover {\n    border-color: var(--pink-200)!important\n  }\n\n  .hover\\:border-pink-300:hover {\n    border-color: var(--pink-300)!important\n  }\n\n  .hover\\:border-pink-400:hover {\n    border-color: var(--pink-400)!important\n  }\n\n  .hover\\:border-pink-500:hover {\n    border-color: var(--pink-500)!important\n  }\n\n  .hover\\:border-pink-600:hover {\n    border-color: var(--pink-600)!important\n  }\n\n  .hover\\:border-pink-700:hover {\n    border-color: var(--pink-700)!important\n  }\n\n  .hover\\:border-pink-800:hover {\n    border-color: var(--pink-800)!important\n  }\n\n  .hover\\:border-pink-900:hover {\n    border-color: var(--pink-900)!important\n  }\n\n  .active\\:border-pink-50:active {\n    border-color: var(--pink-50)!important\n  }\n\n  .active\\:border-pink-100:active {\n    border-color: var(--pink-100)!important\n  }\n\n  .active\\:border-pink-200:active {\n    border-color: var(--pink-200)!important\n  }\n\n  .active\\:border-pink-300:active {\n    border-color: var(--pink-300)!important\n  }\n\n  .active\\:border-pink-400:active {\n    border-color: var(--pink-400)!important\n  }\n\n  .active\\:border-pink-500:active {\n    border-color: var(--pink-500)!important\n  }\n\n  .active\\:border-pink-600:active {\n    border-color: var(--pink-600)!important\n  }\n\n  .active\\:border-pink-700:active {\n    border-color: var(--pink-700)!important\n  }\n\n  .active\\:border-pink-800:active {\n    border-color: var(--pink-800)!important\n  }\n\n  .active\\:border-pink-900:active {\n    border-color: var(--pink-900)!important\n  }\n\n  .border-indigo-50 {\n    border-color: var(--indigo-50)!important\n  }\n\n  .border-indigo-100 {\n    border-color: var(--indigo-100)!important\n  }\n\n  .border-indigo-200 {\n    border-color: var(--indigo-200)!important\n  }\n\n  .border-indigo-300 {\n    border-color: var(--indigo-300)!important\n  }\n\n  .border-indigo-400 {\n    border-color: var(--indigo-400)!important\n  }\n\n  .border-indigo-500 {\n    border-color: var(--indigo-500)!important\n  }\n\n  .border-indigo-600 {\n    border-color: var(--indigo-600)!important\n  }\n\n  .border-indigo-700 {\n    border-color: var(--indigo-700)!important\n  }\n\n  .border-indigo-800 {\n    border-color: var(--indigo-800)!important\n  }\n\n  .border-indigo-900 {\n    border-color: var(--indigo-900)!important\n  }\n\n  .focus\\:border-indigo-50:focus {\n    border-color: var(--indigo-50)!important\n  }\n\n  .focus\\:border-indigo-100:focus {\n    border-color: var(--indigo-100)!important\n  }\n\n  .focus\\:border-indigo-200:focus {\n    border-color: var(--indigo-200)!important\n  }\n\n  .focus\\:border-indigo-300:focus {\n    border-color: var(--indigo-300)!important\n  }\n\n  .focus\\:border-indigo-400:focus {\n    border-color: var(--indigo-400)!important\n  }\n\n  .focus\\:border-indigo-500:focus {\n    border-color: var(--indigo-500)!important\n  }\n\n  .focus\\:border-indigo-600:focus {\n    border-color: var(--indigo-600)!important\n  }\n\n  .focus\\:border-indigo-700:focus {\n    border-color: var(--indigo-700)!important\n  }\n\n  .focus\\:border-indigo-800:focus {\n    border-color: var(--indigo-800)!important\n  }\n\n  .focus\\:border-indigo-900:focus {\n    border-color: var(--indigo-900)!important\n  }\n\n  .hover\\:border-indigo-50:hover {\n    border-color: var(--indigo-50)!important\n  }\n\n  .hover\\:border-indigo-100:hover {\n    border-color: var(--indigo-100)!important\n  }\n\n  .hover\\:border-indigo-200:hover {\n    border-color: var(--indigo-200)!important\n  }\n\n  .hover\\:border-indigo-300:hover {\n    border-color: var(--indigo-300)!important\n  }\n\n  .hover\\:border-indigo-400:hover {\n    border-color: var(--indigo-400)!important\n  }\n\n  .hover\\:border-indigo-500:hover {\n    border-color: var(--indigo-500)!important\n  }\n\n  .hover\\:border-indigo-600:hover {\n    border-color: var(--indigo-600)!important\n  }\n\n  .hover\\:border-indigo-700:hover {\n    border-color: var(--indigo-700)!important\n  }\n\n  .hover\\:border-indigo-800:hover {\n    border-color: var(--indigo-800)!important\n  }\n\n  .hover\\:border-indigo-900:hover {\n    border-color: var(--indigo-900)!important\n  }\n\n  .active\\:border-indigo-50:active {\n    border-color: var(--indigo-50)!important\n  }\n\n  .active\\:border-indigo-100:active {\n    border-color: var(--indigo-100)!important\n  }\n\n  .active\\:border-indigo-200:active {\n    border-color: var(--indigo-200)!important\n  }\n\n  .active\\:border-indigo-300:active {\n    border-color: var(--indigo-300)!important\n  }\n\n  .active\\:border-indigo-400:active {\n    border-color: var(--indigo-400)!important\n  }\n\n  .active\\:border-indigo-500:active {\n    border-color: var(--indigo-500)!important\n  }\n\n  .active\\:border-indigo-600:active {\n    border-color: var(--indigo-600)!important\n  }\n\n  .active\\:border-indigo-700:active {\n    border-color: var(--indigo-700)!important\n  }\n\n  .active\\:border-indigo-800:active {\n    border-color: var(--indigo-800)!important\n  }\n\n  .active\\:border-indigo-900:active {\n    border-color: var(--indigo-900)!important\n  }\n\n  .border-teal-50 {\n    border-color: var(--teal-50)!important\n  }\n\n  .border-teal-100 {\n    border-color: var(--teal-100)!important\n  }\n\n  .border-teal-200 {\n    border-color: var(--teal-200)!important\n  }\n\n  .border-teal-300 {\n    border-color: var(--teal-300)!important\n  }\n\n  .border-teal-400 {\n    border-color: var(--teal-400)!important\n  }\n\n  .border-teal-500 {\n    border-color: var(--teal-500)!important\n  }\n\n  .border-teal-600 {\n    border-color: var(--teal-600)!important\n  }\n\n  .border-teal-700 {\n    border-color: var(--teal-700)!important\n  }\n\n  .border-teal-800 {\n    border-color: var(--teal-800)!important\n  }\n\n  .border-teal-900 {\n    border-color: var(--teal-900)!important\n  }\n\n  .focus\\:border-teal-50:focus {\n    border-color: var(--teal-50)!important\n  }\n\n  .focus\\:border-teal-100:focus {\n    border-color: var(--teal-100)!important\n  }\n\n  .focus\\:border-teal-200:focus {\n    border-color: var(--teal-200)!important\n  }\n\n  .focus\\:border-teal-300:focus {\n    border-color: var(--teal-300)!important\n  }\n\n  .focus\\:border-teal-400:focus {\n    border-color: var(--teal-400)!important\n  }\n\n  .focus\\:border-teal-500:focus {\n    border-color: var(--teal-500)!important\n  }\n\n  .focus\\:border-teal-600:focus {\n    border-color: var(--teal-600)!important\n  }\n\n  .focus\\:border-teal-700:focus {\n    border-color: var(--teal-700)!important\n  }\n\n  .focus\\:border-teal-800:focus {\n    border-color: var(--teal-800)!important\n  }\n\n  .focus\\:border-teal-900:focus {\n    border-color: var(--teal-900)!important\n  }\n\n  .hover\\:border-teal-50:hover {\n    border-color: var(--teal-50)!important\n  }\n\n  .hover\\:border-teal-100:hover {\n    border-color: var(--teal-100)!important\n  }\n\n  .hover\\:border-teal-200:hover {\n    border-color: var(--teal-200)!important\n  }\n\n  .hover\\:border-teal-300:hover {\n    border-color: var(--teal-300)!important\n  }\n\n  .hover\\:border-teal-400:hover {\n    border-color: var(--teal-400)!important\n  }\n\n  .hover\\:border-teal-500:hover {\n    border-color: var(--teal-500)!important\n  }\n\n  .hover\\:border-teal-600:hover {\n    border-color: var(--teal-600)!important\n  }\n\n  .hover\\:border-teal-700:hover {\n    border-color: var(--teal-700)!important\n  }\n\n  .hover\\:border-teal-800:hover {\n    border-color: var(--teal-800)!important\n  }\n\n  .hover\\:border-teal-900:hover {\n    border-color: var(--teal-900)!important\n  }\n\n  .active\\:border-teal-50:active {\n    border-color: var(--teal-50)!important\n  }\n\n  .active\\:border-teal-100:active {\n    border-color: var(--teal-100)!important\n  }\n\n  .active\\:border-teal-200:active {\n    border-color: var(--teal-200)!important\n  }\n\n  .active\\:border-teal-300:active {\n    border-color: var(--teal-300)!important\n  }\n\n  .active\\:border-teal-400:active {\n    border-color: var(--teal-400)!important\n  }\n\n  .active\\:border-teal-500:active {\n    border-color: var(--teal-500)!important\n  }\n\n  .active\\:border-teal-600:active {\n    border-color: var(--teal-600)!important\n  }\n\n  .active\\:border-teal-700:active {\n    border-color: var(--teal-700)!important\n  }\n\n  .active\\:border-teal-800:active {\n    border-color: var(--teal-800)!important\n  }\n\n  .active\\:border-teal-900:active {\n    border-color: var(--teal-900)!important\n  }\n\n  .border-orange-50 {\n    border-color: var(--orange-50)!important\n  }\n\n  .border-orange-100 {\n    border-color: var(--orange-100)!important\n  }\n\n  .border-orange-200 {\n    border-color: var(--orange-200)!important\n  }\n\n  .border-orange-300 {\n    border-color: var(--orange-300)!important\n  }\n\n  .border-orange-400 {\n    border-color: var(--orange-400)!important\n  }\n\n  .border-orange-500 {\n    border-color: var(--orange-500)!important\n  }\n\n  .border-orange-600 {\n    border-color: var(--orange-600)!important\n  }\n\n  .border-orange-700 {\n    border-color: var(--orange-700)!important\n  }\n\n  .border-orange-800 {\n    border-color: var(--orange-800)!important\n  }\n\n  .border-orange-900 {\n    border-color: var(--orange-900)!important\n  }\n\n  .focus\\:border-orange-50:focus {\n    border-color: var(--orange-50)!important\n  }\n\n  .focus\\:border-orange-100:focus {\n    border-color: var(--orange-100)!important\n  }\n\n  .focus\\:border-orange-200:focus {\n    border-color: var(--orange-200)!important\n  }\n\n  .focus\\:border-orange-300:focus {\n    border-color: var(--orange-300)!important\n  }\n\n  .focus\\:border-orange-400:focus {\n    border-color: var(--orange-400)!important\n  }\n\n  .focus\\:border-orange-500:focus {\n    border-color: var(--orange-500)!important\n  }\n\n  .focus\\:border-orange-600:focus {\n    border-color: var(--orange-600)!important\n  }\n\n  .focus\\:border-orange-700:focus {\n    border-color: var(--orange-700)!important\n  }\n\n  .focus\\:border-orange-800:focus {\n    border-color: var(--orange-800)!important\n  }\n\n  .focus\\:border-orange-900:focus {\n    border-color: var(--orange-900)!important\n  }\n\n  .hover\\:border-orange-50:hover {\n    border-color: var(--orange-50)!important\n  }\n\n  .hover\\:border-orange-100:hover {\n    border-color: var(--orange-100)!important\n  }\n\n  .hover\\:border-orange-200:hover {\n    border-color: var(--orange-200)!important\n  }\n\n  .hover\\:border-orange-300:hover {\n    border-color: var(--orange-300)!important\n  }\n\n  .hover\\:border-orange-400:hover {\n    border-color: var(--orange-400)!important\n  }\n\n  .hover\\:border-orange-500:hover {\n    border-color: var(--orange-500)!important\n  }\n\n  .hover\\:border-orange-600:hover {\n    border-color: var(--orange-600)!important\n  }\n\n  .hover\\:border-orange-700:hover {\n    border-color: var(--orange-700)!important\n  }\n\n  .hover\\:border-orange-800:hover {\n    border-color: var(--orange-800)!important\n  }\n\n  .hover\\:border-orange-900:hover {\n    border-color: var(--orange-900)!important\n  }\n\n  .active\\:border-orange-50:active {\n    border-color: var(--orange-50)!important\n  }\n\n  .active\\:border-orange-100:active {\n    border-color: var(--orange-100)!important\n  }\n\n  .active\\:border-orange-200:active {\n    border-color: var(--orange-200)!important\n  }\n\n  .active\\:border-orange-300:active {\n    border-color: var(--orange-300)!important\n  }\n\n  .active\\:border-orange-400:active {\n    border-color: var(--orange-400)!important\n  }\n\n  .active\\:border-orange-500:active {\n    border-color: var(--orange-500)!important\n  }\n\n  .active\\:border-orange-600:active {\n    border-color: var(--orange-600)!important\n  }\n\n  .active\\:border-orange-700:active {\n    border-color: var(--orange-700)!important\n  }\n\n  .active\\:border-orange-800:active {\n    border-color: var(--orange-800)!important\n  }\n\n  .active\\:border-orange-900:active {\n    border-color: var(--orange-900)!important\n  }\n\n  .border-bluegray-50 {\n    border-color: var(--bluegray-50)!important\n  }\n\n  .border-bluegray-100 {\n    border-color: var(--bluegray-100)!important\n  }\n\n  .border-bluegray-200 {\n    border-color: var(--bluegray-200)!important\n  }\n\n  .border-bluegray-300 {\n    border-color: var(--bluegray-300)!important\n  }\n\n  .border-bluegray-400 {\n    border-color: var(--bluegray-400)!important\n  }\n\n  .border-bluegray-500 {\n    border-color: var(--bluegray-500)!important\n  }\n\n  .border-bluegray-600 {\n    border-color: var(--bluegray-600)!important\n  }\n\n  .border-bluegray-700 {\n    border-color: var(--bluegray-700)!important\n  }\n\n  .border-bluegray-800 {\n    border-color: var(--bluegray-800)!important\n  }\n\n  .border-bluegray-900 {\n    border-color: var(--bluegray-900)!important\n  }\n\n  .focus\\:border-bluegray-50:focus {\n    border-color: var(--bluegray-50)!important\n  }\n\n  .focus\\:border-bluegray-100:focus {\n    border-color: var(--bluegray-100)!important\n  }\n\n  .focus\\:border-bluegray-200:focus {\n    border-color: var(--bluegray-200)!important\n  }\n\n  .focus\\:border-bluegray-300:focus {\n    border-color: var(--bluegray-300)!important\n  }\n\n  .focus\\:border-bluegray-400:focus {\n    border-color: var(--bluegray-400)!important\n  }\n\n  .focus\\:border-bluegray-500:focus {\n    border-color: var(--bluegray-500)!important\n  }\n\n  .focus\\:border-bluegray-600:focus {\n    border-color: var(--bluegray-600)!important\n  }\n\n  .focus\\:border-bluegray-700:focus {\n    border-color: var(--bluegray-700)!important\n  }\n\n  .focus\\:border-bluegray-800:focus {\n    border-color: var(--bluegray-800)!important\n  }\n\n  .focus\\:border-bluegray-900:focus {\n    border-color: var(--bluegray-900)!important\n  }\n\n  .hover\\:border-bluegray-50:hover {\n    border-color: var(--bluegray-50)!important\n  }\n\n  .hover\\:border-bluegray-100:hover {\n    border-color: var(--bluegray-100)!important\n  }\n\n  .hover\\:border-bluegray-200:hover {\n    border-color: var(--bluegray-200)!important\n  }\n\n  .hover\\:border-bluegray-300:hover {\n    border-color: var(--bluegray-300)!important\n  }\n\n  .hover\\:border-bluegray-400:hover {\n    border-color: var(--bluegray-400)!important\n  }\n\n  .hover\\:border-bluegray-500:hover {\n    border-color: var(--bluegray-500)!important\n  }\n\n  .hover\\:border-bluegray-600:hover {\n    border-color: var(--bluegray-600)!important\n  }\n\n  .hover\\:border-bluegray-700:hover {\n    border-color: var(--bluegray-700)!important\n  }\n\n  .hover\\:border-bluegray-800:hover {\n    border-color: var(--bluegray-800)!important\n  }\n\n  .hover\\:border-bluegray-900:hover {\n    border-color: var(--bluegray-900)!important\n  }\n\n  .active\\:border-bluegray-50:active {\n    border-color: var(--bluegray-50)!important\n  }\n\n  .active\\:border-bluegray-100:active {\n    border-color: var(--bluegray-100)!important\n  }\n\n  .active\\:border-bluegray-200:active {\n    border-color: var(--bluegray-200)!important\n  }\n\n  .active\\:border-bluegray-300:active {\n    border-color: var(--bluegray-300)!important\n  }\n\n  .active\\:border-bluegray-400:active {\n    border-color: var(--bluegray-400)!important\n  }\n\n  .active\\:border-bluegray-500:active {\n    border-color: var(--bluegray-500)!important\n  }\n\n  .active\\:border-bluegray-600:active {\n    border-color: var(--bluegray-600)!important\n  }\n\n  .active\\:border-bluegray-700:active {\n    border-color: var(--bluegray-700)!important\n  }\n\n  .active\\:border-bluegray-800:active {\n    border-color: var(--bluegray-800)!important\n  }\n\n  .active\\:border-bluegray-900:active {\n    border-color: var(--bluegray-900)!important\n  }\n\n  .border-purple-50 {\n    border-color: var(--purple-50)!important\n  }\n\n  .border-purple-100 {\n    border-color: var(--purple-100)!important\n  }\n\n  .border-purple-200 {\n    border-color: var(--purple-200)!important\n  }\n\n  .border-purple-300 {\n    border-color: var(--purple-300)!important\n  }\n\n  .border-purple-400 {\n    border-color: var(--purple-400)!important\n  }\n\n  .border-purple-500 {\n    border-color: var(--purple-500)!important\n  }\n\n  .border-purple-600 {\n    border-color: var(--purple-600)!important\n  }\n\n  .border-purple-700 {\n    border-color: var(--purple-700)!important\n  }\n\n  .border-purple-800 {\n    border-color: var(--purple-800)!important\n  }\n\n  .border-purple-900 {\n    border-color: var(--purple-900)!important\n  }\n\n  .focus\\:border-purple-50:focus {\n    border-color: var(--purple-50)!important\n  }\n\n  .focus\\:border-purple-100:focus {\n    border-color: var(--purple-100)!important\n  }\n\n  .focus\\:border-purple-200:focus {\n    border-color: var(--purple-200)!important\n  }\n\n  .focus\\:border-purple-300:focus {\n    border-color: var(--purple-300)!important\n  }\n\n  .focus\\:border-purple-400:focus {\n    border-color: var(--purple-400)!important\n  }\n\n  .focus\\:border-purple-500:focus {\n    border-color: var(--purple-500)!important\n  }\n\n  .focus\\:border-purple-600:focus {\n    border-color: var(--purple-600)!important\n  }\n\n  .focus\\:border-purple-700:focus {\n    border-color: var(--purple-700)!important\n  }\n\n  .focus\\:border-purple-800:focus {\n    border-color: var(--purple-800)!important\n  }\n\n  .focus\\:border-purple-900:focus {\n    border-color: var(--purple-900)!important\n  }\n\n  .hover\\:border-purple-50:hover {\n    border-color: var(--purple-50)!important\n  }\n\n  .hover\\:border-purple-100:hover {\n    border-color: var(--purple-100)!important\n  }\n\n  .hover\\:border-purple-200:hover {\n    border-color: var(--purple-200)!important\n  }\n\n  .hover\\:border-purple-300:hover {\n    border-color: var(--purple-300)!important\n  }\n\n  .hover\\:border-purple-400:hover {\n    border-color: var(--purple-400)!important\n  }\n\n  .hover\\:border-purple-500:hover {\n    border-color: var(--purple-500)!important\n  }\n\n  .hover\\:border-purple-600:hover {\n    border-color: var(--purple-600)!important\n  }\n\n  .hover\\:border-purple-700:hover {\n    border-color: var(--purple-700)!important\n  }\n\n  .hover\\:border-purple-800:hover {\n    border-color: var(--purple-800)!important\n  }\n\n  .hover\\:border-purple-900:hover {\n    border-color: var(--purple-900)!important\n  }\n\n  .active\\:border-purple-50:active {\n    border-color: var(--purple-50)!important\n  }\n\n  .active\\:border-purple-100:active {\n    border-color: var(--purple-100)!important\n  }\n\n  .active\\:border-purple-200:active {\n    border-color: var(--purple-200)!important\n  }\n\n  .active\\:border-purple-300:active {\n    border-color: var(--purple-300)!important\n  }\n\n  .active\\:border-purple-400:active {\n    border-color: var(--purple-400)!important\n  }\n\n  .active\\:border-purple-500:active {\n    border-color: var(--purple-500)!important\n  }\n\n  .active\\:border-purple-600:active {\n    border-color: var(--purple-600)!important\n  }\n\n  .active\\:border-purple-700:active {\n    border-color: var(--purple-700)!important\n  }\n\n  .active\\:border-purple-800:active {\n    border-color: var(--purple-800)!important\n  }\n\n  .active\\:border-purple-900:active {\n    border-color: var(--purple-900)!important\n  }\n\n  .border-gray-50 {\n    border-color: var(--gray-50)!important\n  }\n\n  .border-gray-100 {\n    border-color: var(--gray-100)!important\n  }\n\n  .border-gray-200 {\n    border-color: var(--gray-200)!important\n  }\n\n  .border-gray-300 {\n    border-color: var(--gray-300)!important\n  }\n\n  .border-gray-400 {\n    border-color: var(--gray-400)!important\n  }\n\n  .border-gray-500 {\n    border-color: var(--gray-500)!important\n  }\n\n  .border-gray-600 {\n    border-color: var(--gray-600)!important\n  }\n\n  .border-gray-700 {\n    border-color: var(--gray-700)!important\n  }\n\n  .border-gray-800 {\n    border-color: var(--gray-800)!important\n  }\n\n  .border-gray-900 {\n    border-color: var(--gray-900)!important\n  }\n\n  .focus\\:border-gray-50:focus {\n    border-color: var(--gray-50)!important\n  }\n\n  .focus\\:border-gray-100:focus {\n    border-color: var(--gray-100)!important\n  }\n\n  .focus\\:border-gray-200:focus {\n    border-color: var(--gray-200)!important\n  }\n\n  .focus\\:border-gray-300:focus {\n    border-color: var(--gray-300)!important\n  }\n\n  .focus\\:border-gray-400:focus {\n    border-color: var(--gray-400)!important\n  }\n\n  .focus\\:border-gray-500:focus {\n    border-color: var(--gray-500)!important\n  }\n\n  .focus\\:border-gray-600:focus {\n    border-color: var(--gray-600)!important\n  }\n\n  .focus\\:border-gray-700:focus {\n    border-color: var(--gray-700)!important\n  }\n\n  .focus\\:border-gray-800:focus {\n    border-color: var(--gray-800)!important\n  }\n\n  .focus\\:border-gray-900:focus {\n    border-color: var(--gray-900)!important\n  }\n\n  .hover\\:border-gray-50:hover {\n    border-color: var(--gray-50)!important\n  }\n\n  .hover\\:border-gray-100:hover {\n    border-color: var(--gray-100)!important\n  }\n\n  .hover\\:border-gray-200:hover {\n    border-color: var(--gray-200)!important\n  }\n\n  .hover\\:border-gray-300:hover {\n    border-color: var(--gray-300)!important\n  }\n\n  .hover\\:border-gray-400:hover {\n    border-color: var(--gray-400)!important\n  }\n\n  .hover\\:border-gray-500:hover {\n    border-color: var(--gray-500)!important\n  }\n\n  .hover\\:border-gray-600:hover {\n    border-color: var(--gray-600)!important\n  }\n\n  .hover\\:border-gray-700:hover {\n    border-color: var(--gray-700)!important\n  }\n\n  .hover\\:border-gray-800:hover {\n    border-color: var(--gray-800)!important\n  }\n\n  .hover\\:border-gray-900:hover {\n    border-color: var(--gray-900)!important\n  }\n\n  .active\\:border-gray-50:active {\n    border-color: var(--gray-50)!important\n  }\n\n  .active\\:border-gray-100:active {\n    border-color: var(--gray-100)!important\n  }\n\n  .active\\:border-gray-200:active {\n    border-color: var(--gray-200)!important\n  }\n\n  .active\\:border-gray-300:active {\n    border-color: var(--gray-300)!important\n  }\n\n  .active\\:border-gray-400:active {\n    border-color: var(--gray-400)!important\n  }\n\n  .active\\:border-gray-500:active {\n    border-color: var(--gray-500)!important\n  }\n\n  .active\\:border-gray-600:active {\n    border-color: var(--gray-600)!important\n  }\n\n  .active\\:border-gray-700:active {\n    border-color: var(--gray-700)!important\n  }\n\n  .active\\:border-gray-800:active {\n    border-color: var(--gray-800)!important\n  }\n\n  .active\\:border-gray-900:active {\n    border-color: var(--gray-900)!important\n  }\n\n  .border-red-50 {\n    border-color: var(--red-50)!important\n  }\n\n  .border-red-100 {\n    border-color: var(--red-100)!important\n  }\n\n  .border-red-200 {\n    border-color: var(--red-200)!important\n  }\n\n  .border-red-300 {\n    border-color: var(--red-300)!important\n  }\n\n  .border-red-400 {\n    border-color: var(--red-400)!important\n  }\n\n  .border-red-500 {\n    border-color: var(--red-500)!important\n  }\n\n  .border-red-600 {\n    border-color: var(--red-600)!important\n  }\n\n  .border-red-700 {\n    border-color: var(--red-700)!important\n  }\n\n  .border-red-800 {\n    border-color: var(--red-800)!important\n  }\n\n  .border-red-900 {\n    border-color: var(--red-900)!important\n  }\n\n  .focus\\:border-red-50:focus {\n    border-color: var(--red-50)!important\n  }\n\n  .focus\\:border-red-100:focus {\n    border-color: var(--red-100)!important\n  }\n\n  .focus\\:border-red-200:focus {\n    border-color: var(--red-200)!important\n  }\n\n  .focus\\:border-red-300:focus {\n    border-color: var(--red-300)!important\n  }\n\n  .focus\\:border-red-400:focus {\n    border-color: var(--red-400)!important\n  }\n\n  .focus\\:border-red-500:focus {\n    border-color: var(--red-500)!important\n  }\n\n  .focus\\:border-red-600:focus {\n    border-color: var(--red-600)!important\n  }\n\n  .focus\\:border-red-700:focus {\n    border-color: var(--red-700)!important\n  }\n\n  .focus\\:border-red-800:focus {\n    border-color: var(--red-800)!important\n  }\n\n  .focus\\:border-red-900:focus {\n    border-color: var(--red-900)!important\n  }\n\n  .hover\\:border-red-50:hover {\n    border-color: var(--red-50)!important\n  }\n\n  .hover\\:border-red-100:hover {\n    border-color: var(--red-100)!important\n  }\n\n  .hover\\:border-red-200:hover {\n    border-color: var(--red-200)!important\n  }\n\n  .hover\\:border-red-300:hover {\n    border-color: var(--red-300)!important\n  }\n\n  .hover\\:border-red-400:hover {\n    border-color: var(--red-400)!important\n  }\n\n  .hover\\:border-red-500:hover {\n    border-color: var(--red-500)!important\n  }\n\n  .hover\\:border-red-600:hover {\n    border-color: var(--red-600)!important\n  }\n\n  .hover\\:border-red-700:hover {\n    border-color: var(--red-700)!important\n  }\n\n  .hover\\:border-red-800:hover {\n    border-color: var(--red-800)!important\n  }\n\n  .hover\\:border-red-900:hover {\n    border-color: var(--red-900)!important\n  }\n\n  .active\\:border-red-50:active {\n    border-color: var(--red-50)!important\n  }\n\n  .active\\:border-red-100:active {\n    border-color: var(--red-100)!important\n  }\n\n  .active\\:border-red-200:active {\n    border-color: var(--red-200)!important\n  }\n\n  .active\\:border-red-300:active {\n    border-color: var(--red-300)!important\n  }\n\n  .active\\:border-red-400:active {\n    border-color: var(--red-400)!important\n  }\n\n  .active\\:border-red-500:active {\n    border-color: var(--red-500)!important\n  }\n\n  .active\\:border-red-600:active {\n    border-color: var(--red-600)!important\n  }\n\n  .active\\:border-red-700:active {\n    border-color: var(--red-700)!important\n  }\n\n  .active\\:border-red-800:active {\n    border-color: var(--red-800)!important\n  }\n\n  .active\\:border-red-900:active {\n    border-color: var(--red-900)!important\n  }\n\n  .border-primary-50 {\n    border-color: var(--primary-50)!important\n  }\n\n  .border-primary-100 {\n    border-color: var(--primary-100)!important\n  }\n\n  .border-primary-200 {\n    border-color: var(--primary-200)!important\n  }\n\n  .border-primary-300 {\n    border-color: var(--primary-300)!important\n  }\n\n  .border-primary-400 {\n    border-color: var(--primary-400)!important\n  }\n\n  .border-primary-500 {\n    border-color: var(--primary-500)!important\n  }\n\n  .border-primary-600 {\n    border-color: var(--primary-600)!important\n  }\n\n  .border-primary-700 {\n    border-color: var(--primary-700)!important\n  }\n\n  .border-primary-800 {\n    border-color: var(--primary-800)!important\n  }\n\n  .border-primary-900 {\n    border-color: var(--primary-900)!important\n  }\n\n  .focus\\:border-primary-50:focus {\n    border-color: var(--primary-50)!important\n  }\n\n  .focus\\:border-primary-100:focus {\n    border-color: var(--primary-100)!important\n  }\n\n  .focus\\:border-primary-200:focus {\n    border-color: var(--primary-200)!important\n  }\n\n  .focus\\:border-primary-300:focus {\n    border-color: var(--primary-300)!important\n  }\n\n  .focus\\:border-primary-400:focus {\n    border-color: var(--primary-400)!important\n  }\n\n  .focus\\:border-primary-500:focus {\n    border-color: var(--primary-500)!important\n  }\n\n  .focus\\:border-primary-600:focus {\n    border-color: var(--primary-600)!important\n  }\n\n  .focus\\:border-primary-700:focus {\n    border-color: var(--primary-700)!important\n  }\n\n  .focus\\:border-primary-800:focus {\n    border-color: var(--primary-800)!important\n  }\n\n  .focus\\:border-primary-900:focus {\n    border-color: var(--primary-900)!important\n  }\n\n  .hover\\:border-primary-50:hover {\n    border-color: var(--primary-50)!important\n  }\n\n  .hover\\:border-primary-100:hover {\n    border-color: var(--primary-100)!important\n  }\n\n  .hover\\:border-primary-200:hover {\n    border-color: var(--primary-200)!important\n  }\n\n  .hover\\:border-primary-300:hover {\n    border-color: var(--primary-300)!important\n  }\n\n  .hover\\:border-primary-400:hover {\n    border-color: var(--primary-400)!important\n  }\n\n  .hover\\:border-primary-500:hover {\n    border-color: var(--primary-500)!important\n  }\n\n  .hover\\:border-primary-600:hover {\n    border-color: var(--primary-600)!important\n  }\n\n  .hover\\:border-primary-700:hover {\n    border-color: var(--primary-700)!important\n  }\n\n  .hover\\:border-primary-800:hover {\n    border-color: var(--primary-800)!important\n  }\n\n  .hover\\:border-primary-900:hover {\n    border-color: var(--primary-900)!important\n  }\n\n  .active\\:border-primary-50:active {\n    border-color: var(--primary-50)!important\n  }\n\n  .active\\:border-primary-100:active {\n    border-color: var(--primary-100)!important\n  }\n\n  .active\\:border-primary-200:active {\n    border-color: var(--primary-200)!important\n  }\n\n  .active\\:border-primary-300:active {\n    border-color: var(--primary-300)!important\n  }\n\n  .active\\:border-primary-400:active {\n    border-color: var(--primary-400)!important\n  }\n\n  .active\\:border-primary-500:active {\n    border-color: var(--primary-500)!important\n  }\n\n  .active\\:border-primary-600:active {\n    border-color: var(--primary-600)!important\n  }\n\n  .active\\:border-primary-700:active {\n    border-color: var(--primary-700)!important\n  }\n\n  .active\\:border-primary-800:active {\n    border-color: var(--primary-800)!important\n  }\n\n  .active\\:border-primary-900:active {\n    border-color: var(--primary-900)!important\n  }\n\n  .bg-white-alpha-10 {\n    background-color: #ffffff1a!important\n  }\n\n  .bg-white-alpha-20 {\n    background-color: #fff3!important\n  }\n\n  .bg-white-alpha-30 {\n    background-color: #ffffff4d!important\n  }\n\n  .bg-white-alpha-40 {\n    background-color: #fff6!important\n  }\n\n  .bg-white-alpha-50 {\n    background-color: #ffffff80!important\n  }\n\n  .bg-white-alpha-60 {\n    background-color: #fff9!important\n  }\n\n  .bg-white-alpha-70 {\n    background-color: #ffffffb3!important\n  }\n\n  .bg-white-alpha-80 {\n    background-color: #fffc!important\n  }\n\n  .bg-white-alpha-90 {\n    background-color: #ffffffe6!important\n  }\n\n  .hover\\:bg-white-alpha-10:hover {\n    background-color: #ffffff1a!important\n  }\n\n  .hover\\:bg-white-alpha-20:hover {\n    background-color: #fff3!important\n  }\n\n  .hover\\:bg-white-alpha-30:hover {\n    background-color: #ffffff4d!important\n  }\n\n  .hover\\:bg-white-alpha-40:hover {\n    background-color: #fff6!important\n  }\n\n  .hover\\:bg-white-alpha-50:hover {\n    background-color: #ffffff80!important\n  }\n\n  .hover\\:bg-white-alpha-60:hover {\n    background-color: #fff9!important\n  }\n\n  .hover\\:bg-white-alpha-70:hover {\n    background-color: #ffffffb3!important\n  }\n\n  .hover\\:bg-white-alpha-80:hover {\n    background-color: #fffc!important\n  }\n\n  .hover\\:bg-white-alpha-90:hover {\n    background-color: #ffffffe6!important\n  }\n\n  .focus\\:bg-white-alpha-10:focus {\n    background-color: #ffffff1a!important\n  }\n\n  .focus\\:bg-white-alpha-20:focus {\n    background-color: #fff3!important\n  }\n\n  .focus\\:bg-white-alpha-30:focus {\n    background-color: #ffffff4d!important\n  }\n\n  .focus\\:bg-white-alpha-40:focus {\n    background-color: #fff6!important\n  }\n\n  .focus\\:bg-white-alpha-50:focus {\n    background-color: #ffffff80!important\n  }\n\n  .focus\\:bg-white-alpha-60:focus {\n    background-color: #fff9!important\n  }\n\n  .focus\\:bg-white-alpha-70:focus {\n    background-color: #ffffffb3!important\n  }\n\n  .focus\\:bg-white-alpha-80:focus {\n    background-color: #fffc!important\n  }\n\n  .focus\\:bg-white-alpha-90:focus {\n    background-color: #ffffffe6!important\n  }\n\n  .active\\:bg-white-alpha-10:active {\n    background-color: #ffffff1a!important\n  }\n\n  .active\\:bg-white-alpha-20:active {\n    background-color: #fff3!important\n  }\n\n  .active\\:bg-white-alpha-30:active {\n    background-color: #ffffff4d!important\n  }\n\n  .active\\:bg-white-alpha-40:active {\n    background-color: #fff6!important\n  }\n\n  .active\\:bg-white-alpha-50:active {\n    background-color: #ffffff80!important\n  }\n\n  .active\\:bg-white-alpha-60:active {\n    background-color: #fff9!important\n  }\n\n  .active\\:bg-white-alpha-70:active {\n    background-color: #ffffffb3!important\n  }\n\n  .active\\:bg-white-alpha-80:active {\n    background-color: #fffc!important\n  }\n\n  .active\\:bg-white-alpha-90:active {\n    background-color: #ffffffe6!important\n  }\n\n  .bg-black-alpha-10 {\n    background-color: #0000001a!important\n  }\n\n  .bg-black-alpha-20 {\n    background-color: #0003!important\n  }\n\n  .bg-black-alpha-30 {\n    background-color: #0000004d!important\n  }\n\n  .bg-black-alpha-40 {\n    background-color: #0006!important\n  }\n\n  .bg-black-alpha-50 {\n    background-color: #00000080!important\n  }\n\n  .bg-black-alpha-60 {\n    background-color: #0009!important\n  }\n\n  .bg-black-alpha-70 {\n    background-color: #000000b3!important\n  }\n\n  .bg-black-alpha-80 {\n    background-color: #000c!important\n  }\n\n  .bg-black-alpha-90 {\n    background-color: #000000e6!important\n  }\n\n  .hover\\:bg-black-alpha-10:hover {\n    background-color: #0000001a!important\n  }\n\n  .hover\\:bg-black-alpha-20:hover {\n    background-color: #0003!important\n  }\n\n  .hover\\:bg-black-alpha-30:hover {\n    background-color: #0000004d!important\n  }\n\n  .hover\\:bg-black-alpha-40:hover {\n    background-color: #0006!important\n  }\n\n  .hover\\:bg-black-alpha-50:hover {\n    background-color: #00000080!important\n  }\n\n  .hover\\:bg-black-alpha-60:hover {\n    background-color: #0009!important\n  }\n\n  .hover\\:bg-black-alpha-70:hover {\n    background-color: #000000b3!important\n  }\n\n  .hover\\:bg-black-alpha-80:hover {\n    background-color: #000c!important\n  }\n\n  .hover\\:bg-black-alpha-90:hover {\n    background-color: #000000e6!important\n  }\n\n  .focus\\:bg-black-alpha-10:focus {\n    background-color: #0000001a!important\n  }\n\n  .focus\\:bg-black-alpha-20:focus {\n    background-color: #0003!important\n  }\n\n  .focus\\:bg-black-alpha-30:focus {\n    background-color: #0000004d!important\n  }\n\n  .focus\\:bg-black-alpha-40:focus {\n    background-color: #0006!important\n  }\n\n  .focus\\:bg-black-alpha-50:focus {\n    background-color: #00000080!important\n  }\n\n  .focus\\:bg-black-alpha-60:focus {\n    background-color: #0009!important\n  }\n\n  .focus\\:bg-black-alpha-70:focus {\n    background-color: #000000b3!important\n  }\n\n  .focus\\:bg-black-alpha-80:focus {\n    background-color: #000c!important\n  }\n\n  .focus\\:bg-black-alpha-90:focus {\n    background-color: #000000e6!important\n  }\n\n  .active\\:bg-black-alpha-10:active {\n    background-color: #0000001a!important\n  }\n\n  .active\\:bg-black-alpha-20:active {\n    background-color: #0003!important\n  }\n\n  .active\\:bg-black-alpha-30:active {\n    background-color: #0000004d!important\n  }\n\n  .active\\:bg-black-alpha-40:active {\n    background-color: #0006!important\n  }\n\n  .active\\:bg-black-alpha-50:active {\n    background-color: #00000080!important\n  }\n\n  .active\\:bg-black-alpha-60:active {\n    background-color: #0009!important\n  }\n\n  .active\\:bg-black-alpha-70:active {\n    background-color: #000000b3!important\n  }\n\n  .active\\:bg-black-alpha-80:active {\n    background-color: #000c!important\n  }\n\n  .active\\:bg-black-alpha-90:active {\n    background-color: #000000e6!important\n  }\n\n  .border-white-alpha-10 {\n    border-color: #ffffff1a!important\n  }\n\n  .border-white-alpha-20 {\n    border-color: #fff3!important\n  }\n\n  .border-white-alpha-30 {\n    border-color: #ffffff4d!important\n  }\n\n  .border-white-alpha-40 {\n    border-color: #fff6!important\n  }\n\n  .border-white-alpha-50 {\n    border-color: #ffffff80!important\n  }\n\n  .border-white-alpha-60 {\n    border-color: #fff9!important\n  }\n\n  .border-white-alpha-70 {\n    border-color: #ffffffb3!important\n  }\n\n  .border-white-alpha-80 {\n    border-color: #fffc!important\n  }\n\n  .border-white-alpha-90 {\n    border-color: #ffffffe6!important\n  }\n\n  .hover\\:border-white-alpha-10:hover {\n    border-color: #ffffff1a!important\n  }\n\n  .hover\\:border-white-alpha-20:hover {\n    border-color: #fff3!important\n  }\n\n  .hover\\:border-white-alpha-30:hover {\n    border-color: #ffffff4d!important\n  }\n\n  .hover\\:border-white-alpha-40:hover {\n    border-color: #fff6!important\n  }\n\n  .hover\\:border-white-alpha-50:hover {\n    border-color: #ffffff80!important\n  }\n\n  .hover\\:border-white-alpha-60:hover {\n    border-color: #fff9!important\n  }\n\n  .hover\\:border-white-alpha-70:hover {\n    border-color: #ffffffb3!important\n  }\n\n  .hover\\:border-white-alpha-80:hover {\n    border-color: #fffc!important\n  }\n\n  .hover\\:border-white-alpha-90:hover {\n    border-color: #ffffffe6!important\n  }\n\n  .focus\\:border-white-alpha-10:focus {\n    border-color: #ffffff1a!important\n  }\n\n  .focus\\:border-white-alpha-20:focus {\n    border-color: #fff3!important\n  }\n\n  .focus\\:border-white-alpha-30:focus {\n    border-color: #ffffff4d!important\n  }\n\n  .focus\\:border-white-alpha-40:focus {\n    border-color: #fff6!important\n  }\n\n  .focus\\:border-white-alpha-50:focus {\n    border-color: #ffffff80!important\n  }\n\n  .focus\\:border-white-alpha-60:focus {\n    border-color: #fff9!important\n  }\n\n  .focus\\:border-white-alpha-70:focus {\n    border-color: #ffffffb3!important\n  }\n\n  .focus\\:border-white-alpha-80:focus {\n    border-color: #fffc!important\n  }\n\n  .focus\\:border-white-alpha-90:focus {\n    border-color: #ffffffe6!important\n  }\n\n  .active\\:border-white-alpha-10:active {\n    border-color: #ffffff1a!important\n  }\n\n  .active\\:border-white-alpha-20:active {\n    border-color: #fff3!important\n  }\n\n  .active\\:border-white-alpha-30:active {\n    border-color: #ffffff4d!important\n  }\n\n  .active\\:border-white-alpha-40:active {\n    border-color: #fff6!important\n  }\n\n  .active\\:border-white-alpha-50:active {\n    border-color: #ffffff80!important\n  }\n\n  .active\\:border-white-alpha-60:active {\n    border-color: #fff9!important\n  }\n\n  .active\\:border-white-alpha-70:active {\n    border-color: #ffffffb3!important\n  }\n\n  .active\\:border-white-alpha-80:active {\n    border-color: #fffc!important\n  }\n\n  .active\\:border-white-alpha-90:active {\n    border-color: #ffffffe6!important\n  }\n\n  .border-black-alpha-10 {\n    border-color: #0000001a!important\n  }\n\n  .border-black-alpha-20 {\n    border-color: #0003!important\n  }\n\n  .border-black-alpha-30 {\n    border-color: #0000004d!important\n  }\n\n  .border-black-alpha-40 {\n    border-color: #0006!important\n  }\n\n  .border-black-alpha-50 {\n    border-color: #00000080!important\n  }\n\n  .border-black-alpha-60 {\n    border-color: #0009!important\n  }\n\n  .border-black-alpha-70 {\n    border-color: #000000b3!important\n  }\n\n  .border-black-alpha-80 {\n    border-color: #000c!important\n  }\n\n  .border-black-alpha-90 {\n    border-color: #000000e6!important\n  }\n\n  .hover\\:border-black-alpha-10:hover {\n    border-color: #0000001a!important\n  }\n\n  .hover\\:border-black-alpha-20:hover {\n    border-color: #0003!important\n  }\n\n  .hover\\:border-black-alpha-30:hover {\n    border-color: #0000004d!important\n  }\n\n  .hover\\:border-black-alpha-40:hover {\n    border-color: #0006!important\n  }\n\n  .hover\\:border-black-alpha-50:hover {\n    border-color: #00000080!important\n  }\n\n  .hover\\:border-black-alpha-60:hover {\n    border-color: #0009!important\n  }\n\n  .hover\\:border-black-alpha-70:hover {\n    border-color: #000000b3!important\n  }\n\n  .hover\\:border-black-alpha-80:hover {\n    border-color: #000c!important\n  }\n\n  .hover\\:border-black-alpha-90:hover {\n    border-color: #000000e6!important\n  }\n\n  .focus\\:border-black-alpha-10:focus {\n    border-color: #0000001a!important\n  }\n\n  .focus\\:border-black-alpha-20:focus {\n    border-color: #0003!important\n  }\n\n  .focus\\:border-black-alpha-30:focus {\n    border-color: #0000004d!important\n  }\n\n  .focus\\:border-black-alpha-40:focus {\n    border-color: #0006!important\n  }\n\n  .focus\\:border-black-alpha-50:focus {\n    border-color: #00000080!important\n  }\n\n  .focus\\:border-black-alpha-60:focus {\n    border-color: #0009!important\n  }\n\n  .focus\\:border-black-alpha-70:focus {\n    border-color: #000000b3!important\n  }\n\n  .focus\\:border-black-alpha-80:focus {\n    border-color: #000c!important\n  }\n\n  .focus\\:border-black-alpha-90:focus {\n    border-color: #000000e6!important\n  }\n\n  .active\\:border-black-alpha-10:active {\n    border-color: #0000001a!important\n  }\n\n  .active\\:border-black-alpha-20:active {\n    border-color: #0003!important\n  }\n\n  .active\\:border-black-alpha-30:active {\n    border-color: #0000004d!important\n  }\n\n  .active\\:border-black-alpha-40:active {\n    border-color: #0006!important\n  }\n\n  .active\\:border-black-alpha-50:active {\n    border-color: #00000080!important\n  }\n\n  .active\\:border-black-alpha-60:active {\n    border-color: #0009!important\n  }\n\n  .active\\:border-black-alpha-70:active {\n    border-color: #000000b3!important\n  }\n\n  .active\\:border-black-alpha-80:active {\n    border-color: #000c!important\n  }\n\n  .active\\:border-black-alpha-90:active {\n    border-color: #000000e6!important\n  }\n\n  .text-white-alpha-10 {\n    color: #ffffff1a!important\n  }\n\n  .text-white-alpha-20 {\n    color: #fff3!important\n  }\n\n  .text-white-alpha-30 {\n    color: #ffffff4d!important\n  }\n\n  .text-white-alpha-40 {\n    color: #fff6!important\n  }\n\n  .text-white-alpha-50 {\n    color: #ffffff80!important\n  }\n\n  .text-white-alpha-60 {\n    color: #fff9!important\n  }\n\n  .text-white-alpha-70 {\n    color: #ffffffb3!important\n  }\n\n  .text-white-alpha-80 {\n    color: #fffc!important\n  }\n\n  .text-white-alpha-90 {\n    color: #ffffffe6!important\n  }\n\n  .hover\\:text-white-alpha-10:hover {\n    color: #ffffff1a!important\n  }\n\n  .hover\\:text-white-alpha-20:hover {\n    color: #fff3!important\n  }\n\n  .hover\\:text-white-alpha-30:hover {\n    color: #ffffff4d!important\n  }\n\n  .hover\\:text-white-alpha-40:hover {\n    color: #fff6!important\n  }\n\n  .hover\\:text-white-alpha-50:hover {\n    color: #ffffff80!important\n  }\n\n  .hover\\:text-white-alpha-60:hover {\n    color: #fff9!important\n  }\n\n  .hover\\:text-white-alpha-70:hover {\n    color: #ffffffb3!important\n  }\n\n  .hover\\:text-white-alpha-80:hover {\n    color: #fffc!important\n  }\n\n  .hover\\:text-white-alpha-90:hover {\n    color: #ffffffe6!important\n  }\n\n  .focus\\:text-white-alpha-10:focus {\n    color: #ffffff1a!important\n  }\n\n  .focus\\:text-white-alpha-20:focus {\n    color: #fff3!important\n  }\n\n  .focus\\:text-white-alpha-30:focus {\n    color: #ffffff4d!important\n  }\n\n  .focus\\:text-white-alpha-40:focus {\n    color: #fff6!important\n  }\n\n  .focus\\:text-white-alpha-50:focus {\n    color: #ffffff80!important\n  }\n\n  .focus\\:text-white-alpha-60:focus {\n    color: #fff9!important\n  }\n\n  .focus\\:text-white-alpha-70:focus {\n    color: #ffffffb3!important\n  }\n\n  .focus\\:text-white-alpha-80:focus {\n    color: #fffc!important\n  }\n\n  .focus\\:text-white-alpha-90:focus {\n    color: #ffffffe6!important\n  }\n\n  .active\\:text-white-alpha-10:active {\n    color: #ffffff1a!important\n  }\n\n  .active\\:text-white-alpha-20:active {\n    color: #fff3!important\n  }\n\n  .active\\:text-white-alpha-30:active {\n    color: #ffffff4d!important\n  }\n\n  .active\\:text-white-alpha-40:active {\n    color: #fff6!important\n  }\n\n  .active\\:text-white-alpha-50:active {\n    color: #ffffff80!important\n  }\n\n  .active\\:text-white-alpha-60:active {\n    color: #fff9!important\n  }\n\n  .active\\:text-white-alpha-70:active {\n    color: #ffffffb3!important\n  }\n\n  .active\\:text-white-alpha-80:active {\n    color: #fffc!important\n  }\n\n  .active\\:text-white-alpha-90:active {\n    color: #ffffffe6!important\n  }\n\n  .text-black-alpha-10 {\n    color: #0000001a!important\n  }\n\n  .text-black-alpha-20 {\n    color: #0003!important\n  }\n\n  .text-black-alpha-30 {\n    color: #0000004d!important\n  }\n\n  .text-black-alpha-40 {\n    color: #0006!important\n  }\n\n  .text-black-alpha-50 {\n    color: #00000080!important\n  }\n\n  .text-black-alpha-60 {\n    color: #0009!important\n  }\n\n  .text-black-alpha-70 {\n    color: #000000b3!important\n  }\n\n  .text-black-alpha-80 {\n    color: #000c!important\n  }\n\n  .text-black-alpha-90 {\n    color: #000000e6!important\n  }\n\n  .hover\\:text-black-alpha-10:hover {\n    color: #0000001a!important\n  }\n\n  .hover\\:text-black-alpha-20:hover {\n    color: #0003!important\n  }\n\n  .hover\\:text-black-alpha-30:hover {\n    color: #0000004d!important\n  }\n\n  .hover\\:text-black-alpha-40:hover {\n    color: #0006!important\n  }\n\n  .hover\\:text-black-alpha-50:hover {\n    color: #00000080!important\n  }\n\n  .hover\\:text-black-alpha-60:hover {\n    color: #0009!important\n  }\n\n  .hover\\:text-black-alpha-70:hover {\n    color: #000000b3!important\n  }\n\n  .hover\\:text-black-alpha-80:hover {\n    color: #000c!important\n  }\n\n  .hover\\:text-black-alpha-90:hover {\n    color: #000000e6!important\n  }\n\n  .focus\\:text-black-alpha-10:focus {\n    color: #0000001a!important\n  }\n\n  .focus\\:text-black-alpha-20:focus {\n    color: #0003!important\n  }\n\n  .focus\\:text-black-alpha-30:focus {\n    color: #0000004d!important\n  }\n\n  .focus\\:text-black-alpha-40:focus {\n    color: #0006!important\n  }\n\n  .focus\\:text-black-alpha-50:focus {\n    color: #00000080!important\n  }\n\n  .focus\\:text-black-alpha-60:focus {\n    color: #0009!important\n  }\n\n  .focus\\:text-black-alpha-70:focus {\n    color: #000000b3!important\n  }\n\n  .focus\\:text-black-alpha-80:focus {\n    color: #000c!important\n  }\n\n  .focus\\:text-black-alpha-90:focus {\n    color: #000000e6!important\n  }\n\n  .active\\:text-black-alpha-10:active {\n    color: #0000001a!important\n  }\n\n  .active\\:text-black-alpha-20:active {\n    color: #0003!important\n  }\n\n  .active\\:text-black-alpha-30:active {\n    color: #0000004d!important\n  }\n\n  .active\\:text-black-alpha-40:active {\n    color: #0006!important\n  }\n\n  .active\\:text-black-alpha-50:active {\n    color: #00000080!important\n  }\n\n  .active\\:text-black-alpha-60:active {\n    color: #0009!important\n  }\n\n  .active\\:text-black-alpha-70:active {\n    color: #000000b3!important\n  }\n\n  .active\\:text-black-alpha-80:active {\n    color: #000c!important\n  }\n\n  .active\\:text-black-alpha-90:active {\n    color: #000000e6!important\n  }\n\n  .text-primary {\n    color: var(--primary-color)!important\n  }\n\n  .bg-primary {\n    color: var(--primary-color-text)!important;\n    background-color: var(--primary-color)!important\n  }\n\n  .bg-primary-reverse {\n    color: var(--primary-color)!important;\n    background-color: var(--primary-color-text)!important\n  }\n\n  .bg-white {\n    background-color: #fff!important\n  }\n\n  .border-primary {\n    border-color: var(--primary-color)!important\n  }\n\n  .text-white {\n    color: #fff!important\n  }\n\n  .border-white {\n    border-color: #fff!important\n  }\n\n  .text-color {\n    color: var(--text-color)!important\n  }\n\n  .text-color-secondary {\n    color: var(--text-color-secondary)!important\n  }\n\n  .surface-ground {\n    background-color: var(--surface-ground)!important\n  }\n\n  .surface-section {\n    background-color: var(--surface-section)!important\n  }\n\n  .surface-card {\n    background-color: var(--surface-card)!important\n  }\n\n  .surface-card\\:hover:hover {\n    box-shadow: var(--shadow-4);\n  }\n\n  .surface-overlay {\n    background-color: var(--surface-overlay)!important\n  }\n\n  .surface-hover {\n    background-color: var(--surface-hover)!important\n  }\n\n  .surface-border {\n    border-color: var(--surface-border)!important\n  }\n\n  .focus\\:text-primary:focus {\n    color: var(--primary-color)!important\n  }\n\n  .hover\\:text-primary:hover,.active\\:text-primary:active {\n    color: var(--primary-color)!important\n  }\n\n  .focus\\:bg-primary:focus {\n    color: var(--primary-color-text)!important;\n    background-color: var(--primary-color)!important\n  }\n\n  .hover\\:bg-primary:hover,.active\\:bg-primary:active {\n    color: var(--primary-color-text)!important;\n    background-color: var(--primary-color)!important\n  }\n\n  .focus\\:bg-primary-reverse:focus {\n    color: var(--primary-color)!important;\n    background-color: var(--primary-color-text)!important\n  }\n\n  .hover\\:bg-primary-reverse:hover,.active\\:bg-primary-reverse:active {\n    color: var(--primary-color)!important;\n    background-color: var(--primary-color-text)!important\n  }\n\n  .focus\\:bg-white:focus {\n    background-color: #fff!important\n  }\n\n  .hover\\:bg-white:hover,.active\\:bg-white:active {\n    background-color: #fff!important\n  }\n\n  .focus\\:border-primary:focus {\n    border-color: var(--primary-color)!important\n  }\n\n  .hover\\:border-primary:hover,.active\\:border-primary:active {\n    border-color: var(--primary-color)!important\n  }\n\n  .focus\\:text-white:focus {\n    color: #fff!important\n  }\n\n  .hover\\:text-white:hover,.active\\:text-white:active {\n    color: #fff!important\n  }\n\n  .focus\\:border-white:focus {\n    border-color: #fff!important\n  }\n\n  .hover\\:border-white:hover,.active\\:border-white:active {\n    border-color: #fff!important\n  }\n\n  .focus\\:text-color:focus {\n    color: var(--text-color)!important\n  }\n\n  .hover\\:text-color:hover,.active\\:text-color:active {\n    color: var(--text-color)!important\n  }\n\n  .focus\\:text-color-secondary:focus {\n    color: var(--text-color-secondary)!important\n  }\n\n  .hover\\:text-color-secondary:hover,.active\\:text-color-secondary:active {\n    color: var(--text-color-secondary)!important\n  }\n\n  .focus\\:surface-ground:focus {\n    background-color: var(--surface-ground)!important\n  }\n\n  .hover\\:surface-ground:hover,.active\\:surface-ground:active {\n    background-color: var(--surface-ground)!important\n  }\n\n  .focus\\:surface-section:focus {\n    background-color: var(--surface-section)!important\n  }\n\n  .hover\\:surface-section:hover,.active\\:surface-section:active {\n    background-color: var(--surface-section)!important\n  }\n\n  .focus\\:surface-card:focus {\n    background-color: var(--surface-card)!important\n  }\n\n  .hover\\:surface-card:hover,.active\\:surface-card:active {\n    background-color: var(--surface-card)!important\n  }\n\n  .focus\\:surface-overlay:focus {\n    background-color: var(--surface-overlay)!important\n  }\n\n  .hover\\:surface-overlay:hover,.active\\:surface-overlay:active {\n    background-color: var(--surface-overlay)!important\n  }\n\n  .focus\\:surface-hover:focus {\n    background-color: var(--surface-hover)!important\n  }\n\n  .hover\\:surface-hover:hover,.active\\:surface-hover:active {\n    background-color: var(--surface-hover)!important\n  }\n\n  .focus\\:surface-border:focus {\n    border-color: var(--surface-border)!important\n  }\n\n  .hover\\:surface-border:hover,.active\\:surface-border:active {\n    border-color: var(--surface-border)!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:text-primary {\n      color:var(--primary-color)!important\n    }\n\n    .sm\\:bg-primary {\n      color: var(--primary-color-text)!important;\n      background-color: var(--primary-color)!important\n    }\n\n    .sm\\:bg-primary-reverse {\n      color: var(--primary-color)!important;\n      background-color: var(--primary-color-text)!important\n    }\n\n    .sm\\:bg-white {\n      background-color: #fff!important\n    }\n\n    .sm\\:border-primary {\n      border-color: var(--primary-color)!important\n    }\n\n    .sm\\:text-white {\n      color: #fff!important\n    }\n\n    .sm\\:border-white {\n      border-color: #fff!important\n    }\n\n    .sm\\:text-color {\n      color: var(--text-color)!important\n    }\n\n    .sm\\:text-color-secondary {\n      color: var(--text-color-secondary)!important\n    }\n\n    .sm\\:surface-ground {\n      background-color: var(--surface-ground)!important\n    }\n\n    .sm\\:surface-section {\n      background-color: var(--surface-section)!important\n    }\n\n    .sm\\:surface-card {\n      background-color: var(--surface-card)!important\n    }\n\n    .sm\\:surface-overlay {\n      background-color: var(--surface-overlay)!important\n    }\n\n    .sm\\:surface-hover {\n      background-color: var(--surface-hover)!important\n    }\n\n    .sm\\:surface-border {\n      border-color: var(--surface-border)!important\n    }\n\n    .sm\\:focus\\:text-primary:focus {\n      color: var(--primary-color)!important\n    }\n\n    .sm\\:hover\\:text-primary:hover,.sm\\:active\\:text-primary:active {\n      color: var(--primary-color)!important\n    }\n\n    .sm\\:focus\\:bg-primary:focus {\n      color: var(--primary-color-text)!important;\n      background-color: var(--primary-color)!important\n    }\n\n    .sm\\:hover\\:bg-primary:hover,.sm\\:active\\:bg-primary:active {\n      color: var(--primary-color-text)!important;\n      background-color: var(--primary-color)!important\n    }\n\n    .sm\\:focus\\:bg-primary-reverse:focus {\n      color: var(--primary-color)!important;\n      background-color: var(--primary-color-text)!important\n    }\n\n    .sm\\:hover\\:bg-primary-reverse:hover,.sm\\:active\\:bg-primary-reverse:active {\n      color: var(--primary-color)!important;\n      background-color: var(--primary-color-text)!important\n    }\n\n    .sm\\:focus\\:bg-white:focus {\n      background-color: #fff!important\n    }\n\n    .sm\\:hover\\:bg-white:hover,.sm\\:active\\:bg-white:active {\n      background-color: #fff!important\n    }\n\n    .sm\\:focus\\:border-primary:focus {\n      border-color: var(--primary-color)!important\n    }\n\n    .sm\\:hover\\:border-primary:hover,.sm\\:active\\:border-primary:active {\n      border-color: var(--primary-color)!important\n    }\n\n    .sm\\:focus\\:text-white:focus {\n      color: #fff!important\n    }\n\n    .sm\\:hover\\:text-white:hover,.sm\\:active\\:text-white:active {\n      color: #fff!important\n    }\n\n    .sm\\:focus\\:border-white:focus {\n      border-color: #fff!important\n    }\n\n    .sm\\:hover\\:border-white:hover,.sm\\:active\\:border-white:active {\n      border-color: #fff!important\n    }\n\n    .sm\\:focus\\:text-color:focus {\n      color: var(--text-color)!important\n    }\n\n    .sm\\:hover\\:text-color:hover,.sm\\:active\\:text-color:active {\n      color: var(--text-color)!important\n    }\n\n    .sm\\:focus\\:text-color-secondary:focus {\n      color: var(--text-color-secondary)!important\n    }\n\n    .sm\\:hover\\:text-color-secondary:hover,.sm\\:active\\:text-color-secondary:active {\n      color: var(--text-color-secondary)!important\n    }\n\n    .sm\\:focus\\:surface-ground:focus {\n      background-color: var(--surface-ground)!important\n    }\n\n    .sm\\:hover\\:surface-ground:hover,.sm\\:active\\:surface-ground:active {\n      background-color: var(--surface-ground)!important\n    }\n\n    .sm\\:focus\\:surface-section:focus {\n      background-color: var(--surface-section)!important\n    }\n\n    .sm\\:hover\\:surface-section:hover,.sm\\:active\\:surface-section:active {\n      background-color: var(--surface-section)!important\n    }\n\n    .sm\\:focus\\:surface-card:focus {\n      background-color: var(--surface-card)!important\n    }\n\n    .sm\\:hover\\:surface-card:hover,.sm\\:active\\:surface-card:active {\n      background-color: var(--surface-card)!important\n    }\n\n    .sm\\:focus\\:surface-overlay:focus {\n      background-color: var(--surface-overlay)!important\n    }\n\n    .sm\\:hover\\:surface-overlay:hover,.sm\\:active\\:surface-overlay:active {\n      background-color: var(--surface-overlay)!important\n    }\n\n    .sm\\:focus\\:surface-hover:focus {\n      background-color: var(--surface-hover)!important\n    }\n\n    .sm\\:hover\\:surface-hover:hover,.sm\\:active\\:surface-hover:active {\n      background-color: var(--surface-hover)!important\n    }\n\n    .sm\\:focus\\:surface-border:focus {\n      border-color: var(--surface-border)!important\n    }\n\n    .sm\\:hover\\:surface-border:hover,.sm\\:active\\:surface-border:active {\n      border-color: var(--surface-border)!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:text-primary {\n      color:var(--primary-color)!important\n    }\n\n    .md\\:bg-primary {\n      color: var(--primary-color-text)!important;\n      background-color: var(--primary-color)!important\n    }\n\n    .md\\:bg-primary-reverse {\n      color: var(--primary-color)!important;\n      background-color: var(--primary-color-text)!important\n    }\n\n    .md\\:bg-white {\n      background-color: #fff!important\n    }\n\n    .md\\:border-primary {\n      border-color: var(--primary-color)!important\n    }\n\n    .md\\:text-white {\n      color: #fff!important\n    }\n\n    .md\\:border-white {\n      border-color: #fff!important\n    }\n\n    .md\\:text-color {\n      color: var(--text-color)!important\n    }\n\n    .md\\:text-color-secondary {\n      color: var(--text-color-secondary)!important\n    }\n\n    .md\\:surface-ground {\n      background-color: var(--surface-ground)!important\n    }\n\n    .md\\:surface-section {\n      background-color: var(--surface-section)!important\n    }\n\n    .md\\:surface-card {\n      background-color: var(--surface-card)!important\n    }\n\n    .md\\:surface-overlay {\n      background-color: var(--surface-overlay)!important\n    }\n\n    .md\\:surface-hover {\n      background-color: var(--surface-hover)!important\n    }\n\n    .md\\:surface-border {\n      border-color: var(--surface-border)!important\n    }\n\n    .md\\:focus\\:text-primary:focus {\n      color: var(--primary-color)!important\n    }\n\n    .md\\:hover\\:text-primary:hover,.md\\:active\\:text-primary:active {\n      color: var(--primary-color)!important\n    }\n\n    .md\\:focus\\:bg-primary:focus {\n      color: var(--primary-color-text)!important;\n      background-color: var(--primary-color)!important\n    }\n\n    .md\\:hover\\:bg-primary:hover,.md\\:active\\:bg-primary:active {\n      color: var(--primary-color-text)!important;\n      background-color: var(--primary-color)!important\n    }\n\n    .md\\:focus\\:bg-primary-reverse:focus {\n      color: var(--primary-color)!important;\n      background-color: var(--primary-color-text)!important\n    }\n\n    .md\\:hover\\:bg-primary-reverse:hover,.md\\:active\\:bg-primary-reverse:active {\n      color: var(--primary-color)!important;\n      background-color: var(--primary-color-text)!important\n    }\n\n    .md\\:focus\\:bg-white:focus {\n      background-color: #fff!important\n    }\n\n    .md\\:hover\\:bg-white:hover,.md\\:active\\:bg-white:active {\n      background-color: #fff!important\n    }\n\n    .md\\:focus\\:border-primary:focus {\n      border-color: var(--primary-color)!important\n    }\n\n    .md\\:hover\\:border-primary:hover,.md\\:active\\:border-primary:active {\n      border-color: var(--primary-color)!important\n    }\n\n    .md\\:focus\\:text-white:focus {\n      color: #fff!important\n    }\n\n    .md\\:hover\\:text-white:hover,.md\\:active\\:text-white:active {\n      color: #fff!important\n    }\n\n    .md\\:focus\\:border-white:focus {\n      border-color: #fff!important\n    }\n\n    .md\\:hover\\:border-white:hover,.md\\:active\\:border-white:active {\n      border-color: #fff!important\n    }\n\n    .md\\:focus\\:text-color:focus {\n      color: var(--text-color)!important\n    }\n\n    .md\\:hover\\:text-color:hover,.md\\:active\\:text-color:active {\n      color: var(--text-color)!important\n    }\n\n    .md\\:focus\\:text-color-secondary:focus {\n      color: var(--text-color-secondary)!important\n    }\n\n    .md\\:hover\\:text-color-secondary:hover,.md\\:active\\:text-color-secondary:active {\n      color: var(--text-color-secondary)!important\n    }\n\n    .md\\:focus\\:surface-ground:focus {\n      background-color: var(--surface-ground)!important\n    }\n\n    .md\\:hover\\:surface-ground:hover,.md\\:active\\:surface-ground:active {\n      background-color: var(--surface-ground)!important\n    }\n\n    .md\\:focus\\:surface-section:focus {\n      background-color: var(--surface-section)!important\n    }\n\n    .md\\:hover\\:surface-section:hover,.md\\:active\\:surface-section:active {\n      background-color: var(--surface-section)!important\n    }\n\n    .md\\:focus\\:surface-card:focus {\n      background-color: var(--surface-card)!important\n    }\n\n    .md\\:hover\\:surface-card:hover,.md\\:active\\:surface-card:active {\n      background-color: var(--surface-card)!important\n    }\n\n    .md\\:focus\\:surface-overlay:focus {\n      background-color: var(--surface-overlay)!important\n    }\n\n    .md\\:hover\\:surface-overlay:hover,.md\\:active\\:surface-overlay:active {\n      background-color: var(--surface-overlay)!important\n    }\n\n    .md\\:focus\\:surface-hover:focus {\n      background-color: var(--surface-hover)!important\n    }\n\n    .md\\:hover\\:surface-hover:hover,.md\\:active\\:surface-hover:active {\n      background-color: var(--surface-hover)!important\n    }\n\n    .md\\:focus\\:surface-border:focus {\n      border-color: var(--surface-border)!important\n    }\n\n    .md\\:hover\\:surface-border:hover,.md\\:active\\:surface-border:active {\n      border-color: var(--surface-border)!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:text-primary {\n      color:var(--primary-color)!important\n    }\n\n    .lg\\:bg-primary {\n      color: var(--primary-color-text)!important;\n      background-color: var(--primary-color)!important\n    }\n\n    .lg\\:bg-primary-reverse {\n      color: var(--primary-color)!important;\n      background-color: var(--primary-color-text)!important\n    }\n\n    .lg\\:bg-white {\n      background-color: #fff!important\n    }\n\n    .lg\\:border-primary {\n      border-color: var(--primary-color)!important\n    }\n\n    .lg\\:text-white {\n      color: #fff!important\n    }\n\n    .lg\\:border-white {\n      border-color: #fff!important\n    }\n\n    .lg\\:text-color {\n      color: var(--text-color)!important\n    }\n\n    .lg\\:text-color-secondary {\n      color: var(--text-color-secondary)!important\n    }\n\n    .lg\\:surface-ground {\n      background-color: var(--surface-ground)!important\n    }\n\n    .lg\\:surface-section {\n      background-color: var(--surface-section)!important\n    }\n\n    .lg\\:surface-card {\n      background-color: var(--surface-card)!important\n    }\n\n    .lg\\:surface-overlay {\n      background-color: var(--surface-overlay)!important\n    }\n\n    .lg\\:surface-hover {\n      background-color: var(--surface-hover)!important\n    }\n\n    .lg\\:surface-border {\n      border-color: var(--surface-border)!important\n    }\n\n    .lg\\:focus\\:text-primary:focus {\n      color: var(--primary-color)!important\n    }\n\n    .lg\\:hover\\:text-primary:hover,.lg\\:active\\:text-primary:active {\n      color: var(--primary-color)!important\n    }\n\n    .lg\\:focus\\:bg-primary:focus {\n      color: var(--primary-color-text)!important;\n      background-color: var(--primary-color)!important\n    }\n\n    .lg\\:hover\\:bg-primary:hover,.lg\\:active\\:bg-primary:active {\n      color: var(--primary-color-text)!important;\n      background-color: var(--primary-color)!important\n    }\n\n    .lg\\:focus\\:bg-primary-reverse:focus {\n      color: var(--primary-color)!important;\n      background-color: var(--primary-color-text)!important\n    }\n\n    .lg\\:hover\\:bg-primary-reverse:hover,.lg\\:active\\:bg-primary-reverse:active {\n      color: var(--primary-color)!important;\n      background-color: var(--primary-color-text)!important\n    }\n\n    .lg\\:focus\\:bg-white:focus {\n      background-color: #fff!important\n    }\n\n    .lg\\:hover\\:bg-white:hover,.lg\\:active\\:bg-white:active {\n      background-color: #fff!important\n    }\n\n    .lg\\:focus\\:border-primary:focus {\n      border-color: var(--primary-color)!important\n    }\n\n    .lg\\:hover\\:border-primary:hover,.lg\\:active\\:border-primary:active {\n      border-color: var(--primary-color)!important\n    }\n\n    .lg\\:focus\\:text-white:focus {\n      color: #fff!important\n    }\n\n    .lg\\:hover\\:text-white:hover,.lg\\:active\\:text-white:active {\n      color: #fff!important\n    }\n\n    .lg\\:focus\\:border-white:focus {\n      border-color: #fff!important\n    }\n\n    .lg\\:hover\\:border-white:hover,.lg\\:active\\:border-white:active {\n      border-color: #fff!important\n    }\n\n    .lg\\:focus\\:text-color:focus {\n      color: var(--text-color)!important\n    }\n\n    .lg\\:hover\\:text-color:hover,.lg\\:active\\:text-color:active {\n      color: var(--text-color)!important\n    }\n\n    .lg\\:focus\\:text-color-secondary:focus {\n      color: var(--text-color-secondary)!important\n    }\n\n    .lg\\:hover\\:text-color-secondary:hover,.lg\\:active\\:text-color-secondary:active {\n      color: var(--text-color-secondary)!important\n    }\n\n    .lg\\:focus\\:surface-ground:focus {\n      background-color: var(--surface-ground)!important\n    }\n\n    .lg\\:hover\\:surface-ground:hover,.lg\\:active\\:surface-ground:active {\n      background-color: var(--surface-ground)!important\n    }\n\n    .lg\\:focus\\:surface-section:focus {\n      background-color: var(--surface-section)!important\n    }\n\n    .lg\\:hover\\:surface-section:hover,.lg\\:active\\:surface-section:active {\n      background-color: var(--surface-section)!important\n    }\n\n    .lg\\:focus\\:surface-card:focus {\n      background-color: var(--surface-card)!important\n    }\n\n    .lg\\:hover\\:surface-card:hover,.lg\\:active\\:surface-card:active {\n      background-color: var(--surface-card)!important\n    }\n\n    .lg\\:focus\\:surface-overlay:focus {\n      background-color: var(--surface-overlay)!important\n    }\n\n    .lg\\:hover\\:surface-overlay:hover,.lg\\:active\\:surface-overlay:active {\n      background-color: var(--surface-overlay)!important\n    }\n\n    .lg\\:focus\\:surface-hover:focus {\n      background-color: var(--surface-hover)!important\n    }\n\n    .lg\\:hover\\:surface-hover:hover,.lg\\:active\\:surface-hover:active {\n      background-color: var(--surface-hover)!important\n    }\n\n    .lg\\:focus\\:surface-border:focus {\n      border-color: var(--surface-border)!important\n    }\n\n    .lg\\:hover\\:surface-border:hover,.lg\\:active\\:surface-border:active {\n      border-color: var(--surface-border)!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:text-primary {\n      color:var(--primary-color)!important\n    }\n\n    .xl\\:bg-primary {\n      color: var(--primary-color-text)!important;\n      background-color: var(--primary-color)!important\n    }\n\n    .xl\\:bg-primary-reverse {\n      color: var(--primary-color)!important;\n      background-color: var(--primary-color-text)!important\n    }\n\n    .xl\\:bg-white {\n      background-color: #fff!important\n    }\n\n    .xl\\:border-primary {\n      border-color: var(--primary-color)!important\n    }\n\n    .xl\\:text-white {\n      color: #fff!important\n    }\n\n    .xl\\:border-white {\n      border-color: #fff!important\n    }\n\n    .xl\\:text-color {\n      color: var(--text-color)!important\n    }\n\n    .xl\\:text-color-secondary {\n      color: var(--text-color-secondary)!important\n    }\n\n    .xl\\:surface-ground {\n      background-color: var(--surface-ground)!important\n    }\n\n    .xl\\:surface-section {\n      background-color: var(--surface-section)!important\n    }\n\n    .xl\\:surface-card {\n      background-color: var(--surface-card)!important\n    }\n\n    .xl\\:surface-overlay {\n      background-color: var(--surface-overlay)!important\n    }\n\n    .xl\\:surface-hover {\n      background-color: var(--surface-hover)!important\n    }\n\n    .xl\\:surface-border {\n      border-color: var(--surface-border)!important\n    }\n\n    .xl\\:focus\\:text-primary:focus {\n      color: var(--primary-color)!important\n    }\n\n    .xl\\:hover\\:text-primary:hover,.xl\\:active\\:text-primary:active {\n      color: var(--primary-color)!important\n    }\n\n    .xl\\:focus\\:bg-primary:focus {\n      color: var(--primary-color-text)!important;\n      background-color: var(--primary-color)!important\n    }\n\n    .xl\\:hover\\:bg-primary:hover,.xl\\:active\\:bg-primary:active {\n      color: var(--primary-color-text)!important;\n      background-color: var(--primary-color)!important\n    }\n\n    .xl\\:focus\\:bg-primary-reverse:focus {\n      color: var(--primary-color)!important;\n      background-color: var(--primary-color-text)!important\n    }\n\n    .xl\\:hover\\:bg-primary-reverse:hover,.xl\\:active\\:bg-primary-reverse:active {\n      color: var(--primary-color)!important;\n      background-color: var(--primary-color-text)!important\n    }\n\n    .xl\\:focus\\:bg-white:focus {\n      background-color: #fff!important\n    }\n\n    .xl\\:hover\\:bg-white:hover,.xl\\:active\\:bg-white:active {\n      background-color: #fff!important\n    }\n\n    .xl\\:focus\\:border-primary:focus {\n      border-color: var(--primary-color)!important\n    }\n\n    .xl\\:hover\\:border-primary:hover,.xl\\:active\\:border-primary:active {\n      border-color: var(--primary-color)!important\n    }\n\n    .xl\\:focus\\:text-white:focus {\n      color: #fff!important\n    }\n\n    .xl\\:hover\\:text-white:hover,.xl\\:active\\:text-white:active {\n      color: #fff!important\n    }\n\n    .xl\\:focus\\:border-white:focus {\n      border-color: #fff!important\n    }\n\n    .xl\\:hover\\:border-white:hover,.xl\\:active\\:border-white:active {\n      border-color: #fff!important\n    }\n\n    .xl\\:focus\\:text-color:focus {\n      color: var(--text-color)!important\n    }\n\n    .xl\\:hover\\:text-color:hover,.xl\\:active\\:text-color:active {\n      color: var(--text-color)!important\n    }\n\n    .xl\\:focus\\:text-color-secondary:focus {\n      color: var(--text-color-secondary)!important\n    }\n\n    .xl\\:hover\\:text-color-secondary:hover,.xl\\:active\\:text-color-secondary:active {\n      color: var(--text-color-secondary)!important\n    }\n\n    .xl\\:focus\\:surface-ground:focus {\n      background-color: var(--surface-ground)!important\n    }\n\n    .xl\\:hover\\:surface-ground:hover,.xl\\:active\\:surface-ground:active {\n      background-color: var(--surface-ground)!important\n    }\n\n    .xl\\:focus\\:surface-section:focus {\n      background-color: var(--surface-section)!important\n    }\n\n    .xl\\:hover\\:surface-section:hover,.xl\\:active\\:surface-section:active {\n      background-color: var(--surface-section)!important\n    }\n\n    .xl\\:focus\\:surface-card:focus {\n      background-color: var(--surface-card)!important\n    }\n\n    .xl\\:hover\\:surface-card:hover,.xl\\:active\\:surface-card:active {\n      background-color: var(--surface-card)!important\n    }\n\n    .xl\\:focus\\:surface-overlay:focus {\n      background-color: var(--surface-overlay)!important\n    }\n\n    .xl\\:hover\\:surface-overlay:hover,.xl\\:active\\:surface-overlay:active {\n      background-color: var(--surface-overlay)!important\n    }\n\n    .xl\\:focus\\:surface-hover:focus {\n      background-color: var(--surface-hover)!important\n    }\n\n    .xl\\:hover\\:surface-hover:hover,.xl\\:active\\:surface-hover:active {\n      background-color: var(--surface-hover)!important\n    }\n\n    .xl\\:focus\\:surface-border:focus {\n      border-color: var(--surface-border)!important\n    }\n\n    .xl\\:hover\\:surface-border:hover,.xl\\:active\\:surface-border:active {\n      border-color: var(--surface-border)!important\n    }\n  }\n\n  .field {\n    margin-bottom: 1rem\n  }\n\n  .field>label {\n    display: inline-block;\n    margin-bottom: .5rem\n  }\n\n  .field.grid>label {\n    display: flex;\n    align-items: center\n  }\n\n  .field>small {\n    margin-top: .25rem\n  }\n\n  .field.grid,.formgrid.grid {\n    margin-top: 0\n  }\n\n  .field.grid .col-fixed,.formgrid.grid .col-fixed,.field.grid .col,.formgrid.grid .col,.field.grid .col-1,.formgrid.grid .col-1,.field.grid .col-2,.formgrid.grid .col-2,.field.grid .col-3,.formgrid.grid .col-3,.field.grid .col-4,.formgrid.grid .col-4,.field.grid .col-5,.formgrid.grid .col-5,.field.grid .col-6,.formgrid.grid .col-6,.field.grid .col-7,.formgrid.grid .col-7,.field.grid .col-8,.formgrid.grid .col-8,.field.grid .col-9,.formgrid.grid .col-9,.field.grid .col-10,.formgrid.grid .col-10,.field.grid .col-11,.formgrid.grid .col-11,.field.grid .col-12,.formgrid.grid .col-12 {\n    padding-top: 0;\n    padding-bottom: 0\n  }\n\n  .formgroup-inline {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start\n  }\n\n  .formgroup-inline .field,.formgroup-inline .field-checkbox,.formgroup-inline .field-radiobutton {\n    margin-right: 1rem\n  }\n\n  .formgroup-inline .field>label,.formgroup-inline .field-checkbox>label,.formgroup-inline .field-radiobutton>label {\n    margin-right: .5rem;\n    margin-bottom: 0\n  }\n\n  .field-checkbox,.field-radiobutton {\n    margin-bottom: 1rem;\n    display: flex;\n    align-items: center\n  }\n\n  .field-checkbox>label,.field-radiobutton>label {\n    margin-left: .5rem;\n    line-height: 1\n  }\n\n  .hidden {\n    display: none!important\n  }\n\n  .block {\n    display: block!important\n  }\n\n  .inline {\n    display: inline!important\n  }\n\n  .inline-block {\n    display: inline-block!important\n  }\n\n  .flex {\n    display: flex!important\n  }\n\n  .inline-flex {\n    display: inline-flex!important\n  }\n\n  .flex-center {\n    align-items: center!important;\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:hidden {\n      display:none!important\n    }\n\n    .sm\\:block {\n      display: block!important\n    }\n\n    .sm\\:inline {\n      display: inline!important\n    }\n\n    .sm\\:inline-block {\n      display: inline-block!important\n    }\n\n    .sm\\:flex {\n      display: flex!important\n    }\n\n    .sm\\:inline-flex {\n      display: inline-flex!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:hidden {\n      display:none!important\n    }\n\n    .md\\:block {\n      display: block!important\n    }\n\n    .md\\:inline {\n      display: inline!important\n    }\n\n    .md\\:inline-block {\n      display: inline-block!important\n    }\n\n    .md\\:flex {\n      display: flex!important\n    }\n\n    .md\\:inline-flex {\n      display: inline-flex!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:hidden {\n      display:none!important\n    }\n\n    .lg\\:block {\n      display: block!important\n    }\n\n    .lg\\:inline {\n      display: inline!important\n    }\n\n    .lg\\:inline-block {\n      display: inline-block!important\n    }\n\n    .lg\\:flex {\n      display: flex!important\n    }\n\n    .lg\\:inline-flex {\n      display: inline-flex!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:hidden {\n      display:none!important\n    }\n\n    .xl\\:block {\n      display: block!important\n    }\n\n    .xl\\:inline {\n      display: inline!important\n    }\n\n    .xl\\:inline-block {\n      display: inline-block!important\n    }\n\n    .xl\\:flex {\n      display: flex!important\n    }\n\n    .xl\\:inline-flex {\n      display: inline-flex!important\n    }\n  }\n\n  .text-center {\n    text-align: center!important\n  }\n\n  .text-justify {\n    text-align: justify!important\n  }\n\n  .text-left {\n    text-align: left!important\n  }\n\n  .text-right {\n    text-align: right!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:text-center {\n      text-align:center!important\n    }\n\n    .sm\\:text-justify {\n      text-align: justify!important\n    }\n\n    .sm\\:text-left {\n      text-align: left!important\n    }\n\n    .sm\\:text-right {\n      text-align: right!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:text-center {\n      text-align:center!important\n    }\n\n    .md\\:text-justify {\n      text-align: justify!important\n    }\n\n    .md\\:text-left {\n      text-align: left!important\n    }\n\n    .md\\:text-right {\n      text-align: right!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:text-center {\n      text-align:center!important\n    }\n\n    .lg\\:text-justify {\n      text-align: justify!important\n    }\n\n    .lg\\:text-left {\n      text-align: left!important\n    }\n\n    .lg\\:text-right {\n      text-align: right!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:text-center {\n      text-align:center!important\n    }\n\n    .xl\\:text-justify {\n      text-align: justify!important\n    }\n\n    .xl\\:text-left {\n      text-align: left!important\n    }\n\n    .xl\\:text-right {\n      text-align: right!important\n    }\n  }\n\n  .underline {\n    text-decoration: underline!important\n  }\n\n  .line-through {\n    text-decoration: line-through!important\n  }\n\n  .no-underline {\n    text-decoration: none!important\n  }\n\n  .focus\\:underline:focus {\n    text-decoration: underline!important\n  }\n\n  .hover\\:underline:hover,.active\\:underline:active {\n    text-decoration: underline!important\n  }\n\n  .focus\\:line-through:focus {\n    text-decoration: line-through!important\n  }\n\n  .hover\\:line-through:hover,.active\\:line-through:active {\n    text-decoration: line-through!important\n  }\n\n  .focus\\:no-underline:focus {\n    text-decoration: none!important\n  }\n\n  .hover\\:no-underline:hover,.active\\:no-underline:active {\n    text-decoration: none!important\n  }\n\n  .lowercase {\n    text-transform: lowercase!important\n  }\n\n  .uppercase {\n    text-transform: uppercase!important\n  }\n\n  .capitalize {\n    text-transform: capitalize!important\n  }\n\n  .text-overflow-clip {\n    text-overflow: clip!important\n  }\n\n  .text-overflow-ellipsis {\n    text-overflow: ellipsis!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:text-overflow-clip {\n      text-overflow:clip!important\n    }\n\n    .sm\\:text-overflow-ellipsis {\n      text-overflow: ellipsis!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:text-overflow-clip {\n      text-overflow:clip!important\n    }\n\n    .md\\:text-overflow-ellipsis {\n      text-overflow: ellipsis!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:text-overflow-clip {\n      text-overflow:clip!important\n    }\n\n    .lg\\:text-overflow-ellipsis {\n      text-overflow: ellipsis!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:text-overflow-clip {\n      text-overflow:clip!important\n    }\n\n    .xl\\:text-overflow-ellipsis {\n      text-overflow: ellipsis!important\n    }\n  }\n\n  .font-light {\n    font-weight: 300!important\n  }\n\n  .font-normal {\n    font-weight: 400!important\n  }\n\n  .font-medium {\n    font-weight: 500!important\n  }\n\n  .font-semibold {\n    font-weight: 600!important\n  }\n\n  .font-bold {\n    font-weight: 700!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:font-light {\n      font-weight:300!important\n    }\n\n    .sm\\:font-normal {\n      font-weight: 400!important\n    }\n\n    .sm\\:font-medium {\n      font-weight: 500!important\n    }\n\n    .sm\\:font-semibold {\n      font-weight: 600!important\n    }\n\n    .sm\\:font-bold {\n      font-weight: 700!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:font-light {\n      font-weight:300!important\n    }\n\n    .md\\:font-normal {\n      font-weight: 400!important\n    }\n\n    .md\\:font-medium {\n      font-weight: 500!important\n    }\n\n    .md\\:font-semibold {\n      font-weight: 600!important\n    }\n\n    .md\\:font-bold {\n      font-weight: 700!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:font-light {\n      font-weight:300!important\n    }\n\n    .lg\\:font-normal {\n      font-weight: 400!important\n    }\n\n    .lg\\:font-medium {\n      font-weight: 500!important\n    }\n\n    .lg\\:font-semibold {\n      font-weight: 600!important\n    }\n\n    .lg\\:font-bold {\n      font-weight: 700!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:font-light {\n      font-weight:300!important\n    }\n\n    .xl\\:font-normal {\n      font-weight: 400!important\n    }\n\n    .xl\\:font-medium {\n      font-weight: 500!important\n    }\n\n    .xl\\:font-semibold {\n      font-weight: 600!important\n    }\n\n    .xl\\:font-bold {\n      font-weight: 700!important\n    }\n  }\n\n  .font-italic {\n    font-style: italic!important\n  }\n\n  .text-xs {\n    font-size: .75rem!important\n  }\n\n  .text-sm {\n    font-size: .875rem!important\n  }\n\n  .text-base {\n    font-size: 1rem!important\n  }\n\n  .text-lg {\n    font-size: 1.125rem!important\n  }\n\n  .text-xl {\n    font-size: 1.25rem!important\n  }\n\n  .text-2xl {\n    font-size: 1.5rem!important\n  }\n\n  .text-3xl {\n    font-size: 1.75rem!important\n  }\n\n  .text-4xl {\n    font-size: 2rem!important\n  }\n\n  .text-5xl {\n    font-size: 2.5rem!important\n  }\n\n  .text-6xl {\n    font-size: 3rem!important\n  }\n\n  .text-7xl {\n    font-size: 4rem!important\n  }\n\n  .text-8xl {\n    font-size: 6rem!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:text-xs {\n      font-size:.75rem!important\n    }\n\n    .sm\\:text-sm {\n      font-size: .875rem!important\n    }\n\n    .sm\\:text-base {\n      font-size: 1rem!important\n    }\n\n    .sm\\:text-lg {\n      font-size: 1.125rem!important\n    }\n\n    .sm\\:text-xl {\n      font-size: 1.25rem!important\n    }\n\n    .sm\\:text-2xl {\n      font-size: 1.5rem!important\n    }\n\n    .sm\\:text-3xl {\n      font-size: 1.75rem!important\n    }\n\n    .sm\\:text-4xl {\n      font-size: 2rem!important\n    }\n\n    .sm\\:text-5xl {\n      font-size: 2.5rem!important\n    }\n\n    .sm\\:text-6xl {\n      font-size: 3rem!important\n    }\n\n    .sm\\:text-7xl {\n      font-size: 4rem!important\n    }\n\n    .sm\\:text-8xl {\n      font-size: 6rem!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:text-xs {\n      font-size:.75rem!important\n    }\n\n    .md\\:text-sm {\n      font-size: .875rem!important\n    }\n\n    .md\\:text-base {\n      font-size: 1rem!important\n    }\n\n    .md\\:text-lg {\n      font-size: 1.125rem!important\n    }\n\n    .md\\:text-xl {\n      font-size: 1.25rem!important\n    }\n\n    .md\\:text-2xl {\n      font-size: 1.5rem!important\n    }\n\n    .md\\:text-3xl {\n      font-size: 1.75rem!important\n    }\n\n    .md\\:text-4xl {\n      font-size: 2rem!important\n    }\n\n    .md\\:text-5xl {\n      font-size: 2.5rem!important\n    }\n\n    .md\\:text-6xl {\n      font-size: 3rem!important\n    }\n\n    .md\\:text-7xl {\n      font-size: 4rem!important\n    }\n\n    .md\\:text-8xl {\n      font-size: 6rem!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:text-xs {\n      font-size:.75rem!important\n    }\n\n    .lg\\:text-sm {\n      font-size: .875rem!important\n    }\n\n    .lg\\:text-base {\n      font-size: 1rem!important\n    }\n\n    .lg\\:text-lg {\n      font-size: 1.125rem!important\n    }\n\n    .lg\\:text-xl {\n      font-size: 1.25rem!important\n    }\n\n    .lg\\:text-2xl {\n      font-size: 1.5rem!important\n    }\n\n    .lg\\:text-3xl {\n      font-size: 1.75rem!important\n    }\n\n    .lg\\:text-4xl {\n      font-size: 2rem!important\n    }\n\n    .lg\\:text-5xl {\n      font-size: 2.5rem!important\n    }\n\n    .lg\\:text-6xl {\n      font-size: 3rem!important\n    }\n\n    .lg\\:text-7xl {\n      font-size: 4rem!important\n    }\n\n    .lg\\:text-8xl {\n      font-size: 6rem!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:text-xs {\n      font-size:.75rem!important\n    }\n\n    .xl\\:text-sm {\n      font-size: .875rem!important\n    }\n\n    .xl\\:text-base {\n      font-size: 1rem!important\n    }\n\n    .xl\\:text-lg {\n      font-size: 1.125rem!important\n    }\n\n    .xl\\:text-xl {\n      font-size: 1.25rem!important\n    }\n\n    .xl\\:text-2xl {\n      font-size: 1.5rem!important\n    }\n\n    .xl\\:text-3xl {\n      font-size: 1.75rem!important\n    }\n\n    .xl\\:text-4xl {\n      font-size: 2rem!important\n    }\n\n    .xl\\:text-5xl {\n      font-size: 2.5rem!important\n    }\n\n    .xl\\:text-6xl {\n      font-size: 3rem!important\n    }\n\n    .xl\\:text-7xl {\n      font-size: 4rem!important\n    }\n\n    .xl\\:text-8xl {\n      font-size: 6rem!important\n    }\n  }\n\n  .line-height-1 {\n    line-height: 1!important\n  }\n\n  .line-height-2 {\n    line-height: 1.25!important\n  }\n\n  .line-height-3 {\n    line-height: 1.5!important\n  }\n\n  .line-height-4 {\n    line-height: 2!important\n  }\n\n  .white-space-normal {\n    white-space: normal!important\n  }\n\n  .white-space-nowrap {\n    white-space: nowrap!important\n  }\n\n  .vertical-align-baseline {\n    vertical-align: baseline!important\n  }\n\n  .vertical-align-top {\n    vertical-align: top!important\n  }\n\n  .vertical-align-middle {\n    vertical-align: middle!important\n  }\n\n  .vertical-align-bottom {\n    vertical-align: bottom!important\n  }\n\n  .vertical-align-text-top {\n    vertical-align: text-top!important\n  }\n\n  .vertical-align-text-bottom {\n    vertical-align: text-bottom!important\n  }\n\n  .vertical-align-sub {\n    vertical-align: sub!important\n  }\n\n  .vertical-align-super {\n    vertical-align: super!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:vertical-align-baseline {\n      vertical-align:baseline!important\n    }\n\n    .sm\\:vertical-align-top {\n      vertical-align: top!important\n    }\n\n    .sm\\:vertical-align-middle {\n      vertical-align: middle!important\n    }\n\n    .sm\\:vertical-align-bottom {\n      vertical-align: bottom!important\n    }\n\n    .sm\\:vertical-align-text-top {\n      vertical-align: text-top!important\n    }\n\n    .sm\\:vertical-align-text-bottom {\n      vertical-align: text-bottom!important\n    }\n\n    .sm\\:vertical-align-sub {\n      vertical-align: sub!important\n    }\n\n    .sm\\:vertical-align-super {\n      vertical-align: super!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:vertical-align-baseline {\n      vertical-align:baseline!important\n    }\n\n    .md\\:vertical-align-top {\n      vertical-align: top!important\n    }\n\n    .md\\:vertical-align-middle {\n      vertical-align: middle!important\n    }\n\n    .md\\:vertical-align-bottom {\n      vertical-align: bottom!important\n    }\n\n    .md\\:vertical-align-text-top {\n      vertical-align: text-top!important\n    }\n\n    .md\\:vertical-align-text-bottom {\n      vertical-align: text-bottom!important\n    }\n\n    .md\\:vertical-align-sub {\n      vertical-align: sub!important\n    }\n\n    .md\\:vertical-align-super {\n      vertical-align: super!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:vertical-align-baseline {\n      vertical-align:baseline!important\n    }\n\n    .lg\\:vertical-align-top {\n      vertical-align: top!important\n    }\n\n    .lg\\:vertical-align-middle {\n      vertical-align: middle!important\n    }\n\n    .lg\\:vertical-align-bottom {\n      vertical-align: bottom!important\n    }\n\n    .lg\\:vertical-align-text-top {\n      vertical-align: text-top!important\n    }\n\n    .lg\\:vertical-align-text-bottom {\n      vertical-align: text-bottom!important\n    }\n\n    .lg\\:vertical-align-sub {\n      vertical-align: sub!important\n    }\n\n    .lg\\:vertical-align-super {\n      vertical-align: super!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:vertical-align-baseline {\n      vertical-align:baseline!important\n    }\n\n    .xl\\:vertical-align-top {\n      vertical-align: top!important\n    }\n\n    .xl\\:vertical-align-middle {\n      vertical-align: middle!important\n    }\n\n    .xl\\:vertical-align-bottom {\n      vertical-align: bottom!important\n    }\n\n    .xl\\:vertical-align-text-top {\n      vertical-align: text-top!important\n    }\n\n    .xl\\:vertical-align-text-bottom {\n      vertical-align: text-bottom!important\n    }\n\n    .xl\\:vertical-align-sub {\n      vertical-align: sub!important\n    }\n\n    .xl\\:vertical-align-super {\n      vertical-align: super!important\n    }\n  }\n\n  .flex-row {\n    flex-direction: row!important\n  }\n\n  .flex-row-reverse {\n    flex-direction: row-reverse!important\n  }\n\n  .flex-column {\n    flex-direction: column!important\n  }\n\n  .flex-column-reverse {\n    flex-direction: column-reverse!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:flex-row {\n      flex-direction:row!important\n    }\n\n    .sm\\:flex-row-reverse {\n      flex-direction: row-reverse!important\n    }\n\n    .sm\\:flex-column {\n      flex-direction: column!important\n    }\n\n    .sm\\:flex-column-reverse {\n      flex-direction: column-reverse!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:flex-row {\n      flex-direction:row!important\n    }\n\n    .md\\:flex-row-reverse {\n      flex-direction: row-reverse!important\n    }\n\n    .md\\:flex-column {\n      flex-direction: column!important\n    }\n\n    .md\\:flex-column-reverse {\n      flex-direction: column-reverse!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:flex-row {\n      flex-direction:row!important\n    }\n\n    .lg\\:flex-row-reverse {\n      flex-direction: row-reverse!important\n    }\n\n    .lg\\:flex-column {\n      flex-direction: column!important\n    }\n\n    .lg\\:flex-column-reverse {\n      flex-direction: column-reverse!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:flex-row {\n      flex-direction:row!important\n    }\n\n    .xl\\:flex-row-reverse {\n      flex-direction: row-reverse!important\n    }\n\n    .xl\\:flex-column {\n      flex-direction: column!important\n    }\n\n    .xl\\:flex-column-reverse {\n      flex-direction: column-reverse!important\n    }\n  }\n\n  .flex-wrap {\n    flex-wrap: wrap!important\n  }\n\n  .flex-wrap-reverse {\n    flex-wrap: wrap-reverse!important\n  }\n\n  .flex-nowrap {\n    flex-wrap: nowrap!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:flex-wrap {\n      flex-wrap:wrap!important\n    }\n\n    .sm\\:flex-wrap-reverse {\n      flex-wrap: wrap-reverse!important\n    }\n\n    .sm\\:flex-nowrap {\n      flex-wrap: nowrap!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:flex-wrap {\n      flex-wrap:wrap!important\n    }\n\n    .md\\:flex-wrap-reverse {\n      flex-wrap: wrap-reverse!important\n    }\n\n    .md\\:flex-nowrap {\n      flex-wrap: nowrap!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:flex-wrap {\n      flex-wrap:wrap!important\n    }\n\n    .lg\\:flex-wrap-reverse {\n      flex-wrap: wrap-reverse!important\n    }\n\n    .lg\\:flex-nowrap {\n      flex-wrap: nowrap!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:flex-wrap {\n      flex-wrap:wrap!important\n    }\n\n    .xl\\:flex-wrap-reverse {\n      flex-wrap: wrap-reverse!important\n    }\n\n    .xl\\:flex-nowrap {\n      flex-wrap: nowrap!important\n    }\n  }\n\n  .justify-content-start {\n    justify-content: flex-start!important\n  }\n\n  .justify-content-end {\n    justify-content: flex-end!important\n  }\n\n  .justify-content-center {\n    justify-content: center!important\n  }\n\n  .justify-content-between {\n    justify-content: space-between!important\n  }\n\n  .justify-content-around {\n    justify-content: space-around!important\n  }\n\n  .justify-content-evenly {\n    justify-content: space-evenly!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:justify-content-start {\n      justify-content:flex-start!important\n    }\n\n    .sm\\:justify-content-end {\n      justify-content: flex-end!important\n    }\n\n    .sm\\:justify-content-center {\n      justify-content: center!important\n    }\n\n    .sm\\:justify-content-between {\n      justify-content: space-between!important\n    }\n\n    .sm\\:justify-content-around {\n      justify-content: space-around!important\n    }\n\n    .sm\\:justify-content-evenly {\n      justify-content: space-evenly!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:justify-content-start {\n      justify-content:flex-start!important\n    }\n\n    .md\\:justify-content-end {\n      justify-content: flex-end!important\n    }\n\n    .md\\:justify-content-center {\n      justify-content: center!important\n    }\n\n    .md\\:justify-content-between {\n      justify-content: space-between!important\n    }\n\n    .md\\:justify-content-around {\n      justify-content: space-around!important\n    }\n\n    .md\\:justify-content-evenly {\n      justify-content: space-evenly!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:justify-content-start {\n      justify-content:flex-start!important\n    }\n\n    .lg\\:justify-content-end {\n      justify-content: flex-end!important\n    }\n\n    .lg\\:justify-content-center {\n      justify-content: center!important\n    }\n\n    .lg\\:justify-content-between {\n      justify-content: space-between!important\n    }\n\n    .lg\\:justify-content-around {\n      justify-content: space-around!important\n    }\n\n    .lg\\:justify-content-evenly {\n      justify-content: space-evenly!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:justify-content-start {\n      justify-content:flex-start!important\n    }\n\n    .xl\\:justify-content-end {\n      justify-content: flex-end!important\n    }\n\n    .xl\\:justify-content-center {\n      justify-content: center!important\n    }\n\n    .xl\\:justify-content-between {\n      justify-content: space-between!important\n    }\n\n    .xl\\:justify-content-around {\n      justify-content: space-around!important\n    }\n\n    .xl\\:justify-content-evenly {\n      justify-content: space-evenly!important\n    }\n  }\n\n  .align-content-start {\n    align-content: flex-start!important\n  }\n\n  .align-content-end {\n    align-content: flex-end!important\n  }\n\n  .align-content-center {\n    align-content: center!important\n  }\n\n  .align-content-between {\n    align-content: space-between!important\n  }\n\n  .align-content-around {\n    align-content: space-around!important\n  }\n\n  .align-content-evenly {\n    align-content: space-evenly!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:align-content-start {\n      align-content:flex-start!important\n    }\n\n    .sm\\:align-content-end {\n      align-content: flex-end!important\n    }\n\n    .sm\\:align-content-center {\n      align-content: center!important\n    }\n\n    .sm\\:align-content-between {\n      align-content: space-between!important\n    }\n\n    .sm\\:align-content-around {\n      align-content: space-around!important\n    }\n\n    .sm\\:align-content-evenly {\n      align-content: space-evenly!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:align-content-start {\n      align-content:flex-start!important\n    }\n\n    .md\\:align-content-end {\n      align-content: flex-end!important\n    }\n\n    .md\\:align-content-center {\n      align-content: center!important\n    }\n\n    .md\\:align-content-between {\n      align-content: space-between!important\n    }\n\n    .md\\:align-content-around {\n      align-content: space-around!important\n    }\n\n    .md\\:align-content-evenly {\n      align-content: space-evenly!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:align-content-start {\n      align-content:flex-start!important\n    }\n\n    .lg\\:align-content-end {\n      align-content: flex-end!important\n    }\n\n    .lg\\:align-content-center {\n      align-content: center!important\n    }\n\n    .lg\\:align-content-between {\n      align-content: space-between!important\n    }\n\n    .lg\\:align-content-around {\n      align-content: space-around!important\n    }\n\n    .lg\\:align-content-evenly {\n      align-content: space-evenly!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:align-content-start {\n      align-content:flex-start!important\n    }\n\n    .xl\\:align-content-end {\n      align-content: flex-end!important\n    }\n\n    .xl\\:align-content-center {\n      align-content: center!important\n    }\n\n    .xl\\:align-content-between {\n      align-content: space-between!important\n    }\n\n    .xl\\:align-content-around {\n      align-content: space-around!important\n    }\n\n    .xl\\:align-content-evenly {\n      align-content: space-evenly!important\n    }\n  }\n\n  .align-items-stretch {\n    align-items: stretch!important\n  }\n\n  .align-items-start {\n    align-items: flex-start!important\n  }\n\n  .align-items-center {\n    align-items: center!important\n  }\n\n  .align-items-end {\n    align-items: flex-end!important\n  }\n\n  .align-items-baseline {\n    align-items: baseline!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:align-items-stretch {\n      align-items:stretch!important\n    }\n\n    .sm\\:align-items-start {\n      align-items: flex-start!important\n    }\n\n    .sm\\:align-items-center {\n      align-items: center!important\n    }\n\n    .sm\\:align-items-end {\n      align-items: flex-end!important\n    }\n\n    .sm\\:align-items-baseline {\n      align-items: baseline!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:align-items-stretch {\n      align-items:stretch!important\n    }\n\n    .md\\:align-items-start {\n      align-items: flex-start!important\n    }\n\n    .md\\:align-items-center {\n      align-items: center!important\n    }\n\n    .md\\:align-items-end {\n      align-items: flex-end!important\n    }\n\n    .md\\:align-items-baseline {\n      align-items: baseline!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:align-items-stretch {\n      align-items:stretch!important\n    }\n\n    .lg\\:align-items-start {\n      align-items: flex-start!important\n    }\n\n    .lg\\:align-items-center {\n      align-items: center!important\n    }\n\n    .lg\\:align-items-end {\n      align-items: flex-end!important\n    }\n\n    .lg\\:align-items-baseline {\n      align-items: baseline!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:align-items-stretch {\n      align-items:stretch!important\n    }\n\n    .xl\\:align-items-start {\n      align-items: flex-start!important\n    }\n\n    .xl\\:align-items-center {\n      align-items: center!important\n    }\n\n    .xl\\:align-items-end {\n      align-items: flex-end!important\n    }\n\n    .xl\\:align-items-baseline {\n      align-items: baseline!important\n    }\n  }\n\n  .align-self-auto {\n    align-self: auto!important\n  }\n\n  .align-self-start {\n    align-self: flex-start!important\n  }\n\n  .align-self-end {\n    align-self: flex-end!important\n  }\n\n  .align-self-center {\n    align-self: center!important\n  }\n\n  .align-self-stretch {\n    align-self: stretch!important\n  }\n\n  .align-self-baseline {\n    align-self: baseline!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:align-self-auto {\n      align-self:auto!important\n    }\n\n    .sm\\:align-self-start {\n      align-self: flex-start!important\n    }\n\n    .sm\\:align-self-end {\n      align-self: flex-end!important\n    }\n\n    .sm\\:align-self-center {\n      align-self: center!important\n    }\n\n    .sm\\:align-self-stretch {\n      align-self: stretch!important\n    }\n\n    .sm\\:align-self-baseline {\n      align-self: baseline!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:align-self-auto {\n      align-self:auto!important\n    }\n\n    .md\\:align-self-start {\n      align-self: flex-start!important\n    }\n\n    .md\\:align-self-end {\n      align-self: flex-end!important\n    }\n\n    .md\\:align-self-center {\n      align-self: center!important\n    }\n\n    .md\\:align-self-stretch {\n      align-self: stretch!important\n    }\n\n    .md\\:align-self-baseline {\n      align-self: baseline!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:align-self-auto {\n      align-self:auto!important\n    }\n\n    .lg\\:align-self-start {\n      align-self: flex-start!important\n    }\n\n    .lg\\:align-self-end {\n      align-self: flex-end!important\n    }\n\n    .lg\\:align-self-center {\n      align-self: center!important\n    }\n\n    .lg\\:align-self-stretch {\n      align-self: stretch!important\n    }\n\n    .lg\\:align-self-baseline {\n      align-self: baseline!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:align-self-auto {\n      align-self:auto!important\n    }\n\n    .xl\\:align-self-start {\n      align-self: flex-start!important\n    }\n\n    .xl\\:align-self-end {\n      align-self: flex-end!important\n    }\n\n    .xl\\:align-self-center {\n      align-self: center!important\n    }\n\n    .xl\\:align-self-stretch {\n      align-self: stretch!important\n    }\n\n    .xl\\:align-self-baseline {\n      align-self: baseline!important\n    }\n  }\n\n  .flex-order-0 {\n    order: 0!important\n  }\n\n  .flex-order-1 {\n    order: 1!important\n  }\n\n  .flex-order-2 {\n    order: 2!important\n  }\n\n  .flex-order-3 {\n    order: 3!important\n  }\n\n  .flex-order-4 {\n    order: 4!important\n  }\n\n  .flex-order-5 {\n    order: 5!important\n  }\n\n  .flex-order-6 {\n    order: 6!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:flex-order-0 {\n      order:0!important\n    }\n\n    .sm\\:flex-order-1 {\n      order: 1!important\n    }\n\n    .sm\\:flex-order-2 {\n      order: 2!important\n    }\n\n    .sm\\:flex-order-3 {\n      order: 3!important\n    }\n\n    .sm\\:flex-order-4 {\n      order: 4!important\n    }\n\n    .sm\\:flex-order-5 {\n      order: 5!important\n    }\n\n    .sm\\:flex-order-6 {\n      order: 6!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:flex-order-0 {\n      order:0!important\n    }\n\n    .md\\:flex-order-1 {\n      order: 1!important\n    }\n\n    .md\\:flex-order-2 {\n      order: 2!important\n    }\n\n    .md\\:flex-order-3 {\n      order: 3!important\n    }\n\n    .md\\:flex-order-4 {\n      order: 4!important\n    }\n\n    .md\\:flex-order-5 {\n      order: 5!important\n    }\n\n    .md\\:flex-order-6 {\n      order: 6!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:flex-order-0 {\n      order:0!important\n    }\n\n    .lg\\:flex-order-1 {\n      order: 1!important\n    }\n\n    .lg\\:flex-order-2 {\n      order: 2!important\n    }\n\n    .lg\\:flex-order-3 {\n      order: 3!important\n    }\n\n    .lg\\:flex-order-4 {\n      order: 4!important\n    }\n\n    .lg\\:flex-order-5 {\n      order: 5!important\n    }\n\n    .lg\\:flex-order-6 {\n      order: 6!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:flex-order-0 {\n      order:0!important\n    }\n\n    .xl\\:flex-order-1 {\n      order: 1!important\n    }\n\n    .xl\\:flex-order-2 {\n      order: 2!important\n    }\n\n    .xl\\:flex-order-3 {\n      order: 3!important\n    }\n\n    .xl\\:flex-order-4 {\n      order: 4!important\n    }\n\n    .xl\\:flex-order-5 {\n      order: 5!important\n    }\n\n    .xl\\:flex-order-6 {\n      order: 6!important\n    }\n  }\n\n  .flex-1 {\n    flex: 1 1 0%!important\n  }\n\n  .flex-auto {\n    flex: 1 1 auto!important\n  }\n\n  .flex-initial {\n    flex: 0 1 auto!important\n  }\n\n  .flex-none {\n    flex: none!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:flex-1 {\n      flex:1 1 0%!important\n    }\n\n    .sm\\:flex-auto {\n      flex: 1 1 auto!important\n    }\n\n    .sm\\:flex-initial {\n      flex: 0 1 auto!important\n    }\n\n    .sm\\:flex-none {\n      flex: none!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:flex-1 {\n      flex:1 1 0%!important\n    }\n\n    .md\\:flex-auto {\n      flex: 1 1 auto!important\n    }\n\n    .md\\:flex-initial {\n      flex: 0 1 auto!important\n    }\n\n    .md\\:flex-none {\n      flex: none!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:flex-1 {\n      flex:1 1 0%!important\n    }\n\n    .lg\\:flex-auto {\n      flex: 1 1 auto!important\n    }\n\n    .lg\\:flex-initial {\n      flex: 0 1 auto!important\n    }\n\n    .lg\\:flex-none {\n      flex: none!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:flex-1 {\n      flex:1 1 0%!important\n    }\n\n    .xl\\:flex-auto {\n      flex: 1 1 auto!important\n    }\n\n    .xl\\:flex-initial {\n      flex: 0 1 auto!important\n    }\n\n    .xl\\:flex-none {\n      flex: none!important\n    }\n  }\n\n  .flex-grow-0 {\n    flex-grow: 0!important\n  }\n\n  .flex-grow-1 {\n    flex-grow: 1!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:flex-grow-0 {\n      flex-grow:0!important\n    }\n\n    .sm\\:flex-grow-1 {\n      flex-grow: 1!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:flex-grow-0 {\n      flex-grow:0!important\n    }\n\n    .md\\:flex-grow-1 {\n      flex-grow: 1!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:flex-grow-0 {\n      flex-grow:0!important\n    }\n\n    .lg\\:flex-grow-1 {\n      flex-grow: 1!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:flex-grow-0 {\n      flex-grow:0!important\n    }\n\n    .xl\\:flex-grow-1 {\n      flex-grow: 1!important\n    }\n  }\n\n  .flex-shrink-0 {\n    flex-shrink: 0!important\n  }\n\n  .flex-shrink-1 {\n    flex-shrink: 1!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:flex-shrink-0 {\n      flex-shrink:0!important\n    }\n\n    .sm\\:flex-shrink-1 {\n      flex-shrink: 1!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:flex-shrink-0 {\n      flex-shrink:0!important\n    }\n\n    .md\\:flex-shrink-1 {\n      flex-shrink: 1!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:flex-shrink-0 {\n      flex-shrink:0!important\n    }\n\n    .lg\\:flex-shrink-1 {\n      flex-shrink: 1!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:flex-shrink-0 {\n      flex-shrink:0!important\n    }\n\n    .xl\\:flex-shrink-1 {\n      flex-shrink: 1!important\n    }\n  }\n\n  .gap-0 {\n    gap: 0rem!important\n  }\n\n  .gap-1 {\n    gap: .25rem!important\n  }\n\n  .gap-2 {\n    gap: .5rem!important\n  }\n\n  .gap-3 {\n    gap: 1rem!important\n  }\n\n  .gap-4 {\n    gap: 1.5rem!important\n  }\n\n  .gap-5 {\n    gap: 2rem!important\n  }\n\n  .gap-6 {\n    gap: 3rem!important\n  }\n\n  .gap-7 {\n    gap: 4rem!important\n  }\n\n  .gap-8 {\n    gap: 5rem!important\n  }\n\n  .row-gap-0 {\n    row-gap: 0rem!important\n  }\n\n  .row-gap-1 {\n    row-gap: .25rem!important\n  }\n\n  .row-gap-2 {\n    row-gap: .5rem!important\n  }\n\n  .row-gap-3 {\n    row-gap: 1rem!important\n  }\n\n  .row-gap-4 {\n    row-gap: 1.5rem!important\n  }\n\n  .row-gap-5 {\n    row-gap: 2rem!important\n  }\n\n  .row-gap-6 {\n    row-gap: 3rem!important\n  }\n\n  .row-gap-7 {\n    row-gap: 4rem!important\n  }\n\n  .row-gap-8 {\n    row-gap: 5rem!important\n  }\n\n  .column-gap-0 {\n    column-gap: 0rem!important\n  }\n\n  .column-gap-1 {\n    column-gap: .25rem!important\n  }\n\n  .column-gap-2 {\n    column-gap: .5rem!important\n  }\n\n  .column-gap-3 {\n    column-gap: 1rem!important\n  }\n\n  .column-gap-4 {\n    column-gap: 1.5rem!important\n  }\n\n  .column-gap-5 {\n    column-gap: 2rem!important\n  }\n\n  .column-gap-6 {\n    column-gap: 3rem!important\n  }\n\n  .column-gap-7 {\n    column-gap: 4rem!important\n  }\n\n  .column-gap-8 {\n    column-gap: 5rem!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:gap-0 {\n      gap:0rem!important\n    }\n\n    .sm\\:gap-1 {\n      gap: .25rem!important\n    }\n\n    .sm\\:gap-2 {\n      gap: .5rem!important\n    }\n\n    .sm\\:gap-3 {\n      gap: 1rem!important\n    }\n\n    .sm\\:gap-4 {\n      gap: 1.5rem!important\n    }\n\n    .sm\\:gap-5 {\n      gap: 2rem!important\n    }\n\n    .sm\\:gap-6 {\n      gap: 3rem!important\n    }\n\n    .sm\\:gap-7 {\n      gap: 4rem!important\n    }\n\n    .sm\\:gap-8 {\n      gap: 5rem!important\n    }\n\n    .sm\\:row-gap-0 {\n      row-gap: 0rem!important\n    }\n\n    .sm\\:row-gap-1 {\n      row-gap: .25rem!important\n    }\n\n    .sm\\:row-gap-2 {\n      row-gap: .5rem!important\n    }\n\n    .sm\\:row-gap-3 {\n      row-gap: 1rem!important\n    }\n\n    .sm\\:row-gap-4 {\n      row-gap: 1.5rem!important\n    }\n\n    .sm\\:row-gap-5 {\n      row-gap: 2rem!important\n    }\n\n    .sm\\:row-gap-6 {\n      row-gap: 3rem!important\n    }\n\n    .sm\\:row-gap-7 {\n      row-gap: 4rem!important\n    }\n\n    .sm\\:row-gap-8 {\n      row-gap: 5rem!important\n    }\n\n    .sm\\:column-gap-0 {\n      column-gap: 0rem!important\n    }\n\n    .sm\\:column-gap-1 {\n      column-gap: .25rem!important\n    }\n\n    .sm\\:column-gap-2 {\n      column-gap: .5rem!important\n    }\n\n    .sm\\:column-gap-3 {\n      column-gap: 1rem!important\n    }\n\n    .sm\\:column-gap-4 {\n      column-gap: 1.5rem!important\n    }\n\n    .sm\\:column-gap-5 {\n      column-gap: 2rem!important\n    }\n\n    .sm\\:column-gap-6 {\n      column-gap: 3rem!important\n    }\n\n    .sm\\:column-gap-7 {\n      column-gap: 4rem!important\n    }\n\n    .sm\\:column-gap-8 {\n      column-gap: 5rem!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:gap-0 {\n      gap:0rem!important\n    }\n\n    .md\\:gap-1 {\n      gap: .25rem!important\n    }\n\n    .md\\:gap-2 {\n      gap: .5rem!important\n    }\n\n    .md\\:gap-3 {\n      gap: 1rem!important\n    }\n\n    .md\\:gap-4 {\n      gap: 1.5rem!important\n    }\n\n    .md\\:gap-5 {\n      gap: 2rem!important\n    }\n\n    .md\\:gap-6 {\n      gap: 3rem!important\n    }\n\n    .md\\:gap-7 {\n      gap: 4rem!important\n    }\n\n    .md\\:gap-8 {\n      gap: 5rem!important\n    }\n\n    .md\\:row-gap-0 {\n      row-gap: 0rem!important\n    }\n\n    .md\\:row-gap-1 {\n      row-gap: .25rem!important\n    }\n\n    .md\\:row-gap-2 {\n      row-gap: .5rem!important\n    }\n\n    .md\\:row-gap-3 {\n      row-gap: 1rem!important\n    }\n\n    .md\\:row-gap-4 {\n      row-gap: 1.5rem!important\n    }\n\n    .md\\:row-gap-5 {\n      row-gap: 2rem!important\n    }\n\n    .md\\:row-gap-6 {\n      row-gap: 3rem!important\n    }\n\n    .md\\:row-gap-7 {\n      row-gap: 4rem!important\n    }\n\n    .md\\:row-gap-8 {\n      row-gap: 5rem!important\n    }\n\n    .md\\:column-gap-0 {\n      column-gap: 0rem!important\n    }\n\n    .md\\:column-gap-1 {\n      column-gap: .25rem!important\n    }\n\n    .md\\:column-gap-2 {\n      column-gap: .5rem!important\n    }\n\n    .md\\:column-gap-3 {\n      column-gap: 1rem!important\n    }\n\n    .md\\:column-gap-4 {\n      column-gap: 1.5rem!important\n    }\n\n    .md\\:column-gap-5 {\n      column-gap: 2rem!important\n    }\n\n    .md\\:column-gap-6 {\n      column-gap: 3rem!important\n    }\n\n    .md\\:column-gap-7 {\n      column-gap: 4rem!important\n    }\n\n    .md\\:column-gap-8 {\n      column-gap: 5rem!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:gap-0 {\n      gap:0rem!important\n    }\n\n    .lg\\:gap-1 {\n      gap: .25rem!important\n    }\n\n    .lg\\:gap-2 {\n      gap: .5rem!important\n    }\n\n    .lg\\:gap-3 {\n      gap: 1rem!important\n    }\n\n    .lg\\:gap-4 {\n      gap: 1.5rem!important\n    }\n\n    .lg\\:gap-5 {\n      gap: 2rem!important\n    }\n\n    .lg\\:gap-6 {\n      gap: 3rem!important\n    }\n\n    .lg\\:gap-7 {\n      gap: 4rem!important\n    }\n\n    .lg\\:gap-8 {\n      gap: 5rem!important\n    }\n\n    .lg\\:row-gap-0 {\n      row-gap: 0rem!important\n    }\n\n    .lg\\:row-gap-1 {\n      row-gap: .25rem!important\n    }\n\n    .lg\\:row-gap-2 {\n      row-gap: .5rem!important\n    }\n\n    .lg\\:row-gap-3 {\n      row-gap: 1rem!important\n    }\n\n    .lg\\:row-gap-4 {\n      row-gap: 1.5rem!important\n    }\n\n    .lg\\:row-gap-5 {\n      row-gap: 2rem!important\n    }\n\n    .lg\\:row-gap-6 {\n      row-gap: 3rem!important\n    }\n\n    .lg\\:row-gap-7 {\n      row-gap: 4rem!important\n    }\n\n    .lg\\:row-gap-8 {\n      row-gap: 5rem!important\n    }\n\n    .lg\\:column-gap-0 {\n      column-gap: 0rem!important\n    }\n\n    .lg\\:column-gap-1 {\n      column-gap: .25rem!important\n    }\n\n    .lg\\:column-gap-2 {\n      column-gap: .5rem!important\n    }\n\n    .lg\\:column-gap-3 {\n      column-gap: 1rem!important\n    }\n\n    .lg\\:column-gap-4 {\n      column-gap: 1.5rem!important\n    }\n\n    .lg\\:column-gap-5 {\n      column-gap: 2rem!important\n    }\n\n    .lg\\:column-gap-6 {\n      column-gap: 3rem!important\n    }\n\n    .lg\\:column-gap-7 {\n      column-gap: 4rem!important\n    }\n\n    .lg\\:column-gap-8 {\n      column-gap: 5rem!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:gap-0 {\n      gap:0rem!important\n    }\n\n    .xl\\:gap-1 {\n      gap: .25rem!important\n    }\n\n    .xl\\:gap-2 {\n      gap: .5rem!important\n    }\n\n    .xl\\:gap-3 {\n      gap: 1rem!important\n    }\n\n    .xl\\:gap-4 {\n      gap: 1.5rem!important\n    }\n\n    .xl\\:gap-5 {\n      gap: 2rem!important\n    }\n\n    .xl\\:gap-6 {\n      gap: 3rem!important\n    }\n\n    .xl\\:gap-7 {\n      gap: 4rem!important\n    }\n\n    .xl\\:gap-8 {\n      gap: 5rem!important\n    }\n\n    .xl\\:row-gap-0 {\n      row-gap: 0rem!important\n    }\n\n    .xl\\:row-gap-1 {\n      row-gap: .25rem!important\n    }\n\n    .xl\\:row-gap-2 {\n      row-gap: .5rem!important\n    }\n\n    .xl\\:row-gap-3 {\n      row-gap: 1rem!important\n    }\n\n    .xl\\:row-gap-4 {\n      row-gap: 1.5rem!important\n    }\n\n    .xl\\:row-gap-5 {\n      row-gap: 2rem!important\n    }\n\n    .xl\\:row-gap-6 {\n      row-gap: 3rem!important\n    }\n\n    .xl\\:row-gap-7 {\n      row-gap: 4rem!important\n    }\n\n    .xl\\:row-gap-8 {\n      row-gap: 5rem!important\n    }\n\n    .xl\\:column-gap-0 {\n      column-gap: 0rem!important\n    }\n\n    .xl\\:column-gap-1 {\n      column-gap: .25rem!important\n    }\n\n    .xl\\:column-gap-2 {\n      column-gap: .5rem!important\n    }\n\n    .xl\\:column-gap-3 {\n      column-gap: 1rem!important\n    }\n\n    .xl\\:column-gap-4 {\n      column-gap: 1.5rem!important\n    }\n\n    .xl\\:column-gap-5 {\n      column-gap: 2rem!important\n    }\n\n    .xl\\:column-gap-6 {\n      column-gap: 3rem!important\n    }\n\n    .xl\\:column-gap-7 {\n      column-gap: 4rem!important\n    }\n\n    .xl\\:column-gap-8 {\n      column-gap: 5rem!important\n    }\n  }\n\n  .p-0 {\n    padding: 0rem!important\n  }\n\n  .p-1 {\n    padding: .25rem!important\n  }\n\n  .p-2 {\n    padding: .5rem!important\n  }\n\n  .p-3 {\n    padding: 1rem!important\n  }\n\n  .p-4 {\n    padding: 1.5rem!important\n  }\n\n  .p-5 {\n    padding: 2rem!important\n  }\n\n  .p-6 {\n    padding: 3rem!important\n  }\n\n  .p-7 {\n    padding: 4rem!important\n  }\n\n  .p-8 {\n    padding: 5rem!important\n  }\n\n  .pt-0 {\n    padding-top: 0rem!important\n  }\n\n  .pt-1 {\n    padding-top: .25rem!important\n  }\n\n  .pt-2 {\n    padding-top: .5rem!important\n  }\n\n  .pt-3 {\n    padding-top: 1rem!important\n  }\n\n  .pt-4 {\n    padding-top: 1.5rem!important\n  }\n\n  .pt-5 {\n    padding-top: 2rem!important\n  }\n\n  .pt-6 {\n    padding-top: 3rem!important\n  }\n\n  .pt-7 {\n    padding-top: 4rem!important\n  }\n\n  .pt-8 {\n    padding-top: 5rem!important\n  }\n\n  .pr-0 {\n    padding-right: 0rem!important\n  }\n\n  .pr-1 {\n    padding-right: .25rem!important\n  }\n\n  .pr-2 {\n    padding-right: .5rem!important\n  }\n\n  .pr-3 {\n    padding-right: 1rem!important\n  }\n\n  .pr-4 {\n    padding-right: 1.5rem!important\n  }\n\n  .pr-5 {\n    padding-right: 2rem!important\n  }\n\n  .pr-6 {\n    padding-right: 3rem!important\n  }\n\n  .pr-7 {\n    padding-right: 4rem!important\n  }\n\n  .pr-8 {\n    padding-right: 5rem!important\n  }\n\n  .pl-0 {\n    padding-left: 0rem!important\n  }\n\n  .pl-1 {\n    padding-left: .25rem!important\n  }\n\n  .pl-2 {\n    padding-left: .5rem!important\n  }\n\n  .pl-3 {\n    padding-left: 1rem!important\n  }\n\n  .pl-4 {\n    padding-left: 1.5rem!important\n  }\n\n  .pl-5 {\n    padding-left: 2rem!important\n  }\n\n  .pl-6 {\n    padding-left: 3rem!important\n  }\n\n  .pl-7 {\n    padding-left: 4rem!important\n  }\n\n  .pl-8 {\n    padding-left: 5rem!important\n  }\n\n  .pb-0 {\n    padding-bottom: 0rem!important\n  }\n\n  .pb-1 {\n    padding-bottom: .25rem!important\n  }\n\n  .pb-2 {\n    padding-bottom: .5rem!important\n  }\n\n  .pb-3 {\n    padding-bottom: 1rem!important\n  }\n\n  .pb-4 {\n    padding-bottom: 1.5rem!important\n  }\n\n  .pb-5 {\n    padding-bottom: 2rem!important\n  }\n\n  .pb-6 {\n    padding-bottom: 3rem!important\n  }\n\n  .pb-7 {\n    padding-bottom: 4rem!important\n  }\n\n  .pb-8 {\n    padding-bottom: 5rem!important\n  }\n\n  .px-0 {\n    padding-left: 0rem!important;\n    padding-right: 0rem!important\n  }\n\n  .px-1 {\n    padding-left: .25rem!important;\n    padding-right: .25rem!important\n  }\n\n  .px-2 {\n    padding-left: .5rem!important;\n    padding-right: .5rem!important\n  }\n\n  .px-3 {\n    padding-left: 1rem!important;\n    padding-right: 1rem!important\n  }\n\n  .px-4 {\n    padding-left: 1.5rem!important;\n    padding-right: 1.5rem!important\n  }\n\n  .px-5 {\n    padding-left: 2rem!important;\n    padding-right: 2rem!important\n  }\n\n  .px-6 {\n    padding-left: 3rem!important;\n    padding-right: 3rem!important\n  }\n\n  .px-7 {\n    padding-left: 4rem!important;\n    padding-right: 4rem!important\n  }\n\n  .px-8 {\n    padding-left: 5rem!important;\n    padding-right: 5rem!important\n  }\n\n  .py-0 {\n    padding-top: 0rem!important;\n    padding-bottom: 0rem!important\n  }\n\n  .py-1 {\n    padding-top: .25rem!important;\n    padding-bottom: .25rem!important\n  }\n\n  .py-2 {\n    padding-top: .5rem!important;\n    padding-bottom: .5rem!important\n  }\n\n  .py-3 {\n    padding-top: 1rem!important;\n    padding-bottom: 1rem!important\n  }\n\n  .py-4 {\n    padding-top: 1.5rem!important;\n    padding-bottom: 1.5rem!important\n  }\n\n  .py-5 {\n    padding-top: 2rem!important;\n    padding-bottom: 2rem!important\n  }\n\n  .py-6 {\n    padding-top: 3rem!important;\n    padding-bottom: 3rem!important\n  }\n\n  .py-7 {\n    padding-top: 4rem!important;\n    padding-bottom: 4rem!important\n  }\n\n  .py-8 {\n    padding-top: 5rem!important;\n    padding-bottom: 5rem!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:p-0 {\n      padding:unset!important\n    }\n\n    .sm\\:p-1 {\n      padding: .25rem!important\n    }\n\n    .sm\\:p-2 {\n      padding: .5rem!important\n    }\n\n    .sm\\:p-3 {\n      padding: 1rem!important\n    }\n\n    .sm\\:p-4 {\n      padding: 1.5rem!important\n    }\n\n    .sm\\:p-5 {\n      padding: 2rem!important\n    }\n\n    .sm\\:p-6 {\n      padding: 3rem!important\n    }\n\n    .sm\\:p-7 {\n      padding: 4rem!important\n    }\n\n    .sm\\:p-8 {\n      padding: 5rem!important\n    }\n\n    .sm\\:pt-0 {\n      padding-top: 0rem!important\n    }\n\n    .sm\\:pt-1 {\n      padding-top: .25rem!important\n    }\n\n    .sm\\:pt-2 {\n      padding-top: .5rem!important\n    }\n\n    .sm\\:pt-3 {\n      padding-top: 1rem!important\n    }\n\n    .sm\\:pt-4 {\n      padding-top: 1.5rem!important\n    }\n\n    .sm\\:pt-5 {\n      padding-top: 2rem!important\n    }\n\n    .sm\\:pt-6 {\n      padding-top: 3rem!important\n    }\n\n    .sm\\:pt-7 {\n      padding-top: 4rem!important\n    }\n\n    .sm\\:pt-8 {\n      padding-top: 5rem!important\n    }\n\n    .sm\\:pr-0 {\n      padding-right: 0rem!important\n    }\n\n    .sm\\:pr-1 {\n      padding-right: .25rem!important\n    }\n\n    .sm\\:pr-2 {\n      padding-right: .5rem!important\n    }\n\n    .sm\\:pr-3 {\n      padding-right: 1rem!important\n    }\n\n    .sm\\:pr-4 {\n      padding-right: 1.5rem!important\n    }\n\n    .sm\\:pr-5 {\n      padding-right: 2rem!important\n    }\n\n    .sm\\:pr-6 {\n      padding-right: 3rem!important\n    }\n\n    .sm\\:pr-7 {\n      padding-right: 4rem!important\n    }\n\n    .sm\\:pr-8 {\n      padding-right: 5rem!important\n    }\n\n    .sm\\:pl-0 {\n      padding-left: 0rem!important\n    }\n\n    .sm\\:pl-1 {\n      padding-left: .25rem!important\n    }\n\n    .sm\\:pl-2 {\n      padding-left: .5rem!important\n    }\n\n    .sm\\:pl-3 {\n      padding-left: 1rem!important\n    }\n\n    .sm\\:pl-4 {\n      padding-left: 1.5rem!important\n    }\n\n    .sm\\:pl-5 {\n      padding-left: 2rem!important\n    }\n\n    .sm\\:pl-6 {\n      padding-left: 3rem!important\n    }\n\n    .sm\\:pl-7 {\n      padding-left: 4rem!important\n    }\n\n    .sm\\:pl-8 {\n      padding-left: 5rem!important\n    }\n\n    .sm\\:pb-0 {\n      padding-bottom: 0rem!important\n    }\n\n    .sm\\:pb-1 {\n      padding-bottom: .25rem!important\n    }\n\n    .sm\\:pb-2 {\n      padding-bottom: .5rem!important\n    }\n\n    .sm\\:pb-3 {\n      padding-bottom: 1rem!important\n    }\n\n    .sm\\:pb-4 {\n      padding-bottom: 1.5rem!important\n    }\n\n    .sm\\:pb-5 {\n      padding-bottom: 2rem!important\n    }\n\n    .sm\\:pb-6 {\n      padding-bottom: 3rem!important\n    }\n\n    .sm\\:pb-7 {\n      padding-bottom: 4rem!important\n    }\n\n    .sm\\:pb-8 {\n      padding-bottom: 5rem!important\n    }\n\n    .sm\\:px-0 {\n      padding-left: 0rem!important;\n      padding-right: 0rem!important\n    }\n\n    .sm\\:px-1 {\n      padding-left: .25rem!important;\n      padding-right: .25rem!important\n    }\n\n    .sm\\:px-2 {\n      padding-left: .5rem!important;\n      padding-right: .5rem!important\n    }\n\n    .sm\\:px-3 {\n      padding-left: 1rem!important;\n      padding-right: 1rem!important\n    }\n\n    .sm\\:px-4 {\n      padding-left: 1.5rem!important;\n      padding-right: 1.5rem!important\n    }\n\n    .sm\\:px-5 {\n      padding-left: 2rem!important;\n      padding-right: 2rem!important\n    }\n\n    .sm\\:px-6 {\n      padding-left: 3rem!important;\n      padding-right: 3rem!important\n    }\n\n    .sm\\:px-7 {\n      padding-left: 4rem!important;\n      padding-right: 4rem!important\n    }\n\n    .sm\\:px-8 {\n      padding-left: 5rem!important;\n      padding-right: 5rem!important\n    }\n\n    .sm\\:py-0 {\n      padding-top: 0rem!important;\n      padding-bottom: 0rem!important\n    }\n\n    .sm\\:py-1 {\n      padding-top: .25rem!important;\n      padding-bottom: .25rem!important\n    }\n\n    .sm\\:py-2 {\n      padding-top: .5rem!important;\n      padding-bottom: .5rem!important\n    }\n\n    .sm\\:py-3 {\n      padding-top: 1rem!important;\n      padding-bottom: 1rem!important\n    }\n\n    .sm\\:py-4 {\n      padding-top: 1.5rem!important;\n      padding-bottom: 1.5rem!important\n    }\n\n    .sm\\:py-5 {\n      padding-top: 2rem!important;\n      padding-bottom: 2rem!important\n    }\n\n    .sm\\:py-6 {\n      padding-top: 3rem!important;\n      padding-bottom: 3rem!important\n    }\n\n    .sm\\:py-7 {\n      padding-top: 4rem!important;\n      padding-bottom: 4rem!important\n    }\n\n    .sm\\:py-8 {\n      padding-top: 5rem!important;\n      padding-bottom: 5rem!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:p-0 {\n      padding:0!important\n    }\n\n    .md\\:p-1 {\n      padding: .25rem!important\n    }\n\n    .md\\:p-2 {\n      padding: .5rem!important\n    }\n\n    .md\\:p-3 {\n      padding: 1rem!important\n    }\n\n    .md\\:p-4 {\n      padding: 1.5rem!important\n    }\n\n    .md\\:p-5 {\n      padding: 2rem!important\n    }\n\n    .md\\:p-6 {\n      padding: 3rem!important\n    }\n\n    .md\\:p-7 {\n      padding: 4rem!important\n    }\n\n    .md\\:p-8 {\n      padding: 5rem!important\n    }\n\n    .md\\:pt-0 {\n      padding-top: 0rem!important\n    }\n\n    .md\\:pt-1 {\n      padding-top: .25rem!important\n    }\n\n    .md\\:pt-2 {\n      padding-top: .5rem!important\n    }\n\n    .md\\:pt-3 {\n      padding-top: 1rem!important\n    }\n\n    .md\\:pt-4 {\n      padding-top: 1.5rem!important\n    }\n\n    .md\\:pt-5 {\n      padding-top: 2rem!important\n    }\n\n    .md\\:pt-6 {\n      padding-top: 3rem!important\n    }\n\n    .md\\:pt-7 {\n      padding-top: 4rem!important\n    }\n\n    .md\\:pt-8 {\n      padding-top: 5rem!important\n    }\n\n    .md\\:pr-0 {\n      padding-right: 0rem!important\n    }\n\n    .md\\:pr-1 {\n      padding-right: .25rem!important\n    }\n\n    .md\\:pr-2 {\n      padding-right: .5rem!important\n    }\n\n    .md\\:pr-3 {\n      padding-right: 1rem!important\n    }\n\n    .md\\:pr-4 {\n      padding-right: 1.5rem!important\n    }\n\n    .md\\:pr-5 {\n      padding-right: 2rem!important\n    }\n\n    .md\\:pr-6 {\n      padding-right: 3rem!important\n    }\n\n    .md\\:pr-7 {\n      padding-right: 4rem!important\n    }\n\n    .md\\:pr-8 {\n      padding-right: 5rem!important\n    }\n\n    .md\\:pl-0 {\n      padding-left: 0rem!important\n    }\n\n    .md\\:pl-1 {\n      padding-left: .25rem!important\n    }\n\n    .md\\:pl-2 {\n      padding-left: .5rem!important\n    }\n\n    .md\\:pl-3 {\n      padding-left: 1rem!important\n    }\n\n    .md\\:pl-4 {\n      padding-left: 1.5rem!important\n    }\n\n    .md\\:pl-5 {\n      padding-left: 2rem!important\n    }\n\n    .md\\:pl-6 {\n      padding-left: 3rem!important\n    }\n\n    .md\\:pl-7 {\n      padding-left: 4rem!important\n    }\n\n    .md\\:pl-8 {\n      padding-left: 5rem!important\n    }\n\n    .md\\:pb-0 {\n      padding-bottom: 0rem!important\n    }\n\n    .md\\:pb-1 {\n      padding-bottom: .25rem!important\n    }\n\n    .md\\:pb-2 {\n      padding-bottom: .5rem!important\n    }\n\n    .md\\:pb-3 {\n      padding-bottom: 1rem!important\n    }\n\n    .md\\:pb-4 {\n      padding-bottom: 1.5rem!important\n    }\n\n    .md\\:pb-5 {\n      padding-bottom: 2rem!important\n    }\n\n    .md\\:pb-6 {\n      padding-bottom: 3rem!important\n    }\n\n    .md\\:pb-7 {\n      padding-bottom: 4rem!important\n    }\n\n    .md\\:pb-8 {\n      padding-bottom: 5rem!important\n    }\n\n    .md\\:px-0 {\n      padding-left: 0rem!important;\n      padding-right: 0rem!important\n    }\n\n    .md\\:px-1 {\n      padding-left: .25rem!important;\n      padding-right: .25rem!important\n    }\n\n    .md\\:px-2 {\n      padding-left: .5rem!important;\n      padding-right: .5rem!important\n    }\n\n    .md\\:px-3 {\n      padding-left: 1rem!important;\n      padding-right: 1rem!important\n    }\n\n    .md\\:px-4 {\n      padding-left: 1.5rem!important;\n      padding-right: 1.5rem!important\n    }\n\n    .md\\:px-5 {\n      padding-left: 2rem!important;\n      padding-right: 2rem!important\n    }\n\n    .md\\:px-6 {\n      padding-left: 3rem!important;\n      padding-right: 3rem!important\n    }\n\n    .md\\:px-7 {\n      padding-left: 4rem!important;\n      padding-right: 4rem!important\n    }\n\n    .md\\:px-8 {\n      padding-left: 5rem!important;\n      padding-right: 5rem!important\n    }\n\n    .md\\:py-0 {\n      padding-top: 0rem!important;\n      padding-bottom: 0rem!important\n    }\n\n    .md\\:py-1 {\n      padding-top: .25rem!important;\n      padding-bottom: .25rem!important\n    }\n\n    .md\\:py-2 {\n      padding-top: .5rem!important;\n      padding-bottom: .5rem!important\n    }\n\n    .md\\:py-3 {\n      padding-top: 1rem!important;\n      padding-bottom: 1rem!important\n    }\n\n    .md\\:py-4 {\n      padding-top: 1.5rem!important;\n      padding-bottom: 1.5rem!important\n    }\n\n    .md\\:py-5 {\n      padding-top: 2rem!important;\n      padding-bottom: 2rem!important\n    }\n\n    .md\\:py-6 {\n      padding-top: 3rem!important;\n      padding-bottom: 3rem!important\n    }\n\n    .md\\:py-7 {\n      padding-top: 4rem!important;\n      padding-bottom: 4rem!important\n    }\n\n    .md\\:py-8 {\n      padding-top: 5rem!important;\n      padding-bottom: 5rem!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:p-0 {\n      padding:0!important\n    }\n\n    .lg\\:p-1 {\n      padding: .25rem!important\n    }\n\n    .lg\\:p-2 {\n      padding: .5rem!important\n    }\n\n    .lg\\:p-3 {\n      padding: 1rem!important\n    }\n\n    .lg\\:p-4 {\n      padding: 1.5rem!important\n    }\n\n    .lg\\:p-5 {\n      padding: 2rem!important\n    }\n\n    .lg\\:p-6 {\n      padding: 3rem!important\n    }\n\n    .lg\\:p-7 {\n      padding: 4rem!important\n    }\n\n    .lg\\:p-8 {\n      padding: 5rem!important\n    }\n\n    .lg\\:pt-0 {\n      padding-top: 0rem!important\n    }\n\n    .lg\\:pt-1 {\n      padding-top: .25rem!important\n    }\n\n    .lg\\:pt-2 {\n      padding-top: .5rem!important\n    }\n\n    .lg\\:pt-3 {\n      padding-top: 1rem!important\n    }\n\n    .lg\\:pt-4 {\n      padding-top: 1.5rem!important\n    }\n\n    .lg\\:pt-5 {\n      padding-top: 2rem!important\n    }\n\n    .lg\\:pt-6 {\n      padding-top: 3rem!important\n    }\n\n    .lg\\:pt-7 {\n      padding-top: 4rem!important\n    }\n\n    .lg\\:pt-8 {\n      padding-top: 5rem!important\n    }\n\n    .lg\\:pr-0 {\n      padding-right: 0rem!important\n    }\n\n    .lg\\:pr-1 {\n      padding-right: .25rem!important\n    }\n\n    .lg\\:pr-2 {\n      padding-right: .5rem!important\n    }\n\n    .lg\\:pr-3 {\n      padding-right: 1rem!important\n    }\n\n    .lg\\:pr-4 {\n      padding-right: 1.5rem!important\n    }\n\n    .lg\\:pr-5 {\n      padding-right: 2rem!important\n    }\n\n    .lg\\:pr-6 {\n      padding-right: 3rem!important\n    }\n\n    .lg\\:pr-7 {\n      padding-right: 4rem!important\n    }\n\n    .lg\\:pr-8 {\n      padding-right: 5rem!important\n    }\n\n    .lg\\:pl-0 {\n      padding-left: 0rem!important\n    }\n\n    .lg\\:pl-1 {\n      padding-left: .25rem!important\n    }\n\n    .lg\\:pl-2 {\n      padding-left: .5rem!important\n    }\n\n    .lg\\:pl-3 {\n      padding-left: 1rem!important\n    }\n\n    .lg\\:pl-4 {\n      padding-left: 1.5rem!important\n    }\n\n    .lg\\:pl-5 {\n      padding-left: 2rem!important\n    }\n\n    .lg\\:pl-6 {\n      padding-left: 3rem!important\n    }\n\n    .lg\\:pl-7 {\n      padding-left: 4rem!important\n    }\n\n    .lg\\:pl-8 {\n      padding-left: 5rem!important\n    }\n\n    .lg\\:pb-0 {\n      padding-bottom: 0rem!important\n    }\n\n    .lg\\:pb-1 {\n      padding-bottom: .25rem!important\n    }\n\n    .lg\\:pb-2 {\n      padding-bottom: .5rem!important\n    }\n\n    .lg\\:pb-3 {\n      padding-bottom: 1rem!important\n    }\n\n    .lg\\:pb-4 {\n      padding-bottom: 1.5rem!important\n    }\n\n    .lg\\:pb-5 {\n      padding-bottom: 2rem!important\n    }\n\n    .lg\\:pb-6 {\n      padding-bottom: 3rem!important\n    }\n\n    .lg\\:pb-7 {\n      padding-bottom: 4rem!important\n    }\n\n    .lg\\:pb-8 {\n      padding-bottom: 5rem!important\n    }\n\n    .lg\\:px-0 {\n      padding-left: 0rem!important;\n      padding-right: 0rem!important\n    }\n\n    .lg\\:px-1 {\n      padding-left: .25rem!important;\n      padding-right: .25rem!important\n    }\n\n    .lg\\:px-2 {\n      padding-left: .5rem!important;\n      padding-right: .5rem!important\n    }\n\n    .lg\\:px-3 {\n      padding-left: 1rem!important;\n      padding-right: 1rem!important\n    }\n\n    .lg\\:px-4 {\n      padding-left: 1.5rem!important;\n      padding-right: 1.5rem!important\n    }\n\n    .lg\\:px-5 {\n      padding-left: 2rem!important;\n      padding-right: 2rem!important\n    }\n\n    .lg\\:px-6 {\n      padding-left: 3rem!important;\n      padding-right: 3rem!important\n    }\n\n    .lg\\:px-7 {\n      padding-left: 4rem!important;\n      padding-right: 4rem!important\n    }\n\n    .lg\\:px-8 {\n      padding-left: 5rem!important;\n      padding-right: 5rem!important\n    }\n\n    .lg\\:py-0 {\n      padding-top: 0rem!important;\n      padding-bottom: 0rem!important\n    }\n\n    .lg\\:py-1 {\n      padding-top: .25rem!important;\n      padding-bottom: .25rem!important\n    }\n\n    .lg\\:py-2 {\n      padding-top: .5rem!important;\n      padding-bottom: .5rem!important\n    }\n\n    .lg\\:py-3 {\n      padding-top: 1rem!important;\n      padding-bottom: 1rem!important\n    }\n\n    .lg\\:py-4 {\n      padding-top: 1.5rem!important;\n      padding-bottom: 1.5rem!important\n    }\n\n    .lg\\:py-5 {\n      padding-top: 2rem!important;\n      padding-bottom: 2rem!important\n    }\n\n    .lg\\:py-6 {\n      padding-top: 3rem!important;\n      padding-bottom: 3rem!important\n    }\n\n    .lg\\:py-7 {\n      padding-top: 4rem!important;\n      padding-bottom: 4rem!important\n    }\n\n    .lg\\:py-8 {\n      padding-top: 5rem!important;\n      padding-bottom: 5rem!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:p-0 {\n      padding:0!important\n    }\n\n    .xl\\:p-1 {\n      padding: .25rem!important\n    }\n\n    .xl\\:p-2 {\n      padding: .5rem!important\n    }\n\n    .xl\\:p-3 {\n      padding: 1rem!important\n    }\n\n    .xl\\:p-4 {\n      padding: 1.5rem!important\n    }\n\n    .xl\\:p-5 {\n      padding: 2rem!important\n    }\n\n    .xl\\:p-6 {\n      padding: 3rem!important\n    }\n\n    .xl\\:p-7 {\n      padding: 4rem!important\n    }\n\n    .xl\\:p-8 {\n      padding: 5rem!important\n    }\n\n    .xl\\:pt-0 {\n      padding-top: 0rem!important\n    }\n\n    .xl\\:pt-1 {\n      padding-top: .25rem!important\n    }\n\n    .xl\\:pt-2 {\n      padding-top: .5rem!important\n    }\n\n    .xl\\:pt-3 {\n      padding-top: 1rem!important\n    }\n\n    .xl\\:pt-4 {\n      padding-top: 1.5rem!important\n    }\n\n    .xl\\:pt-5 {\n      padding-top: 2rem!important\n    }\n\n    .xl\\:pt-6 {\n      padding-top: 3rem!important\n    }\n\n    .xl\\:pt-7 {\n      padding-top: 4rem!important\n    }\n\n    .xl\\:pt-8 {\n      padding-top: 5rem!important\n    }\n\n    .xl\\:pr-0 {\n      padding-right: 0rem!important\n    }\n\n    .xl\\:pr-1 {\n      padding-right: .25rem!important\n    }\n\n    .xl\\:pr-2 {\n      padding-right: .5rem!important\n    }\n\n    .xl\\:pr-3 {\n      padding-right: 1rem!important\n    }\n\n    .xl\\:pr-4 {\n      padding-right: 1.5rem!important\n    }\n\n    .xl\\:pr-5 {\n      padding-right: 2rem!important\n    }\n\n    .xl\\:pr-6 {\n      padding-right: 3rem!important\n    }\n\n    .xl\\:pr-7 {\n      padding-right: 4rem!important\n    }\n\n    .xl\\:pr-8 {\n      padding-right: 5rem!important\n    }\n\n    .xl\\:pl-0 {\n      padding-left: 0rem!important\n    }\n\n    .xl\\:pl-1 {\n      padding-left: .25rem!important\n    }\n\n    .xl\\:pl-2 {\n      padding-left: .5rem!important\n    }\n\n    .xl\\:pl-3 {\n      padding-left: 1rem!important\n    }\n\n    .xl\\:pl-4 {\n      padding-left: 1.5rem!important\n    }\n\n    .xl\\:pl-5 {\n      padding-left: 2rem!important\n    }\n\n    .xl\\:pl-6 {\n      padding-left: 3rem!important\n    }\n\n    .xl\\:pl-7 {\n      padding-left: 4rem!important\n    }\n\n    .xl\\:pl-8 {\n      padding-left: 5rem!important\n    }\n\n    .xl\\:pb-0 {\n      padding-bottom: 0rem!important\n    }\n\n    .xl\\:pb-1 {\n      padding-bottom: .25rem!important\n    }\n\n    .xl\\:pb-2 {\n      padding-bottom: .5rem!important\n    }\n\n    .xl\\:pb-3 {\n      padding-bottom: 1rem!important\n    }\n\n    .xl\\:pb-4 {\n      padding-bottom: 1.5rem!important\n    }\n\n    .xl\\:pb-5 {\n      padding-bottom: 2rem!important\n    }\n\n    .xl\\:pb-6 {\n      padding-bottom: 3rem!important\n    }\n\n    .xl\\:pb-7 {\n      padding-bottom: 4rem!important\n    }\n\n    .xl\\:pb-8 {\n      padding-bottom: 5rem!important\n    }\n\n    .xl\\:px-0 {\n      padding-left: 0rem!important;\n      padding-right: 0rem!important\n    }\n\n    .xl\\:px-1 {\n      padding-left: .25rem!important;\n      padding-right: .25rem!important\n    }\n\n    .xl\\:px-2 {\n      padding-left: .5rem!important;\n      padding-right: .5rem!important\n    }\n\n    .xl\\:px-3 {\n      padding-left: 1rem!important;\n      padding-right: 1rem!important\n    }\n\n    .xl\\:px-4 {\n      padding-left: 1.5rem!important;\n      padding-right: 1.5rem!important\n    }\n\n    .xl\\:px-5 {\n      padding-left: 2rem!important;\n      padding-right: 2rem!important\n    }\n\n    .xl\\:px-6 {\n      padding-left: 3rem!important;\n      padding-right: 3rem!important\n    }\n\n    .xl\\:px-7 {\n      padding-left: 4rem!important;\n      padding-right: 4rem!important\n    }\n\n    .xl\\:px-8 {\n      padding-left: 5rem!important;\n      padding-right: 5rem!important\n    }\n\n    .xl\\:py-0 {\n      padding-top: 0rem!important;\n      padding-bottom: 0rem!important\n    }\n\n    .xl\\:py-1 {\n      padding-top: .25rem!important;\n      padding-bottom: .25rem!important\n    }\n\n    .xl\\:py-2 {\n      padding-top: .5rem!important;\n      padding-bottom: .5rem!important\n    }\n\n    .xl\\:py-3 {\n      padding-top: 1rem!important;\n      padding-bottom: 1rem!important\n    }\n\n    .xl\\:py-4 {\n      padding-top: 1.5rem!important;\n      padding-bottom: 1.5rem!important\n    }\n\n    .xl\\:py-5 {\n      padding-top: 2rem!important;\n      padding-bottom: 2rem!important\n    }\n\n    .xl\\:py-6 {\n      padding-top: 3rem!important;\n      padding-bottom: 3rem!important\n    }\n\n    .xl\\:py-7 {\n      padding-top: 4rem!important;\n      padding-bottom: 4rem!important\n    }\n\n    .xl\\:py-8 {\n      padding-top: 5rem!important;\n      padding-bottom: 5rem!important\n    }\n  }\n\n  .m-0 {\n    margin: 0rem!important\n  }\n\n  .m-1 {\n    margin: .25rem!important\n  }\n\n  .m-2 {\n    margin: .5rem!important\n  }\n\n  .m-3 {\n    margin: 1rem!important\n  }\n\n  .m-4 {\n    margin: 1.5rem!important\n  }\n\n  .m-5 {\n    margin: 2rem!important\n  }\n\n  .m-6 {\n    margin: 3rem!important\n  }\n\n  .m-7 {\n    margin: 4rem!important\n  }\n\n  .m-8 {\n    margin: 5rem!important\n  }\n\n  .-m-1 {\n    margin: -.25rem!important\n  }\n\n  .-m-2 {\n    margin: -.5rem!important\n  }\n\n  .-m-3 {\n    margin: -1rem!important\n  }\n\n  .-m-4 {\n    margin: -1.5rem!important\n  }\n\n  .-m-5 {\n    margin: -2rem!important\n  }\n\n  .-m-6 {\n    margin: -3rem!important\n  }\n\n  .-m-7 {\n    margin: -4rem!important\n  }\n\n  .-m-8 {\n    margin: -5rem!important\n  }\n\n  .m-auto {\n    margin: auto!important\n  }\n\n  .mt-0 {\n    margin-top: 0rem!important\n  }\n\n  .mt-1 {\n    margin-top: .25rem!important\n  }\n\n  .mt-2 {\n    margin-top: .5rem!important\n  }\n\n  .mt-3 {\n    margin-top: 1rem!important\n  }\n\n  .mt-4 {\n    margin-top: 1.5rem!important\n  }\n\n  .mt-5 {\n    margin-top: 2rem!important\n  }\n\n  .mt-6 {\n    margin-top: 3rem!important\n  }\n\n  .mt-7 {\n    margin-top: 4rem!important\n  }\n\n  .mt-8 {\n    margin-top: 5rem!important\n  }\n\n  .-mt-1 {\n    margin-top: -.25rem!important\n  }\n\n  .-mt-2 {\n    margin-top: -.5rem!important\n  }\n\n  .-mt-3 {\n    margin-top: -1rem!important\n  }\n\n  .-mt-4 {\n    margin-top: -1.5rem!important\n  }\n\n  .-mt-5 {\n    margin-top: -2rem!important\n  }\n\n  .-mt-6 {\n    margin-top: -3rem!important\n  }\n\n  .-mt-7 {\n    margin-top: -4rem!important\n  }\n\n  .-mt-8 {\n    margin-top: -5rem!important\n  }\n\n  .mt-auto {\n    margin-top: auto!important\n  }\n\n  .mr-0 {\n    margin-right: 0rem!important\n  }\n\n  .mr-1 {\n    margin-right: .25rem!important\n  }\n\n  .mr-2 {\n    margin-right: .5rem!important\n  }\n\n  .mr-3 {\n    margin-right: 1rem!important\n  }\n\n  .mr-4 {\n    margin-right: 1.5rem!important\n  }\n\n  .mr-5 {\n    margin-right: 2rem!important\n  }\n\n  .mr-6 {\n    margin-right: 3rem!important\n  }\n\n  .mr-7 {\n    margin-right: 4rem!important\n  }\n\n  .mr-8 {\n    margin-right: 5rem!important\n  }\n\n  .-mr-1 {\n    margin-right: -.25rem!important\n  }\n\n  .-mr-2 {\n    margin-right: -.5rem!important\n  }\n\n  .-mr-3 {\n    margin-right: -1rem!important\n  }\n\n  .-mr-4 {\n    margin-right: -1.5rem!important\n  }\n\n  .-mr-5 {\n    margin-right: -2rem!important\n  }\n\n  .-mr-6 {\n    margin-right: -3rem!important\n  }\n\n  .-mr-7 {\n    margin-right: -4rem!important\n  }\n\n  .-mr-8 {\n    margin-right: -5rem!important\n  }\n\n  .mr-auto {\n    margin-right: auto!important\n  }\n\n  .ml-0 {\n    margin-left: 0rem!important\n  }\n\n  .ml-1 {\n    margin-left: .25rem!important\n  }\n\n  .ml-2 {\n    margin-left: .5rem!important\n  }\n\n  .ml-3 {\n    margin-left: 1rem!important\n  }\n\n  .ml-4 {\n    margin-left: 1.5rem!important\n  }\n\n  .ml-5 {\n    margin-left: 2rem!important\n  }\n\n  .ml-6 {\n    margin-left: 3rem!important\n  }\n\n  .ml-7 {\n    margin-left: 4rem!important\n  }\n\n  .ml-8 {\n    margin-left: 5rem!important\n  }\n\n  .-ml-1 {\n    margin-left: -.25rem!important\n  }\n\n  .-ml-2 {\n    margin-left: -.5rem!important\n  }\n\n  .-ml-3 {\n    margin-left: -1rem!important\n  }\n\n  .-ml-4 {\n    margin-left: -1.5rem!important\n  }\n\n  .-ml-5 {\n    margin-left: -2rem!important\n  }\n\n  .-ml-6 {\n    margin-left: -3rem!important\n  }\n\n  .-ml-7 {\n    margin-left: -4rem!important\n  }\n\n  .-ml-8 {\n    margin-left: -5rem!important\n  }\n\n  .ml-auto {\n    margin-left: auto!important\n  }\n\n  .mb-0 {\n    margin-bottom: 0rem!important\n  }\n\n  .mb-1 {\n    margin-bottom: .25rem!important\n  }\n\n  .mb-2 {\n    margin-bottom: .5rem!important\n  }\n\n  .mb-3 {\n    margin-bottom: 1rem!important\n  }\n\n  .mb-4 {\n    margin-bottom: 1.5rem!important\n  }\n\n  .mb-5 {\n    margin-bottom: 2rem!important\n  }\n\n  .mb-6 {\n    margin-bottom: 3rem!important\n  }\n\n  .mb-7 {\n    margin-bottom: 4rem!important\n  }\n\n  .mb-8 {\n    margin-bottom: 5rem!important\n  }\n\n  .-mb-1 {\n    margin-bottom: -.25rem!important\n  }\n\n  .-mb-2 {\n    margin-bottom: -.5rem!important\n  }\n\n  .-mb-3 {\n    margin-bottom: -1rem!important\n  }\n\n  .-mb-4 {\n    margin-bottom: -1.5rem!important\n  }\n\n  .-mb-5 {\n    margin-bottom: -2rem!important\n  }\n\n  .-mb-6 {\n    margin-bottom: -3rem!important\n  }\n\n  .-mb-7 {\n    margin-bottom: -4rem!important\n  }\n\n  .-mb-8 {\n    margin-bottom: -5rem!important\n  }\n\n  .mb-auto {\n    margin-bottom: auto!important\n  }\n\n  .mx-0 {\n    margin-left: 0rem!important;\n    margin-right: 0rem!important\n  }\n\n  .mx-1 {\n    margin-left: .25rem!important;\n    margin-right: .25rem!important\n  }\n\n  .mx-2 {\n    margin-left: .5rem!important;\n    margin-right: .5rem!important\n  }\n\n  .mx-3 {\n    margin-left: 1rem!important;\n    margin-right: 1rem!important\n  }\n\n  .mx-4 {\n    margin-left: 1.5rem!important;\n    margin-right: 1.5rem!important\n  }\n\n  .mx-5 {\n    margin-left: 2rem!important;\n    margin-right: 2rem!important\n  }\n\n  .mx-6 {\n    margin-left: 3rem!important;\n    margin-right: 3rem!important\n  }\n\n  .mx-7 {\n    margin-left: 4rem!important;\n    margin-right: 4rem!important\n  }\n\n  .mx-8 {\n    margin-left: 5rem!important;\n    margin-right: 5rem!important\n  }\n\n  .-mx-1 {\n    margin-left: -.25rem!important;\n    margin-right: -.25rem!important\n  }\n\n  .-mx-2 {\n    margin-left: -.5rem!important;\n    margin-right: -.5rem!important\n  }\n\n  .-mx-3 {\n    margin-left: -1rem!important;\n    margin-right: -1rem!important\n  }\n\n  .-mx-4 {\n    margin-left: -1.5rem!important;\n    margin-right: -1.5rem!important\n  }\n\n  .-mx-5 {\n    margin-left: -2rem!important;\n    margin-right: -2rem!important\n  }\n\n  .-mx-6 {\n    margin-left: -3rem!important;\n    margin-right: -3rem!important\n  }\n\n  .-mx-7 {\n    margin-left: -4rem!important;\n    margin-right: -4rem!important\n  }\n\n  .-mx-8 {\n    margin-left: -5rem!important;\n    margin-right: -5rem!important\n  }\n\n  .mx-auto {\n    margin-left: auto!important;\n    margin-right: auto!important\n  }\n\n  .my-0 {\n    margin-top: 0rem!important;\n    margin-bottom: 0rem!important\n  }\n\n  .my-1 {\n    margin-top: .25rem!important;\n    margin-bottom: .25rem!important\n  }\n\n  .my-2 {\n    margin-top: .5rem!important;\n    margin-bottom: .5rem!important\n  }\n\n  .my-3 {\n    margin-top: 1rem!important;\n    margin-bottom: 1rem!important\n  }\n\n  .my-4 {\n    margin-top: 1.5rem!important;\n    margin-bottom: 1.5rem!important\n  }\n\n  .my-5 {\n    margin-top: 2rem!important;\n    margin-bottom: 2rem!important\n  }\n\n  .my-6 {\n    margin-top: 3rem!important;\n    margin-bottom: 3rem!important\n  }\n\n  .my-7 {\n    margin-top: 4rem!important;\n    margin-bottom: 4rem!important\n  }\n\n  .my-8 {\n    margin-top: 5rem!important;\n    margin-bottom: 5rem!important\n  }\n\n  .-my-1 {\n    margin-top: -.25rem!important;\n    margin-bottom: -.25rem!important\n  }\n\n  .-my-2 {\n    margin-top: -.5rem!important;\n    margin-bottom: -.5rem!important\n  }\n\n  .-my-3 {\n    margin-top: -1rem!important;\n    margin-bottom: -1rem!important\n  }\n\n  .-my-4 {\n    margin-top: -1.5rem!important;\n    margin-bottom: -1.5rem!important\n  }\n\n  .-my-5 {\n    margin-top: -2rem!important;\n    margin-bottom: -2rem!important\n  }\n\n  .-my-6 {\n    margin-top: -3rem!important;\n    margin-bottom: -3rem!important\n  }\n\n  .-my-7 {\n    margin-top: -4rem!important;\n    margin-bottom: -4rem!important\n  }\n\n  .-my-8 {\n    margin-top: -5rem!important;\n    margin-bottom: -5rem!important\n  }\n\n  .my-auto {\n    margin-top: auto!important;\n    margin-bottom: auto!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:m-0 {\n      margin:0rem!important\n    }\n\n    .sm\\:m-1 {\n      margin: .25rem!important\n    }\n\n    .sm\\:m-2 {\n      margin: .5rem!important\n    }\n\n    .sm\\:m-3 {\n      margin: 1rem!important\n    }\n\n    .sm\\:m-4 {\n      margin: 1.5rem!important\n    }\n\n    .sm\\:m-5 {\n      margin: 2rem!important\n    }\n\n    .sm\\:m-6 {\n      margin: 3rem!important\n    }\n\n    .sm\\:m-7 {\n      margin: 4rem!important\n    }\n\n    .sm\\:m-8 {\n      margin: 5rem!important\n    }\n\n    .sm\\:-m-1 {\n      margin: -.25rem!important\n    }\n\n    .sm\\:-m-2 {\n      margin: -.5rem!important\n    }\n\n    .sm\\:-m-3 {\n      margin: -1rem!important\n    }\n\n    .sm\\:-m-4 {\n      margin: -1.5rem!important\n    }\n\n    .sm\\:-m-5 {\n      margin: -2rem!important\n    }\n\n    .sm\\:-m-6 {\n      margin: -3rem!important\n    }\n\n    .sm\\:-m-7 {\n      margin: -4rem!important\n    }\n\n    .sm\\:-m-8 {\n      margin: -5rem!important\n    }\n\n    .sm\\:m-auto {\n      margin: auto!important\n    }\n\n    .sm\\:mt-0 {\n      margin-top: 0rem!important\n    }\n\n    .sm\\:mt-1 {\n      margin-top: .25rem!important\n    }\n\n    .sm\\:mt-2 {\n      margin-top: .5rem!important\n    }\n\n    .sm\\:mt-3 {\n      margin-top: 1rem!important\n    }\n\n    .sm\\:mt-4 {\n      margin-top: 1.5rem!important\n    }\n\n    .sm\\:mt-5 {\n      margin-top: 2rem!important\n    }\n\n    .sm\\:mt-6 {\n      margin-top: 3rem!important\n    }\n\n    .sm\\:mt-7 {\n      margin-top: 4rem!important\n    }\n\n    .sm\\:mt-8 {\n      margin-top: 5rem!important\n    }\n\n    .sm\\:-mt-1 {\n      margin-top: -.25rem!important\n    }\n\n    .sm\\:-mt-2 {\n      margin-top: -.5rem!important\n    }\n\n    .sm\\:-mt-3 {\n      margin-top: -1rem!important\n    }\n\n    .sm\\:-mt-4 {\n      margin-top: -1.5rem!important\n    }\n\n    .sm\\:-mt-5 {\n      margin-top: -2rem!important\n    }\n\n    .sm\\:-mt-6 {\n      margin-top: -3rem!important\n    }\n\n    .sm\\:-mt-7 {\n      margin-top: -4rem!important\n    }\n\n    .sm\\:-mt-8 {\n      margin-top: -5rem!important\n    }\n\n    .sm\\:mt-auto {\n      margin-top: auto!important\n    }\n\n    .sm\\:mr-0 {\n      margin-right: 0rem!important\n    }\n\n    .sm\\:mr-1 {\n      margin-right: .25rem!important\n    }\n\n    .sm\\:mr-2 {\n      margin-right: .5rem!important\n    }\n\n    .sm\\:mr-3 {\n      margin-right: 1rem!important\n    }\n\n    .sm\\:mr-4 {\n      margin-right: 1.5rem!important\n    }\n\n    .sm\\:mr-5 {\n      margin-right: 2rem!important\n    }\n\n    .sm\\:mr-6 {\n      margin-right: 3rem!important\n    }\n\n    .sm\\:mr-7 {\n      margin-right: 4rem!important\n    }\n\n    .sm\\:mr-8 {\n      margin-right: 5rem!important\n    }\n\n    .sm\\:-mr-1 {\n      margin-right: -.25rem!important\n    }\n\n    .sm\\:-mr-2 {\n      margin-right: -.5rem!important\n    }\n\n    .sm\\:-mr-3 {\n      margin-right: -1rem!important\n    }\n\n    .sm\\:-mr-4 {\n      margin-right: -1.5rem!important\n    }\n\n    .sm\\:-mr-5 {\n      margin-right: -2rem!important\n    }\n\n    .sm\\:-mr-6 {\n      margin-right: -3rem!important\n    }\n\n    .sm\\:-mr-7 {\n      margin-right: -4rem!important\n    }\n\n    .sm\\:-mr-8 {\n      margin-right: -5rem!important\n    }\n\n    .sm\\:mr-auto {\n      margin-right: auto!important\n    }\n\n    .sm\\:ml-0 {\n      margin-left: 0rem!important\n    }\n\n    .sm\\:ml-1 {\n      margin-left: .25rem!important\n    }\n\n    .sm\\:ml-2 {\n      margin-left: .5rem!important\n    }\n\n    .sm\\:ml-3 {\n      margin-left: 1rem!important\n    }\n\n    .sm\\:ml-4 {\n      margin-left: 1.5rem!important\n    }\n\n    .sm\\:ml-5 {\n      margin-left: 2rem!important\n    }\n\n    .sm\\:ml-6 {\n      margin-left: 3rem!important\n    }\n\n    .sm\\:ml-7 {\n      margin-left: 4rem!important\n    }\n\n    .sm\\:ml-8 {\n      margin-left: 5rem!important\n    }\n\n    .sm\\:-ml-1 {\n      margin-left: -.25rem!important\n    }\n\n    .sm\\:-ml-2 {\n      margin-left: -.5rem!important\n    }\n\n    .sm\\:-ml-3 {\n      margin-left: -1rem!important\n    }\n\n    .sm\\:-ml-4 {\n      margin-left: -1.5rem!important\n    }\n\n    .sm\\:-ml-5 {\n      margin-left: -2rem!important\n    }\n\n    .sm\\:-ml-6 {\n      margin-left: -3rem!important\n    }\n\n    .sm\\:-ml-7 {\n      margin-left: -4rem!important\n    }\n\n    .sm\\:-ml-8 {\n      margin-left: -5rem!important\n    }\n\n    .sm\\:ml-auto {\n      margin-left: auto!important\n    }\n\n    .sm\\:mb-0 {\n      margin-bottom: 0rem!important\n    }\n\n    .sm\\:mb-1 {\n      margin-bottom: .25rem!important\n    }\n\n    .sm\\:mb-2 {\n      margin-bottom: .5rem!important\n    }\n\n    .sm\\:mb-3 {\n      margin-bottom: 1rem!important\n    }\n\n    .sm\\:mb-4 {\n      margin-bottom: 1.5rem!important\n    }\n\n    .sm\\:mb-5 {\n      margin-bottom: 2rem!important\n    }\n\n    .sm\\:mb-6 {\n      margin-bottom: 3rem!important\n    }\n\n    .sm\\:mb-7 {\n      margin-bottom: 4rem!important\n    }\n\n    .sm\\:mb-8 {\n      margin-bottom: 5rem!important\n    }\n\n    .sm\\:-mb-1 {\n      margin-bottom: -.25rem!important\n    }\n\n    .sm\\:-mb-2 {\n      margin-bottom: -.5rem!important\n    }\n\n    .sm\\:-mb-3 {\n      margin-bottom: -1rem!important\n    }\n\n    .sm\\:-mb-4 {\n      margin-bottom: -1.5rem!important\n    }\n\n    .sm\\:-mb-5 {\n      margin-bottom: -2rem!important\n    }\n\n    .sm\\:-mb-6 {\n      margin-bottom: -3rem!important\n    }\n\n    .sm\\:-mb-7 {\n      margin-bottom: -4rem!important\n    }\n\n    .sm\\:-mb-8 {\n      margin-bottom: -5rem!important\n    }\n\n    .sm\\:mb-auto {\n      margin-bottom: auto!important\n    }\n\n    .sm\\:mx-0 {\n      margin-left: 0rem!important;\n      margin-right: 0rem!important\n    }\n\n    .sm\\:mx-1 {\n      margin-left: .25rem!important;\n      margin-right: .25rem!important\n    }\n\n    .sm\\:mx-2 {\n      margin-left: .5rem!important;\n      margin-right: .5rem!important\n    }\n\n    .sm\\:mx-3 {\n      margin-left: 1rem!important;\n      margin-right: 1rem!important\n    }\n\n    .sm\\:mx-4 {\n      margin-left: 1.5rem!important;\n      margin-right: 1.5rem!important\n    }\n\n    .sm\\:mx-5 {\n      margin-left: 2rem!important;\n      margin-right: 2rem!important\n    }\n\n    .sm\\:mx-6 {\n      margin-left: 3rem!important;\n      margin-right: 3rem!important\n    }\n\n    .sm\\:mx-7 {\n      margin-left: 4rem!important;\n      margin-right: 4rem!important\n    }\n\n    .sm\\:mx-8 {\n      margin-left: 5rem!important;\n      margin-right: 5rem!important\n    }\n\n    .sm\\:-mx-1 {\n      margin-left: -.25rem!important;\n      margin-right: -.25rem!important\n    }\n\n    .sm\\:-mx-2 {\n      margin-left: -.5rem!important;\n      margin-right: -.5rem!important\n    }\n\n    .sm\\:-mx-3 {\n      margin-left: -1rem!important;\n      margin-right: -1rem!important\n    }\n\n    .sm\\:-mx-4 {\n      margin-left: -1.5rem!important;\n      margin-right: -1.5rem!important\n    }\n\n    .sm\\:-mx-5 {\n      margin-left: -2rem!important;\n      margin-right: -2rem!important\n    }\n\n    .sm\\:-mx-6 {\n      margin-left: -3rem!important;\n      margin-right: -3rem!important\n    }\n\n    .sm\\:-mx-7 {\n      margin-left: -4rem!important;\n      margin-right: -4rem!important\n    }\n\n    .sm\\:-mx-8 {\n      margin-left: -5rem!important;\n      margin-right: -5rem!important\n    }\n\n    .sm\\:mx-auto {\n      margin-left: auto!important;\n      margin-right: auto!important\n    }\n\n    .sm\\:my-0 {\n      margin-top: 0rem!important;\n      margin-bottom: 0rem!important\n    }\n\n    .sm\\:my-1 {\n      margin-top: .25rem!important;\n      margin-bottom: .25rem!important\n    }\n\n    .sm\\:my-2 {\n      margin-top: .5rem!important;\n      margin-bottom: .5rem!important\n    }\n\n    .sm\\:my-3 {\n      margin-top: 1rem!important;\n      margin-bottom: 1rem!important\n    }\n\n    .sm\\:my-4 {\n      margin-top: 1.5rem!important;\n      margin-bottom: 1.5rem!important\n    }\n\n    .sm\\:my-5 {\n      margin-top: 2rem!important;\n      margin-bottom: 2rem!important\n    }\n\n    .sm\\:my-6 {\n      margin-top: 3rem!important;\n      margin-bottom: 3rem!important\n    }\n\n    .sm\\:my-7 {\n      margin-top: 4rem!important;\n      margin-bottom: 4rem!important\n    }\n\n    .sm\\:my-8 {\n      margin-top: 5rem!important;\n      margin-bottom: 5rem!important\n    }\n\n    .sm\\:-my-1 {\n      margin-top: -.25rem!important;\n      margin-bottom: -.25rem!important\n    }\n\n    .sm\\:-my-2 {\n      margin-top: -.5rem!important;\n      margin-bottom: -.5rem!important\n    }\n\n    .sm\\:-my-3 {\n      margin-top: -1rem!important;\n      margin-bottom: -1rem!important\n    }\n\n    .sm\\:-my-4 {\n      margin-top: -1.5rem!important;\n      margin-bottom: -1.5rem!important\n    }\n\n    .sm\\:-my-5 {\n      margin-top: -2rem!important;\n      margin-bottom: -2rem!important\n    }\n\n    .sm\\:-my-6 {\n      margin-top: -3rem!important;\n      margin-bottom: -3rem!important\n    }\n\n    .sm\\:-my-7 {\n      margin-top: -4rem!important;\n      margin-bottom: -4rem!important\n    }\n\n    .sm\\:-my-8 {\n      margin-top: -5rem!important;\n      margin-bottom: -5rem!important\n    }\n\n    .sm\\:my-auto {\n      margin-top: auto!important;\n      margin-bottom: auto!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:m-0 {\n      margin:0rem!important\n    }\n\n    .md\\:m-1 {\n      margin: .25rem!important\n    }\n\n    .md\\:m-2 {\n      margin: .5rem!important\n    }\n\n    .md\\:m-3 {\n      margin: 1rem!important\n    }\n\n    .md\\:m-4 {\n      margin: 1.5rem!important\n    }\n\n    .md\\:m-5 {\n      margin: 2rem!important\n    }\n\n    .md\\:m-6 {\n      margin: 3rem!important\n    }\n\n    .md\\:m-7 {\n      margin: 4rem!important\n    }\n\n    .md\\:m-8 {\n      margin: 5rem!important\n    }\n\n    .md\\:-m-1 {\n      margin: -.25rem!important\n    }\n\n    .md\\:-m-2 {\n      margin: -.5rem!important\n    }\n\n    .md\\:-m-3 {\n      margin: -1rem!important\n    }\n\n    .md\\:-m-4 {\n      margin: -1.5rem!important\n    }\n\n    .md\\:-m-5 {\n      margin: -2rem!important\n    }\n\n    .md\\:-m-6 {\n      margin: -3rem!important\n    }\n\n    .md\\:-m-7 {\n      margin: -4rem!important\n    }\n\n    .md\\:-m-8 {\n      margin: -5rem!important\n    }\n\n    .md\\:m-auto {\n      margin: auto!important\n    }\n\n    .md\\:mt-0 {\n      margin-top: 0rem!important\n    }\n\n    .md\\:mt-1 {\n      margin-top: .25rem!important\n    }\n\n    .md\\:mt-2 {\n      margin-top: .5rem!important\n    }\n\n    .md\\:mt-3 {\n      margin-top: 1rem!important\n    }\n\n    .md\\:mt-4 {\n      margin-top: 1.5rem!important\n    }\n\n    .md\\:mt-5 {\n      margin-top: 2rem!important\n    }\n\n    .md\\:mt-6 {\n      margin-top: 3rem!important\n    }\n\n    .md\\:mt-7 {\n      margin-top: 4rem!important\n    }\n\n    .md\\:mt-8 {\n      margin-top: 5rem!important\n    }\n\n    .md\\:-mt-1 {\n      margin-top: -.25rem!important\n    }\n\n    .md\\:-mt-2 {\n      margin-top: -.5rem!important\n    }\n\n    .md\\:-mt-3 {\n      margin-top: -1rem!important\n    }\n\n    .md\\:-mt-4 {\n      margin-top: -1.5rem!important\n    }\n\n    .md\\:-mt-5 {\n      margin-top: -2rem!important\n    }\n\n    .md\\:-mt-6 {\n      margin-top: -3rem!important\n    }\n\n    .md\\:-mt-7 {\n      margin-top: -4rem!important\n    }\n\n    .md\\:-mt-8 {\n      margin-top: -5rem!important\n    }\n\n    .md\\:mt-auto {\n      margin-top: auto!important\n    }\n\n    .md\\:mr-0 {\n      margin-right: 0rem!important\n    }\n\n    .md\\:mr-1 {\n      margin-right: .25rem!important\n    }\n\n    .md\\:mr-2 {\n      margin-right: .5rem!important\n    }\n\n    .md\\:mr-3 {\n      margin-right: 1rem!important\n    }\n\n    .md\\:mr-4 {\n      margin-right: 1.5rem!important\n    }\n\n    .md\\:mr-5 {\n      margin-right: 2rem!important\n    }\n\n    .md\\:mr-6 {\n      margin-right: 3rem!important\n    }\n\n    .md\\:mr-7 {\n      margin-right: 4rem!important\n    }\n\n    .md\\:mr-8 {\n      margin-right: 5rem!important\n    }\n\n    .md\\:-mr-1 {\n      margin-right: -.25rem!important\n    }\n\n    .md\\:-mr-2 {\n      margin-right: -.5rem!important\n    }\n\n    .md\\:-mr-3 {\n      margin-right: -1rem!important\n    }\n\n    .md\\:-mr-4 {\n      margin-right: -1.5rem!important\n    }\n\n    .md\\:-mr-5 {\n      margin-right: -2rem!important\n    }\n\n    .md\\:-mr-6 {\n      margin-right: -3rem!important\n    }\n\n    .md\\:-mr-7 {\n      margin-right: -4rem!important\n    }\n\n    .md\\:-mr-8 {\n      margin-right: -5rem!important\n    }\n\n    .md\\:mr-auto {\n      margin-right: auto!important\n    }\n\n    .md\\:ml-0 {\n      margin-left: 0rem!important\n    }\n\n    .md\\:ml-1 {\n      margin-left: .25rem!important\n    }\n\n    .md\\:ml-2 {\n      margin-left: .5rem!important\n    }\n\n    .md\\:ml-3 {\n      margin-left: 1rem!important\n    }\n\n    .md\\:ml-4 {\n      margin-left: 1.5rem!important\n    }\n\n    .md\\:ml-5 {\n      margin-left: 2rem!important\n    }\n\n    .md\\:ml-6 {\n      margin-left: 3rem!important\n    }\n\n    .md\\:ml-7 {\n      margin-left: 4rem!important\n    }\n\n    .md\\:ml-8 {\n      margin-left: 5rem!important\n    }\n\n    .md\\:-ml-1 {\n      margin-left: -.25rem!important\n    }\n\n    .md\\:-ml-2 {\n      margin-left: -.5rem!important\n    }\n\n    .md\\:-ml-3 {\n      margin-left: -1rem!important\n    }\n\n    .md\\:-ml-4 {\n      margin-left: -1.5rem!important\n    }\n\n    .md\\:-ml-5 {\n      margin-left: -2rem!important\n    }\n\n    .md\\:-ml-6 {\n      margin-left: -3rem!important\n    }\n\n    .md\\:-ml-7 {\n      margin-left: -4rem!important\n    }\n\n    .md\\:-ml-8 {\n      margin-left: -5rem!important\n    }\n\n    .md\\:ml-auto {\n      margin-left: auto!important\n    }\n\n    .md\\:mb-0 {\n      margin-bottom: 0rem!important\n    }\n\n    .md\\:mb-1 {\n      margin-bottom: .25rem!important\n    }\n\n    .md\\:mb-2 {\n      margin-bottom: .5rem!important\n    }\n\n    .md\\:mb-3 {\n      margin-bottom: 1rem!important\n    }\n\n    .md\\:mb-4 {\n      margin-bottom: 1.5rem!important\n    }\n\n    .md\\:mb-5 {\n      margin-bottom: 2rem!important\n    }\n\n    .md\\:mb-6 {\n      margin-bottom: 3rem!important\n    }\n\n    .md\\:mb-7 {\n      margin-bottom: 4rem!important\n    }\n\n    .md\\:mb-8 {\n      margin-bottom: 5rem!important\n    }\n\n    .md\\:-mb-1 {\n      margin-bottom: -.25rem!important\n    }\n\n    .md\\:-mb-2 {\n      margin-bottom: -.5rem!important\n    }\n\n    .md\\:-mb-3 {\n      margin-bottom: -1rem!important\n    }\n\n    .md\\:-mb-4 {\n      margin-bottom: -1.5rem!important\n    }\n\n    .md\\:-mb-5 {\n      margin-bottom: -2rem!important\n    }\n\n    .md\\:-mb-6 {\n      margin-bottom: -3rem!important\n    }\n\n    .md\\:-mb-7 {\n      margin-bottom: -4rem!important\n    }\n\n    .md\\:-mb-8 {\n      margin-bottom: -5rem!important\n    }\n\n    .md\\:mb-auto {\n      margin-bottom: auto!important\n    }\n\n    .md\\:mx-0 {\n      margin-left: 0rem!important;\n      margin-right: 0rem!important\n    }\n\n    .md\\:mx-1 {\n      margin-left: .25rem!important;\n      margin-right: .25rem!important\n    }\n\n    .md\\:mx-2 {\n      margin-left: .5rem!important;\n      margin-right: .5rem!important\n    }\n\n    .md\\:mx-3 {\n      margin-left: 1rem!important;\n      margin-right: 1rem!important\n    }\n\n    .md\\:mx-4 {\n      margin-left: 1.5rem!important;\n      margin-right: 1.5rem!important\n    }\n\n    .md\\:mx-5 {\n      margin-left: 2rem!important;\n      margin-right: 2rem!important\n    }\n\n    .md\\:mx-6 {\n      margin-left: 3rem!important;\n      margin-right: 3rem!important\n    }\n\n    .md\\:mx-7 {\n      margin-left: 4rem!important;\n      margin-right: 4rem!important\n    }\n\n    .md\\:mx-8 {\n      margin-left: 5rem!important;\n      margin-right: 5rem!important\n    }\n\n    .md\\:-mx-1 {\n      margin-left: -.25rem!important;\n      margin-right: -.25rem!important\n    }\n\n    .md\\:-mx-2 {\n      margin-left: -.5rem!important;\n      margin-right: -.5rem!important\n    }\n\n    .md\\:-mx-3 {\n      margin-left: -1rem!important;\n      margin-right: -1rem!important\n    }\n\n    .md\\:-mx-4 {\n      margin-left: -1.5rem!important;\n      margin-right: -1.5rem!important\n    }\n\n    .md\\:-mx-5 {\n      margin-left: -2rem!important;\n      margin-right: -2rem!important\n    }\n\n    .md\\:-mx-6 {\n      margin-left: -3rem!important;\n      margin-right: -3rem!important\n    }\n\n    .md\\:-mx-7 {\n      margin-left: -4rem!important;\n      margin-right: -4rem!important\n    }\n\n    .md\\:-mx-8 {\n      margin-left: -5rem!important;\n      margin-right: -5rem!important\n    }\n\n    .md\\:mx-auto {\n      margin-left: auto!important;\n      margin-right: auto!important\n    }\n\n    .md\\:my-0 {\n      margin-top: 0rem!important;\n      margin-bottom: 0rem!important\n    }\n\n    .md\\:my-1 {\n      margin-top: .25rem!important;\n      margin-bottom: .25rem!important\n    }\n\n    .md\\:my-2 {\n      margin-top: .5rem!important;\n      margin-bottom: .5rem!important\n    }\n\n    .md\\:my-3 {\n      margin-top: 1rem!important;\n      margin-bottom: 1rem!important\n    }\n\n    .md\\:my-4 {\n      margin-top: 1.5rem!important;\n      margin-bottom: 1.5rem!important\n    }\n\n    .md\\:my-5 {\n      margin-top: 2rem!important;\n      margin-bottom: 2rem!important\n    }\n\n    .md\\:my-6 {\n      margin-top: 3rem!important;\n      margin-bottom: 3rem!important\n    }\n\n    .md\\:my-7 {\n      margin-top: 4rem!important;\n      margin-bottom: 4rem!important\n    }\n\n    .md\\:my-8 {\n      margin-top: 5rem!important;\n      margin-bottom: 5rem!important\n    }\n\n    .md\\:-my-1 {\n      margin-top: -.25rem!important;\n      margin-bottom: -.25rem!important\n    }\n\n    .md\\:-my-2 {\n      margin-top: -.5rem!important;\n      margin-bottom: -.5rem!important\n    }\n\n    .md\\:-my-3 {\n      margin-top: -1rem!important;\n      margin-bottom: -1rem!important\n    }\n\n    .md\\:-my-4 {\n      margin-top: -1.5rem!important;\n      margin-bottom: -1.5rem!important\n    }\n\n    .md\\:-my-5 {\n      margin-top: -2rem!important;\n      margin-bottom: -2rem!important\n    }\n\n    .md\\:-my-6 {\n      margin-top: -3rem!important;\n      margin-bottom: -3rem!important\n    }\n\n    .md\\:-my-7 {\n      margin-top: -4rem!important;\n      margin-bottom: -4rem!important\n    }\n\n    .md\\:-my-8 {\n      margin-top: -5rem!important;\n      margin-bottom: -5rem!important\n    }\n\n    .md\\:my-auto {\n      margin-top: auto!important;\n      margin-bottom: auto!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:m-0 {\n      margin:0rem!important\n    }\n\n    .lg\\:m-1 {\n      margin: .25rem!important\n    }\n\n    .lg\\:m-2 {\n      margin: .5rem!important\n    }\n\n    .lg\\:m-3 {\n      margin: 1rem!important\n    }\n\n    .lg\\:m-4 {\n      margin: 1.5rem!important\n    }\n\n    .lg\\:m-5 {\n      margin: 2rem!important\n    }\n\n    .lg\\:m-6 {\n      margin: 3rem!important\n    }\n\n    .lg\\:m-7 {\n      margin: 4rem!important\n    }\n\n    .lg\\:m-8 {\n      margin: 5rem!important\n    }\n\n    .lg\\:-m-1 {\n      margin: -.25rem!important\n    }\n\n    .lg\\:-m-2 {\n      margin: -.5rem!important\n    }\n\n    .lg\\:-m-3 {\n      margin: -1rem!important\n    }\n\n    .lg\\:-m-4 {\n      margin: -1.5rem!important\n    }\n\n    .lg\\:-m-5 {\n      margin: -2rem!important\n    }\n\n    .lg\\:-m-6 {\n      margin: -3rem!important\n    }\n\n    .lg\\:-m-7 {\n      margin: -4rem!important\n    }\n\n    .lg\\:-m-8 {\n      margin: -5rem!important\n    }\n\n    .lg\\:m-auto {\n      margin: auto!important\n    }\n\n    .lg\\:mt-0 {\n      margin-top: 0rem!important\n    }\n\n    .lg\\:mt-1 {\n      margin-top: .25rem!important\n    }\n\n    .lg\\:mt-2 {\n      margin-top: .5rem!important\n    }\n\n    .lg\\:mt-3 {\n      margin-top: 1rem!important\n    }\n\n    .lg\\:mt-4 {\n      margin-top: 1.5rem!important\n    }\n\n    .lg\\:mt-5 {\n      margin-top: 2rem!important\n    }\n\n    .lg\\:mt-6 {\n      margin-top: 3rem!important\n    }\n\n    .lg\\:mt-7 {\n      margin-top: 4rem!important\n    }\n\n    .lg\\:mt-8 {\n      margin-top: 5rem!important\n    }\n\n    .lg\\:-mt-1 {\n      margin-top: -.25rem!important\n    }\n\n    .lg\\:-mt-2 {\n      margin-top: -.5rem!important\n    }\n\n    .lg\\:-mt-3 {\n      margin-top: -1rem!important\n    }\n\n    .lg\\:-mt-4 {\n      margin-top: -1.5rem!important\n    }\n\n    .lg\\:-mt-5 {\n      margin-top: -2rem!important\n    }\n\n    .lg\\:-mt-6 {\n      margin-top: -3rem!important\n    }\n\n    .lg\\:-mt-7 {\n      margin-top: -4rem!important\n    }\n\n    .lg\\:-mt-8 {\n      margin-top: -5rem!important\n    }\n\n    .lg\\:mt-auto {\n      margin-top: auto!important\n    }\n\n    .lg\\:mr-0 {\n      margin-right: 0rem!important\n    }\n\n    .lg\\:mr-1 {\n      margin-right: .25rem!important\n    }\n\n    .lg\\:mr-2 {\n      margin-right: .5rem!important\n    }\n\n    .lg\\:mr-3 {\n      margin-right: 1rem!important\n    }\n\n    .lg\\:mr-4 {\n      margin-right: 1.5rem!important\n    }\n\n    .lg\\:mr-5 {\n      margin-right: 2rem!important\n    }\n\n    .lg\\:mr-6 {\n      margin-right: 3rem!important\n    }\n\n    .lg\\:mr-7 {\n      margin-right: 4rem!important\n    }\n\n    .lg\\:mr-8 {\n      margin-right: 5rem!important\n    }\n\n    .lg\\:-mr-1 {\n      margin-right: -.25rem!important\n    }\n\n    .lg\\:-mr-2 {\n      margin-right: -.5rem!important\n    }\n\n    .lg\\:-mr-3 {\n      margin-right: -1rem!important\n    }\n\n    .lg\\:-mr-4 {\n      margin-right: -1.5rem!important\n    }\n\n    .lg\\:-mr-5 {\n      margin-right: -2rem!important\n    }\n\n    .lg\\:-mr-6 {\n      margin-right: -3rem!important\n    }\n\n    .lg\\:-mr-7 {\n      margin-right: -4rem!important\n    }\n\n    .lg\\:-mr-8 {\n      margin-right: -5rem!important\n    }\n\n    .lg\\:mr-auto {\n      margin-right: auto!important\n    }\n\n    .lg\\:ml-0 {\n      margin-left: 0rem!important\n    }\n\n    .lg\\:ml-1 {\n      margin-left: .25rem!important\n    }\n\n    .lg\\:ml-2 {\n      margin-left: .5rem!important\n    }\n\n    .lg\\:ml-3 {\n      margin-left: 1rem!important\n    }\n\n    .lg\\:ml-4 {\n      margin-left: 1.5rem!important\n    }\n\n    .lg\\:ml-5 {\n      margin-left: 2rem!important\n    }\n\n    .lg\\:ml-6 {\n      margin-left: 3rem!important\n    }\n\n    .lg\\:ml-7 {\n      margin-left: 4rem!important\n    }\n\n    .lg\\:ml-8 {\n      margin-left: 5rem!important\n    }\n\n    .lg\\:-ml-1 {\n      margin-left: -.25rem!important\n    }\n\n    .lg\\:-ml-2 {\n      margin-left: -.5rem!important\n    }\n\n    .lg\\:-ml-3 {\n      margin-left: -1rem!important\n    }\n\n    .lg\\:-ml-4 {\n      margin-left: -1.5rem!important\n    }\n\n    .lg\\:-ml-5 {\n      margin-left: -2rem!important\n    }\n\n    .lg\\:-ml-6 {\n      margin-left: -3rem!important\n    }\n\n    .lg\\:-ml-7 {\n      margin-left: -4rem!important\n    }\n\n    .lg\\:-ml-8 {\n      margin-left: -5rem!important\n    }\n\n    .lg\\:ml-auto {\n      margin-left: auto!important\n    }\n\n    .lg\\:mb-0 {\n      margin-bottom: 0rem!important\n    }\n\n    .lg\\:mb-1 {\n      margin-bottom: .25rem!important\n    }\n\n    .lg\\:mb-2 {\n      margin-bottom: .5rem!important\n    }\n\n    .lg\\:mb-3 {\n      margin-bottom: 1rem!important\n    }\n\n    .lg\\:mb-4 {\n      margin-bottom: 1.5rem!important\n    }\n\n    .lg\\:mb-5 {\n      margin-bottom: 2rem!important\n    }\n\n    .lg\\:mb-6 {\n      margin-bottom: 3rem!important\n    }\n\n    .lg\\:mb-7 {\n      margin-bottom: 4rem!important\n    }\n\n    .lg\\:mb-8 {\n      margin-bottom: 5rem!important\n    }\n\n    .lg\\:-mb-1 {\n      margin-bottom: -.25rem!important\n    }\n\n    .lg\\:-mb-2 {\n      margin-bottom: -.5rem!important\n    }\n\n    .lg\\:-mb-3 {\n      margin-bottom: -1rem!important\n    }\n\n    .lg\\:-mb-4 {\n      margin-bottom: -1.5rem!important\n    }\n\n    .lg\\:-mb-5 {\n      margin-bottom: -2rem!important\n    }\n\n    .lg\\:-mb-6 {\n      margin-bottom: -3rem!important\n    }\n\n    .lg\\:-mb-7 {\n      margin-bottom: -4rem!important\n    }\n\n    .lg\\:-mb-8 {\n      margin-bottom: -5rem!important\n    }\n\n    .lg\\:mb-auto {\n      margin-bottom: auto!important\n    }\n\n    .lg\\:mx-0 {\n      margin-left: 0rem!important;\n      margin-right: 0rem!important\n    }\n\n    .lg\\:mx-1 {\n      margin-left: .25rem!important;\n      margin-right: .25rem!important\n    }\n\n    .lg\\:mx-2 {\n      margin-left: .5rem!important;\n      margin-right: .5rem!important\n    }\n\n    .lg\\:mx-3 {\n      margin-left: 1rem!important;\n      margin-right: 1rem!important\n    }\n\n    .lg\\:mx-4 {\n      margin-left: 1.5rem!important;\n      margin-right: 1.5rem!important\n    }\n\n    .lg\\:mx-5 {\n      margin-left: 2rem!important;\n      margin-right: 2rem!important\n    }\n\n    .lg\\:mx-6 {\n      margin-left: 3rem!important;\n      margin-right: 3rem!important\n    }\n\n    .lg\\:mx-7 {\n      margin-left: 4rem!important;\n      margin-right: 4rem!important\n    }\n\n    .lg\\:mx-8 {\n      margin-left: 5rem!important;\n      margin-right: 5rem!important\n    }\n\n    .lg\\:-mx-1 {\n      margin-left: -.25rem!important;\n      margin-right: -.25rem!important\n    }\n\n    .lg\\:-mx-2 {\n      margin-left: -.5rem!important;\n      margin-right: -.5rem!important\n    }\n\n    .lg\\:-mx-3 {\n      margin-left: -1rem!important;\n      margin-right: -1rem!important\n    }\n\n    .lg\\:-mx-4 {\n      margin-left: -1.5rem!important;\n      margin-right: -1.5rem!important\n    }\n\n    .lg\\:-mx-5 {\n      margin-left: -2rem!important;\n      margin-right: -2rem!important\n    }\n\n    .lg\\:-mx-6 {\n      margin-left: -3rem!important;\n      margin-right: -3rem!important\n    }\n\n    .lg\\:-mx-7 {\n      margin-left: -4rem!important;\n      margin-right: -4rem!important\n    }\n\n    .lg\\:-mx-8 {\n      margin-left: -5rem!important;\n      margin-right: -5rem!important\n    }\n\n    .lg\\:mx-auto {\n      margin-left: auto!important;\n      margin-right: auto!important\n    }\n\n    .lg\\:my-0 {\n      margin-top: 0rem!important;\n      margin-bottom: 0rem!important\n    }\n\n    .lg\\:my-1 {\n      margin-top: .25rem!important;\n      margin-bottom: .25rem!important\n    }\n\n    .lg\\:my-2 {\n      margin-top: .5rem!important;\n      margin-bottom: .5rem!important\n    }\n\n    .lg\\:my-3 {\n      margin-top: 1rem!important;\n      margin-bottom: 1rem!important\n    }\n\n    .lg\\:my-4 {\n      margin-top: 1.5rem!important;\n      margin-bottom: 1.5rem!important\n    }\n\n    .lg\\:my-5 {\n      margin-top: 2rem!important;\n      margin-bottom: 2rem!important\n    }\n\n    .lg\\:my-6 {\n      margin-top: 3rem!important;\n      margin-bottom: 3rem!important\n    }\n\n    .lg\\:my-7 {\n      margin-top: 4rem!important;\n      margin-bottom: 4rem!important\n    }\n\n    .lg\\:my-8 {\n      margin-top: 5rem!important;\n      margin-bottom: 5rem!important\n    }\n\n    .lg\\:-my-1 {\n      margin-top: -.25rem!important;\n      margin-bottom: -.25rem!important\n    }\n\n    .lg\\:-my-2 {\n      margin-top: -.5rem!important;\n      margin-bottom: -.5rem!important\n    }\n\n    .lg\\:-my-3 {\n      margin-top: -1rem!important;\n      margin-bottom: -1rem!important\n    }\n\n    .lg\\:-my-4 {\n      margin-top: -1.5rem!important;\n      margin-bottom: -1.5rem!important\n    }\n\n    .lg\\:-my-5 {\n      margin-top: -2rem!important;\n      margin-bottom: -2rem!important\n    }\n\n    .lg\\:-my-6 {\n      margin-top: -3rem!important;\n      margin-bottom: -3rem!important\n    }\n\n    .lg\\:-my-7 {\n      margin-top: -4rem!important;\n      margin-bottom: -4rem!important\n    }\n\n    .lg\\:-my-8 {\n      margin-top: -5rem!important;\n      margin-bottom: -5rem!important\n    }\n\n    .lg\\:my-auto {\n      margin-top: auto!important;\n      margin-bottom: auto!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:m-0 {\n      margin:0rem!important\n    }\n\n    .xl\\:m-1 {\n      margin: .25rem!important\n    }\n\n    .xl\\:m-2 {\n      margin: .5rem!important\n    }\n\n    .xl\\:m-3 {\n      margin: 1rem!important\n    }\n\n    .xl\\:m-4 {\n      margin: 1.5rem!important\n    }\n\n    .xl\\:m-5 {\n      margin: 2rem!important\n    }\n\n    .xl\\:m-6 {\n      margin: 3rem!important\n    }\n\n    .xl\\:m-7 {\n      margin: 4rem!important\n    }\n\n    .xl\\:m-8 {\n      margin: 5rem!important\n    }\n\n    .xl\\:-m-1 {\n      margin: -.25rem!important\n    }\n\n    .xl\\:-m-2 {\n      margin: -.5rem!important\n    }\n\n    .xl\\:-m-3 {\n      margin: -1rem!important\n    }\n\n    .xl\\:-m-4 {\n      margin: -1.5rem!important\n    }\n\n    .xl\\:-m-5 {\n      margin: -2rem!important\n    }\n\n    .xl\\:-m-6 {\n      margin: -3rem!important\n    }\n\n    .xl\\:-m-7 {\n      margin: -4rem!important\n    }\n\n    .xl\\:-m-8 {\n      margin: -5rem!important\n    }\n\n    .xl\\:m-auto {\n      margin: auto!important\n    }\n\n    .xl\\:mt-0 {\n      margin-top: 0rem!important\n    }\n\n    .xl\\:mt-1 {\n      margin-top: .25rem!important\n    }\n\n    .xl\\:mt-2 {\n      margin-top: .5rem!important\n    }\n\n    .xl\\:mt-3 {\n      margin-top: 1rem!important\n    }\n\n    .xl\\:mt-4 {\n      margin-top: 1.5rem!important\n    }\n\n    .xl\\:mt-5 {\n      margin-top: 2rem!important\n    }\n\n    .xl\\:mt-6 {\n      margin-top: 3rem!important\n    }\n\n    .xl\\:mt-7 {\n      margin-top: 4rem!important\n    }\n\n    .xl\\:mt-8 {\n      margin-top: 5rem!important\n    }\n\n    .xl\\:-mt-1 {\n      margin-top: -.25rem!important\n    }\n\n    .xl\\:-mt-2 {\n      margin-top: -.5rem!important\n    }\n\n    .xl\\:-mt-3 {\n      margin-top: -1rem!important\n    }\n\n    .xl\\:-mt-4 {\n      margin-top: -1.5rem!important\n    }\n\n    .xl\\:-mt-5 {\n      margin-top: -2rem!important\n    }\n\n    .xl\\:-mt-6 {\n      margin-top: -3rem!important\n    }\n\n    .xl\\:-mt-7 {\n      margin-top: -4rem!important\n    }\n\n    .xl\\:-mt-8 {\n      margin-top: -5rem!important\n    }\n\n    .xl\\:mt-auto {\n      margin-top: auto!important\n    }\n\n    .xl\\:mr-0 {\n      margin-right: 0rem!important\n    }\n\n    .xl\\:mr-1 {\n      margin-right: .25rem!important\n    }\n\n    .xl\\:mr-2 {\n      margin-right: .5rem!important\n    }\n\n    .xl\\:mr-3 {\n      margin-right: 1rem!important\n    }\n\n    .xl\\:mr-4 {\n      margin-right: 1.5rem!important\n    }\n\n    .xl\\:mr-5 {\n      margin-right: 2rem!important\n    }\n\n    .xl\\:mr-6 {\n      margin-right: 3rem!important\n    }\n\n    .xl\\:mr-7 {\n      margin-right: 4rem!important\n    }\n\n    .xl\\:mr-8 {\n      margin-right: 5rem!important\n    }\n\n    .xl\\:-mr-1 {\n      margin-right: -.25rem!important\n    }\n\n    .xl\\:-mr-2 {\n      margin-right: -.5rem!important\n    }\n\n    .xl\\:-mr-3 {\n      margin-right: -1rem!important\n    }\n\n    .xl\\:-mr-4 {\n      margin-right: -1.5rem!important\n    }\n\n    .xl\\:-mr-5 {\n      margin-right: -2rem!important\n    }\n\n    .xl\\:-mr-6 {\n      margin-right: -3rem!important\n    }\n\n    .xl\\:-mr-7 {\n      margin-right: -4rem!important\n    }\n\n    .xl\\:-mr-8 {\n      margin-right: -5rem!important\n    }\n\n    .xl\\:mr-auto {\n      margin-right: auto!important\n    }\n\n    .xl\\:ml-0 {\n      margin-left: 0rem!important\n    }\n\n    .xl\\:ml-1 {\n      margin-left: .25rem!important\n    }\n\n    .xl\\:ml-2 {\n      margin-left: .5rem!important\n    }\n\n    .xl\\:ml-3 {\n      margin-left: 1rem!important\n    }\n\n    .xl\\:ml-4 {\n      margin-left: 1.5rem!important\n    }\n\n    .xl\\:ml-5 {\n      margin-left: 2rem!important\n    }\n\n    .xl\\:ml-6 {\n      margin-left: 3rem!important\n    }\n\n    .xl\\:ml-7 {\n      margin-left: 4rem!important\n    }\n\n    .xl\\:ml-8 {\n      margin-left: 5rem!important\n    }\n\n    .xl\\:-ml-1 {\n      margin-left: -.25rem!important\n    }\n\n    .xl\\:-ml-2 {\n      margin-left: -.5rem!important\n    }\n\n    .xl\\:-ml-3 {\n      margin-left: -1rem!important\n    }\n\n    .xl\\:-ml-4 {\n      margin-left: -1.5rem!important\n    }\n\n    .xl\\:-ml-5 {\n      margin-left: -2rem!important\n    }\n\n    .xl\\:-ml-6 {\n      margin-left: -3rem!important\n    }\n\n    .xl\\:-ml-7 {\n      margin-left: -4rem!important\n    }\n\n    .xl\\:-ml-8 {\n      margin-left: -5rem!important\n    }\n\n    .xl\\:ml-auto {\n      margin-left: auto!important\n    }\n\n    .xl\\:mb-0 {\n      margin-bottom: 0rem!important\n    }\n\n    .xl\\:mb-1 {\n      margin-bottom: .25rem!important\n    }\n\n    .xl\\:mb-2 {\n      margin-bottom: .5rem!important\n    }\n\n    .xl\\:mb-3 {\n      margin-bottom: 1rem!important\n    }\n\n    .xl\\:mb-4 {\n      margin-bottom: 1.5rem!important\n    }\n\n    .xl\\:mb-5 {\n      margin-bottom: 2rem!important\n    }\n\n    .xl\\:mb-6 {\n      margin-bottom: 3rem!important\n    }\n\n    .xl\\:mb-7 {\n      margin-bottom: 4rem!important\n    }\n\n    .xl\\:mb-8 {\n      margin-bottom: 5rem!important\n    }\n\n    .xl\\:-mb-1 {\n      margin-bottom: -.25rem!important\n    }\n\n    .xl\\:-mb-2 {\n      margin-bottom: -.5rem!important\n    }\n\n    .xl\\:-mb-3 {\n      margin-bottom: -1rem!important\n    }\n\n    .xl\\:-mb-4 {\n      margin-bottom: -1.5rem!important\n    }\n\n    .xl\\:-mb-5 {\n      margin-bottom: -2rem!important\n    }\n\n    .xl\\:-mb-6 {\n      margin-bottom: -3rem!important\n    }\n\n    .xl\\:-mb-7 {\n      margin-bottom: -4rem!important\n    }\n\n    .xl\\:-mb-8 {\n      margin-bottom: -5rem!important\n    }\n\n    .xl\\:mb-auto {\n      margin-bottom: auto!important\n    }\n\n    .xl\\:mx-0 {\n      margin-left: 0rem!important;\n      margin-right: 0rem!important\n    }\n\n    .xl\\:mx-1 {\n      margin-left: .25rem!important;\n      margin-right: .25rem!important\n    }\n\n    .xl\\:mx-2 {\n      margin-left: .5rem!important;\n      margin-right: .5rem!important\n    }\n\n    .xl\\:mx-3 {\n      margin-left: 1rem!important;\n      margin-right: 1rem!important\n    }\n\n    .xl\\:mx-4 {\n      margin-left: 1.5rem!important;\n      margin-right: 1.5rem!important\n    }\n\n    .xl\\:mx-5 {\n      margin-left: 2rem!important;\n      margin-right: 2rem!important\n    }\n\n    .xl\\:mx-6 {\n      margin-left: 3rem!important;\n      margin-right: 3rem!important\n    }\n\n    .xl\\:mx-7 {\n      margin-left: 4rem!important;\n      margin-right: 4rem!important\n    }\n\n    .xl\\:mx-8 {\n      margin-left: 5rem!important;\n      margin-right: 5rem!important\n    }\n\n    .xl\\:-mx-1 {\n      margin-left: -.25rem!important;\n      margin-right: -.25rem!important\n    }\n\n    .xl\\:-mx-2 {\n      margin-left: -.5rem!important;\n      margin-right: -.5rem!important\n    }\n\n    .xl\\:-mx-3 {\n      margin-left: -1rem!important;\n      margin-right: -1rem!important\n    }\n\n    .xl\\:-mx-4 {\n      margin-left: -1.5rem!important;\n      margin-right: -1.5rem!important\n    }\n\n    .xl\\:-mx-5 {\n      margin-left: -2rem!important;\n      margin-right: -2rem!important\n    }\n\n    .xl\\:-mx-6 {\n      margin-left: -3rem!important;\n      margin-right: -3rem!important\n    }\n\n    .xl\\:-mx-7 {\n      margin-left: -4rem!important;\n      margin-right: -4rem!important\n    }\n\n    .xl\\:-mx-8 {\n      margin-left: -5rem!important;\n      margin-right: -5rem!important\n    }\n\n    .xl\\:mx-auto {\n      margin-left: auto!important;\n      margin-right: auto!important\n    }\n\n    .xl\\:my-0 {\n      margin-top: 0rem!important;\n      margin-bottom: 0rem!important\n    }\n\n    .xl\\:my-1 {\n      margin-top: .25rem!important;\n      margin-bottom: .25rem!important\n    }\n\n    .xl\\:my-2 {\n      margin-top: .5rem!important;\n      margin-bottom: .5rem!important\n    }\n\n    .xl\\:my-3 {\n      margin-top: 1rem!important;\n      margin-bottom: 1rem!important\n    }\n\n    .xl\\:my-4 {\n      margin-top: 1.5rem!important;\n      margin-bottom: 1.5rem!important\n    }\n\n    .xl\\:my-5 {\n      margin-top: 2rem!important;\n      margin-bottom: 2rem!important\n    }\n\n    .xl\\:my-6 {\n      margin-top: 3rem!important;\n      margin-bottom: 3rem!important\n    }\n\n    .xl\\:my-7 {\n      margin-top: 4rem!important;\n      margin-bottom: 4rem!important\n    }\n\n    .xl\\:my-8 {\n      margin-top: 5rem!important;\n      margin-bottom: 5rem!important\n    }\n\n    .xl\\:-my-1 {\n      margin-top: -.25rem!important;\n      margin-bottom: -.25rem!important\n    }\n\n    .xl\\:-my-2 {\n      margin-top: -.5rem!important;\n      margin-bottom: -.5rem!important\n    }\n\n    .xl\\:-my-3 {\n      margin-top: -1rem!important;\n      margin-bottom: -1rem!important\n    }\n\n    .xl\\:-my-4 {\n      margin-top: -1.5rem!important;\n      margin-bottom: -1.5rem!important\n    }\n\n    .xl\\:-my-5 {\n      margin-top: -2rem!important;\n      margin-bottom: -2rem!important\n    }\n\n    .xl\\:-my-6 {\n      margin-top: -3rem!important;\n      margin-bottom: -3rem!important\n    }\n\n    .xl\\:-my-7 {\n      margin-top: -4rem!important;\n      margin-bottom: -4rem!important\n    }\n\n    .xl\\:-my-8 {\n      margin-top: -5rem!important;\n      margin-bottom: -5rem!important\n    }\n\n    .xl\\:my-auto {\n      margin-top: auto!important;\n      margin-bottom: auto!important\n    }\n  }\n\n  .shadow-none {\n    box-shadow: none!important\n  }\n\n  .shadow-1 {\n    box-shadow: 0 3px 5px #00000005,0 0 2px #0000000d,0 1px 4px #00000014!important\n  }\n\n  .shadow-2 {\n    box-shadow: 0 4px 10px #00000008,0 0 2px #0000000f,0 2px 6px #0000001f!important\n  }\n\n  .shadow-3 {\n    box-shadow: 0 1px 8px #00000014,0 3px 4px #0000001a,0 1px 4px -1px #0000001a!important\n  }\n\n  .shadow-4 {\n    box-shadow: 0 1px 10px #0000001f,0 4px 5px #00000024,0 2px 4px -1px #0003!important\n  }\n\n  .shadow-5 {\n    box-shadow: 0 1px 7px #0000001a,0 4px 5px -2px #0000001f,0 10px 15px -5px #0003!important\n  }\n\n  .shadow-6 {\n    box-shadow: 0 3px 5px #0000000f,0 7px 9px #0000001f,0 20px 25px -8px #0000002e!important\n  }\n\n  .shadow-7 {\n    box-shadow: 0 7px 30px #00000014,0 22px 30px 2px #00000026,0 8px 10px #00000026!important\n  }\n\n  .shadow-8 {\n    box-shadow: 0 9px 46px 8px #0000001f,0 24px 38px 3px #00000024,0 11px 15px #0003!important\n  }\n\n  .focus\\:shadow-none:focus {\n    box-shadow: none!important\n  }\n\n  .hover\\:shadow-none:hover,.active\\:shadow-none:active {\n    box-shadow: none!important\n  }\n\n  .focus\\:shadow-1:focus {\n    box-shadow: 0 3px 5px #00000005,0 0 2px #0000000d,0 1px 4px #00000014!important\n  }\n\n  .hover\\:shadow-1:hover,.active\\:shadow-1:active {\n    box-shadow: 0 3px 5px #00000005,0 0 2px #0000000d,0 1px 4px #00000014!important\n  }\n\n  .focus\\:shadow-2:focus {\n    box-shadow: 0 4px 10px #00000008,0 0 2px #0000000f,0 2px 6px #0000001f!important\n  }\n\n  .hover\\:shadow-2:hover,.active\\:shadow-2:active {\n    box-shadow: 0 4px 10px #00000008,0 0 2px #0000000f,0 2px 6px #0000001f!important\n  }\n\n  .focus\\:shadow-3:focus {\n    box-shadow: 0 1px 8px #00000014,0 3px 4px #0000001a,0 1px 4px -1px #0000001a!important\n  }\n\n  .hover\\:shadow-3:hover,.active\\:shadow-3:active {\n    box-shadow: 0 1px 8px #00000014,0 3px 4px #0000001a,0 1px 4px -1px #0000001a!important\n  }\n\n  .focus\\:shadow-4:focus {\n    box-shadow: 0 1px 10px #0000001f,0 4px 5px #00000024,0 2px 4px -1px #0003!important\n  }\n\n  .hover\\:shadow-4:hover,.active\\:shadow-4:active {\n    box-shadow: 0 1px 10px #0000001f,0 4px 5px #00000024,0 2px 4px -1px #0003!important\n  }\n\n  .focus\\:shadow-5:focus {\n    box-shadow: 0 1px 7px #0000001a,0 4px 5px -2px #0000001f,0 10px 15px -5px #0003!important\n  }\n\n  .hover\\:shadow-5:hover,.active\\:shadow-5:active {\n    box-shadow: 0 1px 7px #0000001a,0 4px 5px -2px #0000001f,0 10px 15px -5px #0003!important\n  }\n\n  .focus\\:shadow-6:focus {\n    box-shadow: 0 3px 5px #0000000f,0 7px 9px #0000001f,0 20px 25px -8px #0000002e!important\n  }\n\n  .hover\\:shadow-6:hover,.active\\:shadow-6:active {\n    box-shadow: 0 3px 5px #0000000f,0 7px 9px #0000001f,0 20px 25px -8px #0000002e!important\n  }\n\n  .focus\\:shadow-7:focus {\n    box-shadow: 0 7px 30px #00000014,0 22px 30px 2px #00000026,0 8px 10px #00000026!important\n  }\n\n  .hover\\:shadow-7:hover,.active\\:shadow-7:active {\n    box-shadow: 0 7px 30px #00000014,0 22px 30px 2px #00000026,0 8px 10px #00000026!important\n  }\n\n  .focus\\:shadow-8:focus {\n    box-shadow: 0 9px 46px 8px #0000001f,0 24px 38px 3px #00000024,0 11px 15px #0003!important\n  }\n\n  .hover\\:shadow-8:hover,.active\\:shadow-8:active {\n    box-shadow: 0 9px 46px 8px #0000001f,0 24px 38px 3px #00000024,0 11px 15px #0003!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:shadow-none {\n      box-shadow:none!important\n    }\n\n    .sm\\:shadow-1 {\n      box-shadow: 0 3px 5px #00000005,0 0 2px #0000000d,0 1px 4px #00000014!important\n    }\n\n    .sm\\:shadow-2 {\n      box-shadow: 0 4px 10px #00000008,0 0 2px #0000000f,0 2px 6px #0000001f!important\n    }\n\n    .sm\\:shadow-3 {\n      box-shadow: 0 1px 8px #00000014,0 3px 4px #0000001a,0 1px 4px -1px #0000001a!important\n    }\n\n    .sm\\:shadow-4 {\n      box-shadow: 0 1px 10px #0000001f,0 4px 5px #00000024,0 2px 4px -1px #0003!important\n    }\n\n    .sm\\:shadow-5 {\n      box-shadow: 0 1px 7px #0000001a,0 4px 5px -2px #0000001f,0 10px 15px -5px #0003!important\n    }\n\n    .sm\\:shadow-6 {\n      box-shadow: 0 3px 5px #0000000f,0 7px 9px #0000001f,0 20px 25px -8px #0000002e!important\n    }\n\n    .sm\\:shadow-7 {\n      box-shadow: 0 7px 30px #00000014,0 22px 30px 2px #00000026,0 8px 10px #00000026!important\n    }\n\n    .sm\\:shadow-8 {\n      box-shadow: 0 9px 46px 8px #0000001f,0 24px 38px 3px #00000024,0 11px 15px #0003!important\n    }\n\n    .sm\\:focus\\:shadow-none:focus {\n      box-shadow: none!important\n    }\n\n    .sm\\:hover\\:shadow-none:hover,.sm\\:active\\:shadow-none:active {\n      box-shadow: none!important\n    }\n\n    .sm\\:focus\\:shadow-1:focus {\n      box-shadow: 0 3px 5px #00000005,0 0 2px #0000000d,0 1px 4px #00000014!important\n    }\n\n    .sm\\:hover\\:shadow-1:hover,.sm\\:active\\:shadow-1:active {\n      box-shadow: 0 3px 5px #00000005,0 0 2px #0000000d,0 1px 4px #00000014!important\n    }\n\n    .sm\\:focus\\:shadow-2:focus {\n      box-shadow: 0 4px 10px #00000008,0 0 2px #0000000f,0 2px 6px #0000001f!important\n    }\n\n    .sm\\:hover\\:shadow-2:hover,.sm\\:active\\:shadow-2:active {\n      box-shadow: 0 4px 10px #00000008,0 0 2px #0000000f,0 2px 6px #0000001f!important\n    }\n\n    .sm\\:focus\\:shadow-3:focus {\n      box-shadow: 0 1px 8px #00000014,0 3px 4px #0000001a,0 1px 4px -1px #0000001a!important\n    }\n\n    .sm\\:hover\\:shadow-3:hover,.sm\\:active\\:shadow-3:active {\n      box-shadow: 0 1px 8px #00000014,0 3px 4px #0000001a,0 1px 4px -1px #0000001a!important\n    }\n\n    .sm\\:focus\\:shadow-4:focus {\n      box-shadow: 0 1px 10px #0000001f,0 4px 5px #00000024,0 2px 4px -1px #0003!important\n    }\n\n    .sm\\:hover\\:shadow-4:hover,.sm\\:active\\:shadow-4:active {\n      box-shadow: 0 1px 10px #0000001f,0 4px 5px #00000024,0 2px 4px -1px #0003!important\n    }\n\n    .sm\\:focus\\:shadow-5:focus {\n      box-shadow: 0 1px 7px #0000001a,0 4px 5px -2px #0000001f,0 10px 15px -5px #0003!important\n    }\n\n    .sm\\:hover\\:shadow-5:hover,.sm\\:active\\:shadow-5:active {\n      box-shadow: 0 1px 7px #0000001a,0 4px 5px -2px #0000001f,0 10px 15px -5px #0003!important\n    }\n\n    .sm\\:focus\\:shadow-6:focus {\n      box-shadow: 0 3px 5px #0000000f,0 7px 9px #0000001f,0 20px 25px -8px #0000002e!important\n    }\n\n    .sm\\:hover\\:shadow-6:hover,.sm\\:active\\:shadow-6:active {\n      box-shadow: 0 3px 5px #0000000f,0 7px 9px #0000001f,0 20px 25px -8px #0000002e!important\n    }\n\n    .sm\\:focus\\:shadow-7:focus {\n      box-shadow: 0 7px 30px #00000014,0 22px 30px 2px #00000026,0 8px 10px #00000026!important\n    }\n\n    .sm\\:hover\\:shadow-7:hover,.sm\\:active\\:shadow-7:active {\n      box-shadow: 0 7px 30px #00000014,0 22px 30px 2px #00000026,0 8px 10px #00000026!important\n    }\n\n    .sm\\:focus\\:shadow-8:focus {\n      box-shadow: 0 9px 46px 8px #0000001f,0 24px 38px 3px #00000024,0 11px 15px #0003!important\n    }\n\n    .sm\\:hover\\:shadow-8:hover,.sm\\:active\\:shadow-8:active {\n      box-shadow: 0 9px 46px 8px #0000001f,0 24px 38px 3px #00000024,0 11px 15px #0003!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:shadow-none {\n      box-shadow:none!important\n    }\n\n    .md\\:shadow-1 {\n      box-shadow: 0 3px 5px #00000005,0 0 2px #0000000d,0 1px 4px #00000014!important\n    }\n\n    .md\\:shadow-2 {\n      box-shadow: 0 4px 10px #00000008,0 0 2px #0000000f,0 2px 6px #0000001f!important\n    }\n\n    .md\\:shadow-3 {\n      box-shadow: 0 1px 8px #00000014,0 3px 4px #0000001a,0 1px 4px -1px #0000001a!important\n    }\n\n    .md\\:shadow-4 {\n      box-shadow: 0 1px 10px #0000001f,0 4px 5px #00000024,0 2px 4px -1px #0003!important\n    }\n\n    .md\\:shadow-5 {\n      box-shadow: 0 1px 7px #0000001a,0 4px 5px -2px #0000001f,0 10px 15px -5px #0003!important\n    }\n\n    .md\\:shadow-6 {\n      box-shadow: 0 3px 5px #0000000f,0 7px 9px #0000001f,0 20px 25px -8px #0000002e!important\n    }\n\n    .md\\:shadow-7 {\n      box-shadow: 0 7px 30px #00000014,0 22px 30px 2px #00000026,0 8px 10px #00000026!important\n    }\n\n    .md\\:shadow-8 {\n      box-shadow: 0 9px 46px 8px #0000001f,0 24px 38px 3px #00000024,0 11px 15px #0003!important\n    }\n\n    .md\\:focus\\:shadow-none:focus {\n      box-shadow: none!important\n    }\n\n    .md\\:hover\\:shadow-none:hover,.md\\:active\\:shadow-none:active {\n      box-shadow: none!important\n    }\n\n    .md\\:focus\\:shadow-1:focus {\n      box-shadow: 0 3px 5px #00000005,0 0 2px #0000000d,0 1px 4px #00000014!important\n    }\n\n    .md\\:hover\\:shadow-1:hover,.md\\:active\\:shadow-1:active {\n      box-shadow: 0 3px 5px #00000005,0 0 2px #0000000d,0 1px 4px #00000014!important\n    }\n\n    .md\\:focus\\:shadow-2:focus {\n      box-shadow: 0 4px 10px #00000008,0 0 2px #0000000f,0 2px 6px #0000001f!important\n    }\n\n    .md\\:hover\\:shadow-2:hover,.md\\:active\\:shadow-2:active {\n      box-shadow: 0 4px 10px #00000008,0 0 2px #0000000f,0 2px 6px #0000001f!important\n    }\n\n    .md\\:focus\\:shadow-3:focus {\n      box-shadow: 0 1px 8px #00000014,0 3px 4px #0000001a,0 1px 4px -1px #0000001a!important\n    }\n\n    .md\\:hover\\:shadow-3:hover,.md\\:active\\:shadow-3:active {\n      box-shadow: 0 1px 8px #00000014,0 3px 4px #0000001a,0 1px 4px -1px #0000001a!important\n    }\n\n    .md\\:focus\\:shadow-4:focus {\n      box-shadow: 0 1px 10px #0000001f,0 4px 5px #00000024,0 2px 4px -1px #0003!important\n    }\n\n    .md\\:hover\\:shadow-4:hover,.md\\:active\\:shadow-4:active {\n      box-shadow: 0 1px 10px #0000001f,0 4px 5px #00000024,0 2px 4px -1px #0003!important\n    }\n\n    .md\\:focus\\:shadow-5:focus {\n      box-shadow: 0 1px 7px #0000001a,0 4px 5px -2px #0000001f,0 10px 15px -5px #0003!important\n    }\n\n    .md\\:hover\\:shadow-5:hover,.md\\:active\\:shadow-5:active {\n      box-shadow: 0 1px 7px #0000001a,0 4px 5px -2px #0000001f,0 10px 15px -5px #0003!important\n    }\n\n    .md\\:focus\\:shadow-6:focus {\n      box-shadow: 0 3px 5px #0000000f,0 7px 9px #0000001f,0 20px 25px -8px #0000002e!important\n    }\n\n    .md\\:hover\\:shadow-6:hover,.md\\:active\\:shadow-6:active {\n      box-shadow: 0 3px 5px #0000000f,0 7px 9px #0000001f,0 20px 25px -8px #0000002e!important\n    }\n\n    .md\\:focus\\:shadow-7:focus {\n      box-shadow: 0 7px 30px #00000014,0 22px 30px 2px #00000026,0 8px 10px #00000026!important\n    }\n\n    .md\\:hover\\:shadow-7:hover,.md\\:active\\:shadow-7:active {\n      box-shadow: 0 7px 30px #00000014,0 22px 30px 2px #00000026,0 8px 10px #00000026!important\n    }\n\n    .md\\:focus\\:shadow-8:focus {\n      box-shadow: 0 9px 46px 8px #0000001f,0 24px 38px 3px #00000024,0 11px 15px #0003!important\n    }\n\n    .md\\:hover\\:shadow-8:hover,.md\\:active\\:shadow-8:active {\n      box-shadow: 0 9px 46px 8px #0000001f,0 24px 38px 3px #00000024,0 11px 15px #0003!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:shadow-none {\n      box-shadow:none!important\n    }\n\n    .lg\\:shadow-1 {\n      box-shadow: 0 3px 5px #00000005,0 0 2px #0000000d,0 1px 4px #00000014!important\n    }\n\n    .lg\\:shadow-2 {\n      box-shadow: 0 4px 10px #00000008,0 0 2px #0000000f,0 2px 6px #0000001f!important\n    }\n\n    .lg\\:shadow-3 {\n      box-shadow: 0 1px 8px #00000014,0 3px 4px #0000001a,0 1px 4px -1px #0000001a!important\n    }\n\n    .lg\\:shadow-4 {\n      box-shadow: 0 1px 10px #0000001f,0 4px 5px #00000024,0 2px 4px -1px #0003!important\n    }\n\n    .lg\\:shadow-5 {\n      box-shadow: 0 1px 7px #0000001a,0 4px 5px -2px #0000001f,0 10px 15px -5px #0003!important\n    }\n\n    .lg\\:shadow-6 {\n      box-shadow: 0 3px 5px #0000000f,0 7px 9px #0000001f,0 20px 25px -8px #0000002e!important\n    }\n\n    .lg\\:shadow-7 {\n      box-shadow: 0 7px 30px #00000014,0 22px 30px 2px #00000026,0 8px 10px #00000026!important\n    }\n\n    .lg\\:shadow-8 {\n      box-shadow: 0 9px 46px 8px #0000001f,0 24px 38px 3px #00000024,0 11px 15px #0003!important\n    }\n\n    .lg\\:focus\\:shadow-none:focus {\n      box-shadow: none!important\n    }\n\n    .lg\\:hover\\:shadow-none:hover,.lg\\:active\\:shadow-none:active {\n      box-shadow: none!important\n    }\n\n    .lg\\:focus\\:shadow-1:focus {\n      box-shadow: 0 3px 5px #00000005,0 0 2px #0000000d,0 1px 4px #00000014!important\n    }\n\n    .lg\\:hover\\:shadow-1:hover,.lg\\:active\\:shadow-1:active {\n      box-shadow: 0 3px 5px #00000005,0 0 2px #0000000d,0 1px 4px #00000014!important\n    }\n\n    .lg\\:focus\\:shadow-2:focus {\n      box-shadow: 0 4px 10px #00000008,0 0 2px #0000000f,0 2px 6px #0000001f!important\n    }\n\n    .lg\\:hover\\:shadow-2:hover,.lg\\:active\\:shadow-2:active {\n      box-shadow: 0 4px 10px #00000008,0 0 2px #0000000f,0 2px 6px #0000001f!important\n    }\n\n    .lg\\:focus\\:shadow-3:focus {\n      box-shadow: 0 1px 8px #00000014,0 3px 4px #0000001a,0 1px 4px -1px #0000001a!important\n    }\n\n    .lg\\:hover\\:shadow-3:hover,.lg\\:active\\:shadow-3:active {\n      box-shadow: 0 1px 8px #00000014,0 3px 4px #0000001a,0 1px 4px -1px #0000001a!important\n    }\n\n    .lg\\:focus\\:shadow-4:focus {\n      box-shadow: 0 1px 10px #0000001f,0 4px 5px #00000024,0 2px 4px -1px #0003!important\n    }\n\n    .lg\\:hover\\:shadow-4:hover,.lg\\:active\\:shadow-4:active {\n      box-shadow: 0 1px 10px #0000001f,0 4px 5px #00000024,0 2px 4px -1px #0003!important\n    }\n\n    .lg\\:focus\\:shadow-5:focus {\n      box-shadow: 0 1px 7px #0000001a,0 4px 5px -2px #0000001f,0 10px 15px -5px #0003!important\n    }\n\n    .lg\\:hover\\:shadow-5:hover,.lg\\:active\\:shadow-5:active {\n      box-shadow: 0 1px 7px #0000001a,0 4px 5px -2px #0000001f,0 10px 15px -5px #0003!important\n    }\n\n    .lg\\:focus\\:shadow-6:focus {\n      box-shadow: 0 3px 5px #0000000f,0 7px 9px #0000001f,0 20px 25px -8px #0000002e!important\n    }\n\n    .lg\\:hover\\:shadow-6:hover,.lg\\:active\\:shadow-6:active {\n      box-shadow: 0 3px 5px #0000000f,0 7px 9px #0000001f,0 20px 25px -8px #0000002e!important\n    }\n\n    .lg\\:focus\\:shadow-7:focus {\n      box-shadow: 0 7px 30px #00000014,0 22px 30px 2px #00000026,0 8px 10px #00000026!important\n    }\n\n    .lg\\:hover\\:shadow-7:hover,.lg\\:active\\:shadow-7:active {\n      box-shadow: 0 7px 30px #00000014,0 22px 30px 2px #00000026,0 8px 10px #00000026!important\n    }\n\n    .lg\\:focus\\:shadow-8:focus {\n      box-shadow: 0 9px 46px 8px #0000001f,0 24px 38px 3px #00000024,0 11px 15px #0003!important\n    }\n\n    .lg\\:hover\\:shadow-8:hover,.lg\\:active\\:shadow-8:active {\n      box-shadow: 0 9px 46px 8px #0000001f,0 24px 38px 3px #00000024,0 11px 15px #0003!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:shadow-none {\n      box-shadow:none!important\n    }\n\n    .xl\\:shadow-1 {\n      box-shadow: 0 3px 5px #00000005,0 0 2px #0000000d,0 1px 4px #00000014!important\n    }\n\n    .xl\\:shadow-2 {\n      box-shadow: 0 4px 10px #00000008,0 0 2px #0000000f,0 2px 6px #0000001f!important\n    }\n\n    .xl\\:shadow-3 {\n      box-shadow: 0 1px 8px #00000014,0 3px 4px #0000001a,0 1px 4px -1px #0000001a!important\n    }\n\n    .xl\\:shadow-4 {\n      box-shadow: 0 1px 10px #0000001f,0 4px 5px #00000024,0 2px 4px -1px #0003!important\n    }\n\n    .xl\\:shadow-5 {\n      box-shadow: 0 1px 7px #0000001a,0 4px 5px -2px #0000001f,0 10px 15px -5px #0003!important\n    }\n\n    .xl\\:shadow-6 {\n      box-shadow: 0 3px 5px #0000000f,0 7px 9px #0000001f,0 20px 25px -8px #0000002e!important\n    }\n\n    .xl\\:shadow-7 {\n      box-shadow: 0 7px 30px #00000014,0 22px 30px 2px #00000026,0 8px 10px #00000026!important\n    }\n\n    .xl\\:shadow-8 {\n      box-shadow: 0 9px 46px 8px #0000001f,0 24px 38px 3px #00000024,0 11px 15px #0003!important\n    }\n\n    .xl\\:focus\\:shadow-none:focus {\n      box-shadow: none!important\n    }\n\n    .xl\\:hover\\:shadow-none:hover,.xl\\:active\\:shadow-none:active {\n      box-shadow: none!important\n    }\n\n    .xl\\:focus\\:shadow-1:focus {\n      box-shadow: 0 3px 5px #00000005,0 0 2px #0000000d,0 1px 4px #00000014!important\n    }\n\n    .xl\\:hover\\:shadow-1:hover,.xl\\:active\\:shadow-1:active {\n      box-shadow: 0 3px 5px #00000005,0 0 2px #0000000d,0 1px 4px #00000014!important\n    }\n\n    .xl\\:focus\\:shadow-2:focus {\n      box-shadow: 0 4px 10px #00000008,0 0 2px #0000000f,0 2px 6px #0000001f!important\n    }\n\n    .xl\\:hover\\:shadow-2:hover,.xl\\:active\\:shadow-2:active {\n      box-shadow: 0 4px 10px #00000008,0 0 2px #0000000f,0 2px 6px #0000001f!important\n    }\n\n    .xl\\:focus\\:shadow-3:focus {\n      box-shadow: 0 1px 8px #00000014,0 3px 4px #0000001a,0 1px 4px -1px #0000001a!important\n    }\n\n    .xl\\:hover\\:shadow-3:hover,.xl\\:active\\:shadow-3:active {\n      box-shadow: 0 1px 8px #00000014,0 3px 4px #0000001a,0 1px 4px -1px #0000001a!important\n    }\n\n    .xl\\:focus\\:shadow-4:focus {\n      box-shadow: 0 1px 10px #0000001f,0 4px 5px #00000024,0 2px 4px -1px #0003!important\n    }\n\n    .xl\\:hover\\:shadow-4:hover,.xl\\:active\\:shadow-4:active {\n      box-shadow: 0 1px 10px #0000001f,0 4px 5px #00000024,0 2px 4px -1px #0003!important\n    }\n\n    .xl\\:focus\\:shadow-5:focus {\n      box-shadow: 0 1px 7px #0000001a,0 4px 5px -2px #0000001f,0 10px 15px -5px #0003!important\n    }\n\n    .xl\\:hover\\:shadow-5:hover,.xl\\:active\\:shadow-5:active {\n      box-shadow: 0 1px 7px #0000001a,0 4px 5px -2px #0000001f,0 10px 15px -5px #0003!important\n    }\n\n    .xl\\:focus\\:shadow-6:focus {\n      box-shadow: 0 3px 5px #0000000f,0 7px 9px #0000001f,0 20px 25px -8px #0000002e!important\n    }\n\n    .xl\\:hover\\:shadow-6:hover,.xl\\:active\\:shadow-6:active {\n      box-shadow: 0 3px 5px #0000000f,0 7px 9px #0000001f,0 20px 25px -8px #0000002e!important\n    }\n\n    .xl\\:focus\\:shadow-7:focus {\n      box-shadow: 0 7px 30px #00000014,0 22px 30px 2px #00000026,0 8px 10px #00000026!important\n    }\n\n    .xl\\:hover\\:shadow-7:hover,.xl\\:active\\:shadow-7:active {\n      box-shadow: 0 7px 30px #00000014,0 22px 30px 2px #00000026,0 8px 10px #00000026!important\n    }\n\n    .xl\\:focus\\:shadow-8:focus {\n      box-shadow: 0 9px 46px 8px #0000001f,0 24px 38px 3px #00000024,0 11px 15px #0003!important\n    }\n\n    .xl\\:hover\\:shadow-8:hover,.xl\\:active\\:shadow-8:active {\n      box-shadow: 0 9px 46px 8px #0000001f,0 24px 38px 3px #00000024,0 11px 15px #0003!important\n    }\n  }\n\n  .border-none {\n    border-width: 0 !important;\n    border-style: none\n  }\n\n  .border-1 {\n    border-width: 1px!important;\n    border-style: solid\n  }\n\n  .border-2 {\n    border-width: 2px!important;\n    border-style: solid\n  }\n\n  .border-3 {\n    border-width: 3px!important;\n    border-style: solid\n  }\n\n  .border-top-none {\n    border-top-width: 0 !important;\n    border-top-style: none\n  }\n\n  .border-top-1 {\n    border-top-width: 1px!important;\n    border-top-style: solid\n  }\n\n  .border-top-2 {\n    border-top-width: 2px!important;\n    border-top-style: solid\n  }\n\n  .border-top-3 {\n    border-top-width: 3px!important;\n    border-top-style: solid\n  }\n\n  .border-right-none {\n    border-right-width: 0 !important;\n    border-right-style: none\n  }\n\n  .border-right-1 {\n    border-right-width: 1px!important;\n    border-right-style: solid\n  }\n\n  .border-right-2 {\n    border-right-width: 2px!important;\n    border-right-style: solid\n  }\n\n  .border-right-3 {\n    border-right-width: 3px!important;\n    border-right-style: solid\n  }\n\n  .border-left-none {\n    border-left-width: 0 !important;\n    border-left-style: none\n  }\n\n  .border-left-1 {\n    border-left-width: 1px!important;\n    border-left-style: solid\n  }\n\n  .border-left-2 {\n    border-left-width: 2px!important;\n    border-left-style: solid\n  }\n\n  .border-left-3 {\n    border-left-width: 3px!important;\n    border-left-style: solid\n  }\n\n  .border-bottom-none {\n    border-bottom-width: 0 !important;\n    border-bottom-style: none\n  }\n\n  .border-bottom-1 {\n    border-bottom-width: 1px!important;\n    border-bottom-style: solid\n  }\n\n  .border-bottom-2 {\n    border-bottom-width: 2px!important;\n    border-bottom-style: solid\n  }\n\n  .border-bottom-3 {\n    border-bottom-width: 3px!important;\n    border-bottom-style: solid\n  }\n\n  .border-x-none {\n    border-left-width: 0 !important;\n    border-left-style: none;\n    border-right-width: 0 !important;\n    border-right-style: none\n  }\n\n  .border-x-1 {\n    border-left-width: 1px!important;\n    border-left-style: solid;\n    border-right-width: 1px!important;\n    border-right-style: solid\n  }\n\n  .border-x-2 {\n    border-left-width: 2px!important;\n    border-left-style: solid;\n    border-right-width: 2px!important;\n    border-right-style: solid\n  }\n\n  .border-x-3 {\n    border-left-width: 3px!important;\n    border-left-style: solid;\n    border-right-width: 3px!important;\n    border-right-style: solid\n  }\n\n  .border-y-none {\n    border-top-width: 0 !important;\n    border-top-style: none;\n    border-bottom-width: 0 !important;\n    border-bottom-style: none\n  }\n\n  .border-y-1 {\n    border-top-width: 1px!important;\n    border-top-style: solid;\n    border-bottom-width: 1px!important;\n    border-bottom-style: solid\n  }\n\n  .border-y-2 {\n    border-top-width: 2px!important;\n    border-top-style: solid;\n    border-bottom-width: 2px!important;\n    border-bottom-style: solid\n  }\n\n  .border-y-3 {\n    border-top-width: 3px!important;\n    border-top-style: solid;\n    border-bottom-width: 3px!important;\n    border-bottom-style: solid\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:border-none {\n      border-width:0 !important;\n      border-style: none\n    }\n\n    .sm\\:border-1 {\n      border-width: 1px!important;\n      border-style: solid\n    }\n\n    .sm\\:border-2 {\n      border-width: 2px!important;\n      border-style: solid\n    }\n\n    .sm\\:border-3 {\n      border-width: 3px!important;\n      border-style: solid\n    }\n\n    .sm\\:border-top-none {\n      border-top-width: 0 !important;\n      border-top-style: none\n    }\n\n    .sm\\:border-top-1 {\n      border-top-width: 1px!important;\n      border-top-style: solid\n    }\n\n    .sm\\:border-top-2 {\n      border-top-width: 2px!important;\n      border-top-style: solid\n    }\n\n    .sm\\:border-top-3 {\n      border-top-width: 3px!important;\n      border-top-style: solid\n    }\n\n    .sm\\:border-right-none {\n      border-right-width: 0 !important;\n      border-right-style: none\n    }\n\n    .sm\\:border-right-1 {\n      border-right-width: 1px!important;\n      border-right-style: solid\n    }\n\n    .sm\\:border-right-2 {\n      border-right-width: 2px!important;\n      border-right-style: solid\n    }\n\n    .sm\\:border-right-3 {\n      border-right-width: 3px!important;\n      border-right-style: solid\n    }\n\n    .sm\\:border-left-none {\n      border-left-width: 0 !important;\n      border-left-style: none\n    }\n\n    .sm\\:border-left-1 {\n      border-left-width: 1px!important;\n      border-left-style: solid\n    }\n\n    .sm\\:border-left-2 {\n      border-left-width: 2px!important;\n      border-left-style: solid\n    }\n\n    .sm\\:border-left-3 {\n      border-left-width: 3px!important;\n      border-left-style: solid\n    }\n\n    .sm\\:border-bottom-none {\n      border-bottom-width: 0 !important;\n      border-bottom-style: none\n    }\n\n    .sm\\:border-bottom-1 {\n      border-bottom-width: 1px!important;\n      border-bottom-style: solid\n    }\n\n    .sm\\:border-bottom-2 {\n      border-bottom-width: 2px!important;\n      border-bottom-style: solid\n    }\n\n    .sm\\:border-bottom-3 {\n      border-bottom-width: 3px!important;\n      border-bottom-style: solid\n    }\n\n    .sm\\:border-x-none {\n      border-left-width: 0 !important;\n      border-left-style: none;\n      border-right-width: 0 !important;\n      border-right-style: none\n    }\n\n    .sm\\:border-x-1 {\n      border-left-width: 1px!important;\n      border-left-style: solid;\n      border-right-width: 1px!important;\n      border-right-style: solid\n    }\n\n    .sm\\:border-x-2 {\n      border-left-width: 2px!important;\n      border-left-style: solid;\n      border-right-width: 2px!important;\n      border-right-style: solid\n    }\n\n    .sm\\:border-x-3 {\n      border-left-width: 3px!important;\n      border-left-style: solid;\n      border-right-width: 3px!important;\n      border-right-style: solid\n    }\n\n    .sm\\:border-y-none {\n      border-top-width: 0 !important;\n      border-top-style: none;\n      border-bottom-width: 0 !important;\n      border-bottom-style: none\n    }\n\n    .sm\\:border-y-1 {\n      border-top-width: 1px!important;\n      border-top-style: solid;\n      border-bottom-width: 1px!important;\n      border-bottom-style: solid\n    }\n\n    .sm\\:border-y-2 {\n      border-top-width: 2px!important;\n      border-top-style: solid;\n      border-bottom-width: 2px!important;\n      border-bottom-style: solid\n    }\n\n    .sm\\:border-y-3 {\n      border-top-width: 3px!important;\n      border-top-style: solid;\n      border-bottom-width: 3px!important;\n      border-bottom-style: solid\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:border-none {\n      border-width:0 !important;\n      border-style: none\n    }\n\n    .md\\:border-1 {\n      border-width: 1px!important;\n      border-style: solid\n    }\n\n    .md\\:border-2 {\n      border-width: 2px!important;\n      border-style: solid\n    }\n\n    .md\\:border-3 {\n      border-width: 3px!important;\n      border-style: solid\n    }\n\n    .md\\:border-top-none {\n      border-top-width: 0 !important;\n      border-top-style: none\n    }\n\n    .md\\:border-top-1 {\n      border-top-width: 1px!important;\n      border-top-style: solid\n    }\n\n    .md\\:border-top-2 {\n      border-top-width: 2px!important;\n      border-top-style: solid\n    }\n\n    .md\\:border-top-3 {\n      border-top-width: 3px!important;\n      border-top-style: solid\n    }\n\n    .md\\:border-right-none {\n      border-right-width: 0 !important;\n      border-right-style: none\n    }\n\n    .md\\:border-right-1 {\n      border-right-width: 1px!important;\n      border-right-style: solid\n    }\n\n    .md\\:border-right-2 {\n      border-right-width: 2px!important;\n      border-right-style: solid\n    }\n\n    .md\\:border-right-3 {\n      border-right-width: 3px!important;\n      border-right-style: solid\n    }\n\n    .md\\:border-left-none {\n      border-left-width: 0 !important;\n      border-left-style: none\n    }\n\n    .md\\:border-left-1 {\n      border-left-width: 1px!important;\n      border-left-style: solid\n    }\n\n    .md\\:border-left-2 {\n      border-left-width: 2px!important;\n      border-left-style: solid\n    }\n\n    .md\\:border-left-3 {\n      border-left-width: 3px!important;\n      border-left-style: solid\n    }\n\n    .md\\:border-bottom-none {\n      border-bottom-width: 0 !important;\n      border-bottom-style: none\n    }\n\n    .md\\:border-bottom-1 {\n      border-bottom-width: 1px!important;\n      border-bottom-style: solid\n    }\n\n    .md\\:border-bottom-2 {\n      border-bottom-width: 2px!important;\n      border-bottom-style: solid\n    }\n\n    .md\\:border-bottom-3 {\n      border-bottom-width: 3px!important;\n      border-bottom-style: solid\n    }\n\n    .md\\:border-x-none {\n      border-left-width: 0 !important;\n      border-left-style: none;\n      border-right-width: 0 !important;\n      border-right-style: none\n    }\n\n    .md\\:border-x-1 {\n      border-left-width: 1px!important;\n      border-left-style: solid;\n      border-right-width: 1px!important;\n      border-right-style: solid\n    }\n\n    .md\\:border-x-2 {\n      border-left-width: 2px!important;\n      border-left-style: solid;\n      border-right-width: 2px!important;\n      border-right-style: solid\n    }\n\n    .md\\:border-x-3 {\n      border-left-width: 3px!important;\n      border-left-style: solid;\n      border-right-width: 3px!important;\n      border-right-style: solid\n    }\n\n    .md\\:border-y-none {\n      border-top-width: 0 !important;\n      border-top-style: none;\n      border-bottom-width: 0 !important;\n      border-bottom-style: none\n    }\n\n    .md\\:border-y-1 {\n      border-top-width: 1px!important;\n      border-top-style: solid;\n      border-bottom-width: 1px!important;\n      border-bottom-style: solid\n    }\n\n    .md\\:border-y-2 {\n      border-top-width: 2px!important;\n      border-top-style: solid;\n      border-bottom-width: 2px!important;\n      border-bottom-style: solid\n    }\n\n    .md\\:border-y-3 {\n      border-top-width: 3px!important;\n      border-top-style: solid;\n      border-bottom-width: 3px!important;\n      border-bottom-style: solid\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:border-none {\n      border-width:0 !important;\n      border-style: none\n    }\n\n    .lg\\:border-1 {\n      border-width: 1px!important;\n      border-style: solid\n    }\n\n    .lg\\:border-2 {\n      border-width: 2px!important;\n      border-style: solid\n    }\n\n    .lg\\:border-3 {\n      border-width: 3px!important;\n      border-style: solid\n    }\n\n    .lg\\:border-top-none {\n      border-top-width: 0 !important;\n      border-top-style: none\n    }\n\n    .lg\\:border-top-1 {\n      border-top-width: 1px!important;\n      border-top-style: solid\n    }\n\n    .lg\\:border-top-2 {\n      border-top-width: 2px!important;\n      border-top-style: solid\n    }\n\n    .lg\\:border-top-3 {\n      border-top-width: 3px!important;\n      border-top-style: solid\n    }\n\n    .lg\\:border-right-none {\n      border-right-width: 0 !important;\n      border-right-style: none\n    }\n\n    .lg\\:border-right-1 {\n      border-right-width: 1px!important;\n      border-right-style: solid\n    }\n\n    .lg\\:border-right-2 {\n      border-right-width: 2px!important;\n      border-right-style: solid\n    }\n\n    .lg\\:border-right-3 {\n      border-right-width: 3px!important;\n      border-right-style: solid\n    }\n\n    .lg\\:border-left-none {\n      border-left-width: 0 !important;\n      border-left-style: none\n    }\n\n    .lg\\:border-left-1 {\n      border-left-width: 1px!important;\n      border-left-style: solid\n    }\n\n    .lg\\:border-left-2 {\n      border-left-width: 2px!important;\n      border-left-style: solid\n    }\n\n    .lg\\:border-left-3 {\n      border-left-width: 3px!important;\n      border-left-style: solid\n    }\n\n    .lg\\:border-bottom-none {\n      border-bottom-width: 0 !important;\n      border-bottom-style: none\n    }\n\n    .lg\\:border-bottom-1 {\n      border-bottom-width: 1px!important;\n      border-bottom-style: solid\n    }\n\n    .lg\\:border-bottom-2 {\n      border-bottom-width: 2px!important;\n      border-bottom-style: solid\n    }\n\n    .lg\\:border-bottom-3 {\n      border-bottom-width: 3px!important;\n      border-bottom-style: solid\n    }\n\n    .lg\\:border-x-none {\n      border-left-width: 0 !important;\n      border-left-style: none;\n      border-right-width: 0 !important;\n      border-right-style: none\n    }\n\n    .lg\\:border-x-1 {\n      border-left-width: 1px!important;\n      border-left-style: solid;\n      border-right-width: 1px!important;\n      border-right-style: solid\n    }\n\n    .lg\\:border-x-2 {\n      border-left-width: 2px!important;\n      border-left-style: solid;\n      border-right-width: 2px!important;\n      border-right-style: solid\n    }\n\n    .lg\\:border-x-3 {\n      border-left-width: 3px!important;\n      border-left-style: solid;\n      border-right-width: 3px!important;\n      border-right-style: solid\n    }\n\n    .lg\\:border-y-none {\n      border-top-width: 0 !important;\n      border-top-style: none;\n      border-bottom-width: 0 !important;\n      border-bottom-style: none\n    }\n\n    .lg\\:border-y-1 {\n      border-top-width: 1px!important;\n      border-top-style: solid;\n      border-bottom-width: 1px!important;\n      border-bottom-style: solid\n    }\n\n    .lg\\:border-y-2 {\n      border-top-width: 2px!important;\n      border-top-style: solid;\n      border-bottom-width: 2px!important;\n      border-bottom-style: solid\n    }\n\n    .lg\\:border-y-3 {\n      border-top-width: 3px!important;\n      border-top-style: solid;\n      border-bottom-width: 3px!important;\n      border-bottom-style: solid\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:border-none {\n      border-width:0 !important;\n      border-style: none\n    }\n\n    .xl\\:border-1 {\n      border-width: 1px!important;\n      border-style: solid\n    }\n\n    .xl\\:border-2 {\n      border-width: 2px!important;\n      border-style: solid\n    }\n\n    .xl\\:border-3 {\n      border-width: 3px!important;\n      border-style: solid\n    }\n\n    .xl\\:border-top-none {\n      border-top-width: 0 !important;\n      border-top-style: none\n    }\n\n    .xl\\:border-top-1 {\n      border-top-width: 1px!important;\n      border-top-style: solid\n    }\n\n    .xl\\:border-top-2 {\n      border-top-width: 2px!important;\n      border-top-style: solid\n    }\n\n    .xl\\:border-top-3 {\n      border-top-width: 3px!important;\n      border-top-style: solid\n    }\n\n    .xl\\:border-right-none {\n      border-right-width: 0 !important;\n      border-right-style: none\n    }\n\n    .xl\\:border-right-1 {\n      border-right-width: 1px!important;\n      border-right-style: solid\n    }\n\n    .xl\\:border-right-2 {\n      border-right-width: 2px!important;\n      border-right-style: solid\n    }\n\n    .xl\\:border-right-3 {\n      border-right-width: 3px!important;\n      border-right-style: solid\n    }\n\n    .xl\\:border-left-none {\n      border-left-width: 0 !important;\n      border-left-style: none\n    }\n\n    .xl\\:border-left-1 {\n      border-left-width: 1px!important;\n      border-left-style: solid\n    }\n\n    .xl\\:border-left-2 {\n      border-left-width: 2px!important;\n      border-left-style: solid\n    }\n\n    .xl\\:border-left-3 {\n      border-left-width: 3px!important;\n      border-left-style: solid\n    }\n\n    .xl\\:border-bottom-none {\n      border-bottom-width: 0 !important;\n      border-bottom-style: none\n    }\n\n    .xl\\:border-bottom-1 {\n      border-bottom-width: 1px!important;\n      border-bottom-style: solid\n    }\n\n    .xl\\:border-bottom-2 {\n      border-bottom-width: 2px!important;\n      border-bottom-style: solid\n    }\n\n    .xl\\:border-bottom-3 {\n      border-bottom-width: 3px!important;\n      border-bottom-style: solid\n    }\n\n    .xl\\:border-x-none {\n      border-left-width: 0 !important;\n      border-left-style: none;\n      border-right-width: 0 !important;\n      border-right-style: none\n    }\n\n    .xl\\:border-x-1 {\n      border-left-width: 1px!important;\n      border-left-style: solid;\n      border-right-width: 1px!important;\n      border-right-style: solid\n    }\n\n    .xl\\:border-x-2 {\n      border-left-width: 2px!important;\n      border-left-style: solid;\n      border-right-width: 2px!important;\n      border-right-style: solid\n    }\n\n    .xl\\:border-x-3 {\n      border-left-width: 3px!important;\n      border-left-style: solid;\n      border-right-width: 3px!important;\n      border-right-style: solid\n    }\n\n    .xl\\:border-y-none {\n      border-top-width: 0 !important;\n      border-top-style: none;\n      border-bottom-width: 0 !important;\n      border-bottom-style: none\n    }\n\n    .xl\\:border-y-1 {\n      border-top-width: 1px!important;\n      border-top-style: solid;\n      border-bottom-width: 1px!important;\n      border-bottom-style: solid\n    }\n\n    .xl\\:border-y-2 {\n      border-top-width: 2px!important;\n      border-top-style: solid;\n      border-bottom-width: 2px!important;\n      border-bottom-style: solid\n    }\n\n    .xl\\:border-y-3 {\n      border-top-width: 3px!important;\n      border-top-style: solid;\n      border-bottom-width: 3px!important;\n      border-bottom-style: solid\n    }\n  }\n\n  .border-solid {\n    border-style: solid!important\n  }\n\n  .border-dashed {\n    border-style: dashed!important\n  }\n\n  .border-dotted {\n    border-style: dotted!important\n  }\n\n  .border-double {\n    border-style: double!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:border-solid {\n      border-style:solid!important\n    }\n\n    .sm\\:border-dashed {\n      border-style: dashed!important\n    }\n\n    .sm\\:border-dotted {\n      border-style: dotted!important\n    }\n\n    .sm\\:border-double {\n      border-style: double!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:border-solid {\n      border-style:solid!important\n    }\n\n    .md\\:border-dashed {\n      border-style: dashed!important\n    }\n\n    .md\\:border-dotted {\n      border-style: dotted!important\n    }\n\n    .md\\:border-double {\n      border-style: double!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:border-solid {\n      border-style:solid!important\n    }\n\n    .lg\\:border-dashed {\n      border-style: dashed!important\n    }\n\n    .lg\\:border-dotted {\n      border-style: dotted!important\n    }\n\n    .lg\\:border-double {\n      border-style: double!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:border-solid {\n      border-style:solid!important\n    }\n\n    .xl\\:border-dashed {\n      border-style: dashed!important\n    }\n\n    .xl\\:border-dotted {\n      border-style: dotted!important\n    }\n\n    .xl\\:border-double {\n      border-style: double!important\n    }\n  }\n\n  .border-noround {\n    border-radius: 0!important\n  }\n\n  .border-round {\n    border-radius: var(--border-radius)!important\n  }\n\n  .border-round-xs {\n    border-radius: .125rem!important\n  }\n\n  .border-round-sm {\n    border-radius: .25rem!important\n  }\n\n  .border-round-md {\n    border-radius: .375rem!important\n  }\n\n  .border-round-lg {\n    border-radius: .5rem!important\n  }\n\n  .border-round-xl {\n    border-radius: .75rem!important\n  }\n\n  .border-round-2xl {\n    border-radius: 1rem!important\n  }\n\n  .border-round-3xl {\n    border-radius: 1.5rem!important\n  }\n\n  .border-circle {\n    border-radius: 50%!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:border-noround {\n      border-radius:0!important\n    }\n\n    .sm\\:border-round {\n      border-radius: var(--border-radius)!important\n    }\n\n    .sm\\:border-round-xs {\n      border-radius: .125rem!important\n    }\n\n    .sm\\:border-round-sm {\n      border-radius: .25rem!important\n    }\n\n    .sm\\:border-round-md {\n      border-radius: .375rem!important\n    }\n\n    .sm\\:border-round-lg {\n      border-radius: .5rem!important\n    }\n\n    .sm\\:border-round-xl {\n      border-radius: .75rem!important\n    }\n\n    .sm\\:border-round-2xl {\n      border-radius: 1rem!important\n    }\n\n    .sm\\:border-round-3xl {\n      border-radius: 1.5rem!important\n    }\n\n    .sm\\:border-circle {\n      border-radius: 50%!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:border-noround {\n      border-radius:0!important\n    }\n\n    .md\\:border-round {\n      border-radius: var(--border-radius)!important\n    }\n\n    .md\\:border-round-xs {\n      border-radius: .125rem!important\n    }\n\n    .md\\:border-round-sm {\n      border-radius: .25rem!important\n    }\n\n    .md\\:border-round-md {\n      border-radius: .375rem!important\n    }\n\n    .md\\:border-round-lg {\n      border-radius: .5rem!important\n    }\n\n    .md\\:border-round-xl {\n      border-radius: .75rem!important\n    }\n\n    .md\\:border-round-2xl {\n      border-radius: 1rem!important\n    }\n\n    .md\\:border-round-3xl {\n      border-radius: 1.5rem!important\n    }\n\n    .md\\:border-circle {\n      border-radius: 50%!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:border-noround {\n      border-radius:0!important\n    }\n\n    .lg\\:border-round {\n      border-radius: var(--border-radius)!important\n    }\n\n    .lg\\:border-round-xs {\n      border-radius: .125rem!important\n    }\n\n    .lg\\:border-round-sm {\n      border-radius: .25rem!important\n    }\n\n    .lg\\:border-round-md {\n      border-radius: .375rem!important\n    }\n\n    .lg\\:border-round-lg {\n      border-radius: .5rem!important\n    }\n\n    .lg\\:border-round-xl {\n      border-radius: .75rem!important\n    }\n\n    .lg\\:border-round-2xl {\n      border-radius: 1rem!important\n    }\n\n    .lg\\:border-round-3xl {\n      border-radius: 1.5rem!important\n    }\n\n    .lg\\:border-circle {\n      border-radius: 50%!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:border-noround {\n      border-radius:0!important\n    }\n\n    .xl\\:border-round {\n      border-radius: var(--border-radius)!important\n    }\n\n    .xl\\:border-round-xs {\n      border-radius: .125rem!important\n    }\n\n    .xl\\:border-round-sm {\n      border-radius: .25rem!important\n    }\n\n    .xl\\:border-round-md {\n      border-radius: .375rem!important\n    }\n\n    .xl\\:border-round-lg {\n      border-radius: .5rem!important\n    }\n\n    .xl\\:border-round-xl {\n      border-radius: .75rem!important\n    }\n\n    .xl\\:border-round-2xl {\n      border-radius: 1rem!important\n    }\n\n    .xl\\:border-round-3xl {\n      border-radius: 1.5rem!important\n    }\n\n    .xl\\:border-circle {\n      border-radius: 50%!important\n    }\n  }\n\n  .border-noround-left {\n    border-top-left-radius: 0!important;\n    border-bottom-left-radius: 0!important\n  }\n\n  .border-noround-top {\n    border-top-left-radius: 0!important;\n    border-top-right-radius: 0!important\n  }\n\n  .border-noround-right {\n    border-top-right-radius: 0!important;\n    border-bottom-right-radius: 0!important\n  }\n\n  .border-noround-bottom {\n    border-bottom-left-radius: 0!important;\n    border-bottom-right-radius: 0!important\n  }\n\n  .border-round-left {\n    border-top-left-radius: var(--border-radius)!important;\n    border-bottom-left-radius: var(--border-radius)!important\n  }\n\n  .border-round-top {\n    border-top-left-radius: var(--border-radius)!important;\n    border-top-right-radius: var(--border-radius)!important\n  }\n\n  .border-round-right {\n    border-top-right-radius: var(--border-radius)!important;\n    border-bottom-right-radius: var(--border-radius)!important\n  }\n\n  .border-round-bottom {\n    border-bottom-left-radius: var(--border-radius)!important;\n    border-bottom-right-radius: var(--border-radius)!important\n  }\n\n  .border-round-left-xs {\n    border-top-left-radius: .125rem!important;\n    border-bottom-left-radius: .125rem!important\n  }\n\n  .border-round-top-xs {\n    border-top-left-radius: .125rem!important;\n    border-top-right-radius: .125rem!important\n  }\n\n  .border-round-right-xs {\n    border-top-right-radius: .125rem!important;\n    border-bottom-right-radius: .125rem!important\n  }\n\n  .border-round-bottom-xs {\n    border-bottom-left-radius: .125rem!important;\n    border-bottom-right-radius: .125rem!important\n  }\n\n  .border-round-left-sm {\n    border-top-left-radius: .25rem!important;\n    border-bottom-left-radius: .25rem!important\n  }\n\n  .border-round-top-sm {\n    border-top-left-radius: .25rem!important;\n    border-top-right-radius: .25rem!important\n  }\n\n  .border-round-right-sm {\n    border-top-right-radius: .25rem!important;\n    border-bottom-right-radius: .25rem!important\n  }\n\n  .border-round-bottom-sm {\n    border-bottom-left-radius: .25rem!important;\n    border-bottom-right-radius: .25rem!important\n  }\n\n  .border-round-left-md {\n    border-top-left-radius: .375rem!important;\n    border-bottom-left-radius: .375rem!important\n  }\n\n  .border-round-top-md {\n    border-top-left-radius: .375rem!important;\n    border-top-right-radius: .375rem!important\n  }\n\n  .border-round-right-md {\n    border-top-right-radius: .375rem!important;\n    border-bottom-right-radius: .375rem!important\n  }\n\n  .border-round-bottom-md {\n    border-bottom-left-radius: .375rem!important;\n    border-bottom-right-radius: .375rem!important\n  }\n\n  .border-round-left-lg {\n    border-top-left-radius: .5rem!important;\n    border-bottom-left-radius: .5rem!important\n  }\n\n  .border-round-top-lg {\n    border-top-left-radius: .5rem!important;\n    border-top-right-radius: .5rem!important\n  }\n\n  .border-round-right-lg {\n    border-top-right-radius: .5rem!important;\n    border-bottom-right-radius: .5rem!important\n  }\n\n  .border-round-bottom-lg {\n    border-bottom-left-radius: .5rem!important;\n    border-bottom-right-radius: .5rem!important\n  }\n\n  .border-round-left-xl {\n    border-top-left-radius: .75rem!important;\n    border-bottom-left-radius: .75rem!important\n  }\n\n  .border-round-top-xl {\n    border-top-left-radius: .75rem!important;\n    border-top-right-radius: .75rem!important\n  }\n\n  .border-round-right-xl {\n    border-top-right-radius: .75rem!important;\n    border-bottom-right-radius: .75rem!important\n  }\n\n  .border-round-bottom-xl {\n    border-bottom-left-radius: .75rem!important;\n    border-bottom-right-radius: .75rem!important\n  }\n\n  .border-round-left-2xl {\n    border-top-left-radius: 1rem!important;\n    border-bottom-left-radius: 1rem!important\n  }\n\n  .border-round-top-2xl {\n    border-top-left-radius: 1rem!important;\n    border-top-right-radius: 1rem!important\n  }\n\n  .border-round-right-2xl {\n    border-top-right-radius: 1rem!important;\n    border-bottom-right-radius: 1rem!important\n  }\n\n  .border-round-bottom-2xl {\n    border-bottom-left-radius: 1rem!important;\n    border-bottom-right-radius: 1rem!important\n  }\n\n  .border-round-left-3xl {\n    border-top-left-radius: 1.5rem!important;\n    border-bottom-left-radius: 1.5rem!important\n  }\n\n  .border-round-top-3xl {\n    border-top-left-radius: 1.5rem!important;\n    border-top-right-radius: 1.5rem!important\n  }\n\n  .border-round-right-3xl {\n    border-top-right-radius: 1.5rem!important;\n    border-bottom-right-radius: 1.5rem!important\n  }\n\n  .border-round-bottom-3xl {\n    border-bottom-left-radius: 1.5rem!important;\n    border-bottom-right-radius: 1.5rem!important\n  }\n\n  .border-circle-left {\n    border-top-left-radius: 50%!important;\n    border-bottom-left-radius: 50%!important\n  }\n\n  .border-circle-top {\n    border-top-left-radius: 50%!important;\n    border-top-right-radius: 50%!important\n  }\n\n  .border-circle-right {\n    border-top-right-radius: 50%!important;\n    border-bottom-right-radius: 50%!important\n  }\n\n  .border-circle-bottom {\n    border-bottom-left-radius: 50%!important;\n    border-bottom-right-radius: 50%!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:border-noround-left {\n      border-top-left-radius:0!important;\n      border-bottom-left-radius: 0!important\n    }\n\n    .sm\\:border-noround-top {\n      border-top-left-radius: 0!important;\n      border-top-right-radius: 0!important\n    }\n\n    .sm\\:border-noround-right {\n      border-top-right-radius: 0!important;\n      border-bottom-right-radius: 0!important\n    }\n\n    .sm\\:border-noround-bottom {\n      border-bottom-left-radius: 0!important;\n      border-bottom-right-radius: 0!important\n    }\n\n    .sm\\:border-round-left {\n      border-top-left-radius: var(--border-radius)!important;\n      border-bottom-left-radius: var(--border-radius)!important\n    }\n\n    .sm\\:border-round-top {\n      border-top-left-radius: var(--border-radius)!important;\n      border-top-right-radius: var(--border-radius)!important\n    }\n\n    .sm\\:border-round-right {\n      border-top-right-radius: var(--border-radius)!important;\n      border-bottom-right-radius: var(--border-radius)!important\n    }\n\n    .sm\\:border-round-bottom {\n      border-bottom-left-radius: var(--border-radius)!important;\n      border-bottom-right-radius: var(--border-radius)!important\n    }\n\n    .sm\\:border-round-left-xs {\n      border-top-left-radius: .125rem!important;\n      border-bottom-left-radius: .125rem!important\n    }\n\n    .sm\\:border-round-top-xs {\n      border-top-left-radius: .125rem!important;\n      border-top-right-radius: .125rem!important\n    }\n\n    .sm\\:border-round-right-xs {\n      border-top-right-radius: .125rem!important;\n      border-bottom-right-radius: .125rem!important\n    }\n\n    .sm\\:border-round-bottom-xs {\n      border-bottom-left-radius: .125rem!important;\n      border-bottom-right-radius: .125rem!important\n    }\n\n    .sm\\:border-round-left-sm {\n      border-top-left-radius: .25rem!important;\n      border-bottom-left-radius: .25rem!important\n    }\n\n    .sm\\:border-round-top-sm {\n      border-top-left-radius: .25rem!important;\n      border-top-right-radius: .25rem!important\n    }\n\n    .sm\\:border-round-right-sm {\n      border-top-right-radius: .25rem!important;\n      border-bottom-right-radius: .25rem!important\n    }\n\n    .sm\\:border-round-bottom-sm {\n      border-bottom-left-radius: .25rem!important;\n      border-bottom-right-radius: .25rem!important\n    }\n\n    .sm\\:border-round-left-md {\n      border-top-left-radius: .375rem!important;\n      border-bottom-left-radius: .375rem!important\n    }\n\n    .sm\\:border-round-top-md {\n      border-top-left-radius: .375rem!important;\n      border-top-right-radius: .375rem!important\n    }\n\n    .sm\\:border-round-right-md {\n      border-top-right-radius: .375rem!important;\n      border-bottom-right-radius: .375rem!important\n    }\n\n    .sm\\:border-round-bottom-md {\n      border-bottom-left-radius: .375rem!important;\n      border-bottom-right-radius: .375rem!important\n    }\n\n    .sm\\:border-round-left-lg {\n      border-top-left-radius: .5rem!important;\n      border-bottom-left-radius: .5rem!important\n    }\n\n    .sm\\:border-round-top-lg {\n      border-top-left-radius: .5rem!important;\n      border-top-right-radius: .5rem!important\n    }\n\n    .sm\\:border-round-right-lg {\n      border-top-right-radius: .5rem!important;\n      border-bottom-right-radius: .5rem!important\n    }\n\n    .sm\\:border-round-bottom-lg {\n      border-bottom-left-radius: .5rem!important;\n      border-bottom-right-radius: .5rem!important\n    }\n\n    .sm\\:border-round-left-xl {\n      border-top-left-radius: .75rem!important;\n      border-bottom-left-radius: .75rem!important\n    }\n\n    .sm\\:border-round-top-xl {\n      border-top-left-radius: .75rem!important;\n      border-top-right-radius: .75rem!important\n    }\n\n    .sm\\:border-round-right-xl {\n      border-top-right-radius: .75rem!important;\n      border-bottom-right-radius: .75rem!important\n    }\n\n    .sm\\:border-round-bottom-xl {\n      border-bottom-left-radius: .75rem!important;\n      border-bottom-right-radius: .75rem!important\n    }\n\n    .sm\\:border-round-left-2xl {\n      border-top-left-radius: 1rem!important;\n      border-bottom-left-radius: 1rem!important\n    }\n\n    .sm\\:border-round-top-2xl {\n      border-top-left-radius: 1rem!important;\n      border-top-right-radius: 1rem!important\n    }\n\n    .sm\\:border-round-right-2xl {\n      border-top-right-radius: 1rem!important;\n      border-bottom-right-radius: 1rem!important\n    }\n\n    .sm\\:border-round-bottom-2xl {\n      border-bottom-left-radius: 1rem!important;\n      border-bottom-right-radius: 1rem!important\n    }\n\n    .sm\\:border-round-left-3xl {\n      border-top-left-radius: 1.5rem!important;\n      border-bottom-left-radius: 1.5rem!important\n    }\n\n    .sm\\:border-round-top-3xl {\n      border-top-left-radius: 1.5rem!important;\n      border-top-right-radius: 1.5rem!important\n    }\n\n    .sm\\:border-round-right-3xl {\n      border-top-right-radius: 1.5rem!important;\n      border-bottom-right-radius: 1.5rem!important\n    }\n\n    .sm\\:border-round-bottom-3xl {\n      border-bottom-left-radius: 1.5rem!important;\n      border-bottom-right-radius: 1.5rem!important\n    }\n\n    .sm\\:border-circle-left {\n      border-top-left-radius: 50%!important;\n      border-bottom-left-radius: 50%!important\n    }\n\n    .sm\\:border-circle-top {\n      border-top-left-radius: 50%!important;\n      border-top-right-radius: 50%!important\n    }\n\n    .sm\\:border-circle-right {\n      border-top-right-radius: 50%!important;\n      border-bottom-right-radius: 50%!important\n    }\n\n    .sm\\:border-circle-bottom {\n      border-bottom-left-radius: 50%!important;\n      border-bottom-right-radius: 50%!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:border-noround-left {\n      border-top-left-radius:0!important;\n      border-bottom-left-radius: 0!important\n    }\n\n    .md\\:border-noround-top {\n      border-top-left-radius: 0!important;\n      border-top-right-radius: 0!important\n    }\n\n    .md\\:border-noround-right {\n      border-top-right-radius: 0!important;\n      border-bottom-right-radius: 0!important\n    }\n\n    .md\\:border-noround-bottom {\n      border-bottom-left-radius: 0!important;\n      border-bottom-right-radius: 0!important\n    }\n\n    .md\\:border-round-left {\n      border-top-left-radius: var(--border-radius)!important;\n      border-bottom-left-radius: var(--border-radius)!important\n    }\n\n    .md\\:border-round-top {\n      border-top-left-radius: var(--border-radius)!important;\n      border-top-right-radius: var(--border-radius)!important\n    }\n\n    .md\\:border-round-right {\n      border-top-right-radius: var(--border-radius)!important;\n      border-bottom-right-radius: var(--border-radius)!important\n    }\n\n    .md\\:border-round-bottom {\n      border-bottom-left-radius: var(--border-radius)!important;\n      border-bottom-right-radius: var(--border-radius)!important\n    }\n\n    .md\\:border-round-left-xs {\n      border-top-left-radius: .125rem!important;\n      border-bottom-left-radius: .125rem!important\n    }\n\n    .md\\:border-round-top-xs {\n      border-top-left-radius: .125rem!important;\n      border-top-right-radius: .125rem!important\n    }\n\n    .md\\:border-round-right-xs {\n      border-top-right-radius: .125rem!important;\n      border-bottom-right-radius: .125rem!important\n    }\n\n    .md\\:border-round-bottom-xs {\n      border-bottom-left-radius: .125rem!important;\n      border-bottom-right-radius: .125rem!important\n    }\n\n    .md\\:border-round-left-sm {\n      border-top-left-radius: .25rem!important;\n      border-bottom-left-radius: .25rem!important\n    }\n\n    .md\\:border-round-top-sm {\n      border-top-left-radius: .25rem!important;\n      border-top-right-radius: .25rem!important\n    }\n\n    .md\\:border-round-right-sm {\n      border-top-right-radius: .25rem!important;\n      border-bottom-right-radius: .25rem!important\n    }\n\n    .md\\:border-round-bottom-sm {\n      border-bottom-left-radius: .25rem!important;\n      border-bottom-right-radius: .25rem!important\n    }\n\n    .md\\:border-round-left-md {\n      border-top-left-radius: .375rem!important;\n      border-bottom-left-radius: .375rem!important\n    }\n\n    .md\\:border-round-top-md {\n      border-top-left-radius: .375rem!important;\n      border-top-right-radius: .375rem!important\n    }\n\n    .md\\:border-round-right-md {\n      border-top-right-radius: .375rem!important;\n      border-bottom-right-radius: .375rem!important\n    }\n\n    .md\\:border-round-bottom-md {\n      border-bottom-left-radius: .375rem!important;\n      border-bottom-right-radius: .375rem!important\n    }\n\n    .md\\:border-round-left-lg {\n      border-top-left-radius: .5rem!important;\n      border-bottom-left-radius: .5rem!important\n    }\n\n    .md\\:border-round-top-lg {\n      border-top-left-radius: .5rem!important;\n      border-top-right-radius: .5rem!important\n    }\n\n    .md\\:border-round-right-lg {\n      border-top-right-radius: .5rem!important;\n      border-bottom-right-radius: .5rem!important\n    }\n\n    .md\\:border-round-bottom-lg {\n      border-bottom-left-radius: .5rem!important;\n      border-bottom-right-radius: .5rem!important\n    }\n\n    .md\\:border-round-left-xl {\n      border-top-left-radius: .75rem!important;\n      border-bottom-left-radius: .75rem!important\n    }\n\n    .md\\:border-round-top-xl {\n      border-top-left-radius: .75rem!important;\n      border-top-right-radius: .75rem!important\n    }\n\n    .md\\:border-round-right-xl {\n      border-top-right-radius: .75rem!important;\n      border-bottom-right-radius: .75rem!important\n    }\n\n    .md\\:border-round-bottom-xl {\n      border-bottom-left-radius: .75rem!important;\n      border-bottom-right-radius: .75rem!important\n    }\n\n    .md\\:border-round-left-2xl {\n      border-top-left-radius: 1rem!important;\n      border-bottom-left-radius: 1rem!important\n    }\n\n    .md\\:border-round-top-2xl {\n      border-top-left-radius: 1rem!important;\n      border-top-right-radius: 1rem!important\n    }\n\n    .md\\:border-round-right-2xl {\n      border-top-right-radius: 1rem!important;\n      border-bottom-right-radius: 1rem!important\n    }\n\n    .md\\:border-round-bottom-2xl {\n      border-bottom-left-radius: 1rem!important;\n      border-bottom-right-radius: 1rem!important\n    }\n\n    .md\\:border-round-left-3xl {\n      border-top-left-radius: 1.5rem!important;\n      border-bottom-left-radius: 1.5rem!important\n    }\n\n    .md\\:border-round-top-3xl {\n      border-top-left-radius: 1.5rem!important;\n      border-top-right-radius: 1.5rem!important\n    }\n\n    .md\\:border-round-right-3xl {\n      border-top-right-radius: 1.5rem!important;\n      border-bottom-right-radius: 1.5rem!important\n    }\n\n    .md\\:border-round-bottom-3xl {\n      border-bottom-left-radius: 1.5rem!important;\n      border-bottom-right-radius: 1.5rem!important\n    }\n\n    .md\\:border-circle-left {\n      border-top-left-radius: 50%!important;\n      border-bottom-left-radius: 50%!important\n    }\n\n    .md\\:border-circle-top {\n      border-top-left-radius: 50%!important;\n      border-top-right-radius: 50%!important\n    }\n\n    .md\\:border-circle-right {\n      border-top-right-radius: 50%!important;\n      border-bottom-right-radius: 50%!important\n    }\n\n    .md\\:border-circle-bottom {\n      border-bottom-left-radius: 50%!important;\n      border-bottom-right-radius: 50%!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:border-noround-left {\n      border-top-left-radius:0!important;\n      border-bottom-left-radius: 0!important\n    }\n\n    .lg\\:border-noround-top {\n      border-top-left-radius: 0!important;\n      border-top-right-radius: 0!important\n    }\n\n    .lg\\:border-noround-right {\n      border-top-right-radius: 0!important;\n      border-bottom-right-radius: 0!important\n    }\n\n    .lg\\:border-noround-bottom {\n      border-bottom-left-radius: 0!important;\n      border-bottom-right-radius: 0!important\n    }\n\n    .lg\\:border-round-left {\n      border-top-left-radius: var(--border-radius)!important;\n      border-bottom-left-radius: var(--border-radius)!important\n    }\n\n    .lg\\:border-round-top {\n      border-top-left-radius: var(--border-radius)!important;\n      border-top-right-radius: var(--border-radius)!important\n    }\n\n    .lg\\:border-round-right {\n      border-top-right-radius: var(--border-radius)!important;\n      border-bottom-right-radius: var(--border-radius)!important\n    }\n\n    .lg\\:border-round-bottom {\n      border-bottom-left-radius: var(--border-radius)!important;\n      border-bottom-right-radius: var(--border-radius)!important\n    }\n\n    .lg\\:border-round-left-xs {\n      border-top-left-radius: .125rem!important;\n      border-bottom-left-radius: .125rem!important\n    }\n\n    .lg\\:border-round-top-xs {\n      border-top-left-radius: .125rem!important;\n      border-top-right-radius: .125rem!important\n    }\n\n    .lg\\:border-round-right-xs {\n      border-top-right-radius: .125rem!important;\n      border-bottom-right-radius: .125rem!important\n    }\n\n    .lg\\:border-round-bottom-xs {\n      border-bottom-left-radius: .125rem!important;\n      border-bottom-right-radius: .125rem!important\n    }\n\n    .lg\\:border-round-left-sm {\n      border-top-left-radius: .25rem!important;\n      border-bottom-left-radius: .25rem!important\n    }\n\n    .lg\\:border-round-top-sm {\n      border-top-left-radius: .25rem!important;\n      border-top-right-radius: .25rem!important\n    }\n\n    .lg\\:border-round-right-sm {\n      border-top-right-radius: .25rem!important;\n      border-bottom-right-radius: .25rem!important\n    }\n\n    .lg\\:border-round-bottom-sm {\n      border-bottom-left-radius: .25rem!important;\n      border-bottom-right-radius: .25rem!important\n    }\n\n    .lg\\:border-round-left-md {\n      border-top-left-radius: .375rem!important;\n      border-bottom-left-radius: .375rem!important\n    }\n\n    .lg\\:border-round-top-md {\n      border-top-left-radius: .375rem!important;\n      border-top-right-radius: .375rem!important\n    }\n\n    .lg\\:border-round-right-md {\n      border-top-right-radius: .375rem!important;\n      border-bottom-right-radius: .375rem!important\n    }\n\n    .lg\\:border-round-bottom-md {\n      border-bottom-left-radius: .375rem!important;\n      border-bottom-right-radius: .375rem!important\n    }\n\n    .lg\\:border-round-left-lg {\n      border-top-left-radius: .5rem!important;\n      border-bottom-left-radius: .5rem!important\n    }\n\n    .lg\\:border-round-top-lg {\n      border-top-left-radius: .5rem!important;\n      border-top-right-radius: .5rem!important\n    }\n\n    .lg\\:border-round-right-lg {\n      border-top-right-radius: .5rem!important;\n      border-bottom-right-radius: .5rem!important\n    }\n\n    .lg\\:border-round-bottom-lg {\n      border-bottom-left-radius: .5rem!important;\n      border-bottom-right-radius: .5rem!important\n    }\n\n    .lg\\:border-round-left-xl {\n      border-top-left-radius: .75rem!important;\n      border-bottom-left-radius: .75rem!important\n    }\n\n    .lg\\:border-round-top-xl {\n      border-top-left-radius: .75rem!important;\n      border-top-right-radius: .75rem!important\n    }\n\n    .lg\\:border-round-right-xl {\n      border-top-right-radius: .75rem!important;\n      border-bottom-right-radius: .75rem!important\n    }\n\n    .lg\\:border-round-bottom-xl {\n      border-bottom-left-radius: .75rem!important;\n      border-bottom-right-radius: .75rem!important\n    }\n\n    .lg\\:border-round-left-2xl {\n      border-top-left-radius: 1rem!important;\n      border-bottom-left-radius: 1rem!important\n    }\n\n    .lg\\:border-round-top-2xl {\n      border-top-left-radius: 1rem!important;\n      border-top-right-radius: 1rem!important\n    }\n\n    .lg\\:border-round-right-2xl {\n      border-top-right-radius: 1rem!important;\n      border-bottom-right-radius: 1rem!important\n    }\n\n    .lg\\:border-round-bottom-2xl {\n      border-bottom-left-radius: 1rem!important;\n      border-bottom-right-radius: 1rem!important\n    }\n\n    .lg\\:border-round-left-3xl {\n      border-top-left-radius: 1.5rem!important;\n      border-bottom-left-radius: 1.5rem!important\n    }\n\n    .lg\\:border-round-top-3xl {\n      border-top-left-radius: 1.5rem!important;\n      border-top-right-radius: 1.5rem!important\n    }\n\n    .lg\\:border-round-right-3xl {\n      border-top-right-radius: 1.5rem!important;\n      border-bottom-right-radius: 1.5rem!important\n    }\n\n    .lg\\:border-round-bottom-3xl {\n      border-bottom-left-radius: 1.5rem!important;\n      border-bottom-right-radius: 1.5rem!important\n    }\n\n    .lg\\:border-circle-left {\n      border-top-left-radius: 50%!important;\n      border-bottom-left-radius: 50%!important\n    }\n\n    .lg\\:border-circle-top {\n      border-top-left-radius: 50%!important;\n      border-top-right-radius: 50%!important\n    }\n\n    .lg\\:border-circle-right {\n      border-top-right-radius: 50%!important;\n      border-bottom-right-radius: 50%!important\n    }\n\n    .lg\\:border-circle-bottom {\n      border-bottom-left-radius: 50%!important;\n      border-bottom-right-radius: 50%!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:border-noround-left {\n      border-top-left-radius:0!important;\n      border-bottom-left-radius: 0!important\n    }\n\n    .xl\\:border-noround-top {\n      border-top-left-radius: 0!important;\n      border-top-right-radius: 0!important\n    }\n\n    .xl\\:border-noround-right {\n      border-top-right-radius: 0!important;\n      border-bottom-right-radius: 0!important\n    }\n\n    .xl\\:border-noround-bottom {\n      border-bottom-left-radius: 0!important;\n      border-bottom-right-radius: 0!important\n    }\n\n    .xl\\:border-round-left {\n      border-top-left-radius: var(--border-radius)!important;\n      border-bottom-left-radius: var(--border-radius)!important\n    }\n\n    .xl\\:border-round-top {\n      border-top-left-radius: var(--border-radius)!important;\n      border-top-right-radius: var(--border-radius)!important\n    }\n\n    .xl\\:border-round-right {\n      border-top-right-radius: var(--border-radius)!important;\n      border-bottom-right-radius: var(--border-radius)!important\n    }\n\n    .xl\\:border-round-bottom {\n      border-bottom-left-radius: var(--border-radius)!important;\n      border-bottom-right-radius: var(--border-radius)!important\n    }\n\n    .xl\\:border-round-left-xs {\n      border-top-left-radius: .125rem!important;\n      border-bottom-left-radius: .125rem!important\n    }\n\n    .xl\\:border-round-top-xs {\n      border-top-left-radius: .125rem!important;\n      border-top-right-radius: .125rem!important\n    }\n\n    .xl\\:border-round-right-xs {\n      border-top-right-radius: .125rem!important;\n      border-bottom-right-radius: .125rem!important\n    }\n\n    .xl\\:border-round-bottom-xs {\n      border-bottom-left-radius: .125rem!important;\n      border-bottom-right-radius: .125rem!important\n    }\n\n    .xl\\:border-round-left-sm {\n      border-top-left-radius: .25rem!important;\n      border-bottom-left-radius: .25rem!important\n    }\n\n    .xl\\:border-round-top-sm {\n      border-top-left-radius: .25rem!important;\n      border-top-right-radius: .25rem!important\n    }\n\n    .xl\\:border-round-right-sm {\n      border-top-right-radius: .25rem!important;\n      border-bottom-right-radius: .25rem!important\n    }\n\n    .xl\\:border-round-bottom-sm {\n      border-bottom-left-radius: .25rem!important;\n      border-bottom-right-radius: .25rem!important\n    }\n\n    .xl\\:border-round-left-md {\n      border-top-left-radius: .375rem!important;\n      border-bottom-left-radius: .375rem!important\n    }\n\n    .xl\\:border-round-top-md {\n      border-top-left-radius: .375rem!important;\n      border-top-right-radius: .375rem!important\n    }\n\n    .xl\\:border-round-right-md {\n      border-top-right-radius: .375rem!important;\n      border-bottom-right-radius: .375rem!important\n    }\n\n    .xl\\:border-round-bottom-md {\n      border-bottom-left-radius: .375rem!important;\n      border-bottom-right-radius: .375rem!important\n    }\n\n    .xl\\:border-round-left-lg {\n      border-top-left-radius: .5rem!important;\n      border-bottom-left-radius: .5rem!important\n    }\n\n    .xl\\:border-round-top-lg {\n      border-top-left-radius: .5rem!important;\n      border-top-right-radius: .5rem!important\n    }\n\n    .xl\\:border-round-right-lg {\n      border-top-right-radius: .5rem!important;\n      border-bottom-right-radius: .5rem!important\n    }\n\n    .xl\\:border-round-bottom-lg {\n      border-bottom-left-radius: .5rem!important;\n      border-bottom-right-radius: .5rem!important\n    }\n\n    .xl\\:border-round-left-xl {\n      border-top-left-radius: .75rem!important;\n      border-bottom-left-radius: .75rem!important\n    }\n\n    .xl\\:border-round-top-xl {\n      border-top-left-radius: .75rem!important;\n      border-top-right-radius: .75rem!important\n    }\n\n    .xl\\:border-round-right-xl {\n      border-top-right-radius: .75rem!important;\n      border-bottom-right-radius: .75rem!important\n    }\n\n    .xl\\:border-round-bottom-xl {\n      border-bottom-left-radius: .75rem!important;\n      border-bottom-right-radius: .75rem!important\n    }\n\n    .xl\\:border-round-left-2xl {\n      border-top-left-radius: 1rem!important;\n      border-bottom-left-radius: 1rem!important\n    }\n\n    .xl\\:border-round-top-2xl {\n      border-top-left-radius: 1rem!important;\n      border-top-right-radius: 1rem!important\n    }\n\n    .xl\\:border-round-right-2xl {\n      border-top-right-radius: 1rem!important;\n      border-bottom-right-radius: 1rem!important\n    }\n\n    .xl\\:border-round-bottom-2xl {\n      border-bottom-left-radius: 1rem!important;\n      border-bottom-right-radius: 1rem!important\n    }\n\n    .xl\\:border-round-left-3xl {\n      border-top-left-radius: 1.5rem!important;\n      border-bottom-left-radius: 1.5rem!important\n    }\n\n    .xl\\:border-round-top-3xl {\n      border-top-left-radius: 1.5rem!important;\n      border-top-right-radius: 1.5rem!important\n    }\n\n    .xl\\:border-round-right-3xl {\n      border-top-right-radius: 1.5rem!important;\n      border-bottom-right-radius: 1.5rem!important\n    }\n\n    .xl\\:border-round-bottom-3xl {\n      border-bottom-left-radius: 1.5rem!important;\n      border-bottom-right-radius: 1.5rem!important\n    }\n\n    .xl\\:border-circle-left {\n      border-top-left-radius: 50%!important;\n      border-bottom-left-radius: 50%!important\n    }\n\n    .xl\\:border-circle-top {\n      border-top-left-radius: 50%!important;\n      border-top-right-radius: 50%!important\n    }\n\n    .xl\\:border-circle-right {\n      border-top-right-radius: 50%!important;\n      border-bottom-right-radius: 50%!important\n    }\n\n    .xl\\:border-circle-bottom {\n      border-bottom-left-radius: 50%!important;\n      border-bottom-right-radius: 50%!important\n    }\n  }\n\n  .w-full {\n    width: 100%!important\n  }\n\n  .w-screen {\n    width: 100vw!important\n  }\n\n  .w-auto {\n    width: auto!important\n  }\n\n  .w-1 {\n    width: 8.3333%!important\n  }\n\n  .w-2 {\n    width: 16.6667%!important\n  }\n\n  .w-3 {\n    width: 25%!important\n  }\n\n  .w-4 {\n    width: 33.3333%!important\n  }\n\n  .w-5 {\n    width: 41.6667%!important\n  }\n\n  .w-6 {\n    width: 50%!important\n  }\n\n  .w-7 {\n    width: 58.3333%!important\n  }\n\n  .w-8 {\n    width: 66.6667%!important\n  }\n\n  .w-9 {\n    width: 75%!important\n  }\n\n  .w-10 {\n    width: 83.3333%!important\n  }\n\n  .w-11 {\n    width: 91.6667%!important\n  }\n\n  .w-12 {\n    width: 100%!important\n  }\n\n  .w-min {\n    width: min-content!important\n  }\n\n  .w-max {\n    width: max-content!important\n  }\n\n  .w-fit {\n    width: -moz-fit-content!important;\n    width: fit-content!important\n  }\n\n  .w-1rem {\n    width: 1rem!important\n  }\n\n  .w-2rem {\n    width: 2rem!important\n  }\n\n  .w-3rem {\n    width: 3rem!important\n  }\n\n  .w-4rem {\n    width: 4rem!important\n  }\n\n  .w-5rem {\n    width: 5rem!important\n  }\n\n  .w-6rem {\n    width: 6rem!important\n  }\n\n  .w-7rem {\n    width: 7rem!important\n  }\n\n  .w-8rem {\n    width: 8rem!important\n  }\n\n  .w-9rem {\n    width: 9rem!important\n  }\n\n  .w-10rem {\n    width: 10rem!important\n  }\n\n  .w-11rem {\n    width: 11rem!important\n  }\n\n  .w-12rem {\n    width: 12rem!important\n  }\n\n  .w-13rem {\n    width: 13rem!important\n  }\n\n  .w-14rem {\n    width: 14rem!important\n  }\n\n  .w-15rem {\n    width: 15rem!important\n  }\n\n  .w-16rem {\n    width: 16rem!important\n  }\n\n  .w-17rem {\n    width: 17rem!important\n  }\n\n  .w-18rem {\n    width: 18rem!important\n  }\n\n  .w-19rem {\n    width: 19rem!important\n  }\n\n  .w-20rem {\n    width: 20rem!important\n  }\n\n  .w-21rem {\n    width: 21rem!important\n  }\n\n  .w-22rem {\n    width: 22rem!important\n  }\n\n  .w-23rem {\n    width: 23rem!important\n  }\n\n  .w-24rem {\n    width: 24rem!important\n  }\n\n  .w-25rem {\n    width: 25rem!important\n  }\n\n  .w-26rem {\n    width: 26rem!important\n  }\n\n  .w-27rem {\n    width: 27rem!important\n  }\n\n  .w-28rem {\n    width: 28rem!important\n  }\n\n  .w-29rem {\n    width: 29rem!important\n  }\n\n  .w-30rem {\n    width: 30rem!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:w-full {\n      width:100%!important\n    }\n\n    .sm\\:w-screen {\n      width: 100vw!important\n    }\n\n    .sm\\:w-auto {\n      width: auto!important\n    }\n\n    .sm\\:w-1 {\n      width: 8.3333%!important\n    }\n\n    .sm\\:w-2 {\n      width: 16.6667%!important\n    }\n\n    .sm\\:w-3 {\n      width: 25%!important\n    }\n\n    .sm\\:w-4 {\n      width: 33.3333%!important\n    }\n\n    .sm\\:w-5 {\n      width: 41.6667%!important\n    }\n\n    .sm\\:w-6 {\n      width: 50%!important\n    }\n\n    .sm\\:w-7 {\n      width: 58.3333%!important\n    }\n\n    .sm\\:w-8 {\n      width: 66.6667%!important\n    }\n\n    .sm\\:w-9 {\n      width: 75%!important\n    }\n\n    .sm\\:w-10 {\n      width: 83.3333%!important\n    }\n\n    .sm\\:w-11 {\n      width: 91.6667%!important\n    }\n\n    .sm\\:w-12 {\n      width: 100%!important\n    }\n\n    .sm\\:w-min {\n      width: min-content!important\n    }\n\n    .sm\\:w-max {\n      width: max-content!important\n    }\n\n    .sm\\:w-fit {\n      width: -moz-fit-content!important;\n      width: fit-content!important\n    }\n\n    .sm\\:w-1rem {\n      width: 1rem!important\n    }\n\n    .sm\\:w-2rem {\n      width: 2rem!important\n    }\n\n    .sm\\:w-3rem {\n      width: 3rem!important\n    }\n\n    .sm\\:w-4rem {\n      width: 4rem!important\n    }\n\n    .sm\\:w-5rem {\n      width: 5rem!important\n    }\n\n    .sm\\:w-6rem {\n      width: 6rem!important\n    }\n\n    .sm\\:w-7rem {\n      width: 7rem!important\n    }\n\n    .sm\\:w-8rem {\n      width: 8rem!important\n    }\n\n    .sm\\:w-9rem {\n      width: 9rem!important\n    }\n\n    .sm\\:w-10rem {\n      width: 10rem!important\n    }\n\n    .sm\\:w-11rem {\n      width: 11rem!important\n    }\n\n    .sm\\:w-12rem {\n      width: 12rem!important\n    }\n\n    .sm\\:w-13rem {\n      width: 13rem!important\n    }\n\n    .sm\\:w-14rem {\n      width: 14rem!important\n    }\n\n    .sm\\:w-15rem {\n      width: 15rem!important\n    }\n\n    .sm\\:w-16rem {\n      width: 16rem!important\n    }\n\n    .sm\\:w-17rem {\n      width: 17rem!important\n    }\n\n    .sm\\:w-18rem {\n      width: 18rem!important\n    }\n\n    .sm\\:w-19rem {\n      width: 19rem!important\n    }\n\n    .sm\\:w-20rem {\n      width: 20rem!important\n    }\n\n    .sm\\:w-21rem {\n      width: 21rem!important\n    }\n\n    .sm\\:w-22rem {\n      width: 22rem!important\n    }\n\n    .sm\\:w-23rem {\n      width: 23rem!important\n    }\n\n    .sm\\:w-24rem {\n      width: 24rem!important\n    }\n\n    .sm\\:w-25rem {\n      width: 25rem!important\n    }\n\n    .sm\\:w-26rem {\n      width: 26rem!important\n    }\n\n    .sm\\:w-27rem {\n      width: 27rem!important\n    }\n\n    .sm\\:w-28rem {\n      width: 28rem!important\n    }\n\n    .sm\\:w-29rem {\n      width: 29rem!important\n    }\n\n    .sm\\:w-30rem {\n      width: 30rem!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:w-full {\n      width:100%!important\n    }\n\n    .md\\:w-screen {\n      width: 100vw!important\n    }\n\n    .md\\:w-auto {\n      width: auto!important\n    }\n\n    .md\\:w-1 {\n      width: 8.3333%!important\n    }\n\n    .md\\:w-2 {\n      width: 16.6667%!important\n    }\n\n    .md\\:w-3 {\n      width: 25%!important\n    }\n\n    .md\\:w-4 {\n      width: 33.3333%!important\n    }\n\n    .md\\:w-5 {\n      width: 41.6667%!important\n    }\n\n    .md\\:w-6 {\n      width: 50%!important\n    }\n\n    .md\\:w-7 {\n      width: 58.3333%!important\n    }\n\n    .md\\:w-8 {\n      width: 66.6667%!important\n    }\n\n    .md\\:w-9 {\n      width: 75%!important\n    }\n\n    .md\\:w-10 {\n      width: 83.3333%!important\n    }\n\n    .md\\:w-11 {\n      width: 91.6667%!important\n    }\n\n    .md\\:w-12 {\n      width: 100%!important\n    }\n\n    .md\\:w-min {\n      width: min-content!important\n    }\n\n    .md\\:w-max {\n      width: max-content!important\n    }\n\n    .md\\:w-fit {\n      width: -moz-fit-content!important;\n      width: fit-content!important\n    }\n\n    .md\\:w-1rem {\n      width: 1rem!important\n    }\n\n    .md\\:w-2rem {\n      width: 2rem!important\n    }\n\n    .md\\:w-3rem {\n      width: 3rem!important\n    }\n\n    .md\\:w-4rem {\n      width: 4rem!important\n    }\n\n    .md\\:w-5rem {\n      width: 5rem!important\n    }\n\n    .md\\:w-6rem {\n      width: 6rem!important\n    }\n\n    .md\\:w-7rem {\n      width: 7rem!important\n    }\n\n    .md\\:w-8rem {\n      width: 8rem!important\n    }\n\n    .md\\:w-9rem {\n      width: 9rem!important\n    }\n\n    .md\\:w-10rem {\n      width: 10rem!important\n    }\n\n    .md\\:w-11rem {\n      width: 11rem!important\n    }\n\n    .md\\:w-12rem {\n      width: 12rem!important\n    }\n\n    .md\\:w-13rem {\n      width: 13rem!important\n    }\n\n    .md\\:w-14rem {\n      width: 14rem!important\n    }\n\n    .md\\:w-15rem {\n      width: 15rem!important\n    }\n\n    .md\\:w-16rem {\n      width: 16rem!important\n    }\n\n    .md\\:w-17rem {\n      width: 17rem!important\n    }\n\n    .md\\:w-18rem {\n      width: 18rem!important\n    }\n\n    .md\\:w-19rem {\n      width: 19rem!important\n    }\n\n    .md\\:w-20rem {\n      width: 20rem!important\n    }\n\n    .md\\:w-21rem {\n      width: 21rem!important\n    }\n\n    .md\\:w-22rem {\n      width: 22rem!important\n    }\n\n    .md\\:w-23rem {\n      width: 23rem!important\n    }\n\n    .md\\:w-24rem {\n      width: 24rem!important\n    }\n\n    .md\\:w-25rem {\n      width: 25rem!important\n    }\n\n    .md\\:w-26rem {\n      width: 26rem!important\n    }\n\n    .md\\:w-27rem {\n      width: 27rem!important\n    }\n\n    .md\\:w-28rem {\n      width: 28rem!important\n    }\n\n    .md\\:w-29rem {\n      width: 29rem!important\n    }\n\n    .md\\:w-30rem {\n      width: 30rem!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:w-full {\n      width:100%!important\n    }\n\n    .lg\\:w-screen {\n      width: 100vw!important\n    }\n\n    .lg\\:w-auto {\n      width: auto!important\n    }\n\n    .lg\\:w-1 {\n      width: 8.3333%!important\n    }\n\n    .lg\\:w-2 {\n      width: 16.6667%!important\n    }\n\n    .lg\\:w-3 {\n      width: 25%!important\n    }\n\n    .lg\\:w-4 {\n      width: 33.3333%!important\n    }\n\n    .lg\\:w-5 {\n      width: 41.6667%!important\n    }\n\n    .lg\\:w-6 {\n      width: 50%!important\n    }\n\n    .lg\\:w-7 {\n      width: 58.3333%!important\n    }\n\n    .lg\\:w-8 {\n      width: 66.6667%!important\n    }\n\n    .lg\\:w-9 {\n      width: 75%!important\n    }\n\n    .lg\\:w-10 {\n      width: 83.3333%!important\n    }\n\n    .lg\\:w-11 {\n      width: 91.6667%!important\n    }\n\n    .lg\\:w-12 {\n      width: 100%!important\n    }\n\n    .lg\\:w-min {\n      width: min-content!important\n    }\n\n    .lg\\:w-max {\n      width: max-content!important\n    }\n\n    .lg\\:w-fit {\n      width: -moz-fit-content!important;\n      width: fit-content!important\n    }\n\n    .lg\\:w-1rem {\n      width: 1rem!important\n    }\n\n    .lg\\:w-2rem {\n      width: 2rem!important\n    }\n\n    .lg\\:w-3rem {\n      width: 3rem!important\n    }\n\n    .lg\\:w-4rem {\n      width: 4rem!important\n    }\n\n    .lg\\:w-5rem {\n      width: 5rem!important\n    }\n\n    .lg\\:w-6rem {\n      width: 6rem!important\n    }\n\n    .lg\\:w-7rem {\n      width: 7rem!important\n    }\n\n    .lg\\:w-8rem {\n      width: 8rem!important\n    }\n\n    .lg\\:w-9rem {\n      width: 9rem!important\n    }\n\n    .lg\\:w-10rem {\n      width: 10rem!important\n    }\n\n    .lg\\:w-11rem {\n      width: 11rem!important\n    }\n\n    .lg\\:w-12rem {\n      width: 12rem!important\n    }\n\n    .lg\\:w-13rem {\n      width: 13rem!important\n    }\n\n    .lg\\:w-14rem {\n      width: 14rem!important\n    }\n\n    .lg\\:w-15rem {\n      width: 15rem!important\n    }\n\n    .lg\\:w-16rem {\n      width: 16rem!important\n    }\n\n    .lg\\:w-17rem {\n      width: 17rem!important\n    }\n\n    .lg\\:w-18rem {\n      width: 18rem!important\n    }\n\n    .lg\\:w-19rem {\n      width: 19rem!important\n    }\n\n    .lg\\:w-20rem {\n      width: 20rem!important\n    }\n\n    .lg\\:w-21rem {\n      width: 21rem!important\n    }\n\n    .lg\\:w-22rem {\n      width: 22rem!important\n    }\n\n    .lg\\:w-23rem {\n      width: 23rem!important\n    }\n\n    .lg\\:w-24rem {\n      width: 24rem!important\n    }\n\n    .lg\\:w-25rem {\n      width: 25rem!important\n    }\n\n    .lg\\:w-26rem {\n      width: 26rem!important\n    }\n\n    .lg\\:w-27rem {\n      width: 27rem!important\n    }\n\n    .lg\\:w-28rem {\n      width: 28rem!important\n    }\n\n    .lg\\:w-29rem {\n      width: 29rem!important\n    }\n\n    .lg\\:w-30rem {\n      width: 30rem!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:w-full {\n      width:100%!important\n    }\n\n    .xl\\:w-screen {\n      width: 100vw!important\n    }\n\n    .xl\\:w-auto {\n      width: auto!important\n    }\n\n    .xl\\:w-1 {\n      width: 8.3333%!important\n    }\n\n    .xl\\:w-2 {\n      width: 16.6667%!important\n    }\n\n    .xl\\:w-3 {\n      width: 25%!important\n    }\n\n    .xl\\:w-4 {\n      width: 33.3333%!important\n    }\n\n    .xl\\:w-5 {\n      width: 41.6667%!important\n    }\n\n    .xl\\:w-6 {\n      width: 50%!important\n    }\n\n    .xl\\:w-7 {\n      width: 58.3333%!important\n    }\n\n    .xl\\:w-8 {\n      width: 66.6667%!important\n    }\n\n    .xl\\:w-9 {\n      width: 75%!important\n    }\n\n    .xl\\:w-10 {\n      width: 83.3333%!important\n    }\n\n    .xl\\:w-11 {\n      width: 91.6667%!important\n    }\n\n    .xl\\:w-12 {\n      width: 100%!important\n    }\n\n    .xl\\:w-min {\n      width: min-content!important\n    }\n\n    .xl\\:w-max {\n      width: max-content!important\n    }\n\n    .xl\\:w-fit {\n      width: -moz-fit-content!important;\n      width: fit-content!important\n    }\n\n    .xl\\:w-1rem {\n      width: 1rem!important\n    }\n\n    .xl\\:w-2rem {\n      width: 2rem!important\n    }\n\n    .xl\\:w-3rem {\n      width: 3rem!important\n    }\n\n    .xl\\:w-4rem {\n      width: 4rem!important\n    }\n\n    .xl\\:w-5rem {\n      width: 5rem!important\n    }\n\n    .xl\\:w-6rem {\n      width: 6rem!important\n    }\n\n    .xl\\:w-7rem {\n      width: 7rem!important\n    }\n\n    .xl\\:w-8rem {\n      width: 8rem!important\n    }\n\n    .xl\\:w-9rem {\n      width: 9rem!important\n    }\n\n    .xl\\:w-10rem {\n      width: 10rem!important\n    }\n\n    .xl\\:w-11rem {\n      width: 11rem!important\n    }\n\n    .xl\\:w-12rem {\n      width: 12rem!important\n    }\n\n    .xl\\:w-13rem {\n      width: 13rem!important\n    }\n\n    .xl\\:w-14rem {\n      width: 14rem!important\n    }\n\n    .xl\\:w-15rem {\n      width: 15rem!important\n    }\n\n    .xl\\:w-16rem {\n      width: 16rem!important\n    }\n\n    .xl\\:w-17rem {\n      width: 17rem!important\n    }\n\n    .xl\\:w-18rem {\n      width: 18rem!important\n    }\n\n    .xl\\:w-19rem {\n      width: 19rem!important\n    }\n\n    .xl\\:w-20rem {\n      width: 20rem!important\n    }\n\n    .xl\\:w-21rem {\n      width: 21rem!important\n    }\n\n    .xl\\:w-22rem {\n      width: 22rem!important\n    }\n\n    .xl\\:w-23rem {\n      width: 23rem!important\n    }\n\n    .xl\\:w-24rem {\n      width: 24rem!important\n    }\n\n    .xl\\:w-25rem {\n      width: 25rem!important\n    }\n\n    .xl\\:w-26rem {\n      width: 26rem!important\n    }\n\n    .xl\\:w-27rem {\n      width: 27rem!important\n    }\n\n    .xl\\:w-28rem {\n      width: 28rem!important\n    }\n\n    .xl\\:w-29rem {\n      width: 29rem!important\n    }\n\n    .xl\\:w-30rem {\n      width: 30rem!important\n    }\n  }\n\n  .h-full {\n    height: 100%!important\n  }\n\n  .h-screen {\n    height: 100vh!important\n  }\n\n  .h-auto {\n    height: auto!important\n  }\n\n  .h-min {\n    height: min-content!important\n  }\n\n  .h-max {\n    height: max-content!important\n  }\n\n  .h-fit {\n    height: -moz-fit-content!important;\n    height: fit-content!important\n  }\n\n  .h-1rem {\n    height: 1rem!important\n  }\n\n  .h-2rem {\n    height: 2rem!important\n  }\n\n  .h-3rem {\n    height: 3rem!important\n  }\n\n  .h-4rem {\n    height: 4rem!important\n  }\n\n  .h-5rem {\n    height: 5rem!important\n  }\n\n  .h-6rem {\n    height: 6rem!important\n  }\n\n  .h-7rem {\n    height: 7rem!important\n  }\n\n  .h-8rem {\n    height: 8rem!important\n  }\n\n  .h-9rem {\n    height: 9rem!important\n  }\n\n  .h-10rem {\n    height: 10rem!important\n  }\n\n  .h-11rem {\n    height: 11rem!important\n  }\n\n  .h-12rem {\n    height: 12rem!important\n  }\n\n  .h-13rem {\n    height: 13rem!important\n  }\n\n  .h-14rem {\n    height: 14rem!important\n  }\n\n  .h-15rem {\n    height: 15rem!important\n  }\n\n  .h-16rem {\n    height: 16rem!important\n  }\n\n  .h-17rem {\n    height: 17rem!important\n  }\n\n  .h-18rem {\n    height: 18rem!important\n  }\n\n  .h-19rem {\n    height: 19rem!important\n  }\n\n  .h-20rem {\n    height: 20rem!important\n  }\n\n  .h-21rem {\n    height: 21rem!important\n  }\n\n  .h-22rem {\n    height: 22rem!important\n  }\n\n  .h-23rem {\n    height: 23rem!important\n  }\n\n  .h-24rem {\n    height: 24rem!important\n  }\n\n  .h-25rem {\n    height: 25rem!important\n  }\n\n  .h-26rem {\n    height: 26rem!important\n  }\n\n  .h-27rem {\n    height: 27rem!important\n  }\n\n  .h-28rem {\n    height: 28rem!important\n  }\n\n  .h-29rem {\n    height: 29rem!important\n  }\n\n  .h-30rem {\n    height: 30rem!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:h-full {\n      height:100%!important\n    }\n\n    .sm\\:h-screen {\n      height: 100vh!important\n    }\n\n    .sm\\:h-auto {\n      height: auto!important\n    }\n\n    .sm\\:h-min {\n      height: min-content!important\n    }\n\n    .sm\\:h-max {\n      height: max-content!important\n    }\n\n    .sm\\:h-fit {\n      height: -moz-fit-content!important;\n      height: fit-content!important\n    }\n\n    .sm\\:h-1rem {\n      height: 1rem!important\n    }\n\n    .sm\\:h-2rem {\n      height: 2rem!important\n    }\n\n    .sm\\:h-3rem {\n      height: 3rem!important\n    }\n\n    .sm\\:h-4rem {\n      height: 4rem!important\n    }\n\n    .sm\\:h-5rem {\n      height: 5rem!important\n    }\n\n    .sm\\:h-6rem {\n      height: 6rem!important\n    }\n\n    .sm\\:h-7rem {\n      height: 7rem!important\n    }\n\n    .sm\\:h-8rem {\n      height: 8rem!important\n    }\n\n    .sm\\:h-9rem {\n      height: 9rem!important\n    }\n\n    .sm\\:h-10rem {\n      height: 10rem!important\n    }\n\n    .sm\\:h-11rem {\n      height: 11rem!important\n    }\n\n    .sm\\:h-12rem {\n      height: 12rem!important\n    }\n\n    .sm\\:h-13rem {\n      height: 13rem!important\n    }\n\n    .sm\\:h-14rem {\n      height: 14rem!important\n    }\n\n    .sm\\:h-15rem {\n      height: 15rem!important\n    }\n\n    .sm\\:h-16rem {\n      height: 16rem!important\n    }\n\n    .sm\\:h-17rem {\n      height: 17rem!important\n    }\n\n    .sm\\:h-18rem {\n      height: 18rem!important\n    }\n\n    .sm\\:h-19rem {\n      height: 19rem!important\n    }\n\n    .sm\\:h-20rem {\n      height: 20rem!important\n    }\n\n    .sm\\:h-21rem {\n      height: 21rem!important\n    }\n\n    .sm\\:h-22rem {\n      height: 22rem!important\n    }\n\n    .sm\\:h-23rem {\n      height: 23rem!important\n    }\n\n    .sm\\:h-24rem {\n      height: 24rem!important\n    }\n\n    .sm\\:h-25rem {\n      height: 25rem!important\n    }\n\n    .sm\\:h-26rem {\n      height: 26rem!important\n    }\n\n    .sm\\:h-27rem {\n      height: 27rem!important\n    }\n\n    .sm\\:h-28rem {\n      height: 28rem!important\n    }\n\n    .sm\\:h-29rem {\n      height: 29rem!important\n    }\n\n    .sm\\:h-30rem {\n      height: 30rem!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:h-full {\n      height:100%!important\n    }\n\n    .md\\:h-screen {\n      height: 100vh!important\n    }\n\n    .md\\:h-auto {\n      height: auto!important\n    }\n\n    .md\\:h-min {\n      height: min-content!important\n    }\n\n    .md\\:h-max {\n      height: max-content!important\n    }\n\n    .md\\:h-fit {\n      height: -moz-fit-content!important;\n      height: fit-content!important\n    }\n\n    .md\\:h-1rem {\n      height: 1rem!important\n    }\n\n    .md\\:h-2rem {\n      height: 2rem!important\n    }\n\n    .md\\:h-3rem {\n      height: 3rem!important\n    }\n\n    .md\\:h-4rem {\n      height: 4rem!important\n    }\n\n    .md\\:h-5rem {\n      height: 5rem!important\n    }\n\n    .md\\:h-6rem {\n      height: 6rem!important\n    }\n\n    .md\\:h-7rem {\n      height: 7rem!important\n    }\n\n    .md\\:h-8rem {\n      height: 8rem!important\n    }\n\n    .md\\:h-9rem {\n      height: 9rem!important\n    }\n\n    .md\\:h-10rem {\n      height: 10rem!important\n    }\n\n    .md\\:h-11rem {\n      height: 11rem!important\n    }\n\n    .md\\:h-12rem {\n      height: 12rem!important\n    }\n\n    .md\\:h-13rem {\n      height: 13rem!important\n    }\n\n    .md\\:h-14rem {\n      height: 14rem!important\n    }\n\n    .md\\:h-15rem {\n      height: 15rem!important\n    }\n\n    .md\\:h-16rem {\n      height: 16rem!important\n    }\n\n    .md\\:h-17rem {\n      height: 17rem!important\n    }\n\n    .md\\:h-18rem {\n      height: 18rem!important\n    }\n\n    .md\\:h-19rem {\n      height: 19rem!important\n    }\n\n    .md\\:h-20rem {\n      height: 20rem!important\n    }\n\n    .md\\:h-21rem {\n      height: 21rem!important\n    }\n\n    .md\\:h-22rem {\n      height: 22rem!important\n    }\n\n    .md\\:h-23rem {\n      height: 23rem!important\n    }\n\n    .md\\:h-24rem {\n      height: 24rem!important\n    }\n\n    .md\\:h-25rem {\n      height: 25rem!important\n    }\n\n    .md\\:h-26rem {\n      height: 26rem!important\n    }\n\n    .md\\:h-27rem {\n      height: 27rem!important\n    }\n\n    .md\\:h-28rem {\n      height: 28rem!important\n    }\n\n    .md\\:h-29rem {\n      height: 29rem!important\n    }\n\n    .md\\:h-30rem {\n      height: 30rem!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:h-full {\n      height:100%!important\n    }\n\n    .lg\\:h-screen {\n      height: 100vh!important\n    }\n\n    .lg\\:h-auto {\n      height: auto!important\n    }\n\n    .lg\\:h-min {\n      height: min-content!important\n    }\n\n    .lg\\:h-max {\n      height: max-content!important\n    }\n\n    .lg\\:h-fit {\n      height: -moz-fit-content!important;\n      height: fit-content!important\n    }\n\n    .lg\\:h-1rem {\n      height: 1rem!important\n    }\n\n    .lg\\:h-2rem {\n      height: 2rem!important\n    }\n\n    .lg\\:h-3rem {\n      height: 3rem!important\n    }\n\n    .lg\\:h-4rem {\n      height: 4rem!important\n    }\n\n    .lg\\:h-5rem {\n      height: 5rem!important\n    }\n\n    .lg\\:h-6rem {\n      height: 6rem!important\n    }\n\n    .lg\\:h-7rem {\n      height: 7rem!important\n    }\n\n    .lg\\:h-8rem {\n      height: 8rem!important\n    }\n\n    .lg\\:h-9rem {\n      height: 9rem!important\n    }\n\n    .lg\\:h-10rem {\n      height: 10rem!important\n    }\n\n    .lg\\:h-11rem {\n      height: 11rem!important\n    }\n\n    .lg\\:h-12rem {\n      height: 12rem!important\n    }\n\n    .lg\\:h-13rem {\n      height: 13rem!important\n    }\n\n    .lg\\:h-14rem {\n      height: 14rem!important\n    }\n\n    .lg\\:h-15rem {\n      height: 15rem!important\n    }\n\n    .lg\\:h-16rem {\n      height: 16rem!important\n    }\n\n    .lg\\:h-17rem {\n      height: 17rem!important\n    }\n\n    .lg\\:h-18rem {\n      height: 18rem!important\n    }\n\n    .lg\\:h-19rem {\n      height: 19rem!important\n    }\n\n    .lg\\:h-20rem {\n      height: 20rem!important\n    }\n\n    .lg\\:h-21rem {\n      height: 21rem!important\n    }\n\n    .lg\\:h-22rem {\n      height: 22rem!important\n    }\n\n    .lg\\:h-23rem {\n      height: 23rem!important\n    }\n\n    .lg\\:h-24rem {\n      height: 24rem!important\n    }\n\n    .lg\\:h-25rem {\n      height: 25rem!important\n    }\n\n    .lg\\:h-26rem {\n      height: 26rem!important\n    }\n\n    .lg\\:h-27rem {\n      height: 27rem!important\n    }\n\n    .lg\\:h-28rem {\n      height: 28rem!important\n    }\n\n    .lg\\:h-29rem {\n      height: 29rem!important\n    }\n\n    .lg\\:h-30rem {\n      height: 30rem!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:h-full {\n      height:100%!important\n    }\n\n    .xl\\:h-screen {\n      height: 100vh!important\n    }\n\n    .xl\\:h-auto {\n      height: auto!important\n    }\n\n    .xl\\:h-min {\n      height: min-content!important\n    }\n\n    .xl\\:h-max {\n      height: max-content!important\n    }\n\n    .xl\\:h-fit {\n      height: -moz-fit-content!important;\n      height: fit-content!important\n    }\n\n    .xl\\:h-1rem {\n      height: 1rem!important\n    }\n\n    .xl\\:h-2rem {\n      height: 2rem!important\n    }\n\n    .xl\\:h-3rem {\n      height: 3rem!important\n    }\n\n    .xl\\:h-4rem {\n      height: 4rem!important\n    }\n\n    .xl\\:h-5rem {\n      height: 5rem!important\n    }\n\n    .xl\\:h-6rem {\n      height: 6rem!important\n    }\n\n    .xl\\:h-7rem {\n      height: 7rem!important\n    }\n\n    .xl\\:h-8rem {\n      height: 8rem!important\n    }\n\n    .xl\\:h-9rem {\n      height: 9rem!important\n    }\n\n    .xl\\:h-10rem {\n      height: 10rem!important\n    }\n\n    .xl\\:h-11rem {\n      height: 11rem!important\n    }\n\n    .xl\\:h-12rem {\n      height: 12rem!important\n    }\n\n    .xl\\:h-13rem {\n      height: 13rem!important\n    }\n\n    .xl\\:h-14rem {\n      height: 14rem!important\n    }\n\n    .xl\\:h-15rem {\n      height: 15rem!important\n    }\n\n    .xl\\:h-16rem {\n      height: 16rem!important\n    }\n\n    .xl\\:h-17rem {\n      height: 17rem!important\n    }\n\n    .xl\\:h-18rem {\n      height: 18rem!important\n    }\n\n    .xl\\:h-19rem {\n      height: 19rem!important\n    }\n\n    .xl\\:h-20rem {\n      height: 20rem!important\n    }\n\n    .xl\\:h-21rem {\n      height: 21rem!important\n    }\n\n    .xl\\:h-22rem {\n      height: 22rem!important\n    }\n\n    .xl\\:h-23rem {\n      height: 23rem!important\n    }\n\n    .xl\\:h-24rem {\n      height: 24rem!important\n    }\n\n    .xl\\:h-25rem {\n      height: 25rem!important\n    }\n\n    .xl\\:h-26rem {\n      height: 26rem!important\n    }\n\n    .xl\\:h-27rem {\n      height: 27rem!important\n    }\n\n    .xl\\:h-28rem {\n      height: 28rem!important\n    }\n\n    .xl\\:h-29rem {\n      height: 29rem!important\n    }\n\n    .xl\\:h-30rem {\n      height: 30rem!important\n    }\n  }\n\n  .min-w-0 {\n    min-width: 0px!important\n  }\n\n  .min-w-full {\n    min-width: 100%!important\n  }\n\n  .min-w-screen {\n    min-width: 100vw!important\n  }\n\n  .min-w-min {\n    min-width: min-content!important\n  }\n\n  .min-w-max {\n    min-width: max-content!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:min-w-0 {\n      min-width:0px!important\n    }\n\n    .sm\\:min-w-full {\n      min-width: 100%!important\n    }\n\n    .sm\\:min-w-screen {\n      min-width: 100vw!important\n    }\n\n    .sm\\:min-w-min {\n      min-width: min-content!important\n    }\n\n    .sm\\:min-w-max {\n      min-width: max-content!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:min-w-0 {\n      min-width:0px!important\n    }\n\n    .md\\:min-w-full {\n      min-width: 100%!important\n    }\n\n    .md\\:min-w-screen {\n      min-width: 100vw!important\n    }\n\n    .md\\:min-w-min {\n      min-width: min-content!important\n    }\n\n    .md\\:min-w-max {\n      min-width: max-content!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:min-w-0 {\n      min-width:0px!important\n    }\n\n    .lg\\:min-w-full {\n      min-width: 100%!important\n    }\n\n    .lg\\:min-w-screen {\n      min-width: 100vw!important\n    }\n\n    .lg\\:min-w-min {\n      min-width: min-content!important\n    }\n\n    .lg\\:min-w-max {\n      min-width: max-content!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:min-w-0 {\n      min-width:0px!important\n    }\n\n    .xl\\:min-w-full {\n      min-width: 100%!important\n    }\n\n    .xl\\:min-w-screen {\n      min-width: 100vw!important\n    }\n\n    .xl\\:min-w-min {\n      min-width: min-content!important\n    }\n\n    .xl\\:min-w-max {\n      min-width: max-content!important\n    }\n  }\n\n  .max-w-0 {\n    max-width: 0px!important\n  }\n\n  .max-w-full {\n    max-width: 100%!important\n  }\n\n  .max-w-screen {\n    max-width: 100vw!important\n  }\n\n  .max-w-min {\n    max-width: min-content!important\n  }\n\n  .max-w-max {\n    max-width: max-content!important\n  }\n\n  .max-w-fit {\n    max-width: -moz-fit-content!important;\n    max-width: fit-content!important\n  }\n\n  .max-w-1rem {\n    max-width: 1rem!important\n  }\n\n  .max-w-2rem {\n    max-width: 2rem!important\n  }\n\n  .max-w-3rem {\n    max-width: 3rem!important\n  }\n\n  .max-w-4rem {\n    max-width: 4rem!important\n  }\n\n  .max-w-5rem {\n    max-width: 5rem!important\n  }\n\n  .max-w-6rem {\n    max-width: 6rem!important\n  }\n\n  .max-w-7rem {\n    max-width: 7rem!important\n  }\n\n  .max-w-8rem {\n    max-width: 8rem!important\n  }\n\n  .max-w-9rem {\n    max-width: 9rem!important\n  }\n\n  .max-w-10rem {\n    max-width: 10rem!important\n  }\n\n  .max-w-11rem {\n    max-width: 11rem!important\n  }\n\n  .max-w-12rem {\n    max-width: 12rem!important\n  }\n\n  .max-w-13rem {\n    max-width: 13rem!important\n  }\n\n  .max-w-14rem {\n    max-width: 14rem!important\n  }\n\n  .max-w-15rem {\n    max-width: 15rem!important\n  }\n\n  .max-w-16rem {\n    max-width: 16rem!important\n  }\n\n  .max-w-17rem {\n    max-width: 17rem!important\n  }\n\n  .max-w-18rem {\n    max-width: 18rem!important\n  }\n\n  .max-w-19rem {\n    max-width: 19rem!important\n  }\n\n  .max-w-20rem {\n    max-width: 20rem!important\n  }\n\n  .max-w-21rem {\n    max-width: 21rem!important\n  }\n\n  .max-w-22rem {\n    max-width: 22rem!important\n  }\n\n  .max-w-23rem {\n    max-width: 23rem!important\n  }\n\n  .max-w-24rem {\n    max-width: 24rem!important\n  }\n\n  .max-w-25rem {\n    max-width: 25rem!important\n  }\n\n  .max-w-26rem {\n    max-width: 26rem!important\n  }\n\n  .max-w-27rem {\n    max-width: 27rem!important\n  }\n\n  .max-w-28rem {\n    max-width: 28rem!important\n  }\n\n  .max-w-29rem {\n    max-width: 29rem!important\n  }\n\n  .max-w-30rem {\n    max-width: 30rem!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:max-w-0 {\n      max-width:0px!important\n    }\n\n    .sm\\:max-w-full {\n      max-width: 100%!important\n    }\n\n    .sm\\:max-w-screen {\n      max-width: 100vw!important\n    }\n\n    .sm\\:max-w-min {\n      max-width: min-content!important\n    }\n\n    .sm\\:max-w-max {\n      max-width: max-content!important\n    }\n\n    .sm\\:max-w-fit {\n      max-width: -moz-fit-content!important;\n      max-width: fit-content!important\n    }\n\n    .sm\\:max-w-1rem {\n      max-width: 1rem!important\n    }\n\n    .sm\\:max-w-2rem {\n      max-width: 2rem!important\n    }\n\n    .sm\\:max-w-3rem {\n      max-width: 3rem!important\n    }\n\n    .sm\\:max-w-4rem {\n      max-width: 4rem!important\n    }\n\n    .sm\\:max-w-5rem {\n      max-width: 5rem!important\n    }\n\n    .sm\\:max-w-6rem {\n      max-width: 6rem!important\n    }\n\n    .sm\\:max-w-7rem {\n      max-width: 7rem!important\n    }\n\n    .sm\\:max-w-8rem {\n      max-width: 8rem!important\n    }\n\n    .sm\\:max-w-9rem {\n      max-width: 9rem!important\n    }\n\n    .sm\\:max-w-10rem {\n      max-width: 10rem!important\n    }\n\n    .sm\\:max-w-11rem {\n      max-width: 11rem!important\n    }\n\n    .sm\\:max-w-12rem {\n      max-width: 12rem!important\n    }\n\n    .sm\\:max-w-13rem {\n      max-width: 13rem!important\n    }\n\n    .sm\\:max-w-14rem {\n      max-width: 14rem!important\n    }\n\n    .sm\\:max-w-15rem {\n      max-width: 15rem!important\n    }\n\n    .sm\\:max-w-16rem {\n      max-width: 16rem!important\n    }\n\n    .sm\\:max-w-17rem {\n      max-width: 17rem!important\n    }\n\n    .sm\\:max-w-18rem {\n      max-width: 18rem!important\n    }\n\n    .sm\\:max-w-19rem {\n      max-width: 19rem!important\n    }\n\n    .sm\\:max-w-20rem {\n      max-width: 20rem!important\n    }\n\n    .sm\\:max-w-21rem {\n      max-width: 21rem!important\n    }\n\n    .sm\\:max-w-22rem {\n      max-width: 22rem!important\n    }\n\n    .sm\\:max-w-23rem {\n      max-width: 23rem!important\n    }\n\n    .sm\\:max-w-24rem {\n      max-width: 24rem!important\n    }\n\n    .sm\\:max-w-25rem {\n      max-width: 25rem!important\n    }\n\n    .sm\\:max-w-26rem {\n      max-width: 26rem!important\n    }\n\n    .sm\\:max-w-27rem {\n      max-width: 27rem!important\n    }\n\n    .sm\\:max-w-28rem {\n      max-width: 28rem!important\n    }\n\n    .sm\\:max-w-29rem {\n      max-width: 29rem!important\n    }\n\n    .sm\\:max-w-30rem {\n      max-width: 30rem!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:max-w-0 {\n      max-width:0px!important\n    }\n\n    .md\\:max-w-full {\n      max-width: 100%!important\n    }\n\n    .md\\:max-w-screen {\n      max-width: 100vw!important\n    }\n\n    .md\\:max-w-min {\n      max-width: min-content!important\n    }\n\n    .md\\:max-w-max {\n      max-width: max-content!important\n    }\n\n    .md\\:max-w-fit {\n      max-width: -moz-fit-content!important;\n      max-width: fit-content!important\n    }\n\n    .md\\:max-w-1rem {\n      max-width: 1rem!important\n    }\n\n    .md\\:max-w-2rem {\n      max-width: 2rem!important\n    }\n\n    .md\\:max-w-3rem {\n      max-width: 3rem!important\n    }\n\n    .md\\:max-w-4rem {\n      max-width: 4rem!important\n    }\n\n    .md\\:max-w-5rem {\n      max-width: 5rem!important\n    }\n\n    .md\\:max-w-6rem {\n      max-width: 6rem!important\n    }\n\n    .md\\:max-w-7rem {\n      max-width: 7rem!important\n    }\n\n    .md\\:max-w-8rem {\n      max-width: 8rem!important\n    }\n\n    .md\\:max-w-9rem {\n      max-width: 9rem!important\n    }\n\n    .md\\:max-w-10rem {\n      max-width: 10rem!important\n    }\n\n    .md\\:max-w-11rem {\n      max-width: 11rem!important\n    }\n\n    .md\\:max-w-12rem {\n      max-width: 12rem!important\n    }\n\n    .md\\:max-w-13rem {\n      max-width: 13rem!important\n    }\n\n    .md\\:max-w-14rem {\n      max-width: 14rem!important\n    }\n\n    .md\\:max-w-15rem {\n      max-width: 15rem!important\n    }\n\n    .md\\:max-w-16rem {\n      max-width: 16rem!important\n    }\n\n    .md\\:max-w-17rem {\n      max-width: 17rem!important\n    }\n\n    .md\\:max-w-18rem {\n      max-width: 18rem!important\n    }\n\n    .md\\:max-w-19rem {\n      max-width: 19rem!important\n    }\n\n    .md\\:max-w-20rem {\n      max-width: 20rem!important\n    }\n\n    .md\\:max-w-21rem {\n      max-width: 21rem!important\n    }\n\n    .md\\:max-w-22rem {\n      max-width: 22rem!important\n    }\n\n    .md\\:max-w-23rem {\n      max-width: 23rem!important\n    }\n\n    .md\\:max-w-24rem {\n      max-width: 24rem!important\n    }\n\n    .md\\:max-w-25rem {\n      max-width: 25rem!important\n    }\n\n    .md\\:max-w-26rem {\n      max-width: 26rem!important\n    }\n\n    .md\\:max-w-27rem {\n      max-width: 27rem!important\n    }\n\n    .md\\:max-w-28rem {\n      max-width: 28rem!important\n    }\n\n    .md\\:max-w-29rem {\n      max-width: 29rem!important\n    }\n\n    .md\\:max-w-30rem {\n      max-width: 30rem!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:max-w-0 {\n      max-width:0px!important\n    }\n\n    .lg\\:max-w-full {\n      max-width: 100%!important\n    }\n\n    .lg\\:max-w-screen {\n      max-width: 100vw!important\n    }\n\n    .lg\\:max-w-min {\n      max-width: min-content!important\n    }\n\n    .lg\\:max-w-max {\n      max-width: max-content!important\n    }\n\n    .lg\\:max-w-fit {\n      max-width: -moz-fit-content!important;\n      max-width: fit-content!important\n    }\n\n    .lg\\:max-w-1rem {\n      max-width: 1rem!important\n    }\n\n    .lg\\:max-w-2rem {\n      max-width: 2rem!important\n    }\n\n    .lg\\:max-w-3rem {\n      max-width: 3rem!important\n    }\n\n    .lg\\:max-w-4rem {\n      max-width: 4rem!important\n    }\n\n    .lg\\:max-w-5rem {\n      max-width: 5rem!important\n    }\n\n    .lg\\:max-w-6rem {\n      max-width: 6rem!important\n    }\n\n    .lg\\:max-w-7rem {\n      max-width: 7rem!important\n    }\n\n    .lg\\:max-w-8rem {\n      max-width: 8rem!important\n    }\n\n    .lg\\:max-w-9rem {\n      max-width: 9rem!important\n    }\n\n    .lg\\:max-w-10rem {\n      max-width: 10rem!important\n    }\n\n    .lg\\:max-w-11rem {\n      max-width: 11rem!important\n    }\n\n    .lg\\:max-w-12rem {\n      max-width: 12rem!important\n    }\n\n    .lg\\:max-w-13rem {\n      max-width: 13rem!important\n    }\n\n    .lg\\:max-w-14rem {\n      max-width: 14rem!important\n    }\n\n    .lg\\:max-w-15rem {\n      max-width: 15rem!important\n    }\n\n    .lg\\:max-w-16rem {\n      max-width: 16rem!important\n    }\n\n    .lg\\:max-w-17rem {\n      max-width: 17rem!important\n    }\n\n    .lg\\:max-w-18rem {\n      max-width: 18rem!important\n    }\n\n    .lg\\:max-w-19rem {\n      max-width: 19rem!important\n    }\n\n    .lg\\:max-w-20rem {\n      max-width: 20rem!important\n    }\n\n    .lg\\:max-w-21rem {\n      max-width: 21rem!important\n    }\n\n    .lg\\:max-w-22rem {\n      max-width: 22rem!important\n    }\n\n    .lg\\:max-w-23rem {\n      max-width: 23rem!important\n    }\n\n    .lg\\:max-w-24rem {\n      max-width: 24rem!important\n    }\n\n    .lg\\:max-w-25rem {\n      max-width: 25rem!important\n    }\n\n    .lg\\:max-w-26rem {\n      max-width: 26rem!important\n    }\n\n    .lg\\:max-w-27rem {\n      max-width: 27rem!important\n    }\n\n    .lg\\:max-w-28rem {\n      max-width: 28rem!important\n    }\n\n    .lg\\:max-w-29rem {\n      max-width: 29rem!important\n    }\n\n    .lg\\:max-w-30rem {\n      max-width: 30rem!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:max-w-0 {\n      max-width:0px!important\n    }\n\n    .xl\\:max-w-full {\n      max-width: 100%!important\n    }\n\n    .xl\\:max-w-screen {\n      max-width: 100vw!important\n    }\n\n    .xl\\:max-w-min {\n      max-width: min-content!important\n    }\n\n    .xl\\:max-w-max {\n      max-width: max-content!important\n    }\n\n    .xl\\:max-w-fit {\n      max-width: -moz-fit-content!important;\n      max-width: fit-content!important\n    }\n\n    .xl\\:max-w-1rem {\n      max-width: 1rem!important\n    }\n\n    .xl\\:max-w-2rem {\n      max-width: 2rem!important\n    }\n\n    .xl\\:max-w-3rem {\n      max-width: 3rem!important\n    }\n\n    .xl\\:max-w-4rem {\n      max-width: 4rem!important\n    }\n\n    .xl\\:max-w-5rem {\n      max-width: 5rem!important\n    }\n\n    .xl\\:max-w-6rem {\n      max-width: 6rem!important\n    }\n\n    .xl\\:max-w-7rem {\n      max-width: 7rem!important\n    }\n\n    .xl\\:max-w-8rem {\n      max-width: 8rem!important\n    }\n\n    .xl\\:max-w-9rem {\n      max-width: 9rem!important\n    }\n\n    .xl\\:max-w-10rem {\n      max-width: 10rem!important\n    }\n\n    .xl\\:max-w-11rem {\n      max-width: 11rem!important\n    }\n\n    .xl\\:max-w-12rem {\n      max-width: 12rem!important\n    }\n\n    .xl\\:max-w-13rem {\n      max-width: 13rem!important\n    }\n\n    .xl\\:max-w-14rem {\n      max-width: 14rem!important\n    }\n\n    .xl\\:max-w-15rem {\n      max-width: 15rem!important\n    }\n\n    .xl\\:max-w-16rem {\n      max-width: 16rem!important\n    }\n\n    .xl\\:max-w-17rem {\n      max-width: 17rem!important\n    }\n\n    .xl\\:max-w-18rem {\n      max-width: 18rem!important\n    }\n\n    .xl\\:max-w-19rem {\n      max-width: 19rem!important\n    }\n\n    .xl\\:max-w-20rem {\n      max-width: 20rem!important\n    }\n\n    .xl\\:max-w-21rem {\n      max-width: 21rem!important\n    }\n\n    .xl\\:max-w-22rem {\n      max-width: 22rem!important\n    }\n\n    .xl\\:max-w-23rem {\n      max-width: 23rem!important\n    }\n\n    .xl\\:max-w-24rem {\n      max-width: 24rem!important\n    }\n\n    .xl\\:max-w-25rem {\n      max-width: 25rem!important\n    }\n\n    .xl\\:max-w-26rem {\n      max-width: 26rem!important\n    }\n\n    .xl\\:max-w-27rem {\n      max-width: 27rem!important\n    }\n\n    .xl\\:max-w-28rem {\n      max-width: 28rem!important\n    }\n\n    .xl\\:max-w-29rem {\n      max-width: 29rem!important\n    }\n\n    .xl\\:max-w-30rem {\n      max-width: 30rem!important\n    }\n  }\n\n  .min-h-0 {\n    min-height: 0px!important\n  }\n\n  .min-h-full {\n    min-height: 100%!important\n  }\n\n  .min-h-screen {\n    min-height: 100vh!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:min-h-0 {\n      min-height:0px!important\n    }\n\n    .sm\\:min-h-full {\n      min-height: 100%!important\n    }\n\n    .sm\\:min-h-screen {\n      min-height: 100vh!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:min-h-0 {\n      min-height:0px!important\n    }\n\n    .md\\:min-h-full {\n      min-height: 100%!important\n    }\n\n    .md\\:min-h-screen {\n      min-height: 100vh!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:min-h-0 {\n      min-height:0px!important\n    }\n\n    .lg\\:min-h-full {\n      min-height: 100%!important\n    }\n\n    .lg\\:min-h-screen {\n      min-height: 100vh!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:min-h-0 {\n      min-height:0px!important\n    }\n\n    .xl\\:min-h-full {\n      min-height: 100%!important\n    }\n\n    .xl\\:min-h-screen {\n      min-height: 100vh!important\n    }\n  }\n\n  .max-h-0 {\n    max-height: 0px!important\n  }\n\n  .max-h-full {\n    max-height: 100%!important\n  }\n\n  .max-h-screen {\n    max-height: 100vh!important\n  }\n\n  .max-h-min {\n    max-height: min-content!important\n  }\n\n  .max-h-max {\n    max-height: max-content!important\n  }\n\n  .max-h-fit {\n    max-height: -moz-fit-content!important;\n    max-height: fit-content!important\n  }\n\n  .max-h-1rem {\n    max-height: 1rem!important\n  }\n\n  .max-h-2rem {\n    max-height: 2rem!important\n  }\n\n  .max-h-3rem {\n    max-height: 3rem!important\n  }\n\n  .max-h-4rem {\n    max-height: 4rem!important\n  }\n\n  .max-h-5rem {\n    max-height: 5rem!important\n  }\n\n  .max-h-6rem {\n    max-height: 6rem!important\n  }\n\n  .max-h-7rem {\n    max-height: 7rem!important\n  }\n\n  .max-h-8rem {\n    max-height: 8rem!important\n  }\n\n  .max-h-9rem {\n    max-height: 9rem!important\n  }\n\n  .max-h-10rem {\n    max-height: 10rem!important\n  }\n\n  .max-h-11rem {\n    max-height: 11rem!important\n  }\n\n  .max-h-12rem {\n    max-height: 12rem!important\n  }\n\n  .max-h-13rem {\n    max-height: 13rem!important\n  }\n\n  .max-h-14rem {\n    max-height: 14rem!important\n  }\n\n  .max-h-15rem {\n    max-height: 15rem!important\n  }\n\n  .max-h-16rem {\n    max-height: 16rem!important\n  }\n\n  .max-h-17rem {\n    max-height: 17rem!important\n  }\n\n  .max-h-18rem {\n    max-height: 18rem!important\n  }\n\n  .max-h-19rem {\n    max-height: 19rem!important\n  }\n\n  .max-h-20rem {\n    max-height: 20rem!important\n  }\n\n  .max-h-21rem {\n    max-height: 21rem!important\n  }\n\n  .max-h-22rem {\n    max-height: 22rem!important\n  }\n\n  .max-h-23rem {\n    max-height: 23rem!important\n  }\n\n  .max-h-24rem {\n    max-height: 24rem!important\n  }\n\n  .max-h-25rem {\n    max-height: 25rem!important\n  }\n\n  .max-h-26rem {\n    max-height: 26rem!important\n  }\n\n  .max-h-27rem {\n    max-height: 27rem!important\n  }\n\n  .max-h-28rem {\n    max-height: 28rem!important\n  }\n\n  .max-h-29rem {\n    max-height: 29rem!important\n  }\n\n  .max-h-30rem {\n    max-height: 30rem!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:max-h-0 {\n      max-height:0px!important\n    }\n\n    .sm\\:max-h-full {\n      max-height: 100%!important\n    }\n\n    .sm\\:max-h-screen {\n      max-height: 100vh!important\n    }\n\n    .sm\\:max-h-min {\n      max-height: min-content!important\n    }\n\n    .sm\\:max-h-max {\n      max-height: max-content!important\n    }\n\n    .sm\\:max-h-fit {\n      max-height: -moz-fit-content!important;\n      max-height: fit-content!important\n    }\n\n    .sm\\:max-h-1rem {\n      max-height: 1rem!important\n    }\n\n    .sm\\:max-h-2rem {\n      max-height: 2rem!important\n    }\n\n    .sm\\:max-h-3rem {\n      max-height: 3rem!important\n    }\n\n    .sm\\:max-h-4rem {\n      max-height: 4rem!important\n    }\n\n    .sm\\:max-h-5rem {\n      max-height: 5rem!important\n    }\n\n    .sm\\:max-h-6rem {\n      max-height: 6rem!important\n    }\n\n    .sm\\:max-h-7rem {\n      max-height: 7rem!important\n    }\n\n    .sm\\:max-h-8rem {\n      max-height: 8rem!important\n    }\n\n    .sm\\:max-h-9rem {\n      max-height: 9rem!important\n    }\n\n    .sm\\:max-h-10rem {\n      max-height: 10rem!important\n    }\n\n    .sm\\:max-h-11rem {\n      max-height: 11rem!important\n    }\n\n    .sm\\:max-h-12rem {\n      max-height: 12rem!important\n    }\n\n    .sm\\:max-h-13rem {\n      max-height: 13rem!important\n    }\n\n    .sm\\:max-h-14rem {\n      max-height: 14rem!important\n    }\n\n    .sm\\:max-h-15rem {\n      max-height: 15rem!important\n    }\n\n    .sm\\:max-h-16rem {\n      max-height: 16rem!important\n    }\n\n    .sm\\:max-h-17rem {\n      max-height: 17rem!important\n    }\n\n    .sm\\:max-h-18rem {\n      max-height: 18rem!important\n    }\n\n    .sm\\:max-h-19rem {\n      max-height: 19rem!important\n    }\n\n    .sm\\:max-h-20rem {\n      max-height: 20rem!important\n    }\n\n    .sm\\:max-h-21rem {\n      max-height: 21rem!important\n    }\n\n    .sm\\:max-h-22rem {\n      max-height: 22rem!important\n    }\n\n    .sm\\:max-h-23rem {\n      max-height: 23rem!important\n    }\n\n    .sm\\:max-h-24rem {\n      max-height: 24rem!important\n    }\n\n    .sm\\:max-h-25rem {\n      max-height: 25rem!important\n    }\n\n    .sm\\:max-h-26rem {\n      max-height: 26rem!important\n    }\n\n    .sm\\:max-h-27rem {\n      max-height: 27rem!important\n    }\n\n    .sm\\:max-h-28rem {\n      max-height: 28rem!important\n    }\n\n    .sm\\:max-h-29rem {\n      max-height: 29rem!important\n    }\n\n    .sm\\:max-h-30rem {\n      max-height: 30rem!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:max-h-0 {\n      max-height:0px!important\n    }\n\n    .md\\:max-h-full {\n      max-height: 100%!important\n    }\n\n    .md\\:max-h-screen {\n      max-height: 100vh!important\n    }\n\n    .md\\:max-h-min {\n      max-height: min-content!important\n    }\n\n    .md\\:max-h-max {\n      max-height: max-content!important\n    }\n\n    .md\\:max-h-fit {\n      max-height: -moz-fit-content!important;\n      max-height: fit-content!important\n    }\n\n    .md\\:max-h-1rem {\n      max-height: 1rem!important\n    }\n\n    .md\\:max-h-2rem {\n      max-height: 2rem!important\n    }\n\n    .md\\:max-h-3rem {\n      max-height: 3rem!important\n    }\n\n    .md\\:max-h-4rem {\n      max-height: 4rem!important\n    }\n\n    .md\\:max-h-5rem {\n      max-height: 5rem!important\n    }\n\n    .md\\:max-h-6rem {\n      max-height: 6rem!important\n    }\n\n    .md\\:max-h-7rem {\n      max-height: 7rem!important\n    }\n\n    .md\\:max-h-8rem {\n      max-height: 8rem!important\n    }\n\n    .md\\:max-h-9rem {\n      max-height: 9rem!important\n    }\n\n    .md\\:max-h-10rem {\n      max-height: 10rem!important\n    }\n\n    .md\\:max-h-11rem {\n      max-height: 11rem!important\n    }\n\n    .md\\:max-h-12rem {\n      max-height: 12rem!important\n    }\n\n    .md\\:max-h-13rem {\n      max-height: 13rem!important\n    }\n\n    .md\\:max-h-14rem {\n      max-height: 14rem!important\n    }\n\n    .md\\:max-h-15rem {\n      max-height: 15rem!important\n    }\n\n    .md\\:max-h-16rem {\n      max-height: 16rem!important\n    }\n\n    .md\\:max-h-17rem {\n      max-height: 17rem!important\n    }\n\n    .md\\:max-h-18rem {\n      max-height: 18rem!important\n    }\n\n    .md\\:max-h-19rem {\n      max-height: 19rem!important\n    }\n\n    .md\\:max-h-20rem {\n      max-height: 20rem!important\n    }\n\n    .md\\:max-h-21rem {\n      max-height: 21rem!important\n    }\n\n    .md\\:max-h-22rem {\n      max-height: 22rem!important\n    }\n\n    .md\\:max-h-23rem {\n      max-height: 23rem!important\n    }\n\n    .md\\:max-h-24rem {\n      max-height: 24rem!important\n    }\n\n    .md\\:max-h-25rem {\n      max-height: 25rem!important\n    }\n\n    .md\\:max-h-26rem {\n      max-height: 26rem!important\n    }\n\n    .md\\:max-h-27rem {\n      max-height: 27rem!important\n    }\n\n    .md\\:max-h-28rem {\n      max-height: 28rem!important\n    }\n\n    .md\\:max-h-29rem {\n      max-height: 29rem!important\n    }\n\n    .md\\:max-h-30rem {\n      max-height: 30rem!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:max-h-0 {\n      max-height:0px!important\n    }\n\n    .lg\\:max-h-full {\n      max-height: 100%!important\n    }\n\n    .lg\\:max-h-screen {\n      max-height: 100vh!important\n    }\n\n    .lg\\:max-h-min {\n      max-height: min-content!important\n    }\n\n    .lg\\:max-h-max {\n      max-height: max-content!important\n    }\n\n    .lg\\:max-h-fit {\n      max-height: -moz-fit-content!important;\n      max-height: fit-content!important\n    }\n\n    .lg\\:max-h-1rem {\n      max-height: 1rem!important\n    }\n\n    .lg\\:max-h-2rem {\n      max-height: 2rem!important\n    }\n\n    .lg\\:max-h-3rem {\n      max-height: 3rem!important\n    }\n\n    .lg\\:max-h-4rem {\n      max-height: 4rem!important\n    }\n\n    .lg\\:max-h-5rem {\n      max-height: 5rem!important\n    }\n\n    .lg\\:max-h-6rem {\n      max-height: 6rem!important\n    }\n\n    .lg\\:max-h-7rem {\n      max-height: 7rem!important\n    }\n\n    .lg\\:max-h-8rem {\n      max-height: 8rem!important\n    }\n\n    .lg\\:max-h-9rem {\n      max-height: 9rem!important\n    }\n\n    .lg\\:max-h-10rem {\n      max-height: 10rem!important\n    }\n\n    .lg\\:max-h-11rem {\n      max-height: 11rem!important\n    }\n\n    .lg\\:max-h-12rem {\n      max-height: 12rem!important\n    }\n\n    .lg\\:max-h-13rem {\n      max-height: 13rem!important\n    }\n\n    .lg\\:max-h-14rem {\n      max-height: 14rem!important\n    }\n\n    .lg\\:max-h-15rem {\n      max-height: 15rem!important\n    }\n\n    .lg\\:max-h-16rem {\n      max-height: 16rem!important\n    }\n\n    .lg\\:max-h-17rem {\n      max-height: 17rem!important\n    }\n\n    .lg\\:max-h-18rem {\n      max-height: 18rem!important\n    }\n\n    .lg\\:max-h-19rem {\n      max-height: 19rem!important\n    }\n\n    .lg\\:max-h-20rem {\n      max-height: 20rem!important\n    }\n\n    .lg\\:max-h-21rem {\n      max-height: 21rem!important\n    }\n\n    .lg\\:max-h-22rem {\n      max-height: 22rem!important\n    }\n\n    .lg\\:max-h-23rem {\n      max-height: 23rem!important\n    }\n\n    .lg\\:max-h-24rem {\n      max-height: 24rem!important\n    }\n\n    .lg\\:max-h-25rem {\n      max-height: 25rem!important\n    }\n\n    .lg\\:max-h-26rem {\n      max-height: 26rem!important\n    }\n\n    .lg\\:max-h-27rem {\n      max-height: 27rem!important\n    }\n\n    .lg\\:max-h-28rem {\n      max-height: 28rem!important\n    }\n\n    .lg\\:max-h-29rem {\n      max-height: 29rem!important\n    }\n\n    .lg\\:max-h-30rem {\n      max-height: 30rem!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:max-h-0 {\n      max-height:0px!important\n    }\n\n    .xl\\:max-h-full {\n      max-height: 100%!important\n    }\n\n    .xl\\:max-h-screen {\n      max-height: 100vh!important\n    }\n\n    .xl\\:max-h-min {\n      max-height: min-content!important\n    }\n\n    .xl\\:max-h-max {\n      max-height: max-content!important\n    }\n\n    .xl\\:max-h-fit {\n      max-height: -moz-fit-content!important;\n      max-height: fit-content!important\n    }\n\n    .xl\\:max-h-1rem {\n      max-height: 1rem!important\n    }\n\n    .xl\\:max-h-2rem {\n      max-height: 2rem!important\n    }\n\n    .xl\\:max-h-3rem {\n      max-height: 3rem!important\n    }\n\n    .xl\\:max-h-4rem {\n      max-height: 4rem!important\n    }\n\n    .xl\\:max-h-5rem {\n      max-height: 5rem!important\n    }\n\n    .xl\\:max-h-6rem {\n      max-height: 6rem!important\n    }\n\n    .xl\\:max-h-7rem {\n      max-height: 7rem!important\n    }\n\n    .xl\\:max-h-8rem {\n      max-height: 8rem!important\n    }\n\n    .xl\\:max-h-9rem {\n      max-height: 9rem!important\n    }\n\n    .xl\\:max-h-10rem {\n      max-height: 10rem!important\n    }\n\n    .xl\\:max-h-11rem {\n      max-height: 11rem!important\n    }\n\n    .xl\\:max-h-12rem {\n      max-height: 12rem!important\n    }\n\n    .xl\\:max-h-13rem {\n      max-height: 13rem!important\n    }\n\n    .xl\\:max-h-14rem {\n      max-height: 14rem!important\n    }\n\n    .xl\\:max-h-15rem {\n      max-height: 15rem!important\n    }\n\n    .xl\\:max-h-16rem {\n      max-height: 16rem!important\n    }\n\n    .xl\\:max-h-17rem {\n      max-height: 17rem!important\n    }\n\n    .xl\\:max-h-18rem {\n      max-height: 18rem!important\n    }\n\n    .xl\\:max-h-19rem {\n      max-height: 19rem!important\n    }\n\n    .xl\\:max-h-20rem {\n      max-height: 20rem!important\n    }\n\n    .xl\\:max-h-21rem {\n      max-height: 21rem!important\n    }\n\n    .xl\\:max-h-22rem {\n      max-height: 22rem!important\n    }\n\n    .xl\\:max-h-23rem {\n      max-height: 23rem!important\n    }\n\n    .xl\\:max-h-24rem {\n      max-height: 24rem!important\n    }\n\n    .xl\\:max-h-25rem {\n      max-height: 25rem!important\n    }\n\n    .xl\\:max-h-26rem {\n      max-height: 26rem!important\n    }\n\n    .xl\\:max-h-27rem {\n      max-height: 27rem!important\n    }\n\n    .xl\\:max-h-28rem {\n      max-height: 28rem!important\n    }\n\n    .xl\\:max-h-29rem {\n      max-height: 29rem!important\n    }\n\n    .xl\\:max-h-30rem {\n      max-height: 30rem!important\n    }\n  }\n\n  .static {\n    position: static!important\n  }\n\n  .fixed {\n    position: fixed!important\n  }\n\n  .absolute {\n    position: absolute!important\n  }\n\n  .relative {\n    position: relative!important\n  }\n\n  .sticky {\n    position: sticky!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:static {\n      position:static!important\n    }\n\n    .sm\\:fixed {\n      position: fixed!important\n    }\n\n    .sm\\:absolute {\n      position: absolute!important\n    }\n\n    .sm\\:relative {\n      position: relative!important\n    }\n\n    .sm\\:sticky {\n      position: sticky!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:static {\n      position:static!important\n    }\n\n    .md\\:fixed {\n      position: fixed!important\n    }\n\n    .md\\:absolute {\n      position: absolute!important\n    }\n\n    .md\\:relative {\n      position: relative!important\n    }\n\n    .md\\:sticky {\n      position: sticky!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:static {\n      position:static!important\n    }\n\n    .lg\\:fixed {\n      position: fixed!important\n    }\n\n    .lg\\:absolute {\n      position: absolute!important\n    }\n\n    .lg\\:relative {\n      position: relative!important\n    }\n\n    .lg\\:sticky {\n      position: sticky!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:static {\n      position:static!important\n    }\n\n    .xl\\:fixed {\n      position: fixed!important\n    }\n\n    .xl\\:absolute {\n      position: absolute!important\n    }\n\n    .xl\\:relative {\n      position: relative!important\n    }\n\n    .xl\\:sticky {\n      position: sticky!important\n    }\n  }\n\n  .top-auto {\n    top: auto!important\n  }\n\n  .top-0 {\n    top: 0!important\n  }\n\n  .top-50 {\n    top: 50%!important\n  }\n\n  .top-100 {\n    top: 100%!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:top-auto {\n      top:auto!important\n    }\n\n    .sm\\:top-0 {\n      top: 0!important\n    }\n\n    .sm\\:top-50 {\n      top: 50%!important\n    }\n\n    .sm\\:top-100 {\n      top: 100%!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:top-auto {\n      top:auto!important\n    }\n\n    .md\\:top-0 {\n      top: 0!important\n    }\n\n    .md\\:top-50 {\n      top: 50%!important\n    }\n\n    .md\\:top-100 {\n      top: 100%!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:top-auto {\n      top:auto!important\n    }\n\n    .lg\\:top-0 {\n      top: 0!important\n    }\n\n    .lg\\:top-50 {\n      top: 50%!important\n    }\n\n    .lg\\:top-100 {\n      top: 100%!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:top-auto {\n      top:auto!important\n    }\n\n    .xl\\:top-0 {\n      top: 0!important\n    }\n\n    .xl\\:top-50 {\n      top: 50%!important\n    }\n\n    .xl\\:top-100 {\n      top: 100%!important\n    }\n  }\n\n  .left-auto {\n    left: auto!important\n  }\n\n  .left-0 {\n    left: 0!important\n  }\n\n  .left-50 {\n    left: 50%!important\n  }\n\n  .left-100 {\n    left: 100%!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:left-auto {\n      left:auto!important\n    }\n\n    .sm\\:left-0 {\n      left: 0!important\n    }\n\n    .sm\\:left-50 {\n      left: 50%!important\n    }\n\n    .sm\\:left-100 {\n      left: 100%!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:left-auto {\n      left:auto!important\n    }\n\n    .md\\:left-0 {\n      left: 0!important\n    }\n\n    .md\\:left-50 {\n      left: 50%!important\n    }\n\n    .md\\:left-100 {\n      left: 100%!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:left-auto {\n      left:auto!important\n    }\n\n    .lg\\:left-0 {\n      left: 0!important\n    }\n\n    .lg\\:left-50 {\n      left: 50%!important\n    }\n\n    .lg\\:left-100 {\n      left: 100%!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:left-auto {\n      left:auto!important\n    }\n\n    .xl\\:left-0 {\n      left: 0!important\n    }\n\n    .xl\\:left-50 {\n      left: 50%!important\n    }\n\n    .xl\\:left-100 {\n      left: 100%!important\n    }\n  }\n\n  .right-auto {\n    right: auto!important\n  }\n\n  .right-0 {\n    right: 0!important\n  }\n\n  .right-50 {\n    right: 50%!important\n  }\n\n  .right-100 {\n    right: 100%!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:right-auto {\n      right:auto!important\n    }\n\n    .sm\\:right-0 {\n      right: 0!important\n    }\n\n    .sm\\:right-50 {\n      right: 50%!important\n    }\n\n    .sm\\:right-100 {\n      right: 100%!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:right-auto {\n      right:auto!important\n    }\n\n    .md\\:right-0 {\n      right: 0!important\n    }\n\n    .md\\:right-50 {\n      right: 50%!important\n    }\n\n    .md\\:right-100 {\n      right: 100%!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:right-auto {\n      right:auto!important\n    }\n\n    .lg\\:right-0 {\n      right: 0!important\n    }\n\n    .lg\\:right-50 {\n      right: 50%!important\n    }\n\n    .lg\\:right-100 {\n      right: 100%!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:right-auto {\n      right:auto!important\n    }\n\n    .xl\\:right-0 {\n      right: 0!important\n    }\n\n    .xl\\:right-50 {\n      right: 50%!important\n    }\n\n    .xl\\:right-100 {\n      right: 100%!important\n    }\n  }\n\n  .bottom-auto {\n    bottom: auto!important\n  }\n\n  .bottom-0 {\n    bottom: 0!important\n  }\n\n  .bottom-50 {\n    bottom: 50%!important\n  }\n\n  .bottom-100 {\n    bottom: 100%!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:bottom-auto {\n      bottom:auto!important\n    }\n\n    .sm\\:bottom-0 {\n      bottom: 0!important\n    }\n\n    .sm\\:bottom-50 {\n      bottom: 50%!important\n    }\n\n    .sm\\:bottom-100 {\n      bottom: 100%!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:bottom-auto {\n      bottom:auto!important\n    }\n\n    .md\\:bottom-0 {\n      bottom: 0!important\n    }\n\n    .md\\:bottom-50 {\n      bottom: 50%!important\n    }\n\n    .md\\:bottom-100 {\n      bottom: 100%!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:bottom-auto {\n      bottom:auto!important\n    }\n\n    .lg\\:bottom-0 {\n      bottom: 0!important\n    }\n\n    .lg\\:bottom-50 {\n      bottom: 50%!important\n    }\n\n    .lg\\:bottom-100 {\n      bottom: 100%!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:bottom-auto {\n      bottom:auto!important\n    }\n\n    .xl\\:bottom-0 {\n      bottom: 0!important\n    }\n\n    .xl\\:bottom-50 {\n      bottom: 50%!important\n    }\n\n    .xl\\:bottom-100 {\n      bottom: 100%!important\n    }\n  }\n\n  .overflow-auto {\n    overflow: auto!important\n  }\n\n  .overflow-hidden {\n    overflow: hidden!important\n  }\n\n  .overflow-visible {\n    overflow: visible!important\n  }\n\n  .overflow-scroll {\n    overflow: scroll!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:overflow-auto {\n      overflow:auto!important\n    }\n\n    .sm\\:overflow-hidden {\n      overflow: hidden!important\n    }\n\n    .sm\\:overflow-visible {\n      overflow: visible!important\n    }\n\n    .sm\\:overflow-scroll {\n      overflow: scroll!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:overflow-auto {\n      overflow:auto!important\n    }\n\n    .md\\:overflow-hidden {\n      overflow: hidden!important\n    }\n\n    .md\\:overflow-visible {\n      overflow: visible!important\n    }\n\n    .md\\:overflow-scroll {\n      overflow: scroll!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:overflow-auto {\n      overflow:auto!important\n    }\n\n    .lg\\:overflow-hidden {\n      overflow: hidden!important\n    }\n\n    .lg\\:overflow-visible {\n      overflow: visible!important\n    }\n\n    .lg\\:overflow-scroll {\n      overflow: scroll!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:overflow-auto {\n      overflow:auto!important\n    }\n\n    .xl\\:overflow-hidden {\n      overflow: hidden!important\n    }\n\n    .xl\\:overflow-visible {\n      overflow: visible!important\n    }\n\n    .xl\\:overflow-scroll {\n      overflow: scroll!important\n    }\n  }\n\n  .overflow-x-auto {\n    overflow-x: auto!important\n  }\n\n  .overflow-x-hidden {\n    overflow-x: hidden!important\n  }\n\n  .overflow-x-visible {\n    overflow-x: visible!important\n  }\n\n  .overflow-x-scroll {\n    overflow-x: scroll!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:overflow-x-auto {\n      overflow-x:auto!important\n    }\n\n    .sm\\:overflow-x-hidden {\n      overflow-x: hidden!important\n    }\n\n    .sm\\:overflow-x-visible {\n      overflow-x: visible!important\n    }\n\n    .sm\\:overflow-x-scroll {\n      overflow-x: scroll!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:overflow-x-auto {\n      overflow-x:auto!important\n    }\n\n    .md\\:overflow-x-hidden {\n      overflow-x: hidden!important\n    }\n\n    .md\\:overflow-x-visible {\n      overflow-x: visible!important\n    }\n\n    .md\\:overflow-x-scroll {\n      overflow-x: scroll!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:overflow-x-auto {\n      overflow-x:auto!important\n    }\n\n    .lg\\:overflow-x-hidden {\n      overflow-x: hidden!important\n    }\n\n    .lg\\:overflow-x-visible {\n      overflow-x: visible!important\n    }\n\n    .lg\\:overflow-x-scroll {\n      overflow-x: scroll!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:overflow-x-auto {\n      overflow-x:auto!important\n    }\n\n    .xl\\:overflow-x-hidden {\n      overflow-x: hidden!important\n    }\n\n    .xl\\:overflow-x-visible {\n      overflow-x: visible!important\n    }\n\n    .xl\\:overflow-x-scroll {\n      overflow-x: scroll!important\n    }\n  }\n\n  .overflow-y-auto {\n    overflow-y: auto!important\n  }\n\n  .overflow-y-hidden {\n    overflow-y: hidden!important\n  }\n\n  .overflow-y-visible {\n    overflow-y: visible!important\n  }\n\n  .overflow-y-scroll {\n    overflow-y: scroll!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:overflow-y-auto {\n      overflow-y:auto!important\n    }\n\n    .sm\\:overflow-y-hidden {\n      overflow-y: hidden!important\n    }\n\n    .sm\\:overflow-y-visible {\n      overflow-y: visible!important\n    }\n\n    .sm\\:overflow-y-scroll {\n      overflow-y: scroll!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:overflow-y-auto {\n      overflow-y:auto!important\n    }\n\n    .md\\:overflow-y-hidden {\n      overflow-y: hidden!important\n    }\n\n    .md\\:overflow-y-visible {\n      overflow-y: visible!important\n    }\n\n    .md\\:overflow-y-scroll {\n      overflow-y: scroll!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:overflow-y-auto {\n      overflow-y:auto!important\n    }\n\n    .lg\\:overflow-y-hidden {\n      overflow-y: hidden!important\n    }\n\n    .lg\\:overflow-y-visible {\n      overflow-y: visible!important\n    }\n\n    .lg\\:overflow-y-scroll {\n      overflow-y: scroll!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:overflow-y-auto {\n      overflow-y:auto!important\n    }\n\n    .xl\\:overflow-y-hidden {\n      overflow-y: hidden!important\n    }\n\n    .xl\\:overflow-y-visible {\n      overflow-y: visible!important\n    }\n\n    .xl\\:overflow-y-scroll {\n      overflow-y: scroll!important\n    }\n  }\n\n  .z-auto {\n    z-index: auto!important\n  }\n\n  .z-0 {\n    z-index: 0!important\n  }\n\n  .z-1 {\n    z-index: 1!important\n  }\n\n  .z-2 {\n    z-index: 2!important\n  }\n\n  .z-3 {\n    z-index: 3!important\n  }\n\n  .z-4 {\n    z-index: 4!important\n  }\n\n  .z-5 {\n    z-index: 5!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:z-auto {\n      z-index:auto!important\n    }\n\n    .sm\\:z-0 {\n      z-index: 0!important\n    }\n\n    .sm\\:z-1 {\n      z-index: 1!important\n    }\n\n    .sm\\:z-2 {\n      z-index: 2!important\n    }\n\n    .sm\\:z-3 {\n      z-index: 3!important\n    }\n\n    .sm\\:z-4 {\n      z-index: 4!important\n    }\n\n    .sm\\:z-5 {\n      z-index: 5!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:z-auto {\n      z-index:auto!important\n    }\n\n    .md\\:z-0 {\n      z-index: 0!important\n    }\n\n    .md\\:z-1 {\n      z-index: 1!important\n    }\n\n    .md\\:z-2 {\n      z-index: 2!important\n    }\n\n    .md\\:z-3 {\n      z-index: 3!important\n    }\n\n    .md\\:z-4 {\n      z-index: 4!important\n    }\n\n    .md\\:z-5 {\n      z-index: 5!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:z-auto {\n      z-index:auto!important\n    }\n\n    .lg\\:z-0 {\n      z-index: 0!important\n    }\n\n    .lg\\:z-1 {\n      z-index: 1!important\n    }\n\n    .lg\\:z-2 {\n      z-index: 2!important\n    }\n\n    .lg\\:z-3 {\n      z-index: 3!important\n    }\n\n    .lg\\:z-4 {\n      z-index: 4!important\n    }\n\n    .lg\\:z-5 {\n      z-index: 5!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:z-auto {\n      z-index:auto!important\n    }\n\n    .xl\\:z-0 {\n      z-index: 0!important\n    }\n\n    .xl\\:z-1 {\n      z-index: 1!important\n    }\n\n    .xl\\:z-2 {\n      z-index: 2!important\n    }\n\n    .xl\\:z-3 {\n      z-index: 3!important\n    }\n\n    .xl\\:z-4 {\n      z-index: 4!important\n    }\n\n    .xl\\:z-5 {\n      z-index: 5!important\n    }\n  }\n\n  .bg-repeat {\n    background-repeat: repeat!important\n  }\n\n  .bg-no-repeat {\n    background-repeat: no-repeat!important\n  }\n\n  .bg-repeat-x {\n    background-repeat: repeat-x!important\n  }\n\n  .bg-repeat-y {\n    background-repeat: repeat-y!important\n  }\n\n  .bg-repeat-round {\n    background-repeat: round!important\n  }\n\n  .bg-repeat-space {\n    background-repeat: space!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:bg-repeat {\n      background-repeat:repeat!important\n    }\n\n    .sm\\:bg-no-repeat {\n      background-repeat: no-repeat!important\n    }\n\n    .sm\\:bg-repeat-x {\n      background-repeat: repeat-x!important\n    }\n\n    .sm\\:bg-repeat-y {\n      background-repeat: repeat-y!important\n    }\n\n    .sm\\:bg-repeat-round {\n      background-repeat: round!important\n    }\n\n    .sm\\:bg-repeat-space {\n      background-repeat: space!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:bg-repeat {\n      background-repeat:repeat!important\n    }\n\n    .md\\:bg-no-repeat {\n      background-repeat: no-repeat!important\n    }\n\n    .md\\:bg-repeat-x {\n      background-repeat: repeat-x!important\n    }\n\n    .md\\:bg-repeat-y {\n      background-repeat: repeat-y!important\n    }\n\n    .md\\:bg-repeat-round {\n      background-repeat: round!important\n    }\n\n    .md\\:bg-repeat-space {\n      background-repeat: space!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:bg-repeat {\n      background-repeat:repeat!important\n    }\n\n    .lg\\:bg-no-repeat {\n      background-repeat: no-repeat!important\n    }\n\n    .lg\\:bg-repeat-x {\n      background-repeat: repeat-x!important\n    }\n\n    .lg\\:bg-repeat-y {\n      background-repeat: repeat-y!important\n    }\n\n    .lg\\:bg-repeat-round {\n      background-repeat: round!important\n    }\n\n    .lg\\:bg-repeat-space {\n      background-repeat: space!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:bg-repeat {\n      background-repeat:repeat!important\n    }\n\n    .xl\\:bg-no-repeat {\n      background-repeat: no-repeat!important\n    }\n\n    .xl\\:bg-repeat-x {\n      background-repeat: repeat-x!important\n    }\n\n    .xl\\:bg-repeat-y {\n      background-repeat: repeat-y!important\n    }\n\n    .xl\\:bg-repeat-round {\n      background-repeat: round!important\n    }\n\n    .xl\\:bg-repeat-space {\n      background-repeat: space!important\n    }\n  }\n\n  .bg-auto {\n    background-size: auto!important\n  }\n\n  .bg-cover {\n    background-size: cover!important\n  }\n\n  .bg-contain {\n    background-size: contain!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:bg-auto {\n      background-size:auto!important\n    }\n\n    .sm\\:bg-cover {\n      background-size: cover!important\n    }\n\n    .sm\\:bg-contain {\n      background-size: contain!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:bg-auto {\n      background-size:auto!important\n    }\n\n    .md\\:bg-cover {\n      background-size: cover!important\n    }\n\n    .md\\:bg-contain {\n      background-size: contain!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:bg-auto {\n      background-size:auto!important\n    }\n\n    .lg\\:bg-cover {\n      background-size: cover!important\n    }\n\n    .lg\\:bg-contain {\n      background-size: contain!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:bg-auto {\n      background-size:auto!important\n    }\n\n    .xl\\:bg-cover {\n      background-size: cover!important\n    }\n\n    .xl\\:bg-contain {\n      background-size: contain!important\n    }\n  }\n\n  .bg-bottom {\n    background-position: bottom!important\n  }\n\n  .bg-center {\n    background-position: center!important\n  }\n\n  .bg-left {\n    background-position: left!important\n  }\n\n  .bg-left-bottom {\n    background-position: left bottom!important\n  }\n\n  .bg-left-top {\n    background-position: left top!important\n  }\n\n  .bg-right {\n    background-position: right!important\n  }\n\n  .bg-right-bottom {\n    background-position: right bottom!important\n  }\n\n  .bg-right-top {\n    background-position: right top!important\n  }\n\n  .bg-top {\n    background-position: top!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:bg-bottom {\n      background-position:bottom!important\n    }\n\n    .sm\\:bg-center {\n      background-position: center!important\n    }\n\n    .sm\\:bg-left {\n      background-position: left!important\n    }\n\n    .sm\\:bg-left-bottom {\n      background-position: left bottom!important\n    }\n\n    .sm\\:bg-left-top {\n      background-position: left top!important\n    }\n\n    .sm\\:bg-right {\n      background-position: right!important\n    }\n\n    .sm\\:bg-right-bottom {\n      background-position: right bottom!important\n    }\n\n    .sm\\:bg-right-top {\n      background-position: right top!important\n    }\n\n    .sm\\:bg-top {\n      background-position: top!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:bg-bottom {\n      background-position:bottom!important\n    }\n\n    .md\\:bg-center {\n      background-position: center!important\n    }\n\n    .md\\:bg-left {\n      background-position: left!important\n    }\n\n    .md\\:bg-left-bottom {\n      background-position: left bottom!important\n    }\n\n    .md\\:bg-left-top {\n      background-position: left top!important\n    }\n\n    .md\\:bg-right {\n      background-position: right!important\n    }\n\n    .md\\:bg-right-bottom {\n      background-position: right bottom!important\n    }\n\n    .md\\:bg-right-top {\n      background-position: right top!important\n    }\n\n    .md\\:bg-top {\n      background-position: top!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:bg-bottom {\n      background-position:bottom!important\n    }\n\n    .lg\\:bg-center {\n      background-position: center!important\n    }\n\n    .lg\\:bg-left {\n      background-position: left!important\n    }\n\n    .lg\\:bg-left-bottom {\n      background-position: left bottom!important\n    }\n\n    .lg\\:bg-left-top {\n      background-position: left top!important\n    }\n\n    .lg\\:bg-right {\n      background-position: right!important\n    }\n\n    .lg\\:bg-right-bottom {\n      background-position: right bottom!important\n    }\n\n    .lg\\:bg-right-top {\n      background-position: right top!important\n    }\n\n    .lg\\:bg-top {\n      background-position: top!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:bg-bottom {\n      background-position:bottom!important\n    }\n\n    .xl\\:bg-center {\n      background-position: center!important\n    }\n\n    .xl\\:bg-left {\n      background-position: left!important\n    }\n\n    .xl\\:bg-left-bottom {\n      background-position: left bottom!important\n    }\n\n    .xl\\:bg-left-top {\n      background-position: left top!important\n    }\n\n    .xl\\:bg-right {\n      background-position: right!important\n    }\n\n    .xl\\:bg-right-bottom {\n      background-position: right bottom!important\n    }\n\n    .xl\\:bg-right-top {\n      background-position: right top!important\n    }\n\n    .xl\\:bg-top {\n      background-position: top!important\n    }\n  }\n\n  .list-none {\n    list-style: none!important\n  }\n\n  .list-disc {\n    list-style: disc!important\n  }\n\n  .list-decimal {\n    list-style: decimal!important\n  }\n\n  .appearance-none {\n    appearance: none!important\n  }\n\n  .outline-none {\n    outline: none!important\n  }\n\n  .pointer-events-none {\n    pointer-events: none!important\n  }\n\n  .pointer-events-auto {\n    pointer-events: auto!important\n  }\n\n  .cursor-auto {\n    cursor: auto!important\n  }\n\n  .cursor-pointer {\n    cursor: pointer!important\n  }\n\n  .cursor-wait {\n    cursor: wait!important\n  }\n\n  .cursor-move {\n    cursor: move!important\n  }\n\n  .select-none {\n    -webkit-user-select: none!important;\n    user-select: none!important\n  }\n\n  .select-text {\n    -webkit-user-select: text!important;\n    user-select: text!important\n  }\n\n  .select-all {\n    -webkit-user-select: all!important;\n    user-select: all!important\n  }\n\n  .select-auto {\n    -webkit-user-select: auto!important;\n    user-select: auto!important\n  }\n\n  .opacity-0 {\n    opacity: 0!important\n  }\n\n  .opacity-10 {\n    opacity: .1!important\n  }\n\n  .opacity-20 {\n    opacity: .2!important\n  }\n\n  .opacity-30 {\n    opacity: .3!important\n  }\n\n  .opacity-40 {\n    opacity: .4!important\n  }\n\n  .opacity-50 {\n    opacity: .5!important\n  }\n\n  .opacity-60 {\n    opacity: .6!important\n  }\n\n  .opacity-70 {\n    opacity: .7!important\n  }\n\n  .opacity-80 {\n    opacity: .8!important\n  }\n\n  .opacity-90 {\n    opacity: .9!important\n  }\n\n  .opacity-100 {\n    opacity: 1!important\n  }\n\n  .reset {\n    all: unset\n  }\n\n  .transition-none {\n    transition-property: none!important\n  }\n\n  .transition-all {\n    transition-property: all!important\n  }\n\n  .transition-colors {\n    transition-property: background-color,border-color,color!important\n  }\n\n  .transition-transform {\n    transition-property: transform!important\n  }\n\n  .transition-duration-100 {\n    transition-duration: .1s!important\n  }\n\n  .transition-duration-150 {\n    transition-duration: .15s!important\n  }\n\n  .transition-duration-200 {\n    transition-duration: .2s!important\n  }\n\n  .transition-duration-300 {\n    transition-duration: .3s!important\n  }\n\n  .transition-duration-400 {\n    transition-duration: .4s!important\n  }\n\n  .transition-duration-500 {\n    transition-duration: .5s!important\n  }\n\n  .transition-duration-1000 {\n    transition-duration: 1s!important\n  }\n\n  .transition-duration-2000 {\n    transition-duration: 2s!important\n  }\n\n  .transition-duration-3000 {\n    transition-duration: 3s!important\n  }\n\n  .transition-linear {\n    transition-timing-function: linear!important\n  }\n\n  .transition-ease-in {\n    transition-timing-function: cubic-bezier(.4,0,1,1)!important\n  }\n\n  .transition-ease-out {\n    transition-timing-function: cubic-bezier(0,0,.2,1)!important\n  }\n\n  .transition-ease-in-out {\n    transition-timing-function: cubic-bezier(.4,0,.2,1)!important\n  }\n\n  .transition-delay-100 {\n    transition-delay: .1s!important\n  }\n\n  .transition-delay-150 {\n    transition-delay: .15s!important\n  }\n\n  .transition-delay-200 {\n    transition-delay: .2s!important\n  }\n\n  .transition-delay-300 {\n    transition-delay: .3s!important\n  }\n\n  .transition-delay-400 {\n    transition-delay: .4s!important\n  }\n\n  .transition-delay-500 {\n    transition-delay: .5s!important\n  }\n\n  .transition-delay-1000 {\n    transition-delay: 1s!important\n  }\n\n  .translate-x-0 {\n    transform: translate(0)!important\n  }\n\n  .translate-x-100 {\n    transform: translate(100%)!important\n  }\n\n  .-translate-x-100 {\n    transform: translate(-100%)!important\n  }\n\n  .translate-y-0 {\n    transform: translateY(0)!important\n  }\n\n  .translate-y-100 {\n    transform: translateY(100%)!important\n  }\n\n  .-translate-y-100 {\n    transform: translateY(-100%)!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:translate-x-0 {\n      transform:translate(0)!important\n    }\n\n    .sm\\:translate-x-100 {\n      transform: translate(100%)!important\n    }\n\n    .sm\\:-translate-x-100 {\n      transform: translate(-100%)!important\n    }\n\n    .sm\\:translate-y-0 {\n      transform: translateY(0)!important\n    }\n\n    .sm\\:translate-y-100 {\n      transform: translateY(100%)!important\n    }\n\n    .sm\\:-translate-y-100 {\n      transform: translateY(-100%)!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:translate-x-0 {\n      transform:translate(0)!important\n    }\n\n    .md\\:translate-x-100 {\n      transform: translate(100%)!important\n    }\n\n    .md\\:-translate-x-100 {\n      transform: translate(-100%)!important\n    }\n\n    .md\\:translate-y-0 {\n      transform: translateY(0)!important\n    }\n\n    .md\\:translate-y-100 {\n      transform: translateY(100%)!important\n    }\n\n    .md\\:-translate-y-100 {\n      transform: translateY(-100%)!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:translate-x-0 {\n      transform:translate(0)!important\n    }\n\n    .lg\\:translate-x-100 {\n      transform: translate(100%)!important\n    }\n\n    .lg\\:-translate-x-100 {\n      transform: translate(-100%)!important\n    }\n\n    .lg\\:translate-y-0 {\n      transform: translateY(0)!important\n    }\n\n    .lg\\:translate-y-100 {\n      transform: translateY(100%)!important\n    }\n\n    .lg\\:-translate-y-100 {\n      transform: translateY(-100%)!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:translate-x-0 {\n      transform:translate(0)!important\n    }\n\n    .xl\\:translate-x-100 {\n      transform: translate(100%)!important\n    }\n\n    .xl\\:-translate-x-100 {\n      transform: translate(-100%)!important\n    }\n\n    .xl\\:translate-y-0 {\n      transform: translateY(0)!important\n    }\n\n    .xl\\:translate-y-100 {\n      transform: translateY(100%)!important\n    }\n\n    .xl\\:-translate-y-100 {\n      transform: translateY(-100%)!important\n    }\n  }\n\n  .rotate-45 {\n    transform: rotate(45deg)!important\n  }\n\n  .-rotate-45 {\n    transform: rotate(-45deg)!important\n  }\n\n  .rotate-90 {\n    transform: rotate(90deg)!important\n  }\n\n  .-rotate-90 {\n    transform: rotate(-90deg)!important\n  }\n\n  .rotate-180 {\n    transform: rotate(180deg)!important\n  }\n\n  .-rotate-180 {\n    transform: rotate(-180deg)!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:rotate-45 {\n      transform:rotate(45deg)!important\n    }\n\n    .sm\\:-rotate-45 {\n      transform: rotate(-45deg)!important\n    }\n\n    .sm\\:rotate-90 {\n      transform: rotate(90deg)!important\n    }\n\n    .sm\\:-rotate-90 {\n      transform: rotate(-90deg)!important\n    }\n\n    .sm\\:rotate-180 {\n      transform: rotate(180deg)!important\n    }\n\n    .sm\\:-rotate-180 {\n      transform: rotate(-180deg)!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:rotate-45 {\n      transform:rotate(45deg)!important\n    }\n\n    .md\\:-rotate-45 {\n      transform: rotate(-45deg)!important\n    }\n\n    .md\\:rotate-90 {\n      transform: rotate(90deg)!important\n    }\n\n    .md\\:-rotate-90 {\n      transform: rotate(-90deg)!important\n    }\n\n    .md\\:rotate-180 {\n      transform: rotate(180deg)!important\n    }\n\n    .md\\:-rotate-180 {\n      transform: rotate(-180deg)!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:rotate-45 {\n      transform:rotate(45deg)!important\n    }\n\n    .lg\\:-rotate-45 {\n      transform: rotate(-45deg)!important\n    }\n\n    .lg\\:rotate-90 {\n      transform: rotate(90deg)!important\n    }\n\n    .lg\\:-rotate-90 {\n      transform: rotate(-90deg)!important\n    }\n\n    .lg\\:rotate-180 {\n      transform: rotate(180deg)!important\n    }\n\n    .lg\\:-rotate-180 {\n      transform: rotate(-180deg)!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:rotate-45 {\n      transform:rotate(45deg)!important\n    }\n\n    .xl\\:-rotate-45 {\n      transform: rotate(-45deg)!important\n    }\n\n    .xl\\:rotate-90 {\n      transform: rotate(90deg)!important\n    }\n\n    .xl\\:-rotate-90 {\n      transform: rotate(-90deg)!important\n    }\n\n    .xl\\:rotate-180 {\n      transform: rotate(180deg)!important\n    }\n\n    .xl\\:-rotate-180 {\n      transform: rotate(-180deg)!important\n    }\n  }\n\n  .origin-center {\n    transform-origin: center!important\n  }\n\n  .origin-top {\n    transform-origin: top!important\n  }\n\n  .origin-top-right {\n    transform-origin: top right!important\n  }\n\n  .origin-right {\n    transform-origin: right!important\n  }\n\n  .origin-bottom-right {\n    transform-origin: bottom right!important\n  }\n\n  .origin-bottom {\n    transform-origin: bottom!important\n  }\n\n  .origin-bottom-left {\n    transform-origin: bottom left!important\n  }\n\n  .origin-left {\n    transform-origin: left!important\n  }\n\n  .origin-top-left {\n    transform-origin: top-left!important\n  }\n\n  @media only screen and (max-width: 600px) {\n    .sm\\:origin-center {\n      transform-origin:center!important\n    }\n\n    .sm\\:origin-top {\n      transform-origin: top!important\n    }\n\n    .sm\\:origin-top-right {\n      transform-origin: top right!important\n    }\n\n    .sm\\:origin-right {\n      transform-origin: right!important\n    }\n\n    .sm\\:origin-bottom-right {\n      transform-origin: bottom right!important\n    }\n\n    .sm\\:origin-bottom {\n      transform-origin: bottom!important\n    }\n\n    .sm\\:origin-bottom-left {\n      transform-origin: bottom left!important\n    }\n\n    .sm\\:origin-left {\n      transform-origin: left!important\n    }\n\n    .sm\\:origin-top-left {\n      transform-origin: top-left!important\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .md\\:origin-center {\n      transform-origin:center!important\n    }\n\n    .md\\:origin-top {\n      transform-origin: top!important\n    }\n\n    .md\\:origin-top-right {\n      transform-origin: top right!important\n    }\n\n    .md\\:origin-right {\n      transform-origin: right!important\n    }\n\n    .md\\:origin-bottom-right {\n      transform-origin: bottom right!important\n    }\n\n    .md\\:origin-bottom {\n      transform-origin: bottom!important\n    }\n\n    .md\\:origin-bottom-left {\n      transform-origin: bottom left!important\n    }\n\n    .md\\:origin-left {\n      transform-origin: left!important\n    }\n\n    .md\\:origin-top-left {\n      transform-origin: top-left!important\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .lg\\:origin-center {\n      transform-origin:center!important\n    }\n\n    .lg\\:origin-top {\n      transform-origin: top!important\n    }\n\n    .lg\\:origin-top-right {\n      transform-origin: top right!important\n    }\n\n    .lg\\:origin-right {\n      transform-origin: right!important\n    }\n\n    .lg\\:origin-bottom-right {\n      transform-origin: bottom right!important\n    }\n\n    .lg\\:origin-bottom {\n      transform-origin: bottom!important\n    }\n\n    .lg\\:origin-bottom-left {\n      transform-origin: bottom left!important\n    }\n\n    .lg\\:origin-left {\n      transform-origin: left!important\n    }\n\n    .lg\\:origin-top-left {\n      transform-origin: top-left!important\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .xl\\:origin-center {\n      transform-origin:center!important\n    }\n\n    .xl\\:origin-top {\n      transform-origin: top!important\n    }\n\n    .xl\\:origin-top-right {\n      transform-origin: top right!important\n    }\n\n    .xl\\:origin-right {\n      transform-origin: right!important\n    }\n\n    .xl\\:origin-bottom-right {\n      transform-origin: bottom right!important\n    }\n\n    .xl\\:origin-bottom {\n      transform-origin: bottom!important\n    }\n\n    .xl\\:origin-bottom-left {\n      transform-origin: bottom left!important\n    }\n\n    .xl\\:origin-left {\n      transform-origin: left!important\n    }\n\n    .xl\\:origin-top-left {\n      transform-origin: top-left!important\n    }\n  }\n\n  @keyframes fadein {\n    0% {\n      opacity: 0\n    }\n\n    to {\n      opacity: 1\n    }\n  }\n\n  @keyframes fadeout {\n    0% {\n      opacity: 1\n    }\n\n    to {\n      opacity: 0\n    }\n  }\n\n  @keyframes scalein {\n    0% {\n      opacity: 0;\n      transform: scaleY(.8);\n      transition: transform .12s cubic-bezier(0,0,.2,1),opacity .12s cubic-bezier(0,0,.2,1)\n    }\n\n    to {\n      opacity: 1;\n      transform: scaleY(1)\n    }\n  }\n\n  @keyframes slidedown {\n    0% {\n      max-height: 0\n    }\n\n    to {\n      max-height: auto\n    }\n  }\n\n  @keyframes slideup {\n    0% {\n      max-height: 1000px\n    }\n\n    to {\n      max-height: 0\n    }\n  }\n\n  @keyframes fadeinleft {\n    0% {\n      opacity: 0;\n      transform: translate(-100%);\n      transition: transform .12s cubic-bezier(0,0,.2,1),opacity .12s cubic-bezier(0,0,.2,1)\n    }\n\n    to {\n      opacity: 1;\n      transform: translate(0)\n    }\n  }\n\n  @keyframes fadeoutleft {\n    0% {\n      opacity: 1;\n      transform: translate(0);\n      transition: transform .12s cubic-bezier(0,0,.2,1),opacity .12s cubic-bezier(0,0,.2,1)\n    }\n\n    to {\n      opacity: 0;\n      transform: translate(-100%)\n    }\n  }\n\n  @keyframes fadeinright {\n    0% {\n      opacity: 0;\n      transform: translate(100%);\n      transition: transform .12s cubic-bezier(0,0,.2,1),opacity .12s cubic-bezier(0,0,.2,1)\n    }\n\n    to {\n      opacity: 1;\n      transform: translate(0)\n    }\n  }\n\n  @keyframes fadeoutright {\n    0% {\n      opacity: 1;\n      transform: translate(0);\n      transition: transform .12s cubic-bezier(0,0,.2,1),opacity .12s cubic-bezier(0,0,.2,1)\n    }\n\n    to {\n      opacity: 0;\n      transform: translate(100%)\n    }\n  }\n\n  @keyframes fadeinup {\n    0% {\n      opacity: 0;\n      transform: translateY(-100%);\n      transition: transform .12s cubic-bezier(0,0,.2,1),opacity .12s cubic-bezier(0,0,.2,1)\n    }\n\n    to {\n      opacity: 1;\n      transform: translateY(0)\n    }\n  }\n\n  @keyframes fadeoutup {\n    0% {\n      opacity: 1;\n      transform: translateY(0);\n      transition: transform .12s cubic-bezier(0,0,.2,1),opacity .12s cubic-bezier(0,0,.2,1)\n    }\n\n    to {\n      opacity: 0;\n      transform: translateY(-100%)\n    }\n  }\n\n  @keyframes fadeindown {\n    0% {\n      opacity: 0;\n      transform: translateY(100%);\n      transition: transform .12s cubic-bezier(0,0,.2,1),opacity .12s cubic-bezier(0,0,.2,1)\n    }\n\n    to {\n      opacity: 1;\n      transform: translateY(0)\n    }\n  }\n\n  @keyframes fadeoutdown {\n    0% {\n      opacity: 1;\n      transform: translateY(0);\n      transition: transform .12s cubic-bezier(0,0,.2,1),opacity .12s cubic-bezier(0,0,.2,1)\n    }\n\n    to {\n      opacity: 0;\n      transform: translateY(100%)\n    }\n  }\n\n  @keyframes animate-width {\n    0% {\n      width: 0\n    }\n\n    to {\n      width: 100%\n    }\n  }\n\n  @keyframes flip {\n    0% {\n      transform: perspective(2000px) rotateX(-100deg)\n    }\n\n    to {\n      transform: perspective(2000px) rotateX(0)\n    }\n  }\n\n  @keyframes flipleft {\n    0% {\n      transform: perspective(2000px) rotateY(-100deg);\n      opacity: 0\n    }\n\n    to {\n      transform: perspective(2000px) rotateY(0);\n      opacity: 1\n    }\n  }\n\n  @keyframes flipright {\n    0% {\n      transform: perspective(2000px) rotateY(100deg);\n      opacity: 0\n    }\n\n    to {\n      transform: perspective(2000px) rotateY(0);\n      opacity: 1\n    }\n  }\n\n  @keyframes flipup {\n    0% {\n      transform: perspective(2000px) rotateX(-100deg);\n      opacity: 0\n    }\n\n    to {\n      transform: perspective(2000px) rotateX(0);\n      opacity: 1\n    }\n  }\n\n  @keyframes zoomin {\n    0% {\n      opacity: 0;\n      transform: scale3d(.3,.3,.3)\n    }\n\n    50% {\n      opacity: 1\n    }\n  }\n\n  @keyframes zoomindown {\n    0% {\n      opacity: 0;\n      transform: scale3d(.1,.1,.1) translate3d(0,-1000px,0)\n    }\n\n    60% {\n      opacity: 1;\n      transform: scale3d(.475,.475,.475) translate3d(0,60px,0)\n    }\n  }\n\n  @keyframes zoominleft {\n    0% {\n      opacity: 0;\n      transform: scale3d(.1,.1,.1) translate3d(-1000px,0,0)\n    }\n\n    60% {\n      opacity: 1;\n      transform: scale3d(.475,.475,.475) translate3d(10px,0,0)\n    }\n  }\n\n  @keyframes zoominright {\n    0% {\n      opacity: 0;\n      transform: scale3d(.1,.1,.1) translate3d(1000px,0,0)\n    }\n\n    60% {\n      opacity: 1;\n      transform: scale3d(.475,.475,.475) translate3d(-10px,0,0)\n    }\n  }\n\n  @keyframes zoominup {\n    0% {\n      opacity: 0;\n      transform: scale3d(.1,.1,.1) translate3d(0,1000px,0)\n    }\n\n    60% {\n      opacity: 1;\n      transform: scale3d(.475,.475,.475) translate3d(0,-60px,0)\n    }\n  }\n\n  .fadein {\n    animation: fadein .15s linear\n  }\n\n  .fadeout {\n    animation: fadeout .15s linear\n  }\n\n  .slidedown {\n    animation: slidedown .45s ease-in-out\n  }\n\n  .slideup {\n    animation: slideup .45s cubic-bezier(0,1,0,1)\n  }\n\n  .scalein {\n    animation: scalein .15s linear\n  }\n\n  .fadeinleft {\n    animation: fadeinleft .15s linear\n  }\n\n  .fadeoutleft {\n    animation: fadeoutleft .15s linear\n  }\n\n  .fadeinright {\n    animation: fadeinright .15s linear\n  }\n\n  .fadeoutright {\n    animation: fadeoutright .15s linear\n  }\n\n  .fadeinup {\n    animation: fadeinup .15s linear\n  }\n\n  .fadeoutup {\n    animation: fadeoutup .15s linear\n  }\n\n  .fadeindown {\n    animation: fadeindown .15s linear\n  }\n\n  .fadeoutdown {\n    animation: fadeoutdown .15s linear\n  }\n\n  .animate-width {\n    animation: animate-width 1s linear\n  }\n\n  .flip {\n    backface-visibility: visible;\n    animation: flip .15s linear\n  }\n\n  .flipup {\n    backface-visibility: visible;\n    animation: flipup .15s linear\n  }\n\n  .flipleft {\n    backface-visibility: visible;\n    animation: flipleft .15s linear\n  }\n\n  .flipright {\n    backface-visibility: visible;\n    animation: flipright .15s linear\n  }\n\n  .zoomin {\n    animation: zoomin .15s linear\n  }\n\n  .zoomindown {\n    animation: zoomindown .15s linear\n  }\n\n  .zoominleft {\n    animation: zoominleft .15s linear\n  }\n\n  .zoominright {\n    animation: zoominright .15s linear\n  }\n\n  .zoominup {\n    animation: zoominup .15s linear\n  }\n\n  .animation-duration-100 {\n    animation-duration: .1s!important\n  }\n\n  .animation-duration-150 {\n    animation-duration: .15s!important\n  }\n\n  .animation-duration-200 {\n    animation-duration: .2s!important\n  }\n\n  .animation-duration-300 {\n    animation-duration: .3s!important\n  }\n\n  .animation-duration-400 {\n    animation-duration: .4s!important\n  }\n\n  .animation-duration-500 {\n    animation-duration: .5s!important\n  }\n\n  .animation-duration-1000 {\n    animation-duration: 1s!important\n  }\n\n  .animation-duration-2000 {\n    animation-duration: 2s!important\n  }\n\n  .animation-duration-3000 {\n    animation-duration: 3s!important\n  }\n\n  .animation-delay-100 {\n    animation-delay: .1s!important\n  }\n\n  .animation-delay-150 {\n    animation-delay: .15s!important\n  }\n\n  .animation-delay-200 {\n    animation-delay: .2s!important\n  }\n\n  .animation-delay-300 {\n    animation-delay: .3s!important\n  }\n\n  .animation-delay-400 {\n    animation-delay: .4s!important\n  }\n\n  .animation-delay-500 {\n    animation-delay: .5s!important\n  }\n\n  .animation-delay-1000 {\n    animation-delay: 1s!important\n  }\n\n  .animation-iteration-1 {\n    animation-iteration-count: 1!important\n  }\n\n  .animation-iteration-2 {\n    animation-iteration-count: 2!important\n  }\n\n  .animation-iteration-infinite {\n    animation-iteration-count: infinite!important\n  }\n\n  .animation-linear {\n    animation-timing-function: linear!important\n  }\n\n  .animation-ease-in {\n    animation-timing-function: cubic-bezier(.4,0,1,1)!important\n  }\n\n  .animation-ease-out {\n    animation-timing-function: cubic-bezier(0,0,.2,1)!important\n  }\n\n  .animation-ease-in-out {\n    animation-timing-function: cubic-bezier(.4,0,.2,1)!important\n  }\n\n  .animation-fill-none {\n    animation-fill-mode: none!important\n  }\n\n  .animation-fill-forwards {\n    animation-fill-mode: forwards!important\n  }\n\n  .animation-fill-backwards {\n    animation-fill-mode: backwards!important\n  }\n\n  .animation-fill-both {\n    animation-fill-mode: both!important\n  }\n\n  .product-badge {\n    border-radius: var(--border-radius);\n    padding: .25em .5rem;\n    text-transform: uppercase;\n    font-weight: 700;\n    font-size: 12px;\n    letter-spacing: .3px\n  }\n\n  .product-badge.status-instock {\n    background: var(--green-200);\n    color: var(--green-800)\n  }\n\n  .product-badge.status-outofstock {\n    background: var(--pink-200);\n    color: var(--pink-800)\n  }\n\n  .product-badge.status-lowstock {\n    background: var(--yellow-200);\n    color: var(--yellow-800)\n  }\n\n  .product-badge-text {\n    font-weight: 700;\n    font-size: 12px;\n    letter-spacing: .3px\n  }\n\n  .product-badge-text.status-instock {\n    color: var(--green-500)\n  }\n\n  .product-badge-text.status-outofstock {\n    color: var(--pink-500)\n  }\n\n  .product-badge-text.status-lowstock {\n    color: var(--yellow-500)\n  }\n\n  .customer-badge {\n    border-radius: var(--border-radius);\n    padding: .25em .5rem;\n    text-transform: uppercase;\n    font-weight: 700;\n    font-size: 12px;\n    letter-spacing: .3px\n  }\n\n  .customer-badge.status-qualified {\n    background: var(--green-200);\n    color: var(--green-800)\n  }\n\n  .customer-badge.status-unqualified {\n    background: var(--pink-200);\n    color: var(--pink-800)\n  }\n\n  .customer-badge.status-negotiation {\n    background: var(--yellow-200);\n    color: var(--yellow-800)\n  }\n\n  .customer-badge.status-new {\n    background: var(--blue-200);\n    color: var(--blue-800)\n  }\n\n  .customer-badge.status-renewal {\n    background: var(--purple-200);\n    color: var(--purple-800)\n  }\n\n  .customer-badge.status-proposal {\n    background: var(--orange-200);\n    color: var(--orange-800)\n  }\n\n  .order-badge {\n    border-radius: var(--border-radius);\n    padding: .25em .5rem;\n    text-transform: uppercase;\n    font-weight: 700;\n    font-size: 12px;\n    letter-spacing: .3px\n  }\n\n  .order-badge.order-delivered {\n    background: #C8E6C9;\n    color: #256029\n  }\n\n  .order-badge.order-cancelled {\n    background: #FFCDD2;\n    color: #c63737\n  }\n\n  .order-badge.order-pending {\n    background: #FEEDAF;\n    color: #8a5340\n  }\n\n  .order-badge.order-returned {\n    background: #ECCFFF;\n    color: #694382\n  }\n\n  pre.app-code {\n    background-color: var(--surface-ground);\n    margin: 0 0 1rem;\n    padding: 0;\n    border-radius: var(--border-radius);\n    overflow: auto\n  }\n\n  pre.app-code code {\n    color: var(--surface-900);\n    padding: 1rem;\n    line-height: 1.5;\n    display: block;\n    font-family: monaco,Consolas,monospace\n  }\n}","\n//reused color variables\n$shade000:#ffffff;              //surface\n$shade200:#e9ecef;              //hover background\n$shade300:#dee2e6;              //border, divider\n$shade900:#292B2C;              //text color\n\n$transitionDuration:.15s;\n$listItemTransition:box-shadow $transitionDuration;\n$inlineSpacing:.5rem;\n\n$focusOutlineColor:#3E6131;\n$focusOutline:0 none;\n$focusOutlineOffset:0;\n$inputListItemFocusShadow:none; /*inset 0 0 0 0.15rem $focusOutlineColor;*/\n$borderRadius:8px;\n$divider:1px solid $shade300;\n\n$horizontalMenuPadding:0;\n$horizontalMenuBg:#3E642F;\n$horizontalMenuBorder:0 none;\n$horizontalMenuTextColor:rgba(255,255,255,.7);\n$horizontalMenuRootMenuitemPadding:.75rem .5rem;\n$horizontalMenuRootMenuitemBorderRadius:0;\n$horizontalMenuRootMenuitemTextColor:rgba(255,255,255,.7);\n$horizontalMenuRootMenuitemIconColor:rgba(254,197,48,.8);\n$horizontalMenuRootMenuitemTextHoverColor:rgba(255,255,255,1);\n$horizontalMenuRootMenuitemIconHoverColor:rgba(254,197,48,1);\n$horizontalMenuRootMenuitemHoverBg:var(--primary);\n$horizontalMenuRootMenuitemTextActiveColor:rgba(255,255,255,.9);\n$horizontalMenuRootMenuitemIconActiveColor:rgba(254,197,48,.9);\n$horizontalMenuRootMenuitemActiveBg:var(--primary);\n\n//menu (e.g. menu, menubar, tieredmenu)\n$menuWidth:auto;\n$menuBg:$shade000;\n$menuTextColor:$shade900;\n$menuitemPadding:.75rem 1rem;\n$menuitemBorderRadius:0;\n$menuitemTextColor:$shade900;\n$menuitemIconColor:$shade900;\n$menuitemTextHoverColor:$shade900;\n$menuitemIconHoverColor:$shade900;\n$menuitemHoverBg:$shade200;\n$menuitemTextActiveColor:$shade900;\n$menuitemIconActiveColor:$shade900;\n$menuitemActiveBg:$shade200;\n$submenuHeaderMargin:0;\n$submenuHeaderPadding:.75rem 1rem;\n$submenuHeaderBg:$shade000;\n$submenuHeaderTextColor:$shade900;\n$submenuHeaderFontWeight:600;\n$overlayMenuBg:$menuBg;\n$overlayMenuBorder:1px solid rgba(0,0,0,.15);\n$overlayMenuShadow:none;\n$verticalMenuPadding:.5rem 0;\n$verticalMenuitemMargin:0;\n$menuSeparatorMargin:.5rem 0;\n\n//progressbar\n$progressBarHeight:0.5rem;\n$progressBarBorder:0 none;\n$progressBarBg:$shade200;\n$progressBarValueBg:var(--primary-light);\n$progressBarBorderTopLeftRadius:5px;\n$progressBarBorderTopRightRadius:5px;\n\n:root {\n  --border-radius:#{$borderRadius};\n}","@import \"../../_variables.scss\";\n@import \"../../../layout/_mixins.scss\";\n\n.p-megamenu {\n    padding: $horizontalMenuPadding;\n    background: $horizontalMenuBg;\n    color: $horizontalMenuTextColor;\n    border: $horizontalMenuBorder;\n    border-radius: $borderRadius;\n\n    .p-megamenu-root-list {\n        > .p-menuitem {\n            > .p-menuitem-link {\n                @include horizontal-rootmenuitem-link();\n            }\n\n            &.p-menuitem-active {\n                > .p-menuitem-link,\n                > .p-menuitem-link:not(.p-disabled):hover {\n                    background: $horizontalMenuRootMenuitemActiveBg;\n\n                    .p-menuitem-text {\n                        color: $horizontalMenuRootMenuitemTextActiveColor;\n                    }\n\n                    .p-menuitem-icon {\n                        color: $horizontalMenuRootMenuitemIconActiveColor;\n                    }\n\n                    .p-submenu-icon {\n                        color: $horizontalMenuRootMenuitemIconActiveColor;\n                    }\n                }\n            }\n        }\n    }\n\n    .p-menuitem-link {\n        @include menuitem-link();\n    }\n\n    .p-megamenu-panel {\n        background: $overlayMenuBg;\n        color: $menuTextColor;\n        border: $overlayMenuBorder;\n        box-shadow: $overlayMenuShadow;\n    }\n\n    .p-megamenu-submenu-header {\n        margin: $submenuHeaderMargin;\n        padding: $submenuHeaderPadding;\n        color: $submenuHeaderTextColor;\n        background: $submenuHeaderBg;\n        font-weight: $submenuHeaderFontWeight;\n        border-top-right-radius: $borderRadius;\n        border-top-left-radius: $borderRadius;\n    }\n\n    .p-megamenu-submenu {\n        padding: $verticalMenuPadding;\n        width: $menuWidth;\n\n        .p-menu-separator {\n            border-top: $divider;\n            margin: $menuSeparatorMargin;\n        }\n\n        .p-menuitem {\n            margin: $verticalMenuitemMargin;\n\n            &:last-child {\n                margin: 0;\n            }\n        }\n    }\n\n    .p-menuitem {\n        &.p-menuitem-active {\n            > .p-menuitem-link {\n                background: $menuitemActiveBg;\n\n                .p-menuitem-text {\n                    color: $menuitemTextActiveColor;\n                }\n\n                .p-menuitem-icon, .p-submenu-icon {\n                    color: $menuitemIconActiveColor;\n                }\n            }\n        }\n    }\n}","@import \"../theme/_variables.scss\";\n\n@mixin menuitem-link {\n    padding: $menuitemPadding;\n    color: $menuitemTextColor;\n    border-radius: $menuitemBorderRadius;\n    transition: $listItemTransition;\n    user-select: none;\n    width: max-content;\n\n    .p-menuitem-text {\n        color: $menuitemTextColor;\n    }\n\n    .p-menuitem-icon {\n        color: $menuitemIconColor;\n        margin-right: $inlineSpacing;\n    }\n\n    .p-submenu-icon {\n        color: $menuitemIconColor;\n    }\n\n    &:not(.p-disabled):hover {\n        background: $menuitemHoverBg;\n\n        .p-menuitem-text {\n            color: $menuitemTextHoverColor;\n        }\n\n        .p-menuitem-icon {\n            color: $menuitemIconHoverColor;\n        }\n\n        .p-submenu-icon {\n            color: $menuitemIconHoverColor;\n        }\n    }\n\n    &:focus {\n        @include focused-listitem();\n    }\n}\n\n@mixin focused-listitem() {\n    outline: $focusOutline;\n    outline-offset: $focusOutlineOffset;\n    box-shadow: $inputListItemFocusShadow;\n}\n\n@mixin horizontal-rootmenuitem-link {\n    padding: $horizontalMenuRootMenuitemPadding;\n    color: $horizontalMenuRootMenuitemTextColor;\n    border-radius: $horizontalMenuRootMenuitemBorderRadius;\n    transition: $listItemTransition;\n    user-select: none;\n\n    .p-menuitem-text {\n        color: $horizontalMenuRootMenuitemTextColor;\n    }\n\n    .p-menuitem-icon {\n        color: $horizontalMenuRootMenuitemIconColor;\n        margin-right: $inlineSpacing;\n    }\n\n    .p-submenu-icon {\n        color: $horizontalMenuRootMenuitemTextColor; /*$horizontalMenuRootMenuitemIconColor*/;\n        margin-left: $inlineSpacing;\n    }\n\n    &:not(.p-disabled):hover {\n        background: $horizontalMenuRootMenuitemHoverBg;\n\n        .p-menuitem-text {\n            color: $horizontalMenuRootMenuitemTextHoverColor;\n        }\n\n        .p-menuitem-icon {\n            color: $horizontalMenuRootMenuitemIconHoverColor;\n        }\n\n        .p-submenu-icon {\n            color: $horizontalMenuRootMenuitemIconHoverColor;\n        }\n    }\n\n    &:focus {\n        @include focused-listitem();\n    }\n}","::ng-deep {\n\t.ui-inputgroup {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tpadding: 0 !important;\n\n\t\t.ui-inputgroup-addon {\n\t\t\tbackground-color: #f8f9fa;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\ttext-align: center;\n\t\t\tmin-width: 36px !important;\n\t\t\theight: inherit;\n\t\t}\n\n\t\t/* Styling for ui-inputgroup-addon when it comes AFTER ui-inputgroup-widget */\n\t\t.ui-inputgroup-widget + .ui-inputgroup-addon {\n\t\t\tborder-top: 1px solid var(--border-light);\n\t\t\tborder-right: 1px solid var(--border-light);\n\t\t\tborder-bottom: 1px solid var(--border-light);\n\t\t\tborder-left: none;\n\t\t\tborder-radius: 0 4px 4px 0;\n\t\t}\n\n\t\t/* Styling for ui-inputgroup-addon when it comes BEFORE ui-inputgroup-widget */\n\t\t.ui-inputgroup-addon:not(.ui-inputgroup-widget + .ui-inputgroup-addon) {\n\t\t\tborder-top: 1px solid var(--border-light);\n\t\t\tborder-left: 1px solid var(--border-light);\n\t\t\tborder-bottom: 1px solid var(--border-light);\n\t\t\tborder-right: none;\n\t\t\tborder-radius: 4px 0 0 4px;\n\t\t}\n\n\t\t.ui-inputgroup-widget {\n\t\t\tdisplay: table-cell;\n\t\t\theight: inherit;\n\t\t\twidth: inherit;\n\t\t\tborder-radius: 3px;\n\n\t\t\t&.border-left-zero {\n\t\t\t\t.p-inputtext {\n\t\t\t\t\tborder-top-left-radius: 0 !important;\n\t\t\t\t\tborder-bottom-left-radius: 0 !important;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.border-right-zero {\n\t\t\t\t.p-inputtext {\n\t\t\t\t\tborder-top-right-radius: 0 !important;\n\t\t\t\t\tborder-bottom-right-radius: 0 !important;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.border-zero {\n\t\t\t\t.p-inputtext {\n\t\t\t\t\tborder-radius: 0 !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",":host ::ng-deep {\n    .contact-section,\n    .generic-section {\n        position: relative;\n        z-index: 3;\n    }\n\n    .contact-item {\n        display: flex;\n        border: 1px solid var(--gray-4);\n        border-radius: 10px;\n        background: var(--white);\n        margin-bottom: 30px;\n        padding: 20px 30px;\n        -webkit-transition: all 0.3s ease-out 0s;\n        -moz-transition: all 0.3s ease-out 0s;\n        -ms-transition: all 0.3s ease-out 0s;\n        -o-transition: all 0.3s ease-out 0s;\n        transition: all 0.3s ease-out 0s;\n\n        .contact-icon {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            font-size: 22px;\n            width: 50px;\n            height: 50px;\n            border-radius: 50%;\n            background: var(--primary);\n            color: var(--white);\n            -webkit-transition: all 0.3s ease-out 0s;\n            -moz-transition: all 0.3s ease-out 0s;\n            -ms-transition: all 0.3s ease-out 0s;\n            -o-transition: all 0.3s ease-out 0s;\n            transition: all 0.3s ease-out 0s;\n        }\n\n        .contact-content {\n            margin-left: 25px;\n            a,\n            a:visited {\n                color: var(--primary);\n            }\n            a:hover {\n                color: var(--dark-2);\n            }\n            h4 {\n                color: var(--primary);\n                margin-bottom: 10px;\n            }\n        }\n    }\n    .contact-item:hover {\n        box-shadow: var(--shadow-4);\n    }\n\n    .contact-form-wrapper,\n    .build-form-wrapper,\n    .about-form-wrapper,\n    .retail-form-wrapper,\n    .orthodox-form-wrapper,\n    .products-form-wrapper {\n        position: relative;\n        z-index: 1;\n        padding: 50px 40px;\n        background: var(--white);\n        border: 1px solid var(--gray-4);\n        margin-left: 0;\n        border-radius: 10px;\n        min-height: 50vh;\n        -webkit-transition: all 0.3s ease-out 0s;\n        -moz-transition: all 0.3s ease-out 0s;\n        -ms-transition: all 0.3s ease-out 0s;\n        -o-transition: all 0.3s ease-out 0s;\n        transition: all 0.3s ease-out 0s;\n    }\n\n    .contact-form-wrapper .contact-form .primary-btn,\n    .build-form-wrapper .build-form .primary-btn,\n    .about-form-wrapper .about-form .primary-btn,\n    .retail-form-wrapper .retail-form .primary-btn,\n    .orthodox-form-wrapper .orthodox-form .primary-btn,\n    .products-form-wrapper .retail-form .primary-btn {\n        background: var(--primary);\n        color: var(--white);\n        box-shadow: var(--shadow-2);\n    }\n    .contact-form-wrapper .contact-form .active.primary-btn,\n    .contact-form-wrapper .contact-form .primary-btn:hover,\n    .contact-form-wrapper .contact-form .primary-btn:focus,\n    .build-form-wrapper .build-form .active.primary-btn,\n    .build-form-wrapper .build-form .primary-btn:hover,\n    .build-form-wrapper .build-form .primary-btn:focus,\n    .about-form-wrapper .about-form .active.primary-btn,\n    .about-form-wrapper .about-form .primary-btn:hover,\n    .about-form-wrapper .about-form .primary-btn:focus,\n    .retail-form-wrapper .retail-form .active.primary-btn,\n    .retail-form-wrapper .retail-form .primary-btn:hover,\n    .retail-form-wrapper .retail-form .primary-btn:focus,\n    .orthodox-form-wrapper .orthodox-form .active.primary-btn,\n    .orthodox-form-wrapper .orthodox-form .primary-btn:hover,\n    .orthodox-form-wrapper .orthodox-form .primary-btn:focus,\n    .products-form-wrapper .products-form .active.primary-btn,\n    .products-form-wrapper .products-form .primary-btn:hover,\n    .products-form-wrapper .products-form .primary-btn:focus {\n        background: var(--primary-dark);\n        color: var(--white);\n        box-shadow: var(--shadow-4);\n    }\n    .contact-form-wrapper .contact-form .deactive.primary-btn,\n    .build-form-wrapper .build-form .deactive.primary-btn,\n    .about-form-wrapper .about-form .deactive.primary-btn,\n    .retail-form-wrapper .retail-form .deactive.primary-btn,\n    .orthodox-form-wrapper .orthodox-form .deactive.primary-btn,\n    .products-form-wrapper .products-form .deactive.primary-btn {\n        background: var(--gray-4);\n        color: var(--dark-3);\n        pointer-events: none;\n    }\n\n    .contact-form-wrapper:hover,\n    .build-form-wrapper:hover,\n    .about-form-wrapper:hover,\n    .retail-form-wrapper:hover,\n    .orthodox-form-wrapper:hover,\n    .products-form-wrapper:hover {\n        box-shadow: var(--shadow-4);\n    }\n\n    .contact-form-wrapper,\n    .build-form-wrapper,\n    .about-form-wrapper,\n    .retail-form-wrapper,\n    .orthodox-form-wrapper,\n    .products-form-wrapper {\n        .section-title {\n            margin-bottom: 30px;\n\n            span {\n                font-size: 20px;\n                color: var(--primary);\n                font-weight: 700;\n            }\n\n            h2 {\n                margin-bottom: 10px;\n            }\n\n            p {\n                color: var(--dark-2);\n            }\n        }\n\n        .contact-form,\n        .build-form,\n        .about-form,\n        .retail-form,\n        .orthodox-form,\n        .products-form {\n            input,\n            textarea {\n                padding: 15px 25px;\n                border-radius: 30px;\n                border: 1px solid var(--gray-4);\n                margin-bottom: 25px;\n                width: 100%;\n                -webkit-transition: all 0.3s ease-out 0s;\n                -moz-transition: all 0.3s ease-out 0s;\n                -ms-transition: all 0.3s ease-out 0s;\n                -o-transition: all 0.3s ease-out 0s;\n                transition: all 0.3s ease-out 0s;\n            }\n\n            input:focus,\n            textarea:focus {\n                border-color: var(--primary);\n            }\n\n            textarea {\n                border-radius: 18px;\n            }\n        }\n    }\n}\n\n\n/* Extra small devices (phones, 600px and down) */\n@media only screen and (max-width: 600px) {\n    :host ::ng-deep {\n        .contact-form-wrapper,\n        .build-form-wrapper,\n        .about-form-wrapper,\n        .retail-form-wrapper,\n        .orthodox-form-wrapper,\n        .products-form-wrapper {\n            padding: 10px;\n\n            .contact-form,\n            .build-form,\n            .about-form,\n            .retail-form,\n            .orthodox-form,\n            .products-form {\n                input,\n                textarea {\n                    padding: 12px 25px;\n                }\n            }\n\n            .p-accordion {\n                .p-accordion-content {\n                    padding: 10px;\n\n                    .p-tabview {\n                        .p-tabview-panels {\n                            padding: 10px 0;\n                        }\n                    }\n                }\n            }\n        }\n        .contact-item {\n            margin-bottom: .75rem;\n        }\n    }\n}\n\n/* Small devices (portrait tablets and large phones, 600px and up) */\n@media only screen and (min-width: 600px) {\n    :host ::ng-deep {\n        .contact-form-wrapper,\n        .build-form-wrapper,\n        .about-form-wrapper,\n        .retail-form-wrapper,\n        .orthodox-form-wrapper,\n        .products-form-wrapper {\n            padding: 15px 12px;\n\n            .contact-form,\n            .build-form,\n            .about-form,\n            .retail-form,\n            .orthodox-form,\n            .products-form {\n                input,\n                textarea {\n                    padding: 12px 25px;\n                }\n            }\n        }\n\n        .contact-section {\n            padding-top: 0;\n        }\n    }\n}\n\n/* Medium devices (landscape tablets, 768px and up) */\n@media only screen and (min-width: 768px) {\n    :host ::ng-deep {\n        .contact-form-wrapper,\n        .build-form-wrapper,\n        .about-form-wrapper,\n        .retail-form-wrapper,\n        .orthodox-form-wrapper,\n        .products-form-wrapper {\n            padding: 25px 20px;\n        }\n        .contact-section {\n            padding-top: 0;\n        }\n    }\n}\n\n/* Large devices (laptops/desktops, 992px and up) */\n@media only screen and (min-width: 992px) {\n    :host ::ng-deep {\n        .contact-form-wrapper,\n        .build-form-wrapper,\n        .about-form-wrapper,\n        .retail-form-wrapper,\n        .orthodox-form-wrapper,\n        .products-form-wrapper {\n            padding: 35px 30px;\n        }\n    }\n}\n\n/* Extra large devices (large laptops and desktops, 1200px and up) */\n@media only screen and (min-width: 1200px) {\n    :host ::ng-deep {\n        .contact-form-wrapper,\n        .build-form-wrapper,\n        .about-form-wrapper,\n        .retail-form-wrapper,\n        .orthodox-form-wrapper,\n        .products-form-wrapper {\n            padding: 35px 40px 40px 40px !important;\n        }\n\n        .contact-section {\n            .contact-item-wrapper {\n                .contact-item {\n                    padding: 20px;\n                    .contact-content {\n                        margin-left: 20px;\n                    }\n                }\n            }\n        }\n\n        .contact-form-wrapper,\n        .about-form-wrapper {\n            margin-left: 30px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
